!(function () {
    var e = {
            7080: function (e, t, n) {
                const { Token: i } = n(5537),
                    a = n(7318),
                    { Interval: o } = n(7059);

                class r {}

                e.exports = class extends r {
                    constructor(e) {
                        super();
                        this.tokenSource = e;
                        this.tokens = [];
                        this.index = -1;
                        this.fetchedEOF = !1;
                    }

                    mark() {
                        return 0;
                    }

                    release(e) {}

                    reset() {
                        this.seek(0);
                    }

                    seek(e) {
                        this.lazyInit();
                        this.index = this.adjustSeekIndex(e);
                    }

                    get(e) {
                        this.lazyInit();
                        return this.tokens[e];
                    }

                    consume() {
                        let e = !1;
                        if (this.index >= 0) {
                            if (this.fetchedEOF) {
                                e = this.index < this.tokens.length - 1;
                            } else {
                                e = this.index < this.tokens.length;
                            }
                        } else {
                            e = !1;
                        }
                        if (!e && this.LA(1) === i.EOF) {
                            throw 'cannot consume EOF';
                        }
                        if (this.sync(this.index + 1)) {
                            this.index = this.adjustSeekIndex(this.index + 1);
                        }
                    }

                    sync(e) {
                        const t = e - this.tokens.length + 1;
                        if (t > 0) {
                            return this.fetch(t) >= t;
                        }
                        return !0;
                    }

                    fetch(e) {
                        if (this.fetchedEOF) {
                            return 0;
                        }
                        for (let t = 0; t < e; t++) {
                            const e = this.tokenSource.nextToken();
                            e.tokenIndex = this.tokens.length;
                            this.tokens.push(e);
                            if (e.type === i.EOF) {
                                this.fetchedEOF = !0;
                                return t + 1;
                            }
                        }
                        return e;
                    }

                    getTokens(e, t, n) {
                        if (void 0 === n) {
                            n = null;
                        }
                        if (e < 0 || t < 0) {
                            return null;
                        }
                        this.lazyInit();
                        const a = [];
                        if (t >= this.tokens.length) {
                            t = this.tokens.length - 1;
                        }
                        for (let o = e; o < t; o++) {
                            const e = this.tokens[o];
                            if (e.type === i.EOF) {
                                break;
                            }
                            if (null === n || n.contains(e.type)) {
                                a.push(e);
                            }
                        }
                        return a;
                    }

                    LA(e) {
                        return this.LT(e).type;
                    }

                    LB(e) {
                        if (this.index - e < 0) {
                            return null;
                        } else {
                            return this.tokens[this.index - e];
                        }
                    }

                    LT(e) {
                        this.lazyInit();
                        if (0 === e) {
                            return null;
                        }
                        if (e < 0) {
                            return this.LB(-e);
                        }
                        const t = this.index + e - 1;
                        this.sync(t);
                        if (t >= this.tokens.length) {
                            return this.tokens[this.tokens.length - 1];
                        } else {
                            return this.tokens[t];
                        }
                    }

                    adjustSeekIndex(e) {
                        return e;
                    }

                    lazyInit() {
                        if (-1 === this.index) {
                            this.setup();
                        }
                    }

                    setup() {
                        this.sync(0);
                        this.index = this.adjustSeekIndex(0);
                    }

                    setTokenSource(e) {
                        this.tokenSource = e;
                        this.tokens = [];
                        this.index = -1;
                        this.fetchedEOF = !1;
                    }

                    nextTokenOnChannel(e, t) {
                        this.sync(e);
                        if (e >= this.tokens.length) {
                            return -1;
                        }
                        let n = this.tokens[e];
                        for (; n.channel !== this.channel; ) {
                            if (n.type === i.EOF) {
                                return -1;
                            }
                            e += 1;
                            this.sync(e);
                            n = this.tokens[e];
                        }
                        return e;
                    }

                    previousTokenOnChannel(e, t) {
                        for (; e >= 0 && this.tokens[e].channel !== t; ) {
                            e -= 1;
                        }
                        return e;
                    }

                    getHiddenTokensToRight(e, t) {
                        if (void 0 === t) {
                            t = -1;
                        }
                        this.lazyInit();
                        if (e < 0 || e >= this.tokens.length) {
                            throw e + ' not in 0..' + this.tokens.length - 1;
                        }
                        const n = this.nextTokenOnChannel(e + 1, a.DEFAULT_TOKEN_CHANNEL),
                            i = e + 1,
                            o = -1 === n ? this.tokens.length - 1 : n;
                        return this.filterForChannel(i, o, t);
                    }

                    getHiddenTokensToLeft(e, t) {
                        if (void 0 === t) {
                            t = -1;
                        }
                        this.lazyInit();
                        if (e < 0 || e >= this.tokens.length) {
                            throw e + ' not in 0..' + this.tokens.length - 1;
                        }
                        const n = this.previousTokenOnChannel(e - 1, a.DEFAULT_TOKEN_CHANNEL);
                        if (n === e - 1) {
                            return null;
                        }
                        const i = n + 1,
                            o = e - 1;
                        return this.filterForChannel(i, o, t);
                    }

                    filterForChannel(e, t, n) {
                        const i = [];
                        for (let o = e; o < t + 1; o++) {
                            const e = this.tokens[o];
                            if (-1 === n) {
                                if (e.channel !== a.DEFAULT_TOKEN_CHANNEL) {
                                    i.push(e);
                                }
                            } else if (e.channel === n) {
                                i.push(e);
                            }
                        }
                        if (0 === i.length) {
                            return null;
                        } else {
                            return i;
                        }
                    }

                    getSourceName() {
                        return this.tokenSource.getSourceName();
                    }

                    getText(e) {
                        this.lazyInit();
                        this.fill();
                        if (null == e) {
                            e = new o(0, this.tokens.length - 1);
                        }
                        let t = e.start;
                        if (t instanceof i) {
                            t = t.tokenIndex;
                        }
                        let n = e.stop;
                        if (n instanceof i) {
                            n = n.tokenIndex;
                        }
                        if (null === t || null === n || t < 0 || n < 0) {
                            return '';
                        }
                        if (n >= this.tokens.length) {
                            n = this.tokens.length - 1;
                        }
                        let a = '';
                        for (let e = t; e < n + 1; e++) {
                            const t = this.tokens[e];
                            if (t.type === i.EOF) {
                                break;
                            }
                            a += t.text;
                        }
                        return a;
                    }

                    fill() {
                        this.lazyInit();
                        for (; 1e3 === this.fetch(1e3); ) {}
                    }
                };
            },
            462: function (e, t, n) {
                const i = n(5537).CommonToken;

                class a {}

                class o extends a {
                    constructor(e) {
                        super();
                        this.copyText = void 0 === e ? !1 : e;
                    }

                    create(e, t, n, a, o, r, s, c) {
                        const l = new i(e, t, a, o, r);
                        l.line = s;
                        l.column = c;
                        if (null !== n) {
                            l.text = n;
                        } else if (this.copyText && null !== e[1]) {
                            l.text = e[1].getText(o, r);
                        }
                        return l;
                    }

                    createThin(e, t) {
                        const n = new i(null, e);
                        n.text = t;
                        return n;
                    }
                }

                o.DEFAULT = new o();
                e.exports = o;
            },
            8206: function (e, t, n) {
                const i = n(5537).Token,
                    a = n(7080);
                e.exports = class extends a {
                    constructor(e, t) {
                        super(e);
                        this.channel = void 0 === t ? i.DEFAULT_CHANNEL : t;
                    }

                    adjustSeekIndex(e) {
                        return this.nextTokenOnChannel(e, this.channel);
                    }

                    LB(e) {
                        if (0 === e || this.index - e < 0) {
                            return null;
                        }
                        let t = this.index,
                            n = 1;
                        for (; n <= e; ) {
                            t = this.previousTokenOnChannel(t - 1, this.channel);
                            n += 1;
                        }
                        if (t < 0) {
                            return null;
                        } else {
                            return this.tokens[t];
                        }
                    }

                    LT(e) {
                        this.lazyInit();
                        if (0 === e) {
                            return null;
                        }
                        if (e < 0) {
                            return this.LB(-e);
                        }
                        let t = this.index,
                            n = 1;
                        for (; n < e; ) {
                            if (this.sync(t + 1)) {
                                t = this.nextTokenOnChannel(t + 1, this.channel);
                            }
                            n += 1;
                        }
                        return this.tokens[t];
                    }

                    getNumberOfOnChannelTokens() {
                        let e = 0;
                        this.fill();
                        for (let t = 0; t < this.tokens.length; t++) {
                            const n = this.tokens[t];
                            if (n.channel === this.channel) {
                                e += 1;
                            }
                            if (n.type === i.EOF) {
                                break;
                            }
                        }
                        return e;
                    }
                };
            },
            916: function (e, t, n) {
                const { Token: i } = n(5537);
                n(7767);
                n(7838);
                e.exports = class {
                    constructor(e, t) {
                        this.name = '<empty>';
                        this.strdata = e;
                        this.decodeToUnicodeCodePoints = t || !1;
                        this._index = 0;
                        this.data = [];
                        if (this.decodeToUnicodeCodePoints) {
                            for (let e = 0; e < this.strdata.length; ) {
                                const t = this.strdata.codePointAt(e);
                                this.data.push(t);
                                e += t <= 65535 ? 1 : 2;
                            }
                        } else {
                            this.data = new Array(this.strdata.length);
                            for (let e = 0; e < this.strdata.length; e++) {
                                const t = this.strdata.charCodeAt(e);
                                this.data[e] = t;
                            }
                        }
                        this._size = this.data.length;
                    }

                    reset() {
                        this._index = 0;
                    }

                    consume() {
                        if (this._index >= this._size) {
                            throw 'cannot consume EOF';
                        }
                        this._index += 1;
                    }

                    LA(e) {
                        if (0 === e) {
                            return 0;
                        }
                        if (e < 0) {
                            e += 1;
                        }
                        const t = this._index + e - 1;
                        if (t < 0 || t >= this._size) {
                            return i.EOF;
                        } else {
                            return this.data[t];
                        }
                    }

                    LT(e) {
                        return this.LA(e);
                    }

                    mark() {
                        return -1;
                    }

                    release(e) {}

                    seek(e) {
                        if (!(e <= this._index)) {
                            this._index = Math.min(e, this._size);
                        } else {
                            this._index = e;
                        }
                    }

                    getText(e, t) {
                        if (t >= this._size) {
                            t = this._size - 1;
                        }
                        if (e >= this._size) {
                            return '';
                        } else if (this.decodeToUnicodeCodePoints) {
                            let n = '';
                            for (let i = e; i <= t; i++) {
                                n += String.fromCodePoint(this.data[i]);
                            }
                            return n;
                        } else {
                            return this.strdata.slice(e, t + 1);
                        }
                    }

                    toString() {
                        return this.strdata;
                    }

                    get index() {
                        return this._index;
                    }

                    get size() {
                        return this._size;
                    }
                };
            },
            7059: function (e, t, n) {
                const { Token: i } = n(5537);

                class a {
                    constructor(e, t) {
                        this.start = e;
                        this.stop = t;
                    }

                    clone() {
                        return new a(this.start, this.stop);
                    }

                    contains(e) {
                        return e >= this.start && e < this.stop;
                    }

                    toString() {
                        if (this.start === this.stop - 1) {
                            return this.start.toString();
                        } else {
                            return this.start.toString() + '..' + (this.stop - 1).toString();
                        }
                    }

                    get length() {
                        return this.stop - this.start;
                    }
                }

                class o {
                    constructor() {
                        this.intervals = null;
                        this.readOnly = !1;
                    }

                    first(e) {
                        if (null === this.intervals || 0 === this.intervals.length) {
                            return i.INVALID_TYPE;
                        } else {
                            return this.intervals[0].start;
                        }
                    }

                    addOne(e) {
                        this.addInterval(new a(e, e + 1));
                    }

                    addRange(e, t) {
                        this.addInterval(new a(e, t + 1));
                    }

                    addInterval(e) {
                        if (null === this.intervals) {
                            this.intervals = [];
                            this.intervals.push(e.clone());
                        } else {
                            for (let t = 0; t < this.intervals.length; t++) {
                                const n = this.intervals[t];
                                if (e.stop < n.start) {
                                    this.intervals.splice(t, 0, e);
                                    return;
                                } else if (e.stop === n.start) {
                                    this.intervals[t] = new a(e.start, n.stop);
                                    return;
                                } else if (e.start <= n.stop) {
                                    this.intervals[t] = new a(Math.min(n.start, e.start), Math.max(n.stop, e.stop));
                                    this.reduce(t);
                                    return;
                                }
                            }
                            this.intervals.push(e.clone());
                        }
                    }

                    addSet(e) {
                        if (null !== e.intervals) {
                            e.intervals.forEach(e => this.addInterval(e), this);
                        }
                        return this;
                    }

                    reduce(e) {
                        if (e < this.intervals.length - 1) {
                            const t = this.intervals[e],
                                n = this.intervals[e + 1];
                            if (t.stop >= n.stop) {
                                this.intervals.splice(e + 1, 1);
                                this.reduce(e);
                            } else if (t.stop >= n.start) {
                                this.intervals[e] = new a(t.start, n.stop);
                                this.intervals.splice(e + 1, 1);
                            }
                        }
                    }

                    complement(e, t) {
                        const n = new o();
                        n.addInterval(new a(e, t + 1));
                        if (null !== this.intervals) {
                            this.intervals.forEach(e => n.removeRange(e));
                        }
                        return n;
                    }

                    contains(e) {
                        if (null === this.intervals) {
                            return !1;
                        } else {
                            for (let t = 0; t < this.intervals.length; t++) {
                                if (this.intervals[t].contains(e)) {
                                    return !0;
                                }
                            }
                            return !1;
                        }
                    }

                    removeRange(e) {
                        if (e.start === e.stop - 1) {
                            this.removeOne(e.start);
                        } else if (null !== this.intervals) {
                            let t = 0;
                            for (let n = 0; n < this.intervals.length; n++) {
                                const n = this.intervals[t];
                                if (e.stop <= n.start) {
                                    return;
                                } else if (e.start > n.start && e.stop < n.stop) {
                                    this.intervals[t] = new a(n.start, e.start);
                                    const i = new a(e.stop, n.stop);
                                    this.intervals.splice(t, 0, i);
                                    return;
                                } else if (e.start <= n.start && e.stop >= n.stop) {
                                    this.intervals.splice(t, 1);
                                    t -= 1;
                                } else if (e.start < n.stop) {
                                    this.intervals[t] = new a(n.start, e.start);
                                } else if (e.stop < n.stop) {
                                    this.intervals[t] = new a(e.stop, n.stop);
                                }
                                t += 1;
                            }
                        }
                    }

                    removeOne(e) {
                        if (null !== this.intervals) {
                            for (let t = 0; t < this.intervals.length; t++) {
                                const n = this.intervals[t];
                                if (e < n.start) {
                                    return;
                                } else if (e === n.start && e === n.stop - 1) {
                                    this.intervals.splice(t, 1);
                                    return;
                                } else if (e === n.start) {
                                    this.intervals[t] = new a(n.start + 1, n.stop);
                                    return;
                                } else if (e === n.stop - 1) {
                                    this.intervals[t] = new a(n.start, n.stop - 1);
                                    return;
                                } else if (e < n.stop - 1) {
                                    const i = new a(n.start, e);
                                    n.start = e + 1;
                                    this.intervals.splice(t, 0, i);
                                    return;
                                }
                            }
                        }
                    }

                    toString(e, t, n) {
                        e = e || null;
                        t = t || null;
                        n = n || !1;
                        if (null === this.intervals) {
                            return '{}';
                        } else if (null !== e || null !== t) {
                            return this.toTokenString(e, t);
                        } else if (n) {
                            return this.toCharString();
                        } else {
                            return this.toIndexString();
                        }
                    }

                    toCharString() {
                        const e = [];
                        for (let t = 0; t < this.intervals.length; t++) {
                            const n = this.intervals[t];
                            if (n.stop === n.start + 1) {
                                if (n.start === i.EOF) {
                                    e.push('<EOF>');
                                } else {
                                    e.push("'" + String.fromCharCode(n.start) + "'");
                                }
                            } else {
                                e.push(
                                    "'" + String.fromCharCode(n.start) + "'..'" + String.fromCharCode(n.stop - 1) + "'",
                                );
                            }
                        }
                        if (e.length > 1) {
                            return '{' + e.join(', ') + '}';
                        } else {
                            return e[0];
                        }
                    }

                    toIndexString() {
                        const e = [];
                        for (let t = 0; t < this.intervals.length; t++) {
                            const n = this.intervals[t];
                            if (n.stop === n.start + 1) {
                                if (n.start === i.EOF) {
                                    e.push('<EOF>');
                                } else {
                                    e.push(n.start.toString());
                                }
                            } else {
                                e.push(n.start.toString() + '..' + (n.stop - 1).toString());
                            }
                        }
                        if (e.length > 1) {
                            return '{' + e.join(', ') + '}';
                        } else {
                            return e[0];
                        }
                    }

                    toTokenString(e, t) {
                        const n = [];
                        for (let i = 0; i < this.intervals.length; i++) {
                            const a = this.intervals[i];
                            for (let i = a.start; i < a.stop; i++) {
                                n.push(this.elementName(e, t, i));
                            }
                        }
                        if (n.length > 1) {
                            return '{' + n.join(', ') + '}';
                        } else {
                            return n[0];
                        }
                    }

                    elementName(e, t, n) {
                        if (n === i.EOF) {
                            return '<EOF>';
                        } else if (n === i.EPSILON) {
                            return '<EPSILON>';
                        } else {
                            return e[n] || t[n];
                        }
                    }

                    get length() {
                        return this.intervals.map(e => e.length).reduce((e, t) => e + t);
                    }
                }

                e.exports = { Interval: a, IntervalSet: o };
            },
            3245: function (e, t, n) {
                const { Set: i, BitSet: a } = n(2373),
                    { Token: o } = n(5537),
                    { ATNConfig: r } = n(5185),
                    { IntervalSet: s } = n(7059),
                    { RuleStopState: c } = n(2766),
                    {
                        RuleTransition: l,
                        NotSetTransition: u,
                        WildcardTransition: d,
                        AbstractPredicateTransition: m,
                    } = n(5651),
                    {
                        predictionContextFromRuleContext: p,
                        PredictionContext: f,
                        SingletonPredictionContext: g,
                    } = n(6400);

                class h {
                    constructor(e) {
                        this.atn = e;
                    }

                    getDecisionLookahead(e) {
                        if (null === e) {
                            return null;
                        }
                        const t = e.transitions.length,
                            n = [];
                        for (let o = 0; o < t; o++) {
                            n[o] = new s();
                            const t = new i(),
                                r = !1;
                            this._LOOK(e.transition(o).target, null, f.EMPTY, n[o], t, new a(), r, !1);
                            if (0 === n[o].length || n[o].contains(h.HIT_PRED)) {
                                n[o] = null;
                            }
                        }
                        return n;
                    }

                    LOOK(e, t, n) {
                        const o = new s(),
                            r = null !== (n = n || null) ? p(e.atn, n) : null;
                        this._LOOK(e, t, r, o, new i(), new a(), !0, !0);
                        return o;
                    }

                    _LOOK(e, t, n, i, a, s, p, y) {
                        const x = new r({ state: e, alt: 0, context: n }, null);
                        if (!a.contains(x)) {
                            a.add(x);
                            if (e === t) {
                                if (null === n) {
                                    i.addOne(o.EPSILON);
                                    return;
                                } else if (n.isEmpty() && y) {
                                    i.addOne(o.EOF);
                                    return;
                                }
                            }
                            if (e instanceof c) {
                                if (null === n) {
                                    i.addOne(o.EPSILON);
                                    return;
                                } else if (n.isEmpty() && y) {
                                    i.addOne(o.EOF);
                                    return;
                                }
                                if (n !== f.EMPTY) {
                                    const o = s.contains(e.ruleIndex);
                                    try {
                                        s.remove(e.ruleIndex);
                                        for (let e = 0; e < n.length; e++) {
                                            const o = this.atn.states[n.getReturnState(e)];
                                            this._LOOK(o, t, n.getParent(e), i, a, s, p, y);
                                        }
                                    } finally {
                                        if (o) {
                                            s.add(e.ruleIndex);
                                        }
                                    }
                                    return;
                                }
                            }
                            for (let r = 0; r < e.transitions.length; r++) {
                                const c = e.transitions[r];
                                if (c.constructor === l) {
                                    if (s.contains(c.target.ruleIndex)) {
                                        continue;
                                    }
                                    const e = g.create(n, c.followState.stateNumber);
                                    try {
                                        s.add(c.target.ruleIndex);
                                        this._LOOK(c.target, t, e, i, a, s, p, y);
                                    } finally {
                                        s.remove(c.target.ruleIndex);
                                    }
                                } else if (c instanceof m) {
                                    if (p) {
                                        this._LOOK(c.target, t, n, i, a, s, p, y);
                                    } else {
                                        i.addOne(h.HIT_PRED);
                                    }
                                } else if (c.isEpsilon) {
                                    this._LOOK(c.target, t, n, i, a, s, p, y);
                                } else if (c.constructor === d) {
                                    i.addRange(o.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType);
                                } else {
                                    let e = c.label;
                                    if (null !== e) {
                                        if (c instanceof u) {
                                            e = e.complement(o.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType);
                                        }
                                        i.addSet(e);
                                    }
                                }
                            }
                        }
                    }
                }

                h.HIT_PRED = o.INVALID_TYPE;
                e.exports = h;
            },
            7318: function (e, t, n) {
                const { Token: i } = n(5537),
                    a = n(9612),
                    o = n(462),
                    { RecognitionException: r } = n(586),
                    { LexerNoViableAltException: s } = n(586);

                class c extends a {
                    constructor(e) {
                        super();
                        this._input = e;
                        this._factory = o.DEFAULT;
                        this._tokenFactorySourcePair = [this, e];
                        this._interp = null;
                        this._token = null;
                        this._tokenStartCharIndex = -1;
                        this._tokenStartLine = -1;
                        this._tokenStartColumn = -1;
                        this._hitEOF = !1;
                        this._channel = i.DEFAULT_CHANNEL;
                        this._type = i.INVALID_TYPE;
                        this._modeStack = [];
                        this._mode = c.DEFAULT_MODE;
                        this._text = null;
                    }

                    reset() {
                        if (null !== this._input) {
                            this._input.seek(0);
                        }
                        this._token = null;
                        this._type = i.INVALID_TYPE;
                        this._channel = i.DEFAULT_CHANNEL;
                        this._tokenStartCharIndex = -1;
                        this._tokenStartColumn = -1;
                        this._tokenStartLine = -1;
                        this._text = null;
                        this._hitEOF = !1;
                        this._mode = c.DEFAULT_MODE;
                        this._modeStack = [];
                        this._interp.reset();
                    }

                    nextToken() {
                        if (null === this._input) {
                            throw 'nextToken requires a non-null input stream.';
                        }
                        const e = this._input.mark();
                        try {
                            for (;;) {
                                if (this._hitEOF) {
                                    this.emitEOF();
                                    return this._token;
                                }
                                this._token = null;
                                this._channel = i.DEFAULT_CHANNEL;
                                this._tokenStartCharIndex = this._input.index;
                                this._tokenStartColumn = this._interp.column;
                                this._tokenStartLine = this._interp.line;
                                this._text = null;
                                let e = !1;
                                for (;;) {
                                    this._type = i.INVALID_TYPE;
                                    let t = c.SKIP;
                                    try {
                                        t = this._interp.match(this._input, this._mode);
                                    } catch (e) {
                                        if (e instanceof r) {
                                            this.notifyListeners(e);
                                            this.recover(e);
                                        } else {
                                            console.log(e.stack);
                                            throw e;
                                        }
                                    }
                                    if (this._input.LA(1) === i.EOF) {
                                        this._hitEOF = !0;
                                    }
                                    if (this._type === i.INVALID_TYPE) {
                                        this._type = t;
                                    }
                                    if (this._type === c.SKIP) {
                                        e = !0;
                                        break;
                                    }
                                    if (this._type !== c.MORE) {
                                        break;
                                    }
                                }
                                if (!e) {
                                    if (null === this._token) {
                                        this.emit();
                                    }
                                    return this._token;
                                }
                            }
                        } finally {
                            this._input.release(e);
                        }
                    }

                    skip() {
                        this._type = c.SKIP;
                    }

                    more() {
                        this._type = c.MORE;
                    }

                    mode(e) {
                        this._mode = e;
                    }

                    pushMode(e) {
                        if (this._interp.debug) {
                            console.log('pushMode ' + e);
                        }
                        this._modeStack.push(this._mode);
                        this.mode(e);
                    }

                    popMode() {
                        if (0 === this._modeStack.length) {
                            throw 'Empty Stack';
                        }
                        if (this._interp.debug) {
                            console.log('popMode back to ' + this._modeStack.slice(0, -1));
                        }
                        this.mode(this._modeStack.pop());
                        return this._mode;
                    }

                    emitToken(e) {
                        this._token = e;
                    }

                    emit() {
                        const e = this._factory.create(
                            this._tokenFactorySourcePair,
                            this._type,
                            this._text,
                            this._channel,
                            this._tokenStartCharIndex,
                            this.getCharIndex() - 1,
                            this._tokenStartLine,
                            this._tokenStartColumn,
                        );
                        this.emitToken(e);
                        return e;
                    }

                    emitEOF() {
                        const e = this.column,
                            t = this.line,
                            n = this._factory.create(
                                this._tokenFactorySourcePair,
                                i.EOF,
                                null,
                                i.DEFAULT_CHANNEL,
                                this._input.index,
                                this._input.index - 1,
                                t,
                                e,
                            );
                        this.emitToken(n);
                        return n;
                    }

                    getCharIndex() {
                        return this._input.index;
                    }

                    getAllTokens() {
                        const e = [];
                        let t = this.nextToken();
                        for (; t.type !== i.EOF; ) {
                            e.push(t);
                            t = this.nextToken();
                        }
                        return e;
                    }

                    notifyListeners(e) {
                        const t = this._tokenStartCharIndex,
                            n = this._input.index,
                            i = this._input.getText(t, n),
                            a = "token recognition error at: '" + this.getErrorDisplay(i) + "'";
                        this.getErrorListenerDispatch().syntaxError(
                            this,
                            null,
                            this._tokenStartLine,
                            this._tokenStartColumn,
                            a,
                            e,
                        );
                    }

                    getErrorDisplay(e) {
                        const t = [];
                        for (let n = 0; n < e.length; n++) {
                            t.push(e[n]);
                        }
                        return t.join('');
                    }

                    getErrorDisplayForChar(e) {
                        if (e.charCodeAt(0) === i.EOF) {
                            return '<EOF>';
                        } else if ('\n' === e) {
                            return '\\n';
                        } else if ('\t' === e) {
                            return '\\t';
                        } else if ('\r' === e) {
                            return '\\r';
                        } else {
                            return e;
                        }
                    }

                    getCharErrorDisplay(e) {
                        return "'" + this.getErrorDisplayForChar(e) + "'";
                    }

                    recover(e) {
                        if (this._input.LA(1) !== i.EOF) {
                            if (e instanceof s) {
                                this._interp.consume(this._input);
                            } else {
                                this._input.consume();
                            }
                        }
                    }

                    get inputStream() {
                        return this._input;
                    }

                    set inputStream(e) {
                        this._input = null;
                        this._tokenFactorySourcePair = [this, this._input];
                        this.reset();
                        this._input = e;
                        this._tokenFactorySourcePair = [this, this._input];
                    }

                    get sourceName() {
                        return this._input.sourceName;
                    }

                    get type() {
                        return this._type;
                    }

                    set type(e) {
                        this._type = e;
                    }

                    get line() {
                        return this._interp.line;
                    }

                    set line(e) {
                        this._interp.line = e;
                    }

                    get column() {
                        return this._interp.column;
                    }

                    set column(e) {
                        this._interp.column = e;
                    }

                    get text() {
                        if (null !== this._text) {
                            return this._text;
                        } else {
                            return this._interp.getText(this._input);
                        }
                    }

                    set text(e) {
                        this._text = e;
                    }
                }

                c.DEFAULT_MODE = 0;
                c.MORE = -2;
                c.SKIP = -3;
                c.DEFAULT_TOKEN_CHANNEL = i.DEFAULT_CHANNEL;
                c.HIDDEN = i.HIDDEN_CHANNEL;
                c.MIN_CHAR_VALUE = 0;
                c.MAX_CHAR_VALUE = 1114111;
                e.exports = c;
            },
            233: function (e, t, n) {
                const { Token: i } = n(5537),
                    { ParseTreeListener: a, TerminalNode: o, ErrorNode: r } = n(5489),
                    s = n(9612),
                    { DefaultErrorStrategy: c } = n(422),
                    l = n(6220),
                    u = n(8550),
                    d = n(7318);

                class m extends a {
                    constructor(e) {
                        super();
                        this.parser = e;
                    }

                    enterEveryRule(e) {
                        console.log(
                            'enter   ' +
                                this.parser.ruleNames[e.ruleIndex] +
                                ', LT(1)=' +
                                this.parser._input.LT(1).text,
                        );
                    }

                    visitTerminal(e) {
                        console.log(
                            'consume ' + e.symbol + ' rule ' + this.parser.ruleNames[this.parser._ctx.ruleIndex],
                        );
                    }

                    exitEveryRule(e) {
                        console.log(
                            'exit    ' +
                                this.parser.ruleNames[e.ruleIndex] +
                                ', LT(1)=' +
                                this.parser._input.LT(1).text,
                        );
                    }
                }

                class p extends s {
                    constructor(e) {
                        super();
                        this._input = null;
                        this._errHandler = new c();
                        this._precedenceStack = [];
                        this._precedenceStack.push(0);
                        this._ctx = null;
                        this.buildParseTrees = !0;
                        this._tracer = null;
                        this._parseListeners = null;
                        this._syntaxErrors = 0;
                        this.setInputStream(e);
                    }

                    reset() {
                        if (null !== this._input) {
                            this._input.seek(0);
                        }
                        this._errHandler.reset(this);
                        this._ctx = null;
                        this._syntaxErrors = 0;
                        this.setTrace(!1);
                        this._precedenceStack = [];
                        this._precedenceStack.push(0);
                        if (null !== this._interp) {
                            this._interp.reset();
                        }
                    }

                    match(e) {
                        let t = this.getCurrentToken();
                        if (t.type === e) {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        } else {
                            t = this._errHandler.recoverInline(this);
                            if (this.buildParseTrees && -1 === t.tokenIndex) {
                                this._ctx.addErrorNode(t);
                            }
                        }
                        return t;
                    }

                    matchWildcard() {
                        let e = this.getCurrentToken();
                        if (e.type > 0) {
                            this._errHandler.reportMatch(this);
                            this.consume();
                        } else {
                            e = this._errHandler.recoverInline(this);
                            if (this._buildParseTrees && -1 === e.tokenIndex) {
                                this._ctx.addErrorNode(e);
                            }
                        }
                        return e;
                    }

                    getParseListeners() {
                        return this._parseListeners || [];
                    }

                    addParseListener(e) {
                        if (null === e) {
                            throw 'listener';
                        }
                        if (null === this._parseListeners) {
                            this._parseListeners = [];
                        }
                        this._parseListeners.push(e);
                    }

                    removeParseListener(e) {
                        if (null !== this._parseListeners) {
                            const t = this._parseListeners.indexOf(e);
                            if (t >= 0) {
                                this._parseListeners.splice(t, 1);
                            }
                            if (0 === this._parseListeners.length) {
                                this._parseListeners = null;
                            }
                        }
                    }

                    removeParseListeners() {
                        this._parseListeners = null;
                    }

                    triggerEnterRuleEvent() {
                        if (null !== this._parseListeners) {
                            const e = this._ctx;
                            this._parseListeners.forEach(function (t) {
                                t.enterEveryRule(e);
                                e.enterRule(t);
                            });
                        }
                    }

                    triggerExitRuleEvent() {
                        if (null !== this._parseListeners) {
                            const e = this._ctx;
                            this._parseListeners
                                .slice(0)
                                .reverse()
                                .forEach(function (t) {
                                    e.exitRule(t);
                                    t.exitEveryRule(e);
                                });
                        }
                    }

                    getTokenFactory() {
                        return this._input.tokenSource._factory;
                    }

                    setTokenFactory(e) {
                        this._input.tokenSource._factory = e;
                    }

                    getATNWithBypassAlts() {
                        const e = this.getSerializedATN();
                        if (null === e) {
                            throw 'The current parser does not support an ATN with bypass alternatives.';
                        }
                        let t = this.bypassAltsAtnCache[e];
                        if (null === t) {
                            const n = new u();
                            n.generateRuleBypassTransitions = !0;
                            t = new l(n).deserialize(e);
                            this.bypassAltsAtnCache[e] = t;
                        }
                        return t;
                    }

                    compileParseTreePattern(e, t, n) {
                        if (null === (n = n || null)) {
                            if (null !== this.getTokenStream()) {
                                const e = this.getTokenStream().tokenSource;
                                if (e instanceof d) {
                                    n = e;
                                }
                            }
                        }
                        if (null === n) {
                            throw "Parser can't discover a lexer to use";
                        }
                        return new ParseTreePatternMatcher(n, this).compile(e, t);
                    }

                    getInputStream() {
                        return this.getTokenStream();
                    }

                    setInputStream(e) {
                        this.setTokenStream(e);
                    }

                    getTokenStream() {
                        return this._input;
                    }

                    setTokenStream(e) {
                        this._input = null;
                        this.reset();
                        this._input = e;
                    }

                    getCurrentToken() {
                        return this._input.LT(1);
                    }

                    notifyErrorListeners(e, t, n) {
                        n = n || null;
                        if (null === (t = t || null)) {
                            t = this.getCurrentToken();
                        }
                        this._syntaxErrors += 1;
                        const i = t.line,
                            a = t.column;
                        this.getErrorListenerDispatch().syntaxError(this, t, i, a, e, n);
                    }

                    consume() {
                        const e = this.getCurrentToken();
                        if (e.type !== i.EOF) {
                            this.getInputStream().consume();
                        }
                        const t = null !== this._parseListeners && this._parseListeners.length > 0;
                        if (this.buildParseTrees || t) {
                            let n;
                            if (this._errHandler.inErrorRecoveryMode(this)) {
                                n = this._ctx.addErrorNode(e);
                            } else {
                                n = this._ctx.addTokenNode(e);
                            }
                            n.invokingState = this.state;
                            if (t) {
                                this._parseListeners.forEach(function (e) {
                                    if (n instanceof r || (void 0 !== n.isErrorNode && n.isErrorNode())) {
                                        e.visitErrorNode(n);
                                    } else if (n instanceof o) {
                                        e.visitTerminal(n);
                                    }
                                });
                            }
                        }
                        return e;
                    }

                    addContextToParseTree() {
                        if (null !== this._ctx.parentCtx) {
                            this._ctx.parentCtx.addChild(this._ctx);
                        }
                    }

                    enterRule(e, t, n) {
                        this.state = t;
                        this._ctx = e;
                        this._ctx.start = this._input.LT(1);
                        if (this.buildParseTrees) {
                            this.addContextToParseTree();
                        }
                        this.triggerEnterRuleEvent();
                    }

                    exitRule() {
                        this._ctx.stop = this._input.LT(-1);
                        this.triggerExitRuleEvent();
                        this.state = this._ctx.invokingState;
                        this._ctx = this._ctx.parentCtx;
                    }

                    enterOuterAlt(e, t) {
                        e.setAltNumber(t);
                        if (this.buildParseTrees && this._ctx !== e) {
                            if (null !== this._ctx.parentCtx) {
                                this._ctx.parentCtx.removeLastChild();
                                this._ctx.parentCtx.addChild(e);
                            }
                        }
                        this._ctx = e;
                    }

                    getPrecedence() {
                        if (0 === this._precedenceStack.length) {
                            return -1;
                        } else {
                            return this._precedenceStack[this._precedenceStack.length - 1];
                        }
                    }

                    enterRecursionRule(e, t, n, i) {
                        this.state = t;
                        this._precedenceStack.push(i);
                        this._ctx = e;
                        this._ctx.start = this._input.LT(1);
                        this.triggerEnterRuleEvent();
                    }

                    pushNewRecursionContext(e, t, n) {
                        const i = this._ctx;
                        i.parentCtx = e;
                        i.invokingState = t;
                        i.stop = this._input.LT(-1);
                        this._ctx = e;
                        this._ctx.start = i.start;
                        if (this.buildParseTrees) {
                            this._ctx.addChild(i);
                        }
                        this.triggerEnterRuleEvent();
                    }

                    unrollRecursionContexts(e) {
                        this._precedenceStack.pop();
                        this._ctx.stop = this._input.LT(-1);
                        const t = this._ctx,
                            n = this.getParseListeners();
                        if (null !== n && n.length > 0) {
                            for (; this._ctx !== e; ) {
                                this.triggerExitRuleEvent();
                                this._ctx = this._ctx.parentCtx;
                            }
                        } else {
                            this._ctx = e;
                        }
                        t.parentCtx = e;
                        if (this.buildParseTrees && null !== e) {
                            e.addChild(t);
                        }
                    }

                    getInvokingContext(e) {
                        let t = this._ctx;
                        for (; null !== t; ) {
                            if (t.ruleIndex === e) {
                                return t;
                            }
                            t = t.parentCtx;
                        }
                        return null;
                    }

                    precpred(e, t) {
                        return t >= this._precedenceStack[this._precedenceStack.length - 1];
                    }

                    inContext(e) {
                        return !1;
                    }

                    isExpectedToken(e) {
                        const t = this._interp.atn;
                        let n = this._ctx;
                        const a = t.states[this.state];
                        let o = t.nextTokens(a);
                        if (o.contains(e)) {
                            return !0;
                        }
                        if (!o.contains(i.EPSILON)) {
                            return !1;
                        }
                        for (; null !== n && n.invokingState >= 0 && o.contains(i.EPSILON); ) {
                            const i = t.states[n.invokingState].transitions[0];
                            o = t.nextTokens(i.followState);
                            if (o.contains(e)) {
                                return !0;
                            }
                            n = n.parentCtx;
                        }
                        if (o.contains(i.EPSILON) && e === i.EOF) {
                            return !0;
                        } else {
                            return !1;
                        }
                    }

                    getExpectedTokens() {
                        return this._interp.atn.getExpectedTokens(this.state, this._ctx);
                    }

                    getExpectedTokensWithinCurrentRule() {
                        const e = this._interp.atn,
                            t = e.states[this.state];
                        return e.nextTokens(t);
                    }

                    getRuleIndex(e) {
                        const t = this.getRuleIndexMap()[e];
                        if (null !== t) {
                            return t;
                        } else {
                            return -1;
                        }
                    }

                    getRuleInvocationStack(e) {
                        if (null === (e = e || null)) {
                            e = this._ctx;
                        }
                        const t = [];
                        for (; null !== e; ) {
                            const n = e.ruleIndex;
                            if (n < 0) {
                                t.push('n/a');
                            } else {
                                t.push(this.ruleNames[n]);
                            }
                            e = e.parentCtx;
                        }
                        return t;
                    }

                    getDFAStrings() {
                        return this._interp.decisionToDFA.toString();
                    }

                    dumpDFA() {
                        let e = !1;
                        for (let t = 0; t < this._interp.decisionToDFA.length; t++) {
                            const n = this._interp.decisionToDFA[t];
                            if (n.states.length > 0) {
                                if (e) {
                                    console.log();
                                }
                                this.printer.println('Decision ' + n.decision + ':');
                                this.printer.print(n.toString(this.literalNames, this.symbolicNames));
                                e = !0;
                            }
                        }
                    }

                    getSourceName() {
                        return this._input.sourceName;
                    }

                    setTrace(e) {
                        if (!e) {
                            this.removeParseListener(this._tracer);
                            this._tracer = null;
                        } else {
                            if (null !== this._tracer) {
                                this.removeParseListener(this._tracer);
                            }
                            this._tracer = new m(this);
                            this.addParseListener(this._tracer);
                        }
                    }
                }

                p.bypassAltsAtnCache = {};
                e.exports = p;
            },
            72: function (e, t, n) {
                const i = n(2841),
                    a = n(5489),
                    o = a.INVALID_INTERVAL,
                    r = a.TerminalNode,
                    s = a.TerminalNodeImpl,
                    c = a.ErrorNodeImpl,
                    l = n(7059).Interval;

                class u extends i {
                    constructor(e, t) {
                        super((e = e || null), (t = t || null));
                        this.ruleIndex = -1;
                        this.children = null;
                        this.start = null;
                        this.stop = null;
                        this.exception = null;
                    }

                    copyFrom(e) {
                        this.parentCtx = e.parentCtx;
                        this.invokingState = e.invokingState;
                        this.children = null;
                        this.start = e.start;
                        this.stop = e.stop;
                        if (e.children) {
                            this.children = [];
                            e.children.map(function (e) {
                                if (e instanceof c) {
                                    this.children.push(e);
                                    e.parentCtx = this;
                                }
                            }, this);
                        }
                    }

                    enterRule(e) {}

                    exitRule(e) {}

                    addChild(e) {
                        if (null === this.children) {
                            this.children = [];
                        }
                        this.children.push(e);
                        return e;
                    }

                    removeLastChild() {
                        if (null !== this.children) {
                            this.children.pop();
                        }
                    }

                    addTokenNode(e) {
                        const t = new s(e);
                        this.addChild(t);
                        t.parentCtx = this;
                        return t;
                    }

                    addErrorNode(e) {
                        const t = new c(e);
                        this.addChild(t);
                        t.parentCtx = this;
                        return t;
                    }

                    getChild(e, t) {
                        t = t || null;
                        if (null === this.children || e < 0 || e >= this.children.length) {
                            return null;
                        }
                        if (null === t) {
                            return this.children[e];
                        } else {
                            for (let n = 0; n < this.children.length; n++) {
                                const i = this.children[n];
                                if (i instanceof t) {
                                    if (0 === e) {
                                        return i;
                                    } else {
                                        e -= 1;
                                    }
                                }
                            }
                            return null;
                        }
                    }

                    getToken(e, t) {
                        if (null === this.children || t < 0 || t >= this.children.length) {
                            return null;
                        }
                        for (let n = 0; n < this.children.length; n++) {
                            const i = this.children[n];
                            if (i instanceof r) {
                                if (i.symbol.type === e) {
                                    if (0 === t) {
                                        return i;
                                    } else {
                                        t -= 1;
                                    }
                                }
                            }
                        }
                        return null;
                    }

                    getTokens(e) {
                        if (null === this.children) {
                            return [];
                        } else {
                            const t = [];
                            for (let n = 0; n < this.children.length; n++) {
                                const i = this.children[n];
                                if (i instanceof r) {
                                    if (i.symbol.type === e) {
                                        t.push(i);
                                    }
                                }
                            }
                            return t;
                        }
                    }

                    getTypedRuleContext(e, t) {
                        return this.getChild(t, e);
                    }

                    getTypedRuleContexts(e) {
                        if (null === this.children) {
                            return [];
                        } else {
                            const t = [];
                            for (let n = 0; n < this.children.length; n++) {
                                const i = this.children[n];
                                if (i instanceof e) {
                                    t.push(i);
                                }
                            }
                            return t;
                        }
                    }

                    getChildCount() {
                        if (null === this.children) {
                            return 0;
                        } else {
                            return this.children.length;
                        }
                    }

                    getSourceInterval() {
                        if (null === this.start || null === this.stop) {
                            return o;
                        } else {
                            return new l(this.start.tokenIndex, this.stop.tokenIndex);
                        }
                    }
                }

                i.EMPTY = new u();
                e.exports = u;
            },
            6400: function (e, t, n) {
                const i = n(2841),
                    { Hash: a, Map: o, equalArrays: r } = n(2373);

                class s {
                    constructor(e) {
                        this.cachedHashCode = e;
                    }

                    isEmpty() {
                        return this === s.EMPTY;
                    }

                    hasEmptyPath() {
                        return this.getReturnState(this.length - 1) === s.EMPTY_RETURN_STATE;
                    }

                    hashCode() {
                        return this.cachedHashCode;
                    }

                    updateHashCode(e) {
                        e.update(this.cachedHashCode);
                    }
                }

                s.EMPTY = null;
                s.EMPTY_RETURN_STATE = 2147483647;
                s.globalNodeCount = 1;
                s.id = s.globalNodeCount;

                class c extends s {
                    constructor(e, t) {
                        let n = 0;
                        const i = new a();
                        if (null !== e) {
                            i.update(e, t);
                        } else {
                            i.update(1);
                        }
                        n = i.finish();
                        super(n);
                        this.parentCtx = e;
                        this.returnState = t;
                    }

                    getParent(e) {
                        return this.parentCtx;
                    }

                    getReturnState(e) {
                        return this.returnState;
                    }

                    equals(e) {
                        if (this === e) {
                            return !0;
                        } else if (!(e instanceof c)) {
                            return !1;
                        } else if (this.hashCode() !== e.hashCode()) {
                            return !1;
                        } else if (this.returnState !== e.returnState) {
                            return !1;
                        } else if (null == this.parentCtx) {
                            return null == e.parentCtx;
                        } else {
                            return this.parentCtx.equals(e.parentCtx);
                        }
                    }

                    toString() {
                        const e = null === this.parentCtx ? '' : this.parentCtx.toString();
                        if (0 === e.length) {
                            if (this.returnState === s.EMPTY_RETURN_STATE) {
                                return '$';
                            } else {
                                return '' + this.returnState;
                            }
                        } else {
                            return this.returnState + ' ' + e;
                        }
                    }

                    get length() {
                        return 1;
                    }

                    static create(e, t) {
                        if (t === s.EMPTY_RETURN_STATE && null === e) {
                            return s.EMPTY;
                        } else {
                            return new c(e, t);
                        }
                    }
                }

                class l extends c {
                    constructor() {
                        super(null, s.EMPTY_RETURN_STATE);
                    }

                    isEmpty() {
                        return !0;
                    }

                    getParent(e) {
                        return null;
                    }

                    getReturnState(e) {
                        return this.returnState;
                    }

                    equals(e) {
                        return this === e;
                    }

                    toString() {
                        return '$';
                    }
                }

                s.EMPTY = new l();

                class u extends s {
                    constructor(e, t) {
                        const n = new a();
                        n.update(e, t);
                        super(n.finish());
                        this.parents = e;
                        this.returnStates = t;
                        return this;
                    }

                    isEmpty() {
                        return this.returnStates[0] === s.EMPTY_RETURN_STATE;
                    }

                    getParent(e) {
                        return this.parents[e];
                    }

                    getReturnState(e) {
                        return this.returnStates[e];
                    }

                    equals(e) {
                        if (this === e) {
                            return !0;
                        } else if (!(e instanceof u)) {
                            return !1;
                        } else if (this.hashCode() !== e.hashCode()) {
                            return !1;
                        } else {
                            return r(this.returnStates, e.returnStates) && r(this.parents, e.parents);
                        }
                    }

                    toString() {
                        if (this.isEmpty()) {
                            return '[]';
                        } else {
                            let e = '[';
                            for (let t = 0; t < this.returnStates.length; t++) {
                                if (t > 0) {
                                    e += ', ';
                                }
                                if (this.returnStates[t] !== s.EMPTY_RETURN_STATE) {
                                    e += this.returnStates[t];
                                    if (null !== this.parents[t]) {
                                        e = e + ' ' + this.parents[t];
                                    } else {
                                        e += 'null';
                                    }
                                } else {
                                    e += '$';
                                }
                            }
                            return e + ']';
                        }
                    }

                    get length() {
                        return this.returnStates.length;
                    }
                }

                function d(e, t, n, i) {
                    if (e === t) {
                        return e;
                    }
                    if (e instanceof c && t instanceof c) {
                        return (function (e, t, n, i) {
                            if (null !== i) {
                                let n = i.get(e, t);
                                if (null !== n) {
                                    return n;
                                }
                                n = i.get(t, e);
                                if (null !== n) {
                                    return n;
                                }
                            }
                            const a = (function (e, t, n) {
                                if (n) {
                                    if (e === s.EMPTY) {
                                        return s.EMPTY;
                                    }
                                    if (t === s.EMPTY) {
                                        return s.EMPTY;
                                    }
                                } else if (e === s.EMPTY && t === s.EMPTY) {
                                    return s.EMPTY;
                                } else if (e === s.EMPTY) {
                                    const e = [t.returnState, s.EMPTY_RETURN_STATE],
                                        n = [t.parentCtx, null];
                                    return new u(n, e);
                                } else if (t === s.EMPTY) {
                                    const t = [e.returnState, s.EMPTY_RETURN_STATE],
                                        n = [e.parentCtx, null];
                                    return new u(n, t);
                                }
                                return null;
                            })(e, t, n);
                            if (null !== a) {
                                if (null !== i) {
                                    i.set(e, t, a);
                                }
                                return a;
                            }
                            if (e.returnState === t.returnState) {
                                const a = d(e.parentCtx, t.parentCtx, n, i);
                                if (a === e.parentCtx) {
                                    return e;
                                }
                                if (a === t.parentCtx) {
                                    return t;
                                }
                                const o = c.create(a, e.returnState);
                                if (null !== i) {
                                    i.set(e, t, o);
                                }
                                return o;
                            } else {
                                let n = null;
                                if (e === t || (null !== e.parentCtx && e.parentCtx === t.parentCtx)) {
                                    n = e.parentCtx;
                                }
                                if (null !== n) {
                                    const a = [e.returnState, t.returnState];
                                    if (e.returnState > t.returnState) {
                                        a[0] = t.returnState;
                                        a[1] = e.returnState;
                                    }
                                    const o = new u([n, n], a);
                                    if (null !== i) {
                                        i.set(e, t, o);
                                    }
                                    return o;
                                }
                                const a = [e.returnState, t.returnState];
                                let o = [e.parentCtx, t.parentCtx];
                                if (e.returnState > t.returnState) {
                                    a[0] = t.returnState;
                                    a[1] = e.returnState;
                                    o = [t.parentCtx, e.parentCtx];
                                }
                                const r = new u(o, a);
                                if (null !== i) {
                                    i.set(e, t, r);
                                }
                                return r;
                            }
                        })(e, t, n, i);
                    }
                    if (n) {
                        if (e instanceof l) {
                            return e;
                        }
                        if (t instanceof l) {
                            return t;
                        }
                    }
                    if (e instanceof c) {
                        e = new u([e.getParent()], [e.returnState]);
                    }
                    if (t instanceof c) {
                        t = new u([t.getParent()], [t.returnState]);
                    }
                    return (function (e, t, n, i) {
                        if (null !== i) {
                            let n = i.get(e, t);
                            if (null !== n) {
                                return n;
                            }
                            n = i.get(t, e);
                            if (null !== n) {
                                return n;
                            }
                        }
                        let a = 0,
                            r = 0,
                            l = 0,
                            m = [],
                            p = [];
                        for (; a < e.returnStates.length && r < t.returnStates.length; ) {
                            const o = e.parents[a],
                                c = t.parents[r];
                            if (e.returnStates[a] === t.returnStates[r]) {
                                const t = e.returnStates[a];
                                if (
                                    (t === s.EMPTY_RETURN_STATE && null === o && null === c) ||
                                    (null !== o && null !== c && o === c)
                                ) {
                                    p[l] = o;
                                    m[l] = t;
                                } else {
                                    p[l] = d(o, c, n, i);
                                    m[l] = t;
                                }
                                a += 1;
                                r += 1;
                            } else if (e.returnStates[a] < t.returnStates[r]) {
                                p[l] = o;
                                m[l] = e.returnStates[a];
                                a += 1;
                            } else {
                                p[l] = c;
                                m[l] = t.returnStates[r];
                                r += 1;
                            }
                            l += 1;
                        }
                        if (a < e.returnStates.length) {
                            for (let t = a; t < e.returnStates.length; t++) {
                                p[l] = e.parents[t];
                                m[l] = e.returnStates[t];
                                l += 1;
                            }
                        } else {
                            for (let e = r; e < t.returnStates.length; e++) {
                                p[l] = t.parents[e];
                                m[l] = t.returnStates[e];
                                l += 1;
                            }
                        }
                        if (l < p.length) {
                            if (1 === l) {
                                const n = c.create(p[0], m[0]);
                                if (null !== i) {
                                    i.set(e, t, n);
                                }
                                return n;
                            }
                            p = p.slice(0, l);
                            m = m.slice(0, l);
                        }
                        const f = new u(p, m);
                        if (f === e) {
                            if (null !== i) {
                                i.set(e, t, e);
                            }
                            return e;
                        }
                        if (f === t) {
                            if (null !== i) {
                                i.set(e, t, t);
                            }
                            return t;
                        }
                        !(function (e) {
                            const t = new o();
                            for (let n = 0; n < e.length; n++) {
                                const i = e[n];
                                if (!t.containsKey(i)) {
                                    t.put(i, i);
                                }
                            }
                            for (let n = 0; n < e.length; n++) {
                                e[n] = t.get(e[n]);
                            }
                        })(p);
                        if (null !== i) {
                            i.set(e, t, f);
                        }
                        return f;
                    })(e, t, n, i);
                }

                e.exports = {
                    merge: d,
                    PredictionContext: s,
                    PredictionContextCache: class {
                        constructor() {
                            this.cache = new o();
                        }

                        add(e) {
                            if (e === s.EMPTY) {
                                return s.EMPTY;
                            }
                            const t = this.cache.get(e) || null;
                            if (null !== t) {
                                return t;
                            }
                            this.cache.put(e, e);
                            return e;
                        }

                        get(e) {
                            return this.cache.get(e) || null;
                        }

                        get length() {
                            return this.cache.length;
                        }
                    },
                    SingletonPredictionContext: c,
                    predictionContextFromRuleContext: function e(t, n) {
                        if (null == n) {
                            n = i.EMPTY;
                        }
                        if (null === n.parentCtx || n === i.EMPTY) {
                            return s.EMPTY;
                        }
                        const a = e(t, n.parentCtx),
                            o = t.states[n.invokingState].transitions[0];
                        return c.create(a, o.followState.stateNumber);
                    },
                    getCachedPredictionContext: function e(t, n, i) {
                        if (t.isEmpty()) {
                            return t;
                        }
                        let a = i.get(t) || null;
                        if (null !== a) {
                            return a;
                        }
                        a = n.get(t);
                        if (null !== a) {
                            i.put(t, a);
                            return a;
                        }
                        let o = !1,
                            r = [];
                        for (let a = 0; a < r.length; a++) {
                            const s = e(t.getParent(a), n, i);
                            if (o || s !== t.getParent(a)) {
                                if (!o) {
                                    r = [];
                                    for (let e = 0; e < t.length; e++) {
                                        r[e] = t.getParent(e);
                                    }
                                    o = !0;
                                }
                                r[a] = s;
                            }
                        }
                        if (!o) {
                            n.add(t);
                            i.put(t, t);
                            return t;
                        }
                        let l = null;
                        if (0 === r.length) {
                            l = s.EMPTY;
                        } else if (1 === r.length) {
                            l = c.create(r[0], t.getReturnState(0));
                        } else {
                            l = new u(r, t.returnStates);
                        }
                        n.add(l);
                        i.put(l, l);
                        i.put(t, l);
                        return l;
                    },
                };
            },
            9612: function (e, t, n) {
                const { Token: i } = n(5537),
                    { ConsoleErrorListener: a } = n(6207),
                    { ProxyErrorListener: o } = n(6207);

                class r {
                    constructor() {
                        this._listeners = [a.INSTANCE];
                        this._interp = null;
                        this._stateNumber = -1;
                    }

                    checkVersion(e) {
                        const t = '4.9.3';
                        if (t !== e) {
                            console.log('ANTLR runtime and generated code versions disagree: 4.9.3!=' + e);
                        }
                    }

                    addErrorListener(e) {
                        this._listeners.push(e);
                    }

                    removeErrorListeners() {
                        this._listeners = [];
                    }

                    getLiteralNames() {
                        return Object.getPrototypeOf(this).constructor.literalNames || [];
                    }

                    getSymbolicNames() {
                        return Object.getPrototypeOf(this).constructor.symbolicNames || [];
                    }

                    getTokenNames() {
                        if (!this.tokenNames) {
                            const e = this.getLiteralNames(),
                                t = this.getSymbolicNames(),
                                n = e.length > t.length ? e.length : t.length;
                            this.tokenNames = [];
                            for (let i = 0; i < n; i++) {
                                this.tokenNames[i] = e[i] || t[i] || '<INVALID';
                            }
                        }
                        return this.tokenNames;
                    }

                    getTokenTypeMap() {
                        const e = this.getTokenNames();
                        if (null === e) {
                            throw 'The current recognizer does not provide a list of token names.';
                        }
                        let t = this.tokenTypeMapCache[e];
                        if (void 0 === t) {
                            t = e.reduce(function (e, t, n) {
                                e[t] = n;
                            });
                            t.EOF = i.EOF;
                            this.tokenTypeMapCache[e] = t;
                        }
                        return t;
                    }

                    getRuleIndexMap() {
                        const e = this.ruleNames;
                        if (null === e) {
                            throw 'The current recognizer does not provide a list of rule names.';
                        }
                        let t = this.ruleIndexMapCache[e];
                        if (void 0 === t) {
                            t = e.reduce(function (e, t, n) {
                                e[t] = n;
                            });
                            this.ruleIndexMapCache[e] = t;
                        }
                        return t;
                    }

                    getTokenType(e) {
                        const t = this.getTokenTypeMap()[e];
                        if (void 0 !== t) {
                            return t;
                        } else {
                            return i.INVALID_TYPE;
                        }
                    }

                    getErrorHeader(e) {
                        return 'line ' + e.getOffendingToken().line + ':' + e.getOffendingToken().column;
                    }

                    getTokenErrorDisplay(e) {
                        if (null === e) {
                            return '<no token>';
                        }
                        let t = e.text;
                        if (null === t) {
                            if (e.type === i.EOF) {
                                t = '<EOF>';
                            } else {
                                t = '<' + e.type + '>';
                            }
                        }
                        t = t.replace('\n', '\\n').replace('\r', '\\r').replace('\t', '\\t');
                        return "'" + t + "'";
                    }

                    getErrorListenerDispatch() {
                        return new o(this._listeners);
                    }

                    sempred(e, t, n) {
                        return !0;
                    }

                    precpred(e, t) {
                        return !0;
                    }

                    get state() {
                        return this._stateNumber;
                    }

                    set state(e) {
                        this._stateNumber = e;
                    }
                }

                r.tokenTypeMapCache = {};
                r.ruleIndexMapCache = {};
                e.exports = r;
            },
            2841: function (e, t, n) {
                const { RuleNode: i } = n(5489),
                    { INVALID_INTERVAL: a } = n(5489),
                    o = n(164);
                e.exports = class extends i {
                    constructor(e, t) {
                        super();
                        this.parentCtx = e || null;
                        this.invokingState = t || -1;
                    }

                    depth() {
                        let e = 0,
                            t = this;
                        for (; null !== t; ) {
                            t = t.parentCtx;
                            e += 1;
                        }
                        return e;
                    }

                    isEmpty() {
                        return -1 === this.invokingState;
                    }

                    getSourceInterval() {
                        return a;
                    }

                    getRuleContext() {
                        return this;
                    }

                    getPayload() {
                        return this;
                    }

                    getText() {
                        if (0 === this.getChildCount()) {
                            return '';
                        } else {
                            return this.children
                                .map(function (e) {
                                    return e.getText();
                                })
                                .join('');
                        }
                    }

                    getAltNumber() {
                        return 0;
                    }

                    setAltNumber(e) {}

                    getChild(e) {
                        return null;
                    }

                    getChildCount() {
                        return 0;
                    }

                    accept(e) {
                        return e.visitChildren(this);
                    }

                    toStringTree(e, t) {
                        return o.toStringTree(this, e, t);
                    }

                    toString(e, t) {
                        e = e || null;
                        t = t || null;
                        let n = this,
                            i = '[';
                        for (; null !== n && n !== t; ) {
                            if (null === e) {
                                if (!n.isEmpty()) {
                                    i += n.invokingState;
                                }
                            } else {
                                const t = n.ruleIndex;
                                i += t >= 0 && t < e.length ? e[t] : '' + t;
                            }
                            if (null !== n.parentCtx && (null !== e || !n.parentCtx.isEmpty())) {
                                i += ' ';
                            }
                            n = n.parentCtx;
                        }
                        i += ']';
                        return i;
                    }
                };
            },
            5537: function (e) {
                class t {
                    constructor() {
                        this.source = null;
                        this.type = null;
                        this.channel = null;
                        this.start = null;
                        this.stop = null;
                        this.tokenIndex = null;
                        this.line = null;
                        this.column = null;
                        this._text = null;
                    }

                    getTokenSource() {
                        return this.source[0];
                    }

                    getInputStream() {
                        return this.source[1];
                    }

                    get text() {
                        return this._text;
                    }

                    set text(e) {
                        this._text = e;
                    }
                }

                t.INVALID_TYPE = 0;
                t.EPSILON = -2;
                t.MIN_USER_TOKEN_TYPE = 1;
                t.EOF = -1;
                t.DEFAULT_CHANNEL = 0;
                t.HIDDEN_CHANNEL = 1;

                class n extends t {
                    constructor(e, i, a, o, r) {
                        super();
                        this.source = void 0 !== e ? e : n.EMPTY_SOURCE;
                        this.type = void 0 !== i ? i : null;
                        this.channel = void 0 !== a ? a : t.DEFAULT_CHANNEL;
                        this.start = void 0 !== o ? o : -1;
                        this.stop = void 0 !== r ? r : -1;
                        this.tokenIndex = -1;
                        if (null !== this.source[0]) {
                            this.line = e[0].line;
                            this.column = e[0].column;
                        } else {
                            this.column = -1;
                        }
                    }

                    clone() {
                        const e = new n(this.source, this.type, this.channel, this.start, this.stop);
                        e.tokenIndex = this.tokenIndex;
                        e.line = this.line;
                        e.column = this.column;
                        e.text = this.text;
                        return e;
                    }

                    toString() {
                        let e = this.text;
                        if (null !== e) {
                            e = e.replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t');
                        } else {
                            e = '<no text>';
                        }
                        return (
                            '[@' +
                            this.tokenIndex +
                            ',' +
                            this.start +
                            ':' +
                            this.stop +
                            "='" +
                            e +
                            "',<" +
                            this.type +
                            '>' +
                            (this.channel > 0 ? ',channel=' + this.channel : '') +
                            ',' +
                            this.line +
                            ':' +
                            this.column +
                            ']'
                        );
                    }

                    get text() {
                        if (null !== this._text) {
                            return this._text;
                        }
                        const e = this.getInputStream();
                        if (null === e) {
                            return null;
                        }
                        const t = e.size;
                        if (this.start < t && this.stop < t) {
                            return e.getText(this.start, this.stop);
                        } else {
                            return '<EOF>';
                        }
                    }

                    set text(e) {
                        this._text = e;
                    }
                }

                n.EMPTY_SOURCE = [null, null];
                e.exports = { Token: t, CommonToken: n };
            },
            2373: function (e) {
                function t(e) {
                    return null === e ? 'null' : e;
                }

                function n(e) {
                    return Array.isArray(e) ? '[' + e.map(t).join(', ') + ']' : 'null';
                }

                String.prototype.seed = String.prototype.seed || Math.round(Math.random() * Math.pow(2, 32));
                String.prototype.hashCode = function () {
                    const e = this.toString();
                    let t, n;
                    const i = 3 & e.length,
                        a = e.length - i;
                    let o = String.prototype.seed;
                    const r = 3432918353,
                        s = 461845907;
                    let c = 0;
                    for (; c < a; ) {
                        n =
                            (255 & e.charCodeAt(c)) |
                            ((255 & e.charCodeAt(++c)) << 8) |
                            ((255 & e.charCodeAt(++c)) << 16) |
                            ((255 & e.charCodeAt(++c)) << 24);
                        ++c;
                        n = ((65535 & n) * r + ((((n >>> 16) * r) & 65535) << 16)) & 4294967295;
                        n = (n << 15) | (n >>> 17);
                        n = ((65535 & n) * s + ((((n >>> 16) * s) & 65535) << 16)) & 4294967295;
                        o ^= n;
                        o = (o << 13) | (o >>> 19);
                        t = (5 * (65535 & o) + (((5 * (o >>> 16)) & 65535) << 16)) & 4294967295;
                        o = 27492 + (65535 & t) + (((58964 + (t >>> 16)) & 65535) << 16);
                    }
                    n = 0;
                    switch (i) {
                        case 3:
                            n ^= (255 & e.charCodeAt(c + 2)) << 16;
                        case 2:
                            n ^= (255 & e.charCodeAt(c + 1)) << 8;
                        case 1:
                            n ^= 255 & e.charCodeAt(c);
                            n = ((65535 & n) * r + ((((n >>> 16) * r) & 65535) << 16)) & 4294967295;
                            n = (n << 15) | (n >>> 17);
                            n = ((65535 & n) * s + ((((n >>> 16) * s) & 65535) << 16)) & 4294967295;
                            o ^= n;
                    }
                    o ^= e.length;
                    o ^= o >>> 16;
                    o = (2246822507 * (65535 & o) + (((2246822507 * (o >>> 16)) & 65535) << 16)) & 4294967295;
                    o ^= o >>> 13;
                    o = (3266489909 * (65535 & o) + (((3266489909 * (o >>> 16)) & 65535) << 16)) & 4294967295;
                    o ^= o >>> 16;
                    return o >>> 0;
                };

                function i(e, t) {
                    return e ? e.equals(t) : e == t;
                }

                function a(e) {
                    return e ? e.hashCode() : -1;
                }

                class o {
                    constructor() {
                        this.data = [];
                    }

                    add(e) {
                        this.data[e] = !0;
                    }

                    or(e) {
                        const t = this;
                        Object.keys(e.data).map(function (e) {
                            t.add(e);
                        });
                    }

                    remove(e) {
                        delete this.data[e];
                    }

                    contains(e) {
                        return !0 === this.data[e];
                    }

                    values() {
                        return Object.keys(this.data);
                    }

                    minValue() {
                        return Math.min.apply(null, this.values());
                    }

                    hashCode() {
                        const e = new s();
                        e.update(this.values());
                        return e.finish();
                    }

                    equals(e) {
                        if (!(e instanceof o)) {
                            return !1;
                        } else {
                            return this.hashCode() === e.hashCode();
                        }
                    }

                    toString() {
                        return '{' + this.values().join(', ') + '}';
                    }

                    get length() {
                        return this.values().length;
                    }
                }

                class r {
                    constructor(e, t) {
                        this.data = {};
                        this.hashFunction = e || a;
                        this.equalsFunction = t || i;
                    }

                    put(e, t) {
                        const n = 'hash_' + this.hashFunction(e);
                        if (n in this.data) {
                            const i = this.data[n];
                            for (let n = 0; n < i.length; n++) {
                                const a = i[n];
                                if (this.equalsFunction(e, a.key)) {
                                    const e = a.value;
                                    a.value = t;
                                    return e;
                                }
                            }
                            i.push({ key: e, value: t });
                            return t;
                        } else {
                            this.data[n] = [{ key: e, value: t }];
                            return t;
                        }
                    }

                    containsKey(e) {
                        const t = 'hash_' + this.hashFunction(e);
                        if (t in this.data) {
                            const n = this.data[t];
                            for (let t = 0; t < n.length; t++) {
                                const i = n[t];
                                if (this.equalsFunction(e, i.key)) {
                                    return !0;
                                }
                            }
                        }
                        return !1;
                    }

                    get(e) {
                        const t = 'hash_' + this.hashFunction(e);
                        if (t in this.data) {
                            const n = this.data[t];
                            for (let t = 0; t < n.length; t++) {
                                const i = n[t];
                                if (this.equalsFunction(e, i.key)) {
                                    return i.value;
                                }
                            }
                        }
                        return null;
                    }

                    entries() {
                        let e = [];
                        for (const t in this.data) {
                            if (0 === t.indexOf('hash_')) {
                                e = e.concat(this.data[t]);
                            }
                        }
                        return e;
                    }

                    getKeys() {
                        return this.entries().map(function (e) {
                            return e.key;
                        });
                    }

                    getValues() {
                        return this.entries().map(function (e) {
                            return e.value;
                        });
                    }

                    toString() {
                        return (
                            '[' +
                            this.entries()
                                .map(function (e) {
                                    return '{' + e.key + ':' + e.value + '}';
                                })
                                .join(', ') +
                            ']'
                        );
                    }

                    get length() {
                        let e = 0;
                        for (const t in this.data) {
                            if (0 === t.indexOf('hash_')) {
                                e += this.data[t].length;
                            }
                        }
                        return e;
                    }
                }

                class s {
                    constructor() {
                        this.count = 0;
                        this.hash = 0;
                    }

                    update() {
                        for (let e = 0; e < arguments.length; e++) {
                            const t = arguments[e];
                            if (null != t) {
                                if (Array.isArray(t)) {
                                    this.update.apply(this, t);
                                } else {
                                    let e = 0;
                                    switch (typeof t) {
                                        case 'undefined':
                                        case 'function':
                                            continue;
                                        case 'number':
                                        case 'boolean':
                                            e = t;
                                            break;
                                        case 'string':
                                            e = t.hashCode();
                                            break;
                                        default:
                                            if (t.updateHashCode) {
                                                t.updateHashCode(this);
                                            } else {
                                                console.log('No updateHashCode for ' + t.toString());
                                            }
                                            continue;
                                    }
                                    e *= 3432918353;
                                    e = (e << 15) | (e >>> 17);
                                    e *= 461845907;
                                    this.count = this.count + 1;
                                    let n = this.hash ^ e;
                                    n = (n << 13) | (n >>> 19);
                                    n = 5 * n + 3864292196;
                                    this.hash = n;
                                }
                            }
                        }
                    }

                    finish() {
                        let e = this.hash ^ (4 * this.count);
                        e ^= e >>> 16;
                        e *= 2246822507;
                        e ^= e >>> 13;
                        e *= 3266489909;
                        e ^= e >>> 16;
                        return e;
                    }
                }

                e.exports = {
                    Hash: s,
                    Set: class {
                        constructor(e, t) {
                            this.data = {};
                            this.hashFunction = e || a;
                            this.equalsFunction = t || i;
                        }

                        add(e) {
                            const t = 'hash_' + this.hashFunction(e);
                            if (t in this.data) {
                                const n = this.data[t];
                                for (let t = 0; t < n.length; t++) {
                                    if (this.equalsFunction(e, n[t])) {
                                        return n[t];
                                    }
                                }
                                n.push(e);
                                return e;
                            } else {
                                this.data[t] = [e];
                                return e;
                            }
                        }

                        contains(e) {
                            return null != this.get(e);
                        }

                        get(e) {
                            const t = 'hash_' + this.hashFunction(e);
                            if (t in this.data) {
                                const n = this.data[t];
                                for (let t = 0; t < n.length; t++) {
                                    if (this.equalsFunction(e, n[t])) {
                                        return n[t];
                                    }
                                }
                            }
                            return null;
                        }

                        values() {
                            let e = [];
                            for (const t in this.data) {
                                if (0 === t.indexOf('hash_')) {
                                    e = e.concat(this.data[t]);
                                }
                            }
                            return e;
                        }

                        toString() {
                            return n(this.values());
                        }

                        get length() {
                            let e = 0;
                            for (const t in this.data) {
                                if (0 === t.indexOf('hash_')) {
                                    e += this.data[t].length;
                                }
                            }
                            return e;
                        }
                    },
                    Map: r,
                    BitSet: o,
                    AltDict: class {
                        constructor() {
                            this.data = {};
                        }

                        get(e) {
                            if ((e = 'k-' + e) in this.data) {
                                return this.data[e];
                            } else {
                                return null;
                            }
                        }

                        put(e, t) {
                            e = 'k-' + e;
                            this.data[e] = t;
                        }

                        values() {
                            const e = this.data;
                            return Object.keys(this.data).map(function (t) {
                                return e[t];
                            });
                        }
                    },
                    DoubleDict: class {
                        constructor(e) {
                            this.defaultMapCtor = e || r;
                            this.cacheMap = new this.defaultMapCtor();
                        }

                        get(e, t) {
                            const n = this.cacheMap.get(e) || null;
                            return null === n ? null : n.get(t) || null;
                        }

                        set(e, t, n) {
                            let i = this.cacheMap.get(e) || null;
                            if (null === i) {
                                i = new this.defaultMapCtor();
                                this.cacheMap.put(e, i);
                            }
                            i.put(t, n);
                        }
                    },
                    hashStuff: function () {
                        const e = new s();
                        e.update.apply(e, arguments);
                        return e.finish();
                    },
                    escapeWhitespace: function (e, t) {
                        e = e.replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r');
                        if (t) {
                            e = e.replace(/ /g, '·');
                        }
                        return e;
                    },
                    arrayToString: n,
                    titleCase: function (e) {
                        return e.replace(/\w\S*/g, function (e) {
                            return e.charAt(0).toUpperCase() + e.substr(1);
                        });
                    },
                    equalArrays: function (e, t) {
                        if (!Array.isArray(e) || !Array.isArray(t)) {
                            return !1;
                        }
                        if (e === t) {
                            return !0;
                        }
                        if (e.length !== t.length) {
                            return !1;
                        }
                        for (let n = 0; n < e.length; n++) {
                            if (e[n] !== t[n]) {
                                if (!e[n].equals || !e[n].equals(t[n])) {
                                    return !1;
                                }
                            }
                        }
                        return !0;
                    },
                };
            },
            4471: function (e, t, n) {
                const i = n(3245),
                    { IntervalSet: a } = n(7059),
                    { Token: o } = n(5537);

                class r {
                    constructor(e, t) {
                        this.grammarType = e;
                        this.maxTokenType = t;
                        this.states = [];
                        this.decisionToState = [];
                        this.ruleToStartState = [];
                        this.ruleToStopState = null;
                        this.modeNameToStartState = {};
                        this.ruleToTokenType = null;
                        this.lexerActions = null;
                        this.modeToStartState = [];
                    }

                    nextTokensInContext(e, t) {
                        return new i(this).LOOK(e, null, t);
                    }

                    nextTokensNoContext(e) {
                        if (null !== e.nextTokenWithinRule) {
                            return e.nextTokenWithinRule;
                        }
                        e.nextTokenWithinRule = this.nextTokensInContext(e, null);
                        e.nextTokenWithinRule.readOnly = !0;
                        return e.nextTokenWithinRule;
                    }

                    nextTokens(e, t) {
                        if (void 0 === t) {
                            return this.nextTokensNoContext(e);
                        } else {
                            return this.nextTokensInContext(e, t);
                        }
                    }

                    addState(e) {
                        if (null !== e) {
                            e.atn = this;
                            e.stateNumber = this.states.length;
                        }
                        this.states.push(e);
                    }

                    removeState(e) {
                        this.states[e.stateNumber] = null;
                    }

                    defineDecisionState(e) {
                        this.decisionToState.push(e);
                        e.decision = this.decisionToState.length - 1;
                        return e.decision;
                    }

                    getDecisionState(e) {
                        if (0 === this.decisionToState.length) {
                            return null;
                        } else {
                            return this.decisionToState[e];
                        }
                    }

                    getExpectedTokens(e, t) {
                        if (e < 0 || e >= this.states.length) {
                            throw 'Invalid state number.';
                        }
                        const n = this.states[e];
                        let i = this.nextTokens(n);
                        if (!i.contains(o.EPSILON)) {
                            return i;
                        }
                        const r = new a();
                        r.addSet(i);
                        r.removeOne(o.EPSILON);
                        for (; null !== t && t.invokingState >= 0 && i.contains(o.EPSILON); ) {
                            const e = this.states[t.invokingState].transitions[0];
                            i = this.nextTokens(e.followState);
                            r.addSet(i);
                            r.removeOne(o.EPSILON);
                            t = t.parentCtx;
                        }
                        if (i.contains(o.EPSILON)) {
                            r.addOne(o.EOF);
                        }
                        return r;
                    }
                }

                r.INVALID_ALT_NUMBER = 0;
                e.exports = r;
            },
            5185: function (e, t, n) {
                const { DecisionState: i } = n(2766),
                    { SemanticContext: a } = n(6389),
                    { Hash: o } = n(2373);

                function r(e, t) {
                    if (null === e) {
                        const e = { state: null, alt: null, context: null, semanticContext: null };
                        if (t) {
                            e.reachesIntoOuterContext = 0;
                        }
                        return e;
                    } else {
                        const n = {};
                        n.state = e.state || null;
                        n.alt = void 0 === e.alt ? null : e.alt;
                        n.context = e.context || null;
                        n.semanticContext = e.semanticContext || null;
                        if (t) {
                            n.reachesIntoOuterContext = e.reachesIntoOuterContext || 0;
                            n.precedenceFilterSuppressed = e.precedenceFilterSuppressed || !1;
                        }
                        return n;
                    }
                }

                class s {
                    constructor(e, t) {
                        this.checkContext(e, t);
                        e = r(e);
                        t = r(t, !0);
                        this.state = null !== e.state ? e.state : t.state;
                        this.alt = null !== e.alt ? e.alt : t.alt;
                        this.context = null !== e.context ? e.context : t.context;
                        this.semanticContext =
                            null !== e.semanticContext
                                ? e.semanticContext
                                : null !== t.semanticContext
                                ? t.semanticContext
                                : a.NONE;
                        this.reachesIntoOuterContext = t.reachesIntoOuterContext;
                        this.precedenceFilterSuppressed = t.precedenceFilterSuppressed;
                    }

                    checkContext(e, t) {
                        if (
                            !(
                                (null !== e.context && void 0 !== e.context) ||
                                (null !== t && null !== t.context && void 0 !== t.context)
                            )
                        ) {
                            this.context = null;
                        }
                    }

                    hashCode() {
                        const e = new o();
                        this.updateHashCode(e);
                        return e.finish();
                    }

                    updateHashCode(e) {
                        e.update(this.state.stateNumber, this.alt, this.context, this.semanticContext);
                    }

                    equals(e) {
                        if (this === e) {
                            return !0;
                        } else if (!(e instanceof s)) {
                            return !1;
                        } else {
                            return (
                                this.state.stateNumber === e.state.stateNumber &&
                                this.alt === e.alt &&
                                (null === this.context ? null === e.context : this.context.equals(e.context)) &&
                                this.semanticContext.equals(e.semanticContext) &&
                                this.precedenceFilterSuppressed === e.precedenceFilterSuppressed
                            );
                        }
                    }

                    hashCodeForConfigSet() {
                        const e = new o();
                        e.update(this.state.stateNumber, this.alt, this.semanticContext);
                        return e.finish();
                    }

                    equalsForConfigSet(e) {
                        if (this === e) {
                            return !0;
                        } else if (!(e instanceof s)) {
                            return !1;
                        } else {
                            return (
                                this.state.stateNumber === e.state.stateNumber &&
                                this.alt === e.alt &&
                                this.semanticContext.equals(e.semanticContext)
                            );
                        }
                    }

                    toString() {
                        return (
                            '(' +
                            this.state +
                            ',' +
                            this.alt +
                            (null !== this.context ? ',[' + this.context.toString() + ']' : '') +
                            (this.semanticContext !== a.NONE ? ',' + this.semanticContext.toString() : '') +
                            (this.reachesIntoOuterContext > 0 ? ',up=' + this.reachesIntoOuterContext : '') +
                            ')'
                        );
                    }
                }

                class c extends s {
                    constructor(e, t) {
                        super(e, t);
                        const n = e.lexerActionExecutor || null;
                        this.lexerActionExecutor = n || (null !== t ? t.lexerActionExecutor : null);
                        this.passedThroughNonGreedyDecision =
                            null !== t ? this.checkNonGreedyDecision(t, this.state) : !1;
                        this.hashCodeForConfigSet = c.prototype.hashCode;
                        this.equalsForConfigSet = c.prototype.equals;
                        return this;
                    }

                    updateHashCode(e) {
                        e.update(
                            this.state.stateNumber,
                            this.alt,
                            this.context,
                            this.semanticContext,
                            this.passedThroughNonGreedyDecision,
                            this.lexerActionExecutor,
                        );
                    }

                    equals(e) {
                        return (
                            this === e ||
                            (e instanceof c &&
                                this.passedThroughNonGreedyDecision === e.passedThroughNonGreedyDecision &&
                                (this.lexerActionExecutor
                                    ? this.lexerActionExecutor.equals(e.lexerActionExecutor)
                                    : !e.lexerActionExecutor) &&
                                super.equals(e))
                        );
                    }

                    checkNonGreedyDecision(e, t) {
                        return e.passedThroughNonGreedyDecision || (t instanceof i && t.nonGreedy);
                    }
                }

                e.exports.ATNConfig = s;
                e.exports.LexerATNConfig = c;
            },
            7329: function (e, t, n) {
                const i = n(4471),
                    a = n(2373),
                    { SemanticContext: o } = n(6389),
                    { merge: r } = n(6400);

                function s(e) {
                    return e.hashCodeForConfigSet();
                }

                function c(e, t) {
                    if (e === t) {
                        return !0;
                    } else if (null === e || null === t) {
                        return !1;
                    } else {
                        return e.equalsForConfigSet(t);
                    }
                }

                class l {
                    constructor(e) {
                        this.configLookup = new a.Set(s, c);
                        this.fullCtx = void 0 === e ? !0 : e;
                        this.readOnly = !1;
                        this.configs = [];
                        this.uniqueAlt = 0;
                        this.conflictingAlts = null;
                        this.hasSemanticContext = !1;
                        this.dipsIntoOuterContext = !1;
                        this.cachedHashCode = -1;
                    }

                    add(e, t) {
                        if (void 0 === t) {
                            t = null;
                        }
                        if (this.readOnly) {
                            throw 'This set is readonly';
                        }
                        if (e.semanticContext !== o.NONE) {
                            this.hasSemanticContext = !0;
                        }
                        if (e.reachesIntoOuterContext > 0) {
                            this.dipsIntoOuterContext = !0;
                        }
                        const n = this.configLookup.add(e);
                        if (n === e) {
                            this.cachedHashCode = -1;
                            this.configs.push(e);
                            return !0;
                        }
                        const i = !this.fullCtx,
                            a = r(n.context, e.context, i, t);
                        n.reachesIntoOuterContext = Math.max(n.reachesIntoOuterContext, e.reachesIntoOuterContext);
                        if (e.precedenceFilterSuppressed) {
                            n.precedenceFilterSuppressed = !0;
                        }
                        n.context = a;
                        return !0;
                    }

                    getStates() {
                        const e = new a.Set();
                        for (let t = 0; t < this.configs.length; t++) {
                            e.add(this.configs[t].state);
                        }
                        return e;
                    }

                    getPredicates() {
                        const e = [];
                        for (let t = 0; t < this.configs.length; t++) {
                            const n = this.configs[t].semanticContext;
                            if (n !== o.NONE) {
                                e.push(n.semanticContext);
                            }
                        }
                        return e;
                    }

                    optimizeConfigs(e) {
                        if (this.readOnly) {
                            throw 'This set is readonly';
                        }
                        if (0 !== this.configLookup.length) {
                            for (let t = 0; t < this.configs.length; t++) {
                                const n = this.configs[t];
                                n.context = e.getCachedContext(n.context);
                            }
                        }
                    }

                    addAll(e) {
                        for (let t = 0; t < e.length; t++) {
                            this.add(e[t]);
                        }
                        return !1;
                    }

                    equals(e) {
                        return (
                            this === e ||
                            (e instanceof l &&
                                a.equalArrays(this.configs, e.configs) &&
                                this.fullCtx === e.fullCtx &&
                                this.uniqueAlt === e.uniqueAlt &&
                                this.conflictingAlts === e.conflictingAlts &&
                                this.hasSemanticContext === e.hasSemanticContext &&
                                this.dipsIntoOuterContext === e.dipsIntoOuterContext)
                        );
                    }

                    hashCode() {
                        const e = new a.Hash();
                        e.update(this.configs);
                        return e.finish();
                    }

                    updateHashCode(e) {
                        if (this.readOnly) {
                            if (-1 === this.cachedHashCode) {
                                this.cachedHashCode = this.hashCode();
                            }
                            e.update(this.cachedHashCode);
                        } else {
                            e.update(this.hashCode());
                        }
                    }

                    isEmpty() {
                        return 0 === this.configs.length;
                    }

                    contains(e) {
                        if (null === this.configLookup) {
                            throw 'This method is not implemented for readonly sets.';
                        }
                        return this.configLookup.contains(e);
                    }

                    containsFast(e) {
                        if (null === this.configLookup) {
                            throw 'This method is not implemented for readonly sets.';
                        }
                        return this.configLookup.containsFast(e);
                    }

                    clear() {
                        if (this.readOnly) {
                            throw 'This set is readonly';
                        }
                        this.configs = [];
                        this.cachedHashCode = -1;
                        this.configLookup = new a.Set();
                    }

                    setReadonly(e) {
                        this.readOnly = e;
                        if (e) {
                            this.configLookup = null;
                        }
                    }

                    toString() {
                        return (
                            a.arrayToString(this.configs) +
                            (this.hasSemanticContext ? ',hasSemanticContext=' + this.hasSemanticContext : '') +
                            (this.uniqueAlt !== i.INVALID_ALT_NUMBER ? ',uniqueAlt=' + this.uniqueAlt : '') +
                            (null !== this.conflictingAlts ? ',conflictingAlts=' + this.conflictingAlts : '') +
                            (this.dipsIntoOuterContext ? ',dipsIntoOuterContext' : '')
                        );
                    }

                    get items() {
                        return this.configs;
                    }

                    get length() {
                        return this.configs.length;
                    }
                }

                e.exports = {
                    ATNConfigSet: l,
                    OrderedATNConfigSet: class extends l {
                        constructor() {
                            super();
                            this.configLookup = new a.Set();
                        }
                    },
                };
            },
            8550: function (e) {
                class t {
                    constructor(e) {
                        if (void 0 === e) {
                            e = null;
                        }
                        this.readOnly = !1;
                        this.verifyATN = null === e ? !0 : e.verifyATN;
                        this.generateRuleBypassTransitions = null === e ? !1 : e.generateRuleBypassTransitions;
                    }
                }

                t.defaultOptions = new t();
                t.defaultOptions.readOnly = !0;
                e.exports = t;
            },
            6220: function (e, t, n) {
                const { Token: i } = n(5537),
                    a = n(4471),
                    o = n(6095),
                    {
                        ATNState: r,
                        BasicState: s,
                        DecisionState: c,
                        BlockStartState: l,
                        BlockEndState: u,
                        LoopEndState: d,
                        RuleStartState: m,
                        RuleStopState: p,
                        TokensStartState: f,
                        PlusLoopbackState: g,
                        StarLoopbackState: h,
                        StarLoopEntryState: y,
                        PlusBlockStartState: x,
                        StarBlockStartState: _,
                        BasicBlockStartState: E,
                    } = n(2766),
                    {
                        Transition: C,
                        AtomTransition: S,
                        SetTransition: b,
                        NotSetTransition: v,
                        RuleTransition: D,
                        RangeTransition: R,
                        ActionTransition: M,
                        EpsilonTransition: T,
                        WildcardTransition: k,
                        PredicateTransition: I,
                        PrecedencePredicateTransition: P,
                    } = n(5651),
                    { IntervalSet: L } = n(7059),
                    A = n(8550),
                    {
                        LexerActionType: w,
                        LexerSkipAction: O,
                        LexerChannelAction: Y,
                        LexerCustomAction: B,
                        LexerMoreAction: N,
                        LexerTypeAction: q,
                        LexerPushModeAction: H,
                        LexerPopModeAction: j,
                        LexerModeAction: F,
                    } = n(2446),
                    U = '59627784-3BE5-417A-B9EB-8131A7286089',
                    V = ['AADB8D7E-AEEF-4415-AD2B-8204D6CF042E', U],
                    Q = U;

                function G(e, t) {
                    const n = [];
                    n[e - 1] = t;
                    return n.map(function (e) {
                        return t;
                    });
                }

                const z = (function () {
                    const e = [];
                    for (let t = 0; t < 256; t++) {
                        e[t] = (t + 256).toString(16).substr(1).toUpperCase();
                    }
                    return e;
                })();
                e.exports = class {
                    constructor(e) {
                        if (null == e) {
                            e = A.defaultOptions;
                        }
                        this.deserializationOptions = e;
                        this.stateFactories = null;
                        this.actionFactories = null;
                    }

                    isFeatureSupported(e, t) {
                        const n = V.indexOf(e);
                        if (n < 0) {
                            return !1;
                        }
                        return V.indexOf(t) >= n;
                    }

                    deserialize(e) {
                        this.reset(e);
                        this.checkVersion();
                        this.checkUUID();
                        const t = this.readATN();
                        this.readStates(t);
                        this.readRules(t);
                        this.readModes(t);
                        const n = [];
                        this.readSets(t, n, this.readInt.bind(this));
                        if (this.isFeatureSupported(U, this.uuid)) {
                            this.readSets(t, n, this.readInt32.bind(this));
                        }
                        this.readEdges(t, n);
                        this.readDecisions(t);
                        this.readLexerActions(t);
                        this.markPrecedenceDecisions(t);
                        this.verifyATN(t);
                        if (this.deserializationOptions.generateRuleBypassTransitions && t.grammarType === o.PARSER) {
                            this.generateRuleBypassTransitions(t);
                            this.verifyATN(t);
                        }
                        return t;
                    }

                    reset(e) {
                        const t = e.split('').map(function (e) {
                            const t = e.charCodeAt(0);
                            return t > 1 ? t - 2 : t + 65534;
                        });
                        t[0] = e.charCodeAt(0);
                        this.data = t;
                        this.pos = 0;
                    }

                    checkVersion() {
                        const e = this.readInt();
                        if (3 !== e) {
                            throw 'Could not deserialize ATN with version ' + e + ' (expected 3).';
                        }
                    }

                    checkUUID() {
                        const e = this.readUUID();
                        if (V.indexOf(e) < 0) {
                            throw Q;
                        }
                        this.uuid = e;
                    }

                    readATN() {
                        const e = this.readInt(),
                            t = this.readInt();
                        return new a(e, t);
                    }

                    readStates(e) {
                        let t, n, i;
                        const a = [],
                            o = [],
                            s = this.readInt();
                        for (let t = 0; t < s; t++) {
                            const t = this.readInt();
                            if (t === r.INVALID_TYPE) {
                                e.addState(null);
                                continue;
                            }
                            let n = this.readInt();
                            if (65535 === n) {
                                n = -1;
                            }
                            const i = this.stateFactory(t, n);
                            if (t === r.LOOP_END) {
                                const e = this.readInt();
                                a.push([i, e]);
                            } else if (i instanceof l) {
                                const e = this.readInt();
                                o.push([i, e]);
                            }
                            e.addState(i);
                        }
                        for (t = 0; t < a.length; t++) {
                            n = a[t];
                            n[0].loopBackState = e.states[n[1]];
                        }
                        for (t = 0; t < o.length; t++) {
                            n = o[t];
                            n[0].endState = e.states[n[1]];
                        }
                        let c = this.readInt();
                        for (t = 0; t < c; t++) {
                            i = this.readInt();
                            e.states[i].nonGreedy = !0;
                        }
                        let u = this.readInt();
                        for (t = 0; t < u; t++) {
                            i = this.readInt();
                            e.states[i].isPrecedenceRule = !0;
                        }
                    }

                    readRules(e) {
                        let t;
                        const n = this.readInt();
                        if (e.grammarType === o.LEXER) {
                            e.ruleToTokenType = G(n, 0);
                        }
                        e.ruleToStartState = G(n, 0);
                        for (t = 0; t < n; t++) {
                            const n = this.readInt();
                            e.ruleToStartState[t] = e.states[n];
                            if (e.grammarType === o.LEXER) {
                                let n = this.readInt();
                                if (65535 === n) {
                                    n = i.EOF;
                                }
                                e.ruleToTokenType[t] = n;
                            }
                        }
                        e.ruleToStopState = G(n, 0);
                        for (t = 0; t < e.states.length; t++) {
                            const n = e.states[t];
                            if (n instanceof p) {
                                e.ruleToStopState[n.ruleIndex] = n;
                                e.ruleToStartState[n.ruleIndex].stopState = n;
                            }
                        }
                    }

                    readModes(e) {
                        const t = this.readInt();
                        for (let n = 0; n < t; n++) {
                            let t = this.readInt();
                            e.modeToStartState.push(e.states[t]);
                        }
                    }

                    readSets(e, t, n) {
                        const i = this.readInt();
                        for (let e = 0; e < i; e++) {
                            const e = new L();
                            t.push(e);
                            const i = this.readInt();
                            if (0 !== this.readInt()) {
                                e.addOne(-1);
                            }
                            for (let t = 0; t < i; t++) {
                                const t = n(),
                                    i = n();
                                e.addRange(t, i);
                            }
                        }
                    }

                    readEdges(e, t) {
                        let n, i, a, o, r;
                        const s = this.readInt();
                        for (n = 0; n < s; n++) {
                            const n = this.readInt(),
                                i = this.readInt(),
                                a = this.readInt(),
                                r = this.readInt(),
                                s = this.readInt(),
                                c = this.readInt();
                            o = this.edgeFactory(e, a, n, i, r, s, c, t);
                            e.states[n].addTransition(o);
                        }
                        for (n = 0; n < e.states.length; n++) {
                            a = e.states[n];
                            for (i = 0; i < a.transitions.length; i++) {
                                const t = a.transitions[i];
                                if (!(t instanceof D)) {
                                    continue;
                                }
                                let n = -1;
                                if (e.ruleToStartState[t.target.ruleIndex].isPrecedenceRule) {
                                    if (0 === t.precedence) {
                                        n = t.target.ruleIndex;
                                    }
                                }
                                o = new T(t.followState, n);
                                e.ruleToStopState[t.target.ruleIndex].addTransition(o);
                            }
                        }
                        for (n = 0; n < e.states.length; n++) {
                            a = e.states[n];
                            if (a instanceof l) {
                                if (null === a.endState) {
                                    throw 'IllegalState';
                                }
                                if (null !== a.endState.startState) {
                                    throw 'IllegalState';
                                }
                                a.endState.startState = a;
                            }
                            if (a instanceof g) {
                                for (i = 0; i < a.transitions.length; i++) {
                                    r = a.transitions[i].target;
                                    if (r instanceof x) {
                                        r.loopBackState = a;
                                    }
                                }
                            } else if (a instanceof h) {
                                for (i = 0; i < a.transitions.length; i++) {
                                    r = a.transitions[i].target;
                                    if (r instanceof y) {
                                        r.loopBackState = a;
                                    }
                                }
                            }
                        }
                    }

                    readDecisions(e) {
                        const t = this.readInt();
                        for (let n = 0; n < t; n++) {
                            const t = this.readInt(),
                                i = e.states[t];
                            e.decisionToState.push(i);
                            i.decision = n;
                        }
                    }

                    readLexerActions(e) {
                        if (e.grammarType === o.LEXER) {
                            const t = this.readInt();
                            e.lexerActions = G(t, null);
                            for (let n = 0; n < t; n++) {
                                const t = this.readInt();
                                let i = this.readInt();
                                if (65535 === i) {
                                    i = -1;
                                }
                                let a = this.readInt();
                                if (65535 === a) {
                                    a = -1;
                                }
                                e.lexerActions[n] = this.lexerActionFactory(t, i, a);
                            }
                        }
                    }

                    generateRuleBypassTransitions(e) {
                        let t;
                        const n = e.ruleToStartState.length;
                        for (t = 0; t < n; t++) {
                            e.ruleToTokenType[t] = e.maxTokenType + t + 1;
                        }
                        for (t = 0; t < n; t++) {
                            this.generateRuleBypassTransition(e, t);
                        }
                    }

                    generateRuleBypassTransition(e, t) {
                        let n, i;
                        const a = new E();
                        a.ruleIndex = t;
                        e.addState(a);
                        const o = new u();
                        o.ruleIndex = t;
                        e.addState(o);
                        a.endState = o;
                        e.defineDecisionState(a);
                        o.startState = a;
                        let r = null,
                            c = null;
                        if (e.ruleToStartState[t].isPrecedenceRule) {
                            c = null;
                            for (n = 0; n < e.states.length; n++) {
                                i = e.states[n];
                                if (this.stateIsEndStateFor(i, t)) {
                                    c = i;
                                    r = i.loopBackState.transitions[0];
                                    break;
                                }
                            }
                            if (null === r) {
                                throw "Couldn't identify final state of the precedence rule prefix section.";
                            }
                        } else {
                            c = e.ruleToStopState[t];
                        }
                        for (n = 0; n < e.states.length; n++) {
                            i = e.states[n];
                            for (let e = 0; e < i.transitions.length; e++) {
                                const t = i.transitions[e];
                                if (t !== r) {
                                    if (t.target === c) {
                                        t.target = o;
                                    }
                                }
                            }
                        }
                        const l = e.ruleToStartState[t],
                            d = l.transitions.length;
                        for (; d > 0; ) {
                            a.addTransition(l.transitions[d - 1]);
                            l.transitions = l.transitions.slice(-1);
                        }
                        e.ruleToStartState[t].addTransition(new T(a));
                        o.addTransition(new T(c));
                        const m = new s();
                        e.addState(m);
                        m.addTransition(new S(o, e.ruleToTokenType[t]));
                        a.addTransition(new T(m));
                    }

                    stateIsEndStateFor(e, t) {
                        if (e.ruleIndex !== t) {
                            return null;
                        }
                        if (!(e instanceof y)) {
                            return null;
                        }
                        const n = e.transitions[e.transitions.length - 1].target;
                        if (!(n instanceof d)) {
                            return null;
                        }
                        if (n.epsilonOnlyTransitions && n.transitions[0].target instanceof p) {
                            return e;
                        } else {
                            return null;
                        }
                    }

                    markPrecedenceDecisions(e) {
                        for (let t = 0; t < e.states.length; t++) {
                            const n = e.states[t];
                            if (n instanceof y) {
                                if (e.ruleToStartState[n.ruleIndex].isPrecedenceRule) {
                                    const e = n.transitions[n.transitions.length - 1].target;
                                    if (e instanceof d) {
                                        if (e.epsilonOnlyTransitions && e.transitions[0].target instanceof p) {
                                            n.isPrecedenceDecision = !0;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    verifyATN(e) {
                        if (this.deserializationOptions.verifyATN) {
                            for (let t = 0; t < e.states.length; t++) {
                                const n = e.states[t];
                                if (null !== n) {
                                    this.checkCondition(n.epsilonOnlyTransitions || n.transitions.length <= 1);
                                    if (n instanceof x) {
                                        this.checkCondition(null !== n.loopBackState);
                                    } else if (n instanceof y) {
                                        this.checkCondition(null !== n.loopBackState);
                                        this.checkCondition(2 === n.transitions.length);
                                        if (n.transitions[0].target instanceof _) {
                                            this.checkCondition(n.transitions[1].target instanceof d);
                                            this.checkCondition(!n.nonGreedy);
                                        } else if (n.transitions[0].target instanceof d) {
                                            this.checkCondition(n.transitions[1].target instanceof _);
                                            this.checkCondition(n.nonGreedy);
                                        } else {
                                            throw 'IllegalState';
                                        }
                                    } else if (n instanceof h) {
                                        this.checkCondition(1 === n.transitions.length);
                                        this.checkCondition(n.transitions[0].target instanceof y);
                                    } else if (n instanceof d) {
                                        this.checkCondition(null !== n.loopBackState);
                                    } else if (n instanceof m) {
                                        this.checkCondition(null !== n.stopState);
                                    } else if (n instanceof l) {
                                        this.checkCondition(null !== n.endState);
                                    } else if (n instanceof u) {
                                        this.checkCondition(null !== n.startState);
                                    } else if (n instanceof c) {
                                        this.checkCondition(n.transitions.length <= 1 || n.decision >= 0);
                                    } else {
                                        this.checkCondition(n.transitions.length <= 1 || n instanceof p);
                                    }
                                }
                            }
                        }
                    }

                    checkCondition(e, t) {
                        if (!e) {
                            if (null == t) {
                                t = 'IllegalState';
                            }
                            throw t;
                        }
                    }

                    readInt() {
                        return this.data[this.pos++];
                    }

                    readInt32() {
                        return this.readInt() | (this.readInt() << 16);
                    }

                    readLong() {
                        return (4294967295 & this.readInt32()) | (this.readInt32() << 32);
                    }

                    readUUID() {
                        const e = [];
                        for (let t = 7; t >= 0; t--) {
                            const n = this.readInt();
                            e[2 * t + 1] = 255 & n;
                            e[2 * t] = (n >> 8) & 255;
                        }
                        return (
                            z[e[0]] +
                            z[e[1]] +
                            z[e[2]] +
                            z[e[3]] +
                            '-' +
                            z[e[4]] +
                            z[e[5]] +
                            '-' +
                            z[e[6]] +
                            z[e[7]] +
                            '-' +
                            z[e[8]] +
                            z[e[9]] +
                            '-' +
                            z[e[10]] +
                            z[e[11]] +
                            z[e[12]] +
                            z[e[13]] +
                            z[e[14]] +
                            z[e[15]]
                        );
                    }

                    edgeFactory(e, t, n, a, o, r, s, c) {
                        const l = e.states[a];
                        switch (t) {
                            case C.EPSILON:
                                return new T(l);
                            case C.RANGE:
                                return 0 !== s ? new R(l, i.EOF, r) : new R(l, o, r);
                            case C.RULE:
                                return new D(e.states[o], r, s, l);
                            case C.PREDICATE:
                                return new I(l, o, r, 0 !== s);
                            case C.PRECEDENCE:
                                return new P(l, o);
                            case C.ATOM:
                                return 0 !== s ? new S(l, i.EOF) : new S(l, o);
                            case C.ACTION:
                                return new M(l, o, r, 0 !== s);
                            case C.SET:
                                return new b(l, c[o]);
                            case C.NOT_SET:
                                return new v(l, c[o]);
                            case C.WILDCARD:
                                return new k(l);
                            default:
                                throw 'The specified transition type: ' + t + ' is not valid.';
                        }
                    }

                    stateFactory(e, t) {
                        if (null === this.stateFactories) {
                            const e = [];
                            e[r.INVALID_TYPE] = null;
                            e[r.BASIC] = () => new s();
                            e[r.RULE_START] = () => new m();
                            e[r.BLOCK_START] = () => new E();
                            e[r.PLUS_BLOCK_START] = () => new x();
                            e[r.STAR_BLOCK_START] = () => new _();
                            e[r.TOKEN_START] = () => new f();
                            e[r.RULE_STOP] = () => new p();
                            e[r.BLOCK_END] = () => new u();
                            e[r.STAR_LOOP_BACK] = () => new h();
                            e[r.STAR_LOOP_ENTRY] = () => new y();
                            e[r.PLUS_LOOP_BACK] = () => new g();
                            e[r.LOOP_END] = () => new d();
                            this.stateFactories = e;
                        }
                        if (e > this.stateFactories.length || null === this.stateFactories[e]) {
                            throw 'The specified state type ' + e + ' is not valid.';
                        } else {
                            const n = this.stateFactories[e]();
                            if (null !== n) {
                                n.ruleIndex = t;
                                return n;
                            }
                        }
                    }

                    lexerActionFactory(e, t, n) {
                        if (null === this.actionFactories) {
                            const e = [];
                            e[w.CHANNEL] = (e, t) => new Y(e);
                            e[w.CUSTOM] = (e, t) => new B(e, t);
                            e[w.MODE] = (e, t) => new F(e);
                            e[w.MORE] = (e, t) => N.INSTANCE;
                            e[w.POP_MODE] = (e, t) => j.INSTANCE;
                            e[w.PUSH_MODE] = (e, t) => new H(e);
                            e[w.SKIP] = (e, t) => O.INSTANCE;
                            e[w.TYPE] = (e, t) => new q(e);
                            this.actionFactories = e;
                        }
                        if (e > this.actionFactories.length || null === this.actionFactories[e]) {
                            throw 'The specified lexer action type ' + e + ' is not valid.';
                        } else {
                            return this.actionFactories[e](t, n);
                        }
                    }
                };
            },
            7093: function (e, t, n) {
                const { DFAState: i } = n(2982),
                    { ATNConfigSet: a } = n(7329),
                    { getCachedPredictionContext: o } = n(6400),
                    { Map: r } = n(2373);

                class s {
                    constructor(e, t) {
                        this.atn = e;
                        this.sharedContextCache = t;
                        return this;
                    }

                    getCachedContext(e) {
                        if (null === this.sharedContextCache) {
                            return e;
                        }
                        const t = new r();
                        return o(e, this.sharedContextCache, t);
                    }
                }

                s.ERROR = new i(2147483647, new a());
                e.exports = s;
            },
            2766: function (e) {
                class t {
                    constructor() {
                        this.atn = null;
                        this.stateNumber = t.INVALID_STATE_NUMBER;
                        this.stateType = null;
                        this.ruleIndex = 0;
                        this.epsilonOnlyTransitions = !1;
                        this.transitions = [];
                        this.nextTokenWithinRule = null;
                    }

                    toString() {
                        return this.stateNumber;
                    }

                    equals(e) {
                        if (e instanceof t) {
                            return this.stateNumber === e.stateNumber;
                        } else {
                            return !1;
                        }
                    }

                    isNonGreedyExitState() {
                        return !1;
                    }

                    addTransition(e, t) {
                        if (void 0 === t) {
                            t = -1;
                        }
                        if (0 === this.transitions.length) {
                            this.epsilonOnlyTransitions = e.isEpsilon;
                        } else if (this.epsilonOnlyTransitions !== e.isEpsilon) {
                            this.epsilonOnlyTransitions = !1;
                        }
                        if (-1 === t) {
                            this.transitions.push(e);
                        } else {
                            this.transitions.splice(t, 1, e);
                        }
                    }
                }

                t.INVALID_TYPE = 0;
                t.BASIC = 1;
                t.RULE_START = 2;
                t.BLOCK_START = 3;
                t.PLUS_BLOCK_START = 4;
                t.STAR_BLOCK_START = 5;
                t.TOKEN_START = 6;
                t.RULE_STOP = 7;
                t.BLOCK_END = 8;
                t.STAR_LOOP_BACK = 9;
                t.STAR_LOOP_ENTRY = 10;
                t.PLUS_LOOP_BACK = 11;
                t.LOOP_END = 12;
                t.serializationNames = [
                    'INVALID',
                    'BASIC',
                    'RULE_START',
                    'BLOCK_START',
                    'PLUS_BLOCK_START',
                    'STAR_BLOCK_START',
                    'TOKEN_START',
                    'RULE_STOP',
                    'BLOCK_END',
                    'STAR_LOOP_BACK',
                    'STAR_LOOP_ENTRY',
                    'PLUS_LOOP_BACK',
                    'LOOP_END',
                ];
                t.INVALID_STATE_NUMBER = -1;

                class n extends t {
                    constructor() {
                        super();
                        this.decision = -1;
                        this.nonGreedy = !1;
                        return this;
                    }
                }

                class i extends n {
                    constructor() {
                        super();
                        this.endState = null;
                        return this;
                    }
                }

                e.exports = {
                    ATNState: t,
                    BasicState: class extends t {
                        constructor() {
                            super();
                            this.stateType = t.BASIC;
                        }
                    },
                    DecisionState: n,
                    BlockStartState: i,
                    BlockEndState: class extends t {
                        constructor() {
                            super();
                            this.stateType = t.BLOCK_END;
                            this.startState = null;
                            return this;
                        }
                    },
                    LoopEndState: class extends t {
                        constructor() {
                            super();
                            this.stateType = t.LOOP_END;
                            this.loopBackState = null;
                            return this;
                        }
                    },
                    RuleStartState: class extends t {
                        constructor() {
                            super();
                            this.stateType = t.RULE_START;
                            this.stopState = null;
                            this.isPrecedenceRule = !1;
                            return this;
                        }
                    },
                    RuleStopState: class extends t {
                        constructor() {
                            super();
                            this.stateType = t.RULE_STOP;
                            return this;
                        }
                    },
                    TokensStartState: class extends n {
                        constructor() {
                            super();
                            this.stateType = t.TOKEN_START;
                            return this;
                        }
                    },
                    PlusLoopbackState: class extends n {
                        constructor() {
                            super();
                            this.stateType = t.PLUS_LOOP_BACK;
                            return this;
                        }
                    },
                    StarLoopbackState: class extends t {
                        constructor() {
                            super();
                            this.stateType = t.STAR_LOOP_BACK;
                            return this;
                        }
                    },
                    StarLoopEntryState: class extends n {
                        constructor() {
                            super();
                            this.stateType = t.STAR_LOOP_ENTRY;
                            this.loopBackState = null;
                            this.isPrecedenceDecision = null;
                            return this;
                        }
                    },
                    PlusBlockStartState: class extends i {
                        constructor() {
                            super();
                            this.stateType = t.PLUS_BLOCK_START;
                            this.loopBackState = null;
                            return this;
                        }
                    },
                    StarBlockStartState: class extends i {
                        constructor() {
                            super();
                            this.stateType = t.STAR_BLOCK_START;
                            return this;
                        }
                    },
                    BasicBlockStartState: class extends i {
                        constructor() {
                            super();
                            this.stateType = t.BLOCK_START;
                            return this;
                        }
                    },
                };
            },
            6095: function (e) {
                e.exports = { LEXER: 0, PARSER: 1 };
            },
            5849: function (e, t, n) {
                const { Token: i } = n(5537),
                    a = n(7318),
                    o = n(4471),
                    r = n(7093),
                    { DFAState: s } = n(2982),
                    { OrderedATNConfigSet: c } = n(7329),
                    { PredictionContext: l } = n(6400),
                    { SingletonPredictionContext: u } = n(6400),
                    { RuleStopState: d } = n(2766),
                    { LexerATNConfig: m } = n(5185),
                    { Transition: p } = n(5651),
                    f = n(2163),
                    { LexerNoViableAltException: g } = n(586);

                function h(e) {
                    e.index = -1;
                    e.line = 0;
                    e.column = -1;
                    e.dfaState = null;
                }

                class y {
                    constructor() {
                        h(this);
                    }

                    reset() {
                        h(this);
                    }
                }

                class x extends r {
                    constructor(e, t, n, i) {
                        super(t, i);
                        this.decisionToDFA = n;
                        this.recog = e;
                        this.startIndex = -1;
                        this.line = 1;
                        this.column = 0;
                        this.mode = a.DEFAULT_MODE;
                        this.prevAccept = new y();
                    }

                    copyState(e) {
                        this.column = e.column;
                        this.line = e.line;
                        this.mode = e.mode;
                        this.startIndex = e.startIndex;
                    }

                    match(e, t) {
                        this.match_calls += 1;
                        this.mode = t;
                        const n = e.mark();
                        try {
                            this.startIndex = e.index;
                            this.prevAccept.reset();
                            const n = this.decisionToDFA[t];
                            if (null === n.s0) {
                                return this.matchATN(e);
                            } else {
                                return this.execATN(e, n.s0);
                            }
                        } finally {
                            e.release(n);
                        }
                    }

                    reset() {
                        this.prevAccept.reset();
                        this.startIndex = -1;
                        this.line = 1;
                        this.column = 0;
                        this.mode = a.DEFAULT_MODE;
                    }

                    matchATN(e) {
                        const t = this.atn.modeToStartState[this.mode];
                        if (x.debug) {
                            console.log('matchATN mode ' + this.mode + ' start: ' + t);
                        }
                        const n = this.mode,
                            i = this.computeStartState(e, t),
                            a = i.hasSemanticContext;
                        i.hasSemanticContext = !1;
                        const o = this.addDFAState(i);
                        if (!a) {
                            this.decisionToDFA[this.mode].s0 = o;
                        }
                        const r = this.execATN(e, o);
                        if (x.debug) {
                            console.log('DFA after matchATN: ' + this.decisionToDFA[n].toLexerString());
                        }
                        return r;
                    }

                    execATN(e, t) {
                        if (x.debug) {
                            console.log('start state closure=' + t.configs);
                        }
                        if (t.isAcceptState) {
                            this.captureSimState(this.prevAccept, e, t);
                        }
                        let n = e.LA(1),
                            a = t;
                        for (;;) {
                            if (x.debug) {
                                console.log('execATN loop starting closure: ' + a.configs);
                            }
                            let t = this.getExistingTargetState(a, n);
                            if (null === t) {
                                t = this.computeTargetState(e, a, n);
                            }
                            if (t === r.ERROR) {
                                break;
                            }
                            if (n !== i.EOF) {
                                this.consume(e);
                            }
                            if (t.isAcceptState) {
                                this.captureSimState(this.prevAccept, e, t);
                                if (n === i.EOF) {
                                    break;
                                }
                            }
                            n = e.LA(1);
                            a = t;
                        }
                        return this.failOrAccept(this.prevAccept, e, a.configs, n);
                    }

                    getExistingTargetState(e, t) {
                        if (null === e.edges || t < x.MIN_DFA_EDGE || t > x.MAX_DFA_EDGE) {
                            return null;
                        }
                        let n = e.edges[t - x.MIN_DFA_EDGE];
                        if (void 0 === n) {
                            n = null;
                        }
                        if (x.debug && null !== n) {
                            console.log('reuse state ' + e.stateNumber + ' edge to ' + n.stateNumber);
                        }
                        return n;
                    }

                    computeTargetState(e, t, n) {
                        const i = new c();
                        this.getReachableConfigSet(e, t.configs, i, n);
                        if (0 === i.items.length) {
                            if (!i.hasSemanticContext) {
                                this.addDFAEdge(t, n, r.ERROR);
                            }
                            return r.ERROR;
                        }
                        return this.addDFAEdge(t, n, null, i);
                    }

                    failOrAccept(e, t, n, a) {
                        if (null !== this.prevAccept.dfaState) {
                            const n = e.dfaState.lexerActionExecutor;
                            this.accept(t, n, this.startIndex, e.index, e.line, e.column);
                            return e.dfaState.prediction;
                        } else {
                            if (a === i.EOF && t.index === this.startIndex) {
                                return i.EOF;
                            }
                            throw new g(this.recog, t, this.startIndex, n);
                        }
                    }

                    getReachableConfigSet(e, t, n, a) {
                        let r = o.INVALID_ALT_NUMBER;
                        for (let o = 0; o < t.items.length; o++) {
                            const s = t.items[o],
                                c = s.alt === r;
                            if (!c || !s.passedThroughNonGreedyDecision) {
                                if (x.debug) {
                                    console.log('testing %s at %s\n', this.getTokenName(a), s.toString(this.recog, !0));
                                }
                                for (let t = 0; t < s.state.transitions.length; t++) {
                                    const o = s.state.transitions[t],
                                        l = this.getReachableTarget(o, a);
                                    if (null !== l) {
                                        let t = s.lexerActionExecutor;
                                        if (null !== t) {
                                            t = t.fixOffsetBeforeMatch(e.index - this.startIndex);
                                        }
                                        const o = a === i.EOF,
                                            u = new m({ state: l, lexerActionExecutor: t }, s);
                                        if (this.closure(e, u, n, c, !0, o)) {
                                            r = s.alt;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    accept(e, t, n, i, a, o) {
                        if (x.debug) {
                            console.log('ACTION %s\n', t);
                        }
                        e.seek(i);
                        this.line = a;
                        this.column = o;
                        if (null !== t && null !== this.recog) {
                            t.execute(this.recog, e, n);
                        }
                    }

                    getReachableTarget(e, t) {
                        if (e.matches(t, 0, a.MAX_CHAR_VALUE)) {
                            return e.target;
                        } else {
                            return null;
                        }
                    }

                    computeStartState(e, t) {
                        const n = l.EMPTY,
                            i = new c();
                        for (let a = 0; a < t.transitions.length; a++) {
                            const o = t.transitions[a].target,
                                r = new m({ state: o, alt: a + 1, context: n }, null);
                            this.closure(e, r, i, !1, !1, !1);
                        }
                        return i;
                    }

                    closure(e, t, n, i, a, o) {
                        let r = null;
                        if (x.debug) {
                            console.log('closure(' + t.toString(this.recog, !0) + ')');
                        }
                        if (t.state instanceof d) {
                            if (x.debug) {
                                if (null !== this.recog) {
                                    console.log(
                                        'closure at %s rule stop %s\n',
                                        this.recog.ruleNames[t.state.ruleIndex],
                                        t,
                                    );
                                } else {
                                    console.log('closure at rule stop %s\n', t);
                                }
                            }
                            if (null === t.context || t.context.hasEmptyPath()) {
                                if (null === t.context || t.context.isEmpty()) {
                                    n.add(t);
                                    return !0;
                                } else {
                                    n.add(new m({ state: t.state, context: l.EMPTY }, t));
                                    i = !0;
                                }
                            }
                            if (null !== t.context && !t.context.isEmpty()) {
                                for (let s = 0; s < t.context.length; s++) {
                                    if (t.context.getReturnState(s) !== l.EMPTY_RETURN_STATE) {
                                        const c = t.context.getParent(s),
                                            l = this.atn.states[t.context.getReturnState(s)];
                                        r = new m({ state: l, context: c }, t);
                                        i = this.closure(e, r, n, i, a, o);
                                    }
                                }
                            }
                            return i;
                        }
                        if (!t.state.epsilonOnlyTransitions) {
                            if (!i || !t.passedThroughNonGreedyDecision) {
                                n.add(t);
                            }
                        }
                        for (let s = 0; s < t.state.transitions.length; s++) {
                            const c = t.state.transitions[s];
                            r = this.getEpsilonTarget(e, t, c, n, a, o);
                            if (null !== r) {
                                i = this.closure(e, r, n, i, a, o);
                            }
                        }
                        return i;
                    }

                    getEpsilonTarget(e, t, n, o, r, s) {
                        let c = null;
                        if (n.serializationType === p.RULE) {
                            const e = u.create(t.context, n.followState.stateNumber);
                            c = new m({ state: n.target, context: e }, t);
                        } else if (n.serializationType === p.PRECEDENCE) {
                            throw 'Precedence predicates are not supported in lexers.';
                        } else if (n.serializationType === p.PREDICATE) {
                            if (x.debug) {
                                console.log('EVAL rule ' + n.ruleIndex + ':' + n.predIndex);
                            }
                            o.hasSemanticContext = !0;
                            if (this.evaluatePredicate(e, n.ruleIndex, n.predIndex, r)) {
                                c = new m({ state: n.target }, t);
                            }
                        } else if (n.serializationType === p.ACTION) {
                            if (null === t.context || t.context.hasEmptyPath()) {
                                const e = f.append(t.lexerActionExecutor, this.atn.lexerActions[n.actionIndex]);
                                c = new m({ state: n.target, lexerActionExecutor: e }, t);
                            } else {
                                c = new m({ state: n.target }, t);
                            }
                        } else if (n.serializationType === p.EPSILON) {
                            c = new m({ state: n.target }, t);
                        } else if (
                            n.serializationType === p.ATOM ||
                            n.serializationType === p.RANGE ||
                            n.serializationType === p.SET
                        ) {
                            if (s) {
                                if (n.matches(i.EOF, 0, a.MAX_CHAR_VALUE)) {
                                    c = new m({ state: n.target }, t);
                                }
                            }
                        }
                        return c;
                    }

                    evaluatePredicate(e, t, n, i) {
                        if (null === this.recog) {
                            return !0;
                        }
                        if (!i) {
                            return this.recog.sempred(null, t, n);
                        }
                        const a = this.column,
                            o = this.line,
                            r = e.index,
                            s = e.mark();
                        try {
                            this.consume(e);
                            return this.recog.sempred(null, t, n);
                        } finally {
                            this.column = a;
                            this.line = o;
                            e.seek(r);
                            e.release(s);
                        }
                    }

                    captureSimState(e, t, n) {
                        e.index = t.index;
                        e.line = this.line;
                        e.column = this.column;
                        e.dfaState = n;
                    }

                    addDFAEdge(e, t, n, i) {
                        if (void 0 === n) {
                            n = null;
                        }
                        if (void 0 === i) {
                            i = null;
                        }
                        if (null === n && null !== i) {
                            const e = i.hasSemanticContext;
                            i.hasSemanticContext = !1;
                            n = this.addDFAState(i);
                            if (e) {
                                return n;
                            }
                        }
                        if (t < x.MIN_DFA_EDGE || t > x.MAX_DFA_EDGE) {
                            return n;
                        }
                        if (x.debug) {
                            console.log('EDGE ' + e + ' -> ' + n + ' upon ' + t);
                        }
                        if (null === e.edges) {
                            e.edges = [];
                        }
                        e.edges[t - x.MIN_DFA_EDGE] = n;
                        return n;
                    }

                    addDFAState(e) {
                        const t = new s(null, e);
                        let n = null;
                        for (let t = 0; t < e.items.length; t++) {
                            const i = e.items[t];
                            if (i.state instanceof d) {
                                n = i;
                                break;
                            }
                        }
                        if (null !== n) {
                            t.isAcceptState = !0;
                            t.lexerActionExecutor = n.lexerActionExecutor;
                            t.prediction = this.atn.ruleToTokenType[n.state.ruleIndex];
                        }
                        const i = this.decisionToDFA[this.mode],
                            a = i.states.get(t);
                        if (null !== a) {
                            return a;
                        }
                        const o = t;
                        o.stateNumber = i.states.length;
                        e.setReadonly(!0);
                        o.configs = e;
                        i.states.add(o);
                        return o;
                    }

                    getDFA(e) {
                        return this.decisionToDFA[e];
                    }

                    getText(e) {
                        return e.getText(this.startIndex, e.index - 1);
                    }

                    consume(e) {
                        if (e.LA(1) === '\n'.charCodeAt(0)) {
                            this.line += 1;
                            this.column = 0;
                        } else {
                            this.column += 1;
                        }
                        e.consume();
                    }

                    getTokenName(e) {
                        if (-1 === e) {
                            return 'EOF';
                        } else {
                            return "'" + String.fromCharCode(e) + "'";
                        }
                    }
                }

                x.debug = !1;
                x.dfa_debug = !1;
                x.MIN_DFA_EDGE = 0;
                x.MAX_DFA_EDGE = 127;
                x.match_calls = 0;
                e.exports = x;
            },
            2446: function (e) {
                const t = { CHANNEL: 0, CUSTOM: 1, MODE: 2, MORE: 3, POP_MODE: 4, PUSH_MODE: 5, SKIP: 6, TYPE: 7 };

                class n {
                    constructor(e) {
                        this.actionType = e;
                        this.isPositionDependent = !1;
                    }

                    hashCode() {
                        const e = new Hash();
                        this.updateHashCode(e);
                        return e.finish();
                    }

                    updateHashCode(e) {
                        e.update(this.actionType);
                    }

                    equals(e) {
                        return this === e;
                    }
                }

                class i extends n {
                    constructor() {
                        super(t.SKIP);
                    }

                    execute(e) {
                        e.skip();
                    }

                    toString() {
                        return 'skip';
                    }
                }

                i.INSTANCE = new i();

                class a extends n {
                    constructor(e) {
                        super(t.TYPE);
                        this.type = e;
                    }

                    execute(e) {
                        e.type = this.type;
                    }

                    updateHashCode(e) {
                        e.update(this.actionType, this.type);
                    }

                    equals(e) {
                        if (this === e) {
                            return !0;
                        } else if (!(e instanceof a)) {
                            return !1;
                        } else {
                            return this.type === e.type;
                        }
                    }

                    toString() {
                        return 'type(' + this.type + ')';
                    }
                }

                class o extends n {
                    constructor(e) {
                        super(t.PUSH_MODE);
                        this.mode = e;
                    }

                    execute(e) {
                        e.pushMode(this.mode);
                    }

                    updateHashCode(e) {
                        e.update(this.actionType, this.mode);
                    }

                    equals(e) {
                        if (this === e) {
                            return !0;
                        } else if (!(e instanceof o)) {
                            return !1;
                        } else {
                            return this.mode === e.mode;
                        }
                    }

                    toString() {
                        return 'pushMode(' + this.mode + ')';
                    }
                }

                class r extends n {
                    constructor() {
                        super(t.POP_MODE);
                    }

                    execute(e) {
                        e.popMode();
                    }

                    toString() {
                        return 'popMode';
                    }
                }

                r.INSTANCE = new r();

                class s extends n {
                    constructor() {
                        super(t.MORE);
                    }

                    execute(e) {
                        e.more();
                    }

                    toString() {
                        return 'more';
                    }
                }

                s.INSTANCE = new s();

                class c extends n {
                    constructor(e) {
                        super(t.MODE);
                        this.mode = e;
                    }

                    execute(e) {
                        e.mode(this.mode);
                    }

                    updateHashCode(e) {
                        e.update(this.actionType, this.mode);
                    }

                    equals(e) {
                        if (this === e) {
                            return !0;
                        } else if (!(e instanceof c)) {
                            return !1;
                        } else {
                            return this.mode === e.mode;
                        }
                    }

                    toString() {
                        return 'mode(' + this.mode + ')';
                    }
                }

                class l extends n {
                    constructor(e, n) {
                        super(t.CUSTOM);
                        this.ruleIndex = e;
                        this.actionIndex = n;
                        this.isPositionDependent = !0;
                    }

                    execute(e) {
                        e.action(null, this.ruleIndex, this.actionIndex);
                    }

                    updateHashCode(e) {
                        e.update(this.actionType, this.ruleIndex, this.actionIndex);
                    }

                    equals(e) {
                        if (this === e) {
                            return !0;
                        } else if (!(e instanceof l)) {
                            return !1;
                        } else {
                            return this.ruleIndex === e.ruleIndex && this.actionIndex === e.actionIndex;
                        }
                    }
                }

                class u extends n {
                    constructor(e) {
                        super(t.CHANNEL);
                        this.channel = e;
                    }

                    execute(e) {
                        e._channel = this.channel;
                    }

                    updateHashCode(e) {
                        e.update(this.actionType, this.channel);
                    }

                    equals(e) {
                        if (this === e) {
                            return !0;
                        } else if (!(e instanceof u)) {
                            return !1;
                        } else {
                            return this.channel === e.channel;
                        }
                    }

                    toString() {
                        return 'channel(' + this.channel + ')';
                    }
                }

                class d extends n {
                    constructor(e, t) {
                        super(t.actionType);
                        this.offset = e;
                        this.action = t;
                        this.isPositionDependent = !0;
                    }

                    execute(e) {
                        this.action.execute(e);
                    }

                    updateHashCode(e) {
                        e.update(this.actionType, this.offset, this.action);
                    }

                    equals(e) {
                        if (this === e) {
                            return !0;
                        } else if (!(e instanceof d)) {
                            return !1;
                        } else {
                            return this.offset === e.offset && this.action === e.action;
                        }
                    }
                }

                e.exports = {
                    LexerActionType: t,
                    LexerSkipAction: i,
                    LexerChannelAction: u,
                    LexerCustomAction: l,
                    LexerIndexedCustomAction: d,
                    LexerMoreAction: s,
                    LexerTypeAction: a,
                    LexerPushModeAction: o,
                    LexerPopModeAction: r,
                    LexerModeAction: c,
                };
            },
            2163: function (e, t, n) {
                const { hashStuff: i } = n(2373),
                    { LexerIndexedCustomAction: a } = n(2446);

                class o {
                    constructor(e) {
                        this.lexerActions = null === e ? [] : e;
                        this.cachedHashCode = i(e);
                        return this;
                    }

                    fixOffsetBeforeMatch(e) {
                        let t = null;
                        for (let n = 0; n < this.lexerActions.length; n++) {
                            if (this.lexerActions[n].isPositionDependent && !(this.lexerActions[n] instanceof a)) {
                                if (null === t) {
                                    t = this.lexerActions.concat([]);
                                }
                                t[n] = new a(e, this.lexerActions[n]);
                            }
                        }
                        if (null === t) {
                            return this;
                        } else {
                            return new o(t);
                        }
                    }

                    execute(e, t, n) {
                        let i = !1;
                        const o = t.index;
                        try {
                            for (let r = 0; r < this.lexerActions.length; r++) {
                                let s = this.lexerActions[r];
                                if (s instanceof a) {
                                    const e = s.offset;
                                    t.seek(n + e);
                                    s = s.action;
                                    i = n + e !== o;
                                } else if (s.isPositionDependent) {
                                    t.seek(o);
                                    i = !1;
                                }
                                s.execute(e);
                            }
                        } finally {
                            if (i) {
                                t.seek(o);
                            }
                        }
                    }

                    hashCode() {
                        return this.cachedHashCode;
                    }

                    updateHashCode(e) {
                        e.update(this.cachedHashCode);
                    }

                    equals(e) {
                        if (this === e) {
                            return !0;
                        } else if (!(e instanceof o)) {
                            return !1;
                        } else if (this.cachedHashCode != e.cachedHashCode) {
                            return !1;
                        } else if (this.lexerActions.length != e.lexerActions.length) {
                            return !1;
                        } else {
                            const t = this.lexerActions.length;
                            for (let n = 0; n < t; ++n) {
                                if (!this.lexerActions[n].equals(e.lexerActions[n])) {
                                    return !1;
                                }
                            }
                            return !0;
                        }
                    }

                    static append(e, t) {
                        if (null === e) {
                            return new o([t]);
                        }
                        const n = e.lexerActions.concat([t]);
                        return new o(n);
                    }
                }

                e.exports = o;
            },
            2006: function (e, t, n) {
                const i = n(2373),
                    { Set: a, BitSet: o, DoubleDict: r } = i,
                    s = n(4471),
                    { ATNState: c, RuleStopState: l } = n(2766),
                    { ATNConfig: u } = n(5185),
                    { ATNConfigSet: d } = n(7329),
                    { Token: m } = n(5537),
                    { DFAState: p, PredPrediction: f } = n(2982),
                    g = n(7093),
                    h = n(9098),
                    y = n(2841),
                    { SemanticContext: x } = (n(72), n(6389)),
                    { PredictionContext: _ } = n(6400),
                    { Interval: E } = n(7059),
                    {
                        Transition: C,
                        SetTransition: S,
                        NotSetTransition: b,
                        RuleTransition: v,
                        ActionTransition: D,
                    } = n(5651),
                    { NoViableAltException: R } = n(586),
                    { SingletonPredictionContext: M, predictionContextFromRuleContext: T } = n(6400);
                e.exports = class extends g {
                    constructor(e, t, n, i) {
                        super(t, i);
                        this.parser = e;
                        this.decisionToDFA = n;
                        this.predictionMode = h.LL;
                        this._input = null;
                        this._startIndex = 0;
                        this._outerContext = null;
                        this._dfa = null;
                        this.mergeCache = null;
                        this.debug = !1;
                        this.debug_closure = !1;
                        this.debug_add = !1;
                        this.debug_list_atn_decisions = !1;
                        this.dfa_debug = !1;
                        this.retry_debug = !1;
                    }

                    reset() {}

                    adaptivePredict(e, t, n) {
                        if (this.debug || this.debug_list_atn_decisions) {
                            console.log(
                                'adaptivePredict decision ' +
                                    t +
                                    ' exec LA(1)==' +
                                    this.getLookaheadName(e) +
                                    ' line ' +
                                    e.LT(1).line +
                                    ':' +
                                    e.LT(1).column,
                            );
                        }
                        this._input = e;
                        this._startIndex = e.index;
                        this._outerContext = n;
                        const i = this.decisionToDFA[t];
                        this._dfa = i;
                        const a = e.mark(),
                            o = e.index;
                        try {
                            let t;
                            if (i.precedenceDfa) {
                                t = i.getPrecedenceStartState(this.parser.getPrecedence());
                            } else {
                                t = i.s0;
                            }
                            if (null === t) {
                                if (null === n) {
                                    n = y.EMPTY;
                                }
                                if (this.debug || this.debug_list_atn_decisions) {
                                    console.log(
                                        'predictATN decision ' +
                                            i.decision +
                                            ' exec LA(1)==' +
                                            this.getLookaheadName(e) +
                                            ', outerContext=' +
                                            n.toString(this.parser.ruleNames),
                                    );
                                }
                                const a = !1;
                                let o = this.computeStartState(i.atnStartState, y.EMPTY, a);
                                if (i.precedenceDfa) {
                                    i.s0.configs = o;
                                    o = this.applyPrecedenceFilter(o);
                                    t = this.addDFAState(i, new p(null, o));
                                    i.setPrecedenceStartState(this.parser.getPrecedence(), t);
                                } else {
                                    t = this.addDFAState(i, new p(null, o));
                                    i.s0 = t;
                                }
                            }
                            const a = this.execATN(i, t, e, o, n);
                            if (this.debug) {
                                console.log(
                                    'DFA after predictATN: ' +
                                        i.toString(this.parser.literalNames, this.parser.symbolicNames),
                                );
                            }
                            return a;
                        } finally {
                            this._dfa = null;
                            this.mergeCache = null;
                            e.seek(o);
                            e.release(a);
                        }
                    }

                    execATN(e, t, n, i, a) {
                        if (this.debug || this.debug_list_atn_decisions) {
                            console.log(
                                'execATN decision ' +
                                    e.decision +
                                    ' exec LA(1)==' +
                                    this.getLookaheadName(n) +
                                    ' line ' +
                                    n.LT(1).line +
                                    ':' +
                                    n.LT(1).column,
                            );
                        }
                        let o,
                            r = t;
                        if (this.debug) {
                            console.log('s0 = ' + t);
                        }
                        let c = n.LA(1);
                        for (;;) {
                            let t = this.getExistingTargetState(r, c);
                            if (null === t) {
                                t = this.computeTargetState(e, r, c);
                            }
                            if (t === g.ERROR) {
                                const e = this.noViableAlt(n, a, r.configs, i);
                                n.seek(i);
                                o = this.getSynValidOrSemInvalidAltThatFinishedDecisionEntryRule(r.configs, a);
                                if (o !== s.INVALID_ALT_NUMBER) {
                                    return o;
                                } else {
                                    throw e;
                                }
                            }
                            if (t.requiresFullContext && this.predictionMode !== h.SLL) {
                                let r = null;
                                if (null !== t.predicates) {
                                    if (this.debug) {
                                        console.log('DFA state has preds in DFA sim LL failover');
                                    }
                                    const e = n.index;
                                    if (e !== i) {
                                        n.seek(i);
                                    }
                                    r = this.evalSemanticContext(t.predicates, a, !0);
                                    if (1 === r.length) {
                                        if (this.debug) {
                                            console.log('Full LL avoided');
                                        }
                                        return r.minValue();
                                    }
                                    if (e !== i) {
                                        n.seek(e);
                                    }
                                }
                                if (this.dfa_debug) {
                                    console.log('ctx sensitive state ' + a + ' in ' + t);
                                }
                                const s = !0,
                                    c = this.computeStartState(e.atnStartState, a, s);
                                this.reportAttemptingFullContext(e, r, t.configs, i, n.index);
                                o = this.execATNWithFullContext(e, t, c, n, i, a);
                                return o;
                            }
                            if (t.isAcceptState) {
                                if (null === t.predicates) {
                                    return t.prediction;
                                }
                                const o = n.index;
                                n.seek(i);
                                const r = this.evalSemanticContext(t.predicates, a, !0);
                                if (0 === r.length) {
                                    throw this.noViableAlt(n, a, t.configs, i);
                                } else if (1 === r.length) {
                                    return r.minValue();
                                } else {
                                    this.reportAmbiguity(e, t, i, o, !1, r, t.configs);
                                    return r.minValue();
                                }
                            }
                            r = t;
                            if (c !== m.EOF) {
                                n.consume();
                                c = n.LA(1);
                            }
                        }
                    }

                    getExistingTargetState(e, t) {
                        const n = e.edges;
                        if (null === n) {
                            return null;
                        } else {
                            return n[t + 1] || null;
                        }
                    }

                    computeTargetState(e, t, n) {
                        const a = this.computeReachSet(t.configs, n, !1);
                        if (null === a) {
                            this.addDFAEdge(e, t, n, g.ERROR);
                            return g.ERROR;
                        }
                        let o = new p(null, a);
                        const r = this.getUniqueAlt(a);
                        if (this.debug) {
                            const e = h.getConflictingAltSubsets(a);
                            console.log(
                                'SLL altSubSets=' +
                                    i.arrayToString(e) +
                                    ', configs=' +
                                    a +
                                    ', predict=' +
                                    r +
                                    ', allSubsetsConflict=' +
                                    h.allSubsetsConflict(e) +
                                    ', conflictingAlts=' +
                                    this.getConflictingAlts(a),
                            );
                        }
                        if (r !== s.INVALID_ALT_NUMBER) {
                            o.isAcceptState = !0;
                            o.configs.uniqueAlt = r;
                            o.prediction = r;
                        } else if (h.hasSLLConflictTerminatingPrediction(this.predictionMode, a)) {
                            o.configs.conflictingAlts = this.getConflictingAlts(a);
                            o.requiresFullContext = !0;
                            o.isAcceptState = !0;
                            o.prediction = o.configs.conflictingAlts.minValue();
                        }
                        if (o.isAcceptState && o.configs.hasSemanticContext) {
                            this.predicateDFAState(o, this.atn.getDecisionState(e.decision));
                            if (null !== o.predicates) {
                                o.prediction = s.INVALID_ALT_NUMBER;
                            }
                        }
                        o = this.addDFAEdge(e, t, n, o);
                        return o;
                    }

                    predicateDFAState(e, t) {
                        const n = t.transitions.length,
                            i = this.getConflictingAltsOrUniqueAlt(e.configs),
                            a = this.getPredsForAmbigAlts(i, e.configs, n);
                        if (null !== a) {
                            e.predicates = this.getPredicatePredictions(i, a);
                            e.prediction = s.INVALID_ALT_NUMBER;
                        } else {
                            e.prediction = i.minValue();
                        }
                    }

                    execATNWithFullContext(e, t, n, i, a, o) {
                        if (this.debug || this.debug_list_atn_decisions) {
                            console.log('execATNWithFullContext ' + n);
                        }
                        let r,
                            c = !1,
                            l = n;
                        i.seek(a);
                        let u = i.LA(1),
                            d = -1;
                        for (;;) {
                            r = this.computeReachSet(l, u, true);
                            if (null === r) {
                                const e = this.noViableAlt(i, o, l, a);
                                i.seek(a);
                                const t = this.getSynValidOrSemInvalidAltThatFinishedDecisionEntryRule(l, o);
                                if (t !== s.INVALID_ALT_NUMBER) {
                                    return t;
                                } else {
                                    throw e;
                                }
                            }
                            const e = h.getConflictingAltSubsets(r);
                            if (this.debug) {
                                console.log(
                                    'LL altSubSets=' +
                                        e +
                                        ', predict=' +
                                        h.getUniqueAlt(e) +
                                        ', resolvesToJustOneViableAlt=' +
                                        h.resolvesToJustOneViableAlt(e),
                                );
                            }
                            r.uniqueAlt = this.getUniqueAlt(r);
                            if (r.uniqueAlt !== s.INVALID_ALT_NUMBER) {
                                d = r.uniqueAlt;
                                break;
                            } else if (this.predictionMode !== h.LL_EXACT_AMBIG_DETECTION) {
                                d = h.resolvesToJustOneViableAlt(e);
                                if (d !== s.INVALID_ALT_NUMBER) {
                                    break;
                                }
                            } else if (h.allSubsetsConflict(e) && h.allSubsetsEqual(e)) {
                                c = !0;
                                d = h.getSingleViableAlt(e);
                                break;
                            }
                            l = r;
                            if (u !== m.EOF) {
                                i.consume();
                                u = i.LA(1);
                            }
                        }
                        if (r.uniqueAlt !== s.INVALID_ALT_NUMBER) {
                            this.reportContextSensitivity(e, d, r, a, i.index);
                            return d;
                        }
                        this.reportAmbiguity(e, t, a, i.index, c, null, r);
                        return d;
                    }

                    computeReachSet(e, t, n) {
                        if (this.debug) {
                            console.log('in computeReachSet, starting closure: ' + e);
                        }
                        if (null === this.mergeCache) {
                            this.mergeCache = new r();
                        }
                        const i = new d(n);
                        let o = null;
                        for (let a = 0; a < e.items.length; a++) {
                            const r = e.items[a];
                            if (this.debug) {
                                console.log('testing ' + this.getTokenName(t) + ' at ' + r);
                            }
                            if (!(r.state instanceof l)) {
                                for (let e = 0; e < r.state.transitions.length; e++) {
                                    const n = r.state.transitions[e],
                                        a = this.getReachableTarget(n, t);
                                    if (null !== a) {
                                        const e = new u({ state: a }, r);
                                        i.add(e, this.mergeCache);
                                        if (this.debug_add) {
                                            console.log('added ' + e + ' to intermediate');
                                        }
                                    }
                                }
                            } else if (n || t === m.EOF) {
                                if (null === o) {
                                    o = [];
                                }
                                o.push(r);
                                if (this.debug_add) {
                                    console.log('added ' + r + ' to skippedStopStates');
                                }
                            }
                        }
                        let c = null;
                        if (null === o && t !== m.EOF) {
                            if (1 === i.items.length) {
                                c = i;
                            } else if (this.getUniqueAlt(i) !== s.INVALID_ALT_NUMBER) {
                                c = i;
                            }
                        }
                        if (null === c) {
                            c = new d(n);
                            const e = new a(),
                                o = t === m.EOF;
                            for (let t = 0; t < i.items.length; t++) {
                                this.closure(i.items[t], c, e, !1, n, o);
                            }
                        }
                        if (t === m.EOF) {
                            c = this.removeAllConfigsNotInRuleStopState(c, c === i);
                        }
                        if (!(null === o || (n && h.hasConfigInRuleStopState(c)))) {
                            for (let e = 0; e < o.length; e++) {
                                c.add(o[e], this.mergeCache);
                            }
                        }
                        if (0 === c.items.length) {
                            return null;
                        } else {
                            return c;
                        }
                    }

                    removeAllConfigsNotInRuleStopState(e, t) {
                        if (h.allConfigsInRuleStopStates(e)) {
                            return e;
                        }
                        const n = new d(e.fullCtx);
                        for (let i = 0; i < e.items.length; i++) {
                            const a = e.items[i];
                            if (!(a.state instanceof l)) {
                                if (t && a.state.epsilonOnlyTransitions) {
                                    if (this.atn.nextTokens(a.state).contains(m.EPSILON)) {
                                        const e = this.atn.ruleToStopState[a.state.ruleIndex];
                                        n.add(new u({ state: e }, a), this.mergeCache);
                                    }
                                }
                            } else {
                                n.add(a, this.mergeCache);
                            }
                        }
                        return n;
                    }

                    computeStartState(e, t, n) {
                        const i = T(this.atn, t),
                            o = new d(n);
                        for (let t = 0; t < e.transitions.length; t++) {
                            const r = e.transitions[t].target,
                                s = new u({ state: r, alt: t + 1, context: i }, null),
                                c = new a();
                            this.closure(s, o, c, !0, n, !1);
                        }
                        return o;
                    }

                    applyPrecedenceFilter(e) {
                        let t;
                        const n = [],
                            i = new d(e.fullCtx);
                        for (let a = 0; a < e.items.length; a++) {
                            t = e.items[a];
                            if (1 !== t.alt) {
                                continue;
                            }
                            const o = t.semanticContext.evalPrecedence(this.parser, this._outerContext);
                            if (null !== o) {
                                n[t.state.stateNumber] = t.context;
                                if (o !== t.semanticContext) {
                                    i.add(new u({ semanticContext: o }, t), this.mergeCache);
                                } else {
                                    i.add(t, this.mergeCache);
                                }
                            }
                        }
                        for (let a = 0; a < e.items.length; a++) {
                            t = e.items[a];
                            if (1 !== t.alt) {
                                if (!t.precedenceFilterSuppressed) {
                                    const e = n[t.state.stateNumber] || null;
                                    if (null !== e && e.equals(t.context)) {
                                        continue;
                                    }
                                }
                                i.add(t, this.mergeCache);
                            }
                        }
                        return i;
                    }

                    getReachableTarget(e, t) {
                        if (e.matches(t, 0, this.atn.maxTokenType)) {
                            return e.target;
                        } else {
                            return null;
                        }
                    }

                    getPredsForAmbigAlts(e, t, n) {
                        let a = [];
                        for (let n = 0; n < t.items.length; n++) {
                            const i = t.items[n];
                            if (e.contains(i.alt)) {
                                a[i.alt] = x.orContext(a[i.alt] || null, i.semanticContext);
                            }
                        }
                        let o = 0;
                        for (let e = 1; e < n + 1; e++) {
                            const t = a[e] || null;
                            if (null === t) {
                                a[e] = x.NONE;
                            } else if (t !== x.NONE) {
                                o += 1;
                            }
                        }
                        if (0 === o) {
                            a = null;
                        }
                        if (this.debug) {
                            console.log('getPredsForAmbigAlts result ' + i.arrayToString(a));
                        }
                        return a;
                    }

                    getPredicatePredictions(e, t) {
                        const n = [];
                        let i = !1;
                        for (let a = 1; a < t.length; a++) {
                            const o = t[a];
                            if (null !== e && e.contains(a)) {
                                n.push(new f(o, a));
                            }
                            if (o !== x.NONE) {
                                i = !0;
                            }
                        }
                        if (!i) {
                            return null;
                        } else {
                            return n;
                        }
                    }

                    getSynValidOrSemInvalidAltThatFinishedDecisionEntryRule(e, t) {
                        const n = this.splitAccordingToSemanticValidity(e, t),
                            i = n[0],
                            a = n[1];
                        let o = this.getAltThatFinishedDecisionEntryRule(i);
                        if (o !== s.INVALID_ALT_NUMBER) {
                            return o;
                        }
                        if (a.items.length > 0) {
                            o = this.getAltThatFinishedDecisionEntryRule(a);
                            if (o !== s.INVALID_ALT_NUMBER) {
                                return o;
                            }
                        }
                        return s.INVALID_ALT_NUMBER;
                    }

                    getAltThatFinishedDecisionEntryRule(e) {
                        const t = [];
                        for (let n = 0; n < e.items.length; n++) {
                            const i = e.items[n];
                            if (i.reachesIntoOuterContext > 0 || (i.state instanceof l && i.context.hasEmptyPath())) {
                                if (t.indexOf(i.alt) < 0) {
                                    t.push(i.alt);
                                }
                            }
                        }
                        if (0 === t.length) {
                            return s.INVALID_ALT_NUMBER;
                        } else {
                            return Math.min.apply(null, t);
                        }
                    }

                    splitAccordingToSemanticValidity(e, t) {
                        const n = new d(e.fullCtx),
                            i = new d(e.fullCtx);
                        for (let a = 0; a < e.items.length; a++) {
                            const o = e.items[a];
                            if (o.semanticContext !== x.NONE) {
                                if (o.semanticContext.evaluate(this.parser, t)) {
                                    n.add(o);
                                } else {
                                    i.add(o);
                                }
                            } else {
                                n.add(o);
                            }
                        }
                        return [n, i];
                    }

                    evalSemanticContext(e, t, n) {
                        const i = new o();
                        for (let a = 0; a < e.length; a++) {
                            const o = e[a];
                            if (o.pred === x.NONE) {
                                i.add(o.alt);
                                if (!n) {
                                    break;
                                }
                                continue;
                            }
                            const r = o.pred.evaluate(this.parser, t);
                            if (this.debug || this.dfa_debug) {
                                console.log('eval pred ' + o + '=' + r);
                            }
                            if (r) {
                                if (this.debug || this.dfa_debug) {
                                    console.log('PREDICT ' + o.alt);
                                }
                                i.add(o.alt);
                                if (!n) {
                                    break;
                                }
                            }
                        }
                        return i;
                    }

                    closure(e, t, n, i, a, o) {
                        this.closureCheckingStopState(e, t, n, i, a, 0, o);
                    }

                    closureCheckingStopState(e, t, n, i, a, o, r) {
                        if (this.debug || this.debug_closure) {
                            console.log('closure(' + e.toString(this.parser, !0) + ')');
                            if (e.reachesIntoOuterContext > 50) {
                                throw 'problem';
                            }
                        }
                        if (e.state instanceof l) {
                            if (!e.context.isEmpty()) {
                                for (let s = 0; s < e.context.length; s++) {
                                    if (e.context.getReturnState(s) === _.EMPTY_RETURN_STATE) {
                                        if (a) {
                                            t.add(new u({ state: e.state, context: _.EMPTY }, e), this.mergeCache);
                                            continue;
                                        } else {
                                            if (this.debug) {
                                                console.log('FALLING off rule ' + this.getRuleName(e.state.ruleIndex));
                                            }
                                            this.closure_(e, t, n, i, a, o, r);
                                        }
                                        continue;
                                    }
                                    const c = this.atn.states[e.context.getReturnState(s)],
                                        l = e.context.getParent(s),
                                        d = { state: c, alt: e.alt, context: l, semanticContext: e.semanticContext },
                                        m = new u(d, null);
                                    m.reachesIntoOuterContext = e.reachesIntoOuterContext;
                                    this.closureCheckingStopState(m, t, n, i, a, o - 1, r);
                                }
                                return;
                            } else if (a) {
                                t.add(e, this.mergeCache);
                                return;
                            } else if (this.debug) {
                                console.log('FALLING off rule ' + this.getRuleName(e.state.ruleIndex));
                            }
                        }
                        this.closure_(e, t, n, i, a, o, r);
                    }

                    closure_(e, t, n, i, a, o, r) {
                        const s = e.state;
                        if (!s.epsilonOnlyTransitions) {
                            t.add(e, this.mergeCache);
                        }
                        for (let c = 0; c < s.transitions.length; c++) {
                            if (0 === c && this.canDropLoopEntryEdgeInLeftRecursiveRule(e)) {
                                continue;
                            }
                            const u = s.transitions[c],
                                d = i && !(u instanceof D),
                                m = this.getEpsilonTarget(e, u, d, 0 === o, a, r);
                            if (null !== m) {
                                let i = o;
                                if (e.state instanceof l) {
                                    if (null !== this._dfa && this._dfa.precedenceDfa) {
                                        if (u.outermostPrecedenceReturn === this._dfa.atnStartState.ruleIndex) {
                                            m.precedenceFilterSuppressed = !0;
                                        }
                                    }
                                    m.reachesIntoOuterContext += 1;
                                    if (n.add(m) !== m) {
                                        continue;
                                    }
                                    t.dipsIntoOuterContext = !0;
                                    i -= 1;
                                    if (this.debug) {
                                        console.log('dips into outer ctx: ' + m);
                                    }
                                } else {
                                    if (!u.isEpsilon && n.add(m) !== m) {
                                        continue;
                                    }
                                    if (u instanceof v) {
                                        if (i >= 0) {
                                            i += 1;
                                        }
                                    }
                                }
                                this.closureCheckingStopState(m, t, n, d, a, i, r);
                            }
                        }
                    }

                    canDropLoopEntryEdgeInLeftRecursiveRule(e) {
                        const t = e.state;
                        if (t.stateType !== c.STAR_LOOP_ENTRY) {
                            return !1;
                        }
                        if (
                            t.stateType !== c.STAR_LOOP_ENTRY ||
                            !t.isPrecedenceDecision ||
                            e.context.isEmpty() ||
                            e.context.hasEmptyPath()
                        ) {
                            return !1;
                        }
                        const n = e.context.length;
                        for (let i = 0; i < n; i++) {
                            if (this.atn.states[e.context.getReturnState(i)].ruleIndex !== t.ruleIndex) {
                                return !1;
                            }
                        }
                        const i = t.transitions[0].target.endState.stateNumber,
                            a = this.atn.states[i];
                        for (let i = 0; i < n; i++) {
                            const n = e.context.getReturnState(i),
                                o = this.atn.states[n];
                            if (1 !== o.transitions.length || !o.transitions[0].isEpsilon) {
                                return !1;
                            }
                            const r = o.transitions[0].target;
                            if (o.stateType !== c.BLOCK_END || r !== t) {
                                if (o !== a) {
                                    if (r !== a) {
                                        if (
                                            r.stateType !== c.BLOCK_END ||
                                            1 !== r.transitions.length ||
                                            !r.transitions[0].isEpsilon ||
                                            r.transitions[0].target !== t
                                        ) {
                                            return !1;
                                        }
                                    }
                                }
                            }
                        }
                        return !0;
                    }

                    getRuleName(e) {
                        if (null !== this.parser && e >= 0) {
                            return this.parser.ruleNames[e];
                        } else {
                            return '<rule ' + e + '>';
                        }
                    }

                    getEpsilonTarget(e, t, n, i, a, o) {
                        switch (t.serializationType) {
                            case C.RULE:
                                return this.ruleTransition(e, t);
                            case C.PRECEDENCE:
                                return this.precedenceTransition(e, t, n, i, a);
                            case C.PREDICATE:
                                return this.predTransition(e, t, n, i, a);
                            case C.ACTION:
                                return this.actionTransition(e, t);
                            case C.EPSILON:
                                return new u({ state: t.target }, e);
                            case C.ATOM:
                            case C.RANGE:
                            case C.SET:
                                if (o) {
                                    if (t.matches(m.EOF, 0, 1)) {
                                        return new u({ state: t.target }, e);
                                    }
                                }
                                return null;
                            default:
                                return null;
                        }
                    }

                    actionTransition(e, t) {
                        if (this.debug) {
                            const e = -1 === t.actionIndex ? 65535 : t.actionIndex;
                            console.log('ACTION edge ' + t.ruleIndex + ':' + e);
                        }
                        return new u({ state: t.target }, e);
                    }

                    precedenceTransition(e, t, n, a, o) {
                        if (this.debug) {
                            console.log(
                                'PRED (collectPredicates=' + n + ') ' + t.precedence + '>=_p, ctx dependent=true',
                            );
                            if (null !== this.parser) {
                                console.log(
                                    'context surrounding pred is ' +
                                        i.arrayToString(this.parser.getRuleInvocationStack()),
                                );
                            }
                        }
                        let r = null;
                        if (n && a) {
                            if (o) {
                                const n = this._input.index;
                                this._input.seek(this._startIndex);
                                const i = t.getPredicate().evaluate(this.parser, this._outerContext);
                                this._input.seek(n);
                                if (i) {
                                    r = new u({ state: t.target }, e);
                                }
                            } else {
                                const n = x.andContext(e.semanticContext, t.getPredicate());
                                r = new u({ state: t.target, semanticContext: n }, e);
                            }
                        } else {
                            r = new u({ state: t.target }, e);
                        }
                        if (this.debug) {
                            console.log('config from pred transition=' + r);
                        }
                        return r;
                    }

                    predTransition(e, t, n, a, o) {
                        if (this.debug) {
                            console.log(
                                'PRED (collectPredicates=' +
                                    n +
                                    ') ' +
                                    t.ruleIndex +
                                    ':' +
                                    t.predIndex +
                                    ', ctx dependent=' +
                                    t.isCtxDependent,
                            );
                            if (null !== this.parser) {
                                console.log(
                                    'context surrounding pred is ' +
                                        i.arrayToString(this.parser.getRuleInvocationStack()),
                                );
                            }
                        }
                        let r = null;
                        if (n && ((t.isCtxDependent && a) || !t.isCtxDependent)) {
                            if (o) {
                                const n = this._input.index;
                                this._input.seek(this._startIndex);
                                const i = t.getPredicate().evaluate(this.parser, this._outerContext);
                                this._input.seek(n);
                                if (i) {
                                    r = new u({ state: t.target }, e);
                                }
                            } else {
                                const n = x.andContext(e.semanticContext, t.getPredicate());
                                r = new u({ state: t.target, semanticContext: n }, e);
                            }
                        } else {
                            r = new u({ state: t.target }, e);
                        }
                        if (this.debug) {
                            console.log('config from pred transition=' + r);
                        }
                        return r;
                    }

                    ruleTransition(e, t) {
                        if (this.debug) {
                            console.log('CALL rule ' + this.getRuleName(t.target.ruleIndex) + ', ctx=' + e.context);
                        }
                        const n = t.followState,
                            i = M.create(e.context, n.stateNumber);
                        return new u({ state: t.target, context: i }, e);
                    }

                    getConflictingAlts(e) {
                        const t = h.getConflictingAltSubsets(e);
                        return h.getAlts(t);
                    }

                    getConflictingAltsOrUniqueAlt(e) {
                        let t = null;
                        if (e.uniqueAlt !== s.INVALID_ALT_NUMBER) {
                            t = new o();
                            t.add(e.uniqueAlt);
                        } else {
                            t = e.conflictingAlts;
                        }
                        return t;
                    }

                    getTokenName(e) {
                        if (e === m.EOF) {
                            return 'EOF';
                        }
                        if (null !== this.parser && null !== this.parser.literalNames) {
                            if (e >= this.parser.literalNames.length && e >= this.parser.symbolicNames.length) {
                                console.log(e + ' ttype out of range: ' + this.parser.literalNames);
                                console.log('' + this.parser.getInputStream().getTokens());
                            } else {
                                return (this.parser.literalNames[e] || this.parser.symbolicNames[e]) + '<' + e + '>';
                            }
                        }
                        return '' + e;
                    }

                    getLookaheadName(e) {
                        return this.getTokenName(e.LA(1));
                    }

                    dumpDeadEndConfigs(e) {
                        console.log('dead end configs: ');
                        const t = e.getDeadEndConfigs();
                        for (let e = 0; e < t.length; e++) {
                            const n = t[e];
                            let i = 'no edges';
                            if (n.state.transitions.length > 0) {
                                const e = n.state.transitions[0];
                                if (e instanceof AtomTransition) {
                                    i = 'Atom ' + this.getTokenName(e.label);
                                } else if (e instanceof S) {
                                    i = (e instanceof b ? '~' : '') + 'Set ' + e.set;
                                }
                            }
                            console.error(n.toString(this.parser, !0) + ':' + i);
                        }
                    }

                    noViableAlt(e, t, n, i) {
                        return new R(this.parser, e, e.get(i), e.LT(1), n, t);
                    }

                    getUniqueAlt(e) {
                        let t = s.INVALID_ALT_NUMBER;
                        for (let n = 0; n < e.items.length; n++) {
                            const i = e.items[n];
                            if (t === s.INVALID_ALT_NUMBER) {
                                t = i.alt;
                            } else if (i.alt !== t) {
                                return s.INVALID_ALT_NUMBER;
                            }
                        }
                        return t;
                    }

                    addDFAEdge(e, t, n, i) {
                        if (this.debug) {
                            console.log('EDGE ' + t + ' -> ' + i + ' upon ' + this.getTokenName(n));
                        }
                        if (null === i) {
                            return null;
                        }
                        i = this.addDFAState(e, i);
                        if (null === t || n < -1 || n > this.atn.maxTokenType) {
                            return i;
                        }
                        if (null === t.edges) {
                            t.edges = [];
                        }
                        t.edges[n + 1] = i;
                        if (this.debug) {
                            const t = null === this.parser ? null : this.parser.literalNames,
                                n = null === this.parser ? null : this.parser.symbolicNames;
                            console.log('DFA=\n' + e.toString(t, n));
                        }
                        return i;
                    }

                    addDFAState(e, t) {
                        if (t === g.ERROR) {
                            return t;
                        }
                        const n = e.states.get(t);
                        if (null !== n) {
                            return n;
                        }
                        t.stateNumber = e.states.length;
                        if (!t.configs.readOnly) {
                            t.configs.optimizeConfigs(this);
                            t.configs.setReadonly(!0);
                        }
                        e.states.add(t);
                        if (this.debug) {
                            console.log('adding new DFA state: ' + t);
                        }
                        return t;
                    }

                    reportAttemptingFullContext(e, t, n, i, a) {
                        if (this.debug || this.retry_debug) {
                            const t = new E(i, a + 1);
                            console.log(
                                'reportAttemptingFullContext decision=' +
                                    e.decision +
                                    ':' +
                                    n +
                                    ', input=' +
                                    this.parser.getTokenStream().getText(t),
                            );
                        }
                        if (null !== this.parser) {
                            this.parser
                                .getErrorListenerDispatch()
                                .reportAttemptingFullContext(this.parser, e, i, a, t, n);
                        }
                    }

                    reportContextSensitivity(e, t, n, i, a) {
                        if (this.debug || this.retry_debug) {
                            const t = new E(i, a + 1);
                            console.log(
                                'reportContextSensitivity decision=' +
                                    e.decision +
                                    ':' +
                                    n +
                                    ', input=' +
                                    this.parser.getTokenStream().getText(t),
                            );
                        }
                        if (null !== this.parser) {
                            this.parser.getErrorListenerDispatch().reportContextSensitivity(this.parser, e, i, a, t, n);
                        }
                    }

                    reportAmbiguity(e, t, n, i, a, o, r) {
                        if (this.debug || this.retry_debug) {
                            const e = new E(n, i + 1);
                            console.log(
                                'reportAmbiguity ' + o + ':' + r + ', input=' + this.parser.getTokenStream().getText(e),
                            );
                        }
                        if (null !== this.parser) {
                            this.parser.getErrorListenerDispatch().reportAmbiguity(this.parser, e, n, i, a, o, r);
                        }
                    }
                };
            },
            9098: function (e, t, n) {
                const { Map: i, BitSet: a, AltDict: o, hashStuff: r } = n(2373),
                    s = n(4471),
                    { RuleStopState: c } = n(2766),
                    { ATNConfigSet: l } = n(7329),
                    { ATNConfig: u } = n(5185),
                    { SemanticContext: d } = n(6389),
                    m = {
                        SLL: 0,
                        LL: 1,
                        LL_EXACT_AMBIG_DETECTION: 2,
                        hasSLLConflictTerminatingPrediction: function (e, t) {
                            if (m.allConfigsInRuleStopStates(t)) {
                                return !0;
                            }
                            if (e === m.SLL) {
                                if (t.hasSemanticContext) {
                                    const e = new l();
                                    for (let n = 0; n < t.items.length; n++) {
                                        let i = t.items[n];
                                        i = new u({ semanticContext: d.NONE }, i);
                                        e.add(i);
                                    }
                                    t = e;
                                }
                            }
                            const n = m.getConflictingAltSubsets(t);
                            return m.hasConflictingAltSet(n) && !m.hasStateAssociatedWithOneAlt(t);
                        },
                        hasConfigInRuleStopState: function (e) {
                            for (let t = 0; t < e.items.length; t++) {
                                if (e.items[t].state instanceof c) {
                                    return !0;
                                }
                            }
                            return !1;
                        },
                        allConfigsInRuleStopStates: function (e) {
                            for (let t = 0; t < e.items.length; t++) {
                                if (!(e.items[t].state instanceof c)) {
                                    return !1;
                                }
                            }
                            return !0;
                        },
                        resolvesToJustOneViableAlt: function (e) {
                            return m.getSingleViableAlt(e);
                        },
                        allSubsetsConflict: function (e) {
                            return !m.hasNonConflictingAltSet(e);
                        },
                        hasNonConflictingAltSet: function (e) {
                            for (let t = 0; t < e.length; t++) {
                                if (1 === e[t].length) {
                                    return !0;
                                }
                            }
                            return !1;
                        },
                        hasConflictingAltSet: function (e) {
                            for (let t = 0; t < e.length; t++) {
                                if (e[t].length > 1) {
                                    return !0;
                                }
                            }
                            return !1;
                        },
                        allSubsetsEqual: function (e) {
                            let t = null;
                            for (let n = 0; n < e.length; n++) {
                                const i = e[n];
                                if (null === t) {
                                    t = i;
                                } else if (i !== t) {
                                    return !1;
                                }
                            }
                            return !0;
                        },
                        getUniqueAlt: function (e) {
                            const t = m.getAlts(e);
                            if (1 === t.length) {
                                return t.minValue();
                            } else {
                                return s.INVALID_ALT_NUMBER;
                            }
                        },
                        getAlts: function (e) {
                            const t = new a();
                            e.map(function (e) {
                                t.or(e);
                            });
                            return t;
                        },
                        getConflictingAltSubsets: function (e) {
                            const t = new i();
                            t.hashFunction = function (e) {
                                r(e.state.stateNumber, e.context);
                            };
                            t.equalsFunction = function (e, t) {
                                return e.state.stateNumber === t.state.stateNumber && e.context.equals(t.context);
                            };
                            e.items.map(function (e) {
                                let n = t.get(e);
                                if (null === n) {
                                    n = new a();
                                    t.put(e, n);
                                }
                                n.add(e.alt);
                            });
                            return t.getValues();
                        },
                        getStateToAltMap: function (e) {
                            const t = new o();
                            e.items.map(function (e) {
                                let n = t.get(e.state);
                                if (null === n) {
                                    n = new a();
                                    t.put(e.state, n);
                                }
                                n.add(e.alt);
                            });
                            return t;
                        },
                        hasStateAssociatedWithOneAlt: function (e) {
                            const t = m.getStateToAltMap(e).values();
                            for (let e = 0; e < t.length; e++) {
                                if (1 === t[e].length) {
                                    return !0;
                                }
                            }
                            return !1;
                        },
                        getSingleViableAlt: function (e) {
                            let t = null;
                            for (let n = 0; n < e.length; n++) {
                                const i = e[n].minValue();
                                if (null === t) {
                                    t = i;
                                } else if (t !== i) {
                                    return s.INVALID_ALT_NUMBER;
                                }
                            }
                            return t;
                        },
                    };
                e.exports = m;
            },
            6389: function (e, t, n) {
                const { Set: i, Hash: a, equalArrays: o } = n(2373);

                class r {
                    hashCode() {
                        const e = new a();
                        this.updateHashCode(e);
                        return e.finish();
                    }

                    evaluate(e, t) {}

                    evalPrecedence(e, t) {
                        return this;
                    }

                    static andContext(e, t) {
                        if (null === e || e === r.NONE) {
                            return t;
                        }
                        if (null === t || t === r.NONE) {
                            return e;
                        }
                        const n = new l(e, t);
                        if (1 === n.opnds.length) {
                            return n.opnds[0];
                        } else {
                            return n;
                        }
                    }

                    static orContext(e, t) {
                        if (null === e) {
                            return t;
                        }
                        if (null === t) {
                            return e;
                        }
                        if (e === r.NONE || t === r.NONE) {
                            return r.NONE;
                        }
                        const n = new u(e, t);
                        if (1 === n.opnds.length) {
                            return n.opnds[0];
                        } else {
                            return n;
                        }
                    }
                }

                class s extends r {
                    constructor(e, t, n) {
                        super();
                        this.ruleIndex = void 0 === e ? -1 : e;
                        this.predIndex = void 0 === t ? -1 : t;
                        this.isCtxDependent = void 0 === n ? !1 : n;
                    }

                    evaluate(e, t) {
                        const n = this.isCtxDependent ? t : null;
                        return e.sempred(n, this.ruleIndex, this.predIndex);
                    }

                    updateHashCode(e) {
                        e.update(this.ruleIndex, this.predIndex, this.isCtxDependent);
                    }

                    equals(e) {
                        if (this === e) {
                            return !0;
                        } else if (!(e instanceof s)) {
                            return !1;
                        } else {
                            return (
                                this.ruleIndex === e.ruleIndex &&
                                this.predIndex === e.predIndex &&
                                this.isCtxDependent === e.isCtxDependent
                            );
                        }
                    }

                    toString() {
                        return '{' + this.ruleIndex + ':' + this.predIndex + '}?';
                    }
                }

                r.NONE = new s();

                class c extends r {
                    constructor(e) {
                        super();
                        this.precedence = void 0 === e ? 0 : e;
                    }

                    evaluate(e, t) {
                        return e.precpred(t, this.precedence);
                    }

                    evalPrecedence(e, t) {
                        if (e.precpred(t, this.precedence)) {
                            return r.NONE;
                        } else {
                            return null;
                        }
                    }

                    compareTo(e) {
                        return this.precedence - e.precedence;
                    }

                    updateHashCode(e) {
                        e.update(this.precedence);
                    }

                    equals(e) {
                        if (this === e) {
                            return !0;
                        } else if (!(e instanceof c)) {
                            return !1;
                        } else {
                            return this.precedence === e.precedence;
                        }
                    }

                    toString() {
                        return '{' + this.precedence + '>=prec}?';
                    }

                    static filterPrecedencePredicates(e) {
                        const t = [];
                        e.values().map(function (e) {
                            if (e instanceof c) {
                                t.push(e);
                            }
                        });
                        return t;
                    }
                }

                class l extends r {
                    constructor(e, t) {
                        super();
                        const n = new i();
                        if (e instanceof l) {
                            e.opnds.map(function (e) {
                                n.add(e);
                            });
                        } else {
                            n.add(e);
                        }
                        if (t instanceof l) {
                            t.opnds.map(function (e) {
                                n.add(e);
                            });
                        } else {
                            n.add(t);
                        }
                        const a = c.filterPrecedencePredicates(n);
                        if (a.length > 0) {
                            let e = null;
                            a.map(function (t) {
                                if (null === e || t.precedence < e.precedence) {
                                    e = t;
                                }
                            });
                            n.add(e);
                        }
                        this.opnds = Array.from(n.values());
                    }

                    equals(e) {
                        if (this === e) {
                            return !0;
                        } else if (!(e instanceof l)) {
                            return !1;
                        } else {
                            return o(this.opnds, e.opnds);
                        }
                    }

                    updateHashCode(e) {
                        e.update(this.opnds, 'AND');
                    }

                    evaluate(e, t) {
                        for (let n = 0; n < this.opnds.length; n++) {
                            if (!this.opnds[n].evaluate(e, t)) {
                                return !1;
                            }
                        }
                        return !0;
                    }

                    evalPrecedence(e, t) {
                        let n = !1;
                        const i = [];
                        for (let a = 0; a < this.opnds.length; a++) {
                            const o = this.opnds[a],
                                s = o.evalPrecedence(e, t);
                            n |= s !== o;
                            if (null === s) {
                                return null;
                            } else if (s !== r.NONE) {
                                i.push(s);
                            }
                        }
                        if (!n) {
                            return this;
                        }
                        if (0 === i.length) {
                            return r.NONE;
                        }
                        let a = null;
                        i.map(function (e) {
                            a = null === a ? e : r.andContext(a, e);
                        });
                        return a;
                    }

                    toString() {
                        const e = this.opnds.map(e => e.toString());
                        return (e.length > 3 ? e.slice(3) : e).join('&&');
                    }
                }

                class u extends r {
                    constructor(e, t) {
                        super();
                        const n = new i();
                        if (e instanceof u) {
                            e.opnds.map(function (e) {
                                n.add(e);
                            });
                        } else {
                            n.add(e);
                        }
                        if (t instanceof u) {
                            t.opnds.map(function (e) {
                                n.add(e);
                            });
                        } else {
                            n.add(t);
                        }
                        const a = c.filterPrecedencePredicates(n);
                        if (a.length > 0) {
                            const e = a.sort(function (e, t) {
                                    return e.compareTo(t);
                                }),
                                t = e[e.length - 1];
                            n.add(t);
                        }
                        this.opnds = Array.from(n.values());
                    }

                    equals(e) {
                        if (this === e) {
                            return !0;
                        } else if (!(e instanceof u)) {
                            return !1;
                        } else {
                            return o(this.opnds, e.opnds);
                        }
                    }

                    updateHashCode(e) {
                        e.update(this.opnds, 'OR');
                    }

                    evaluate(e, t) {
                        for (let n = 0; n < this.opnds.length; n++) {
                            if (this.opnds[n].evaluate(e, t)) {
                                return !0;
                            }
                        }
                        return !1;
                    }

                    evalPrecedence(e, t) {
                        let n = !1;
                        const i = [];
                        for (let a = 0; a < this.opnds.length; a++) {
                            const o = this.opnds[a],
                                s = o.evalPrecedence(e, t);
                            n |= s !== o;
                            if (s === r.NONE) {
                                return r.NONE;
                            } else if (null !== s) {
                                i.push(s);
                            }
                        }
                        if (!n) {
                            return this;
                        }
                        if (0 === i.length) {
                            return null;
                        }
                        const a = null;
                        i.map(function (e) {
                            return 1 ? e : r.orContext(a, e);
                        });
                        return a;
                    }

                    toString() {
                        const e = this.opnds.map(e => e.toString());
                        return (e.length > 3 ? e.slice(3) : e).join('||');
                    }
                }

                e.exports = { SemanticContext: r, PrecedencePredicate: c, Predicate: s };
            },
            5651: function (e, t, n) {
                const { Token: i } = n(5537),
                    { IntervalSet: a } = n(7059),
                    { Predicate: o, PrecedencePredicate: r } = n(6389);

                class s {
                    constructor(e) {
                        if (null == e) {
                            throw 'target cannot be null.';
                        }
                        this.target = e;
                        this.isEpsilon = !1;
                        this.label = null;
                    }
                }

                s.EPSILON = 1;
                s.RANGE = 2;
                s.RULE = 3;
                s.PREDICATE = 4;
                s.ATOM = 5;
                s.ACTION = 6;
                s.SET = 7;
                s.NOT_SET = 8;
                s.WILDCARD = 9;
                s.PRECEDENCE = 10;
                s.serializationNames = [
                    'INVALID',
                    'EPSILON',
                    'RANGE',
                    'RULE',
                    'PREDICATE',
                    'ATOM',
                    'ACTION',
                    'SET',
                    'NOT_SET',
                    'WILDCARD',
                    'PRECEDENCE',
                ];
                s.serializationTypes = {
                    EpsilonTransition: s.EPSILON,
                    RangeTransition: s.RANGE,
                    RuleTransition: s.RULE,
                    PredicateTransition: s.PREDICATE,
                    AtomTransition: s.ATOM,
                    ActionTransition: s.ACTION,
                    SetTransition: s.SET,
                    NotSetTransition: s.NOT_SET,
                    WildcardTransition: s.WILDCARD,
                    PrecedencePredicateTransition: s.PRECEDENCE,
                };

                class c extends s {
                    constructor(e) {
                        super(e);
                    }
                }

                class l extends s {
                    constructor(e, t) {
                        super(e);
                        this.serializationType = s.SET;
                        if (null != t) {
                            this.label = t;
                        } else {
                            this.label = new a();
                            this.label.addOne(i.INVALID_TYPE);
                        }
                    }

                    matches(e, t, n) {
                        return this.label.contains(e);
                    }

                    toString() {
                        return this.label.toString();
                    }
                }

                e.exports = {
                    Transition: s,
                    AtomTransition: class extends s {
                        constructor(e, t) {
                            super(e);
                            this.label_ = t;
                            this.label = this.makeLabel();
                            this.serializationType = s.ATOM;
                        }

                        makeLabel() {
                            const e = new a();
                            e.addOne(this.label_);
                            return e;
                        }

                        matches(e, t, n) {
                            return this.label_ === e;
                        }

                        toString() {
                            return this.label_;
                        }
                    },
                    SetTransition: l,
                    NotSetTransition: class extends l {
                        constructor(e, t) {
                            super(e, t);
                            this.serializationType = s.NOT_SET;
                        }

                        matches(e, t, n) {
                            return e >= t && e <= n && !super.matches(e, t, n);
                        }

                        toString() {
                            return '~' + super.toString();
                        }
                    },
                    RuleTransition: class extends s {
                        constructor(e, t, n, i) {
                            super(e);
                            this.ruleIndex = t;
                            this.precedence = n;
                            this.followState = i;
                            this.serializationType = s.RULE;
                            this.isEpsilon = !0;
                        }

                        matches(e, t, n) {
                            return !1;
                        }
                    },
                    ActionTransition: class extends s {
                        constructor(e, t, n, i) {
                            super(e);
                            this.serializationType = s.ACTION;
                            this.ruleIndex = t;
                            this.actionIndex = void 0 === n ? -1 : n;
                            this.isCtxDependent = void 0 === i ? !1 : i;
                            this.isEpsilon = !0;
                        }

                        matches(e, t, n) {
                            return !1;
                        }

                        toString() {
                            return 'action_' + this.ruleIndex + ':' + this.actionIndex;
                        }
                    },
                    EpsilonTransition: class extends s {
                        constructor(e, t) {
                            super(e);
                            this.serializationType = s.EPSILON;
                            this.isEpsilon = !0;
                            this.outermostPrecedenceReturn = t;
                        }

                        matches(e, t, n) {
                            return !1;
                        }

                        toString() {
                            return 'epsilon';
                        }
                    },
                    RangeTransition: class extends s {
                        constructor(e, t, n) {
                            super(e);
                            this.serializationType = s.RANGE;
                            this.start = t;
                            this.stop = n;
                            this.label = this.makeLabel();
                        }

                        makeLabel() {
                            const e = new a();
                            e.addRange(this.start, this.stop);
                            return e;
                        }

                        matches(e, t, n) {
                            return e >= this.start && e <= this.stop;
                        }

                        toString() {
                            return (
                                "'" + String.fromCharCode(this.start) + "'..'" + String.fromCharCode(this.stop) + "'"
                            );
                        }
                    },
                    WildcardTransition: class extends s {
                        constructor(e) {
                            super(e);
                            this.serializationType = s.WILDCARD;
                        }

                        matches(e, t, n) {
                            return e >= t && e <= n;
                        }

                        toString() {
                            return '.';
                        }
                    },
                    PredicateTransition: class extends c {
                        constructor(e, t, n, i) {
                            super(e);
                            this.serializationType = s.PREDICATE;
                            this.ruleIndex = t;
                            this.predIndex = n;
                            this.isCtxDependent = i;
                            this.isEpsilon = !0;
                        }

                        matches(e, t, n) {
                            return !1;
                        }

                        getPredicate() {
                            return new o(this.ruleIndex, this.predIndex, this.isCtxDependent);
                        }

                        toString() {
                            return 'pred_' + this.ruleIndex + ':' + this.predIndex;
                        }
                    },
                    PrecedencePredicateTransition: class extends c {
                        constructor(e, t) {
                            super(e);
                            this.serializationType = s.PRECEDENCE;
                            this.precedence = t;
                            this.isEpsilon = !0;
                        }

                        matches(e, t, n) {
                            return !1;
                        }

                        getPredicate() {
                            return new r(this.precedence);
                        }

                        toString() {
                            return this.precedence + ' >= _p';
                        }
                    },
                    AbstractPredicateTransition: c,
                };
            },
            9642: function (e, t, n) {
                t.ATN = n(4471);
                t.ATNDeserializer = n(6220);
                t.LexerATNSimulator = n(5849);
                t.ParserATNSimulator = n(2006);
                t.PredictionMode = n(9098);
            },
            8399: function (e, t, n) {
                const { Set: i } = n(2373),
                    { DFAState: a } = n(2982),
                    { StarLoopEntryState: o } = n(2766),
                    { ATNConfigSet: r } = n(7329),
                    { DFASerializer: s } = n(4139),
                    { LexerDFASerializer: c } = n(4139);
                e.exports = class {
                    constructor(e, t) {
                        if (void 0 === t) {
                            t = 0;
                        }
                        this.atnStartState = e;
                        this.decision = t;
                        this._states = new i();
                        this.s0 = null;
                        this.precedenceDfa = !1;
                        if (e instanceof o) {
                            if (e.isPrecedenceDecision) {
                                this.precedenceDfa = !0;
                                const e = new a(null, new r());
                                e.edges = [];
                                e.isAcceptState = !1;
                                e.requiresFullContext = !1;
                                this.s0 = e;
                            }
                        }
                    }

                    getPrecedenceStartState(e) {
                        if (!this.precedenceDfa) {
                            throw 'Only precedence DFAs may contain a precedence start state.';
                        }
                        if (e < 0 || e >= this.s0.edges.length) {
                            return null;
                        } else {
                            return this.s0.edges[e] || null;
                        }
                    }

                    setPrecedenceStartState(e, t) {
                        if (!this.precedenceDfa) {
                            throw 'Only precedence DFAs may contain a precedence start state.';
                        }
                        if (!(e < 0)) {
                            this.s0.edges[e] = t;
                        }
                    }

                    setPrecedenceDfa(e) {
                        if (this.precedenceDfa !== e) {
                            this._states = new i();
                            if (e) {
                                const e = new a(null, new r());
                                e.edges = [];
                                e.isAcceptState = !1;
                                e.requiresFullContext = !1;
                                this.s0 = e;
                            } else {
                                this.s0 = null;
                            }
                            this.precedenceDfa = e;
                        }
                    }

                    sortedStates() {
                        return this._states.values().sort(function (e, t) {
                            return e.stateNumber - t.stateNumber;
                        });
                    }

                    toString(e, t) {
                        e = e || null;
                        t = t || null;
                        if (null === this.s0) {
                            return '';
                        }
                        return new s(this, e, t).toString();
                    }

                    toLexerString() {
                        if (null === this.s0) {
                            return '';
                        }
                        return new c(this).toString();
                    }

                    get states() {
                        return this._states;
                    }
                };
            },
            4139: function (e, t, n) {
                const i = n(2373);

                class a {
                    constructor(e, t, n) {
                        this.dfa = e;
                        this.literalNames = t || [];
                        this.symbolicNames = n || [];
                    }

                    toString() {
                        if (null === this.dfa.s0) {
                            return null;
                        }
                        let e = '';
                        const t = this.dfa.sortedStates();
                        for (let n = 0; n < t.length; n++) {
                            const i = t[n];
                            if (null !== i.edges) {
                                const t = i.edges.length;
                                for (let n = 0; n < t; n++) {
                                    const t = i.edges[n] || null;
                                    if (null !== t && 2147483647 !== t.stateNumber) {
                                        e = e.concat(this.getStateString(i));
                                        e = e.concat('-');
                                        e = e.concat(this.getEdgeLabel(n));
                                        e = e.concat('->');
                                        e = e.concat(this.getStateString(t));
                                        e = e.concat('\n');
                                    }
                                }
                            }
                        }
                        return 0 === e.length ? null : e;
                    }

                    getEdgeLabel(e) {
                        if (0 === e) {
                            return 'EOF';
                        } else if (null !== this.literalNames || null !== this.symbolicNames) {
                            return this.literalNames[e - 1] || this.symbolicNames[e - 1];
                        } else {
                            return String.fromCharCode(e - 1);
                        }
                    }

                    getStateString(e) {
                        const t =
                            (e.isAcceptState ? ':' : '') + 's' + e.stateNumber + (e.requiresFullContext ? '^' : '');
                        if (e.isAcceptState) {
                            if (null !== e.predicates) {
                                return t + '=>' + i.arrayToString(e.predicates);
                            } else {
                                return t + '=>' + e.prediction.toString();
                            }
                        } else {
                            return t;
                        }
                    }
                }

                e.exports = {
                    DFASerializer: a,
                    LexerDFASerializer: class extends a {
                        constructor(e) {
                            super(e, null);
                        }

                        getEdgeLabel(e) {
                            return "'" + String.fromCharCode(e) + "'";
                        }
                    },
                };
            },
            2982: function (e, t, n) {
                const { ATNConfigSet: i } = n(7329),
                    { Hash: a, Set: o } = n(2373);

                class r {
                    constructor(e, t) {
                        if (null === e) {
                            e = -1;
                        }
                        if (null === t) {
                            t = new i();
                        }
                        this.stateNumber = e;
                        this.configs = t;
                        this.edges = null;
                        this.isAcceptState = !1;
                        this.prediction = 0;
                        this.lexerActionExecutor = null;
                        this.requiresFullContext = !1;
                        this.predicates = null;
                        return this;
                    }

                    getAltSet() {
                        const e = new o();
                        if (null !== this.configs) {
                            for (let t = 0; t < this.configs.length; t++) {
                                const n = this.configs[t];
                                e.add(n.alt);
                            }
                        }
                        if (0 === e.length) {
                            return null;
                        } else {
                            return e;
                        }
                    }

                    equals(e) {
                        return this === e || (e instanceof r && this.configs.equals(e.configs));
                    }

                    toString() {
                        let e = this.stateNumber + ':' + this.configs;
                        if (this.isAcceptState) {
                            e += '=>';
                            if (null !== this.predicates) {
                                e += this.predicates;
                            } else {
                                e += this.prediction;
                            }
                        }
                        return e;
                    }

                    hashCode() {
                        const e = new a();
                        e.update(this.configs);
                        return e.finish();
                    }
                }

                e.exports = {
                    DFAState: r,
                    PredPrediction: class {
                        constructor(e, t) {
                            this.alt = t;
                            this.pred = e;
                        }

                        toString() {
                            return '(' + this.pred + ', ' + this.alt + ')';
                        }
                    },
                };
            },
            6098: function (e, t, n) {
                t.DFA = n(8399);
                t.DFASerializer = n(4139).DFASerializer;
                t.LexerDFASerializer = n(4139).LexerDFASerializer;
                t.PredPrediction = n(2982).PredPrediction;
            },
            1602: function (e, t, n) {
                const { BitSet: i } = n(2373),
                    { ErrorListener: a } = n(6207),
                    { Interval: o } = n(7059);
                e.exports = class extends a {
                    constructor(e) {
                        super();
                        e = e || !0;
                        this.exactOnly = e;
                    }

                    reportAmbiguity(e, t, n, i, a, r, s) {
                        if (this.exactOnly && !a) {
                            return;
                        }
                        const c =
                            'reportAmbiguity d=' +
                            this.getDecisionDescription(e, t) +
                            ': ambigAlts=' +
                            this.getConflictingAlts(r, s) +
                            ", input='" +
                            e.getTokenStream().getText(new o(n, i)) +
                            "'";
                        e.notifyErrorListeners(c);
                    }

                    reportAttemptingFullContext(e, t, n, i, a, r) {
                        const s =
                            'reportAttemptingFullContext d=' +
                            this.getDecisionDescription(e, t) +
                            ", input='" +
                            e.getTokenStream().getText(new o(n, i)) +
                            "'";
                        e.notifyErrorListeners(s);
                    }

                    reportContextSensitivity(e, t, n, i, a, r) {
                        const s =
                            'reportContextSensitivity d=' +
                            this.getDecisionDescription(e, t) +
                            ", input='" +
                            e.getTokenStream().getText(new o(n, i)) +
                            "'";
                        e.notifyErrorListeners(s);
                    }

                    getDecisionDescription(e, t) {
                        const n = t.decision,
                            i = t.atnStartState.ruleIndex,
                            a = e.ruleNames;
                        if (i < 0 || i >= a.length) {
                            return '' + n;
                        }
                        const o = a[i] || null;
                        if (null === o || 0 === o.length) {
                            return '' + n;
                        } else {
                            return `${n} (${o})`;
                        }
                    }

                    getConflictingAlts(e, t) {
                        if (null !== e) {
                            return e;
                        }
                        const n = new i();
                        for (let e = 0; e < t.items.length; e++) {
                            n.add(t.items[e].alt);
                        }
                        return `{${n.values().join(', ')}}`;
                    }
                };
            },
            6207: function (e) {
                class t {
                    syntaxError(e, t, n, i, a, o) {}

                    reportAmbiguity(e, t, n, i, a, o, r) {}

                    reportAttemptingFullContext(e, t, n, i, a, o) {}

                    reportContextSensitivity(e, t, n, i, a, o) {}
                }

                class n extends t {
                    constructor() {
                        super();
                    }

                    syntaxError(e, t, n, i, a, o) {
                        console.error('line ' + n + ':' + i + ' ' + a);
                    }
                }

                n.INSTANCE = new n();
                e.exports = {
                    ErrorListener: t,
                    ConsoleErrorListener: n,
                    ProxyErrorListener: class extends t {
                        constructor(e) {
                            super();
                            if (null === e) {
                                throw 'delegates';
                            }
                            this.delegates = e;
                            return this;
                        }

                        syntaxError(e, t, n, i, a, o) {
                            this.delegates.map(r => r.syntaxError(e, t, n, i, a, o));
                        }

                        reportAmbiguity(e, t, n, i, a, o, r) {
                            this.delegates.map(s => s.reportAmbiguity(e, t, n, i, a, o, r));
                        }

                        reportAttemptingFullContext(e, t, n, i, a, o) {
                            this.delegates.map(r => r.reportAttemptingFullContext(e, t, n, i, a, o));
                        }

                        reportContextSensitivity(e, t, n, i, a, o) {
                            this.delegates.map(r => r.reportContextSensitivity(e, t, n, i, a, o));
                        }
                    },
                };
            },
            422: function (e, t, n) {
                const { Token: i } = n(5537),
                    {
                        NoViableAltException: a,
                        InputMismatchException: o,
                        FailedPredicateException: r,
                        ParseCancellationException: s,
                    } = n(586),
                    { ATNState: c } = n(2766),
                    { Interval: l, IntervalSet: u } = n(7059);

                class d {
                    reset(e) {}

                    recoverInline(e) {}

                    recover(e, t) {}

                    sync(e) {}

                    inErrorRecoveryMode(e) {}

                    reportError(e) {}
                }

                class m extends d {
                    constructor() {
                        super();
                        this.errorRecoveryMode = !1;
                        this.lastErrorIndex = -1;
                        this.lastErrorStates = null;
                        this.nextTokensContext = null;
                        this.nextTokenState = 0;
                    }

                    reset(e) {
                        this.endErrorCondition(e);
                    }

                    beginErrorCondition(e) {
                        this.errorRecoveryMode = !0;
                    }

                    inErrorRecoveryMode(e) {
                        return this.errorRecoveryMode;
                    }

                    endErrorCondition(e) {
                        this.errorRecoveryMode = !1;
                        this.lastErrorStates = null;
                        this.lastErrorIndex = -1;
                    }

                    reportMatch(e) {
                        this.endErrorCondition(e);
                    }

                    reportError(e, t) {
                        if (!this.inErrorRecoveryMode(e)) {
                            this.beginErrorCondition(e);
                            if (t instanceof a) {
                                this.reportNoViableAlternative(e, t);
                            } else if (t instanceof o) {
                                this.reportInputMismatch(e, t);
                            } else if (t instanceof r) {
                                this.reportFailedPredicate(e, t);
                            } else {
                                console.log('unknown recognition error type: ' + t.constructor.name);
                                console.log(t.stack);
                                e.notifyErrorListeners(t.getOffendingToken(), t.getMessage(), t);
                            }
                        }
                    }

                    recover(e, t) {
                        if (
                            this.lastErrorIndex === e.getInputStream().index &&
                            null !== this.lastErrorStates &&
                            this.lastErrorStates.indexOf(e.state) >= 0
                        ) {
                            e.consume();
                        }
                        this.lastErrorIndex = e._input.index;
                        if (null === this.lastErrorStates) {
                            this.lastErrorStates = [];
                        }
                        this.lastErrorStates.push(e.state);
                        const n = this.getErrorRecoverySet(e);
                        this.consumeUntil(e, n);
                    }

                    sync(e) {
                        if (this.inErrorRecoveryMode(e)) {
                            return;
                        }
                        const t = e._interp.atn.states[e.state],
                            n = e.getTokenStream().LA(1),
                            a = e.atn.nextTokens(t);
                        if (!a.contains(n)) {
                            if (a.contains(i.EPSILON)) {
                                if (null === this.nextTokensContext) {
                                    this.nextTokensContext = e._ctx;
                                    this.nextTokensState = e._stateNumber;
                                }
                                return;
                            }
                            switch (t.stateType) {
                                case c.BLOCK_START:
                                case c.STAR_BLOCK_START:
                                case c.PLUS_BLOCK_START:
                                case c.STAR_LOOP_ENTRY:
                                    if (null !== this.singleTokenDeletion(e)) {
                                        return;
                                    } else {
                                        throw new o(e);
                                    }
                                case c.PLUS_LOOP_BACK:
                                case c.STAR_LOOP_BACK:
                                    this.reportUnwantedToken(e);
                                    const t = new u();
                                    t.addSet(e.getExpectedTokens());
                                    const n = t.addSet(this.getErrorRecoverySet(e));
                                    this.consumeUntil(e, n);
                            }
                        } else {
                            this.nextTokensContext = null;
                            this.nextTokenState = c.INVALID_STATE_NUMBER;
                        }
                    }

                    reportNoViableAlternative(e, t) {
                        const n = e.getTokenStream();
                        let a;
                        if (null !== n) {
                            if (t.startToken.type === i.EOF) {
                                a = '<EOF>';
                            } else {
                                a = n.getText(new l(t.startToken.tokenIndex, t.offendingToken.tokenIndex));
                            }
                        } else {
                            a = '<unknown input>';
                        }
                        const o = 'no viable alternative at input ' + this.escapeWSAndQuote(a);
                        e.notifyErrorListeners(o, t.offendingToken, t);
                    }

                    reportInputMismatch(e, t) {
                        const n =
                            'mismatched input ' +
                            this.getTokenErrorDisplay(t.offendingToken) +
                            ' expecting ' +
                            t.getExpectedTokens().toString(e.literalNames, e.symbolicNames);
                        e.notifyErrorListeners(n, t.offendingToken, t);
                    }

                    reportFailedPredicate(e, t) {
                        const n = 'rule ' + e.ruleNames[e._ctx.ruleIndex] + ' ' + t.message;
                        e.notifyErrorListeners(n, t.offendingToken, t);
                    }

                    reportUnwantedToken(e) {
                        if (this.inErrorRecoveryMode(e)) {
                            return;
                        }
                        this.beginErrorCondition(e);
                        const t = e.getCurrentToken(),
                            n =
                                'extraneous input ' +
                                this.getTokenErrorDisplay(t) +
                                ' expecting ' +
                                this.getExpectedTokens(e).toString(e.literalNames, e.symbolicNames);
                        e.notifyErrorListeners(n, t, null);
                    }

                    reportMissingToken(e) {
                        if (this.inErrorRecoveryMode(e)) {
                            return;
                        }
                        this.beginErrorCondition(e);
                        const t = e.getCurrentToken(),
                            n =
                                'missing ' +
                                this.getExpectedTokens(e).toString(e.literalNames, e.symbolicNames) +
                                ' at ' +
                                this.getTokenErrorDisplay(t);
                        e.notifyErrorListeners(n, t, null);
                    }

                    recoverInline(e) {
                        const t = this.singleTokenDeletion(e);
                        if (null !== t) {
                            e.consume();
                            return t;
                        }
                        if (this.singleTokenInsertion(e)) {
                            return this.getMissingSymbol(e);
                        }
                        throw new o(e);
                    }

                    singleTokenInsertion(e) {
                        const t = e.getTokenStream().LA(1),
                            n = e._interp.atn,
                            i = n.states[e.state].transitions[0].target;
                        if (n.nextTokens(i, e._ctx).contains(t)) {
                            this.reportMissingToken(e);
                            return !0;
                        } else {
                            return !1;
                        }
                    }

                    singleTokenDeletion(e) {
                        const t = e.getTokenStream().LA(2);
                        if (this.getExpectedTokens(e).contains(t)) {
                            this.reportUnwantedToken(e);
                            e.consume();
                            const t = e.getCurrentToken();
                            this.reportMatch(e);
                            return t;
                        } else {
                            return null;
                        }
                    }

                    getMissingSymbol(e) {
                        const t = e.getCurrentToken(),
                            n = this.getExpectedTokens(e).first();
                        let a;
                        if (n === i.EOF) {
                            a = '<missing EOF>';
                        } else {
                            a = '<missing ' + e.literalNames[n] + '>';
                        }
                        let o = t;
                        const r = e.getTokenStream().LT(-1);
                        if (o.type === i.EOF && null !== r) {
                            o = r;
                        }
                        return e.getTokenFactory().create(o.source, n, a, i.DEFAULT_CHANNEL, -1, -1, o.line, o.column);
                    }

                    getExpectedTokens(e) {
                        return e.getExpectedTokens();
                    }

                    getTokenErrorDisplay(e) {
                        if (null === e) {
                            return '<no token>';
                        }
                        let t = e.text;
                        if (null === t) {
                            if (e.type === i.EOF) {
                                t = '<EOF>';
                            } else {
                                t = '<' + e.type + '>';
                            }
                        }
                        return this.escapeWSAndQuote(t);
                    }

                    escapeWSAndQuote(e) {
                        return (
                            "'" +
                            (e = (e = (e = e.replace(/\n/g, '\\n')).replace(/\r/g, '\\r')).replace(/\t/g, '\\t')) +
                            "'"
                        );
                    }

                    getErrorRecoverySet(e) {
                        const t = e._interp.atn;
                        let n = e._ctx;
                        const a = new u();
                        for (; null !== n && n.invokingState >= 0; ) {
                            const e = t.states[n.invokingState].transitions[0],
                                i = t.nextTokens(e.followState);
                            a.addSet(i);
                            n = n.parentCtx;
                        }
                        a.removeOne(i.EPSILON);
                        return a;
                    }

                    consumeUntil(e, t) {
                        let n = e.getTokenStream().LA(1);
                        for (; n !== i.EOF && !t.contains(n); ) {
                            e.consume();
                            n = e.getTokenStream().LA(1);
                        }
                    }
                }

                e.exports = {
                    BailErrorStrategy: class extends m {
                        constructor() {
                            super();
                        }

                        recover(e, t) {
                            let n = e._ctx;
                            for (; null !== n; ) {
                                n.exception = t;
                                n = n.parentCtx;
                            }
                            throw new s(t);
                        }

                        recoverInline(e) {
                            this.recover(e, new o(e));
                        }

                        sync(e) {}
                    },
                    DefaultErrorStrategy: m,
                };
            },
            586: function (e, t, n) {
                const { PredicateTransition: i } = n(5651),
                    { Interval: a } = n(7059).Interval;

                class o extends Error {
                    constructor(e) {
                        super(e.message);
                        if (Error.captureStackTrace) {
                            Error.captureStackTrace(this, o);
                        } else {
                            new Error().stack;
                        }
                        this.message = e.message;
                        this.recognizer = e.recognizer;
                        this.input = e.input;
                        this.ctx = e.ctx;
                        this.offendingToken = null;
                        this.offendingState = -1;
                        if (null !== this.recognizer) {
                            this.offendingState = this.recognizer.state;
                        }
                    }

                    getExpectedTokens() {
                        if (null !== this.recognizer) {
                            return this.recognizer.atn.getExpectedTokens(this.offendingState, this.ctx);
                        } else {
                            return null;
                        }
                    }

                    toString() {
                        return this.message;
                    }
                }

                function r(e, t) {
                    if (null !== t) {
                        return t;
                    } else {
                        return 'failed predicate: {' + e + '}?';
                    }
                }

                class s extends Error {
                    constructor() {
                        super();
                        Error.captureStackTrace(this, s);
                    }
                }

                e.exports = {
                    RecognitionException: o,
                    NoViableAltException: class extends o {
                        constructor(e, t, n, i, a, o) {
                            o = o || e._ctx;
                            i = i || e.getCurrentToken();
                            n = n || e.getCurrentToken();
                            t = t || e.getInputStream();
                            super({ message: '', recognizer: e, input: t, ctx: o });
                            this.deadEndConfigs = a;
                            this.startToken = n;
                            this.offendingToken = i;
                        }
                    },
                    LexerNoViableAltException: class extends o {
                        constructor(e, t, n, i) {
                            super({ message: '', recognizer: e, input: t, ctx: null });
                            this.startIndex = n;
                            this.deadEndConfigs = i;
                        }

                        toString() {
                            let e = '';
                            if (this.startIndex >= 0 && this.startIndex < this.input.size) {
                                e = this.input.getText(new a(this.startIndex, this.startIndex));
                            }
                            return 'LexerNoViableAltException' + e;
                        }
                    },
                    InputMismatchException: class extends o {
                        constructor(e) {
                            super({ message: '', recognizer: e, input: e.getInputStream(), ctx: e._ctx });
                            this.offendingToken = e.getCurrentToken();
                        }
                    },
                    FailedPredicateException: class extends o {
                        constructor(e, t, n) {
                            super({ message: r(t, n || null), recognizer: e, input: e.getInputStream(), ctx: e._ctx });
                            const a = e._interp.atn.states[e.state].transitions[0];
                            if (a instanceof i) {
                                this.ruleIndex = a.ruleIndex;
                                this.predicateIndex = a.predIndex;
                            } else {
                                this.ruleIndex = 0;
                                this.predicateIndex = 0;
                            }
                            this.predicate = t;
                            this.offendingToken = e.getCurrentToken();
                        }
                    },
                    ParseCancellationException: s,
                };
            },
            9365: function (e, t, n) {
                e.exports.RecognitionException = n(586).RecognitionException;
                e.exports.NoViableAltException = n(586).NoViableAltException;
                e.exports.LexerNoViableAltException = n(586).LexerNoViableAltException;
                e.exports.InputMismatchException = n(586).InputMismatchException;
                e.exports.FailedPredicateException = n(586).FailedPredicateException;
                e.exports.DiagnosticErrorListener = n(1602);
                e.exports.BailErrorStrategy = n(422).BailErrorStrategy;
                e.exports.DefaultErrorStrategy = n(422).DefaultErrorStrategy;
                e.exports.ErrorListener = n(6207).ErrorListener;
            },
            7767: function () {
                if (!String.prototype.codePointAt) {
                    !(function () {
                        'use strict';
                        var e = (function () {
                            let e;
                            try {
                                const t = {},
                                    n = Object.defineProperty;
                                e = n(t, t, t) && n;
                            } catch (e) {}
                            return e;
                        })();
                        const t = function (e) {
                            if (null == this) {
                                throw TypeError();
                            }
                            const t = String(this),
                                n = t.length;
                            let i = e ? Number(e) : 0;
                            if (i != i) {
                                i = 0;
                            }
                            if (i < 0 || i >= n) {
                                return;
                            }
                            const a = t.charCodeAt(i);
                            let o;
                            if (a >= 55296 && a <= 56319 && n > i + 1) {
                                o = t.charCodeAt(i + 1);
                                if (o >= 56320 && o <= 57343) {
                                    return 1024 * (a - 55296) + o - 56320 + 65536;
                                }
                            }
                            return a;
                        };
                        if (e) {
                            e(String.prototype, 'codePointAt', { value: t, configurable: !0, writable: !0 });
                        } else {
                            String.prototype.codePointAt = t;
                        }
                    })();
                }
            },
            7838: function () {
                if (!String.fromCodePoint) {
                    !(function () {
                        const e = (function () {
                                let e;
                                try {
                                    const t = {},
                                        n = Object.defineProperty;
                                    e = n(t, t, t) && n;
                                } catch (e) {}
                                return e;
                            })(),
                            t = String.fromCharCode,
                            n = Math.floor,
                            i = function (e) {
                                const i = [];
                                let a,
                                    o,
                                    r = -1;
                                const s = arguments.length;
                                if (!s) {
                                    return '';
                                }
                                let c = '';
                                for (; ++r < s; ) {
                                    let e = Number(arguments[r]);
                                    if (!isFinite(e) || e < 0 || e > 1114111 || n(e) !== e) {
                                        throw RangeError('Invalid code point: ' + e);
                                    }
                                    if (e <= 65535) {
                                        i.push(e);
                                    } else {
                                        e -= 65536;
                                        a = 55296 + (e >> 10);
                                        o = (e % 1024) + 56320;
                                        i.push(a, o);
                                    }
                                    if (r + 1 === s || i.length > 16384) {
                                        c += t.apply(null, i);
                                        i.length = 0;
                                    }
                                }
                                return c;
                            };
                        if (e) {
                            e(String, 'fromCodePoint', { value: i, configurable: !0, writable: !0 });
                        } else {
                            String.fromCodePoint = i;
                        }
                    })();
                }
            },
            5489: function (e, t, n) {
                const { Token: i } = n(5537),
                    { Interval: a } = n(7059),
                    o = new a(-1, -2);

                class r {}

                class s extends r {
                    constructor() {
                        super();
                    }
                }

                class c extends s {
                    constructor() {
                        super();
                    }
                }

                class l extends c {
                    constructor() {
                        super();
                    }
                }

                class u extends l {
                    constructor() {
                        super();
                    }
                }

                class d extends l {
                    constructor(e) {
                        super();
                        this.parentCtx = null;
                        this.symbol = e;
                    }

                    getChild(e) {
                        return null;
                    }

                    getSymbol() {
                        return this.symbol;
                    }

                    getParent() {
                        return this.parentCtx;
                    }

                    getPayload() {
                        return this.symbol;
                    }

                    getSourceInterval() {
                        if (null === this.symbol) {
                            return o;
                        }
                        const e = this.symbol.tokenIndex;
                        return new a(e, e);
                    }

                    getChildCount() {
                        return 0;
                    }

                    accept(e) {
                        return e.visitTerminal(this);
                    }

                    getText() {
                        return this.symbol.text;
                    }

                    toString() {
                        if (this.symbol.type === i.EOF) {
                            return '<EOF>';
                        } else {
                            return this.symbol.text;
                        }
                    }
                }

                class m {
                    walk(e, t) {
                        if (t instanceof u || (void 0 !== t.isErrorNode && t.isErrorNode())) {
                            e.visitErrorNode(t);
                        } else if (t instanceof l) {
                            e.visitTerminal(t);
                        } else {
                            this.enterRule(e, t);
                            for (let n = 0; n < t.getChildCount(); n++) {
                                const i = t.getChild(n);
                                this.walk(e, i);
                            }
                            this.exitRule(e, t);
                        }
                    }

                    enterRule(e, t) {
                        const n = t.getRuleContext();
                        e.enterEveryRule(n);
                        n.enterRule(e);
                    }

                    exitRule(e, t) {
                        const n = t.getRuleContext();
                        n.exitRule(e);
                        e.exitEveryRule(n);
                    }
                }

                m.DEFAULT = new m();
                e.exports = {
                    RuleNode: class extends c {
                        constructor() {
                            super();
                        }

                        getRuleContext() {
                            throw new Error('missing interface implementation');
                        }
                    },
                    ErrorNode: u,
                    TerminalNode: l,
                    ErrorNodeImpl: class extends d {
                        constructor(e) {
                            super(e);
                        }

                        isErrorNode() {
                            return !0;
                        }

                        accept(e) {
                            return e.visitErrorNode(this);
                        }
                    },
                    TerminalNodeImpl: d,
                    ParseTreeListener: class {
                        visitTerminal(e) {}

                        visitErrorNode(e) {}

                        enterEveryRule(e) {}

                        exitEveryRule(e) {}
                    },
                    ParseTreeVisitor: class {
                        visit(e) {
                            if (Array.isArray(e)) {
                                return e.map(function (e) {
                                    return e.accept(this);
                                }, this);
                            } else {
                                return e.accept(this);
                            }
                        }

                        visitChildren(e) {
                            if (e.children) {
                                return this.visit(e.children);
                            } else {
                                return null;
                            }
                        }

                        visitTerminal(e) {}

                        visitErrorNode(e) {}
                    },
                    ParseTreeWalker: m,
                    INVALID_INTERVAL: o,
                };
            },
            164: function (e, t, n) {
                const i = n(2373),
                    { Token: a } = n(5537),
                    { ErrorNode: o, TerminalNode: r, RuleNode: s } = n(5489),
                    c = {
                        toStringTree: function (e, t, n) {
                            t = t || null;
                            if (null !== (n = n || null)) {
                                t = n.ruleNames;
                            }
                            let a = c.getNodeText(e, t);
                            a = i.escapeWhitespace(a, !1);
                            const o = e.getChildCount();
                            if (0 === o) {
                                return a;
                            }
                            let r = '(' + a + ' ';
                            if (o > 0) {
                                a = c.toStringTree(e.getChild(0), t);
                                r = r.concat(a);
                            }
                            for (let n = 1; n < o; n++) {
                                a = c.toStringTree(e.getChild(n), t);
                                r = r.concat(' ' + a);
                            }
                            r = r.concat(')');
                            return r;
                        },
                        getNodeText: function (e, t, n) {
                            t = t || null;
                            if (null !== (n = n || null)) {
                                t = n.ruleNames;
                            }
                            if (null !== t) {
                                if (e instanceof s) {
                                    const n = e.getRuleContext().getAltNumber();
                                    if (0 != n) {
                                        return t[e.ruleIndex] + ':' + n;
                                    } else {
                                        return t[e.ruleIndex];
                                    }
                                } else if (e instanceof o) {
                                    return e.toString();
                                } else if (e instanceof r) {
                                    if (null !== e.symbol) {
                                        return e.symbol.text;
                                    }
                                }
                            }
                            const i = e.getPayload();
                            if (i instanceof a) {
                                return i.text;
                            } else {
                                return e.getPayload().toString();
                            }
                        },
                        getChildren: function (e) {
                            const t = [];
                            for (let n = 0; n < e.getChildCount(); n++) {
                                t.push(e.getChild(n));
                            }
                            return t;
                        },
                        getAncestors: function (e) {
                            let t = [];
                            e = e.getParent();
                            for (; null !== e; ) {
                                t = [e].concat(t);
                                e = e.getParent();
                            }
                            return t;
                        },
                        findAllTokenNodes: function (e, t) {
                            return c.findAllNodes(e, t, !0);
                        },
                        findAllRuleNodes: function (e, t) {
                            return c.findAllNodes(e, t, !1);
                        },
                        findAllNodes: function (e, t, n) {
                            const i = [];
                            c._findAllNodes(e, t, n, i);
                            return i;
                        },
                        _findAllNodes: function (e, t, n, i) {
                            if (n && e instanceof r) {
                                if (e.symbol.type === t) {
                                    i.push(e);
                                }
                            } else if (!n && e instanceof s) {
                                if (e.ruleIndex === t) {
                                    i.push(e);
                                }
                            }
                            for (let a = 0; a < e.getChildCount(); a++) {
                                c._findAllNodes(e.getChild(a), t, n, i);
                            }
                        },
                        descendants: function (e) {
                            let t = [e];
                            for (let n = 0; n < e.getChildCount(); n++) {
                                t = t.concat(c.descendants(e.getChild(n)));
                            }
                            return t;
                        },
                    };
                e.exports = c;
            },
            2625: function (e, t, n) {
                const i = n(5489),
                    a = n(164);
                e.exports = { ...i, Trees: a };
            },
            1066: function (e, t, n) {
                'use strict';
                var i = n(2264)('ArrayBuffer.prototype.byteLength', !0),
                    a = n(6445);
                e.exports = function (e) {
                    if (!a(e)) {
                        return NaN;
                    } else {
                        return i ? i(e) : e.byteLength;
                    }
                };
            },
            2264: function (e, t, n) {
                'use strict';
                var i = n(9718),
                    a = n(2756),
                    o = a(i('String.prototype.indexOf'));
                e.exports = function (e, t) {
                    var n = i(e, !!t);
                    if ('function' == typeof n && o(e, '.prototype.') > -1) {
                        return a(n);
                    } else {
                        return n;
                    }
                };
            },
            2756: function (e, t, n) {
                'use strict';
                var i = n(9932),
                    a = n(9718),
                    o = n(6930),
                    r = n(4114),
                    s = a('%Function.prototype.apply%'),
                    c = a('%Function.prototype.call%'),
                    l = a('%Reflect.apply%', !0) || i.call(c, s),
                    u = n(70),
                    d = a('%Math.max%');
                e.exports = function (e) {
                    if ('function' != typeof e) {
                        throw new r('a function is required');
                    }
                    var t = l(i, c, arguments);
                    return o(t, 1 + d(0, e.length - (arguments.length - 1)), !0);
                };
                var m = function () {
                    return l(i, s, arguments);
                };
                if (u) {
                    u(e.exports, 'apply', { value: m });
                } else {
                    e.exports.apply = m;
                }
            },
            6795: function (e, t, n) {
                'use strict';
                var i = n(1274),
                    a = n(2264),
                    o = n(1188),
                    r = n(9718),
                    s = n(2889),
                    c = n(1233),
                    l = n(3354),
                    u = n(3929),
                    d = n(3169),
                    m = n(6445),
                    p = n(5661),
                    f = n(78),
                    g = n(3187),
                    h = n(9722),
                    y = n(1524),
                    x = n(6244),
                    _ = n(4912),
                    E = n(1066),
                    C = a('SharedArrayBuffer.prototype.byteLength', !0),
                    S = a('Date.prototype.getTime'),
                    b = Object.getPrototypeOf,
                    v = a('Object.prototype.toString'),
                    D = r('%Set%', !0),
                    R = a('Map.prototype.has', !0),
                    M = a('Map.prototype.get', !0),
                    T = a('Map.prototype.size', !0),
                    k = a('Set.prototype.add', !0),
                    I = a('Set.prototype.delete', !0),
                    P = a('Set.prototype.has', !0),
                    L = a('Set.prototype.size', !0);

                function A(e, t, n, i) {
                    for (var a, o = s(e); (a = o.next()) && !a.done; ) {
                        if (N(t, a.value, n, i)) {
                            I(e, a.value);
                            return !0;
                        }
                    }
                    return !1;
                }

                function w(e) {
                    if (void 0 === e) {
                        return null;
                    }
                    if ('object' != typeof e) {
                        if ('symbol' == typeof e) {
                            return !1;
                        }
                        if ('string' == typeof e || 'number' == typeof e) {
                            return +e == +e;
                        } else {
                            return !0;
                        }
                    }
                }

                function O(e, t, n, a, o, r) {
                    var s = w(n);
                    if (null != s) {
                        return s;
                    }
                    var c = M(t, s),
                        l = i({}, o, { strict: !1 });
                    if ((void 0 === c && !R(t, s)) || !N(a, c, l, r)) {
                        return !1;
                    } else {
                        return !R(e, s) && N(a, c, l, r);
                    }
                }

                function Y(e, t, n) {
                    var i = w(n);
                    if (null != i) {
                        return i;
                    } else {
                        return P(t, i) && !P(e, i);
                    }
                }

                function B(e, t, n, i, a, o) {
                    for (var r, c, l = s(e); (r = l.next()) && !r.done; ) {
                        if (N(n, (c = r.value), a, o) && N(i, M(t, c), a, o)) {
                            I(e, c);
                            return !0;
                        }
                    }
                    return !1;
                }

                function N(e, t, n, a) {
                    var r = n || {};
                    if (r.strict ? l(e, t) : e === t) {
                        return !0;
                    }
                    if (y(e) !== y(t)) {
                        return !1;
                    }
                    if (!e || !t || ('object' != typeof e && 'object' != typeof t)) {
                        return r.strict ? l(e, t) : e == t;
                    }
                    var c,
                        I = a.has(e),
                        w = a.has(t);
                    if (I && w) {
                        if (a.get(e) === a.get(t)) {
                            return !0;
                        }
                    } else {
                        c = {};
                    }
                    if (!I) {
                        a.set(e, c);
                    }
                    if (!w) {
                        a.set(t, c);
                    }
                    return (function (e, t, n, a) {
                        var r, c;
                        if (typeof e != typeof t) {
                            return !1;
                        }
                        if (null == e || null == t) {
                            return !1;
                        }
                        if (v(e) !== v(t)) {
                            return !1;
                        }
                        if (u(e) !== u(t)) {
                            return !1;
                        }
                        var l = d(e),
                            y = d(t);
                        if (l !== y) {
                            return !1;
                        }
                        var I = e instanceof Error,
                            w = t instanceof Error;
                        if (I !== w) {
                            return !1;
                        }
                        if (I || w) {
                            if (e.name !== t.name || e.message !== t.message) {
                                return !1;
                            }
                        }
                        var H = f(e),
                            j = f(t);
                        if (H !== j) {
                            return !1;
                        }
                        if ((H || j) && (e.source !== t.source || o(e) !== o(t))) {
                            return !1;
                        }
                        var F = p(e),
                            U = p(t);
                        if (F !== U) {
                            return !1;
                        }
                        if (F || U) {
                            if (S(e) !== S(t)) {
                                return !1;
                            }
                        }
                        if (n.strict && b && b(e) !== b(t)) {
                            return !1;
                        }
                        var V = _(e),
                            Q = _(t);
                        if (V !== Q) {
                            return !1;
                        }
                        if (V || Q) {
                            if (e.length !== t.length) {
                                return !1;
                            }
                            for (r = 0; r < e.length; r++) {
                                if (e[r] !== t[r]) {
                                    return !1;
                                }
                            }
                            return !0;
                        }
                        var G = q(e),
                            z = q(t);
                        if (G !== z) {
                            return !1;
                        }
                        if (G || z) {
                            if (e.length !== t.length) {
                                return !1;
                            }
                            for (r = 0; r < e.length; r++) {
                                if (e[r] !== t[r]) {
                                    return !1;
                                }
                            }
                            return !0;
                        }
                        var W = m(e),
                            K = m(t);
                        if (W !== K) {
                            return !1;
                        }
                        if (W || K) {
                            if (E(e) !== E(t)) {
                                return !1;
                            } else {
                                return 'function' == typeof Uint8Array && N(new Uint8Array(e), new Uint8Array(t), n, a);
                            }
                        }
                        var J = g(e),
                            $ = g(t);
                        if (J !== $) {
                            return !1;
                        }
                        if (J || $) {
                            if (C(e) !== C(t)) {
                                return !1;
                            } else {
                                return 'function' == typeof Uint8Array && N(new Uint8Array(e), new Uint8Array(t), n, a);
                            }
                        }
                        if (typeof e != typeof t) {
                            return !1;
                        }
                        var X = h(e),
                            Z = h(t);
                        if (X.length !== Z.length) {
                            return !1;
                        }
                        X.sort();
                        Z.sort();
                        for (r = X.length - 1; r >= 0; r--) {
                            if (X[r] != Z[r]) {
                                return !1;
                            }
                        }
                        for (r = X.length - 1; r >= 0; r--) {
                            if (!N(e[(c = X[r])], t[c], n, a)) {
                                return !1;
                            }
                        }
                        var ee = x(e),
                            te = x(t);
                        if (ee !== te) {
                            return !1;
                        }
                        if ('Set' === ee || 'Set' === te) {
                            return (function (e, t, n, i) {
                                if (L(e) !== L(t)) {
                                    return !1;
                                }
                                var a,
                                    o,
                                    r,
                                    c = s(e),
                                    l = s(t);
                                for (; (a = c.next()) && !a.done; ) {
                                    if (a.value && 'object' == typeof a.value) {
                                        if (!r) {
                                            r = new D();
                                        }
                                        k(r, a.value);
                                    } else if (!P(t, a.value)) {
                                        if (n.strict) {
                                            return !1;
                                        }
                                        if (!Y(e, t, a.value)) {
                                            return !1;
                                        }
                                        if (!r) {
                                            r = new D();
                                        }
                                        k(r, a.value);
                                    }
                                }
                                if (r) {
                                    for (; (o = l.next()) && !o.done; ) {
                                        if (o.value && 'object' == typeof o.value) {
                                            if (!A(r, o.value, n.strict, i)) {
                                                return !1;
                                            }
                                        } else if (!n.strict && !P(e, o.value) && !A(r, o.value, n.strict, i)) {
                                            return !1;
                                        }
                                    }
                                    return 0 === L(r);
                                }
                                return !0;
                            })(e, t, n, a);
                        }
                        if ('Map' === ee) {
                            return (function (e, t, n, a) {
                                if (T(e) !== T(t)) {
                                    return !1;
                                }
                                var o,
                                    r,
                                    c,
                                    l,
                                    u,
                                    d,
                                    m = s(e),
                                    p = s(t);
                                for (; (o = m.next()) && !o.done; ) {
                                    l = o.value[0];
                                    u = o.value[1];
                                    if (l && 'object' == typeof l) {
                                        if (!c) {
                                            c = new D();
                                        }
                                        k(c, l);
                                    } else if ((void 0 === (d = M(t, l)) && !R(t, l)) || !N(u, d, n, a)) {
                                        if (n.strict) {
                                            return !1;
                                        }
                                        if (!O(e, t, l, u, n, a)) {
                                            return !1;
                                        }
                                        if (!c) {
                                            c = new D();
                                        }
                                        k(c, l);
                                    }
                                }
                                if (c) {
                                    for (; (r = p.next()) && !r.done; ) {
                                        l = r.value[0];
                                        d = r.value[1];
                                        if (l && 'object' == typeof l) {
                                            if (!B(c, e, l, d, n, a)) {
                                                return !1;
                                            }
                                        } else if (
                                            !(
                                                n.strict ||
                                                (e.has(l) && N(M(e, l), d, n, a)) ||
                                                B(c, e, l, d, i({}, n, { strict: !1 }), a)
                                            )
                                        ) {
                                            return !1;
                                        }
                                    }
                                    return 0 === L(c);
                                }
                                return !0;
                            })(e, t, n, a);
                        }
                        return !0;
                    })(e, t, r, a);
                }

                function q(e) {
                    if (!e || 'object' != typeof e || 'number' != typeof e.length) {
                        return !1;
                    }
                    if ('function' != typeof e.copy || 'function' != typeof e.slice) {
                        return !1;
                    }
                    if (e.length > 0 && 'number' != typeof e[0]) {
                        return !1;
                    } else {
                        return !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
                    }
                }

                e.exports = function (e, t, n) {
                    return N(e, t, n, c());
                };
            },
            1828: function (e, t, n) {
                'use strict';
                var i = n(70),
                    a = n(4121),
                    o = n(4114),
                    r = n(7570);
                e.exports = function (e, t, n) {
                    if (!e || ('object' != typeof e && 'function' != typeof e)) {
                        throw new o('`obj` must be an object or a function`');
                    }
                    if ('string' != typeof t && 'symbol' != typeof t) {
                        throw new o('`property` must be a string or a symbol`');
                    }
                    if (arguments.length > 3 && 'boolean' != typeof arguments[3] && null !== arguments[3]) {
                        throw new o('`nonEnumerable`, if provided, must be a boolean or null');
                    }
                    if (arguments.length > 4 && 'boolean' != typeof arguments[4] && null !== arguments[4]) {
                        throw new o('`nonWritable`, if provided, must be a boolean or null');
                    }
                    if (arguments.length > 5 && 'boolean' != typeof arguments[5] && null !== arguments[5]) {
                        throw new o('`nonConfigurable`, if provided, must be a boolean or null');
                    }
                    if (arguments.length > 6 && 'boolean' != typeof arguments[6]) {
                        throw new o('`loose`, if provided, must be a boolean');
                    }
                    var s = arguments.length > 3 ? arguments[3] : null,
                        c = arguments.length > 4 ? arguments[4] : null,
                        l = arguments.length > 5 ? arguments[5] : null,
                        u = arguments.length > 6 ? arguments[6] : !1,
                        d = !!r && r(e, t);
                    if (i) {
                        i(e, t, {
                            configurable: null === l && d ? d.configurable : !l,
                            enumerable: null === s && d ? d.enumerable : !s,
                            value: n,
                            writable: null === c && d ? d.writable : !c,
                        });
                    } else if (u || (!s && !c && !l)) {
                        e[t] = n;
                    } else {
                        throw new a(
                            'This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.',
                        );
                    }
                };
            },
            5935: function (e, t, n) {
                'use strict';
                var i = n(9722),
                    a = 'function' == typeof Symbol && 'symbol' == typeof Symbol('foo'),
                    o = Object.prototype.toString,
                    r = Array.prototype.concat,
                    s = n(1828),
                    c = n(6177)(),
                    l = function (e, t, n, i) {
                        if (t in e) {
                            if (!0 === i) {
                                if (e[t] === n) {
                                    return;
                                }
                            } else if (
                                !((a = i), 'function' == typeof a && '[object Function]' === o.call(a)) ||
                                !i()
                            ) {
                                return;
                            }
                        }
                        var a;
                        if (c) {
                            s(e, t, n, !0);
                        } else {
                            s(e, t, n);
                        }
                    },
                    u = function (e, t) {
                        var n = arguments.length > 2 ? arguments[2] : {},
                            o = i(t);
                        if (a) {
                            o = r.call(o, Object.getOwnPropertySymbols(t));
                        }
                        for (var s = 0; s < o.length; s += 1) {
                            l(e, o[s], t[o[s]], n[o[s]]);
                        }
                    };
                u.supportsDescriptors = !!c;
                e.exports = u;
            },
            70: function (e, t, n) {
                'use strict';
                var i = n(9718)('%Object.defineProperty%', !0) || !1;
                if (i) {
                    try {
                        i({}, 'a', { value: 1 });
                    } catch (e) {
                        i = !1;
                    }
                }
                e.exports = i;
            },
            8208: function (e) {
                'use strict';
                e.exports = EvalError;
            },
            6788: function (e) {
                'use strict';
                e.exports = Error;
            },
            5785: function (e) {
                'use strict';
                e.exports = RangeError;
            },
            7369: function (e) {
                'use strict';
                e.exports = ReferenceError;
            },
            4121: function (e) {
                'use strict';
                e.exports = SyntaxError;
            },
            4114: function (e) {
                'use strict';
                e.exports = TypeError;
            },
            9394: function (e) {
                'use strict';
                e.exports = URIError;
            },
            5608: function (e) {
                e.exports = e => {
                    e.availableTypes = new Set();
                    Object.keys(e.type2Parent).forEach(t => e.availableTypes.add(t));
                    Object.values(e.type2Parent).forEach(t => e.availableTypes.add(t));
                    e.path2TypeWithoutElements = {};
                    for (let t in e.path2Type) {
                        if ('Element' !== e.path2Type[t] && 'BackboneElement' !== e.path2Type[t]) {
                            e.path2TypeWithoutElements[t] = e.path2Type[t];
                        }
                    }
                };
            },
            7887: function (e, t, n) {
                const i = n(5608),
                    a = {
                        choiceTypePaths: n(4764),
                        pathsDefinedElsewhere: n(6717),
                        type2Parent: n(6707),
                        path2Type: n(1430),
                    };
                i(a);
                e.exports = a;
            },
            1126: function (e, t, n) {
                const i = n(5608),
                    a = {
                        choiceTypePaths: n(1265),
                        pathsDefinedElsewhere: n(359),
                        type2Parent: n(3194),
                        path2Type: n(9023),
                    };
                i(a);
                e.exports = a;
            },
            8137: function (e) {
                e.exports = function (e) {
                    var t = new Date(e.getTime()),
                        n = t.getTimezoneOffset();
                    t.setSeconds(0, 0);
                    return 6e4 * n + (t.getTime() % 6e4);
                };
            },
            4644: function (e, t, n) {
                var i = n(9234);
                e.exports = function (e, t) {
                    var n = i(e),
                        a = Number(t);
                    n.setDate(n.getDate() + a);
                    return n;
                };
            },
            5030: function (e, t, n) {
                var i = n(5949);
                e.exports = function (e, t) {
                    var n = Number(t);
                    return i(e, 36e5 * n);
                };
            },
            5949: function (e, t, n) {
                var i = n(9234);
                e.exports = function (e, t) {
                    var n = i(e).getTime(),
                        a = Number(t);
                    return new Date(n + a);
                };
            },
            6680: function (e, t, n) {
                var i = n(5949);
                e.exports = function (e, t) {
                    var n = Number(t);
                    return i(e, 6e4 * n);
                };
            },
            7332: function (e, t, n) {
                var i = n(9234),
                    a = n(4460);
                e.exports = function (e, t) {
                    var n = i(e),
                        o = Number(t),
                        r = n.getMonth() + o,
                        s = new Date(0);
                    s.setFullYear(n.getFullYear(), r, 1);
                    s.setHours(0, 0, 0, 0);
                    var c = a(s);
                    n.setMonth(r, Math.min(c, n.getDate()));
                    return n;
                };
            },
            1712: function (e, t, n) {
                var i = n(5949);
                e.exports = function (e, t) {
                    var n = Number(t);
                    return i(e, 1e3 * n);
                };
            },
            864: function (e, t, n) {
                var i = n(4644);
                e.exports = function (e, t) {
                    var n = Number(t);
                    return i(e, 7 * n);
                };
            },
            6331: function (e, t, n) {
                var i = n(7332);
                e.exports = function (e, t) {
                    var n = Number(t);
                    return i(e, 12 * n);
                };
            },
            4460: function (e, t, n) {
                var i = n(9234);
                e.exports = function (e) {
                    var t = i(e),
                        n = t.getFullYear(),
                        a = t.getMonth(),
                        o = new Date(0);
                    o.setFullYear(n, a + 1, 0);
                    o.setHours(0, 0, 0, 0);
                    return o.getDate();
                };
            },
            5516: function (e) {
                e.exports = function (e) {
                    return e instanceof Date;
                };
            },
            9234: function (e, t, n) {
                var i = n(8137),
                    a = n(5516),
                    o = 36e5,
                    r = 6e4,
                    s = /[T ]/,
                    c = /:/,
                    l = /^(\d{2})$/,
                    u = [/^([+-]\d{2})$/, /^([+-]\d{3})$/, /^([+-]\d{4})$/],
                    d = /^(\d{4})/,
                    m = [/^([+-]\d{4})/, /^([+-]\d{5})/, /^([+-]\d{6})/],
                    p = /^-(\d{2})$/,
                    f = /^-?(\d{3})$/,
                    g = /^-?(\d{2})-?(\d{2})$/,
                    h = /^-?W(\d{2})$/,
                    y = /^-?W(\d{2})-?(\d{1})$/,
                    x = /^(\d{2}([.,]\d*)?)$/,
                    _ = /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
                    E = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
                    C = /([Z+-].*)$/,
                    S = /^(Z)$/,
                    b = /^([+-])(\d{2})$/,
                    v = /^([+-])(\d{2}):?(\d{2})$/;

                function D(e, t, n) {
                    t = t || 0;
                    n = n || 0;
                    var i = new Date(0);
                    i.setUTCFullYear(e, 0, 4);
                    var a = 7 * t + n + 1 - (i.getUTCDay() || 7);
                    i.setUTCDate(i.getUTCDate() + a);
                    return i;
                }

                e.exports = function (e, t) {
                    if (a(e)) {
                        return new Date(e.getTime());
                    } else if ('string' != typeof e) {
                        return new Date(e);
                    }
                    var n = (t || {}).additionalDigits;
                    if (null == n) {
                        n = 2;
                    } else {
                        n = Number(n);
                    }
                    var R = (function (e) {
                            var t,
                                n = {},
                                i = e.split(s);
                            if (c.test(i[0])) {
                                n.date = null;
                                t = i[0];
                            } else {
                                n.date = i[0];
                                t = i[1];
                            }
                            if (t) {
                                var a = C.exec(t);
                                if (a) {
                                    n.time = t.replace(a[1], '');
                                    n.timezone = a[1];
                                } else {
                                    n.time = t;
                                }
                            }
                            return n;
                        })(e),
                        M = (function (e, t) {
                            var n,
                                i = u[t],
                                a = m[t];
                            if ((n = d.exec(e) || a.exec(e))) {
                                var o = n[1];
                                return { year: parseInt(o, 10), restDateString: e.slice(o.length) };
                            }
                            if ((n = l.exec(e) || i.exec(e))) {
                                var r = n[1];
                                return { year: 100 * parseInt(r, 10), restDateString: e.slice(r.length) };
                            }
                            return { year: null };
                        })(R.date, n),
                        T = M.year,
                        k = (function (e, t) {
                            if (null === t) {
                                return null;
                            }
                            var n, i, a;
                            if (0 === e.length) {
                                (i = new Date(0)).setUTCFullYear(t);
                                return i;
                            }
                            if ((n = p.exec(e))) {
                                i = new Date(0);
                                a = parseInt(n[1], 10) - 1;
                                i.setUTCFullYear(t, a);
                                return i;
                            }
                            if ((n = f.exec(e))) {
                                i = new Date(0);
                                var o = parseInt(n[1], 10);
                                i.setUTCFullYear(t, 0, o);
                                return i;
                            }
                            if ((n = g.exec(e))) {
                                i = new Date(0);
                                a = parseInt(n[1], 10) - 1;
                                var r = parseInt(n[2], 10);
                                i.setUTCFullYear(t, a, r);
                                return i;
                            }
                            if ((n = h.exec(e))) {
                                return D(t, parseInt(n[1], 10) - 1);
                            }
                            if ((n = y.exec(e))) {
                                return D(t, parseInt(n[1], 10) - 1, parseInt(n[2], 10) - 1);
                            }
                            return null;
                        })(M.restDateString, T);
                    if (k) {
                        var I,
                            P = k.getTime(),
                            L = 0;
                        if (R.time) {
                            L = (function (e) {
                                var t, n, i;
                                if ((t = x.exec(e))) {
                                    return ((n = parseFloat(t[1].replace(',', '.'))) % 24) * o;
                                }
                                if ((t = _.exec(e))) {
                                    n = parseInt(t[1], 10);
                                    i = parseFloat(t[2].replace(',', '.'));
                                    return (n % 24) * o + i * r;
                                }
                                if ((t = E.exec(e))) {
                                    n = parseInt(t[1], 10);
                                    i = parseInt(t[2], 10);
                                    var a = parseFloat(t[3].replace(',', '.'));
                                    return (n % 24) * o + i * r + 1e3 * a;
                                }
                                return null;
                            })(R.time);
                        }
                        if (R.timezone) {
                            I =
                                (function (e) {
                                    var t, n;
                                    if ((t = S.exec(e))) {
                                        return 0;
                                    }
                                    if ((t = b.exec(e))) {
                                        n = 60 * parseInt(t[2], 10);
                                        return '+' === t[1] ? -n : n;
                                    }
                                    if ((t = v.exec(e))) {
                                        n = 60 * parseInt(t[2], 10) + parseInt(t[3], 10);
                                        return '+' === t[1] ? -n : n;
                                    }
                                    return 0;
                                })(R.timezone) * r;
                        } else {
                            var A = P + L,
                                w = new Date(A);
                            I = i(w);
                            var O = new Date(A);
                            O.setDate(w.getDate() + 1);
                            var Y = i(O) - i(w);
                            if (Y > 0) {
                                I += Y;
                            }
                        }
                        return new Date(P + L + I);
                    } else {
                        return new Date(e);
                    }
                };
            },
            4354: function (e, t, n) {
                const i = n(3367),
                    a = n(4808);
                let o = {
                    memberOf: function (e, t) {
                        if (!this.async) {
                            throw new Error(
                                'The asynchronous function "memberOf" is not allowed. To enable asynchronous functions, use the async=true or async="always" option.',
                            );
                        }
                        if (1 !== e.length || null == e[0]) {
                            return [];
                        }
                        if ('string' == typeof t && /^https?:\/\/.*/.test(t)) {
                            const n = this.processedVars.terminologies;
                            if (!n) {
                                throw new Error('Option "terminologyUrl" is not specified.');
                            }
                            return a.validateVS([n], t, i.valData(e[0]), '').then(
                                e => e.parameter.find(e => 'result' === e.name).valueBoolean,
                                () => [],
                            );
                        }
                        return [];
                    },
                };
                e.exports = o;
            },
            4876: function (e, t, n) {
                let i = {};
                const a = n(2477),
                    o = n(6079),
                    r = n(3367);
                i.aggregateMacro = function (e, t, n) {
                    return e.reduce((e, n, i) => {
                        if (e instanceof Promise) {
                            return e.then(e => {
                                this.$index = i;
                                this.$total = e;
                                return (this.$total = t(n));
                            });
                        } else {
                            this.$index = i;
                            return (this.$total = t(n));
                        }
                    }, (this.$total = n));
                };
                i.countFn = function (e) {
                    if (e && e.length) {
                        return e.length;
                    } else {
                        return 0;
                    }
                };
                i.sumFn = function (e) {
                    return i.aggregateMacro.apply(this, [
                        e.slice(1),
                        e => {
                            let t = r.arraify(e).filter(e => null != r.valData(e)),
                                n = r.arraify(this.$total).filter(e => null != r.valData(e));
                            if (0 === t.length || 0 === n.length) {
                                return [];
                            } else {
                                return a.plus(t, n);
                            }
                        },
                        e[0],
                    ]);
                };

                function s(e, t) {
                    let n;
                    if (0 === e.length || null == r.valData(e[0])) {
                        n = [];
                    } else {
                        n = [e[0]];
                        for (let i = 1; i < e.length; i++) {
                            if (null == r.valData(e[i])) {
                                n = [];
                                break;
                            }
                            const a = [e[i]];
                            n = r.isTrue(t(a, n)) ? a : n;
                        }
                    }
                    return n;
                }

                i.minFn = function (e) {
                    return s(e, o.lt);
                };
                i.maxFn = function (e) {
                    return s(e, o.gt);
                };
                i.avgFn = function (e) {
                    const t = r.arraify(i.sumFn(e)),
                        n = r.arraify(i.countFn(e));
                    if (0 === t.length || 0 === n.length) {
                        return [];
                    } else {
                        return a.div(t, n);
                    }
                };
                e.exports = i;
            },
            8130: function (e, t, n) {
                const { deepEqual: i } = n(988),
                    a = {};

                function o(e, t) {
                    for (var n = 0; n < e.length; n++) {
                        if (i(e[n], t[0])) {
                            return !0;
                        }
                    }
                    return !1;
                }

                a.contains = function (e, t) {
                    if (0 == t.length) {
                        return [];
                    }
                    if (0 == e.length) {
                        return !1;
                    }
                    if (t.length > 1) {
                        throw new Error('Expected singleton on right side of contains, got ' + JSON.stringify(t));
                    }
                    return o(e, t);
                };
                a.in = function (e, t) {
                    if (0 == e.length) {
                        return [];
                    }
                    if (0 == t.length) {
                        return !1;
                    }
                    if (e.length > 1) {
                        throw new Error('Expected singleton on right side of in, got ' + JSON.stringify(t));
                    }
                    return o(t, e);
                };
                e.exports = a;
            },
            2017: function (e, t, n) {
                const i = {},
                    { distinctFn: a } = n(5437),
                    o = n(5919),
                    { deepEqual: r, maxCollSizeForDeepEqual: s } = n(988);
                i.union = function (e, t) {
                    return a(e.concat(t));
                };
                i.combineFn = function (e, t) {
                    return e.concat(t);
                };
                i.intersect = function (e, t) {
                    let n = [];
                    const i = e.length;
                    let c = t.length;
                    if (i && c) {
                        if (i + c > s) {
                            let a = {};
                            t.forEach(e => {
                                const t = o(e);
                                if (a[t]) {
                                    c--;
                                } else {
                                    a[t] = !0;
                                }
                            });
                            for (let t = 0; t < i && c > 0; ++t) {
                                let i = e[t],
                                    r = o(i);
                                if (a[r]) {
                                    n.push(i);
                                    a[r] = !1;
                                    c--;
                                }
                            }
                        } else {
                            n = a(e).filter(e => t.some(t => r(e, t)));
                        }
                    }
                    return n;
                };
                i.exclude = function (e, t) {
                    let n = [];
                    const i = e.length,
                        a = t.length;
                    if (!a) {
                        return e;
                    }
                    if (i) {
                        if (i + a > s) {
                            let i = {};
                            t.forEach(e => {
                                const t = o(e);
                                i[t] = !0;
                            });
                            n = e.filter(e => !i[o(e)]);
                        } else {
                            n = e.filter(e => !t.some(t => r(e, t)));
                        }
                    }
                    return n;
                };
                e.exports = i;
            },
            1930: function (e) {
                e.exports = {
                    reset: function () {
                        this.nowDate = new Date();
                        this.today = null;
                        this.now = null;
                        this.timeOfDay = null;
                        this.localTimezoneOffset = null;
                    },
                    today: null,
                    now: null,
                    timeOfDay: null,
                };
            },
            7338: function (e, t, n) {
                var i = {};
                const a = n(5457),
                    o = n(1930),
                    r = a.FP_Date,
                    s = a.FP_DateTime,
                    c = a.FP_Time;
                i.now = function () {
                    if (!o.now) {
                        var e = o.nowDate,
                            t = s.isoDateTime(e);
                        o.now = new s(t);
                    }
                    return o.now;
                };
                i.today = function () {
                    if (!o.today) {
                        var e = o.nowDate,
                            t = r.isoDate(e);
                        o.today = new r(t);
                    }
                    return o.today;
                };
                i.timeOfDay = function () {
                    if (!o.timeOfDay) {
                        const e = o.nowDate,
                            t = s.isoTime(e);
                        o.timeOfDay = new c(t);
                    }
                    return o.timeOfDay;
                };
                e.exports = i;
            },
            988: function (e, t, n) {
                const { FP_Type: i, FP_Quantity: a } = n(5457);
                var o = n(3367),
                    r = n(9477),
                    s = Array.prototype.slice,
                    c = Object.keys,
                    l = function (e) {
                        return '[object Arguments]' == Object.prototype.toString.call(e);
                    };

                function u(e) {
                    return 'string' == typeof e || e instanceof String;
                }

                function d(e) {
                    return !isNaN(parseFloat(e)) && isFinite(e);
                }

                function m(e) {
                    return e.toUpperCase().replace(/\s+/, ' ');
                }

                function p(e, t, n) {
                    if (!n) {
                        n = {};
                    }
                    if ((e = o.valDataConverted(e)) === (t = o.valDataConverted(t))) {
                        return !0;
                    }
                    if (n.fuzzy) {
                        if (u(e) && u(t)) {
                            return m(e) == m(t);
                        }
                        if (d(e) && d(t)) {
                            return r.isEquivalent(e, t);
                        }
                    } else if ('number' == typeof e && 'number' == typeof t) {
                        return r.isEqual(e, t);
                    }
                    if (e instanceof Date && t instanceof Date) {
                        return e.getTime() === t.getTime();
                    } else if (!e || !t || ('object' != typeof e && 'object' != typeof t)) {
                        return e === t;
                    } else {
                        var g = e instanceof i,
                            h = t instanceof i;
                        if (g && h) {
                            return n.fuzzy ? e.equivalentTo(t) : e.equals(t);
                        } else if (g || h) {
                            let i = !1;
                            if ('number' == typeof e) {
                                e = new a(e, "'1'");
                                i = !0;
                            }
                            if ('number' == typeof t) {
                                t = new a(t, "'1'");
                                i = !0;
                            }
                            if (i) {
                                return n.fuzzy ? e.equivalentTo(t) : e.equals(t);
                            } else {
                                return !1;
                            }
                        }
                        return (function (e, t, n) {
                            var i, a;
                            if (f(e) || f(t)) {
                                return !1;
                            }
                            if (e.prototype !== t.prototype) {
                                return !1;
                            }
                            if (l(e) || l(t)) {
                                return p((e = l(e) ? s.call(e) : e), (t = l(t) ? s.call(t) : t), n);
                            }
                            try {
                                var o = c(e),
                                    r = c(t);
                            } catch (e) {
                                return !1;
                            }
                            if (o.length != r.length) {
                                return !1;
                            }
                            o.sort();
                            r.sort();
                            for (i = o.length - 1; i >= 0; i--) {
                                if (o[i] != r[i]) {
                                    return !1;
                                }
                            }
                            if (1 === o.length) {
                                return p(e[(a = o[0])], t[a], n);
                            }
                            for (i = o.length - 1; i >= 0; i--) {
                                if (!p(e[(a = o[i])], t[a], n)) {
                                    return !1;
                                }
                            }
                            return typeof e == typeof t;
                        })(e, t, n);
                    }
                }

                function f(e) {
                    return null == e;
                }

                e.exports = { deepEqual: p, maxCollSizeForDeepEqual: 6 };
            },
            6079: function (e, t, n) {
                const i = n(3367),
                    { deepEqual: a } = n(988),
                    o = n(5457),
                    r = o.FP_Type,
                    s = o.FP_DateTime;
                var c = {};

                function l(e, t) {
                    if (i.isEmpty(e) || i.isEmpty(t)) {
                        return [];
                    } else {
                        return a(e, t);
                    }
                }

                function u(e, t) {
                    if (i.isEmpty(e) && i.isEmpty(t)) {
                        return [!0];
                    }
                    if (i.isEmpty(e) || i.isEmpty(t)) {
                        return [];
                    } else {
                        return a(e, t, { fuzzy: !0 });
                    }
                }

                c.equal = function (e, t) {
                    return l(e, t);
                };
                c.unequal = function (e, t) {
                    var n = l(e, t);
                    return void 0 === n ? void 0 : !n;
                };
                c.equival = function (e, t) {
                    return u(e, t);
                };
                c.unequival = function (e, t) {
                    return !u(e, t);
                };

                function d(e, t) {
                    i.assertOnlyOne(e, 'Singleton was expected');
                    i.assertOnlyOne(t, 'Singleton was expected');
                    e = i.valDataConverted(e[0]);
                    t = i.valDataConverted(t[0]);
                    if (null != e && null != t) {
                        let n = e instanceof s ? s : e.constructor,
                            a = t instanceof s ? s : t.constructor;
                        if (n !== a) {
                            i.raiseError(
                                'Type of "' +
                                    e +
                                    '" (' +
                                    n.name +
                                    ') did not match type of "' +
                                    t +
                                    '" (' +
                                    a.name +
                                    ')',
                                'InequalityExpression',
                            );
                        }
                    }
                    return [e, t];
                }

                c.lt = function (e, t) {
                    const [n, i] = d(e, t);
                    if (null == n || null == i) {
                        return [];
                    }
                    if (n instanceof r) {
                        const e = n.compare(i);
                        return null === e ? [] : e < 0;
                    }
                    return n < i;
                };
                c.gt = function (e, t) {
                    const [n, i] = d(e, t);
                    if (null == n || null == i) {
                        return [];
                    }
                    if (n instanceof r) {
                        const e = n.compare(i);
                        return null === e ? [] : e > 0;
                    }
                    return n > i;
                };
                c.lte = function (e, t) {
                    const [n, i] = d(e, t);
                    if (null == n || null == i) {
                        return [];
                    }
                    if (n instanceof r) {
                        const e = n.compare(i);
                        return null === e ? [] : e <= 0;
                    }
                    return n <= i;
                };
                c.gte = function (e, t) {
                    const [n, i] = d(e, t);
                    if (null == n || null == i) {
                        return [];
                    }
                    if (n instanceof r) {
                        const e = n.compare(i);
                        return null === e ? [] : e >= 0;
                    }
                    return n >= i;
                };
                e.exports = c;
            },
            3843: function (e, t, n) {
                const i = n(3367),
                    { whereMacro: a, distinctFn: o } = n(5437),
                    r = n(6251),
                    s = n(5919),
                    { deepEqual: c, maxCollSizeForDeepEqual: l } = n(988),
                    u = {};
                u.emptyFn = i.isEmpty;
                u.notFn = function (e) {
                    let t = r.singleton(e, 'Boolean');
                    return 'boolean' == typeof t ? !t : [];
                };
                u.existsMacro = function (e, t) {
                    if (t) {
                        const n = a.call(this, e, t);
                        if (n instanceof Promise) {
                            return n.then(e => u.existsMacro(e));
                        } else {
                            return u.existsMacro(n);
                        }
                    }
                    return !i.isEmpty(e);
                };
                u.allMacro = function (e, t) {
                    const n = [];
                    for (let a = 0, o = e.length; a < o; ++a) {
                        this.$index = a;
                        const o = t(e[a]);
                        if (o instanceof Promise) {
                            n.push(o);
                        } else if (!i.isTrue(o)) {
                            return [!1];
                        }
                    }
                    if (n.length) {
                        return Promise.all(n).then(e => (e.some(e => !i.isTrue(e)) ? [!1] : [!0]));
                    } else {
                        return [!0];
                    }
                };
                u.allTrueFn = function (e) {
                    let t = !0;
                    for (let n = 0, a = e.length; n < a && t; ++n) {
                        t = !0 === i.assertType(e[n], ['boolean'], 'allTrue');
                    }
                    return [t];
                };
                u.anyTrueFn = function (e) {
                    let t = !1;
                    for (let n = 0, a = e.length; n < a && !t; ++n) {
                        t = !0 === i.assertType(e[n], ['boolean'], 'anyTrue');
                    }
                    return [t];
                };
                u.allFalseFn = function (e) {
                    let t = !0;
                    for (let n = 0, a = e.length; n < a && t; ++n) {
                        t = !1 === i.assertType(e[n], ['boolean'], 'allFalse');
                    }
                    return [t];
                };
                u.anyFalseFn = function (e) {
                    let t = !1;
                    for (let n = 0, a = e.length; n < a && !t; ++n) {
                        t = !1 === i.assertType(e[n], ['boolean'], 'anyFalse');
                    }
                    return [t];
                };

                function d(e, t) {
                    const n = e.length,
                        a = t.length;
                    let o = n <= a;
                    if (o) {
                        if (n + a > l) {
                            const n = t.reduce((e, t) => {
                                e[s(t)] = !0;
                                return e;
                            }, {});
                            o = !e.some(e => !n[s(e)]);
                        } else {
                            for (let n = 0, a = e.length; n < a && o; ++n) {
                                let a = i.valData(e[n]);
                                o = t.some(e => c(a, i.valData(e)));
                            }
                        }
                    }
                    return o;
                }

                u.subsetOfFn = function (e, t) {
                    return [d(e, t)];
                };
                u.supersetOfFn = function (e, t) {
                    return [d(t, e)];
                };
                u.isDistinctFn = function (e) {
                    return [e.length === o(e).length];
                };
                e.exports = u;
            },
            7941: function (e, t, n) {
                const { version: i } = n(9852),
                    a = n(6031),
                    o = n(3367);
                n(2844);
                const r = n(1930);
                let s = {},
                    c = n(3843),
                    l = n(5437),
                    u = n(4876),
                    d = n(1609),
                    m = n(2017),
                    p = n(6251),
                    f = n(6079),
                    g = n(8130),
                    h = n(2477),
                    y = n(957),
                    x = n(3401),
                    _ = n(7338),
                    E = n(4354),
                    C = n(4293);
                const S = n(5457),
                    {
                        FP_Date: b,
                        FP_DateTime: v,
                        FP_Time: D,
                        FP_Quantity: R,
                        FP_Type: M,
                        ResourceNode: T,
                        TypeInfo: k,
                    } = S;
                let I = T.makeResNode;
                const P = n(4808);
                s.invocationTable = {
                    memberOf: { fn: E.memberOf, arity: { 1: ['String'] } },
                    empty: { fn: c.emptyFn },
                    not: { fn: c.notFn },
                    exists: { fn: c.existsMacro, arity: { 0: [], 1: ['Expr'] } },
                    all: { fn: c.allMacro, arity: { 1: ['Expr'] } },
                    allTrue: { fn: c.allTrueFn },
                    anyTrue: { fn: c.anyTrueFn },
                    allFalse: { fn: c.allFalseFn },
                    anyFalse: { fn: c.anyFalseFn },
                    subsetOf: { fn: c.subsetOfFn, arity: { 1: ['AnyAtRoot'] } },
                    supersetOf: { fn: c.supersetOfFn, arity: { 1: ['AnyAtRoot'] } },
                    isDistinct: { fn: c.isDistinctFn },
                    distinct: { fn: l.distinctFn },
                    count: { fn: u.countFn },
                    where: { fn: l.whereMacro, arity: { 1: ['Expr'] } },
                    extension: { fn: l.extension, arity: { 1: ['String'] } },
                    select: { fn: l.selectMacro, arity: { 1: ['Expr'] } },
                    aggregate: { fn: u.aggregateMacro, arity: { 1: ['Expr'], 2: ['Expr', 'AnyAtRoot'] } },
                    sum: { fn: u.sumFn },
                    min: { fn: u.minFn },
                    max: { fn: u.maxFn },
                    avg: { fn: u.avgFn },
                    weight: { fn: d.weight },
                    ordinal: { fn: d.weight },
                    single: { fn: l.singleFn },
                    first: { fn: l.firstFn },
                    last: { fn: l.lastFn },
                    type: { fn: S.typeFn, arity: { 0: [] } },
                    ofType: { fn: l.ofTypeFn, arity: { 1: ['TypeSpecifier'] } },
                    is: { fn: S.isFn, arity: { 1: ['TypeSpecifier'] } },
                    as: { fn: S.asFn, arity: { 1: ['TypeSpecifier'] } },
                    tail: { fn: l.tailFn },
                    take: { fn: l.takeFn, arity: { 1: ['Integer'] } },
                    skip: { fn: l.skipFn, arity: { 1: ['Integer'] } },
                    combine: { fn: m.combineFn, arity: { 1: ['AnyAtRoot'] } },
                    union: { fn: m.union, arity: { 1: ['AnyAtRoot'] } },
                    intersect: { fn: m.intersect, arity: { 1: ['AnyAtRoot'] } },
                    exclude: { fn: m.exclude, arity: { 1: ['AnyAtRoot'] } },
                    iif: { fn: p.iifMacro, arity: { 2: ['Expr', 'Expr'], 3: ['Expr', 'Expr', 'Expr'] } },
                    trace: { fn: p.traceFn, arity: { 1: ['String'], 2: ['String', 'Expr'] } },
                    defineVariable: { fn: p.defineVariable, arity: { 1: ['String'], 2: ['String', 'Expr'] } },
                    toInteger: { fn: p.toInteger },
                    toDecimal: { fn: p.toDecimal },
                    toString: { fn: p.toString },
                    toDate: { fn: p.toDate },
                    toDateTime: { fn: p.toDateTime },
                    toTime: { fn: p.toTime },
                    toBoolean: { fn: p.toBoolean },
                    toQuantity: { fn: p.toQuantity, arity: { 0: [], 1: ['String'] } },
                    hasValue: { fn: p.hasValueFn },
                    convertsToBoolean: { fn: p.createConvertsToFn(p.toBoolean, 'boolean') },
                    convertsToInteger: { fn: p.createConvertsToFn(p.toInteger, 'number') },
                    convertsToDecimal: { fn: p.createConvertsToFn(p.toDecimal, 'number') },
                    convertsToString: { fn: p.createConvertsToFn(p.toString, 'string') },
                    convertsToDate: { fn: p.createConvertsToFn(p.toDate, b) },
                    convertsToDateTime: { fn: p.createConvertsToFn(p.toDateTime, v) },
                    convertsToTime: { fn: p.createConvertsToFn(p.toTime, D) },
                    convertsToQuantity: { fn: p.createConvertsToFn(p.toQuantity, R) },
                    indexOf: { fn: y.indexOf, arity: { 1: ['String'] } },
                    substring: { fn: y.substring, arity: { 1: ['Integer'], 2: ['Integer', 'Integer'] } },
                    startsWith: { fn: y.startsWith, arity: { 1: ['String'] } },
                    endsWith: { fn: y.endsWith, arity: { 1: ['String'] } },
                    contains: { fn: y.containsFn, arity: { 1: ['String'] } },
                    upper: { fn: y.upper },
                    lower: { fn: y.lower },
                    replace: { fn: y.replace, arity: { 2: ['String', 'String'] } },
                    matches: { fn: y.matches, arity: { 1: ['String'] } },
                    replaceMatches: { fn: y.replaceMatches, arity: { 2: ['String', 'String'] } },
                    length: { fn: y.length },
                    toChars: { fn: y.toChars },
                    join: { fn: y.joinFn, arity: { 0: [], 1: ['String'] } },
                    split: { fn: y.splitFn, arity: { 1: ['String'] } },
                    trim: { fn: y.trimFn },
                    encode: { fn: y.encodeFn, arity: { 1: ['String'] } },
                    decode: { fn: y.decodeFn, arity: { 1: ['String'] } },
                    abs: { fn: h.abs },
                    ceiling: { fn: h.ceiling },
                    exp: { fn: h.exp },
                    floor: { fn: h.floor },
                    ln: { fn: h.ln },
                    log: { fn: h.log, arity: { 1: ['Number'] }, nullable: !0 },
                    power: { fn: h.power, arity: { 1: ['Number'] }, nullable: !0 },
                    round: { fn: h.round, arity: { 0: [], 1: ['Number'] } },
                    sqrt: { fn: h.sqrt },
                    truncate: { fn: h.truncate },
                    now: { fn: _.now },
                    today: { fn: _.today },
                    timeOfDay: { fn: _.timeOfDay },
                    repeat: { fn: l.repeatMacro, arity: { 1: ['Expr'] } },
                    children: { fn: x.children },
                    descendants: { fn: x.descendants },
                    '|': { fn: m.union, arity: { 2: ['Any', 'Any'] } },
                    '=': { fn: f.equal, arity: { 2: ['Any', 'Any'] }, nullable: !0 },
                    '!=': { fn: f.unequal, arity: { 2: ['Any', 'Any'] }, nullable: !0 },
                    '~': { fn: f.equival, arity: { 2: ['Any', 'Any'] } },
                    '!~': { fn: f.unequival, arity: { 2: ['Any', 'Any'] } },
                    '<': { fn: f.lt, arity: { 2: ['Any', 'Any'] }, nullable: !0 },
                    '>': { fn: f.gt, arity: { 2: ['Any', 'Any'] }, nullable: !0 },
                    '<=': { fn: f.lte, arity: { 2: ['Any', 'Any'] }, nullable: !0 },
                    '>=': { fn: f.gte, arity: { 2: ['Any', 'Any'] }, nullable: !0 },
                    containsOp: { fn: g.contains, arity: { 2: ['Any', 'Any'] } },
                    inOp: { fn: g.in, arity: { 2: ['Any', 'Any'] } },
                    isOp: { fn: S.isFn, arity: { 2: ['Any', 'TypeSpecifier'] } },
                    asOp: { fn: S.asFn, arity: { 2: ['Any', 'TypeSpecifier'] } },
                    '&': { fn: h.amp, arity: { 2: ['String', 'String'] } },
                    '+': { fn: h.plus, arity: { 2: ['Any', 'Any'] }, nullable: !0 },
                    '-': { fn: h.minus, arity: { 2: ['Any', 'Any'] }, nullable: !0 },
                    '*': { fn: h.mul, arity: { 2: ['Any', 'Any'] }, nullable: !0 },
                    '/': { fn: h.div, arity: { 2: ['Any', 'Any'] }, nullable: !0 },
                    mod: { fn: h.mod, arity: { 2: ['Number', 'Number'] }, nullable: !0 },
                    div: { fn: h.intdiv, arity: { 2: ['Number', 'Number'] }, nullable: !0 },
                    or: { fn: C.orOp, arity: { 2: [['Boolean'], ['Boolean']] } },
                    and: { fn: C.andOp, arity: { 2: [['Boolean'], ['Boolean']] } },
                    xor: { fn: C.xorOp, arity: { 2: [['Boolean'], ['Boolean']] } },
                    implies: { fn: C.impliesOp, arity: { 2: [['Boolean'], ['Boolean']] } },
                };
                s.InvocationExpression = function (e, t, n) {
                    return n.children.reduce(function (t, n) {
                        return s.doEval(e, t, n);
                    }, t);
                };
                s.TermExpression = function (e, t, n) {
                    if (t) {
                        t = t.map(e => {
                            if (e instanceof Object && e.resourceType) {
                                return I(e, null, e.resourceType, null, e.resourceType);
                            } else {
                                return e;
                            }
                        });
                    }
                    return s.doEval(e, t, n.children[0]);
                };
                s.PolarityExpression = function (e, t, n) {
                    var i = n.terminalNodeText[0],
                        a = s.doEval(e, t, n.children[0]);
                    if (1 !== a.length) {
                        throw new Error('Unary ' + i + ' can only be applied to an individual number or Quantity.');
                    }
                    if (a[0] instanceof R) {
                        if ('-' === i) {
                            a[0] = new R(-a[0].value, a[0].unit);
                        }
                    } else if ('number' == typeof a[0] && !isNaN(a[0])) {
                        if ('-' === i) {
                            a[0] = -a[0];
                        }
                    } else {
                        throw new Error('Unary ' + i + ' can only be applied to a number or Quantity.');
                    }
                    return a;
                };
                s.TypeSpecifier = function (e, t, n) {
                    let i, a;
                    const o = n.text.split('.').map(e => e.replace(/(^`|`$)/g, ''));
                    switch (o.length) {
                        case 2:
                            [i, a] = o;
                            break;
                        case 1:
                            [a] = o;
                            break;
                        default:
                            throw new Error('Expected TypeSpecifier node, got ' + JSON.stringify(n));
                    }
                    const r = new k({ namespace: i, name: a });
                    if (!r.isValid()) {
                        throw new Error('"' + r + '" cannot be resolved to a valid type identifier');
                    }
                    return r;
                };
                s.ExternalConstantTerm = function (e, t, n) {
                    var i,
                        a = n.children[0].children[0],
                        o = s.Identifier(e, t, a)[0];
                    if (o in e.vars) {
                        i = e.vars[o];
                        if (Array.isArray(i)) {
                            i = i.map(e =>
                                e?.__path__
                                    ? I(e, e.__path__.parentResNode, e.__path__.path, null, e.__path__.fhirNodeDataType)
                                    : e?.resourceType
                                    ? I(e, null, null, null)
                                    : e,
                            );
                        } else {
                            i = i?.__path__
                                ? I(i, i.__path__.parentResNode, i.__path__.path, null, i.__path__.fhirNodeDataType)
                                : i?.resourceType
                                ? I(i, null, null, null)
                                : i;
                        }
                        e.processedVars[o] = i;
                        delete e.vars[o];
                    } else if (o in e.processedVars) {
                        i = e.processedVars[o];
                    } else if (e.definedVars && o in e.definedVars) {
                        i = e.definedVars[o];
                    } else {
                        throw new Error('Attempting to access an undefined environment variable: ' + o);
                    }
                    return null == i ? [] : i instanceof Array ? i : [i];
                };
                s.LiteralTerm = function (e, t, n) {
                    var i = n.children[0];
                    if (i) {
                        return s.doEval(e, t, i);
                    } else {
                        return [n.text];
                    }
                };
                s.StringLiteral = function (e, t, n) {
                    var i = n.text.replace(/(^'|'$)/g, '');
                    return [
                        (i = i.replace(/\\(u\d{4}|.)/g, function (e, t) {
                            switch (e) {
                                case '\\r':
                                    return '\r';
                                case '\\n':
                                    return '\n';
                                case '\\t':
                                    return '\t';
                                case '\\f':
                                    return '\f';
                                default:
                                    if (t.length > 1) {
                                        return String.fromCharCode('0x' + t.slice(1));
                                    } else {
                                        return t;
                                    }
                            }
                        })),
                    ];
                };
                s.BooleanLiteral = function (e, t, n) {
                    if ('true' === n.text) {
                        return [!0];
                    } else {
                        return [!1];
                    }
                };
                s.QuantityLiteral = function (e, t, n) {
                    var i = n.children[0],
                        a = Number(i.terminalNodeText[0]),
                        o = i.children[0],
                        r = o.terminalNodeText[0];
                    if (!r && o.children) {
                        r = o.children[0].terminalNodeText[0];
                    }
                    return [new R(a, r)];
                };
                s.DateTimeLiteral = function (e, t, n) {
                    var i = n.text.slice(1);
                    return [new v(i)];
                };
                s.TimeLiteral = function (e, t, n) {
                    var i = n.text.slice(1);
                    return [new D(i)];
                };
                s.NumberLiteral = function (e, t, n) {
                    return [Number(n.text)];
                };
                s.Identifier = function (e, t, n) {
                    return [n.text.replace(/(^`|`$)/g, '')];
                };
                s.InvocationTerm = function (e, t, n) {
                    return s.doEval(e, t, n.children[0]);
                };
                s.MemberInvocation = function (e, t, n) {
                    const i = s.doEval(e, t, n.children[0])[0],
                        a = e.model;
                    if (t) {
                        return t.reduce(function (e, t) {
                            t = I(t, null, t.__path__?.path, null, t.__path__?.fhirNodeDataType);
                            if (t.data?.resourceType === i) {
                                e.push(t);
                            } else {
                                o.pushFn(e, o.makeChildResNodes(t, i, a));
                            }
                            return e;
                        }, []);
                    } else {
                        return [];
                    }
                };
                s.IndexerExpression = function (e, t, n) {
                    const i = n.children[0],
                        a = n.children[1];
                    var r = s.doEval(e, t, i),
                        c = s.doEval(e, t, a);
                    if (o.isEmpty(c)) {
                        return [];
                    }
                    var l = parseInt(c[0]);
                    if (r && o.isSome(l) && r.length > l && l >= 0) {
                        return [r[l]];
                    } else {
                        return [];
                    }
                };
                s.Functn = function (e, t, n) {
                    return n.children.map(function (n) {
                        return s.doEval(e, t, n);
                    });
                };
                s.realizeParams = function (e, t, n) {
                    if (n && n[0] && n[0].children) {
                        return n[0].children.map(function (n) {
                            return s.doEval(e, t, n);
                        });
                    } else {
                        return [];
                    }
                };

                function L(e, t, n, i) {
                    if ('Expr' === n) {
                        return function (t) {
                            const n = o.arraify(t);
                            let a = { ...e, $this: n };
                            if (e.definedVars) {
                                a.definedVars = { ...e.definedVars };
                            }
                            return s.doEval(a, n, i);
                        };
                    }
                    if ('AnyAtRoot' === n) {
                        const t = e.$this || e.dataRoot;
                        let n = { ...e, $this: t };
                        if (e.definedVars) {
                            n.definedVars = { ...e.definedVars };
                        }
                        return s.doEval(n, t, i);
                    }
                    if ('Identifier' === n) {
                        if ('TermExpression' === i.type) {
                            return i.text;
                        } else {
                            throw new Error('Expected identifier node, got ' + JSON.stringify(i));
                        }
                    }
                    if ('TypeSpecifier' === n) {
                        return s.TypeSpecifier(e, t, i);
                    }
                    let a;
                    if ('AnySingletonAtRoot' === n) {
                        const t = e.$this || e.dataRoot;
                        let n = { ...e, $this: t };
                        if (e.definedVars) {
                            n.definedVars = { ...e.definedVars };
                        }
                        a = s.doEval(n, t, i);
                    } else {
                        let o = { ...e };
                        if (e.definedVars) {
                            o.definedVars = { ...e.definedVars };
                        }
                        a = s.doEval(o, t, i);
                        if ('Any' === n) {
                            return a;
                        }
                        if (Array.isArray(n)) {
                            if (0 === a.length) {
                                return [];
                            } else {
                                n = n[0];
                            }
                        }
                    }
                    return p.singleton(a, n);
                }

                function A(e) {
                    return null == e || o.isEmpty(e);
                }

                function w(e, t, n, i) {
                    var a = s.invocationTable[t];
                    if (a && a.fn) {
                        var r = i ? i.length : 0;
                        if (2 !== r) {
                            throw new Error('Infix invoke should have arity 2');
                        }
                        var c = a.arity[r];
                        if (c) {
                            for (var l = [], u = 0; u < r; u++) {
                                var d = c[u],
                                    m = i[u];
                                l.push(L(e, n, d, m));
                            }
                            if (a.nullable) {
                                if (l.some(A)) {
                                    return [];
                                }
                            }
                            if (l.some(e => e instanceof Promise)) {
                                return Promise.all(l).then(t => {
                                    var n = a.fn.apply(e, t);
                                    return o.arraify(n);
                                });
                            }
                            var p = a.fn.apply(e, l);
                            return o.arraify(p);
                        } else {
                            console.log(t + ' wrong arity: got ' + r);
                            return [];
                        }
                    } else {
                        throw new Error('Not impl ' + t);
                    }
                }

                s.FunctionInvocation = function (e, t, n) {
                    var i = s.doEval(e, t, n.children[0]);
                    const a = i[0];
                    i.shift();
                    return (function (e, t, n, i) {
                        var a,
                            r =
                                e.userInvocationTable?.[t] ||
                                s.invocationTable[t] ||
                                (1 === n.length && n[0]?.invocationTable[t]);
                        if (r) {
                            if (!r.arity) {
                                if (!i) {
                                    a = r.fn.call(e, n);
                                    return o.resolveAndArraify(a);
                                } else {
                                    throw new Error(t + ' expects no params');
                                }
                            } else {
                                var c = i ? i.length : 0,
                                    l = r.arity[c];
                                if (l) {
                                    for (var u = [], d = 0; d < c; d++) {
                                        var m = l[d],
                                            p = i[d];
                                        u.push(L(e, n, m, p));
                                    }
                                    u.unshift(n);
                                    if (r.nullable) {
                                        if (u.some(A)) {
                                            return [];
                                        }
                                    }
                                    if (u.some(e => e instanceof Promise)) {
                                        return Promise.all(u).then(t => {
                                            a = r.fn.apply(e, t);
                                            return o.resolveAndArraify(a);
                                        });
                                    }
                                    a = r.fn.apply(e, u);
                                    return o.resolveAndArraify(a);
                                } else {
                                    console.log(t + ' wrong arity: got ' + c);
                                    return [];
                                }
                            }
                        } else {
                            throw new Error('Not implemented: ' + t);
                        }
                    })(e, a, t, i && i[0] && i[0].children);
                };
                s.ParamList = function (e, t, n) {
                    return n;
                };
                s.UnionExpression = function (e, t, n) {
                    return w(e, '|', t, n.children);
                };
                s.ThisInvocation = function (e) {
                    return e.$this;
                };
                s.TotalInvocation = function (e) {
                    return o.arraify(e.$total);
                };
                s.IndexInvocation = function (e) {
                    return o.arraify(e.$index);
                };
                s.OpExpression = function (e, t, n) {
                    return w(e, n.terminalNodeText[0], t, n.children);
                };
                s.AliasOpExpression = function (e) {
                    return function (t, n, i) {
                        var a = i.terminalNodeText[0],
                            o = e[a];
                        if (!o) {
                            throw new Error('Do not know how to alias ' + a + ' by ' + JSON.stringify(e));
                        }
                        return w(t, o, n, i.children);
                    };
                };
                s.NullLiteral = function () {
                    return [];
                };
                s.ParenthesizedTerm = function (e, t, n) {
                    return s.doEval(e, t, n.children[0]);
                };
                s.evalTable = {
                    BooleanLiteral: s.BooleanLiteral,
                    EqualityExpression: s.OpExpression,
                    FunctionInvocation: s.FunctionInvocation,
                    Functn: s.Functn,
                    Identifier: s.Identifier,
                    IndexerExpression: s.IndexerExpression,
                    InequalityExpression: s.OpExpression,
                    InvocationExpression: s.InvocationExpression,
                    AdditiveExpression: s.OpExpression,
                    MultiplicativeExpression: s.OpExpression,
                    TypeExpression: s.AliasOpExpression({ is: 'isOp', as: 'asOp' }),
                    MembershipExpression: s.AliasOpExpression({ contains: 'containsOp', in: 'inOp' }),
                    NullLiteral: s.NullLiteral,
                    EntireExpression: s.InvocationTerm,
                    InvocationTerm: s.InvocationTerm,
                    LiteralTerm: s.LiteralTerm,
                    MemberInvocation: s.MemberInvocation,
                    NumberLiteral: s.NumberLiteral,
                    ParamList: s.ParamList,
                    ParenthesizedTerm: s.ParenthesizedTerm,
                    StringLiteral: s.StringLiteral,
                    TermExpression: s.TermExpression,
                    ThisInvocation: s.ThisInvocation,
                    TotalInvocation: s.TotalInvocation,
                    IndexInvocation: s.IndexInvocation,
                    UnionExpression: s.UnionExpression,
                    OrExpression: s.OpExpression,
                    ImpliesExpression: s.OpExpression,
                    AndExpression: s.OpExpression,
                    XorExpression: s.OpExpression,
                };
                s.doEval = function (e, t, n) {
                    if (t instanceof Promise) {
                        return t.then(t => s.doEvalSync(e, t, n));
                    } else {
                        return s.doEvalSync(e, t, n);
                    }
                };
                s.doEvalSync = function (e, t, n) {
                    const i = s.evalTable[n.type] || s[n.type];
                    if (i) {
                        return i.call(s, e, t, n);
                    } else {
                        throw new Error('No ' + n.type + ' evaluator ');
                    }
                };

                function O(e) {
                    return a.parse(e);
                }

                function Y(e, t, n, i, a) {
                    r.reset();
                    let c = o
                            .arraify(e)
                            .map(e =>
                                e?.__path__
                                    ? I(e, e.__path__.parentResNode, e.__path__.path, null, e.__path__.fhirNodeDataType)
                                    : e,
                            ),
                        l = {
                            dataRoot: c,
                            processedVars: { ucum: 'http://unitsofmeasure.org' },
                            vars: { context: c, ...n },
                            model: i,
                        };
                    if (a.traceFn) {
                        l.customTraceFn = a.traceFn;
                    }
                    if (a.userInvocationTable) {
                        l.userInvocationTable = a.userInvocationTable;
                    }
                    l.defaultScoreExts = [
                        'http://hl7.org/fhir/StructureDefinition/ordinalValue',
                        'http://hl7.org/fhir/StructureDefinition/itemWeight',
                        'http://hl7.org/fhir/StructureDefinition/questionnaire-ordinalValue',
                    ];
                    if (a.async) {
                        l.async = a.async;
                    }
                    if (a.terminologyUrl) {
                        l.processedVars.terminologies = new P(a.terminologyUrl);
                    }
                    const u = s.doEval(l, c, t.children[0]);
                    return u instanceof Promise
                        ? u.then(e => B(e, a))
                        : 'always' === a.async
                        ? Promise.resolve(B(u, a))
                        : B(u, a);
                }

                function B(e, t) {
                    return e.reduce((e, n) => {
                        let i, a, r;
                        if (n instanceof T) {
                            i = n.path;
                            a = n.fhirNodeDataType;
                            r = n.parentResNode;
                        }
                        if ((n = o.valData(n)) instanceof M) {
                            if (t.resolveInternalTypes) {
                                n = n.toString();
                            }
                        }
                        if (null != n) {
                            if (i && 'object' == typeof n && !n.__path__) {
                                Object.defineProperty(n, '__path__', {
                                    value: {
                                        path: i,
                                        fhirNodeDataType: a,
                                        parentResNode: r,
                                    },
                                });
                            }
                            e.push(n);
                        }
                        return e;
                    }, []);
                }

                function N(e, t, n) {
                    const i = (n = { resolveInternalTypes: !0, ...n }).userInvocationTable;
                    if (i) {
                        n.userInvocationTable = Object.keys(i).reduce((e, t) => {
                            if (i[t].internalStructures) {
                                e[t] = i[t];
                            } else {
                                e[t] = {
                                    ...i[t],
                                    fn: (...e) =>
                                        i[t].fn.apply(
                                            this,
                                            e.map(e => (Array.isArray(e) ? e.map(e => o.valData(e)) : e)),
                                        ),
                                };
                            }
                            return e;
                        }, {});
                    }
                    if ('object' == typeof e) {
                        const i = O(e.expression);
                        return function (a, o) {
                            if (e.base) {
                                let n = t.pathsDefinedElsewhere[e.base] || e.base;
                                const i = t && t.path2Type[n];
                                n = 'BackboneElement' === i || 'Element' === i ? n : i || n;
                                a = I(a, null, n, null, i);
                            }
                            k.model = t;
                            return Y(a, i, o, t, n);
                        };
                    } else {
                        const i = O(e);
                        return function (e, a) {
                            k.model = t;
                            return Y(e, i, a, t, n);
                        };
                    }
                }

                e.exports = {
                    version: i,
                    parse: O,
                    compile: N,
                    evaluate: function (e, t, n, i, a) {
                        return N(t, i, a)(e, n);
                    },
                    resolveInternalTypes: function e(t) {
                        if (Array.isArray(t)) {
                            for (let n = 0, i = t.length; n < i; ++n) {
                                t[n] = e(t[n]);
                            }
                        } else if (t instanceof M) {
                            t = t.toString();
                        } else if ('object' == typeof t) {
                            for (let n of Object.keys(t)) {
                                t[n] = e(t[n]);
                            }
                        }
                        return t;
                    },
                    types: function (e) {
                        return o.arraify(e).map(e => {
                            const t = k.fromValue(
                                e?.__path__
                                    ? new T(
                                          e,
                                          e.__path__?.parentResNode,
                                          e.__path__?.path,
                                          null,
                                          e.__path__?.fhirNodeDataType,
                                      )
                                    : e,
                            );
                            return `${t.namespace}.${t.name}`;
                        });
                    },
                    ucumUtils: n(6758).UcumLhcUtils.getInstance(),
                    util: o,
                };
            },
            5437: function (e, t, n) {
                const i = n(3367),
                    { TypeInfo: a, ResourceNode: o } = n(5457),
                    r = n(5919),
                    { deepEqual: s, maxCollSizeForDeepEqual: c } = n(988);
                var l = {
                    whereMacro: function (e, t) {
                        if (!1 !== e && !e) {
                            return [];
                        } else {
                            return i.flatten(
                                e.map((e, n) => {
                                    this.$index = n;
                                    const i = t(e);
                                    if (i instanceof Promise) {
                                        return i.then(t => (t[0] ? e : []));
                                    } else {
                                        return i[0] ? e : [];
                                    }
                                }),
                            );
                        }
                    },
                    extension: function (e, t) {
                        if ((!1 !== e && !e) || !t) {
                            return [];
                        } else {
                            return i.flatten(
                                e.map((e, n) => {
                                    this.$index = n;
                                    const i = e && ((e.data && e.data.extension) || (e._data && e._data.extension));
                                    if (i) {
                                        return i
                                            .filter(e => e.url === t)
                                            .map(t => o.makeResNode(t, e, 'Extension', null, 'Extension'));
                                    } else {
                                        return [];
                                    }
                                }),
                            );
                        }
                    },
                    selectMacro: function (e, t) {
                        if (!1 !== e && !e) {
                            return [];
                        } else {
                            return i.flatten(
                                e.map((e, n) => {
                                    this.$index = n;
                                    return t(e);
                                }),
                            );
                        }
                    },
                    repeatMacro: function (e, t, n = [], i = {}) {
                        if (!1 !== e && !e) {
                            return [];
                        }
                        let a = [].concat(...e.map(e => t(e)));
                        if (a.some(e => e instanceof Promise)) {
                            return Promise.all(a).then(e => {
                                if ((e = [].concat(...e)).length) {
                                    return l.repeatMacro(u(e, i, n), t, n, i);
                                } else {
                                    return n;
                                }
                            });
                        } else if (a.length) {
                            return l.repeatMacro(u(a, i, n), t, n, i);
                        } else {
                            return n;
                        }
                    },
                };

                function u(e, t, n) {
                    const i = e.filter(e => {
                        const n = r(e),
                            i = !t[n];
                        if (i) {
                            t[n] = !0;
                        }
                        return i;
                    });
                    n.push.apply(n, i);
                    return i;
                }

                l.singleFn = function (e) {
                    if (1 === e.length) {
                        return e;
                    } else if (0 === e.length) {
                        return [];
                    } else {
                        throw new Error('Expected single');
                    }
                };
                l.firstFn = function (e) {
                    return e[0];
                };
                l.lastFn = function (e) {
                    return e[e.length - 1];
                };
                l.tailFn = function (e) {
                    return e.slice(1, e.length);
                };
                l.takeFn = function (e, t) {
                    return e.slice(0, t);
                };
                l.skipFn = function (e, t) {
                    return e.slice(t, e.length);
                };
                l.ofTypeFn = function (e, t) {
                    return e.filter(e => a.fromValue(e).is(t));
                };
                l.distinctFn = function (e) {
                    let t = [];
                    if (e.length > 0) {
                        if (e.length > c) {
                            let n = {};
                            for (let i = 0, a = e.length; i < a; ++i) {
                                let a = e[i],
                                    o = r(a);
                                if (!n[o]) {
                                    t.push(a);
                                    n[o] = !0;
                                }
                            }
                        } else {
                            e = e.concat().reverse();
                            do {
                                let n = e.pop();
                                t.push(n);
                                e = e.filter(e => !s(n, e));
                            } while (e.length);
                        }
                    }
                    return t;
                };
                e.exports = l;
            },
            5919: function (e, t, n) {
                const i = n(6758).UcumLhcUtils.getInstance(),
                    { roundToMaxPrecision: a } = n(9477),
                    { valDataConverted: o } = n(3367),
                    { FP_Type: r, FP_Quantity: s } = n(5457);

                function c(e) {
                    if (null === (e = o(e))) {
                        return null;
                    } else if ('number' == typeof e) {
                        return a(e);
                    } else if (e instanceof Date) {
                        return e.toISOString();
                    }
                    if (e instanceof s) {
                        const t = s._yearMonthConversionFactor[e.unit];
                        if (t) {
                            return '_!yearMonth!_:' + t * e.value;
                        } else {
                            const t = s.toUcumQuantity(e.value, e.unit),
                                n = i.getSpecifiedUnit(t.unit).unit;
                            return '_!' + n.property_ + '!_:' + n.magnitude_ * t.value;
                        }
                    } else if (e instanceof r) {
                        return e.toString();
                    } else if ('object' == typeof e) {
                        return Array.isArray(e)
                            ? e.map(c)
                            : Object.keys(e)
                                  .sort()
                                  .reduce((t, n) => {
                                      const i = e[n];
                                      t[n] = c(i);
                                      return t;
                                  }, {});
                    }
                    return e;
                }

                e.exports = function (e) {
                    return JSON.stringify(c(e));
                };
            },
            4293: function (e) {
                var t = {
                    orOp: function (e, t) {
                        if (Array.isArray(t)) {
                            if (!0 === e) {
                                return !0;
                            } else if (!1 === e) {
                                return [];
                            } else if (Array.isArray(e)) {
                                return [];
                            }
                        }
                        if (Array.isArray(e)) {
                            if (!0 === t) {
                                return !0;
                            } else {
                                return [];
                            }
                        }
                        return e || t;
                    },
                    andOp: function (e, t) {
                        if (Array.isArray(t)) {
                            if (!0 === e) {
                                return [];
                            } else if (!1 === e) {
                                return !1;
                            } else if (Array.isArray(e)) {
                                return [];
                            }
                        }
                        if (Array.isArray(e)) {
                            if (!0 === t) {
                                return [];
                            } else {
                                return !1;
                            }
                        }
                        return e && t;
                    },
                    xorOp: function (e, t) {
                        if (Array.isArray(e) || Array.isArray(t)) {
                            return [];
                        } else {
                            return (e && !t) || (!e && t);
                        }
                    },
                    impliesOp: function (e, t) {
                        if (Array.isArray(t)) {
                            if (!0 === e) {
                                return [];
                            } else if (!1 === e) {
                                return !0;
                            } else if (Array.isArray(e)) {
                                return [];
                            }
                        }
                        if (Array.isArray(e)) {
                            if (!0 === t) {
                                return !0;
                            } else {
                                return [];
                            }
                        }
                        if (!1 === e) {
                            return !0;
                        } else {
                            return e && t;
                        }
                    },
                };
                e.exports = t;
            },
            2477: function (e, t, n) {
                const { FP_Quantity: i, FP_Type: a } = n(5457),
                    o = n(3367),
                    r = {};

                function s(e, t) {
                    let n;
                    if (c(e)) {
                        n = [];
                    } else if (1 !== e.length) {
                        throw new Error(
                            'Unexpected collection' + JSON.stringify(e) + '; expected singleton of type number',
                        );
                    } else {
                        const i = o.valData(e[0]);
                        if (null == i) {
                            n = [];
                        } else if ('number' == typeof i) {
                            n = t(i);
                        } else {
                            throw new Error('Expected number, but got ' + JSON.stringify(i));
                        }
                    }
                    return n;
                }

                function c(e) {
                    if ('number' == typeof e) {
                        return !1;
                    } else {
                        return 0 === e.length;
                    }
                }

                r.amp = function (e, t) {
                    return (e || '') + (t || '');
                };
                r.plus = function (e, t) {
                    let n;
                    if (1 === e.length && 1 === t.length) {
                        const r = o.valDataConverted(e[0]),
                            s = o.valDataConverted(t[0]);
                        if (null == r || null == s) {
                            n = [];
                        } else if ('string' == typeof r && 'string' == typeof s) {
                            n = r + s;
                        } else if ('number' == typeof r) {
                            if ('number' == typeof s) {
                                n = r + s;
                            } else if (s instanceof i) {
                                n = new i(r, "'1'").plus(s);
                            }
                        } else if (r instanceof a) {
                            if (s instanceof i) {
                                n = r.plus(s);
                            } else if (s instanceof a) {
                                n = s.plus(r);
                            } else if ('number' == typeof s) {
                                n = r.plus(new i(s, "'1'"));
                            }
                        }
                    }
                    if (void 0 === n) {
                        throw new Error('Cannot ' + JSON.stringify(e) + ' + ' + JSON.stringify(t));
                    }
                    return n;
                };
                r.minus = function (e, t) {
                    if (1 === e.length && 1 === t.length) {
                        const n = o.valDataConverted(e[0]),
                            r = o.valDataConverted(t[0]);
                        if (null == n || null == r) {
                            return [];
                        }
                        if ('number' == typeof n) {
                            if ('number' == typeof r) {
                                return n - r;
                            }
                            if (r instanceof i) {
                                return new i(n, "'1'").plus(new i(-r.value, r.unit));
                            }
                        }
                        if (n instanceof a) {
                            if (r instanceof i) {
                                return n.plus(new i(-r.value, r.unit));
                            }
                            if ('number' == typeof r) {
                                return n.plus(new i(-r, "'1'"));
                            }
                        }
                    }
                    throw new Error('Cannot ' + JSON.stringify(e) + ' - ' + JSON.stringify(t));
                };
                r.mul = function (e, t) {
                    if (1 === e.length && 1 === t.length) {
                        const n = o.valDataConverted(e[0]),
                            r = o.valDataConverted(t[0]);
                        if (null == n || null == r) {
                            return [];
                        }
                        if ('number' == typeof n) {
                            if ('number' == typeof r) {
                                return n * r;
                            }
                            if (r instanceof i) {
                                return new i(n, "'1'").mul(r);
                            }
                        }
                        if (n instanceof a) {
                            if (r instanceof i) {
                                return n.mul(r);
                            }
                            if ('number' == typeof r) {
                                return n.mul(new i(r, "'1'"));
                            }
                        }
                    }
                    throw new Error('Cannot ' + JSON.stringify(e) + ' * ' + JSON.stringify(t));
                };
                r.div = function (e, t) {
                    if (1 === e.length && 1 === t.length) {
                        const n = o.valDataConverted(e[0]),
                            r = o.valDataConverted(t[0]);
                        if (null == n || null == r) {
                            return [];
                        }
                        if ('number' == typeof n) {
                            if ('number' == typeof r) {
                                if (0 === r) {
                                    return [];
                                } else {
                                    return n / r;
                                }
                            }
                            if (r instanceof i) {
                                return new i(n, "'1'").div(r);
                            }
                        }
                        if (n instanceof a) {
                            if (r instanceof i) {
                                return n.div(r);
                            }
                            if ('number' == typeof r) {
                                return n.div(new i(r, "'1'"));
                            }
                        }
                    }
                    throw new Error('Cannot ' + JSON.stringify(e) + ' / ' + JSON.stringify(t));
                };
                r.intdiv = function (e, t) {
                    if (0 === t) {
                        return [];
                    } else {
                        return Math.floor(e / t);
                    }
                };
                r.mod = function (e, t) {
                    if (0 === t) {
                        return [];
                    } else {
                        return e % t;
                    }
                };
                r.abs = function (e) {
                    let t;
                    if (c(e)) {
                        t = [];
                    } else if (1 !== e.length) {
                        throw new Error(
                            'Unexpected collection' +
                                JSON.stringify(e) +
                                '; expected singleton of type number or Quantity',
                        );
                    } else {
                        var n = o.valData(e[0]);
                        if (null == n) {
                            t = [];
                        } else if ('number' == typeof n) {
                            t = Math.abs(n);
                        } else if (n instanceof i) {
                            t = new i(Math.abs(n.value), n.unit);
                        } else {
                            throw new Error('Expected number or Quantity, but got ' + JSON.stringify(n || e));
                        }
                    }
                    return t;
                };
                r.ceiling = function (e) {
                    return s(e, Math.ceil);
                };
                r.exp = function (e) {
                    return s(e, Math.exp);
                };
                r.floor = function (e) {
                    return s(e, Math.floor);
                };
                r.ln = function (e) {
                    return s(e, Math.log);
                };
                r.log = function (e, t) {
                    return s(e, e => Math.log(e) / Math.log(t));
                };
                r.power = function (e, t) {
                    return s(e, e => {
                        const n = Math.pow(e, t);
                        return isNaN(n) ? [] : n;
                    });
                };
                r.round = function (e, t) {
                    return s(e, e => {
                        if (void 0 === t) {
                            return Math.round(e);
                        } else {
                            let n = Math.pow(10, t);
                            return Math.round(e * n) / n;
                        }
                    });
                };
                r.sqrt = function (e) {
                    return s(e, e => {
                        if (e < 0) {
                            return [];
                        } else {
                            return Math.sqrt(e);
                        }
                    });
                };
                r.truncate = function (e) {
                    return s(e, Math.trunc);
                };
                e.exports = r;
            },
            6251: function (e, t, n) {
                var i = n(3367),
                    a = n(5457);
                const { FP_Quantity: o, TypeInfo: r } = a;
                var s = {
                    iifMacro: function (e, t, n, i) {
                        const a = t(e);
                        if (a instanceof Promise) {
                            return a.then(t => c(e, t, n, i));
                        } else {
                            return c(e, a, n, i);
                        }
                    },
                };

                function c(e, t, n, a) {
                    if (i.isTrue(t)) {
                        return n(e);
                    } else {
                        return a ? a(e) : [];
                    }
                }

                s.traceFn = function (e, t, n) {
                    const i = n ? n(e) : null;
                    if (i instanceof Promise) {
                        return i.then(n => s.traceFn(e, t, n));
                    }
                    if (this.customTraceFn) {
                        if (n) {
                            this.customTraceFn(n(e), t ?? '');
                        } else {
                            this.customTraceFn(e, t ?? '');
                        }
                    } else if (n) {
                        console.log('TRACE:[' + (t || '') + ']', JSON.stringify(n(e), null, ' '));
                    } else {
                        console.log('TRACE:[' + (t || '') + ']', JSON.stringify(e, null, ' '));
                    }
                    return e;
                };
                s.defineVariable = function (e, t, n) {
                    let i = e;
                    if (n) {
                        i = n(e);
                    }
                    if (!this.definedVars) {
                        this.definedVars = {};
                    }
                    if (t in this.vars || t in this.processedVars) {
                        throw new Error('Environment Variable %' + t + ' already defined');
                    }
                    if (Object.keys(this.definedVars).includes(t)) {
                        throw new Error('Variable %' + t + ' already defined');
                    }
                    this.definedVars[t] = i;
                    return e;
                };
                var l = /^[+-]?\d+$/;
                s.toInteger = function (e) {
                    if (1 !== e.length) {
                        return [];
                    }
                    var t = i.valData(e[0]);
                    if (!1 === t) {
                        return 0;
                    }
                    if (!0 === t) {
                        return 1;
                    }
                    if ('number' == typeof t) {
                        if (Number.isInteger(t)) {
                            return t;
                        } else {
                            return [];
                        }
                    }
                    if ('string' == typeof t && l.test(t)) {
                        return parseInt(t);
                    } else {
                        return [];
                    }
                };
                const u = /^((\+|-)?\d+(\.\d+)?)\s*(('[^']+')|([a-zA-Z]+))?$/,
                    d = 1,
                    m = 5,
                    p = 6;
                s.toQuantity = function (e, t) {
                    let n;
                    if (e.length > 1) {
                        throw new Error('Could not convert to quantity: input collection contains multiple items');
                    } else if (1 === e.length) {
                        if (t) {
                            const e = o._calendarDuration2Seconds[this.unit],
                                n = o._calendarDuration2Seconds[t];
                            if (!e != !n && (e > 1 || n > 1)) {
                                return null;
                            }
                            if (!o.mapTimeUnitsToUCUMCode[t]) {
                                t = `'${t}'`;
                            }
                        }
                        var a = i.valDataConverted(e[0]);
                        let r;
                        if ('number' == typeof a) {
                            n = new o(a, "'1'");
                        } else if (a instanceof o) {
                            n = a;
                        } else if ('boolean' == typeof a) {
                            n = new o(a ? 1 : 0, "'1'");
                        } else if ('string' == typeof a && (r = u.exec(a))) {
                            const e = r[d],
                                t = r[m],
                                i = r[p];
                            if (!i || o.mapTimeUnitsToUCUMCode[i]) {
                                n = new o(Number(e), t || i || "'1'");
                            }
                        }
                        if (n && t && n.unit !== t) {
                            n = o.convUnitTo(n.unit, n.value, t);
                        }
                    }
                    return n || [];
                };
                var f = /^[+-]?\d+(\.\d+)?$/;
                s.toDecimal = function (e) {
                    if (1 !== e.length) {
                        return [];
                    }
                    var t = i.valData(e[0]);
                    if (!1 === t) {
                        return 0;
                    }
                    if (!0 === t) {
                        return 1;
                    }
                    if ('number' == typeof t) {
                        return t;
                    }
                    if ('string' == typeof t && f.test(t)) {
                        return parseFloat(t);
                    } else {
                        return [];
                    }
                };
                s.toString = function (e) {
                    if (1 !== e.length) {
                        return [];
                    }
                    var t = i.valDataConverted(e[0]);
                    if (null == t) {
                        return [];
                    } else {
                        return t.toString();
                    }
                };

                function g(e) {
                    let t = e.slice(3);
                    s['to' + t] = function (n) {
                        var o = [];
                        if (n.length > 1) {
                            throw Error('to ' + t + ' called for a collection of length ' + n.length);
                        }
                        if (1 === n.length) {
                            var r = i.valData(n[0]);
                            if ('string' == typeof r) {
                                var s = a[e].checkString(r);
                                if (s) {
                                    o = s;
                                }
                            }
                        }
                        return o;
                    };
                }

                g('FP_Date');
                g('FP_DateTime');
                g('FP_Time');
                const h = ['true', 't', 'yes', 'y', '1', '1.0'].reduce((e, t) => {
                        e[t] = !0;
                        return e;
                    }, {}),
                    y = ['false', 'f', 'no', 'n', '0', '0.0'].reduce((e, t) => {
                        e[t] = !0;
                        return e;
                    }, {});
                s.toBoolean = function (e) {
                    if (1 !== e.length) {
                        return [];
                    }
                    const t = i.valData(e[0]);
                    switch (typeof t) {
                        case 'boolean':
                            return t;
                        case 'number':
                            if (1 === t) {
                                return !0;
                            }
                            if (0 === t) {
                                return !1;
                            }
                            break;
                        case 'string':
                            const e = t.toLowerCase();
                            if (h[e]) {
                                return !0;
                            }
                            if (y[e]) {
                                return !1;
                            }
                    }
                    return [];
                };
                s.createConvertsToFn = function (e, t) {
                    if ('string' == typeof t) {
                        return function (n) {
                            if (1 !== n.length) {
                                return [];
                            } else {
                                return typeof e(n) === t;
                            }
                        };
                    } else {
                        return function (n) {
                            if (1 !== n.length) {
                                return [];
                            } else {
                                return e(n) instanceof t;
                            }
                        };
                    }
                };
                const x = {
                    Integer: function (e) {
                        if (Number.isInteger(e)) {
                            return e;
                        }
                    },
                    Boolean: function (e) {
                        if (!0 === e || !1 === e) {
                            return e;
                        } else {
                            return !0;
                        }
                    },
                    Number: function (e) {
                        if ('number' == typeof e) {
                            return e;
                        }
                    },
                    String: function (e) {
                        if ('string' == typeof e) {
                            return e;
                        }
                    },
                    AnySingletonAtRoot: function (e) {
                        return e;
                    },
                };
                s.singleton = function (e, t) {
                    if (e.length > 1) {
                        throw new Error(
                            'Unexpected collection' + JSON.stringify(e) + '; expected singleton of type ' + t,
                        );
                    } else if (0 === e.length) {
                        return [];
                    }
                    const n = i.valData(e[0]);
                    if (null == n) {
                        return [];
                    }
                    const a = x[t];
                    if (a) {
                        const i = a(n);
                        if (void 0 !== i) {
                            return i;
                        }
                        throw new Error(`Expected ${t.toLowerCase()}, but got: ${JSON.stringify(e)}`);
                    }
                    throw new Error('Not supported type ' + t);
                };
                const _ = new Set();
                [
                    'instant',
                    'time',
                    'date',
                    'dateTime',
                    'base64Binary',
                    'decimal',
                    'integer64',
                    'boolean',
                    'string',
                    'code',
                    'markdown',
                    'id',
                    'integer',
                    'unsignedInt',
                    'positiveInt',
                    'uri',
                    'oid',
                    'uuid',
                    'canonical',
                    'url',
                    'Integer',
                    'Decimal',
                    'String',
                    'Date',
                    'DateTime',
                    'Time',
                ].forEach(e => _.add(e));
                s.hasValueFn = function (e) {
                    return 1 === e.length && null != i.valData(e[0]) && _.has(r.fromValue(e[0]).name);
                };
                e.exports = s;
            },
            3401: function (e, t, n) {
                const i = n(3367);
                var a = {
                    children: function (e) {
                        let t = this.model;
                        return e.reduce(function (e, n) {
                            let a = i.valData(n);
                            if (null == a) {
                                return e;
                            } else if ('object' == typeof a) {
                                for (var o of Object.keys(a)) {
                                    i.pushFn(e, i.makeChildResNodes(n, o, t));
                                }
                                return e;
                            } else {
                                return e;
                            }
                        }, []);
                    },
                    descendants: function (e) {
                        for (var t = a.children.call(this, e), n = []; t.length > 0; ) {
                            i.pushFn(n, t);
                            t = a.children.call(this, t);
                        }
                        return n;
                    },
                };
                e.exports = a;
            },
            9477: function (e) {
                let t = {};

                function n(e) {
                    const t = /(\d+)(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/.exec('' + +e);
                    if (!t) {
                        return 0;
                    }
                    const n = t[2],
                        i = t[3];
                    return Math.max(0, ('0' === n ? 0 : (n || '').length) - (i || 0));
                }

                function i(e, t) {
                    const n = Math.pow(10, t);
                    return Math.round(e * n) / n;
                }

                const a = (t.roundToMaxPrecision = function (e) {
                    return 1e-8 * Math.round(e / 1e-8);
                });
                t.isEquivalent = function (e, t) {
                    if (Number.isInteger(e) && Number.isInteger(t)) {
                        return e === t;
                    }
                    const a = Math.min(n(e), n(t));
                    if (0 === a) {
                        return Math.round(e) === Math.round(t);
                    } else {
                        return i(e, a) === i(t, a);
                    }
                };
                t.isEqual = function (e, t) {
                    return a(e) === a(t);
                };
                e.exports = t;
            },
            2915: function (e, t, n) {
                t.atn = n(9642);
                t.codepointat = n(7767);
                t.dfa = n(6098);
                t.fromcodepoint = n(7838);
                t.tree = n(2625);
                t.error = n(9365);
                t.Token = n(5537).Token;
                t.CommonToken = n(5537).CommonToken;
                t.InputStream = n(916);
                t.CommonTokenStream = n(8206);
                t.Lexer = n(7318);
                t.Parser = n(233);
                var i = n(6400);
                t.PredictionContextCache = i.PredictionContextCache;
                t.ParserRuleContext = n(72);
                t.Interval = n(7059).Interval;
                t.IntervalSet = n(7059).IntervalSet;
                t.Utils = n(2373);
                t.LL1Analyzer = n(3245).LL1Analyzer;
            },
            4177: function (e, t, n) {
                const i = n(2915),
                    a = [
                        '悋Ꜫ脳맭䅼㯧瞆',
                        '奤Aȃ\b\t\t',
                        '\t\t\t',
                        '\t\b\t\b\t\t\t\n\t\n\v\t\v',
                        '\f\t\f\r\t\r\t\t',
                        '\t\t\t\t',
                        '\t\t\t',
                        '\t\t\t\t',
                        '\t\t\t',
                        '\t\t \t !\t!"\t"#',
                        "\t#$\t$%\t%&\t&'\t'(\t()\t)",
                        '*\t*+\t+,\t,-\t-.\t./\t/0\t0',
                        '1\t12\t23\t34\t45\t56\t67\t7',
                        '8\t89\t9:\t:;\t;<\t<=\t=>\t>',
                        '?\t?@\t@A\tAB\tBC\tCD\tD',
                        '',
                        '\b',
                        '\b\t\t\t\t\n\n\n\n',
                        '\v\v\f\f\r\r\r',
                        '',
                        '',
                        '',
                        '',
                        '',
                        '',
                        '',
                        '',
                        '',
                        ' ',
                        ' !!!!!"""',
                        '"""##$$$$$',
                        '$%%%%%%%&',
                        "&&&&&&''((",
                        '((())))))*',
                        '****++++,,',
                        ',,,-------',
                        '.......///',
                        '/////////0',
                        '0000011111',
                        '1122222233',
                        '3334444445',
                        '5555555666',
                        '6666677777',
                        '7777777788',
                        '8888888888',
                        '88ƃ\n88ƅ\n88Ƈ\n888Ɗ',
                        '\n89999:::::',
                        '::::::ƚ\n:\r::ƛ',
                        ':ƞ\n::Ơ\n::Ƣ\n::::',
                        ':::::ƫ\n:;;Ʈ\n;',
                        ';;Ʊ\n;\f;;ƴ\v;<<<',
                        '<ƹ\n<\f<<Ƽ\v<<<==',
                        '==ǃ\n=\f==ǆ\v===>',
                        '>ǋ\n>\r>>ǌ>>>Ǒ\n>\r>>ǒ',
                        '>Ǖ\n>??ǘ\n?\r??Ǚ?',
                        '?@@@@@Ǣ\n@\f@@ǥ\v',
                        '@@@@@@AAAA',
                        'Aǰ\nA\fAAǳ\vAAABB',
                        'BBǺ\nBCCCCCCD',
                        'DǣE\t\v',
                        '\r\b\t\n\v\f\r',
                        "!#%')+",
                        '-/13579;= ?!A',
                        '"C#E$G%I&K\'M(O)Q*S+U,W-Y.[/]0_1a2c3e4g5i6k7m8o9q:su;w<y={>}',
                        '?@A\f',
                        '2;--//C\\aac|2;C\\aac|',
                        '^^bb))\v\f""',
                        '\f\f\n))11^^bbhhppttvv2;CHchȔ',
                        '',
                        '\t',
                        '\v\r',
                        '',
                        '',
                        '',
                        '',
                        '!',
                        '#%',
                        "')+",
                        '-/',
                        '13',
                        '57',
                        '9;',
                        '=?A',
                        'CE',
                        'GI',
                        'KM',
                        'OQ',
                        'SUW',
                        'Y[',
                        ']_',
                        'ac',
                        'eg',
                        'ikm',
                        'oq',
                        'uw',
                        'y{',
                        '}',
                        '',
                        '',
                        '\t\v',
                        '\r',
                        '',
                        '¡',
                        '£¦',
                        '¨ª',
                        '!­#°%³',
                        "'µ)·",
                        '+º-½',
                        '/À1É',
                        '3Í5Ð',
                        '7Ô9Ü;Þ',
                        '=à?â',
                        'AäCé',
                        'EïGñ',
                        'I÷Kþ',
                        'MąOćQČ',
                        'SĒUė',
                        'WěYĠ',
                        '[ħ]Į',
                        '_ĺaŀ',
                        'cŇeōgŒ',
                        'iŘkŠ',
                        'mŨoŵ',
                        'qƋsƏ',
                        'uƭwƵ',
                        'yƿ{Ǌ}Ǘ',
                        'ǝǫ',
                        'Ƕǻ',
                        'ȁ',
                        '0',
                        ']',
                        '_\b',
                        '-\n/',
                        '\f,',
                        '1',
                        'f',
                        'kx',
                        'o',
                        'qf',
                        ' ( ',
                        '¡¢~¢',
                        '£¤>¤¥',
                        '?¥¦§',
                        '>§¨©',
                        '@©ª«',
                        '@«¬?¬ ',
                        '­®k®¯u',
                        '¯"°±c',
                        '±²u²$³',
                        '´?´&µ¶',
                        '¶(·¸',
                        '#¸¹?¹*',
                        'º»#»¼',
                        '¼,½¾k',
                        '¾¿p¿.',
                        'ÀÁeÁÂqÂ',
                        'ÃpÃÄvÄÅ',
                        'cÅÆkÆÇ',
                        'pÇÈuÈ0',
                        'ÉÊcÊËp',
                        'ËÌfÌ2Í',
                        'ÎqÎÏtÏ4',
                        'ÐÑzÑÒ',
                        'qÒÓtÓ6',
                        'ÔÕkÕÖo',
                        'Ö×r×ØnØ',
                        'ÙkÙÚgÚÛ',
                        'uÛ8ÜÝ',
                        '*Ý:Þß+',
                        'ß<àá}',
                        'á>âã',
                        'ã@äåvå',
                        'ætæçwçè',
                        'gèBéê',
                        'hêëcëìn',
                        'ìíuíîg',
                        "îDïð'ð",
                        'Fñò&òó',
                        'vóôjôõ',
                        'kõöuöH',
                        '÷ø&øùk',
                        'ùúpúûfû',
                        'ügüýzýJ',
                        'þÿ&ÿĀ',
                        'vĀāqāĂv',
                        'ĂăcăĄn',
                        'ĄLąĆ.Ć',
                        'NćĈ{Ĉĉ',
                        'gĉĊcĊċ',
                        'tċPČčo',
                        'čĎqĎďp',
                        'ďĐvĐđjđ',
                        'RĒēyēĔ',
                        'gĔĕgĕĖ',
                        'mĖTėĘf',
                        'ĘęcęĚ{',
                        'ĚVěĜjĜ',
                        'ĝqĝĞwĞğ',
                        'tğXĠġ',
                        'oġĢkĢģp',
                        'ģĤwĤĥv',
                        'ĥĦgĦZħ',
                        'ĨuĨĩgĩĪ',
                        'eĪīqīĬ',
                        'pĬĭfĭ\\',
                        'Įįoįİk',
                        'İınıĲnĲ',
                        'ĳkĳĴuĴĵ',
                        'gĵĶeĶķ',
                        'qķĸpĸĹf',
                        'Ĺ^ĺĻ{',
                        'ĻļgļĽcĽ',
                        'ľtľĿuĿ`',
                        'ŀŁoŁł',
                        'qłŃpŃńv',
                        'ńŅjŅņu',
                        'ņbŇňyň',
                        'ŉgŉŊgŊŋ',
                        'mŋŌuŌd',
                        'ōŎfŎŏc',
                        'ŏŐ{Őőu',
                        'őfŒœjœ',
                        'ŔqŔŕwŕŖ',
                        'tŖŗuŗh',
                        'ŘřořŚk',
                        'ŚśpśŜw',
                        'ŜŝvŝŞgŞ',
                        'şuşjŠš',
                        'ušŢgŢţ',
                        'eţŤqŤťp',
                        'ťŦfŦŧu',
                        'ŧlŨũoũ',
                        'ŪkŪūnūŬ',
                        'nŬŭkŭŮ',
                        'uŮůgůŰe',
                        'ŰűqűŲp',
                        'ŲųfųŴuŴ',
                        'nŵŶBŶŷ',
                        '\tŷŸ\tŸŹ\t',
                        'ŹƆ\tźŻ/',
                        'Żż\tżƄ\t',
                        'Žž/žſ\tſ',
                        'Ƃ\tƀƁVƁƃ',
                        's:ƂƀƂƃ',
                        'ƃƅƄŽ',
                        'ƄƅƅƇ',
                        'ƆźƆƇ',
                        'ƇƉƈƊ',
                        '\\ƉƈƉƊ',
                        'ƊpƋƌ',
                        'BƌƍVƍƎs:',
                        'ƎrƏƐ\tƐ',
                        'ơ\tƑƒ<ƒƓ',
                        '\tƓƟ\tƔƕ',
                        '<ƕƖ\tƖƝ\t',
                        'Ɨƙ0Ƙƚ\t',
                        'ƙƘƚƛ',
                        'ƛƙƛƜ',
                        'ƜƞƝƗ',
                        'ƝƞƞƠ',
                        'ƟƔƟƠ',
                        'ƠƢơƑ',
                        'ơƢƢƪ',
                        'ƣƫ\\Ƥƥ\tƥ',
                        'Ʀ\tƦƧ\tƧƨ',
                        '<ƨƩ\tƩƫ\t',
                        'ƪƣƪƤ',
                        'ƪƫƫt',
                        'ƬƮ\tƭƬ',
                        'ƮƲƯƱ\t',
                        'ưƯƱƴ',
                        'ƲưƲƳ',
                        'ƳvƴƲ',
                        'Ƶƺbƶƹ',
                        'BƷƹ\nƸƶ',
                        'ƸƷƹƼ',
                        'ƺƸƺƻ',
                        'ƻƽƼƺ',
                        'ƽƾbƾx',
                        'ƿǄ)ǀǃBǁ',
                        'ǃ\nǂǀǂ',
                        'ǁǃǆǄ',
                        'ǂǄǅǅ',
                        'ǇǆǄǇ',
                        'ǈ)ǈzǉǋ',
                        '\tǊǉǋǌ',
                        'ǌǊǌǍ',
                        'Ǎǔǎǐ',
                        '0ǏǑ\tǐǏ',
                        'Ǒǒǒǐ',
                        'ǒǓǓǕ',
                        'ǔǎǔǕ',
                        'Ǖ|ǖǘ\t\b',
                        'ǗǖǘǙ',
                        'ǙǗǙǚ',
                        'ǚǛǛǜ\b?',
                        'ǜ~ǝǞ1Ǟ',
                        'ǟ,ǟǣǠ',
                        'Ǣ\vǡǠǢ',
                        'ǥǣǤǣ',
                        'ǡǤǦǥ',
                        'ǣǦǧ,ǧ',
                        'Ǩ1Ǩǩǩ',
                        'Ǫ\b@ǪǫǬ',
                        '1Ǭǭ1ǭǱ',
                        'Ǯǰ\n\tǯǮ',
                        'ǰǳǱǯ',
                        'ǱǲǲǴ',
                        'ǳǱǴǵ\bA',
                        'ǵǶǹ^',
                        'ǷǺ\t\nǸǺCǹ',
                        'ǷǹǸǺ',
                        'ǻǼwǼ',
                        'ǽDǽǾDǾǿ',
                        'DǿȀDȀ',
                        'ȁȂ\t\vȂ',
                        'ƂƄƆƉƛƝƟ',
                        'ơƪƭưƲƸƺǂǄǌǒǔ',
                        'ǙǣǱǹ',
                    ].join(''),
                    o = new i.atn.ATNDeserializer().deserialize(a),
                    r = o.decisionToState.map((e, t) => new i.dfa.DFA(e, t));

                class s extends i.Lexer {
                    static grammarFileName = 'FHIRPath.g4';
                    static channelNames = ['DEFAULT_TOKEN_CHANNEL', 'HIDDEN'];
                    static modeNames = ['DEFAULT_MODE'];
                    static literalNames = [
                        null,
                        "'.'",
                        "'['",
                        "']'",
                        "'+'",
                        "'-'",
                        "'*'",
                        "'/'",
                        "'div'",
                        "'mod'",
                        "'&'",
                        "'|'",
                        "'<='",
                        "'<'",
                        "'>'",
                        "'>='",
                        "'is'",
                        "'as'",
                        "'='",
                        "'~'",
                        "'!='",
                        "'!~'",
                        "'in'",
                        "'contains'",
                        "'and'",
                        "'or'",
                        "'xor'",
                        "'implies'",
                        "'('",
                        "')'",
                        "'{'",
                        "'}'",
                        "'true'",
                        "'false'",
                        "'%'",
                        "'$this'",
                        "'$index'",
                        "'$total'",
                        "','",
                        "'year'",
                        "'month'",
                        "'week'",
                        "'day'",
                        "'hour'",
                        "'minute'",
                        "'second'",
                        "'millisecond'",
                        "'years'",
                        "'months'",
                        "'weeks'",
                        "'days'",
                        "'hours'",
                        "'minutes'",
                        "'seconds'",
                        "'milliseconds'",
                    ];
                    static symbolicNames = [
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        'DATETIME',
                        'TIME',
                        'IDENTIFIER',
                        'DELIMITEDIDENTIFIER',
                        'STRING',
                        'NUMBER',
                        'WS',
                        'COMMENT',
                        'LINE_COMMENT',
                    ];
                    static ruleNames = [
                        'T__0',
                        'T__1',
                        'T__2',
                        'T__3',
                        'T__4',
                        'T__5',
                        'T__6',
                        'T__7',
                        'T__8',
                        'T__9',
                        'T__10',
                        'T__11',
                        'T__12',
                        'T__13',
                        'T__14',
                        'T__15',
                        'T__16',
                        'T__17',
                        'T__18',
                        'T__19',
                        'T__20',
                        'T__21',
                        'T__22',
                        'T__23',
                        'T__24',
                        'T__25',
                        'T__26',
                        'T__27',
                        'T__28',
                        'T__29',
                        'T__30',
                        'T__31',
                        'T__32',
                        'T__33',
                        'T__34',
                        'T__35',
                        'T__36',
                        'T__37',
                        'T__38',
                        'T__39',
                        'T__40',
                        'T__41',
                        'T__42',
                        'T__43',
                        'T__44',
                        'T__45',
                        'T__46',
                        'T__47',
                        'T__48',
                        'T__49',
                        'T__50',
                        'T__51',
                        'T__52',
                        'T__53',
                        'DATETIME',
                        'TIME',
                        'TIMEFORMAT',
                        'IDENTIFIER',
                        'DELIMITEDIDENTIFIER',
                        'STRING',
                        'NUMBER',
                        'WS',
                        'COMMENT',
                        'LINE_COMMENT',
                        'ESC',
                        'UNICODE',
                        'HEX',
                    ];

                    constructor(e) {
                        super(e);
                        this._interp = new i.atn.LexerATNSimulator(this, o, r, new i.PredictionContextCache());
                    }

                    get atn() {
                        return o;
                    }
                }

                s.EOF = i.Token.EOF;
                s.T__0 = 1;
                s.T__1 = 2;
                s.T__2 = 3;
                s.T__3 = 4;
                s.T__4 = 5;
                s.T__5 = 6;
                s.T__6 = 7;
                s.T__7 = 8;
                s.T__8 = 9;
                s.T__9 = 10;
                s.T__10 = 11;
                s.T__11 = 12;
                s.T__12 = 13;
                s.T__13 = 14;
                s.T__14 = 15;
                s.T__15 = 16;
                s.T__16 = 17;
                s.T__17 = 18;
                s.T__18 = 19;
                s.T__19 = 20;
                s.T__20 = 21;
                s.T__21 = 22;
                s.T__22 = 23;
                s.T__23 = 24;
                s.T__24 = 25;
                s.T__25 = 26;
                s.T__26 = 27;
                s.T__27 = 28;
                s.T__28 = 29;
                s.T__29 = 30;
                s.T__30 = 31;
                s.T__31 = 32;
                s.T__32 = 33;
                s.T__33 = 34;
                s.T__34 = 35;
                s.T__35 = 36;
                s.T__36 = 37;
                s.T__37 = 38;
                s.T__38 = 39;
                s.T__39 = 40;
                s.T__40 = 41;
                s.T__41 = 42;
                s.T__42 = 43;
                s.T__43 = 44;
                s.T__44 = 45;
                s.T__45 = 46;
                s.T__46 = 47;
                s.T__47 = 48;
                s.T__48 = 49;
                s.T__49 = 50;
                s.T__50 = 51;
                s.T__51 = 52;
                s.T__52 = 53;
                s.T__53 = 54;
                s.DATETIME = 55;
                s.TIME = 56;
                s.IDENTIFIER = 57;
                s.DELIMITEDIDENTIFIER = 58;
                s.STRING = 59;
                s.NUMBER = 60;
                s.WS = 61;
                s.COMMENT = 62;
                s.LINE_COMMENT = 63;
                e.exports = s;
            },
            603: function (e, t, n) {
                const i = n(2915);

                class a extends i.tree.ParseTreeListener {
                    enterEntireExpression(e) {}

                    exitEntireExpression(e) {}

                    enterIndexerExpression(e) {}

                    exitIndexerExpression(e) {}

                    enterPolarityExpression(e) {}

                    exitPolarityExpression(e) {}

                    enterAdditiveExpression(e) {}

                    exitAdditiveExpression(e) {}

                    enterMultiplicativeExpression(e) {}

                    exitMultiplicativeExpression(e) {}

                    enterUnionExpression(e) {}

                    exitUnionExpression(e) {}

                    enterOrExpression(e) {}

                    exitOrExpression(e) {}

                    enterAndExpression(e) {}

                    exitAndExpression(e) {}

                    enterMembershipExpression(e) {}

                    exitMembershipExpression(e) {}

                    enterInequalityExpression(e) {}

                    exitInequalityExpression(e) {}

                    enterInvocationExpression(e) {}

                    exitInvocationExpression(e) {}

                    enterEqualityExpression(e) {}

                    exitEqualityExpression(e) {}

                    enterImpliesExpression(e) {}

                    exitImpliesExpression(e) {}

                    enterTermExpression(e) {}

                    exitTermExpression(e) {}

                    enterTypeExpression(e) {}

                    exitTypeExpression(e) {}

                    enterInvocationTerm(e) {}

                    exitInvocationTerm(e) {}

                    enterLiteralTerm(e) {}

                    exitLiteralTerm(e) {}

                    enterExternalConstantTerm(e) {}

                    exitExternalConstantTerm(e) {}

                    enterParenthesizedTerm(e) {}

                    exitParenthesizedTerm(e) {}

                    enterNullLiteral(e) {}

                    exitNullLiteral(e) {}

                    enterBooleanLiteral(e) {}

                    exitBooleanLiteral(e) {}

                    enterStringLiteral(e) {}

                    exitStringLiteral(e) {}

                    enterNumberLiteral(e) {}

                    exitNumberLiteral(e) {}

                    enterDateTimeLiteral(e) {}

                    exitDateTimeLiteral(e) {}

                    enterTimeLiteral(e) {}

                    exitTimeLiteral(e) {}

                    enterQuantityLiteral(e) {}

                    exitQuantityLiteral(e) {}

                    enterExternalConstant(e) {}

                    exitExternalConstant(e) {}

                    enterMemberInvocation(e) {}

                    exitMemberInvocation(e) {}

                    enterFunctionInvocation(e) {}

                    exitFunctionInvocation(e) {}

                    enterThisInvocation(e) {}

                    exitThisInvocation(e) {}

                    enterIndexInvocation(e) {}

                    exitIndexInvocation(e) {}

                    enterTotalInvocation(e) {}

                    exitTotalInvocation(e) {}

                    enterFunctn(e) {}

                    exitFunctn(e) {}

                    enterParamList(e) {}

                    exitParamList(e) {}

                    enterQuantity(e) {}

                    exitQuantity(e) {}

                    enterUnit(e) {}

                    exitUnit(e) {}

                    enterDateTimePrecision(e) {}

                    exitDateTimePrecision(e) {}

                    enterPluralDateTimePrecision(e) {}

                    exitPluralDateTimePrecision(e) {}

                    enterTypeSpecifier(e) {}

                    exitTypeSpecifier(e) {}

                    enterQualifiedIdentifier(e) {}

                    exitQualifiedIdentifier(e) {}

                    enterIdentifier(e) {}

                    exitIdentifier(e) {}
                }

                e.exports = a;
            },
            4968: function (e, t, n) {
                const i = n(2915),
                    a = n(603),
                    o = [
                        '悋Ꜫ脳맭䅼㯧瞆',
                        '奤A\t\t',
                        '\t\t\t\t',
                        '\b\t\b\t\t\t\n\t\n\v\t\v\f\t\f',
                        '\r\t\r\t\t\t',
                        '',
                        '(\n',
                        '',
                        '',
                        '',
                        '',
                        '',
                        '',
                        'P\n\fS\v',
                        '\\',
                        '\n',
                        'f\n',
                        'k\n',
                        'r\n\b',
                        '\b\b\bw\n\b\b\b\t\t\t',
                        '\t~\n\t\f\t\t\v\t\n\n\n\n\n',
                        '\v\v\v\v\n\v',
                        '\f\f\r\r',
                        '\n\f',
                        '\v',
                        '\b\n\f',
                        '\b\v',
                        '\f\f',
                        '',
                        '"#)018',
                        ";<­ '",
                        '[\be',
                        '\ng\fqs',
                        'z',
                        '',
                        '',
                        '',
                        ' !!"',
                        '"#$\b$(',
                        "%&\t&(\r'#",
                        "'%(Q",
                        ')*\f\f*+\t+P\r,-\f\v',
                        '-.\t.P\f/0\f\n',
                        '01\r1P\v23\f\t',
                        '34\t4P\n56\f6',
                        '7\t7P\b89\f9:',
                        '\t:P;<\f',
                        '<==P>?\f',
                        '?@\t\b@PAB\f',
                        'BCCPDE\f',
                        'EFFP\fGH\f',
                        'HIIJJK',
                        'KPLM\f\bMN\t\t',
                        'NPO)O,',
                        'O/O2O5',
                        'O8O;',
                        'O>OAOD',
                        'OGOLPS',
                        'QOQRR',
                        'SQT\\\f',
                        'U\\\bV\\\nWX',
                        'XYYZZ\\',
                        '[T[U',
                        '[V[W\\',
                        ']^ ^f!_f\t\n',
                        '`f=af>bf9cf',
                        ':df\ne]e_',
                        'e`ea',
                        'ebeced',
                        'f\tgj$hk',
                        'ik=jhji',
                        'k\vlr',
                        'mr\bnr%or&',
                        "pr'qlqm",
                        'qnqoqp',
                        'r\rsttv',
                        'uw\tvu',
                        'vwwxxy',
                        'yz',
                        '{|(|~}{',
                        '~}',
                        '',
                        '>',
                        '\v',
                        '',
                        '\f\r',
                        '=',
                        '',
                        '\t\v',
                        '\t\f',
                        '',
                        '',
                        '',
                        '',
                        '',
                        '',
                        "\t\r'OQ[ejqv",
                        '',
                    ].join(''),
                    r = new i.atn.ATNDeserializer().deserialize(o),
                    s = r.decisionToState.map((e, t) => new i.dfa.DFA(e, t)),
                    c = new i.PredictionContextCache();

                class l extends i.Parser {
                    static grammarFileName = 'FHIRPath.g4';
                    static literalNames = [
                        null,
                        "'.'",
                        "'['",
                        "']'",
                        "'+'",
                        "'-'",
                        "'*'",
                        "'/'",
                        "'div'",
                        "'mod'",
                        "'&'",
                        "'|'",
                        "'<='",
                        "'<'",
                        "'>'",
                        "'>='",
                        "'is'",
                        "'as'",
                        "'='",
                        "'~'",
                        "'!='",
                        "'!~'",
                        "'in'",
                        "'contains'",
                        "'and'",
                        "'or'",
                        "'xor'",
                        "'implies'",
                        "'('",
                        "')'",
                        "'{'",
                        "'}'",
                        "'true'",
                        "'false'",
                        "'%'",
                        "'$this'",
                        "'$index'",
                        "'$total'",
                        "','",
                        "'year'",
                        "'month'",
                        "'week'",
                        "'day'",
                        "'hour'",
                        "'minute'",
                        "'second'",
                        "'millisecond'",
                        "'years'",
                        "'months'",
                        "'weeks'",
                        "'days'",
                        "'hours'",
                        "'minutes'",
                        "'seconds'",
                        "'milliseconds'",
                    ];
                    static symbolicNames = [
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        'DATETIME',
                        'TIME',
                        'IDENTIFIER',
                        'DELIMITEDIDENTIFIER',
                        'STRING',
                        'NUMBER',
                        'WS',
                        'COMMENT',
                        'LINE_COMMENT',
                    ];
                    static ruleNames = [
                        'entireExpression',
                        'expression',
                        'term',
                        'literal',
                        'externalConstant',
                        'invocation',
                        'functn',
                        'paramList',
                        'quantity',
                        'unit',
                        'dateTimePrecision',
                        'pluralDateTimePrecision',
                        'typeSpecifier',
                        'qualifiedIdentifier',
                        'identifier',
                    ];

                    constructor(e) {
                        super(e);
                        this._interp = new i.atn.ParserATNSimulator(this, r, s, c);
                        this.ruleNames = l.ruleNames;
                        this.literalNames = l.literalNames;
                        this.symbolicNames = l.symbolicNames;
                    }

                    get atn() {
                        return r;
                    }

                    sempred(e, t, n) {
                        if (1 === t) {
                            return this.expression_sempred(e, n);
                        } else {
                            throw 'No predicate with index:' + t;
                        }
                    }

                    expression_sempred(e, t) {
                        switch (t) {
                            case 0:
                                return this.precpred(this._ctx, 10);
                            case 1:
                                return this.precpred(this._ctx, 9);
                            case 2:
                                return this.precpred(this._ctx, 8);
                            case 3:
                                return this.precpred(this._ctx, 7);
                            case 4:
                                return this.precpred(this._ctx, 5);
                            case 5:
                                return this.precpred(this._ctx, 4);
                            case 6:
                                return this.precpred(this._ctx, 3);
                            case 7:
                                return this.precpred(this._ctx, 2);
                            case 8:
                                return this.precpred(this._ctx, 1);
                            case 9:
                                return this.precpred(this._ctx, 13);
                            case 10:
                                return this.precpred(this._ctx, 12);
                            case 11:
                                return this.precpred(this._ctx, 6);
                            default:
                                throw 'No predicate with index:' + t;
                        }
                    }

                    entireExpression() {
                        let e = new u(this, this._ctx, this.state);
                        this.enterRule(e, 0, l.RULE_entireExpression);
                        try {
                            this.enterOuterAlt(e, 1);
                            this.state = 30;
                            this.expression(0);
                            this.state = 31;
                            this.match(l.EOF);
                        } catch (t) {
                            if (t instanceof i.error.RecognitionException) {
                                e.exception = t;
                                this._errHandler.reportError(this, t);
                                this._errHandler.recover(this, t);
                            } else {
                                throw t;
                            }
                        } finally {
                            this.exitRule();
                        }
                        return e;
                    }

                    expression(e) {
                        if (void 0 === e) {
                            e = 0;
                        }
                        const t = this._ctx,
                            n = this.state;
                        let a = new d(this, this._ctx, n),
                            o = a;
                        this.enterRecursionRule(a, 2, l.RULE_expression, e);
                        var r = 0;
                        try {
                            this.enterOuterAlt(a, 1);
                            this.state = 37;
                            this._errHandler.sync(this);
                            switch (this._input.LA(1)) {
                                case l.T__15:
                                case l.T__16:
                                case l.T__21:
                                case l.T__22:
                                case l.T__27:
                                case l.T__29:
                                case l.T__31:
                                case l.T__32:
                                case l.T__33:
                                case l.T__34:
                                case l.T__35:
                                case l.T__36:
                                case l.DATETIME:
                                case l.TIME:
                                case l.IDENTIFIER:
                                case l.DELIMITEDIDENTIFIER:
                                case l.STRING:
                                case l.NUMBER:
                                    a = new v(this, a);
                                    this._ctx = a;
                                    o = a;
                                    this.state = 34;
                                    this.term();
                                    break;
                                case l.T__3:
                                case l.T__4:
                                    a = new p(this, a);
                                    this._ctx = a;
                                    o = a;
                                    this.state = 35;
                                    if ((r = this._input.LA(1)) !== l.T__3 && r !== l.T__4) {
                                        this._errHandler.recoverInline(this);
                                    } else {
                                        this._errHandler.reportMatch(this);
                                        this.consume();
                                    }
                                    this.state = 36;
                                    this.expression(11);
                                    break;
                                default:
                                    throw new i.error.NoViableAltException(this);
                            }
                            this._ctx.stop = this._input.LT(-1);
                            this.state = 79;
                            this._errHandler.sync(this);
                            for (
                                var s = this._interp.adaptivePredict(this._input, 2, this._ctx);
                                2 != s && s != i.atn.ATN.INVALID_ALT_NUMBER;

                            ) {
                                if (1 === s) {
                                    if (null !== this._parseListeners) {
                                        this.triggerExitRuleEvent();
                                    }
                                    o = a;
                                    this.state = 77;
                                    this._errHandler.sync(this);
                                    switch (this._interp.adaptivePredict(this._input, 1, this._ctx)) {
                                        case 1:
                                            a = new g(this, new d(this, t, n));
                                            this.pushNewRecursionContext(a, 2, l.RULE_expression);
                                            this.state = 39;
                                            if (!this.precpred(this._ctx, 10)) {
                                                throw new i.error.FailedPredicateException(
                                                    this,
                                                    'this.precpred(this._ctx, 10)',
                                                );
                                            }
                                            this.state = 40;
                                            if (
                                                -32 & (r = this._input.LA(1)) ||
                                                !(
                                                    (1 << r) &
                                                    ((1 << l.T__5) | (1 << l.T__6) | (1 << l.T__7) | (1 << l.T__8))
                                                )
                                            ) {
                                                this._errHandler.recoverInline(this);
                                            } else {
                                                this._errHandler.reportMatch(this);
                                                this.consume();
                                            }
                                            this.state = 41;
                                            this.expression(11);
                                            break;
                                        case 2:
                                            a = new f(this, new d(this, t, n));
                                            this.pushNewRecursionContext(a, 2, l.RULE_expression);
                                            this.state = 42;
                                            if (!this.precpred(this._ctx, 9)) {
                                                throw new i.error.FailedPredicateException(
                                                    this,
                                                    'this.precpred(this._ctx, 9)',
                                                );
                                            }
                                            this.state = 43;
                                            if (
                                                -32 & (r = this._input.LA(1)) ||
                                                !((1 << r) & ((1 << l.T__3) | (1 << l.T__4) | (1 << l.T__9)))
                                            ) {
                                                this._errHandler.recoverInline(this);
                                            } else {
                                                this._errHandler.reportMatch(this);
                                                this.consume();
                                            }
                                            this.state = 44;
                                            this.expression(10);
                                            break;
                                        case 3:
                                            a = new h(this, new d(this, t, n));
                                            this.pushNewRecursionContext(a, 2, l.RULE_expression);
                                            this.state = 45;
                                            if (!this.precpred(this._ctx, 8)) {
                                                throw new i.error.FailedPredicateException(
                                                    this,
                                                    'this.precpred(this._ctx, 8)',
                                                );
                                            }
                                            this.state = 46;
                                            this.match(l.T__10);
                                            this.state = 47;
                                            this.expression(9);
                                            break;
                                        case 4:
                                            a = new E(this, new d(this, t, n));
                                            this.pushNewRecursionContext(a, 2, l.RULE_expression);
                                            this.state = 48;
                                            if (!this.precpred(this._ctx, 7)) {
                                                throw new i.error.FailedPredicateException(
                                                    this,
                                                    'this.precpred(this._ctx, 7)',
                                                );
                                            }
                                            this.state = 49;
                                            if (
                                                -32 & (r = this._input.LA(1)) ||
                                                !(
                                                    (1 << r) &
                                                    ((1 << l.T__11) | (1 << l.T__12) | (1 << l.T__13) | (1 << l.T__14))
                                                )
                                            ) {
                                                this._errHandler.recoverInline(this);
                                            } else {
                                                this._errHandler.reportMatch(this);
                                                this.consume();
                                            }
                                            this.state = 50;
                                            this.expression(8);
                                            break;
                                        case 5:
                                            a = new S(this, new d(this, t, n));
                                            this.pushNewRecursionContext(a, 2, l.RULE_expression);
                                            this.state = 51;
                                            if (!this.precpred(this._ctx, 5)) {
                                                throw new i.error.FailedPredicateException(
                                                    this,
                                                    'this.precpred(this._ctx, 5)',
                                                );
                                            }
                                            this.state = 52;
                                            if (
                                                -32 & (r = this._input.LA(1)) ||
                                                !(
                                                    (1 << r) &
                                                    ((1 << l.T__17) | (1 << l.T__18) | (1 << l.T__19) | (1 << l.T__20))
                                                )
                                            ) {
                                                this._errHandler.recoverInline(this);
                                            } else {
                                                this._errHandler.reportMatch(this);
                                                this.consume();
                                            }
                                            this.state = 53;
                                            this.expression(6);
                                            break;
                                        case 6:
                                            a = new _(this, new d(this, t, n));
                                            this.pushNewRecursionContext(a, 2, l.RULE_expression);
                                            this.state = 54;
                                            if (!this.precpred(this._ctx, 4)) {
                                                throw new i.error.FailedPredicateException(
                                                    this,
                                                    'this.precpred(this._ctx, 4)',
                                                );
                                            }
                                            this.state = 55;
                                            if ((r = this._input.LA(1)) !== l.T__21 && r !== l.T__22) {
                                                this._errHandler.recoverInline(this);
                                            } else {
                                                this._errHandler.reportMatch(this);
                                                this.consume();
                                            }
                                            this.state = 56;
                                            this.expression(5);
                                            break;
                                        case 7:
                                            a = new x(this, new d(this, t, n));
                                            this.pushNewRecursionContext(a, 2, l.RULE_expression);
                                            this.state = 57;
                                            if (!this.precpred(this._ctx, 3)) {
                                                throw new i.error.FailedPredicateException(
                                                    this,
                                                    'this.precpred(this._ctx, 3)',
                                                );
                                            }
                                            this.state = 58;
                                            this.match(l.T__23);
                                            this.state = 59;
                                            this.expression(4);
                                            break;
                                        case 8:
                                            a = new y(this, new d(this, t, n));
                                            this.pushNewRecursionContext(a, 2, l.RULE_expression);
                                            this.state = 60;
                                            if (!this.precpred(this._ctx, 2)) {
                                                throw new i.error.FailedPredicateException(
                                                    this,
                                                    'this.precpred(this._ctx, 2)',
                                                );
                                            }
                                            this.state = 61;
                                            if ((r = this._input.LA(1)) !== l.T__24 && r !== l.T__25) {
                                                this._errHandler.recoverInline(this);
                                            } else {
                                                this._errHandler.reportMatch(this);
                                                this.consume();
                                            }
                                            this.state = 62;
                                            this.expression(3);
                                            break;
                                        case 9:
                                            a = new b(this, new d(this, t, n));
                                            this.pushNewRecursionContext(a, 2, l.RULE_expression);
                                            this.state = 63;
                                            if (!this.precpred(this._ctx, 1)) {
                                                throw new i.error.FailedPredicateException(
                                                    this,
                                                    'this.precpred(this._ctx, 1)',
                                                );
                                            }
                                            this.state = 64;
                                            this.match(l.T__26);
                                            this.state = 65;
                                            this.expression(2);
                                            break;
                                        case 10:
                                            a = new C(this, new d(this, t, n));
                                            this.pushNewRecursionContext(a, 2, l.RULE_expression);
                                            this.state = 66;
                                            if (!this.precpred(this._ctx, 13)) {
                                                throw new i.error.FailedPredicateException(
                                                    this,
                                                    'this.precpred(this._ctx, 13)',
                                                );
                                            }
                                            this.state = 67;
                                            this.match(l.T__0);
                                            this.state = 68;
                                            this.invocation();
                                            break;
                                        case 11:
                                            a = new m(this, new d(this, t, n));
                                            this.pushNewRecursionContext(a, 2, l.RULE_expression);
                                            this.state = 69;
                                            if (!this.precpred(this._ctx, 12)) {
                                                throw new i.error.FailedPredicateException(
                                                    this,
                                                    'this.precpred(this._ctx, 12)',
                                                );
                                            }
                                            this.state = 70;
                                            this.match(l.T__1);
                                            this.state = 71;
                                            this.expression(0);
                                            this.state = 72;
                                            this.match(l.T__2);
                                            break;
                                        case 12:
                                            a = new D(this, new d(this, t, n));
                                            this.pushNewRecursionContext(a, 2, l.RULE_expression);
                                            this.state = 74;
                                            if (!this.precpred(this._ctx, 6)) {
                                                throw new i.error.FailedPredicateException(
                                                    this,
                                                    'this.precpred(this._ctx, 6)',
                                                );
                                            }
                                            this.state = 75;
                                            if ((r = this._input.LA(1)) !== l.T__15 && r !== l.T__16) {
                                                this._errHandler.recoverInline(this);
                                            } else {
                                                this._errHandler.reportMatch(this);
                                                this.consume();
                                            }
                                            this.state = 76;
                                            this.typeSpecifier();
                                    }
                                }
                                this.state = 81;
                                this._errHandler.sync(this);
                                s = this._interp.adaptivePredict(this._input, 2, this._ctx);
                            }
                        } catch (e) {
                            if (e instanceof i.error.RecognitionException) {
                                a.exception = e;
                                this._errHandler.reportError(this, e);
                                this._errHandler.recover(this, e);
                            } else {
                                throw e;
                            }
                        } finally {
                            this.unrollRecursionContexts(t);
                        }
                        return a;
                    }

                    term() {
                        let e = new R(this, this._ctx, this.state);
                        this.enterRule(e, 4, l.RULE_term);
                        try {
                            this.state = 89;
                            this._errHandler.sync(this);
                            switch (this._input.LA(1)) {
                                case l.T__15:
                                case l.T__16:
                                case l.T__21:
                                case l.T__22:
                                case l.T__34:
                                case l.T__35:
                                case l.T__36:
                                case l.IDENTIFIER:
                                case l.DELIMITEDIDENTIFIER:
                                    e = new I(this, e);
                                    this.enterOuterAlt(e, 1);
                                    this.state = 82;
                                    this.invocation();
                                    break;
                                case l.T__29:
                                case l.T__31:
                                case l.T__32:
                                case l.DATETIME:
                                case l.TIME:
                                case l.STRING:
                                case l.NUMBER:
                                    e = new T(this, e);
                                    this.enterOuterAlt(e, 2);
                                    this.state = 83;
                                    this.literal();
                                    break;
                                case l.T__33:
                                    e = new M(this, e);
                                    this.enterOuterAlt(e, 3);
                                    this.state = 84;
                                    this.externalConstant();
                                    break;
                                case l.T__27:
                                    e = new k(this, e);
                                    this.enterOuterAlt(e, 4);
                                    this.state = 85;
                                    this.match(l.T__27);
                                    this.state = 86;
                                    this.expression(0);
                                    this.state = 87;
                                    this.match(l.T__28);
                                    break;
                                default:
                                    throw new i.error.NoViableAltException(this);
                            }
                        } catch (t) {
                            if (t instanceof i.error.RecognitionException) {
                                e.exception = t;
                                this._errHandler.reportError(this, t);
                                this._errHandler.recover(this, t);
                            } else {
                                throw t;
                            }
                        } finally {
                            this.exitRule();
                        }
                        return e;
                    }

                    literal() {
                        let e = new P(this, this._ctx, this.state);
                        this.enterRule(e, 6, l.RULE_literal);
                        var t = 0;
                        try {
                            this.state = 99;
                            this._errHandler.sync(this);
                            switch (this._interp.adaptivePredict(this._input, 4, this._ctx)) {
                                case 1:
                                    e = new A(this, e);
                                    this.enterOuterAlt(e, 1);
                                    this.state = 91;
                                    this.match(l.T__29);
                                    this.state = 92;
                                    this.match(l.T__30);
                                    break;
                                case 2:
                                    e = new Y(this, e);
                                    this.enterOuterAlt(e, 2);
                                    this.state = 93;
                                    if ((t = this._input.LA(1)) !== l.T__31 && t !== l.T__32) {
                                        this._errHandler.recoverInline(this);
                                    } else {
                                        this._errHandler.reportMatch(this);
                                        this.consume();
                                    }
                                    break;
                                case 3:
                                    e = new O(this, e);
                                    this.enterOuterAlt(e, 3);
                                    this.state = 94;
                                    this.match(l.STRING);
                                    break;
                                case 4:
                                    e = new B(this, e);
                                    this.enterOuterAlt(e, 4);
                                    this.state = 95;
                                    this.match(l.NUMBER);
                                    break;
                                case 5:
                                    e = new w(this, e);
                                    this.enterOuterAlt(e, 5);
                                    this.state = 96;
                                    this.match(l.DATETIME);
                                    break;
                                case 6:
                                    e = new L(this, e);
                                    this.enterOuterAlt(e, 6);
                                    this.state = 97;
                                    this.match(l.TIME);
                                    break;
                                case 7:
                                    e = new N(this, e);
                                    this.enterOuterAlt(e, 7);
                                    this.state = 98;
                                    this.quantity();
                            }
                        } catch (t) {
                            if (t instanceof i.error.RecognitionException) {
                                e.exception = t;
                                this._errHandler.reportError(this, t);
                                this._errHandler.recover(this, t);
                            } else {
                                throw t;
                            }
                        } finally {
                            this.exitRule();
                        }
                        return e;
                    }

                    externalConstant() {
                        let e = new q(this, this._ctx, this.state);
                        this.enterRule(e, 8, l.RULE_externalConstant);
                        try {
                            this.enterOuterAlt(e, 1);
                            this.state = 101;
                            this.match(l.T__33);
                            this.state = 104;
                            this._errHandler.sync(this);
                            switch (this._input.LA(1)) {
                                case l.T__15:
                                case l.T__16:
                                case l.T__21:
                                case l.T__22:
                                case l.IDENTIFIER:
                                case l.DELIMITEDIDENTIFIER:
                                    this.state = 102;
                                    this.identifier();
                                    break;
                                case l.STRING:
                                    this.state = 103;
                                    this.match(l.STRING);
                                    break;
                                default:
                                    throw new i.error.NoViableAltException(this);
                            }
                        } catch (t) {
                            if (t instanceof i.error.RecognitionException) {
                                e.exception = t;
                                this._errHandler.reportError(this, t);
                                this._errHandler.recover(this, t);
                            } else {
                                throw t;
                            }
                        } finally {
                            this.exitRule();
                        }
                        return e;
                    }

                    invocation() {
                        let e = new H(this, this._ctx, this.state);
                        this.enterRule(e, 10, l.RULE_invocation);
                        try {
                            this.state = 111;
                            this._errHandler.sync(this);
                            switch (this._interp.adaptivePredict(this._input, 6, this._ctx)) {
                                case 1:
                                    e = new Q(this, e);
                                    this.enterOuterAlt(e, 1);
                                    this.state = 106;
                                    this.identifier();
                                    break;
                                case 2:
                                    e = new V(this, e);
                                    this.enterOuterAlt(e, 2);
                                    this.state = 107;
                                    this.functn();
                                    break;
                                case 3:
                                    e = new F(this, e);
                                    this.enterOuterAlt(e, 3);
                                    this.state = 108;
                                    this.match(l.T__34);
                                    break;
                                case 4:
                                    e = new U(this, e);
                                    this.enterOuterAlt(e, 4);
                                    this.state = 109;
                                    this.match(l.T__35);
                                    break;
                                case 5:
                                    e = new j(this, e);
                                    this.enterOuterAlt(e, 5);
                                    this.state = 110;
                                    this.match(l.T__36);
                            }
                        } catch (t) {
                            if (t instanceof i.error.RecognitionException) {
                                e.exception = t;
                                this._errHandler.reportError(this, t);
                                this._errHandler.recover(this, t);
                            } else {
                                throw t;
                            }
                        } finally {
                            this.exitRule();
                        }
                        return e;
                    }

                    functn() {
                        let e = new G(this, this._ctx, this.state);
                        this.enterRule(e, 12, l.RULE_functn);
                        var t = 0;
                        try {
                            this.enterOuterAlt(e, 1);
                            this.state = 113;
                            this.identifier();
                            this.state = 114;
                            this.match(l.T__27);
                            this.state = 116;
                            this._errHandler.sync(this);
                            if (
                                (!(-32 & (t = this._input.LA(1))) &&
                                    (1 << t) &
                                        ((1 << l.T__3) |
                                            (1 << l.T__4) |
                                            (1 << l.T__15) |
                                            (1 << l.T__16) |
                                            (1 << l.T__21) |
                                            (1 << l.T__22) |
                                            (1 << l.T__27) |
                                            (1 << l.T__29))) ||
                                (!((t - 32) & -32) &&
                                    (1 << (t - 32)) &
                                        ((1 << (l.T__31 - 32)) |
                                            (1 << (l.T__32 - 32)) |
                                            (1 << (l.T__33 - 32)) |
                                            (1 << (l.T__34 - 32)) |
                                            (1 << (l.T__35 - 32)) |
                                            (1 << (l.T__36 - 32)) |
                                            (1 << (l.DATETIME - 32)) |
                                            (1 << (l.TIME - 32)) |
                                            (1 << (l.IDENTIFIER - 32)) |
                                            (1 << (l.DELIMITEDIDENTIFIER - 32)) |
                                            (1 << (l.STRING - 32)) |
                                            (1 << (l.NUMBER - 32))))
                            ) {
                                this.state = 115;
                                this.paramList();
                            }
                            this.state = 118;
                            this.match(l.T__28);
                        } catch (t) {
                            if (t instanceof i.error.RecognitionException) {
                                e.exception = t;
                                this._errHandler.reportError(this, t);
                                this._errHandler.recover(this, t);
                            } else {
                                throw t;
                            }
                        } finally {
                            this.exitRule();
                        }
                        return e;
                    }

                    paramList() {
                        let e = new z(this, this._ctx, this.state);
                        this.enterRule(e, 14, l.RULE_paramList);
                        var t = 0;
                        try {
                            this.enterOuterAlt(e, 1);
                            this.state = 120;
                            this.expression(0);
                            this.state = 125;
                            this._errHandler.sync(this);
                            t = this._input.LA(1);
                            for (; t === l.T__37; ) {
                                this.state = 121;
                                this.match(l.T__37);
                                this.state = 122;
                                this.expression(0);
                                this.state = 127;
                                this._errHandler.sync(this);
                                t = this._input.LA(1);
                            }
                        } catch (t) {
                            if (t instanceof i.error.RecognitionException) {
                                e.exception = t;
                                this._errHandler.reportError(this, t);
                                this._errHandler.recover(this, t);
                            } else {
                                throw t;
                            }
                        } finally {
                            this.exitRule();
                        }
                        return e;
                    }

                    quantity() {
                        let e = new W(this, this._ctx, this.state);
                        this.enterRule(e, 16, l.RULE_quantity);
                        try {
                            this.enterOuterAlt(e, 1);
                            this.state = 128;
                            this.match(l.NUMBER);
                            this.state = 130;
                            this._errHandler.sync(this);
                            if (1 === this._interp.adaptivePredict(this._input, 9, this._ctx)) {
                                this.state = 129;
                                this.unit();
                            }
                        } catch (t) {
                            if (t instanceof i.error.RecognitionException) {
                                e.exception = t;
                                this._errHandler.reportError(this, t);
                                this._errHandler.recover(this, t);
                            } else {
                                throw t;
                            }
                        } finally {
                            this.exitRule();
                        }
                        return e;
                    }

                    unit() {
                        let e = new K(this, this._ctx, this.state);
                        this.enterRule(e, 18, l.RULE_unit);
                        try {
                            this.state = 135;
                            this._errHandler.sync(this);
                            switch (this._input.LA(1)) {
                                case l.T__38:
                                case l.T__39:
                                case l.T__40:
                                case l.T__41:
                                case l.T__42:
                                case l.T__43:
                                case l.T__44:
                                case l.T__45:
                                    this.enterOuterAlt(e, 1);
                                    this.state = 132;
                                    this.dateTimePrecision();
                                    break;
                                case l.T__46:
                                case l.T__47:
                                case l.T__48:
                                case l.T__49:
                                case l.T__50:
                                case l.T__51:
                                case l.T__52:
                                case l.T__53:
                                    this.enterOuterAlt(e, 2);
                                    this.state = 133;
                                    this.pluralDateTimePrecision();
                                    break;
                                case l.STRING:
                                    this.enterOuterAlt(e, 3);
                                    this.state = 134;
                                    this.match(l.STRING);
                                    break;
                                default:
                                    throw new i.error.NoViableAltException(this);
                            }
                        } catch (t) {
                            if (t instanceof i.error.RecognitionException) {
                                e.exception = t;
                                this._errHandler.reportError(this, t);
                                this._errHandler.recover(this, t);
                            } else {
                                throw t;
                            }
                        } finally {
                            this.exitRule();
                        }
                        return e;
                    }

                    dateTimePrecision() {
                        let e = new J(this, this._ctx, this.state);
                        this.enterRule(e, 20, l.RULE_dateTimePrecision);
                        var t = 0;
                        try {
                            this.enterOuterAlt(e, 1);
                            this.state = 137;
                            if (
                                ((t = this._input.LA(1)) - 39) & -32 ||
                                !(
                                    (1 << (t - 39)) &
                                    ((1 << (l.T__38 - 39)) |
                                        (1 << (l.T__39 - 39)) |
                                        (1 << (l.T__40 - 39)) |
                                        (1 << (l.T__41 - 39)) |
                                        (1 << (l.T__42 - 39)) |
                                        (1 << (l.T__43 - 39)) |
                                        (1 << (l.T__44 - 39)) |
                                        (1 << (l.T__45 - 39)))
                                )
                            ) {
                                this._errHandler.recoverInline(this);
                            } else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                        } catch (t) {
                            if (t instanceof i.error.RecognitionException) {
                                e.exception = t;
                                this._errHandler.reportError(this, t);
                                this._errHandler.recover(this, t);
                            } else {
                                throw t;
                            }
                        } finally {
                            this.exitRule();
                        }
                        return e;
                    }

                    pluralDateTimePrecision() {
                        let e = new $(this, this._ctx, this.state);
                        this.enterRule(e, 22, l.RULE_pluralDateTimePrecision);
                        var t = 0;
                        try {
                            this.enterOuterAlt(e, 1);
                            this.state = 139;
                            if (
                                ((t = this._input.LA(1)) - 47) & -32 ||
                                !(
                                    (1 << (t - 47)) &
                                    ((1 << (l.T__46 - 47)) |
                                        (1 << (l.T__47 - 47)) |
                                        (1 << (l.T__48 - 47)) |
                                        (1 << (l.T__49 - 47)) |
                                        (1 << (l.T__50 - 47)) |
                                        (1 << (l.T__51 - 47)) |
                                        (1 << (l.T__52 - 47)) |
                                        (1 << (l.T__53 - 47)))
                                )
                            ) {
                                this._errHandler.recoverInline(this);
                            } else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                        } catch (t) {
                            if (t instanceof i.error.RecognitionException) {
                                e.exception = t;
                                this._errHandler.reportError(this, t);
                                this._errHandler.recover(this, t);
                            } else {
                                throw t;
                            }
                        } finally {
                            this.exitRule();
                        }
                        return e;
                    }

                    typeSpecifier() {
                        let e = new X(this, this._ctx, this.state);
                        this.enterRule(e, 24, l.RULE_typeSpecifier);
                        try {
                            this.enterOuterAlt(e, 1);
                            this.state = 141;
                            this.qualifiedIdentifier();
                        } catch (t) {
                            if (t instanceof i.error.RecognitionException) {
                                e.exception = t;
                                this._errHandler.reportError(this, t);
                                this._errHandler.recover(this, t);
                            } else {
                                throw t;
                            }
                        } finally {
                            this.exitRule();
                        }
                        return e;
                    }

                    qualifiedIdentifier() {
                        let e = new Z(this, this._ctx, this.state);
                        this.enterRule(e, 26, l.RULE_qualifiedIdentifier);
                        try {
                            this.enterOuterAlt(e, 1);
                            this.state = 143;
                            this.identifier();
                            this.state = 148;
                            this._errHandler.sync(this);
                            for (
                                var t = this._interp.adaptivePredict(this._input, 11, this._ctx);
                                2 != t && t != i.atn.ATN.INVALID_ALT_NUMBER;

                            ) {
                                if (1 === t) {
                                    this.state = 144;
                                    this.match(l.T__0);
                                    this.state = 145;
                                    this.identifier();
                                }
                                this.state = 150;
                                this._errHandler.sync(this);
                                t = this._interp.adaptivePredict(this._input, 11, this._ctx);
                            }
                        } catch (t) {
                            if (t instanceof i.error.RecognitionException) {
                                e.exception = t;
                                this._errHandler.reportError(this, t);
                                this._errHandler.recover(this, t);
                            } else {
                                throw t;
                            }
                        } finally {
                            this.exitRule();
                        }
                        return e;
                    }

                    identifier() {
                        let e = new ee(this, this._ctx, this.state);
                        this.enterRule(e, 28, l.RULE_identifier);
                        var t = 0;
                        try {
                            this.enterOuterAlt(e, 1);
                            this.state = 151;
                            if (
                                (-32 & (t = this._input.LA(1)) ||
                                    !(
                                        (1 << t) &
                                        ((1 << l.T__15) | (1 << l.T__16) | (1 << l.T__21) | (1 << l.T__22))
                                    )) &&
                                t !== l.IDENTIFIER &&
                                t !== l.DELIMITEDIDENTIFIER
                            ) {
                                this._errHandler.recoverInline(this);
                            } else {
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                        } catch (t) {
                            if (t instanceof i.error.RecognitionException) {
                                e.exception = t;
                                this._errHandler.reportError(this, t);
                                this._errHandler.recover(this, t);
                            } else {
                                throw t;
                            }
                        } finally {
                            this.exitRule();
                        }
                        return e;
                    }
                }

                l.EOF = i.Token.EOF;
                l.T__0 = 1;
                l.T__1 = 2;
                l.T__2 = 3;
                l.T__3 = 4;
                l.T__4 = 5;
                l.T__5 = 6;
                l.T__6 = 7;
                l.T__7 = 8;
                l.T__8 = 9;
                l.T__9 = 10;
                l.T__10 = 11;
                l.T__11 = 12;
                l.T__12 = 13;
                l.T__13 = 14;
                l.T__14 = 15;
                l.T__15 = 16;
                l.T__16 = 17;
                l.T__17 = 18;
                l.T__18 = 19;
                l.T__19 = 20;
                l.T__20 = 21;
                l.T__21 = 22;
                l.T__22 = 23;
                l.T__23 = 24;
                l.T__24 = 25;
                l.T__25 = 26;
                l.T__26 = 27;
                l.T__27 = 28;
                l.T__28 = 29;
                l.T__29 = 30;
                l.T__30 = 31;
                l.T__31 = 32;
                l.T__32 = 33;
                l.T__33 = 34;
                l.T__34 = 35;
                l.T__35 = 36;
                l.T__36 = 37;
                l.T__37 = 38;
                l.T__38 = 39;
                l.T__39 = 40;
                l.T__40 = 41;
                l.T__41 = 42;
                l.T__42 = 43;
                l.T__43 = 44;
                l.T__44 = 45;
                l.T__45 = 46;
                l.T__46 = 47;
                l.T__47 = 48;
                l.T__48 = 49;
                l.T__49 = 50;
                l.T__50 = 51;
                l.T__51 = 52;
                l.T__52 = 53;
                l.T__53 = 54;
                l.DATETIME = 55;
                l.TIME = 56;
                l.IDENTIFIER = 57;
                l.DELIMITEDIDENTIFIER = 58;
                l.STRING = 59;
                l.NUMBER = 60;
                l.WS = 61;
                l.COMMENT = 62;
                l.LINE_COMMENT = 63;
                l.RULE_entireExpression = 0;
                l.RULE_expression = 1;
                l.RULE_term = 2;
                l.RULE_literal = 3;
                l.RULE_externalConstant = 4;
                l.RULE_invocation = 5;
                l.RULE_functn = 6;
                l.RULE_paramList = 7;
                l.RULE_quantity = 8;
                l.RULE_unit = 9;
                l.RULE_dateTimePrecision = 10;
                l.RULE_pluralDateTimePrecision = 11;
                l.RULE_typeSpecifier = 12;
                l.RULE_qualifiedIdentifier = 13;
                l.RULE_identifier = 14;

                class u extends i.ParserRuleContext {
                    constructor(e, t, n) {
                        if (void 0 === t) {
                            t = null;
                        }
                        if (null == n) {
                            n = -1;
                        }
                        super(t, n);
                        this.parser = e;
                        this.ruleIndex = l.RULE_entireExpression;
                    }

                    expression() {
                        return this.getTypedRuleContext(d, 0);
                    }

                    EOF() {
                        return this.getToken(l.EOF, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterEntireExpression(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitEntireExpression(this);
                        }
                    }
                }

                class d extends i.ParserRuleContext {
                    constructor(e, t, n) {
                        if (void 0 === t) {
                            t = null;
                        }
                        if (null == n) {
                            n = -1;
                        }
                        super(t, n);
                        this.parser = e;
                        this.ruleIndex = l.RULE_expression;
                    }

                    copyFrom(e) {
                        super.copyFrom(e);
                    }
                }

                class m extends d {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    expression = function (e) {
                        if (void 0 === e) {
                            e = null;
                        }
                        if (null === e) {
                            return this.getTypedRuleContexts(d);
                        } else {
                            return this.getTypedRuleContext(d, e);
                        }
                    };

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterIndexerExpression(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitIndexerExpression(this);
                        }
                    }
                }

                l.IndexerExpressionContext = m;

                class p extends d {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    expression() {
                        return this.getTypedRuleContext(d, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterPolarityExpression(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitPolarityExpression(this);
                        }
                    }
                }

                l.PolarityExpressionContext = p;

                class f extends d {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    expression = function (e) {
                        if (void 0 === e) {
                            e = null;
                        }
                        if (null === e) {
                            return this.getTypedRuleContexts(d);
                        } else {
                            return this.getTypedRuleContext(d, e);
                        }
                    };

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterAdditiveExpression(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitAdditiveExpression(this);
                        }
                    }
                }

                l.AdditiveExpressionContext = f;

                class g extends d {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    expression = function (e) {
                        if (void 0 === e) {
                            e = null;
                        }
                        if (null === e) {
                            return this.getTypedRuleContexts(d);
                        } else {
                            return this.getTypedRuleContext(d, e);
                        }
                    };

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterMultiplicativeExpression(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitMultiplicativeExpression(this);
                        }
                    }
                }

                l.MultiplicativeExpressionContext = g;

                class h extends d {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    expression = function (e) {
                        if (void 0 === e) {
                            e = null;
                        }
                        if (null === e) {
                            return this.getTypedRuleContexts(d);
                        } else {
                            return this.getTypedRuleContext(d, e);
                        }
                    };

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterUnionExpression(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitUnionExpression(this);
                        }
                    }
                }

                l.UnionExpressionContext = h;

                class y extends d {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    expression = function (e) {
                        if (void 0 === e) {
                            e = null;
                        }
                        if (null === e) {
                            return this.getTypedRuleContexts(d);
                        } else {
                            return this.getTypedRuleContext(d, e);
                        }
                    };

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterOrExpression(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitOrExpression(this);
                        }
                    }
                }

                l.OrExpressionContext = y;

                class x extends d {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    expression = function (e) {
                        if (void 0 === e) {
                            e = null;
                        }
                        if (null === e) {
                            return this.getTypedRuleContexts(d);
                        } else {
                            return this.getTypedRuleContext(d, e);
                        }
                    };

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterAndExpression(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitAndExpression(this);
                        }
                    }
                }

                l.AndExpressionContext = x;

                class _ extends d {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    expression = function (e) {
                        if (void 0 === e) {
                            e = null;
                        }
                        if (null === e) {
                            return this.getTypedRuleContexts(d);
                        } else {
                            return this.getTypedRuleContext(d, e);
                        }
                    };

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterMembershipExpression(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitMembershipExpression(this);
                        }
                    }
                }

                l.MembershipExpressionContext = _;

                class E extends d {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    expression = function (e) {
                        if (void 0 === e) {
                            e = null;
                        }
                        if (null === e) {
                            return this.getTypedRuleContexts(d);
                        } else {
                            return this.getTypedRuleContext(d, e);
                        }
                    };

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterInequalityExpression(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitInequalityExpression(this);
                        }
                    }
                }

                l.InequalityExpressionContext = E;

                class C extends d {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    expression() {
                        return this.getTypedRuleContext(d, 0);
                    }

                    invocation() {
                        return this.getTypedRuleContext(H, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterInvocationExpression(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitInvocationExpression(this);
                        }
                    }
                }

                l.InvocationExpressionContext = C;

                class S extends d {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    expression = function (e) {
                        if (void 0 === e) {
                            e = null;
                        }
                        if (null === e) {
                            return this.getTypedRuleContexts(d);
                        } else {
                            return this.getTypedRuleContext(d, e);
                        }
                    };

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterEqualityExpression(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitEqualityExpression(this);
                        }
                    }
                }

                l.EqualityExpressionContext = S;

                class b extends d {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    expression = function (e) {
                        if (void 0 === e) {
                            e = null;
                        }
                        if (null === e) {
                            return this.getTypedRuleContexts(d);
                        } else {
                            return this.getTypedRuleContext(d, e);
                        }
                    };

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterImpliesExpression(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitImpliesExpression(this);
                        }
                    }
                }

                l.ImpliesExpressionContext = b;

                class v extends d {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    term() {
                        return this.getTypedRuleContext(R, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterTermExpression(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitTermExpression(this);
                        }
                    }
                }

                l.TermExpressionContext = v;

                class D extends d {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    expression() {
                        return this.getTypedRuleContext(d, 0);
                    }

                    typeSpecifier() {
                        return this.getTypedRuleContext(X, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterTypeExpression(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitTypeExpression(this);
                        }
                    }
                }

                l.TypeExpressionContext = D;

                class R extends i.ParserRuleContext {
                    constructor(e, t, n) {
                        if (void 0 === t) {
                            t = null;
                        }
                        if (null == n) {
                            n = -1;
                        }
                        super(t, n);
                        this.parser = e;
                        this.ruleIndex = l.RULE_term;
                    }

                    copyFrom(e) {
                        super.copyFrom(e);
                    }
                }

                class M extends R {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    externalConstant() {
                        return this.getTypedRuleContext(q, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterExternalConstantTerm(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitExternalConstantTerm(this);
                        }
                    }
                }

                l.ExternalConstantTermContext = M;

                class T extends R {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    literal() {
                        return this.getTypedRuleContext(P, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterLiteralTerm(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitLiteralTerm(this);
                        }
                    }
                }

                l.LiteralTermContext = T;

                class k extends R {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    expression() {
                        return this.getTypedRuleContext(d, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterParenthesizedTerm(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitParenthesizedTerm(this);
                        }
                    }
                }

                l.ParenthesizedTermContext = k;

                class I extends R {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    invocation() {
                        return this.getTypedRuleContext(H, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterInvocationTerm(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitInvocationTerm(this);
                        }
                    }
                }

                l.InvocationTermContext = I;

                class P extends i.ParserRuleContext {
                    constructor(e, t, n) {
                        if (void 0 === t) {
                            t = null;
                        }
                        if (null == n) {
                            n = -1;
                        }
                        super(t, n);
                        this.parser = e;
                        this.ruleIndex = l.RULE_literal;
                    }

                    copyFrom(e) {
                        super.copyFrom(e);
                    }
                }

                class L extends P {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    TIME() {
                        return this.getToken(l.TIME, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterTimeLiteral(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitTimeLiteral(this);
                        }
                    }
                }

                l.TimeLiteralContext = L;

                class A extends P {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterNullLiteral(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitNullLiteral(this);
                        }
                    }
                }

                l.NullLiteralContext = A;

                class w extends P {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    DATETIME() {
                        return this.getToken(l.DATETIME, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterDateTimeLiteral(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitDateTimeLiteral(this);
                        }
                    }
                }

                l.DateTimeLiteralContext = w;

                class O extends P {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    STRING() {
                        return this.getToken(l.STRING, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterStringLiteral(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitStringLiteral(this);
                        }
                    }
                }

                l.StringLiteralContext = O;

                class Y extends P {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterBooleanLiteral(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitBooleanLiteral(this);
                        }
                    }
                }

                l.BooleanLiteralContext = Y;

                class B extends P {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    NUMBER() {
                        return this.getToken(l.NUMBER, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterNumberLiteral(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitNumberLiteral(this);
                        }
                    }
                }

                l.NumberLiteralContext = B;

                class N extends P {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    quantity() {
                        return this.getTypedRuleContext(W, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterQuantityLiteral(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitQuantityLiteral(this);
                        }
                    }
                }

                l.QuantityLiteralContext = N;

                class q extends i.ParserRuleContext {
                    constructor(e, t, n) {
                        if (void 0 === t) {
                            t = null;
                        }
                        if (null == n) {
                            n = -1;
                        }
                        super(t, n);
                        this.parser = e;
                        this.ruleIndex = l.RULE_externalConstant;
                    }

                    identifier() {
                        return this.getTypedRuleContext(ee, 0);
                    }

                    STRING() {
                        return this.getToken(l.STRING, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterExternalConstant(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitExternalConstant(this);
                        }
                    }
                }

                class H extends i.ParserRuleContext {
                    constructor(e, t, n) {
                        if (void 0 === t) {
                            t = null;
                        }
                        if (null == n) {
                            n = -1;
                        }
                        super(t, n);
                        this.parser = e;
                        this.ruleIndex = l.RULE_invocation;
                    }

                    copyFrom(e) {
                        super.copyFrom(e);
                    }
                }

                class j extends H {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterTotalInvocation(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitTotalInvocation(this);
                        }
                    }
                }

                l.TotalInvocationContext = j;

                class F extends H {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterThisInvocation(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitThisInvocation(this);
                        }
                    }
                }

                l.ThisInvocationContext = F;

                class U extends H {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterIndexInvocation(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitIndexInvocation(this);
                        }
                    }
                }

                l.IndexInvocationContext = U;

                class V extends H {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    functn() {
                        return this.getTypedRuleContext(G, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterFunctionInvocation(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitFunctionInvocation(this);
                        }
                    }
                }

                l.FunctionInvocationContext = V;

                class Q extends H {
                    constructor(e, t) {
                        super(e);
                        super.copyFrom(t);
                    }

                    identifier() {
                        return this.getTypedRuleContext(ee, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterMemberInvocation(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitMemberInvocation(this);
                        }
                    }
                }

                l.MemberInvocationContext = Q;

                class G extends i.ParserRuleContext {
                    constructor(e, t, n) {
                        if (void 0 === t) {
                            t = null;
                        }
                        if (null == n) {
                            n = -1;
                        }
                        super(t, n);
                        this.parser = e;
                        this.ruleIndex = l.RULE_functn;
                    }

                    identifier() {
                        return this.getTypedRuleContext(ee, 0);
                    }

                    paramList() {
                        return this.getTypedRuleContext(z, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterFunctn(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitFunctn(this);
                        }
                    }
                }

                class z extends i.ParserRuleContext {
                    constructor(e, t, n) {
                        if (void 0 === t) {
                            t = null;
                        }
                        if (null == n) {
                            n = -1;
                        }
                        super(t, n);
                        this.parser = e;
                        this.ruleIndex = l.RULE_paramList;
                    }

                    expression = function (e) {
                        if (void 0 === e) {
                            e = null;
                        }
                        if (null === e) {
                            return this.getTypedRuleContexts(d);
                        } else {
                            return this.getTypedRuleContext(d, e);
                        }
                    };

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterParamList(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitParamList(this);
                        }
                    }
                }

                class W extends i.ParserRuleContext {
                    constructor(e, t, n) {
                        if (void 0 === t) {
                            t = null;
                        }
                        if (null == n) {
                            n = -1;
                        }
                        super(t, n);
                        this.parser = e;
                        this.ruleIndex = l.RULE_quantity;
                    }

                    NUMBER() {
                        return this.getToken(l.NUMBER, 0);
                    }

                    unit() {
                        return this.getTypedRuleContext(K, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterQuantity(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitQuantity(this);
                        }
                    }
                }

                class K extends i.ParserRuleContext {
                    constructor(e, t, n) {
                        if (void 0 === t) {
                            t = null;
                        }
                        if (null == n) {
                            n = -1;
                        }
                        super(t, n);
                        this.parser = e;
                        this.ruleIndex = l.RULE_unit;
                    }

                    dateTimePrecision() {
                        return this.getTypedRuleContext(J, 0);
                    }

                    pluralDateTimePrecision() {
                        return this.getTypedRuleContext($, 0);
                    }

                    STRING() {
                        return this.getToken(l.STRING, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterUnit(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitUnit(this);
                        }
                    }
                }

                class J extends i.ParserRuleContext {
                    constructor(e, t, n) {
                        if (void 0 === t) {
                            t = null;
                        }
                        if (null == n) {
                            n = -1;
                        }
                        super(t, n);
                        this.parser = e;
                        this.ruleIndex = l.RULE_dateTimePrecision;
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterDateTimePrecision(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitDateTimePrecision(this);
                        }
                    }
                }

                class $ extends i.ParserRuleContext {
                    constructor(e, t, n) {
                        if (void 0 === t) {
                            t = null;
                        }
                        if (null == n) {
                            n = -1;
                        }
                        super(t, n);
                        this.parser = e;
                        this.ruleIndex = l.RULE_pluralDateTimePrecision;
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterPluralDateTimePrecision(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitPluralDateTimePrecision(this);
                        }
                    }
                }

                class X extends i.ParserRuleContext {
                    constructor(e, t, n) {
                        if (void 0 === t) {
                            t = null;
                        }
                        if (null == n) {
                            n = -1;
                        }
                        super(t, n);
                        this.parser = e;
                        this.ruleIndex = l.RULE_typeSpecifier;
                    }

                    qualifiedIdentifier() {
                        return this.getTypedRuleContext(Z, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterTypeSpecifier(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitTypeSpecifier(this);
                        }
                    }
                }

                class Z extends i.ParserRuleContext {
                    constructor(e, t, n) {
                        if (void 0 === t) {
                            t = null;
                        }
                        if (null == n) {
                            n = -1;
                        }
                        super(t, n);
                        this.parser = e;
                        this.ruleIndex = l.RULE_qualifiedIdentifier;
                    }

                    identifier = function (e) {
                        if (void 0 === e) {
                            e = null;
                        }
                        if (null === e) {
                            return this.getTypedRuleContexts(ee);
                        } else {
                            return this.getTypedRuleContext(ee, e);
                        }
                    };

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterQualifiedIdentifier(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitQualifiedIdentifier(this);
                        }
                    }
                }

                class ee extends i.ParserRuleContext {
                    constructor(e, t, n) {
                        if (void 0 === t) {
                            t = null;
                        }
                        if (null == n) {
                            n = -1;
                        }
                        super(t, n);
                        this.parser = e;
                        this.ruleIndex = l.RULE_identifier;
                    }

                    IDENTIFIER() {
                        return this.getToken(l.IDENTIFIER, 0);
                    }

                    DELIMITEDIDENTIFIER() {
                        return this.getToken(l.DELIMITEDIDENTIFIER, 0);
                    }

                    enterRule(e) {
                        if (e instanceof a) {
                            e.enterIdentifier(this);
                        }
                    }

                    exitRule(e) {
                        if (e instanceof a) {
                            e.exitIdentifier(this);
                        }
                    }
                }

                l.EntireExpressionContext = u;
                l.ExpressionContext = d;
                l.TermContext = R;
                l.LiteralContext = P;
                l.ExternalConstantContext = q;
                l.InvocationContext = H;
                l.FunctnContext = G;
                l.ParamListContext = z;
                l.QuantityContext = W;
                l.UnitContext = K;
                l.DateTimePrecisionContext = J;
                l.PluralDateTimePrecisionContext = $;
                l.TypeSpecifierContext = X;
                l.QualifiedIdentifierContext = Z;
                l.IdentifierContext = ee;
                e.exports = l;
            },
            6031: function (e, t, n) {
                const i = n(2915),
                    a = n(4177),
                    o = n(4968),
                    r = n(603);

                class s extends i.error.ErrorListener {
                    constructor(e) {
                        super();
                        this.errors = e;
                    }

                    syntaxError(e, t, n, i, a, o) {
                        this.errors.push([e, t, n, i, a, o]);
                    }
                }

                e.exports = {
                    parse: function (e) {
                        var t = new i.InputStream(e),
                            n = new a(t),
                            c = new i.CommonTokenStream(n),
                            l = new o(c);
                        l.buildParseTrees = !0;
                        var u = [],
                            d = new s(u);
                        n.removeErrorListeners();
                        n.addErrorListener(d);
                        l.removeErrorListeners();
                        l.addErrorListener(d);
                        var m = l.entireExpression();

                        class p extends r {
                            constructor() {
                                super();
                            }
                        }

                        var f,
                            g = {},
                            h = [g];
                        for (let e of Object.getOwnPropertyNames(r.prototype)) {
                            if (e.startsWith('enter')) {
                                p.prototype[e] = function (t) {
                                    let n = h[h.length - 1],
                                        i = e.slice(5);
                                    (f = { type: i }).text = t.getText();
                                    if (!n.children) {
                                        n.children = [];
                                    }
                                    n.children.push(f);
                                    h.push(f);
                                    f.terminalNodeText = [];
                                    for (let e of t.children) {
                                        if (e.symbol) {
                                            f.terminalNodeText.push(e.getText());
                                        }
                                    }
                                };
                            } else if (e.startsWith('exit')) {
                                p.prototype[e] = function () {
                                    h.pop();
                                };
                            }
                        }
                        var y = new p();
                        i.tree.ParseTreeWalker.DEFAULT.walk(y, m);
                        if (u.length > 0) {
                            let e = [];
                            for (let t = 0, n = u.length; t < n; ++t) {
                                let n = u[t],
                                    i = 'line: ' + n[2] + '; column: ' + n[3] + '; message: ' + n[4];
                                e.push(i);
                            }
                            var x = new Error(e.join('\n'));
                            x.errors = u;
                            throw x;
                        }
                        return g;
                    },
                };
            },
            2844: function (e, t, n) {
                const i = Function.prototype.call.bind(Array.prototype.slice);
                Number.isInteger =
                    Number.isInteger ||
                    function (e) {
                        return 'number' == typeof e && isFinite(e) && Math.floor(e) === e;
                    };
                if (!String.prototype.startsWith) {
                    Object.defineProperty(String.prototype, 'startsWith', {
                        value: function (e, t) {
                            t = t || 0;
                            return this.indexOf(e, t) === t;
                        },
                    });
                }
                if (!String.prototype.endsWith) {
                    Object.defineProperty(String.prototype, 'endsWith', {
                        value: function (e, t) {
                            var n = this.toString();
                            if (void 0 === t || t > n.length) {
                                t = n.length;
                            }
                            t -= e.length;
                            var i = n.indexOf(e, t);
                            return -1 !== i && i === t;
                        },
                    });
                }
                if (!String.prototype.includes) {
                    Object.defineProperty(String.prototype, 'includes', {
                        value: function () {
                            return -1 !== this.indexOf.apply(this, arguments);
                        },
                    });
                }
                if (!Object.assign) {
                    Object.defineProperty(Object, 'assign', {
                        value: function (e) {
                            if (null == e) {
                                throw new TypeError('Cannot convert undefined or null to object');
                            }
                            return i(arguments, 1).reduce(function (e, t) {
                                Object.keys(Object(t)).forEach(function (n) {
                                    e[n] = t[n];
                                });
                                return e;
                            }, Object(e));
                        },
                    });
                }
                if ('undefined' == typeof btoa) {
                    n.g.btoa = function (e) {
                        return new Buffer.from(e, 'binary').toString('base64');
                    };
                }
                if ('undefined' == typeof atob) {
                    n.g.atob = function (e) {
                        return new Buffer.from(e, 'base64').toString('binary');
                    };
                }
            },
            1609: function (e) {
                let t = {
                    weight: function (e) {
                        if (!1 !== e && !e) {
                            return [];
                        }
                        const t = this.vars.scoreExt || this.processedVars.scoreExt,
                            n = t ? e => e.url === t : e => this.defaultScoreExts.includes(e.url),
                            i = [],
                            a = this.vars.questionnaire || this.processedVars.questionnaire?.data;
                        e.forEach(e => {
                            if (e?.data) {
                                const t = e.data.valueCoding;
                                let o = t;
                                if (!o) {
                                    const t = Object.keys(e.data).find(e => e.length > 5 && e.startsWith('value'));
                                    o = t ? e.data[t] : e._data?.extension ? e._data : e.data;
                                }
                                const r = o?.extension?.find(n)?.valueDecimal;
                                if (void 0 !== r) {
                                    i.push(r);
                                } else if (t) {
                                    const o = (function (e) {
                                        const t = [];
                                        for (; e.data?.linkId; ) {
                                            t.push(e.data.linkId);
                                            e = e.parentResNode;
                                        }
                                        return t;
                                    })(e.parentResNode);
                                    if (o.length) {
                                        if (a) {
                                            const r = (function (e, t) {
                                                    let n = e;
                                                    for (let e = t.length - 1; e >= 0; --e) {
                                                        n = n.item?.find(n => n.linkId === t[e]);
                                                        if (!n) {
                                                            return null;
                                                        }
                                                    }
                                                    return n;
                                                })(a, o),
                                                s = r?.answerOption?.find(
                                                    e =>
                                                        e.valueCoding.code === t.code &&
                                                        e.valueCoding.system === t.system,
                                                );
                                            if (s) {
                                                const e = s.extension?.find(n)?.valueDecimal;
                                                if (void 0 !== e) {
                                                    i.push(e);
                                                }
                                            } else {
                                                throw new Error(
                                                    'Questionnaire answerOption with this linkId was not found: ' +
                                                        e.parentResNode.data.linkId +
                                                        '.',
                                                );
                                            }
                                        } else {
                                            throw new Error('%questionnaire is needed but not specified.');
                                        }
                                    }
                                }
                            }
                        });
                        return i;
                    },
                };
                e.exports = t;
            },
            957: function (e, t, n) {
                const i = n(3367),
                    a = n(6251),
                    o = {},
                    r = {};
                o.indexOf = function (e, t) {
                    const n = a.singleton(e, 'String');
                    return i.isEmpty(t) || i.isEmpty(n) ? [] : n.indexOf(t);
                };
                o.substring = function (e, t, n) {
                    const o = a.singleton(e, 'String');
                    if (i.isEmpty(o) || i.isEmpty(t) || t < 0 || t >= o.length) {
                        return [];
                    }
                    if (void 0 === n || i.isEmpty(n)) {
                        return o.substring(t);
                    } else {
                        return o.substring(t, t + n);
                    }
                };
                o.startsWith = function (e, t) {
                    const n = a.singleton(e, 'String');
                    return i.isEmpty(t) || i.isEmpty(n) ? [] : n.startsWith(t);
                };
                o.endsWith = function (e, t) {
                    const n = a.singleton(e, 'String');
                    return i.isEmpty(t) || i.isEmpty(n) ? [] : n.endsWith(t);
                };
                o.containsFn = function (e, t) {
                    const n = a.singleton(e, 'String');
                    return i.isEmpty(t) || i.isEmpty(n) ? [] : n.includes(t);
                };
                o.upper = function (e) {
                    const t = a.singleton(e, 'String');
                    return i.isEmpty(t) ? [] : t.toUpperCase();
                };
                o.lower = function (e) {
                    const t = a.singleton(e, 'String');
                    return i.isEmpty(t) ? [] : t.toLowerCase();
                };
                o.joinFn = function (e, t) {
                    const n = [];
                    e.forEach(e => {
                        const t = i.valData(e);
                        if ('string' == typeof t) {
                            n.push(t);
                        } else if (null != t) {
                            throw new Error('Join requires a collection of strings.');
                        }
                    });
                    if (i.isEmpty(n)) {
                        return [];
                    }
                    if (void 0 === t) {
                        t = '';
                    }
                    return n.join(t);
                };
                o.splitFn = function (e, t) {
                    const n = a.singleton(e, 'String');
                    return i.isEmpty(n) ? [] : n.split(t);
                };
                o.trimFn = function (e) {
                    const t = a.singleton(e, 'String');
                    return i.isEmpty(t) ? [] : t.trim();
                };
                o.encodeFn = function (e, t) {
                    const n = a.singleton(e, 'String');
                    if (i.isEmpty(n)) {
                        return [];
                    }
                    if ('urlbase64' === t || 'base64url' === t) {
                        return btoa(n).replace(/\+/g, '-').replace(/\//g, '_');
                    }
                    if ('base64' === t) {
                        return btoa(n);
                    }
                    if ('hex' === t) {
                        return Array.from(n)
                            .map(e =>
                                e.charCodeAt(0) < 128
                                    ? e.charCodeAt(0).toString(16)
                                    : encodeURIComponent(e).replace(/%/g, ''),
                            )
                            .join('');
                    } else {
                        return [];
                    }
                };
                o.decodeFn = function (e, t) {
                    const n = a.singleton(e, 'String');
                    if (i.isEmpty(n)) {
                        return [];
                    }
                    if ('urlbase64' === t || 'base64url' === t) {
                        return atob(n.replace(/-/g, '+').replace(/_/g, '/'));
                    }
                    if ('base64' === t) {
                        return atob(n);
                    }
                    if ('hex' === t) {
                        if (n.length % 2 != 0) {
                            throw new Error("Decode 'hex' requires an even number of characters.");
                        }
                        return decodeURIComponent('%' + n.match(/.{2}/g).join('%'));
                    }
                    return [];
                };
                if (!1 === new RegExp('').dotAll) {
                    o.matches = function (e, t) {
                        const n = a.singleton(e, 'String');
                        if (i.isEmpty(t) || i.isEmpty(n)) {
                            return [];
                        }
                        return new RegExp(t, 'su').test(n);
                    };
                } else {
                    o.matches = function (e, t) {
                        const n = a.singleton(e, 'String');
                        if (i.isEmpty(t) || i.isEmpty(n)) {
                            return [];
                        }
                        return new RegExp(
                            (function (e) {
                                if (!r[e]) {
                                    r[e] = e.replace(/\./g, (e, t, n) => {
                                        const i = n
                                                .substr(0, t)
                                                .replace(/\\\\/g, '')
                                                .replace(/\\[\][]/g, ''),
                                            a = '\\' === i[i.length - 1],
                                            o = i.lastIndexOf('['),
                                            r = i.lastIndexOf(']');
                                        return a || o > r ? '.' : '[^]';
                                    });
                                }
                                return r[e];
                            })(t),
                            'u',
                        ).test(n);
                    };
                }
                o.replace = function (e, t, n) {
                    const o = a.singleton(e, 'String');
                    if (i.isEmpty(t) || i.isEmpty(n) || i.isEmpty(o)) {
                        return [];
                    }
                    const r = new RegExp(i.escapeStringForRegExp(t), 'g');
                    return o.replace(r, n);
                };
                o.replaceMatches = function (e, t, n) {
                    const o = a.singleton(e, 'String');
                    if (i.isEmpty(t) || i.isEmpty(n) || i.isEmpty(o)) {
                        return [];
                    }
                    const r = new RegExp(t, 'gu');
                    return o.replace(r, n);
                };
                o.length = function (e) {
                    const t = a.singleton(e, 'String');
                    return i.isEmpty(t) ? [] : t.length;
                };
                o.toChars = function (e) {
                    const t = a.singleton(e, 'String');
                    return i.isEmpty(t) ? [] : t.split('');
                };
                e.exports = o;
            },
            4808: function (e) {
                class t {
                    constructor(e) {
                        this.terminologyUrl = e;
                        this.invocationTable = t.invocationTable;
                    }

                    static invocationTable = {
                        validateVS: {
                            fn: t.validateVS,
                            arity: {
                                2: ['String', 'AnySingletonAtRoot'],
                                3: ['String', 'AnySingletonAtRoot', 'String'],
                            },
                        },
                    };

                    static validateVS(e, t, i, a = '') {
                        !(function (e) {
                            if (
                                e?.split('&').find(e => {
                                    const t = e.split('=');
                                    return (
                                        t.length <= 2 && t.find(e => encodeURIComponent(decodeURIComponent(e)) !== e)
                                    );
                                })
                            ) {
                                throw new Error(`"${e}" should be a valid URL-encoded string`);
                            }
                        })(a);
                        const o = {
                            Accept: 'application/fhir+json; charset=utf-8',
                            'Content-Type': 'application/fhir+json; charset=utf-8',
                        };
                        let r = new Headers({ Accept: 'application/fhir+json; charset=utf-8' });
                        const s = `${e[0].terminologyUrl}/ValueSet/$validate-code`;
                        let c;
                        if (i.coding) {
                            const e = {
                                resourceType: 'Parameters',
                                parameter: [
                                    { name: 'url', valueUri: t },
                                    { name: 'codeableConcept', valueCodeableConcept: i },
                                ],
                            };
                            r = new Headers(o);
                            c = fetch(s + (a ? '?' + a : ''), { method: 'POST', headers: r, body: JSON.stringify(e) });
                        } else if ('string' == typeof i) {
                            const o = new URLSearchParams({ url: t });
                            c = fetch(`${e[0].terminologyUrl}/ValueSet?${o.toString() + (a ? '&' + a : '')}`, {
                                headers: r,
                            })
                                .then(e => e.json())
                                .then(e => {
                                    const o =
                                        1 === e?.entry?.length &&
                                        (n(e.entry[0].resource.expansion?.contains) ||
                                            n(e.entry[0].resource.compose?.include));
                                    if (o) {
                                        const e = new URLSearchParams({ url: t, code: i, system: o });
                                        return fetch(`${s}?${e.toString() + (a ? '&' + a : '')}`, { headers: r });
                                    } else {
                                        throw new Error('The valueset does not have a single code system.');
                                    }
                                });
                        } else if (i.code) {
                            const e = new URLSearchParams({ url: t ?? '', system: i.system ?? '', code: i.code });
                            c = fetch(`${s}?${e.toString() + (a ? '&' + a : '')}`, { headers: r });
                        }
                        return Promise.resolve(c)
                            .then(e => e.json())
                            .then(e => {
                                if (e?.parameter) {
                                    return e;
                                }
                                throw new Error(e);
                            })
                            .catch(() => {
                                const e = (function (e, t) {
                                    if ('string' == typeof e) {
                                        return e + ' - ' + t;
                                    }
                                    if (e.code) {
                                        return e.system + '|' + e.code + ' - ' + t;
                                    }
                                    if (e.coding) {
                                        return e.coding.map(e => e.system + '|' + e.code).join(',') + ' - ' + t;
                                    }
                                    return;
                                })(i, t);
                                throw new Error('Failed to check membership: ' + e);
                            });
                    }
                }

                function n(e, t = void 0) {
                    if (e) {
                        for (let n = 0; n < e.length; ++n) {
                            if (!t) {
                                t = e[n].system;
                            } else if (t !== e[n].system) {
                                t = void 0;
                                break;
                            }
                        }
                    }
                    return t;
                }

                e.exports = t;
            },
            5457: function (e, t, n) {
                const i = n(6680),
                    a = n(6758).UcumLhcUtils.getInstance(),
                    o = n(9477);
                let r = '[0-9][0-9](\\:[0-9][0-9](\\:[0-9][0-9](\\.[0-9]+)?)?)?(Z|(\\+|-)[0-9][0-9]\\:[0-9][0-9])?',
                    s = new RegExp('^T?' + r + '$'),
                    c = new RegExp('^[0-9][0-9][0-9][0-9](-[0-9][0-9](-[0-9][0-9](T' + r + ')?)?)?Z?$'),
                    l = new RegExp('^[0-9][0-9][0-9][0-9](-[0-9][0-9](-[0-9][0-9])?)?$'),
                    u = new RegExp(
                        '^[0-9][0-9][0-9][0-9](-[0-9][0-9](-[0-9][0-9](T[0-9][0-9](\\:[0-9][0-9](\\:[0-9][0-9](\\.[0-9]+)?))(Z|(\\+|-)[0-9][0-9]\\:[0-9][0-9]))))$',
                    );

                class d {
                    equals() {
                        return !1;
                    }

                    equivalentTo() {
                        return !1;
                    }

                    toString() {
                        return this.asStr ? this.asStr : super.toString();
                    }

                    toJSON() {
                        return this.toString();
                    }

                    compare() {
                        throw 'Comparison not implemented for ' + this.constructor.name;
                    }

                    plus() {
                        throw 'Addition not implemented for ' + this.constructor.name;
                    }

                    mul() {
                        throw 'Multiplication not implemented for ' + this.constructor.name;
                    }

                    div() {
                        throw 'Division not implemented for ' + this.constructor.name;
                    }
                }

                class m extends d {
                    constructor(e, t) {
                        super();
                        this.asStr = e + ' ' + t;
                        this.value = e;
                        this.unit = t;
                    }

                    equals(e) {
                        if (!(e instanceof this.constructor)) {
                            return !1;
                        }
                        const t = m._calendarDuration2Seconds[this.unit],
                            n = m._calendarDuration2Seconds[e.unit];
                        if (!t != !n && (t > 1 || n > 1)) {
                            return null;
                        }
                        if (this.unit === e.unit) {
                            return o.isEqual(this.value, e.value);
                        }
                        const i = this._compareYearsAndMonths(e);
                        if (i) {
                            return i.isEqual;
                        }
                        const r = m.toUcumQuantity(this.value, this.unit),
                            s = m.toUcumQuantity(e.value, e.unit),
                            c = a.convertUnitTo(s.unit, s.value, r.unit);
                        if ('succeeded' !== c.status) {
                            return !1;
                        } else {
                            return o.isEqual(r.value, c.toVal);
                        }
                    }

                    equivalentTo(e) {
                        if (!(e instanceof this.constructor)) {
                            return !1;
                        }
                        if (this.unit === e.unit) {
                            return o.isEquivalent(this.value, e.value);
                        }
                        const t = m.getEquivalentUcumUnitCode(this.unit),
                            n = m.getEquivalentUcumUnitCode(e.unit),
                            i = a.convertUnitTo(n, e.value, t);
                        if ('succeeded' !== i.status) {
                            return !1;
                        } else {
                            return o.isEquivalent(this.value, i.toVal);
                        }
                    }

                    compare(e) {
                        if (this.unit === e.unit) {
                            return this.value - e.value;
                        }
                        const t = m._calendarDuration2Seconds[this.unit],
                            n = m._calendarDuration2Seconds[e.unit];
                        if (!t != !n && (t > 1 || n > 1)) {
                            return null;
                        }
                        const i = m.getEquivalentUcumUnitCode(this.unit),
                            o = m.getEquivalentUcumUnitCode(e.unit),
                            r = a.convertUnitTo(o, e.value, i);
                        if ('succeeded' !== r.status) {
                            return null;
                        } else {
                            return this.value - r.toVal;
                        }
                    }

                    plus(e) {
                        const t = m._yearMonthConversionFactor[this.unit],
                            n = m._yearMonthConversionFactor[e.unit];
                        if (t && n) {
                            return new m(this.value + (e.value * n) / t, this.unit);
                        }
                        const i = m._calendarDuration2Seconds[this.unit],
                            o = m._calendarDuration2Seconds[e.unit];
                        if (!i != !o && (i > 1 || o > 1)) {
                            return null;
                        }
                        const r = i ? 's' : this.unit.replace(p, ''),
                            s = (i || 1) * this.value,
                            c = o ? 's' : e.unit.replace(p, ''),
                            l = (o || 1) * e.value,
                            u = a.convertUnitTo(c, l, r);
                        if ('succeeded' !== u.status || u.fromUnit.isSpecial_ || u.toUnit.isSpecial_) {
                            return null;
                        } else {
                            return new m(s + u.toVal, r);
                        }
                    }

                    mul(e) {
                        const t = m._calendarDuration2Seconds[this.unit],
                            n = m._calendarDuration2Seconds[e.unit];
                        if ((t > 1 && "'1'" !== e.unit) || (n > 1 && "'1'" !== this.unit)) {
                            return null;
                        }
                        const i = this.convToUcumUnits(this, t);
                        if (!i) {
                            return null;
                        }
                        const a = this.convToUcumUnits(e, n);
                        if (!a) {
                            return null;
                        }
                        if ("'1'" === this.unit) {
                            return new m(this.value * e.value, e.unit);
                        } else if ("'1'" === e.unit) {
                            return new m(this.value * e.value, this.unit);
                        }
                        return new m(i.value * a.value, `'(${i.unit}).(${a.unit})'`);
                    }

                    div(e) {
                        if (0 === e.value) {
                            return null;
                        }
                        const t = m._calendarDuration2Seconds[this.unit],
                            n = m._calendarDuration2Seconds[e.unit];
                        if (t) {
                            if (n) {
                                const t = m._yearMonthConversionFactor[this.unit],
                                    n = m._yearMonthConversionFactor[e.unit];
                                if (t && n) {
                                    return new m((this.value * t) / (e.value * n), "'1'");
                                }
                            } else if ("'1'" === e.unit) {
                                return new m(this.value / e.value, this.unit);
                            } else if (t > 1) {
                                return null;
                            }
                        } else if (n > 1) {
                            return null;
                        }
                        const i = this.convToUcumUnits(this, t);
                        if (!i) {
                            return null;
                        }
                        const o = this.convToUcumUnits(e, n);
                        if (!o) {
                            return null;
                        }
                        const r = '1' === o.unit ? i.unit : `(${i.unit})/(${o.unit})`,
                            s = a.convertToBaseUnits(r, i.value / o.value);
                        if ('succeeded' !== s.status) {
                            return null;
                        } else {
                            return new m(
                                s.magnitude,
                                `'${
                                    Object.keys(s.unitToExp)
                                        .map(e => e + s.unitToExp[e])
                                        .join('.') || '1'
                                }'`,
                            );
                        }
                    }

                    convToUcumUnits(e, t) {
                        if (t) {
                            return { value: t * e.value, unit: 's' };
                        } else {
                            const t = e.unit.replace(p, ''),
                                n = a.convertToBaseUnits(t, e.value);
                            if ('succeeded' !== n.status || n.fromUnitIsSpecial) {
                                return null;
                            } else {
                                return {
                                    value: n.magnitude,
                                    unit:
                                        Object.keys(n.unitToExp)
                                            .map(e => e + n.unitToExp[e])
                                            .join('.') || '1',
                                };
                            }
                        }
                    }

                    _compareYearsAndMonths(e) {
                        const t = m._yearMonthConversionFactor[this.unit],
                            n = m._yearMonthConversionFactor[e.unit];
                        if (t && n) {
                            return { isEqual: o.isEqual(this.value * t, e.value * n) };
                        } else {
                            return null;
                        }
                    }
                }

                const p = /^'|'$/g;
                m.getEquivalentUcumUnitCode = function (e) {
                    return m.mapTimeUnitsToUCUMCode[e] || e.replace(p, '');
                };
                m.toUcumQuantity = function (e, t) {
                    const n = m._calendarDuration2Seconds[t];
                    if (n) {
                        return { value: n * e, unit: 's' };
                    } else {
                        return { value: e, unit: t.replace(p, '') };
                    }
                };
                m.convUnitTo = function (e, t, n) {
                    const i = m._yearMonthConversionFactor[e],
                        o = m._yearMonthConversionFactor[n];
                    if (i && o) {
                        return new m((i * t) / o, n);
                    }
                    const r = m._calendarDuration2Seconds[e],
                        s = m._calendarDuration2Seconds[n];
                    if (s) {
                        if (r) {
                            return new m((r * t) / s, n);
                        } else {
                            const i = a.convertUnitTo(e.replace(/^'|'$/g, ''), t, 's');
                            if ('succeeded' === i.status) {
                                return new m(i.toVal / s, n);
                            }
                        }
                    } else {
                        const i = r
                            ? a.convertUnitTo('s', r * t, n.replace(/^'|'$/g, ''))
                            : a.convertUnitTo(e.replace(/^'|'$/g, ''), t, n.replace(/^'|'$/g, ''));
                        if ('succeeded' === i.status) {
                            return new m(i.toVal, n);
                        }
                    }
                    return null;
                };
                m._calendarDuration2Seconds = {
                    years: 31536e3,
                    months: 2592e3,
                    weeks: 604800,
                    days: 86400,
                    hours: 3600,
                    minutes: 60,
                    seconds: 1,
                    milliseconds: 0.001,
                    year: 31536e3,
                    month: 2592e3,
                    week: 604800,
                    day: 86400,
                    hour: 3600,
                    minute: 60,
                    second: 1,
                    millisecond: 0.001,
                };
                m._yearMonthConversionFactor = { years: 12, months: 1, year: 12, month: 1 };
                m.dateTimeArithmeticDurationUnits = {
                    years: 'year',
                    months: 'month',
                    weeks: 'week',
                    days: 'day',
                    hours: 'hour',
                    minutes: 'minute',
                    seconds: 'second',
                    milliseconds: 'millisecond',
                    year: 'year',
                    month: 'month',
                    week: 'week',
                    day: 'day',
                    hour: 'hour',
                    minute: 'minute',
                    second: 'second',
                    millisecond: 'millisecond',
                    "'s'": 'second',
                    "'ms'": 'millisecond',
                };
                m.mapUCUMCodeToTimeUnits = {
                    a: 'year',
                    mo: 'month',
                    wk: 'week',
                    d: 'day',
                    h: 'hour',
                    min: 'minute',
                    s: 'second',
                    ms: 'millisecond',
                };
                m.mapTimeUnitsToUCUMCode = Object.keys(m.mapUCUMCodeToTimeUnits).reduce(function (e, t) {
                    e[m.mapUCUMCodeToTimeUnits[t]] = t;
                    e[m.mapUCUMCodeToTimeUnits[t] + 's'] = t;
                    return e;
                }, {});

                class f extends d {
                    constructor(e) {
                        super();
                        this.asStr = e;
                    }

                    plus(e) {
                        const t = e.unit;
                        let n = m.dateTimeArithmeticDurationUnits[t];
                        if (!n) {
                            throw new Error(
                                'For date/time arithmetic, the unit of the quantity must be one of the following time-based units: ' +
                                    Object.keys(m.dateTimeArithmeticDurationUnits),
                            );
                        }
                        const i = this.constructor,
                            a = i._timeUnitToDatePrecision[n];
                        if (void 0 === a) {
                            throw new Error(
                                'Unsupported unit for +.  The unit should be one of ' +
                                    Object.keys(i._timeUnitToDatePrecision).join(', ') +
                                    '.',
                            );
                        }
                        let o = e.value;
                        const r = i === h;
                        if (r ? a < 2 : a < 5) {
                            o = Math.trunc(o);
                        }
                        if (this._getPrecision() < a) {
                            const e = i._datePrecisionToTimeUnit[this._getPrecision()];
                            if ('second' !== e) {
                                const t = m.convUnitTo(n, o, e);
                                n = t.unit;
                                o = Math.trunc(t.value);
                            }
                        }
                        const s = f.timeUnitToAddFn[n](this._getDateObj(), o);
                        let c = this._getPrecision();
                        if (r) {
                            c += 3;
                        }
                        let l = g.isoDateTime(s, c);
                        if (r) {
                            l = l.slice(l.indexOf('T') + 1);
                        }
                        return new i(l);
                    }

                    equals(e) {
                        var t;
                        if (!(e instanceof this.constructor || this instanceof e.constructor)) {
                            t = !1;
                        } else {
                            var n = this._getPrecision(),
                                i = e._getPrecision();
                            if (n == i) {
                                t = this._getDateObj().getTime() == e._getDateObj().getTime();
                            } else {
                                var a = n <= i ? n : i,
                                    o = this._getDateObj().toISOString(),
                                    r = e._getDateObj().toISOString();
                                if (this.constructor === h) {
                                    a += 3;
                                    n += 3;
                                    i += 3;
                                }
                                for (
                                    var s = n > 2 ? new g(o)._getTimeParts() : this._getTimeParts(),
                                        c = i > 2 ? new g(r)._getTimeParts() : e._getTimeParts(),
                                        l = 0;
                                    l <= a && !1 !== t;
                                    ++l
                                ) {
                                    t = s[l] == c[l];
                                }
                                if (t) {
                                    t = void 0;
                                }
                            }
                        }
                        return t;
                    }

                    equivalentTo(e) {
                        var t = e instanceof this.constructor;
                        if (t) {
                            if ((t = this._getPrecision() == e._getPrecision())) {
                                t = this._getDateObj().getTime() == e._getDateObj().getTime();
                            }
                        }
                        return t;
                    }

                    compare(e) {
                        var t = this._getPrecision(),
                            n = e._getPrecision(),
                            i = t <= n ? this._getDateObj().getTime() : this._dateAtPrecision(n).getTime(),
                            a = n <= t ? e._getDateObj().getTime() : e._dateAtPrecision(t).getTime();
                        if (t !== n && i === a) {
                            return null;
                        } else {
                            return i - a;
                        }
                    }

                    _getPrecision() {
                        if (void 0 === this.precision) {
                            this._getMatchData();
                        }
                        return this.precision;
                    }

                    _getMatchData(e, t) {
                        if (void 0 === this.timeMatchData) {
                            this.timeMatchData = this.asStr.match(e);
                            if (this.timeMatchData) {
                                for (let e = t; e >= 0 && void 0 === this.precision; --e) {
                                    if (this.timeMatchData[e]) {
                                        this.precision = e;
                                    }
                                }
                            }
                        }
                        return this.timeMatchData;
                    }

                    _getTimeParts(e) {
                        var t = [];
                        t = [e[0]];
                        var n = e[4];
                        if (n) {
                            let e = t[0];
                            t[0] = e.slice(0, e.length - n.length);
                        }
                        var i = e[1];
                        if (i) {
                            let n = t[0];
                            t[0] = n.slice(0, n.length - i.length);
                            t[1] = i;
                            var a = e[2];
                            if (a) {
                                t[1] = i.slice(0, i.length - a.length);
                                t[2] = a;
                                var o = e[3];
                                if (o) {
                                    t[2] = a.slice(0, a.length - o.length);
                                    t[3] = o;
                                }
                            }
                        }
                        return t;
                    }

                    _getDateObj() {
                        if (!this.dateObj) {
                            var e = this._getPrecision();
                            this.dateObj = this._dateAtPrecision(e);
                        }
                        return this.dateObj;
                    }

                    _createDate(e, t, n, a, o, r, s, c) {
                        var l = new Date(e, t, n, a, o, r, s);
                        if (c) {
                            var u = l.getTimezoneOffset(),
                                d = 0;
                            if ('Z' != c) {
                                var m = c.split(':'),
                                    p = parseInt(m[0]);
                                d = parseInt(m[1]);
                                if (p < 0) {
                                    d = -d;
                                }
                                d += 60 * p;
                            }
                            l = i(l, -u - d);
                        }
                        return l;
                    }
                }

                f.timeUnitToAddFn = {
                    year: n(6331),
                    month: n(7332),
                    week: n(864),
                    day: n(4644),
                    hour: n(5030),
                    minute: n(6680),
                    second: n(1712),
                    millisecond: n(5949),
                };

                class g extends f {
                    constructor(e) {
                        super(e);
                    }

                    compare(e) {
                        if (!(e instanceof g)) {
                            throw 'Invalid comparison of a DateTime with something else';
                        }
                        return super.compare(e);
                    }

                    _getMatchData() {
                        return super._getMatchData(c, 5);
                    }

                    _getTimeParts() {
                        if (!this.timeParts) {
                            let t = this._getMatchData(),
                                n = t[0];
                            this.timeParts = [n];
                            var e = t[1];
                            if (e) {
                                this.timeParts[0] = n.slice(0, n.length - e.length);
                                this.timeParts[1] = e;
                                let i = t[2];
                                if (i) {
                                    this.timeParts[1] = e.slice(0, e.length - i.length);
                                    this.timeParts[2] = i;
                                    let n = t[3];
                                    if (n) {
                                        this.timeParts[2] = i.slice(0, i.length - n.length);
                                        if ('T' === n[0]) {
                                            t[3] = n.slice(1);
                                        }
                                        this.timeParts = this.timeParts.concat(super._getTimeParts(t.slice(3)));
                                    }
                                }
                            }
                        }
                        return this.timeParts;
                    }

                    _dateAtPrecision(e) {
                        var t = this._getTimeParts(),
                            n = this._getMatchData()[7],
                            i = this._getPrecision(),
                            a = parseInt(t[0]),
                            o = i > 0 ? parseInt(t[1].slice(1)) - 1 : 0,
                            r = i > 1 ? parseInt(t[2].slice(1)) : 1,
                            s = i > 2 ? parseInt(t[3]) : 0,
                            c = i > 3 ? parseInt(t[4].slice(1)) : 0,
                            l = i > 4 ? parseInt(t[5].slice(1)) : 0,
                            u = t.length > 6 ? parseInt(t[6].slice(1)) : 0,
                            d = this._createDate(a, o, r, s, c, l, u, n);
                        if (e < i) {
                            a = d.getFullYear();
                            o = e > 0 ? d.getMonth() : 0;
                            r = e > 1 ? d.getDate() : 1;
                            s = e > 2 ? d.getHours() : 0;
                            c = e > 3 ? d.getMinutes() : 0;
                            d = new Date(a, o, r, s, c);
                        }
                        return d;
                    }
                }

                g.checkString = function (e) {
                    let t = new g(e);
                    if (!t._getMatchData()) {
                        t = null;
                    }
                    return t;
                };
                g._timeUnitToDatePrecision = {
                    year: 0,
                    month: 1,
                    week: 2,
                    day: 2,
                    hour: 3,
                    minute: 4,
                    second: 5,
                    millisecond: 6,
                };
                g._datePrecisionToTimeUnit = ['year', 'month', 'day', 'hour', 'minute', 'second', 'millisecond'];

                class h extends f {
                    constructor(e) {
                        if ('T' == e[0]) {
                            e = e.slice(1);
                        }
                        super(e);
                    }

                    compare(e) {
                        if (!(e instanceof h)) {
                            throw 'Invalid comparison of a time with something else';
                        }
                        return super.compare(e);
                    }

                    _dateAtPrecision(e) {
                        var t = this._getTimeParts(),
                            n = this._getMatchData()[4],
                            i = this._getPrecision(),
                            a = 2010,
                            o = parseInt(t[0]),
                            r = i > 0 ? parseInt(t[1].slice(1)) : 0,
                            s = i > 1 ? parseInt(t[2].slice(1)) : 0,
                            c = t.length > 3 ? parseInt(t[3].slice(1)) : 0,
                            l = this._createDate(a, 0, 1, o, r, s, c, n);
                        if (n) {
                            l.setYear(a);
                            l.setMonth(0);
                            l.setDate(1);
                        }
                        if (e < i) {
                            o = l.getHours();
                            r = e > 0 ? l.getMinutes() : 0;
                            l = new Date(a, 0, 1, o, r);
                        }
                        return l;
                    }

                    _getMatchData() {
                        return super._getMatchData(s, 2);
                    }

                    _getTimeParts() {
                        if (!this.timeParts) {
                            this.timeParts = super._getTimeParts(this._getMatchData());
                        }
                        return this.timeParts;
                    }
                }

                h.checkString = function (e) {
                    let t = new h(e);
                    if (!t._getMatchData()) {
                        t = null;
                    }
                    return t;
                };
                h._timeUnitToDatePrecision = { hour: 0, minute: 1, second: 2, millisecond: 3 };
                h._datePrecisionToTimeUnit = ['hour', 'minute', 'second', 'millisecond'];

                function y(e, t) {
                    var n = e;
                    if (3 === t && e < 100) {
                        n = '0' + e;
                    }
                    if (e < 10) {
                        n = '0' + n;
                    }
                    return n;
                }

                g.isoDateTime = function (e, t) {
                    if (void 0 === t) {
                        t = 5;
                    }
                    var n = '' + e.getFullYear();
                    if (t > 0) {
                        n += '-' + y(e.getMonth() + 1);
                        if (t > 1) {
                            n += '-' + y(e.getDate());
                            if (t > 2) {
                                n += 'T' + g.isoTime(e, t - 3);
                            }
                        }
                    }
                    if (t > 2) {
                        var i = e.getTimezoneOffset(),
                            a = i < 0 ? '+' : '-',
                            o = (i = Math.abs(i)) % 60;
                        n += a + y((i - o) / 60) + ':' + y(o);
                    }
                    return n;
                };
                g.isoTime = function (e, t) {
                    if (void 0 === t) {
                        t = 2;
                    }
                    let n = '' + y(e.getHours());
                    if (t > 0) {
                        n += ':' + y(e.getMinutes());
                        if (t > 1) {
                            n += ':' + y(e.getSeconds());
                            if (e.getMilliseconds()) {
                                n += '.' + y(e.getMilliseconds(), 3);
                            }
                        }
                    }
                    return n;
                };

                class x extends g {
                    constructor(e) {
                        super(e);
                    }

                    _getMatchData() {
                        return f.prototype._getMatchData.apply(this, [l, 2]);
                    }
                }

                x.checkString = function (e) {
                    let t = new x(e);
                    if (!t._getMatchData()) {
                        t = null;
                    }
                    return t;
                };
                x.isoDate = function (e, t) {
                    if (void 0 === t || t > 2) {
                        t = 2;
                    }
                    return g.isoDateTime(e, t);
                };

                class _ extends g {
                    constructor(e) {
                        super(e);
                    }

                    _getMatchData() {
                        return f.prototype._getMatchData.apply(this, [u, 5]);
                    }
                }

                _.checkString = function (e) {
                    let t = new _(e);
                    if (!t._getMatchData()) {
                        t = null;
                    }
                    return t;
                };

                class E {
                    constructor(e, t, n, i, a) {
                        if (e?.resourceType) {
                            n = e.resourceType;
                            a = e.resourceType;
                        }
                        this.parentResNode = t || null;
                        this.path = n || null;
                        this.data = e;
                        this._data = i || {};
                        this.fhirNodeDataType = a || null;
                    }

                    getTypeInfo() {
                        if (!this.typeInfo) {
                            let e;
                            if (S.model) {
                                if (/^System\.(.*)$/.test(this.fhirNodeDataType)) {
                                    e = new S({ namespace: S.System, name: RegExp.$1 });
                                } else if (this.fhirNodeDataType) {
                                    e = new S({ namespace: S.FHIR, name: this.fhirNodeDataType });
                                }
                            }
                            this.typeInfo = e || S.createByValueInSystemNamespace(this.data);
                        }
                        return this.typeInfo;
                    }

                    toJSON() {
                        return JSON.stringify(this.data);
                    }

                    convertData() {
                        if (!this.convertedData) {
                            var e = this.data;
                            const t = S.typeToClassWithCheckString[this.path];
                            if (t) {
                                e = t.checkString(e) || e;
                            } else if (S.isType(this.path, 'Quantity')) {
                                if ('http://unitsofmeasure.org' === e?.system) {
                                    if ('number' == typeof e.value && 'string' == typeof e.code) {
                                        if (void 0 !== e.comparator) {
                                            throw new Error('Cannot convert a FHIR.Quantity that has a comparator');
                                        }
                                        e = new m(e.value, m.mapUCUMCodeToTimeUnits[e.code] || "'" + e.code + "'");
                                    }
                                }
                            }
                            this.convertedData = e;
                        }
                        return this.convertedData;
                    }
                }

                E.makeResNode = function (e, t, n, i, a = null) {
                    return e instanceof E ? e : new E(e, t, n, i, a);
                };
                const C = new Set();
                ['Boolean', 'String', 'Integer', 'Decimal', 'Date', 'DateTime', 'Time', 'Quantity'].forEach(e =>
                    C.add(e),
                );

                class S {
                    constructor({ name: e, namespace: t }) {
                        this.name = e;
                        this.namespace = t;
                    }

                    static model = null;

                    is(e) {
                        if (e instanceof S && (!this.namespace || !e.namespace || this.namespace === e.namespace)) {
                            return S.model && (!this.namespace || this.namespace === S.FHIR)
                                ? S.isType(this.name, e.name)
                                : this.name === e.name;
                        } else {
                            return !1;
                        }
                    }

                    toString() {
                        return (this.namespace ? this.namespace + '.' : '') + this.name;
                    }

                    isValid() {
                        let e = !1;
                        if ('System' === this.namespace) {
                            e = C.has(this.name);
                        } else if ('FHIR' === this.namespace) {
                            e = S.model?.availableTypes.has(this.name);
                        } else if (!this.namespace) {
                            e = C.has(this.name) || S.model?.availableTypes.has(this.name);
                        }
                        return e;
                    }
                }

                S.typeToClassWithCheckString = { date: x, dateTime: g, instant: _, time: h };
                S.isType = function (e, t) {
                    do {
                        if (e === t) {
                            return !0;
                        }
                    } while ((e = S.model?.type2Parent[e]));
                    return !1;
                };
                S.System = 'System';
                S.FHIR = 'FHIR';
                S.createByValueInSystemNamespace = function (e) {
                    let t = typeof e;
                    if (Number.isInteger(e)) {
                        t = 'integer';
                    } else if ('number' === t) {
                        t = 'decimal';
                    } else if (e instanceof x) {
                        t = 'date';
                    } else if (e instanceof g) {
                        t = 'dateTime';
                    } else if (e instanceof h) {
                        t = 'time';
                    } else if (e instanceof m) {
                        t = 'Quantity';
                    }
                    t = t.replace(/^\w/, e => e.toUpperCase());
                    return new S({ namespace: S.System, name: t });
                };
                S.fromValue = function (e) {
                    return e instanceof E ? e.getTypeInfo() : S.createByValueInSystemNamespace(e);
                };
                e.exports = {
                    FP_Type: d,
                    FP_TimeBase: f,
                    FP_Date: x,
                    FP_DateTime: g,
                    FP_Instant: _,
                    FP_Time: h,
                    FP_Quantity: m,
                    timeRE: s,
                    dateTimeRE: c,
                    ResourceNode: E,
                    TypeInfo: S,
                    typeFn: function (e) {
                        return e.map(e => S.fromValue(e));
                    },
                    isFn: function (e, t) {
                        if (0 === e.length) {
                            return [];
                        }
                        if (e.length > 1) {
                            throw new Error("Expected singleton on left side of 'is', got " + JSON.stringify(e));
                        }
                        return S.fromValue(e[0]).is(t);
                    },
                    asFn: function (e, t) {
                        if (0 === e.length) {
                            return [];
                        }
                        if (e.length > 1) {
                            throw new Error("Expected singleton on left side of 'as', got " + JSON.stringify(e));
                        }
                        return S.fromValue(e[0]).is(t) ? e : [];
                    },
                };
            },
            3367: function (e, t, n) {
                const i = {},
                    a = n(5457),
                    { ResourceNode: o } = a;
                i.raiseError = function (e, t) {
                    throw (t = t ? t + ': ' : '') + e;
                };
                i.assertOnlyOne = function (e, t) {
                    if (1 !== e.length) {
                        i.raiseError('Was expecting only one element but got ' + JSON.stringify(e), t);
                    }
                };
                i.assertType = function (e, t, n) {
                    let a = this.valData(e);
                    if (t.indexOf(typeof a) < 0) {
                        let a = t.length > 1 ? 'one of ' + t.join(', ') : t[0];
                        i.raiseError("Found type '" + typeof e + "' but was expecting " + a, n);
                    }
                    return a;
                };
                i.isEmpty = function (e) {
                    return Array.isArray(e) && 0 === e.length;
                };
                i.isSome = function (e) {
                    return null != e && !i.isEmpty(e);
                };
                i.isTrue = function (e) {
                    return null != e && (!0 === e || (1 === e.length && !0 === i.valData(e[0])));
                };
                i.isCapitalized = function (e) {
                    return e && e[0] === e[0].toUpperCase();
                };
                i.flatten = function (e) {
                    if (e.some(e => e instanceof Promise)) {
                        return Promise.all(e).then(e => r(e));
                    } else {
                        return r(e);
                    }
                };

                function r(e) {
                    return [].concat(...e);
                }

                i.arraify = function (e) {
                    if (Array.isArray(e)) {
                        return e;
                    }
                    if (i.isSome(e)) {
                        return [e];
                    } else {
                        return [];
                    }
                };
                i.resolveAndArraify = function (e) {
                    return e instanceof Promise ? e.then(e => i.arraify(e)) : i.arraify(e);
                };
                i.valData = function (e) {
                    return e instanceof o ? e.data : e;
                };
                i.valDataConverted = function (e) {
                    if (e instanceof o) {
                        e = e.convertData();
                    }
                    return e;
                };
                i.escapeStringForRegExp = function (e) {
                    return e.replace(/[-[\]{}()*+?.,\\/^$|#\s]/g, '\\$&');
                };
                i.pushFn = Function.prototype.apply.bind(Array.prototype.push);
                i.makeChildResNodes = function (e, t, n) {
                    let a,
                        r,
                        s = e.path + '.' + t;
                    if (n) {
                        let e = n.pathsDefinedElsewhere[s];
                        if (e) {
                            s = e;
                        }
                    }
                    let c = n && n.choiceTypePaths[s];
                    if (c) {
                        for (let n of c) {
                            let i = t + n;
                            a = e.data?.[i];
                            r = e.data?.['_' + i];
                            if (void 0 !== a || void 0 !== r) {
                                s += n;
                                break;
                            }
                        }
                    } else {
                        a = e.data?.[t];
                        r = e.data?.['_' + t];
                        if (void 0 === a && void 0 === r) {
                            a = e._data[t];
                        }
                        if ('extension' === t) {
                            s = 'Extension';
                        }
                    }
                    let l,
                        u = null;
                    if (n) {
                        u = n.path2Type[s];
                        s = n.path2TypeWithoutElements[s] || s;
                    }
                    if (i.isSome(a) || i.isSome(r)) {
                        if (Array.isArray(a)) {
                            l = a.map((t, n) => o.makeResNode(t, e, s, r && r[n], u));
                            const t = r?.length || 0;
                            for (let n = a.length; n < t; ++n) {
                                l.push(o.makeResNode(null, e, s, r[n], u));
                            }
                        } else if (null == a && Array.isArray(r)) {
                            l = r.map(t => o.makeResNode(null, e, s, t, u));
                        } else {
                            l = [o.makeResNode(a, e, s, r, u)];
                        }
                    } else {
                        l = [];
                    }
                    return l;
                };
                e.exports = i;
            },
            755: function (e, t, n) {
                'use strict';
                var i = n(403),
                    a = Object.prototype.toString,
                    o = Object.prototype.hasOwnProperty;
                e.exports = function (e, t, n) {
                    if (!i(t)) {
                        throw new TypeError('iterator must be a function');
                    }
                    var r;
                    if (arguments.length >= 3) {
                        r = n;
                    }
                    if ('[object Array]' === a.call(e)) {
                        !(function (e, t, n) {
                            for (var i = 0, a = e.length; i < a; i++) {
                                if (o.call(e, i)) {
                                    if (null == n) {
                                        t(e[i], i, e);
                                    } else {
                                        t.call(n, e[i], i, e);
                                    }
                                }
                            }
                        })(e, t, r);
                    } else if ('string' == typeof e) {
                        !(function (e, t, n) {
                            for (var i = 0, a = e.length; i < a; i++) {
                                if (null == n) {
                                    t(e.charAt(i), i, e);
                                } else {
                                    t.call(n, e.charAt(i), i, e);
                                }
                            }
                        })(e, t, r);
                    } else {
                        !(function (e, t, n) {
                            for (var i in e) {
                                if (o.call(e, i)) {
                                    if (null == n) {
                                        t(e[i], i, e);
                                    } else {
                                        t.call(n, e[i], i, e);
                                    }
                                }
                            }
                        })(e, t, r);
                    }
                };
            },
            5712: function (e) {
                'use strict';
                var t = Object.prototype.toString,
                    n = Math.max,
                    i = function (e, t) {
                        for (var n = [], i = 0; i < e.length; i += 1) {
                            n[i] = e[i];
                        }
                        for (var a = 0; a < t.length; a += 1) {
                            n[a + e.length] = t[a];
                        }
                        return n;
                    };
                e.exports = function (e) {
                    var a = this;
                    if ('function' != typeof a || '[object Function]' !== t.apply(a)) {
                        throw new TypeError('Function.prototype.bind called on incompatible ' + a);
                    }
                    for (
                        var o,
                            r = (function (e, t) {
                                for (var n = [], i = t || 0, a = 0; i < e.length; i += 1, a += 1) {
                                    n[a] = e[i];
                                }
                                return n;
                            })(arguments, 1),
                            s = n(0, a.length - r.length),
                            c = [],
                            l = 0;
                        l < s;
                        l++
                    ) {
                        c[l] = '$' + l;
                    }
                    o = Function(
                        'binder',
                        'return function (' +
                            (function (e, t) {
                                for (var n = '', i = 0; i < e.length; i += 1) {
                                    n += e[i];
                                    if (i + 1 < e.length) {
                                        n += t;
                                    }
                                }
                                return n;
                            })(c, ',') +
                            '){ return binder.apply(this,arguments); }',
                    )(function () {
                        if (this instanceof o) {
                            var t = a.apply(this, i(r, arguments));
                            if (Object(t) === t) {
                                return t;
                            } else {
                                return this;
                            }
                        }
                        return a.apply(e, i(r, arguments));
                    });
                    if (a.prototype) {
                        var u = function () {};
                        u.prototype = a.prototype;
                        o.prototype = new u();
                        u.prototype = null;
                    }
                    return o;
                };
            },
            9932: function (e, t, n) {
                'use strict';
                var i = n(5712);
                e.exports = Function.prototype.bind || i;
            },
            3999: function (e) {
                'use strict';
                var t = function () {
                        return 'string' == typeof function () {}.name;
                    },
                    n = Object.getOwnPropertyDescriptor;
                if (n) {
                    try {
                        n([], 'length');
                    } catch (e) {
                        n = null;
                    }
                }
                t.functionsHaveConfigurableNames = function () {
                    if (!t() || !n) {
                        return !1;
                    }
                    var e = n(function () {}, 'name');
                    return !!e && !!e.configurable;
                };
                var i = Function.prototype.bind;
                t.boundFunctionsHaveNames = function () {
                    return t() && 'function' == typeof i && '' !== function () {}.bind().name;
                };
                e.exports = t;
            },
            9718: function (e, t, n) {
                'use strict';
                var i,
                    a = n(6788),
                    o = n(8208),
                    r = n(5785),
                    s = n(7369),
                    c = n(4121),
                    l = n(4114),
                    u = n(9394),
                    d = Function,
                    m = function (e) {
                        try {
                            return d('"use strict"; return (' + e + ').constructor;')();
                        } catch (e) {}
                    },
                    p = Object.getOwnPropertyDescriptor;
                if (p) {
                    try {
                        p({}, '');
                    } catch (e) {
                        p = null;
                    }
                }
                var f = function () {
                        throw new l();
                    },
                    g = p
                        ? (function () {
                              try {
                                  return f;
                              } catch (e) {
                                  try {
                                      return p(arguments, 'callee').get;
                                  } catch (e) {
                                      return f;
                                  }
                              }
                          })()
                        : f,
                    h = n(1064)(),
                    y = n(7411)(),
                    x =
                        Object.getPrototypeOf ||
                        (y
                            ? function (e) {
                                  return e.__proto__;
                              }
                            : null),
                    _ = {},
                    E = 'undefined' == typeof Uint8Array || !x ? i : x(Uint8Array),
                    C = {
                        __proto__: null,
                        '%AggregateError%': 'undefined' == typeof AggregateError ? i : AggregateError,
                        '%Array%': Array,
                        '%ArrayBuffer%': 'undefined' == typeof ArrayBuffer ? i : ArrayBuffer,
                        '%ArrayIteratorPrototype%': h && x ? x([][Symbol.iterator]()) : i,
                        '%AsyncFromSyncIteratorPrototype%': i,
                        '%AsyncFunction%': _,
                        '%AsyncGenerator%': _,
                        '%AsyncGeneratorFunction%': _,
                        '%AsyncIteratorPrototype%': _,
                        '%Atomics%': 'undefined' == typeof Atomics ? i : Atomics,
                        '%BigInt%': 'undefined' == typeof BigInt ? i : BigInt,
                        '%BigInt64Array%': 'undefined' == typeof BigInt64Array ? i : BigInt64Array,
                        '%BigUint64Array%': 'undefined' == typeof BigUint64Array ? i : BigUint64Array,
                        '%Boolean%': Boolean,
                        '%DataView%': 'undefined' == typeof DataView ? i : DataView,
                        '%Date%': Date,
                        '%decodeURI%': decodeURI,
                        '%decodeURIComponent%': decodeURIComponent,
                        '%encodeURI%': encodeURI,
                        '%encodeURIComponent%': encodeURIComponent,
                        '%Error%': a,
                        '%eval%': eval,
                        '%EvalError%': o,
                        '%Float32Array%': 'undefined' == typeof Float32Array ? i : Float32Array,
                        '%Float64Array%': 'undefined' == typeof Float64Array ? i : Float64Array,
                        '%FinalizationRegistry%': 'undefined' == typeof FinalizationRegistry ? i : FinalizationRegistry,
                        '%Function%': d,
                        '%GeneratorFunction%': _,
                        '%Int8Array%': 'undefined' == typeof Int8Array ? i : Int8Array,
                        '%Int16Array%': 'undefined' == typeof Int16Array ? i : Int16Array,
                        '%Int32Array%': 'undefined' == typeof Int32Array ? i : Int32Array,
                        '%isFinite%': isFinite,
                        '%isNaN%': isNaN,
                        '%IteratorPrototype%': h && x ? x(x([][Symbol.iterator]())) : i,
                        '%JSON%': 'object' == typeof JSON ? JSON : i,
                        '%Map%': 'undefined' == typeof Map ? i : Map,
                        '%MapIteratorPrototype%':
                            'undefined' == typeof Map || !h || !x ? i : x(new Map()[Symbol.iterator]()),
                        '%Math%': Math,
                        '%Number%': Number,
                        '%Object%': Object,
                        '%parseFloat%': parseFloat,
                        '%parseInt%': parseInt,
                        '%Promise%': 'undefined' == typeof Promise ? i : Promise,
                        '%Proxy%': 'undefined' == typeof Proxy ? i : Proxy,
                        '%RangeError%': r,
                        '%ReferenceError%': s,
                        '%Reflect%': 'undefined' == typeof Reflect ? i : Reflect,
                        '%RegExp%': RegExp,
                        '%Set%': 'undefined' == typeof Set ? i : Set,
                        '%SetIteratorPrototype%':
                            'undefined' == typeof Set || !h || !x ? i : x(new Set()[Symbol.iterator]()),
                        '%SharedArrayBuffer%': 'undefined' == typeof SharedArrayBuffer ? i : SharedArrayBuffer,
                        '%String%': String,
                        '%StringIteratorPrototype%': h && x ? x(''[Symbol.iterator]()) : i,
                        '%Symbol%': h ? Symbol : i,
                        '%SyntaxError%': c,
                        '%ThrowTypeError%': g,
                        '%TypedArray%': E,
                        '%TypeError%': l,
                        '%Uint8Array%': 'undefined' == typeof Uint8Array ? i : Uint8Array,
                        '%Uint8ClampedArray%': 'undefined' == typeof Uint8ClampedArray ? i : Uint8ClampedArray,
                        '%Uint16Array%': 'undefined' == typeof Uint16Array ? i : Uint16Array,
                        '%Uint32Array%': 'undefined' == typeof Uint32Array ? i : Uint32Array,
                        '%URIError%': u,
                        '%WeakMap%': 'undefined' == typeof WeakMap ? i : WeakMap,
                        '%WeakRef%': 'undefined' == typeof WeakRef ? i : WeakRef,
                        '%WeakSet%': 'undefined' == typeof WeakSet ? i : WeakSet,
                    };
                if (x) {
                    try {
                        null.error;
                    } catch (e) {
                        var S = x(x(e));
                        C['%Error.prototype%'] = S;
                    }
                }
                var b = function e(t) {
                        var n;
                        if ('%AsyncFunction%' === t) {
                            n = m('async function () {}');
                        } else if ('%GeneratorFunction%' === t) {
                            n = m('function* () {}');
                        } else if ('%AsyncGeneratorFunction%' === t) {
                            n = m('async function* () {}');
                        } else if ('%AsyncGenerator%' === t) {
                            var i = e('%AsyncGeneratorFunction%');
                            if (i) {
                                n = i.prototype;
                            }
                        } else if ('%AsyncIteratorPrototype%' === t) {
                            var a = e('%AsyncGenerator%');
                            if (a && x) {
                                n = x(a.prototype);
                            }
                        }
                        C[t] = n;
                        return n;
                    },
                    v = {
                        __proto__: null,
                        '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
                        '%ArrayPrototype%': ['Array', 'prototype'],
                        '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
                        '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
                        '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
                        '%ArrayProto_values%': ['Array', 'prototype', 'values'],
                        '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
                        '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
                        '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
                        '%BooleanPrototype%': ['Boolean', 'prototype'],
                        '%DataViewPrototype%': ['DataView', 'prototype'],
                        '%DatePrototype%': ['Date', 'prototype'],
                        '%ErrorPrototype%': ['Error', 'prototype'],
                        '%EvalErrorPrototype%': ['EvalError', 'prototype'],
                        '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
                        '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
                        '%FunctionPrototype%': ['Function', 'prototype'],
                        '%Generator%': ['GeneratorFunction', 'prototype'],
                        '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
                        '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
                        '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
                        '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
                        '%JSONParse%': ['JSON', 'parse'],
                        '%JSONStringify%': ['JSON', 'stringify'],
                        '%MapPrototype%': ['Map', 'prototype'],
                        '%NumberPrototype%': ['Number', 'prototype'],
                        '%ObjectPrototype%': ['Object', 'prototype'],
                        '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
                        '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
                        '%PromisePrototype%': ['Promise', 'prototype'],
                        '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
                        '%Promise_all%': ['Promise', 'all'],
                        '%Promise_reject%': ['Promise', 'reject'],
                        '%Promise_resolve%': ['Promise', 'resolve'],
                        '%RangeErrorPrototype%': ['RangeError', 'prototype'],
                        '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
                        '%RegExpPrototype%': ['RegExp', 'prototype'],
                        '%SetPrototype%': ['Set', 'prototype'],
                        '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
                        '%StringPrototype%': ['String', 'prototype'],
                        '%SymbolPrototype%': ['Symbol', 'prototype'],
                        '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
                        '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
                        '%TypeErrorPrototype%': ['TypeError', 'prototype'],
                        '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
                        '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
                        '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
                        '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
                        '%URIErrorPrototype%': ['URIError', 'prototype'],
                        '%WeakMapPrototype%': ['WeakMap', 'prototype'],
                        '%WeakSetPrototype%': ['WeakSet', 'prototype'],
                    },
                    D = n(9932),
                    R = n(8396),
                    M = D.call(Function.call, Array.prototype.concat),
                    T = D.call(Function.apply, Array.prototype.splice),
                    k = D.call(Function.call, String.prototype.replace),
                    I = D.call(Function.call, String.prototype.slice),
                    P = D.call(Function.call, RegExp.prototype.exec),
                    L =
                        /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
                    A = /\\(\\)?/g,
                    w = function (e, t) {
                        var n,
                            i = e;
                        if (R(v, i)) {
                            i = '%' + (n = v[i])[0] + '%';
                        }
                        if (R(C, i)) {
                            var a = C[i];
                            if (a === _) {
                                a = b(i);
                            }
                            if (void 0 === a && !t) {
                                throw new l('intrinsic ' + e + ' exists, but is not available. Please file an issue!');
                            }
                            return { alias: n, name: i, value: a };
                        }
                        throw new c('intrinsic ' + e + ' does not exist!');
                    };
                e.exports = function (e, t) {
                    if ('string' != typeof e || 0 === e.length) {
                        throw new l('intrinsic name must be a non-empty string');
                    }
                    if (arguments.length > 1 && 'boolean' != typeof t) {
                        throw new l('"allowMissing" argument must be a boolean');
                    }
                    if (null === P(/^%?[^%]*%?$/, e)) {
                        throw new c(
                            '`%` may not be present anywhere but at the beginning and end of the intrinsic name',
                        );
                    }
                    var n = (function (e) {
                            var t = I(e, 0, 1),
                                n = I(e, -1);
                            if ('%' === t && '%' !== n) {
                                throw new c('invalid intrinsic syntax, expected closing `%`');
                            } else if ('%' === n && '%' !== t) {
                                throw new c('invalid intrinsic syntax, expected opening `%`');
                            }
                            var i = [];
                            k(e, L, function (e, t, n, a) {
                                i[i.length] = n ? k(a, A, '$1') : t || e;
                            });
                            return i;
                        })(e),
                        i = n.length > 0 ? n[0] : '',
                        a = w('%' + i + '%', t),
                        o = a.name,
                        r = a.value,
                        s = !1,
                        u = a.alias;
                    if (u) {
                        i = u[0];
                        T(n, M([0, 1], u));
                    }
                    for (var d = 1, m = !0; d < n.length; d += 1) {
                        var f = n[d],
                            g = I(f, 0, 1),
                            h = I(f, -1);
                        if (('"' === g || "'" === g || '`' === g || '"' === h || "'" === h || '`' === h) && g !== h) {
                            throw new c('property names with quotes must have matching quotes');
                        }
                        if ('constructor' === f || !m) {
                            s = !0;
                        }
                        if (R(C, (o = '%' + (i += '.' + f) + '%'))) {
                            r = C[o];
                        } else if (null != r) {
                            if (!(f in r)) {
                                if (!t) {
                                    throw new l(
                                        'base intrinsic for ' + e + ' exists, but the property is not available.',
                                    );
                                }
                                return;
                            }
                            if (p && d + 1 >= n.length) {
                                var y = p(r, f);
                                if ((m = !!y) && 'get' in y && !('originalValue' in y.get)) {
                                    r = y.get;
                                } else {
                                    r = r[f];
                                }
                            } else {
                                m = R(r, f);
                                r = r[f];
                            }
                            if (m && !s) {
                                C[o] = r;
                            }
                        }
                    }
                    return r;
                };
            },
            7570: function (e, t, n) {
                'use strict';
                var i = n(9718)('%Object.getOwnPropertyDescriptor%', !0);
                if (i) {
                    try {
                        i([], 'length');
                    } catch (e) {
                        i = null;
                    }
                }
                e.exports = i;
            },
            1269: function (e) {
                'use strict';
                var t = 'undefined' != typeof BigInt && BigInt;
                e.exports = function () {
                    return (
                        'function' == typeof t &&
                        'function' == typeof BigInt &&
                        'bigint' == typeof t(42) &&
                        'bigint' == typeof BigInt(42)
                    );
                };
            },
            6177: function (e, t, n) {
                'use strict';
                var i = n(70),
                    a = function () {
                        return !!i;
                    };
                a.hasArrayLengthDefineBug = function () {
                    if (!i) {
                        return null;
                    }
                    try {
                        return 1 !== i([], 'length', { value: 1 }).length;
                    } catch (e) {
                        return !0;
                    }
                };
                e.exports = a;
            },
            7411: function (e) {
                'use strict';
                var t = { __proto__: null, foo: {} },
                    n = Object;
                e.exports = function () {
                    return { __proto__: t }.foo === t.foo && !(t instanceof n);
                };
            },
            1064: function (e, t, n) {
                'use strict';
                var i = 'undefined' != typeof Symbol && Symbol,
                    a = n(2698);
                e.exports = function () {
                    if ('function' != typeof i) {
                        return !1;
                    }
                    if ('function' != typeof Symbol) {
                        return !1;
                    }
                    if ('symbol' != typeof i('foo')) {
                        return !1;
                    }
                    if ('symbol' != typeof Symbol('bar')) {
                        return !1;
                    } else {
                        return a();
                    }
                };
            },
            2698: function (e) {
                'use strict';
                e.exports = function () {
                    if ('function' != typeof Symbol || 'function' != typeof Object.getOwnPropertySymbols) {
                        return !1;
                    }
                    if ('symbol' == typeof Symbol.iterator) {
                        return !0;
                    }
                    var e = {},
                        t = Symbol('test'),
                        n = Object(t);
                    if ('string' == typeof t) {
                        return !1;
                    }
                    if ('[object Symbol]' !== Object.prototype.toString.call(t)) {
                        return !1;
                    }
                    if ('[object Symbol]' !== Object.prototype.toString.call(n)) {
                        return !1;
                    }
                    e[t] = 42;
                    for (t in e) {
                        return !1;
                    }
                    if ('function' == typeof Object.keys && 0 !== Object.keys(e).length) {
                        return !1;
                    }
                    if ('function' == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) {
                        return !1;
                    }
                    var i = Object.getOwnPropertySymbols(e);
                    if (1 !== i.length || i[0] !== t) {
                        return !1;
                    }
                    if (!Object.prototype.propertyIsEnumerable.call(e, t)) {
                        return !1;
                    }
                    if ('function' == typeof Object.getOwnPropertyDescriptor) {
                        var a = Object.getOwnPropertyDescriptor(e, t);
                        if (42 !== a.value || !0 !== a.enumerable) {
                            return !1;
                        }
                    }
                    return !0;
                };
            },
            4903: function (e, t, n) {
                'use strict';
                var i = n(2698);
                e.exports = function () {
                    return i() && !!Symbol.toStringTag;
                };
            },
            8396: function (e, t, n) {
                'use strict';
                var i = Function.prototype.call,
                    a = Object.prototype.hasOwnProperty,
                    o = n(9932);
                e.exports = o.call(i, a);
            },
            5772: function (e, t, n) {
                'use strict';
                var i = n(8396),
                    a = n(1233)(),
                    o = n(4114),
                    r = {
                        assert: function (e, t) {
                            if (!e || ('object' != typeof e && 'function' != typeof e)) {
                                throw new o('`O` is not an object');
                            }
                            if ('string' != typeof t) {
                                throw new o('`slot` must be a string');
                            }
                            a.assert(e);
                            if (!r.has(e, t)) {
                                throw new o('`' + t + '` is not present on `O`');
                            }
                        },
                        get: function (e, t) {
                            if (!e || ('object' != typeof e && 'function' != typeof e)) {
                                throw new o('`O` is not an object');
                            }
                            if ('string' != typeof t) {
                                throw new o('`slot` must be a string');
                            }
                            var n = a.get(e);
                            return n && n['$' + t];
                        },
                        has: function (e, t) {
                            if (!e || ('object' != typeof e && 'function' != typeof e)) {
                                throw new o('`O` is not an object');
                            }
                            if ('string' != typeof t) {
                                throw new o('`slot` must be a string');
                            }
                            var n = a.get(e);
                            return !!n && i(n, '$' + t);
                        },
                        set: function (e, t, n) {
                            if (!e || ('object' != typeof e && 'function' != typeof e)) {
                                throw new o('`O` is not an object');
                            }
                            if ('string' != typeof t) {
                                throw new o('`slot` must be a string');
                            }
                            var i = a.get(e);
                            if (!i) {
                                i = {};
                                a.set(e, i);
                            }
                            i['$' + t] = n;
                        },
                    };
                if (Object.freeze) {
                    Object.freeze(r);
                }
                e.exports = r;
            },
            3929: function (e, t, n) {
                'use strict';
                var i = n(4903)(),
                    a = n(2264)('Object.prototype.toString'),
                    o = function (e) {
                        if (i && e && 'object' == typeof e && Symbol.toStringTag in e) {
                            return !1;
                        } else {
                            return '[object Arguments]' === a(e);
                        }
                    },
                    r = function (e) {
                        if (o(e)) {
                            return !0;
                        } else {
                            return (
                                null !== e &&
                                'object' == typeof e &&
                                'number' == typeof e.length &&
                                e.length >= 0 &&
                                '[object Array]' !== a(e) &&
                                '[object Function]' === a(e.callee)
                            );
                        }
                    },
                    s = (function () {
                        return o(arguments);
                    })();
                o.isLegacyArguments = r;
                e.exports = s ? o : r;
            },
            6445: function (e, t, n) {
                'use strict';
                var i = n(2756),
                    a = n(2264),
                    o = n(9718)('%ArrayBuffer%', !0),
                    r = a('ArrayBuffer.prototype.byteLength', !0),
                    s = a('Object.prototype.toString'),
                    c = !!o && !r && new o(0).slice,
                    l = !!c && i(c);
                e.exports =
                    r || l
                        ? function (e) {
                              if (!e || 'object' != typeof e) {
                                  return !1;
                              }
                              try {
                                  if (r) {
                                      r(e);
                                  } else {
                                      l(e, 0);
                                  }
                                  return !0;
                              } catch (e) {
                                  return !1;
                              }
                          }
                        : o
                        ? function (e) {
                              return '[object ArrayBuffer]' === s(e);
                          }
                        : function (e) {
                              return !1;
                          };
            },
            7500: function (e, t, n) {
                'use strict';
                if (n(1269)()) {
                    var i = BigInt.prototype.valueOf;
                    e.exports = function (e) {
                        if (
                            null == e ||
                            'boolean' == typeof e ||
                            'string' == typeof e ||
                            'number' == typeof e ||
                            'symbol' == typeof e ||
                            'function' == typeof e
                        ) {
                            return !1;
                        }
                        if ('bigint' == typeof e) {
                            return !0;
                        } else {
                            return (function (e) {
                                try {
                                    i.call(e);
                                    return !0;
                                } catch (e) {}
                                return !1;
                            })(e);
                        }
                    };
                } else {
                    e.exports = function (e) {
                        return !1;
                    };
                }
            },
            919: function (e, t, n) {
                'use strict';
                var i = n(2264),
                    a = i('Boolean.prototype.toString'),
                    o = i('Object.prototype.toString'),
                    r = n(4903)();
                e.exports = function (e) {
                    if ('boolean' == typeof e) {
                        return !0;
                    }
                    if (null === e || 'object' != typeof e) {
                        return !1;
                    } else {
                        return r && Symbol.toStringTag in e
                            ? (function (e) {
                                  try {
                                      a(e);
                                      return !0;
                                  } catch (e) {
                                      return !1;
                                  }
                              })(e)
                            : '[object Boolean]' === o(e);
                    }
                };
            },
            403: function (e) {
                'use strict';
                var t,
                    n,
                    i = Function.prototype.toString,
                    a = 'object' == typeof Reflect && null !== Reflect && Reflect.apply;
                if ('function' == typeof a && 'function' == typeof Object.defineProperty) {
                    try {
                        t = Object.defineProperty({}, 'length', {
                            get: function () {
                                throw n;
                            },
                        });
                        n = {};
                        a(
                            function () {
                                throw 42;
                            },
                            null,
                            t,
                        );
                    } catch (e) {
                        if (e !== n) {
                            a = null;
                        }
                    }
                } else {
                    a = null;
                }
                var o = /^\s*class\b/,
                    r = function (e) {
                        try {
                            var t = i.call(e);
                            return o.test(t);
                        } catch (e) {
                            return !1;
                        }
                    },
                    s = function (e) {
                        try {
                            if (r(e)) {
                                return !1;
                            }
                            i.call(e);
                            return !0;
                        } catch (e) {
                            return !1;
                        }
                    },
                    c = Object.prototype.toString,
                    l = 'function' == typeof Symbol && !!Symbol.toStringTag,
                    u = !(0 in [,]),
                    d = function () {
                        return !1;
                    };
                if ('object' == typeof document) {
                    var m = document.all;
                    if (c.call(m) === c.call(document.all)) {
                        d = function (e) {
                            if ((u || !e) && (void 0 === e || 'object' == typeof e)) {
                                try {
                                    var t = c.call(e);
                                    return (
                                        ('[object HTMLAllCollection]' === t ||
                                            '[object HTML document.all class]' === t ||
                                            '[object HTMLCollection]' === t ||
                                            '[object Object]' === t) &&
                                        null == e('')
                                    );
                                } catch (e) {}
                            }
                            return !1;
                        };
                    }
                }
                e.exports = a
                    ? function (e) {
                          if (d(e)) {
                              return !0;
                          }
                          if (!e) {
                              return !1;
                          }
                          if ('function' != typeof e && 'object' != typeof e) {
                              return !1;
                          }
                          try {
                              a(e, null, t);
                          } catch (e) {
                              if (e !== n) {
                                  return !1;
                              }
                          }
                          return !r(e) && s(e);
                      }
                    : function (e) {
                          if (d(e)) {
                              return !0;
                          }
                          if (!e) {
                              return !1;
                          }
                          if ('function' != typeof e && 'object' != typeof e) {
                              return !1;
                          }
                          if (l) {
                              return s(e);
                          }
                          if (r(e)) {
                              return !1;
                          }
                          var t = c.call(e);
                          if (
                              '[object Function]' !== t &&
                              '[object GeneratorFunction]' !== t &&
                              !/^\[object HTML/.test(t)
                          ) {
                              return !1;
                          } else {
                              return s(e);
                          }
                      };
            },
            5661: function (e, t, n) {
                'use strict';
                var i = Date.prototype.getDay,
                    a = Object.prototype.toString,
                    o = n(4903)();
                e.exports = function (e) {
                    if ('object' != typeof e || null === e) {
                        return !1;
                    } else {
                        return o
                            ? (function (e) {
                                  try {
                                      i.call(e);
                                      return !0;
                                  } catch (e) {
                                      return !1;
                                  }
                              })(e)
                            : '[object Date]' === a.call(e);
                    }
                };
            },
            175: function (e) {
                'use strict';
                var t,
                    n = 'function' == typeof Map && Map.prototype ? Map : null,
                    i = 'function' == typeof Set && Set.prototype ? Set : null;
                if (!n) {
                    t = function (e) {
                        return !1;
                    };
                }
                var a = n ? Map.prototype.has : null,
                    o = i ? Set.prototype.has : null;
                if (!t && !a) {
                    t = function (e) {
                        return !1;
                    };
                }
                e.exports =
                    t ||
                    function (e) {
                        if (!e || 'object' != typeof e) {
                            return !1;
                        }
                        try {
                            a.call(e);
                            if (o) {
                                try {
                                    o.call(e);
                                } catch (e) {
                                    return !0;
                                }
                            }
                            return e instanceof n;
                        } catch (e) {}
                        return !1;
                    };
            },
            9206: function (e, t, n) {
                'use strict';
                var i = Number.prototype.toString,
                    a = Object.prototype.toString,
                    o = n(4903)();
                e.exports = function (e) {
                    if ('number' == typeof e) {
                        return !0;
                    }
                    if ('object' != typeof e) {
                        return !1;
                    } else {
                        return o
                            ? (function (e) {
                                  try {
                                      i.call(e);
                                      return !0;
                                  } catch (e) {
                                      return !1;
                                  }
                              })(e)
                            : '[object Number]' === a.call(e);
                    }
                };
            },
            78: function (e, t, n) {
                'use strict';
                var i,
                    a,
                    o,
                    r,
                    s = n(2264),
                    c = n(4903)();
                if (c) {
                    i = s('Object.prototype.hasOwnProperty');
                    a = s('RegExp.prototype.exec');
                    o = {};
                    var l = function () {
                        throw o;
                    };
                    r = { toString: l, valueOf: l };
                    if ('symbol' == typeof Symbol.toPrimitive) {
                        r[Symbol.toPrimitive] = l;
                    }
                }
                var u = s('Object.prototype.toString'),
                    d = Object.getOwnPropertyDescriptor;
                e.exports = c
                    ? function (e) {
                          if (!e || 'object' != typeof e) {
                              return !1;
                          }
                          var t = d(e, 'lastIndex');
                          if (!(t && i(t, 'value'))) {
                              return !1;
                          }
                          try {
                              a(e, r);
                          } catch (e) {
                              return e === o;
                          }
                      }
                    : function (e) {
                          if (!e || ('object' != typeof e && 'function' != typeof e)) {
                              return !1;
                          } else {
                              return '[object RegExp]' === u(e);
                          }
                      };
            },
            4065: function (e) {
                'use strict';
                var t,
                    n = 'function' == typeof Map && Map.prototype ? Map : null,
                    i = 'function' == typeof Set && Set.prototype ? Set : null;
                if (!i) {
                    t = function (e) {
                        return !1;
                    };
                }
                var a = n ? Map.prototype.has : null,
                    o = i ? Set.prototype.has : null;
                if (!t && !o) {
                    t = function (e) {
                        return !1;
                    };
                }
                e.exports =
                    t ||
                    function (e) {
                        if (!e || 'object' != typeof e) {
                            return !1;
                        }
                        try {
                            o.call(e);
                            if (a) {
                                try {
                                    a.call(e);
                                } catch (e) {
                                    return !0;
                                }
                            }
                            return e instanceof i;
                        } catch (e) {}
                        return !1;
                    };
            },
            3187: function (e, t, n) {
                'use strict';
                var i = n(2264)('SharedArrayBuffer.prototype.byteLength', !0);
                e.exports = i
                    ? function (e) {
                          if (!e || 'object' != typeof e) {
                              return !1;
                          }
                          try {
                              i(e);
                              return !0;
                          } catch (e) {
                              return !1;
                          }
                      }
                    : function (e) {
                          return !1;
                      };
            },
            514: function (e, t, n) {
                'use strict';
                var i = String.prototype.valueOf,
                    a = Object.prototype.toString,
                    o = n(4903)();
                e.exports = function (e) {
                    if ('string' == typeof e) {
                        return !0;
                    }
                    if ('object' != typeof e) {
                        return !1;
                    } else {
                        return o
                            ? (function (e) {
                                  try {
                                      i.call(e);
                                      return !0;
                                  } catch (e) {
                                      return !1;
                                  }
                              })(e)
                            : '[object String]' === a.call(e);
                    }
                };
            },
            1735: function (e, t, n) {
                'use strict';
                var i = Object.prototype.toString;
                if (n(1064)()) {
                    var a = Symbol.prototype.toString,
                        o = /^Symbol\(.*\)$/;
                    e.exports = function (e) {
                        if ('symbol' == typeof e) {
                            return !0;
                        }
                        if ('[object Symbol]' !== i.call(e)) {
                            return !1;
                        }
                        try {
                            return (function (e) {
                                if ('symbol' != typeof e.valueOf()) {
                                    return !1;
                                } else {
                                    return o.test(a.call(e));
                                }
                            })(e);
                        } catch (e) {
                            return !1;
                        }
                    };
                } else {
                    e.exports = function (e) {
                        return !1;
                    };
                }
            },
            2355: function (e) {
                'use strict';
                var t,
                    n = 'function' == typeof WeakMap && WeakMap.prototype ? WeakMap : null,
                    i = 'function' == typeof WeakSet && WeakSet.prototype ? WeakSet : null;
                if (!n) {
                    t = function (e) {
                        return !1;
                    };
                }
                var a = n ? n.prototype.has : null,
                    o = i ? i.prototype.has : null;
                if (!t && !a) {
                    t = function (e) {
                        return !1;
                    };
                }
                e.exports =
                    t ||
                    function (e) {
                        if (!e || 'object' != typeof e) {
                            return !1;
                        }
                        try {
                            a.call(e, a);
                            if (o) {
                                try {
                                    o.call(e, o);
                                } catch (e) {
                                    return !0;
                                }
                            }
                            return e instanceof n;
                        } catch (e) {}
                        return !1;
                    };
            },
            3277: function (e, t, n) {
                'use strict';
                var i = n(9718),
                    a = n(2264),
                    o = i('%WeakSet%', !0),
                    r = a('WeakSet.prototype.has', !0);
                if (r) {
                    var s = a('WeakMap.prototype.has', !0);
                    e.exports = function (e) {
                        if (!e || 'object' != typeof e) {
                            return !1;
                        }
                        try {
                            r(e, r);
                            if (s) {
                                try {
                                    s(e, s);
                                } catch (e) {
                                    return !0;
                                }
                            }
                            return e instanceof o;
                        } catch (e) {}
                        return !1;
                    };
                } else {
                    e.exports = function (e) {
                        return !1;
                    };
                }
            },
            3169: function (e) {
                var t = {}.toString;
                e.exports =
                    Array.isArray ||
                    function (e) {
                        return '[object Array]' == t.call(e);
                    };
            },
            5124: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('af', {
                        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
                        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
                        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
                        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
                        meridiemParse: /vm|nm/i,
                        isPM: function (e) {
                            return /^nm$/i.test(e);
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return n ? 'vm' : 'VM';
                            } else {
                                return n ? 'nm' : 'NM';
                            }
                        },
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Vandag om] LT',
                            nextDay: '[Môre om] LT',
                            nextWeek: 'dddd [om] LT',
                            lastDay: '[Gister om] LT',
                            lastWeek: '[Laas] dddd [om] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'oor %s',
                            past: '%s gelede',
                            s: "'n paar sekondes",
                            ss: '%d sekondes',
                            m: "'n minuut",
                            mm: '%d minute',
                            h: "'n uur",
                            hh: '%d ure',
                            d: "'n dag",
                            dd: '%d dae',
                            M: "'n maand",
                            MM: '%d maande',
                            y: "'n jaar",
                            yy: '%d jaar',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
                        ordinal: function (e) {
                            return e + (1 === e || 8 === e || e >= 20 ? 'ste' : 'de');
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            2855: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = function (e) {
                            return 0 === e
                                ? 0
                                : 1 === e
                                ? 1
                                : 2 === e
                                ? 2
                                : e % 100 >= 3 && e % 100 <= 10
                                ? 3
                                : e % 100 >= 11
                                ? 4
                                : 5;
                        },
                        n = {
                            s: [
                                'أقل من ثانية',
                                'ثانية واحدة',
                                ['ثانيتان', 'ثانيتين'],
                                '%d ثوان',
                                '%d ثانية',
                                '%d ثانية',
                            ],
                            m: [
                                'أقل من دقيقة',
                                'دقيقة واحدة',
                                ['دقيقتان', 'دقيقتين'],
                                '%d دقائق',
                                '%d دقيقة',
                                '%d دقيقة',
                            ],
                            h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
                            d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
                            M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
                            y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام'],
                        },
                        i = function (e) {
                            return function (i, a, o, r) {
                                var s = t(i),
                                    c = n[e][t(i)];
                                if (2 === s) {
                                    c = c[a ? 0 : 1];
                                }
                                return c.replace(/%d/i, i);
                            };
                        },
                        a = [
                            'جانفي',
                            'فيفري',
                            'مارس',
                            'أفريل',
                            'ماي',
                            'جوان',
                            'جويلية',
                            'أوت',
                            'سبتمبر',
                            'أكتوبر',
                            'نوفمبر',
                            'ديسمبر',
                        ];
                    e.defineLocale('ar-dz', {
                        months: a,
                        monthsShort: a,
                        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
                        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
                        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'D/‏M/‏YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        meridiemParse: /ص|م/,
                        isPM: function (e) {
                            return 'م' === e;
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return 'ص';
                            } else {
                                return 'م';
                            }
                        },
                        calendar: {
                            sameDay: '[اليوم عند الساعة] LT',
                            nextDay: '[غدًا عند الساعة] LT',
                            nextWeek: 'dddd [عند الساعة] LT',
                            lastDay: '[أمس عند الساعة] LT',
                            lastWeek: 'dddd [عند الساعة] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'بعد %s',
                            past: 'منذ %s',
                            s: i('s'),
                            ss: i('s'),
                            m: i('m'),
                            mm: i('m'),
                            h: i('h'),
                            hh: i('h'),
                            d: i('d'),
                            dd: i('d'),
                            M: i('M'),
                            MM: i('M'),
                            y: i('y'),
                            yy: i('y'),
                        },
                        postformat: function (e) {
                            return e.replace(/,/g, '،');
                        },
                        week: { dow: 0, doy: 4 },
                    });
                })(n(2198));
            },
            7355: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('ar-kw', {
                        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
                        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
                        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
                        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
                        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[اليوم على الساعة] LT',
                            nextDay: '[غدا على الساعة] LT',
                            nextWeek: 'dddd [على الساعة] LT',
                            lastDay: '[أمس على الساعة] LT',
                            lastWeek: 'dddd [على الساعة] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'في %s',
                            past: 'منذ %s',
                            s: 'ثوان',
                            ss: '%d ثانية',
                            m: 'دقيقة',
                            mm: '%d دقائق',
                            h: 'ساعة',
                            hh: '%d ساعات',
                            d: 'يوم',
                            dd: '%d أيام',
                            M: 'شهر',
                            MM: '%d أشهر',
                            y: 'سنة',
                            yy: '%d سنوات',
                        },
                        week: { dow: 0, doy: 12 },
                    });
                })(n(2198));
            },
            4130: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '1', 2: '2', 3: '3', 4: '4', 5: '5', 6: '6', 7: '7', 8: '8', 9: '9', 0: '0' },
                        n = function (e) {
                            return 0 === e
                                ? 0
                                : 1 === e
                                ? 1
                                : 2 === e
                                ? 2
                                : e % 100 >= 3 && e % 100 <= 10
                                ? 3
                                : e % 100 >= 11
                                ? 4
                                : 5;
                        },
                        i = {
                            s: [
                                'أقل من ثانية',
                                'ثانية واحدة',
                                ['ثانيتان', 'ثانيتين'],
                                '%d ثوان',
                                '%d ثانية',
                                '%d ثانية',
                            ],
                            m: [
                                'أقل من دقيقة',
                                'دقيقة واحدة',
                                ['دقيقتان', 'دقيقتين'],
                                '%d دقائق',
                                '%d دقيقة',
                                '%d دقيقة',
                            ],
                            h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
                            d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
                            M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
                            y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام'],
                        },
                        a = function (e) {
                            return function (t, a, o, r) {
                                var s = n(t),
                                    c = i[e][n(t)];
                                if (2 === s) {
                                    c = c[a ? 0 : 1];
                                }
                                return c.replace(/%d/i, t);
                            };
                        },
                        o = [
                            'يناير',
                            'فبراير',
                            'مارس',
                            'أبريل',
                            'مايو',
                            'يونيو',
                            'يوليو',
                            'أغسطس',
                            'سبتمبر',
                            'أكتوبر',
                            'نوفمبر',
                            'ديسمبر',
                        ];
                    e.defineLocale('ar-ly', {
                        months: o,
                        monthsShort: o,
                        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
                        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
                        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'D/‏M/‏YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        meridiemParse: /ص|م/,
                        isPM: function (e) {
                            return 'م' === e;
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return 'ص';
                            } else {
                                return 'م';
                            }
                        },
                        calendar: {
                            sameDay: '[اليوم عند الساعة] LT',
                            nextDay: '[غدًا عند الساعة] LT',
                            nextWeek: 'dddd [عند الساعة] LT',
                            lastDay: '[أمس عند الساعة] LT',
                            lastWeek: 'dddd [عند الساعة] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'بعد %s',
                            past: 'منذ %s',
                            s: a('s'),
                            ss: a('s'),
                            m: a('m'),
                            mm: a('m'),
                            h: a('h'),
                            hh: a('h'),
                            d: a('d'),
                            dd: a('d'),
                            M: a('M'),
                            MM: a('M'),
                            y: a('y'),
                            yy: a('y'),
                        },
                        preparse: function (e) {
                            return e.replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e
                                .replace(/\d/g, function (e) {
                                    return t[e];
                                })
                                .replace(/,/g, '،');
                        },
                        week: { dow: 6, doy: 12 },
                    });
                })(n(2198));
            },
            4523: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('ar-ma', {
                        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
                        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
                        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
                        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
                        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[اليوم على الساعة] LT',
                            nextDay: '[غدا على الساعة] LT',
                            nextWeek: 'dddd [على الساعة] LT',
                            lastDay: '[أمس على الساعة] LT',
                            lastWeek: 'dddd [على الساعة] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'في %s',
                            past: 'منذ %s',
                            s: 'ثوان',
                            ss: '%d ثانية',
                            m: 'دقيقة',
                            mm: '%d دقائق',
                            h: 'ساعة',
                            hh: '%d ساعات',
                            d: 'يوم',
                            dd: '%d أيام',
                            M: 'شهر',
                            MM: '%d أشهر',
                            y: 'سنة',
                            yy: '%d سنوات',
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            4089: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '١', 2: '٢', 3: '٣', 4: '٤', 5: '٥', 6: '٦', 7: '٧', 8: '٨', 9: '٩', 0: '٠' },
                        n = {
                            '١': '1',
                            '٢': '2',
                            '٣': '3',
                            '٤': '4',
                            '٥': '5',
                            '٦': '6',
                            '٧': '7',
                            '٨': '8',
                            '٩': '9',
                            '٠': '0',
                        };
                    e.defineLocale('ar-sa', {
                        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
                        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                            '_',
                        ),
                        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
                        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
                        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        meridiemParse: /ص|م/,
                        isPM: function (e) {
                            return 'م' === e;
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return 'ص';
                            } else {
                                return 'م';
                            }
                        },
                        calendar: {
                            sameDay: '[اليوم على الساعة] LT',
                            nextDay: '[غدا على الساعة] LT',
                            nextWeek: 'dddd [على الساعة] LT',
                            lastDay: '[أمس على الساعة] LT',
                            lastWeek: 'dddd [على الساعة] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'في %s',
                            past: 'منذ %s',
                            s: 'ثوان',
                            ss: '%d ثانية',
                            m: 'دقيقة',
                            mm: '%d دقائق',
                            h: 'ساعة',
                            hh: '%d ساعات',
                            d: 'يوم',
                            dd: '%d أيام',
                            M: 'شهر',
                            MM: '%d أشهر',
                            y: 'سنة',
                            yy: '%d سنوات',
                        },
                        preparse: function (e) {
                            return e
                                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (e) {
                                    return n[e];
                                })
                                .replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e
                                .replace(/\d/g, function (e) {
                                    return t[e];
                                })
                                .replace(/,/g, '،');
                        },
                        week: { dow: 0, doy: 6 },
                    });
                })(n(2198));
            },
            4563: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('ar-tn', {
                        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
                        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                            '_',
                        ),
                        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
                        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
                        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[اليوم على الساعة] LT',
                            nextDay: '[غدا على الساعة] LT',
                            nextWeek: 'dddd [على الساعة] LT',
                            lastDay: '[أمس على الساعة] LT',
                            lastWeek: 'dddd [على الساعة] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'في %s',
                            past: 'منذ %s',
                            s: 'ثوان',
                            ss: '%d ثانية',
                            m: 'دقيقة',
                            mm: '%d دقائق',
                            h: 'ساعة',
                            hh: '%d ساعات',
                            d: 'يوم',
                            dd: '%d أيام',
                            M: 'شهر',
                            MM: '%d أشهر',
                            y: 'سنة',
                            yy: '%d سنوات',
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            4328: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '١', 2: '٢', 3: '٣', 4: '٤', 5: '٥', 6: '٦', 7: '٧', 8: '٨', 9: '٩', 0: '٠' },
                        n = {
                            '١': '1',
                            '٢': '2',
                            '٣': '3',
                            '٤': '4',
                            '٥': '5',
                            '٦': '6',
                            '٧': '7',
                            '٨': '8',
                            '٩': '9',
                            '٠': '0',
                        },
                        i = function (e) {
                            return 0 === e
                                ? 0
                                : 1 === e
                                ? 1
                                : 2 === e
                                ? 2
                                : e % 100 >= 3 && e % 100 <= 10
                                ? 3
                                : e % 100 >= 11
                                ? 4
                                : 5;
                        },
                        a = {
                            s: [
                                'أقل من ثانية',
                                'ثانية واحدة',
                                ['ثانيتان', 'ثانيتين'],
                                '%d ثوان',
                                '%d ثانية',
                                '%d ثانية',
                            ],
                            m: [
                                'أقل من دقيقة',
                                'دقيقة واحدة',
                                ['دقيقتان', 'دقيقتين'],
                                '%d دقائق',
                                '%d دقيقة',
                                '%d دقيقة',
                            ],
                            h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
                            d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
                            M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
                            y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام'],
                        },
                        o = function (e) {
                            return function (t, n, o, r) {
                                var s = i(t),
                                    c = a[e][i(t)];
                                if (2 === s) {
                                    c = c[n ? 0 : 1];
                                }
                                return c.replace(/%d/i, t);
                            };
                        },
                        r = [
                            'يناير',
                            'فبراير',
                            'مارس',
                            'أبريل',
                            'مايو',
                            'يونيو',
                            'يوليو',
                            'أغسطس',
                            'سبتمبر',
                            'أكتوبر',
                            'نوفمبر',
                            'ديسمبر',
                        ];
                    e.defineLocale('ar', {
                        months: r,
                        monthsShort: r,
                        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
                        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
                        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'D/‏M/‏YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        meridiemParse: /ص|م/,
                        isPM: function (e) {
                            return 'م' === e;
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return 'ص';
                            } else {
                                return 'م';
                            }
                        },
                        calendar: {
                            sameDay: '[اليوم عند الساعة] LT',
                            nextDay: '[غدًا عند الساعة] LT',
                            nextWeek: 'dddd [عند الساعة] LT',
                            lastDay: '[أمس عند الساعة] LT',
                            lastWeek: 'dddd [عند الساعة] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'بعد %s',
                            past: 'منذ %s',
                            s: o('s'),
                            ss: o('s'),
                            m: o('m'),
                            mm: o('m'),
                            h: o('h'),
                            hh: o('h'),
                            d: o('d'),
                            dd: o('d'),
                            M: o('M'),
                            MM: o('M'),
                            y: o('y'),
                            yy: o('y'),
                        },
                        preparse: function (e) {
                            return e
                                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (e) {
                                    return n[e];
                                })
                                .replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e
                                .replace(/\d/g, function (e) {
                                    return t[e];
                                })
                                .replace(/,/g, '،');
                        },
                        week: { dow: 6, doy: 12 },
                    });
                })(n(2198));
            },
            2240: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = {
                        1: '-inci',
                        5: '-inci',
                        8: '-inci',
                        70: '-inci',
                        80: '-inci',
                        2: '-nci',
                        7: '-nci',
                        20: '-nci',
                        50: '-nci',
                        3: '-üncü',
                        4: '-üncü',
                        100: '-üncü',
                        6: '-ncı',
                        9: '-uncu',
                        10: '-uncu',
                        30: '-uncu',
                        60: '-ıncı',
                        90: '-ıncı',
                    };
                    e.defineLocale('az', {
                        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
                            '_',
                        ),
                        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
                        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
                        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
                        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[bugün saat] LT',
                            nextDay: '[sabah saat] LT',
                            nextWeek: '[gələn həftə] dddd [saat] LT',
                            lastDay: '[dünən] LT',
                            lastWeek: '[keçən həftə] dddd [saat] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s sonra',
                            past: '%s əvvəl',
                            s: 'bir neçə saniyə',
                            ss: '%d saniyə',
                            m: 'bir dəqiqə',
                            mm: '%d dəqiqə',
                            h: 'bir saat',
                            hh: '%d saat',
                            d: 'bir gün',
                            dd: '%d gün',
                            M: 'bir ay',
                            MM: '%d ay',
                            y: 'bir il',
                            yy: '%d il',
                        },
                        meridiemParse: /gecə|səhər|gündüz|axşam/,
                        isPM: function (e) {
                            return /^(gündüz|axşam)$/.test(e);
                        },
                        meridiem: function (e, t, n) {
                            if (e < 4) {
                                return 'gecə';
                            } else if (e < 12) {
                                return 'səhər';
                            } else if (e < 17) {
                                return 'gündüz';
                            } else {
                                return 'axşam';
                            }
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
                        ordinal: function (e) {
                            if (0 === e) {
                                return e + '-ıncı';
                            }
                            var n = e % 10,
                                i = (e % 100) - n,
                                a = e >= 100 ? 100 : null;
                            return e + (t[n] || t[i] || t[a]);
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            9162: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t) {
                        var n = e.split('_');
                        return t % 10 == 1 && t % 100 != 11
                            ? n[0]
                            : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20)
                            ? n[1]
                            : n[2];
                    }

                    function n(e, n, i) {
                        if ('m' === i) {
                            return n ? 'хвіліна' : 'хвіліну';
                        } else if ('h' === i) {
                            return n ? 'гадзіна' : 'гадзіну';
                        } else {
                            return (
                                e +
                                ' ' +
                                t(
                                    {
                                        ss: n ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
                                        mm: n ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
                                        hh: n ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
                                        dd: 'дзень_дні_дзён',
                                        MM: 'месяц_месяцы_месяцаў',
                                        yy: 'год_гады_гадоў',
                                    }[i],
                                    +e,
                                )
                            );
                        }
                    }

                    e.defineLocale('be', {
                        months: {
                            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                                '_',
                            ),
                            standalone:
                                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                                    '_',
                                ),
                        },
                        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
                        weekdays: {
                            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
                            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
                            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
                        },
                        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
                        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY г.',
                            LLL: 'D MMMM YYYY г., HH:mm',
                            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
                        },
                        calendar: {
                            sameDay: '[Сёння ў] LT',
                            nextDay: '[Заўтра ў] LT',
                            lastDay: '[Учора ў] LT',
                            nextWeek: function () {
                                return '[У] dddd [ў] LT';
                            },
                            lastWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                    case 3:
                                    case 5:
                                    case 6:
                                        return '[У мінулую] dddd [ў] LT';
                                    case 1:
                                    case 2:
                                    case 4:
                                        return '[У мінулы] dddd [ў] LT';
                                }
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'праз %s',
                            past: '%s таму',
                            s: 'некалькі секунд',
                            m: n,
                            mm: n,
                            h: n,
                            hh: n,
                            d: 'дзень',
                            dd: n,
                            M: 'месяц',
                            MM: n,
                            y: 'год',
                            yy: n,
                        },
                        meridiemParse: /ночы|раніцы|дня|вечара/,
                        isPM: function (e) {
                            return /^(дня|вечара)$/.test(e);
                        },
                        meridiem: function (e, t, n) {
                            if (e < 4) {
                                return 'ночы';
                            } else if (e < 12) {
                                return 'раніцы';
                            } else if (e < 17) {
                                return 'дня';
                            } else {
                                return 'вечара';
                            }
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
                        ordinal: function (e, t) {
                            switch (t) {
                                case 'M':
                                case 'd':
                                case 'DDD':
                                case 'w':
                                case 'W':
                                    return (e % 10 == 2 || e % 10 == 3) && e % 100 != 12 && e % 100 != 13
                                        ? e + '-і'
                                        : e + '-ы';
                                case 'D':
                                    return e + '-га';
                                default:
                                    return e;
                            }
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            5488: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('bg', {
                        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
                            '_',
                        ),
                        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
                        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
                        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
                        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'D.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY H:mm',
                            LLLL: 'dddd, D MMMM YYYY H:mm',
                        },
                        calendar: {
                            sameDay: '[Днес в] LT',
                            nextDay: '[Утре в] LT',
                            nextWeek: 'dddd [в] LT',
                            lastDay: '[Вчера в] LT',
                            lastWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                    case 3:
                                    case 6:
                                        return '[Миналата] dddd [в] LT';
                                    case 1:
                                    case 2:
                                    case 4:
                                    case 5:
                                        return '[Миналия] dddd [в] LT';
                                }
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'след %s',
                            past: 'преди %s',
                            s: 'няколко секунди',
                            ss: '%d секунди',
                            m: 'минута',
                            mm: '%d минути',
                            h: 'час',
                            hh: '%d часа',
                            d: 'ден',
                            dd: '%d дена',
                            w: 'седмица',
                            ww: '%d седмици',
                            M: 'месец',
                            MM: '%d месеца',
                            y: 'година',
                            yy: '%d години',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
                        ordinal: function (e) {
                            var t = e % 10,
                                n = e % 100;
                            if (0 === e) {
                                return e + '-ев';
                            } else if (0 === n) {
                                return e + '-ен';
                            } else if (n > 10 && n < 20) {
                                return e + '-ти';
                            } else if (1 === t) {
                                return e + '-ви';
                            } else if (2 === t) {
                                return e + '-ри';
                            } else if (7 === t || 8 === t) {
                                return e + '-ми';
                            } else {
                                return e + '-ти';
                            }
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            6546: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('bm', {
                        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
                            '_',
                        ),
                        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
                        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
                        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
                        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'MMMM [tile] D [san] YYYY',
                            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
                            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
                        },
                        calendar: {
                            sameDay: '[Bi lɛrɛ] LT',
                            nextDay: '[Sini lɛrɛ] LT',
                            nextWeek: 'dddd [don lɛrɛ] LT',
                            lastDay: '[Kunu lɛrɛ] LT',
                            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s kɔnɔ',
                            past: 'a bɛ %s bɔ',
                            s: 'sanga dama dama',
                            ss: 'sekondi %d',
                            m: 'miniti kelen',
                            mm: 'miniti %d',
                            h: 'lɛrɛ kelen',
                            hh: 'lɛrɛ %d',
                            d: 'tile kelen',
                            dd: 'tile %d',
                            M: 'kalo kelen',
                            MM: 'kalo %d',
                            y: 'san kelen',
                            yy: 'san %d',
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            3442: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '১', 2: '২', 3: '৩', 4: '৪', 5: '৫', 6: '৬', 7: '৭', 8: '৮', 9: '৯', 0: '০' },
                        n = {
                            '১': '1',
                            '২': '2',
                            '৩': '3',
                            '৪': '4',
                            '৫': '5',
                            '৬': '6',
                            '৭': '7',
                            '৮': '8',
                            '৯': '9',
                            '০': '0',
                        };
                    e.defineLocale('bn-bd', {
                        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
                            '_',
                        ),
                        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
                        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
                        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
                        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm সময়',
                            LTS: 'A h:mm:ss সময়',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm সময়',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
                        },
                        calendar: {
                            sameDay: '[আজ] LT',
                            nextDay: '[আগামীকাল] LT',
                            nextWeek: 'dddd, LT',
                            lastDay: '[গতকাল] LT',
                            lastWeek: '[গত] dddd, LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s পরে',
                            past: '%s আগে',
                            s: 'কয়েক সেকেন্ড',
                            ss: '%d সেকেন্ড',
                            m: 'এক মিনিট',
                            mm: '%d মিনিট',
                            h: 'এক ঘন্টা',
                            hh: '%d ঘন্টা',
                            d: 'এক দিন',
                            dd: '%d দিন',
                            M: 'এক মাস',
                            MM: '%d মাস',
                            y: 'এক বছর',
                            yy: '%d বছর',
                        },
                        preparse: function (e) {
                            return e.replace(/[১২৩৪৫৬৭৮৯০]/g, function (e) {
                                return n[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('রাত' === t) {
                                return e < 4 ? e : e + 12;
                            } else if ('ভোর' === t) {
                                return e;
                            } else if ('সকাল' === t) {
                                return e;
                            } else if ('দুপুর' === t) {
                                return e >= 3 ? e : e + 12;
                            } else if ('বিকাল' === t) {
                                return e + 12;
                            } else if ('সন্ধ্যা' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 4) {
                                return 'রাত';
                            } else if (e < 6) {
                                return 'ভোর';
                            } else if (e < 12) {
                                return 'সকাল';
                            } else if (e < 15) {
                                return 'দুপুর';
                            } else if (e < 18) {
                                return 'বিকাল';
                            } else if (e < 20) {
                                return 'সন্ধ্যা';
                            } else {
                                return 'রাত';
                            }
                        },
                        week: { dow: 0, doy: 6 },
                    });
                })(n(2198));
            },
            735: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '১', 2: '২', 3: '৩', 4: '৪', 5: '৫', 6: '৬', 7: '৭', 8: '৮', 9: '৯', 0: '০' },
                        n = {
                            '১': '1',
                            '২': '2',
                            '৩': '3',
                            '৪': '4',
                            '৫': '5',
                            '৬': '6',
                            '৭': '7',
                            '৮': '8',
                            '৯': '9',
                            '০': '0',
                        };
                    e.defineLocale('bn', {
                        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
                            '_',
                        ),
                        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
                        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
                        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
                        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm সময়',
                            LTS: 'A h:mm:ss সময়',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm সময়',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
                        },
                        calendar: {
                            sameDay: '[আজ] LT',
                            nextDay: '[আগামীকাল] LT',
                            nextWeek: 'dddd, LT',
                            lastDay: '[গতকাল] LT',
                            lastWeek: '[গত] dddd, LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s পরে',
                            past: '%s আগে',
                            s: 'কয়েক সেকেন্ড',
                            ss: '%d সেকেন্ড',
                            m: 'এক মিনিট',
                            mm: '%d মিনিট',
                            h: 'এক ঘন্টা',
                            hh: '%d ঘন্টা',
                            d: 'এক দিন',
                            dd: '%d দিন',
                            M: 'এক মাস',
                            MM: '%d মাস',
                            y: 'এক বছর',
                            yy: '%d বছর',
                        },
                        preparse: function (e) {
                            return e.replace(/[১২৩৪৫৬৭৮৯০]/g, function (e) {
                                return n[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if (('রাত' === t && e >= 4) || ('দুপুর' === t && e < 5) || 'বিকাল' === t) {
                                return e + 12;
                            } else {
                                return e;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 4) {
                                return 'রাত';
                            } else if (e < 10) {
                                return 'সকাল';
                            } else if (e < 17) {
                                return 'দুপুর';
                            } else if (e < 20) {
                                return 'বিকাল';
                            } else {
                                return 'রাত';
                            }
                        },
                        week: { dow: 0, doy: 6 },
                    });
                })(n(2198));
            },
            3928: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '༡', 2: '༢', 3: '༣', 4: '༤', 5: '༥', 6: '༦', 7: '༧', 8: '༨', 9: '༩', 0: '༠' },
                        n = {
                            '༡': '1',
                            '༢': '2',
                            '༣': '3',
                            '༤': '4',
                            '༥': '5',
                            '༦': '6',
                            '༧': '7',
                            '༨': '8',
                            '༩': '9',
                            '༠': '0',
                        };
                    e.defineLocale('bo', {
                        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
                            '_',
                        ),
                        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split('_'),
                        monthsShortRegex: /^(ཟླ་\d{1,2})/,
                        monthsParseExact: !0,
                        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                            '_',
                        ),
                        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
                        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm',
                            LTS: 'A h:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm',
                        },
                        calendar: {
                            sameDay: '[དི་རིང] LT',
                            nextDay: '[སང་ཉིན] LT',
                            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
                            lastDay: '[ཁ་སང] LT',
                            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s ལ་',
                            past: '%s སྔན་ལ',
                            s: 'ལམ་སང',
                            ss: '%d སྐར་ཆ།',
                            m: 'སྐར་མ་གཅིག',
                            mm: '%d སྐར་མ',
                            h: 'ཆུ་ཚོད་གཅིག',
                            hh: '%d ཆུ་ཚོད',
                            d: 'ཉིན་གཅིག',
                            dd: '%d ཉིན་',
                            M: 'ཟླ་བ་གཅིག',
                            MM: '%d ཟླ་བ',
                            y: 'ལོ་གཅིག',
                            yy: '%d ལོ',
                        },
                        preparse: function (e) {
                            return e.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (e) {
                                return n[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if (('མཚན་མོ' === t && e >= 4) || ('ཉིན་གུང' === t && e < 5) || 'དགོང་དག' === t) {
                                return e + 12;
                            } else {
                                return e;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 4) {
                                return 'མཚན་མོ';
                            } else if (e < 10) {
                                return 'ཞོགས་ཀས';
                            } else if (e < 17) {
                                return 'ཉིན་གུང';
                            } else if (e < 20) {
                                return 'དགོང་དག';
                            } else {
                                return 'མཚན་མོ';
                            }
                        },
                        week: { dow: 0, doy: 6 },
                    });
                })(n(2198));
            },
            3267: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t, n) {
                        return e + ' ' + a({ mm: 'munutenn', MM: 'miz', dd: 'devezh' }[n], e);
                    }

                    function n(e) {
                        switch (i(e)) {
                            case 1:
                            case 3:
                            case 4:
                            case 5:
                            case 9:
                                return e + ' bloaz';
                            default:
                                return e + ' vloaz';
                        }
                    }

                    function i(e) {
                        if (e > 9) {
                            return i(e % 10);
                        } else {
                            return e;
                        }
                    }

                    function a(e, t) {
                        if (2 === t) {
                            return o(e);
                        } else {
                            return e;
                        }
                    }

                    function o(e) {
                        var t = { m: 'v', b: 'v', d: 'z' };
                        if (void 0 === t[e.charAt(0)]) {
                            return e;
                        } else {
                            return t[e.charAt(0)] + e.substring(1);
                        }
                    }

                    var r = [
                            /^gen/i,
                            /^c[ʼ\']hwe/i,
                            /^meu/i,
                            /^ebr/i,
                            /^mae/i,
                            /^(mez|eve)/i,
                            /^gou/i,
                            /^eos/i,
                            /^gwe/i,
                            /^her/i,
                            /^du/i,
                            /^ker/i,
                        ],
                        s =
                            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
                        c = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
                        l = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
                        u = [/^sul/i, /^lun/i, /^meurzh/i, /^merc[ʼ\']her/i, /^yaou/i, /^gwener/i, /^sadorn/i],
                        d = [/^Sul/i, /^Lun/i, /^Meu/i, /^Mer/i, /^Yao/i, /^Gwe/i, /^Sad/i],
                        m = [/^Su/i, /^Lu/i, /^Me([^r]|$)/i, /^Mer/i, /^Ya/i, /^Gw/i, /^Sa/i];
                    e.defineLocale('br', {
                        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
                            '_',
                        ),
                        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
                        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
                        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
                        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
                        weekdaysParse: m,
                        fullWeekdaysParse: u,
                        shortWeekdaysParse: d,
                        minWeekdaysParse: m,
                        monthsRegex: s,
                        monthsShortRegex: s,
                        monthsStrictRegex: c,
                        monthsShortStrictRegex: l,
                        monthsParse: r,
                        longMonthsParse: r,
                        shortMonthsParse: r,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D [a viz] MMMM YYYY',
                            LLL: 'D [a viz] MMMM YYYY HH:mm',
                            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Hiziv da] LT',
                            nextDay: '[Warcʼhoazh da] LT',
                            nextWeek: 'dddd [da] LT',
                            lastDay: '[Decʼh da] LT',
                            lastWeek: 'dddd [paset da] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'a-benn %s',
                            past: '%s ʼzo',
                            s: 'un nebeud segondennoù',
                            ss: '%d eilenn',
                            m: 'ur vunutenn',
                            mm: t,
                            h: 'un eur',
                            hh: '%d eur',
                            d: 'un devezh',
                            dd: t,
                            M: 'ur miz',
                            MM: t,
                            y: 'ur bloaz',
                            yy: n,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
                        ordinal: function (e) {
                            return e + (1 === e ? 'añ' : 'vet');
                        },
                        week: { dow: 1, doy: 4 },
                        meridiemParse: /a.m.|g.m./,
                        isPM: function (e) {
                            return 'g.m.' === e;
                        },
                        meridiem: function (e, t, n) {
                            return e < 12 ? 'a.m.' : 'g.m.';
                        },
                    });
                })(n(2198));
            },
            5164: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t, n) {
                        var i = e + ' ';
                        switch (n) {
                            case 'ss':
                                if (1 === e) {
                                    i += 'sekunda';
                                } else if (2 === e || 3 === e || 4 === e) {
                                    i += 'sekunde';
                                } else {
                                    i += 'sekundi';
                                }
                                return i;
                            case 'm':
                                return t ? 'jedna minuta' : 'jedne minute';
                            case 'mm':
                                if (1 === e) {
                                    i += 'minuta';
                                } else if (2 === e || 3 === e || 4 === e) {
                                    i += 'minute';
                                } else {
                                    i += 'minuta';
                                }
                                return i;
                            case 'h':
                                return t ? 'jedan sat' : 'jednog sata';
                            case 'hh':
                                if (1 === e) {
                                    i += 'sat';
                                } else if (2 === e || 3 === e || 4 === e) {
                                    i += 'sata';
                                } else {
                                    i += 'sati';
                                }
                                return i;
                            case 'dd':
                                if (1 === e) {
                                    i += 'dan';
                                } else {
                                    i += 'dana';
                                }
                                return i;
                            case 'MM':
                                if (1 === e) {
                                    i += 'mjesec';
                                } else if (2 === e || 3 === e || 4 === e) {
                                    i += 'mjeseca';
                                } else {
                                    i += 'mjeseci';
                                }
                                return i;
                            case 'yy':
                                if (1 === e) {
                                    i += 'godina';
                                } else if (2 === e || 3 === e || 4 === e) {
                                    i += 'godine';
                                } else {
                                    i += 'godina';
                                }
                                return i;
                        }
                    }

                    e.defineLocale('bs', {
                        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
                            '_',
                        ),
                        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
                        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
                        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY H:mm',
                            LLLL: 'dddd, D. MMMM YYYY H:mm',
                        },
                        calendar: {
                            sameDay: '[danas u] LT',
                            nextDay: '[sutra u] LT',
                            nextWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                        return '[u] [nedjelju] [u] LT';
                                    case 3:
                                        return '[u] [srijedu] [u] LT';
                                    case 6:
                                        return '[u] [subotu] [u] LT';
                                    case 1:
                                    case 2:
                                    case 4:
                                    case 5:
                                        return '[u] dddd [u] LT';
                                }
                            },
                            lastDay: '[jučer u] LT',
                            lastWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                    case 3:
                                        return '[prošlu] dddd [u] LT';
                                    case 6:
                                        return '[prošle] [subote] [u] LT';
                                    case 1:
                                    case 2:
                                    case 4:
                                    case 5:
                                        return '[prošli] dddd [u] LT';
                                }
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'za %s',
                            past: 'prije %s',
                            s: 'par sekundi',
                            ss: t,
                            m: t,
                            mm: t,
                            h: t,
                            hh: t,
                            d: 'dan',
                            dd: t,
                            M: 'mjesec',
                            MM: t,
                            y: 'godinu',
                            yy: t,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            9991: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('ca', {
                        months: {
                            standalone:
                                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                                    '_',
                                ),
                            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                                '_',
                            ),
                            isFormat: /D[oD]?(\s)+MMMM/,
                        },
                        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
                        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
                        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM [de] YYYY',
                            ll: 'D MMM YYYY',
                            LLL: 'D MMMM [de] YYYY [a les] H:mm',
                            lll: 'D MMM YYYY, H:mm',
                            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
                            llll: 'ddd D MMM YYYY, H:mm',
                        },
                        calendar: {
                            sameDay: function () {
                                return '[avui a ' + (1 !== this.hours() ? 'les' : 'la') + '] LT';
                            },
                            nextDay: function () {
                                return '[demà a ' + (1 !== this.hours() ? 'les' : 'la') + '] LT';
                            },
                            nextWeek: function () {
                                return 'dddd [a ' + (1 !== this.hours() ? 'les' : 'la') + '] LT';
                            },
                            lastDay: function () {
                                return '[ahir a ' + (1 !== this.hours() ? 'les' : 'la') + '] LT';
                            },
                            lastWeek: function () {
                                return '[el] dddd [passat a ' + (1 !== this.hours() ? 'les' : 'la') + '] LT';
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: "d'aquí %s",
                            past: 'fa %s',
                            s: 'uns segons',
                            ss: '%d segons',
                            m: 'un minut',
                            mm: '%d minuts',
                            h: 'una hora',
                            hh: '%d hores',
                            d: 'un dia',
                            dd: '%d dies',
                            M: 'un mes',
                            MM: '%d mesos',
                            y: 'un any',
                            yy: '%d anys',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
                        ordinal: function (e, t) {
                            var n = 1 === e ? 'r' : 2 === e ? 'n' : 3 === e ? 'r' : 4 === e ? 't' : 'è';
                            if ('w' === t || 'W' === t) {
                                n = 'a';
                            }
                            return e + n;
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            9529: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = {
                            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                                '_',
                            ),
                            standalone:
                                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                                    '_',
                                ),
                        },
                        n = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
                        i = [
                            /^led/i,
                            /^úno/i,
                            /^bře/i,
                            /^dub/i,
                            /^kvě/i,
                            /^(čvn|červen$|června)/i,
                            /^(čvc|červenec|července)/i,
                            /^srp/i,
                            /^zář/i,
                            /^říj/i,
                            /^lis/i,
                            /^pro/i,
                        ],
                        a =
                            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

                    function o(e) {
                        return e > 1 && e < 5 && 1 != ~~(e / 10);
                    }

                    function r(e, t, n, i) {
                        var a = e + ' ';
                        switch (n) {
                            case 's':
                                return t || i ? 'pár sekund' : 'pár sekundami';
                            case 'ss':
                                if (t || i) {
                                    return a + (o(e) ? 'sekundy' : 'sekund');
                                } else {
                                    return a + 'sekundami';
                                }
                            case 'm':
                                return t ? 'minuta' : i ? 'minutu' : 'minutou';
                            case 'mm':
                                if (t || i) {
                                    return a + (o(e) ? 'minuty' : 'minut');
                                } else {
                                    return a + 'minutami';
                                }
                            case 'h':
                                return t ? 'hodina' : i ? 'hodinu' : 'hodinou';
                            case 'hh':
                                if (t || i) {
                                    return a + (o(e) ? 'hodiny' : 'hodin');
                                } else {
                                    return a + 'hodinami';
                                }
                            case 'd':
                                return t || i ? 'den' : 'dnem';
                            case 'dd':
                                if (t || i) {
                                    return a + (o(e) ? 'dny' : 'dní');
                                } else {
                                    return a + 'dny';
                                }
                            case 'M':
                                return t || i ? 'měsíc' : 'měsícem';
                            case 'MM':
                                if (t || i) {
                                    return a + (o(e) ? 'měsíce' : 'měsíců');
                                } else {
                                    return a + 'měsíci';
                                }
                            case 'y':
                                return t || i ? 'rok' : 'rokem';
                            case 'yy':
                                if (t || i) {
                                    return a + (o(e) ? 'roky' : 'let');
                                } else {
                                    return a + 'lety';
                                }
                        }
                    }

                    e.defineLocale('cs', {
                        months: t,
                        monthsShort: n,
                        monthsRegex: a,
                        monthsShortRegex: a,
                        monthsStrictRegex:
                            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
                        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
                        monthsParse: i,
                        longMonthsParse: i,
                        shortMonthsParse: i,
                        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
                        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
                        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY H:mm',
                            LLLL: 'dddd D. MMMM YYYY H:mm',
                            l: 'D. M. YYYY',
                        },
                        calendar: {
                            sameDay: '[dnes v] LT',
                            nextDay: '[zítra v] LT',
                            nextWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                        return '[v neděli v] LT';
                                    case 1:
                                    case 2:
                                        return '[v] dddd [v] LT';
                                    case 3:
                                        return '[ve středu v] LT';
                                    case 4:
                                        return '[ve čtvrtek v] LT';
                                    case 5:
                                        return '[v pátek v] LT';
                                    case 6:
                                        return '[v sobotu v] LT';
                                }
                            },
                            lastDay: '[včera v] LT',
                            lastWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                        return '[minulou neděli v] LT';
                                    case 1:
                                    case 2:
                                        return '[minulé] dddd [v] LT';
                                    case 3:
                                        return '[minulou středu v] LT';
                                    case 4:
                                    case 5:
                                        return '[minulý] dddd [v] LT';
                                    case 6:
                                        return '[minulou sobotu v] LT';
                                }
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'za %s',
                            past: 'před %s',
                            s: r,
                            ss: r,
                            m: r,
                            mm: r,
                            h: r,
                            hh: r,
                            d: r,
                            dd: r,
                            M: r,
                            MM: r,
                            y: r,
                            yy: r,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            1046: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('cv', {
                        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
                        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
                        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
                        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
                        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD-MM-YYYY',
                            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
                            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
                            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
                        },
                        calendar: {
                            sameDay: '[Паян] LT [сехетре]',
                            nextDay: '[Ыран] LT [сехетре]',
                            lastDay: '[Ӗнер] LT [сехетре]',
                            nextWeek: '[Ҫитес] dddd LT [сехетре]',
                            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: function (e) {
                                return e + (/сехет$/i.exec(e) ? 'рен' : /ҫул$/i.exec(e) ? 'тан' : 'ран');
                            },
                            past: '%s каялла',
                            s: 'пӗр-ик ҫеккунт',
                            ss: '%d ҫеккунт',
                            m: 'пӗр минут',
                            mm: '%d минут',
                            h: 'пӗр сехет',
                            hh: '%d сехет',
                            d: 'пӗр кун',
                            dd: '%d кун',
                            M: 'пӗр уйӑх',
                            MM: '%d уйӑх',
                            y: 'пӗр ҫул',
                            yy: '%d ҫул',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
                        ordinal: '%d-мӗш',
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            7711: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('cy', {
                        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
                            '_',
                        ),
                        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
                        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                            '_',
                        ),
                        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
                        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Heddiw am] LT',
                            nextDay: '[Yfory am] LT',
                            nextWeek: 'dddd [am] LT',
                            lastDay: '[Ddoe am] LT',
                            lastWeek: 'dddd [diwethaf am] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'mewn %s',
                            past: '%s yn ôl',
                            s: 'ychydig eiliadau',
                            ss: '%d eiliad',
                            m: 'munud',
                            mm: '%d munud',
                            h: 'awr',
                            hh: '%d awr',
                            d: 'diwrnod',
                            dd: '%d diwrnod',
                            M: 'mis',
                            MM: '%d mis',
                            y: 'blwyddyn',
                            yy: '%d flynedd',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
                        ordinal: function (e) {
                            var t = '';
                            if (e > 20) {
                                if (40 === e || 50 === e || 60 === e || 80 === e || 100 === e) {
                                    t = 'fed';
                                } else {
                                    t = 'ain';
                                }
                            } else if (e > 0) {
                                t = [
                                    '',
                                    'af',
                                    'il',
                                    'ydd',
                                    'ydd',
                                    'ed',
                                    'ed',
                                    'ed',
                                    'fed',
                                    'fed',
                                    'fed',
                                    'eg',
                                    'fed',
                                    'eg',
                                    'eg',
                                    'fed',
                                    'eg',
                                    'eg',
                                    'fed',
                                    'eg',
                                    'fed',
                                ][e];
                            }
                            return e + t;
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            5324: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('da', {
                        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
                            '_',
                        ),
                        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
                        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
                        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
                        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY HH:mm',
                            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
                        },
                        calendar: {
                            sameDay: '[i dag kl.] LT',
                            nextDay: '[i morgen kl.] LT',
                            nextWeek: 'på dddd [kl.] LT',
                            lastDay: '[i går kl.] LT',
                            lastWeek: '[i] dddd[s kl.] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'om %s',
                            past: '%s siden',
                            s: 'få sekunder',
                            ss: '%d sekunder',
                            m: 'et minut',
                            mm: '%d minutter',
                            h: 'en time',
                            hh: '%d timer',
                            d: 'en dag',
                            dd: '%d dage',
                            M: 'en måned',
                            MM: '%d måneder',
                            y: 'et år',
                            yy: '%d år',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            6012: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t, n, i) {
                        var a = {
                            m: ['eine Minute', 'einer Minute'],
                            h: ['eine Stunde', 'einer Stunde'],
                            d: ['ein Tag', 'einem Tag'],
                            dd: [e + ' Tage', e + ' Tagen'],
                            w: ['eine Woche', 'einer Woche'],
                            M: ['ein Monat', 'einem Monat'],
                            MM: [e + ' Monate', e + ' Monaten'],
                            y: ['ein Jahr', 'einem Jahr'],
                            yy: [e + ' Jahre', e + ' Jahren'],
                        };
                        return t ? a[n][0] : a[n][1];
                    }

                    e.defineLocale('de-at', {
                        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
                            '_',
                        ),
                        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
                        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
                        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY HH:mm',
                            LLLL: 'dddd, D. MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[heute um] LT [Uhr]',
                            sameElse: 'L',
                            nextDay: '[morgen um] LT [Uhr]',
                            nextWeek: 'dddd [um] LT [Uhr]',
                            lastDay: '[gestern um] LT [Uhr]',
                            lastWeek: '[letzten] dddd [um] LT [Uhr]',
                        },
                        relativeTime: {
                            future: 'in %s',
                            past: 'vor %s',
                            s: 'ein paar Sekunden',
                            ss: '%d Sekunden',
                            m: t,
                            mm: '%d Minuten',
                            h: t,
                            hh: '%d Stunden',
                            d: t,
                            dd: t,
                            w: t,
                            ww: '%d Wochen',
                            M: t,
                            MM: t,
                            y: t,
                            yy: t,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            8954: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t, n, i) {
                        var a = {
                            m: ['eine Minute', 'einer Minute'],
                            h: ['eine Stunde', 'einer Stunde'],
                            d: ['ein Tag', 'einem Tag'],
                            dd: [e + ' Tage', e + ' Tagen'],
                            w: ['eine Woche', 'einer Woche'],
                            M: ['ein Monat', 'einem Monat'],
                            MM: [e + ' Monate', e + ' Monaten'],
                            y: ['ein Jahr', 'einem Jahr'],
                            yy: [e + ' Jahre', e + ' Jahren'],
                        };
                        return t ? a[n][0] : a[n][1];
                    }

                    e.defineLocale('de-ch', {
                        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
                            '_',
                        ),
                        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
                        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
                        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY HH:mm',
                            LLLL: 'dddd, D. MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[heute um] LT [Uhr]',
                            sameElse: 'L',
                            nextDay: '[morgen um] LT [Uhr]',
                            nextWeek: 'dddd [um] LT [Uhr]',
                            lastDay: '[gestern um] LT [Uhr]',
                            lastWeek: '[letzten] dddd [um] LT [Uhr]',
                        },
                        relativeTime: {
                            future: 'in %s',
                            past: 'vor %s',
                            s: 'ein paar Sekunden',
                            ss: '%d Sekunden',
                            m: t,
                            mm: '%d Minuten',
                            h: t,
                            hh: '%d Stunden',
                            d: t,
                            dd: t,
                            w: t,
                            ww: '%d Wochen',
                            M: t,
                            MM: t,
                            y: t,
                            yy: t,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            6752: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t, n, i) {
                        var a = {
                            m: ['eine Minute', 'einer Minute'],
                            h: ['eine Stunde', 'einer Stunde'],
                            d: ['ein Tag', 'einem Tag'],
                            dd: [e + ' Tage', e + ' Tagen'],
                            w: ['eine Woche', 'einer Woche'],
                            M: ['ein Monat', 'einem Monat'],
                            MM: [e + ' Monate', e + ' Monaten'],
                            y: ['ein Jahr', 'einem Jahr'],
                            yy: [e + ' Jahre', e + ' Jahren'],
                        };
                        return t ? a[n][0] : a[n][1];
                    }

                    e.defineLocale('de', {
                        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
                            '_',
                        ),
                        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
                        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
                        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY HH:mm',
                            LLLL: 'dddd, D. MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[heute um] LT [Uhr]',
                            sameElse: 'L',
                            nextDay: '[morgen um] LT [Uhr]',
                            nextWeek: 'dddd [um] LT [Uhr]',
                            lastDay: '[gestern um] LT [Uhr]',
                            lastWeek: '[letzten] dddd [um] LT [Uhr]',
                        },
                        relativeTime: {
                            future: 'in %s',
                            past: 'vor %s',
                            s: 'ein paar Sekunden',
                            ss: '%d Sekunden',
                            m: t,
                            mm: '%d Minuten',
                            h: t,
                            hh: '%d Stunden',
                            d: t,
                            dd: t,
                            w: t,
                            ww: '%d Wochen',
                            M: t,
                            MM: t,
                            y: t,
                            yy: t,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            2361: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = [
                            'ޖެނުއަރީ',
                            'ފެބްރުއަރީ',
                            'މާރިޗު',
                            'އޭޕްރީލު',
                            'މޭ',
                            'ޖޫން',
                            'ޖުލައި',
                            'އޯގަސްޓު',
                            'ސެޕްޓެމްބަރު',
                            'އޮކްޓޯބަރު',
                            'ނޮވެމްބަރު',
                            'ޑިސެމްބަރު',
                        ],
                        n = ['އާދިއްތަ', 'ހޯމަ', 'އަންގާރަ', 'ބުދަ', 'ބުރާސްފަތި', 'ހުކުރު', 'ހޮނިހިރު'];
                    e.defineLocale('dv', {
                        months: t,
                        monthsShort: t,
                        weekdays: n,
                        weekdaysShort: n,
                        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'D/M/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        meridiemParse: /މކ|މފ/,
                        isPM: function (e) {
                            return 'މފ' === e;
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return 'މކ';
                            } else {
                                return 'މފ';
                            }
                        },
                        calendar: {
                            sameDay: '[މިއަދު] LT',
                            nextDay: '[މާދަމާ] LT',
                            nextWeek: 'dddd LT',
                            lastDay: '[އިއްޔެ] LT',
                            lastWeek: '[ފާއިތުވި] dddd LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'ތެރޭގައި %s',
                            past: 'ކުރިން %s',
                            s: 'ސިކުންތުކޮޅެއް',
                            ss: 'd% ސިކުންތު',
                            m: 'މިނިޓެއް',
                            mm: 'މިނިޓު %d',
                            h: 'ގަޑިއިރެއް',
                            hh: 'ގަޑިއިރު %d',
                            d: 'ދުވަހެއް',
                            dd: 'ދުވަސް %d',
                            M: 'މަހެއް',
                            MM: 'މަސް %d',
                            y: 'އަހަރެއް',
                            yy: 'އަހަރު %d',
                        },
                        preparse: function (e) {
                            return e.replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e.replace(/,/g, '،');
                        },
                        week: { dow: 7, doy: 12 },
                    });
                })(n(2198));
            },
            7890: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e) {
                        return (
                            ('undefined' != typeof Function && e instanceof Function) ||
                            '[object Function]' === Object.prototype.toString.call(e)
                        );
                    }

                    e.defineLocale('el', {
                        monthsNominativeEl:
                            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                                '_',
                            ),
                        monthsGenitiveEl:
                            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                                '_',
                            ),
                        months: function (e, t) {
                            if (!e) {
                                return this._monthsNominativeEl;
                            } else if ('string' == typeof t && /D/.test(t.substring(0, t.indexOf('MMMM')))) {
                                return this._monthsGenitiveEl[e.month()];
                            } else {
                                return this._monthsNominativeEl[e.month()];
                            }
                        },
                        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
                        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
                        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
                        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
                        meridiem: function (e, t, n) {
                            if (e > 11) {
                                return n ? 'μμ' : 'ΜΜ';
                            } else {
                                return n ? 'πμ' : 'ΠΜ';
                            }
                        },
                        isPM: function (e) {
                            return 'μ' === (e + '').toLowerCase()[0];
                        },
                        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
                        longDateFormat: {
                            LT: 'h:mm A',
                            LTS: 'h:mm:ss A',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY h:mm A',
                            LLLL: 'dddd, D MMMM YYYY h:mm A',
                        },
                        calendarEl: {
                            sameDay: '[Σήμερα {}] LT',
                            nextDay: '[Αύριο {}] LT',
                            nextWeek: 'dddd [{}] LT',
                            lastDay: '[Χθες {}] LT',
                            lastWeek: function () {
                                if (6 === this.day()) {
                                    return '[το προηγούμενο] dddd [{}] LT';
                                } else {
                                    return '[την προηγούμενη] dddd [{}] LT';
                                }
                            },
                            sameElse: 'L',
                        },
                        calendar: function (e, n) {
                            var i = this._calendarEl[e],
                                a = n && n.hours();
                            if (t(i)) {
                                i = i.apply(n);
                            }
                            return i.replace('{}', a % 12 == 1 ? 'στη' : 'στις');
                        },
                        relativeTime: {
                            future: 'σε %s',
                            past: '%s πριν',
                            s: 'λίγα δευτερόλεπτα',
                            ss: '%d δευτερόλεπτα',
                            m: 'ένα λεπτό',
                            mm: '%d λεπτά',
                            h: 'μία ώρα',
                            hh: '%d ώρες',
                            d: 'μία μέρα',
                            dd: '%d μέρες',
                            M: 'ένας μήνας',
                            MM: '%d μήνες',
                            y: 'ένας χρόνος',
                            yy: '%d χρόνια',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}η/,
                        ordinal: '%dη',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            891: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('en-au', {
                        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                        longDateFormat: {
                            LT: 'h:mm A',
                            LTS: 'h:mm:ss A',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY h:mm A',
                            LLLL: 'dddd, D MMMM YYYY h:mm A',
                        },
                        calendar: {
                            sameDay: '[Today at] LT',
                            nextDay: '[Tomorrow at] LT',
                            nextWeek: 'dddd [at] LT',
                            lastDay: '[Yesterday at] LT',
                            lastWeek: '[Last] dddd [at] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'in %s',
                            past: '%s ago',
                            s: 'a few seconds',
                            ss: '%d seconds',
                            m: 'a minute',
                            mm: '%d minutes',
                            h: 'an hour',
                            hh: '%d hours',
                            d: 'a day',
                            dd: '%d days',
                            M: 'a month',
                            MM: '%d months',
                            y: 'a year',
                            yy: '%d years',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                        ordinal: function (e) {
                            var t = e % 10;
                            return (
                                e +
                                (1 == ~~((e % 100) / 10)
                                    ? 'th'
                                    : 1 === t
                                    ? 'st'
                                    : 2 === t
                                    ? 'nd'
                                    : 3 === t
                                    ? 'rd'
                                    : 'th')
                            );
                        },
                        week: { dow: 0, doy: 4 },
                    });
                })(n(2198));
            },
            281: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('en-ca', {
                        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                        longDateFormat: {
                            LT: 'h:mm A',
                            LTS: 'h:mm:ss A',
                            L: 'YYYY-MM-DD',
                            LL: 'MMMM D, YYYY',
                            LLL: 'MMMM D, YYYY h:mm A',
                            LLLL: 'dddd, MMMM D, YYYY h:mm A',
                        },
                        calendar: {
                            sameDay: '[Today at] LT',
                            nextDay: '[Tomorrow at] LT',
                            nextWeek: 'dddd [at] LT',
                            lastDay: '[Yesterday at] LT',
                            lastWeek: '[Last] dddd [at] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'in %s',
                            past: '%s ago',
                            s: 'a few seconds',
                            ss: '%d seconds',
                            m: 'a minute',
                            mm: '%d minutes',
                            h: 'an hour',
                            hh: '%d hours',
                            d: 'a day',
                            dd: '%d days',
                            M: 'a month',
                            MM: '%d months',
                            y: 'a year',
                            yy: '%d years',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                        ordinal: function (e) {
                            var t = e % 10;
                            return (
                                e +
                                (1 == ~~((e % 100) / 10)
                                    ? 'th'
                                    : 1 === t
                                    ? 'st'
                                    : 2 === t
                                    ? 'nd'
                                    : 3 === t
                                    ? 'rd'
                                    : 'th')
                            );
                        },
                    });
                })(n(2198));
            },
            1876: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('en-gb', {
                        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Today at] LT',
                            nextDay: '[Tomorrow at] LT',
                            nextWeek: 'dddd [at] LT',
                            lastDay: '[Yesterday at] LT',
                            lastWeek: '[Last] dddd [at] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'in %s',
                            past: '%s ago',
                            s: 'a few seconds',
                            ss: '%d seconds',
                            m: 'a minute',
                            mm: '%d minutes',
                            h: 'an hour',
                            hh: '%d hours',
                            d: 'a day',
                            dd: '%d days',
                            M: 'a month',
                            MM: '%d months',
                            y: 'a year',
                            yy: '%d years',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                        ordinal: function (e) {
                            var t = e % 10;
                            return (
                                e +
                                (1 == ~~((e % 100) / 10)
                                    ? 'th'
                                    : 1 === t
                                    ? 'st'
                                    : 2 === t
                                    ? 'nd'
                                    : 3 === t
                                    ? 'rd'
                                    : 'th')
                            );
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            1107: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('en-ie', {
                        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Today at] LT',
                            nextDay: '[Tomorrow at] LT',
                            nextWeek: 'dddd [at] LT',
                            lastDay: '[Yesterday at] LT',
                            lastWeek: '[Last] dddd [at] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'in %s',
                            past: '%s ago',
                            s: 'a few seconds',
                            ss: '%d seconds',
                            m: 'a minute',
                            mm: '%d minutes',
                            h: 'an hour',
                            hh: '%d hours',
                            d: 'a day',
                            dd: '%d days',
                            M: 'a month',
                            MM: '%d months',
                            y: 'a year',
                            yy: '%d years',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                        ordinal: function (e) {
                            var t = e % 10;
                            return (
                                e +
                                (1 == ~~((e % 100) / 10)
                                    ? 'th'
                                    : 1 === t
                                    ? 'st'
                                    : 2 === t
                                    ? 'nd'
                                    : 3 === t
                                    ? 'rd'
                                    : 'th')
                            );
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            6212: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('en-il', {
                        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Today at] LT',
                            nextDay: '[Tomorrow at] LT',
                            nextWeek: 'dddd [at] LT',
                            lastDay: '[Yesterday at] LT',
                            lastWeek: '[Last] dddd [at] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'in %s',
                            past: '%s ago',
                            s: 'a few seconds',
                            ss: '%d seconds',
                            m: 'a minute',
                            mm: '%d minutes',
                            h: 'an hour',
                            hh: '%d hours',
                            d: 'a day',
                            dd: '%d days',
                            M: 'a month',
                            MM: '%d months',
                            y: 'a year',
                            yy: '%d years',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                        ordinal: function (e) {
                            var t = e % 10;
                            return (
                                e +
                                (1 == ~~((e % 100) / 10)
                                    ? 'th'
                                    : 1 === t
                                    ? 'st'
                                    : 2 === t
                                    ? 'nd'
                                    : 3 === t
                                    ? 'rd'
                                    : 'th')
                            );
                        },
                    });
                })(n(2198));
            },
            6446: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('en-in', {
                        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                        longDateFormat: {
                            LT: 'h:mm A',
                            LTS: 'h:mm:ss A',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY h:mm A',
                            LLLL: 'dddd, D MMMM YYYY h:mm A',
                        },
                        calendar: {
                            sameDay: '[Today at] LT',
                            nextDay: '[Tomorrow at] LT',
                            nextWeek: 'dddd [at] LT',
                            lastDay: '[Yesterday at] LT',
                            lastWeek: '[Last] dddd [at] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'in %s',
                            past: '%s ago',
                            s: 'a few seconds',
                            ss: '%d seconds',
                            m: 'a minute',
                            mm: '%d minutes',
                            h: 'an hour',
                            hh: '%d hours',
                            d: 'a day',
                            dd: '%d days',
                            M: 'a month',
                            MM: '%d months',
                            y: 'a year',
                            yy: '%d years',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                        ordinal: function (e) {
                            var t = e % 10;
                            return (
                                e +
                                (1 == ~~((e % 100) / 10)
                                    ? 'th'
                                    : 1 === t
                                    ? 'st'
                                    : 2 === t
                                    ? 'nd'
                                    : 3 === t
                                    ? 'rd'
                                    : 'th')
                            );
                        },
                        week: { dow: 0, doy: 6 },
                    });
                })(n(2198));
            },
            6189: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('en-nz', {
                        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                        longDateFormat: {
                            LT: 'h:mm A',
                            LTS: 'h:mm:ss A',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY h:mm A',
                            LLLL: 'dddd, D MMMM YYYY h:mm A',
                        },
                        calendar: {
                            sameDay: '[Today at] LT',
                            nextDay: '[Tomorrow at] LT',
                            nextWeek: 'dddd [at] LT',
                            lastDay: '[Yesterday at] LT',
                            lastWeek: '[Last] dddd [at] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'in %s',
                            past: '%s ago',
                            s: 'a few seconds',
                            ss: '%d seconds',
                            m: 'a minute',
                            mm: '%d minutes',
                            h: 'an hour',
                            hh: '%d hours',
                            d: 'a day',
                            dd: '%d days',
                            M: 'a month',
                            MM: '%d months',
                            y: 'a year',
                            yy: '%d years',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                        ordinal: function (e) {
                            var t = e % 10;
                            return (
                                e +
                                (1 == ~~((e % 100) / 10)
                                    ? 'th'
                                    : 1 === t
                                    ? 'st'
                                    : 2 === t
                                    ? 'nd'
                                    : 3 === t
                                    ? 'rd'
                                    : 'th')
                            );
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            9091: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('en-sg', {
                        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Today at] LT',
                            nextDay: '[Tomorrow at] LT',
                            nextWeek: 'dddd [at] LT',
                            lastDay: '[Yesterday at] LT',
                            lastWeek: '[Last] dddd [at] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'in %s',
                            past: '%s ago',
                            s: 'a few seconds',
                            ss: '%d seconds',
                            m: 'a minute',
                            mm: '%d minutes',
                            h: 'an hour',
                            hh: '%d hours',
                            d: 'a day',
                            dd: '%d days',
                            M: 'a month',
                            MM: '%d months',
                            y: 'a year',
                            yy: '%d years',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                        ordinal: function (e) {
                            var t = e % 10;
                            return (
                                e +
                                (1 == ~~((e % 100) / 10)
                                    ? 'th'
                                    : 1 === t
                                    ? 'st'
                                    : 2 === t
                                    ? 'nd'
                                    : 3 === t
                                    ? 'rd'
                                    : 'th')
                            );
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            3791: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('eo', {
                        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
                            '_',
                        ),
                        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
                        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
                        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
                        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'YYYY-MM-DD',
                            LL: '[la] D[-an de] MMMM, YYYY',
                            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
                            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
                            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
                        },
                        meridiemParse: /[ap]\.t\.m/i,
                        isPM: function (e) {
                            return 'p' === e.charAt(0).toLowerCase();
                        },
                        meridiem: function (e, t, n) {
                            if (e > 11) {
                                return n ? 'p.t.m.' : 'P.T.M.';
                            } else {
                                return n ? 'a.t.m.' : 'A.T.M.';
                            }
                        },
                        calendar: {
                            sameDay: '[Hodiaŭ je] LT',
                            nextDay: '[Morgaŭ je] LT',
                            nextWeek: 'dddd[n je] LT',
                            lastDay: '[Hieraŭ je] LT',
                            lastWeek: '[pasintan] dddd[n je] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'post %s',
                            past: 'antaŭ %s',
                            s: 'kelkaj sekundoj',
                            ss: '%d sekundoj',
                            m: 'unu minuto',
                            mm: '%d minutoj',
                            h: 'unu horo',
                            hh: '%d horoj',
                            d: 'unu tago',
                            dd: '%d tagoj',
                            M: 'unu monato',
                            MM: '%d monatoj',
                            y: 'unu jaro',
                            yy: '%d jaroj',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}a/,
                        ordinal: '%da',
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            2969: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
                        n = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
                        i = [
                            /^ene/i,
                            /^feb/i,
                            /^mar/i,
                            /^abr/i,
                            /^may/i,
                            /^jun/i,
                            /^jul/i,
                            /^ago/i,
                            /^sep/i,
                            /^oct/i,
                            /^nov/i,
                            /^dic/i,
                        ],
                        a =
                            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
                    e.defineLocale('es-do', {
                        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
                            '_',
                        ),
                        monthsShort: function (e, i) {
                            if (!e) {
                                return t;
                            } else if (/-MMM-/.test(i)) {
                                return n[e.month()];
                            } else {
                                return t[e.month()];
                            }
                        },
                        monthsRegex: a,
                        monthsShortRegex: a,
                        monthsStrictRegex:
                            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
                        monthsShortStrictRegex:
                            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
                        monthsParse: i,
                        longMonthsParse: i,
                        shortMonthsParse: i,
                        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
                        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
                        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'h:mm A',
                            LTS: 'h:mm:ss A',
                            L: 'DD/MM/YYYY',
                            LL: 'D [de] MMMM [de] YYYY',
                            LLL: 'D [de] MMMM [de] YYYY h:mm A',
                            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
                        },
                        calendar: {
                            sameDay: function () {
                                return '[hoy a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            nextDay: function () {
                                return '[mañana a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            nextWeek: function () {
                                return 'dddd [a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            lastDay: function () {
                                return '[ayer a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            lastWeek: function () {
                                return '[el] dddd [pasado a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'en %s',
                            past: 'hace %s',
                            s: 'unos segundos',
                            ss: '%d segundos',
                            m: 'un minuto',
                            mm: '%d minutos',
                            h: 'una hora',
                            hh: '%d horas',
                            d: 'un día',
                            dd: '%d días',
                            w: 'una semana',
                            ww: '%d semanas',
                            M: 'un mes',
                            MM: '%d meses',
                            y: 'un año',
                            yy: '%d años',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}º/,
                        ordinal: '%dº',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            57: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
                        n = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
                        i = [
                            /^ene/i,
                            /^feb/i,
                            /^mar/i,
                            /^abr/i,
                            /^may/i,
                            /^jun/i,
                            /^jul/i,
                            /^ago/i,
                            /^sep/i,
                            /^oct/i,
                            /^nov/i,
                            /^dic/i,
                        ],
                        a =
                            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
                    e.defineLocale('es-mx', {
                        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
                            '_',
                        ),
                        monthsShort: function (e, i) {
                            if (!e) {
                                return t;
                            } else if (/-MMM-/.test(i)) {
                                return n[e.month()];
                            } else {
                                return t[e.month()];
                            }
                        },
                        monthsRegex: a,
                        monthsShortRegex: a,
                        monthsStrictRegex:
                            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
                        monthsShortStrictRegex:
                            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
                        monthsParse: i,
                        longMonthsParse: i,
                        shortMonthsParse: i,
                        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
                        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
                        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D [de] MMMM [de] YYYY',
                            LLL: 'D [de] MMMM [de] YYYY H:mm',
                            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
                        },
                        calendar: {
                            sameDay: function () {
                                return '[hoy a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            nextDay: function () {
                                return '[mañana a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            nextWeek: function () {
                                return 'dddd [a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            lastDay: function () {
                                return '[ayer a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            lastWeek: function () {
                                return '[el] dddd [pasado a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'en %s',
                            past: 'hace %s',
                            s: 'unos segundos',
                            ss: '%d segundos',
                            m: 'un minuto',
                            mm: '%d minutos',
                            h: 'una hora',
                            hh: '%d horas',
                            d: 'un día',
                            dd: '%d días',
                            w: 'una semana',
                            ww: '%d semanas',
                            M: 'un mes',
                            MM: '%d meses',
                            y: 'un año',
                            yy: '%d años',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}º/,
                        ordinal: '%dº',
                        week: { dow: 0, doy: 4 },
                        invalidDate: 'Fecha inválida',
                    });
                })(n(2198));
            },
            4976: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
                        n = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
                        i = [
                            /^ene/i,
                            /^feb/i,
                            /^mar/i,
                            /^abr/i,
                            /^may/i,
                            /^jun/i,
                            /^jul/i,
                            /^ago/i,
                            /^sep/i,
                            /^oct/i,
                            /^nov/i,
                            /^dic/i,
                        ],
                        a =
                            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
                    e.defineLocale('es-us', {
                        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
                            '_',
                        ),
                        monthsShort: function (e, i) {
                            if (!e) {
                                return t;
                            } else if (/-MMM-/.test(i)) {
                                return n[e.month()];
                            } else {
                                return t[e.month()];
                            }
                        },
                        monthsRegex: a,
                        monthsShortRegex: a,
                        monthsStrictRegex:
                            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
                        monthsShortStrictRegex:
                            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
                        monthsParse: i,
                        longMonthsParse: i,
                        shortMonthsParse: i,
                        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
                        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
                        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'h:mm A',
                            LTS: 'h:mm:ss A',
                            L: 'MM/DD/YYYY',
                            LL: 'D [de] MMMM [de] YYYY',
                            LLL: 'D [de] MMMM [de] YYYY h:mm A',
                            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
                        },
                        calendar: {
                            sameDay: function () {
                                return '[hoy a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            nextDay: function () {
                                return '[mañana a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            nextWeek: function () {
                                return 'dddd [a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            lastDay: function () {
                                return '[ayer a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            lastWeek: function () {
                                return '[el] dddd [pasado a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'en %s',
                            past: 'hace %s',
                            s: 'unos segundos',
                            ss: '%d segundos',
                            m: 'un minuto',
                            mm: '%d minutos',
                            h: 'una hora',
                            hh: '%d horas',
                            d: 'un día',
                            dd: '%d días',
                            w: 'una semana',
                            ww: '%d semanas',
                            M: 'un mes',
                            MM: '%d meses',
                            y: 'un año',
                            yy: '%d años',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}º/,
                        ordinal: '%dº',
                        week: { dow: 0, doy: 6 },
                    });
                })(n(2198));
            },
            4659: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
                        n = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
                        i = [
                            /^ene/i,
                            /^feb/i,
                            /^mar/i,
                            /^abr/i,
                            /^may/i,
                            /^jun/i,
                            /^jul/i,
                            /^ago/i,
                            /^sep/i,
                            /^oct/i,
                            /^nov/i,
                            /^dic/i,
                        ],
                        a =
                            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
                    e.defineLocale('es', {
                        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
                            '_',
                        ),
                        monthsShort: function (e, i) {
                            if (!e) {
                                return t;
                            } else if (/-MMM-/.test(i)) {
                                return n[e.month()];
                            } else {
                                return t[e.month()];
                            }
                        },
                        monthsRegex: a,
                        monthsShortRegex: a,
                        monthsStrictRegex:
                            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
                        monthsShortStrictRegex:
                            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
                        monthsParse: i,
                        longMonthsParse: i,
                        shortMonthsParse: i,
                        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
                        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
                        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D [de] MMMM [de] YYYY',
                            LLL: 'D [de] MMMM [de] YYYY H:mm',
                            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
                        },
                        calendar: {
                            sameDay: function () {
                                return '[hoy a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            nextDay: function () {
                                return '[mañana a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            nextWeek: function () {
                                return 'dddd [a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            lastDay: function () {
                                return '[ayer a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            lastWeek: function () {
                                return '[el] dddd [pasado a la' + (1 !== this.hours() ? 's' : '') + '] LT';
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'en %s',
                            past: 'hace %s',
                            s: 'unos segundos',
                            ss: '%d segundos',
                            m: 'un minuto',
                            mm: '%d minutos',
                            h: 'una hora',
                            hh: '%d horas',
                            d: 'un día',
                            dd: '%d días',
                            w: 'una semana',
                            ww: '%d semanas',
                            M: 'un mes',
                            MM: '%d meses',
                            y: 'un año',
                            yy: '%d años',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}º/,
                        ordinal: '%dº',
                        week: { dow: 1, doy: 4 },
                        invalidDate: 'Fecha inválida',
                    });
                })(n(2198));
            },
            970: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t, n, i) {
                        var a = {
                            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
                            ss: [e + 'sekundi', e + 'sekundit'],
                            m: ['ühe minuti', 'üks minut'],
                            mm: [e + ' minuti', e + ' minutit'],
                            h: ['ühe tunni', 'tund aega', 'üks tund'],
                            hh: [e + ' tunni', e + ' tundi'],
                            d: ['ühe päeva', 'üks päev'],
                            M: ['kuu aja', 'kuu aega', 'üks kuu'],
                            MM: [e + ' kuu', e + ' kuud'],
                            y: ['ühe aasta', 'aasta', 'üks aasta'],
                            yy: [e + ' aasta', e + ' aastat'],
                        };
                        if (t) {
                            return a[n][2] ? a[n][2] : a[n][1];
                        } else {
                            return i ? a[n][0] : a[n][1];
                        }
                    }

                    e.defineLocale('et', {
                        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
                            '_',
                        ),
                        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
                        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
                        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
                        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY H:mm',
                            LLLL: 'dddd, D. MMMM YYYY H:mm',
                        },
                        calendar: {
                            sameDay: '[Täna,] LT',
                            nextDay: '[Homme,] LT',
                            nextWeek: '[Järgmine] dddd LT',
                            lastDay: '[Eile,] LT',
                            lastWeek: '[Eelmine] dddd LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s pärast',
                            past: '%s tagasi',
                            s: t,
                            ss: t,
                            m: t,
                            mm: t,
                            h: t,
                            hh: t,
                            d: t,
                            dd: '%d päeva',
                            M: t,
                            MM: t,
                            y: t,
                            yy: t,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            7401: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('eu', {
                        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
                            '_',
                        ),
                        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
                        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
                        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'YYYY-MM-DD',
                            LL: 'YYYY[ko] MMMM[ren] D[a]',
                            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
                            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
                            l: 'YYYY-M-D',
                            ll: 'YYYY[ko] MMM D[a]',
                            lll: 'YYYY[ko] MMM D[a] HH:mm',
                            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
                        },
                        calendar: {
                            sameDay: '[gaur] LT[etan]',
                            nextDay: '[bihar] LT[etan]',
                            nextWeek: 'dddd LT[etan]',
                            lastDay: '[atzo] LT[etan]',
                            lastWeek: '[aurreko] dddd LT[etan]',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s barru',
                            past: 'duela %s',
                            s: 'segundo batzuk',
                            ss: '%d segundo',
                            m: 'minutu bat',
                            mm: '%d minutu',
                            h: 'ordu bat',
                            hh: '%d ordu',
                            d: 'egun bat',
                            dd: '%d egun',
                            M: 'hilabete bat',
                            MM: '%d hilabete',
                            y: 'urte bat',
                            yy: '%d urte',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            4954: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '۱', 2: '۲', 3: '۳', 4: '۴', 5: '۵', 6: '۶', 7: '۷', 8: '۸', 9: '۹', 0: '۰' },
                        n = {
                            '۱': '1',
                            '۲': '2',
                            '۳': '3',
                            '۴': '4',
                            '۵': '5',
                            '۶': '6',
                            '۷': '7',
                            '۸': '8',
                            '۹': '9',
                            '۰': '0',
                        };
                    e.defineLocale('fa', {
                        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
                        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
                        weekdays: 'یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه'.split('_'),
                        weekdaysShort: 'یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه'.split('_'),
                        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        meridiemParse: /قبل از ظهر|بعد از ظهر/,
                        isPM: function (e) {
                            return /بعد از ظهر/.test(e);
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return 'قبل از ظهر';
                            } else {
                                return 'بعد از ظهر';
                            }
                        },
                        calendar: {
                            sameDay: '[امروز ساعت] LT',
                            nextDay: '[فردا ساعت] LT',
                            nextWeek: 'dddd [ساعت] LT',
                            lastDay: '[دیروز ساعت] LT',
                            lastWeek: 'dddd [پیش] [ساعت] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'در %s',
                            past: '%s پیش',
                            s: 'چند ثانیه',
                            ss: '%d ثانیه',
                            m: 'یک دقیقه',
                            mm: '%d دقیقه',
                            h: 'یک ساعت',
                            hh: '%d ساعت',
                            d: 'یک روز',
                            dd: '%d روز',
                            M: 'یک ماه',
                            MM: '%d ماه',
                            y: 'یک سال',
                            yy: '%d سال',
                        },
                        preparse: function (e) {
                            return e
                                .replace(/[۰-۹]/g, function (e) {
                                    return n[e];
                                })
                                .replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e
                                .replace(/\d/g, function (e) {
                                    return t[e];
                                })
                                .replace(/,/g, '،');
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}م/,
                        ordinal: '%dم',
                        week: { dow: 6, doy: 12 },
                    });
                })(n(2198));
            },
            8066: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
                        n = ['nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden', t[7], t[8], t[9]];

                    function i(e, t, n, i) {
                        var o = '';
                        switch (n) {
                            case 's':
                                return i ? 'muutaman sekunnin' : 'muutama sekunti';
                            case 'ss':
                                o = i ? 'sekunnin' : 'sekuntia';
                                break;
                            case 'm':
                                return i ? 'minuutin' : 'minuutti';
                            case 'mm':
                                o = i ? 'minuutin' : 'minuuttia';
                                break;
                            case 'h':
                                return i ? 'tunnin' : 'tunti';
                            case 'hh':
                                o = i ? 'tunnin' : 'tuntia';
                                break;
                            case 'd':
                                return i ? 'päivän' : 'päivä';
                            case 'dd':
                                o = i ? 'päivän' : 'päivää';
                                break;
                            case 'M':
                                return i ? 'kuukauden' : 'kuukausi';
                            case 'MM':
                                o = i ? 'kuukauden' : 'kuukautta';
                                break;
                            case 'y':
                                return i ? 'vuoden' : 'vuosi';
                            case 'yy':
                                o = i ? 'vuoden' : 'vuotta';
                        }
                        return (o = a(e, i) + ' ' + o);
                    }

                    function a(e, i) {
                        return e < 10 ? (i ? n[e] : t[e]) : e;
                    }

                    e.defineLocale('fi', {
                        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
                            '_',
                        ),
                        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
                        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
                        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
                        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
                        longDateFormat: {
                            LT: 'HH.mm',
                            LTS: 'HH.mm.ss',
                            L: 'DD.MM.YYYY',
                            LL: 'Do MMMM[ta] YYYY',
                            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
                            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
                            l: 'D.M.YYYY',
                            ll: 'Do MMM YYYY',
                            lll: 'Do MMM YYYY, [klo] HH.mm',
                            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
                        },
                        calendar: {
                            sameDay: '[tänään] [klo] LT',
                            nextDay: '[huomenna] [klo] LT',
                            nextWeek: 'dddd [klo] LT',
                            lastDay: '[eilen] [klo] LT',
                            lastWeek: '[viime] dddd[na] [klo] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s päästä',
                            past: '%s sitten',
                            s: i,
                            ss: i,
                            m: i,
                            mm: i,
                            h: i,
                            hh: i,
                            d: i,
                            dd: i,
                            M: i,
                            MM: i,
                            y: i,
                            yy: i,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            6428: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('fil', {
                        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
                            '_',
                        ),
                        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
                        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
                        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
                        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'MM/D/YYYY',
                            LL: 'MMMM D, YYYY',
                            LLL: 'MMMM D, YYYY HH:mm',
                            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: 'LT [ngayong araw]',
                            nextDay: '[Bukas ng] LT',
                            nextWeek: 'LT [sa susunod na] dddd',
                            lastDay: 'LT [kahapon]',
                            lastWeek: 'LT [noong nakaraang] dddd',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'sa loob ng %s',
                            past: '%s ang nakalipas',
                            s: 'ilang segundo',
                            ss: '%d segundo',
                            m: 'isang minuto',
                            mm: '%d minuto',
                            h: 'isang oras',
                            hh: '%d oras',
                            d: 'isang araw',
                            dd: '%d araw',
                            M: 'isang buwan',
                            MM: '%d buwan',
                            y: 'isang taon',
                            yy: '%d taon',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}/,
                        ordinal: function (e) {
                            return e;
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            3924: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('fo', {
                        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
                            '_',
                        ),
                        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
                        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                            '_',
                        ),
                        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
                        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D. MMMM, YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Í dag kl.] LT',
                            nextDay: '[Í morgin kl.] LT',
                            nextWeek: 'dddd [kl.] LT',
                            lastDay: '[Í gjár kl.] LT',
                            lastWeek: '[síðstu] dddd [kl] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'um %s',
                            past: '%s síðani',
                            s: 'fá sekund',
                            ss: '%d sekundir',
                            m: 'ein minuttur',
                            mm: '%d minuttir',
                            h: 'ein tími',
                            hh: '%d tímar',
                            d: 'ein dagur',
                            dd: '%d dagar',
                            M: 'ein mánaður',
                            MM: '%d mánaðir',
                            y: 'eitt ár',
                            yy: '%d ár',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            2028: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('fr-ca', {
                        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
                            '_',
                        ),
                        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
                        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
                        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'YYYY-MM-DD',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Aujourd’hui à] LT',
                            nextDay: '[Demain à] LT',
                            nextWeek: 'dddd [à] LT',
                            lastDay: '[Hier à] LT',
                            lastWeek: 'dddd [dernier à] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'dans %s',
                            past: 'il y a %s',
                            s: 'quelques secondes',
                            ss: '%d secondes',
                            m: 'une minute',
                            mm: '%d minutes',
                            h: 'une heure',
                            hh: '%d heures',
                            d: 'un jour',
                            dd: '%d jours',
                            M: 'un mois',
                            MM: '%d mois',
                            y: 'un an',
                            yy: '%d ans',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
                        ordinal: function (e, t) {
                            switch (t) {
                                default:
                                case 'M':
                                case 'Q':
                                case 'D':
                                case 'DDD':
                                case 'd':
                                    return e + (1 === e ? 'er' : 'e');
                                case 'w':
                                case 'W':
                                    return e + (1 === e ? 're' : 'e');
                            }
                        },
                    });
                })(n(2198));
            },
            6571: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('fr-ch', {
                        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
                            '_',
                        ),
                        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
                        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
                        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Aujourd’hui à] LT',
                            nextDay: '[Demain à] LT',
                            nextWeek: 'dddd [à] LT',
                            lastDay: '[Hier à] LT',
                            lastWeek: 'dddd [dernier à] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'dans %s',
                            past: 'il y a %s',
                            s: 'quelques secondes',
                            ss: '%d secondes',
                            m: 'une minute',
                            mm: '%d minutes',
                            h: 'une heure',
                            hh: '%d heures',
                            d: 'un jour',
                            dd: '%d jours',
                            M: 'un mois',
                            MM: '%d mois',
                            y: 'un an',
                            yy: '%d ans',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
                        ordinal: function (e, t) {
                            switch (t) {
                                default:
                                case 'M':
                                case 'Q':
                                case 'D':
                                case 'DDD':
                                case 'd':
                                    return e + (1 === e ? 'er' : 'e');
                                case 'w':
                                case 'W':
                                    return e + (1 === e ? 're' : 'e');
                            }
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            4615: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
                        n = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
                        i =
                            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
                        a = [
                            /^janv/i,
                            /^févr/i,
                            /^mars/i,
                            /^avr/i,
                            /^mai/i,
                            /^juin/i,
                            /^juil/i,
                            /^août/i,
                            /^sept/i,
                            /^oct/i,
                            /^nov/i,
                            /^déc/i,
                        ];
                    e.defineLocale('fr', {
                        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
                            '_',
                        ),
                        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
                        monthsRegex: i,
                        monthsShortRegex: i,
                        monthsStrictRegex: t,
                        monthsShortStrictRegex: n,
                        monthsParse: a,
                        longMonthsParse: a,
                        shortMonthsParse: a,
                        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
                        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
                        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Aujourd’hui à] LT',
                            nextDay: '[Demain à] LT',
                            nextWeek: 'dddd [à] LT',
                            lastDay: '[Hier à] LT',
                            lastWeek: 'dddd [dernier à] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'dans %s',
                            past: 'il y a %s',
                            s: 'quelques secondes',
                            ss: '%d secondes',
                            m: 'une minute',
                            mm: '%d minutes',
                            h: 'une heure',
                            hh: '%d heures',
                            d: 'un jour',
                            dd: '%d jours',
                            w: 'une semaine',
                            ww: '%d semaines',
                            M: 'un mois',
                            MM: '%d mois',
                            y: 'un an',
                            yy: '%d ans',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
                        ordinal: function (e, t) {
                            switch (t) {
                                case 'D':
                                    return e + (1 === e ? 'er' : '');
                                default:
                                case 'M':
                                case 'Q':
                                case 'DDD':
                                case 'd':
                                    return e + (1 === e ? 'er' : 'e');
                                case 'w':
                                case 'W':
                                    return e + (1 === e ? 're' : 'e');
                            }
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            2450: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
                        n = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
                    e.defineLocale('fy', {
                        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
                            '_',
                        ),
                        monthsShort: function (e, i) {
                            if (!e) {
                                return t;
                            } else if (/-MMM-/.test(i)) {
                                return n[e.month()];
                            } else {
                                return t[e.month()];
                            }
                        },
                        monthsParseExact: !0,
                        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
                        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
                        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD-MM-YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[hjoed om] LT',
                            nextDay: '[moarn om] LT',
                            nextWeek: 'dddd [om] LT',
                            lastDay: '[juster om] LT',
                            lastWeek: '[ôfrûne] dddd [om] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'oer %s',
                            past: '%s lyn',
                            s: 'in pear sekonden',
                            ss: '%d sekonden',
                            m: 'ien minút',
                            mm: '%d minuten',
                            h: 'ien oere',
                            hh: '%d oeren',
                            d: 'ien dei',
                            dd: '%d dagen',
                            M: 'ien moanne',
                            MM: '%d moannen',
                            y: 'ien jier',
                            yy: '%d jierren',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
                        ordinal: function (e) {
                            return e + (1 === e || 8 === e || e >= 20 ? 'ste' : 'de');
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            4363: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = [
                            'Eanáir',
                            'Feabhra',
                            'Márta',
                            'Aibreán',
                            'Bealtaine',
                            'Meitheamh',
                            'Iúil',
                            'Lúnasa',
                            'Meán Fómhair',
                            'Deireadh Fómhair',
                            'Samhain',
                            'Nollaig',
                        ],
                        n = [
                            'Ean',
                            'Feabh',
                            'Márt',
                            'Aib',
                            'Beal',
                            'Meith',
                            'Iúil',
                            'Lún',
                            'M.F.',
                            'D.F.',
                            'Samh',
                            'Noll',
                        ],
                        i = [
                            'Dé Domhnaigh',
                            'Dé Luain',
                            'Dé Máirt',
                            'Dé Céadaoin',
                            'Déardaoin',
                            'Dé hAoine',
                            'Dé Sathairn',
                        ],
                        a = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
                        o = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
                    e.defineLocale('ga', {
                        months: t,
                        monthsShort: n,
                        monthsParseExact: !0,
                        weekdays: i,
                        weekdaysShort: a,
                        weekdaysMin: o,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Inniu ag] LT',
                            nextDay: '[Amárach ag] LT',
                            nextWeek: 'dddd [ag] LT',
                            lastDay: '[Inné ag] LT',
                            lastWeek: 'dddd [seo caite] [ag] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'i %s',
                            past: '%s ó shin',
                            s: 'cúpla soicind',
                            ss: '%d soicind',
                            m: 'nóiméad',
                            mm: '%d nóiméad',
                            h: 'uair an chloig',
                            hh: '%d uair an chloig',
                            d: 'lá',
                            dd: '%d lá',
                            M: 'mí',
                            MM: '%d míonna',
                            y: 'bliain',
                            yy: '%d bliain',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
                        ordinal: function (e) {
                            return e + (1 === e ? 'd' : e % 10 == 2 ? 'na' : 'mh');
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            8920: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = [
                            'Am Faoilleach',
                            'An Gearran',
                            'Am Màrt',
                            'An Giblean',
                            'An Cèitean',
                            'An t-Ògmhios',
                            'An t-Iuchar',
                            'An Lùnastal',
                            'An t-Sultain',
                            'An Dàmhair',
                            'An t-Samhain',
                            'An Dùbhlachd',
                        ],
                        n = [
                            'Faoi',
                            'Gear',
                            'Màrt',
                            'Gibl',
                            'Cèit',
                            'Ògmh',
                            'Iuch',
                            'Lùn',
                            'Sult',
                            'Dàmh',
                            'Samh',
                            'Dùbh',
                        ],
                        i = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'],
                        a = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
                        o = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
                    e.defineLocale('gd', {
                        months: t,
                        monthsShort: n,
                        monthsParseExact: !0,
                        weekdays: i,
                        weekdaysShort: a,
                        weekdaysMin: o,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[An-diugh aig] LT',
                            nextDay: '[A-màireach aig] LT',
                            nextWeek: 'dddd [aig] LT',
                            lastDay: '[An-dè aig] LT',
                            lastWeek: 'dddd [seo chaidh] [aig] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'ann an %s',
                            past: 'bho chionn %s',
                            s: 'beagan diogan',
                            ss: '%d diogan',
                            m: 'mionaid',
                            mm: '%d mionaidean',
                            h: 'uair',
                            hh: '%d uairean',
                            d: 'latha',
                            dd: '%d latha',
                            M: 'mìos',
                            MM: '%d mìosan',
                            y: 'bliadhna',
                            yy: '%d bliadhna',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
                        ordinal: function (e) {
                            return e + (1 === e ? 'd' : e % 10 == 2 ? 'na' : 'mh');
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            5072: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('gl', {
                        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
                            '_',
                        ),
                        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
                        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
                        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D [de] MMMM [de] YYYY',
                            LLL: 'D [de] MMMM [de] YYYY H:mm',
                            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
                        },
                        calendar: {
                            sameDay: function () {
                                return '[hoxe ' + (1 !== this.hours() ? 'ás' : 'á') + '] LT';
                            },
                            nextDay: function () {
                                return '[mañá ' + (1 !== this.hours() ? 'ás' : 'á') + '] LT';
                            },
                            nextWeek: function () {
                                return 'dddd [' + (1 !== this.hours() ? 'ás' : 'a') + '] LT';
                            },
                            lastDay: function () {
                                return '[onte ' + (1 !== this.hours() ? 'á' : 'a') + '] LT';
                            },
                            lastWeek: function () {
                                return '[o] dddd [pasado ' + (1 !== this.hours() ? 'ás' : 'a') + '] LT';
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: function (e) {
                                if (0 === e.indexOf('un')) {
                                    return 'n' + e;
                                } else {
                                    return 'en ' + e;
                                }
                            },
                            past: 'hai %s',
                            s: 'uns segundos',
                            ss: '%d segundos',
                            m: 'un minuto',
                            mm: '%d minutos',
                            h: 'unha hora',
                            hh: '%d horas',
                            d: 'un día',
                            dd: '%d días',
                            M: 'un mes',
                            MM: '%d meses',
                            y: 'un ano',
                            yy: '%d anos',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}º/,
                        ordinal: '%dº',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            7609: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t, n, i) {
                        var a = {
                            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
                            ss: [e + ' सॅकंडांनी', e + ' सॅकंड'],
                            m: ['एका मिणटान', 'एक मिनूट'],
                            mm: [e + ' मिणटांनी', e + ' मिणटां'],
                            h: ['एका वरान', 'एक वर'],
                            hh: [e + ' वरांनी', e + ' वरां'],
                            d: ['एका दिसान', 'एक दीस'],
                            dd: [e + ' दिसांनी', e + ' दीस'],
                            M: ['एका म्हयन्यान', 'एक म्हयनो'],
                            MM: [e + ' म्हयन्यानी', e + ' म्हयने'],
                            y: ['एका वर्सान', 'एक वर्स'],
                            yy: [e + ' वर्सांनी', e + ' वर्सां'],
                        };
                        return i ? a[n][0] : a[n][1];
                    }

                    e.defineLocale('gom-deva', {
                        months: {
                            standalone:
                                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                                    '_',
                                ),
                            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                                '_',
                            ),
                            isFormat: /MMMM(\s)+D[oD]?/,
                        },
                        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                            '_',
                        ),
                        monthsParseExact: !0,
                        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
                        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
                        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'A h:mm [वाजतां]',
                            LTS: 'A h:mm:ss [वाजतां]',
                            L: 'DD-MM-YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
                            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
                            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
                        },
                        calendar: {
                            sameDay: '[आयज] LT',
                            nextDay: '[फाल्यां] LT',
                            nextWeek: '[फुडलो] dddd[,] LT',
                            lastDay: '[काल] LT',
                            lastWeek: '[फाटलो] dddd[,] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s',
                            past: '%s आदीं',
                            s: t,
                            ss: t,
                            m: t,
                            mm: t,
                            h: t,
                            hh: t,
                            d: t,
                            dd: t,
                            M: t,
                            MM: t,
                            y: t,
                            yy: t,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
                        ordinal: function (e, t) {
                            if ('D' === t) {
                                return e + 'वेर';
                            } else {
                                return e;
                            }
                        },
                        week: { dow: 0, doy: 3 },
                        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('राती' === t) {
                                return e < 4 ? e : e + 12;
                            } else if ('सकाळीं' === t) {
                                return e;
                            } else if ('दनपारां' === t) {
                                return e > 12 ? e : e + 12;
                            } else if ('सांजे' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 4) {
                                return 'राती';
                            } else if (e < 12) {
                                return 'सकाळीं';
                            } else if (e < 16) {
                                return 'दनपारां';
                            } else if (e < 20) {
                                return 'सांजे';
                            } else {
                                return 'राती';
                            }
                        },
                    });
                })(n(2198));
            },
            7314: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t, n, i) {
                        var a = {
                            s: ['thoddea sekondamni', 'thodde sekond'],
                            ss: [e + ' sekondamni', e + ' sekond'],
                            m: ['eka mintan', 'ek minut'],
                            mm: [e + ' mintamni', e + ' mintam'],
                            h: ['eka voran', 'ek vor'],
                            hh: [e + ' voramni', e + ' voram'],
                            d: ['eka disan', 'ek dis'],
                            dd: [e + ' disamni', e + ' dis'],
                            M: ['eka mhoinean', 'ek mhoino'],
                            MM: [e + ' mhoineamni', e + ' mhoine'],
                            y: ['eka vorsan', 'ek voros'],
                            yy: [e + ' vorsamni', e + ' vorsam'],
                        };
                        return i ? a[n][0] : a[n][1];
                    }

                    e.defineLocale('gom-latn', {
                        months: {
                            standalone:
                                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
                            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                                '_',
                            ),
                            isFormat: /MMMM(\s)+D[oD]?/,
                        },
                        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
                        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
                        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'A h:mm [vazta]',
                            LTS: 'A h:mm:ss [vazta]',
                            L: 'DD-MM-YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY A h:mm [vazta]',
                            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
                            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
                        },
                        calendar: {
                            sameDay: '[Aiz] LT',
                            nextDay: '[Faleam] LT',
                            nextWeek: '[Fuddlo] dddd[,] LT',
                            lastDay: '[Kal] LT',
                            lastWeek: '[Fattlo] dddd[,] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s',
                            past: '%s adim',
                            s: t,
                            ss: t,
                            m: t,
                            mm: t,
                            h: t,
                            hh: t,
                            d: t,
                            dd: t,
                            M: t,
                            MM: t,
                            y: t,
                            yy: t,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
                        ordinal: function (e, t) {
                            if ('D' === t) {
                                return e + 'er';
                            } else {
                                return e;
                            }
                        },
                        week: { dow: 0, doy: 3 },
                        meridiemParse: /rati|sokallim|donparam|sanje/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('rati' === t) {
                                return e < 4 ? e : e + 12;
                            } else if ('sokallim' === t) {
                                return e;
                            } else if ('donparam' === t) {
                                return e > 12 ? e : e + 12;
                            } else if ('sanje' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 4) {
                                return 'rati';
                            } else if (e < 12) {
                                return 'sokallim';
                            } else if (e < 16) {
                                return 'donparam';
                            } else if (e < 20) {
                                return 'sanje';
                            } else {
                                return 'rati';
                            }
                        },
                    });
                })(n(2198));
            },
            9215: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '૧', 2: '૨', 3: '૩', 4: '૪', 5: '૫', 6: '૬', 7: '૭', 8: '૮', 9: '૯', 0: '૦' },
                        n = {
                            '૧': '1',
                            '૨': '2',
                            '૩': '3',
                            '૪': '4',
                            '૫': '5',
                            '૬': '6',
                            '૭': '7',
                            '૮': '8',
                            '૯': '9',
                            '૦': '0',
                        };
                    e.defineLocale('gu', {
                        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
                            '_',
                        ),
                        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                            '_',
                        ),
                        monthsParseExact: !0,
                        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
                        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
                        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm વાગ્યે',
                            LTS: 'A h:mm:ss વાગ્યે',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
                        },
                        calendar: {
                            sameDay: '[આજ] LT',
                            nextDay: '[કાલે] LT',
                            nextWeek: 'dddd, LT',
                            lastDay: '[ગઇકાલે] LT',
                            lastWeek: '[પાછલા] dddd, LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s મા',
                            past: '%s પહેલા',
                            s: 'અમુક પળો',
                            ss: '%d સેકંડ',
                            m: 'એક મિનિટ',
                            mm: '%d મિનિટ',
                            h: 'એક કલાક',
                            hh: '%d કલાક',
                            d: 'એક દિવસ',
                            dd: '%d દિવસ',
                            M: 'એક મહિનો',
                            MM: '%d મહિનો',
                            y: 'એક વર્ષ',
                            yy: '%d વર્ષ',
                        },
                        preparse: function (e) {
                            return e.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (e) {
                                return n[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('રાત' === t) {
                                return e < 4 ? e : e + 12;
                            } else if ('સવાર' === t) {
                                return e;
                            } else if ('બપોર' === t) {
                                return e >= 10 ? e : e + 12;
                            } else if ('સાંજ' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 4) {
                                return 'રાત';
                            } else if (e < 10) {
                                return 'સવાર';
                            } else if (e < 17) {
                                return 'બપોર';
                            } else if (e < 20) {
                                return 'સાંજ';
                            } else {
                                return 'રાત';
                            }
                        },
                        week: { dow: 0, doy: 6 },
                    });
                })(n(2198));
            },
            9548: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('he', {
                        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
                        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
                        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
                        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
                        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D [ב]MMMM YYYY',
                            LLL: 'D [ב]MMMM YYYY HH:mm',
                            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
                            l: 'D/M/YYYY',
                            ll: 'D MMM YYYY',
                            lll: 'D MMM YYYY HH:mm',
                            llll: 'ddd, D MMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[היום ב־]LT',
                            nextDay: '[מחר ב־]LT',
                            nextWeek: 'dddd [בשעה] LT',
                            lastDay: '[אתמול ב־]LT',
                            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'בעוד %s',
                            past: 'לפני %s',
                            s: 'מספר שניות',
                            ss: '%d שניות',
                            m: 'דקה',
                            mm: '%d דקות',
                            h: 'שעה',
                            hh: function (e) {
                                if (2 === e) {
                                    return 'שעתיים';
                                } else {
                                    return e + ' שעות';
                                }
                            },
                            d: 'יום',
                            dd: function (e) {
                                if (2 === e) {
                                    return 'יומיים';
                                } else {
                                    return e + ' ימים';
                                }
                            },
                            M: 'חודש',
                            MM: function (e) {
                                if (2 === e) {
                                    return 'חודשיים';
                                } else {
                                    return e + ' חודשים';
                                }
                            },
                            y: 'שנה',
                            yy: function (e) {
                                if (2 === e) {
                                    return 'שנתיים';
                                } else if (e % 10 == 0 && 10 !== e) {
                                    return e + ' שנה';
                                }
                                return e + ' שנים';
                            },
                        },
                        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
                        isPM: function (e) {
                            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(e);
                        },
                        meridiem: function (e, t, n) {
                            if (e < 5) {
                                return 'לפנות בוקר';
                            } else if (e < 10) {
                                return 'בבוקר';
                            } else if (e < 12) {
                                return n ? 'לפנה"צ' : 'לפני הצהריים';
                            } else if (e < 18) {
                                return n ? 'אחה"צ' : 'אחרי הצהריים';
                            } else {
                                return 'בערב';
                            }
                        },
                    });
                })(n(2198));
            },
            8440: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '१', 2: '२', 3: '३', 4: '४', 5: '५', 6: '६', 7: '७', 8: '८', 9: '९', 0: '०' },
                        n = {
                            '१': '1',
                            '२': '2',
                            '३': '3',
                            '४': '4',
                            '५': '5',
                            '६': '6',
                            '७': '7',
                            '८': '8',
                            '९': '9',
                            '०': '0',
                        },
                        i = [
                            /^जन/i,
                            /^फ़र|फर/i,
                            /^मार्च/i,
                            /^अप्रै/i,
                            /^मई/i,
                            /^जून/i,
                            /^जुल/i,
                            /^अग/i,
                            /^सितं|सित/i,
                            /^अक्टू/i,
                            /^नव|नवं/i,
                            /^दिसं|दिस/i,
                        ],
                        a = [
                            /^जन/i,
                            /^फ़र/i,
                            /^मार्च/i,
                            /^अप्रै/i,
                            /^मई/i,
                            /^जून/i,
                            /^जुल/i,
                            /^अग/i,
                            /^सित/i,
                            /^अक्टू/i,
                            /^नव/i,
                            /^दिस/i,
                        ];
                    e.defineLocale('hi', {
                        months: {
                            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                                '_',
                            ),
                            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                                '_',
                            ),
                        },
                        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
                        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
                        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
                        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm बजे',
                            LTS: 'A h:mm:ss बजे',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm बजे',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
                        },
                        monthsParse: i,
                        longMonthsParse: i,
                        shortMonthsParse: a,
                        monthsRegex:
                            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
                        monthsShortRegex:
                            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
                        monthsStrictRegex:
                            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
                        monthsShortStrictRegex:
                            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
                        calendar: {
                            sameDay: '[आज] LT',
                            nextDay: '[कल] LT',
                            nextWeek: 'dddd, LT',
                            lastDay: '[कल] LT',
                            lastWeek: '[पिछले] dddd, LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s में',
                            past: '%s पहले',
                            s: 'कुछ ही क्षण',
                            ss: '%d सेकंड',
                            m: 'एक मिनट',
                            mm: '%d मिनट',
                            h: 'एक घंटा',
                            hh: '%d घंटे',
                            d: 'एक दिन',
                            dd: '%d दिन',
                            M: 'एक महीने',
                            MM: '%d महीने',
                            y: 'एक वर्ष',
                            yy: '%d वर्ष',
                        },
                        preparse: function (e) {
                            return e.replace(/[१२३४५६७८९०]/g, function (e) {
                                return n[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /रात|सुबह|दोपहर|शाम/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('रात' === t) {
                                return e < 4 ? e : e + 12;
                            } else if ('सुबह' === t) {
                                return e;
                            } else if ('दोपहर' === t) {
                                return e >= 10 ? e : e + 12;
                            } else if ('शाम' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 4) {
                                return 'रात';
                            } else if (e < 10) {
                                return 'सुबह';
                            } else if (e < 17) {
                                return 'दोपहर';
                            } else if (e < 20) {
                                return 'शाम';
                            } else {
                                return 'रात';
                            }
                        },
                        week: { dow: 0, doy: 6 },
                    });
                })(n(2198));
            },
            7641: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t, n) {
                        var i = e + ' ';
                        switch (n) {
                            case 'ss':
                                if (1 === e) {
                                    i += 'sekunda';
                                } else if (2 === e || 3 === e || 4 === e) {
                                    i += 'sekunde';
                                } else {
                                    i += 'sekundi';
                                }
                                return i;
                            case 'm':
                                return t ? 'jedna minuta' : 'jedne minute';
                            case 'mm':
                                if (1 === e) {
                                    i += 'minuta';
                                } else if (2 === e || 3 === e || 4 === e) {
                                    i += 'minute';
                                } else {
                                    i += 'minuta';
                                }
                                return i;
                            case 'h':
                                return t ? 'jedan sat' : 'jednog sata';
                            case 'hh':
                                if (1 === e) {
                                    i += 'sat';
                                } else if (2 === e || 3 === e || 4 === e) {
                                    i += 'sata';
                                } else {
                                    i += 'sati';
                                }
                                return i;
                            case 'dd':
                                if (1 === e) {
                                    i += 'dan';
                                } else {
                                    i += 'dana';
                                }
                                return i;
                            case 'MM':
                                if (1 === e) {
                                    i += 'mjesec';
                                } else if (2 === e || 3 === e || 4 === e) {
                                    i += 'mjeseca';
                                } else {
                                    i += 'mjeseci';
                                }
                                return i;
                            case 'yy':
                                if (1 === e) {
                                    i += 'godina';
                                } else if (2 === e || 3 === e || 4 === e) {
                                    i += 'godine';
                                } else {
                                    i += 'godina';
                                }
                                return i;
                        }
                    }

                    e.defineLocale('hr', {
                        months: {
                            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                                '_',
                            ),
                            standalone:
                                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                                    '_',
                                ),
                        },
                        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
                        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
                        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'Do MMMM YYYY',
                            LLL: 'Do MMMM YYYY H:mm',
                            LLLL: 'dddd, Do MMMM YYYY H:mm',
                        },
                        calendar: {
                            sameDay: '[danas u] LT',
                            nextDay: '[sutra u] LT',
                            nextWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                        return '[u] [nedjelju] [u] LT';
                                    case 3:
                                        return '[u] [srijedu] [u] LT';
                                    case 6:
                                        return '[u] [subotu] [u] LT';
                                    case 1:
                                    case 2:
                                    case 4:
                                    case 5:
                                        return '[u] dddd [u] LT';
                                }
                            },
                            lastDay: '[jučer u] LT',
                            lastWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                        return '[prošlu] [nedjelju] [u] LT';
                                    case 3:
                                        return '[prošlu] [srijedu] [u] LT';
                                    case 6:
                                        return '[prošle] [subote] [u] LT';
                                    case 1:
                                    case 2:
                                    case 4:
                                    case 5:
                                        return '[prošli] dddd [u] LT';
                                }
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'za %s',
                            past: 'prije %s',
                            s: 'par sekundi',
                            ss: t,
                            m: t,
                            mm: t,
                            h: t,
                            hh: t,
                            d: 'dan',
                            dd: t,
                            M: 'mjesec',
                            MM: t,
                            y: 'godinu',
                            yy: t,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            9676: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');

                    function n(e, t, n, i) {
                        var a = e;
                        switch (n) {
                            case 's':
                                return i || t ? 'néhány másodperc' : 'néhány másodperce';
                            case 'ss':
                                return a + (i || t) ? ' másodperc' : ' másodperce';
                            case 'm':
                                return 'egy' + (i || t ? ' perc' : ' perce');
                            case 'mm':
                                return a + (i || t ? ' perc' : ' perce');
                            case 'h':
                                return 'egy' + (i || t ? ' óra' : ' órája');
                            case 'hh':
                                return a + (i || t ? ' óra' : ' órája');
                            case 'd':
                                return 'egy' + (i || t ? ' nap' : ' napja');
                            case 'dd':
                                return a + (i || t ? ' nap' : ' napja');
                            case 'M':
                                return 'egy' + (i || t ? ' hónap' : ' hónapja');
                            case 'MM':
                                return a + (i || t ? ' hónap' : ' hónapja');
                            case 'y':
                                return 'egy' + (i || t ? ' év' : ' éve');
                            case 'yy':
                                return a + (i || t ? ' év' : ' éve');
                        }
                        return '';
                    }

                    function i(e) {
                        return (e ? '' : '[múlt] ') + '[' + t[this.day()] + '] LT[-kor]';
                    }

                    e.defineLocale('hu', {
                        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
                            '_',
                        ),
                        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
                        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
                        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'YYYY.MM.DD.',
                            LL: 'YYYY. MMMM D.',
                            LLL: 'YYYY. MMMM D. H:mm',
                            LLLL: 'YYYY. MMMM D., dddd H:mm',
                        },
                        meridiemParse: /de|du/i,
                        isPM: function (e) {
                            return 'u' === e.charAt(1).toLowerCase();
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return !0 === n ? 'de' : 'DE';
                            } else {
                                return !0 === n ? 'du' : 'DU';
                            }
                        },
                        calendar: {
                            sameDay: '[ma] LT[-kor]',
                            nextDay: '[holnap] LT[-kor]',
                            nextWeek: function () {
                                return i.call(this, !0);
                            },
                            lastDay: '[tegnap] LT[-kor]',
                            lastWeek: function () {
                                return i.call(this, !1);
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s múlva',
                            past: '%s',
                            s: n,
                            ss: n,
                            m: n,
                            mm: n,
                            h: n,
                            hh: n,
                            d: n,
                            dd: n,
                            M: n,
                            MM: n,
                            y: n,
                            yy: n,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            6243: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('hy-am', {
                        months: {
                            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                                '_',
                            ),
                            standalone:
                                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                                    '_',
                                ),
                        },
                        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
                        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
                        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
                        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY թ.',
                            LLL: 'D MMMM YYYY թ., HH:mm',
                            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
                        },
                        calendar: {
                            sameDay: '[այսօր] LT',
                            nextDay: '[վաղը] LT',
                            lastDay: '[երեկ] LT',
                            nextWeek: function () {
                                return 'dddd [օրը ժամը] LT';
                            },
                            lastWeek: function () {
                                return '[անցած] dddd [օրը ժամը] LT';
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s հետո',
                            past: '%s առաջ',
                            s: 'մի քանի վայրկյան',
                            ss: '%d վայրկյան',
                            m: 'րոպե',
                            mm: '%d րոպե',
                            h: 'ժամ',
                            hh: '%d ժամ',
                            d: 'օր',
                            dd: '%d օր',
                            M: 'ամիս',
                            MM: '%d ամիս',
                            y: 'տարի',
                            yy: '%d տարի',
                        },
                        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
                        isPM: function (e) {
                            return /^(ցերեկվա|երեկոյան)$/.test(e);
                        },
                        meridiem: function (e) {
                            if (e < 4) {
                                return 'գիշերվա';
                            } else if (e < 12) {
                                return 'առավոտվա';
                            } else if (e < 17) {
                                return 'ցերեկվա';
                            } else {
                                return 'երեկոյան';
                            }
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
                        ordinal: function (e, t) {
                            switch (t) {
                                case 'DDD':
                                case 'w':
                                case 'W':
                                case 'DDDo':
                                    if (1 === e) {
                                        return e + '-ին';
                                    } else {
                                        return e + '-րդ';
                                    }
                                default:
                                    return e;
                            }
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            2342: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('id', {
                        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
                        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
                        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
                        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
                        longDateFormat: {
                            LT: 'HH.mm',
                            LTS: 'HH.mm.ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY [pukul] HH.mm',
                            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
                        },
                        meridiemParse: /pagi|siang|sore|malam/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('pagi' === t) {
                                return e;
                            } else if ('siang' === t) {
                                return e >= 11 ? e : e + 12;
                            } else if ('sore' === t || 'malam' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 11) {
                                return 'pagi';
                            } else if (e < 15) {
                                return 'siang';
                            } else if (e < 19) {
                                return 'sore';
                            } else {
                                return 'malam';
                            }
                        },
                        calendar: {
                            sameDay: '[Hari ini pukul] LT',
                            nextDay: '[Besok pukul] LT',
                            nextWeek: 'dddd [pukul] LT',
                            lastDay: '[Kemarin pukul] LT',
                            lastWeek: 'dddd [lalu pukul] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'dalam %s',
                            past: '%s yang lalu',
                            s: 'beberapa detik',
                            ss: '%d detik',
                            m: 'semenit',
                            mm: '%d menit',
                            h: 'sejam',
                            hh: '%d jam',
                            d: 'sehari',
                            dd: '%d hari',
                            M: 'sebulan',
                            MM: '%d bulan',
                            y: 'setahun',
                            yy: '%d tahun',
                        },
                        week: { dow: 0, doy: 6 },
                    });
                })(n(2198));
            },
            8311: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e) {
                        if (e % 100 == 11) {
                            return !0;
                        } else if (e % 10 == 1) {
                            return !1;
                        }
                        return !0;
                    }

                    function n(e, n, i, a) {
                        var o = e + ' ';
                        switch (i) {
                            case 's':
                                return n || a ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
                            case 'ss':
                                if (t(e)) {
                                    return o + (n || a ? 'sekúndur' : 'sekúndum');
                                } else {
                                    return o + 'sekúnda';
                                }
                            case 'm':
                                return n ? 'mínúta' : 'mínútu';
                            case 'mm':
                                if (t(e)) {
                                    return o + (n || a ? 'mínútur' : 'mínútum');
                                } else if (n) {
                                    return o + 'mínúta';
                                }
                                return o + 'mínútu';
                            case 'hh':
                                if (t(e)) {
                                    return o + (n || a ? 'klukkustundir' : 'klukkustundum');
                                } else {
                                    return o + 'klukkustund';
                                }
                            case 'd':
                                if (n) {
                                    return 'dagur';
                                } else {
                                    return a ? 'dag' : 'degi';
                                }
                            case 'dd':
                                if (t(e)) {
                                    if (n) {
                                        return o + 'dagar';
                                    } else {
                                        return o + (a ? 'daga' : 'dögum');
                                    }
                                } else if (n) {
                                    return o + 'dagur';
                                }
                                return o + (a ? 'dag' : 'degi');
                            case 'M':
                                if (n) {
                                    return 'mánuður';
                                } else {
                                    return a ? 'mánuð' : 'mánuði';
                                }
                            case 'MM':
                                if (t(e)) {
                                    if (n) {
                                        return o + 'mánuðir';
                                    } else {
                                        return o + (a ? 'mánuði' : 'mánuðum');
                                    }
                                } else if (n) {
                                    return o + 'mánuður';
                                }
                                return o + (a ? 'mánuð' : 'mánuði');
                            case 'y':
                                return n || a ? 'ár' : 'ári';
                            case 'yy':
                                if (t(e)) {
                                    return o + (n || a ? 'ár' : 'árum');
                                } else {
                                    return o + (n || a ? 'ár' : 'ári');
                                }
                        }
                    }

                    e.defineLocale('is', {
                        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
                            '_',
                        ),
                        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
                        weekdays:
                            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                                '_',
                            ),
                        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
                        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY [kl.] H:mm',
                            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
                        },
                        calendar: {
                            sameDay: '[í dag kl.] LT',
                            nextDay: '[á morgun kl.] LT',
                            nextWeek: 'dddd [kl.] LT',
                            lastDay: '[í gær kl.] LT',
                            lastWeek: '[síðasta] dddd [kl.] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'eftir %s',
                            past: 'fyrir %s síðan',
                            s: n,
                            ss: n,
                            m: n,
                            mm: n,
                            h: 'klukkustund',
                            hh: n,
                            d: n,
                            dd: n,
                            M: n,
                            MM: n,
                            y: n,
                            yy: n,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            944: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('it-ch', {
                        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
                            '_',
                        ),
                        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
                        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
                        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
                        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Oggi alle] LT',
                            nextDay: '[Domani alle] LT',
                            nextWeek: 'dddd [alle] LT',
                            lastDay: '[Ieri alle] LT',
                            lastWeek: function () {
                                if (0 === this.day()) {
                                    return '[la scorsa] dddd [alle] LT';
                                } else {
                                    return '[lo scorso] dddd [alle] LT';
                                }
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: function (e) {
                                return (/^[0-9].+$/.test(e) ? 'tra' : 'in') + ' ' + e;
                            },
                            past: '%s fa',
                            s: 'alcuni secondi',
                            ss: '%d secondi',
                            m: 'un minuto',
                            mm: '%d minuti',
                            h: "un'ora",
                            hh: '%d ore',
                            d: 'un giorno',
                            dd: '%d giorni',
                            M: 'un mese',
                            MM: '%d mesi',
                            y: 'un anno',
                            yy: '%d anni',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}º/,
                        ordinal: '%dº',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            8630: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('it', {
                        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
                            '_',
                        ),
                        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
                        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
                        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
                        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: function () {
                                return (
                                    '[Oggi a' + (this.hours() > 1 ? 'lle ' : 0 === this.hours() ? ' ' : "ll'") + ']LT'
                                );
                            },
                            nextDay: function () {
                                return (
                                    '[Domani a' + (this.hours() > 1 ? 'lle ' : 0 === this.hours() ? ' ' : "ll'") + ']LT'
                                );
                            },
                            nextWeek: function () {
                                return (
                                    'dddd [a' + (this.hours() > 1 ? 'lle ' : 0 === this.hours() ? ' ' : "ll'") + ']LT'
                                );
                            },
                            lastDay: function () {
                                return (
                                    '[Ieri a' + (this.hours() > 1 ? 'lle ' : 0 === this.hours() ? ' ' : "ll'") + ']LT'
                                );
                            },
                            lastWeek: function () {
                                if (0 === this.day()) {
                                    return (
                                        '[La scorsa] dddd [a' +
                                        (this.hours() > 1 ? 'lle ' : 0 === this.hours() ? ' ' : "ll'") +
                                        ']LT'
                                    );
                                } else {
                                    return (
                                        '[Lo scorso] dddd [a' +
                                        (this.hours() > 1 ? 'lle ' : 0 === this.hours() ? ' ' : "ll'") +
                                        ']LT'
                                    );
                                }
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'tra %s',
                            past: '%s fa',
                            s: 'alcuni secondi',
                            ss: '%d secondi',
                            m: 'un minuto',
                            mm: '%d minuti',
                            h: "un'ora",
                            hh: '%d ore',
                            d: 'un giorno',
                            dd: '%d giorni',
                            w: 'una settimana',
                            ww: '%d settimane',
                            M: 'un mese',
                            MM: '%d mesi',
                            y: 'un anno',
                            yy: '%d anni',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}º/,
                        ordinal: '%dº',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            6158: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('ja', {
                        eras: [
                            { since: '2019-05-01', offset: 1, name: '令和', narrow: '㋿', abbr: 'R' },
                            {
                                since: '1989-01-08',
                                until: '2019-04-30',
                                offset: 1,
                                name: '平成',
                                narrow: '㍻',
                                abbr: 'H',
                            },
                            {
                                since: '1926-12-25',
                                until: '1989-01-07',
                                offset: 1,
                                name: '昭和',
                                narrow: '㍼',
                                abbr: 'S',
                            },
                            {
                                since: '1912-07-30',
                                until: '1926-12-24',
                                offset: 1,
                                name: '大正',
                                narrow: '㍽',
                                abbr: 'T',
                            },
                            {
                                since: '1873-01-01',
                                until: '1912-07-29',
                                offset: 6,
                                name: '明治',
                                narrow: '㍾',
                                abbr: 'M',
                            },
                            {
                                since: '0001-01-01',
                                until: '1873-12-31',
                                offset: 1,
                                name: '西暦',
                                narrow: 'AD',
                                abbr: 'AD',
                            },
                            { since: '0000-12-31', until: -1 / 0, offset: 1, name: '紀元前', narrow: 'BC', abbr: 'BC' },
                        ],
                        eraYearOrdinalRegex: /(元|\d+)年/,
                        eraYearOrdinalParse: function (e, t) {
                            return '元' === t[1] ? 1 : parseInt(t[1] || e, 10);
                        },
                        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
                        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
                        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
                        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
                        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'YYYY/MM/DD',
                            LL: 'YYYY年M月D日',
                            LLL: 'YYYY年M月D日 HH:mm',
                            LLLL: 'YYYY年M月D日 dddd HH:mm',
                            l: 'YYYY/MM/DD',
                            ll: 'YYYY年M月D日',
                            lll: 'YYYY年M月D日 HH:mm',
                            llll: 'YYYY年M月D日(ddd) HH:mm',
                        },
                        meridiemParse: /午前|午後/i,
                        isPM: function (e) {
                            return '午後' === e;
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return '午前';
                            } else {
                                return '午後';
                            }
                        },
                        calendar: {
                            sameDay: '[今日] LT',
                            nextDay: '[明日] LT',
                            nextWeek: function (e) {
                                if (e.week() !== this.week()) {
                                    return '[来週]dddd LT';
                                } else {
                                    return 'dddd LT';
                                }
                            },
                            lastDay: '[昨日] LT',
                            lastWeek: function (e) {
                                if (this.week() !== e.week()) {
                                    return '[先週]dddd LT';
                                } else {
                                    return 'dddd LT';
                                }
                            },
                            sameElse: 'L',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}日/,
                        ordinal: function (e, t) {
                            switch (t) {
                                case 'y':
                                    return 1 === e ? '元年' : e + '年';
                                case 'd':
                                case 'D':
                                case 'DDD':
                                    return e + '日';
                                default:
                                    return e;
                            }
                        },
                        relativeTime: {
                            future: '%s後',
                            past: '%s前',
                            s: '数秒',
                            ss: '%d秒',
                            m: '1分',
                            mm: '%d分',
                            h: '1時間',
                            hh: '%d時間',
                            d: '1日',
                            dd: '%d日',
                            M: '1ヶ月',
                            MM: '%dヶ月',
                            y: '1年',
                            yy: '%d年',
                        },
                    });
                })(n(2198));
            },
            319: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('jv', {
                        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
                        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
                        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
                        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
                        longDateFormat: {
                            LT: 'HH.mm',
                            LTS: 'HH.mm.ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY [pukul] HH.mm',
                            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
                        },
                        meridiemParse: /enjing|siyang|sonten|ndalu/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('enjing' === t) {
                                return e;
                            } else if ('siyang' === t) {
                                return e >= 11 ? e : e + 12;
                            } else if ('sonten' === t || 'ndalu' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 11) {
                                return 'enjing';
                            } else if (e < 15) {
                                return 'siyang';
                            } else if (e < 19) {
                                return 'sonten';
                            } else {
                                return 'ndalu';
                            }
                        },
                        calendar: {
                            sameDay: '[Dinten puniko pukul] LT',
                            nextDay: '[Mbenjang pukul] LT',
                            nextWeek: 'dddd [pukul] LT',
                            lastDay: '[Kala wingi pukul] LT',
                            lastWeek: 'dddd [kepengker pukul] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'wonten ing %s',
                            past: '%s ingkang kepengker',
                            s: 'sawetawis detik',
                            ss: '%d detik',
                            m: 'setunggal menit',
                            mm: '%d menit',
                            h: 'setunggal jam',
                            hh: '%d jam',
                            d: 'sedinten',
                            dd: '%d dinten',
                            M: 'sewulan',
                            MM: '%d wulan',
                            y: 'setaun',
                            yy: '%d taun',
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            3567: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('ka', {
                        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
                            '_',
                        ),
                        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
                        weekdays: {
                            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
                            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
                            isFormat: /(წინა|შემდეგ)/,
                        },
                        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
                        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[დღეს] LT[-ზე]',
                            nextDay: '[ხვალ] LT[-ზე]',
                            lastDay: '[გუშინ] LT[-ზე]',
                            nextWeek: '[შემდეგ] dddd LT[-ზე]',
                            lastWeek: '[წინა] dddd LT-ზე',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: function (e) {
                                return e.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (e, t, n) {
                                    return 'ი' === n ? t + 'ში' : t + n + 'ში';
                                });
                            },
                            past: function (e) {
                                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(e)) {
                                    return e.replace(/(ი|ე)$/, 'ის წინ');
                                }
                                if (/წელი/.test(e)) {
                                    return e.replace(/წელი$/, 'წლის წინ');
                                } else {
                                    return e;
                                }
                            },
                            s: 'რამდენიმე წამი',
                            ss: '%d წამი',
                            m: 'წუთი',
                            mm: '%d წუთი',
                            h: 'საათი',
                            hh: '%d საათი',
                            d: 'დღე',
                            dd: '%d დღე',
                            M: 'თვე',
                            MM: '%d თვე',
                            y: 'წელი',
                            yy: '%d წელი',
                        },
                        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
                        ordinal: function (e) {
                            if (0 === e) {
                                return e;
                            }
                            if (1 === e) {
                                return e + '-ლი';
                            }
                            if (e < 20 || (e <= 100 && e % 20 == 0) || e % 100 == 0) {
                                return 'მე-' + e;
                            } else {
                                return e + '-ე';
                            }
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            2857: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = {
                        0: '-ші',
                        1: '-ші',
                        2: '-ші',
                        3: '-ші',
                        4: '-ші',
                        5: '-ші',
                        6: '-шы',
                        7: '-ші',
                        8: '-ші',
                        9: '-шы',
                        10: '-шы',
                        20: '-шы',
                        30: '-шы',
                        40: '-шы',
                        50: '-ші',
                        60: '-шы',
                        70: '-ші',
                        80: '-ші',
                        90: '-шы',
                        100: '-ші',
                    };
                    e.defineLocale('kk', {
                        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
                            '_',
                        ),
                        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
                        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
                        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
                        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Бүгін сағат] LT',
                            nextDay: '[Ертең сағат] LT',
                            nextWeek: 'dddd [сағат] LT',
                            lastDay: '[Кеше сағат] LT',
                            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s ішінде',
                            past: '%s бұрын',
                            s: 'бірнеше секунд',
                            ss: '%d секунд',
                            m: 'бір минут',
                            mm: '%d минут',
                            h: 'бір сағат',
                            hh: '%d сағат',
                            d: 'бір күн',
                            dd: '%d күн',
                            M: 'бір ай',
                            MM: '%d ай',
                            y: 'бір жыл',
                            yy: '%d жыл',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
                        ordinal: function (e) {
                            var n = e % 10,
                                i = e >= 100 ? 100 : null;
                            return e + (t[e] || t[n] || t[i]);
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            5683: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '១', 2: '២', 3: '៣', 4: '៤', 5: '៥', 6: '៦', 7: '៧', 8: '៨', 9: '៩', 0: '០' },
                        n = {
                            '១': '1',
                            '២': '2',
                            '៣': '3',
                            '៤': '4',
                            '៥': '5',
                            '៦': '6',
                            '៧': '7',
                            '៨': '8',
                            '៩': '9',
                            '០': '0',
                        };
                    e.defineLocale('km', {
                        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
                        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                            '_',
                        ),
                        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
                        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
                        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        meridiemParse: /ព្រឹក|ល្ងាច/,
                        isPM: function (e) {
                            return 'ល្ងាច' === e;
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return 'ព្រឹក';
                            } else {
                                return 'ល្ងាច';
                            }
                        },
                        calendar: {
                            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
                            nextDay: '[ស្អែក ម៉ោង] LT',
                            nextWeek: 'dddd [ម៉ោង] LT',
                            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
                            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%sទៀត',
                            past: '%sមុន',
                            s: 'ប៉ុន្មានវិនាទី',
                            ss: '%d វិនាទី',
                            m: 'មួយនាទី',
                            mm: '%d នាទី',
                            h: 'មួយម៉ោង',
                            hh: '%d ម៉ោង',
                            d: 'មួយថ្ងៃ',
                            dd: '%d ថ្ងៃ',
                            M: 'មួយខែ',
                            MM: '%d ខែ',
                            y: 'មួយឆ្នាំ',
                            yy: '%d ឆ្នាំ',
                        },
                        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
                        ordinal: 'ទី%d',
                        preparse: function (e) {
                            return e.replace(/[១២៣៤៥៦៧៨៩០]/g, function (e) {
                                return n[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            4454: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '೧', 2: '೨', 3: '೩', 4: '೪', 5: '೫', 6: '೬', 7: '೭', 8: '೮', 9: '೯', 0: '೦' },
                        n = {
                            '೧': '1',
                            '೨': '2',
                            '೩': '3',
                            '೪': '4',
                            '೫': '5',
                            '೬': '6',
                            '೭': '7',
                            '೮': '8',
                            '೯': '9',
                            '೦': '0',
                        };
                    e.defineLocale('kn', {
                        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
                            '_',
                        ),
                        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                            '_',
                        ),
                        monthsParseExact: !0,
                        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
                        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
                        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm',
                            LTS: 'A h:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm',
                        },
                        calendar: {
                            sameDay: '[ಇಂದು] LT',
                            nextDay: '[ನಾಳೆ] LT',
                            nextWeek: 'dddd, LT',
                            lastDay: '[ನಿನ್ನೆ] LT',
                            lastWeek: '[ಕೊನೆಯ] dddd, LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s ನಂತರ',
                            past: '%s ಹಿಂದೆ',
                            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
                            ss: '%d ಸೆಕೆಂಡುಗಳು',
                            m: 'ಒಂದು ನಿಮಿಷ',
                            mm: '%d ನಿಮಿಷ',
                            h: 'ಒಂದು ಗಂಟೆ',
                            hh: '%d ಗಂಟೆ',
                            d: 'ಒಂದು ದಿನ',
                            dd: '%d ದಿನ',
                            M: 'ಒಂದು ತಿಂಗಳು',
                            MM: '%d ತಿಂಗಳು',
                            y: 'ಒಂದು ವರ್ಷ',
                            yy: '%d ವರ್ಷ',
                        },
                        preparse: function (e) {
                            return e.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (e) {
                                return n[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('ರಾತ್ರಿ' === t) {
                                return e < 4 ? e : e + 12;
                            } else if ('ಬೆಳಿಗ್ಗೆ' === t) {
                                return e;
                            } else if ('ಮಧ್ಯಾಹ್ನ' === t) {
                                return e >= 10 ? e : e + 12;
                            } else if ('ಸಂಜೆ' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 4) {
                                return 'ರಾತ್ರಿ';
                            } else if (e < 10) {
                                return 'ಬೆಳಿಗ್ಗೆ';
                            } else if (e < 17) {
                                return 'ಮಧ್ಯಾಹ್ನ';
                            } else if (e < 20) {
                                return 'ಸಂಜೆ';
                            } else {
                                return 'ರಾತ್ರಿ';
                            }
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
                        ordinal: function (e) {
                            return e + 'ನೇ';
                        },
                        week: { dow: 0, doy: 6 },
                    });
                })(n(2198));
            },
            5173: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('ko', {
                        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
                        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
                        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
                        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
                        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm',
                            LTS: 'A h:mm:ss',
                            L: 'YYYY.MM.DD.',
                            LL: 'YYYY년 MMMM D일',
                            LLL: 'YYYY년 MMMM D일 A h:mm',
                            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
                            l: 'YYYY.MM.DD.',
                            ll: 'YYYY년 MMMM D일',
                            lll: 'YYYY년 MMMM D일 A h:mm',
                            llll: 'YYYY년 MMMM D일 dddd A h:mm',
                        },
                        calendar: {
                            sameDay: '오늘 LT',
                            nextDay: '내일 LT',
                            nextWeek: 'dddd LT',
                            lastDay: '어제 LT',
                            lastWeek: '지난주 dddd LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s 후',
                            past: '%s 전',
                            s: '몇 초',
                            ss: '%d초',
                            m: '1분',
                            mm: '%d분',
                            h: '한 시간',
                            hh: '%d시간',
                            d: '하루',
                            dd: '%d일',
                            M: '한 달',
                            MM: '%d달',
                            y: '일 년',
                            yy: '%d년',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
                        ordinal: function (e, t) {
                            switch (t) {
                                case 'd':
                                case 'D':
                                case 'DDD':
                                    return e + '일';
                                case 'M':
                                    return e + '월';
                                case 'w':
                                case 'W':
                                    return e + '주';
                                default:
                                    return e;
                            }
                        },
                        meridiemParse: /오전|오후/,
                        isPM: function (e) {
                            return '오후' === e;
                        },
                        meridiem: function (e, t, n) {
                            return e < 12 ? '오전' : '오후';
                        },
                    });
                })(n(2198));
            },
            4555: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '١', 2: '٢', 3: '٣', 4: '٤', 5: '٥', 6: '٦', 7: '٧', 8: '٨', 9: '٩', 0: '٠' },
                        n = {
                            '١': '1',
                            '٢': '2',
                            '٣': '3',
                            '٤': '4',
                            '٥': '5',
                            '٦': '6',
                            '٧': '7',
                            '٨': '8',
                            '٩': '9',
                            '٠': '0',
                        },
                        i = [
                            'کانونی دووەم',
                            'شوبات',
                            'ئازار',
                            'نیسان',
                            'ئایار',
                            'حوزەیران',
                            'تەمموز',
                            'ئاب',
                            'ئەیلوول',
                            'تشرینی یەكەم',
                            'تشرینی دووەم',
                            'كانونی یەکەم',
                        ];
                    e.defineLocale('ku', {
                        months: i,
                        monthsShort: i,
                        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
                        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
                        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        meridiemParse: /ئێواره‌|به‌یانی/,
                        isPM: function (e) {
                            return /ئێواره‌/.test(e);
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return 'به‌یانی';
                            } else {
                                return 'ئێواره‌';
                            }
                        },
                        calendar: {
                            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
                            nextDay: '[به‌یانی كاتژمێر] LT',
                            nextWeek: 'dddd [كاتژمێر] LT',
                            lastDay: '[دوێنێ كاتژمێر] LT',
                            lastWeek: 'dddd [كاتژمێر] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'له‌ %s',
                            past: '%s',
                            s: 'چه‌ند چركه‌یه‌ك',
                            ss: 'چركه‌ %d',
                            m: 'یه‌ك خوله‌ك',
                            mm: '%d خوله‌ك',
                            h: 'یه‌ك كاتژمێر',
                            hh: '%d كاتژمێر',
                            d: 'یه‌ك ڕۆژ',
                            dd: '%d ڕۆژ',
                            M: 'یه‌ك مانگ',
                            MM: '%d مانگ',
                            y: 'یه‌ك ساڵ',
                            yy: '%d ساڵ',
                        },
                        preparse: function (e) {
                            return e
                                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (e) {
                                    return n[e];
                                })
                                .replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e
                                .replace(/\d/g, function (e) {
                                    return t[e];
                                })
                                .replace(/,/g, '،');
                        },
                        week: { dow: 6, doy: 12 },
                    });
                })(n(2198));
            },
            6615: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = {
                        0: '-чү',
                        1: '-чи',
                        2: '-чи',
                        3: '-чү',
                        4: '-чү',
                        5: '-чи',
                        6: '-чы',
                        7: '-чи',
                        8: '-чи',
                        9: '-чу',
                        10: '-чу',
                        20: '-чы',
                        30: '-чу',
                        40: '-чы',
                        50: '-чү',
                        60: '-чы',
                        70: '-чи',
                        80: '-чи',
                        90: '-чу',
                        100: '-чү',
                    };
                    e.defineLocale('ky', {
                        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                            '_',
                        ),
                        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
                        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
                        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
                        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Бүгүн саат] LT',
                            nextDay: '[Эртең саат] LT',
                            nextWeek: 'dddd [саат] LT',
                            lastDay: '[Кечээ саат] LT',
                            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s ичинде',
                            past: '%s мурун',
                            s: 'бирнече секунд',
                            ss: '%d секунд',
                            m: 'бир мүнөт',
                            mm: '%d мүнөт',
                            h: 'бир саат',
                            hh: '%d саат',
                            d: 'бир күн',
                            dd: '%d күн',
                            M: 'бир ай',
                            MM: '%d ай',
                            y: 'бир жыл',
                            yy: '%d жыл',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
                        ordinal: function (e) {
                            var n = e % 10,
                                i = e >= 100 ? 100 : null;
                            return e + (t[e] || t[n] || t[i]);
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            2029: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t, n, i) {
                        var a = {
                            m: ['eng Minutt', 'enger Minutt'],
                            h: ['eng Stonn', 'enger Stonn'],
                            d: ['een Dag', 'engem Dag'],
                            M: ['ee Mount', 'engem Mount'],
                            y: ['ee Joer', 'engem Joer'],
                        };
                        return t ? a[n][0] : a[n][1];
                    }

                    function n(e) {
                        if (a(e.substr(0, e.indexOf(' ')))) {
                            return 'a ' + e;
                        } else {
                            return 'an ' + e;
                        }
                    }

                    function i(e) {
                        if (a(e.substr(0, e.indexOf(' ')))) {
                            return 'viru ' + e;
                        } else {
                            return 'virun ' + e;
                        }
                    }

                    function a(e) {
                        e = parseInt(e, 10);
                        if (isNaN(e)) {
                            return !1;
                        }
                        if (e < 0) {
                            return !0;
                        } else if (e < 10) {
                            if (4 <= e && e <= 7) {
                                return !0;
                            } else {
                                return !1;
                            }
                        } else if (e < 100) {
                            var t = e % 10;
                            if (0 === t) {
                                return a(e / 10);
                            } else {
                                return a(t);
                            }
                        } else if (e < 1e4) {
                            for (; e >= 10; ) {
                                e /= 10;
                            }
                            return a(e);
                        } else {
                            return a((e /= 1e3));
                        }
                    }

                    e.defineLocale('lb', {
                        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
                            '_',
                        ),
                        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
                        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
                        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm [Auer]',
                            LTS: 'H:mm:ss [Auer]',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY H:mm [Auer]',
                            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
                        },
                        calendar: {
                            sameDay: '[Haut um] LT',
                            sameElse: 'L',
                            nextDay: '[Muer um] LT',
                            nextWeek: 'dddd [um] LT',
                            lastDay: '[Gëschter um] LT',
                            lastWeek: function () {
                                switch (this.day()) {
                                    case 2:
                                    case 4:
                                        return '[Leschten] dddd [um] LT';
                                    default:
                                        return '[Leschte] dddd [um] LT';
                                }
                            },
                        },
                        relativeTime: {
                            future: n,
                            past: i,
                            s: 'e puer Sekonnen',
                            ss: '%d Sekonnen',
                            m: t,
                            mm: '%d Minutten',
                            h: t,
                            hh: '%d Stonnen',
                            d: t,
                            dd: '%d Deeg',
                            M: t,
                            MM: '%d Méint',
                            y: t,
                            yy: '%d Joer',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            4826: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('lo', {
                        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
                        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                            '_',
                        ),
                        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
                        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
                        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
                        },
                        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
                        isPM: function (e) {
                            return 'ຕອນແລງ' === e;
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return 'ຕອນເຊົ້າ';
                            } else {
                                return 'ຕອນແລງ';
                            }
                        },
                        calendar: {
                            sameDay: '[ມື້ນີ້ເວລາ] LT',
                            nextDay: '[ມື້ອື່ນເວລາ] LT',
                            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
                            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
                            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'ອີກ %s',
                            past: '%sຜ່ານມາ',
                            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
                            ss: '%d ວິນາທີ',
                            m: '1 ນາທີ',
                            mm: '%d ນາທີ',
                            h: '1 ຊົ່ວໂມງ',
                            hh: '%d ຊົ່ວໂມງ',
                            d: '1 ມື້',
                            dd: '%d ມື້',
                            M: '1 ເດືອນ',
                            MM: '%d ເດືອນ',
                            y: '1 ປີ',
                            yy: '%d ປີ',
                        },
                        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
                        ordinal: function (e) {
                            return 'ທີ່' + e;
                        },
                    });
                })(n(2198));
            },
            9855: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = {
                        ss: 'sekundė_sekundžių_sekundes',
                        m: 'minutė_minutės_minutę',
                        mm: 'minutės_minučių_minutes',
                        h: 'valanda_valandos_valandą',
                        hh: 'valandos_valandų_valandas',
                        d: 'diena_dienos_dieną',
                        dd: 'dienos_dienų_dienas',
                        M: 'mėnuo_mėnesio_mėnesį',
                        MM: 'mėnesiai_mėnesių_mėnesius',
                        y: 'metai_metų_metus',
                        yy: 'metai_metų_metus',
                    };

                    function n(e, t, n, i) {
                        if (t) {
                            return 'kelios sekundės';
                        } else {
                            return i ? 'kelių sekundžių' : 'kelias sekundes';
                        }
                    }

                    function i(e, t, n, i) {
                        return t ? o(n)[0] : i ? o(n)[1] : o(n)[2];
                    }

                    function a(e) {
                        return e % 10 == 0 || (e > 10 && e < 20);
                    }

                    function o(e) {
                        return t[e].split('_');
                    }

                    function r(e, t, n, r) {
                        var s = e + ' ';
                        if (1 === e) {
                            return s + i(e, t, n[0], r);
                        } else if (t) {
                            return s + (a(e) ? o(n)[1] : o(n)[0]);
                        } else if (r) {
                            return s + o(n)[1];
                        } else {
                            return s + (a(e) ? o(n)[1] : o(n)[2]);
                        }
                    }

                    e.defineLocale('lt', {
                        months: {
                            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                                '_',
                            ),
                            standalone:
                                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                                    '_',
                                ),
                            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
                        },
                        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
                        weekdays: {
                            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                                '_',
                            ),
                            standalone:
                                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                                    '_',
                                ),
                            isFormat: /dddd HH:mm/,
                        },
                        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
                        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'YYYY-MM-DD',
                            LL: 'YYYY [m.] MMMM D [d.]',
                            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
                            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
                            l: 'YYYY-MM-DD',
                            ll: 'YYYY [m.] MMMM D [d.]',
                            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
                            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
                        },
                        calendar: {
                            sameDay: '[Šiandien] LT',
                            nextDay: '[Rytoj] LT',
                            nextWeek: 'dddd LT',
                            lastDay: '[Vakar] LT',
                            lastWeek: '[Praėjusį] dddd LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'po %s',
                            past: 'prieš %s',
                            s: n,
                            ss: r,
                            m: i,
                            mm: r,
                            h: i,
                            hh: r,
                            d: i,
                            dd: r,
                            M: i,
                            MM: r,
                            y: i,
                            yy: r,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
                        ordinal: function (e) {
                            return e + '-oji';
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            7758: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = {
                        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
                        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
                        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
                        h: 'stundas_stundām_stunda_stundas'.split('_'),
                        hh: 'stundas_stundām_stunda_stundas'.split('_'),
                        d: 'dienas_dienām_diena_dienas'.split('_'),
                        dd: 'dienas_dienām_diena_dienas'.split('_'),
                        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
                        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
                        y: 'gada_gadiem_gads_gadi'.split('_'),
                        yy: 'gada_gadiem_gads_gadi'.split('_'),
                    };

                    function n(e, t, n) {
                        if (n) {
                            return t % 10 == 1 && t % 100 != 11 ? e[2] : e[3];
                        } else {
                            return t % 10 == 1 && t % 100 != 11 ? e[0] : e[1];
                        }
                    }

                    function i(e, i, a) {
                        return e + ' ' + n(t[a], e, i);
                    }

                    function a(e, i, a) {
                        return n(t[a], e, i);
                    }

                    function o(e, t) {
                        return t ? 'dažas sekundes' : 'dažām sekundēm';
                    }

                    e.defineLocale('lv', {
                        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
                            '_',
                        ),
                        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
                        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
                        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
                        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY.',
                            LL: 'YYYY. [gada] D. MMMM',
                            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
                            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
                        },
                        calendar: {
                            sameDay: '[Šodien pulksten] LT',
                            nextDay: '[Rīt pulksten] LT',
                            nextWeek: 'dddd [pulksten] LT',
                            lastDay: '[Vakar pulksten] LT',
                            lastWeek: '[Pagājušā] dddd [pulksten] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'pēc %s',
                            past: 'pirms %s',
                            s: o,
                            ss: i,
                            m: a,
                            mm: i,
                            h: a,
                            hh: i,
                            d: a,
                            dd: i,
                            M: a,
                            MM: i,
                            y: a,
                            yy: i,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            6001: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = {
                        words: {
                            ss: ['sekund', 'sekunda', 'sekundi'],
                            m: ['jedan minut', 'jednog minuta'],
                            mm: ['minut', 'minuta', 'minuta'],
                            h: ['jedan sat', 'jednog sata'],
                            hh: ['sat', 'sata', 'sati'],
                            dd: ['dan', 'dana', 'dana'],
                            MM: ['mjesec', 'mjeseca', 'mjeseci'],
                            yy: ['godina', 'godine', 'godina'],
                        },
                        correctGrammaticalCase: function (e, t) {
                            return 1 === e ? t[0] : e >= 2 && e <= 4 ? t[1] : t[2];
                        },
                        translate: function (e, n, i) {
                            var a = t.words[i];
                            if (1 === i.length) {
                                return n ? a[0] : a[1];
                            } else {
                                return e + ' ' + t.correctGrammaticalCase(e, a);
                            }
                        },
                    };
                    e.defineLocale('me', {
                        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
                            '_',
                        ),
                        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
                        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
                        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY H:mm',
                            LLLL: 'dddd, D. MMMM YYYY H:mm',
                        },
                        calendar: {
                            sameDay: '[danas u] LT',
                            nextDay: '[sjutra u] LT',
                            nextWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                        return '[u] [nedjelju] [u] LT';
                                    case 3:
                                        return '[u] [srijedu] [u] LT';
                                    case 6:
                                        return '[u] [subotu] [u] LT';
                                    case 1:
                                    case 2:
                                    case 4:
                                    case 5:
                                        return '[u] dddd [u] LT';
                                }
                            },
                            lastDay: '[juče u] LT',
                            lastWeek: function () {
                                return [
                                    '[prošle] [nedjelje] [u] LT',
                                    '[prošlog] [ponedjeljka] [u] LT',
                                    '[prošlog] [utorka] [u] LT',
                                    '[prošle] [srijede] [u] LT',
                                    '[prošlog] [četvrtka] [u] LT',
                                    '[prošlog] [petka] [u] LT',
                                    '[prošle] [subote] [u] LT',
                                ][this.day()];
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'za %s',
                            past: 'prije %s',
                            s: 'nekoliko sekundi',
                            ss: t.translate,
                            m: t.translate,
                            mm: t.translate,
                            h: t.translate,
                            hh: t.translate,
                            d: 'dan',
                            dd: t.translate,
                            M: 'mjesec',
                            MM: t.translate,
                            y: 'godinu',
                            yy: t.translate,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            9733: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('mi', {
                        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
                            '_',
                        ),
                        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
                        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
                        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
                        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
                        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
                        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
                        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
                        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY [i] HH:mm',
                            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
                        },
                        calendar: {
                            sameDay: '[i teie mahana, i] LT',
                            nextDay: '[apopo i] LT',
                            nextWeek: 'dddd [i] LT',
                            lastDay: '[inanahi i] LT',
                            lastWeek: 'dddd [whakamutunga i] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'i roto i %s',
                            past: '%s i mua',
                            s: 'te hēkona ruarua',
                            ss: '%d hēkona',
                            m: 'he meneti',
                            mm: '%d meneti',
                            h: 'te haora',
                            hh: '%d haora',
                            d: 'he ra',
                            dd: '%d ra',
                            M: 'he marama',
                            MM: '%d marama',
                            y: 'he tau',
                            yy: '%d tau',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}º/,
                        ordinal: '%dº',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            4243: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('mk', {
                        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
                            '_',
                        ),
                        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
                        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
                        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
                        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'D.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY H:mm',
                            LLLL: 'dddd, D MMMM YYYY H:mm',
                        },
                        calendar: {
                            sameDay: '[Денес во] LT',
                            nextDay: '[Утре во] LT',
                            nextWeek: '[Во] dddd [во] LT',
                            lastDay: '[Вчера во] LT',
                            lastWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                    case 3:
                                    case 6:
                                        return '[Изминатата] dddd [во] LT';
                                    case 1:
                                    case 2:
                                    case 4:
                                    case 5:
                                        return '[Изминатиот] dddd [во] LT';
                                }
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'за %s',
                            past: 'пред %s',
                            s: 'неколку секунди',
                            ss: '%d секунди',
                            m: 'една минута',
                            mm: '%d минути',
                            h: 'еден час',
                            hh: '%d часа',
                            d: 'еден ден',
                            dd: '%d дена',
                            M: 'еден месец',
                            MM: '%d месеци',
                            y: 'една година',
                            yy: '%d години',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
                        ordinal: function (e) {
                            var t = e % 10,
                                n = e % 100;
                            if (0 === e) {
                                return e + '-ев';
                            } else if (0 === n) {
                                return e + '-ен';
                            } else if (n > 10 && n < 20) {
                                return e + '-ти';
                            } else if (1 === t) {
                                return e + '-ви';
                            } else if (2 === t) {
                                return e + '-ри';
                            } else if (7 === t || 8 === t) {
                                return e + '-ми';
                            } else {
                                return e + '-ти';
                            }
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            4202: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('ml', {
                        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
                            '_',
                        ),
                        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                            '_',
                        ),
                        monthsParseExact: !0,
                        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
                        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
                        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm -നു',
                            LTS: 'A h:mm:ss -നു',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm -നു',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
                        },
                        calendar: {
                            sameDay: '[ഇന്ന്] LT',
                            nextDay: '[നാളെ] LT',
                            nextWeek: 'dddd, LT',
                            lastDay: '[ഇന്നലെ] LT',
                            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s കഴിഞ്ഞ്',
                            past: '%s മുൻപ്',
                            s: 'അൽപ നിമിഷങ്ങൾ',
                            ss: '%d സെക്കൻഡ്',
                            m: 'ഒരു മിനിറ്റ്',
                            mm: '%d മിനിറ്റ്',
                            h: 'ഒരു മണിക്കൂർ',
                            hh: '%d മണിക്കൂർ',
                            d: 'ഒരു ദിവസം',
                            dd: '%d ദിവസം',
                            M: 'ഒരു മാസം',
                            MM: '%d മാസം',
                            y: 'ഒരു വർഷം',
                            yy: '%d വർഷം',
                        },
                        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if (('രാത്രി' === t && e >= 4) || 'ഉച്ച കഴിഞ്ഞ്' === t || 'വൈകുന്നേരം' === t) {
                                return e + 12;
                            } else {
                                return e;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 4) {
                                return 'രാത്രി';
                            } else if (e < 12) {
                                return 'രാവിലെ';
                            } else if (e < 17) {
                                return 'ഉച്ച കഴിഞ്ഞ്';
                            } else if (e < 20) {
                                return 'വൈകുന്നേരം';
                            } else {
                                return 'രാത്രി';
                            }
                        },
                    });
                })(n(2198));
            },
            9584: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t, n, i) {
                        switch (n) {
                            case 's':
                                return t ? 'хэдхэн секунд' : 'хэдхэн секундын';
                            case 'ss':
                                return e + (t ? ' секунд' : ' секундын');
                            case 'm':
                            case 'mm':
                                return e + (t ? ' минут' : ' минутын');
                            case 'h':
                            case 'hh':
                                return e + (t ? ' цаг' : ' цагийн');
                            case 'd':
                            case 'dd':
                                return e + (t ? ' өдөр' : ' өдрийн');
                            case 'M':
                            case 'MM':
                                return e + (t ? ' сар' : ' сарын');
                            case 'y':
                            case 'yy':
                                return e + (t ? ' жил' : ' жилийн');
                            default:
                                return e;
                        }
                    }

                    e.defineLocale('mn', {
                        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
                            '_',
                        ),
                        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                            '_',
                        ),
                        monthsParseExact: !0,
                        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
                        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
                        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'YYYY-MM-DD',
                            LL: 'YYYY оны MMMMын D',
                            LLL: 'YYYY оны MMMMын D HH:mm',
                            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
                        },
                        meridiemParse: /ҮӨ|ҮХ/i,
                        isPM: function (e) {
                            return 'ҮХ' === e;
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return 'ҮӨ';
                            } else {
                                return 'ҮХ';
                            }
                        },
                        calendar: {
                            sameDay: '[Өнөөдөр] LT',
                            nextDay: '[Маргааш] LT',
                            nextWeek: '[Ирэх] dddd LT',
                            lastDay: '[Өчигдөр] LT',
                            lastWeek: '[Өнгөрсөн] dddd LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s дараа',
                            past: '%s өмнө',
                            s: t,
                            ss: t,
                            m: t,
                            mm: t,
                            h: t,
                            hh: t,
                            d: t,
                            dd: t,
                            M: t,
                            MM: t,
                            y: t,
                            yy: t,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
                        ordinal: function (e, t) {
                            switch (t) {
                                case 'd':
                                case 'D':
                                case 'DDD':
                                    return e + ' өдөр';
                                default:
                                    return e;
                            }
                        },
                    });
                })(n(2198));
            },
            5284: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '१', 2: '२', 3: '३', 4: '४', 5: '५', 6: '६', 7: '७', 8: '८', 9: '९', 0: '०' },
                        n = {
                            '१': '1',
                            '२': '2',
                            '३': '3',
                            '४': '4',
                            '५': '5',
                            '६': '6',
                            '७': '7',
                            '८': '8',
                            '९': '9',
                            '०': '0',
                        };

                    function i(e, t, n, i) {
                        var a = '';
                        if (t) {
                            switch (n) {
                                case 's':
                                    a = 'काही सेकंद';
                                    break;
                                case 'ss':
                                    a = '%d सेकंद';
                                    break;
                                case 'm':
                                    a = 'एक मिनिट';
                                    break;
                                case 'mm':
                                    a = '%d मिनिटे';
                                    break;
                                case 'h':
                                    a = 'एक तास';
                                    break;
                                case 'hh':
                                    a = '%d तास';
                                    break;
                                case 'd':
                                    a = 'एक दिवस';
                                    break;
                                case 'dd':
                                    a = '%d दिवस';
                                    break;
                                case 'M':
                                    a = 'एक महिना';
                                    break;
                                case 'MM':
                                    a = '%d महिने';
                                    break;
                                case 'y':
                                    a = 'एक वर्ष';
                                    break;
                                case 'yy':
                                    a = '%d वर्षे';
                            }
                        } else {
                            switch (n) {
                                case 's':
                                    a = 'काही सेकंदां';
                                    break;
                                case 'ss':
                                    a = '%d सेकंदां';
                                    break;
                                case 'm':
                                    a = 'एका मिनिटा';
                                    break;
                                case 'mm':
                                    a = '%d मिनिटां';
                                    break;
                                case 'h':
                                    a = 'एका तासा';
                                    break;
                                case 'hh':
                                    a = '%d तासां';
                                    break;
                                case 'd':
                                    a = 'एका दिवसा';
                                    break;
                                case 'dd':
                                    a = '%d दिवसां';
                                    break;
                                case 'M':
                                    a = 'एका महिन्या';
                                    break;
                                case 'MM':
                                    a = '%d महिन्यां';
                                    break;
                                case 'y':
                                    a = 'एका वर्षा';
                                    break;
                                case 'yy':
                                    a = '%d वर्षां';
                            }
                        }
                        return a.replace(/%d/i, e);
                    }

                    e.defineLocale('mr', {
                        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                            '_',
                        ),
                        monthsShort:
                            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
                        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
                        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm वाजता',
                            LTS: 'A h:mm:ss वाजता',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm वाजता',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
                        },
                        calendar: {
                            sameDay: '[आज] LT',
                            nextDay: '[उद्या] LT',
                            nextWeek: 'dddd, LT',
                            lastDay: '[काल] LT',
                            lastWeek: '[मागील] dddd, LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%sमध्ये',
                            past: '%sपूर्वी',
                            s: i,
                            ss: i,
                            m: i,
                            mm: i,
                            h: i,
                            hh: i,
                            d: i,
                            dd: i,
                            M: i,
                            MM: i,
                            y: i,
                            yy: i,
                        },
                        preparse: function (e) {
                            return e.replace(/[१२३४५६७८९०]/g, function (e) {
                                return n[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('पहाटे' === t || 'सकाळी' === t) {
                                return e;
                            } else if ('दुपारी' === t || 'सायंकाळी' === t || 'रात्री' === t) {
                                return e >= 12 ? e : e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e >= 0 && e < 6) {
                                return 'पहाटे';
                            } else if (e < 12) {
                                return 'सकाळी';
                            } else if (e < 17) {
                                return 'दुपारी';
                            } else if (e < 20) {
                                return 'सायंकाळी';
                            } else {
                                return 'रात्री';
                            }
                        },
                        week: { dow: 0, doy: 6 },
                    });
                })(n(2198));
            },
            5650: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('ms-my', {
                        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
                        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
                        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
                        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
                        longDateFormat: {
                            LT: 'HH.mm',
                            LTS: 'HH.mm.ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY [pukul] HH.mm',
                            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
                        },
                        meridiemParse: /pagi|tengahari|petang|malam/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('pagi' === t) {
                                return e;
                            } else if ('tengahari' === t) {
                                return e >= 11 ? e : e + 12;
                            } else if ('petang' === t || 'malam' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 11) {
                                return 'pagi';
                            } else if (e < 15) {
                                return 'tengahari';
                            } else if (e < 19) {
                                return 'petang';
                            } else {
                                return 'malam';
                            }
                        },
                        calendar: {
                            sameDay: '[Hari ini pukul] LT',
                            nextDay: '[Esok pukul] LT',
                            nextWeek: 'dddd [pukul] LT',
                            lastDay: '[Kelmarin pukul] LT',
                            lastWeek: 'dddd [lepas pukul] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'dalam %s',
                            past: '%s yang lepas',
                            s: 'beberapa saat',
                            ss: '%d saat',
                            m: 'seminit',
                            mm: '%d minit',
                            h: 'sejam',
                            hh: '%d jam',
                            d: 'sehari',
                            dd: '%d hari',
                            M: 'sebulan',
                            MM: '%d bulan',
                            y: 'setahun',
                            yy: '%d tahun',
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            6936: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('ms', {
                        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
                        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
                        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
                        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
                        longDateFormat: {
                            LT: 'HH.mm',
                            LTS: 'HH.mm.ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY [pukul] HH.mm',
                            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
                        },
                        meridiemParse: /pagi|tengahari|petang|malam/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('pagi' === t) {
                                return e;
                            } else if ('tengahari' === t) {
                                return e >= 11 ? e : e + 12;
                            } else if ('petang' === t || 'malam' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 11) {
                                return 'pagi';
                            } else if (e < 15) {
                                return 'tengahari';
                            } else if (e < 19) {
                                return 'petang';
                            } else {
                                return 'malam';
                            }
                        },
                        calendar: {
                            sameDay: '[Hari ini pukul] LT',
                            nextDay: '[Esok pukul] LT',
                            nextWeek: 'dddd [pukul] LT',
                            lastDay: '[Kelmarin pukul] LT',
                            lastWeek: 'dddd [lepas pukul] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'dalam %s',
                            past: '%s yang lepas',
                            s: 'beberapa saat',
                            ss: '%d saat',
                            m: 'seminit',
                            mm: '%d minit',
                            h: 'sejam',
                            hh: '%d jam',
                            d: 'sehari',
                            dd: '%d hari',
                            M: 'sebulan',
                            MM: '%d bulan',
                            y: 'setahun',
                            yy: '%d tahun',
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            1122: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('mt', {
                        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
                        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
                        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
                        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Illum fil-]LT',
                            nextDay: '[Għada fil-]LT',
                            nextWeek: 'dddd [fil-]LT',
                            lastDay: '[Il-bieraħ fil-]LT',
                            lastWeek: 'dddd [li għadda] [fil-]LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'f’ %s',
                            past: '%s ilu',
                            s: 'ftit sekondi',
                            ss: '%d sekondi',
                            m: 'minuta',
                            mm: '%d minuti',
                            h: 'siegħa',
                            hh: '%d siegħat',
                            d: 'ġurnata',
                            dd: '%d ġranet',
                            M: 'xahar',
                            MM: '%d xhur',
                            y: 'sena',
                            yy: '%d sni',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}º/,
                        ordinal: '%dº',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            8629: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '၁', 2: '၂', 3: '၃', 4: '၄', 5: '၅', 6: '၆', 7: '၇', 8: '၈', 9: '၉', 0: '၀' },
                        n = {
                            '၁': '1',
                            '၂': '2',
                            '၃': '3',
                            '၄': '4',
                            '၅': '5',
                            '၆': '6',
                            '၇': '7',
                            '၈': '8',
                            '၉': '9',
                            '၀': '0',
                        };
                    e.defineLocale('my', {
                        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
                            '_',
                        ),
                        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
                        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
                        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
                        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[ယနေ.] LT [မှာ]',
                            nextDay: '[မနက်ဖြန်] LT [မှာ]',
                            nextWeek: 'dddd LT [မှာ]',
                            lastDay: '[မနေ.က] LT [မှာ]',
                            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'လာမည့် %s မှာ',
                            past: 'လွန်ခဲ့သော %s က',
                            s: 'စက္ကန်.အနည်းငယ်',
                            ss: '%d စက္ကန့်',
                            m: 'တစ်မိနစ်',
                            mm: '%d မိနစ်',
                            h: 'တစ်နာရီ',
                            hh: '%d နာရီ',
                            d: 'တစ်ရက်',
                            dd: '%d ရက်',
                            M: 'တစ်လ',
                            MM: '%d လ',
                            y: 'တစ်နှစ်',
                            yy: '%d နှစ်',
                        },
                        preparse: function (e) {
                            return e.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (e) {
                                return n[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            6623: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('nb', {
                        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
                            '_',
                        ),
                        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
                        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
                        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY [kl.] HH:mm',
                            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
                        },
                        calendar: {
                            sameDay: '[i dag kl.] LT',
                            nextDay: '[i morgen kl.] LT',
                            nextWeek: 'dddd [kl.] LT',
                            lastDay: '[i går kl.] LT',
                            lastWeek: '[forrige] dddd [kl.] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'om %s',
                            past: '%s siden',
                            s: 'noen sekunder',
                            ss: '%d sekunder',
                            m: 'ett minutt',
                            mm: '%d minutter',
                            h: 'en time',
                            hh: '%d timer',
                            d: 'en dag',
                            dd: '%d dager',
                            w: 'en uke',
                            ww: '%d uker',
                            M: 'en måned',
                            MM: '%d måneder',
                            y: 'ett år',
                            yy: '%d år',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            2942: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '१', 2: '२', 3: '३', 4: '४', 5: '५', 6: '६', 7: '७', 8: '८', 9: '९', 0: '०' },
                        n = {
                            '१': '1',
                            '२': '2',
                            '३': '3',
                            '४': '4',
                            '५': '5',
                            '६': '6',
                            '७': '7',
                            '८': '8',
                            '९': '9',
                            '०': '0',
                        };
                    e.defineLocale('ne', {
                        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
                            '_',
                        ),
                        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
                        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
                        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'Aको h:mm बजे',
                            LTS: 'Aको h:mm:ss बजे',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, Aको h:mm बजे',
                            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
                        },
                        preparse: function (e) {
                            return e.replace(/[१२३४५६७८९०]/g, function (e) {
                                return n[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('राति' === t) {
                                return e < 4 ? e : e + 12;
                            } else if ('बिहान' === t) {
                                return e;
                            } else if ('दिउँसो' === t) {
                                return e >= 10 ? e : e + 12;
                            } else if ('साँझ' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 3) {
                                return 'राति';
                            } else if (e < 12) {
                                return 'बिहान';
                            } else if (e < 16) {
                                return 'दिउँसो';
                            } else if (e < 20) {
                                return 'साँझ';
                            } else {
                                return 'राति';
                            }
                        },
                        calendar: {
                            sameDay: '[आज] LT',
                            nextDay: '[भोलि] LT',
                            nextWeek: '[आउँदो] dddd[,] LT',
                            lastDay: '[हिजो] LT',
                            lastWeek: '[गएको] dddd[,] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%sमा',
                            past: '%s अगाडि',
                            s: 'केही क्षण',
                            ss: '%d सेकेण्ड',
                            m: 'एक मिनेट',
                            mm: '%d मिनेट',
                            h: 'एक घण्टा',
                            hh: '%d घण्टा',
                            d: 'एक दिन',
                            dd: '%d दिन',
                            M: 'एक महिना',
                            MM: '%d महिना',
                            y: 'एक बर्ष',
                            yy: '%d बर्ष',
                        },
                        week: { dow: 0, doy: 6 },
                    });
                })(n(2198));
            },
            3903: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
                        n = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
                        i = [
                            /^jan/i,
                            /^feb/i,
                            /^maart|mrt.?$/i,
                            /^apr/i,
                            /^mei$/i,
                            /^jun[i.]?$/i,
                            /^jul[i.]?$/i,
                            /^aug/i,
                            /^sep/i,
                            /^okt/i,
                            /^nov/i,
                            /^dec/i,
                        ],
                        a =
                            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
                    e.defineLocale('nl-be', {
                        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
                            '_',
                        ),
                        monthsShort: function (e, i) {
                            if (!e) {
                                return t;
                            } else if (/-MMM-/.test(i)) {
                                return n[e.month()];
                            } else {
                                return t[e.month()];
                            }
                        },
                        monthsRegex: a,
                        monthsShortRegex: a,
                        monthsStrictRegex:
                            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
                        monthsShortStrictRegex:
                            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
                        monthsParse: i,
                        longMonthsParse: i,
                        shortMonthsParse: i,
                        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
                        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
                        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[vandaag om] LT',
                            nextDay: '[morgen om] LT',
                            nextWeek: 'dddd [om] LT',
                            lastDay: '[gisteren om] LT',
                            lastWeek: '[afgelopen] dddd [om] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'over %s',
                            past: '%s geleden',
                            s: 'een paar seconden',
                            ss: '%d seconden',
                            m: 'één minuut',
                            mm: '%d minuten',
                            h: 'één uur',
                            hh: '%d uur',
                            d: 'één dag',
                            dd: '%d dagen',
                            M: 'één maand',
                            MM: '%d maanden',
                            y: 'één jaar',
                            yy: '%d jaar',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
                        ordinal: function (e) {
                            return e + (1 === e || 8 === e || e >= 20 ? 'ste' : 'de');
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            8229: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
                        n = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
                        i = [
                            /^jan/i,
                            /^feb/i,
                            /^maart|mrt.?$/i,
                            /^apr/i,
                            /^mei$/i,
                            /^jun[i.]?$/i,
                            /^jul[i.]?$/i,
                            /^aug/i,
                            /^sep/i,
                            /^okt/i,
                            /^nov/i,
                            /^dec/i,
                        ],
                        a =
                            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
                    e.defineLocale('nl', {
                        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
                            '_',
                        ),
                        monthsShort: function (e, i) {
                            if (!e) {
                                return t;
                            } else if (/-MMM-/.test(i)) {
                                return n[e.month()];
                            } else {
                                return t[e.month()];
                            }
                        },
                        monthsRegex: a,
                        monthsShortRegex: a,
                        monthsStrictRegex:
                            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
                        monthsShortStrictRegex:
                            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
                        monthsParse: i,
                        longMonthsParse: i,
                        shortMonthsParse: i,
                        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
                        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
                        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD-MM-YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[vandaag om] LT',
                            nextDay: '[morgen om] LT',
                            nextWeek: 'dddd [om] LT',
                            lastDay: '[gisteren om] LT',
                            lastWeek: '[afgelopen] dddd [om] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'over %s',
                            past: '%s geleden',
                            s: 'een paar seconden',
                            ss: '%d seconden',
                            m: 'één minuut',
                            mm: '%d minuten',
                            h: 'één uur',
                            hh: '%d uur',
                            d: 'één dag',
                            dd: '%d dagen',
                            w: 'één week',
                            ww: '%d weken',
                            M: 'één maand',
                            MM: '%d maanden',
                            y: 'één jaar',
                            yy: '%d jaar',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
                        ordinal: function (e) {
                            return e + (1 === e || 8 === e || e >= 20 ? 'ste' : 'de');
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            131: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('nn', {
                        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
                            '_',
                        ),
                        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
                        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
                        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY [kl.] H:mm',
                            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
                        },
                        calendar: {
                            sameDay: '[I dag klokka] LT',
                            nextDay: '[I morgon klokka] LT',
                            nextWeek: 'dddd [klokka] LT',
                            lastDay: '[I går klokka] LT',
                            lastWeek: '[Føregåande] dddd [klokka] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'om %s',
                            past: '%s sidan',
                            s: 'nokre sekund',
                            ss: '%d sekund',
                            m: 'eit minutt',
                            mm: '%d minutt',
                            h: 'ein time',
                            hh: '%d timar',
                            d: 'ein dag',
                            dd: '%d dagar',
                            w: 'ei veke',
                            ww: '%d veker',
                            M: 'ein månad',
                            MM: '%d månader',
                            y: 'eit år',
                            yy: '%d år',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            4939: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('oc-lnc', {
                        months: {
                            standalone:
                                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                                    '_',
                                ),
                            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                                '_',
                            ),
                            isFormat: /D[oD]?(\s)+MMMM/,
                        },
                        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split('_'),
                        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
                        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM [de] YYYY',
                            ll: 'D MMM YYYY',
                            LLL: 'D MMMM [de] YYYY [a] H:mm',
                            lll: 'D MMM YYYY, H:mm',
                            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
                            llll: 'ddd D MMM YYYY, H:mm',
                        },
                        calendar: {
                            sameDay: '[uèi a] LT',
                            nextDay: '[deman a] LT',
                            nextWeek: 'dddd [a] LT',
                            lastDay: '[ièr a] LT',
                            lastWeek: 'dddd [passat a] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: "d'aquí %s",
                            past: 'fa %s',
                            s: 'unas segondas',
                            ss: '%d segondas',
                            m: 'una minuta',
                            mm: '%d minutas',
                            h: 'una ora',
                            hh: '%d oras',
                            d: 'un jorn',
                            dd: '%d jorns',
                            M: 'un mes',
                            MM: '%d meses',
                            y: 'un an',
                            yy: '%d ans',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
                        ordinal: function (e, t) {
                            var n = 1 === e ? 'r' : 2 === e ? 'n' : 3 === e ? 'r' : 4 === e ? 't' : 'è';
                            if ('w' === t || 'W' === t) {
                                n = 'a';
                            }
                            return e + n;
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            2510: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '੧', 2: '੨', 3: '੩', 4: '੪', 5: '੫', 6: '੬', 7: '੭', 8: '੮', 9: '੯', 0: '੦' },
                        n = {
                            '੧': '1',
                            '੨': '2',
                            '੩': '3',
                            '੪': '4',
                            '੫': '5',
                            '੬': '6',
                            '੭': '7',
                            '੮': '8',
                            '੯': '9',
                            '੦': '0',
                        };
                    e.defineLocale('pa-in', {
                        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
                        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
                        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
                        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
                        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm ਵਜੇ',
                            LTS: 'A h:mm:ss ਵਜੇ',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
                        },
                        calendar: {
                            sameDay: '[ਅਜ] LT',
                            nextDay: '[ਕਲ] LT',
                            nextWeek: '[ਅਗਲਾ] dddd, LT',
                            lastDay: '[ਕਲ] LT',
                            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s ਵਿੱਚ',
                            past: '%s ਪਿਛਲੇ',
                            s: 'ਕੁਝ ਸਕਿੰਟ',
                            ss: '%d ਸਕਿੰਟ',
                            m: 'ਇਕ ਮਿੰਟ',
                            mm: '%d ਮਿੰਟ',
                            h: 'ਇੱਕ ਘੰਟਾ',
                            hh: '%d ਘੰਟੇ',
                            d: 'ਇੱਕ ਦਿਨ',
                            dd: '%d ਦਿਨ',
                            M: 'ਇੱਕ ਮਹੀਨਾ',
                            MM: '%d ਮਹੀਨੇ',
                            y: 'ਇੱਕ ਸਾਲ',
                            yy: '%d ਸਾਲ',
                        },
                        preparse: function (e) {
                            return e.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (e) {
                                return n[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('ਰਾਤ' === t) {
                                return e < 4 ? e : e + 12;
                            } else if ('ਸਵੇਰ' === t) {
                                return e;
                            } else if ('ਦੁਪਹਿਰ' === t) {
                                return e >= 10 ? e : e + 12;
                            } else if ('ਸ਼ਾਮ' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 4) {
                                return 'ਰਾਤ';
                            } else if (e < 10) {
                                return 'ਸਵੇਰ';
                            } else if (e < 17) {
                                return 'ਦੁਪਹਿਰ';
                            } else if (e < 20) {
                                return 'ਸ਼ਾਮ';
                            } else {
                                return 'ਰਾਤ';
                            }
                        },
                        week: { dow: 0, doy: 6 },
                    });
                })(n(2198));
            },
            8131: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t =
                            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                                '_',
                            ),
                        n =
                            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                                '_',
                            ),
                        i = [
                            /^sty/i,
                            /^lut/i,
                            /^mar/i,
                            /^kwi/i,
                            /^maj/i,
                            /^cze/i,
                            /^lip/i,
                            /^sie/i,
                            /^wrz/i,
                            /^paź/i,
                            /^lis/i,
                            /^gru/i,
                        ];

                    function a(e) {
                        return e % 10 < 5 && e % 10 > 1 && ~~(e / 10) % 10 != 1;
                    }

                    function o(e, t, n) {
                        var i = e + ' ';
                        switch (n) {
                            case 'ss':
                                return i + (a(e) ? 'sekundy' : 'sekund');
                            case 'm':
                                return t ? 'minuta' : 'minutę';
                            case 'mm':
                                return i + (a(e) ? 'minuty' : 'minut');
                            case 'h':
                                return t ? 'godzina' : 'godzinę';
                            case 'hh':
                                return i + (a(e) ? 'godziny' : 'godzin');
                            case 'ww':
                                return i + (a(e) ? 'tygodnie' : 'tygodni');
                            case 'MM':
                                return i + (a(e) ? 'miesiące' : 'miesięcy');
                            case 'yy':
                                return i + (a(e) ? 'lata' : 'lat');
                        }
                    }

                    e.defineLocale('pl', {
                        months: function (e, i) {
                            if (!e) {
                                return t;
                            } else if (/D MMMM/.test(i)) {
                                return n[e.month()];
                            } else {
                                return t[e.month()];
                            }
                        },
                        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
                        monthsParse: i,
                        longMonthsParse: i,
                        shortMonthsParse: i,
                        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
                        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
                        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Dziś o] LT',
                            nextDay: '[Jutro o] LT',
                            nextWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                        return '[W niedzielę o] LT';
                                    case 2:
                                        return '[We wtorek o] LT';
                                    case 3:
                                        return '[W środę o] LT';
                                    case 6:
                                        return '[W sobotę o] LT';
                                    default:
                                        return '[W] dddd [o] LT';
                                }
                            },
                            lastDay: '[Wczoraj o] LT',
                            lastWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                        return '[W zeszłą niedzielę o] LT';
                                    case 3:
                                        return '[W zeszłą środę o] LT';
                                    case 6:
                                        return '[W zeszłą sobotę o] LT';
                                    default:
                                        return '[W zeszły] dddd [o] LT';
                                }
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'za %s',
                            past: '%s temu',
                            s: 'kilka sekund',
                            ss: o,
                            m: o,
                            mm: o,
                            h: o,
                            hh: o,
                            d: '1 dzień',
                            dd: '%d dni',
                            w: 'tydzień',
                            ww: o,
                            M: 'miesiąc',
                            MM: o,
                            y: 'rok',
                            yy: o,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            160: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('pt-br', {
                        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
                            '_',
                        ),
                        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
                        weekdays:
                            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split('_'),
                        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
                        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D [de] MMMM [de] YYYY',
                            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
                            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
                        },
                        calendar: {
                            sameDay: '[Hoje às] LT',
                            nextDay: '[Amanhã às] LT',
                            nextWeek: 'dddd [às] LT',
                            lastDay: '[Ontem às] LT',
                            lastWeek: function () {
                                return 0 === this.day() || 6 === this.day()
                                    ? '[Último] dddd [às] LT'
                                    : '[Última] dddd [às] LT';
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'em %s',
                            past: 'há %s',
                            s: 'poucos segundos',
                            ss: '%d segundos',
                            m: 'um minuto',
                            mm: '%d minutos',
                            h: 'uma hora',
                            hh: '%d horas',
                            d: 'um dia',
                            dd: '%d dias',
                            M: 'um mês',
                            MM: '%d meses',
                            y: 'um ano',
                            yy: '%d anos',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}º/,
                        ordinal: '%dº',
                        invalidDate: 'Data inválida',
                    });
                })(n(2198));
            },
            7899: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('pt', {
                        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
                            '_',
                        ),
                        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
                        weekdays:
                            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
                        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
                        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D [de] MMMM [de] YYYY',
                            LLL: 'D [de] MMMM [de] YYYY HH:mm',
                            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Hoje às] LT',
                            nextDay: '[Amanhã às] LT',
                            nextWeek: 'dddd [às] LT',
                            lastDay: '[Ontem às] LT',
                            lastWeek: function () {
                                return 0 === this.day() || 6 === this.day()
                                    ? '[Último] dddd [às] LT'
                                    : '[Última] dddd [às] LT';
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'em %s',
                            past: 'há %s',
                            s: 'segundos',
                            ss: '%d segundos',
                            m: 'um minuto',
                            mm: '%d minutos',
                            h: 'uma hora',
                            hh: '%d horas',
                            d: 'um dia',
                            dd: '%d dias',
                            w: 'uma semana',
                            ww: '%d semanas',
                            M: 'um mês',
                            MM: '%d meses',
                            y: 'um ano',
                            yy: '%d anos',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}º/,
                        ordinal: '%dº',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            4184: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t, n) {
                        var i = ' ';
                        if (e % 100 >= 20 || (e >= 100 && e % 100 == 0)) {
                            i = ' de ';
                        }
                        return (
                            e +
                            i +
                            {
                                ss: 'secunde',
                                mm: 'minute',
                                hh: 'ore',
                                dd: 'zile',
                                ww: 'săptămâni',
                                MM: 'luni',
                                yy: 'ani',
                            }[n]
                        );
                    }

                    e.defineLocale('ro', {
                        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
                            '_',
                        ),
                        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
                        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
                        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY H:mm',
                            LLLL: 'dddd, D MMMM YYYY H:mm',
                        },
                        calendar: {
                            sameDay: '[azi la] LT',
                            nextDay: '[mâine la] LT',
                            nextWeek: 'dddd [la] LT',
                            lastDay: '[ieri la] LT',
                            lastWeek: '[fosta] dddd [la] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'peste %s',
                            past: '%s în urmă',
                            s: 'câteva secunde',
                            ss: t,
                            m: 'un minut',
                            mm: t,
                            h: 'o oră',
                            hh: t,
                            d: 'o zi',
                            dd: t,
                            w: 'o săptămână',
                            ww: t,
                            M: 'o lună',
                            MM: t,
                            y: 'un an',
                            yy: t,
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            7418: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t) {
                        var n = e.split('_');
                        return t % 10 == 1 && t % 100 != 11
                            ? n[0]
                            : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20)
                            ? n[1]
                            : n[2];
                    }

                    function n(e, n, i) {
                        if ('m' === i) {
                            return n ? 'минута' : 'минуту';
                        } else {
                            return (
                                e +
                                ' ' +
                                t(
                                    {
                                        ss: n ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
                                        mm: n ? 'минута_минуты_минут' : 'минуту_минуты_минут',
                                        hh: 'час_часа_часов',
                                        dd: 'день_дня_дней',
                                        ww: 'неделя_недели_недель',
                                        MM: 'месяц_месяца_месяцев',
                                        yy: 'год_года_лет',
                                    }[i],
                                    +e,
                                )
                            );
                        }
                    }

                    var i = [
                        /^янв/i,
                        /^фев/i,
                        /^мар/i,
                        /^апр/i,
                        /^ма[йя]/i,
                        /^июн/i,
                        /^июл/i,
                        /^авг/i,
                        /^сен/i,
                        /^окт/i,
                        /^ноя/i,
                        /^дек/i,
                    ];
                    e.defineLocale('ru', {
                        months: {
                            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                                '_',
                            ),
                            standalone:
                                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                                    '_',
                                ),
                        },
                        monthsShort: {
                            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
                            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_'),
                        },
                        weekdays: {
                            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
                            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
                            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
                        },
                        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
                        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
                        monthsParse: i,
                        longMonthsParse: i,
                        shortMonthsParse: i,
                        monthsRegex:
                            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
                        monthsShortRegex:
                            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
                        monthsStrictRegex:
                            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
                        monthsShortStrictRegex:
                            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY г.',
                            LLL: 'D MMMM YYYY г., H:mm',
                            LLLL: 'dddd, D MMMM YYYY г., H:mm',
                        },
                        calendar: {
                            sameDay: '[Сегодня, в] LT',
                            nextDay: '[Завтра, в] LT',
                            lastDay: '[Вчера, в] LT',
                            nextWeek: function (e) {
                                if (e.week() !== this.week()) {
                                    switch (this.day()) {
                                        case 0:
                                            return '[В следующее] dddd, [в] LT';
                                        case 1:
                                        case 2:
                                        case 4:
                                            return '[В следующий] dddd, [в] LT';
                                        case 3:
                                        case 5:
                                        case 6:
                                            return '[В следующую] dddd, [в] LT';
                                    }
                                } else if (2 === this.day()) {
                                    return '[Во] dddd, [в] LT';
                                } else {
                                    return '[В] dddd, [в] LT';
                                }
                            },
                            lastWeek: function (e) {
                                if (e.week() !== this.week()) {
                                    switch (this.day()) {
                                        case 0:
                                            return '[В прошлое] dddd, [в] LT';
                                        case 1:
                                        case 2:
                                        case 4:
                                            return '[В прошлый] dddd, [в] LT';
                                        case 3:
                                        case 5:
                                        case 6:
                                            return '[В прошлую] dddd, [в] LT';
                                    }
                                } else if (2 === this.day()) {
                                    return '[Во] dddd, [в] LT';
                                } else {
                                    return '[В] dddd, [в] LT';
                                }
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'через %s',
                            past: '%s назад',
                            s: 'несколько секунд',
                            ss: n,
                            m: n,
                            mm: n,
                            h: 'час',
                            hh: n,
                            d: 'день',
                            dd: n,
                            w: 'неделя',
                            ww: n,
                            M: 'месяц',
                            MM: n,
                            y: 'год',
                            yy: n,
                        },
                        meridiemParse: /ночи|утра|дня|вечера/i,
                        isPM: function (e) {
                            return /^(дня|вечера)$/.test(e);
                        },
                        meridiem: function (e, t, n) {
                            if (e < 4) {
                                return 'ночи';
                            } else if (e < 12) {
                                return 'утра';
                            } else if (e < 17) {
                                return 'дня';
                            } else {
                                return 'вечера';
                            }
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
                        ordinal: function (e, t) {
                            switch (t) {
                                case 'M':
                                case 'd':
                                case 'DDD':
                                    return e + '-й';
                                case 'D':
                                    return e + '-го';
                                case 'w':
                                case 'W':
                                    return e + '-я';
                                default:
                                    return e;
                            }
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            9068: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = [
                            'جنوري',
                            'فيبروري',
                            'مارچ',
                            'اپريل',
                            'مئي',
                            'جون',
                            'جولاءِ',
                            'آگسٽ',
                            'سيپٽمبر',
                            'آڪٽوبر',
                            'نومبر',
                            'ڊسمبر',
                        ],
                        n = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
                    e.defineLocale('sd', {
                        months: t,
                        monthsShort: t,
                        weekdays: n,
                        weekdaysShort: n,
                        weekdaysMin: n,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd، D MMMM YYYY HH:mm',
                        },
                        meridiemParse: /صبح|شام/,
                        isPM: function (e) {
                            return 'شام' === e;
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return 'صبح';
                            } else {
                                return 'شام';
                            }
                        },
                        calendar: {
                            sameDay: '[اڄ] LT',
                            nextDay: '[سڀاڻي] LT',
                            nextWeek: 'dddd [اڳين هفتي تي] LT',
                            lastDay: '[ڪالهه] LT',
                            lastWeek: '[گزريل هفتي] dddd [تي] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s پوء',
                            past: '%s اڳ',
                            s: 'چند سيڪنڊ',
                            ss: '%d سيڪنڊ',
                            m: 'هڪ منٽ',
                            mm: '%d منٽ',
                            h: 'هڪ ڪلاڪ',
                            hh: '%d ڪلاڪ',
                            d: 'هڪ ڏينهن',
                            dd: '%d ڏينهن',
                            M: 'هڪ مهينو',
                            MM: '%d مهينا',
                            y: 'هڪ سال',
                            yy: '%d سال',
                        },
                        preparse: function (e) {
                            return e.replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e.replace(/,/g, '،');
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            8179: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('se', {
                        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
                            '_',
                        ),
                        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
                        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                            '_',
                        ),
                        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
                        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'MMMM D. [b.] YYYY',
                            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
                            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
                        },
                        calendar: {
                            sameDay: '[otne ti] LT',
                            nextDay: '[ihttin ti] LT',
                            nextWeek: 'dddd [ti] LT',
                            lastDay: '[ikte ti] LT',
                            lastWeek: '[ovddit] dddd [ti] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s geažes',
                            past: 'maŋit %s',
                            s: 'moadde sekunddat',
                            ss: '%d sekunddat',
                            m: 'okta minuhta',
                            mm: '%d minuhtat',
                            h: 'okta diimmu',
                            hh: '%d diimmut',
                            d: 'okta beaivi',
                            dd: '%d beaivvit',
                            M: 'okta mánnu',
                            MM: '%d mánut',
                            y: 'okta jahki',
                            yy: '%d jagit',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            7727: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('si', {
                        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
                            '_',
                        ),
                        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
                        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
                        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
                        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'a h:mm',
                            LTS: 'a h:mm:ss',
                            L: 'YYYY/MM/DD',
                            LL: 'YYYY MMMM D',
                            LLL: 'YYYY MMMM D, a h:mm',
                            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
                        },
                        calendar: {
                            sameDay: '[අද] LT[ට]',
                            nextDay: '[හෙට] LT[ට]',
                            nextWeek: 'dddd LT[ට]',
                            lastDay: '[ඊයේ] LT[ට]',
                            lastWeek: '[පසුගිය] dddd LT[ට]',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%sකින්',
                            past: '%sකට පෙර',
                            s: 'තත්පර කිහිපය',
                            ss: 'තත්පර %d',
                            m: 'මිනිත්තුව',
                            mm: 'මිනිත්තු %d',
                            h: 'පැය',
                            hh: 'පැය %d',
                            d: 'දිනය',
                            dd: 'දින %d',
                            M: 'මාසය',
                            MM: 'මාස %d',
                            y: 'වසර',
                            yy: 'වසර %d',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
                        ordinal: function (e) {
                            return e + ' වැනි';
                        },
                        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
                        isPM: function (e) {
                            return 'ප.ව.' === e || 'පස් වරු' === e;
                        },
                        meridiem: function (e, t, n) {
                            if (e > 11) {
                                return n ? 'ප.ව.' : 'පස් වරු';
                            } else {
                                return n ? 'පෙ.ව.' : 'පෙර වරු';
                            }
                        },
                    });
                })(n(2198));
            },
            6657: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                            '_',
                        ),
                        n = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');

                    function i(e) {
                        return e > 1 && e < 5;
                    }

                    function a(e, t, n, a) {
                        var o = e + ' ';
                        switch (n) {
                            case 's':
                                return t || a ? 'pár sekúnd' : 'pár sekundami';
                            case 'ss':
                                if (t || a) {
                                    return o + (i(e) ? 'sekundy' : 'sekúnd');
                                } else {
                                    return o + 'sekundami';
                                }
                            case 'm':
                                return t ? 'minúta' : a ? 'minútu' : 'minútou';
                            case 'mm':
                                if (t || a) {
                                    return o + (i(e) ? 'minúty' : 'minút');
                                } else {
                                    return o + 'minútami';
                                }
                            case 'h':
                                return t ? 'hodina' : a ? 'hodinu' : 'hodinou';
                            case 'hh':
                                if (t || a) {
                                    return o + (i(e) ? 'hodiny' : 'hodín');
                                } else {
                                    return o + 'hodinami';
                                }
                            case 'd':
                                return t || a ? 'deň' : 'dňom';
                            case 'dd':
                                if (t || a) {
                                    return o + (i(e) ? 'dni' : 'dní');
                                } else {
                                    return o + 'dňami';
                                }
                            case 'M':
                                return t || a ? 'mesiac' : 'mesiacom';
                            case 'MM':
                                if (t || a) {
                                    return o + (i(e) ? 'mesiace' : 'mesiacov');
                                } else {
                                    return o + 'mesiacmi';
                                }
                            case 'y':
                                return t || a ? 'rok' : 'rokom';
                            case 'yy':
                                if (t || a) {
                                    return o + (i(e) ? 'roky' : 'rokov');
                                } else {
                                    return o + 'rokmi';
                                }
                        }
                    }

                    e.defineLocale('sk', {
                        months: t,
                        monthsShort: n,
                        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
                        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
                        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY H:mm',
                            LLLL: 'dddd D. MMMM YYYY H:mm',
                        },
                        calendar: {
                            sameDay: '[dnes o] LT',
                            nextDay: '[zajtra o] LT',
                            nextWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                        return '[v nedeľu o] LT';
                                    case 1:
                                    case 2:
                                        return '[v] dddd [o] LT';
                                    case 3:
                                        return '[v stredu o] LT';
                                    case 4:
                                        return '[vo štvrtok o] LT';
                                    case 5:
                                        return '[v piatok o] LT';
                                    case 6:
                                        return '[v sobotu o] LT';
                                }
                            },
                            lastDay: '[včera o] LT',
                            lastWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                        return '[minulú nedeľu o] LT';
                                    case 1:
                                    case 2:
                                    case 4:
                                    case 5:
                                        return '[minulý] dddd [o] LT';
                                    case 3:
                                        return '[minulú stredu o] LT';
                                    case 6:
                                        return '[minulú sobotu o] LT';
                                }
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'za %s',
                            past: 'pred %s',
                            s: a,
                            ss: a,
                            m: a,
                            mm: a,
                            h: a,
                            hh: a,
                            d: a,
                            dd: a,
                            M: a,
                            MM: a,
                            y: a,
                            yy: a,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            9636: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t, n, i) {
                        var a = e + ' ';
                        switch (n) {
                            case 's':
                                return t || i ? 'nekaj sekund' : 'nekaj sekundami';
                            case 'ss':
                                if (1 === e) {
                                    a += t ? 'sekundo' : 'sekundi';
                                } else if (2 === e) {
                                    a += t || i ? 'sekundi' : 'sekundah';
                                } else if (e < 5) {
                                    a += t || i ? 'sekunde' : 'sekundah';
                                } else {
                                    a += 'sekund';
                                }
                                return a;
                            case 'm':
                                return t ? 'ena minuta' : 'eno minuto';
                            case 'mm':
                                if (1 === e) {
                                    a += t ? 'minuta' : 'minuto';
                                } else if (2 === e) {
                                    a += t || i ? 'minuti' : 'minutama';
                                } else if (e < 5) {
                                    a += t || i ? 'minute' : 'minutami';
                                } else {
                                    a += t || i ? 'minut' : 'minutami';
                                }
                                return a;
                            case 'h':
                                return t ? 'ena ura' : 'eno uro';
                            case 'hh':
                                if (1 === e) {
                                    a += t ? 'ura' : 'uro';
                                } else if (2 === e) {
                                    a += t || i ? 'uri' : 'urama';
                                } else if (e < 5) {
                                    a += t || i ? 'ure' : 'urami';
                                } else {
                                    a += t || i ? 'ur' : 'urami';
                                }
                                return a;
                            case 'd':
                                return t || i ? 'en dan' : 'enim dnem';
                            case 'dd':
                                if (1 === e) {
                                    a += t || i ? 'dan' : 'dnem';
                                } else if (2 === e) {
                                    a += t || i ? 'dni' : 'dnevoma';
                                } else {
                                    a += t || i ? 'dni' : 'dnevi';
                                }
                                return a;
                            case 'M':
                                return t || i ? 'en mesec' : 'enim mesecem';
                            case 'MM':
                                if (1 === e) {
                                    a += t || i ? 'mesec' : 'mesecem';
                                } else if (2 === e) {
                                    a += t || i ? 'meseca' : 'mesecema';
                                } else if (e < 5) {
                                    a += t || i ? 'mesece' : 'meseci';
                                } else {
                                    a += t || i ? 'mesecev' : 'meseci';
                                }
                                return a;
                            case 'y':
                                return t || i ? 'eno leto' : 'enim letom';
                            case 'yy':
                                if (1 === e) {
                                    a += t || i ? 'leto' : 'letom';
                                } else if (2 === e) {
                                    a += t || i ? 'leti' : 'letoma';
                                } else if (e < 5) {
                                    a += t || i ? 'leta' : 'leti';
                                } else {
                                    a += t || i ? 'let' : 'leti';
                                }
                                return a;
                        }
                    }

                    e.defineLocale('sl', {
                        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
                            '_',
                        ),
                        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
                        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
                        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD. MM. YYYY',
                            LL: 'D. MMMM YYYY',
                            LLL: 'D. MMMM YYYY H:mm',
                            LLLL: 'dddd, D. MMMM YYYY H:mm',
                        },
                        calendar: {
                            sameDay: '[danes ob] LT',
                            nextDay: '[jutri ob] LT',
                            nextWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                        return '[v] [nedeljo] [ob] LT';
                                    case 3:
                                        return '[v] [sredo] [ob] LT';
                                    case 6:
                                        return '[v] [soboto] [ob] LT';
                                    case 1:
                                    case 2:
                                    case 4:
                                    case 5:
                                        return '[v] dddd [ob] LT';
                                }
                            },
                            lastDay: '[včeraj ob] LT',
                            lastWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                        return '[prejšnjo] [nedeljo] [ob] LT';
                                    case 3:
                                        return '[prejšnjo] [sredo] [ob] LT';
                                    case 6:
                                        return '[prejšnjo] [soboto] [ob] LT';
                                    case 1:
                                    case 2:
                                    case 4:
                                    case 5:
                                        return '[prejšnji] dddd [ob] LT';
                                }
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'čez %s',
                            past: 'pred %s',
                            s: t,
                            ss: t,
                            m: t,
                            mm: t,
                            h: t,
                            hh: t,
                            d: t,
                            dd: t,
                            M: t,
                            MM: t,
                            y: t,
                            yy: t,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            3303: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('sq', {
                        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
                        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
                        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
                        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
                        weekdaysParseExact: !0,
                        meridiemParse: /PD|MD/,
                        isPM: function (e) {
                            return 'M' === e.charAt(0);
                        },
                        meridiem: function (e, t, n) {
                            return e < 12 ? 'PD' : 'MD';
                        },
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Sot në] LT',
                            nextDay: '[Nesër në] LT',
                            nextWeek: 'dddd [në] LT',
                            lastDay: '[Dje në] LT',
                            lastWeek: 'dddd [e kaluar në] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'në %s',
                            past: '%s më parë',
                            s: 'disa sekonda',
                            ss: '%d sekonda',
                            m: 'një minutë',
                            mm: '%d minuta',
                            h: 'një orë',
                            hh: '%d orë',
                            d: 'një ditë',
                            dd: '%d ditë',
                            M: 'një muaj',
                            MM: '%d muaj',
                            y: 'një vit',
                            yy: '%d vite',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            277: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = {
                        words: {
                            ss: ['секунда', 'секунде', 'секунди'],
                            m: ['један минут', 'једног минута'],
                            mm: ['минут', 'минута', 'минута'],
                            h: ['један сат', 'једног сата'],
                            hh: ['сат', 'сата', 'сати'],
                            d: ['један дан', 'једног дана'],
                            dd: ['дан', 'дана', 'дана'],
                            M: ['један месец', 'једног месеца'],
                            MM: ['месец', 'месеца', 'месеци'],
                            y: ['једну годину', 'једне године'],
                            yy: ['годину', 'године', 'година'],
                        },
                        correctGrammaticalCase: function (e, t) {
                            if (e % 10 >= 1 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20)) {
                                return e % 10 == 1 ? t[0] : t[1];
                            } else {
                                return t[2];
                            }
                        },
                        translate: function (e, n, i, a) {
                            var o,
                                r = t.words[i];
                            if (1 === i.length) {
                                if ('y' === i && n) {
                                    return 'једна година';
                                } else {
                                    return a || n ? r[0] : r[1];
                                }
                            }
                            o = t.correctGrammaticalCase(e, r);
                            if ('yy' === i && n && 'годину' === o) {
                                return e + ' година';
                            } else {
                                return e + ' ' + o;
                            }
                        },
                    };
                    e.defineLocale('sr-cyrl', {
                        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
                            '_',
                        ),
                        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
                        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
                        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'D. M. YYYY.',
                            LL: 'D. MMMM YYYY.',
                            LLL: 'D. MMMM YYYY. H:mm',
                            LLLL: 'dddd, D. MMMM YYYY. H:mm',
                        },
                        calendar: {
                            sameDay: '[данас у] LT',
                            nextDay: '[сутра у] LT',
                            nextWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                        return '[у] [недељу] [у] LT';
                                    case 3:
                                        return '[у] [среду] [у] LT';
                                    case 6:
                                        return '[у] [суботу] [у] LT';
                                    case 1:
                                    case 2:
                                    case 4:
                                    case 5:
                                        return '[у] dddd [у] LT';
                                }
                            },
                            lastDay: '[јуче у] LT',
                            lastWeek: function () {
                                return [
                                    '[прошле] [недеље] [у] LT',
                                    '[прошлог] [понедељка] [у] LT',
                                    '[прошлог] [уторка] [у] LT',
                                    '[прошле] [среде] [у] LT',
                                    '[прошлог] [четвртка] [у] LT',
                                    '[прошлог] [петка] [у] LT',
                                    '[прошле] [суботе] [у] LT',
                                ][this.day()];
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'за %s',
                            past: 'пре %s',
                            s: 'неколико секунди',
                            ss: t.translate,
                            m: t.translate,
                            mm: t.translate,
                            h: t.translate,
                            hh: t.translate,
                            d: t.translate,
                            dd: t.translate,
                            M: t.translate,
                            MM: t.translate,
                            y: t.translate,
                            yy: t.translate,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            4378: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = {
                        words: {
                            ss: ['sekunda', 'sekunde', 'sekundi'],
                            m: ['jedan minut', 'jednog minuta'],
                            mm: ['minut', 'minuta', 'minuta'],
                            h: ['jedan sat', 'jednog sata'],
                            hh: ['sat', 'sata', 'sati'],
                            d: ['jedan dan', 'jednog dana'],
                            dd: ['dan', 'dana', 'dana'],
                            M: ['jedan mesec', 'jednog meseca'],
                            MM: ['mesec', 'meseca', 'meseci'],
                            y: ['jednu godinu', 'jedne godine'],
                            yy: ['godinu', 'godine', 'godina'],
                        },
                        correctGrammaticalCase: function (e, t) {
                            if (e % 10 >= 1 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20)) {
                                return e % 10 == 1 ? t[0] : t[1];
                            } else {
                                return t[2];
                            }
                        },
                        translate: function (e, n, i, a) {
                            var o,
                                r = t.words[i];
                            if (1 === i.length) {
                                if ('y' === i && n) {
                                    return 'jedna godina';
                                } else {
                                    return a || n ? r[0] : r[1];
                                }
                            }
                            o = t.correctGrammaticalCase(e, r);
                            if ('yy' === i && n && 'godinu' === o) {
                                return e + ' godina';
                            } else {
                                return e + ' ' + o;
                            }
                        },
                    };
                    e.defineLocale('sr', {
                        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
                            '_',
                        ),
                        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
                        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
                        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'D. M. YYYY.',
                            LL: 'D. MMMM YYYY.',
                            LLL: 'D. MMMM YYYY. H:mm',
                            LLLL: 'dddd, D. MMMM YYYY. H:mm',
                        },
                        calendar: {
                            sameDay: '[danas u] LT',
                            nextDay: '[sutra u] LT',
                            nextWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                        return '[u] [nedelju] [u] LT';
                                    case 3:
                                        return '[u] [sredu] [u] LT';
                                    case 6:
                                        return '[u] [subotu] [u] LT';
                                    case 1:
                                    case 2:
                                    case 4:
                                    case 5:
                                        return '[u] dddd [u] LT';
                                }
                            },
                            lastDay: '[juče u] LT',
                            lastWeek: function () {
                                return [
                                    '[prošle] [nedelje] [u] LT',
                                    '[prošlog] [ponedeljka] [u] LT',
                                    '[prošlog] [utorka] [u] LT',
                                    '[prošle] [srede] [u] LT',
                                    '[prošlog] [četvrtka] [u] LT',
                                    '[prošlog] [petka] [u] LT',
                                    '[prošle] [subote] [u] LT',
                                ][this.day()];
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'za %s',
                            past: 'pre %s',
                            s: 'nekoliko sekundi',
                            ss: t.translate,
                            m: t.translate,
                            mm: t.translate,
                            h: t.translate,
                            hh: t.translate,
                            d: t.translate,
                            dd: t.translate,
                            M: t.translate,
                            MM: t.translate,
                            y: t.translate,
                            yy: t.translate,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            3865: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('ss', {
                        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
                            '_',
                        ),
                        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
                        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
                        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
                        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'h:mm A',
                            LTS: 'h:mm:ss A',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY h:mm A',
                            LLLL: 'dddd, D MMMM YYYY h:mm A',
                        },
                        calendar: {
                            sameDay: '[Namuhla nga] LT',
                            nextDay: '[Kusasa nga] LT',
                            nextWeek: 'dddd [nga] LT',
                            lastDay: '[Itolo nga] LT',
                            lastWeek: 'dddd [leliphelile] [nga] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'nga %s',
                            past: 'wenteka nga %s',
                            s: 'emizuzwana lomcane',
                            ss: '%d mzuzwana',
                            m: 'umzuzu',
                            mm: '%d emizuzu',
                            h: 'lihora',
                            hh: '%d emahora',
                            d: 'lilanga',
                            dd: '%d emalanga',
                            M: 'inyanga',
                            MM: '%d tinyanga',
                            y: 'umnyaka',
                            yy: '%d iminyaka',
                        },
                        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
                        meridiem: function (e, t, n) {
                            if (e < 11) {
                                return 'ekuseni';
                            } else if (e < 15) {
                                return 'emini';
                            } else if (e < 19) {
                                return 'entsambama';
                            } else {
                                return 'ebusuku';
                            }
                        },
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('ekuseni' === t) {
                                return e;
                            } else if ('emini' === t) {
                                return e >= 11 ? e : e + 12;
                            } else if ('entsambama' === t || 'ebusuku' === t) {
                                if (0 === e) {
                                    return 0;
                                } else {
                                    return e + 12;
                                }
                            }
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}/,
                        ordinal: '%d',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            8422: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('sv', {
                        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
                            '_',
                        ),
                        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
                        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
                        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
                        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'YYYY-MM-DD',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY [kl.] HH:mm',
                            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
                            lll: 'D MMM YYYY HH:mm',
                            llll: 'ddd D MMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Idag] LT',
                            nextDay: '[Imorgon] LT',
                            lastDay: '[Igår] LT',
                            nextWeek: '[På] dddd LT',
                            lastWeek: '[I] dddd[s] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'om %s',
                            past: 'för %s sedan',
                            s: 'några sekunder',
                            ss: '%d sekunder',
                            m: 'en minut',
                            mm: '%d minuter',
                            h: 'en timme',
                            hh: '%d timmar',
                            d: 'en dag',
                            dd: '%d dagar',
                            M: 'en månad',
                            MM: '%d månader',
                            y: 'ett år',
                            yy: '%d år',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
                        ordinal: function (e) {
                            var t = e % 10;
                            return (
                                e +
                                (1 == ~~((e % 100) / 10)
                                    ? ':e'
                                    : 1 === t
                                    ? ':a'
                                    : 2 === t
                                    ? ':a'
                                    : 3 === t
                                    ? ':e'
                                    : ':e')
                            );
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            6613: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('sw', {
                        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
                        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
                        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
                        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'hh:mm A',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[leo saa] LT',
                            nextDay: '[kesho saa] LT',
                            nextWeek: '[wiki ijayo] dddd [saat] LT',
                            lastDay: '[jana] LT',
                            lastWeek: '[wiki iliyopita] dddd [saat] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s baadaye',
                            past: 'tokea %s',
                            s: 'hivi punde',
                            ss: 'sekunde %d',
                            m: 'dakika moja',
                            mm: 'dakika %d',
                            h: 'saa limoja',
                            hh: 'masaa %d',
                            d: 'siku moja',
                            dd: 'siku %d',
                            M: 'mwezi mmoja',
                            MM: 'miezi %d',
                            y: 'mwaka mmoja',
                            yy: 'miaka %d',
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            1900: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = { 1: '௧', 2: '௨', 3: '௩', 4: '௪', 5: '௫', 6: '௬', 7: '௭', 8: '௮', 9: '௯', 0: '௦' },
                        n = {
                            '௧': '1',
                            '௨': '2',
                            '௩': '3',
                            '௪': '4',
                            '௫': '5',
                            '௬': '6',
                            '௭': '7',
                            '௮': '8',
                            '௯': '9',
                            '௦': '0',
                        };
                    e.defineLocale('ta', {
                        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                            '_',
                        ),
                        monthsShort:
                            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                                '_',
                            ),
                        weekdays:
                            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                                '_',
                            ),
                        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
                        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, HH:mm',
                            LLLL: 'dddd, D MMMM YYYY, HH:mm',
                        },
                        calendar: {
                            sameDay: '[இன்று] LT',
                            nextDay: '[நாளை] LT',
                            nextWeek: 'dddd, LT',
                            lastDay: '[நேற்று] LT',
                            lastWeek: '[கடந்த வாரம்] dddd, LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s இல்',
                            past: '%s முன்',
                            s: 'ஒரு சில விநாடிகள்',
                            ss: '%d விநாடிகள்',
                            m: 'ஒரு நிமிடம்',
                            mm: '%d நிமிடங்கள்',
                            h: 'ஒரு மணி நேரம்',
                            hh: '%d மணி நேரம்',
                            d: 'ஒரு நாள்',
                            dd: '%d நாட்கள்',
                            M: 'ஒரு மாதம்',
                            MM: '%d மாதங்கள்',
                            y: 'ஒரு வருடம்',
                            yy: '%d ஆண்டுகள்',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}வது/,
                        ordinal: function (e) {
                            return e + 'வது';
                        },
                        preparse: function (e) {
                            return e.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (e) {
                                return n[e];
                            });
                        },
                        postformat: function (e) {
                            return e.replace(/\d/g, function (e) {
                                return t[e];
                            });
                        },
                        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
                        meridiem: function (e, t, n) {
                            if (e < 2) {
                                return ' யாமம்';
                            } else if (e < 6) {
                                return ' வைகறை';
                            } else if (e < 10) {
                                return ' காலை';
                            } else if (e < 14) {
                                return ' நண்பகல்';
                            } else if (e < 18) {
                                return ' எற்பாடு';
                            } else if (e < 22) {
                                return ' மாலை';
                            } else {
                                return ' யாமம்';
                            }
                        },
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('யாமம்' === t) {
                                return e < 2 ? e : e + 12;
                            } else if ('வைகறை' === t || 'காலை' === t) {
                                return e;
                            } else if ('நண்பகல்' === t) {
                                return e >= 10 ? e : e + 12;
                            } else {
                                return e + 12;
                            }
                        },
                        week: { dow: 0, doy: 6 },
                    });
                })(n(2198));
            },
            3072: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('te', {
                        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
                            '_',
                        ),
                        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
                        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
                        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
                        longDateFormat: {
                            LT: 'A h:mm',
                            LTS: 'A h:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY, A h:mm',
                            LLLL: 'dddd, D MMMM YYYY, A h:mm',
                        },
                        calendar: {
                            sameDay: '[నేడు] LT',
                            nextDay: '[రేపు] LT',
                            nextWeek: 'dddd, LT',
                            lastDay: '[నిన్న] LT',
                            lastWeek: '[గత] dddd, LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s లో',
                            past: '%s క్రితం',
                            s: 'కొన్ని క్షణాలు',
                            ss: '%d సెకన్లు',
                            m: 'ఒక నిమిషం',
                            mm: '%d నిమిషాలు',
                            h: 'ఒక గంట',
                            hh: '%d గంటలు',
                            d: 'ఒక రోజు',
                            dd: '%d రోజులు',
                            M: 'ఒక నెల',
                            MM: '%d నెలలు',
                            y: 'ఒక సంవత్సరం',
                            yy: '%d సంవత్సరాలు',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}వ/,
                        ordinal: '%dవ',
                        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('రాత్రి' === t) {
                                return e < 4 ? e : e + 12;
                            } else if ('ఉదయం' === t) {
                                return e;
                            } else if ('మధ్యాహ్నం' === t) {
                                return e >= 10 ? e : e + 12;
                            } else if ('సాయంత్రం' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 4) {
                                return 'రాత్రి';
                            } else if (e < 10) {
                                return 'ఉదయం';
                            } else if (e < 17) {
                                return 'మధ్యాహ్నం';
                            } else if (e < 20) {
                                return 'సాయంత్రం';
                            } else {
                                return 'రాత్రి';
                            }
                        },
                        week: { dow: 0, doy: 6 },
                    });
                })(n(2198));
            },
            8046: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('tet', {
                        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
                        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
                        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
                        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Ohin iha] LT',
                            nextDay: '[Aban iha] LT',
                            nextWeek: 'dddd [iha] LT',
                            lastDay: '[Horiseik iha] LT',
                            lastWeek: 'dddd [semana kotuk] [iha] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'iha %s',
                            past: '%s liuba',
                            s: 'segundu balun',
                            ss: 'segundu %d',
                            m: 'minutu ida',
                            mm: 'minutu %d',
                            h: 'oras ida',
                            hh: 'oras %d',
                            d: 'loron ida',
                            dd: 'loron %d',
                            M: 'fulan ida',
                            MM: 'fulan %d',
                            y: 'tinan ida',
                            yy: 'tinan %d',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                        ordinal: function (e) {
                            var t = e % 10;
                            return (
                                e +
                                (1 == ~~((e % 100) / 10)
                                    ? 'th'
                                    : 1 === t
                                    ? 'st'
                                    : 2 === t
                                    ? 'nd'
                                    : 3 === t
                                    ? 'rd'
                                    : 'th')
                            );
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            9850: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = {
                        0: '-ум',
                        1: '-ум',
                        2: '-юм',
                        3: '-юм',
                        4: '-ум',
                        5: '-ум',
                        6: '-ум',
                        7: '-ум',
                        8: '-ум',
                        9: '-ум',
                        10: '-ум',
                        12: '-ум',
                        13: '-ум',
                        20: '-ум',
                        30: '-юм',
                        40: '-ум',
                        50: '-ум',
                        60: '-ум',
                        70: '-ум',
                        80: '-ум',
                        90: '-ум',
                        100: '-ум',
                    };
                    e.defineLocale('tg', {
                        months: {
                            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                                '_',
                            ),
                            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                                '_',
                            ),
                        },
                        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
                        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
                        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
                        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Имрӯз соати] LT',
                            nextDay: '[Фардо соати] LT',
                            lastDay: '[Дирӯз соати] LT',
                            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
                            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'баъди %s',
                            past: '%s пеш',
                            s: 'якчанд сония',
                            m: 'як дақиқа',
                            mm: '%d дақиқа',
                            h: 'як соат',
                            hh: '%d соат',
                            d: 'як рӯз',
                            dd: '%d рӯз',
                            M: 'як моҳ',
                            MM: '%d моҳ',
                            y: 'як сол',
                            yy: '%d сол',
                        },
                        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('шаб' === t) {
                                return e < 4 ? e : e + 12;
                            } else if ('субҳ' === t) {
                                return e;
                            } else if ('рӯз' === t) {
                                return e >= 11 ? e : e + 12;
                            } else if ('бегоҳ' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            if (e < 4) {
                                return 'шаб';
                            } else if (e < 11) {
                                return 'субҳ';
                            } else if (e < 16) {
                                return 'рӯз';
                            } else if (e < 19) {
                                return 'бегоҳ';
                            } else {
                                return 'шаб';
                            }
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
                        ordinal: function (e) {
                            var n = e % 10,
                                i = e >= 100 ? 100 : null;
                            return e + (t[e] || t[n] || t[i]);
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            7563: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('th', {
                        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
                            '_',
                        ),
                        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
                        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'),
                        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'H:mm',
                            LTS: 'H:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY เวลา H:mm',
                            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
                        },
                        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
                        isPM: function (e) {
                            return 'หลังเที่ยง' === e;
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return 'ก่อนเที่ยง';
                            } else {
                                return 'หลังเที่ยง';
                            }
                        },
                        calendar: {
                            sameDay: '[วันนี้ เวลา] LT',
                            nextDay: '[พรุ่งนี้ เวลา] LT',
                            nextWeek: 'dddd[หน้า เวลา] LT',
                            lastDay: '[เมื่อวานนี้ เวลา] LT',
                            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'อีก %s',
                            past: '%sที่แล้ว',
                            s: 'ไม่กี่วินาที',
                            ss: '%d วินาที',
                            m: '1 นาที',
                            mm: '%d นาที',
                            h: '1 ชั่วโมง',
                            hh: '%d ชั่วโมง',
                            d: '1 วัน',
                            dd: '%d วัน',
                            w: '1 สัปดาห์',
                            ww: '%d สัปดาห์',
                            M: '1 เดือน',
                            MM: '%d เดือน',
                            y: '1 ปี',
                            yy: '%d ปี',
                        },
                    });
                })(n(2198));
            },
            6350: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = {
                        1: "'inji",
                        5: "'inji",
                        8: "'inji",
                        70: "'inji",
                        80: "'inji",
                        2: "'nji",
                        7: "'nji",
                        20: "'nji",
                        50: "'nji",
                        3: "'ünji",
                        4: "'ünji",
                        100: "'ünji",
                        6: "'njy",
                        9: "'unjy",
                        10: "'unjy",
                        30: "'unjy",
                        60: "'ynjy",
                        90: "'ynjy",
                    };
                    e.defineLocale('tk', {
                        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
                            '_',
                        ),
                        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
                        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split('_'),
                        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
                        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[bugün sagat] LT',
                            nextDay: '[ertir sagat] LT',
                            nextWeek: '[indiki] dddd [sagat] LT',
                            lastDay: '[düýn] LT',
                            lastWeek: '[geçen] dddd [sagat] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s soň',
                            past: '%s öň',
                            s: 'birnäçe sekunt',
                            m: 'bir minut',
                            mm: '%d minut',
                            h: 'bir sagat',
                            hh: '%d sagat',
                            d: 'bir gün',
                            dd: '%d gün',
                            M: 'bir aý',
                            MM: '%d aý',
                            y: 'bir ýyl',
                            yy: '%d ýyl',
                        },
                        ordinal: function (e, n) {
                            switch (n) {
                                case 'd':
                                case 'D':
                                case 'Do':
                                case 'DD':
                                    return e;
                                default:
                                    if (0 === e) {
                                        return e + "'unjy";
                                    }
                                    var i = e % 10,
                                        a = (e % 100) - i,
                                        o = e >= 100 ? 100 : null;
                                    return e + (t[i] || t[a] || t[o]);
                            }
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            3972: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('tl-ph', {
                        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
                            '_',
                        ),
                        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
                        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
                        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
                        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'MM/D/YYYY',
                            LL: 'MMMM D, YYYY',
                            LLL: 'MMMM D, YYYY HH:mm',
                            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: 'LT [ngayong araw]',
                            nextDay: '[Bukas ng] LT',
                            nextWeek: 'LT [sa susunod na] dddd',
                            lastDay: 'LT [kahapon]',
                            lastWeek: 'LT [noong nakaraang] dddd',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'sa loob ng %s',
                            past: '%s ang nakalipas',
                            s: 'ilang segundo',
                            ss: '%d segundo',
                            m: 'isang minuto',
                            mm: '%d minuto',
                            h: 'isang oras',
                            hh: '%d oras',
                            d: 'isang araw',
                            dd: '%d araw',
                            M: 'isang buwan',
                            MM: '%d buwan',
                            y: 'isang taon',
                            yy: '%d taon',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}/,
                        ordinal: function (e) {
                            return e;
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            8911: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

                    function n(e) {
                        var t = e;
                        return (t =
                            -1 !== e.indexOf('jaj')
                                ? t.slice(0, -3) + 'leS'
                                : -1 !== e.indexOf('jar')
                                ? t.slice(0, -3) + 'waQ'
                                : -1 !== e.indexOf('DIS')
                                ? t.slice(0, -3) + 'nem'
                                : t + ' pIq');
                    }

                    function i(e) {
                        var t = e;
                        return (t =
                            -1 !== e.indexOf('jaj')
                                ? t.slice(0, -3) + 'Hu’'
                                : -1 !== e.indexOf('jar')
                                ? t.slice(0, -3) + 'wen'
                                : -1 !== e.indexOf('DIS')
                                ? t.slice(0, -3) + 'ben'
                                : t + ' ret');
                    }

                    function a(e, t, n, i) {
                        var a = o(e);
                        switch (n) {
                            case 'ss':
                                return a + ' lup';
                            case 'mm':
                                return a + ' tup';
                            case 'hh':
                                return a + ' rep';
                            case 'dd':
                                return a + ' jaj';
                            case 'MM':
                                return a + ' jar';
                            case 'yy':
                                return a + ' DIS';
                        }
                    }

                    function o(e) {
                        var n = Math.floor((e % 1e3) / 100),
                            i = Math.floor((e % 100) / 10),
                            a = e % 10,
                            o = '';
                        if (n > 0) {
                            o += t[n] + 'vatlh';
                        }
                        if (i > 0) {
                            o += ('' !== o ? ' ' : '') + t[i] + 'maH';
                        }
                        if (a > 0) {
                            o += ('' !== o ? ' ' : '') + t[a];
                        }
                        return '' === o ? 'pagh' : o;
                    }

                    e.defineLocale('tlh', {
                        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
                            '_',
                        ),
                        monthsShort:
                            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                                '_',
                            ),
                        monthsParseExact: !0,
                        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
                        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
                        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[DaHjaj] LT',
                            nextDay: '[wa’leS] LT',
                            nextWeek: 'LLL',
                            lastDay: '[wa’Hu’] LT',
                            lastWeek: 'LLL',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: n,
                            past: i,
                            s: 'puS lup',
                            ss: a,
                            m: 'wa’ tup',
                            mm: a,
                            h: 'wa’ rep',
                            hh: a,
                            d: 'wa’ jaj',
                            dd: a,
                            M: 'wa’ jar',
                            MM: a,
                            y: 'wa’ DIS',
                            yy: a,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            9445: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = {
                        1: "'inci",
                        5: "'inci",
                        8: "'inci",
                        70: "'inci",
                        80: "'inci",
                        2: "'nci",
                        7: "'nci",
                        20: "'nci",
                        50: "'nci",
                        3: "'üncü",
                        4: "'üncü",
                        100: "'üncü",
                        6: "'ncı",
                        9: "'uncu",
                        10: "'uncu",
                        30: "'uncu",
                        60: "'ıncı",
                        90: "'ıncı",
                    };
                    e.defineLocale('tr', {
                        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
                        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
                        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
                        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
                        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return n ? 'öö' : 'ÖÖ';
                            } else {
                                return n ? 'ös' : 'ÖS';
                            }
                        },
                        meridiemParse: /öö|ÖÖ|ös|ÖS/,
                        isPM: function (e) {
                            return 'ös' === e || 'ÖS' === e;
                        },
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[bugün saat] LT',
                            nextDay: '[yarın saat] LT',
                            nextWeek: '[gelecek] dddd [saat] LT',
                            lastDay: '[dün] LT',
                            lastWeek: '[geçen] dddd [saat] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s sonra',
                            past: '%s önce',
                            s: 'birkaç saniye',
                            ss: '%d saniye',
                            m: 'bir dakika',
                            mm: '%d dakika',
                            h: 'bir saat',
                            hh: '%d saat',
                            d: 'bir gün',
                            dd: '%d gün',
                            w: 'bir hafta',
                            ww: '%d hafta',
                            M: 'bir ay',
                            MM: '%d ay',
                            y: 'bir yıl',
                            yy: '%d yıl',
                        },
                        ordinal: function (e, n) {
                            switch (n) {
                                case 'd':
                                case 'D':
                                case 'Do':
                                case 'DD':
                                    return e;
                                default:
                                    if (0 === e) {
                                        return e + "'ıncı";
                                    }
                                    var i = e % 10,
                                        a = (e % 100) - i,
                                        o = e >= 100 ? 100 : null;
                                    return e + (t[i] || t[a] || t[o]);
                            }
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            9013: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t, n, i) {
                        var a = {
                            s: ['viensas secunds', "'iensas secunds"],
                            ss: [e + ' secunds', e + ' secunds'],
                            m: ["'n míut", "'iens míut"],
                            mm: [e + ' míuts', e + ' míuts'],
                            h: ["'n þora", "'iensa þora"],
                            hh: [e + ' þoras', e + ' þoras'],
                            d: ["'n ziua", "'iensa ziua"],
                            dd: [e + ' ziuas', e + ' ziuas'],
                            M: ["'n mes", "'iens mes"],
                            MM: [e + ' mesen', e + ' mesen'],
                            y: ["'n ar", "'iens ar"],
                            yy: [e + ' ars', e + ' ars'],
                        };
                        return i ? a[n][0] : t ? a[n][0] : a[n][1];
                    }

                    e.defineLocale('tzl', {
                        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
                            '_',
                        ),
                        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
                        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
                        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
                        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
                        longDateFormat: {
                            LT: 'HH.mm',
                            LTS: 'HH.mm.ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D. MMMM [dallas] YYYY',
                            LLL: 'D. MMMM [dallas] YYYY HH.mm',
                            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
                        },
                        meridiemParse: /d\'o|d\'a/i,
                        isPM: function (e) {
                            return "d'o" === e.toLowerCase();
                        },
                        meridiem: function (e, t, n) {
                            if (e > 11) {
                                return n ? "d'o" : "D'O";
                            } else {
                                return n ? "d'a" : "D'A";
                            }
                        },
                        calendar: {
                            sameDay: '[oxhi à] LT',
                            nextDay: '[demà à] LT',
                            nextWeek: 'dddd [à] LT',
                            lastDay: '[ieiri à] LT',
                            lastWeek: '[sür el] dddd [lasteu à] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'osprei %s',
                            past: 'ja%s',
                            s: t,
                            ss: t,
                            m: t,
                            mm: t,
                            h: t,
                            hh: t,
                            d: t,
                            dd: t,
                            M: t,
                            MM: t,
                            y: t,
                            yy: t,
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}\./,
                        ordinal: '%d.',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            4302: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('tzm-latn', {
                        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                            '_',
                        ),
                        monthsShort:
                            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                                '_',
                            ),
                        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
                        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
                        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[asdkh g] LT',
                            nextDay: '[aska g] LT',
                            nextWeek: 'dddd [g] LT',
                            lastDay: '[assant g] LT',
                            lastWeek: 'dddd [g] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'dadkh s yan %s',
                            past: 'yan %s',
                            s: 'imik',
                            ss: '%d imik',
                            m: 'minuḍ',
                            mm: '%d minuḍ',
                            h: 'saɛa',
                            hh: '%d tassaɛin',
                            d: 'ass',
                            dd: '%d ossan',
                            M: 'ayowr',
                            MM: '%d iyyirn',
                            y: 'asgas',
                            yy: '%d isgasn',
                        },
                        week: { dow: 6, doy: 12 },
                    });
                })(n(2198));
            },
            54: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('tzm', {
                        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                            '_',
                        ),
                        monthsShort:
                            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                                '_',
                            ),
                        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
                        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
                        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
                            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
                            nextWeek: 'dddd [ⴴ] LT',
                            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
                            lastWeek: 'dddd [ⴴ] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
                            past: 'ⵢⴰⵏ %s',
                            s: 'ⵉⵎⵉⴽ',
                            ss: '%d ⵉⵎⵉⴽ',
                            m: 'ⵎⵉⵏⵓⴺ',
                            mm: '%d ⵎⵉⵏⵓⴺ',
                            h: 'ⵙⴰⵄⴰ',
                            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
                            d: 'ⴰⵙⵙ',
                            dd: '%d oⵙⵙⴰⵏ',
                            M: 'ⴰⵢoⵓⵔ',
                            MM: '%d ⵉⵢⵢⵉⵔⵏ',
                            y: 'ⴰⵙⴳⴰⵙ',
                            yy: '%d ⵉⵙⴳⴰⵙⵏ',
                        },
                        week: { dow: 6, doy: 12 },
                    });
                })(n(2198));
            },
            4225: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('ug-cn', {
                        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                            '_',
                        ),
                        monthsShort:
                            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                                '_',
                            ),
                        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split('_'),
                        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
                        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'YYYY-MM-DD',
                            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
                            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
                            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
                        },
                        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('يېرىم كېچە' === t || 'سەھەر' === t || 'چۈشتىن بۇرۇن' === t) {
                                return e;
                            } else if ('چۈشتىن كېيىن' === t || 'كەچ' === t) {
                                return e + 12;
                            } else {
                                return e >= 11 ? e : e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            var i = 100 * e + t;
                            if (i < 600) {
                                return 'يېرىم كېچە';
                            } else if (i < 900) {
                                return 'سەھەر';
                            } else if (i < 1130) {
                                return 'چۈشتىن بۇرۇن';
                            } else if (i < 1230) {
                                return 'چۈش';
                            } else if (i < 1800) {
                                return 'چۈشتىن كېيىن';
                            } else {
                                return 'كەچ';
                            }
                        },
                        calendar: {
                            sameDay: '[بۈگۈن سائەت] LT',
                            nextDay: '[ئەتە سائەت] LT',
                            nextWeek: '[كېلەركى] dddd [سائەت] LT',
                            lastDay: '[تۆنۈگۈن] LT',
                            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s كېيىن',
                            past: '%s بۇرۇن',
                            s: 'نەچچە سېكونت',
                            ss: '%d سېكونت',
                            m: 'بىر مىنۇت',
                            mm: '%d مىنۇت',
                            h: 'بىر سائەت',
                            hh: '%d سائەت',
                            d: 'بىر كۈن',
                            dd: '%d كۈن',
                            M: 'بىر ئاي',
                            MM: '%d ئاي',
                            y: 'بىر يىل',
                            yy: '%d يىل',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
                        ordinal: function (e, t) {
                            switch (t) {
                                case 'd':
                                case 'D':
                                case 'DDD':
                                    return e + '-كۈنى';
                                case 'w':
                                case 'W':
                                    return e + '-ھەپتە';
                                default:
                                    return e;
                            }
                        },
                        preparse: function (e) {
                            return e.replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e.replace(/,/g, '،');
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            219: function (e, t, n) {
                !(function (e) {
                    'use strict';

                    function t(e, t) {
                        var n = e.split('_');
                        return t % 10 == 1 && t % 100 != 11
                            ? n[0]
                            : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20)
                            ? n[1]
                            : n[2];
                    }

                    function n(e, n, i) {
                        if ('m' === i) {
                            return n ? 'хвилина' : 'хвилину';
                        } else if ('h' === i) {
                            return n ? 'година' : 'годину';
                        } else {
                            return (
                                e +
                                ' ' +
                                t(
                                    {
                                        ss: n ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
                                        mm: n ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
                                        hh: n ? 'година_години_годин' : 'годину_години_годин',
                                        dd: 'день_дні_днів',
                                        MM: 'місяць_місяці_місяців',
                                        yy: 'рік_роки_років',
                                    }[i],
                                    +e,
                                )
                            );
                        }
                    }

                    function i(e, t) {
                        var n = {
                            nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
                            accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
                            genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_'),
                        };
                        if (!0 === e) {
                            return n.nominative.slice(1, 7).concat(n.nominative.slice(0, 1));
                        }
                        if (!e) {
                            return n.nominative;
                        } else {
                            return n[
                                /(\[[ВвУу]\]) ?dddd/.test(t)
                                    ? 'accusative'
                                    : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(t)
                                    ? 'genitive'
                                    : 'nominative'
                            ][e.day()];
                        }
                    }

                    function a(e) {
                        return function () {
                            return e + 'о' + (11 === this.hours() ? 'б' : '') + '] LT';
                        };
                    }

                    e.defineLocale('uk', {
                        months: {
                            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                                '_',
                            ),
                            standalone:
                                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                                    '_',
                                ),
                        },
                        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
                        weekdays: i,
                        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
                        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD.MM.YYYY',
                            LL: 'D MMMM YYYY р.',
                            LLL: 'D MMMM YYYY р., HH:mm',
                            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
                        },
                        calendar: {
                            sameDay: a('[Сьогодні '),
                            nextDay: a('[Завтра '),
                            lastDay: a('[Вчора '),
                            nextWeek: a('[У] dddd ['),
                            lastWeek: function () {
                                switch (this.day()) {
                                    case 0:
                                    case 3:
                                    case 5:
                                    case 6:
                                        return a('[Минулої] dddd [').call(this);
                                    case 1:
                                    case 2:
                                    case 4:
                                        return a('[Минулого] dddd [').call(this);
                                }
                            },
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'за %s',
                            past: '%s тому',
                            s: 'декілька секунд',
                            ss: n,
                            m: n,
                            mm: n,
                            h: 'годину',
                            hh: n,
                            d: 'день',
                            dd: n,
                            M: 'місяць',
                            MM: n,
                            y: 'рік',
                            yy: n,
                        },
                        meridiemParse: /ночі|ранку|дня|вечора/,
                        isPM: function (e) {
                            return /^(дня|вечора)$/.test(e);
                        },
                        meridiem: function (e, t, n) {
                            if (e < 4) {
                                return 'ночі';
                            } else if (e < 12) {
                                return 'ранку';
                            } else if (e < 17) {
                                return 'дня';
                            } else {
                                return 'вечора';
                            }
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
                        ordinal: function (e, t) {
                            switch (t) {
                                case 'M':
                                case 'd':
                                case 'DDD':
                                case 'w':
                                case 'W':
                                    return e + '-й';
                                case 'D':
                                    return e + '-го';
                                default:
                                    return e;
                            }
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            6412: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    var t = [
                            'جنوری',
                            'فروری',
                            'مارچ',
                            'اپریل',
                            'مئی',
                            'جون',
                            'جولائی',
                            'اگست',
                            'ستمبر',
                            'اکتوبر',
                            'نومبر',
                            'دسمبر',
                        ],
                        n = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
                    e.defineLocale('ur', {
                        months: t,
                        monthsShort: t,
                        weekdays: n,
                        weekdaysShort: n,
                        weekdaysMin: n,
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd، D MMMM YYYY HH:mm',
                        },
                        meridiemParse: /صبح|شام/,
                        isPM: function (e) {
                            return 'شام' === e;
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return 'صبح';
                            } else {
                                return 'شام';
                            }
                        },
                        calendar: {
                            sameDay: '[آج بوقت] LT',
                            nextDay: '[کل بوقت] LT',
                            nextWeek: 'dddd [بوقت] LT',
                            lastDay: '[گذشتہ روز بوقت] LT',
                            lastWeek: '[گذشتہ] dddd [بوقت] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s بعد',
                            past: '%s قبل',
                            s: 'چند سیکنڈ',
                            ss: '%d سیکنڈ',
                            m: 'ایک منٹ',
                            mm: '%d منٹ',
                            h: 'ایک گھنٹہ',
                            hh: '%d گھنٹے',
                            d: 'ایک دن',
                            dd: '%d دن',
                            M: 'ایک ماہ',
                            MM: '%d ماہ',
                            y: 'ایک سال',
                            yy: '%d سال',
                        },
                        preparse: function (e) {
                            return e.replace(/،/g, ',');
                        },
                        postformat: function (e) {
                            return e.replace(/,/g, '،');
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            8556: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('uz-latn', {
                        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
                        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
                        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
                        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
                        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'D MMMM YYYY, dddd HH:mm',
                        },
                        calendar: {
                            sameDay: '[Bugun soat] LT [da]',
                            nextDay: '[Ertaga] LT [da]',
                            nextWeek: 'dddd [kuni soat] LT [da]',
                            lastDay: '[Kecha soat] LT [da]',
                            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'Yaqin %s ichida',
                            past: 'Bir necha %s oldin',
                            s: 'soniya',
                            ss: '%d soniya',
                            m: 'bir daqiqa',
                            mm: '%d daqiqa',
                            h: 'bir soat',
                            hh: '%d soat',
                            d: 'bir kun',
                            dd: '%d kun',
                            M: 'bir oy',
                            MM: '%d oy',
                            y: 'bir yil',
                            yy: '%d yil',
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            2804: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('uz', {
                        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
                        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
                        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
                        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
                        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'D MMMM YYYY, dddd HH:mm',
                        },
                        calendar: {
                            sameDay: '[Бугун соат] LT [да]',
                            nextDay: '[Эртага] LT [да]',
                            nextWeek: 'dddd [куни соат] LT [да]',
                            lastDay: '[Кеча соат] LT [да]',
                            lastWeek: '[Утган] dddd [куни соат] LT [да]',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'Якин %s ичида',
                            past: 'Бир неча %s олдин',
                            s: 'фурсат',
                            ss: '%d фурсат',
                            m: 'бир дакика',
                            mm: '%d дакика',
                            h: 'бир соат',
                            hh: '%d соат',
                            d: 'бир кун',
                            dd: '%d кун',
                            M: 'бир ой',
                            MM: '%d ой',
                            y: 'бир йил',
                            yy: '%d йил',
                        },
                        week: { dow: 1, doy: 7 },
                    });
                })(n(2198));
            },
            8290: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('vi', {
                        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
                            '_',
                        ),
                        monthsShort:
                            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                                '_',
                            ),
                        monthsParseExact: !0,
                        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
                        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
                        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
                        weekdaysParseExact: !0,
                        meridiemParse: /sa|ch/i,
                        isPM: function (e) {
                            return /^ch$/i.test(e);
                        },
                        meridiem: function (e, t, n) {
                            if (e < 12) {
                                return n ? 'sa' : 'SA';
                            } else {
                                return n ? 'ch' : 'CH';
                            }
                        },
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM [năm] YYYY',
                            LLL: 'D MMMM [năm] YYYY HH:mm',
                            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
                            l: 'DD/M/YYYY',
                            ll: 'D MMM YYYY',
                            lll: 'D MMM YYYY HH:mm',
                            llll: 'ddd, D MMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[Hôm nay lúc] LT',
                            nextDay: '[Ngày mai lúc] LT',
                            nextWeek: 'dddd [tuần tới lúc] LT',
                            lastDay: '[Hôm qua lúc] LT',
                            lastWeek: 'dddd [tuần trước lúc] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: '%s tới',
                            past: '%s trước',
                            s: 'vài giây',
                            ss: '%d giây',
                            m: 'một phút',
                            mm: '%d phút',
                            h: 'một giờ',
                            hh: '%d giờ',
                            d: 'một ngày',
                            dd: '%d ngày',
                            w: 'một tuần',
                            ww: '%d tuần',
                            M: 'một tháng',
                            MM: '%d tháng',
                            y: 'một năm',
                            yy: '%d năm',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}/,
                        ordinal: function (e) {
                            return e;
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            6658: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('x-pseudo', {
                        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
                            '_',
                        ),
                        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
                        monthsParseExact: !0,
                        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
                        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
                        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
                        weekdaysParseExact: !0,
                        longDateFormat: {
                            LT: 'HH:mm',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY HH:mm',
                            LLLL: 'dddd, D MMMM YYYY HH:mm',
                        },
                        calendar: {
                            sameDay: '[T~ódá~ý át] LT',
                            nextDay: '[T~ómó~rró~w át] LT',
                            nextWeek: 'dddd [át] LT',
                            lastDay: '[Ý~ést~érdá~ý át] LT',
                            lastWeek: '[L~ást] dddd [át] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'í~ñ %s',
                            past: '%s á~gó',
                            s: 'á ~féw ~sécó~ñds',
                            ss: '%d s~écóñ~ds',
                            m: 'á ~míñ~úté',
                            mm: '%d m~íñú~tés',
                            h: 'á~ñ hó~úr',
                            hh: '%d h~óúrs',
                            d: 'á ~dáý',
                            dd: '%d d~áýs',
                            M: 'á ~móñ~th',
                            MM: '%d m~óñt~hs',
                            y: 'á ~ýéár',
                            yy: '%d ý~éárs',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
                        ordinal: function (e) {
                            var t = e % 10;
                            return (
                                e +
                                (1 == ~~((e % 100) / 10)
                                    ? 'th'
                                    : 1 === t
                                    ? 'st'
                                    : 2 === t
                                    ? 'nd'
                                    : 3 === t
                                    ? 'rd'
                                    : 'th')
                            );
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            3067: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('yo', {
                        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
                        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
                        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
                        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
                        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
                        longDateFormat: {
                            LT: 'h:mm A',
                            LTS: 'h:mm:ss A',
                            L: 'DD/MM/YYYY',
                            LL: 'D MMMM YYYY',
                            LLL: 'D MMMM YYYY h:mm A',
                            LLLL: 'dddd, D MMMM YYYY h:mm A',
                        },
                        calendar: {
                            sameDay: '[Ònì ni] LT',
                            nextDay: '[Ọ̀la ni] LT',
                            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
                            lastDay: '[Àna ni] LT',
                            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
                            sameElse: 'L',
                        },
                        relativeTime: {
                            future: 'ní %s',
                            past: '%s kọjá',
                            s: 'ìsẹjú aayá die',
                            ss: 'aayá %d',
                            m: 'ìsẹjú kan',
                            mm: 'ìsẹjú %d',
                            h: 'wákati kan',
                            hh: 'wákati %d',
                            d: 'ọjọ́ kan',
                            dd: 'ọjọ́ %d',
                            M: 'osù kan',
                            MM: 'osù %d',
                            y: 'ọdún kan',
                            yy: 'ọdún %d',
                        },
                        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
                        ordinal: 'ọjọ́ %d',
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            8939: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('zh-cn', {
                        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
                        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
                        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
                        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
                        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'YYYY/MM/DD',
                            LL: 'YYYY年M月D日',
                            LLL: 'YYYY年M月D日Ah点mm分',
                            LLLL: 'YYYY年M月D日ddddAh点mm分',
                            l: 'YYYY/M/D',
                            ll: 'YYYY年M月D日',
                            lll: 'YYYY年M月D日 HH:mm',
                            llll: 'YYYY年M月D日dddd HH:mm',
                        },
                        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('凌晨' === t || '早上' === t || '上午' === t) {
                                return e;
                            } else if ('下午' === t || '晚上' === t) {
                                return e + 12;
                            } else {
                                return e >= 11 ? e : e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            var i = 100 * e + t;
                            if (i < 600) {
                                return '凌晨';
                            } else if (i < 900) {
                                return '早上';
                            } else if (i < 1130) {
                                return '上午';
                            } else if (i < 1230) {
                                return '中午';
                            } else if (i < 1800) {
                                return '下午';
                            } else {
                                return '晚上';
                            }
                        },
                        calendar: {
                            sameDay: '[今天]LT',
                            nextDay: '[明天]LT',
                            nextWeek: function (e) {
                                if (e.week() !== this.week()) {
                                    return '[下]dddLT';
                                } else {
                                    return '[本]dddLT';
                                }
                            },
                            lastDay: '[昨天]LT',
                            lastWeek: function (e) {
                                if (this.week() !== e.week()) {
                                    return '[上]dddLT';
                                } else {
                                    return '[本]dddLT';
                                }
                            },
                            sameElse: 'L',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
                        ordinal: function (e, t) {
                            switch (t) {
                                case 'd':
                                case 'D':
                                case 'DDD':
                                    return e + '日';
                                case 'M':
                                    return e + '月';
                                case 'w':
                                case 'W':
                                    return e + '周';
                                default:
                                    return e;
                            }
                        },
                        relativeTime: {
                            future: '%s后',
                            past: '%s前',
                            s: '几秒',
                            ss: '%d 秒',
                            m: '1 分钟',
                            mm: '%d 分钟',
                            h: '1 小时',
                            hh: '%d 小时',
                            d: '1 天',
                            dd: '%d 天',
                            w: '1 周',
                            ww: '%d 周',
                            M: '1 个月',
                            MM: '%d 个月',
                            y: '1 年',
                            yy: '%d 年',
                        },
                        week: { dow: 1, doy: 4 },
                    });
                })(n(2198));
            },
            9731: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('zh-hk', {
                        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
                        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
                        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
                        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
                        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'YYYY/MM/DD',
                            LL: 'YYYY年M月D日',
                            LLL: 'YYYY年M月D日 HH:mm',
                            LLLL: 'YYYY年M月D日dddd HH:mm',
                            l: 'YYYY/M/D',
                            ll: 'YYYY年M月D日',
                            lll: 'YYYY年M月D日 HH:mm',
                            llll: 'YYYY年M月D日dddd HH:mm',
                        },
                        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('凌晨' === t || '早上' === t || '上午' === t) {
                                return e;
                            } else if ('中午' === t) {
                                return e >= 11 ? e : e + 12;
                            } else if ('下午' === t || '晚上' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            var i = 100 * e + t;
                            if (i < 600) {
                                return '凌晨';
                            } else if (i < 900) {
                                return '早上';
                            } else if (i < 1200) {
                                return '上午';
                            } else if (1200 === i) {
                                return '中午';
                            } else if (i < 1800) {
                                return '下午';
                            } else {
                                return '晚上';
                            }
                        },
                        calendar: {
                            sameDay: '[今天]LT',
                            nextDay: '[明天]LT',
                            nextWeek: '[下]ddddLT',
                            lastDay: '[昨天]LT',
                            lastWeek: '[上]ddddLT',
                            sameElse: 'L',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
                        ordinal: function (e, t) {
                            switch (t) {
                                case 'd':
                                case 'D':
                                case 'DDD':
                                    return e + '日';
                                case 'M':
                                    return e + '月';
                                case 'w':
                                case 'W':
                                    return e + '週';
                                default:
                                    return e;
                            }
                        },
                        relativeTime: {
                            future: '%s後',
                            past: '%s前',
                            s: '幾秒',
                            ss: '%d 秒',
                            m: '1 分鐘',
                            mm: '%d 分鐘',
                            h: '1 小時',
                            hh: '%d 小時',
                            d: '1 天',
                            dd: '%d 天',
                            M: '1 個月',
                            MM: '%d 個月',
                            y: '1 年',
                            yy: '%d 年',
                        },
                    });
                })(n(2198));
            },
            6702: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('zh-mo', {
                        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
                        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
                        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
                        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
                        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'DD/MM/YYYY',
                            LL: 'YYYY年M月D日',
                            LLL: 'YYYY年M月D日 HH:mm',
                            LLLL: 'YYYY年M月D日dddd HH:mm',
                            l: 'D/M/YYYY',
                            ll: 'YYYY年M月D日',
                            lll: 'YYYY年M月D日 HH:mm',
                            llll: 'YYYY年M月D日dddd HH:mm',
                        },
                        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('凌晨' === t || '早上' === t || '上午' === t) {
                                return e;
                            } else if ('中午' === t) {
                                return e >= 11 ? e : e + 12;
                            } else if ('下午' === t || '晚上' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            var i = 100 * e + t;
                            if (i < 600) {
                                return '凌晨';
                            } else if (i < 900) {
                                return '早上';
                            } else if (i < 1130) {
                                return '上午';
                            } else if (i < 1230) {
                                return '中午';
                            } else if (i < 1800) {
                                return '下午';
                            } else {
                                return '晚上';
                            }
                        },
                        calendar: {
                            sameDay: '[今天] LT',
                            nextDay: '[明天] LT',
                            nextWeek: '[下]dddd LT',
                            lastDay: '[昨天] LT',
                            lastWeek: '[上]dddd LT',
                            sameElse: 'L',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
                        ordinal: function (e, t) {
                            switch (t) {
                                case 'd':
                                case 'D':
                                case 'DDD':
                                    return e + '日';
                                case 'M':
                                    return e + '月';
                                case 'w':
                                case 'W':
                                    return e + '週';
                                default:
                                    return e;
                            }
                        },
                        relativeTime: {
                            future: '%s內',
                            past: '%s前',
                            s: '幾秒',
                            ss: '%d 秒',
                            m: '1 分鐘',
                            mm: '%d 分鐘',
                            h: '1 小時',
                            hh: '%d 小時',
                            d: '1 天',
                            dd: '%d 天',
                            M: '1 個月',
                            MM: '%d 個月',
                            y: '1 年',
                            yy: '%d 年',
                        },
                    });
                })(n(2198));
            },
            4203: function (e, t, n) {
                !(function (e) {
                    'use strict';
                    e.defineLocale('zh-tw', {
                        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
                        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
                        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
                        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
                        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
                        longDateFormat: {
                            LT: 'HH:mm',
                            LTS: 'HH:mm:ss',
                            L: 'YYYY/MM/DD',
                            LL: 'YYYY年M月D日',
                            LLL: 'YYYY年M月D日 HH:mm',
                            LLLL: 'YYYY年M月D日dddd HH:mm',
                            l: 'YYYY/M/D',
                            ll: 'YYYY年M月D日',
                            lll: 'YYYY年M月D日 HH:mm',
                            llll: 'YYYY年M月D日dddd HH:mm',
                        },
                        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
                        meridiemHour: function (e, t) {
                            if (12 === e) {
                                e = 0;
                            }
                            if ('凌晨' === t || '早上' === t || '上午' === t) {
                                return e;
                            } else if ('中午' === t) {
                                return e >= 11 ? e : e + 12;
                            } else if ('下午' === t || '晚上' === t) {
                                return e + 12;
                            }
                        },
                        meridiem: function (e, t, n) {
                            var i = 100 * e + t;
                            if (i < 600) {
                                return '凌晨';
                            } else if (i < 900) {
                                return '早上';
                            } else if (i < 1130) {
                                return '上午';
                            } else if (i < 1230) {
                                return '中午';
                            } else if (i < 1800) {
                                return '下午';
                            } else {
                                return '晚上';
                            }
                        },
                        calendar: {
                            sameDay: '[今天] LT',
                            nextDay: '[明天] LT',
                            nextWeek: '[下]dddd LT',
                            lastDay: '[昨天] LT',
                            lastWeek: '[上]dddd LT',
                            sameElse: 'L',
                        },
                        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
                        ordinal: function (e, t) {
                            switch (t) {
                                case 'd':
                                case 'D':
                                case 'DDD':
                                    return e + '日';
                                case 'M':
                                    return e + '月';
                                case 'w':
                                case 'W':
                                    return e + '週';
                                default:
                                    return e;
                            }
                        },
                        relativeTime: {
                            future: '%s後',
                            past: '%s前',
                            s: '幾秒',
                            ss: '%d 秒',
                            m: '1 分鐘',
                            mm: '%d 分鐘',
                            h: '1 小時',
                            hh: '%d 小時',
                            d: '1 天',
                            dd: '%d 天',
                            M: '1 個月',
                            MM: '%d 個月',
                            y: '1 年',
                            yy: '%d 年',
                        },
                    });
                })(n(2198));
            },
            2198: function (e, t, n) {
                (e = n.nmd(e)).exports = (function () {
                    'use strict';
                    var t, i;

                    function a() {
                        return t.apply(null, arguments);
                    }

                    function o(e) {
                        t = e;
                    }

                    function r(e) {
                        return e instanceof Array || '[object Array]' === Object.prototype.toString.call(e);
                    }

                    function s(e) {
                        return null != e && '[object Object]' === Object.prototype.toString.call(e);
                    }

                    function c(e, t) {
                        return Object.prototype.hasOwnProperty.call(e, t);
                    }

                    function l(e) {
                        if (Object.getOwnPropertyNames) {
                            return 0 === Object.getOwnPropertyNames(e).length;
                        } else {
                            var t;
                            for (t in e) {
                                if (c(e, t)) {
                                    return !1;
                                }
                            }
                            return !0;
                        }
                    }

                    function u(e) {
                        return void 0 === e;
                    }

                    function d(e) {
                        return 'number' == typeof e || '[object Number]' === Object.prototype.toString.call(e);
                    }

                    function m(e) {
                        return e instanceof Date || '[object Date]' === Object.prototype.toString.call(e);
                    }

                    function p(e, t) {
                        var n,
                            i = [],
                            a = e.length;
                        for (n = 0; n < a; ++n) {
                            i.push(t(e[n], n));
                        }
                        return i;
                    }

                    function f(e, t) {
                        for (var n in t) {
                            if (c(t, n)) {
                                e[n] = t[n];
                            }
                        }
                        if (c(t, 'toString')) {
                            e.toString = t.toString;
                        }
                        if (c(t, 'valueOf')) {
                            e.valueOf = t.valueOf;
                        }
                        return e;
                    }

                    function g(e, t, n, i) {
                        return Kn(e, t, n, i, !0).utc();
                    }

                    function h() {
                        return {
                            empty: !1,
                            unusedTokens: [],
                            unusedInput: [],
                            overflow: -2,
                            charsLeftOver: 0,
                            nullInput: !1,
                            invalidEra: null,
                            invalidMonth: null,
                            invalidFormat: !1,
                            userInvalidated: !1,
                            iso: !1,
                            parsedDateParts: [],
                            era: null,
                            meridiem: null,
                            rfc2822: !1,
                            weekdayMismatch: !1,
                        };
                    }

                    function y(e) {
                        if (null == e._pf) {
                            e._pf = h();
                        }
                        return e._pf;
                    }

                    if (Array.prototype.some) {
                        i = Array.prototype.some;
                    } else {
                        i = function (e) {
                            var t,
                                n = Object(this),
                                i = n.length >>> 0;
                            for (t = 0; t < i; t++) {
                                if (t in n && e.call(this, n[t], t, n)) {
                                    return !0;
                                }
                            }
                            return !1;
                        };
                    }

                    function x(e) {
                        if (null == e._isValid) {
                            var t = y(e),
                                n = i.call(t.parsedDateParts, function (e) {
                                    return null != e;
                                }),
                                a =
                                    !isNaN(e._d.getTime()) &&
                                    t.overflow < 0 &&
                                    !t.empty &&
                                    !t.invalidEra &&
                                    !t.invalidMonth &&
                                    !t.invalidWeekday &&
                                    !t.weekdayMismatch &&
                                    !t.nullInput &&
                                    !t.invalidFormat &&
                                    !t.userInvalidated &&
                                    (!t.meridiem || (t.meridiem && n));
                            if (e._strict) {
                                a = a && 0 === t.charsLeftOver && 0 === t.unusedTokens.length && void 0 === t.bigHour;
                            }
                            if (null == Object.isFrozen || !Object.isFrozen(e)) {
                                e._isValid = a;
                            } else {
                                return a;
                            }
                        }
                        return e._isValid;
                    }

                    function _(e) {
                        var t = g(NaN);
                        if (null != e) {
                            f(y(t), e);
                        } else {
                            y(t).userInvalidated = !0;
                        }
                        return t;
                    }

                    var E = (a.momentProperties = []),
                        C = !1;

                    function S(e, t) {
                        var n,
                            i,
                            a,
                            o = E.length;
                        if (!u(t._isAMomentObject)) {
                            e._isAMomentObject = t._isAMomentObject;
                        }
                        if (!u(t._i)) {
                            e._i = t._i;
                        }
                        if (!u(t._f)) {
                            e._f = t._f;
                        }
                        if (!u(t._l)) {
                            e._l = t._l;
                        }
                        if (!u(t._strict)) {
                            e._strict = t._strict;
                        }
                        if (!u(t._tzm)) {
                            e._tzm = t._tzm;
                        }
                        if (!u(t._isUTC)) {
                            e._isUTC = t._isUTC;
                        }
                        if (!u(t._offset)) {
                            e._offset = t._offset;
                        }
                        if (!u(t._pf)) {
                            e._pf = y(t);
                        }
                        if (!u(t._locale)) {
                            e._locale = t._locale;
                        }
                        if (o > 0) {
                            for (n = 0; n < o; n++) {
                                if (!u((a = t[(i = E[n])]))) {
                                    e[i] = a;
                                }
                            }
                        }
                        return e;
                    }

                    function b(e) {
                        S(this, e);
                        this._d = new Date(null != e._d ? e._d.getTime() : NaN);
                        if (!this.isValid()) {
                            this._d = new Date(NaN);
                        }
                        if (!1 === C) {
                            C = !0;
                            a.updateOffset(this);
                            C = !1;
                        }
                    }

                    function v(e) {
                        return e instanceof b || (null != e && null != e._isAMomentObject);
                    }

                    function D(e) {
                        if (!1 === a.suppressDeprecationWarnings && 'undefined' != typeof console && console.warn) {
                            console.warn('Deprecation warning: ' + e);
                        }
                    }

                    function R(e, t) {
                        var n = !0;
                        return f(function () {
                            if (null != a.deprecationHandler) {
                                a.deprecationHandler(null, e);
                            }
                            if (n) {
                                var i,
                                    o,
                                    r,
                                    s = [],
                                    l = arguments.length;
                                for (o = 0; o < l; o++) {
                                    i = '';
                                    if ('object' == typeof arguments[o]) {
                                        i += '\n[' + o + '] ';
                                        for (r in arguments[0]) {
                                            if (c(arguments[0], r)) {
                                                i += r + ': ' + arguments[0][r] + ', ';
                                            }
                                        }
                                        i = i.slice(0, -2);
                                    } else {
                                        i = arguments[o];
                                    }
                                    s.push(i);
                                }
                                D(
                                    e +
                                        '\nArguments: ' +
                                        Array.prototype.slice.call(s).join('') +
                                        '\n' +
                                        new Error().stack,
                                );
                                n = !1;
                            }
                            return t.apply(this, arguments);
                        }, t);
                    }

                    var M,
                        T = {};

                    function k(e, t) {
                        if (null != a.deprecationHandler) {
                            a.deprecationHandler(e, t);
                        }
                        if (!T[e]) {
                            D(t);
                            T[e] = !0;
                        }
                    }

                    a.suppressDeprecationWarnings = !1;
                    a.deprecationHandler = null;

                    function I(e) {
                        return (
                            ('undefined' != typeof Function && e instanceof Function) ||
                            '[object Function]' === Object.prototype.toString.call(e)
                        );
                    }

                    function P(e) {
                        var t, n;
                        for (n in e) {
                            if (c(e, n)) {
                                if (I((t = e[n]))) {
                                    this[n] = t;
                                } else {
                                    this['_' + n] = t;
                                }
                            }
                        }
                        this._config = e;
                        this._dayOfMonthOrdinalParseLenient = new RegExp(
                            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source,
                        );
                    }

                    function L(e, t) {
                        var n,
                            i = f({}, e);
                        for (n in t) {
                            if (c(t, n)) {
                                if (s(e[n]) && s(t[n])) {
                                    i[n] = {};
                                    f(i[n], e[n]);
                                    f(i[n], t[n]);
                                } else if (null != t[n]) {
                                    i[n] = t[n];
                                } else {
                                    delete i[n];
                                }
                            }
                        }
                        for (n in e) {
                            if (c(e, n) && !c(t, n) && s(e[n])) {
                                i[n] = f({}, i[n]);
                            }
                        }
                        return i;
                    }

                    function A(e) {
                        if (null != e) {
                            this.set(e);
                        }
                    }

                    if (Object.keys) {
                        M = Object.keys;
                    } else {
                        M = function (e) {
                            var t,
                                n = [];
                            for (t in e) {
                                if (c(e, t)) {
                                    n.push(t);
                                }
                            }
                            return n;
                        };
                    }
                    var w = {
                        sameDay: '[Today at] LT',
                        nextDay: '[Tomorrow at] LT',
                        nextWeek: 'dddd [at] LT',
                        lastDay: '[Yesterday at] LT',
                        lastWeek: '[Last] dddd [at] LT',
                        sameElse: 'L',
                    };

                    function O(e, t, n) {
                        var i = this._calendar[e] || this._calendar.sameElse;
                        return I(i) ? i.call(t, n) : i;
                    }

                    function Y(e, t, n) {
                        var i = '' + Math.abs(e),
                            a = t - i.length;
                        return (e >= 0 ? (n ? '+' : '') : '-') + Math.pow(10, Math.max(0, a)).toString().substr(1) + i;
                    }

                    var B =
                            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
                        N = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
                        q = {},
                        H = {};

                    function j(e, t, n, i) {
                        var a = i;
                        if ('string' == typeof i) {
                            a = function () {
                                return this[i]();
                            };
                        }
                        if (e) {
                            H[e] = a;
                        }
                        if (t) {
                            H[t[0]] = function () {
                                return Y(a.apply(this, arguments), t[1], t[2]);
                            };
                        }
                        if (n) {
                            H[n] = function () {
                                return this.localeData().ordinal(a.apply(this, arguments), e);
                            };
                        }
                    }

                    function F(e) {
                        if (e.match(/\[[\s\S]/)) {
                            return e.replace(/^\[|\]$/g, '');
                        } else {
                            return e.replace(/\\/g, '');
                        }
                    }

                    function U(e) {
                        var t,
                            n,
                            i = e.match(B);
                        for (t = 0, n = i.length; t < n; t++) {
                            if (H[i[t]]) {
                                i[t] = H[i[t]];
                            } else {
                                i[t] = F(i[t]);
                            }
                        }
                        return function (t) {
                            var a,
                                o = '';
                            for (a = 0; a < n; a++) {
                                o += I(i[a]) ? i[a].call(t, e) : i[a];
                            }
                            return o;
                        };
                    }

                    function V(e, t) {
                        if (!e.isValid()) {
                            return e.localeData().invalidDate();
                        }
                        t = Q(t, e.localeData());
                        q[t] = q[t] || U(t);
                        return q[t](e);
                    }

                    function Q(e, t) {
                        var n = 5;

                        function i(e) {
                            return t.longDateFormat(e) || e;
                        }

                        N.lastIndex = 0;
                        for (; n >= 0 && N.test(e); ) {
                            e = e.replace(N, i);
                            N.lastIndex = 0;
                            n -= 1;
                        }
                        return e;
                    }

                    var G = {
                        LTS: 'h:mm:ss A',
                        LT: 'h:mm A',
                        L: 'MM/DD/YYYY',
                        LL: 'MMMM D, YYYY',
                        LLL: 'MMMM D, YYYY h:mm A',
                        LLLL: 'dddd, MMMM D, YYYY h:mm A',
                    };

                    function z(e) {
                        var t = this._longDateFormat[e],
                            n = this._longDateFormat[e.toUpperCase()];
                        if (t || !n) {
                            return t;
                        }
                        this._longDateFormat[e] = n
                            .match(B)
                            .map(function (e) {
                                if ('MMMM' === e || 'MM' === e || 'DD' === e || 'dddd' === e) {
                                    return e.slice(1);
                                } else {
                                    return e;
                                }
                            })
                            .join('');
                        return this._longDateFormat[e];
                    }

                    var W = 'Invalid date';

                    function K() {
                        return this._invalidDate;
                    }

                    var J = '%d',
                        $ = /\d{1,2}/;

                    function X(e) {
                        return this._ordinal.replace('%d', e);
                    }

                    var Z = {
                        future: 'in %s',
                        past: '%s ago',
                        s: 'a few seconds',
                        ss: '%d seconds',
                        m: 'a minute',
                        mm: '%d minutes',
                        h: 'an hour',
                        hh: '%d hours',
                        d: 'a day',
                        dd: '%d days',
                        w: 'a week',
                        ww: '%d weeks',
                        M: 'a month',
                        MM: '%d months',
                        y: 'a year',
                        yy: '%d years',
                    };

                    function ee(e, t, n, i) {
                        var a = this._relativeTime[n];
                        return I(a) ? a(e, t, n, i) : a.replace(/%d/i, e);
                    }

                    function te(e, t) {
                        var n = this._relativeTime[e > 0 ? 'future' : 'past'];
                        return I(n) ? n(t) : n.replace(/%s/i, t);
                    }

                    var ne = {};

                    function ie(e, t) {
                        var n = e.toLowerCase();
                        ne[n] = ne[n + 's'] = ne[t] = e;
                    }

                    function ae(e) {
                        return 'string' == typeof e ? ne[e] || ne[e.toLowerCase()] : void 0;
                    }

                    function oe(e) {
                        var t,
                            n,
                            i = {};
                        for (n in e) {
                            if (c(e, n)) {
                                if ((t = ae(n))) {
                                    i[t] = e[n];
                                }
                            }
                        }
                        return i;
                    }

                    var re = {};

                    function se(e, t) {
                        re[e] = t;
                    }

                    function ce(e) {
                        var t,
                            n = [];
                        for (t in e) {
                            if (c(e, t)) {
                                n.push({ unit: t, priority: re[t] });
                            }
                        }
                        n.sort(function (e, t) {
                            return e.priority - t.priority;
                        });
                        return n;
                    }

                    function le(e) {
                        return (e % 4 == 0 && e % 100 != 0) || e % 400 == 0;
                    }

                    function ue(e) {
                        if (e < 0) {
                            return Math.ceil(e) || 0;
                        } else {
                            return Math.floor(e);
                        }
                    }

                    function de(e) {
                        var t = +e,
                            n = 0;
                        if (0 !== t && isFinite(t)) {
                            n = ue(t);
                        }
                        return n;
                    }

                    function me(e, t) {
                        return function (n) {
                            if (null != n) {
                                fe(this, e, n);
                                a.updateOffset(this, t);
                                return this;
                            } else {
                                return pe(this, e);
                            }
                        };
                    }

                    function pe(e, t) {
                        return e.isValid() ? e._d['get' + (e._isUTC ? 'UTC' : '') + t]() : NaN;
                    }

                    function fe(e, t, n) {
                        if (e.isValid() && !isNaN(n)) {
                            if ('FullYear' === t && le(e.year()) && 1 === e.month() && 29 === e.date()) {
                                n = de(n);
                                e._d['set' + (e._isUTC ? 'UTC' : '') + t](n, e.month(), et(n, e.month()));
                            } else {
                                e._d['set' + (e._isUTC ? 'UTC' : '') + t](n);
                            }
                        }
                    }

                    function ge(e) {
                        if (I(this[(e = ae(e))])) {
                            return this[e]();
                        } else {
                            return this;
                        }
                    }

                    function he(e, t) {
                        if ('object' == typeof e) {
                            var n,
                                i = ce((e = oe(e))),
                                a = i.length;
                            for (n = 0; n < a; n++) {
                                this[i[n].unit](e[i[n].unit]);
                            }
                        } else if (I(this[(e = ae(e))])) {
                            return this[e](t);
                        }
                        return this;
                    }

                    var ye,
                        xe = /\d/,
                        _e = /\d\d/,
                        Ee = /\d{3}/,
                        Ce = /\d{4}/,
                        Se = /[+-]?\d{6}/,
                        be = /\d\d?/,
                        ve = /\d\d\d\d?/,
                        De = /\d\d\d\d\d\d?/,
                        Re = /\d{1,3}/,
                        Me = /\d{1,4}/,
                        Te = /[+-]?\d{1,6}/,
                        ke = /\d+/,
                        Ie = /[+-]?\d+/,
                        Pe = /Z|[+-]\d\d:?\d\d/gi,
                        Le = /Z|[+-]\d\d(?::?\d\d)?/gi,
                        Ae = /[+-]?\d+(\.\d{1,3})?/,
                        we =
                            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
                    ye = {};

                    function Oe(e, t, n) {
                        ye[e] = I(t)
                            ? t
                            : function (e, i) {
                                  return e && n ? n : t;
                              };
                    }

                    function Ye(e, t) {
                        if (!c(ye, e)) {
                            return new RegExp(Be(e));
                        } else {
                            return ye[e](t._strict, t._locale);
                        }
                    }

                    function Be(e) {
                        return Ne(
                            e
                                .replace('\\', '')
                                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (e, t, n, i, a) {
                                    return t || n || i || a;
                                }),
                        );
                    }

                    function Ne(e) {
                        return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                    }

                    var qe = {};

                    function He(e, t) {
                        var n,
                            i,
                            a = t;
                        if ('string' == typeof e) {
                            e = [e];
                        }
                        if (d(t)) {
                            a = function (e, n) {
                                n[t] = de(e);
                            };
                        }
                        i = e.length;
                        for (n = 0; n < i; n++) {
                            qe[e[n]] = a;
                        }
                    }

                    function je(e, t) {
                        He(e, function (e, n, i, a) {
                            i._w = i._w || {};
                            t(e, i._w, i, a);
                        });
                    }

                    function Fe(e, t, n) {
                        if (null != t && c(qe, e)) {
                            qe[e](t, n._a, n, e);
                        }
                    }

                    var Ue,
                        Ve = 0,
                        Qe = 1,
                        Ge = 2,
                        ze = 3,
                        We = 4,
                        Ke = 5,
                        Je = 6,
                        $e = 7,
                        Xe = 8;

                    function Ze(e, t) {
                        return ((e % t) + t) % t;
                    }

                    if (Array.prototype.indexOf) {
                        Ue = Array.prototype.indexOf;
                    } else {
                        Ue = function (e) {
                            var t;
                            for (t = 0; t < this.length; ++t) {
                                if (this[t] === e) {
                                    return t;
                                }
                            }
                            return -1;
                        };
                    }

                    function et(e, t) {
                        if (isNaN(e) || isNaN(t)) {
                            return NaN;
                        }
                        var n = Ze(t, 12);
                        e += (t - n) / 12;
                        return 1 === n ? (le(e) ? 29 : 28) : 31 - ((n % 7) % 2);
                    }

                    j('M', ['MM', 2], 'Mo', function () {
                        return this.month() + 1;
                    });
                    j('MMM', 0, 0, function (e) {
                        return this.localeData().monthsShort(this, e);
                    });
                    j('MMMM', 0, 0, function (e) {
                        return this.localeData().months(this, e);
                    });
                    ie('month', 'M');
                    se('month', 8);
                    Oe('M', be);
                    Oe('MM', be, _e);
                    Oe('MMM', function (e, t) {
                        return t.monthsShortRegex(e);
                    });
                    Oe('MMMM', function (e, t) {
                        return t.monthsRegex(e);
                    });
                    He(['M', 'MM'], function (e, t) {
                        t[Qe] = de(e) - 1;
                    });
                    He(['MMM', 'MMMM'], function (e, t, n, i) {
                        var a = n._locale.monthsParse(e, i, n._strict);
                        if (null != a) {
                            t[Qe] = a;
                        } else {
                            y(n).invalidMonth = e;
                        }
                    });
                    var tt =
                            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                                '_',
                            ),
                        nt = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
                        it = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
                        at = we,
                        ot = we;

                    function rt(e, t) {
                        if (!e) {
                            return r(this._months) ? this._months : this._months.standalone;
                        } else {
                            return r(this._months)
                                ? this._months[e.month()]
                                : this._months[(this._months.isFormat || it).test(t) ? 'format' : 'standalone'][
                                      e.month()
                                  ];
                        }
                    }

                    function st(e, t) {
                        if (!e) {
                            return r(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
                        } else {
                            return r(this._monthsShort)
                                ? this._monthsShort[e.month()]
                                : this._monthsShort[it.test(t) ? 'format' : 'standalone'][e.month()];
                        }
                    }

                    function ct(e, t, n) {
                        var i,
                            a,
                            o,
                            r = e.toLocaleLowerCase();
                        if (!this._monthsParse) {
                            this._monthsParse = [];
                            this._longMonthsParse = [];
                            this._shortMonthsParse = [];
                            for (i = 0; i < 12; ++i) {
                                o = g([2e3, i]);
                                this._shortMonthsParse[i] = this.monthsShort(o, '').toLocaleLowerCase();
                                this._longMonthsParse[i] = this.months(o, '').toLocaleLowerCase();
                            }
                        }
                        if (n) {
                            if ('MMM' === t) {
                                return -1 !== (a = Ue.call(this._shortMonthsParse, r)) ? a : null;
                            } else {
                                return -1 !== (a = Ue.call(this._longMonthsParse, r)) ? a : null;
                            }
                        } else if ('MMM' === t) {
                            if (-1 !== (a = Ue.call(this._shortMonthsParse, r))) {
                                return a;
                            } else {
                                return -1 !== (a = Ue.call(this._longMonthsParse, r)) ? a : null;
                            }
                        } else if (-1 !== (a = Ue.call(this._longMonthsParse, r))) {
                            return a;
                        } else {
                            return -1 !== (a = Ue.call(this._shortMonthsParse, r)) ? a : null;
                        }
                    }

                    function lt(e, t, n) {
                        var i, a, o;
                        if (this._monthsParseExact) {
                            return ct.call(this, e, t, n);
                        }
                        if (!this._monthsParse) {
                            this._monthsParse = [];
                            this._longMonthsParse = [];
                            this._shortMonthsParse = [];
                        }
                        for (i = 0; i < 12; i++) {
                            a = g([2e3, i]);
                            if (n && !this._longMonthsParse[i]) {
                                this._longMonthsParse[i] = new RegExp(
                                    '^' + this.months(a, '').replace('.', '') + '$',
                                    'i',
                                );
                                this._shortMonthsParse[i] = new RegExp(
                                    '^' + this.monthsShort(a, '').replace('.', '') + '$',
                                    'i',
                                );
                            }
                            if (!n && !this._monthsParse[i]) {
                                o = '^' + this.months(a, '') + '|^' + this.monthsShort(a, '');
                                this._monthsParse[i] = new RegExp(o.replace('.', ''), 'i');
                            }
                            if (n && 'MMMM' === t && this._longMonthsParse[i].test(e)) {
                                return i;
                            } else if (n && 'MMM' === t && this._shortMonthsParse[i].test(e)) {
                                return i;
                            } else if (!n && this._monthsParse[i].test(e)) {
                                return i;
                            }
                        }
                    }

                    function ut(e, t) {
                        var n;
                        if (!e.isValid()) {
                            return e;
                        }
                        if ('string' == typeof t) {
                            if (/^\d+$/.test(t)) {
                                t = de(t);
                            } else if (!d((t = e.localeData().monthsParse(t)))) {
                                return e;
                            }
                        }
                        n = Math.min(e.date(), et(e.year(), t));
                        e._d['set' + (e._isUTC ? 'UTC' : '') + 'Month'](t, n);
                        return e;
                    }

                    function dt(e) {
                        if (null != e) {
                            ut(this, e);
                            a.updateOffset(this, !0);
                            return this;
                        } else {
                            return pe(this, 'Month');
                        }
                    }

                    function mt() {
                        return et(this.year(), this.month());
                    }

                    function pt(e) {
                        if (this._monthsParseExact) {
                            if (!c(this, '_monthsRegex')) {
                                gt.call(this);
                            }
                            if (e) {
                                return this._monthsShortStrictRegex;
                            } else {
                                return this._monthsShortRegex;
                            }
                        } else {
                            if (!c(this, '_monthsShortRegex')) {
                                this._monthsShortRegex = at;
                            }
                            return this._monthsShortStrictRegex && e
                                ? this._monthsShortStrictRegex
                                : this._monthsShortRegex;
                        }
                    }

                    function ft(e) {
                        if (this._monthsParseExact) {
                            if (!c(this, '_monthsRegex')) {
                                gt.call(this);
                            }
                            if (e) {
                                return this._monthsStrictRegex;
                            } else {
                                return this._monthsRegex;
                            }
                        } else {
                            if (!c(this, '_monthsRegex')) {
                                this._monthsRegex = ot;
                            }
                            return this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex;
                        }
                    }

                    function gt() {
                        function e(e, t) {
                            return t.length - e.length;
                        }

                        var t,
                            n,
                            i = [],
                            a = [],
                            o = [];
                        for (t = 0; t < 12; t++) {
                            n = g([2e3, t]);
                            i.push(this.monthsShort(n, ''));
                            a.push(this.months(n, ''));
                            o.push(this.months(n, ''));
                            o.push(this.monthsShort(n, ''));
                        }
                        i.sort(e);
                        a.sort(e);
                        o.sort(e);
                        for (t = 0; t < 12; t++) {
                            i[t] = Ne(i[t]);
                            a[t] = Ne(a[t]);
                        }
                        for (t = 0; t < 24; t++) {
                            o[t] = Ne(o[t]);
                        }
                        this._monthsRegex = new RegExp('^(' + o.join('|') + ')', 'i');
                        this._monthsShortRegex = this._monthsRegex;
                        this._monthsStrictRegex = new RegExp('^(' + a.join('|') + ')', 'i');
                        this._monthsShortStrictRegex = new RegExp('^(' + i.join('|') + ')', 'i');
                    }

                    j('Y', 0, 0, function () {
                        var e = this.year();
                        return e <= 9999 ? Y(e, 4) : '+' + e;
                    });
                    j(0, ['YY', 2], 0, function () {
                        return this.year() % 100;
                    });
                    j(0, ['YYYY', 4], 0, 'year');
                    j(0, ['YYYYY', 5], 0, 'year');
                    j(0, ['YYYYYY', 6, !0], 0, 'year');
                    ie('year', 'y');
                    se('year', 1);
                    Oe('Y', Ie);
                    Oe('YY', be, _e);
                    Oe('YYYY', Me, Ce);
                    Oe('YYYYY', Te, Se);
                    Oe('YYYYYY', Te, Se);
                    He(['YYYYY', 'YYYYYY'], Ve);
                    He('YYYY', function (e, t) {
                        t[Ve] = 2 === e.length ? a.parseTwoDigitYear(e) : de(e);
                    });
                    He('YY', function (e, t) {
                        t[Ve] = a.parseTwoDigitYear(e);
                    });
                    He('Y', function (e, t) {
                        t[Ve] = parseInt(e, 10);
                    });

                    function ht(e) {
                        return le(e) ? 366 : 365;
                    }

                    a.parseTwoDigitYear = function (e) {
                        return de(e) + (de(e) > 68 ? 1900 : 2e3);
                    };
                    var yt = me('FullYear', !0);

                    function xt() {
                        return le(this.year());
                    }

                    function _t(e, t, n, i, a, o, r) {
                        var s;
                        if (e < 100 && e >= 0) {
                            s = new Date(e + 400, t, n, i, a, o, r);
                            if (isFinite(s.getFullYear())) {
                                s.setFullYear(e);
                            }
                        } else {
                            s = new Date(e, t, n, i, a, o, r);
                        }
                        return s;
                    }

                    function Et(e) {
                        var t, n;
                        if (e < 100 && e >= 0) {
                            (n = Array.prototype.slice.call(arguments))[0] = e + 400;
                            t = new Date(Date.UTC.apply(null, n));
                            if (isFinite(t.getUTCFullYear())) {
                                t.setUTCFullYear(e);
                            }
                        } else {
                            t = new Date(Date.UTC.apply(null, arguments));
                        }
                        return t;
                    }

                    function Ct(e, t, n) {
                        var i = 7 + t - n;
                        return (-(7 + Et(e, 0, i).getUTCDay() - t) % 7) + i - 1;
                    }

                    function St(e, t, n, i, a) {
                        var o,
                            r,
                            s = 1 + 7 * (t - 1) + ((7 + n - i) % 7) + Ct(e, i, a);
                        if (s <= 0) {
                            r = ht((o = e - 1)) + s;
                        } else if (s > ht(e)) {
                            o = e + 1;
                            r = s - ht(e);
                        } else {
                            o = e;
                            r = s;
                        }
                        return { year: o, dayOfYear: r };
                    }

                    function bt(e, t, n) {
                        var i,
                            a,
                            o = Ct(e.year(), t, n),
                            r = Math.floor((e.dayOfYear() - o - 1) / 7) + 1;
                        if (r < 1) {
                            i = r + vt((a = e.year() - 1), t, n);
                        } else if (r > vt(e.year(), t, n)) {
                            i = r - vt(e.year(), t, n);
                            a = e.year() + 1;
                        } else {
                            a = e.year();
                            i = r;
                        }
                        return { week: i, year: a };
                    }

                    function vt(e, t, n) {
                        var i = Ct(e, t, n),
                            a = Ct(e + 1, t, n);
                        return (ht(e) - i + a) / 7;
                    }

                    j('w', ['ww', 2], 'wo', 'week');
                    j('W', ['WW', 2], 'Wo', 'isoWeek');
                    ie('week', 'w');
                    ie('isoWeek', 'W');
                    se('week', 5);
                    se('isoWeek', 5);
                    Oe('w', be);
                    Oe('ww', be, _e);
                    Oe('W', be);
                    Oe('WW', be, _e);
                    je(['w', 'ww', 'W', 'WW'], function (e, t, n, i) {
                        t[i.substr(0, 1)] = de(e);
                    });

                    function Dt(e) {
                        return bt(e, this._week.dow, this._week.doy).week;
                    }

                    var Rt = { dow: 0, doy: 6 };

                    function Mt() {
                        return this._week.dow;
                    }

                    function Tt() {
                        return this._week.doy;
                    }

                    function kt(e) {
                        var t = this.localeData().week(this);
                        return null == e ? t : this.add(7 * (e - t), 'd');
                    }

                    function It(e) {
                        var t = bt(this, 1, 4).week;
                        return null == e ? t : this.add(7 * (e - t), 'd');
                    }

                    j('d', 0, 'do', 'day');
                    j('dd', 0, 0, function (e) {
                        return this.localeData().weekdaysMin(this, e);
                    });
                    j('ddd', 0, 0, function (e) {
                        return this.localeData().weekdaysShort(this, e);
                    });
                    j('dddd', 0, 0, function (e) {
                        return this.localeData().weekdays(this, e);
                    });
                    j('e', 0, 0, 'weekday');
                    j('E', 0, 0, 'isoWeekday');
                    ie('day', 'd');
                    ie('weekday', 'e');
                    ie('isoWeekday', 'E');
                    se('day', 11);
                    se('weekday', 11);
                    se('isoWeekday', 11);
                    Oe('d', be);
                    Oe('e', be);
                    Oe('E', be);
                    Oe('dd', function (e, t) {
                        return t.weekdaysMinRegex(e);
                    });
                    Oe('ddd', function (e, t) {
                        return t.weekdaysShortRegex(e);
                    });
                    Oe('dddd', function (e, t) {
                        return t.weekdaysRegex(e);
                    });
                    je(['dd', 'ddd', 'dddd'], function (e, t, n, i) {
                        var a = n._locale.weekdaysParse(e, i, n._strict);
                        if (null != a) {
                            t.d = a;
                        } else {
                            y(n).invalidWeekday = e;
                        }
                    });
                    je(['d', 'e', 'E'], function (e, t, n, i) {
                        t[i] = de(e);
                    });

                    function Pt(e, t) {
                        if ('string' != typeof e) {
                            return e;
                        }
                        if (!isNaN(e)) {
                            return parseInt(e, 10);
                        }
                        if ('number' == typeof (e = t.weekdaysParse(e))) {
                            return e;
                        } else {
                            return null;
                        }
                    }

                    function Lt(e, t) {
                        if ('string' == typeof e) {
                            return t.weekdaysParse(e) % 7 || 7;
                        } else {
                            return isNaN(e) ? null : e;
                        }
                    }

                    function At(e, t) {
                        return e.slice(t, 7).concat(e.slice(0, t));
                    }

                    var wt = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
                        Ot = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
                        Yt = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
                        Bt = we,
                        Nt = we,
                        qt = we;

                    function Ht(e, t) {
                        var n = r(this._weekdays)
                            ? this._weekdays
                            : this._weekdays[
                                  e && !0 !== e && this._weekdays.isFormat.test(t) ? 'format' : 'standalone'
                              ];
                        return !0 === e ? At(n, this._week.dow) : e ? n[e.day()] : n;
                    }

                    function jt(e) {
                        return !0 === e
                            ? At(this._weekdaysShort, this._week.dow)
                            : e
                            ? this._weekdaysShort[e.day()]
                            : this._weekdaysShort;
                    }

                    function Ft(e) {
                        return !0 === e
                            ? At(this._weekdaysMin, this._week.dow)
                            : e
                            ? this._weekdaysMin[e.day()]
                            : this._weekdaysMin;
                    }

                    function Ut(e, t, n) {
                        var i,
                            a,
                            o,
                            r = e.toLocaleLowerCase();
                        if (!this._weekdaysParse) {
                            this._weekdaysParse = [];
                            this._shortWeekdaysParse = [];
                            this._minWeekdaysParse = [];
                            for (i = 0; i < 7; ++i) {
                                o = g([2e3, 1]).day(i);
                                this._minWeekdaysParse[i] = this.weekdaysMin(o, '').toLocaleLowerCase();
                                this._shortWeekdaysParse[i] = this.weekdaysShort(o, '').toLocaleLowerCase();
                                this._weekdaysParse[i] = this.weekdays(o, '').toLocaleLowerCase();
                            }
                        }
                        if (n) {
                            if ('dddd' === t) {
                                return -1 !== (a = Ue.call(this._weekdaysParse, r)) ? a : null;
                            } else if ('ddd' === t) {
                                return -1 !== (a = Ue.call(this._shortWeekdaysParse, r)) ? a : null;
                            } else {
                                return -1 !== (a = Ue.call(this._minWeekdaysParse, r)) ? a : null;
                            }
                        } else if ('dddd' === t) {
                            if (-1 !== (a = Ue.call(this._weekdaysParse, r))) {
                                return a;
                            }
                            if (-1 !== (a = Ue.call(this._shortWeekdaysParse, r))) {
                                return a;
                            } else {
                                return -1 !== (a = Ue.call(this._minWeekdaysParse, r)) ? a : null;
                            }
                        } else if ('ddd' === t) {
                            if (-1 !== (a = Ue.call(this._shortWeekdaysParse, r))) {
                                return a;
                            }
                            if (-1 !== (a = Ue.call(this._weekdaysParse, r))) {
                                return a;
                            } else {
                                return -1 !== (a = Ue.call(this._minWeekdaysParse, r)) ? a : null;
                            }
                        } else {
                            if (-1 !== (a = Ue.call(this._minWeekdaysParse, r))) {
                                return a;
                            }
                            if (-1 !== (a = Ue.call(this._weekdaysParse, r))) {
                                return a;
                            } else {
                                return -1 !== (a = Ue.call(this._shortWeekdaysParse, r)) ? a : null;
                            }
                        }
                    }

                    function Vt(e, t, n) {
                        var i, a, o;
                        if (this._weekdaysParseExact) {
                            return Ut.call(this, e, t, n);
                        }
                        if (!this._weekdaysParse) {
                            this._weekdaysParse = [];
                            this._minWeekdaysParse = [];
                            this._shortWeekdaysParse = [];
                            this._fullWeekdaysParse = [];
                        }
                        for (i = 0; i < 7; i++) {
                            a = g([2e3, 1]).day(i);
                            if (n && !this._fullWeekdaysParse[i]) {
                                this._fullWeekdaysParse[i] = new RegExp(
                                    '^' + this.weekdays(a, '').replace('.', '\\.?') + '$',
                                    'i',
                                );
                                this._shortWeekdaysParse[i] = new RegExp(
                                    '^' + this.weekdaysShort(a, '').replace('.', '\\.?') + '$',
                                    'i',
                                );
                                this._minWeekdaysParse[i] = new RegExp(
                                    '^' + this.weekdaysMin(a, '').replace('.', '\\.?') + '$',
                                    'i',
                                );
                            }
                            if (!this._weekdaysParse[i]) {
                                o =
                                    '^' +
                                    this.weekdays(a, '') +
                                    '|^' +
                                    this.weekdaysShort(a, '') +
                                    '|^' +
                                    this.weekdaysMin(a, '');
                                this._weekdaysParse[i] = new RegExp(o.replace('.', ''), 'i');
                            }
                            if (n && 'dddd' === t && this._fullWeekdaysParse[i].test(e)) {
                                return i;
                            } else if (n && 'ddd' === t && this._shortWeekdaysParse[i].test(e)) {
                                return i;
                            } else if (n && 'dd' === t && this._minWeekdaysParse[i].test(e)) {
                                return i;
                            } else if (!n && this._weekdaysParse[i].test(e)) {
                                return i;
                            }
                        }
                    }

                    function Qt(e) {
                        if (!this.isValid()) {
                            return null != e ? this : NaN;
                        }
                        var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
                        if (null != e) {
                            e = Pt(e, this.localeData());
                            return this.add(e - t, 'd');
                        } else {
                            return t;
                        }
                    }

                    function Gt(e) {
                        if (!this.isValid()) {
                            return null != e ? this : NaN;
                        }
                        var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
                        return null == e ? t : this.add(e - t, 'd');
                    }

                    function zt(e) {
                        if (!this.isValid()) {
                            return null != e ? this : NaN;
                        }
                        if (null != e) {
                            var t = Lt(e, this.localeData());
                            return this.day(this.day() % 7 ? t : t - 7);
                        } else {
                            return this.day() || 7;
                        }
                    }

                    function Wt(e) {
                        if (this._weekdaysParseExact) {
                            if (!c(this, '_weekdaysRegex')) {
                                $t.call(this);
                            }
                            if (e) {
                                return this._weekdaysStrictRegex;
                            } else {
                                return this._weekdaysRegex;
                            }
                        } else {
                            if (!c(this, '_weekdaysRegex')) {
                                this._weekdaysRegex = Bt;
                            }
                            return this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex;
                        }
                    }

                    function Kt(e) {
                        if (this._weekdaysParseExact) {
                            if (!c(this, '_weekdaysRegex')) {
                                $t.call(this);
                            }
                            if (e) {
                                return this._weekdaysShortStrictRegex;
                            } else {
                                return this._weekdaysShortRegex;
                            }
                        } else {
                            if (!c(this, '_weekdaysShortRegex')) {
                                this._weekdaysShortRegex = Nt;
                            }
                            return this._weekdaysShortStrictRegex && e
                                ? this._weekdaysShortStrictRegex
                                : this._weekdaysShortRegex;
                        }
                    }

                    function Jt(e) {
                        if (this._weekdaysParseExact) {
                            if (!c(this, '_weekdaysRegex')) {
                                $t.call(this);
                            }
                            if (e) {
                                return this._weekdaysMinStrictRegex;
                            } else {
                                return this._weekdaysMinRegex;
                            }
                        } else {
                            if (!c(this, '_weekdaysMinRegex')) {
                                this._weekdaysMinRegex = qt;
                            }
                            return this._weekdaysMinStrictRegex && e
                                ? this._weekdaysMinStrictRegex
                                : this._weekdaysMinRegex;
                        }
                    }

                    function $t() {
                        function e(e, t) {
                            return t.length - e.length;
                        }

                        var t,
                            n,
                            i,
                            a,
                            o,
                            r = [],
                            s = [],
                            c = [],
                            l = [];
                        for (t = 0; t < 7; t++) {
                            n = g([2e3, 1]).day(t);
                            i = Ne(this.weekdaysMin(n, ''));
                            a = Ne(this.weekdaysShort(n, ''));
                            o = Ne(this.weekdays(n, ''));
                            r.push(i);
                            s.push(a);
                            c.push(o);
                            l.push(i);
                            l.push(a);
                            l.push(o);
                        }
                        r.sort(e);
                        s.sort(e);
                        c.sort(e);
                        l.sort(e);
                        this._weekdaysRegex = new RegExp('^(' + l.join('|') + ')', 'i');
                        this._weekdaysShortRegex = this._weekdaysRegex;
                        this._weekdaysMinRegex = this._weekdaysRegex;
                        this._weekdaysStrictRegex = new RegExp('^(' + c.join('|') + ')', 'i');
                        this._weekdaysShortStrictRegex = new RegExp('^(' + s.join('|') + ')', 'i');
                        this._weekdaysMinStrictRegex = new RegExp('^(' + r.join('|') + ')', 'i');
                    }

                    function Xt() {
                        return this.hours() % 12 || 12;
                    }

                    function Zt() {
                        return this.hours() || 24;
                    }

                    j('H', ['HH', 2], 0, 'hour');
                    j('h', ['hh', 2], 0, Xt);
                    j('k', ['kk', 2], 0, Zt);
                    j('hmm', 0, 0, function () {
                        return '' + Xt.apply(this) + Y(this.minutes(), 2);
                    });
                    j('hmmss', 0, 0, function () {
                        return '' + Xt.apply(this) + Y(this.minutes(), 2) + Y(this.seconds(), 2);
                    });
                    j('Hmm', 0, 0, function () {
                        return '' + this.hours() + Y(this.minutes(), 2);
                    });
                    j('Hmmss', 0, 0, function () {
                        return '' + this.hours() + Y(this.minutes(), 2) + Y(this.seconds(), 2);
                    });

                    function en(e, t) {
                        j(e, 0, 0, function () {
                            return this.localeData().meridiem(this.hours(), this.minutes(), t);
                        });
                    }

                    en('a', !0);
                    en('A', !1);
                    ie('hour', 'h');
                    se('hour', 13);

                    function tn(e, t) {
                        return t._meridiemParse;
                    }

                    Oe('a', tn);
                    Oe('A', tn);
                    Oe('H', be);
                    Oe('h', be);
                    Oe('k', be);
                    Oe('HH', be, _e);
                    Oe('hh', be, _e);
                    Oe('kk', be, _e);
                    Oe('hmm', ve);
                    Oe('hmmss', De);
                    Oe('Hmm', ve);
                    Oe('Hmmss', De);
                    He(['H', 'HH'], ze);
                    He(['k', 'kk'], function (e, t, n) {
                        var i = de(e);
                        t[ze] = 24 === i ? 0 : i;
                    });
                    He(['a', 'A'], function (e, t, n) {
                        n._isPm = n._locale.isPM(e);
                        n._meridiem = e;
                    });
                    He(['h', 'hh'], function (e, t, n) {
                        t[ze] = de(e);
                        y(n).bigHour = !0;
                    });
                    He('hmm', function (e, t, n) {
                        var i = e.length - 2;
                        t[ze] = de(e.substr(0, i));
                        t[We] = de(e.substr(i));
                        y(n).bigHour = !0;
                    });
                    He('hmmss', function (e, t, n) {
                        var i = e.length - 4,
                            a = e.length - 2;
                        t[ze] = de(e.substr(0, i));
                        t[We] = de(e.substr(i, 2));
                        t[Ke] = de(e.substr(a));
                        y(n).bigHour = !0;
                    });
                    He('Hmm', function (e, t, n) {
                        var i = e.length - 2;
                        t[ze] = de(e.substr(0, i));
                        t[We] = de(e.substr(i));
                    });
                    He('Hmmss', function (e, t, n) {
                        var i = e.length - 4,
                            a = e.length - 2;
                        t[ze] = de(e.substr(0, i));
                        t[We] = de(e.substr(i, 2));
                        t[Ke] = de(e.substr(a));
                    });

                    function nn(e) {
                        return 'p' === (e + '').toLowerCase().charAt(0);
                    }

                    var an = /[ap]\.?m?\.?/i,
                        on = me('Hours', !0);

                    function rn(e, t, n) {
                        if (e > 11) {
                            return n ? 'pm' : 'PM';
                        } else {
                            return n ? 'am' : 'AM';
                        }
                    }

                    var sn,
                        cn = {
                            calendar: w,
                            longDateFormat: G,
                            invalidDate: W,
                            ordinal: J,
                            dayOfMonthOrdinalParse: $,
                            relativeTime: Z,
                            months: tt,
                            monthsShort: nt,
                            week: Rt,
                            weekdays: wt,
                            weekdaysMin: Yt,
                            weekdaysShort: Ot,
                            meridiemParse: an,
                        },
                        ln = {},
                        un = {};

                    function dn(e, t) {
                        var n,
                            i = Math.min(e.length, t.length);
                        for (n = 0; n < i; n += 1) {
                            if (e[n] !== t[n]) {
                                return n;
                            }
                        }
                        return i;
                    }

                    function mn(e) {
                        return e ? e.toLowerCase().replace('_', '-') : e;
                    }

                    function pn(e) {
                        for (var t, n, i, a, o = 0; o < e.length; ) {
                            t = (a = mn(e[o]).split('-')).length;
                            n = (n = mn(e[o + 1])) ? n.split('-') : null;
                            for (; t > 0; ) {
                                if ((i = gn(a.slice(0, t).join('-')))) {
                                    return i;
                                }
                                if (n && n.length >= t && dn(a, n) >= t - 1) {
                                    break;
                                }
                                t--;
                            }
                            o++;
                        }
                        return sn;
                    }

                    function fn(e) {
                        return null != e.match('^[^/\\\\]*$');
                    }

                    function gn(t) {
                        var i = null;
                        if (void 0 === ln[t] && e && e.exports && fn(t)) {
                            try {
                                i = sn._abbr;
                                n(5358)('./' + t);
                                hn(i);
                            } catch (e) {
                                ln[t] = null;
                            }
                        }
                        return ln[t];
                    }

                    function hn(e, t) {
                        var n;
                        if (e) {
                            if (u(t)) {
                                n = _n(e);
                            } else {
                                n = yn(e, t);
                            }
                            if (n) {
                                sn = n;
                            } else if ('undefined' != typeof console && console.warn) {
                                console.warn('Locale ' + e + ' not found. Did you forget to load it?');
                            }
                        }
                        return sn._abbr;
                    }

                    function yn(e, t) {
                        if (null !== t) {
                            var n,
                                i = cn;
                            t.abbr = e;
                            if (null != ln[e]) {
                                k(
                                    'defineLocaleOverride',
                                    'use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.',
                                );
                                i = ln[e]._config;
                            } else if (null != t.parentLocale) {
                                if (null != ln[t.parentLocale]) {
                                    i = ln[t.parentLocale]._config;
                                } else if (null != (n = gn(t.parentLocale))) {
                                    i = n._config;
                                } else {
                                    if (!un[t.parentLocale]) {
                                        un[t.parentLocale] = [];
                                    }
                                    un[t.parentLocale].push({ name: e, config: t });
                                    return null;
                                }
                            }
                            ln[e] = new A(L(i, t));
                            if (un[e]) {
                                un[e].forEach(function (e) {
                                    yn(e.name, e.config);
                                });
                            }
                            hn(e);
                            return ln[e];
                        } else {
                            delete ln[e];
                            return null;
                        }
                    }

                    function xn(e, t) {
                        if (null != t) {
                            var n,
                                i,
                                a = cn;
                            if (null != ln[e] && null != ln[e].parentLocale) {
                                ln[e].set(L(ln[e]._config, t));
                            } else {
                                if (null != (i = gn(e))) {
                                    a = i._config;
                                }
                                t = L(a, t);
                                if (null == i) {
                                    t.abbr = e;
                                }
                                (n = new A(t)).parentLocale = ln[e];
                                ln[e] = n;
                            }
                            hn(e);
                        } else if (null != ln[e]) {
                            if (null != ln[e].parentLocale) {
                                ln[e] = ln[e].parentLocale;
                                if (e === hn()) {
                                    hn(e);
                                }
                            } else if (null != ln[e]) {
                                delete ln[e];
                            }
                        }
                        return ln[e];
                    }

                    function _n(e) {
                        var t;
                        if (e && e._locale && e._locale._abbr) {
                            e = e._locale._abbr;
                        }
                        if (!e) {
                            return sn;
                        }
                        if (!r(e)) {
                            if ((t = gn(e))) {
                                return t;
                            }
                            e = [e];
                        }
                        return pn(e);
                    }

                    function En() {
                        return M(ln);
                    }

                    function Cn(e) {
                        var t,
                            n = e._a;
                        if (n && -2 === y(e).overflow) {
                            t =
                                n[Qe] < 0 || n[Qe] > 11
                                    ? Qe
                                    : n[Ge] < 1 || n[Ge] > et(n[Ve], n[Qe])
                                    ? Ge
                                    : n[ze] < 0 ||
                                      n[ze] > 24 ||
                                      (24 === n[ze] && (0 !== n[We] || 0 !== n[Ke] || 0 !== n[Je]))
                                    ? ze
                                    : n[We] < 0 || n[We] > 59
                                    ? We
                                    : n[Ke] < 0 || n[Ke] > 59
                                    ? Ke
                                    : n[Je] < 0 || n[Je] > 999
                                    ? Je
                                    : -1;
                            if (y(e)._overflowDayOfYear && (t < Ve || t > Ge)) {
                                t = Ge;
                            }
                            if (y(e)._overflowWeeks && -1 === t) {
                                t = $e;
                            }
                            if (y(e)._overflowWeekday && -1 === t) {
                                t = Xe;
                            }
                            y(e).overflow = t;
                        }
                        return e;
                    }

                    var Sn =
                            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
                        bn =
                            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
                        vn = /Z|[+-]\d\d(?::?\d\d)?/,
                        Dn = [
                            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
                            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
                            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
                            ['GGGG-[W]WW', /\d{4}-W\d\d/, !1],
                            ['YYYY-DDD', /\d{4}-\d{3}/],
                            ['YYYY-MM', /\d{4}-\d\d/, !1],
                            ['YYYYYYMMDD', /[+-]\d{10}/],
                            ['YYYYMMDD', /\d{8}/],
                            ['GGGG[W]WWE', /\d{4}W\d{3}/],
                            ['GGGG[W]WW', /\d{4}W\d{2}/, !1],
                            ['YYYYDDD', /\d{7}/],
                            ['YYYYMM', /\d{6}/, !1],
                            ['YYYY', /\d{4}/, !1],
                        ],
                        Rn = [
                            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
                            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
                            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
                            ['HH:mm', /\d\d:\d\d/],
                            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
                            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
                            ['HHmmss', /\d\d\d\d\d\d/],
                            ['HHmm', /\d\d\d\d/],
                            ['HH', /\d\d/],
                        ],
                        Mn = /^\/?Date\((-?\d+)/i,
                        Tn =
                            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
                        kn = {
                            UT: 0,
                            GMT: 0,
                            EDT: -240,
                            EST: -300,
                            CDT: -300,
                            CST: -360,
                            MDT: -360,
                            MST: -420,
                            PDT: -420,
                            PST: -480,
                        };

                    function In(e) {
                        var t,
                            n,
                            i,
                            a,
                            o,
                            r,
                            s = e._i,
                            c = Sn.exec(s) || bn.exec(s),
                            l = Dn.length,
                            u = Rn.length;
                        if (c) {
                            y(e).iso = !0;
                            for (t = 0, n = l; t < n; t++) {
                                if (Dn[t][1].exec(c[1])) {
                                    a = Dn[t][0];
                                    i = !1 !== Dn[t][2];
                                    break;
                                }
                            }
                            if (null == a) {
                                e._isValid = !1;
                                return;
                            }
                            if (c[3]) {
                                for (t = 0, n = u; t < n; t++) {
                                    if (Rn[t][1].exec(c[3])) {
                                        o = (c[2] || ' ') + Rn[t][0];
                                        break;
                                    }
                                }
                                if (null == o) {
                                    e._isValid = !1;
                                    return;
                                }
                            }
                            if (!i && null != o) {
                                e._isValid = !1;
                                return;
                            }
                            if (c[4]) {
                                if (vn.exec(c[4])) {
                                    r = 'Z';
                                } else {
                                    e._isValid = !1;
                                    return;
                                }
                            }
                            e._f = a + (o || '') + (r || '');
                            Fn(e);
                        } else {
                            e._isValid = !1;
                        }
                    }

                    function Pn(e, t, n, i, a, o) {
                        var r = [Ln(e), nt.indexOf(t), parseInt(n, 10), parseInt(i, 10), parseInt(a, 10)];
                        if (o) {
                            r.push(parseInt(o, 10));
                        }
                        return r;
                    }

                    function Ln(e) {
                        var t = parseInt(e, 10);
                        if (t <= 49) {
                            return 2e3 + t;
                        } else if (t <= 999) {
                            return 1900 + t;
                        }
                        return t;
                    }

                    function An(e) {
                        return e
                            .replace(/\([^()]*\)|[\n\t]/g, ' ')
                            .replace(/(\s\s+)/g, ' ')
                            .replace(/^\s\s*/, '')
                            .replace(/\s\s*$/, '');
                    }

                    function wn(e, t, n) {
                        if (e) {
                            if (Ot.indexOf(e) !== new Date(t[0], t[1], t[2]).getDay()) {
                                y(n).weekdayMismatch = !0;
                                n._isValid = !1;
                                return !1;
                            }
                        }
                        return !0;
                    }

                    function On(e, t, n) {
                        if (e) {
                            return kn[e];
                        } else if (t) {
                            return 0;
                        } else {
                            var i = parseInt(n, 10),
                                a = i % 100;
                            return ((i - a) / 100) * 60 + a;
                        }
                    }

                    function Yn(e) {
                        var t,
                            n = Tn.exec(An(e._i));
                        if (n) {
                            t = Pn(n[4], n[3], n[2], n[5], n[6], n[7]);
                            if (!wn(n[1], t, e)) {
                                return;
                            }
                            e._a = t;
                            e._tzm = On(n[8], n[9], n[10]);
                            e._d = Et.apply(null, e._a);
                            e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm);
                            y(e).rfc2822 = !0;
                        } else {
                            e._isValid = !1;
                        }
                    }

                    function Bn(e) {
                        var t = Mn.exec(e._i);
                        if (null === t) {
                            In(e);
                            if (!1 === e._isValid) {
                                delete e._isValid;
                                Yn(e);
                                if (!1 === e._isValid) {
                                    delete e._isValid;
                                    if (e._strict) {
                                        e._isValid = !1;
                                    } else {
                                        a.createFromInputFallback(e);
                                    }
                                }
                            }
                        } else {
                            e._d = new Date(+t[1]);
                        }
                    }

                    a.createFromInputFallback = R(
                        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
                        function (e) {
                            e._d = new Date(e._i + (e._useUTC ? ' UTC' : ''));
                        },
                    );

                    function Nn(e, t, n) {
                        if (null != e) {
                            return e;
                        }
                        if (null != t) {
                            return t;
                        } else {
                            return n;
                        }
                    }

                    function qn(e) {
                        var t = new Date(a.now());
                        if (e._useUTC) {
                            return [t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()];
                        } else {
                            return [t.getFullYear(), t.getMonth(), t.getDate()];
                        }
                    }

                    function Hn(e) {
                        var t,
                            n,
                            i,
                            a,
                            o,
                            r = [];
                        if (!e._d) {
                            i = qn(e);
                            if (e._w && null == e._a[Ge] && null == e._a[Qe]) {
                                jn(e);
                            }
                            if (null != e._dayOfYear) {
                                o = Nn(e._a[Ve], i[Ve]);
                                if (e._dayOfYear > ht(o) || 0 === e._dayOfYear) {
                                    y(e)._overflowDayOfYear = !0;
                                }
                                n = Et(o, 0, e._dayOfYear);
                                e._a[Qe] = n.getUTCMonth();
                                e._a[Ge] = n.getUTCDate();
                            }
                            for (t = 0; t < 3 && null == e._a[t]; ++t) {
                                e._a[t] = r[t] = i[t];
                            }
                            for (; t < 7; t++) {
                                e._a[t] = r[t] = null == e._a[t] ? (2 === t ? 1 : 0) : e._a[t];
                            }
                            if (24 === e._a[ze] && 0 === e._a[We] && 0 === e._a[Ke] && 0 === e._a[Je]) {
                                e._nextDay = !0;
                                e._a[ze] = 0;
                            }
                            e._d = (e._useUTC ? Et : _t).apply(null, r);
                            a = e._useUTC ? e._d.getUTCDay() : e._d.getDay();
                            if (null != e._tzm) {
                                e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm);
                            }
                            if (e._nextDay) {
                                e._a[ze] = 24;
                            }
                            if (e._w && void 0 !== e._w.d && e._w.d !== a) {
                                y(e).weekdayMismatch = !0;
                            }
                        }
                    }

                    function jn(e) {
                        var t, n, i, a, o, r, s, c, l;
                        if (null != (t = e._w).GG || null != t.W || null != t.E) {
                            o = 1;
                            r = 4;
                            n = Nn(t.GG, e._a[Ve], bt(Jn(), 1, 4).year);
                            i = Nn(t.W, 1);
                            if ((a = Nn(t.E, 1)) < 1 || a > 7) {
                                c = !0;
                            }
                        } else {
                            o = e._locale._week.dow;
                            r = e._locale._week.doy;
                            l = bt(Jn(), o, r);
                            n = Nn(t.gg, e._a[Ve], l.year);
                            i = Nn(t.w, l.week);
                            if (null != t.d) {
                                if ((a = t.d) < 0 || a > 6) {
                                    c = !0;
                                }
                            } else if (null != t.e) {
                                a = t.e + o;
                                if (t.e < 0 || t.e > 6) {
                                    c = !0;
                                }
                            } else {
                                a = o;
                            }
                        }
                        if (i < 1 || i > vt(n, o, r)) {
                            y(e)._overflowWeeks = !0;
                        } else if (null != c) {
                            y(e)._overflowWeekday = !0;
                        } else {
                            s = St(n, i, a, o, r);
                            e._a[Ve] = s.year;
                            e._dayOfYear = s.dayOfYear;
                        }
                    }

                    a.ISO_8601 = function () {};
                    a.RFC_2822 = function () {};

                    function Fn(e) {
                        if (e._f !== a.ISO_8601) {
                            if (e._f !== a.RFC_2822) {
                                e._a = [];
                                y(e).empty = !0;
                                var t,
                                    n,
                                    i,
                                    o,
                                    r,
                                    s,
                                    c,
                                    l = '' + e._i,
                                    u = l.length,
                                    d = 0;
                                c = (i = Q(e._f, e._locale).match(B) || []).length;
                                for (t = 0; t < c; t++) {
                                    o = i[t];
                                    if ((n = (l.match(Ye(o, e)) || [])[0])) {
                                        if ((r = l.substr(0, l.indexOf(n))).length > 0) {
                                            y(e).unusedInput.push(r);
                                        }
                                        l = l.slice(l.indexOf(n) + n.length);
                                        d += n.length;
                                    }
                                    if (H[o]) {
                                        if (n) {
                                            y(e).empty = !1;
                                        } else {
                                            y(e).unusedTokens.push(o);
                                        }
                                        Fe(o, n, e);
                                    } else if (e._strict && !n) {
                                        y(e).unusedTokens.push(o);
                                    }
                                }
                                y(e).charsLeftOver = u - d;
                                if (l.length > 0) {
                                    y(e).unusedInput.push(l);
                                }
                                if (e._a[ze] <= 12 && !0 === y(e).bigHour && e._a[ze] > 0) {
                                    y(e).bigHour = void 0;
                                }
                                y(e).parsedDateParts = e._a.slice(0);
                                y(e).meridiem = e._meridiem;
                                e._a[ze] = Un(e._locale, e._a[ze], e._meridiem);
                                if (null !== (s = y(e).era)) {
                                    e._a[Ve] = e._locale.erasConvertYear(s, e._a[Ve]);
                                }
                                Hn(e);
                                Cn(e);
                            } else {
                                Yn(e);
                            }
                        } else {
                            In(e);
                        }
                    }

                    function Un(e, t, n) {
                        var i;
                        if (null == n) {
                            return t;
                        }
                        if (null != e.meridiemHour) {
                            return e.meridiemHour(t, n);
                        } else if (null != e.isPM) {
                            if ((i = e.isPM(n)) && t < 12) {
                                t += 12;
                            }
                            if (!i && 12 === t) {
                                t = 0;
                            }
                            return t;
                        } else {
                            return t;
                        }
                    }

                    function Vn(e) {
                        var t,
                            n,
                            i,
                            a,
                            o,
                            r,
                            s = !1,
                            c = e._f.length;
                        if (0 !== c) {
                            for (a = 0; a < c; a++) {
                                o = 0;
                                r = !1;
                                t = S({}, e);
                                if (null != e._useUTC) {
                                    t._useUTC = e._useUTC;
                                }
                                t._f = e._f[a];
                                Fn(t);
                                if (x(t)) {
                                    r = !0;
                                }
                                o += y(t).charsLeftOver;
                                o += 10 * y(t).unusedTokens.length;
                                y(t).score = o;
                                if (!s) {
                                    if (null == i || o < i || r) {
                                        i = o;
                                        n = t;
                                        if (r) {
                                            s = !0;
                                        }
                                    }
                                } else if (o < i) {
                                    i = o;
                                    n = t;
                                }
                            }
                            f(e, n || t);
                        } else {
                            y(e).invalidFormat = !0;
                            e._d = new Date(NaN);
                        }
                    }

                    function Qn(e) {
                        if (!e._d) {
                            var t = oe(e._i),
                                n = void 0 === t.day ? t.date : t.day;
                            e._a = p([t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond], function (e) {
                                return e && parseInt(e, 10);
                            });
                            Hn(e);
                        }
                    }

                    function Gn(e) {
                        var t = new b(Cn(zn(e)));
                        if (t._nextDay) {
                            t.add(1, 'd');
                            t._nextDay = void 0;
                        }
                        return t;
                    }

                    function zn(e) {
                        var t = e._i,
                            n = e._f;
                        e._locale = e._locale || _n(e._l);
                        if (null === t || (void 0 === n && '' === t)) {
                            return _({ nullInput: !0 });
                        }
                        if ('string' == typeof t) {
                            e._i = t = e._locale.preparse(t);
                        }
                        if (v(t)) {
                            return new b(Cn(t));
                        } else if (m(t)) {
                            e._d = t;
                        } else if (r(n)) {
                            Vn(e);
                        } else if (n) {
                            Fn(e);
                        } else {
                            Wn(e);
                        }
                        if (!x(e)) {
                            e._d = null;
                        }
                        return e;
                    }

                    function Wn(e) {
                        var t = e._i;
                        if (u(t)) {
                            e._d = new Date(a.now());
                        } else if (m(t)) {
                            e._d = new Date(t.valueOf());
                        } else if ('string' == typeof t) {
                            Bn(e);
                        } else if (r(t)) {
                            e._a = p(t.slice(0), function (e) {
                                return parseInt(e, 10);
                            });
                            Hn(e);
                        } else if (s(t)) {
                            Qn(e);
                        } else if (d(t)) {
                            e._d = new Date(t);
                        } else {
                            a.createFromInputFallback(e);
                        }
                    }

                    function Kn(e, t, n, i, a) {
                        var o = {};
                        if (!0 === t || !1 === t) {
                            i = t;
                            t = void 0;
                        }
                        if (!0 === n || !1 === n) {
                            i = n;
                            n = void 0;
                        }
                        if ((s(e) && l(e)) || (r(e) && 0 === e.length)) {
                            e = void 0;
                        }
                        o._isAMomentObject = !0;
                        o._useUTC = o._isUTC = a;
                        o._l = n;
                        o._i = e;
                        o._f = t;
                        o._strict = i;
                        return Gn(o);
                    }

                    function Jn(e, t, n, i) {
                        return Kn(e, t, n, i, !1);
                    }

                    var $n = R(
                            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
                            function () {
                                var e = Jn.apply(null, arguments);
                                if (this.isValid() && e.isValid()) {
                                    return e < this ? this : e;
                                } else {
                                    return _();
                                }
                            },
                        ),
                        Xn = R(
                            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
                            function () {
                                var e = Jn.apply(null, arguments);
                                if (this.isValid() && e.isValid()) {
                                    return e > this ? this : e;
                                } else {
                                    return _();
                                }
                            },
                        );

                    function Zn(e, t) {
                        var n, i;
                        if (1 === t.length && r(t[0])) {
                            t = t[0];
                        }
                        if (!t.length) {
                            return Jn();
                        }
                        n = t[0];
                        for (i = 1; i < t.length; ++i) {
                            if (!t[i].isValid() || t[i][e](n)) {
                                n = t[i];
                            }
                        }
                        return n;
                    }

                    function ei() {
                        return Zn('isBefore', [].slice.call(arguments, 0));
                    }

                    function ti() {
                        return Zn('isAfter', [].slice.call(arguments, 0));
                    }

                    var ni = function () {
                            return Date.now ? Date.now() : +new Date();
                        },
                        ii = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

                    function ai(e) {
                        var t,
                            n,
                            i = !1,
                            a = ii.length;
                        for (t in e) {
                            if (c(e, t) && (-1 === Ue.call(ii, t) || (null != e[t] && isNaN(e[t])))) {
                                return !1;
                            }
                        }
                        for (n = 0; n < a; ++n) {
                            if (e[ii[n]]) {
                                if (i) {
                                    return !1;
                                }
                                if (parseFloat(e[ii[n]]) !== de(e[ii[n]])) {
                                    i = !0;
                                }
                            }
                        }
                        return !0;
                    }

                    function oi() {
                        return this._isValid;
                    }

                    function ri() {
                        return ki(NaN);
                    }

                    function si(e) {
                        var t = oe(e),
                            n = t.year || 0,
                            i = t.quarter || 0,
                            a = t.month || 0,
                            o = t.week || t.isoWeek || 0,
                            r = t.day || 0,
                            s = t.hour || 0,
                            c = t.minute || 0,
                            l = t.second || 0,
                            u = t.millisecond || 0;
                        this._isValid = ai(t);
                        this._milliseconds = +u + 1e3 * l + 6e4 * c + 1e3 * s * 60 * 60;
                        this._days = +r + 7 * o;
                        this._months = +a + 3 * i + 12 * n;
                        this._data = {};
                        this._locale = _n();
                        this._bubble();
                    }

                    function ci(e) {
                        return e instanceof si;
                    }

                    function li(e) {
                        if (e < 0) {
                            return -1 * Math.round(-1 * e);
                        } else {
                            return Math.round(e);
                        }
                    }

                    function ui(e, t, n) {
                        var i,
                            a = Math.min(e.length, t.length),
                            o = Math.abs(e.length - t.length),
                            r = 0;
                        for (i = 0; i < a; i++) {
                            if ((n && e[i] !== t[i]) || (!n && de(e[i]) !== de(t[i]))) {
                                r++;
                            }
                        }
                        return r + o;
                    }

                    function di(e, t) {
                        j(e, 0, 0, function () {
                            var e = this.utcOffset(),
                                n = '+';
                            if (e < 0) {
                                e = -e;
                                n = '-';
                            }
                            return n + Y(~~(e / 60), 2) + t + Y(~~e % 60, 2);
                        });
                    }

                    di('Z', ':');
                    di('ZZ', '');
                    Oe('Z', Le);
                    Oe('ZZ', Le);
                    He(['Z', 'ZZ'], function (e, t, n) {
                        n._useUTC = !0;
                        n._tzm = pi(Le, e);
                    });
                    var mi = /([\+\-]|\d\d)/gi;

                    function pi(e, t) {
                        var n,
                            i,
                            a = (t || '').match(e);
                        if (null === a) {
                            return null;
                        } else {
                            return 0 ===
                                (i = 60 * (n = ((a[a.length - 1] || []) + '').match(mi) || ['-', 0, 0])[1] + de(n[2]))
                                ? 0
                                : '+' === n[0]
                                ? i
                                : -i;
                        }
                    }

                    function fi(e, t) {
                        var n, i;
                        if (t._isUTC) {
                            n = t.clone();
                            i = (v(e) || m(e) ? e.valueOf() : Jn(e).valueOf()) - n.valueOf();
                            n._d.setTime(n._d.valueOf() + i);
                            a.updateOffset(n, !1);
                            return n;
                        } else {
                            return Jn(e).local();
                        }
                    }

                    function gi(e) {
                        return -Math.round(e._d.getTimezoneOffset());
                    }

                    a.updateOffset = function () {};

                    function hi(e, t, n) {
                        var i,
                            o = this._offset || 0;
                        if (!this.isValid()) {
                            return null != e ? this : NaN;
                        }
                        if (null != e) {
                            if ('string' == typeof e) {
                                if (null === (e = pi(Le, e))) {
                                    return this;
                                }
                            } else if (Math.abs(e) < 16 && !n) {
                                e *= 60;
                            }
                            if (!this._isUTC && t) {
                                i = gi(this);
                            }
                            this._offset = e;
                            this._isUTC = !0;
                            if (null != i) {
                                this.add(i, 'm');
                            }
                            if (o !== e) {
                                if (!t || this._changeInProgress) {
                                    wi(this, ki(e - o, 'm'), 1, !1);
                                } else if (!this._changeInProgress) {
                                    this._changeInProgress = !0;
                                    a.updateOffset(this, !0);
                                    this._changeInProgress = null;
                                }
                            }
                            return this;
                        } else {
                            return this._isUTC ? o : gi(this);
                        }
                    }

                    function yi(e, t) {
                        if (null != e) {
                            if ('string' != typeof e) {
                                e = -e;
                            }
                            this.utcOffset(e, t);
                            return this;
                        } else {
                            return -this.utcOffset();
                        }
                    }

                    function xi(e) {
                        return this.utcOffset(0, e);
                    }

                    function _i(e) {
                        if (this._isUTC) {
                            this.utcOffset(0, e);
                            this._isUTC = !1;
                            if (e) {
                                this.subtract(gi(this), 'm');
                            }
                        }
                        return this;
                    }

                    function Ei() {
                        if (null != this._tzm) {
                            this.utcOffset(this._tzm, !1, !0);
                        } else if ('string' == typeof this._i) {
                            var e = pi(Pe, this._i);
                            if (null != e) {
                                this.utcOffset(e);
                            } else {
                                this.utcOffset(0, !0);
                            }
                        }
                        return this;
                    }

                    function Ci(e) {
                        if (!this.isValid()) {
                            return !1;
                        }
                        e = e ? Jn(e).utcOffset() : 0;
                        return (this.utcOffset() - e) % 60 == 0;
                    }

                    function Si() {
                        return (
                            this.utcOffset() > this.clone().month(0).utcOffset() ||
                            this.utcOffset() > this.clone().month(5).utcOffset()
                        );
                    }

                    function bi() {
                        if (!u(this._isDSTShifted)) {
                            return this._isDSTShifted;
                        }
                        var e,
                            t = {};
                        S(t, this);
                        if ((t = zn(t))._a) {
                            e = t._isUTC ? g(t._a) : Jn(t._a);
                            this._isDSTShifted = this.isValid() && ui(t._a, e.toArray()) > 0;
                        } else {
                            this._isDSTShifted = !1;
                        }
                        return this._isDSTShifted;
                    }

                    function vi() {
                        return this.isValid() ? !this._isUTC : !1;
                    }

                    function Di() {
                        return this.isValid() ? this._isUTC : !1;
                    }

                    function Ri() {
                        return this.isValid() ? this._isUTC && 0 === this._offset : !1;
                    }

                    var Mi = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
                        Ti =
                            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

                    function ki(e, t) {
                        var n,
                            i,
                            a,
                            o = e,
                            r = null;
                        if (ci(e)) {
                            o = { ms: e._milliseconds, d: e._days, M: e._months };
                        } else if (d(e) || !isNaN(+e)) {
                            o = {};
                            if (t) {
                                o[t] = +e;
                            } else {
                                o.milliseconds = +e;
                            }
                        } else if ((r = Mi.exec(e))) {
                            n = '-' === r[1] ? -1 : 1;
                            o = {
                                y: 0,
                                d: de(r[Ge]) * n,
                                h: de(r[ze]) * n,
                                m: de(r[We]) * n,
                                s: de(r[Ke]) * n,
                                ms: de(li(1e3 * r[Je])) * n,
                            };
                        } else if ((r = Ti.exec(e))) {
                            n = '-' === r[1] ? -1 : 1;
                            o = {
                                y: Ii(r[2], n),
                                M: Ii(r[3], n),
                                w: Ii(r[4], n),
                                d: Ii(r[5], n),
                                h: Ii(r[6], n),
                                m: Ii(r[7], n),
                                s: Ii(r[8], n),
                            };
                        } else if (null == o) {
                            o = {};
                        } else if ('object' == typeof o && ('from' in o || 'to' in o)) {
                            a = Li(Jn(o.from), Jn(o.to));
                            (o = {}).ms = a.milliseconds;
                            o.M = a.months;
                        }
                        i = new si(o);
                        if (ci(e) && c(e, '_locale')) {
                            i._locale = e._locale;
                        }
                        if (ci(e) && c(e, '_isValid')) {
                            i._isValid = e._isValid;
                        }
                        return i;
                    }

                    ki.fn = si.prototype;
                    ki.invalid = ri;

                    function Ii(e, t) {
                        var n = e && parseFloat(e.replace(',', '.'));
                        return (isNaN(n) ? 0 : n) * t;
                    }

                    function Pi(e, t) {
                        var n = {};
                        n.months = t.month() - e.month() + 12 * (t.year() - e.year());
                        if (e.clone().add(n.months, 'M').isAfter(t)) {
                            --n.months;
                        }
                        n.milliseconds = +t - +e.clone().add(n.months, 'M');
                        return n;
                    }

                    function Li(e, t) {
                        var n;
                        if (!e.isValid() || !t.isValid()) {
                            return { milliseconds: 0, months: 0 };
                        }
                        t = fi(t, e);
                        if (e.isBefore(t)) {
                            n = Pi(e, t);
                        } else {
                            (n = Pi(t, e)).milliseconds = -n.milliseconds;
                            n.months = -n.months;
                        }
                        return n;
                    }

                    function Ai(e, t) {
                        return function (n, i) {
                            var a;
                            if (null !== i && !isNaN(+i)) {
                                k(
                                    t,
                                    'moment().' +
                                        t +
                                        '(period, number) is deprecated. Please use moment().' +
                                        t +
                                        '(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.',
                                );
                                a = n;
                                n = i;
                                i = a;
                            }
                            wi(this, ki(n, i), e);
                            return this;
                        };
                    }

                    function wi(e, t, n, i) {
                        var o = t._milliseconds,
                            r = li(t._days),
                            s = li(t._months);
                        if (e.isValid()) {
                            i = null == i ? !0 : i;
                            if (s) {
                                ut(e, pe(e, 'Month') + s * n);
                            }
                            if (r) {
                                fe(e, 'Date', pe(e, 'Date') + r * n);
                            }
                            if (o) {
                                e._d.setTime(e._d.valueOf() + o * n);
                            }
                            if (i) {
                                a.updateOffset(e, r || s);
                            }
                        }
                    }

                    var Oi = Ai(1, 'add'),
                        Yi = Ai(-1, 'subtract');

                    function Bi(e) {
                        return 'string' == typeof e || e instanceof String;
                    }

                    function Ni(e) {
                        return v(e) || m(e) || Bi(e) || d(e) || Hi(e) || qi(e) || null == e;
                    }

                    function qi(e) {
                        var t,
                            n,
                            i = s(e) && !l(e),
                            a = !1,
                            o = [
                                'years',
                                'year',
                                'y',
                                'months',
                                'month',
                                'M',
                                'days',
                                'day',
                                'd',
                                'dates',
                                'date',
                                'D',
                                'hours',
                                'hour',
                                'h',
                                'minutes',
                                'minute',
                                'm',
                                'seconds',
                                'second',
                                's',
                                'milliseconds',
                                'millisecond',
                                'ms',
                            ],
                            r = o.length;
                        for (t = 0; t < r; t += 1) {
                            n = o[t];
                            a = a || c(e, n);
                        }
                        return i && a;
                    }

                    function Hi(e) {
                        var t = r(e),
                            n = !1;
                        if (t) {
                            n =
                                0 ===
                                e.filter(function (t) {
                                    return !d(t) && Bi(e);
                                }).length;
                        }
                        return t && n;
                    }

                    function ji(e) {
                        var t,
                            n,
                            i = s(e) && !l(e),
                            a = !1,
                            o = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'];
                        for (t = 0; t < o.length; t += 1) {
                            n = o[t];
                            a = a || c(e, n);
                        }
                        return i && a;
                    }

                    function Fi(e, t) {
                        var n = e.diff(t, 'days', !0);
                        return n < -6
                            ? 'sameElse'
                            : n < -1
                            ? 'lastWeek'
                            : n < 0
                            ? 'lastDay'
                            : n < 1
                            ? 'sameDay'
                            : n < 2
                            ? 'nextDay'
                            : n < 7
                            ? 'nextWeek'
                            : 'sameElse';
                    }

                    function Ui(e, t) {
                        if (1 === arguments.length) {
                            if (!arguments[0]) {
                                e = void 0;
                                t = void 0;
                            } else if (Ni(arguments[0])) {
                                e = arguments[0];
                                t = void 0;
                            } else if (ji(arguments[0])) {
                                t = arguments[0];
                                e = void 0;
                            }
                        }
                        var n = e || Jn(),
                            i = fi(n, this).startOf('day'),
                            o = a.calendarFormat(this, i) || 'sameElse',
                            r = t && (I(t[o]) ? t[o].call(this, n) : t[o]);
                        return this.format(r || this.localeData().calendar(o, this, Jn(n)));
                    }

                    function Vi() {
                        return new b(this);
                    }

                    function Qi(e, t) {
                        var n = v(e) ? e : Jn(e);
                        if (!this.isValid() || !n.isValid()) {
                            return !1;
                        }
                        if ('millisecond' === (t = ae(t) || 'millisecond')) {
                            return this.valueOf() > n.valueOf();
                        } else {
                            return n.valueOf() < this.clone().startOf(t).valueOf();
                        }
                    }

                    function Gi(e, t) {
                        var n = v(e) ? e : Jn(e);
                        if (!this.isValid() || !n.isValid()) {
                            return !1;
                        }
                        if ('millisecond' === (t = ae(t) || 'millisecond')) {
                            return this.valueOf() < n.valueOf();
                        } else {
                            return this.clone().endOf(t).valueOf() < n.valueOf();
                        }
                    }

                    function zi(e, t, n, i) {
                        var a = v(e) ? e : Jn(e),
                            o = v(t) ? t : Jn(t);
                        if (!(this.isValid() && a.isValid() && o.isValid())) {
                            return !1;
                        } else {
                            return (
                                ('(' === (i = i || '()')[0] ? this.isAfter(a, n) : !this.isBefore(a, n)) &&
                                (')' === i[1] ? this.isBefore(o, n) : !this.isAfter(o, n))
                            );
                        }
                    }

                    function Wi(e, t) {
                        var n,
                            i = v(e) ? e : Jn(e);
                        if (!this.isValid() || !i.isValid()) {
                            return !1;
                        }
                        if ('millisecond' === (t = ae(t) || 'millisecond')) {
                            return this.valueOf() === i.valueOf();
                        } else {
                            n = i.valueOf();
                            return this.clone().startOf(t).valueOf() <= n && n <= this.clone().endOf(t).valueOf();
                        }
                    }

                    function Ki(e, t) {
                        return this.isSame(e, t) || this.isAfter(e, t);
                    }

                    function Ji(e, t) {
                        return this.isSame(e, t) || this.isBefore(e, t);
                    }

                    function $i(e, t, n) {
                        var i, a, o;
                        if (!this.isValid()) {
                            return NaN;
                        }
                        if (!(i = fi(e, this)).isValid()) {
                            return NaN;
                        }
                        a = 6e4 * (i.utcOffset() - this.utcOffset());
                        switch ((t = ae(t))) {
                            case 'year':
                                o = Xi(this, i) / 12;
                                break;
                            case 'month':
                                o = Xi(this, i);
                                break;
                            case 'quarter':
                                o = Xi(this, i) / 3;
                                break;
                            case 'second':
                                o = (this - i) / 1e3;
                                break;
                            case 'minute':
                                o = (this - i) / 6e4;
                                break;
                            case 'hour':
                                o = (this - i) / 36e5;
                                break;
                            case 'day':
                                o = (this - i - a) / 864e5;
                                break;
                            case 'week':
                                o = (this - i - a) / 6048e5;
                                break;
                            default:
                                o = this - i;
                        }
                        return n ? o : ue(o);
                    }

                    function Xi(e, t) {
                        if (e.date() < t.date()) {
                            return -Xi(t, e);
                        }
                        var n,
                            i = 12 * (t.year() - e.year()) + (t.month() - e.month()),
                            a = e.clone().add(i, 'months');
                        if (t - a < 0) {
                            n = (t - a) / (a - e.clone().add(i - 1, 'months'));
                        } else {
                            n = (t - a) / (e.clone().add(i + 1, 'months') - a);
                        }
                        return -(i + n) || 0;
                    }

                    a.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
                    a.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

                    function Zi() {
                        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
                    }

                    function ea(e) {
                        if (!this.isValid()) {
                            return null;
                        }
                        var t = !0 !== e,
                            n = t ? this.clone().utc() : this;
                        if (n.year() < 0 || n.year() > 9999) {
                            return V(n, t ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
                        }
                        if (I(Date.prototype.toISOString)) {
                            if (t) {
                                return this.toDate().toISOString();
                            } else {
                                return new Date(this.valueOf() + 60 * this.utcOffset() * 1e3)
                                    .toISOString()
                                    .replace('Z', V(n, 'Z'));
                            }
                        }
                        return V(n, t ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
                    }

                    function ta() {
                        if (!this.isValid()) {
                            return 'moment.invalid(/* ' + this._i + ' */)';
                        }
                        var e,
                            t,
                            n,
                            i,
                            a = 'moment',
                            o = '';
                        if (!this.isLocal()) {
                            a = 0 === this.utcOffset() ? 'moment.utc' : 'moment.parseZone';
                            o = 'Z';
                        }
                        e = '[' + a + '("]';
                        t = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
                        n = '-MM-DD[T]HH:mm:ss.SSS';
                        i = o + '[")]';
                        return this.format(e + t + n + i);
                    }

                    function na(e) {
                        if (!e) {
                            e = this.isUtc() ? a.defaultFormatUtc : a.defaultFormat;
                        }
                        var t = V(this, e);
                        return this.localeData().postformat(t);
                    }

                    function ia(e, t) {
                        if (this.isValid() && ((v(e) && e.isValid()) || Jn(e).isValid())) {
                            return ki({ to: this, from: e }).locale(this.locale()).humanize(!t);
                        } else {
                            return this.localeData().invalidDate();
                        }
                    }

                    function aa(e) {
                        return this.from(Jn(), e);
                    }

                    function oa(e, t) {
                        if (this.isValid() && ((v(e) && e.isValid()) || Jn(e).isValid())) {
                            return ki({ from: this, to: e }).locale(this.locale()).humanize(!t);
                        } else {
                            return this.localeData().invalidDate();
                        }
                    }

                    function ra(e) {
                        return this.to(Jn(), e);
                    }

                    function sa(e) {
                        var t;
                        if (void 0 === e) {
                            return this._locale._abbr;
                        } else {
                            if (null != (t = _n(e))) {
                                this._locale = t;
                            }
                            return this;
                        }
                    }

                    var ca = R(
                        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
                        function (e) {
                            if (void 0 === e) {
                                return this.localeData();
                            } else {
                                return this.locale(e);
                            }
                        },
                    );

                    function la() {
                        return this._locale;
                    }

                    var ua = 1e3,
                        da = 60 * ua,
                        ma = 60 * da,
                        pa = 3506328 * ma;

                    function fa(e, t) {
                        return ((e % t) + t) % t;
                    }

                    function ga(e, t, n) {
                        if (e < 100 && e >= 0) {
                            return new Date(e + 400, t, n) - pa;
                        } else {
                            return new Date(e, t, n).valueOf();
                        }
                    }

                    function ha(e, t, n) {
                        if (e < 100 && e >= 0) {
                            return Date.UTC(e + 400, t, n) - pa;
                        } else {
                            return Date.UTC(e, t, n);
                        }
                    }

                    function ya(e) {
                        var t, n;
                        if (void 0 === (e = ae(e)) || 'millisecond' === e || !this.isValid()) {
                            return this;
                        }
                        n = this._isUTC ? ha : ga;
                        switch (e) {
                            case 'year':
                                t = n(this.year(), 0, 1);
                                break;
                            case 'quarter':
                                t = n(this.year(), this.month() - (this.month() % 3), 1);
                                break;
                            case 'month':
                                t = n(this.year(), this.month(), 1);
                                break;
                            case 'week':
                                t = n(this.year(), this.month(), this.date() - this.weekday());
                                break;
                            case 'isoWeek':
                                t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                                break;
                            case 'day':
                            case 'date':
                                t = n(this.year(), this.month(), this.date());
                                break;
                            case 'hour':
                                t = this._d.valueOf();
                                t -= fa(t + (this._isUTC ? 0 : this.utcOffset() * da), ma);
                                break;
                            case 'minute':
                                t = this._d.valueOf();
                                t -= fa(t, da);
                                break;
                            case 'second':
                                t = this._d.valueOf();
                                t -= fa(t, ua);
                        }
                        this._d.setTime(t);
                        a.updateOffset(this, !0);
                        return this;
                    }

                    function xa(e) {
                        var t, n;
                        if (void 0 === (e = ae(e)) || 'millisecond' === e || !this.isValid()) {
                            return this;
                        }
                        n = this._isUTC ? ha : ga;
                        switch (e) {
                            case 'year':
                                t = n(this.year() + 1, 0, 1) - 1;
                                break;
                            case 'quarter':
                                t = n(this.year(), this.month() - (this.month() % 3) + 3, 1) - 1;
                                break;
                            case 'month':
                                t = n(this.year(), this.month() + 1, 1) - 1;
                                break;
                            case 'week':
                                t = n(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                                break;
                            case 'isoWeek':
                                t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                                break;
                            case 'day':
                            case 'date':
                                t = n(this.year(), this.month(), this.date() + 1) - 1;
                                break;
                            case 'hour':
                                t = this._d.valueOf();
                                t += ma - fa(t + (this._isUTC ? 0 : this.utcOffset() * da), ma) - 1;
                                break;
                            case 'minute':
                                t = this._d.valueOf();
                                t += da - fa(t, da) - 1;
                                break;
                            case 'second':
                                t = this._d.valueOf();
                                t += ua - fa(t, ua) - 1;
                        }
                        this._d.setTime(t);
                        a.updateOffset(this, !0);
                        return this;
                    }

                    function _a() {
                        return this._d.valueOf() - 6e4 * (this._offset || 0);
                    }

                    function Ea() {
                        return Math.floor(this.valueOf() / 1e3);
                    }

                    function Ca() {
                        return new Date(this.valueOf());
                    }

                    function Sa() {
                        var e = this;
                        return [e.year(), e.month(), e.date(), e.hour(), e.minute(), e.second(), e.millisecond()];
                    }

                    function ba() {
                        var e = this;
                        return {
                            years: e.year(),
                            months: e.month(),
                            date: e.date(),
                            hours: e.hours(),
                            minutes: e.minutes(),
                            seconds: e.seconds(),
                            milliseconds: e.milliseconds(),
                        };
                    }

                    function va() {
                        return this.isValid() ? this.toISOString() : null;
                    }

                    function Da() {
                        return x(this);
                    }

                    function Ra() {
                        return f({}, y(this));
                    }

                    function Ma() {
                        return y(this).overflow;
                    }

                    function Ta() {
                        return {
                            input: this._i,
                            format: this._f,
                            locale: this._locale,
                            isUTC: this._isUTC,
                            strict: this._strict,
                        };
                    }

                    j('N', 0, 0, 'eraAbbr');
                    j('NN', 0, 0, 'eraAbbr');
                    j('NNN', 0, 0, 'eraAbbr');
                    j('NNNN', 0, 0, 'eraName');
                    j('NNNNN', 0, 0, 'eraNarrow');
                    j('y', ['y', 1], 'yo', 'eraYear');
                    j('y', ['yy', 2], 0, 'eraYear');
                    j('y', ['yyy', 3], 0, 'eraYear');
                    j('y', ['yyyy', 4], 0, 'eraYear');
                    Oe('N', qa);
                    Oe('NN', qa);
                    Oe('NNN', qa);
                    Oe('NNNN', Ha);
                    Oe('NNNNN', ja);
                    He(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (e, t, n, i) {
                        var a = n._locale.erasParse(e, i, n._strict);
                        if (a) {
                            y(n).era = a;
                        } else {
                            y(n).invalidEra = e;
                        }
                    });
                    Oe('y', ke);
                    Oe('yy', ke);
                    Oe('yyy', ke);
                    Oe('yyyy', ke);
                    Oe('yo', Fa);
                    He(['y', 'yy', 'yyy', 'yyyy'], Ve);
                    He(['yo'], function (e, t, n, i) {
                        var a;
                        if (n._locale._eraYearOrdinalRegex) {
                            a = e.match(n._locale._eraYearOrdinalRegex);
                        }
                        if (n._locale.eraYearOrdinalParse) {
                            t[Ve] = n._locale.eraYearOrdinalParse(e, a);
                        } else {
                            t[Ve] = parseInt(e, 10);
                        }
                    });

                    function ka(e, t) {
                        var n,
                            i,
                            o,
                            r = this._eras || _n('en')._eras;
                        for (n = 0, i = r.length; n < i; ++n) {
                            if ('string' == typeof r[n].since) {
                                o = a(r[n].since).startOf('day');
                                r[n].since = o.valueOf();
                            }
                            switch (typeof r[n].until) {
                                case 'undefined':
                                    r[n].until = 1 / 0;
                                    break;
                                case 'string':
                                    o = a(r[n].until).startOf('day').valueOf();
                                    r[n].until = o.valueOf();
                            }
                        }
                        return r;
                    }

                    function Ia(e, t, n) {
                        var i,
                            a,
                            o,
                            r,
                            s,
                            c = this.eras();
                        e = e.toUpperCase();
                        for (i = 0, a = c.length; i < a; ++i) {
                            o = c[i].name.toUpperCase();
                            r = c[i].abbr.toUpperCase();
                            s = c[i].narrow.toUpperCase();
                            if (n) {
                                switch (t) {
                                    case 'N':
                                    case 'NN':
                                    case 'NNN':
                                        if (r === e) {
                                            return c[i];
                                        }
                                        break;
                                    case 'NNNN':
                                        if (o === e) {
                                            return c[i];
                                        }
                                        break;
                                    case 'NNNNN':
                                        if (s === e) {
                                            return c[i];
                                        }
                                }
                            } else if ([o, r, s].indexOf(e) >= 0) {
                                return c[i];
                            }
                        }
                    }

                    function Pa(e, t) {
                        var n = e.since <= e.until ? 1 : -1;
                        if (void 0 === t) {
                            return a(e.since).year();
                        } else {
                            return a(e.since).year() + (t - e.offset) * n;
                        }
                    }

                    function La() {
                        var e,
                            t,
                            n,
                            i = this.localeData().eras();
                        for (e = 0, t = i.length; e < t; ++e) {
                            n = this.clone().startOf('day').valueOf();
                            if (i[e].since <= n && n <= i[e].until) {
                                return i[e].name;
                            }
                            if (i[e].until <= n && n <= i[e].since) {
                                return i[e].name;
                            }
                        }
                        return '';
                    }

                    function Aa() {
                        var e,
                            t,
                            n,
                            i = this.localeData().eras();
                        for (e = 0, t = i.length; e < t; ++e) {
                            n = this.clone().startOf('day').valueOf();
                            if (i[e].since <= n && n <= i[e].until) {
                                return i[e].narrow;
                            }
                            if (i[e].until <= n && n <= i[e].since) {
                                return i[e].narrow;
                            }
                        }
                        return '';
                    }

                    function wa() {
                        var e,
                            t,
                            n,
                            i = this.localeData().eras();
                        for (e = 0, t = i.length; e < t; ++e) {
                            n = this.clone().startOf('day').valueOf();
                            if (i[e].since <= n && n <= i[e].until) {
                                return i[e].abbr;
                            }
                            if (i[e].until <= n && n <= i[e].since) {
                                return i[e].abbr;
                            }
                        }
                        return '';
                    }

                    function Oa() {
                        var e,
                            t,
                            n,
                            i,
                            o = this.localeData().eras();
                        for (e = 0, t = o.length; e < t; ++e) {
                            n = o[e].since <= o[e].until ? 1 : -1;
                            i = this.clone().startOf('day').valueOf();
                            if ((o[e].since <= i && i <= o[e].until) || (o[e].until <= i && i <= o[e].since)) {
                                return (this.year() - a(o[e].since).year()) * n + o[e].offset;
                            }
                        }
                        return this.year();
                    }

                    function Ya(e) {
                        if (!c(this, '_erasNameRegex')) {
                            Ua.call(this);
                        }
                        return e ? this._erasNameRegex : this._erasRegex;
                    }

                    function Ba(e) {
                        if (!c(this, '_erasAbbrRegex')) {
                            Ua.call(this);
                        }
                        return e ? this._erasAbbrRegex : this._erasRegex;
                    }

                    function Na(e) {
                        if (!c(this, '_erasNarrowRegex')) {
                            Ua.call(this);
                        }
                        return e ? this._erasNarrowRegex : this._erasRegex;
                    }

                    function qa(e, t) {
                        return t.erasAbbrRegex(e);
                    }

                    function Ha(e, t) {
                        return t.erasNameRegex(e);
                    }

                    function ja(e, t) {
                        return t.erasNarrowRegex(e);
                    }

                    function Fa(e, t) {
                        return t._eraYearOrdinalRegex || ke;
                    }

                    function Ua() {
                        var e,
                            t,
                            n = [],
                            i = [],
                            a = [],
                            o = [],
                            r = this.eras();
                        for (e = 0, t = r.length; e < t; ++e) {
                            i.push(Ne(r[e].name));
                            n.push(Ne(r[e].abbr));
                            a.push(Ne(r[e].narrow));
                            o.push(Ne(r[e].name));
                            o.push(Ne(r[e].abbr));
                            o.push(Ne(r[e].narrow));
                        }
                        this._erasRegex = new RegExp('^(' + o.join('|') + ')', 'i');
                        this._erasNameRegex = new RegExp('^(' + i.join('|') + ')', 'i');
                        this._erasAbbrRegex = new RegExp('^(' + n.join('|') + ')', 'i');
                        this._erasNarrowRegex = new RegExp('^(' + a.join('|') + ')', 'i');
                    }

                    j(0, ['gg', 2], 0, function () {
                        return this.weekYear() % 100;
                    });
                    j(0, ['GG', 2], 0, function () {
                        return this.isoWeekYear() % 100;
                    });

                    function Va(e, t) {
                        j(0, [e, e.length], 0, t);
                    }

                    Va('gggg', 'weekYear');
                    Va('ggggg', 'weekYear');
                    Va('GGGG', 'isoWeekYear');
                    Va('GGGGG', 'isoWeekYear');
                    ie('weekYear', 'gg');
                    ie('isoWeekYear', 'GG');
                    se('weekYear', 1);
                    se('isoWeekYear', 1);
                    Oe('G', Ie);
                    Oe('g', Ie);
                    Oe('GG', be, _e);
                    Oe('gg', be, _e);
                    Oe('GGGG', Me, Ce);
                    Oe('gggg', Me, Ce);
                    Oe('GGGGG', Te, Se);
                    Oe('ggggg', Te, Se);
                    je(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (e, t, n, i) {
                        t[i.substr(0, 2)] = de(e);
                    });
                    je(['gg', 'GG'], function (e, t, n, i) {
                        t[i] = a.parseTwoDigitYear(e);
                    });

                    function Qa(e) {
                        return $a.call(
                            this,
                            e,
                            this.week(),
                            this.weekday(),
                            this.localeData()._week.dow,
                            this.localeData()._week.doy,
                        );
                    }

                    function Ga(e) {
                        return $a.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
                    }

                    function za() {
                        return vt(this.year(), 1, 4);
                    }

                    function Wa() {
                        return vt(this.isoWeekYear(), 1, 4);
                    }

                    function Ka() {
                        var e = this.localeData()._week;
                        return vt(this.year(), e.dow, e.doy);
                    }

                    function Ja() {
                        var e = this.localeData()._week;
                        return vt(this.weekYear(), e.dow, e.doy);
                    }

                    function $a(e, t, n, i, a) {
                        var o;
                        if (null == e) {
                            return bt(this, i, a).year;
                        } else {
                            if (t > (o = vt(e, i, a))) {
                                t = o;
                            }
                            return Xa.call(this, e, t, n, i, a);
                        }
                    }

                    function Xa(e, t, n, i, a) {
                        var o = St(e, t, n, i, a),
                            r = Et(o.year, 0, o.dayOfYear);
                        this.year(r.getUTCFullYear());
                        this.month(r.getUTCMonth());
                        this.date(r.getUTCDate());
                        return this;
                    }

                    j('Q', 0, 'Qo', 'quarter');
                    ie('quarter', 'Q');
                    se('quarter', 7);
                    Oe('Q', xe);
                    He('Q', function (e, t) {
                        t[Qe] = 3 * (de(e) - 1);
                    });

                    function Za(e) {
                        return null == e
                            ? Math.ceil((this.month() + 1) / 3)
                            : this.month(3 * (e - 1) + (this.month() % 3));
                    }

                    j('D', ['DD', 2], 'Do', 'date');
                    ie('date', 'D');
                    se('date', 9);
                    Oe('D', be);
                    Oe('DD', be, _e);
                    Oe('Do', function (e, t) {
                        return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
                    });
                    He(['D', 'DD'], Ge);
                    He('Do', function (e, t) {
                        t[Ge] = de(e.match(be)[0]);
                    });
                    var eo = me('Date', !0);
                    j('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
                    ie('dayOfYear', 'DDD');
                    se('dayOfYear', 4);
                    Oe('DDD', Re);
                    Oe('DDDD', Ee);
                    He(['DDD', 'DDDD'], function (e, t, n) {
                        n._dayOfYear = de(e);
                    });

                    function to(e) {
                        var t = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
                        return null == e ? t : this.add(e - t, 'd');
                    }

                    j('m', ['mm', 2], 0, 'minute');
                    ie('minute', 'm');
                    se('minute', 14);
                    Oe('m', be);
                    Oe('mm', be, _e);
                    He(['m', 'mm'], We);
                    var no = me('Minutes', !1);
                    j('s', ['ss', 2], 0, 'second');
                    ie('second', 's');
                    se('second', 15);
                    Oe('s', be);
                    Oe('ss', be, _e);
                    He(['s', 'ss'], Ke);
                    var io,
                        ao,
                        oo = me('Seconds', !1);
                    j('S', 0, 0, function () {
                        return ~~(this.millisecond() / 100);
                    });
                    j(0, ['SS', 2], 0, function () {
                        return ~~(this.millisecond() / 10);
                    });
                    j(0, ['SSS', 3], 0, 'millisecond');
                    j(0, ['SSSS', 4], 0, function () {
                        return 10 * this.millisecond();
                    });
                    j(0, ['SSSSS', 5], 0, function () {
                        return 100 * this.millisecond();
                    });
                    j(0, ['SSSSSS', 6], 0, function () {
                        return 1e3 * this.millisecond();
                    });
                    j(0, ['SSSSSSS', 7], 0, function () {
                        return 1e4 * this.millisecond();
                    });
                    j(0, ['SSSSSSSS', 8], 0, function () {
                        return 1e5 * this.millisecond();
                    });
                    j(0, ['SSSSSSSSS', 9], 0, function () {
                        return 1e6 * this.millisecond();
                    });
                    ie('millisecond', 'ms');
                    se('millisecond', 16);
                    Oe('S', Re, xe);
                    Oe('SS', Re, _e);
                    Oe('SSS', Re, Ee);
                    for (io = 'SSSS'; io.length <= 9; io += 'S') {
                        Oe(io, ke);
                    }

                    function ro(e, t) {
                        t[Je] = de(1e3 * ('0.' + e));
                    }

                    for (io = 'S'; io.length <= 9; io += 'S') {
                        He(io, ro);
                    }
                    ao = me('Milliseconds', !1);
                    j('z', 0, 0, 'zoneAbbr');
                    j('zz', 0, 0, 'zoneName');

                    function so() {
                        return this._isUTC ? 'UTC' : '';
                    }

                    function co() {
                        return this._isUTC ? 'Coordinated Universal Time' : '';
                    }

                    var lo = b.prototype;
                    lo.add = Oi;
                    lo.calendar = Ui;
                    lo.clone = Vi;
                    lo.diff = $i;
                    lo.endOf = xa;
                    lo.format = na;
                    lo.from = ia;
                    lo.fromNow = aa;
                    lo.to = oa;
                    lo.toNow = ra;
                    lo.get = ge;
                    lo.invalidAt = Ma;
                    lo.isAfter = Qi;
                    lo.isBefore = Gi;
                    lo.isBetween = zi;
                    lo.isSame = Wi;
                    lo.isSameOrAfter = Ki;
                    lo.isSameOrBefore = Ji;
                    lo.isValid = Da;
                    lo.lang = ca;
                    lo.locale = sa;
                    lo.localeData = la;
                    lo.max = Xn;
                    lo.min = $n;
                    lo.parsingFlags = Ra;
                    lo.set = he;
                    lo.startOf = ya;
                    lo.subtract = Yi;
                    lo.toArray = Sa;
                    lo.toObject = ba;
                    lo.toDate = Ca;
                    lo.toISOString = ea;
                    lo.inspect = ta;
                    if ('undefined' != typeof Symbol && null != Symbol.for) {
                        lo[Symbol.for('nodejs.util.inspect.custom')] = function () {
                            return 'Moment<' + this.format() + '>';
                        };
                    }
                    lo.toJSON = va;
                    lo.toString = Zi;
                    lo.unix = Ea;
                    lo.valueOf = _a;
                    lo.creationData = Ta;
                    lo.eraName = La;
                    lo.eraNarrow = Aa;
                    lo.eraAbbr = wa;
                    lo.eraYear = Oa;
                    lo.year = yt;
                    lo.isLeapYear = xt;
                    lo.weekYear = Qa;
                    lo.isoWeekYear = Ga;
                    lo.quarter = lo.quarters = Za;
                    lo.month = dt;
                    lo.daysInMonth = mt;
                    lo.week = lo.weeks = kt;
                    lo.isoWeek = lo.isoWeeks = It;
                    lo.weeksInYear = Ka;
                    lo.weeksInWeekYear = Ja;
                    lo.isoWeeksInYear = za;
                    lo.isoWeeksInISOWeekYear = Wa;
                    lo.date = eo;
                    lo.day = lo.days = Qt;
                    lo.weekday = Gt;
                    lo.isoWeekday = zt;
                    lo.dayOfYear = to;
                    lo.hour = lo.hours = on;
                    lo.minute = lo.minutes = no;
                    lo.second = lo.seconds = oo;
                    lo.millisecond = lo.milliseconds = ao;
                    lo.utcOffset = hi;
                    lo.utc = xi;
                    lo.local = _i;
                    lo.parseZone = Ei;
                    lo.hasAlignedHourOffset = Ci;
                    lo.isDST = Si;
                    lo.isLocal = vi;
                    lo.isUtcOffset = Di;
                    lo.isUtc = Ri;
                    lo.isUTC = Ri;
                    lo.zoneAbbr = so;
                    lo.zoneName = co;
                    lo.dates = R('dates accessor is deprecated. Use date instead.', eo);
                    lo.months = R('months accessor is deprecated. Use month instead', dt);
                    lo.years = R('years accessor is deprecated. Use year instead', yt);
                    lo.zone = R(
                        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
                        yi,
                    );
                    lo.isDSTShifted = R(
                        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
                        bi,
                    );

                    function uo(e) {
                        return Jn(1e3 * e);
                    }

                    function mo() {
                        return Jn.apply(null, arguments).parseZone();
                    }

                    function po(e) {
                        return e;
                    }

                    var fo = A.prototype;
                    fo.calendar = O;
                    fo.longDateFormat = z;
                    fo.invalidDate = K;
                    fo.ordinal = X;
                    fo.preparse = po;
                    fo.postformat = po;
                    fo.relativeTime = ee;
                    fo.pastFuture = te;
                    fo.set = P;
                    fo.eras = ka;
                    fo.erasParse = Ia;
                    fo.erasConvertYear = Pa;
                    fo.erasAbbrRegex = Ba;
                    fo.erasNameRegex = Ya;
                    fo.erasNarrowRegex = Na;
                    fo.months = rt;
                    fo.monthsShort = st;
                    fo.monthsParse = lt;
                    fo.monthsRegex = ft;
                    fo.monthsShortRegex = pt;
                    fo.week = Dt;
                    fo.firstDayOfYear = Tt;
                    fo.firstDayOfWeek = Mt;
                    fo.weekdays = Ht;
                    fo.weekdaysMin = Ft;
                    fo.weekdaysShort = jt;
                    fo.weekdaysParse = Vt;
                    fo.weekdaysRegex = Wt;
                    fo.weekdaysShortRegex = Kt;
                    fo.weekdaysMinRegex = Jt;
                    fo.isPM = nn;
                    fo.meridiem = rn;

                    function go(e, t, n, i) {
                        var a = _n(),
                            o = g().set(i, t);
                        return a[n](o, e);
                    }

                    function ho(e, t, n) {
                        if (d(e)) {
                            t = e;
                            e = void 0;
                        }
                        e = e || '';
                        if (null != t) {
                            return go(e, t, n, 'month');
                        }
                        var i,
                            a = [];
                        for (i = 0; i < 12; i++) {
                            a[i] = go(e, i, n, 'month');
                        }
                        return a;
                    }

                    function yo(e, t, n, i) {
                        if ('boolean' == typeof e) {
                            if (d(t)) {
                                n = t;
                                t = void 0;
                            }
                            t = t || '';
                        } else {
                            n = t = e;
                            e = !1;
                            if (d(t)) {
                                n = t;
                                t = void 0;
                            }
                            t = t || '';
                        }
                        var a,
                            o = _n(),
                            r = e ? o._week.dow : 0,
                            s = [];
                        if (null != n) {
                            return go(t, (n + r) % 7, i, 'day');
                        }
                        for (a = 0; a < 7; a++) {
                            s[a] = go(t, (a + r) % 7, i, 'day');
                        }
                        return s;
                    }

                    function xo(e, t) {
                        return ho(e, t, 'months');
                    }

                    function _o(e, t) {
                        return ho(e, t, 'monthsShort');
                    }

                    function Eo(e, t, n) {
                        return yo(e, t, n, 'weekdays');
                    }

                    function Co(e, t, n) {
                        return yo(e, t, n, 'weekdaysShort');
                    }

                    function So(e, t, n) {
                        return yo(e, t, n, 'weekdaysMin');
                    }

                    hn('en', {
                        eras: [
                            {
                                since: '0001-01-01',
                                until: 1 / 0,
                                offset: 1,
                                name: 'Anno Domini',
                                narrow: 'AD',
                                abbr: 'AD',
                            },
                            {
                                since: '0000-12-31',
                                until: -1 / 0,
                                offset: 1,
                                name: 'Before Christ',
                                narrow: 'BC',
                                abbr: 'BC',
                            },
                        ],
                        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
                        ordinal: function (e) {
                            var t = e % 10;
                            return (
                                e +
                                (1 === de((e % 100) / 10)
                                    ? 'th'
                                    : 1 === t
                                    ? 'st'
                                    : 2 === t
                                    ? 'nd'
                                    : 3 === t
                                    ? 'rd'
                                    : 'th')
                            );
                        },
                    });
                    a.lang = R('moment.lang is deprecated. Use moment.locale instead.', hn);
                    a.langData = R('moment.langData is deprecated. Use moment.localeData instead.', _n);
                    var bo = Math.abs;

                    function vo() {
                        var e = this._data;
                        this._milliseconds = bo(this._milliseconds);
                        this._days = bo(this._days);
                        this._months = bo(this._months);
                        e.milliseconds = bo(e.milliseconds);
                        e.seconds = bo(e.seconds);
                        e.minutes = bo(e.minutes);
                        e.hours = bo(e.hours);
                        e.months = bo(e.months);
                        e.years = bo(e.years);
                        return this;
                    }

                    function Do(e, t, n, i) {
                        var a = ki(t, n);
                        e._milliseconds += i * a._milliseconds;
                        e._days += i * a._days;
                        e._months += i * a._months;
                        return e._bubble();
                    }

                    function Ro(e, t) {
                        return Do(this, e, t, 1);
                    }

                    function Mo(e, t) {
                        return Do(this, e, t, -1);
                    }

                    function To(e) {
                        if (e < 0) {
                            return Math.floor(e);
                        } else {
                            return Math.ceil(e);
                        }
                    }

                    function ko() {
                        var e,
                            t,
                            n,
                            i,
                            a,
                            o = this._milliseconds,
                            r = this._days,
                            s = this._months,
                            c = this._data;
                        if (!((o >= 0 && r >= 0 && s >= 0) || (o <= 0 && r <= 0 && s <= 0))) {
                            o += 864e5 * To(Po(s) + r);
                            r = 0;
                            s = 0;
                        }
                        c.milliseconds = o % 1e3;
                        e = ue(o / 1e3);
                        c.seconds = e % 60;
                        t = ue(e / 60);
                        c.minutes = t % 60;
                        n = ue(t / 60);
                        c.hours = n % 24;
                        r += ue(n / 24);
                        s += a = ue(Io(r));
                        r -= To(Po(a));
                        i = ue(s / 12);
                        s %= 12;
                        c.days = r;
                        c.months = s;
                        c.years = i;
                        return this;
                    }

                    function Io(e) {
                        return (4800 * e) / 146097;
                    }

                    function Po(e) {
                        return (146097 * e) / 4800;
                    }

                    function Lo(e) {
                        if (!this.isValid()) {
                            return NaN;
                        }
                        var t,
                            n,
                            i = this._milliseconds;
                        if ('month' === (e = ae(e)) || 'quarter' === e || 'year' === e) {
                            t = this._days + i / 864e5;
                            n = this._months + Io(t);
                            switch (e) {
                                case 'month':
                                    return n;
                                case 'quarter':
                                    return n / 3;
                                case 'year':
                                    return n / 12;
                            }
                        } else {
                            t = this._days + Math.round(Po(this._months));
                            switch (e) {
                                case 'week':
                                    return t / 7 + i / 6048e5;
                                case 'day':
                                    return t + i / 864e5;
                                case 'hour':
                                    return 24 * t + i / 36e5;
                                case 'minute':
                                    return 1440 * t + i / 6e4;
                                case 'second':
                                    return 86400 * t + i / 1e3;
                                case 'millisecond':
                                    return Math.floor(864e5 * t) + i;
                                default:
                                    throw new Error('Unknown unit ' + e);
                            }
                        }
                    }

                    function Ao() {
                        if (!this.isValid()) {
                            return NaN;
                        } else {
                            return (
                                this._milliseconds +
                                864e5 * this._days +
                                (this._months % 12) * 2592e6 +
                                31536e6 * de(this._months / 12)
                            );
                        }
                    }

                    function wo(e) {
                        return function () {
                            return this.as(e);
                        };
                    }

                    var Oo = wo('ms'),
                        Yo = wo('s'),
                        Bo = wo('m'),
                        No = wo('h'),
                        qo = wo('d'),
                        Ho = wo('w'),
                        jo = wo('M'),
                        Fo = wo('Q'),
                        Uo = wo('y');

                    function Vo() {
                        return ki(this);
                    }

                    function Qo(e) {
                        e = ae(e);
                        return this.isValid() ? this[e + 's']() : NaN;
                    }

                    function Go(e) {
                        return function () {
                            return this.isValid() ? this._data[e] : NaN;
                        };
                    }

                    var zo = Go('milliseconds'),
                        Wo = Go('seconds'),
                        Ko = Go('minutes'),
                        Jo = Go('hours'),
                        $o = Go('days'),
                        Xo = Go('months'),
                        Zo = Go('years');

                    function er() {
                        return ue(this.days() / 7);
                    }

                    var tr = Math.round,
                        nr = { ss: 44, s: 45, m: 45, h: 22, d: 26, w: null, M: 11 };

                    function ir(e, t, n, i, a) {
                        return a.relativeTime(t || 1, !!n, e, i);
                    }

                    function ar(e, t, n, i) {
                        var a = ki(e).abs(),
                            o = tr(a.as('s')),
                            r = tr(a.as('m')),
                            s = tr(a.as('h')),
                            c = tr(a.as('d')),
                            l = tr(a.as('M')),
                            u = tr(a.as('w')),
                            d = tr(a.as('y')),
                            m =
                                (o <= n.ss && ['s', o]) ||
                                (o < n.s && ['ss', o]) ||
                                (r <= 1 && ['m']) ||
                                (r < n.m && ['mm', r]) ||
                                (s <= 1 && ['h']) ||
                                (s < n.h && ['hh', s]) ||
                                (c <= 1 && ['d']) ||
                                (c < n.d && ['dd', c]);
                        if (null != n.w) {
                            m = m || (u <= 1 && ['w']) || (u < n.w && ['ww', u]);
                        }
                        (m = m || (l <= 1 && ['M']) || (l < n.M && ['MM', l]) || (d <= 1 && ['y']) || ['yy', d])[2] = t;
                        m[3] = +e > 0;
                        m[4] = i;
                        return ir.apply(null, m);
                    }

                    function or(e) {
                        if (void 0 === e) {
                            return tr;
                        }
                        if ('function' == typeof e) {
                            tr = e;
                            return !0;
                        }
                        return !1;
                    }

                    function rr(e, t) {
                        if (void 0 === nr[e]) {
                            return !1;
                        }
                        if (void 0 === t) {
                            return nr[e];
                        }
                        nr[e] = t;
                        if ('s' === e) {
                            nr.ss = t - 1;
                        }
                        return !0;
                    }

                    function sr(e, t) {
                        if (!this.isValid()) {
                            return this.localeData().invalidDate();
                        }
                        var n,
                            i,
                            a = !1,
                            o = nr;
                        if ('object' == typeof e) {
                            t = e;
                            e = !1;
                        }
                        if ('boolean' == typeof e) {
                            a = e;
                        }
                        if ('object' == typeof t) {
                            o = Object.assign({}, nr, t);
                            if (null != t.s && null == t.ss) {
                                o.ss = t.s - 1;
                            }
                        }
                        i = ar(this, !a, o, (n = this.localeData()));
                        if (a) {
                            i = n.pastFuture(+this, i);
                        }
                        return n.postformat(i);
                    }

                    var cr = Math.abs;

                    function lr(e) {
                        return (e > 0) - (e < 0) || +e;
                    }

                    function ur() {
                        if (!this.isValid()) {
                            return this.localeData().invalidDate();
                        }
                        var e,
                            t,
                            n,
                            i,
                            a,
                            o,
                            r,
                            s,
                            c = cr(this._milliseconds) / 1e3,
                            l = cr(this._days),
                            u = cr(this._months),
                            d = this.asSeconds();
                        if (!d) {
                            return 'P0D';
                        }
                        e = ue(c / 60);
                        t = ue(e / 60);
                        c %= 60;
                        e %= 60;
                        n = ue(u / 12);
                        u %= 12;
                        i = c ? c.toFixed(3).replace(/\.?0+$/, '') : '';
                        a = d < 0 ? '-' : '';
                        o = lr(this._months) !== lr(d) ? '-' : '';
                        r = lr(this._days) !== lr(d) ? '-' : '';
                        s = lr(this._milliseconds) !== lr(d) ? '-' : '';
                        return (
                            a +
                            'P' +
                            (n ? o + n + 'Y' : '') +
                            (u ? o + u + 'M' : '') +
                            (l ? r + l + 'D' : '') +
                            (t || e || c ? 'T' : '') +
                            (t ? s + t + 'H' : '') +
                            (e ? s + e + 'M' : '') +
                            (c ? s + i + 'S' : '')
                        );
                    }

                    var dr = si.prototype;
                    dr.isValid = oi;
                    dr.abs = vo;
                    dr.add = Ro;
                    dr.subtract = Mo;
                    dr.as = Lo;
                    dr.asMilliseconds = Oo;
                    dr.asSeconds = Yo;
                    dr.asMinutes = Bo;
                    dr.asHours = No;
                    dr.asDays = qo;
                    dr.asWeeks = Ho;
                    dr.asMonths = jo;
                    dr.asQuarters = Fo;
                    dr.asYears = Uo;
                    dr.valueOf = Ao;
                    dr._bubble = ko;
                    dr.clone = Vo;
                    dr.get = Qo;
                    dr.milliseconds = zo;
                    dr.seconds = Wo;
                    dr.minutes = Ko;
                    dr.hours = Jo;
                    dr.days = $o;
                    dr.weeks = er;
                    dr.months = Xo;
                    dr.years = Zo;
                    dr.humanize = sr;
                    dr.toISOString = ur;
                    dr.toString = ur;
                    dr.toJSON = ur;
                    dr.locale = sa;
                    dr.localeData = la;
                    dr.toIsoString = R(
                        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
                        ur,
                    );
                    dr.lang = ca;
                    j('X', 0, 0, 'unix');
                    j('x', 0, 0, 'valueOf');
                    Oe('x', Ie);
                    Oe('X', Ae);
                    He('X', function (e, t, n) {
                        n._d = new Date(1e3 * parseFloat(e));
                    });
                    He('x', function (e, t, n) {
                        n._d = new Date(de(e));
                    });
                    a.version = '2.29.4';
                    o(Jn);
                    a.fn = lo;
                    a.min = ei;
                    a.max = ti;
                    a.now = ni;
                    a.utc = g;
                    a.unix = uo;
                    a.months = xo;
                    a.isDate = m;
                    a.locale = hn;
                    a.invalid = _;
                    a.duration = ki;
                    a.isMoment = v;
                    a.weekdays = Eo;
                    a.parseZone = mo;
                    a.localeData = _n;
                    a.isDuration = ci;
                    a.monthsShort = _o;
                    a.weekdaysMin = So;
                    a.defineLocale = yn;
                    a.updateLocale = xn;
                    a.locales = En;
                    a.weekdaysShort = Co;
                    a.normalizeUnits = ae;
                    a.relativeTimeRounding = or;
                    a.relativeTimeThreshold = rr;
                    a.calendarFormat = Fi;
                    a.prototype = lo;
                    a.HTML5_FMT = {
                        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
                        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
                        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
                        DATE: 'YYYY-MM-DD',
                        TIME: 'HH:mm',
                        TIME_SECONDS: 'HH:mm:ss',
                        TIME_MS: 'HH:mm:ss.SSS',
                        WEEK: 'GGGG-[W]WW',
                        MONTH: 'YYYY-MM',
                    };
                    return a;
                })();
            },
            6410: function (e, t, n) {
                var i = 'function' == typeof Map && Map.prototype,
                    a =
                        Object.getOwnPropertyDescriptor && i
                            ? Object.getOwnPropertyDescriptor(Map.prototype, 'size')
                            : null,
                    o = i && a && 'function' == typeof a.get ? a.get : null,
                    r = i && Map.prototype.forEach,
                    s = 'function' == typeof Set && Set.prototype,
                    c =
                        Object.getOwnPropertyDescriptor && s
                            ? Object.getOwnPropertyDescriptor(Set.prototype, 'size')
                            : null,
                    l = s && c && 'function' == typeof c.get ? c.get : null,
                    u = s && Set.prototype.forEach,
                    d = 'function' == typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null,
                    m = 'function' == typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null,
                    p = 'function' == typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null,
                    f = Boolean.prototype.valueOf,
                    g = Object.prototype.toString,
                    h = Function.prototype.toString,
                    y = String.prototype.match,
                    x = String.prototype.slice,
                    _ = String.prototype.replace,
                    E = String.prototype.toUpperCase,
                    C = String.prototype.toLowerCase,
                    S = RegExp.prototype.test,
                    b = Array.prototype.concat,
                    v = Array.prototype.join,
                    D = Array.prototype.slice,
                    R = Math.floor,
                    M = 'function' == typeof BigInt ? BigInt.prototype.valueOf : null,
                    T = Object.getOwnPropertySymbols,
                    k =
                        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                            ? Symbol.prototype.toString
                            : null,
                    I = 'function' == typeof Symbol && 'object' == typeof Symbol.iterator,
                    P =
                        'function' == typeof Symbol &&
                        Symbol.toStringTag &&
                        (typeof Symbol.toStringTag === I ? 'object' : 'symbol')
                            ? Symbol.toStringTag
                            : null,
                    L = Object.prototype.propertyIsEnumerable,
                    A =
                        ('function' == typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) ||
                        ([].__proto__ === Array.prototype
                            ? function (e) {
                                  return e.__proto__;
                              }
                            : null);

                function w(e, t) {
                    if (e === 1 / 0 || e === -1 / 0 || e != e || (e && e > -1e3 && e < 1e3) || S.call(/e/, t)) {
                        return t;
                    }
                    var n = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
                    if ('number' == typeof e) {
                        var i = e < 0 ? -R(-e) : R(e);
                        if (i !== e) {
                            var a = String(i),
                                o = x.call(t, a.length + 1);
                            return _.call(a, n, '$&_') + '.' + _.call(_.call(o, /([0-9]{3})/g, '$&_'), /_$/, '');
                        }
                    }
                    return _.call(t, n, '$&_');
                }

                var O = n(2634),
                    Y = O.custom,
                    B = F(Y) ? Y : null;
                e.exports = function e(t, i, a, s) {
                    var c = i || {};
                    if (V(c, 'quoteStyle') && 'single' !== c.quoteStyle && 'double' !== c.quoteStyle) {
                        throw new TypeError('option "quoteStyle" must be "single" or "double"');
                    }
                    if (
                        V(c, 'maxStringLength') &&
                        ('number' == typeof c.maxStringLength
                            ? c.maxStringLength < 0 && c.maxStringLength !== 1 / 0
                            : null !== c.maxStringLength)
                    ) {
                        throw new TypeError(
                            'option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`',
                        );
                    }
                    var g = V(c, 'customInspect') ? c.customInspect : !0;
                    if ('boolean' != typeof g && 'symbol' !== g) {
                        throw new TypeError(
                            'option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`',
                        );
                    }
                    if (
                        V(c, 'indent') &&
                        null !== c.indent &&
                        '\t' !== c.indent &&
                        !(parseInt(c.indent, 10) === c.indent && c.indent > 0)
                    ) {
                        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
                    }
                    if (V(c, 'numericSeparator') && 'boolean' != typeof c.numericSeparator) {
                        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
                    }
                    var E = c.numericSeparator;
                    if (void 0 === t) {
                        return 'undefined';
                    }
                    if (null === t) {
                        return 'null';
                    }
                    if ('boolean' == typeof t) {
                        return t ? 'true' : 'false';
                    }
                    if ('string' == typeof t) {
                        return z(t, c);
                    }
                    if ('number' == typeof t) {
                        if (0 === t) {
                            return 1 / 0 / t > 0 ? '0' : '-0';
                        }
                        var S = String(t);
                        return E ? w(t, S) : S;
                    }
                    if ('bigint' == typeof t) {
                        var R = String(t) + 'n';
                        return E ? w(t, R) : R;
                    }
                    var T = void 0 === c.depth ? 5 : c.depth;
                    if (void 0 === a) {
                        a = 0;
                    }
                    if (a >= T && T > 0 && 'object' == typeof t) {
                        return H(t) ? '[Array]' : '[Object]';
                    }
                    var Y = (function (e, t) {
                        var n;
                        if ('\t' === e.indent) {
                            n = '\t';
                        } else if ('number' == typeof e.indent && e.indent > 0) {
                            n = v.call(Array(e.indent + 1), ' ');
                        } else {
                            return null;
                        }
                        return { base: n, prev: v.call(Array(t + 1), n) };
                    })(c, a);
                    if (void 0 === s) {
                        s = [];
                    } else if (G(s, t) >= 0) {
                        return '[Circular]';
                    }

                    function U(t, n, i) {
                        if (n) {
                            (s = D.call(s)).push(n);
                        }
                        if (i) {
                            var o = { depth: c.depth };
                            if (V(c, 'quoteStyle')) {
                                o.quoteStyle = c.quoteStyle;
                            }
                            return e(t, o, a + 1, s);
                        }
                        return e(t, c, a + 1, s);
                    }

                    if ('function' == typeof t && !j(t)) {
                        var W = (function (e) {
                                if (e.name) {
                                    return e.name;
                                }
                                var t = y.call(h.call(e), /^function\s*([\w$]+)/);
                                if (t) {
                                    return t[1];
                                }
                                return null;
                            })(t),
                            ee = Z(t, U);
                        return (
                            '[Function' +
                            (W ? ': ' + W : ' (anonymous)') +
                            ']' +
                            (ee.length > 0 ? ' { ' + v.call(ee, ', ') + ' }' : '')
                        );
                    }
                    if (F(t)) {
                        var te = I ? _.call(String(t), /^(Symbol\(.*\))_[^)]*$/, '$1') : k.call(t);
                        return 'object' == typeof t && !I ? K(te) : te;
                    }
                    if (
                        (function (e) {
                            if (!e || 'object' != typeof e) {
                                return !1;
                            }
                            if ('undefined' != typeof HTMLElement && e instanceof HTMLElement) {
                                return !0;
                            }
                            return 'string' == typeof e.nodeName && 'function' == typeof e.getAttribute;
                        })(t)
                    ) {
                        for (
                            var ne = '<' + C.call(String(t.nodeName)), ie = t.attributes || [], ae = 0;
                            ae < ie.length;
                            ae++
                        ) {
                            ne += ' ' + ie[ae].name + '=' + N(q(ie[ae].value), 'double', c);
                        }
                        ne += '>';
                        if (t.childNodes && t.childNodes.length) {
                            ne += '...';
                        }
                        return (ne += '</' + C.call(String(t.nodeName)) + '>');
                    }
                    if (H(t)) {
                        if (0 === t.length) {
                            return '[]';
                        }
                        var oe = Z(t, U);
                        if (
                            Y &&
                            !(function (e) {
                                for (var t = 0; t < e.length; t++) {
                                    if (G(e[t], '\n') >= 0) {
                                        return !1;
                                    }
                                }
                                return !0;
                            })(oe)
                        ) {
                            return '[' + X(oe, Y) + ']';
                        } else {
                            return '[ ' + v.call(oe, ', ') + ' ]';
                        }
                    }
                    if (
                        (function (e) {
                            return !('[object Error]' !== Q(e) || (P && 'object' == typeof e && P in e));
                        })(t)
                    ) {
                        var re = Z(t, U);
                        if (!('cause' in Error.prototype) && 'cause' in t && !L.call(t, 'cause')) {
                            return '{ [' + String(t) + '] ' + v.call(b.call('[cause]: ' + U(t.cause), re), ', ') + ' }';
                        }
                        if (0 === re.length) {
                            return '[' + String(t) + ']';
                        } else {
                            return '{ [' + String(t) + '] ' + v.call(re, ', ') + ' }';
                        }
                    }
                    if ('object' == typeof t && g) {
                        if (B && 'function' == typeof t[B] && O) {
                            return O(t, { depth: T - a });
                        } else if ('symbol' !== g && 'function' == typeof t.inspect) {
                            return t.inspect();
                        }
                    }
                    if (
                        (function (e) {
                            if (!o || !e || 'object' != typeof e) {
                                return !1;
                            }
                            try {
                                o.call(e);
                                try {
                                    l.call(e);
                                } catch (e) {
                                    return !0;
                                }
                                return e instanceof Map;
                            } catch (e) {}
                            return !1;
                        })(t)
                    ) {
                        var se = [];
                        if (r) {
                            r.call(t, function (e, n) {
                                se.push(U(n, t, !0) + ' => ' + U(e, t));
                            });
                        }
                        return $('Map', o.call(t), se, Y);
                    }
                    if (
                        (function (e) {
                            if (!l || !e || 'object' != typeof e) {
                                return !1;
                            }
                            try {
                                l.call(e);
                                try {
                                    o.call(e);
                                } catch (e) {
                                    return !0;
                                }
                                return e instanceof Set;
                            } catch (e) {}
                            return !1;
                        })(t)
                    ) {
                        var ce = [];
                        if (u) {
                            u.call(t, function (e) {
                                ce.push(U(e, t));
                            });
                        }
                        return $('Set', l.call(t), ce, Y);
                    }
                    if (
                        (function (e) {
                            if (!d || !e || 'object' != typeof e) {
                                return !1;
                            }
                            try {
                                d.call(e, d);
                                try {
                                    m.call(e, m);
                                } catch (e) {
                                    return !0;
                                }
                                return e instanceof WeakMap;
                            } catch (e) {}
                            return !1;
                        })(t)
                    ) {
                        return J('WeakMap');
                    }
                    if (
                        (function (e) {
                            if (!m || !e || 'object' != typeof e) {
                                return !1;
                            }
                            try {
                                m.call(e, m);
                                try {
                                    d.call(e, d);
                                } catch (e) {
                                    return !0;
                                }
                                return e instanceof WeakSet;
                            } catch (e) {}
                            return !1;
                        })(t)
                    ) {
                        return J('WeakSet');
                    }
                    if (
                        (function (e) {
                            if (!p || !e || 'object' != typeof e) {
                                return !1;
                            }
                            try {
                                p.call(e);
                                return !0;
                            } catch (e) {}
                            return !1;
                        })(t)
                    ) {
                        return J('WeakRef');
                    }
                    if (
                        (function (e) {
                            return !('[object Number]' !== Q(e) || (P && 'object' == typeof e && P in e));
                        })(t)
                    ) {
                        return K(U(Number(t)));
                    }
                    if (
                        (function (e) {
                            if (!e || 'object' != typeof e || !M) {
                                return !1;
                            }
                            try {
                                M.call(e);
                                return !0;
                            } catch (e) {}
                            return !1;
                        })(t)
                    ) {
                        return K(U(M.call(t)));
                    }
                    if (
                        (function (e) {
                            return !('[object Boolean]' !== Q(e) || (P && 'object' == typeof e && P in e));
                        })(t)
                    ) {
                        return K(f.call(t));
                    }
                    if (
                        (function (e) {
                            return !('[object String]' !== Q(e) || (P && 'object' == typeof e && P in e));
                        })(t)
                    ) {
                        return K(U(String(t)));
                    }
                    if ('undefined' != typeof window && t === window) {
                        return '{ [object Window] }';
                    }
                    if (t === n.g) {
                        return '{ [object globalThis] }';
                    }
                    if (
                        !(function (e) {
                            return !('[object Date]' !== Q(e) || (P && 'object' == typeof e && P in e));
                        })(t) &&
                        !j(t)
                    ) {
                        var le = Z(t, U),
                            ue = A ? A(t) === Object.prototype : t instanceof Object || t.constructor === Object,
                            de = t instanceof Object ? '' : 'null prototype',
                            me = !ue && P && Object(t) === t && P in t ? x.call(Q(t), 8, -1) : de ? 'Object' : '',
                            pe =
                                (ue || 'function' != typeof t.constructor
                                    ? ''
                                    : t.constructor.name
                                    ? t.constructor.name + ' '
                                    : '') + (me || de ? '[' + v.call(b.call([], me || [], de || []), ': ') + '] ' : '');
                        if (0 === le.length) {
                            return pe + '{}';
                        }
                        if (Y) {
                            return pe + '{' + X(le, Y) + '}';
                        } else {
                            return pe + '{ ' + v.call(le, ', ') + ' }';
                        }
                    }
                    return String(t);
                };

                function N(e, t, n) {
                    var i = 'double' === (n.quoteStyle || t) ? '"' : "'";
                    return i + e + i;
                }

                function q(e) {
                    return _.call(String(e), /"/g, '&quot;');
                }

                function H(e) {
                    return !('[object Array]' !== Q(e) || (P && 'object' == typeof e && P in e));
                }

                function j(e) {
                    return !('[object RegExp]' !== Q(e) || (P && 'object' == typeof e && P in e));
                }

                function F(e) {
                    if (I) {
                        return e && 'object' == typeof e && e instanceof Symbol;
                    }
                    if ('symbol' == typeof e) {
                        return !0;
                    }
                    if (!e || 'object' != typeof e || !k) {
                        return !1;
                    }
                    try {
                        k.call(e);
                        return !0;
                    } catch (e) {}
                    return !1;
                }

                var U =
                    Object.prototype.hasOwnProperty ||
                    function (e) {
                        return e in this;
                    };

                function V(e, t) {
                    return U.call(e, t);
                }

                function Q(e) {
                    return g.call(e);
                }

                function G(e, t) {
                    if (e.indexOf) {
                        return e.indexOf(t);
                    }
                    for (var n = 0, i = e.length; n < i; n++) {
                        if (e[n] === t) {
                            return n;
                        }
                    }
                    return -1;
                }

                function z(e, t) {
                    if (e.length > t.maxStringLength) {
                        var n = e.length - t.maxStringLength,
                            i = '... ' + n + ' more character' + (n > 1 ? 's' : '');
                        return z(x.call(e, 0, t.maxStringLength), t) + i;
                    }
                    return N(_.call(_.call(e, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, W), 'single', t);
                }

                function W(e) {
                    var t = e.charCodeAt(0),
                        n = { 8: 'b', 9: 't', 10: 'n', 12: 'f', 13: 'r' }[t];
                    if (n) {
                        return '\\' + n;
                    } else {
                        return '\\x' + (t < 16 ? '0' : '') + E.call(t.toString(16));
                    }
                }

                function K(e) {
                    return 'Object(' + e + ')';
                }

                function J(e) {
                    return e + ' { ? }';
                }

                function $(e, t, n, i) {
                    return e + ' (' + t + ') {' + (i ? X(n, i) : v.call(n, ', ')) + '}';
                }

                function X(e, t) {
                    if (0 === e.length) {
                        return '';
                    }
                    var n = '\n' + t.prev + t.base;
                    return n + v.call(e, ',' + n) + '\n' + t.prev;
                }

                function Z(e, t) {
                    var n = H(e),
                        i = [];
                    if (n) {
                        i.length = e.length;
                        for (var a = 0; a < e.length; a++) {
                            i[a] = V(e, a) ? t(e[a], e) : '';
                        }
                    }
                    var o,
                        r = 'function' == typeof T ? T(e) : [];
                    if (I) {
                        o = {};
                        for (var s = 0; s < r.length; s++) {
                            o['$' + r[s]] = r[s];
                        }
                    }
                    for (var c in e) {
                        if (V(e, c)) {
                            if (!(n && String(Number(c)) === c && c < e.length)) {
                                if (!(I && o['$' + c] instanceof Symbol)) {
                                    if (S.call(/[^\w$]/, c)) {
                                        i.push(t(c, e) + ': ' + t(e[c], e));
                                    } else {
                                        i.push(c + ': ' + t(e[c], e));
                                    }
                                }
                            }
                        }
                    }
                    if ('function' == typeof T) {
                        for (var l = 0; l < r.length; l++) {
                            if (L.call(e, r[l])) {
                                i.push('[' + t(r[l]) + ']: ' + t(e[r[l]], e));
                            }
                        }
                    }
                    return i;
                }
            },
            1474: function (e) {
                'use strict';
                var t = function (e) {
                    return e != e;
                };
                e.exports = function (e, n) {
                    if (0 === e && 0 === n) {
                        return 1 / e == 1 / n;
                    }
                    if (e === n) {
                        return !0;
                    }
                    if (t(e) && t(n)) {
                        return !0;
                    } else {
                        return !1;
                    }
                };
            },
            3354: function (e, t, n) {
                'use strict';
                var i = n(5935),
                    a = n(2756),
                    o = n(1474),
                    r = n(1723),
                    s = n(2365),
                    c = a(r(), Object);
                i(c, { getPolyfill: r, implementation: o, shim: s });
                e.exports = c;
            },
            1723: function (e, t, n) {
                'use strict';
                var i = n(1474);
                e.exports = function () {
                    return 'function' == typeof Object.is ? Object.is : i;
                };
            },
            2365: function (e, t, n) {
                'use strict';
                var i = n(1723),
                    a = n(5935);
                e.exports = function () {
                    var e = i();
                    a(
                        Object,
                        { is: e },
                        {
                            is: function () {
                                return Object.is !== e;
                            },
                        },
                    );
                    return e;
                };
            },
            1730: function (e, t, n) {
                'use strict';
                var i;
                if (!Object.keys) {
                    var a = Object.prototype.hasOwnProperty,
                        o = Object.prototype.toString,
                        r = n(6838),
                        s = Object.prototype.propertyIsEnumerable,
                        c = !s.call({ toString: null }, 'toString'),
                        l = s.call(function () {}, 'prototype'),
                        u = [
                            'toString',
                            'toLocaleString',
                            'valueOf',
                            'hasOwnProperty',
                            'isPrototypeOf',
                            'propertyIsEnumerable',
                            'constructor',
                        ],
                        d = function (e) {
                            var t = e.constructor;
                            return t && t.prototype === e;
                        },
                        m = {
                            $applicationCache: !0,
                            $console: !0,
                            $external: !0,
                            $frame: !0,
                            $frameElement: !0,
                            $frames: !0,
                            $innerHeight: !0,
                            $innerWidth: !0,
                            $onmozfullscreenchange: !0,
                            $onmozfullscreenerror: !0,
                            $outerHeight: !0,
                            $outerWidth: !0,
                            $pageXOffset: !0,
                            $pageYOffset: !0,
                            $parent: !0,
                            $scrollLeft: !0,
                            $scrollTop: !0,
                            $scrollX: !0,
                            $scrollY: !0,
                            $self: !0,
                            $webkitIndexedDB: !0,
                            $webkitStorageInfo: !0,
                            $window: !0,
                        },
                        p = (function () {
                            if ('undefined' == typeof window) {
                                return !1;
                            }
                            for (var e in window) {
                                try {
                                    if (
                                        !m['$' + e] &&
                                        a.call(window, e) &&
                                        null !== window[e] &&
                                        'object' == typeof window[e]
                                    ) {
                                        try {
                                            d(window[e]);
                                        } catch (e) {
                                            return !0;
                                        }
                                    }
                                } catch (e) {
                                    return !0;
                                }
                            }
                            return !1;
                        })();
                    i = function (e) {
                        var t = null !== e && 'object' == typeof e,
                            n = '[object Function]' === o.call(e),
                            i = r(e),
                            s = t && '[object String]' === o.call(e),
                            m = [];
                        if (!t && !n && !i) {
                            throw new TypeError('Object.keys called on a non-object');
                        }
                        var f = l && n;
                        if (s && e.length > 0 && !a.call(e, 0)) {
                            for (var g = 0; g < e.length; ++g) {
                                m.push(String(g));
                            }
                        }
                        if (i && e.length > 0) {
                            for (var h = 0; h < e.length; ++h) {
                                m.push(String(h));
                            }
                        } else {
                            for (var y in e) {
                                if ((!f || 'prototype' !== y) && a.call(e, y)) {
                                    m.push(String(y));
                                }
                            }
                        }
                        if (c) {
                            for (
                                var x = (function (e) {
                                        if ('undefined' == typeof window || !p) {
                                            return d(e);
                                        }
                                        try {
                                            return d(e);
                                        } catch (e) {
                                            return !1;
                                        }
                                    })(e),
                                    _ = 0;
                                _ < u.length;
                                ++_
                            ) {
                                if ((!x || 'constructor' !== u[_]) && a.call(e, u[_])) {
                                    m.push(u[_]);
                                }
                            }
                        }
                        return m;
                    };
                }
                e.exports = i;
            },
            9722: function (e, t, n) {
                'use strict';
                var i = Array.prototype.slice,
                    a = n(6838),
                    o = Object.keys,
                    r = o
                        ? function (e) {
                              return o(e);
                          }
                        : n(1730),
                    s = Object.keys;
                r.shim = function () {
                    if (Object.keys) {
                        var e = (function () {
                            var e = Object.keys(arguments);
                            return e && e.length === arguments.length;
                        })(1, 2);
                        if (!e) {
                            Object.keys = function (e) {
                                if (a(e)) {
                                    return s(i.call(e));
                                } else {
                                    return s(e);
                                }
                            };
                        }
                    } else {
                        Object.keys = r;
                    }
                    return Object.keys || r;
                };
                e.exports = r;
            },
            6838: function (e) {
                'use strict';
                var t = Object.prototype.toString;
                e.exports = function (e) {
                    var n = t.call(e),
                        i = '[object Arguments]' === n;
                    if (!i) {
                        i =
                            '[object Array]' !== n &&
                            null !== e &&
                            'object' == typeof e &&
                            'number' == typeof e.length &&
                            e.length >= 0 &&
                            '[object Function]' === t.call(e.callee);
                    }
                    return i;
                };
            },
            2418: function (e, t, n) {
                'use strict';
                var i = n(9722),
                    a = n(2698)(),
                    o = n(2264),
                    r = Object,
                    s = o('Array.prototype.push'),
                    c = o('Object.prototype.propertyIsEnumerable'),
                    l = a ? Object.getOwnPropertySymbols : null;
                e.exports = function (e, t) {
                    if (null == e) {
                        throw new TypeError('target must be an object');
                    }
                    var n = r(e);
                    if (1 === arguments.length) {
                        return n;
                    }
                    for (var o = 1; o < arguments.length; ++o) {
                        var u = r(arguments[o]),
                            d = i(u),
                            m = a && (Object.getOwnPropertySymbols || l);
                        if (m) {
                            for (var p = m(u), f = 0; f < p.length; ++f) {
                                var g = p[f];
                                if (c(u, g)) {
                                    s(d, g);
                                }
                            }
                        }
                        for (var h = 0; h < d.length; ++h) {
                            var y = d[h];
                            if (c(u, y)) {
                                var x = u[y];
                                n[y] = x;
                            }
                        }
                    }
                    return n;
                };
            },
            1274: function (e, t, n) {
                'use strict';
                var i = n(5935),
                    a = n(2756),
                    o = n(2418),
                    r = n(8267),
                    s = n(1085),
                    c = a.apply(r()),
                    l = function (e, t) {
                        return c(Object, arguments);
                    };
                i(l, { getPolyfill: r, implementation: o, shim: s });
                e.exports = l;
            },
            8267: function (e, t, n) {
                'use strict';
                var i = n(2418);
                e.exports = function () {
                    if (!Object.assign) {
                        return i;
                    }
                    if (
                        (function () {
                            if (!Object.assign) {
                                return !1;
                            }
                            for (var e = 'abcdefghijklmnopqrst', t = e.split(''), n = {}, i = 0; i < t.length; ++i) {
                                n[t[i]] = t[i];
                            }
                            var a = Object.assign({}, n),
                                o = '';
                            for (var r in a) {
                                o += r;
                            }
                            return e !== o;
                        })()
                    ) {
                        return i;
                    }
                    if (
                        (function () {
                            if (!Object.assign || !Object.preventExtensions) {
                                return !1;
                            }
                            var e = Object.preventExtensions({ 1: 2 });
                            try {
                                Object.assign(e, 'xy');
                            } catch (t) {
                                return 'y' === e[1];
                            }
                            return !1;
                        })()
                    ) {
                        return i;
                    } else {
                        return Object.assign;
                    }
                };
            },
            1085: function (e, t, n) {
                'use strict';
                var i = n(5935),
                    a = n(8267);
                e.exports = function () {
                    var e = a();
                    i(
                        Object,
                        { assign: e },
                        {
                            assign: function () {
                                return Object.assign !== e;
                            },
                        },
                    );
                    return e;
                };
            },
            2031: function (e) {
                'use strict';
                e.exports = [
                    'Float32Array',
                    'Float64Array',
                    'Int8Array',
                    'Int16Array',
                    'Int32Array',
                    'Uint8Array',
                    'Uint8ClampedArray',
                    'Uint16Array',
                    'Uint32Array',
                    'BigInt64Array',
                    'BigUint64Array',
                ];
            },
            1160: function (e, t, n) {
                'use strict';
                var i = n(4761),
                    a = n(4114),
                    o = Object;
                e.exports = i(
                    function () {
                        if (null == this || this !== o(this)) {
                            throw new a('RegExp.prototype.flags getter called on non-object');
                        }
                        var e = '';
                        if (this.hasIndices) {
                            e += 'd';
                        }
                        if (this.global) {
                            e += 'g';
                        }
                        if (this.ignoreCase) {
                            e += 'i';
                        }
                        if (this.multiline) {
                            e += 'm';
                        }
                        if (this.dotAll) {
                            e += 's';
                        }
                        if (this.unicode) {
                            e += 'u';
                        }
                        if (this.unicodeSets) {
                            e += 'v';
                        }
                        if (this.sticky) {
                            e += 'y';
                        }
                        return e;
                    },
                    'get flags',
                    !0,
                );
            },
            1188: function (e, t, n) {
                'use strict';
                var i = n(5935),
                    a = n(2756),
                    o = n(1160),
                    r = n(557),
                    s = n(3675),
                    c = a(r());
                i(c, { getPolyfill: r, implementation: o, shim: s });
                e.exports = c;
            },
            557: function (e, t, n) {
                'use strict';
                var i = n(1160),
                    a = n(5935).supportsDescriptors,
                    o = Object.getOwnPropertyDescriptor;
                e.exports = function () {
                    if (a && 'gim' === /a/gim.flags) {
                        var e = o(RegExp.prototype, 'flags');
                        if (
                            e &&
                            'function' == typeof e.get &&
                            'boolean' == typeof RegExp.prototype.dotAll &&
                            'boolean' == typeof RegExp.prototype.hasIndices
                        ) {
                            var t = '',
                                n = {};
                            Object.defineProperty(n, 'hasIndices', {
                                get: function () {
                                    t += 'd';
                                },
                            });
                            Object.defineProperty(n, 'sticky', {
                                get: function () {
                                    t += 'y';
                                },
                            });
                            if ('dy' === t) {
                                return e.get;
                            }
                        }
                    }
                    return i;
                };
            },
            3675: function (e, t, n) {
                'use strict';
                var i = n(5935).supportsDescriptors,
                    a = n(557),
                    o = Object.getOwnPropertyDescriptor,
                    r = Object.defineProperty,
                    s = TypeError,
                    c = Object.getPrototypeOf,
                    l = /a/;
                e.exports = function () {
                    if (!i || !c) {
                        throw new s(
                            'RegExp.prototype.flags requires a true ES5 environment that supports property descriptors',
                        );
                    }
                    var e = a(),
                        t = c(l),
                        n = o(t, 'flags');
                    if (!n || n.get !== e) {
                        r(t, 'flags', { configurable: !0, enumerable: !1, get: e });
                    }
                    return e;
                };
            },
            6930: function (e, t, n) {
                'use strict';
                var i = n(9718),
                    a = n(1828),
                    o = n(6177)(),
                    r = n(7570),
                    s = n(4114),
                    c = i('%Math.floor%');
                e.exports = function (e, t) {
                    if ('function' != typeof e) {
                        throw new s('`fn` is not a function');
                    }
                    if ('number' != typeof t || t < 0 || t > 4294967295 || c(t) !== t) {
                        throw new s('`length` must be a positive 32-bit integer');
                    }
                    var n = arguments.length > 2 && !!arguments[2],
                        i = !0,
                        l = !0;
                    if ('length' in e && r) {
                        var u = r(e, 'length');
                        if (u && !u.configurable) {
                            i = !1;
                        }
                        if (u && !u.writable) {
                            l = !1;
                        }
                    }
                    if (i || l || !n) {
                        if (o) {
                            a(e, 'length', t, !0, !0);
                        } else {
                            a(e, 'length', t);
                        }
                    }
                    return e;
                };
            },
            4761: function (e, t, n) {
                'use strict';
                var i = n(1828),
                    a = n(6177)(),
                    o = n(3999).functionsHaveConfigurableNames(),
                    r = n(4114);
                e.exports = function (e, t) {
                    if ('function' != typeof e) {
                        throw new r('`fn` is not a function');
                    }
                    if (!(arguments.length > 2 && !!arguments[2]) || o) {
                        if (a) {
                            i(e, 'name', t, !0, !0);
                        } else {
                            i(e, 'name', t);
                        }
                    }
                    return e;
                };
            },
            1233: function (e, t, n) {
                'use strict';
                var i = n(9718),
                    a = n(2264),
                    o = n(6410),
                    r = n(4114),
                    s = i('%WeakMap%', !0),
                    c = i('%Map%', !0),
                    l = a('WeakMap.prototype.get', !0),
                    u = a('WeakMap.prototype.set', !0),
                    d = a('WeakMap.prototype.has', !0),
                    m = a('Map.prototype.get', !0),
                    p = a('Map.prototype.set', !0),
                    f = a('Map.prototype.has', !0),
                    g = function (e, t) {
                        for (var n, i = e; null !== (n = i.next); i = n) {
                            if (n.key === t) {
                                i.next = n.next;
                                n.next = e.next;
                                e.next = n;
                                return n;
                            }
                        }
                    };
                e.exports = function () {
                    var e,
                        t,
                        n,
                        i = {
                            assert: function (e) {
                                if (!i.has(e)) {
                                    throw new r('Side channel does not contain ' + o(e));
                                }
                            },
                            get: function (i) {
                                if (s && i && ('object' == typeof i || 'function' == typeof i)) {
                                    if (e) {
                                        return l(e, i);
                                    }
                                } else if (c) {
                                    if (t) {
                                        return m(t, i);
                                    }
                                } else if (n) {
                                    return (function (e, t) {
                                        var n = g(e, t);
                                        return n && n.value;
                                    })(n, i);
                                }
                            },
                            has: function (i) {
                                if (s && i && ('object' == typeof i || 'function' == typeof i)) {
                                    if (e) {
                                        return d(e, i);
                                    }
                                } else if (c) {
                                    if (t) {
                                        return f(t, i);
                                    }
                                } else if (n) {
                                    return (function (e, t) {
                                        return !!g(e, t);
                                    })(n, i);
                                }
                                return !1;
                            },
                            set: function (i, a) {
                                if (s && i && ('object' == typeof i || 'function' == typeof i)) {
                                    if (!e) {
                                        e = new s();
                                    }
                                    u(e, i, a);
                                } else if (c) {
                                    if (!t) {
                                        t = new c();
                                    }
                                    p(t, i, a);
                                } else {
                                    if (!n) {
                                        n = { key: {}, next: null };
                                    }
                                    !(function (e, t, n) {
                                        var i = g(e, t);
                                        if (i) {
                                            i.value = n;
                                        } else {
                                            e.next = { key: t, next: e.next, value: n };
                                        }
                                    })(n, i, a);
                                }
                            },
                        };
                    return i;
                };
            },
            2123: function (e, t, n) {
                'use strict';
                var i = n(5772),
                    a = SyntaxError,
                    o = 'object' == typeof StopIteration ? StopIteration : null;
                e.exports = function (e) {
                    if (!o) {
                        throw new a('this environment lacks StopIteration');
                    }
                    i.set(e, '[[Done]]', !1);
                    var t = {
                        next: function () {
                            var e = i.get(this, '[[Iterator]]'),
                                t = i.get(e, '[[Done]]');
                            try {
                                return { done: t, value: t ? void 0 : e.next() };
                            } catch (t) {
                                i.set(e, '[[Done]]', !0);
                                if (t !== o) {
                                    throw t;
                                }
                                return { done: !0, value: void 0 };
                            }
                        },
                    };
                    i.set(t, '[[Iterator]]', e);
                    return t;
                };
            },
            1524: function (e, t, n) {
                'use strict';
                var i = n(514),
                    a = n(9206),
                    o = n(919),
                    r = n(1735),
                    s = n(7500);
                e.exports = function (e) {
                    if (null == e || ('object' != typeof e && 'function' != typeof e)) {
                        return null;
                    }
                    if (i(e)) {
                        return 'String';
                    }
                    if (a(e)) {
                        return 'Number';
                    }
                    if (o(e)) {
                        return 'Boolean';
                    }
                    if (r(e)) {
                        return 'Symbol';
                    }
                    if (s(e)) {
                        return 'BigInt';
                    } else {
                        return;
                    }
                };
            },
            6244: function (e, t, n) {
                'use strict';
                var i = n(175),
                    a = n(4065),
                    o = n(2355),
                    r = n(3277);
                e.exports = function (e) {
                    if (e && 'object' == typeof e) {
                        if (i(e)) {
                            return 'Map';
                        }
                        if (a(e)) {
                            return 'Set';
                        }
                        if (o(e)) {
                            return 'WeakMap';
                        }
                        if (r(e)) {
                            return 'WeakSet';
                        }
                    }
                    return !1;
                };
            },
            4912: function (e, t, n) {
                'use strict';
                var i = n(755),
                    a = n(750),
                    o = n(2756),
                    r = n(2264),
                    s = n(7570),
                    c = r('Object.prototype.toString'),
                    l = n(4903)(),
                    u = 'undefined' == typeof globalThis ? n.g : globalThis,
                    d = a(),
                    m = r('String.prototype.slice'),
                    p = Object.getPrototypeOf,
                    f =
                        r('Array.prototype.indexOf', !0) ||
                        function (e, t) {
                            for (var n = 0; n < e.length; n += 1) {
                                if (e[n] === t) {
                                    return n;
                                }
                            }
                            return -1;
                        },
                    g = { __proto__: null };
                if (l && s && p) {
                    i(d, function (e) {
                        var t = new u[e]();
                        if (Symbol.toStringTag in t) {
                            var n = p(t),
                                i = s(n, Symbol.toStringTag);
                            if (!i) {
                                var a = p(n);
                                i = s(a, Symbol.toStringTag);
                            }
                            g['$' + e] = o(i.get);
                        }
                    });
                } else {
                    i(d, function (e) {
                        var t = new u[e](),
                            n = t.slice || t.set;
                        if (n) {
                            g['$' + e] = o(n);
                        }
                    });
                }
                e.exports = function (e) {
                    if (!e || 'object' != typeof e) {
                        return !1;
                    }
                    if (!l) {
                        var t = m(c(e), 8, -1);
                        if (f(d, t) > -1) {
                            return t;
                        }
                        if ('Object' !== t) {
                            return !1;
                        } else {
                            return (function (e) {
                                var t = !1;
                                i(g, function (n, i) {
                                    if (!t) {
                                        try {
                                            n(e);
                                            t = m(i, 1);
                                        } catch (e) {}
                                    }
                                });
                                return t;
                            })(e);
                        }
                    }
                    if (!s) {
                        return null;
                    } else {
                        return (function (e) {
                            var t = !1;
                            i(g, function (n, i) {
                                if (!t) {
                                    try {
                                        if ('$' + n(e) === i) {
                                            t = m(i, 1);
                                        }
                                    } catch (e) {}
                                }
                            });
                            return t;
                        })(e);
                    }
                };
            },
            1910: function (e, t) {
                'use strict';
                t.A = function (e) {
                    var t = e;
                    t.stdQProfile = 'http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire';
                    t.stdQRProfile = 'http://hl7.org/fhir/4.0/StructureDefinition/QuestionnaireResponse';
                    t._handleInitialValues = function (e, t) {
                        if (null === t.defaultAnswer || void 0 === t.defaultAnswer || '' === t.defaultAnswer) {
                            return;
                        }
                        var n = this._getAssumedDataTypeForExport(t),
                            i =
                                this._answerRepeats(t) && Array.isArray(t.defaultAnswer)
                                    ? t.defaultAnswer
                                    : [t.defaultAnswer],
                            a = this._getValueKeyByDataType('value', t),
                            o = null;
                        let r = [];
                        for (var s = 0, c = i.length; s < c; s++) {
                            let e = i[s];
                            if ('CODING' === n) {
                                let n = !1;
                                if (t.answers) {
                                    for (var l = 0, u = t.answers.length; l < u; l++) {
                                        if (LForms.Util.areTwoAnswersSame(e, t.answers[l], t)) {
                                            n = !0;
                                            break;
                                        }
                                    }
                                }
                                if (!n) {
                                    if ('string' == typeof e) {
                                        r.push({ valueString: e });
                                    } else if ('object' == typeof e) {
                                        let t = LForms.Util.deepCopy(e);
                                        if (t.text) {
                                            t.display = t.text;
                                            delete t.text;
                                        }
                                        if (t.system) {
                                            t.system = LForms.Util.getCodeSystem(t.system);
                                        }
                                        r.push(t);
                                    }
                                }
                            } else if ('QTY' === n) {
                                (o = {})[a] = this._makeQuantity(e, t.units);
                                r.push(o);
                            } else if (t.answers && ('ST' === n || 'INT' === n || 'DT' === n || 'TM' === n)) {
                                r.push({ [a]: e.text });
                            } else if (
                                'INT' === n ||
                                'REAL' === n ||
                                'BL' === n ||
                                'TM' === n ||
                                'ST' === n ||
                                'TX' === n ||
                                'URL' === n
                            ) {
                                (o = {})[a] = e;
                                r.push(o);
                            } else if ('DT' === n || 'DTM' === n) {
                                var d = LForms.Util.stringToDate(e);
                                if (d) {
                                    d = 'DTM' === n ? LForms.Util.dateToDTMString(d) : LForms.Util.dateToDTStringISO(d);
                                    r.push({ [a]: d });
                                } else {
                                    console.error(
                                        e + ': Invalid date/datetime string as defaultAnswer for ' + t.questionCode,
                                    );
                                }
                            }
                        }
                        if (r.length > 0) {
                            e.initial = r;
                        }
                    };
                };
            },
            6726: function (e, t) {
                'use strict';
                t.A = function (e) {
                    var t = e;
                    t.fhirExtUrlOptionScore = t.fhirExtUrlOptionScoreLookup.R4;
                    t._processDataType = function (e, n) {
                        var i = t._getDataType(n);
                        if ('open-choice' === n.type) {
                            e.answerConstraint = 'optionsOrString';
                        }
                        if ('SECTION' === i) {
                            e.header = !0;
                        }
                        e.dataType = i;
                    };
                    t._processDefaultAnswerValue = function (e, n, i) {
                        var a = (e = LForms.Util.deepCopy(e)).valueCoding;
                        if (a) {
                            a._type = 'Coding';
                        } else {
                            a = t._getFHIRValueWithPrefixKey(e, /^value/);
                        }
                        if (null != a) {
                            n.push(a);
                        }
                    };
                };
            },
            4333: function (e, t, n) {
                'use strict';
                var i = n(561);
                let a = Object.create(i.A);
                Object.assign(a, {
                    _createObsIntValue: function (e) {
                        let t;
                        if (e.unit) {
                            let n = { value: e.value };
                            this._setFHIRQuantityUnit(n, e.unit);
                            t = { key: 'valueQuantity', val: n };
                        } else {
                            t = { key: 'valueInteger', val: e.value };
                        }
                        return t;
                    },
                });
                t.A = a;
            },
            4462: function (e, t) {
                'use strict';
                var n = {
                    convertLFormsToQRAndExtractFHIRData: function (e, t, n) {
                        var i = this.convertLFormsToQuestionnaireResponse(e, t, n);
                        if (!i.id) {
                            i.id = this._commonExport._getUniqueId((i.identifier && i.identifier.value) || 'QR');
                        }
                        for (
                            var a = 'QuestionnaireResponse/' + i.id, o = [i], r = 0, s = e.itemList.length;
                            r < s;
                            ++r
                        ) {
                            var c = e.itemList[r];
                            if (this._getExtractValue(c) && this._hasItemValue(c)) {
                                const e = [];
                                for (var l = c; l && !e.length; ) {
                                    if (l.extension) {
                                        LForms.Util.findObjectInArray(
                                            l.extension,
                                            'url',
                                            this.fhirExtObsExtractCategory,
                                            0,
                                            !0,
                                        ).forEach(t => e.push(t.valueCodeableConcept));
                                    }
                                    l = l._parentItem;
                                }
                                for (
                                    var u = this._commonExport._createObservation(c), d = 0, m = u.length;
                                    d < m;
                                    d++
                                ) {
                                    if (i.basedOn) {
                                        u[d].basedOn = i.basedOn;
                                    }
                                    if (i.partOf) {
                                        u[d].partOf = i.partOf;
                                    }
                                    if (i.subject) {
                                        u[d].subject = i.subject;
                                    }
                                    if (i.encounter) {
                                        u[d].encounter = i.encounter;
                                    }
                                    if (i.authored) {
                                        u[d].effectiveDateTime = i.authored;
                                        u[d].issued = i.authored;
                                    }
                                    if (i.author) {
                                        u[d].performer = i.author;
                                    }
                                    u[d].derivedFrom = [{ reference: a }];
                                    if (e.length) {
                                        u[d].category = e;
                                    }
                                    o.push(u[d]);
                                }
                            }
                        }
                        return o;
                    },
                    _processQuestionCardinality: function (e, t) {
                        if (t.questionCardinality) {
                            if ('*' === t.questionCardinality.max) {
                                e.repeats = !0;
                            } else if (parseInt(t.questionCardinality.max) > 1) {
                                e.repeats = !0;
                                e.extension.push({
                                    url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-maxOccurs',
                                    valueInteger: parseInt(t.questionCardinality.max),
                                });
                            }
                        }
                    },
                    _handleSpecialConstraints: function (e, t) {
                        if (e && 'TITLE' === t.dataType) {
                            delete e.code;
                            delete e.required;
                            delete e.repeats;
                            delete e.readOnly;
                        }
                    },
                    _handleRestrictions: function (e, t) {
                        if (t.restrictions) {
                            for (var n in t.restrictions) {
                                var i = t.restrictions[n],
                                    a = null,
                                    o = this._getAssumedDataTypeForExport(t),
                                    r = this._getValueKeyByDataType('value', t);
                                switch (n) {
                                    case 'minExclusive':
                                    case 'minInclusive':
                                    case 'maxExclusive':
                                    case 'maxInclusive':
                                        a = this._exportMinMax(o, i, r, n);
                                        break;
                                    case 'minLength':
                                        if ('ST' === o || 'TX' === o || 'URL' === o || 'QTY' === o) {
                                            a = {
                                                url: 'http://hl7.org/fhir/StructureDefinition/minLength',
                                                valueInteger: parseInt(i),
                                            };
                                        }
                                        break;
                                    case 'maxLength':
                                        if ('ST' === o || 'TX' === o || 'URL' === o || 'QTY' === o) {
                                            e.maxLength = parseInt(i);
                                        }
                                        break;
                                    case 'pattern':
                                        if ('ST' === o || 'TX' === o) {
                                            a = {
                                                url: 'http://hl7.org/fhir/StructureDefinition/regex',
                                                valueString: i,
                                            };
                                        }
                                        break;
                                    case 'maxDecimalPlaces':
                                        if ('REAL' === o) {
                                            a = { url: this.fhirExtUrlMaxDecimalPlaces, valueInteger: i };
                                        }
                                }
                                if (a) {
                                    e.extension.push(a);
                                }
                            }
                        }
                    },
                    _handleChoiceField: function (e, t) {
                        if (t.externallyDefined) {
                            this._handleExternallyDefined(e, t);
                        } else if (t.answers && !t.answerValueSet) {
                            if (!t._fhirExt || !t._fhirExt[this.fhirExtAnswerExp]) {
                                e.answerOption = this._handleAnswers(t);
                            }
                        } else if (t.answerValueSet) {
                            e.answerValueSet = t.answerValueSet;
                        }
                    },
                    _handleAnswers: function (e) {
                        for (var t = [], n = 0, i = e.answers.length; n < i; n++) {
                            var a = e.answers[n],
                                o = {};
                            if ('CODING' === e.dataType) {
                                o.valueCoding = {};
                                if (a.code) {
                                    o.valueCoding.code = a.code;
                                }
                                if (a.text) {
                                    o.valueCoding.display = a.text;
                                }
                                if (a.system) {
                                    o.valueCoding.system = LForms.Util.getCodeSystem(a.system);
                                }
                                if (e.defaultAnswer && 'CODING' === e.dataType) {
                                    for (
                                        var r =
                                                this._answerRepeats(e) && Array.isArray(e.defaultAnswer)
                                                    ? e.defaultAnswer
                                                    : [e.defaultAnswer],
                                            s = 0,
                                            c = r.length;
                                        s < c;
                                        s++
                                    ) {
                                        if (LForms.Util.areTwoAnswersSame(r[s], a, e)) {
                                            o.initialSelected = !0;
                                        }
                                    }
                                }
                            } else if (
                                'ST' === e.dataType ||
                                'INT' === e.dataType ||
                                'DT' === e.dataType ||
                                'TM' === e.dataType
                            ) {
                                var l = this._getValueKeyByDataType('value', e);
                                o[l] = a.text;
                                if ('valueString' === l && a.obj_valueString) {
                                    o._valueString = a.obj_valueString;
                                }
                            }
                            var u = [];
                            if (a.label) {
                                u.push({
                                    url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
                                    valueString: a.label,
                                });
                            }
                            if (null !== a.score && void 0 !== a.score) {
                                u.push({ url: this.fhirExtUrlOptionScore, valueDecimal: a.score });
                            }
                            if (u.length > 0) {
                                o.extension = u;
                            }
                            t.push(o);
                        }
                        return t;
                    },
                    _handleLFormsUnits: function (e, t) {
                        if (t.units && t.units.length > 0) {
                            var n = this._getAssumedDataTypeForExport(t);
                            if ('REAL' === n || 'INT' === n) {
                                e.extension.push({
                                    url: this.fhirExtUrlUnit,
                                    valueCoding: this._createFhirUnitCoding(t.units[0]),
                                });
                            } else if ('QTY' === n) {
                                var i = this._getDefaultUnit(t.units);
                                if (i && i.default && !(e.initial && e.initial.length > 0)) {
                                    if (!e.initial) {
                                        e.initial = [];
                                    }
                                    var a = {};
                                    this._setUnitAttributesToFhirQuantity(a, i);
                                    e.initial.push({ valueQuantity: a });
                                }
                                for (var o = 0, r = t.units.length; o < r; o++) {
                                    var s = t.units[o],
                                        c = {
                                            url: this.fhirExtUrlUnitOption,
                                            valueCoding: this._createFhirUnitCoding(s),
                                        };
                                    e.extension.push(c);
                                }
                            }
                        }
                    },
                    _handleSkipLogic: function (e, t, n) {
                        if (t.skipLogic) {
                            for (var i = [], a = !1, o = 0, r = t.skipLogic.conditions.length; o < r; o++) {
                                var s = t.skipLogic.conditions[o],
                                    c = n._getSkipLogicSourceItem(t, s.source);
                                let e = this._createEnableWhenRulesForSkipLogicCondition(s, c);
                                if (e.length > 1) {
                                    a = !0;
                                }
                                i = i.concat(e);
                            }
                            if (a && t.skipLogic.conditions.length > 1) {
                                throw new Error(
                                    'Multiple skip logic conditons included with range specification is not supported yet.',
                                );
                            }
                            e.enableWhen = i;
                            if ('ALL' === t.skipLogic.logic || a) {
                                e.enableBehavior = 'all';
                            } else if (i.length > 1) {
                                e.enableBehavior = 'any';
                            }
                        }
                    },
                    _processQRQuestionnaire: function (e, t) {
                        if (t.url) {
                            e.questionnaire = t.version ? t.url + '|' + t.version : t.url;
                        }
                    },
                };
                t.A = n;
            },
            2777: function (e, t) {
                'use strict';
                t.A = function (e) {
                    var t = e;
                    t.fhirExtUrlValueSetScore = 'http://hl7.org/fhir/StructureDefinition/ordinalValue';
                    t._extractContainedVS = function (e) {
                        var n;
                        if (e.contained && e.contained.length > 0) {
                            n = {};
                            e.contained.forEach(function (e) {
                                if ('ValueSet' === e.resourceType) {
                                    var i = t.answersFromVS(e);
                                    if (!i) {
                                        i = [];
                                    }
                                    var a = { answers: i };
                                    if (e.id) {
                                        n['#' + e.id] = a;
                                    }
                                    if (e.url) {
                                        n[e.url] = a;
                                    }
                                }
                            });
                        }
                        return n;
                    };
                    t._processSkipLogic = function (e, n, i) {
                        if (n.enableWhen) {
                            e.skipLogic = { conditions: [], action: 'show' };
                            for (var a = 0; a < n.enableWhen.length; a++) {
                                if (!n.enableWhen[a].question) {
                                    throw new Error(
                                        "Question with linkId '" +
                                            n.linkId +
                                            "' contains enableWhen but is missing the enableWhen.question field.",
                                    );
                                }
                                if (!i[n.enableWhen[a].question]) {
                                    throw new Error(
                                        "Question with linkId '" +
                                            n.linkId +
                                            "' contains enableWhen pointing to a question with linkId '" +
                                            n.enableWhen[a].question +
                                            "' that does not exist.",
                                    );
                                }
                                var o = t._getDataType(i[n.enableWhen[a].question]),
                                    r = { source: n.enableWhen[a].question, trigger: {} },
                                    s = t._getFHIRValueWithPrefixKey(n.enableWhen[a], /^answer/),
                                    c = t._operatorMapping[n.enableWhen[a].operator];
                                if (!c) {
                                    throw new Error(
                                        'Unable to map FHIR enableWhen operator: ' + n.enableWhen[a].operator,
                                    );
                                }
                                if ('exists' === c) {
                                    r.trigger.exists = s;
                                } else if ('CODING' === o) {
                                    r.trigger[c] = t._copyTriggerCoding(s, null, !1);
                                } else if ('QTY' === o) {
                                    r.trigger[c] = s.value;
                                } else {
                                    r.trigger[c] = s;
                                }
                                e.skipLogic.conditions.push(r);
                            }
                            if (n.enableBehavior) {
                                e.skipLogic.logic = n.enableBehavior.toUpperCase();
                            }
                        }
                    };
                    t._processAnswers = function (e, n, i, a) {
                        if (n.answerOption) {
                            e.answers = [];
                            for (var o = 0; o < n.answerOption.length; o++) {
                                var r = {},
                                    s = n.answerOption[o],
                                    c = Object.keys(s).filter(function (e) {
                                        return 0 === e.indexOf('value');
                                    });
                                if (c && c.length > 0) {
                                    if ('valueCoding' === c[0]) {
                                        if (void 0 !== s[c[0]].code) {
                                            r.code = s[c[0]].code;
                                        }
                                        if (void 0 !== s[c[0]].display) {
                                            r.text = s[c[0]].display;
                                        }
                                        if (void 0 !== s[c[0]].system) {
                                            r.system = s[c[0]].system;
                                        }
                                    } else if ('valueString' === c[0] || 'valueDate' === c[0] || 'valueTime' === c[0]) {
                                        r.text = s[c[0]];
                                        if ('valueString' === c[0] && s._valueString) {
                                            r.obj_valueString = s._valueString;
                                            const e = LForms.Util.findObjectInArray(
                                                r.obj_valueString.extension,
                                                'url',
                                                'http://hl7.org/fhir/StructureDefinition/rendering-xhtml',
                                            );
                                            if (e) {
                                                r.textHTML = e.valueString;
                                                if (t._widgetOptions?.allowHTML) {
                                                    if (a && e.valueString.match(/img/) && e.valueString.match(/src/)) {
                                                        r.textHTML =
                                                            LForms.Util._internalUtil._getHtmlStringWithContainedImages(
                                                                a,
                                                                e.valueString,
                                                            ) || r.textHTML;
                                                    }
                                                    let t = LForms.Util.checkForInvalidHtmlTags(r.textHTML);
                                                    if (t && t.length > 0) {
                                                        r._hasInvalidHtmlTag = !0;
                                                        LForms.Util._internalUtil.printInvalidHtmlToConsole(t);
                                                    }
                                                }
                                            }
                                        }
                                    } else if ('valueInteger' === c[0]) {
                                        r.text = parseInt(s[c[0]]);
                                    } else {
                                        throw new Error('Unable to handle data type in answerOption: ' + c[0]);
                                    }
                                    var l = LForms.Util.findObjectInArray(s.extension, 'url', t.fhirExtUrlOptionPrefix);
                                    if (l) {
                                        r.label = l.valueString;
                                    }
                                    var u = s.extension?.find(e => t.fhirExtUrlOptionScoreUrlSet.has(e.url));
                                    if (
                                        (u = !u
                                            ? LForms.Util.findObjectInArray(
                                                  s.extension,
                                                  'url',
                                                  t.argonautExtUrlExtensionScore,
                                              )
                                            : u)
                                    ) {
                                        r.score = parseFloat(u.valueDecimal);
                                    }
                                }
                                e.answers.push(r);
                            }
                        } else if (n.answerValueSet) {
                            if (i) {
                                var d = i[n.answerValueSet];
                            }
                            if (d) {
                                e.answers = d.answers;
                            } else {
                                e.answerValueSet = n.answerValueSet;
                            }
                        }
                    };
                    t._processFHIRQuestionAndAnswerCardinality = function (e, n) {
                        var i,
                            a,
                            o = LForms.Util.findObjectInArray(n.extension, 'url', t.fhirExtUrlCardinalityMin),
                            r = LForms.Util.findObjectInArray(n.extension, 'url', t.fhirExtUrlCardinalityMax),
                            s = n.repeats,
                            c = n.required;
                        if (
                            'CODING' === e.dataType ||
                            (n.answerOption &&
                                ('ST' === e.dataType ||
                                    'INT' === e.dataType ||
                                    'DT' === e.dataType ||
                                    'TM' === e.dataType))
                        ) {
                            if (s) {
                                if (n.item && n.item.length >= 0 && n.item.some(e => 'display' !== e.type)) {
                                    i = { max: '1' };
                                    a = r ? { max: r.valueInteger.toString() } : { max: '*' };
                                } else {
                                    i = r ? { max: r.valueInteger.toString() } : { max: '*' };
                                }
                            } else {
                                i = { max: '1' };
                            }
                            if (c) {
                                i.min = o ? o.valueInteger.toString() : '1';
                            } else {
                                i.min = '0';
                            }
                        } else {
                            if (s) {
                                a = r ? { max: r.valueInteger.toString() } : { max: '*' };
                            } else {
                                a = { max: '1' };
                            }
                            if (c) {
                                a.min = o ? o.valueInteger.toString() : '1';
                                i = { min: '1' };
                            } else {
                                a.min = '1';
                            }
                        }
                        if (a) {
                            e.questionCardinality = a;
                        }
                        if (i) {
                            e.answerCardinality = i;
                        }
                    };
                    t._processEditable = function (e, t) {
                        if (t.readOnly) {
                            e.editable = '0';
                        }
                    };
                    t._processDefaultAnswer = function (e, n) {
                        var i = [];
                        if (n.answerOption) {
                            n.answerOption.forEach(function (e) {
                                if (e.initialSelected) {
                                    t._processDefaultAnswerValue(e, i, n.type);
                                }
                            });
                        }
                        if (n.initial) {
                            n.initial.forEach(function (e) {
                                t._processDefaultAnswerValue(e, i, n.type);
                            });
                        }
                        if (i.length > 0) {
                            this._processFHIRValues(e, i, !0);
                        }
                    };
                    t.getFirstInitialQuantity = function (e) {
                        return (e.initial && e.initial.length > 0 && e.initial[0].valueQuantity) || null;
                    };
                    t._processDisplayItemCode = function (e, t) {
                        if ('display' === t.type && t.linkId) {
                            var n = t.linkId.split('/');
                            if (n && n[n.length - 1]) {
                                e.questionCode = n[n.length - 1];
                            }
                        }
                    };
                    let n = t._mergeQR;
                    n._getQRStructure = function (e) {
                        var t = { qrItemsInfo: [] };
                        if (e) {
                            this._checkQRItems(t, e);
                        }
                        return t;
                    };
                    n._checkQRItems = function (e, n) {
                        var i = [],
                            a = {};
                        if (n && n.item) {
                            for (var o = 0, r = n.item.length; o < r; o++) {
                                var s = n.item[o].linkId;
                                if (!a[s]) {
                                    for (
                                        var c = this._findTotalRepeatingNum(s, n),
                                            l = c.repeatingItems,
                                            u = 0,
                                            d = l.length;
                                        u < d;
                                        u++
                                    ) {
                                        var m = { linkId: s, item: l[u], index: u, total: c.total };
                                        this._checkQRItems(m, l[u]);
                                        t._checkQRItemAnswerItems(m, l[u]);
                                        i.push(m);
                                    }
                                    a[s] = !0;
                                }
                            }
                            e.qrItemsInfo = i;
                        }
                    };
                    n._findTotalRepeatingNum = function (e, t) {
                        for (var n = 0, i = [], a = 0, o = t.item.length; a < o; a++) {
                            var r = t.item[a];
                            if (e === r.linkId) {
                                i.push(r);
                                if (Array.isArray(r.answer)) {
                                    n += r.answer.length;
                                } else {
                                    n += 1;
                                }
                            }
                        }
                        return { total: n, repeatingItems: i };
                    };
                    n._addRepeatingItems = function (e, t, n) {
                        var i = null;
                        if (e.items) {
                            for (var a = 0, o = e.items.length; a < o; a++) {
                                if (t === e.items[a].linkId) {
                                    i = e.items[a];
                                    break;
                                }
                            }
                            if (i) {
                                for (; n > 1; ) {
                                    var r = LForms.Util.deepCopy(i);
                                    e.items.splice(a, 0, r);
                                    n -= 1;
                                }
                            }
                        }
                    };
                    n._findTheMatchingItemByLinkIdAndIndex = function (e, t, n) {
                        var i = null,
                            a = 0;
                        if (e.items) {
                            for (var o = 0, r = e.items.length; o < r; o++) {
                                if (t === e.items[o].linkId) {
                                    if (a === n) {
                                        i = e.items[o];
                                        break;
                                    } else {
                                        a += 1;
                                    }
                                }
                            }
                        }
                        return i;
                    };
                    n._findTheMatchingItemByLinkId = function (e, t) {
                        var n = null;
                        if (e.items) {
                            for (var i = 0, a = e.items.length; i < a; i++) {
                                if (t === e.items[i].linkId) {
                                    n = e.items[i];
                                    break;
                                }
                            }
                        }
                        return n;
                    };
                };
            },
            1868: function (e, t) {
                'use strict';
                t.A = function (e) {
                    var t = e;
                    t._getFhirDataType = function (e) {
                        var t = this._getAssumedDataTypeForExport(e),
                            n = this._lformsTypesToFHIRTypes[t];
                        if ('coding' === n) {
                            if (!e.answerConstraint || 'optionsOnly' === e.answerConstraint) {
                                n = 'choice';
                            } else if ('optionsOrString' === e.answerConstraint) {
                                n = 'open-choice';
                            }
                        }
                        if (!n) {
                            n = 'string';
                        }
                        return n;
                    };
                    t._lfItemValueToFhirAnswer = function (e) {
                        if (void 0 === e.value || null === e.value || '' === e.value) {
                            return null;
                        }
                        for (
                            var t = this._getAssumedDataTypeForExport(e),
                                n = this._answerRepeats(e) ? e.value : [e.value],
                                i = [],
                                a = 0;
                            a < n.length;
                            ++a
                        ) {
                            var o = n[a];
                            if (null != o && '' !== o) {
                                var r = null,
                                    s = [];
                                if (null !== o.score && void 0 !== o.score) {
                                    s.push({ url: this.fhirExtUrlOptionScore, valueDecimal: o.score });
                                }
                                if ('CODING' === t) {
                                    if ('optionsOrString' === e.answerConstraint && 'string' == typeof o) {
                                        r = { valueString: o };
                                    } else if (!LForms.jQuery.isEmptyObject(o)) {
                                        var c = this._setIfHasValue(
                                            null,
                                            'system',
                                            LForms.Util.getCodeSystem(o.system),
                                        );
                                        c = this._setIfHasValue(c, 'code', o.code);
                                        if ((c = this._setIfHasValue(c, 'display', o.text)) && s.length > 0) {
                                            c.extension = s;
                                        }
                                        r = this._setIfHasValue(null, 'valueCoding', c);
                                    }
                                } else if (e.answers && ('INT' === t || 'ST' === t || 'DT' === t || 'TM' === t)) {
                                    if ('string' != typeof o) {
                                        r = { [(u = this._getValueKeyByDataType('value', e))]: o.text };
                                        if (s.length > 0) {
                                            r['_' + u] = { extension: s };
                                        }
                                    }
                                } else if ('QTY' === t) {
                                    var l = this._makeValueQuantity(o, e.unit);
                                    if (l && s.length > 0) {
                                        l.extension = s;
                                    }
                                    r = this._setIfHasValue(null, 'valueQuantity', l);
                                } else if (this._lformsTypesToFHIRFields[t]) {
                                    var u;
                                    r = { [(u = this._getValueKeyByDataType('value', e))]: o };
                                    if (s.length > 0) {
                                        r['_' + u] = { extension: s };
                                    }
                                }
                            }
                            if (null !== r) {
                                i.push(r);
                            }
                        }
                        return 0 === i.length ? null : i;
                    };
                };
            },
            9407: function (e, t) {
                'use strict';
                t.A = function (e) {
                    var t = e;
                    t._processNonCodingAnswerValueInQR = function (e, t) {
                        let n;
                        if ('ST' === t.dataType || 'INT' === t.dataType || 'DT' === t.dataType || 'TM' === t.dataType) {
                            for (var i = t.answers, a = 0, o = i.length; a < o && !n; ++a) {
                                if (e === i[a].text) {
                                    n = i[a];
                                }
                            }
                        }
                        return n;
                    };
                    t._getDataType = function (e) {
                        var t = 'string';
                        switch (e.type) {
                            case 'string':
                                t = 'ST';
                                break;
                            case 'group':
                                t = 'SECTION';
                                break;
                            case 'choice':
                            case 'open-choice':
                                t = 'CODING';
                                break;
                            case 'integer':
                                t = 'INT';
                                break;
                            case 'decimal':
                                t = 'REAL';
                                break;
                            case 'text':
                                t = 'TX';
                                break;
                            case 'boolean':
                                t = 'BL';
                                break;
                            case 'date':
                                t = 'DT';
                                break;
                            case 'dateTime':
                                t = 'DTM';
                                break;
                            case 'time':
                                t = 'TM';
                                break;
                            case 'display':
                                t = 'TITLE';
                                break;
                            case 'url':
                                t = 'URL';
                                break;
                            case 'quantity':
                                t = 'QTY';
                                break;
                            case 'attachment':
                                t = 'attachment';
                                break;
                            case 'coding':
                                t = 'CODING';
                                console.log(
                                    `Warning: An item (linkId:${e.linkId}) has a type of 'coding', which is not a supported item type in STU3/R4.`,
                                );
                        }
                        return t;
                    };
                };
            },
            21: function (e, t, n) {
                'use strict';
                var i = n(6332),
                    a = {
                        _OBX_REF_PREFIX: 'Observation/',
                        _getFormattedDate: function (e) {
                            return e ? LForms.Util.dateToDTMString(e) : '';
                        },
                        _createDiagnosticReportContent: function (e, t) {
                            for (var n = { result: [], resultObj: [] }, i = 0, a = e.items.length; i < a; i++) {
                                var o = e.items[i];
                                if (o) {
                                    var r = this._commonExport._createObservation(o, !0);
                                    if (o.items && o.items.length > 0) {
                                        r[0].related = [];
                                        for (
                                            var s = this._createDiagnosticReportContent(o, t),
                                                c = 0,
                                                l = s.result.length;
                                            c < l;
                                            c++
                                        ) {
                                            var u = s.result[c];
                                            r[0].related.push({
                                                type: 'has-member',
                                                target: { reference: u.reference },
                                            });
                                        }
                                    }
                                    for (var d = 0, m = r.length; d < m; d++) {
                                        t.push(r[d]);
                                        n.result.push({ reference: '#' + r[d].id });
                                        n.resultObj.push(r[d]);
                                    }
                                }
                            }
                            return n;
                        },
                        _convertFromContainedToBundle: function (e, t) {
                            var n = {};
                            if (!t) {
                                t = 'transaction';
                            }
                            if (e) {
                                switch (t) {
                                    case 'transaction':
                                        n = this._convertContainedToTransactionBundle(e);
                                        break;
                                    case 'collection':
                                        n = this._convertContainedToCollectionBundle(e);
                                        break;
                                    default:
                                        console.log('Bundle type not supported: ' + t);
                                }
                            }
                            return n;
                        },
                        _convertContainedToTransactionBundle: function (e) {
                            var t = { resourceType: 'Bundle', type: 'transaction', entry: [] },
                                n = e.contained;
                            delete e.contained;
                            for (var i = 0, a = e.result.length; i < a; i++) {
                                var o = e.result[i];
                                o.reference = this._OBX_REF_PREFIX + o.reference.slice(1);
                            }
                            t.entry.push({ resource: e, request: { method: 'POST', url: 'DiagnosticReport' } });
                            for (var r = 0, s = n.length; r < s; r++) {
                                var c = n[r];
                                if (c.related) {
                                    for (var l = 0, u = c.related.length; l < u; l++) {
                                        var d = c.related[l];
                                        d.target.reference = this._OBX_REF_PREFIX + d.target.reference.slice(1);
                                    }
                                }
                                t.entry.push({ resource: c, request: { method: 'POST', url: 'Observation' } });
                            }
                            return t;
                        },
                        _convertContainedToCollectionBundle: function (e) {
                            var t = { resourceType: 'Bundle', type: 'collection', entry: [] },
                                n = e.contained;
                            delete e.contained;
                            t.entry.push({ resource: e });
                            for (var i = 0, a = n.length; i < a; i++) {
                                var o = n[i];
                                t.entry.push({ resource: o });
                            }
                            return t;
                        },
                        createDiagnosticReport: function (e, t, n, i) {
                            var a = null,
                                o = [];
                            if (e) {
                                var r = e.getFormData(!0, !0, !0),
                                    s = this._createDiagnosticReportContent(r, o);
                                a = {
                                    resourceType: 'DiagnosticReport',
                                    id: this._commonExport._getUniqueId(r.code),
                                    status: 'final',
                                    code: {
                                        coding: [{ system: 'http://loinc.org', code: r.code, display: r.name }],
                                        text: r.name,
                                    },
                                    result: s.result,
                                    contained: o,
                                };
                                this._commonExport._addVersionTag(a);
                                if (t) {
                                    a.subject = LForms.Util.createLocalFHIRReference(t);
                                }
                                a.issued = this._getFormattedDate(new Date());
                            }
                            var c = n ? this._convertFromContainedToBundle(a, i) : a;
                            LForms.Util.pruneNulls(c);
                            return c;
                        },
                        _findObxById: function (e, t) {
                            var n = null;
                            if (e) {
                                for (var i = '#' === e[0] ? e.slice(1) : e, a = 0, o = t.length; a < o; a++) {
                                    if (t[a].id === i) {
                                        n = t[a];
                                        break;
                                    }
                                }
                            }
                            return n;
                        },
                        _setupItemValueAndUnit: function (e, t) {
                            if (t && e.code.coding[0].code === t.questionCode) {
                                var n = t.dataType;
                                if ((!n || 'ST' === n) && t.units && t.units.length > 0) {
                                    n = 'REAL';
                                }
                                switch (n) {
                                    case 'INT':
                                        if (e.valueInteger) {
                                            t.value = e.valueInteger;
                                            break;
                                        }
                                    case 'REAL':
                                    case 'QTY':
                                        let n = (0, i.I)(e.valueQuantity);
                                        t.value = n.value;
                                        delete n.value;
                                        if (n.name || n.code || n.system) {
                                            t.unit = n;
                                        }
                                        break;
                                    case 'DT':
                                        t.value = LForms.Util.stringToDTDateISO(e.valueDate);
                                        break;
                                    case 'DTM':
                                        t.value = LForms.Util.stringToDate(e.valueDateTime);
                                        break;
                                    case 'CODING':
                                        var a;
                                        if (e.valueCodeableConcept) {
                                            a = {
                                                code: e.valueCodeableConcept.coding[0].code,
                                                text: e.valueCodeableConcept.coding[0].display,
                                                system: e.valueCodeableConcept.coding[0].system,
                                            };
                                        } else if (e.valueString) {
                                            a = e.valueString;
                                        }
                                        if (
                                            t.answerCardinality &&
                                            ('*' === t.answerCardinality.max || parseInt(t.answerCardinality.max) > 1)
                                        ) {
                                            if (!t.value) {
                                                t.value = [];
                                            }
                                            t.value.push(a);
                                        } else {
                                            t.value = a;
                                        }
                                        break;
                                    case 'SECTION':
                                    case 'TITLE':
                                    case '':
                                        break;
                                    default:
                                        t.value = e.valueString;
                                }
                            }
                        },
                        _findTotalRepeatingNum: function (e, t, n) {
                            for (var i = 0, a = [], o = 0, r = e.length; o < r; o++) {
                                if (this._findObxById(e[o], n).code.coding[0].code === t) {
                                    a.push(e[o]);
                                    i += 1;
                                }
                            }
                            return { total: i, refIds: a };
                        },
                        _checkRepeatingItems: function (e, t, n) {
                            var i = [],
                                a = {},
                                o = [];
                            if (!t && n.result) {
                                for (var r = 0, s = n.result.length; r < s; r++) {
                                    o.push(n.result[r].reference);
                                }
                            } else {
                                var c = this._findObxById(t, n.contained);
                                if (c && c.related) {
                                    for (r = 0, s = c.related.length; r < s; r++) {
                                        o.push(c.related[r].target.reference);
                                    }
                                }
                            }
                            for (r = 0, s = o.length; r < s; r++) {
                                var l = o[r],
                                    u = this._findObxById(l, n.contained).code.coding[0].code;
                                if (!a[u]) {
                                    var d = this._findTotalRepeatingNum(o, u, n.contained);
                                    a[u] = { total: d.total, refIds: d.refIds };
                                }
                                for (var m = a[u].refIds, p = 0, f = m.length; p < f; p++) {
                                    if (l === m[p]) {
                                        var g = { code: u, refId: l, index: p, total: a[u].total };
                                        this._checkRepeatingItems(g, l, n);
                                        i.push(g);
                                    }
                                }
                            }
                            e.obxInfoList = i;
                        },
                        _getReportStructure: function (e) {
                            var t = { obxInfoList: [] };
                            if (e) {
                                this._checkRepeatingItems(t, null, e);
                            }
                            return t;
                        },
                        _findTheMatchingItemByCodeAndIndex: function (e, t, n) {
                            var i = null,
                                a = 0;
                            if (e.items) {
                                for (var o = 0, r = e.items.length; o < r; o++) {
                                    var s = e.items[o];
                                    if (t === s.questionCode) {
                                        if (
                                            'CODING' === s.dataType &&
                                            s.answerCardinality &&
                                            ('*' === s.answerCardinality.max || parseInt(s.answerCardinality.max) > 1)
                                        ) {
                                            i = s;
                                            break;
                                        } else if (a === n) {
                                            i = s;
                                            break;
                                        } else {
                                            a += 1;
                                        }
                                    }
                                }
                            }
                            return i;
                        },
                        _addRepeatingItems: function (e, t, n) {
                            var i = null;
                            if (e.items) {
                                for (var a = 0, o = e.items.length; a < o; a++) {
                                    if (t === e.items[a].questionCode) {
                                        i = e.items[a];
                                        break;
                                    }
                                }
                                if (
                                    i &&
                                    ('CODING' !== i.dataType ||
                                        !i.answerCardinality ||
                                        !('*' === i.answerCardinality.max || parseInt(i.answerCardinality.max) > 1))
                                ) {
                                    for (; n > 1; ) {
                                        var r = LForms.Util.deepCopy(i);
                                        e.items.splice(a, 0, r);
                                        n -= 1;
                                    }
                                }
                            }
                        },
                        _processObxAndItem: function (e, t, n) {
                            for (var i = 0, a = e.obxInfoList.length; i < a; i++) {
                                var o = e.obxInfoList[i],
                                    r = this._findObxById(o.refId, n.contained);
                                if (r) {
                                    if (o.total > 1 && 0 === o.index) {
                                        this._addRepeatingItems(t, o.code, o.total);
                                    }
                                    var s = this._findTheMatchingItemByCodeAndIndex(t, o.code, o.index);
                                    this._setupItemValueAndUnit(r, s);
                                    if (o.obxInfoList && o.obxInfoList.length > 0) {
                                        this._processObxAndItem(o, s, n);
                                    }
                                }
                            }
                        },
                        _convertFromBundleToContained: function (e) {
                            var t;
                            if (e && 'searchset' === e.type) {
                                for (var n = e.entry, i = 0, a = n.length; i < a; i++) {
                                    if ('DiagnosticReport' === n[i].resource.resourceType) {
                                        for (var o = 0, r = (t = n[i].resource).result.length; o < r; o++) {
                                            var s = t.result[o];
                                            if (s.reference && s.reference.match(new RegExp(this._OBX_REF_PREFIX))) {
                                                s.reference = s.reference.slice(this._OBX_REF_PREFIX.length);
                                            }
                                        }
                                        t.contained = [];
                                        break;
                                    }
                                }
                                if (t) {
                                    for (i = 0, a = n.length; i < a; i++) {
                                        if ('Observation' === n[i].resource.resourceType) {
                                            var c = n[i].resource;
                                            if (c.related) {
                                                for (o = 0, r = c.related.length; o < r; o++) {
                                                    var l = c.related[o];
                                                    if (
                                                        l.target &&
                                                        l.target.reference &&
                                                        l.target.reference.match(new RegExp(this._OBX_REF_PREFIX))
                                                    ) {
                                                        l.target.reference = l.target.reference.slice(
                                                            this._OBX_REF_PREFIX.length,
                                                        );
                                                    }
                                                }
                                            }
                                            t.contained.push(c);
                                        }
                                    }
                                }
                            }
                            return t;
                        },
                        mergeDiagnosticReportToLForms: function (e, t) {
                            if (!(e instanceof LForms.LFormsData)) {
                                e.hasSavedData = !0;
                                e = new LForms.LFormsData(e).getFormData();
                            }
                            var n = t && 'Bundle' === t.resourceType ? this._convertFromBundleToContained(t) : t,
                                i = this._getReportStructure(n);
                            this._processObxAndItem(i, e, n);
                            return e;
                        },
                    };
                t.A = a;
            },
            561: function (e, t) {
                'use strict';
                var n = 'lformsVersion: ',
                    i = {
                        _createObservation: function (e, t) {
                            var n = [],
                                i = e.dataType;
                            if ((!i || 'ST' === i) && e.units && e.units.length > 0) {
                                i = 'REAL';
                            }
                            switch (i) {
                                case 'INT':
                                    n = [this._createObsIntValue(e)];
                                    break;
                                case 'REAL':
                                case 'QTY':
                                    var a = { value: e.value };
                                    this._setFHIRQuantityUnit(a, e.unit);
                                    n = [{ key: 'valueQuantity', val: a }];
                                    break;
                                case 'DT':
                                    n = [{ key: 'valueDate', val: e.value }];
                                    break;
                                case 'DTM':
                                    n = [{ key: 'valueDateTime', val: e.value }];
                                    break;
                                case 'CODING':
                                    var o,
                                        r = e.answerCardinality.max;
                                    if (r && ('*' === r || parseInt(r) > 1)) {
                                        o = e.value;
                                    } else {
                                        o = [e.value];
                                    }
                                    for (var s = 0, c = o.length; s < c; s++) {
                                        var l = o[s];
                                        if ('object' == typeof l) {
                                            var u = {};
                                            if (l.code) {
                                                u.code = l.code;
                                            }
                                            if (l.text) {
                                                u.display = l.text;
                                            }
                                            var d = l.system;
                                            if (d) {
                                                u.system = LForms.Util.getCodeSystem(d);
                                            }
                                            n.push({
                                                key: 'valueCodeableConcept',
                                                val: { coding: [u], text: u.display },
                                            });
                                        } else if ('string' == typeof l) {
                                            if ('' !== l) {
                                                n.push({ key: 'valueString', val: l });
                                            }
                                        }
                                    }
                                    break;
                                case 'attachment':
                                    n = [{ key: 'valueAttachment', val: e.value }];
                                    break;
                                case 'BL':
                                    n = [{ key: 'valueBoolean', val: e.value }];
                                    break;
                                default:
                                    n = [{ key: 'valueString', val: e.value }];
                            }
                            for (var m = [], p = 0, f = n.length; p < f; p++) {
                                var g = {
                                    resourceType: 'Observation',
                                    status: 'final',
                                    code: { coding: e.codeList, text: e.question },
                                };
                                this._addVersionTag(g);
                                if (t) {
                                    g.id = this._getUniqueId(e.questionCode);
                                }
                                if (!e.header) {
                                    g[n[p].key] = n[p].val;
                                }
                                m.push(g);
                            }
                            return m;
                        },
                        _getUniqueId: function (e) {
                            this._idCtr || (this._idCtr = 0);
                            return (
                                e + '-' + Date.now() + '-' + ++this._idCtr + '-' + Math.random().toString(16).substr(2)
                            );
                        },
                        _setFHIRQuantityUnit: function (e, t) {
                            if (t) {
                                if (t.name) {
                                    e.unit = t.name;
                                }
                                if (t.code) {
                                    e.code = t.code;
                                }
                                if (t.system) {
                                    e.system = t.system;
                                }
                            }
                        },
                        _resTags: function (e) {
                            var t = e.meta;
                            if (!t) {
                                t = e.meta = {};
                            }
                            var n = t.tag;
                            if (!n) {
                                n = t.tag = [];
                            }
                            return n;
                        },
                        _setVersionTag: function (e) {
                            for (var t = this._resTags(e), i = 0, a = t.length; i < a; ++i) {
                                var o = t[i];
                                if (o.code && 0 === o.code.indexOf(n)) {
                                    t.splice(i, 1);
                                    break;
                                }
                            }
                            this._addVersionTag(e);
                        },
                        _addVersionTag: function (e) {
                            this._resTags(e).push({ code: n + LForms.lformsVersion });
                        },
                    };
                t.A = i;
            },
            5252: function (e, t, n) {
                'use strict';
                n.d(t, {
                    F: function () {
                        return i;
                    },
                });
                let i = 'http://loinc.org';
            },
            6332: function (e, t, n) {
                'use strict';
                n.d(t, {
                    I: function () {
                        return i;
                    },
                });

                function i(e) {
                    const t = { _type: 'Quantity', value: e.value },
                        n = e.unit || e.code;
                    if (n) {
                        t.name = n;
                        if (e.code) {
                            t.code = e.code;
                        }
                        if (e.system) {
                            t.system = e.system;
                        }
                    }
                    return t;
                }
            },
            5844: function (e, t, n) {
                'use strict';
                n.d(t, {
                    C: function () {
                        return o;
                    },
                });
                var i = function (e, t, n) {
                        var i = n.valueString;
                        if (i) {
                            e['_' + t + 'CSS'] = i;
                        }
                    },
                    a = {};
                a['http://hl7.org/fhir/StructureDefinition/rendering-style'] = i;

                function o(e) {
                    e.processExtensions = function (e, t) {
                        var n = t ? e[t] : e;
                        if (n) {
                            var i = n.extension;
                            if (i) {
                                for (var o = 0, r = i.length; o < r; ++o) {
                                    var s = i[o],
                                        c = s.url,
                                        l = a[c];
                                    if (l) {
                                        l(e, t, s);
                                    }
                                }
                            }
                        }
                    };
                }
            },
            7360: function (e, t, n) {
                'use strict';
                n.d(t, {
                    A: function () {
                        return a;
                    },
                });

                function i(e) {
                    if (LForms.fhirContext?.client && e._fhir) {
                        if (!LForms._serverFHIRReleaseID) {
                            return new Promise(function (t, n) {
                                LForms.Util.getServerFHIRReleaseID(function (a) {
                                    if (!a) {
                                        n("Unable to obtain the server's FHIR version");
                                    } else {
                                        t(i(e));
                                    }
                                });
                            });
                        } else {
                            var t = [];
                            LForms.Util.validateFHIRVersion(LForms._serverFHIRReleaseID);
                            var n = LForms.FHIR[LForms._serverFHIRReleaseID];
                            let i = e._fhir.SDC.fhirExtObsLinkPeriod;
                            for (var a = 0, o = e.itemList.length; a < o; ++a) {
                                let o = e.itemList[a];
                                const u = o._fhirExt && o._fhirExt[i];
                                if (u) {
                                    var r = u[0].valueDuration,
                                        s = LForms.fhirContext.client;
                                    const i = {
                                        code: o.codeList
                                            .map(e => ['LOINC' === e.system ? n.LOINC_URI : e.system, e.code].join('|'))
                                            .join(','),
                                        _sort: '-date',
                                        status: 'final,amended,corrected',
                                        _count: 5,
                                    };
                                    if (r && r.value && r.code) {
                                        var c = LForms.ucumPkg.UcumLhcUtils.getInstance().convertUnitTo(
                                            r.code,
                                            r.value,
                                            'ms',
                                        );
                                        if ('succeeded' === c.status) {
                                            var l = new Date(new Date() - c.toVal);
                                            i.date = 'gt' + l.toISOString();
                                        }
                                    }
                                    t.push(
                                        s.patient.request(e._buildURL(['Observation'], i)).then(function (t) {
                                            var i = t;
                                            if (i.entry) {
                                                for (var a, r = 0, s = i.entry.length; r < s && !a; ++r) {
                                                    var c = i.entry[r].resource;
                                                    if (!c.focus) {
                                                        n.SDC.importObsValue(o, c);
                                                        if (o.value) {
                                                            a = !0;
                                                            if (o.unit) {
                                                                e._setUnitDisplay(o.unit);
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            return o.questionCode;
                                        }),
                                    );
                                }
                            }
                            return Promise.all(t);
                        }
                    }
                }

                var a = function (e) {
                    var t = e;
                    t.requestLinkedObs = i;
                    t._lformsTypesToFHIRTypes = {
                        SECTION: 'group',
                        TITLE: 'display',
                        ST: 'string',
                        BL: 'boolean',
                        REAL: 'decimal',
                        INT: 'integer',
                        DT: 'date',
                        DTM: 'dateTime',
                        TM: 'time',
                        TX: 'text',
                        URL: 'url',
                        CODING: 'coding',
                        QTY: 'quantity',
                        attachment: 'attachment',
                    };
                    t._lformsTypesToFHIRFields = {
                        attachment: 'Attachment',
                        INT: 'Integer',
                        REAL: 'Decimal',
                        DT: 'Date',
                        DTM: 'DateTime',
                        TM: 'Time',
                        ST: 'String',
                        TX: 'String',
                        BL: 'Boolean',
                        URL: 'Url',
                        CODING: 'Coding',
                        QTY: 'Quantity',
                    };
                    t._operatorMapping = {
                        minExclusive: '>',
                        maxExclusive: '<',
                        minInclusive: '>=',
                        maxInclusive: '<=',
                        value: '=',
                        notEqual: '!=',
                        '>': 'minExclusive',
                        '<': 'maxExclusive',
                        '>=': 'minInclusive',
                        '<=': 'maxInclusive',
                        '=': 'value',
                        '!=': 'notEqual',
                        exists: 'exists',
                    };
                    t._questionRepeats = function (e) {
                        return void 0 !== e._questionRepeatable
                            ? e._questionRepeatable
                            : e.questionCardinality &&
                                  e.questionCardinality.max &&
                                  ('*' === e.questionCardinality.max || parseInt(e.questionCardinality.max) > 1);
                    };
                    t._answerRepeats = function (e) {
                        return void 0 !== e._multipleAnswers
                            ? e._multipleAnswers
                            : e.answerCardinality &&
                                  e.answerCardinality.max &&
                                  ('*' === e.answerCardinality.max || parseInt(e.answerCardinality.max) > 1);
                    };
                    t.copyFields = function (e, t, n) {
                        if (e && t && n && n.length > 0) {
                            n.forEach(function (n) {
                                if (e.hasOwnProperty(n)) {
                                    t[n] = e[n];
                                }
                            });
                        }
                    };
                    t.UCUM_URI = 'http://unitsofmeasure.org';
                    t._setIfHasValue = function (e, t, n) {
                        if (null != n && '' !== n) {
                            if (!e) {
                                e = {};
                            }
                            e[t] = n;
                        }
                        return e;
                    };
                    t._copyTriggerCoding = function (e, n, i) {
                        let a = i ? 'text' : 'display',
                            o = i ? 'display' : 'text';
                        n = t._setIfHasValue(n, 'code', e.code);
                        n = t._setIfHasValue(n, 'system', e.system);
                        return (n = t._setIfHasValue(n, o, e[a]));
                    };
                    t.hasResponsiveExpression = function (e) {
                        var n = e._fhirExt;
                        return n
                            ? !!(n[t.fhirExtCalculatedExp] || n[t.fhirExtAnswerExp] || n[t.fhirExtEnableWhenExp])
                            : !1;
                    };
                    t.hasListExpression = function (e) {
                        var n = e._fhirExt;
                        return n ? !!n[t.fhirExtAnswerExp] : !1;
                    };
                    t.hasInitialExpression = function (e) {
                        return !(!e._fhirExt || !e._fhirExt[t.fhirExtInitialExp]);
                    };
                    t.buildExtensionMap = function (e) {
                        if (!t.isExpressionExtension) {
                            t.isExpressionExtension = [
                                t.fhirExtCalculatedExp,
                                t.fhirExtInitialExp,
                                t.fhirExtAnswerExp,
                                t.fhirExtVariable,
                                t.fhirExtEnableWhenExp,
                            ].reduce((e, t) => {
                                e[t] = !0;
                                return e;
                            }, {});
                        }
                        if (e.extension) {
                            var n = {},
                                i = [];
                            for (let o of e.extension) {
                                var a = n[o.url];
                                if (!a) {
                                    a = n[o.url] = [];
                                }
                                a.push(o);
                                if (t.isExpressionExtension[o.url]) {
                                    i.push(o);
                                }
                            }
                            e._fhirExt = n;
                            if (i.length) {
                                e._exprExtensions = i;
                            }
                        }
                    };
                    t.buildContainedImageMap = function (e) {
                        let t,
                            n = {};
                        if (e && Array.isArray(e)) {
                            const i = ['image/bmp', 'image/jpeg', 'image/x-png', 'image/png', 'image/gif'];
                            e.forEach(e => {
                                if ('Binary' === e.resourceType && e.id && i.includes(e.contentType)) {
                                    n[e.id] = 'data:' + e.contentType + ';base64,' + e.data;
                                    t = !0;
                                }
                            });
                        }
                        return t ? n : null;
                    };
                    t.loadLaunchContext = function (e) {
                        var n = LForms.Util.findObjectInArray(e.extension, 'url', t.fhirExtLaunchContext, 0, !0);
                        const i = {
                                patient: { Patient: 1 },
                                encounter: { Encounter: 1 },
                                user: { Patient: 1, Practitioner: 1, PractitionerRole: 1, RelatedPerson: 1 },
                            },
                            a = [];

                        function o(t, n, a) {
                            let o = a.resourceType,
                                r = i[t];
                            if (r && !r[o]) {
                                console.warn(
                                    'a launch context resource of type ' +
                                        restype +
                                        ' was found for name ' +
                                        t +
                                        ', but the supported types for name ' +
                                        t +
                                        ' are: ' +
                                        Object.keys(r).join(', '),
                                );
                            } else if (-1 == n.indexOf(o)) {
                                console.warn(
                                    'Could not retrieve a resource of the requested types for launch context name ' + t,
                                );
                            } else {
                                e._fhirVariables[t] = a;
                            }
                        }

                        for (var r = 0, s = n.length; r < s; ++r) {
                            let t = n[r].extension,
                                i = null,
                                s = [];
                            for (var c = 0, l = t.length; c < l; ++c) {
                                var u = t[c];
                                if (!i && 'name' === u.url) {
                                    if (u.valueId) {
                                        console.log(
                                            "Warning:  The type of the launchContext 'name' field should be 'Coding', not 'id'.",
                                        );
                                        i = u.valueId;
                                    } else {
                                        i = u.valueCoding?.code;
                                    }
                                    e._checkFHIRVarName(i);
                                } else if ('type' === u.url) {
                                    s.push(u.valueCode);
                                }
                            }
                            if (i && s.length) {
                                a.push(
                                    new Promise(function (e, t) {
                                        let n = LForms.fhirContext.vars?.[i],
                                            a = LForms.fhirContext.client?.[i];
                                        if (!n && !a.id) {
                                            console.warn(
                                                'A launch context resource of name ' +
                                                    i +
                                                    ' was requested by the form, but none was available',
                                            );
                                            e();
                                        } else if (n) {
                                            o(i, s, n);
                                            e();
                                        } else {
                                            a.read().then(
                                                function (t) {
                                                    if (t) {
                                                        o(i, s, t);
                                                    }
                                                    e();
                                                },
                                                function (t) {
                                                    console.warn(
                                                        'A launch context of name ' +
                                                            i +
                                                            ' was requested, but could not be read.',
                                                    );
                                                    console.error(t);
                                                    e();
                                                },
                                            );
                                        }
                                    }),
                                );
                            }
                        }
                        return a;
                    };
                };
            },
            3544: function (e, t) {
                'use strict';
                t.A = function (e) {
                    var t = e;
                    t.convertLFormsToQuestionnaireResponse = function (e, t, n) {
                        var i = null;
                        if (e) {
                            var a = e.getFormData(!0, !0, !0);
                            if (!e._invalidData) {
                                i = {};
                                this._processRepeatingItemValues(a);
                                this._setResponseFormLevelFields(i, a, t);
                                if (this._processQRQuestionnaire) {
                                    this._processQRQuestionnaire(i, a);
                                }
                                if (a.items && Array.isArray(a.items)) {
                                    var o = this._processResponseItem(a, !0);
                                    if (o && o.item && o.item.length) {
                                        i.item = o.item;
                                    }
                                }
                                LForms.Util.pruneNulls(i);
                                if (n) {
                                    i.subject = LForms.Util.createLocalFHIRReference(n);
                                }
                                this._commonExport._setVersionTag(i);
                            }
                        }
                        return i;
                    };
                    t.convertLFormsToQuestionnaire = function (e) {
                        var t = {};
                        if (e) {
                            var n = LForms.Util.deepCopy(e);
                            if (!(n instanceof LForms.LFormsData)) {
                                n = new LForms.LFormsData(n);
                            }
                            this._removeRepeatingItems(n);
                            this._setFormLevelFields(t, n);
                            if (n.items && Array.isArray(n.items)) {
                                t.item = [];
                                for (var i = 0, a = n.items.length; i < a; i++) {
                                    var o = this._processItem(n.items[i], n);
                                    t.item.push(o);
                                }
                            }
                        }
                        LForms.Util.pruneNulls(t);
                        this._commonExport._setVersionTag(t);
                        return t;
                    };
                    t._processItem = function (e, n) {
                        var i = {};
                        i.type = this._getFhirDataType(e);
                        if (this._handleAnswerConstraint) {
                            this._handleAnswerConstraint(i, e);
                        }
                        if (e.codeList && e.codeList.length > 0) {
                            i.code = e.codeList;
                        }
                        i.extension = e.extension || [];
                        if (!0 === e._answerRequired) {
                            i.required = e._answerRequired;
                        }
                        if (i.required) {
                            var a = parseInt(e.questionCardinality.min);
                            if (a > 1) {
                                i.extension.push({
                                    url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-minOccurs',
                                    valueInteger: a,
                                });
                            }
                        }
                        this._processQuestionAndAnswerCardinality(i, e);
                        this._handleItemControl(i, e);
                        this._handleRestrictions(i, e);
                        if (e.isHiddenInDef) {
                            i.extension.push({
                                url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-hidden',
                                valueBoolean: !0,
                            });
                        }
                        i.linkId = e.linkId;
                        i.text = e.question;
                        if (e.prefix) {
                            i.prefix = e.prefix;
                        }
                        for (let t of ['_prefix', '_text']) {
                            let n = e['obj' + t];
                            if (n) {
                                i[t] = n;
                            }
                        }
                        if (e.skipLogic) {
                            this._handleSkipLogic(i, e, n);
                        }
                        if ('SECTION' !== e.dataType && 'TITLE' !== e.dataType && '0' === e.editable) {
                            i.readOnly = !0;
                        }
                        this._handleChoiceField(i, e);
                        this._handleTerminologyServer(i, e);
                        this._handleInitialValues(i, e);
                        if (e.units) {
                            this._handleLFormsUnits(i, e);
                        }
                        this._handleDataControl(i, e);
                        if (this._handleDisabledDisplay) {
                            this._handleDisabledDisplay(i, e);
                        }
                        if (e.items && Array.isArray(e.items)) {
                            i.item = [];
                            for (var o = 0, r = e.items.length; o < r; o++) {
                                var s = this._processItem(e.items[o], n);
                                i.item.push(s);
                            }
                        }
                        if (e.codingInstructions) {
                            let t = {
                                text: e.codingInstructionsPlain ? e.codingInstructionsPlain : e.codingInstructions,
                                type: 'display',
                                linkId: i.linkId + '-help',
                                extension: [
                                    {
                                        url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
                                        valueCodeableConcept: {
                                            text: 'Help-Button',
                                            coding: [
                                                {
                                                    code: 'help',
                                                    display: 'Help-Button',
                                                    system: 'http://hl7.org/fhir/questionnaire-item-control',
                                                },
                                            ],
                                        },
                                    },
                                ],
                            };
                            if ('html' === e.codingInstructionsFormat) {
                                t._text = {
                                    extension: [
                                        {
                                            url: 'http://hl7.org/fhir/StructureDefinition/rendering-xhtml',
                                            valueString: e.codingInstructions,
                                        },
                                    ],
                                };
                            }
                            if (Array.isArray(i.item)) {
                                i.item.push(t);
                            } else {
                                i.item = [t];
                            }
                        }
                        if (e.maxAttachmentSize) {
                            var c = i.extension || (i.extension = []);
                            c.push({ url: t.fhirExtMaxSize, valueDecimal: e.maxAttachmentSize });
                        }
                        if (e.allowedAttachmentTypes) {
                            c = i.extension || (i.extension = []);
                            for (let n of e.allowedAttachmentTypes) {
                                c.push({ url: t.fhirExtMimeType, valueCode: n });
                            }
                        }
                        this._handleSpecialConstraints(i, e);
                        if (0 === i.extension.length) {
                            delete i.extension;
                        }
                        this.copyFields(e, i, this.itemLevelIgnoredFields);
                        return i;
                    };
                    t._processQuestionAndAnswerCardinality = function (e, n) {
                        var i = 0,
                            a = n.questionCardinality,
                            o = n.answerCardinality,
                            r = a && void 0 !== a.max ? a.max : null,
                            s = o && void 0 !== o.max ? o.max : null;
                        if ('*' === r || '*' === s) {
                            if ('TITLE' !== n.dataType) {
                                e.repeats = !0;
                            }
                        } else {
                            var c = parseInt(r),
                                l = parseInt(s);
                            if (c > 1 || l > 1) {
                                if ('TITLE' !== n.dataType) {
                                    e.repeats = !0;
                                    if (!isNaN(c) && !isNaN(l)) {
                                        i = Math.max(c, l);
                                    } else if (!isNaN(c)) {
                                        i = c;
                                    } else if (!isNaN(l)) {
                                        i = l;
                                    }
                                    if (i > 1) {
                                        e.extension.push({ url: t.fhirExtUrlCardinalityMax, valueInteger: i });
                                    }
                                }
                            }
                        }
                    };
                    t._handleExternallyDefined = function (e, n) {
                        if (n.externallyDefined) {
                            e.extension.push({ url: t.fhirExtUrlExternallyDefined, valueUri: n.externallyDefined });
                        }
                    };
                    t._handleDataControl = function (e, t) {
                        if (t.dataControl) {
                            e.extension.push({
                                url: 'http://lhcforms.nlm.nih.gov/fhirExt/dataControl',
                                valueString: JSON.stringify(t.dataControl),
                            });
                        }
                    };
                    t._removeRepeatingItems = function (e) {
                        if (e.items && Array.isArray(e.items)) {
                            for (var t = e.items.length - 1; t >= 0; t--) {
                                if (e.items[t]._id > 1) {
                                    e.items.splice(t, 1);
                                } else {
                                    this._removeRepeatingItems(e.items[t]);
                                }
                            }
                        }
                    };
                    t._setFormLevelFields = function (e, t) {
                        this.copyFields(t, e, this.formLevelFields);
                        e.name = t.shortName;
                        e.title = t.name;
                        if (t.obj_title) {
                            e._title = t.obj_title;
                        }
                        e.code = t.codeList;
                        e.resourceType = 'Questionnaire';
                        e.status = e.status ? e.status : 'draft';
                        if (t.copyrightNotice) {
                            e.copyright = t.copyrightNotice;
                        }
                        this._handleMeta(e);
                    };
                    t._handleMeta = function (e) {
                        e.meta = e.meta ? e.meta : {};
                        this._handleMetaProfile(e.meta);
                    };
                    t._handleMetaProfile = function (e) {
                        const t = LForms.Util.detectFHIRVersionFromProfiles([this.stdQProfile]),
                            n = [];
                        if (e.profile?.length > 0) {
                            for (let i = 0; i < e.profile.length; i++) {
                                const a = LForms.Util.detectFHIRVersionFromProfiles([e.profile[i]]);
                                if (!a || (a === t && e.profile[i] !== this.stdQProfile)) {
                                    n.push(e.profile[i]);
                                }
                            }
                        }
                        n.push(this.stdQProfile);
                        e.profile = n;
                    };
                    t._handleItemControl = function (e, t) {
                        var n,
                            i,
                            a = '';
                        if (!LForms.jQuery.isEmptyObject(t.displayControl)) {
                            var o = this._getAssumedDataTypeForExport(t);
                            if (
                                t.displayControl.answerLayout &&
                                ('CODING' === t.dataType ||
                                    (t.answers &&
                                        ('ST' === t.dataType ||
                                            'INT' === t.dataType ||
                                            'DT' === t.dataType ||
                                            'TM' === t.dataType)))
                            ) {
                                if (t.externallyDefined || (t.answerValueSet && t.isSearchAutocomplete)) {
                                    a = 'autocomplete';
                                    n = 'Auto-complete';
                                } else if ('COMBO_BOX' === t.displayControl.answerLayout.type) {
                                    a = 'drop-down';
                                    n = 'Drop down';
                                } else if ('RADIO_CHECKBOX' === t.displayControl.answerLayout.type) {
                                    if (
                                        t.answerCardinality &&
                                        ('*' === t.answerCardinality.max || parseInt(t.answerCardinality.max) > 1)
                                    ) {
                                        a = 'check-box';
                                        n = 'Check-box';
                                    } else {
                                        a = 'radio-button';
                                        n = 'Radio Button';
                                    }
                                    if ('0' === t.displayControl.answerLayout.columns) {
                                        i = 'horizontal';
                                    } else if ('1' === t.displayControl.answerLayout.columns) {
                                        i = 'vertical';
                                    }
                                }
                            } else if (t.displayControl.questionLayout && 'SECTION' === o) {
                                if ('horizontal' === t.displayControl.questionLayout) {
                                    a = 'gtable';
                                    n = 'Group Table';
                                } else if ('matrix' === t.displayControl.questionLayout) {
                                    a = 'table';
                                    n = 'Vertical Answer Table';
                                }
                            }
                            if (a) {
                                e.extension.push({
                                    url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl',
                                    valueCodeableConcept: {
                                        coding: [
                                            {
                                                system: 'http://hl7.org/fhir/questionnaire-item-control',
                                                code: a,
                                                display: n,
                                            },
                                        ],
                                        text: n || a,
                                    },
                                });
                                if (i) {
                                    e.extension.push({
                                        url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation',
                                        valueCode: i,
                                    });
                                }
                            }
                        }
                    };
                    t._handleTerminologyServer = function (e, n) {
                        if (n.terminologyServer) {
                            e.extension.push({ url: t.fhirExtTerminologyServer, valueUrl: n.terminologyServer });
                        }
                    };
                    t._getAssumedDataTypeForExport = function (e) {
                        var t = e.dataType;
                        if (('REAL' === e.dataType || 'INT' === e.dataType) && e.units && e.units.length > 1) {
                            t = 'QTY';
                        }
                        return t;
                    };
                    t._makeValueQuantity = function (e, n, i) {
                        let a = {},
                            o = parseFloat(e);
                        if (!isNaN(o)) {
                            a.value = o;
                        }
                        if (n) {
                            t._setUnitAttributesToFhirQuantity(a, n);
                            if (i) {
                                a.system = i;
                            }
                        }
                        return Object.keys(a).length > 0 ? a : null;
                    };
                    t._makeQuantity = function (e, t, n) {
                        var i = this._getDefaultUnit(t);
                        return this._makeValueQuantity(e, i, n);
                    };
                    t._getDefaultUnit = function (e) {
                        if (!e || 0 === e.length) {
                            return null;
                        }
                        for (var t = null, n = 0; n < e.length; n++) {
                            if (e[n].default) {
                                t = e[n];
                                break;
                            }
                        }
                        if (!t) {
                            t = e[0];
                        }
                        return t;
                    };
                    t._getValueKeyByDataType = function (e, t) {
                        if (!e) {
                            e = 'value';
                        }
                        var n = 'quantity' === this._getFhirDataType(t) ? 'QTY' : t.dataType;
                        return e + this._lformsTypesToFHIRFields[n];
                    };
                    t._MIN_MAX_TYPES = ['DT', 'DTM', 'TM', 'REAL', 'INT'].reduce((e, t) => {
                        e[t] = t;
                        return e;
                    }, {});
                    t._MIN_MAX_KEYS = ['minExclusive', 'minInclusive', 'maxExclusive', 'maxInclusive'].reduce(
                        (e, t) => {
                            e[t] = t;
                            return e;
                        },
                        {},
                    );
                    t._exportMinMax = function (e, n, i, a) {
                        if (null != n && t._MIN_MAX_TYPES[e] && t._MIN_MAX_KEYS[a]) {
                            var o =
                                    'DT' === e || 'DTM' === e
                                        ? new Date(n).toISOString()
                                        : 'TM' == e
                                        ? new Date('1970-01-01T' + n + 'Z').toISOString()
                                        : null,
                                r =
                                    'DT' === e
                                        ? o.substring(0, 10)
                                        : 'DTM' === e
                                        ? o
                                        : 'TM' === e
                                        ? o.substring(11, o.length - 1)
                                        : 'REAL' === e
                                        ? parseFloat(n)
                                        : parseInt(n);
                            return {
                                url:
                                    0 === a.indexOf('min')
                                        ? 'http://hl7.org/fhir/StructureDefinition/minValue'
                                        : 'http://hl7.org/fhir/StructureDefinition/maxValue',
                                [i]: r,
                            };
                        }
                    };
                    t._skipLogicValueDataTypes = [
                        'BL',
                        'REAL',
                        'INT',
                        'QTY',
                        'DT',
                        'DTM',
                        'TM',
                        'ST',
                        'TX',
                        'URL',
                    ].reduce((e, t) => {
                        e[t] = t;
                        return e;
                    }, {});
                    t._createEnableWhenRulesForSkipLogicCondition = function (e, n) {
                        let i = this._getAssumedDataTypeForExport(n),
                            a = this._getValueKeyByDataType('answer', n),
                            o = [];
                        Object.keys(e.trigger).forEach(function (r) {
                            let s = t._operatorMapping[r],
                                c = e.trigger[r];
                            if (!s || (0 !== c && !1 !== c && !c)) {
                                throw new Error(
                                    'Invalid lforms skip logic trigger: ' + JSON.stringify(e.trigger, null, 4),
                                );
                            }
                            let l = null;
                            if ('exists' === s) {
                                l = { answerBoolean: c };
                            } else if ('CODING' === i) {
                                let e = t._copyTriggerCoding(c, null, !0);
                                if (!e) {
                                    throw new Error('Invalid CODING trigger, key=' + r + '; value=' + c);
                                }
                                l = { answerCoding: e };
                            } else if (i && t._skipLogicValueDataTypes[i]) {
                                let e = c;
                                if ('answerQuantity' === a) {
                                    e = t._makeQuantity(e, n.units);
                                }
                                if (0 === e || !1 === e || e) {
                                    l = { [a]: e };
                                } else {
                                    throw new Error('Invalid value for trigger ' + r + ': ' + c);
                                }
                            } else {
                                throw new Error('Unsupported data type for skip logic export: ' + i);
                            }
                            l.question = n.linkId;
                            l.operator = s;
                            o.push(l);
                        });
                        return o;
                    };
                    t._setResponseFormLevelFields = function (e, t, n) {
                        e.resourceType = 'QuestionnaireResponse';
                        var i = n ? this.stdQRProfile : this.QRProfile;
                        e.meta = e.meta ? e.meta : {};
                        e.meta.profile = e.meta.profile ? e.meta.profile : [i];
                        e.status = 'completed';
                        e.authored = LForms.Util.dateToDTMString(new Date());
                    };
                    t._setUnitAttributesToFhirQuantity = function (e, t) {
                        if (e && t) {
                            if (t.name) {
                                e.unit = t.name;
                            }
                            if (t.code) {
                                e.code = t.code;
                            }
                            if (t.system) {
                                e.system = t.system;
                            }
                        }
                    };
                    t._createFhirUnitCoding = function (e) {
                        var t = null;
                        if (e) {
                            t = {};
                            if (e.code) {
                                t.code = e.code;
                            }
                            if (e.name) {
                                t.display = e.name;
                            }
                            if (e.system) {
                                t.system = e.system;
                            }
                        }
                        return t;
                    };
                    t._lfHasSubItems = function (e) {
                        return e && e.items && Array.isArray(e.items) && e.items.length > 0;
                    };
                    t._processResponseItem = function (e, t) {
                        if (t && 'boolean' != typeof t) {
                            throw new Error(
                                '_processResponseItem function signature has been changed, please check/fix.',
                            );
                        }
                        let n = null,
                            i = !1;
                        if (!t && 'TITLE' !== e.dataType && 'SECTION' !== e.dataType) {
                            n = this._setIfHasValue(n, 'answer', this._lfItemValueToFhirAnswer(e));
                            i = !n?.answer;
                        }
                        if (!i) {
                            if (!n) {
                                n = {};
                            }
                            if (!t && 'TITLE' != e.dataType) {
                                (n.linkId = e.linkId), (n.text = e.question);
                            }
                            if (this._lfHasSubItems(e)) {
                                for (var a = [], o = 0; o < e.items.length; ++o) {
                                    var r = e.items[o];
                                    if (!r._isProcessed) {
                                        var s = r.linkId,
                                            c = e._repeatingItems && e._repeatingItems[s];
                                        if (c) {
                                            let t = { linkId: s, text: r.question, answer: [] };
                                            for (var l = 0; l < c.length; ++l) {
                                                var u = c[l],
                                                    d = this._processResponseItem(u);
                                                if (d?.answer) {
                                                    Array.prototype.push.apply(t.answer, d.answer);
                                                }
                                                u._isProcessed = !0;
                                            }
                                            if (t.answer.length > 0) {
                                                a.push(t);
                                            }
                                            delete e._repeatingItems[s];
                                        } else {
                                            let e = this._processResponseItem(r);
                                            if (e) {
                                                a.push(e);
                                            }
                                        }
                                    }
                                    if (r._isProcessed) {
                                        delete r._isProcessed;
                                    }
                                }
                                if (a.length > 0) {
                                    if (!t && 'SECTION' !== e.dataType) {
                                        n.answer = n.answer || [];
                                        n.answer[0] = n.answer[0] || {};
                                        n.answer[0].item = a;
                                    } else {
                                        n.item = a;
                                    }
                                }
                            }
                        }
                        return n;
                    };
                    t._processRepeatingItemValues = function (e) {
                        if (e.items) {
                            for (var t = 0, n = e.items.length; t < n; t++) {
                                var i = e.items[t];
                                if ('TITLE' !== i.dataType && 'SECTION' !== i.dataType && this._questionRepeats(i)) {
                                    var a = i.linkId;
                                    e._repeatingItems = e._repeatingItems || {};
                                    e._repeatingItems[a] = e._repeatingItems[a] || [];
                                    e._repeatingItems[a].push(i);
                                }
                                if (this._lfHasSubItems(i)) {
                                    this._processRepeatingItemValues(i);
                                }
                            }
                        }
                    };
                    t._getExtractValue = function (e) {
                        let t = e;
                        for (;;) {
                            if (t._fhirExt && t._fhirExt[this.fhirExtObsExtract]) {
                                return t._fhirExt[this.fhirExtObsExtract][0].valueBoolean;
                            } else if (!t._parentItem) {
                                return !1;
                            }
                            t = t._parentItem;
                        }
                    };
                    t._hasItemValue = function (e) {
                        return 'SECTION' !== e.dataType &&
                            'TITLE' !== e.dataType &&
                            'target-disabled' !== e._skipLogicStatus &&
                            !LForms.Util.isItemValueEmpty(e.value)
                            ? !0
                            : !1;
                    };
                };
            },
            5336: function (e, t, n) {
                'use strict';
                n.d(t, {
                    A: function () {
                        return f;
                    },
                });
                const i = {
                    messages: {
                        comparatorInQuantity: { en: 'This item cannot accept a quantity with a comparator' },
                        nonMatchingQuantityUnit: {
                            en: 'An attempt was made to assign a quantity with a non-matching unit.',
                        },
                        MultipleValuesForNonRepeat: {
                            en: 'An attempt was made to assign multiple values to a non-repeating item.',
                        },
                        invalidTagInHelpHTMLContent: { en: 'Invalid HTML tags/attributes found in the help text.' },
                        invalidTagInHTMLContent: { en: 'Invalid HTML tags/attributes found in item text.' },
                    },
                    getMsg: function (e) {
                        const t = this.messages[e];
                        if (!t) {
                            throw new Error('Unknown message ID "' + e + '"');
                        }
                        const n = t[this.language];
                        if (!n) {
                            throw new Error('Unknown language code "' + this.language + '" for message ID "' + e + '"');
                        }
                        return n;
                    },
                    addMsg: function (e, t) {
                        e[t] = this.getMsg(t);
                    },
                    setLanguage: function (e) {
                        this.language = e;
                    },
                };
                var a = n(2198),
                    o = n.n(a),
                    r = n(7337),
                    s = n(6795),
                    c = n.n(s);
                var l = {
                    parseDateFormats: [
                        'M/D/YYYY',
                        'M/D/YY',
                        'M/D',
                        'M-D-YYYY',
                        'M-D-YY',
                        'M-D',
                        'YYYY',
                        'YYYY-M-D',
                        'YYYY/M/D',
                        o().ISO_8601,
                        'M/D/YYYY HH:mm',
                        'M/D/YY HH:mm',
                        'M/D HH:mm',
                        'M-D-YYYY HH:mm',
                        'M-D-YY HH:mm',
                        'M-D HH:mm',
                    ],
                    intRegex: /^\s*(\+|-)?\d+\s*$/,
                    decRegex: /^\s*[\+-]?([\+-]?\d+\.?\d*([eE]?[\+|-]?\d+)?|[\+-]?\d*\.?\d+[eE]?([\+|-]?\d+)?)\s*$/,
                    areTwoAnswersSame: function (e, t, n) {
                        let i = ['label', 'code', 'text', 'score', 'other'];
                        if ('object' != typeof e) {
                            return !1;
                        }
                        let a = t.system ? t.system : n.answerCodeSystem,
                            o = !1;
                        if ((!e.system && !t.system) || e.system === a) {
                            o = !0;
                            let n = Object.keys(e);
                            for (var r = 0, s = n.length; r < s; r++) {
                                if (i.indexOf(n[r]) >= 0 && e[n[r]] !== t[n[r]]) {
                                    o = !1;
                                    break;
                                }
                            }
                        }
                        return o;
                    },
                    dateToDTStringISO: function (e) {
                        return !e || !(e instanceof Date) || isNaN(e.getTime())
                            ? void 0
                            : [
                                  (1e4 + e.getFullYear()).toString().substr(1),
                                  (101 + e.getMonth()).toString().substr(1),
                                  (100 + e.getDate()).toString().substr(1),
                              ].join('-');
                    },
                    stringToDTDateISO: function (e) {
                        var t = new Date(e);
                        return isNaN(t.getTime())
                            ? void 0
                            : new Date(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate());
                    },
                    dateToDTMString: function (e) {
                        if ('string' == typeof e) {
                            e = this.stringToDate(e, !0);
                        }
                        return e.toISOString();
                    },
                    stringToDate: function (e, t) {
                        if (!e || 'string' != typeof e) {
                            return e;
                        }
                        if ('t' === e.trim()) {
                            return new Date();
                        }
                        let n = o()(e, this.parseDateFormats, !0);
                        if (t && !n.isValid()) {
                            n = o()(e);
                        }
                        return n.isValid() ? n.toDate() : null;
                    },
                    isValidDate: function (e) {
                        return !!this.stringToDate(e);
                    },
                    formatDate: function (e, t) {
                        return o()(e).format(t);
                    },
                    getNextLetter: function (e) {
                        for (var t = [], n = e; n > 0; ) {
                            var i = n % 26;
                            i = 0 === i ? 25 : i - 1;
                            t.push(i);
                            n = Math.floor((n - 1) / 26);
                        }
                        for (var a = '', o = t.length - 1; o >= 0; o--) {
                            a += 'abcdefghijklmnopqrstuvqxyz'.charAt(t[o]);
                        }
                        return a;
                    },
                    findObjectInArray: function (e, t, n, i, a) {
                        var o = a ? [] : null;
                        if (Array.isArray(e)) {
                            var r = 0;
                            if (i && Math.abs(i) < e.length) {
                                if (i < 0) {
                                    r = e.length + i;
                                } else {
                                    r = i;
                                }
                            }
                            for (var s = e.length, c = r; c < s; c++) {
                                if (e[c][t] === n) {
                                    var l = e[c];
                                    if (a) {
                                        o.push(l);
                                    } else {
                                        o = l;
                                        break;
                                    }
                                }
                            }
                        }
                        return o;
                    },
                    _pruneObject: function (e, t, n) {
                        if ('object' == typeof t) {
                            for (var i in t) {
                                if (i.match(e)) {
                                    delete t[i];
                                } else if (n && i === n) {
                                    var a = t[i];
                                    if (Array.isArray(a)) {
                                        for (var o = a.length, r = 0; r < o; r++) {
                                            this._pruneObject(e, a[r], n);
                                        }
                                    } else {
                                        this._pruneObject(e, a, n);
                                    }
                                }
                            }
                        }
                    },
                    pruneNulls: function (e) {
                        if (Array.isArray(e)) {
                            for (var t = e.length - 1; t >= 0; t--) {
                                if (null === e[t] || void 0 === e[t]) {
                                    e.splice(t, 1);
                                } else if ('object' == typeof e[t]) {
                                    this.pruneNulls(e[t]);
                                }
                            }
                        } else if (e && 'object' == typeof e) {
                            Object.keys(e).forEach(function (t) {
                                if (null === e[t] || void 0 === e[t]) {
                                    delete e[t];
                                } else if ('object' == typeof e[t]) {
                                    this.pruneNulls(e[t]);
                                }
                            }, this);
                        }
                    },
                    deepCopy: function (e) {
                        return (0, r.Ay)(e);
                    },
                    deepEqual: function (e, t) {
                        return c()(e, t);
                    },
                    shallowEqual: function (e, t) {
                        var n = !0;
                        if (typeof e != typeof t) {
                            n = !1;
                        } else if ('object' != typeof e) {
                            if (e !== t) {
                                n = !1;
                            }
                        } else {
                            var i = Object.keys(e),
                                a = Object.keys(t);
                            if (i.length !== a.length) {
                                n = !1;
                            } else {
                                for (var o = 0, r = i.length; o < r; o++) {
                                    if (e[i[o]] !== t[i[o]]) {
                                        n = !1;
                                        break;
                                    }
                                }
                            }
                        }
                        return n;
                    },
                    showWarning: function (e, t) {
                        if (t) {
                            e = 'The question "' + t.text + '" produced the following warning:  ' + e;
                        }
                        console.log(e);
                    },
                    isInteger(e) {
                        return Number.isInteger(e) ? !0 : 'number' == typeof e ? !1 : this.intRegex.test(e);
                    },
                    isDecimal(e) {
                        return 'number' == typeof e ? !0 : this.decRegex.test(e);
                    },
                };
                var u = {
                    DATA_CONTROL: {
                        CONSTRUCTION_ARRAY: 'ARRAY',
                        CONSTRUCTION_OBJECT: 'OBJECT',
                        CONSTRUCTION_SIMPLE: 'SIMPLE',
                        SOURCE_INTERNAL: 'INTERNAL',
                        EXTERNAL: 'EXTERNAL',
                    },
                    SKIP_LOGIC: {
                        ACTION_ENABLE: 'show',
                        ACTION_DISABLE: 'hide',
                        STATUS_ENABLED: 'target-enabled',
                        STATUS_DISABLED: 'target-disabled',
                    },
                    CALCULATION_METHOD: { TOTALSCORE: 'TOTALSCORE', BMI: 'BMI', BSA: 'BSA' },
                    DATA_TYPE: {
                        INT: 'INT',
                        REAL: 'REAL',
                        ST: 'ST',
                        TX: 'TX',
                        DT: 'DT',
                        DTM: 'DTM',
                        TM: 'TM',
                        CNE: 'CNE',
                        CWE: 'CWE',
                        NR: 'NR',
                        YEAR: 'YEAR',
                        MONTH: 'MONTH',
                        DAY: 'DAY',
                        URL: 'URL',
                        EMAIL: 'EMAIL',
                        PHONE: 'PHONE',
                        SECTION: 'SECTION',
                        TITLE: 'TITLE',
                        QTY: 'QTY',
                        BL: 'BL',
                        CODING: 'CODING',
                    },
                    DISPLAY_MODE: ['lg', 'md', 'sm', 'auto'],
                };
                const d = {
                    assignValueToItem: function (e, t, n) {
                        var i = !1;
                        n = n || (t && t._type);
                        if (t && 'Quantity' === n) {
                            if (e.value !== t.value) {
                                e.value = t.value;
                                i = !0;
                            }
                            var a = { name: t.name };
                            if (t.code) {
                                a.code = t.code;
                                if (t.system) {
                                    a.system = t.system;
                                }
                            }
                            if (!l.deepEqual(e.unit, a)) {
                                e.unit = a;
                                i = !0;
                            }
                        } else if (!l.deepEqual(e.value, t)) {
                            e.value = t;
                            i = !0;
                        }
                        return i;
                    },
                    modelForOffListUnit: function (e) {
                        return e ? { name: e, _displayUnit: e } : void 0;
                    },
                    printInvalidHtmlToConsole: function (e) {
                        console.log('Possible invalid HTML tags/attributes:');
                        e.forEach(e => {
                            if (e.attributeValue) {
                                console.log(
                                    '  - Attribute value: ' + e.attributeValue + ' of ' + e.attribute + ' in ' + e.tag,
                                );
                            } else if (e.attribute) {
                                console.log('  - Attribute: ' + e.attribute + ' in ' + e.tag);
                            } else if (e.tag) {
                                console.log('  - Element: ' + e.tag);
                            }
                        });
                    },
                    setItemMessagesArray: function (e, t, n) {
                        let i, a;
                        for (let e of t) {
                            if (e) {
                                if (!i) {
                                    i = { errors: {}, warnings: {}, info: {} };
                                    a = Object.keys(i);
                                }
                                for (let t of a) {
                                    if (e[t]) {
                                        Object.assign(i[t], e[t]);
                                    }
                                }
                            }
                        }
                        this.setItemMessages(e, i, n);
                    },
                    setItemMessages: function (e, t, n) {
                        if (t) {
                            if (!e.messages) {
                                e.messages = {};
                            }
                            e.messages[n] = t;
                        } else if (e.messages) {
                            delete e.messages[n];
                            if (!Object.keys(e.messages).length) {
                                delete e.messages;
                            }
                        }
                    },
                    addItemWarning: function (e, t, n) {
                        if (!n) {
                            n = 'Other message source';
                        }
                        let a = e.messages;
                        if (!a) {
                            a = e.messages = {};
                        }
                        let o = a[n];
                        if (!o) {
                            o = a[n] = {};
                        }
                        let r = o.warnings;
                        if (!r) {
                            r = o.warnings = {};
                        }
                        r[t] = i.getMsg(t);
                        console.log(JSON.stringify(e.messages));
                    },
                    removeItemWarning: function (e, t, n) {
                        if (!n) {
                            n = 'Other message source';
                        }
                        let i, a, o;
                        if ((i = e.messages) && (a = i[n]) && (o = a.warnings)) {
                            delete o[t];
                        }
                    },
                    hasAnswerList: function (e) {
                        return (
                            'CODING' === e.dataType ||
                            (e.answers &&
                                ('ST' === e.dataType ||
                                    'INT' === e.dataType ||
                                    'DT' === e.dataType ||
                                    'TM' === e.dataType))
                        );
                    },
                    _getHtmlStringWithContainedImages: function (e, t) {
                        if (e) {
                            let n = new DOMParser().parseFromString(t, 'text/html'),
                                i = n.getElementsByTagName('img');
                            for (let t = 0; t < i.length; t++) {
                                let n = i[t].getAttribute('src');
                                if (n && n.match(/^#/)) {
                                    let a = e[n.substring(1)];
                                    if (a) {
                                        i[t].setAttribute('src', a);
                                    }
                                }
                            }
                            return n.body.innerHTML;
                        } else {
                            return '';
                        }
                    },
                    targetEnabled: function (e) {
                        return !1 !== e._enableWhenExpVal && e._skipLogicStatus !== u.SKIP_LOGIC.STATUS_DISABLED;
                    },
                    targetDisabledAndProtected: function (e) {
                        return 'protected' === e._disabledDisplayStatus && !this.targetEnabled(e);
                    },
                    targetShown: function (e) {
                        return 'protected' === e._disabledDisplayStatus || this.targetEnabled(e);
                    },
                };
                d.errorMessages = i;
                d.errorMessages.setLanguage('en');
                var m = n(6332);
                const p = n(7941);
                var f = function (e) {
                    var t = e,
                        n = LForms.Util._internalUtil.errorMessages;
                    t.fhirExtUrlCardinalityMin = 'http://hl7.org/fhir/StructureDefinition/questionnaire-minOccurs';
                    t.fhirExtUrlCardinalityMax = 'http://hl7.org/fhir/StructureDefinition/questionnaire-maxOccurs';
                    t.fhirExtUrlItemControl = 'http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl';
                    t.fhirExtUrlUnit = 'http://hl7.org/fhir/StructureDefinition/questionnaire-unit';
                    t.fhirExtUrlUnitOption = 'http://hl7.org/fhir/StructureDefinition/questionnaire-unitOption';
                    t.fhirExtUrlOptionPrefix = 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix';
                    t.fhirExtVariable = 'http://hl7.org/fhir/StructureDefinition/variable';
                    t.fhirExtUrlMinValue = 'http://hl7.org/fhir/StructureDefinition/minValue';
                    t.fhirExtUrlMaxValue = 'http://hl7.org/fhir/StructureDefinition/maxValue';
                    t.fhirExtUrlMinLength = 'http://hl7.org/fhir/StructureDefinition/minLength';
                    t.fhirExtUrlRegex = 'http://hl7.org/fhir/StructureDefinition/regex';
                    t.fhirExtUrlAnswerRepeats = 'http://hl7.org/fhir/StructureDefinition/questionnaire-answerRepeats';
                    t.fhirExtUrlExternallyDefined =
                        'http://lhcforms.nlm.nih.gov/fhir/StructureDefinition/questionnaire-externallydefined';
                    t.argonautExtUrlExtensionScore =
                        'http://fhir.org/guides/argonaut-questionnaire/StructureDefinition/extension-score';
                    t.fhirExtUrlHidden = 'http://hl7.org/fhir/StructureDefinition/questionnaire-hidden';
                    t.fhirExtTerminologyServer =
                        'http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-preferredTerminologyServer';
                    t.fhirExtUrlDataControl = 'http://lhcforms.nlm.nih.gov/fhirExt/dataControl';
                    t.fhirExtCalculatedExp =
                        'http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-calculatedExpression';
                    t.fhirExtInitialExp =
                        'http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-initialExpression';
                    t.fhirExtObsLinkPeriod =
                        'http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-observationLinkPeriod';
                    t.fhirExtObsExtract =
                        'http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-observationExtract';
                    t.fhirExtObsExtractCategory =
                        'http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-observation-extract-category';
                    t.fhirExtAnswerExp =
                        'http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-answerExpression';
                    t.fhirExtEnableWhenExp =
                        'http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-enableWhenExpression';
                    t.fhirExtChoiceOrientation =
                        'http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation';
                    t.fhirExtLaunchContext =
                        'http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-launchContext';
                    t.fhirExtMaxSize = 'http://hl7.org/fhir/StructureDefinition/maxSize';
                    t.fhirExtMimeType = 'http://hl7.org/fhir/StructureDefinition/mimeType';
                    t.fhirExtUnitOpen = 'http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-unitOpen';
                    t.fhirExtUnitSuppSystem =
                        'http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-unitSupplementalSystem';
                    t.fhirExtEntryFormat = 'http://hl7.org/fhir/StructureDefinition/entryFormat';
                    t.fhirExtUrlMaxDecimalPlaces = 'http://hl7.org/fhir/StructureDefinition/maxDecimalPlaces';
                    t.fhirExtUrlOptionScoreLookup = {
                        STU3: 'http://hl7.org/fhir/StructureDefinition/questionnaire-ordinalValue',
                        R4: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
                        R5: 'http://hl7.org/fhir/StructureDefinition/itemWeight',
                    };
                    t.fhirExtUrlOptionScoreUrlSet = new Set(Object.values(t.fhirExtUrlOptionScoreLookup));
                    t.fhirExtUrlRestrictionArray = [
                        t.fhirExtUrlMinValue,
                        t.fhirExtUrlMaxValue,
                        t.fhirExtUrlMinLength,
                        t.fhirExtUrlRegex,
                        t.fhirExtUrlMaxDecimalPlaces,
                    ];
                    t.handledExtensionSet = new Set([
                        t.fhirExtUrlCardinalityMin,
                        t.fhirExtUrlCardinalityMax,
                        t.fhirExtUrlItemControl,
                        t.fhirExtUrlUnit,
                        t.fhirExtUrlUnitOption,
                        t.fhirExtUrlOptionPrefix,
                        t.fhirExtUrlMinValue,
                        t.fhirExtUrlMaxValue,
                        t.fhirExtUrlMinLength,
                        t.fhirExtUrlRegex,
                        t.fhirExtUrlAnswerRepeats,
                        t.fhirExtUrlExternallyDefined,
                        t.argonautExtUrlExtensionScore,
                        t.fhirExtUrlHidden,
                        t.fhirExtTerminologyServer,
                        t.fhirExtUrlDataControl,
                        t.fhirExtChoiceOrientation,
                        t.fhirExtUrlMaxDecimalPlaces,
                    ]);
                    t.extensionHandlers = {};
                    t.extensionHandlers[t.fhirExtMaxSize] = function (e, t) {
                        t.maxAttachmentSize = e.valueDecimal || e.valueInteger;
                    };
                    t.extensionHandlers[t.fhirExtMimeType] = function (e, t) {
                        t.allowedAttachmentTypes || (t.allowedAttachmentTypes = []);
                        t.allowedAttachmentTypes.push(e.valueCode);
                    };
                    t.extensionHandlers['http://hl7.org/fhir/StructureDefinition/questionnaire-initialExpression'] =
                        function (e, n) {
                            e.url = t.fhirExtInitialExp;
                            return !0;
                        };
                    t.extensionHandlers['http://hl7.org/fhir/StructureDefinition/terminology-server'] = function (
                        e,
                        n,
                    ) {
                        e.url = t.fhirExtTerminologyServer;
                    };
                    t.extensionHandlers[t.fhirExtUnitOpen] = function (e, t) {
                        t._unitOpen = e.valueCode;
                    };
                    t.extensionHandlers[t.fhirExtUnitSuppSystem] = function (e, t) {
                        t._unitSuppSystem = e.valueCanonical;
                    };
                    t.extensionHandlers[t.fhirExtUrlExternallyDefined] = t.extensionHandlers[
                        'http://hl7.org/fhir/StructureDefinition/questionnaire-externallydefined'
                    ] = function (e, t) {
                        if (e.valueUri) {
                            t.externallyDefined = e.valueUri;
                        }
                    };
                    t.extensionHandlers[t.fhirExtEntryFormat] = function (e, t) {
                        if (e.valueString) {
                            t._entryFormat = e.valueString;
                            return !0;
                        }
                    };
                    t.formLevelFields = [
                        'id',
                        'meta',
                        'implicitRules',
                        'language',
                        'text',
                        'contained',
                        'extension',
                        'modifiedExtension',
                        'date',
                        'version',
                        'identifier',
                        'code',
                        'subjectType',
                        'derivedFrom',
                        'status',
                        'experimental',
                        'publisher',
                        'contact',
                        'description',
                        'useContext',
                        'jurisdiction',
                        'purpose',
                        'approvalDate',
                        'reviewDate',
                        'effectivePeriod',
                        'url',
                    ];
                    t.itemLevelIgnoredFields = ['definition', 'id'];
                    t.convertQuestionnaireToLForms = function (e, n) {
                        var i = null;
                        if (n) {
                            t._widgetOptions = n;
                        }
                        if (e) {
                            i = LForms.Util.baseFormDef();
                            t._processFormLevelFields(i, e);
                            var a = t._extractContainedVS(e),
                                o = t.buildContainedImageMap(e.contained);
                            if (e.item && e.item.length > 0) {
                                var r = t._createLinkIdItemMap(e);
                                i.items = [];
                                for (var s = 0; s < e.item.length; s++) {
                                    var c = t._processQuestionnaireItem(e.item[s], a, r, o);
                                    i.items.push(c);
                                }
                            }
                            i.fhirVersion = t.fhirVersion;
                        }
                        return i;
                    };
                    t._processFormLevelFields = function (e, n) {
                        t.copyFields(n, e, t.formLevelFields);
                        t._processTerminologyServer(e, n);
                        e.shortName = n.name;
                        e.name = n.title;
                        if (n._title) {
                            e.obj_title = n._title;
                        }
                        if (n.code && n.code.length > 0) {
                            e.codeList = n.code;
                        }
                        if (n.copyright) {
                            e.copyrightNotice = n.copyright;
                        }
                        var i = t._getCode(n);
                        if (i) {
                            e.code = i.code;
                            e.codeSystem = i.system;
                        }
                    };
                    t._processQuestionnaireItem = function (e, n, i, a) {
                        var o = {};
                        t._processExtensions(o, e);
                        t._processDataType(o, e);
                        if (t._processAnswerConstraint) {
                            t._processAnswerConstraint(o, e);
                        }
                        t._processTextAndPrefix(o, e);
                        t._processCodeAndLinkId(o, e);
                        t._processDisplayItemCode(o, e);
                        t._processEditable(o, e);
                        t._processFHIRQuestionAndAnswerCardinality(o, e);
                        t._processDisplayControl(o, e);
                        t._processDataControl(o, e);
                        t._processRestrictions(o, e);
                        t._processHiddenItem(o, e);
                        t._processUnitList(o, e);
                        t._processAnswers(o, e, n, a);
                        t._processDefaultAnswer(o, e);
                        t._processTerminologyServer(o, e);
                        t._processSkipLogic(o, e, i);
                        t.copyFields(e, o, t.itemLevelIgnoredFields);
                        t._processChildItems(o, e, n, i, a);
                        if (t._processDisabledDisplay) {
                            t._processDisabledDisplay(o, e);
                        }
                        return o;
                    };
                    t._significantDigits = function (e) {
                        var t = /(\d+)(?:\.(\d+))?/.exec('' + +e);
                        if (!t) {
                            return 0;
                        }
                        var n = t[1],
                            i = t[2];
                        return '0' === n ? 0 : n.length + (i ? i.length : 0);
                    };
                    t.importObsValue = function (e, n) {
                        var i = null,
                            a = e.dataType,
                            o = this._lformsTypesToFHIRFields[a];
                        if ('Coding' === o) {
                            o = 'CodeableConcept';
                        }
                        if (o) {
                            i = n['value' + o];
                        }
                        if (!i && ('REAL' === a || 'INT' === a)) {
                            if ((i = n.valueQuantity)) {
                                i._type = 'Quantity';
                            }
                        }
                        if (i) {
                            if (!i._type && 'object' == typeof i) {
                                i._type = o;
                            }
                            var r = !0;
                            if ('Quantity' === i._type) {
                                if (e.units) {
                                    var s,
                                        c = i.system;
                                    if (c && '/' === c[c.length - 1]) {
                                        c = c.slice(0, -1);
                                    }
                                    for (var l, u = c === t.UCUM_URI, d = 0, m = e.units.length; d < m && !s; ++d) {
                                        var p = e.units[d];
                                        if (
                                            (p.system && p.system === c && p.code === i.code) ||
                                            (!p.system && p.name === i.unit)
                                        ) {
                                            s = p;
                                        }
                                        if (u && !s && !l && p.system === t.UCUM_URI) {
                                            l = p;
                                        }
                                    }
                                    if (!s && l) {
                                        var f = LForms.ucumPkg.UcumLhcUtils.getInstance().convertUnitTo(
                                            i.code,
                                            i.value,
                                            l.code,
                                        );
                                        if ('succeeded' === f.status) {
                                            s = l;
                                            var g = this._significantDigits(i.value);
                                            if (g > 0) {
                                                i.value = parseFloat(f.toVal.toPrecision(g));
                                            } else {
                                                i.value = f.toVal;
                                            }
                                            i.code = l.code;
                                            i.unit = l.name || l.code;
                                        }
                                    }
                                    if (!s) {
                                        r = !1;
                                    } else {
                                        e.unit = s;
                                    }
                                }
                            }
                            if (r) {
                                this._processFHIRValues(e, [i]);
                            }
                        }
                    };
                    t._convertFHIRValues = function (e, n, i) {
                        var a = e.dataType,
                            o = [];
                        const r = [],
                            s = p.types(n);
                        for (let p = 0, E = n.length; p < E; ++p) {
                            let E = n[p];
                            if ('object' == typeof E) {
                                E._type = E._type || s[p]?.split('.')[1];
                            }
                            var c = void 0;
                            let C = {},
                                S = !1;
                            if (d.hasAnswerList(e)) {
                                if ('CODING' === a) {
                                    var l = null;
                                    if ('CodeableConcept' === E._type) {
                                        l = E.coding;
                                    } else if ('Coding' === E._type || 'object' == typeof E) {
                                        l = [E];
                                    }
                                    if (!l) {
                                        if ('optionsOrString' === e.answerConstraint) {
                                            c = E;
                                        }
                                    } else {
                                        if (e.answers) {
                                            for (var u = e.answers, m = 0, f = l.length; m < f && !c; ++m) {
                                                for (var g = l[m], h = 0, y = u.length; h < y && !c; ++h) {
                                                    var x = u[h],
                                                        _ = x.system ? LForms.Util.getCodeSystem(x.system) : null;
                                                    if (
                                                        ((!g.system && !_) || g.system === _) &&
                                                        ((g.hasOwnProperty('code') &&
                                                            x.hasOwnProperty('code') &&
                                                            g.code === x.code) ||
                                                            (g.hasOwnProperty('display') &&
                                                                x.hasOwnProperty('text') &&
                                                                g.display === x.text))
                                                    ) {
                                                        c = u[h];
                                                    }
                                                }
                                            }
                                        }
                                        if (!c && 'optionsOrString' === e.answerConstraint) {
                                            c = t._processCODINGValueInQR({ valueCoding: E }, e, !0);
                                        }
                                    }
                                } else if (e.answers) {
                                    c = t._processNonCodingAnswerValueInQR(E, e, i);
                                }
                            } else if (('QTY' === a || 'REAL' === a || 'INT' === a) && 'Quantity' === E._type) {
                                [c, C] = this._convertFHIRQuantity(e, E);
                                S = !!C;
                            } else if (!i && 'DTM' === e.dataType && 'string' == typeof E) {
                                c = new Date(E);
                            } else if (!i && 'DT' === e.dataType && 'string' == typeof E) {
                                c = LForms.Util.stringToDTDateISO(E);
                            } else {
                                c = E;
                            }
                            if (void 0 !== c || null !== c) {
                                o.push(c);
                            }
                            r.push(S ? { errors: C } : null);
                        }
                        return [o, r];
                    };
                    t._convertFHIRQuantity = function (e, i, a) {
                        let o, r;
                        if (void 0 !== i.comparator) {
                            r = {};
                            n.addMsg(r, 'comparatorInQuantity');
                        } else {
                            if (!e.units) {
                                if (i.unit) {
                                    n.addMsg(r, 'nonMatchingQuantityUnit');
                                } else {
                                    o = (0, m.I)(i);
                                }
                            } else {
                                var s,
                                    c = i.system;
                                if (c && '/' === c[c.length - 1]) {
                                    c = c.slice(0, -1);
                                }
                                for (var l, u = c === t.UCUM_URI, d = 0, p = e.units.length; d < p && !s; ++d) {
                                    var f = e.units[d];
                                    if (
                                        (f.system && f.system === c && f.code === i.code) ||
                                        (!f.system && f.name === i.unit)
                                    ) {
                                        s = f;
                                    }
                                    if (u && !s && !l && f.system === t.UCUM_URI) {
                                        l = f;
                                    }
                                }
                                i = LForms.Util.deepCopy(i);
                                if (!s && l) {
                                    var g = LForms.ucumPkg.UcumLhcUtils.getInstance().convertUnitTo(
                                        i.code,
                                        i.value,
                                        l.code,
                                    );
                                    if ('succeeded' === g.status) {
                                        s = l;
                                        var h = this._significantDigits(i.value);
                                        if (h > 0) {
                                            i.value = parseFloat(g.toVal.toPrecision(h));
                                        } else {
                                            i.value = g.toVal;
                                        }
                                        i.code = l.code;
                                        i.unit = l.name || l.code;
                                    }
                                }
                                if (!s) {
                                    if ('optionsOrString' == e._unitOpen) {
                                        delete i.code;
                                        delete i.system;
                                    } else if (
                                        !e._unitSuppSystem ||
                                        'optionsOrType' != e._unitOpen ||
                                        e._unitSuppSystem != i.system
                                    ) {
                                        r = {};
                                        n.addMsg(r, 'nonMatchingQuantityUnit');
                                    }
                                }
                            }
                            if (!r) {
                                o = (0, m.I)(i);
                            }
                        }
                        return [o, r];
                    };
                    t._processFHIRValues = function (e, t, n) {
                        let [i, a] = this._convertFHIRValues(e, t, n),
                            o = LForms.Util._hasMultipleAnswers(e) ? i : i[0];
                        if (n) {
                            e.defaultAnswer = o;
                            LForms.Util._internalUtil.setItemMessagesArray(e, a, 'default answers');
                        } else {
                            LForms.Util._internalUtil.assignValueToItem(e, o);
                            LForms.Util._internalUtil.setItemMessagesArray(e, a, '_processFHIRValues');
                        }
                    };
                    t._getFHIRValueWithPrefixKey = function (e, t) {
                        var n = null;
                        if ('object' == typeof e) {
                            for (var i in e) {
                                var a = i.match(t);
                                if (a) {
                                    if ((n = e[i]) && 'object' == typeof n) {
                                        (n = LForms.Util.deepCopy(n))._type = i.substring(a[0].length);
                                    }
                                    break;
                                }
                            }
                        }
                        return n;
                    };
                    t._processTextAndPrefix = function (e, i) {
                        if (i.prefix) {
                            e.prefix = i.prefix;
                        }
                        e.question = i.text;
                        for (let t of ['_prefix', '_text']) {
                            let n = i[t];
                            if (n) {
                                e['obj' + t] = n;
                            }
                        }
                        const a = e.obj_text
                            ? LForms.Util.findObjectInArray(
                                  e.obj_text.extension,
                                  'url',
                                  'http://hl7.org/fhir/StructureDefinition/rendering-xhtml',
                              )
                            : null;
                        if (a) {
                            e._displayTextHTML = a.valueString;
                            if (t._widgetOptions?.allowHTML) {
                                let t = LForms.Util.checkForInvalidHtmlTags(a.valueString);
                                if (t && t.length > 0) {
                                    e._hasInvalidHtmlTag = !0;
                                    let i = {};
                                    n.addMsg(i, 'invalidTagInHTMLContent');
                                    const a = [{ errors: i }];
                                    LForms.Util._internalUtil.printInvalidHtmlToConsole(t);
                                    LForms.Util._internalUtil.setItemMessagesArray(e, a, '_processTextAndPrefix');
                                }
                            }
                        }
                    };
                    t._processCodeAndLinkId = function (e, n) {
                        if (n.code) {
                            e.codeList = n.code;
                        }
                        var i = t._getCode(n);
                        if (i) {
                            e.questionCode = i.code;
                            e.questionCodeSystem = i.system;
                        } else {
                            e.questionCode = n.linkId;
                            e.questionCodeSystem = 'LinkId';
                        }
                        e.linkId = n.linkId;
                    };
                    t._processUnitList = function (e, n) {
                        var i = [],
                            a = null,
                            o = LForms.Util.findObjectInArray(n.extension, 'url', t.fhirExtUrlUnitOption, 0, !0);
                        if (o && o.length > 0) {
                            if ('quantity' !== n.type) {
                                throw new Error(
                                    'The extension ' +
                                        t.fhirExtUrlUnitOption +
                                        ' can only be used with type quantity.  Question "' +
                                        n.text +
                                        '" is of type ' +
                                        n.type,
                                );
                            }
                            for (var r = 0; r < o.length; r++) {
                                var s = o[r].valueCoding,
                                    c = { name: s.display, code: s.code, system: s.system };
                                i.push(c);
                            }
                        }
                        var l = LForms.Util.findObjectInArray(n.extension, 'url', t.fhirExtUrlUnit);
                        if (l) {
                            if ('integer' !== n.type && 'decimal' !== n.type) {
                                throw new Error(
                                    'The extension ' +
                                        t.fhirExtUrlUnit +
                                        ' can only be used with types integer or decimal.  Question "' +
                                        n.text +
                                        '" is of type ' +
                                        n.type,
                                );
                            }
                            a = {
                                name: l.valueCoding.display,
                                code: l.valueCoding.code,
                                system: l.valueCoding.system,
                                default: !0,
                            };
                            i.push(a);
                        }
                        if ('quantity' === n.type) {
                            let e = this.getFirstInitialQuantity(n);
                            if (e && e.unit) {
                                if ((a = LForms.Util.findItem(i, 'name', e.unit))) {
                                    a.default = !0;
                                } else {
                                    a = { name: e.unit, code: e.code, system: e.system, default: !0 };
                                    i.push(a);
                                }
                            }
                        }
                        if (i.length > 0) {
                            if (!a) {
                                i[0].default = !0;
                            }
                            e.units = i;
                        }
                    };
                    t._processDisplayControl = function (e, n) {
                        var i = LForms.Util.findObjectInArray(n.extension, 'url', t.fhirExtUrlItemControl);
                        if (i) {
                            var a = {};
                            switch (i.valueCodeableConcept.coding[0].code) {
                                case 'Lookup':
                                case 'Combo-box':
                                case 'autocomplete':
                                    e.isSearchAutocomplete = !0;
                                case 'drop-down':
                                    a.answerLayout = { type: 'COMBO_BOX' };
                                    break;
                                case 'Checkbox':
                                case 'check-box':
                                case 'Radio':
                                case 'radio-button':
                                    a.answerLayout = { type: 'RADIO_CHECKBOX' };
                                    var o = LForms.Util.findObjectInArray(
                                        n.extension,
                                        'url',
                                        t.fhirExtChoiceOrientation,
                                    );
                                    if (o) {
                                        if ('vertical' === o.valueCode) {
                                            a.answerLayout.columns = '1';
                                        } else if ('horizontal' === o.valueCode) {
                                            a.answerLayout.columns = '0';
                                        }
                                    }
                                    break;
                                case 'Table':
                                case 'gtable':
                                    if ('SECTION' === e.dataType) {
                                        a.questionLayout = 'horizontal';
                                    }
                                    break;
                                case 'Matrix':
                                case 'table':
                                    if ('SECTION' === e.dataType) {
                                        a.questionLayout = 'matrix';
                                    }
                                    break;
                                default:
                                    a = null;
                            }
                            if (a && !LForms.jQuery.isEmptyObject(a)) {
                                e.displayControl = a;
                            }
                        }
                    };
                    t._processDataControl = function (e, n) {
                        var i = LForms.Util.findObjectInArray(n.extension, 'url', t.fhirExtUrlDataControl);
                        if (i && i.valueString) {
                            try {
                                var a = JSON.parse(i.valueString);
                                if (a) {
                                    e.dataControl = a;
                                }
                            } catch (e) {
                                console.log('Invalid dataControl data!');
                            }
                        }
                    };
                    t._processHiddenItem = function (e, n) {
                        var i = LForms.Util.findObjectInArray(n.extension, 'url', t.fhirExtUrlHidden);
                        if (i) {
                            e.isHiddenInDef =
                                'boolean' == typeof i.valueBoolean ? i.valueBoolean : 'true' === i.valueBoolean;
                        }
                        return e.isHiddenInDef;
                    };
                    var i = (t._mergeQR = {});
                    i.mergeQuestionnaireResponseToLForms = function (e, t) {
                        if (!(e instanceof LForms.LFormsData)) {
                            e.hasSavedData = !0;
                            e = new LForms.LFormsData(e).getFormData();
                        }
                        var n = i._getQRStructure(t);
                        i._processQRItemAndLFormsItem(n, e);
                        return e;
                    };
                    i._processQRItemAndLFormsItem = function (t, n) {
                        for (var i = 0; i < t.qrItemsInfo.length; i++) {
                            var a = t.qrItemsInfo[i],
                                o = a.item;
                            if (o) {
                                if (a.total > 1 && 0 === a.index) {
                                    var r = this._findTheMatchingItemByLinkId(n, a.linkId);
                                    if (e._questionRepeats(r)) {
                                        this._addRepeatingItems(n, a.linkId, a.total);
                                        if ('SECTION' !== r.dataType && 'TITLE' !== r.dataType) {
                                            for (var s = 1; s < a.total; s++) {
                                                var c = LForms.Util.deepCopy(a);
                                                c.index = s;
                                                c.item.answer = [c.item.answer[s]];
                                                if (a.qrAnswersItemsInfo && a.qrAnswersItemsInfo[s]) {
                                                    c.qrAnswersItemsInfo = [a.qrAnswersItemsInfo[s]];
                                                }
                                                t.qrItemsInfo.splice(i + s, 0, c);
                                            }
                                            a.item.answer = [a.item.answer[0]];
                                            if (a.qrAnswersItemsInfo && a.qrAnswersItemsInfo[0]) {
                                                a.qrAnswersItemsInfo = [a.qrAnswersItemsInfo[0]];
                                            } else {
                                                delete a.qrAnswersItemsInfo;
                                            }
                                        }
                                    } else if (e._answerRepeats(r)) {
                                        a.total = 1;
                                    }
                                }
                                var l = this._findTheMatchingItemByLinkIdAndIndex(n, a.linkId, a.index);
                                if ('SECTION' !== l.dataType && 'TITLE' !== l.dataType) {
                                    var u = o.answer;
                                    if (u && u.length > 0) {
                                        this._setupItemValueAndUnit(o.linkId, u, l);
                                        if (a.qrAnswersItemsInfo) {
                                            if (a.qrAnswersItemsInfo.length > 1) {
                                                throw new Error(
                                                    'item.answer.item with item.answer.length > 1 is not yet supported',
                                                );
                                            }
                                            this._processQRItemAndLFormsItem(a.qrAnswersItemsInfo[0], l);
                                        }
                                    }
                                }
                                if (a.qrItemsInfo && a.qrItemsInfo.length > 0) {
                                    this._processQRItemAndLFormsItem(a, l);
                                }
                            }
                        }
                    };
                    i._setupItemValueAndUnit = function (t, n, i) {
                        if (i && t === i.linkId && 'SECTION' !== i.dataType && 'TITLE' !== i.dataType) {
                            var a = i.dataType;
                            if ((!a || 'ST' === a) && i.units && i.units.length > 0) {
                                i.dataType = a = 'REAL';
                            }
                            var o = n[0];
                            switch (a) {
                                case 'BL':
                                    if (!0 === o.valueBoolean || !1 === o.valueBoolean) {
                                        i.value = o.valueBoolean;
                                    }
                                    break;
                                case 'INT':
                                    if (d.hasAnswerList(i)) {
                                        e._processOtherAnswerOptionValueInQR(n, i);
                                    } else if (o.hasOwnProperty('valueQuantity')) {
                                        i.value = o.valueQuantity.value;
                                        if (o.valueQuantity.code) {
                                            i.unit = { name: o.valueQuantity.code };
                                        }
                                    } else if (o.hasOwnProperty('valueInteger')) {
                                        i.value = o.valueInteger;
                                    }
                                    break;
                                case 'REAL':
                                case 'QTY':
                                    if (o.hasOwnProperty('valueQuantity')) {
                                        var r = o.valueQuantity,
                                            s = (0, m.I)(r);
                                        LForms.Util._internalUtil.assignValueToItem(i, s, 'Quantity');
                                    } else if (o.hasOwnProperty('valueDecimal')) {
                                        i.value = o.valueDecimal;
                                    }
                                    break;
                                case 'DT':
                                    if (d.hasAnswerList(i)) {
                                        e._processOtherAnswerOptionValueInQR(n, i);
                                    } else if (o.hasOwnProperty('valueDate')) {
                                        i.value = o.valueDate;
                                    }
                                    break;
                                case 'TM':
                                    if (d.hasAnswerList(i)) {
                                        e._processOtherAnswerOptionValueInQR(n, i);
                                    } else if (o.hasOwnProperty('valueTime')) {
                                        i.value = o.valueTime;
                                    }
                                    break;
                                case 'DTM':
                                    i.value = o.valueDateTime;
                                    break;
                                case 'CODING':
                                    if (e._answerRepeats(i)) {
                                        for (var c = [], l = 0, u = n.length; l < u; l++) {
                                            if ((p = e._processCODINGValueInQR(n[l], i))) {
                                                c.push(p);
                                            }
                                        }
                                        i.value = c;
                                    } else {
                                        var p;
                                        if ((p = e._processCODINGValueInQR(o, i))) {
                                            i.value = p;
                                        }
                                    }
                                    break;
                                case 'ST':
                                    if (d.hasAnswerList(i)) {
                                        e._processOtherAnswerOptionValueInQR(n, i);
                                    } else if (o.hasOwnProperty('valueString')) {
                                        i.value = o.valueString;
                                    }
                                    break;
                                case 'TX':
                                default:
                                    i.value = o.valueString;
                                    break;
                                case 'attachment':
                                    i.value = o.valueAttachment;
                                case 'SECTION':
                                case 'TITLE':
                                case '':
                            }
                        }
                    };
                    t._createLinkIdItemMap = function (e) {
                        var t = function (e, n) {
                                e.forEach(function (e) {
                                    n[e.linkId] = e;
                                    if (e.item) {
                                        t(e.item, n);
                                    }
                                });
                                return n;
                            },
                            n = {};
                        if (e.item) {
                            n = t(e.item, n);
                        }
                        return n;
                    };
                    t._getCode = function (e) {
                        var n = null;
                        if (e && Array.isArray(e.code) && e.code.length) {
                            n = { code: e.code[0].code, system: t._toLfCodeSystem(e.code[0].system) };
                        } else if (e && Array.isArray(e.identifier) && e.identifier.length) {
                            n = { code: e.identifier[0].value, system: t._toLfCodeSystem(e.identifier[0].system) };
                        }
                        return n;
                    };
                    t.answersFromVS = function (e) {
                        var n = e,
                            i = [];
                        if (n.expansion && n.expansion.contains && n.expansion.contains.length > 0) {
                            n.expansion.contains.forEach(function (e) {
                                var n = { code: e.code, text: e.display, system: e.system },
                                    a = LForms.Util.findObjectInArray(e.extension, 'url', t.fhirExtUrlValueSetScore);
                                if (a) {
                                    n.score = parseFloat(a.valueDecimal);
                                }
                                i.push(n);
                            });
                        }
                        return i.length > 0 ? i : null;
                    };
                    t._toLfCodeSystem = function (e) {
                        var t = e;
                        if ('http://loinc.org' === e) {
                            t = 'LOINC';
                        }
                        return t;
                    };
                    t.mergeQuestionnaireResponseToLForms = i.mergeQuestionnaireResponseToLForms;
                    t._processTerminologyServer = function (e, n) {
                        var i = LForms.Util.findObjectInArray(n.extension, 'url', t.fhirExtTerminologyServer);
                        if (i && i.valueUrl) {
                            e.terminologyServer = i.valueUrl;
                        }
                    };
                    t._processExternallyDefined = function (e, n) {
                        var i = LForms.Util.findObjectInArray(n.extension, 'url', t.fhirExtUrlExternallyDefined);
                        if (i && i.valueUri) {
                            e.externallyDefined = i.valueUri;
                        }
                    };
                    t._getTerminologyServer = function (e) {
                        for (var t = e.terminologyServer, n = e._parentItem; !t && n; ) {
                            t = n.terminologyServer;
                            n = n._parentItem;
                        }
                        return t;
                    };
                    t._getExpansionURL = function (e) {
                        var t;
                        if (e.answerValueSet) {
                            var n = this._getTerminologyServer(e);
                            if (n) {
                                t = n + '/ValueSet/$expand?url=' + e.answerValueSet + '&_format=json';
                            }
                        }
                        return t;
                    };
                    t.loadAnswerValueSets = function (e) {
                        for (var n = [], i = e.itemList, a = 0, o = i.length; a < o; ++a) {
                            let o = i[a];
                            if (o.answerValueSet && !o.isSearchAutocomplete) {
                                let i = this._getExpansionURL(o),
                                    a = i ? i : o.answerValueSet;
                                o._answerValueSetKey = a;
                                if (!LForms._valueSetAnswerCache) {
                                    LForms._valueSetAnswerCache = {};
                                }
                                let s = LForms._valueSetAnswerCache[a];
                                if (s) {
                                    o.answers = s;
                                    e._updateAutocompOptions(o);
                                    e._resetItemValueWithAnswers(o);
                                } else if (i) {
                                    n.push(
                                        fetch(i, { headers: { Accept: 'application/fhir+json' } })
                                            .then(function (e) {
                                                return e.json();
                                            })
                                            .then(function (n) {
                                                if ('OperationOutcome' === n.resourceType) {
                                                    var a = n.issue.find(
                                                        e => 'error' === e.severity || 'fatal' === e.severity,
                                                    );
                                                    if (a) {
                                                        throw new Error(a.diagnostics);
                                                    }
                                                } else {
                                                    s = t.answersFromVS(n);
                                                    if (s) {
                                                        LForms._valueSetAnswerCache[i] = s;
                                                        o.answers = s;
                                                        e._updateAutocompOptions(o);
                                                        e._resetItemValueWithAnswers(o);
                                                    }
                                                }
                                            })
                                            .catch(function (e) {
                                                throw new Error('Unable to load ValueSet from ' + i);
                                            }),
                                    );
                                } else {
                                    var r = LForms.fhirContext?.client;
                                    if (!r) {
                                        throw new Error(
                                            'Unable to load ValueSet ' + o.answerValueSet + ' from FHIR server',
                                        );
                                    }
                                    n.push(
                                        r
                                            .request({
                                                url: e._buildURL(['ValueSet', '$expand'], {
                                                    url: o.answerValueSet,
                                                    _format: 'json',
                                                }),
                                                headers: { Accept: 'application/fhir+json' },
                                            })
                                            .then(function (n) {
                                                var i = n,
                                                    r = t.answersFromVS(i);
                                                if (r) {
                                                    LForms._valueSetAnswerCache[a] = r;
                                                    o.answers = r;
                                                    e._updateAutocompOptions(o);
                                                    e._resetItemValueWithAnswers(o);
                                                }
                                            })
                                            .catch(function (e) {
                                                throw new Error(
                                                    'Unable to load ValueSet ' + o.answerValueSet + ' from FHIR server',
                                                );
                                            }),
                                    );
                                }
                            }
                        }
                        return n;
                    };
                    t._processCODINGValueInQR = function (e, t, n) {
                        var i;
                        if (e.valueCoding) {
                            var a = e.valueCoding;
                            i = {};
                            if (a.code) {
                                i.code = a.code;
                            }
                            if (a.display) {
                                i.text = a.display;
                            }
                            if (a.system) {
                                i.system = a.system;
                            }
                            if (n) {
                                i._notOnList = !0;
                            } else if ('optionsOrString' === t.answerConstraint && t.answers) {
                                for (var o = !1, r = 0, s = t.answers.length; r < s; r++) {
                                    if (LForms.Util.areTwoAnswersSame(i, t.answers[r], t)) {
                                        o = !0;
                                        break;
                                    }
                                }
                                if (!o) {
                                    i._notOnList = !0;
                                }
                            }
                        } else if (e.valueString && 'optionsOrString' === t.answerConstraint) {
                            i = e.valueString;
                        }
                        return i;
                    };
                    t._processOtherAnswerOptionValueInQR = function (t, n) {
                        if (d.hasAnswerList(n)) {
                            if (e._answerRepeats(n)) {
                                for (var i = [], a = 0, o = t.length; a < o; a++) {
                                    var r = e._convertOtherAnswerOptionValueInQR(t[a], n);
                                    if (r) {
                                        i.push(r);
                                    }
                                }
                                n.value = i;
                            } else {
                                n.value = e._convertOtherAnswerOptionValueInQR(t[0], n);
                            }
                        }
                    };
                    t._convertOtherAnswerOptionValueInQR = function (e, t) {
                        let n,
                            i = t.dataType;
                        if (t.answers && ('ST' === i || 'INT' === i || 'DT' === i || 'TM' === i)) {
                            let a;
                            switch (i) {
                                case 'ST':
                                    a = e.valueString;
                                    break;
                                case 'INT':
                                    a = e.valueInteger;
                                    break;
                                case 'DT':
                                    a = e.valueDate;
                                    break;
                                case 'TM':
                                    a = e.valueTime;
                            }
                            if (a) {
                                n = { text: a };
                            } else if ('optionsOrString' === t.answerConstraint && e.valueString) {
                                n = e.valueString;
                            }
                        }
                        return n;
                    };
                    t._processCodingInstructions = function (e) {
                        let i,
                            a,
                            o,
                            r,
                            s = LForms.Util.findObjectInArray(e.extension, 'url', t.fhirExtUrlItemControl);
                        if ('display' === e.type && s) {
                            if (e._text) {
                                r = LForms.Util.findObjectInArray(
                                    e._text.extension,
                                    'url',
                                    'http://hl7.org/fhir/StructureDefinition/rendering-xhtml',
                                );
                            }
                            if (r) {
                                i = {
                                    codingInstructionsFormat: 'html',
                                    codingInstructions: r.valueString,
                                    codingInstructionsPlain: e.text,
                                };
                                if (t._widgetOptions?.allowHTML) {
                                    let e = LForms.Util.checkForInvalidHtmlTags(r.valueString);
                                    if (e && e.length > 0) {
                                        i.codingInstructionsHasInvalidHtmlTag = !0;
                                        a = {};
                                        n.addMsg(a, 'invalidTagInHelpHTMLContent');
                                        o = [{ errors: a }];
                                        LForms.Util._internalUtil.printInvalidHtmlToConsole(e);
                                    }
                                }
                            } else {
                                i = {
                                    codingInstructionsFormat: 'text',
                                    codingInstructions: e.text,
                                    codingInstructionsPlain: e.text,
                                };
                            }
                        }
                        return [i, o];
                    };
                    t._processChildItems = function (e, n, i, a, o) {
                        if (Array.isArray(n.item)) {
                            e.items = [];
                            for (var r = 0; r < n.item.length; r++) {
                                var [s, c] = t._processCodingInstructions(n.item[r]);
                                if (c) {
                                    LForms.Util._internalUtil.setItemMessagesArray(e, c, '_processCodingInstructions');
                                }
                                if (s) {
                                    e.codingInstructions = s.codingInstructions;
                                    e.codingInstructionsFormat = s.codingInstructionsFormat;
                                    e.codingInstructionsPlain = s.codingInstructionsPlain;
                                    e.codingInstructionsHasInvalidHtmlTag = s.codingInstructionsHasInvalidHtmlTag;
                                } else {
                                    var l = t._processQuestionnaireItem(n.item[r], i, a, o);
                                    e.items.push(l);
                                }
                            }
                        }
                    };
                    t._processExtensions = function (e, n) {
                        var i = [];
                        if (Array.isArray(n.extension)) {
                            for (var a = 0; a < n.extension.length; a++) {
                                var o = n.extension[a],
                                    r = t.extensionHandlers[o.url];
                                if ((r && r(o, e)) || !t.handledExtensionSet.has(n.extension[a].url)) {
                                    i.push(n.extension[a]);
                                }
                            }
                        }
                        if (i.length > 0) {
                            e.extension = i;
                        }
                    };
                    t._arrayLen = function (e) {
                        return e && Array.isArray(e) ? e.length : -1;
                    };
                    t._checkQRItemAnswerItems = function (e, n) {
                        var i = t._arrayLen(n.answer);
                        if (!(i < 1)) {
                            for (var a = 0, o = [], r = 0; r < i; r++) {
                                if (this._arrayLen(n.answer[r].item) > 0) {
                                    o.push({});
                                    t._mergeQR._checkQRItems(o[r], n.answer[r]);
                                    ++a;
                                } else {
                                    o.push(null);
                                }
                            }
                            if (a > 0) {
                                e.numAnswersWithItems = a;
                                e.qrAnswersItemsInfo = o;
                            }
                        }
                    };
                    t._processRestrictions = function (e, n) {
                        var i = {};
                        if (void 0 !== n.maxLength) {
                            i.maxLength = n.maxLength.toString();
                        }
                        for (var a = 0; a < t.fhirExtUrlRestrictionArray.length; a++) {
                            var o = LForms.Util.findObjectInArray(n.extension, 'url', t.fhirExtUrlRestrictionArray[a]),
                                r = t._getFHIRValueWithPrefixKey(o, /^value/);
                            if (null != r) {
                                if (o.url.match(/minValue$/)) {
                                    i.minInclusive = r;
                                } else if (o.url.match(/maxValue$/)) {
                                    i.maxInclusive = r;
                                } else if (o.url.match(/minLength$/)) {
                                    i.minLength = r;
                                } else if (o.url.match(/regex$/)) {
                                    i.pattern = r;
                                } else if (o.url.match(/maxDecimalPlaces$/)) {
                                    i.maxDecimalPlaces = parseInt(r);
                                }
                            }
                        }
                        if (!LForms.jQuery.isEmptyObject(i)) {
                            e.restrictions = i;
                        }
                    };
                };
            },
            3136: function (e, t, n) {
                'use strict';
                n.d(t, {
                    b: function () {
                        return r;
                    },
                });
                var i = n(7337),
                    a = n(6795),
                    o = n.n(a);
                let r;
                !(function () {
                    r = function (e) {
                        this._queryCache = {};
                        this._pendingQueries = [];
                        this._calculatedValues = {};
                        this._repetitionKeys = {};
                        this._pendingRun = !1;
                        this._currentRunPromise = void 0;
                        this._lfData = e;
                        if (!e._fhir) {
                            throw new Error('lfData._fhir should be set');
                        }
                        this._fhir = e._fhir;
                        this._compiledExpressions = {};
                    };
                    r.prototype = {
                        runCalculations: function (e) {
                            if (this._currentRunPromise) {
                                this._pendingRun = !0;
                            } else {
                                this._pendingRun = !1;
                                this._runStart = new Date();
                                var t = this._lfData;
                                if (!t._fhirVariables.questionnaire) {
                                    t._fhirVariables.questionnaire = this._fhir.SDC.convertLFormsToQuestionnaire(t);
                                }
                                if (!this._linkIdToQItem) {
                                    this._linkIdToQItem = {};
                                    this._addToLinkIdToQItemMap(
                                        t._fhirVariables.questionnaire.item,
                                        this._linkIdToQItem,
                                    );
                                }
                                this._regenerateQuestionnaireResp();
                                const n = this;
                                this._currentRunPromise = this._asyncRunCalculations(e, !1).then(
                                    () => {
                                        console.log('Ran expressions in ' + (new Date() - n._runStart) + ' ms');
                                        if (!n._firstExpressionRunComplete) {
                                            n._firstExpressionRunComplete = !0;
                                        }
                                        n._currentRunPromise = void 0;
                                        if (n._pendingRun) {
                                            return n.runCalculations(!1);
                                        }
                                    },
                                    e => {
                                        console.log('Run of expressions failed; reason follows');
                                        console.log(e);
                                        n._currentRunPromise = void 0;
                                        n._pendingRun = !1;
                                        n._pendingQueries = [];
                                        throw e;
                                    },
                                );
                            }
                            return this._currentRunPromise;
                        },
                        _handlePendingQueries: function () {
                            const e = this;
                            return Promise.allSettled(this._pendingQueries).then(function (t) {
                                e._pendingQueries = [];
                                for (var n = !1, i = !1, a = 0, o = t.length; (!n || !i) && a < o; ++a) {
                                    var r = t[a].value;
                                    if (r) {
                                        n = n || r.variables;
                                        i = i || r.fields;
                                    } else if ('rejected' == t[a].status) {
                                        return Promise.reject(t[a].reason);
                                    }
                                }
                                return { fields: i, variables: n };
                            });
                        },
                        _asyncRunCalculations: function (e, t) {
                            const n = this,
                                i = this._lfData;
                            var a;
                            a = this._evaluateExpressions(i, e, t);
                            return this._handlePendingQueries().then(function (t) {
                                let i = a.variables || t.variables,
                                    o = a.fields || t.fields;
                                if (i || o) {
                                    if (o) {
                                        n._regenerateQuestionnaireResp();
                                    }
                                    let t = !o;
                                    return n._asyncRunCalculations(e, t);
                                }
                            });
                        },
                        _updateItemVariable: function (e, t, n) {
                            const i = this._getItemVariables(e);
                            var a = i[t];
                            i[t] = n;
                            if (!o()(a, n)) {
                                e._varChanged = !0;
                            }
                            return e._varChanged;
                        },
                        _ensureItemVariable: function (e, t) {
                            const n = this._getItemVariables(e);
                            n[t] = n[t];
                        },
                        _evaluateExpressions: function (e, t, n) {
                            var i = {};
                            if (n && e._varChanged) {
                                e._varChanged = !1;
                                n = !1;
                            }
                            if (!n) {
                                e._varChanged = !1;
                                if (e._fhirExt) {
                                    var a = e._exprExtensions;
                                    if (a) {
                                        var o = !1;
                                        for (let n = 0, i = a.length; n < i; ++n) {
                                            let i = a[n];
                                            if (this._evaluateExpression(e, i, t)) {
                                                o = !0;
                                            }
                                        }
                                        if (e._answerListReset) {
                                            e._answerListReset = !1;
                                        }
                                        i = { fields: o, variables: e._varChanged };
                                    }
                                }
                            }
                            if (e.items) {
                                for (var r, s = e.items, c = 0; c < s.length; ++c) {
                                    if ((r = this._evaluateExpressions(e.items[c], t, n)).fields) {
                                        i.fields = !0;
                                    }
                                    if (r.variables) {
                                        i.variables = !0;
                                    }
                                }
                            }
                            return i;
                        },
                        _evaluateExpression: function (e, t, n) {
                            let i = this._fhir.SDC,
                                a = this,
                                o = !1,
                                r = t.url === i.fhirExtInitialExp;
                            if (n || !r) {
                                let n = t.url === i.fhirExtCalculatedExp;
                                if ((n || r) && e._questionRepeatable && !e._lastRepeatingItem) {
                                    return !1;
                                }
                                var s = this._calculatedValues[this._getRepetitionKey(e)];
                                let l;
                                if (n && !e._userModifiedCalculatedValue && s) {
                                    l = this._lfData.getItemValues(e);
                                    if (!e._answerListReset && !this._equalAnswers(s, l)) {
                                        e._userModifiedCalculatedValue = !0;
                                    }
                                }
                                if (!n || !e._userModifiedCalculatedValue) {
                                    let i,
                                        r = t.valueExpression.name;
                                    if ('text/fhirpath' === t.valueExpression.language) {
                                        i = this._evaluateFHIRPath(e, t.valueExpression.expression);
                                        if (i instanceof Promise) {
                                            if (r) {
                                                this._ensureItemVariable(e, r);
                                            }
                                            this._pendingQueries.push(
                                                i.then(i => {
                                                    var a = this._updateItemFromExp(e, t.url, r, i, n, l),
                                                        o = !1;
                                                    if (r) {
                                                        o = this._updateItemVariable(e, r, i);
                                                    }
                                                    if (e._answerListReset) {
                                                        e._answerListReset = !1;
                                                    }
                                                    return { fields: a, variables: o };
                                                }),
                                            );
                                        } else {
                                            var c = this._updateItemFromExp(e, t.url, r, i, n, l);
                                            o = o || c;
                                            if (r) {
                                                this._updateItemVariable(e, r, i);
                                            }
                                        }
                                    } else if ('application/x-fhir-query' === t.valueExpression.language) {
                                        if (r) {
                                            this._ensureItemVariable(e, r);
                                        }
                                        let i = !1;
                                        this._pendingQueries.push(
                                            (function (e, t, n) {
                                                try {
                                                    if ('function' == typeof n) {
                                                        var i = [];
                                                        String.prototype.replace.call(e, t, function () {
                                                            i.push(n.apply(void 0, arguments));
                                                            return '';
                                                        });
                                                        return Promise.all(i).then(function (n) {
                                                            return String.prototype.replace.call(e, t, function () {
                                                                return n.shift();
                                                            });
                                                        });
                                                    } else {
                                                        return Promise.resolve(String.prototype.replace.call(e, t, n));
                                                    }
                                                } catch (e) {
                                                    return Promise.reject(e);
                                                }
                                            })(t.valueExpression.expression, /\{\{([^}]+)\}\}/g, function (t, n) {
                                                return Promise.resolve(a._evaluateFHIRPath(e, n)).then(e => {
                                                    let t = e[0];
                                                    if (null == t) {
                                                        i = !0;
                                                    }
                                                    return i ? '' : '' + t;
                                                });
                                            }).then(o => {
                                                if (!e._currentFhirQueryURLs) {
                                                    e._currentFhirQueryURLs = {};
                                                }
                                                let s = e._currentFhirQueryURLs[r];
                                                if (o !== s) {
                                                    e._currentFhirQueryURLs[r] = o;
                                                    return (
                                                        i
                                                            ? Promise.resolve(void 0)
                                                            : this._queryCache.hasOwnProperty(o)
                                                            ? Promise.resolve(this._queryCache[o])
                                                            : this._fetch(o).then(
                                                                  function (e) {
                                                                      return (a._queryCache[o] = e);
                                                                  },
                                                                  function () {
                                                                      console.error(
                                                                          'Unable to load FHIR data from ' + o,
                                                                      );
                                                                  },
                                                              )
                                                    ).then(function (i) {
                                                        var o = a._updateItemFromExp(e, t.url, r, i, n, l),
                                                            s = !1;
                                                        if (r) {
                                                            s = a._updateItemVariable(e, r, i);
                                                        }
                                                        if (e._answerListReset) {
                                                            e._answerListReset = !1;
                                                        }
                                                        return { fields: o, variables: s };
                                                    });
                                                }
                                            }),
                                        );
                                    }
                                }
                            }
                            return o;
                        },
                        _regenerateQuestionnaireResp: function () {
                            var e = this._fhir.SDC.convertLFormsToQuestionnaireResponse(this._lfData);
                            if (!e) {
                                throw new Error('Invalid data. Cannot generate a QuestionnaireResponse resource.');
                            }
                            this._lfData._fhirVariables.resource = e;
                            this._elemIDToQRItem = this._createIDtoQRItemMap(e);
                        },
                        _itemWithVars: function (e) {
                            for (var t = e; !t._fhirVariables; ) {
                                t = t._parentItem;
                            }
                            return t;
                        },
                        _getItemVariables: function (e) {
                            var t = e._fhirVariables;
                            if (!t) {
                                t = e._fhirVariables = Object.create(this._itemWithVars(e)._fhirVariables);
                            }
                            return t;
                        },
                        _fetch: function (e) {
                            var t;
                            e += (e.indexOf('?') > 0 ? '&' : '?') + '_format=json';
                            if (!/^https?:/.test(e) && LForms.fhirContext?.client) {
                                t = LForms.fhirContext.client.request(e);
                            } else {
                                t = fetch(e).then(function (e) {
                                    return e.json();
                                });
                            }
                            return t;
                        },
                        _updateItemFromExp(e, t, n, i, a, o) {
                            var r = !1,
                                s = this._fhir.SDC;
                            if (a || t != s.fhirExtVariable) {
                                if (t == s.fhirExtAnswerExp) {
                                    r = this._setItemListFromFHIRPath(e, i);
                                } else if (t == s.fhirExtEnableWhenExp) {
                                    var c = i[0];
                                    if ((i = !!c) !== c) {
                                        LForms.Util.showWarning(
                                            'An expression from enableWhenExpression did not resolve to a Boolean as required',
                                            e,
                                        );
                                    }
                                    if (n) {
                                        r = !!e._enableWhenExpVal != i;
                                    }
                                    e._enableWhenExpVal = i;
                                } else {
                                    r = this._setItemValueFromFHIRPath(e, i, a, o);
                                }
                            }
                            return r;
                        },
                        _evaluateFHIRPath: function (e, t) {
                            var n,
                                i = this._itemWithVars(e)._fhirVariables;
                            try {
                                var a = {};
                                for (var o in i) {
                                    a[o] = i[o];
                                }
                                let r, s;
                                if (e._elementId) {
                                    r = this._elemIDToQRItem[e._elementId];
                                    r ||= {};
                                    s = 'QuestionnaireResponse.item';
                                    a.qitem = this._linkIdToQItem[e.linkId];
                                } else {
                                    s = '';
                                    r = this._lfData._fhirVariables.resource;
                                }
                                const c = this._fhir.SDC._getTerminologyServer(e),
                                    l = s + ';' + t + ';' + c;
                                let u = this._compiledExpressions[l];
                                if (!u) {
                                    if (s) {
                                        t = { base: s, expression: t };
                                    }
                                    u = this._compiledExpressions[l] = this._fhir.fhirpath.compile(
                                        t,
                                        this._fhir.fhirpathModel,
                                        { async: !0, ...(c ? { terminologyUrl: c } : {}) },
                                    );
                                }
                                n = u(r, a);
                            } catch (e) {
                                console.log(e);
                            }
                            return n;
                        },
                        _addToLinkIdToQItemMap: function (e, t) {
                            var n;
                            if (e) {
                                for (var i = 0, a = e.length; i < a; ++i) {
                                    t[(n = e[i]).linkId] = n;
                                    if (n.item) {
                                        this._addToLinkIdToQItemMap(n.item, t);
                                    }
                                }
                            }
                        },
                        _createIDtoQRItemMap: function (e) {
                            var t = {};
                            this._addToIDtoQRItemMap(this._lfData, e, t);
                            return t;
                        },
                        _addToIDtoQRItemMap: function (e, t, n) {
                            var i = 0;
                            if (e.linkId === t.linkId) {
                                if (e.items) {
                                    if (t && t.item && t.item.length > 0) {
                                        for (
                                            var a = e.items, o = t.item, r = a.length, s = 0, c = 0, l = o.length;
                                            c < l && s < r;
                                            ++c
                                        ) {
                                            var u = o[c],
                                                d = a[s];
                                            if (!u.answer) {
                                                let e = this._addToIDtoQRItemMap(d, u, n);
                                                if (0 === e) {
                                                    --c;
                                                } else {
                                                    i += e;
                                                }
                                                ++s;
                                            } else {
                                                for (var m = u.answer ? u.answer.length : 0, p = 0; p < m; ++s) {
                                                    if (s >= r) {
                                                        throw new Error(
                                                            'Logic error in _addToIDtoQRITemMap; ran out of lfItems',
                                                        );
                                                    }
                                                    let e = a[s],
                                                        t = this._addToIDtoQRItemMap(e, u, n);
                                                    if (0 != t) {
                                                        if (Array.isArray(e.value)) {
                                                            p += e.value.length;
                                                        } else {
                                                            p += 1;
                                                        }
                                                    }
                                                    i += t;
                                                }
                                            }
                                        }
                                    }
                                }
                                if (e._elementId && (i || (void 0 !== e.value && null !== e.value && '' !== e.value))) {
                                    if (!t) {
                                        throw new Error('Logic error in _addToIDtoQRItemMap; missing qrItem');
                                    } else {
                                        n[e._elementId] = t;
                                        i += 1;
                                    }
                                }
                            }
                            return i;
                        },
                        _setItemListFromFHIRPath: function (e, t) {
                            let n = e.answers,
                                i = !!n && Array.isArray(n),
                                a = !!t && Array.isArray(t),
                                o = i != a || (a && t.length != n.length),
                                r = [];
                            const s = this._fhir.SDC.fhirExtUrlOptionScore;
                            if (a) {
                                for (let a = 0, c = t.length; a < c; ++a) {
                                    let c = t[a],
                                        l = (r[a] = {});
                                    switch (e.dataType) {
                                        case 'CODING':
                                            if ('object' == typeof c) {
                                                let t = c.code;
                                                if (void 0 !== t) {
                                                    l.code = t;
                                                }
                                                let n = c.display;
                                                if (void 0 !== n) {
                                                    l.text = n;
                                                }
                                                let i = c.system;
                                                if (void 0 !== i) {
                                                    l.system = i;
                                                }
                                                let a = e._fhirExt && e._fhirExt[s];
                                                if (a) {
                                                    l.score = a[0].valueDecimal;
                                                }
                                            } else {
                                                l.text = '' + c;
                                            }
                                            if (!o) {
                                                o = !i || !this._lfData._objectEqual(l, n[a]);
                                            }
                                            break;
                                        case 'ST':
                                        case 'DT':
                                        case 'TM':
                                            if ('string' == typeof c) {
                                                l.text = c;
                                                if (!o) {
                                                    o = !i || !this._lfData._objectEqual(l, n[a]);
                                                }
                                            }
                                            break;
                                        case 'INT':
                                            if ('number' == typeof c || 'string' == typeof c) {
                                                l.text = parseInt(c);
                                                if (!o) {
                                                    o = !i || !this._lfData._objectEqual(l, n[a]);
                                                }
                                            }
                                    }
                                }
                            }
                            if (o) {
                                e.answers = r;
                                if (
                                    (this._lfData.hasSavedData && this._firstExpressionRunComplete) ||
                                    !this._lfData.hasSavedData
                                ) {
                                    e.value = null;
                                    this._calculatedValues[this._getRepetitionKey(e)] = [];
                                    e._userModifiedCalculatedValue = !1;
                                }
                                e._hasAnswerList = !0;
                                this._lfData._updateAutocompOptions(e, !0);
                                this._lfData._resetItemValueWithAnswers(e);
                                e._answerListReset = !0;
                            }
                            return o;
                        },
                        _setItemValueFromFHIRPath: function (e, t, n, i) {
                            if (void 0 === i) {
                                i = this._lfData.getItemValues(e);
                            }
                            var a = !1;
                            if (void 0 !== t) {
                                var [r, s] = this._fhir.SDC._convertFHIRValues(e, t),
                                    c = r.filter(e => !LForms.Util.isItemValueEmpty(e));
                                const l = 'FHIRPath value expression';
                                if (
                                    (a = !o()(i, c)) &&
                                    n &&
                                    !this._firstExpressionRunComplete &&
                                    this._lfData.hasSavedData
                                ) {
                                    e._userModifiedCalculatedValue = !0;
                                    a = !1;
                                } else if (a) {
                                    this._lfData.setRepeatingItems(e, r, s, l);
                                } else {
                                    this._lfData.setRepeatingItemMessages(e, s, l);
                                }
                                this._calculatedValues[this._getRepetitionKey(e)] = c;
                            }
                            return a;
                        },
                        _getRepetitionKey: function (e) {
                            var t = this._repetitionKeys[e._elementId];
                            if (!t && e._elementId) {
                                var n = e._elementId.match(/\/\d+$/);
                                if (n) {
                                    t = this._repetitionKeys[e._elementId] = e._elementId.substring(0, n.index);
                                }
                            }
                            return t;
                        },
                        _equalAnswers(e, t) {
                            let n = (0, i.Ay)(e),
                                a = (0, i.Ay)(t);
                            if (Array.isArray(n)) {
                                n.forEach(e => {
                                    this._filterAnswerFields(e);
                                });
                            }
                            if (Array.isArray(a)) {
                                a.forEach(e => {
                                    this._filterAnswerFields(e);
                                });
                            }
                            return o()(n, a);
                        },
                        _filterAnswerFields(e) {
                            if ('object' == typeof e && !(e instanceof Date)) {
                                Object.keys(e).forEach(t => {
                                    if (t && '_' === t[0]) {
                                        delete e[t];
                                    }
                                });
                            }
                        },
                    };
                })();
            },
            5358: function (e, t, n) {
                var i = {
                    './af': 5124,
                    './af.js': 5124,
                    './ar': 4328,
                    './ar-dz': 2855,
                    './ar-dz.js': 2855,
                    './ar-kw': 7355,
                    './ar-kw.js': 7355,
                    './ar-ly': 4130,
                    './ar-ly.js': 4130,
                    './ar-ma': 4523,
                    './ar-ma.js': 4523,
                    './ar-sa': 4089,
                    './ar-sa.js': 4089,
                    './ar-tn': 4563,
                    './ar-tn.js': 4563,
                    './ar.js': 4328,
                    './az': 2240,
                    './az.js': 2240,
                    './be': 9162,
                    './be.js': 9162,
                    './bg': 5488,
                    './bg.js': 5488,
                    './bm': 6546,
                    './bm.js': 6546,
                    './bn': 735,
                    './bn-bd': 3442,
                    './bn-bd.js': 3442,
                    './bn.js': 735,
                    './bo': 3928,
                    './bo.js': 3928,
                    './br': 3267,
                    './br.js': 3267,
                    './bs': 5164,
                    './bs.js': 5164,
                    './ca': 9991,
                    './ca.js': 9991,
                    './cs': 9529,
                    './cs.js': 9529,
                    './cv': 1046,
                    './cv.js': 1046,
                    './cy': 7711,
                    './cy.js': 7711,
                    './da': 5324,
                    './da.js': 5324,
                    './de': 6752,
                    './de-at': 6012,
                    './de-at.js': 6012,
                    './de-ch': 8954,
                    './de-ch.js': 8954,
                    './de.js': 6752,
                    './dv': 2361,
                    './dv.js': 2361,
                    './el': 7890,
                    './el.js': 7890,
                    './en-au': 891,
                    './en-au.js': 891,
                    './en-ca': 281,
                    './en-ca.js': 281,
                    './en-gb': 1876,
                    './en-gb.js': 1876,
                    './en-ie': 1107,
                    './en-ie.js': 1107,
                    './en-il': 6212,
                    './en-il.js': 6212,
                    './en-in': 6446,
                    './en-in.js': 6446,
                    './en-nz': 6189,
                    './en-nz.js': 6189,
                    './en-sg': 9091,
                    './en-sg.js': 9091,
                    './eo': 3791,
                    './eo.js': 3791,
                    './es': 4659,
                    './es-do': 2969,
                    './es-do.js': 2969,
                    './es-mx': 57,
                    './es-mx.js': 57,
                    './es-us': 4976,
                    './es-us.js': 4976,
                    './es.js': 4659,
                    './et': 970,
                    './et.js': 970,
                    './eu': 7401,
                    './eu.js': 7401,
                    './fa': 4954,
                    './fa.js': 4954,
                    './fi': 8066,
                    './fi.js': 8066,
                    './fil': 6428,
                    './fil.js': 6428,
                    './fo': 3924,
                    './fo.js': 3924,
                    './fr': 4615,
                    './fr-ca': 2028,
                    './fr-ca.js': 2028,
                    './fr-ch': 6571,
                    './fr-ch.js': 6571,
                    './fr.js': 4615,
                    './fy': 2450,
                    './fy.js': 2450,
                    './ga': 4363,
                    './ga.js': 4363,
                    './gd': 8920,
                    './gd.js': 8920,
                    './gl': 5072,
                    './gl.js': 5072,
                    './gom-deva': 7609,
                    './gom-deva.js': 7609,
                    './gom-latn': 7314,
                    './gom-latn.js': 7314,
                    './gu': 9215,
                    './gu.js': 9215,
                    './he': 9548,
                    './he.js': 9548,
                    './hi': 8440,
                    './hi.js': 8440,
                    './hr': 7641,
                    './hr.js': 7641,
                    './hu': 9676,
                    './hu.js': 9676,
                    './hy-am': 6243,
                    './hy-am.js': 6243,
                    './id': 2342,
                    './id.js': 2342,
                    './is': 8311,
                    './is.js': 8311,
                    './it': 8630,
                    './it-ch': 944,
                    './it-ch.js': 944,
                    './it.js': 8630,
                    './ja': 6158,
                    './ja.js': 6158,
                    './jv': 319,
                    './jv.js': 319,
                    './ka': 3567,
                    './ka.js': 3567,
                    './kk': 2857,
                    './kk.js': 2857,
                    './km': 5683,
                    './km.js': 5683,
                    './kn': 4454,
                    './kn.js': 4454,
                    './ko': 5173,
                    './ko.js': 5173,
                    './ku': 4555,
                    './ku.js': 4555,
                    './ky': 6615,
                    './ky.js': 6615,
                    './lb': 2029,
                    './lb.js': 2029,
                    './lo': 4826,
                    './lo.js': 4826,
                    './lt': 9855,
                    './lt.js': 9855,
                    './lv': 7758,
                    './lv.js': 7758,
                    './me': 6001,
                    './me.js': 6001,
                    './mi': 9733,
                    './mi.js': 9733,
                    './mk': 4243,
                    './mk.js': 4243,
                    './ml': 4202,
                    './ml.js': 4202,
                    './mn': 9584,
                    './mn.js': 9584,
                    './mr': 5284,
                    './mr.js': 5284,
                    './ms': 6936,
                    './ms-my': 5650,
                    './ms-my.js': 5650,
                    './ms.js': 6936,
                    './mt': 1122,
                    './mt.js': 1122,
                    './my': 8629,
                    './my.js': 8629,
                    './nb': 6623,
                    './nb.js': 6623,
                    './ne': 2942,
                    './ne.js': 2942,
                    './nl': 8229,
                    './nl-be': 3903,
                    './nl-be.js': 3903,
                    './nl.js': 8229,
                    './nn': 131,
                    './nn.js': 131,
                    './oc-lnc': 4939,
                    './oc-lnc.js': 4939,
                    './pa-in': 2510,
                    './pa-in.js': 2510,
                    './pl': 8131,
                    './pl.js': 8131,
                    './pt': 7899,
                    './pt-br': 160,
                    './pt-br.js': 160,
                    './pt.js': 7899,
                    './ro': 4184,
                    './ro.js': 4184,
                    './ru': 7418,
                    './ru.js': 7418,
                    './sd': 9068,
                    './sd.js': 9068,
                    './se': 8179,
                    './se.js': 8179,
                    './si': 7727,
                    './si.js': 7727,
                    './sk': 6657,
                    './sk.js': 6657,
                    './sl': 9636,
                    './sl.js': 9636,
                    './sq': 3303,
                    './sq.js': 3303,
                    './sr': 4378,
                    './sr-cyrl': 277,
                    './sr-cyrl.js': 277,
                    './sr.js': 4378,
                    './ss': 3865,
                    './ss.js': 3865,
                    './sv': 8422,
                    './sv.js': 8422,
                    './sw': 6613,
                    './sw.js': 6613,
                    './ta': 1900,
                    './ta.js': 1900,
                    './te': 3072,
                    './te.js': 3072,
                    './tet': 8046,
                    './tet.js': 8046,
                    './tg': 9850,
                    './tg.js': 9850,
                    './th': 7563,
                    './th.js': 7563,
                    './tk': 6350,
                    './tk.js': 6350,
                    './tl-ph': 3972,
                    './tl-ph.js': 3972,
                    './tlh': 8911,
                    './tlh.js': 8911,
                    './tr': 9445,
                    './tr.js': 9445,
                    './tzl': 9013,
                    './tzl.js': 9013,
                    './tzm': 54,
                    './tzm-latn': 4302,
                    './tzm-latn.js': 4302,
                    './tzm.js': 54,
                    './ug-cn': 4225,
                    './ug-cn.js': 4225,
                    './uk': 219,
                    './uk.js': 219,
                    './ur': 6412,
                    './ur.js': 6412,
                    './uz': 2804,
                    './uz-latn': 8556,
                    './uz-latn.js': 8556,
                    './uz.js': 2804,
                    './vi': 8290,
                    './vi.js': 8290,
                    './x-pseudo': 6658,
                    './x-pseudo.js': 6658,
                    './yo': 3067,
                    './yo.js': 3067,
                    './zh-cn': 8939,
                    './zh-cn.js': 8939,
                    './zh-hk': 9731,
                    './zh-hk.js': 9731,
                    './zh-mo': 6702,
                    './zh-mo.js': 6702,
                    './zh-tw': 4203,
                    './zh-tw.js': 4203,
                };

                function a(e) {
                    var t = o(e);
                    return n(t);
                }

                function o(e) {
                    if (!n.o(i, e)) {
                        var t = new Error("Cannot find module '" + e + "'");
                        t.code = 'MODULE_NOT_FOUND';
                        throw t;
                    }
                    return i[e];
                }

                a.keys = function () {
                    return Object.keys(i);
                };
                a.resolve = o;
                e.exports = a;
                a.id = 5358;
            },
            6758: function (e) {
                'use strict';
                e.exports = LForms.ucumPkg;
            },
            2634: function () {},
            750: function (e, t, n) {
                'use strict';
                var i = n(2031),
                    a = 'undefined' == typeof globalThis ? n.g : globalThis;
                e.exports = function () {
                    for (var e = [], t = 0; t < i.length; t++) {
                        if ('function' == typeof a[i[t]]) {
                            e[e.length] = i[t];
                        }
                    }
                    return e;
                };
            },
            2889: function (e, t, n) {
                'use strict';
                var i = n(3929),
                    a = n(2123);
                if (n(1064)() || n(2698)()) {
                    var o = Symbol.iterator;
                    e.exports = function (e) {
                        if (null != e && void 0 !== e[o]) {
                            return e[o]();
                        }
                        if (i(e)) {
                            return Array.prototype[o].call(e);
                        } else {
                            return;
                        }
                    };
                } else {
                    var r = n(3169),
                        s = n(514),
                        c = n(9718),
                        l = c('%Map%', !0),
                        u = c('%Set%', !0),
                        d = n(2264),
                        m = d('Array.prototype.push'),
                        p = d('String.prototype.charCodeAt'),
                        f = d('String.prototype.slice'),
                        g = function (e) {
                            var t = 0;
                            return {
                                next: function () {
                                    var n,
                                        i = t >= e.length;
                                    if (!i) {
                                        n = e[t];
                                        t += 1;
                                    }
                                    return { done: i, value: n };
                                },
                            };
                        },
                        h = function (e, t) {
                            if (r(e) || i(e)) {
                                return g(e);
                            }
                            if (s(e)) {
                                var n = 0;
                                return {
                                    next: function () {
                                        var t = (function (e, t) {
                                                if (t + 1 >= e.length) {
                                                    return t + 1;
                                                }
                                                var n = p(e, t);
                                                if (n < 55296 || n > 56319) {
                                                    return t + 1;
                                                }
                                                var i = p(e, t + 1);
                                                if (i < 56320 || i > 57343) {
                                                    return t + 1;
                                                } else {
                                                    return t + 2;
                                                }
                                            })(e, n),
                                            i = f(e, n, t);
                                        n = t;
                                        return { done: t > e.length, value: i };
                                    },
                                };
                            }
                            if (t && void 0 !== e['_es6-shim iterator_']) {
                                return e['_es6-shim iterator_']();
                            } else {
                                return;
                            }
                        };
                    if (!l && !u) {
                        e.exports = function (e) {
                            if (null != e) {
                                return h(e, !0);
                            }
                        };
                    } else {
                        var y = n(175),
                            x = n(4065),
                            _ = d('Map.prototype.forEach', !0),
                            E = d('Set.prototype.forEach', !0);
                        if ('undefined' == typeof process || !process.versions || !process.versions.node) {
                            var C = d('Map.prototype.iterator', !0),
                                S = d('Set.prototype.iterator', !0);
                        }
                        var b = d('Map.prototype.@@iterator', !0) || d('Map.prototype._es6-shim iterator_', !0),
                            v = d('Set.prototype.@@iterator', !0) || d('Set.prototype._es6-shim iterator_', !0);
                        e.exports = function (e) {
                            return (
                                (function (e) {
                                    if (y(e)) {
                                        if (C) {
                                            return a(C(e));
                                        }
                                        if (b) {
                                            return b(e);
                                        }
                                        if (_) {
                                            var t = [];
                                            _(e, function (e, n) {
                                                m(t, [n, e]);
                                            });
                                            return g(t);
                                        }
                                    }
                                    if (x(e)) {
                                        if (S) {
                                            return a(S(e));
                                        }
                                        if (v) {
                                            return v(e);
                                        }
                                        if (E) {
                                            var n = [];
                                            E(e, function (e) {
                                                m(n, e);
                                            });
                                            return g(n);
                                        }
                                    }
                                })(e) || h(e)
                            );
                        };
                    }
                }
            },
            7337: function (e, t, n) {
                'use strict';
                n.d(t, {
                    Ay: function () {
                        return w;
                    },
                });
                var i = Function.prototype.toString,
                    a = Object.create,
                    o = Object.prototype.toString,
                    r = (function () {
                        function e() {
                            this._keys = [];
                            this._values = [];
                        }

                        e.prototype.has = function (e) {
                            return !!~this._keys.indexOf(e);
                        };
                        e.prototype.get = function (e) {
                            return this._values[this._keys.indexOf(e)];
                        };
                        e.prototype.set = function (e, t) {
                            this._keys.push(e);
                            this._values.push(t);
                        };
                        return e;
                    })();
                var s =
                    'undefined' != typeof WeakMap
                        ? function () {
                              return new WeakMap();
                          }
                        : function () {
                              return new r();
                          };

                function c(e) {
                    if (!e) {
                        return a(null);
                    }
                    var t = e.constructor;
                    if (t === Object) {
                        return e === Object.prototype ? {} : a(e);
                    }
                    if (t && ~i.call(t).indexOf('[native code]')) {
                        try {
                            return new t();
                        } catch (e) {}
                    }
                    return a(e);
                }

                var l =
                    'g' === /test/g.flags
                        ? function (e) {
                              return e.flags;
                          }
                        : function (e) {
                              var t = '';
                              if (e.global) {
                                  t += 'g';
                              }
                              if (e.ignoreCase) {
                                  t += 'i';
                              }
                              if (e.multiline) {
                                  t += 'm';
                              }
                              if (e.unicode) {
                                  t += 'u';
                              }
                              if (e.sticky) {
                                  t += 'y';
                              }
                              return t;
                          };

                function u(e) {
                    var t = o.call(e);
                    return t.substring(8, t.length - 1);
                }

                var d =
                        'undefined' != typeof Symbol
                            ? function (e) {
                                  return e[Symbol.toStringTag] || u(e);
                              }
                            : u,
                    m = Object.defineProperty,
                    p = Object.getOwnPropertyDescriptor,
                    f = Object.getOwnPropertyNames,
                    g = Object.getOwnPropertySymbols,
                    h = Object.prototype,
                    y = h.hasOwnProperty,
                    x = h.propertyIsEnumerable,
                    _ = 'function' == typeof g;
                var E = _
                    ? function (e) {
                          return f(e).concat(g(e));
                      }
                    : f;

                function C(e, t, n) {
                    for (var i = E(e), a = 0, o = i.length, r = void 0, s = void 0; a < o; ++a) {
                        if ('callee' !== (r = i[a]) && 'caller' !== r) {
                            if ((s = p(e, r))) {
                                if (!s.get && !s.set) {
                                    s.value = n.copier(s.value, n);
                                }
                                try {
                                    m(t, r, s);
                                } catch (e) {
                                    t[r] = s.value;
                                }
                            } else {
                                t[r] = n.copier(e[r], n);
                            }
                        }
                    }
                    return t;
                }

                function S(e, t) {
                    return e.slice(0);
                }

                function b(e, t) {
                    var n = new t.Constructor();
                    t.cache.set(e, n);
                    e.forEach(function (e, i) {
                        n.set(i, t.copier(e, t));
                    });
                    return n;
                }

                var v = _
                    ? function (e, t) {
                          var n = c(t.prototype);
                          t.cache.set(e, n);
                          for (var i in e) {
                              if (y.call(e, i)) {
                                  n[i] = t.copier(e[i], t);
                              }
                          }
                          for (var a = g(e), o = 0, r = a.length, s = void 0; o < r; ++o) {
                              s = a[o];
                              if (x.call(e, s)) {
                                  n[s] = t.copier(e[s], t);
                              }
                          }
                          return n;
                      }
                    : function (e, t) {
                          var n = c(t.prototype);
                          t.cache.set(e, n);
                          for (var i in e) {
                              if (y.call(e, i)) {
                                  n[i] = t.copier(e[i], t);
                              }
                          }
                          return n;
                      };

                function D(e, t) {
                    return new t.Constructor(e.valueOf());
                }

                function R(e, t) {
                    return e;
                }

                function M(e, t) {
                    var n = new t.Constructor();
                    t.cache.set(e, n);
                    e.forEach(function (e) {
                        n.add(t.copier(e, t));
                    });
                    return n;
                }

                var T = Array.isArray,
                    k = Object.assign,
                    I =
                        Object.getPrototypeOf ||
                        function (e) {
                            return e.__proto__;
                        },
                    P = {
                        array: function (e, t) {
                            var n = new t.Constructor();
                            t.cache.set(e, n);
                            for (var i = 0, a = e.length; i < a; ++i) {
                                n[i] = t.copier(e[i], t);
                            }
                            return n;
                        },
                        arrayBuffer: S,
                        blob: function (e, t) {
                            return e.slice(0, e.size, e.type);
                        },
                        dataView: function (e, t) {
                            return new t.Constructor(S(e.buffer));
                        },
                        date: function (e, t) {
                            return new t.Constructor(e.getTime());
                        },
                        error: R,
                        map: b,
                        object: v,
                        regExp: function (e, t) {
                            var n = new t.Constructor(e.source, l(e));
                            n.lastIndex = e.lastIndex;
                            return n;
                        },
                        set: M,
                    },
                    L = k({}, P, {
                        array: function (e, t) {
                            var n = new t.Constructor();
                            t.cache.set(e, n);
                            return C(e, n, t);
                        },
                        map: function (e, t) {
                            return C(e, b(e, t), t);
                        },
                        object: function (e, t) {
                            var n = c(t.prototype);
                            t.cache.set(e, n);
                            return C(e, n, t);
                        },
                        set: function (e, t) {
                            return C(e, M(e, t), t);
                        },
                    });

                function A(e) {
                    var t = (function (e) {
                            return {
                                Arguments: e.object,
                                Array: e.array,
                                ArrayBuffer: e.arrayBuffer,
                                Blob: e.blob,
                                Boolean: D,
                                DataView: e.dataView,
                                Date: e.date,
                                Error: e.error,
                                Float32Array: e.arrayBuffer,
                                Float64Array: e.arrayBuffer,
                                Int8Array: e.arrayBuffer,
                                Int16Array: e.arrayBuffer,
                                Int32Array: e.arrayBuffer,
                                Map: e.map,
                                Number: D,
                                Object: e.object,
                                Promise: R,
                                RegExp: e.regExp,
                                Set: e.set,
                                String: D,
                                WeakMap: R,
                                WeakSet: R,
                                Uint8Array: e.arrayBuffer,
                                Uint8ClampedArray: e.arrayBuffer,
                                Uint16Array: e.arrayBuffer,
                                Uint32Array: e.arrayBuffer,
                                Uint64Array: e.arrayBuffer,
                            };
                        })(k({}, P, e)),
                        n = t.Array,
                        i = t.Object;

                    function a(e, a) {
                        a.prototype = a.Constructor = void 0;
                        if (!e || 'object' != typeof e) {
                            return e;
                        }
                        if (a.cache.has(e)) {
                            return a.cache.get(e);
                        }
                        a.prototype = I(e);
                        a.Constructor = a.prototype && a.prototype.constructor;
                        if (!a.Constructor || a.Constructor === Object) {
                            return i(e, a);
                        }
                        if (T(e)) {
                            return n(e, a);
                        }
                        var o = t[d(e)];
                        if (o) {
                            return o(e, a);
                        } else {
                            return 'function' == typeof e.then ? e : i(e, a);
                        }
                    }

                    return function (e) {
                        return a(e, { Constructor: void 0, cache: s(), copier: a, prototype: void 0 });
                    };
                }

                A(k({}, L, {}));
                var w = A({});
            },
            4764: function (e) {
                'use strict';
                e.exports = JSON.parse(
                    '{"ActivityDefinition.product":["Reference","CodeableConcept"],"ActivityDefinition.subject":["CodeableConcept","Reference"],"ActivityDefinition.timing":["Timing","DateTime","Age","Period","Range","Duration"],"AllergyIntolerance.onset":["DateTime","Age","Period","Range","String"],"Annotation.author":["Reference","String"],"AuditEvent.entity.detail.value":["String","Base64Binary"],"BiologicallyDerivedProduct.collection.collected":["DateTime","Period"],"BiologicallyDerivedProduct.manipulation.time":["DateTime","Period"],"BiologicallyDerivedProduct.processing.time":["DateTime","Period"],"CarePlan.activity.detail.product":["CodeableConcept","Reference"],"CarePlan.activity.detail.scheduled":["Timing","Period","String"],"ChargeItem.occurrence":["DateTime","Period","Timing"],"ChargeItem.product":["Reference","CodeableConcept"],"Claim.accident.location":["Address","Reference"],"Claim.diagnosis.diagnosis":["CodeableConcept","Reference"],"Claim.item.location":["CodeableConcept","Address","Reference"],"Claim.item.serviced":["Date","Period"],"Claim.procedure.procedure":["CodeableConcept","Reference"],"Claim.supportingInfo.timing":["Date","Period"],"Claim.supportingInfo.value":["Boolean","String","Quantity","Attachment","Reference"],"ClaimResponse.addItem.location":["CodeableConcept","Address","Reference"],"ClaimResponse.addItem.serviced":["Date","Period"],"ClinicalImpression.effective":["DateTime","Period"],"CodeSystem.concept.property.value":["Code","Coding","String","Integer","Boolean","DateTime","Decimal"],"Communication.payload.content":["String","Attachment","Reference"],"CommunicationRequest.occurrence":["DateTime","Period"],"CommunicationRequest.payload.content":["String","Attachment","Reference"],"Composition.relatesTo.target":["Identifier","Reference"],"ConceptMap.source":["Uri","Canonical"],"ConceptMap.target":["Uri","Canonical"],"Condition.abatement":["DateTime","Age","Period","Range","String"],"Condition.onset":["DateTime","Age","Period","Range","String"],"Consent.source":["Attachment","Reference"],"Contract.friendly.content":["Attachment","Reference"],"Contract.legal.content":["Attachment","Reference"],"Contract.legallyBinding":["Attachment","Reference"],"Contract.rule.content":["Attachment","Reference"],"Contract.term.action.occurrence":["DateTime","Period","Timing"],"Contract.term.asset.valuedItem.entity":["CodeableConcept","Reference"],"Contract.term.offer.answer.value":["Boolean","Decimal","Integer","Date","DateTime","Time","String","Uri","Attachment","Coding","Quantity","Reference"],"Contract.term.topic":["CodeableConcept","Reference"],"Contract.topic":["CodeableConcept","Reference"],"Coverage.costToBeneficiary.value":["Quantity","Money"],"CoverageEligibilityRequest.item.diagnosis.diagnosis":["CodeableConcept","Reference"],"CoverageEligibilityRequest.serviced":["Date","Period"],"CoverageEligibilityResponse.insurance.item.benefit.allowed":["UnsignedInt","String","Money"],"CoverageEligibilityResponse.insurance.item.benefit.used":["UnsignedInt","String","Money"],"CoverageEligibilityResponse.serviced":["Date","Period"],"DataRequirement.dateFilter.value":["DateTime","Period","Duration"],"DataRequirement.subject":["CodeableConcept","Reference"],"DetectedIssue.identified":["DateTime","Period"],"DeviceDefinition.manufacturer":["String","Reference"],"DeviceRequest.code":["Reference","CodeableConcept"],"DeviceRequest.occurrence":["DateTime","Period","Timing"],"DeviceRequest.parameter.value":["CodeableConcept","Quantity","Range","Boolean"],"DeviceUseStatement.timing":["Timing","Period","DateTime"],"DiagnosticReport.effective":["DateTime","Period"],"Dosage.asNeeded":["Boolean","CodeableConcept"],"Dosage.doseAndRate.dose":["Range","Quantity"],"Dosage.doseAndRate.rate":["Ratio","Range","Quantity"],"ElementDefinition.defaultValue":["Base64Binary","Boolean","Canonical","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Url","Uuid","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","ContactDetail","Contributor","DataRequirement","Expression","ParameterDefinition","RelatedArtifact","TriggerDefinition","UsageContext","Dosage","Meta"],"ElementDefinition.example.value":["Base64Binary","Boolean","Canonical","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Url","Uuid","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","ContactDetail","Contributor","DataRequirement","Expression","ParameterDefinition","RelatedArtifact","TriggerDefinition","UsageContext","Dosage","Meta"],"ElementDefinition.extension.value":["CodeableConcept","Canonical"],"ElementDefinition.fixed":["Base64Binary","Boolean","Canonical","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Url","Uuid","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","ContactDetail","Contributor","DataRequirement","Expression","ParameterDefinition","RelatedArtifact","TriggerDefinition","UsageContext","Dosage","Meta"],"ElementDefinition.maxValue":["Date","DateTime","Instant","Time","Decimal","Integer","PositiveInt","UnsignedInt","Quantity"],"ElementDefinition.minValue":["Date","DateTime","Instant","Time","Decimal","Integer","PositiveInt","UnsignedInt","Quantity"],"ElementDefinition.pattern":["Base64Binary","Boolean","Canonical","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Url","Uuid","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","ContactDetail","Contributor","DataRequirement","Expression","ParameterDefinition","RelatedArtifact","TriggerDefinition","UsageContext","Dosage","Meta"],"EventDefinition.subject":["CodeableConcept","Reference"],"EvidenceVariable.characteristic.definition":["Reference","Canonical","CodeableConcept","Expression","DataRequirement","TriggerDefinition"],"EvidenceVariable.characteristic.participantEffective":["DateTime","Period","Duration","Timing"],"ExplanationOfBenefit.accident.location":["Address","Reference"],"ExplanationOfBenefit.addItem.location":["CodeableConcept","Address","Reference"],"ExplanationOfBenefit.addItem.serviced":["Date","Period"],"ExplanationOfBenefit.benefitBalance.financial.allowed":["UnsignedInt","String","Money"],"ExplanationOfBenefit.benefitBalance.financial.used":["UnsignedInt","Money"],"ExplanationOfBenefit.diagnosis.diagnosis":["CodeableConcept","Reference"],"ExplanationOfBenefit.item.location":["CodeableConcept","Address","Reference"],"ExplanationOfBenefit.item.serviced":["Date","Period"],"ExplanationOfBenefit.procedure.procedure":["CodeableConcept","Reference"],"ExplanationOfBenefit.supportingInfo.timing":["Date","Period"],"ExplanationOfBenefit.supportingInfo.value":["Boolean","String","Quantity","Attachment","Reference"],"Extension.value":["Base64Binary","Boolean","Canonical","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Url","Uuid","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","ContactDetail","Contributor","DataRequirement","Expression","ParameterDefinition","RelatedArtifact","TriggerDefinition","UsageContext","Dosage","Meta"],"FamilyMemberHistory.age":["Age","Range","String"],"FamilyMemberHistory.born":["Period","Date","String"],"FamilyMemberHistory.condition.onset":["Age","Range","Period","String"],"FamilyMemberHistory.deceased":["Boolean","Age","Range","Date","String"],"Goal.start":["Date","CodeableConcept"],"Goal.target.detail":["Quantity","Range","CodeableConcept","String","Boolean","Integer","Ratio"],"Goal.target.due":["Date","Duration"],"Group.characteristic.value":["CodeableConcept","Boolean","Quantity","Range","Reference"],"GuidanceResponse.module":["Uri","Canonical","CodeableConcept"],"Immunization.occurrence":["DateTime","String"],"Immunization.protocolApplied.doseNumber":["PositiveInt","String"],"Immunization.protocolApplied.seriesDoses":["PositiveInt","String"],"ImmunizationEvaluation.doseNumber":["PositiveInt","String"],"ImmunizationEvaluation.seriesDoses":["PositiveInt","String"],"ImmunizationRecommendation.recommendation.doseNumber":["PositiveInt","String"],"ImmunizationRecommendation.recommendation.seriesDoses":["PositiveInt","String"],"ImplementationGuide.definition.page.name":["Url","Reference"],"ImplementationGuide.definition.resource.example":["Boolean","Canonical"],"ImplementationGuide.manifest.resource.example":["Boolean","Canonical"],"Invoice.lineItem.chargeItem":["Reference","CodeableConcept"],"Library.subject":["CodeableConcept","Reference"],"Measure.subject":["CodeableConcept","Reference"],"Media.created":["DateTime","Period"],"Medication.ingredient.item":["CodeableConcept","Reference"],"MedicationAdministration.dosage.rate":["Ratio","Quantity"],"MedicationAdministration.effective":["DateTime","Period"],"MedicationAdministration.medication":["CodeableConcept","Reference"],"MedicationDispense.medication":["CodeableConcept","Reference"],"MedicationDispense.statusReason":["CodeableConcept","Reference"],"MedicationKnowledge.administrationGuidelines.indication":["CodeableConcept","Reference"],"MedicationKnowledge.administrationGuidelines.patientCharacteristics.characteristic":["CodeableConcept","Quantity"],"MedicationKnowledge.drugCharacteristic.value":["CodeableConcept","String","Quantity","Base64Binary"],"MedicationKnowledge.ingredient.item":["CodeableConcept","Reference"],"MedicationRequest.medication":["CodeableConcept","Reference"],"MedicationRequest.reported":["Boolean","Reference"],"MedicationRequest.substitution.allowed":["Boolean","CodeableConcept"],"MedicationStatement.effective":["DateTime","Period"],"MedicationStatement.medication":["CodeableConcept","Reference"],"MedicinalProduct.specialDesignation.indication":["CodeableConcept","Reference"],"MedicinalProductAuthorization.procedure.date":["Period","DateTime"],"MedicinalProductContraindication.otherTherapy.medication":["CodeableConcept","Reference"],"MedicinalProductIndication.otherTherapy.medication":["CodeableConcept","Reference"],"MedicinalProductInteraction.interactant.item":["Reference","CodeableConcept"],"MessageDefinition.event":["Coding","Uri"],"MessageHeader.event":["Coding","Uri"],"NutritionOrder.enteralFormula.administration.rate":["Quantity","Ratio"],"Observation.component.value":["Quantity","CodeableConcept","String","Boolean","Integer","Range","Ratio","SampledData","Time","DateTime","Period"],"Observation.effective":["DateTime","Period","Timing","Instant"],"Observation.value":["Quantity","CodeableConcept","String","Boolean","Integer","Range","Ratio","SampledData","Time","DateTime","Period"],"Parameters.parameter.value":["Base64Binary","Boolean","Canonical","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Url","Uuid","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","ContactDetail","Contributor","DataRequirement","Expression","ParameterDefinition","RelatedArtifact","TriggerDefinition","UsageContext","Dosage","Meta"],"Patient.deceased":["Boolean","DateTime"],"Patient.multipleBirth":["Boolean","Integer"],"PlanDefinition.action.definition":["Canonical","Uri"],"PlanDefinition.action.relatedAction.offset":["Duration","Range"],"PlanDefinition.action.subject":["CodeableConcept","Reference"],"PlanDefinition.action.timing":["DateTime","Age","Period","Duration","Range","Timing"],"PlanDefinition.goal.target.detail":["Quantity","Range","CodeableConcept"],"PlanDefinition.subject":["CodeableConcept","Reference"],"Population.age":["Range","CodeableConcept"],"Procedure.performed":["DateTime","Period","String","Age","Range"],"Provenance.occurred":["Period","DateTime"],"Questionnaire.item.answerOption.value":["Integer","Date","Time","String","Coding","Reference"],"Questionnaire.item.enableWhen.answer":["Boolean","Decimal","Integer","Date","DateTime","Time","String","Coding","Quantity","Reference"],"Questionnaire.item.initial.value":["Boolean","Decimal","Integer","Date","DateTime","Time","String","Uri","Attachment","Coding","Quantity","Reference"],"QuestionnaireResponse.item.answer.value":["Boolean","Decimal","Integer","Date","DateTime","Time","String","Uri","Attachment","Coding","Quantity","Reference"],"RequestGroup.action.relatedAction.offset":["Duration","Range"],"RequestGroup.action.timing":["DateTime","Age","Period","Duration","Range","Timing"],"ResearchDefinition.subject":["CodeableConcept","Reference"],"ResearchElementDefinition.characteristic.definition":["CodeableConcept","Canonical","Expression","DataRequirement"],"ResearchElementDefinition.characteristic.participantEffective":["DateTime","Period","Duration","Timing"],"ResearchElementDefinition.characteristic.studyEffective":["DateTime","Period","Duration","Timing"],"ResearchElementDefinition.subject":["CodeableConcept","Reference"],"RiskAssessment.occurrence":["DateTime","Period"],"RiskAssessment.prediction.probability":["Decimal","Range"],"RiskAssessment.prediction.when":["Period","Range"],"ServiceRequest.asNeeded":["Boolean","CodeableConcept"],"ServiceRequest.occurrence":["DateTime","Period","Timing"],"ServiceRequest.quantity":["Quantity","Ratio","Range"],"Specimen.collection.collected":["DateTime","Period"],"Specimen.collection.fastingStatus":["CodeableConcept","Duration"],"Specimen.container.additive":["CodeableConcept","Reference"],"Specimen.processing.time":["DateTime","Period"],"SpecimenDefinition.typeTested.container.additive.additive":["CodeableConcept","Reference"],"SpecimenDefinition.typeTested.container.minimumVolume":["Quantity","String"],"StructureMap.group.rule.source.defaultValue":["Base64Binary","Boolean","Canonical","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Url","Uuid","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","ContactDetail","Contributor","DataRequirement","Expression","ParameterDefinition","RelatedArtifact","TriggerDefinition","UsageContext","Dosage","Meta"],"StructureMap.group.rule.target.parameter.value":["Id","String","Boolean","Integer","Decimal"],"Substance.ingredient.substance":["CodeableConcept","Reference"],"SubstanceAmount.amount":["Quantity","Range","String"],"SubstanceReferenceInformation.target.amount":["Quantity","Range","String"],"SubstanceSpecification.moiety.amount":["Quantity","String"],"SubstanceSpecification.property.amount":["Quantity","String"],"SubstanceSpecification.property.definingSubstance":["Reference","CodeableConcept"],"SubstanceSpecification.relationship.amount":["Quantity","Range","Ratio","String"],"SubstanceSpecification.relationship.substance":["Reference","CodeableConcept"],"SupplyDelivery.occurrence":["DateTime","Period","Timing"],"SupplyDelivery.suppliedItem.item":["CodeableConcept","Reference"],"SupplyRequest.item":["CodeableConcept","Reference"],"SupplyRequest.occurrence":["DateTime","Period","Timing"],"SupplyRequest.parameter.value":["CodeableConcept","Quantity","Range","Boolean"],"Task.input.value":["Base64Binary","Boolean","Canonical","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Url","Uuid","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","ContactDetail","Contributor","DataRequirement","Expression","ParameterDefinition","RelatedArtifact","TriggerDefinition","UsageContext","Dosage","Meta"],"Task.output.value":["Base64Binary","Boolean","Canonical","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Url","Uuid","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","ContactDetail","Contributor","DataRequirement","Expression","ParameterDefinition","RelatedArtifact","TriggerDefinition","UsageContext","Dosage","Meta"],"Timing.repeat.bounds":["Duration","Range","Period"],"TriggerDefinition.timing":["Timing","Reference","Date","DateTime"],"UsageContext.value":["CodeableConcept","Quantity","Range","Reference"],"ValueSet.expansion.parameter.value":["String","Boolean","Integer","Decimal","Uri","Code","DateTime"]}',
                );
            },
            1430: function (e) {
                'use strict';
                e.exports = JSON.parse(
                    '{"Account.contained":"Resource","Account.coverage":"BackboneElement","Account.coverage.coverage":"Reference","Account.coverage.extension":"Extension","Account.coverage.id":"System.String","Account.coverage.modifierExtension":"Extension","Account.coverage.priority":"positiveInt","Account.description":"string","Account.extension":"Extension","Account.guarantor":"BackboneElement","Account.guarantor.extension":"Extension","Account.guarantor.id":"System.String","Account.guarantor.modifierExtension":"Extension","Account.guarantor.onHold":"boolean","Account.guarantor.party":"Reference","Account.guarantor.period":"Period","Account.id":"System.String","Account.identifier":"Identifier","Account.implicitRules":"uri","Account.language":"code","Account.meta":"Meta","Account.modifierExtension":"Extension","Account.name":"string","Account.owner":"Reference","Account.partOf":"Reference","Account.servicePeriod":"Period","Account.status":"code","Account.subject":"Reference","Account.text":"Narrative","Account.type":"CodeableConcept","ActivityDefinition.approvalDate":"date","ActivityDefinition.author":"ContactDetail","ActivityDefinition.bodySite":"CodeableConcept","ActivityDefinition.code":"CodeableConcept","ActivityDefinition.contact":"ContactDetail","ActivityDefinition.contained":"Resource","ActivityDefinition.copyright":"markdown","ActivityDefinition.date":"dateTime","ActivityDefinition.description":"markdown","ActivityDefinition.doNotPerform":"boolean","ActivityDefinition.dosage":"Dosage","ActivityDefinition.dynamicValue":"BackboneElement","ActivityDefinition.dynamicValue.expression":"Expression","ActivityDefinition.dynamicValue.extension":"Extension","ActivityDefinition.dynamicValue.id":"System.String","ActivityDefinition.dynamicValue.modifierExtension":"Extension","ActivityDefinition.dynamicValue.path":"string","ActivityDefinition.editor":"ContactDetail","ActivityDefinition.effectivePeriod":"Period","ActivityDefinition.endorser":"ContactDetail","ActivityDefinition.experimental":"boolean","ActivityDefinition.extension":"Extension","ActivityDefinition.id":"System.String","ActivityDefinition.identifier":"Identifier","ActivityDefinition.implicitRules":"uri","ActivityDefinition.intent":"code","ActivityDefinition.jurisdiction":"CodeableConcept","ActivityDefinition.kind":"code","ActivityDefinition.language":"code","ActivityDefinition.lastReviewDate":"date","ActivityDefinition.library":"canonical","ActivityDefinition.location":"Reference","ActivityDefinition.meta":"Meta","ActivityDefinition.modifierExtension":"Extension","ActivityDefinition.name":"string","ActivityDefinition.observationRequirement":"Reference","ActivityDefinition.observationResultRequirement":"Reference","ActivityDefinition.participant":"BackboneElement","ActivityDefinition.participant.extension":"Extension","ActivityDefinition.participant.id":"System.String","ActivityDefinition.participant.modifierExtension":"Extension","ActivityDefinition.participant.role":"CodeableConcept","ActivityDefinition.participant.type":"code","ActivityDefinition.priority":"code","ActivityDefinition.productCodeableConcept":"CodeableConcept","ActivityDefinition.productReference":"Reference","ActivityDefinition.profile":"canonical","ActivityDefinition.publisher":"string","ActivityDefinition.purpose":"markdown","ActivityDefinition.quantity":"Quantity","ActivityDefinition.relatedArtifact":"RelatedArtifact","ActivityDefinition.reviewer":"ContactDetail","ActivityDefinition.specimenRequirement":"Reference","ActivityDefinition.status":"code","ActivityDefinition.subjectCodeableConcept":"CodeableConcept","ActivityDefinition.subjectReference":"Reference","ActivityDefinition.subtitle":"string","ActivityDefinition.text":"Narrative","ActivityDefinition.timingAge":"Age","ActivityDefinition.timingDateTime":"dateTime","ActivityDefinition.timingDuration":"Duration","ActivityDefinition.timingPeriod":"Period","ActivityDefinition.timingRange":"Range","ActivityDefinition.timingTiming":"Timing","ActivityDefinition.title":"string","ActivityDefinition.topic":"CodeableConcept","ActivityDefinition.transform":"canonical","ActivityDefinition.url":"uri","ActivityDefinition.usage":"string","ActivityDefinition.useContext":"UsageContext","ActivityDefinition.version":"string","Address.city":"string","Address.country":"string","Address.district":"string","Address.extension":"Extension","Address.id":"System.String","Address.line":"string","Address.period":"Period","Address.postalCode":"string","Address.state":"string","Address.text":"string","Address.type":"code","Address.use":"code","AdverseEvent.actuality":"code","AdverseEvent.category":"CodeableConcept","AdverseEvent.contained":"Resource","AdverseEvent.contributor":"Reference","AdverseEvent.date":"dateTime","AdverseEvent.detected":"dateTime","AdverseEvent.encounter":"Reference","AdverseEvent.event":"CodeableConcept","AdverseEvent.extension":"Extension","AdverseEvent.id":"System.String","AdverseEvent.identifier":"Identifier","AdverseEvent.implicitRules":"uri","AdverseEvent.language":"code","AdverseEvent.location":"Reference","AdverseEvent.meta":"Meta","AdverseEvent.modifierExtension":"Extension","AdverseEvent.outcome":"CodeableConcept","AdverseEvent.recordedDate":"dateTime","AdverseEvent.recorder":"Reference","AdverseEvent.referenceDocument":"Reference","AdverseEvent.resultingCondition":"Reference","AdverseEvent.seriousness":"CodeableConcept","AdverseEvent.severity":"CodeableConcept","AdverseEvent.study":"Reference","AdverseEvent.subject":"Reference","AdverseEvent.subjectMedicalHistory":"Reference","AdverseEvent.suspectEntity":"BackboneElement","AdverseEvent.suspectEntity.causality":"BackboneElement","AdverseEvent.suspectEntity.causality.assessment":"CodeableConcept","AdverseEvent.suspectEntity.causality.author":"Reference","AdverseEvent.suspectEntity.causality.extension":"Extension","AdverseEvent.suspectEntity.causality.id":"System.String","AdverseEvent.suspectEntity.causality.method":"CodeableConcept","AdverseEvent.suspectEntity.causality.modifierExtension":"Extension","AdverseEvent.suspectEntity.causality.productRelatedness":"string","AdverseEvent.suspectEntity.extension":"Extension","AdverseEvent.suspectEntity.id":"System.String","AdverseEvent.suspectEntity.instance":"Reference","AdverseEvent.suspectEntity.modifierExtension":"Extension","AdverseEvent.text":"Narrative","Age.code":"code","Age.comparator":"code","Age.extension":"Extension","Age.id":"System.String","Age.system":"uri","Age.unit":"string","Age.value":"decimal","AllergyIntolerance.asserter":"Reference","AllergyIntolerance.category":"code","AllergyIntolerance.clinicalStatus":"CodeableConcept","AllergyIntolerance.code":"CodeableConcept","AllergyIntolerance.contained":"Resource","AllergyIntolerance.criticality":"code","AllergyIntolerance.encounter":"Reference","AllergyIntolerance.extension":"Extension","AllergyIntolerance.id":"System.String","AllergyIntolerance.identifier":"Identifier","AllergyIntolerance.implicitRules":"uri","AllergyIntolerance.language":"code","AllergyIntolerance.lastOccurrence":"dateTime","AllergyIntolerance.meta":"Meta","AllergyIntolerance.modifierExtension":"Extension","AllergyIntolerance.note":"Annotation","AllergyIntolerance.onsetAge":"Age","AllergyIntolerance.onsetDateTime":"dateTime","AllergyIntolerance.onsetPeriod":"Period","AllergyIntolerance.onsetRange":"Range","AllergyIntolerance.onsetString":"string","AllergyIntolerance.patient":"Reference","AllergyIntolerance.reaction":"BackboneElement","AllergyIntolerance.reaction.description":"string","AllergyIntolerance.reaction.exposureRoute":"CodeableConcept","AllergyIntolerance.reaction.extension":"Extension","AllergyIntolerance.reaction.id":"System.String","AllergyIntolerance.reaction.manifestation":"CodeableConcept","AllergyIntolerance.reaction.modifierExtension":"Extension","AllergyIntolerance.reaction.note":"Annotation","AllergyIntolerance.reaction.onset":"dateTime","AllergyIntolerance.reaction.severity":"code","AllergyIntolerance.reaction.substance":"CodeableConcept","AllergyIntolerance.recordedDate":"dateTime","AllergyIntolerance.recorder":"Reference","AllergyIntolerance.text":"Narrative","AllergyIntolerance.type":"code","AllergyIntolerance.verificationStatus":"CodeableConcept","Annotation.authorReference":"Reference","Annotation.authorString":"string","Annotation.extension":"Extension","Annotation.id":"System.String","Annotation.text":"markdown","Annotation.time":"dateTime","Appointment.appointmentType":"CodeableConcept","Appointment.basedOn":"Reference","Appointment.cancelationReason":"CodeableConcept","Appointment.comment":"string","Appointment.contained":"Resource","Appointment.created":"dateTime","Appointment.description":"string","Appointment.end":"instant","Appointment.extension":"Extension","Appointment.id":"System.String","Appointment.identifier":"Identifier","Appointment.implicitRules":"uri","Appointment.language":"code","Appointment.meta":"Meta","Appointment.minutesDuration":"positiveInt","Appointment.modifierExtension":"Extension","Appointment.participant":"BackboneElement","Appointment.participant.actor":"Reference","Appointment.participant.extension":"Extension","Appointment.participant.id":"System.String","Appointment.participant.modifierExtension":"Extension","Appointment.participant.period":"Period","Appointment.participant.required":"code","Appointment.participant.status":"code","Appointment.participant.type":"CodeableConcept","Appointment.patientInstruction":"string","Appointment.priority":"unsignedInt","Appointment.reasonCode":"CodeableConcept","Appointment.reasonReference":"Reference","Appointment.requestedPeriod":"Period","Appointment.serviceCategory":"CodeableConcept","Appointment.serviceType":"CodeableConcept","Appointment.slot":"Reference","Appointment.specialty":"CodeableConcept","Appointment.start":"instant","Appointment.status":"code","Appointment.supportingInformation":"Reference","Appointment.text":"Narrative","AppointmentResponse.actor":"Reference","AppointmentResponse.appointment":"Reference","AppointmentResponse.comment":"string","AppointmentResponse.contained":"Resource","AppointmentResponse.end":"instant","AppointmentResponse.extension":"Extension","AppointmentResponse.id":"System.String","AppointmentResponse.identifier":"Identifier","AppointmentResponse.implicitRules":"uri","AppointmentResponse.language":"code","AppointmentResponse.meta":"Meta","AppointmentResponse.modifierExtension":"Extension","AppointmentResponse.participantStatus":"code","AppointmentResponse.participantType":"CodeableConcept","AppointmentResponse.start":"instant","AppointmentResponse.text":"Narrative","Attachment.contentType":"code","Attachment.creation":"dateTime","Attachment.data":"base64Binary","Attachment.extension":"Extension","Attachment.hash":"base64Binary","Attachment.id":"System.String","Attachment.language":"code","Attachment.size":"unsignedInt","Attachment.title":"string","Attachment.url":"url","AuditEvent.action":"code","AuditEvent.agent":"BackboneElement","AuditEvent.agent.altId":"string","AuditEvent.agent.extension":"Extension","AuditEvent.agent.id":"System.String","AuditEvent.agent.location":"Reference","AuditEvent.agent.media":"Coding","AuditEvent.agent.modifierExtension":"Extension","AuditEvent.agent.name":"string","AuditEvent.agent.network":"BackboneElement","AuditEvent.agent.network.address":"string","AuditEvent.agent.network.extension":"Extension","AuditEvent.agent.network.id":"System.String","AuditEvent.agent.network.modifierExtension":"Extension","AuditEvent.agent.network.type":"code","AuditEvent.agent.policy":"uri","AuditEvent.agent.purposeOfUse":"CodeableConcept","AuditEvent.agent.requestor":"boolean","AuditEvent.agent.role":"CodeableConcept","AuditEvent.agent.type":"CodeableConcept","AuditEvent.agent.who":"Reference","AuditEvent.contained":"Resource","AuditEvent.entity":"BackboneElement","AuditEvent.entity.description":"string","AuditEvent.entity.detail":"BackboneElement","AuditEvent.entity.detail.extension":"Extension","AuditEvent.entity.detail.id":"System.String","AuditEvent.entity.detail.modifierExtension":"Extension","AuditEvent.entity.detail.type":"string","AuditEvent.entity.detail.valueBase64Binary":"base64Binary","AuditEvent.entity.detail.valueString":"string","AuditEvent.entity.extension":"Extension","AuditEvent.entity.id":"System.String","AuditEvent.entity.lifecycle":"Coding","AuditEvent.entity.modifierExtension":"Extension","AuditEvent.entity.name":"string","AuditEvent.entity.query":"base64Binary","AuditEvent.entity.role":"Coding","AuditEvent.entity.securityLabel":"Coding","AuditEvent.entity.type":"Coding","AuditEvent.entity.what":"Reference","AuditEvent.extension":"Extension","AuditEvent.id":"System.String","AuditEvent.implicitRules":"uri","AuditEvent.language":"code","AuditEvent.meta":"Meta","AuditEvent.modifierExtension":"Extension","AuditEvent.outcome":"code","AuditEvent.outcomeDesc":"string","AuditEvent.period":"Period","AuditEvent.purposeOfEvent":"CodeableConcept","AuditEvent.recorded":"instant","AuditEvent.source":"BackboneElement","AuditEvent.source.extension":"Extension","AuditEvent.source.id":"System.String","AuditEvent.source.modifierExtension":"Extension","AuditEvent.source.observer":"Reference","AuditEvent.source.site":"string","AuditEvent.source.type":"Coding","AuditEvent.subtype":"Coding","AuditEvent.text":"Narrative","AuditEvent.type":"Coding","BackboneElement.extension":"Extension","BackboneElement.id":"System.String","BackboneElement.modifierExtension":"Extension","Basic.author":"Reference","Basic.code":"CodeableConcept","Basic.contained":"Resource","Basic.created":"date","Basic.extension":"Extension","Basic.id":"System.String","Basic.identifier":"Identifier","Basic.implicitRules":"uri","Basic.language":"code","Basic.meta":"Meta","Basic.modifierExtension":"Extension","Basic.subject":"Reference","Basic.text":"Narrative","Binary.contentType":"code","Binary.data":"base64Binary","Binary.id":"System.String","Binary.implicitRules":"uri","Binary.language":"code","Binary.meta":"Meta","Binary.securityContext":"Reference","BiologicallyDerivedProduct.collection":"BackboneElement","BiologicallyDerivedProduct.collection.collectedDateTime":"dateTime","BiologicallyDerivedProduct.collection.collectedPeriod":"Period","BiologicallyDerivedProduct.collection.collector":"Reference","BiologicallyDerivedProduct.collection.extension":"Extension","BiologicallyDerivedProduct.collection.id":"System.String","BiologicallyDerivedProduct.collection.modifierExtension":"Extension","BiologicallyDerivedProduct.collection.source":"Reference","BiologicallyDerivedProduct.contained":"Resource","BiologicallyDerivedProduct.extension":"Extension","BiologicallyDerivedProduct.id":"System.String","BiologicallyDerivedProduct.identifier":"Identifier","BiologicallyDerivedProduct.implicitRules":"uri","BiologicallyDerivedProduct.language":"code","BiologicallyDerivedProduct.manipulation":"BackboneElement","BiologicallyDerivedProduct.manipulation.description":"string","BiologicallyDerivedProduct.manipulation.extension":"Extension","BiologicallyDerivedProduct.manipulation.id":"System.String","BiologicallyDerivedProduct.manipulation.modifierExtension":"Extension","BiologicallyDerivedProduct.manipulation.timeDateTime":"dateTime","BiologicallyDerivedProduct.manipulation.timePeriod":"Period","BiologicallyDerivedProduct.meta":"Meta","BiologicallyDerivedProduct.modifierExtension":"Extension","BiologicallyDerivedProduct.parent":"Reference","BiologicallyDerivedProduct.processing":"BackboneElement","BiologicallyDerivedProduct.processing.additive":"Reference","BiologicallyDerivedProduct.processing.description":"string","BiologicallyDerivedProduct.processing.extension":"Extension","BiologicallyDerivedProduct.processing.id":"System.String","BiologicallyDerivedProduct.processing.modifierExtension":"Extension","BiologicallyDerivedProduct.processing.procedure":"CodeableConcept","BiologicallyDerivedProduct.processing.timeDateTime":"dateTime","BiologicallyDerivedProduct.processing.timePeriod":"Period","BiologicallyDerivedProduct.productCategory":"code","BiologicallyDerivedProduct.productCode":"CodeableConcept","BiologicallyDerivedProduct.quantity":"integer","BiologicallyDerivedProduct.request":"Reference","BiologicallyDerivedProduct.status":"code","BiologicallyDerivedProduct.storage":"BackboneElement","BiologicallyDerivedProduct.storage.description":"string","BiologicallyDerivedProduct.storage.duration":"Period","BiologicallyDerivedProduct.storage.extension":"Extension","BiologicallyDerivedProduct.storage.id":"System.String","BiologicallyDerivedProduct.storage.modifierExtension":"Extension","BiologicallyDerivedProduct.storage.scale":"code","BiologicallyDerivedProduct.storage.temperature":"decimal","BiologicallyDerivedProduct.text":"Narrative","BodyStructure.active":"boolean","BodyStructure.contained":"Resource","BodyStructure.description":"string","BodyStructure.extension":"Extension","BodyStructure.id":"System.String","BodyStructure.identifier":"Identifier","BodyStructure.image":"Attachment","BodyStructure.implicitRules":"uri","BodyStructure.language":"code","BodyStructure.location":"CodeableConcept","BodyStructure.locationQualifier":"CodeableConcept","BodyStructure.meta":"Meta","BodyStructure.modifierExtension":"Extension","BodyStructure.morphology":"CodeableConcept","BodyStructure.patient":"Reference","BodyStructure.text":"Narrative","Bundle.entry":"BackboneElement","Bundle.entry.extension":"Extension","Bundle.entry.fullUrl":"uri","Bundle.entry.id":"System.String","Bundle.entry.modifierExtension":"Extension","Bundle.entry.request":"BackboneElement","Bundle.entry.request.extension":"Extension","Bundle.entry.request.id":"System.String","Bundle.entry.request.ifMatch":"string","Bundle.entry.request.ifModifiedSince":"instant","Bundle.entry.request.ifNoneExist":"string","Bundle.entry.request.ifNoneMatch":"string","Bundle.entry.request.method":"code","Bundle.entry.request.modifierExtension":"Extension","Bundle.entry.request.url":"uri","Bundle.entry.resource":"Resource","Bundle.entry.response":"BackboneElement","Bundle.entry.response.etag":"string","Bundle.entry.response.extension":"Extension","Bundle.entry.response.id":"System.String","Bundle.entry.response.lastModified":"instant","Bundle.entry.response.location":"uri","Bundle.entry.response.modifierExtension":"Extension","Bundle.entry.response.outcome":"Resource","Bundle.entry.response.status":"string","Bundle.entry.search":"BackboneElement","Bundle.entry.search.extension":"Extension","Bundle.entry.search.id":"System.String","Bundle.entry.search.mode":"code","Bundle.entry.search.modifierExtension":"Extension","Bundle.entry.search.score":"decimal","Bundle.id":"System.String","Bundle.identifier":"Identifier","Bundle.implicitRules":"uri","Bundle.language":"code","Bundle.link":"BackboneElement","Bundle.link.extension":"Extension","Bundle.link.id":"System.String","Bundle.link.modifierExtension":"Extension","Bundle.link.relation":"string","Bundle.link.url":"uri","Bundle.meta":"Meta","Bundle.signature":"Signature","Bundle.timestamp":"instant","Bundle.total":"unsignedInt","Bundle.type":"code","CapabilityStatement.contact":"ContactDetail","CapabilityStatement.contained":"Resource","CapabilityStatement.copyright":"markdown","CapabilityStatement.date":"dateTime","CapabilityStatement.description":"markdown","CapabilityStatement.document":"BackboneElement","CapabilityStatement.document.documentation":"markdown","CapabilityStatement.document.extension":"Extension","CapabilityStatement.document.id":"System.String","CapabilityStatement.document.mode":"code","CapabilityStatement.document.modifierExtension":"Extension","CapabilityStatement.document.profile":"canonical","CapabilityStatement.experimental":"boolean","CapabilityStatement.extension":"Extension","CapabilityStatement.fhirVersion":"code","CapabilityStatement.format":"code","CapabilityStatement.id":"System.String","CapabilityStatement.implementation":"BackboneElement","CapabilityStatement.implementation.custodian":"Reference","CapabilityStatement.implementation.description":"string","CapabilityStatement.implementation.extension":"Extension","CapabilityStatement.implementation.id":"System.String","CapabilityStatement.implementation.modifierExtension":"Extension","CapabilityStatement.implementation.url":"url","CapabilityStatement.implementationGuide":"canonical","CapabilityStatement.implicitRules":"uri","CapabilityStatement.imports":"canonical","CapabilityStatement.instantiates":"canonical","CapabilityStatement.jurisdiction":"CodeableConcept","CapabilityStatement.kind":"code","CapabilityStatement.language":"code","CapabilityStatement.messaging":"BackboneElement","CapabilityStatement.messaging.documentation":"markdown","CapabilityStatement.messaging.endpoint":"BackboneElement","CapabilityStatement.messaging.endpoint.address":"url","CapabilityStatement.messaging.endpoint.extension":"Extension","CapabilityStatement.messaging.endpoint.id":"System.String","CapabilityStatement.messaging.endpoint.modifierExtension":"Extension","CapabilityStatement.messaging.endpoint.protocol":"Coding","CapabilityStatement.messaging.extension":"Extension","CapabilityStatement.messaging.id":"System.String","CapabilityStatement.messaging.modifierExtension":"Extension","CapabilityStatement.messaging.reliableCache":"unsignedInt","CapabilityStatement.messaging.supportedMessage":"BackboneElement","CapabilityStatement.messaging.supportedMessage.definition":"canonical","CapabilityStatement.messaging.supportedMessage.extension":"Extension","CapabilityStatement.messaging.supportedMessage.id":"System.String","CapabilityStatement.messaging.supportedMessage.mode":"code","CapabilityStatement.messaging.supportedMessage.modifierExtension":"Extension","CapabilityStatement.meta":"Meta","CapabilityStatement.modifierExtension":"Extension","CapabilityStatement.name":"string","CapabilityStatement.patchFormat":"code","CapabilityStatement.publisher":"string","CapabilityStatement.purpose":"markdown","CapabilityStatement.rest":"BackboneElement","CapabilityStatement.rest.compartment":"canonical","CapabilityStatement.rest.documentation":"markdown","CapabilityStatement.rest.extension":"Extension","CapabilityStatement.rest.id":"System.String","CapabilityStatement.rest.interaction":"BackboneElement","CapabilityStatement.rest.interaction.code":"code","CapabilityStatement.rest.interaction.documentation":"markdown","CapabilityStatement.rest.interaction.extension":"Extension","CapabilityStatement.rest.interaction.id":"System.String","CapabilityStatement.rest.interaction.modifierExtension":"Extension","CapabilityStatement.rest.mode":"code","CapabilityStatement.rest.modifierExtension":"Extension","CapabilityStatement.rest.resource":"BackboneElement","CapabilityStatement.rest.resource.conditionalCreate":"boolean","CapabilityStatement.rest.resource.conditionalDelete":"code","CapabilityStatement.rest.resource.conditionalRead":"code","CapabilityStatement.rest.resource.conditionalUpdate":"boolean","CapabilityStatement.rest.resource.documentation":"markdown","CapabilityStatement.rest.resource.extension":"Extension","CapabilityStatement.rest.resource.id":"System.String","CapabilityStatement.rest.resource.interaction":"BackboneElement","CapabilityStatement.rest.resource.interaction.code":"code","CapabilityStatement.rest.resource.interaction.documentation":"markdown","CapabilityStatement.rest.resource.interaction.extension":"Extension","CapabilityStatement.rest.resource.interaction.id":"System.String","CapabilityStatement.rest.resource.interaction.modifierExtension":"Extension","CapabilityStatement.rest.resource.modifierExtension":"Extension","CapabilityStatement.rest.resource.operation":"BackboneElement","CapabilityStatement.rest.resource.operation.definition":"canonical","CapabilityStatement.rest.resource.operation.documentation":"markdown","CapabilityStatement.rest.resource.operation.extension":"Extension","CapabilityStatement.rest.resource.operation.id":"System.String","CapabilityStatement.rest.resource.operation.modifierExtension":"Extension","CapabilityStatement.rest.resource.operation.name":"string","CapabilityStatement.rest.resource.profile":"canonical","CapabilityStatement.rest.resource.readHistory":"boolean","CapabilityStatement.rest.resource.referencePolicy":"code","CapabilityStatement.rest.resource.searchInclude":"string","CapabilityStatement.rest.resource.searchParam":"BackboneElement","CapabilityStatement.rest.resource.searchParam.definition":"canonical","CapabilityStatement.rest.resource.searchParam.documentation":"markdown","CapabilityStatement.rest.resource.searchParam.extension":"Extension","CapabilityStatement.rest.resource.searchParam.id":"System.String","CapabilityStatement.rest.resource.searchParam.modifierExtension":"Extension","CapabilityStatement.rest.resource.searchParam.name":"string","CapabilityStatement.rest.resource.searchParam.type":"code","CapabilityStatement.rest.resource.searchRevInclude":"string","CapabilityStatement.rest.resource.supportedProfile":"canonical","CapabilityStatement.rest.resource.type":"code","CapabilityStatement.rest.resource.updateCreate":"boolean","CapabilityStatement.rest.resource.versioning":"code","CapabilityStatement.rest.security":"BackboneElement","CapabilityStatement.rest.security.cors":"boolean","CapabilityStatement.rest.security.description":"markdown","CapabilityStatement.rest.security.extension":"Extension","CapabilityStatement.rest.security.id":"System.String","CapabilityStatement.rest.security.modifierExtension":"Extension","CapabilityStatement.rest.security.service":"CodeableConcept","CapabilityStatement.software":"BackboneElement","CapabilityStatement.software.extension":"Extension","CapabilityStatement.software.id":"System.String","CapabilityStatement.software.modifierExtension":"Extension","CapabilityStatement.software.name":"string","CapabilityStatement.software.releaseDate":"dateTime","CapabilityStatement.software.version":"string","CapabilityStatement.status":"code","CapabilityStatement.text":"Narrative","CapabilityStatement.title":"string","CapabilityStatement.url":"uri","CapabilityStatement.useContext":"UsageContext","CapabilityStatement.version":"string","CarePlan.activity":"BackboneElement","CarePlan.activity.detail":"BackboneElement","CarePlan.activity.detail.code":"CodeableConcept","CarePlan.activity.detail.dailyAmount":"Quantity","CarePlan.activity.detail.description":"string","CarePlan.activity.detail.doNotPerform":"boolean","CarePlan.activity.detail.extension":"Extension","CarePlan.activity.detail.goal":"Reference","CarePlan.activity.detail.id":"System.String","CarePlan.activity.detail.instantiatesCanonical":"canonical","CarePlan.activity.detail.instantiatesUri":"uri","CarePlan.activity.detail.kind":"code","CarePlan.activity.detail.location":"Reference","CarePlan.activity.detail.modifierExtension":"Extension","CarePlan.activity.detail.performer":"Reference","CarePlan.activity.detail.productCodeableConcept":"CodeableConcept","CarePlan.activity.detail.productReference":"Reference","CarePlan.activity.detail.quantity":"Quantity","CarePlan.activity.detail.reasonCode":"CodeableConcept","CarePlan.activity.detail.reasonReference":"Reference","CarePlan.activity.detail.scheduledPeriod":"Period","CarePlan.activity.detail.scheduledString":"string","CarePlan.activity.detail.scheduledTiming":"Timing","CarePlan.activity.detail.status":"code","CarePlan.activity.detail.statusReason":"CodeableConcept","CarePlan.activity.extension":"Extension","CarePlan.activity.id":"System.String","CarePlan.activity.modifierExtension":"Extension","CarePlan.activity.outcomeCodeableConcept":"CodeableConcept","CarePlan.activity.outcomeReference":"Reference","CarePlan.activity.progress":"Annotation","CarePlan.activity.reference":"Reference","CarePlan.addresses":"Reference","CarePlan.author":"Reference","CarePlan.basedOn":"Reference","CarePlan.careTeam":"Reference","CarePlan.category":"CodeableConcept","CarePlan.contained":"Resource","CarePlan.contributor":"Reference","CarePlan.created":"dateTime","CarePlan.description":"string","CarePlan.encounter":"Reference","CarePlan.extension":"Extension","CarePlan.goal":"Reference","CarePlan.id":"System.String","CarePlan.identifier":"Identifier","CarePlan.implicitRules":"uri","CarePlan.instantiatesCanonical":"canonical","CarePlan.instantiatesUri":"uri","CarePlan.intent":"code","CarePlan.language":"code","CarePlan.meta":"Meta","CarePlan.modifierExtension":"Extension","CarePlan.note":"Annotation","CarePlan.partOf":"Reference","CarePlan.period":"Period","CarePlan.replaces":"Reference","CarePlan.status":"code","CarePlan.subject":"Reference","CarePlan.supportingInfo":"Reference","CarePlan.text":"Narrative","CarePlan.title":"string","CareTeam.category":"CodeableConcept","CareTeam.contained":"Resource","CareTeam.encounter":"Reference","CareTeam.extension":"Extension","CareTeam.id":"System.String","CareTeam.identifier":"Identifier","CareTeam.implicitRules":"uri","CareTeam.language":"code","CareTeam.managingOrganization":"Reference","CareTeam.meta":"Meta","CareTeam.modifierExtension":"Extension","CareTeam.name":"string","CareTeam.note":"Annotation","CareTeam.participant":"BackboneElement","CareTeam.participant.extension":"Extension","CareTeam.participant.id":"System.String","CareTeam.participant.member":"Reference","CareTeam.participant.modifierExtension":"Extension","CareTeam.participant.onBehalfOf":"Reference","CareTeam.participant.period":"Period","CareTeam.participant.role":"CodeableConcept","CareTeam.period":"Period","CareTeam.reasonCode":"CodeableConcept","CareTeam.reasonReference":"Reference","CareTeam.status":"code","CareTeam.subject":"Reference","CareTeam.telecom":"ContactPoint","CareTeam.text":"Narrative","CatalogEntry.additionalCharacteristic":"CodeableConcept","CatalogEntry.additionalClassification":"CodeableConcept","CatalogEntry.additionalIdentifier":"Identifier","CatalogEntry.classification":"CodeableConcept","CatalogEntry.contained":"Resource","CatalogEntry.extension":"Extension","CatalogEntry.id":"System.String","CatalogEntry.identifier":"Identifier","CatalogEntry.implicitRules":"uri","CatalogEntry.language":"code","CatalogEntry.lastUpdated":"dateTime","CatalogEntry.meta":"Meta","CatalogEntry.modifierExtension":"Extension","CatalogEntry.orderable":"boolean","CatalogEntry.referencedItem":"Reference","CatalogEntry.relatedEntry":"BackboneElement","CatalogEntry.relatedEntry.extension":"Extension","CatalogEntry.relatedEntry.id":"System.String","CatalogEntry.relatedEntry.item":"Reference","CatalogEntry.relatedEntry.modifierExtension":"Extension","CatalogEntry.relatedEntry.relationtype":"code","CatalogEntry.status":"code","CatalogEntry.text":"Narrative","CatalogEntry.type":"CodeableConcept","CatalogEntry.validTo":"dateTime","CatalogEntry.validityPeriod":"Period","ChargeItem.account":"Reference","ChargeItem.bodysite":"CodeableConcept","ChargeItem.code":"CodeableConcept","ChargeItem.contained":"Resource","ChargeItem.context":"Reference","ChargeItem.costCenter":"Reference","ChargeItem.definitionCanonical":"canonical","ChargeItem.definitionUri":"uri","ChargeItem.enteredDate":"dateTime","ChargeItem.enterer":"Reference","ChargeItem.extension":"Extension","ChargeItem.factorOverride":"decimal","ChargeItem.id":"System.String","ChargeItem.identifier":"Identifier","ChargeItem.implicitRules":"uri","ChargeItem.language":"code","ChargeItem.meta":"Meta","ChargeItem.modifierExtension":"Extension","ChargeItem.note":"Annotation","ChargeItem.occurrenceDateTime":"dateTime","ChargeItem.occurrencePeriod":"Period","ChargeItem.occurrenceTiming":"Timing","ChargeItem.overrideReason":"string","ChargeItem.partOf":"Reference","ChargeItem.performer":"BackboneElement","ChargeItem.performer.actor":"Reference","ChargeItem.performer.extension":"Extension","ChargeItem.performer.function":"CodeableConcept","ChargeItem.performer.id":"System.String","ChargeItem.performer.modifierExtension":"Extension","ChargeItem.performingOrganization":"Reference","ChargeItem.priceOverride":"Money","ChargeItem.productCodeableConcept":"CodeableConcept","ChargeItem.productReference":"Reference","ChargeItem.quantity":"Quantity","ChargeItem.reason":"CodeableConcept","ChargeItem.requestingOrganization":"Reference","ChargeItem.service":"Reference","ChargeItem.status":"code","ChargeItem.subject":"Reference","ChargeItem.supportingInformation":"Reference","ChargeItem.text":"Narrative","ChargeItemDefinition.applicability":"BackboneElement","ChargeItemDefinition.applicability.description":"string","ChargeItemDefinition.applicability.expression":"string","ChargeItemDefinition.applicability.extension":"Extension","ChargeItemDefinition.applicability.id":"System.String","ChargeItemDefinition.applicability.language":"string","ChargeItemDefinition.applicability.modifierExtension":"Extension","ChargeItemDefinition.approvalDate":"date","ChargeItemDefinition.code":"CodeableConcept","ChargeItemDefinition.contact":"ContactDetail","ChargeItemDefinition.contained":"Resource","ChargeItemDefinition.copyright":"markdown","ChargeItemDefinition.date":"dateTime","ChargeItemDefinition.derivedFromUri":"uri","ChargeItemDefinition.description":"markdown","ChargeItemDefinition.effectivePeriod":"Period","ChargeItemDefinition.experimental":"boolean","ChargeItemDefinition.extension":"Extension","ChargeItemDefinition.id":"System.String","ChargeItemDefinition.identifier":"Identifier","ChargeItemDefinition.implicitRules":"uri","ChargeItemDefinition.instance":"Reference","ChargeItemDefinition.jurisdiction":"CodeableConcept","ChargeItemDefinition.language":"code","ChargeItemDefinition.lastReviewDate":"date","ChargeItemDefinition.meta":"Meta","ChargeItemDefinition.modifierExtension":"Extension","ChargeItemDefinition.partOf":"canonical","ChargeItemDefinition.propertyGroup":"BackboneElement","ChargeItemDefinition.propertyGroup.extension":"Extension","ChargeItemDefinition.propertyGroup.id":"System.String","ChargeItemDefinition.propertyGroup.modifierExtension":"Extension","ChargeItemDefinition.propertyGroup.priceComponent":"BackboneElement","ChargeItemDefinition.propertyGroup.priceComponent.amount":"Money","ChargeItemDefinition.propertyGroup.priceComponent.code":"CodeableConcept","ChargeItemDefinition.propertyGroup.priceComponent.extension":"Extension","ChargeItemDefinition.propertyGroup.priceComponent.factor":"decimal","ChargeItemDefinition.propertyGroup.priceComponent.id":"System.String","ChargeItemDefinition.propertyGroup.priceComponent.modifierExtension":"Extension","ChargeItemDefinition.propertyGroup.priceComponent.type":"code","ChargeItemDefinition.publisher":"string","ChargeItemDefinition.replaces":"canonical","ChargeItemDefinition.status":"code","ChargeItemDefinition.text":"Narrative","ChargeItemDefinition.title":"string","ChargeItemDefinition.url":"uri","ChargeItemDefinition.useContext":"UsageContext","ChargeItemDefinition.version":"string","Claim.accident":"BackboneElement","Claim.accident.date":"date","Claim.accident.extension":"Extension","Claim.accident.id":"System.String","Claim.accident.locationAddress":"Address","Claim.accident.locationReference":"Reference","Claim.accident.modifierExtension":"Extension","Claim.accident.type":"CodeableConcept","Claim.billablePeriod":"Period","Claim.careTeam":"BackboneElement","Claim.careTeam.extension":"Extension","Claim.careTeam.id":"System.String","Claim.careTeam.modifierExtension":"Extension","Claim.careTeam.provider":"Reference","Claim.careTeam.qualification":"CodeableConcept","Claim.careTeam.responsible":"boolean","Claim.careTeam.role":"CodeableConcept","Claim.careTeam.sequence":"positiveInt","Claim.contained":"Resource","Claim.created":"dateTime","Claim.diagnosis":"BackboneElement","Claim.diagnosis.diagnosisCodeableConcept":"CodeableConcept","Claim.diagnosis.diagnosisReference":"Reference","Claim.diagnosis.extension":"Extension","Claim.diagnosis.id":"System.String","Claim.diagnosis.modifierExtension":"Extension","Claim.diagnosis.onAdmission":"CodeableConcept","Claim.diagnosis.packageCode":"CodeableConcept","Claim.diagnosis.sequence":"positiveInt","Claim.diagnosis.type":"CodeableConcept","Claim.enterer":"Reference","Claim.extension":"Extension","Claim.facility":"Reference","Claim.fundsReserve":"CodeableConcept","Claim.id":"System.String","Claim.identifier":"Identifier","Claim.implicitRules":"uri","Claim.insurance":"BackboneElement","Claim.insurance.businessArrangement":"string","Claim.insurance.claimResponse":"Reference","Claim.insurance.coverage":"Reference","Claim.insurance.extension":"Extension","Claim.insurance.focal":"boolean","Claim.insurance.id":"System.String","Claim.insurance.identifier":"Identifier","Claim.insurance.modifierExtension":"Extension","Claim.insurance.preAuthRef":"string","Claim.insurance.sequence":"positiveInt","Claim.insurer":"Reference","Claim.item":"BackboneElement","Claim.item.bodySite":"CodeableConcept","Claim.item.careTeamSequence":"positiveInt","Claim.item.category":"CodeableConcept","Claim.item.detail":"BackboneElement","Claim.item.detail.category":"CodeableConcept","Claim.item.detail.extension":"Extension","Claim.item.detail.factor":"decimal","Claim.item.detail.id":"System.String","Claim.item.detail.modifier":"CodeableConcept","Claim.item.detail.modifierExtension":"Extension","Claim.item.detail.net":"Money","Claim.item.detail.productOrService":"CodeableConcept","Claim.item.detail.programCode":"CodeableConcept","Claim.item.detail.quantity":"Quantity","Claim.item.detail.revenue":"CodeableConcept","Claim.item.detail.sequence":"positiveInt","Claim.item.detail.subDetail":"BackboneElement","Claim.item.detail.subDetail.category":"CodeableConcept","Claim.item.detail.subDetail.extension":"Extension","Claim.item.detail.subDetail.factor":"decimal","Claim.item.detail.subDetail.id":"System.String","Claim.item.detail.subDetail.modifier":"CodeableConcept","Claim.item.detail.subDetail.modifierExtension":"Extension","Claim.item.detail.subDetail.net":"Money","Claim.item.detail.subDetail.productOrService":"CodeableConcept","Claim.item.detail.subDetail.programCode":"CodeableConcept","Claim.item.detail.subDetail.quantity":"Quantity","Claim.item.detail.subDetail.revenue":"CodeableConcept","Claim.item.detail.subDetail.sequence":"positiveInt","Claim.item.detail.subDetail.udi":"Reference","Claim.item.detail.subDetail.unitPrice":"Money","Claim.item.detail.udi":"Reference","Claim.item.detail.unitPrice":"Money","Claim.item.diagnosisSequence":"positiveInt","Claim.item.encounter":"Reference","Claim.item.extension":"Extension","Claim.item.factor":"decimal","Claim.item.id":"System.String","Claim.item.informationSequence":"positiveInt","Claim.item.locationAddress":"Address","Claim.item.locationCodeableConcept":"CodeableConcept","Claim.item.locationReference":"Reference","Claim.item.modifier":"CodeableConcept","Claim.item.modifierExtension":"Extension","Claim.item.net":"Money","Claim.item.procedureSequence":"positiveInt","Claim.item.productOrService":"CodeableConcept","Claim.item.programCode":"CodeableConcept","Claim.item.quantity":"Quantity","Claim.item.revenue":"CodeableConcept","Claim.item.sequence":"positiveInt","Claim.item.servicedDate":"date","Claim.item.servicedPeriod":"Period","Claim.item.subSite":"CodeableConcept","Claim.item.udi":"Reference","Claim.item.unitPrice":"Money","Claim.language":"code","Claim.meta":"Meta","Claim.modifierExtension":"Extension","Claim.originalPrescription":"Reference","Claim.patient":"Reference","Claim.payee":"BackboneElement","Claim.payee.extension":"Extension","Claim.payee.id":"System.String","Claim.payee.modifierExtension":"Extension","Claim.payee.party":"Reference","Claim.payee.type":"CodeableConcept","Claim.prescription":"Reference","Claim.priority":"CodeableConcept","Claim.procedure":"BackboneElement","Claim.procedure.date":"dateTime","Claim.procedure.extension":"Extension","Claim.procedure.id":"System.String","Claim.procedure.modifierExtension":"Extension","Claim.procedure.procedureCodeableConcept":"CodeableConcept","Claim.procedure.procedureReference":"Reference","Claim.procedure.sequence":"positiveInt","Claim.procedure.type":"CodeableConcept","Claim.procedure.udi":"Reference","Claim.provider":"Reference","Claim.referral":"Reference","Claim.related":"BackboneElement","Claim.related.claim":"Reference","Claim.related.extension":"Extension","Claim.related.id":"System.String","Claim.related.modifierExtension":"Extension","Claim.related.reference":"Identifier","Claim.related.relationship":"CodeableConcept","Claim.status":"code","Claim.subType":"CodeableConcept","Claim.supportingInfo":"BackboneElement","Claim.supportingInfo.category":"CodeableConcept","Claim.supportingInfo.code":"CodeableConcept","Claim.supportingInfo.extension":"Extension","Claim.supportingInfo.id":"System.String","Claim.supportingInfo.modifierExtension":"Extension","Claim.supportingInfo.reason":"CodeableConcept","Claim.supportingInfo.sequence":"positiveInt","Claim.supportingInfo.timingDate":"date","Claim.supportingInfo.timingPeriod":"Period","Claim.supportingInfo.valueAttachment":"Attachment","Claim.supportingInfo.valueBoolean":"boolean","Claim.supportingInfo.valueQuantity":"Quantity","Claim.supportingInfo.valueReference":"Reference","Claim.supportingInfo.valueString":"string","Claim.text":"Narrative","Claim.total":"Money","Claim.type":"CodeableConcept","Claim.use":"code","ClaimResponse.addItem":"BackboneElement","ClaimResponse.addItem.bodySite":"CodeableConcept","ClaimResponse.addItem.detail":"BackboneElement","ClaimResponse.addItem.detail.extension":"Extension","ClaimResponse.addItem.detail.factor":"decimal","ClaimResponse.addItem.detail.id":"System.String","ClaimResponse.addItem.detail.modifier":"CodeableConcept","ClaimResponse.addItem.detail.modifierExtension":"Extension","ClaimResponse.addItem.detail.net":"Money","ClaimResponse.addItem.detail.noteNumber":"positiveInt","ClaimResponse.addItem.detail.productOrService":"CodeableConcept","ClaimResponse.addItem.detail.quantity":"Quantity","ClaimResponse.addItem.detail.subDetail":"BackboneElement","ClaimResponse.addItem.detail.subDetail.extension":"Extension","ClaimResponse.addItem.detail.subDetail.factor":"decimal","ClaimResponse.addItem.detail.subDetail.id":"System.String","ClaimResponse.addItem.detail.subDetail.modifier":"CodeableConcept","ClaimResponse.addItem.detail.subDetail.modifierExtension":"Extension","ClaimResponse.addItem.detail.subDetail.net":"Money","ClaimResponse.addItem.detail.subDetail.noteNumber":"positiveInt","ClaimResponse.addItem.detail.subDetail.productOrService":"CodeableConcept","ClaimResponse.addItem.detail.subDetail.quantity":"Quantity","ClaimResponse.addItem.detail.subDetail.unitPrice":"Money","ClaimResponse.addItem.detail.unitPrice":"Money","ClaimResponse.addItem.detailSequence":"positiveInt","ClaimResponse.addItem.extension":"Extension","ClaimResponse.addItem.factor":"decimal","ClaimResponse.addItem.id":"System.String","ClaimResponse.addItem.itemSequence":"positiveInt","ClaimResponse.addItem.locationAddress":"Address","ClaimResponse.addItem.locationCodeableConcept":"CodeableConcept","ClaimResponse.addItem.locationReference":"Reference","ClaimResponse.addItem.modifier":"CodeableConcept","ClaimResponse.addItem.modifierExtension":"Extension","ClaimResponse.addItem.net":"Money","ClaimResponse.addItem.noteNumber":"positiveInt","ClaimResponse.addItem.productOrService":"CodeableConcept","ClaimResponse.addItem.programCode":"CodeableConcept","ClaimResponse.addItem.provider":"Reference","ClaimResponse.addItem.quantity":"Quantity","ClaimResponse.addItem.servicedDate":"date","ClaimResponse.addItem.servicedPeriod":"Period","ClaimResponse.addItem.subSite":"CodeableConcept","ClaimResponse.addItem.subdetailSequence":"positiveInt","ClaimResponse.addItem.unitPrice":"Money","ClaimResponse.communicationRequest":"Reference","ClaimResponse.contained":"Resource","ClaimResponse.created":"dateTime","ClaimResponse.disposition":"string","ClaimResponse.error":"BackboneElement","ClaimResponse.error.code":"CodeableConcept","ClaimResponse.error.detailSequence":"positiveInt","ClaimResponse.error.extension":"Extension","ClaimResponse.error.id":"System.String","ClaimResponse.error.itemSequence":"positiveInt","ClaimResponse.error.modifierExtension":"Extension","ClaimResponse.error.subDetailSequence":"positiveInt","ClaimResponse.extension":"Extension","ClaimResponse.form":"Attachment","ClaimResponse.formCode":"CodeableConcept","ClaimResponse.fundsReserve":"CodeableConcept","ClaimResponse.id":"System.String","ClaimResponse.identifier":"Identifier","ClaimResponse.implicitRules":"uri","ClaimResponse.insurance":"BackboneElement","ClaimResponse.insurance.businessArrangement":"string","ClaimResponse.insurance.claimResponse":"Reference","ClaimResponse.insurance.coverage":"Reference","ClaimResponse.insurance.extension":"Extension","ClaimResponse.insurance.focal":"boolean","ClaimResponse.insurance.id":"System.String","ClaimResponse.insurance.modifierExtension":"Extension","ClaimResponse.insurance.sequence":"positiveInt","ClaimResponse.insurer":"Reference","ClaimResponse.item":"BackboneElement","ClaimResponse.item.adjudication":"BackboneElement","ClaimResponse.item.adjudication.amount":"Money","ClaimResponse.item.adjudication.category":"CodeableConcept","ClaimResponse.item.adjudication.extension":"Extension","ClaimResponse.item.adjudication.id":"System.String","ClaimResponse.item.adjudication.modifierExtension":"Extension","ClaimResponse.item.adjudication.reason":"CodeableConcept","ClaimResponse.item.adjudication.value":"decimal","ClaimResponse.item.detail":"BackboneElement","ClaimResponse.item.detail.detailSequence":"positiveInt","ClaimResponse.item.detail.extension":"Extension","ClaimResponse.item.detail.id":"System.String","ClaimResponse.item.detail.modifierExtension":"Extension","ClaimResponse.item.detail.noteNumber":"positiveInt","ClaimResponse.item.detail.subDetail":"BackboneElement","ClaimResponse.item.detail.subDetail.extension":"Extension","ClaimResponse.item.detail.subDetail.id":"System.String","ClaimResponse.item.detail.subDetail.modifierExtension":"Extension","ClaimResponse.item.detail.subDetail.noteNumber":"positiveInt","ClaimResponse.item.detail.subDetail.subDetailSequence":"positiveInt","ClaimResponse.item.extension":"Extension","ClaimResponse.item.id":"System.String","ClaimResponse.item.itemSequence":"positiveInt","ClaimResponse.item.modifierExtension":"Extension","ClaimResponse.item.noteNumber":"positiveInt","ClaimResponse.language":"code","ClaimResponse.meta":"Meta","ClaimResponse.modifierExtension":"Extension","ClaimResponse.outcome":"code","ClaimResponse.patient":"Reference","ClaimResponse.payeeType":"CodeableConcept","ClaimResponse.payment":"BackboneElement","ClaimResponse.payment.adjustment":"Money","ClaimResponse.payment.adjustmentReason":"CodeableConcept","ClaimResponse.payment.amount":"Money","ClaimResponse.payment.date":"date","ClaimResponse.payment.extension":"Extension","ClaimResponse.payment.id":"System.String","ClaimResponse.payment.identifier":"Identifier","ClaimResponse.payment.modifierExtension":"Extension","ClaimResponse.payment.type":"CodeableConcept","ClaimResponse.preAuthPeriod":"Period","ClaimResponse.preAuthRef":"string","ClaimResponse.processNote":"BackboneElement","ClaimResponse.processNote.extension":"Extension","ClaimResponse.processNote.id":"System.String","ClaimResponse.processNote.language":"CodeableConcept","ClaimResponse.processNote.modifierExtension":"Extension","ClaimResponse.processNote.number":"positiveInt","ClaimResponse.processNote.text":"string","ClaimResponse.processNote.type":"code","ClaimResponse.request":"Reference","ClaimResponse.requestor":"Reference","ClaimResponse.status":"code","ClaimResponse.subType":"CodeableConcept","ClaimResponse.text":"Narrative","ClaimResponse.total":"BackboneElement","ClaimResponse.total.amount":"Money","ClaimResponse.total.category":"CodeableConcept","ClaimResponse.total.extension":"Extension","ClaimResponse.total.id":"System.String","ClaimResponse.total.modifierExtension":"Extension","ClaimResponse.type":"CodeableConcept","ClaimResponse.use":"code","ClinicalImpression.assessor":"Reference","ClinicalImpression.code":"CodeableConcept","ClinicalImpression.contained":"Resource","ClinicalImpression.date":"dateTime","ClinicalImpression.description":"string","ClinicalImpression.effectiveDateTime":"dateTime","ClinicalImpression.effectivePeriod":"Period","ClinicalImpression.encounter":"Reference","ClinicalImpression.extension":"Extension","ClinicalImpression.finding":"BackboneElement","ClinicalImpression.finding.basis":"string","ClinicalImpression.finding.extension":"Extension","ClinicalImpression.finding.id":"System.String","ClinicalImpression.finding.itemCodeableConcept":"CodeableConcept","ClinicalImpression.finding.itemReference":"Reference","ClinicalImpression.finding.modifierExtension":"Extension","ClinicalImpression.id":"System.String","ClinicalImpression.identifier":"Identifier","ClinicalImpression.implicitRules":"uri","ClinicalImpression.investigation":"BackboneElement","ClinicalImpression.investigation.code":"CodeableConcept","ClinicalImpression.investigation.extension":"Extension","ClinicalImpression.investigation.id":"System.String","ClinicalImpression.investigation.item":"Reference","ClinicalImpression.investigation.modifierExtension":"Extension","ClinicalImpression.language":"code","ClinicalImpression.meta":"Meta","ClinicalImpression.modifierExtension":"Extension","ClinicalImpression.note":"Annotation","ClinicalImpression.previous":"Reference","ClinicalImpression.problem":"Reference","ClinicalImpression.prognosisCodeableConcept":"CodeableConcept","ClinicalImpression.prognosisReference":"Reference","ClinicalImpression.protocol":"uri","ClinicalImpression.status":"code","ClinicalImpression.statusReason":"CodeableConcept","ClinicalImpression.subject":"Reference","ClinicalImpression.summary":"string","ClinicalImpression.supportingInfo":"Reference","ClinicalImpression.text":"Narrative","CodeSystem.caseSensitive":"boolean","CodeSystem.compositional":"boolean","CodeSystem.concept":"BackboneElement","CodeSystem.concept.code":"code","CodeSystem.concept.definition":"string","CodeSystem.concept.designation":"BackboneElement","CodeSystem.concept.designation.extension":"Extension","CodeSystem.concept.designation.id":"System.String","CodeSystem.concept.designation.language":"code","CodeSystem.concept.designation.modifierExtension":"Extension","CodeSystem.concept.designation.use":"Coding","CodeSystem.concept.designation.value":"string","CodeSystem.concept.display":"string","CodeSystem.concept.extension":"Extension","CodeSystem.concept.id":"System.String","CodeSystem.concept.modifierExtension":"Extension","CodeSystem.concept.property":"BackboneElement","CodeSystem.concept.property.code":"code","CodeSystem.concept.property.extension":"Extension","CodeSystem.concept.property.id":"System.String","CodeSystem.concept.property.modifierExtension":"Extension","CodeSystem.concept.property.valueBoolean":"boolean","CodeSystem.concept.property.valueCode":"code","CodeSystem.concept.property.valueCoding":"Coding","CodeSystem.concept.property.valueDateTime":"dateTime","CodeSystem.concept.property.valueDecimal":"decimal","CodeSystem.concept.property.valueInteger":"integer","CodeSystem.concept.property.valueString":"string","CodeSystem.contact":"ContactDetail","CodeSystem.contained":"Resource","CodeSystem.content":"code","CodeSystem.copyright":"markdown","CodeSystem.count":"unsignedInt","CodeSystem.date":"dateTime","CodeSystem.description":"markdown","CodeSystem.experimental":"boolean","CodeSystem.extension":"Extension","CodeSystem.filter":"BackboneElement","CodeSystem.filter.code":"code","CodeSystem.filter.description":"string","CodeSystem.filter.extension":"Extension","CodeSystem.filter.id":"System.String","CodeSystem.filter.modifierExtension":"Extension","CodeSystem.filter.operator":"code","CodeSystem.filter.value":"string","CodeSystem.hierarchyMeaning":"code","CodeSystem.id":"System.String","CodeSystem.identifier":"Identifier","CodeSystem.implicitRules":"uri","CodeSystem.jurisdiction":"CodeableConcept","CodeSystem.language":"code","CodeSystem.meta":"Meta","CodeSystem.modifierExtension":"Extension","CodeSystem.name":"string","CodeSystem.property":"BackboneElement","CodeSystem.property.code":"code","CodeSystem.property.description":"string","CodeSystem.property.extension":"Extension","CodeSystem.property.id":"System.String","CodeSystem.property.modifierExtension":"Extension","CodeSystem.property.type":"code","CodeSystem.property.uri":"uri","CodeSystem.publisher":"string","CodeSystem.purpose":"markdown","CodeSystem.status":"code","CodeSystem.supplements":"canonical","CodeSystem.text":"Narrative","CodeSystem.title":"string","CodeSystem.url":"uri","CodeSystem.useContext":"UsageContext","CodeSystem.valueSet":"canonical","CodeSystem.version":"string","CodeSystem.versionNeeded":"boolean","CodeableConcept.coding":"Coding","CodeableConcept.extension":"Extension","CodeableConcept.id":"System.String","CodeableConcept.text":"string","Coding.code":"code","Coding.display":"string","Coding.extension":"Extension","Coding.id":"System.String","Coding.system":"uri","Coding.userSelected":"boolean","Coding.version":"string","Communication.about":"Reference","Communication.basedOn":"Reference","Communication.category":"CodeableConcept","Communication.contained":"Resource","Communication.encounter":"Reference","Communication.extension":"Extension","Communication.id":"System.String","Communication.identifier":"Identifier","Communication.implicitRules":"uri","Communication.inResponseTo":"Reference","Communication.instantiatesCanonical":"canonical","Communication.instantiatesUri":"uri","Communication.language":"code","Communication.medium":"CodeableConcept","Communication.meta":"Meta","Communication.modifierExtension":"Extension","Communication.note":"Annotation","Communication.partOf":"Reference","Communication.payload":"BackboneElement","Communication.payload.contentAttachment":"Attachment","Communication.payload.contentReference":"Reference","Communication.payload.contentString":"string","Communication.payload.extension":"Extension","Communication.payload.id":"System.String","Communication.payload.modifierExtension":"Extension","Communication.priority":"code","Communication.reasonCode":"CodeableConcept","Communication.reasonReference":"Reference","Communication.received":"dateTime","Communication.recipient":"Reference","Communication.sender":"Reference","Communication.sent":"dateTime","Communication.status":"code","Communication.statusReason":"CodeableConcept","Communication.subject":"Reference","Communication.text":"Narrative","Communication.topic":"CodeableConcept","CommunicationRequest.about":"Reference","CommunicationRequest.authoredOn":"dateTime","CommunicationRequest.basedOn":"Reference","CommunicationRequest.category":"CodeableConcept","CommunicationRequest.contained":"Resource","CommunicationRequest.doNotPerform":"boolean","CommunicationRequest.encounter":"Reference","CommunicationRequest.extension":"Extension","CommunicationRequest.groupIdentifier":"Identifier","CommunicationRequest.id":"System.String","CommunicationRequest.identifier":"Identifier","CommunicationRequest.implicitRules":"uri","CommunicationRequest.language":"code","CommunicationRequest.medium":"CodeableConcept","CommunicationRequest.meta":"Meta","CommunicationRequest.modifierExtension":"Extension","CommunicationRequest.note":"Annotation","CommunicationRequest.occurrenceDateTime":"dateTime","CommunicationRequest.occurrencePeriod":"Period","CommunicationRequest.payload":"BackboneElement","CommunicationRequest.payload.contentAttachment":"Attachment","CommunicationRequest.payload.contentReference":"Reference","CommunicationRequest.payload.contentString":"string","CommunicationRequest.payload.extension":"Extension","CommunicationRequest.payload.id":"System.String","CommunicationRequest.payload.modifierExtension":"Extension","CommunicationRequest.priority":"code","CommunicationRequest.reasonCode":"CodeableConcept","CommunicationRequest.reasonReference":"Reference","CommunicationRequest.recipient":"Reference","CommunicationRequest.replaces":"Reference","CommunicationRequest.requester":"Reference","CommunicationRequest.sender":"Reference","CommunicationRequest.status":"code","CommunicationRequest.statusReason":"CodeableConcept","CommunicationRequest.subject":"Reference","CommunicationRequest.text":"Narrative","CompartmentDefinition.code":"code","CompartmentDefinition.contact":"ContactDetail","CompartmentDefinition.contained":"Resource","CompartmentDefinition.date":"dateTime","CompartmentDefinition.description":"markdown","CompartmentDefinition.experimental":"boolean","CompartmentDefinition.extension":"Extension","CompartmentDefinition.id":"System.String","CompartmentDefinition.implicitRules":"uri","CompartmentDefinition.language":"code","CompartmentDefinition.meta":"Meta","CompartmentDefinition.modifierExtension":"Extension","CompartmentDefinition.name":"string","CompartmentDefinition.publisher":"string","CompartmentDefinition.purpose":"markdown","CompartmentDefinition.resource":"BackboneElement","CompartmentDefinition.resource.code":"code","CompartmentDefinition.resource.documentation":"string","CompartmentDefinition.resource.extension":"Extension","CompartmentDefinition.resource.id":"System.String","CompartmentDefinition.resource.modifierExtension":"Extension","CompartmentDefinition.resource.param":"string","CompartmentDefinition.search":"boolean","CompartmentDefinition.status":"code","CompartmentDefinition.text":"Narrative","CompartmentDefinition.url":"uri","CompartmentDefinition.useContext":"UsageContext","CompartmentDefinition.version":"string","Composition.attester":"BackboneElement","Composition.attester.extension":"Extension","Composition.attester.id":"System.String","Composition.attester.mode":"code","Composition.attester.modifierExtension":"Extension","Composition.attester.party":"Reference","Composition.attester.time":"dateTime","Composition.author":"Reference","Composition.category":"CodeableConcept","Composition.confidentiality":"code","Composition.contained":"Resource","Composition.custodian":"Reference","Composition.date":"dateTime","Composition.encounter":"Reference","Composition.event":"BackboneElement","Composition.event.code":"CodeableConcept","Composition.event.detail":"Reference","Composition.event.extension":"Extension","Composition.event.id":"System.String","Composition.event.modifierExtension":"Extension","Composition.event.period":"Period","Composition.extension":"Extension","Composition.id":"System.String","Composition.identifier":"Identifier","Composition.implicitRules":"uri","Composition.language":"code","Composition.meta":"Meta","Composition.modifierExtension":"Extension","Composition.relatesTo":"BackboneElement","Composition.relatesTo.code":"code","Composition.relatesTo.extension":"Extension","Composition.relatesTo.id":"System.String","Composition.relatesTo.modifierExtension":"Extension","Composition.relatesTo.targetIdentifier":"Identifier","Composition.relatesTo.targetReference":"Reference","Composition.section":"BackboneElement","Composition.section.author":"Reference","Composition.section.code":"CodeableConcept","Composition.section.emptyReason":"CodeableConcept","Composition.section.entry":"Reference","Composition.section.extension":"Extension","Composition.section.focus":"Reference","Composition.section.id":"System.String","Composition.section.mode":"code","Composition.section.modifierExtension":"Extension","Composition.section.orderedBy":"CodeableConcept","Composition.section.text":"Narrative","Composition.section.title":"string","Composition.status":"code","Composition.subject":"Reference","Composition.text":"Narrative","Composition.title":"string","Composition.type":"CodeableConcept","ConceptMap.contact":"ContactDetail","ConceptMap.contained":"Resource","ConceptMap.copyright":"markdown","ConceptMap.date":"dateTime","ConceptMap.description":"markdown","ConceptMap.experimental":"boolean","ConceptMap.extension":"Extension","ConceptMap.group":"BackboneElement","ConceptMap.group.element":"BackboneElement","ConceptMap.group.element.code":"code","ConceptMap.group.element.display":"string","ConceptMap.group.element.extension":"Extension","ConceptMap.group.element.id":"System.String","ConceptMap.group.element.modifierExtension":"Extension","ConceptMap.group.element.target":"BackboneElement","ConceptMap.group.element.target.code":"code","ConceptMap.group.element.target.comment":"string","ConceptMap.group.element.target.dependsOn":"BackboneElement","ConceptMap.group.element.target.dependsOn.display":"string","ConceptMap.group.element.target.dependsOn.extension":"Extension","ConceptMap.group.element.target.dependsOn.id":"System.String","ConceptMap.group.element.target.dependsOn.modifierExtension":"Extension","ConceptMap.group.element.target.dependsOn.property":"uri","ConceptMap.group.element.target.dependsOn.system":"canonical","ConceptMap.group.element.target.dependsOn.value":"string","ConceptMap.group.element.target.display":"string","ConceptMap.group.element.target.equivalence":"code","ConceptMap.group.element.target.extension":"Extension","ConceptMap.group.element.target.id":"System.String","ConceptMap.group.element.target.modifierExtension":"Extension","ConceptMap.group.extension":"Extension","ConceptMap.group.id":"System.String","ConceptMap.group.modifierExtension":"Extension","ConceptMap.group.source":"uri","ConceptMap.group.sourceVersion":"string","ConceptMap.group.target":"uri","ConceptMap.group.targetVersion":"string","ConceptMap.group.unmapped":"BackboneElement","ConceptMap.group.unmapped.code":"code","ConceptMap.group.unmapped.display":"string","ConceptMap.group.unmapped.extension":"Extension","ConceptMap.group.unmapped.id":"System.String","ConceptMap.group.unmapped.mode":"code","ConceptMap.group.unmapped.modifierExtension":"Extension","ConceptMap.group.unmapped.url":"canonical","ConceptMap.id":"System.String","ConceptMap.identifier":"Identifier","ConceptMap.implicitRules":"uri","ConceptMap.jurisdiction":"CodeableConcept","ConceptMap.language":"code","ConceptMap.meta":"Meta","ConceptMap.modifierExtension":"Extension","ConceptMap.name":"string","ConceptMap.publisher":"string","ConceptMap.purpose":"markdown","ConceptMap.sourceCanonical":"canonical","ConceptMap.sourceUri":"uri","ConceptMap.status":"code","ConceptMap.targetCanonical":"canonical","ConceptMap.targetUri":"uri","ConceptMap.text":"Narrative","ConceptMap.title":"string","ConceptMap.url":"uri","ConceptMap.useContext":"UsageContext","ConceptMap.version":"string","Condition.abatementAge":"Age","Condition.abatementDateTime":"dateTime","Condition.abatementPeriod":"Period","Condition.abatementRange":"Range","Condition.abatementString":"string","Condition.asserter":"Reference","Condition.bodySite":"CodeableConcept","Condition.category":"CodeableConcept","Condition.clinicalStatus":"CodeableConcept","Condition.code":"CodeableConcept","Condition.contained":"Resource","Condition.encounter":"Reference","Condition.evidence":"BackboneElement","Condition.evidence.code":"CodeableConcept","Condition.evidence.detail":"Reference","Condition.evidence.extension":"Extension","Condition.evidence.id":"System.String","Condition.evidence.modifierExtension":"Extension","Condition.extension":"Extension","Condition.id":"System.String","Condition.identifier":"Identifier","Condition.implicitRules":"uri","Condition.language":"code","Condition.meta":"Meta","Condition.modifierExtension":"Extension","Condition.note":"Annotation","Condition.onsetAge":"Age","Condition.onsetDateTime":"dateTime","Condition.onsetPeriod":"Period","Condition.onsetRange":"Range","Condition.onsetString":"string","Condition.recordedDate":"dateTime","Condition.recorder":"Reference","Condition.severity":"CodeableConcept","Condition.stage":"BackboneElement","Condition.stage.assessment":"Reference","Condition.stage.extension":"Extension","Condition.stage.id":"System.String","Condition.stage.modifierExtension":"Extension","Condition.stage.summary":"CodeableConcept","Condition.stage.type":"CodeableConcept","Condition.subject":"Reference","Condition.text":"Narrative","Condition.verificationStatus":"CodeableConcept","Consent.category":"CodeableConcept","Consent.contained":"Resource","Consent.dateTime":"dateTime","Consent.extension":"Extension","Consent.id":"System.String","Consent.identifier":"Identifier","Consent.implicitRules":"uri","Consent.language":"code","Consent.meta":"Meta","Consent.modifierExtension":"Extension","Consent.organization":"Reference","Consent.patient":"Reference","Consent.performer":"Reference","Consent.policy":"BackboneElement","Consent.policy.authority":"uri","Consent.policy.extension":"Extension","Consent.policy.id":"System.String","Consent.policy.modifierExtension":"Extension","Consent.policy.uri":"uri","Consent.policyRule":"CodeableConcept","Consent.provision":"BackboneElement","Consent.provision.action":"CodeableConcept","Consent.provision.actor":"BackboneElement","Consent.provision.actor.extension":"Extension","Consent.provision.actor.id":"System.String","Consent.provision.actor.modifierExtension":"Extension","Consent.provision.actor.reference":"Reference","Consent.provision.actor.role":"CodeableConcept","Consent.provision.class":"Coding","Consent.provision.code":"CodeableConcept","Consent.provision.data":"BackboneElement","Consent.provision.data.extension":"Extension","Consent.provision.data.id":"System.String","Consent.provision.data.meaning":"code","Consent.provision.data.modifierExtension":"Extension","Consent.provision.data.reference":"Reference","Consent.provision.dataPeriod":"Period","Consent.provision.extension":"Extension","Consent.provision.id":"System.String","Consent.provision.modifierExtension":"Extension","Consent.provision.period":"Period","Consent.provision.purpose":"Coding","Consent.provision.securityLabel":"Coding","Consent.provision.type":"code","Consent.scope":"CodeableConcept","Consent.sourceAttachment":"Attachment","Consent.sourceReference":"Reference","Consent.status":"code","Consent.text":"Narrative","Consent.verification":"BackboneElement","Consent.verification.extension":"Extension","Consent.verification.id":"System.String","Consent.verification.modifierExtension":"Extension","Consent.verification.verificationDate":"dateTime","Consent.verification.verified":"boolean","Consent.verification.verifiedWith":"Reference","ContactDetail.extension":"Extension","ContactDetail.id":"System.String","ContactDetail.name":"string","ContactDetail.telecom":"ContactPoint","ContactPoint.extension":"Extension","ContactPoint.id":"System.String","ContactPoint.period":"Period","ContactPoint.rank":"positiveInt","ContactPoint.system":"code","ContactPoint.use":"code","ContactPoint.value":"string","Contract.alias":"string","Contract.applies":"Period","Contract.author":"Reference","Contract.authority":"Reference","Contract.contained":"Resource","Contract.contentDefinition":"BackboneElement","Contract.contentDefinition.copyright":"markdown","Contract.contentDefinition.extension":"Extension","Contract.contentDefinition.id":"System.String","Contract.contentDefinition.modifierExtension":"Extension","Contract.contentDefinition.publicationDate":"dateTime","Contract.contentDefinition.publicationStatus":"code","Contract.contentDefinition.publisher":"Reference","Contract.contentDefinition.subType":"CodeableConcept","Contract.contentDefinition.type":"CodeableConcept","Contract.contentDerivative":"CodeableConcept","Contract.domain":"Reference","Contract.expirationType":"CodeableConcept","Contract.extension":"Extension","Contract.friendly":"BackboneElement","Contract.friendly.contentAttachment":"Attachment","Contract.friendly.contentReference":"Reference","Contract.friendly.extension":"Extension","Contract.friendly.id":"System.String","Contract.friendly.modifierExtension":"Extension","Contract.id":"System.String","Contract.identifier":"Identifier","Contract.implicitRules":"uri","Contract.instantiatesCanonical":"Reference","Contract.instantiatesUri":"uri","Contract.issued":"dateTime","Contract.language":"code","Contract.legal":"BackboneElement","Contract.legal.contentAttachment":"Attachment","Contract.legal.contentReference":"Reference","Contract.legal.extension":"Extension","Contract.legal.id":"System.String","Contract.legal.modifierExtension":"Extension","Contract.legalState":"CodeableConcept","Contract.legallyBindingAttachment":"Attachment","Contract.legallyBindingReference":"Reference","Contract.meta":"Meta","Contract.modifierExtension":"Extension","Contract.name":"string","Contract.relevantHistory":"Reference","Contract.rule":"BackboneElement","Contract.rule.contentAttachment":"Attachment","Contract.rule.contentReference":"Reference","Contract.rule.extension":"Extension","Contract.rule.id":"System.String","Contract.rule.modifierExtension":"Extension","Contract.scope":"CodeableConcept","Contract.signer":"BackboneElement","Contract.signer.extension":"Extension","Contract.signer.id":"System.String","Contract.signer.modifierExtension":"Extension","Contract.signer.party":"Reference","Contract.signer.signature":"Signature","Contract.signer.type":"Coding","Contract.site":"Reference","Contract.status":"code","Contract.subType":"CodeableConcept","Contract.subject":"Reference","Contract.subtitle":"string","Contract.supportingInfo":"Reference","Contract.term":"BackboneElement","Contract.term.action":"BackboneElement","Contract.term.action.context":"Reference","Contract.term.action.contextLinkId":"string","Contract.term.action.doNotPerform":"boolean","Contract.term.action.extension":"Extension","Contract.term.action.id":"System.String","Contract.term.action.intent":"CodeableConcept","Contract.term.action.linkId":"string","Contract.term.action.modifierExtension":"Extension","Contract.term.action.note":"Annotation","Contract.term.action.occurrenceDateTime":"dateTime","Contract.term.action.occurrencePeriod":"Period","Contract.term.action.occurrenceTiming":"Timing","Contract.term.action.performer":"Reference","Contract.term.action.performerLinkId":"string","Contract.term.action.performerRole":"CodeableConcept","Contract.term.action.performerType":"CodeableConcept","Contract.term.action.reason":"string","Contract.term.action.reasonCode":"CodeableConcept","Contract.term.action.reasonLinkId":"string","Contract.term.action.reasonReference":"Reference","Contract.term.action.requester":"Reference","Contract.term.action.requesterLinkId":"string","Contract.term.action.securityLabelNumber":"unsignedInt","Contract.term.action.status":"CodeableConcept","Contract.term.action.subject":"BackboneElement","Contract.term.action.subject.extension":"Extension","Contract.term.action.subject.id":"System.String","Contract.term.action.subject.modifierExtension":"Extension","Contract.term.action.subject.reference":"Reference","Contract.term.action.subject.role":"CodeableConcept","Contract.term.action.type":"CodeableConcept","Contract.term.applies":"Period","Contract.term.asset":"BackboneElement","Contract.term.asset.condition":"string","Contract.term.asset.context":"BackboneElement","Contract.term.asset.context.code":"CodeableConcept","Contract.term.asset.context.extension":"Extension","Contract.term.asset.context.id":"System.String","Contract.term.asset.context.modifierExtension":"Extension","Contract.term.asset.context.reference":"Reference","Contract.term.asset.context.text":"string","Contract.term.asset.extension":"Extension","Contract.term.asset.id":"System.String","Contract.term.asset.linkId":"string","Contract.term.asset.modifierExtension":"Extension","Contract.term.asset.period":"Period","Contract.term.asset.periodType":"CodeableConcept","Contract.term.asset.relationship":"Coding","Contract.term.asset.scope":"CodeableConcept","Contract.term.asset.securityLabelNumber":"unsignedInt","Contract.term.asset.subtype":"CodeableConcept","Contract.term.asset.text":"string","Contract.term.asset.type":"CodeableConcept","Contract.term.asset.typeReference":"Reference","Contract.term.asset.usePeriod":"Period","Contract.term.asset.valuedItem":"BackboneElement","Contract.term.asset.valuedItem.effectiveTime":"dateTime","Contract.term.asset.valuedItem.entityCodeableConcept":"CodeableConcept","Contract.term.asset.valuedItem.entityReference":"Reference","Contract.term.asset.valuedItem.extension":"Extension","Contract.term.asset.valuedItem.factor":"decimal","Contract.term.asset.valuedItem.id":"System.String","Contract.term.asset.valuedItem.identifier":"Identifier","Contract.term.asset.valuedItem.linkId":"string","Contract.term.asset.valuedItem.modifierExtension":"Extension","Contract.term.asset.valuedItem.net":"Money","Contract.term.asset.valuedItem.payment":"string","Contract.term.asset.valuedItem.paymentDate":"dateTime","Contract.term.asset.valuedItem.points":"decimal","Contract.term.asset.valuedItem.quantity":"Quantity","Contract.term.asset.valuedItem.recipient":"Reference","Contract.term.asset.valuedItem.responsible":"Reference","Contract.term.asset.valuedItem.securityLabelNumber":"unsignedInt","Contract.term.asset.valuedItem.unitPrice":"Money","Contract.term.extension":"Extension","Contract.term.id":"System.String","Contract.term.identifier":"Identifier","Contract.term.issued":"dateTime","Contract.term.modifierExtension":"Extension","Contract.term.offer":"BackboneElement","Contract.term.offer.answer":"BackboneElement","Contract.term.offer.answer.extension":"Extension","Contract.term.offer.answer.id":"System.String","Contract.term.offer.answer.modifierExtension":"Extension","Contract.term.offer.answer.valueAttachment":"Attachment","Contract.term.offer.answer.valueBoolean":"boolean","Contract.term.offer.answer.valueCoding":"Coding","Contract.term.offer.answer.valueDate":"date","Contract.term.offer.answer.valueDateTime":"dateTime","Contract.term.offer.answer.valueDecimal":"decimal","Contract.term.offer.answer.valueInteger":"integer","Contract.term.offer.answer.valueQuantity":"Quantity","Contract.term.offer.answer.valueReference":"Reference","Contract.term.offer.answer.valueString":"string","Contract.term.offer.answer.valueTime":"time","Contract.term.offer.answer.valueUri":"uri","Contract.term.offer.decision":"CodeableConcept","Contract.term.offer.decisionMode":"CodeableConcept","Contract.term.offer.extension":"Extension","Contract.term.offer.id":"System.String","Contract.term.offer.identifier":"Identifier","Contract.term.offer.linkId":"string","Contract.term.offer.modifierExtension":"Extension","Contract.term.offer.party":"BackboneElement","Contract.term.offer.party.extension":"Extension","Contract.term.offer.party.id":"System.String","Contract.term.offer.party.modifierExtension":"Extension","Contract.term.offer.party.reference":"Reference","Contract.term.offer.party.role":"CodeableConcept","Contract.term.offer.securityLabelNumber":"unsignedInt","Contract.term.offer.text":"string","Contract.term.offer.topic":"Reference","Contract.term.offer.type":"CodeableConcept","Contract.term.securityLabel":"BackboneElement","Contract.term.securityLabel.category":"Coding","Contract.term.securityLabel.classification":"Coding","Contract.term.securityLabel.control":"Coding","Contract.term.securityLabel.extension":"Extension","Contract.term.securityLabel.id":"System.String","Contract.term.securityLabel.modifierExtension":"Extension","Contract.term.securityLabel.number":"unsignedInt","Contract.term.subType":"CodeableConcept","Contract.term.text":"string","Contract.term.topicCodeableConcept":"CodeableConcept","Contract.term.topicReference":"Reference","Contract.term.type":"CodeableConcept","Contract.text":"Narrative","Contract.title":"string","Contract.topicCodeableConcept":"CodeableConcept","Contract.topicReference":"Reference","Contract.type":"CodeableConcept","Contract.url":"uri","Contract.version":"string","Contributor.contact":"ContactDetail","Contributor.extension":"Extension","Contributor.id":"System.String","Contributor.name":"string","Contributor.type":"code","Count.code":"code","Count.comparator":"code","Count.extension":"Extension","Count.id":"System.String","Count.system":"uri","Count.unit":"string","Count.value":"decimal","Coverage.beneficiary":"Reference","Coverage.class":"BackboneElement","Coverage.class.extension":"Extension","Coverage.class.id":"System.String","Coverage.class.modifierExtension":"Extension","Coverage.class.name":"string","Coverage.class.type":"CodeableConcept","Coverage.class.value":"string","Coverage.contained":"Resource","Coverage.contract":"Reference","Coverage.costToBeneficiary":"BackboneElement","Coverage.costToBeneficiary.exception":"BackboneElement","Coverage.costToBeneficiary.exception.extension":"Extension","Coverage.costToBeneficiary.exception.id":"System.String","Coverage.costToBeneficiary.exception.modifierExtension":"Extension","Coverage.costToBeneficiary.exception.period":"Period","Coverage.costToBeneficiary.exception.type":"CodeableConcept","Coverage.costToBeneficiary.extension":"Extension","Coverage.costToBeneficiary.id":"System.String","Coverage.costToBeneficiary.modifierExtension":"Extension","Coverage.costToBeneficiary.type":"CodeableConcept","Coverage.costToBeneficiary.valueMoney":"Money","Coverage.costToBeneficiary.valueQuantity":"Quantity","Coverage.dependent":"string","Coverage.extension":"Extension","Coverage.id":"System.String","Coverage.identifier":"Identifier","Coverage.implicitRules":"uri","Coverage.language":"code","Coverage.meta":"Meta","Coverage.modifierExtension":"Extension","Coverage.network":"string","Coverage.order":"positiveInt","Coverage.payor":"Reference","Coverage.period":"Period","Coverage.policyHolder":"Reference","Coverage.relationship":"CodeableConcept","Coverage.status":"code","Coverage.subrogation":"boolean","Coverage.subscriber":"Reference","Coverage.subscriberId":"string","Coverage.text":"Narrative","Coverage.type":"CodeableConcept","CoverageEligibilityRequest.contained":"Resource","CoverageEligibilityRequest.created":"dateTime","CoverageEligibilityRequest.enterer":"Reference","CoverageEligibilityRequest.extension":"Extension","CoverageEligibilityRequest.facility":"Reference","CoverageEligibilityRequest.id":"System.String","CoverageEligibilityRequest.identifier":"Identifier","CoverageEligibilityRequest.implicitRules":"uri","CoverageEligibilityRequest.insurance":"BackboneElement","CoverageEligibilityRequest.insurance.businessArrangement":"string","CoverageEligibilityRequest.insurance.coverage":"Reference","CoverageEligibilityRequest.insurance.extension":"Extension","CoverageEligibilityRequest.insurance.focal":"boolean","CoverageEligibilityRequest.insurance.id":"System.String","CoverageEligibilityRequest.insurance.modifierExtension":"Extension","CoverageEligibilityRequest.insurer":"Reference","CoverageEligibilityRequest.item":"BackboneElement","CoverageEligibilityRequest.item.category":"CodeableConcept","CoverageEligibilityRequest.item.detail":"Reference","CoverageEligibilityRequest.item.diagnosis":"BackboneElement","CoverageEligibilityRequest.item.diagnosis.diagnosisCodeableConcept":"CodeableConcept","CoverageEligibilityRequest.item.diagnosis.diagnosisReference":"Reference","CoverageEligibilityRequest.item.diagnosis.extension":"Extension","CoverageEligibilityRequest.item.diagnosis.id":"System.String","CoverageEligibilityRequest.item.diagnosis.modifierExtension":"Extension","CoverageEligibilityRequest.item.extension":"Extension","CoverageEligibilityRequest.item.facility":"Reference","CoverageEligibilityRequest.item.id":"System.String","CoverageEligibilityRequest.item.modifier":"CodeableConcept","CoverageEligibilityRequest.item.modifierExtension":"Extension","CoverageEligibilityRequest.item.productOrService":"CodeableConcept","CoverageEligibilityRequest.item.provider":"Reference","CoverageEligibilityRequest.item.quantity":"Quantity","CoverageEligibilityRequest.item.supportingInfoSequence":"positiveInt","CoverageEligibilityRequest.item.unitPrice":"Money","CoverageEligibilityRequest.language":"code","CoverageEligibilityRequest.meta":"Meta","CoverageEligibilityRequest.modifierExtension":"Extension","CoverageEligibilityRequest.patient":"Reference","CoverageEligibilityRequest.priority":"CodeableConcept","CoverageEligibilityRequest.provider":"Reference","CoverageEligibilityRequest.purpose":"code","CoverageEligibilityRequest.servicedDate":"date","CoverageEligibilityRequest.servicedPeriod":"Period","CoverageEligibilityRequest.status":"code","CoverageEligibilityRequest.supportingInfo":"BackboneElement","CoverageEligibilityRequest.supportingInfo.appliesToAll":"boolean","CoverageEligibilityRequest.supportingInfo.extension":"Extension","CoverageEligibilityRequest.supportingInfo.id":"System.String","CoverageEligibilityRequest.supportingInfo.information":"Reference","CoverageEligibilityRequest.supportingInfo.modifierExtension":"Extension","CoverageEligibilityRequest.supportingInfo.sequence":"positiveInt","CoverageEligibilityRequest.text":"Narrative","CoverageEligibilityResponse.contained":"Resource","CoverageEligibilityResponse.created":"dateTime","CoverageEligibilityResponse.disposition":"string","CoverageEligibilityResponse.error":"BackboneElement","CoverageEligibilityResponse.error.code":"CodeableConcept","CoverageEligibilityResponse.error.extension":"Extension","CoverageEligibilityResponse.error.id":"System.String","CoverageEligibilityResponse.error.modifierExtension":"Extension","CoverageEligibilityResponse.extension":"Extension","CoverageEligibilityResponse.form":"CodeableConcept","CoverageEligibilityResponse.id":"System.String","CoverageEligibilityResponse.identifier":"Identifier","CoverageEligibilityResponse.implicitRules":"uri","CoverageEligibilityResponse.insurance":"BackboneElement","CoverageEligibilityResponse.insurance.benefitPeriod":"Period","CoverageEligibilityResponse.insurance.coverage":"Reference","CoverageEligibilityResponse.insurance.extension":"Extension","CoverageEligibilityResponse.insurance.id":"System.String","CoverageEligibilityResponse.insurance.inforce":"boolean","CoverageEligibilityResponse.insurance.item":"BackboneElement","CoverageEligibilityResponse.insurance.item.authorizationRequired":"boolean","CoverageEligibilityResponse.insurance.item.authorizationSupporting":"CodeableConcept","CoverageEligibilityResponse.insurance.item.authorizationUrl":"uri","CoverageEligibilityResponse.insurance.item.benefit":"BackboneElement","CoverageEligibilityResponse.insurance.item.benefit.allowedMoney":"Money","CoverageEligibilityResponse.insurance.item.benefit.allowedString":"string","CoverageEligibilityResponse.insurance.item.benefit.allowedUnsignedInt":"unsignedInt","CoverageEligibilityResponse.insurance.item.benefit.extension":"Extension","CoverageEligibilityResponse.insurance.item.benefit.id":"System.String","CoverageEligibilityResponse.insurance.item.benefit.modifierExtension":"Extension","CoverageEligibilityResponse.insurance.item.benefit.type":"CodeableConcept","CoverageEligibilityResponse.insurance.item.benefit.usedMoney":"Money","CoverageEligibilityResponse.insurance.item.benefit.usedString":"string","CoverageEligibilityResponse.insurance.item.benefit.usedUnsignedInt":"unsignedInt","CoverageEligibilityResponse.insurance.item.category":"CodeableConcept","CoverageEligibilityResponse.insurance.item.description":"string","CoverageEligibilityResponse.insurance.item.excluded":"boolean","CoverageEligibilityResponse.insurance.item.extension":"Extension","CoverageEligibilityResponse.insurance.item.id":"System.String","CoverageEligibilityResponse.insurance.item.modifier":"CodeableConcept","CoverageEligibilityResponse.insurance.item.modifierExtension":"Extension","CoverageEligibilityResponse.insurance.item.name":"string","CoverageEligibilityResponse.insurance.item.network":"CodeableConcept","CoverageEligibilityResponse.insurance.item.productOrService":"CodeableConcept","CoverageEligibilityResponse.insurance.item.provider":"Reference","CoverageEligibilityResponse.insurance.item.term":"CodeableConcept","CoverageEligibilityResponse.insurance.item.unit":"CodeableConcept","CoverageEligibilityResponse.insurance.modifierExtension":"Extension","CoverageEligibilityResponse.insurer":"Reference","CoverageEligibilityResponse.language":"code","CoverageEligibilityResponse.meta":"Meta","CoverageEligibilityResponse.modifierExtension":"Extension","CoverageEligibilityResponse.outcome":"code","CoverageEligibilityResponse.patient":"Reference","CoverageEligibilityResponse.preAuthRef":"string","CoverageEligibilityResponse.purpose":"code","CoverageEligibilityResponse.request":"Reference","CoverageEligibilityResponse.requestor":"Reference","CoverageEligibilityResponse.servicedDate":"date","CoverageEligibilityResponse.servicedPeriod":"Period","CoverageEligibilityResponse.status":"code","CoverageEligibilityResponse.text":"Narrative","DataRequirement.codeFilter":"Element","DataRequirement.codeFilter.code":"Coding","DataRequirement.codeFilter.extension":"Extension","DataRequirement.codeFilter.id":"System.String","DataRequirement.codeFilter.path":"string","DataRequirement.codeFilter.searchParam":"string","DataRequirement.codeFilter.valueSet":"canonical","DataRequirement.dateFilter":"Element","DataRequirement.dateFilter.extension":"Extension","DataRequirement.dateFilter.id":"System.String","DataRequirement.dateFilter.path":"string","DataRequirement.dateFilter.searchParam":"string","DataRequirement.dateFilter.valueDateTime":"dateTime","DataRequirement.dateFilter.valueDuration":"Duration","DataRequirement.dateFilter.valuePeriod":"Period","DataRequirement.extension":"Extension","DataRequirement.id":"System.String","DataRequirement.limit":"positiveInt","DataRequirement.mustSupport":"string","DataRequirement.profile":"canonical","DataRequirement.sort":"Element","DataRequirement.sort.direction":"code","DataRequirement.sort.extension":"Extension","DataRequirement.sort.id":"System.String","DataRequirement.sort.path":"string","DataRequirement.subjectCodeableConcept":"CodeableConcept","DataRequirement.subjectReference":"Reference","DataRequirement.type":"code","DetectedIssue.author":"Reference","DetectedIssue.code":"CodeableConcept","DetectedIssue.contained":"Resource","DetectedIssue.detail":"string","DetectedIssue.evidence":"BackboneElement","DetectedIssue.evidence.code":"CodeableConcept","DetectedIssue.evidence.detail":"Reference","DetectedIssue.evidence.extension":"Extension","DetectedIssue.evidence.id":"System.String","DetectedIssue.evidence.modifierExtension":"Extension","DetectedIssue.extension":"Extension","DetectedIssue.id":"System.String","DetectedIssue.identifiedDateTime":"dateTime","DetectedIssue.identifiedPeriod":"Period","DetectedIssue.identifier":"Identifier","DetectedIssue.implicated":"Reference","DetectedIssue.implicitRules":"uri","DetectedIssue.language":"code","DetectedIssue.meta":"Meta","DetectedIssue.mitigation":"BackboneElement","DetectedIssue.mitigation.action":"CodeableConcept","DetectedIssue.mitigation.author":"Reference","DetectedIssue.mitigation.date":"dateTime","DetectedIssue.mitigation.extension":"Extension","DetectedIssue.mitigation.id":"System.String","DetectedIssue.mitigation.modifierExtension":"Extension","DetectedIssue.modifierExtension":"Extension","DetectedIssue.patient":"Reference","DetectedIssue.reference":"uri","DetectedIssue.severity":"code","DetectedIssue.status":"code","DetectedIssue.text":"Narrative","Device.contact":"ContactPoint","Device.contained":"Resource","Device.definition":"Reference","Device.deviceName":"BackboneElement","Device.deviceName.extension":"Extension","Device.deviceName.id":"System.String","Device.deviceName.modifierExtension":"Extension","Device.deviceName.name":"string","Device.deviceName.type":"code","Device.distinctIdentifier":"string","Device.expirationDate":"dateTime","Device.extension":"Extension","Device.id":"System.String","Device.identifier":"Identifier","Device.implicitRules":"uri","Device.language":"code","Device.location":"Reference","Device.lotNumber":"string","Device.manufactureDate":"dateTime","Device.manufacturer":"string","Device.meta":"Meta","Device.modelNumber":"string","Device.modifierExtension":"Extension","Device.note":"Annotation","Device.owner":"Reference","Device.parent":"Reference","Device.partNumber":"string","Device.patient":"Reference","Device.property":"BackboneElement","Device.property.extension":"Extension","Device.property.id":"System.String","Device.property.modifierExtension":"Extension","Device.property.type":"CodeableConcept","Device.property.valueCode":"CodeableConcept","Device.property.valueQuantity":"Quantity","Device.safety":"CodeableConcept","Device.serialNumber":"string","Device.specialization":"BackboneElement","Device.specialization.extension":"Extension","Device.specialization.id":"System.String","Device.specialization.modifierExtension":"Extension","Device.specialization.systemType":"CodeableConcept","Device.specialization.version":"string","Device.status":"code","Device.statusReason":"CodeableConcept","Device.text":"Narrative","Device.type":"CodeableConcept","Device.udiCarrier":"BackboneElement","Device.udiCarrier.carrierAIDC":"base64Binary","Device.udiCarrier.carrierHRF":"string","Device.udiCarrier.deviceIdentifier":"string","Device.udiCarrier.entryType":"code","Device.udiCarrier.extension":"Extension","Device.udiCarrier.id":"System.String","Device.udiCarrier.issuer":"uri","Device.udiCarrier.jurisdiction":"uri","Device.udiCarrier.modifierExtension":"Extension","Device.url":"uri","Device.version":"BackboneElement","Device.version.component":"Identifier","Device.version.extension":"Extension","Device.version.id":"System.String","Device.version.modifierExtension":"Extension","Device.version.type":"CodeableConcept","Device.version.value":"string","DeviceDefinition.capability":"BackboneElement","DeviceDefinition.capability.description":"CodeableConcept","DeviceDefinition.capability.extension":"Extension","DeviceDefinition.capability.id":"System.String","DeviceDefinition.capability.modifierExtension":"Extension","DeviceDefinition.capability.type":"CodeableConcept","DeviceDefinition.contact":"ContactPoint","DeviceDefinition.contained":"Resource","DeviceDefinition.deviceName":"BackboneElement","DeviceDefinition.deviceName.extension":"Extension","DeviceDefinition.deviceName.id":"System.String","DeviceDefinition.deviceName.modifierExtension":"Extension","DeviceDefinition.deviceName.name":"string","DeviceDefinition.deviceName.type":"code","DeviceDefinition.extension":"Extension","DeviceDefinition.id":"System.String","DeviceDefinition.identifier":"Identifier","DeviceDefinition.implicitRules":"uri","DeviceDefinition.language":"code","DeviceDefinition.languageCode":"CodeableConcept","DeviceDefinition.manufacturerReference":"Reference","DeviceDefinition.manufacturerString":"string","DeviceDefinition.material":"BackboneElement","DeviceDefinition.material.allergenicIndicator":"boolean","DeviceDefinition.material.alternate":"boolean","DeviceDefinition.material.extension":"Extension","DeviceDefinition.material.id":"System.String","DeviceDefinition.material.modifierExtension":"Extension","DeviceDefinition.material.substance":"CodeableConcept","DeviceDefinition.meta":"Meta","DeviceDefinition.modelNumber":"string","DeviceDefinition.modifierExtension":"Extension","DeviceDefinition.note":"Annotation","DeviceDefinition.onlineInformation":"uri","DeviceDefinition.owner":"Reference","DeviceDefinition.parentDevice":"Reference","DeviceDefinition.physicalCharacteristics":"ProdCharacteristic","DeviceDefinition.property":"BackboneElement","DeviceDefinition.property.extension":"Extension","DeviceDefinition.property.id":"System.String","DeviceDefinition.property.modifierExtension":"Extension","DeviceDefinition.property.type":"CodeableConcept","DeviceDefinition.property.valueCode":"CodeableConcept","DeviceDefinition.property.valueQuantity":"Quantity","DeviceDefinition.quantity":"Quantity","DeviceDefinition.safety":"CodeableConcept","DeviceDefinition.shelfLifeStorage":"ProductShelfLife","DeviceDefinition.specialization":"BackboneElement","DeviceDefinition.specialization.extension":"Extension","DeviceDefinition.specialization.id":"System.String","DeviceDefinition.specialization.modifierExtension":"Extension","DeviceDefinition.specialization.systemType":"string","DeviceDefinition.specialization.version":"string","DeviceDefinition.text":"Narrative","DeviceDefinition.type":"CodeableConcept","DeviceDefinition.udiDeviceIdentifier":"BackboneElement","DeviceDefinition.udiDeviceIdentifier.deviceIdentifier":"string","DeviceDefinition.udiDeviceIdentifier.extension":"Extension","DeviceDefinition.udiDeviceIdentifier.id":"System.String","DeviceDefinition.udiDeviceIdentifier.issuer":"uri","DeviceDefinition.udiDeviceIdentifier.jurisdiction":"uri","DeviceDefinition.udiDeviceIdentifier.modifierExtension":"Extension","DeviceDefinition.url":"uri","DeviceDefinition.version":"string","DeviceMetric.calibration":"BackboneElement","DeviceMetric.calibration.extension":"Extension","DeviceMetric.calibration.id":"System.String","DeviceMetric.calibration.modifierExtension":"Extension","DeviceMetric.calibration.state":"code","DeviceMetric.calibration.time":"instant","DeviceMetric.calibration.type":"code","DeviceMetric.category":"code","DeviceMetric.color":"code","DeviceMetric.contained":"Resource","DeviceMetric.extension":"Extension","DeviceMetric.id":"System.String","DeviceMetric.identifier":"Identifier","DeviceMetric.implicitRules":"uri","DeviceMetric.language":"code","DeviceMetric.measurementPeriod":"Timing","DeviceMetric.meta":"Meta","DeviceMetric.modifierExtension":"Extension","DeviceMetric.operationalStatus":"code","DeviceMetric.parent":"Reference","DeviceMetric.source":"Reference","DeviceMetric.text":"Narrative","DeviceMetric.type":"CodeableConcept","DeviceMetric.unit":"CodeableConcept","DeviceRequest.authoredOn":"dateTime","DeviceRequest.basedOn":"Reference","DeviceRequest.codeCodeableConcept":"CodeableConcept","DeviceRequest.codeReference":"Reference","DeviceRequest.contained":"Resource","DeviceRequest.encounter":"Reference","DeviceRequest.extension":"Extension","DeviceRequest.groupIdentifier":"Identifier","DeviceRequest.id":"System.String","DeviceRequest.identifier":"Identifier","DeviceRequest.implicitRules":"uri","DeviceRequest.instantiatesCanonical":"canonical","DeviceRequest.instantiatesUri":"uri","DeviceRequest.insurance":"Reference","DeviceRequest.intent":"code","DeviceRequest.language":"code","DeviceRequest.meta":"Meta","DeviceRequest.modifierExtension":"Extension","DeviceRequest.note":"Annotation","DeviceRequest.occurrenceDateTime":"dateTime","DeviceRequest.occurrencePeriod":"Period","DeviceRequest.occurrenceTiming":"Timing","DeviceRequest.parameter":"BackboneElement","DeviceRequest.parameter.code":"CodeableConcept","DeviceRequest.parameter.extension":"Extension","DeviceRequest.parameter.id":"System.String","DeviceRequest.parameter.modifierExtension":"Extension","DeviceRequest.parameter.valueBoolean":"boolean","DeviceRequest.parameter.valueCodeableConcept":"CodeableConcept","DeviceRequest.parameter.valueQuantity":"Quantity","DeviceRequest.parameter.valueRange":"Range","DeviceRequest.performer":"Reference","DeviceRequest.performerType":"CodeableConcept","DeviceRequest.priorRequest":"Reference","DeviceRequest.priority":"code","DeviceRequest.reasonCode":"CodeableConcept","DeviceRequest.reasonReference":"Reference","DeviceRequest.relevantHistory":"Reference","DeviceRequest.requester":"Reference","DeviceRequest.status":"code","DeviceRequest.subject":"Reference","DeviceRequest.supportingInfo":"Reference","DeviceRequest.text":"Narrative","DeviceUseStatement.basedOn":"Reference","DeviceUseStatement.bodySite":"CodeableConcept","DeviceUseStatement.contained":"Resource","DeviceUseStatement.derivedFrom":"Reference","DeviceUseStatement.device":"Reference","DeviceUseStatement.extension":"Extension","DeviceUseStatement.id":"System.String","DeviceUseStatement.identifier":"Identifier","DeviceUseStatement.implicitRules":"uri","DeviceUseStatement.language":"code","DeviceUseStatement.meta":"Meta","DeviceUseStatement.modifierExtension":"Extension","DeviceUseStatement.note":"Annotation","DeviceUseStatement.reasonCode":"CodeableConcept","DeviceUseStatement.reasonReference":"Reference","DeviceUseStatement.recordedOn":"dateTime","DeviceUseStatement.source":"Reference","DeviceUseStatement.status":"code","DeviceUseStatement.subject":"Reference","DeviceUseStatement.text":"Narrative","DeviceUseStatement.timingDateTime":"dateTime","DeviceUseStatement.timingPeriod":"Period","DeviceUseStatement.timingTiming":"Timing","DiagnosticReport.basedOn":"Reference","DiagnosticReport.category":"CodeableConcept","DiagnosticReport.code":"CodeableConcept","DiagnosticReport.conclusion":"string","DiagnosticReport.conclusionCode":"CodeableConcept","DiagnosticReport.contained":"Resource","DiagnosticReport.effectiveDateTime":"dateTime","DiagnosticReport.effectivePeriod":"Period","DiagnosticReport.encounter":"Reference","DiagnosticReport.extension":"Extension","DiagnosticReport.id":"System.String","DiagnosticReport.identifier":"Identifier","DiagnosticReport.imagingStudy":"Reference","DiagnosticReport.implicitRules":"uri","DiagnosticReport.issued":"instant","DiagnosticReport.language":"code","DiagnosticReport.media":"BackboneElement","DiagnosticReport.media.comment":"string","DiagnosticReport.media.extension":"Extension","DiagnosticReport.media.id":"System.String","DiagnosticReport.media.link":"Reference","DiagnosticReport.media.modifierExtension":"Extension","DiagnosticReport.meta":"Meta","DiagnosticReport.modifierExtension":"Extension","DiagnosticReport.performer":"Reference","DiagnosticReport.presentedForm":"Attachment","DiagnosticReport.result":"Reference","DiagnosticReport.resultsInterpreter":"Reference","DiagnosticReport.specimen":"Reference","DiagnosticReport.status":"code","DiagnosticReport.subject":"Reference","DiagnosticReport.text":"Narrative","Distance.code":"code","Distance.comparator":"code","Distance.extension":"Extension","Distance.id":"System.String","Distance.system":"uri","Distance.unit":"string","Distance.value":"decimal","DocumentManifest.author":"Reference","DocumentManifest.contained":"Resource","DocumentManifest.content":"Reference","DocumentManifest.created":"dateTime","DocumentManifest.description":"string","DocumentManifest.extension":"Extension","DocumentManifest.id":"System.String","DocumentManifest.identifier":"Identifier","DocumentManifest.implicitRules":"uri","DocumentManifest.language":"code","DocumentManifest.masterIdentifier":"Identifier","DocumentManifest.meta":"Meta","DocumentManifest.modifierExtension":"Extension","DocumentManifest.recipient":"Reference","DocumentManifest.related":"BackboneElement","DocumentManifest.related.extension":"Extension","DocumentManifest.related.id":"System.String","DocumentManifest.related.identifier":"Identifier","DocumentManifest.related.modifierExtension":"Extension","DocumentManifest.related.ref":"Reference","DocumentManifest.source":"uri","DocumentManifest.status":"code","DocumentManifest.subject":"Reference","DocumentManifest.text":"Narrative","DocumentManifest.type":"CodeableConcept","DocumentReference.authenticator":"Reference","DocumentReference.author":"Reference","DocumentReference.category":"CodeableConcept","DocumentReference.contained":"Resource","DocumentReference.content":"BackboneElement","DocumentReference.content.attachment":"Attachment","DocumentReference.content.extension":"Extension","DocumentReference.content.format":"Coding","DocumentReference.content.id":"System.String","DocumentReference.content.modifierExtension":"Extension","DocumentReference.context":"BackboneElement","DocumentReference.context.encounter":"Reference","DocumentReference.context.event":"CodeableConcept","DocumentReference.context.extension":"Extension","DocumentReference.context.facilityType":"CodeableConcept","DocumentReference.context.id":"System.String","DocumentReference.context.modifierExtension":"Extension","DocumentReference.context.period":"Period","DocumentReference.context.practiceSetting":"CodeableConcept","DocumentReference.context.related":"Reference","DocumentReference.context.sourcePatientInfo":"Reference","DocumentReference.custodian":"Reference","DocumentReference.date":"instant","DocumentReference.description":"string","DocumentReference.docStatus":"code","DocumentReference.extension":"Extension","DocumentReference.id":"System.String","DocumentReference.identifier":"Identifier","DocumentReference.implicitRules":"uri","DocumentReference.language":"code","DocumentReference.masterIdentifier":"Identifier","DocumentReference.meta":"Meta","DocumentReference.modifierExtension":"Extension","DocumentReference.relatesTo":"BackboneElement","DocumentReference.relatesTo.code":"code","DocumentReference.relatesTo.extension":"Extension","DocumentReference.relatesTo.id":"System.String","DocumentReference.relatesTo.modifierExtension":"Extension","DocumentReference.relatesTo.target":"Reference","DocumentReference.securityLabel":"CodeableConcept","DocumentReference.status":"code","DocumentReference.subject":"Reference","DocumentReference.text":"Narrative","DocumentReference.type":"CodeableConcept","DomainResource.contained":"Resource","DomainResource.extension":"Extension","DomainResource.id":"System.String","DomainResource.implicitRules":"uri","DomainResource.language":"code","DomainResource.meta":"Meta","DomainResource.modifierExtension":"Extension","DomainResource.text":"Narrative","Dosage.additionalInstruction":"CodeableConcept","Dosage.asNeededBoolean":"boolean","Dosage.asNeededCodeableConcept":"CodeableConcept","Dosage.doseAndRate":"Element","Dosage.doseAndRate.doseQuantity":"Quantity","Dosage.doseAndRate.doseRange":"Range","Dosage.doseAndRate.extension":"Extension","Dosage.doseAndRate.id":"System.String","Dosage.doseAndRate.rateQuantity":"Quantity","Dosage.doseAndRate.rateRange":"Range","Dosage.doseAndRate.rateRatio":"Ratio","Dosage.doseAndRate.type":"CodeableConcept","Dosage.extension":"Extension","Dosage.id":"System.String","Dosage.maxDosePerAdministration":"Quantity","Dosage.maxDosePerLifetime":"Quantity","Dosage.maxDosePerPeriod":"Ratio","Dosage.method":"CodeableConcept","Dosage.modifierExtension":"Extension","Dosage.patientInstruction":"string","Dosage.route":"CodeableConcept","Dosage.sequence":"integer","Dosage.site":"CodeableConcept","Dosage.text":"string","Dosage.timing":"Timing","Duration.code":"code","Duration.comparator":"code","Duration.extension":"Extension","Duration.id":"System.String","Duration.system":"uri","Duration.unit":"string","Duration.value":"decimal","EffectEvidenceSynthesis.approvalDate":"date","EffectEvidenceSynthesis.author":"ContactDetail","EffectEvidenceSynthesis.certainty":"BackboneElement","EffectEvidenceSynthesis.certainty.certaintySubcomponent":"BackboneElement","EffectEvidenceSynthesis.certainty.certaintySubcomponent.extension":"Extension","EffectEvidenceSynthesis.certainty.certaintySubcomponent.id":"System.String","EffectEvidenceSynthesis.certainty.certaintySubcomponent.modifierExtension":"Extension","EffectEvidenceSynthesis.certainty.certaintySubcomponent.note":"Annotation","EffectEvidenceSynthesis.certainty.certaintySubcomponent.rating":"CodeableConcept","EffectEvidenceSynthesis.certainty.certaintySubcomponent.type":"CodeableConcept","EffectEvidenceSynthesis.certainty.extension":"Extension","EffectEvidenceSynthesis.certainty.id":"System.String","EffectEvidenceSynthesis.certainty.modifierExtension":"Extension","EffectEvidenceSynthesis.certainty.note":"Annotation","EffectEvidenceSynthesis.certainty.rating":"CodeableConcept","EffectEvidenceSynthesis.contact":"ContactDetail","EffectEvidenceSynthesis.contained":"Resource","EffectEvidenceSynthesis.copyright":"markdown","EffectEvidenceSynthesis.date":"dateTime","EffectEvidenceSynthesis.description":"markdown","EffectEvidenceSynthesis.editor":"ContactDetail","EffectEvidenceSynthesis.effectEstimate":"BackboneElement","EffectEvidenceSynthesis.effectEstimate.description":"string","EffectEvidenceSynthesis.effectEstimate.extension":"Extension","EffectEvidenceSynthesis.effectEstimate.id":"System.String","EffectEvidenceSynthesis.effectEstimate.modifierExtension":"Extension","EffectEvidenceSynthesis.effectEstimate.precisionEstimate":"BackboneElement","EffectEvidenceSynthesis.effectEstimate.precisionEstimate.extension":"Extension","EffectEvidenceSynthesis.effectEstimate.precisionEstimate.from":"decimal","EffectEvidenceSynthesis.effectEstimate.precisionEstimate.id":"System.String","EffectEvidenceSynthesis.effectEstimate.precisionEstimate.level":"decimal","EffectEvidenceSynthesis.effectEstimate.precisionEstimate.modifierExtension":"Extension","EffectEvidenceSynthesis.effectEstimate.precisionEstimate.to":"decimal","EffectEvidenceSynthesis.effectEstimate.precisionEstimate.type":"CodeableConcept","EffectEvidenceSynthesis.effectEstimate.type":"CodeableConcept","EffectEvidenceSynthesis.effectEstimate.unitOfMeasure":"CodeableConcept","EffectEvidenceSynthesis.effectEstimate.value":"decimal","EffectEvidenceSynthesis.effectEstimate.variantState":"CodeableConcept","EffectEvidenceSynthesis.effectivePeriod":"Period","EffectEvidenceSynthesis.endorser":"ContactDetail","EffectEvidenceSynthesis.exposure":"Reference","EffectEvidenceSynthesis.exposureAlternative":"Reference","EffectEvidenceSynthesis.extension":"Extension","EffectEvidenceSynthesis.id":"System.String","EffectEvidenceSynthesis.identifier":"Identifier","EffectEvidenceSynthesis.implicitRules":"uri","EffectEvidenceSynthesis.jurisdiction":"CodeableConcept","EffectEvidenceSynthesis.language":"code","EffectEvidenceSynthesis.lastReviewDate":"date","EffectEvidenceSynthesis.meta":"Meta","EffectEvidenceSynthesis.modifierExtension":"Extension","EffectEvidenceSynthesis.name":"string","EffectEvidenceSynthesis.note":"Annotation","EffectEvidenceSynthesis.outcome":"Reference","EffectEvidenceSynthesis.population":"Reference","EffectEvidenceSynthesis.publisher":"string","EffectEvidenceSynthesis.relatedArtifact":"RelatedArtifact","EffectEvidenceSynthesis.resultsByExposure":"BackboneElement","EffectEvidenceSynthesis.resultsByExposure.description":"string","EffectEvidenceSynthesis.resultsByExposure.exposureState":"code","EffectEvidenceSynthesis.resultsByExposure.extension":"Extension","EffectEvidenceSynthesis.resultsByExposure.id":"System.String","EffectEvidenceSynthesis.resultsByExposure.modifierExtension":"Extension","EffectEvidenceSynthesis.resultsByExposure.riskEvidenceSynthesis":"Reference","EffectEvidenceSynthesis.resultsByExposure.variantState":"CodeableConcept","EffectEvidenceSynthesis.reviewer":"ContactDetail","EffectEvidenceSynthesis.sampleSize":"BackboneElement","EffectEvidenceSynthesis.sampleSize.description":"string","EffectEvidenceSynthesis.sampleSize.extension":"Extension","EffectEvidenceSynthesis.sampleSize.id":"System.String","EffectEvidenceSynthesis.sampleSize.modifierExtension":"Extension","EffectEvidenceSynthesis.sampleSize.numberOfParticipants":"integer","EffectEvidenceSynthesis.sampleSize.numberOfStudies":"integer","EffectEvidenceSynthesis.status":"code","EffectEvidenceSynthesis.studyType":"CodeableConcept","EffectEvidenceSynthesis.synthesisType":"CodeableConcept","EffectEvidenceSynthesis.text":"Narrative","EffectEvidenceSynthesis.title":"string","EffectEvidenceSynthesis.topic":"CodeableConcept","EffectEvidenceSynthesis.url":"uri","EffectEvidenceSynthesis.useContext":"UsageContext","EffectEvidenceSynthesis.version":"string","Element.extension":"Extension","Element.id":"System.String","ElementDefinition.alias":"string","ElementDefinition.base":"Element","ElementDefinition.base.extension":"Extension","ElementDefinition.base.id":"System.String","ElementDefinition.base.max":"string","ElementDefinition.base.min":"unsignedInt","ElementDefinition.base.path":"string","ElementDefinition.binding":"Element","ElementDefinition.binding.description":"string","ElementDefinition.binding.extension":"Extension","ElementDefinition.binding.id":"System.String","ElementDefinition.binding.strength":"code","ElementDefinition.binding.valueSet":"canonical","ElementDefinition.code":"Coding","ElementDefinition.comment":"markdown","ElementDefinition.condition":"id","ElementDefinition.constraint":"Element","ElementDefinition.constraint.expression":"string","ElementDefinition.constraint.extension":"Extension","ElementDefinition.constraint.human":"string","ElementDefinition.constraint.id":"System.String","ElementDefinition.constraint.key":"id","ElementDefinition.constraint.requirements":"string","ElementDefinition.constraint.severity":"code","ElementDefinition.constraint.source":"canonical","ElementDefinition.constraint.xpath":"string","ElementDefinition.contentReference":"uri","ElementDefinition.defaultValueAddress":"Address","ElementDefinition.defaultValueAge":"Age","ElementDefinition.defaultValueAnnotation":"Annotation","ElementDefinition.defaultValueAttachment":"Attachment","ElementDefinition.defaultValueBase64Binary":"base64Binary","ElementDefinition.defaultValueBoolean":"boolean","ElementDefinition.defaultValueCanonical":"canonical","ElementDefinition.defaultValueCode":"code","ElementDefinition.defaultValueCodeableConcept":"CodeableConcept","ElementDefinition.defaultValueCoding":"Coding","ElementDefinition.defaultValueContactDetail":"ContactDetail","ElementDefinition.defaultValueContactPoint":"ContactPoint","ElementDefinition.defaultValueContributor":"Contributor","ElementDefinition.defaultValueCount":"Count","ElementDefinition.defaultValueDataRequirement":"DataRequirement","ElementDefinition.defaultValueDate":"date","ElementDefinition.defaultValueDateTime":"dateTime","ElementDefinition.defaultValueDecimal":"decimal","ElementDefinition.defaultValueDistance":"Distance","ElementDefinition.defaultValueDosage":"Dosage","ElementDefinition.defaultValueDuration":"Duration","ElementDefinition.defaultValueExpression":"Expression","ElementDefinition.defaultValueHumanName":"HumanName","ElementDefinition.defaultValueId":"id","ElementDefinition.defaultValueIdentifier":"Identifier","ElementDefinition.defaultValueInstant":"instant","ElementDefinition.defaultValueInteger":"integer","ElementDefinition.defaultValueMarkdown":"markdown","ElementDefinition.defaultValueMeta":"Meta","ElementDefinition.defaultValueMoney":"Money","ElementDefinition.defaultValueOid":"oid","ElementDefinition.defaultValueParameterDefinition":"ParameterDefinition","ElementDefinition.defaultValuePeriod":"Period","ElementDefinition.defaultValuePositiveInt":"positiveInt","ElementDefinition.defaultValueQuantity":"Quantity","ElementDefinition.defaultValueRange":"Range","ElementDefinition.defaultValueRatio":"Ratio","ElementDefinition.defaultValueReference":"Reference","ElementDefinition.defaultValueRelatedArtifact":"RelatedArtifact","ElementDefinition.defaultValueSampledData":"SampledData","ElementDefinition.defaultValueSignature":"Signature","ElementDefinition.defaultValueString":"string","ElementDefinition.defaultValueTime":"time","ElementDefinition.defaultValueTiming":"Timing","ElementDefinition.defaultValueTriggerDefinition":"TriggerDefinition","ElementDefinition.defaultValueUnsignedInt":"unsignedInt","ElementDefinition.defaultValueUri":"uri","ElementDefinition.defaultValueUrl":"url","ElementDefinition.defaultValueUsageContext":"UsageContext","ElementDefinition.defaultValueUuid":"uuid","ElementDefinition.definition":"markdown","ElementDefinition.example":"Element","ElementDefinition.example.extension":"Extension","ElementDefinition.example.id":"System.String","ElementDefinition.example.label":"string","ElementDefinition.example.valueAddress":"Address","ElementDefinition.example.valueAge":"Age","ElementDefinition.example.valueAnnotation":"Annotation","ElementDefinition.example.valueAttachment":"Attachment","ElementDefinition.example.valueBase64Binary":"base64Binary","ElementDefinition.example.valueBoolean":"boolean","ElementDefinition.example.valueCanonical":"canonical","ElementDefinition.example.valueCode":"code","ElementDefinition.example.valueCodeableConcept":"CodeableConcept","ElementDefinition.example.valueCoding":"Coding","ElementDefinition.example.valueContactDetail":"ContactDetail","ElementDefinition.example.valueContactPoint":"ContactPoint","ElementDefinition.example.valueContributor":"Contributor","ElementDefinition.example.valueCount":"Count","ElementDefinition.example.valueDataRequirement":"DataRequirement","ElementDefinition.example.valueDate":"date","ElementDefinition.example.valueDateTime":"dateTime","ElementDefinition.example.valueDecimal":"decimal","ElementDefinition.example.valueDistance":"Distance","ElementDefinition.example.valueDosage":"Dosage","ElementDefinition.example.valueDuration":"Duration","ElementDefinition.example.valueExpression":"Expression","ElementDefinition.example.valueHumanName":"HumanName","ElementDefinition.example.valueId":"id","ElementDefinition.example.valueIdentifier":"Identifier","ElementDefinition.example.valueInstant":"instant","ElementDefinition.example.valueInteger":"integer","ElementDefinition.example.valueMarkdown":"markdown","ElementDefinition.example.valueMeta":"Meta","ElementDefinition.example.valueMoney":"Money","ElementDefinition.example.valueOid":"oid","ElementDefinition.example.valueParameterDefinition":"ParameterDefinition","ElementDefinition.example.valuePeriod":"Period","ElementDefinition.example.valuePositiveInt":"positiveInt","ElementDefinition.example.valueQuantity":"Quantity","ElementDefinition.example.valueRange":"Range","ElementDefinition.example.valueRatio":"Ratio","ElementDefinition.example.valueReference":"Reference","ElementDefinition.example.valueRelatedArtifact":"RelatedArtifact","ElementDefinition.example.valueSampledData":"SampledData","ElementDefinition.example.valueSignature":"Signature","ElementDefinition.example.valueString":"string","ElementDefinition.example.valueTime":"time","ElementDefinition.example.valueTiming":"Timing","ElementDefinition.example.valueTriggerDefinition":"TriggerDefinition","ElementDefinition.example.valueUnsignedInt":"unsignedInt","ElementDefinition.example.valueUri":"uri","ElementDefinition.example.valueUrl":"url","ElementDefinition.example.valueUsageContext":"UsageContext","ElementDefinition.example.valueUuid":"uuid","ElementDefinition.extension":"Extension","ElementDefinition.extension.extension":"Extension","ElementDefinition.extension.id":"System.String","ElementDefinition.extension.url":"System.String","ElementDefinition.extension.valueCanonical":"canonical","ElementDefinition.extension.valueCodeableConcept":"CodeableConcept","ElementDefinition.extension.valueString":"string","ElementDefinition.fixedAddress":"Address","ElementDefinition.fixedAge":"Age","ElementDefinition.fixedAnnotation":"Annotation","ElementDefinition.fixedAttachment":"Attachment","ElementDefinition.fixedBase64Binary":"base64Binary","ElementDefinition.fixedBoolean":"boolean","ElementDefinition.fixedCanonical":"canonical","ElementDefinition.fixedCode":"code","ElementDefinition.fixedCodeableConcept":"CodeableConcept","ElementDefinition.fixedCoding":"Coding","ElementDefinition.fixedContactDetail":"ContactDetail","ElementDefinition.fixedContactPoint":"ContactPoint","ElementDefinition.fixedContributor":"Contributor","ElementDefinition.fixedCount":"Count","ElementDefinition.fixedDataRequirement":"DataRequirement","ElementDefinition.fixedDate":"date","ElementDefinition.fixedDateTime":"dateTime","ElementDefinition.fixedDecimal":"decimal","ElementDefinition.fixedDistance":"Distance","ElementDefinition.fixedDosage":"Dosage","ElementDefinition.fixedDuration":"Duration","ElementDefinition.fixedExpression":"Expression","ElementDefinition.fixedHumanName":"HumanName","ElementDefinition.fixedId":"id","ElementDefinition.fixedIdentifier":"Identifier","ElementDefinition.fixedInstant":"instant","ElementDefinition.fixedInteger":"integer","ElementDefinition.fixedMarkdown":"markdown","ElementDefinition.fixedMeta":"Meta","ElementDefinition.fixedMoney":"Money","ElementDefinition.fixedOid":"oid","ElementDefinition.fixedParameterDefinition":"ParameterDefinition","ElementDefinition.fixedPeriod":"Period","ElementDefinition.fixedPositiveInt":"positiveInt","ElementDefinition.fixedQuantity":"Quantity","ElementDefinition.fixedRange":"Range","ElementDefinition.fixedRatio":"Ratio","ElementDefinition.fixedReference":"Reference","ElementDefinition.fixedRelatedArtifact":"RelatedArtifact","ElementDefinition.fixedSampledData":"SampledData","ElementDefinition.fixedSignature":"Signature","ElementDefinition.fixedString":"string","ElementDefinition.fixedTime":"time","ElementDefinition.fixedTiming":"Timing","ElementDefinition.fixedTriggerDefinition":"TriggerDefinition","ElementDefinition.fixedUnsignedInt":"unsignedInt","ElementDefinition.fixedUri":"uri","ElementDefinition.fixedUrl":"url","ElementDefinition.fixedUsageContext":"UsageContext","ElementDefinition.fixedUuid":"uuid","ElementDefinition.id":"System.String","ElementDefinition.isModifier":"boolean","ElementDefinition.isModifierReason":"string","ElementDefinition.isSummary":"boolean","ElementDefinition.label":"string","ElementDefinition.mapping":"Element","ElementDefinition.mapping.comment":"string","ElementDefinition.mapping.extension":"Extension","ElementDefinition.mapping.id":"System.String","ElementDefinition.mapping.identity":"id","ElementDefinition.mapping.language":"code","ElementDefinition.mapping.map":"string","ElementDefinition.max":"string","ElementDefinition.maxLength":"integer","ElementDefinition.maxValueDate":"date","ElementDefinition.maxValueDateTime":"dateTime","ElementDefinition.maxValueDecimal":"decimal","ElementDefinition.maxValueInstant":"instant","ElementDefinition.maxValueInteger":"integer","ElementDefinition.maxValuePositiveInt":"positiveInt","ElementDefinition.maxValueQuantity":"Quantity","ElementDefinition.maxValueTime":"time","ElementDefinition.maxValueUnsignedInt":"unsignedInt","ElementDefinition.meaningWhenMissing":"markdown","ElementDefinition.min":"unsignedInt","ElementDefinition.minValueDate":"date","ElementDefinition.minValueDateTime":"dateTime","ElementDefinition.minValueDecimal":"decimal","ElementDefinition.minValueInstant":"instant","ElementDefinition.minValueInteger":"integer","ElementDefinition.minValuePositiveInt":"positiveInt","ElementDefinition.minValueQuantity":"Quantity","ElementDefinition.minValueTime":"time","ElementDefinition.minValueUnsignedInt":"unsignedInt","ElementDefinition.modifierExtension":"Extension","ElementDefinition.mustSupport":"boolean","ElementDefinition.orderMeaning":"string","ElementDefinition.path":"string","ElementDefinition.patternAddress":"Address","ElementDefinition.patternAge":"Age","ElementDefinition.patternAnnotation":"Annotation","ElementDefinition.patternAttachment":"Attachment","ElementDefinition.patternBase64Binary":"base64Binary","ElementDefinition.patternBoolean":"boolean","ElementDefinition.patternCanonical":"canonical","ElementDefinition.patternCode":"code","ElementDefinition.patternCodeableConcept":"CodeableConcept","ElementDefinition.patternCoding":"Coding","ElementDefinition.patternContactDetail":"ContactDetail","ElementDefinition.patternContactPoint":"ContactPoint","ElementDefinition.patternContributor":"Contributor","ElementDefinition.patternCount":"Count","ElementDefinition.patternDataRequirement":"DataRequirement","ElementDefinition.patternDate":"date","ElementDefinition.patternDateTime":"dateTime","ElementDefinition.patternDecimal":"decimal","ElementDefinition.patternDistance":"Distance","ElementDefinition.patternDosage":"Dosage","ElementDefinition.patternDuration":"Duration","ElementDefinition.patternExpression":"Expression","ElementDefinition.patternHumanName":"HumanName","ElementDefinition.patternId":"id","ElementDefinition.patternIdentifier":"Identifier","ElementDefinition.patternInstant":"instant","ElementDefinition.patternInteger":"integer","ElementDefinition.patternMarkdown":"markdown","ElementDefinition.patternMeta":"Meta","ElementDefinition.patternMoney":"Money","ElementDefinition.patternOid":"oid","ElementDefinition.patternParameterDefinition":"ParameterDefinition","ElementDefinition.patternPeriod":"Period","ElementDefinition.patternPositiveInt":"positiveInt","ElementDefinition.patternQuantity":"Quantity","ElementDefinition.patternRange":"Range","ElementDefinition.patternRatio":"Ratio","ElementDefinition.patternReference":"Reference","ElementDefinition.patternRelatedArtifact":"RelatedArtifact","ElementDefinition.patternSampledData":"SampledData","ElementDefinition.patternSignature":"Signature","ElementDefinition.patternString":"string","ElementDefinition.patternTime":"time","ElementDefinition.patternTiming":"Timing","ElementDefinition.patternTriggerDefinition":"TriggerDefinition","ElementDefinition.patternUnsignedInt":"unsignedInt","ElementDefinition.patternUri":"uri","ElementDefinition.patternUrl":"url","ElementDefinition.patternUsageContext":"UsageContext","ElementDefinition.patternUuid":"uuid","ElementDefinition.representation":"code","ElementDefinition.requirements":"markdown","ElementDefinition.short":"string","ElementDefinition.sliceIsConstraining":"boolean","ElementDefinition.sliceName":"string","ElementDefinition.slicing":"Element","ElementDefinition.slicing.description":"string","ElementDefinition.slicing.discriminator":"Element","ElementDefinition.slicing.discriminator.extension":"Extension","ElementDefinition.slicing.discriminator.id":"System.String","ElementDefinition.slicing.discriminator.path":"string","ElementDefinition.slicing.discriminator.type":"code","ElementDefinition.slicing.extension":"Extension","ElementDefinition.slicing.id":"System.String","ElementDefinition.slicing.ordered":"boolean","ElementDefinition.slicing.rules":"code","ElementDefinition.type":"Element","ElementDefinition.type.aggregation":"code","ElementDefinition.type.code":"uri","ElementDefinition.type.extension":"Extension","ElementDefinition.type.id":"System.String","ElementDefinition.type.profile":"canonical","ElementDefinition.type.targetProfile":"canonical","ElementDefinition.type.versioning":"code","Encounter.account":"Reference","Encounter.appointment":"Reference","Encounter.basedOn":"Reference","Encounter.class":"Coding","Encounter.classHistory":"BackboneElement","Encounter.classHistory.class":"Coding","Encounter.classHistory.extension":"Extension","Encounter.classHistory.id":"System.String","Encounter.classHistory.modifierExtension":"Extension","Encounter.classHistory.period":"Period","Encounter.contained":"Resource","Encounter.diagnosis":"BackboneElement","Encounter.diagnosis.condition":"Reference","Encounter.diagnosis.extension":"Extension","Encounter.diagnosis.id":"System.String","Encounter.diagnosis.modifierExtension":"Extension","Encounter.diagnosis.rank":"positiveInt","Encounter.diagnosis.use":"CodeableConcept","Encounter.episodeOfCare":"Reference","Encounter.extension":"Extension","Encounter.hospitalization":"BackboneElement","Encounter.hospitalization.admitSource":"CodeableConcept","Encounter.hospitalization.destination":"Reference","Encounter.hospitalization.dietPreference":"CodeableConcept","Encounter.hospitalization.dischargeDisposition":"CodeableConcept","Encounter.hospitalization.extension":"Extension","Encounter.hospitalization.id":"System.String","Encounter.hospitalization.modifierExtension":"Extension","Encounter.hospitalization.origin":"Reference","Encounter.hospitalization.preAdmissionIdentifier":"Identifier","Encounter.hospitalization.reAdmission":"CodeableConcept","Encounter.hospitalization.specialArrangement":"CodeableConcept","Encounter.hospitalization.specialCourtesy":"CodeableConcept","Encounter.id":"System.String","Encounter.identifier":"Identifier","Encounter.implicitRules":"uri","Encounter.language":"code","Encounter.length":"Duration","Encounter.location":"BackboneElement","Encounter.location.extension":"Extension","Encounter.location.id":"System.String","Encounter.location.location":"Reference","Encounter.location.modifierExtension":"Extension","Encounter.location.period":"Period","Encounter.location.physicalType":"CodeableConcept","Encounter.location.status":"code","Encounter.meta":"Meta","Encounter.modifierExtension":"Extension","Encounter.partOf":"Reference","Encounter.participant":"BackboneElement","Encounter.participant.extension":"Extension","Encounter.participant.id":"System.String","Encounter.participant.individual":"Reference","Encounter.participant.modifierExtension":"Extension","Encounter.participant.period":"Period","Encounter.participant.type":"CodeableConcept","Encounter.period":"Period","Encounter.priority":"CodeableConcept","Encounter.reasonCode":"CodeableConcept","Encounter.reasonReference":"Reference","Encounter.serviceProvider":"Reference","Encounter.serviceType":"CodeableConcept","Encounter.status":"code","Encounter.statusHistory":"BackboneElement","Encounter.statusHistory.extension":"Extension","Encounter.statusHistory.id":"System.String","Encounter.statusHistory.modifierExtension":"Extension","Encounter.statusHistory.period":"Period","Encounter.statusHistory.status":"code","Encounter.subject":"Reference","Encounter.text":"Narrative","Encounter.type":"CodeableConcept","Endpoint.address":"url","Endpoint.connectionType":"Coding","Endpoint.contact":"ContactPoint","Endpoint.contained":"Resource","Endpoint.extension":"Extension","Endpoint.header":"string","Endpoint.id":"System.String","Endpoint.identifier":"Identifier","Endpoint.implicitRules":"uri","Endpoint.language":"code","Endpoint.managingOrganization":"Reference","Endpoint.meta":"Meta","Endpoint.modifierExtension":"Extension","Endpoint.name":"string","Endpoint.payloadMimeType":"code","Endpoint.payloadType":"CodeableConcept","Endpoint.period":"Period","Endpoint.status":"code","Endpoint.text":"Narrative","EnrollmentRequest.candidate":"Reference","EnrollmentRequest.contained":"Resource","EnrollmentRequest.coverage":"Reference","EnrollmentRequest.created":"dateTime","EnrollmentRequest.extension":"Extension","EnrollmentRequest.id":"System.String","EnrollmentRequest.identifier":"Identifier","EnrollmentRequest.implicitRules":"uri","EnrollmentRequest.insurer":"Reference","EnrollmentRequest.language":"code","EnrollmentRequest.meta":"Meta","EnrollmentRequest.modifierExtension":"Extension","EnrollmentRequest.provider":"Reference","EnrollmentRequest.status":"code","EnrollmentRequest.text":"Narrative","EnrollmentResponse.contained":"Resource","EnrollmentResponse.created":"dateTime","EnrollmentResponse.disposition":"string","EnrollmentResponse.extension":"Extension","EnrollmentResponse.id":"System.String","EnrollmentResponse.identifier":"Identifier","EnrollmentResponse.implicitRules":"uri","EnrollmentResponse.language":"code","EnrollmentResponse.meta":"Meta","EnrollmentResponse.modifierExtension":"Extension","EnrollmentResponse.organization":"Reference","EnrollmentResponse.outcome":"code","EnrollmentResponse.request":"Reference","EnrollmentResponse.requestProvider":"Reference","EnrollmentResponse.status":"code","EnrollmentResponse.text":"Narrative","EpisodeOfCare.account":"Reference","EpisodeOfCare.careManager":"Reference","EpisodeOfCare.contained":"Resource","EpisodeOfCare.diagnosis":"BackboneElement","EpisodeOfCare.diagnosis.condition":"Reference","EpisodeOfCare.diagnosis.extension":"Extension","EpisodeOfCare.diagnosis.id":"System.String","EpisodeOfCare.diagnosis.modifierExtension":"Extension","EpisodeOfCare.diagnosis.rank":"positiveInt","EpisodeOfCare.diagnosis.role":"CodeableConcept","EpisodeOfCare.extension":"Extension","EpisodeOfCare.id":"System.String","EpisodeOfCare.identifier":"Identifier","EpisodeOfCare.implicitRules":"uri","EpisodeOfCare.language":"code","EpisodeOfCare.managingOrganization":"Reference","EpisodeOfCare.meta":"Meta","EpisodeOfCare.modifierExtension":"Extension","EpisodeOfCare.patient":"Reference","EpisodeOfCare.period":"Period","EpisodeOfCare.referralRequest":"Reference","EpisodeOfCare.status":"code","EpisodeOfCare.statusHistory":"BackboneElement","EpisodeOfCare.statusHistory.extension":"Extension","EpisodeOfCare.statusHistory.id":"System.String","EpisodeOfCare.statusHistory.modifierExtension":"Extension","EpisodeOfCare.statusHistory.period":"Period","EpisodeOfCare.statusHistory.status":"code","EpisodeOfCare.team":"Reference","EpisodeOfCare.text":"Narrative","EpisodeOfCare.type":"CodeableConcept","EventDefinition.approvalDate":"date","EventDefinition.author":"ContactDetail","EventDefinition.contact":"ContactDetail","EventDefinition.contained":"Resource","EventDefinition.copyright":"markdown","EventDefinition.date":"dateTime","EventDefinition.description":"markdown","EventDefinition.editor":"ContactDetail","EventDefinition.effectivePeriod":"Period","EventDefinition.endorser":"ContactDetail","EventDefinition.experimental":"boolean","EventDefinition.extension":"Extension","EventDefinition.id":"System.String","EventDefinition.identifier":"Identifier","EventDefinition.implicitRules":"uri","EventDefinition.jurisdiction":"CodeableConcept","EventDefinition.language":"code","EventDefinition.lastReviewDate":"date","EventDefinition.meta":"Meta","EventDefinition.modifierExtension":"Extension","EventDefinition.name":"string","EventDefinition.publisher":"string","EventDefinition.purpose":"markdown","EventDefinition.relatedArtifact":"RelatedArtifact","EventDefinition.reviewer":"ContactDetail","EventDefinition.status":"code","EventDefinition.subjectCodeableConcept":"CodeableConcept","EventDefinition.subjectReference":"Reference","EventDefinition.subtitle":"string","EventDefinition.text":"Narrative","EventDefinition.title":"string","EventDefinition.topic":"CodeableConcept","EventDefinition.trigger":"TriggerDefinition","EventDefinition.url":"uri","EventDefinition.usage":"string","EventDefinition.useContext":"UsageContext","EventDefinition.version":"string","Evidence.approvalDate":"date","Evidence.author":"ContactDetail","Evidence.contact":"ContactDetail","Evidence.contained":"Resource","Evidence.copyright":"markdown","Evidence.date":"dateTime","Evidence.description":"markdown","Evidence.editor":"ContactDetail","Evidence.effectivePeriod":"Period","Evidence.endorser":"ContactDetail","Evidence.exposureBackground":"Reference","Evidence.exposureVariant":"Reference","Evidence.extension":"Extension","Evidence.id":"System.String","Evidence.identifier":"Identifier","Evidence.implicitRules":"uri","Evidence.jurisdiction":"CodeableConcept","Evidence.language":"code","Evidence.lastReviewDate":"date","Evidence.meta":"Meta","Evidence.modifierExtension":"Extension","Evidence.name":"string","Evidence.note":"Annotation","Evidence.outcome":"Reference","Evidence.publisher":"string","Evidence.relatedArtifact":"RelatedArtifact","Evidence.reviewer":"ContactDetail","Evidence.shortTitle":"string","Evidence.status":"code","Evidence.subtitle":"string","Evidence.text":"Narrative","Evidence.title":"string","Evidence.topic":"CodeableConcept","Evidence.url":"uri","Evidence.useContext":"UsageContext","Evidence.version":"string","EvidenceVariable.approvalDate":"date","EvidenceVariable.author":"ContactDetail","EvidenceVariable.characteristic":"BackboneElement","EvidenceVariable.characteristic.definitionCanonical":"canonical","EvidenceVariable.characteristic.definitionCodeableConcept":"CodeableConcept","EvidenceVariable.characteristic.definitionDataRequirement":"DataRequirement","EvidenceVariable.characteristic.definitionExpression":"Expression","EvidenceVariable.characteristic.definitionReference":"Reference","EvidenceVariable.characteristic.definitionTriggerDefinition":"TriggerDefinition","EvidenceVariable.characteristic.description":"string","EvidenceVariable.characteristic.exclude":"boolean","EvidenceVariable.characteristic.extension":"Extension","EvidenceVariable.characteristic.groupMeasure":"code","EvidenceVariable.characteristic.id":"System.String","EvidenceVariable.characteristic.modifierExtension":"Extension","EvidenceVariable.characteristic.participantEffectiveDateTime":"dateTime","EvidenceVariable.characteristic.participantEffectiveDuration":"Duration","EvidenceVariable.characteristic.participantEffectivePeriod":"Period","EvidenceVariable.characteristic.participantEffectiveTiming":"Timing","EvidenceVariable.characteristic.timeFromStart":"Duration","EvidenceVariable.characteristic.usageContext":"UsageContext","EvidenceVariable.contact":"ContactDetail","EvidenceVariable.contained":"Resource","EvidenceVariable.copyright":"markdown","EvidenceVariable.date":"dateTime","EvidenceVariable.description":"markdown","EvidenceVariable.editor":"ContactDetail","EvidenceVariable.effectivePeriod":"Period","EvidenceVariable.endorser":"ContactDetail","EvidenceVariable.extension":"Extension","EvidenceVariable.id":"System.String","EvidenceVariable.identifier":"Identifier","EvidenceVariable.implicitRules":"uri","EvidenceVariable.jurisdiction":"CodeableConcept","EvidenceVariable.language":"code","EvidenceVariable.lastReviewDate":"date","EvidenceVariable.meta":"Meta","EvidenceVariable.modifierExtension":"Extension","EvidenceVariable.name":"string","EvidenceVariable.note":"Annotation","EvidenceVariable.publisher":"string","EvidenceVariable.relatedArtifact":"RelatedArtifact","EvidenceVariable.reviewer":"ContactDetail","EvidenceVariable.shortTitle":"string","EvidenceVariable.status":"code","EvidenceVariable.subtitle":"string","EvidenceVariable.text":"Narrative","EvidenceVariable.title":"string","EvidenceVariable.topic":"CodeableConcept","EvidenceVariable.type":"code","EvidenceVariable.url":"uri","EvidenceVariable.useContext":"UsageContext","EvidenceVariable.version":"string","ExampleScenario.actor":"BackboneElement","ExampleScenario.actor.actorId":"string","ExampleScenario.actor.description":"markdown","ExampleScenario.actor.extension":"Extension","ExampleScenario.actor.id":"System.String","ExampleScenario.actor.modifierExtension":"Extension","ExampleScenario.actor.name":"string","ExampleScenario.actor.type":"code","ExampleScenario.contact":"ContactDetail","ExampleScenario.contained":"Resource","ExampleScenario.copyright":"markdown","ExampleScenario.date":"dateTime","ExampleScenario.experimental":"boolean","ExampleScenario.extension":"Extension","ExampleScenario.id":"System.String","ExampleScenario.identifier":"Identifier","ExampleScenario.implicitRules":"uri","ExampleScenario.instance":"BackboneElement","ExampleScenario.instance.containedInstance":"BackboneElement","ExampleScenario.instance.containedInstance.extension":"Extension","ExampleScenario.instance.containedInstance.id":"System.String","ExampleScenario.instance.containedInstance.modifierExtension":"Extension","ExampleScenario.instance.containedInstance.resourceId":"string","ExampleScenario.instance.containedInstance.versionId":"string","ExampleScenario.instance.description":"markdown","ExampleScenario.instance.extension":"Extension","ExampleScenario.instance.id":"System.String","ExampleScenario.instance.modifierExtension":"Extension","ExampleScenario.instance.name":"string","ExampleScenario.instance.resourceId":"string","ExampleScenario.instance.resourceType":"code","ExampleScenario.instance.version":"BackboneElement","ExampleScenario.instance.version.description":"markdown","ExampleScenario.instance.version.extension":"Extension","ExampleScenario.instance.version.id":"System.String","ExampleScenario.instance.version.modifierExtension":"Extension","ExampleScenario.instance.version.versionId":"string","ExampleScenario.jurisdiction":"CodeableConcept","ExampleScenario.language":"code","ExampleScenario.meta":"Meta","ExampleScenario.modifierExtension":"Extension","ExampleScenario.name":"string","ExampleScenario.process":"BackboneElement","ExampleScenario.process.description":"markdown","ExampleScenario.process.extension":"Extension","ExampleScenario.process.id":"System.String","ExampleScenario.process.modifierExtension":"Extension","ExampleScenario.process.postConditions":"markdown","ExampleScenario.process.preConditions":"markdown","ExampleScenario.process.step":"BackboneElement","ExampleScenario.process.step.alternative":"BackboneElement","ExampleScenario.process.step.alternative.description":"markdown","ExampleScenario.process.step.alternative.extension":"Extension","ExampleScenario.process.step.alternative.id":"System.String","ExampleScenario.process.step.alternative.modifierExtension":"Extension","ExampleScenario.process.step.alternative.title":"string","ExampleScenario.process.step.extension":"Extension","ExampleScenario.process.step.id":"System.String","ExampleScenario.process.step.modifierExtension":"Extension","ExampleScenario.process.step.operation":"BackboneElement","ExampleScenario.process.step.operation.description":"markdown","ExampleScenario.process.step.operation.extension":"Extension","ExampleScenario.process.step.operation.id":"System.String","ExampleScenario.process.step.operation.initiator":"string","ExampleScenario.process.step.operation.initiatorActive":"boolean","ExampleScenario.process.step.operation.modifierExtension":"Extension","ExampleScenario.process.step.operation.name":"string","ExampleScenario.process.step.operation.number":"string","ExampleScenario.process.step.operation.receiver":"string","ExampleScenario.process.step.operation.receiverActive":"boolean","ExampleScenario.process.step.operation.type":"string","ExampleScenario.process.step.pause":"boolean","ExampleScenario.process.title":"string","ExampleScenario.publisher":"string","ExampleScenario.purpose":"markdown","ExampleScenario.status":"code","ExampleScenario.text":"Narrative","ExampleScenario.url":"uri","ExampleScenario.useContext":"UsageContext","ExampleScenario.version":"string","ExampleScenario.workflow":"canonical","ExplanationOfBenefit.accident":"BackboneElement","ExplanationOfBenefit.accident.date":"date","ExplanationOfBenefit.accident.extension":"Extension","ExplanationOfBenefit.accident.id":"System.String","ExplanationOfBenefit.accident.locationAddress":"Address","ExplanationOfBenefit.accident.locationReference":"Reference","ExplanationOfBenefit.accident.modifierExtension":"Extension","ExplanationOfBenefit.accident.type":"CodeableConcept","ExplanationOfBenefit.addItem":"BackboneElement","ExplanationOfBenefit.addItem.bodySite":"CodeableConcept","ExplanationOfBenefit.addItem.detail":"BackboneElement","ExplanationOfBenefit.addItem.detail.extension":"Extension","ExplanationOfBenefit.addItem.detail.factor":"decimal","ExplanationOfBenefit.addItem.detail.id":"System.String","ExplanationOfBenefit.addItem.detail.modifier":"CodeableConcept","ExplanationOfBenefit.addItem.detail.modifierExtension":"Extension","ExplanationOfBenefit.addItem.detail.net":"Money","ExplanationOfBenefit.addItem.detail.noteNumber":"positiveInt","ExplanationOfBenefit.addItem.detail.productOrService":"CodeableConcept","ExplanationOfBenefit.addItem.detail.quantity":"Quantity","ExplanationOfBenefit.addItem.detail.subDetail":"BackboneElement","ExplanationOfBenefit.addItem.detail.subDetail.extension":"Extension","ExplanationOfBenefit.addItem.detail.subDetail.factor":"decimal","ExplanationOfBenefit.addItem.detail.subDetail.id":"System.String","ExplanationOfBenefit.addItem.detail.subDetail.modifier":"CodeableConcept","ExplanationOfBenefit.addItem.detail.subDetail.modifierExtension":"Extension","ExplanationOfBenefit.addItem.detail.subDetail.net":"Money","ExplanationOfBenefit.addItem.detail.subDetail.noteNumber":"positiveInt","ExplanationOfBenefit.addItem.detail.subDetail.productOrService":"CodeableConcept","ExplanationOfBenefit.addItem.detail.subDetail.quantity":"Quantity","ExplanationOfBenefit.addItem.detail.subDetail.unitPrice":"Money","ExplanationOfBenefit.addItem.detail.unitPrice":"Money","ExplanationOfBenefit.addItem.detailSequence":"positiveInt","ExplanationOfBenefit.addItem.extension":"Extension","ExplanationOfBenefit.addItem.factor":"decimal","ExplanationOfBenefit.addItem.id":"System.String","ExplanationOfBenefit.addItem.itemSequence":"positiveInt","ExplanationOfBenefit.addItem.locationAddress":"Address","ExplanationOfBenefit.addItem.locationCodeableConcept":"CodeableConcept","ExplanationOfBenefit.addItem.locationReference":"Reference","ExplanationOfBenefit.addItem.modifier":"CodeableConcept","ExplanationOfBenefit.addItem.modifierExtension":"Extension","ExplanationOfBenefit.addItem.net":"Money","ExplanationOfBenefit.addItem.noteNumber":"positiveInt","ExplanationOfBenefit.addItem.productOrService":"CodeableConcept","ExplanationOfBenefit.addItem.programCode":"CodeableConcept","ExplanationOfBenefit.addItem.provider":"Reference","ExplanationOfBenefit.addItem.quantity":"Quantity","ExplanationOfBenefit.addItem.servicedDate":"date","ExplanationOfBenefit.addItem.servicedPeriod":"Period","ExplanationOfBenefit.addItem.subDetailSequence":"positiveInt","ExplanationOfBenefit.addItem.subSite":"CodeableConcept","ExplanationOfBenefit.addItem.unitPrice":"Money","ExplanationOfBenefit.benefitBalance":"BackboneElement","ExplanationOfBenefit.benefitBalance.category":"CodeableConcept","ExplanationOfBenefit.benefitBalance.description":"string","ExplanationOfBenefit.benefitBalance.excluded":"boolean","ExplanationOfBenefit.benefitBalance.extension":"Extension","ExplanationOfBenefit.benefitBalance.financial":"BackboneElement","ExplanationOfBenefit.benefitBalance.financial.allowedMoney":"Money","ExplanationOfBenefit.benefitBalance.financial.allowedString":"string","ExplanationOfBenefit.benefitBalance.financial.allowedUnsignedInt":"unsignedInt","ExplanationOfBenefit.benefitBalance.financial.extension":"Extension","ExplanationOfBenefit.benefitBalance.financial.id":"System.String","ExplanationOfBenefit.benefitBalance.financial.modifierExtension":"Extension","ExplanationOfBenefit.benefitBalance.financial.type":"CodeableConcept","ExplanationOfBenefit.benefitBalance.financial.usedMoney":"Money","ExplanationOfBenefit.benefitBalance.financial.usedUnsignedInt":"unsignedInt","ExplanationOfBenefit.benefitBalance.id":"System.String","ExplanationOfBenefit.benefitBalance.modifierExtension":"Extension","ExplanationOfBenefit.benefitBalance.name":"string","ExplanationOfBenefit.benefitBalance.network":"CodeableConcept","ExplanationOfBenefit.benefitBalance.term":"CodeableConcept","ExplanationOfBenefit.benefitBalance.unit":"CodeableConcept","ExplanationOfBenefit.benefitPeriod":"Period","ExplanationOfBenefit.billablePeriod":"Period","ExplanationOfBenefit.careTeam":"BackboneElement","ExplanationOfBenefit.careTeam.extension":"Extension","ExplanationOfBenefit.careTeam.id":"System.String","ExplanationOfBenefit.careTeam.modifierExtension":"Extension","ExplanationOfBenefit.careTeam.provider":"Reference","ExplanationOfBenefit.careTeam.qualification":"CodeableConcept","ExplanationOfBenefit.careTeam.responsible":"boolean","ExplanationOfBenefit.careTeam.role":"CodeableConcept","ExplanationOfBenefit.careTeam.sequence":"positiveInt","ExplanationOfBenefit.claim":"Reference","ExplanationOfBenefit.claimResponse":"Reference","ExplanationOfBenefit.contained":"Resource","ExplanationOfBenefit.created":"dateTime","ExplanationOfBenefit.diagnosis":"BackboneElement","ExplanationOfBenefit.diagnosis.diagnosisCodeableConcept":"CodeableConcept","ExplanationOfBenefit.diagnosis.diagnosisReference":"Reference","ExplanationOfBenefit.diagnosis.extension":"Extension","ExplanationOfBenefit.diagnosis.id":"System.String","ExplanationOfBenefit.diagnosis.modifierExtension":"Extension","ExplanationOfBenefit.diagnosis.onAdmission":"CodeableConcept","ExplanationOfBenefit.diagnosis.packageCode":"CodeableConcept","ExplanationOfBenefit.diagnosis.sequence":"positiveInt","ExplanationOfBenefit.diagnosis.type":"CodeableConcept","ExplanationOfBenefit.disposition":"string","ExplanationOfBenefit.enterer":"Reference","ExplanationOfBenefit.extension":"Extension","ExplanationOfBenefit.facility":"Reference","ExplanationOfBenefit.form":"Attachment","ExplanationOfBenefit.formCode":"CodeableConcept","ExplanationOfBenefit.fundsReserve":"CodeableConcept","ExplanationOfBenefit.fundsReserveRequested":"CodeableConcept","ExplanationOfBenefit.id":"System.String","ExplanationOfBenefit.identifier":"Identifier","ExplanationOfBenefit.implicitRules":"uri","ExplanationOfBenefit.insurance":"BackboneElement","ExplanationOfBenefit.insurance.coverage":"Reference","ExplanationOfBenefit.insurance.extension":"Extension","ExplanationOfBenefit.insurance.focal":"boolean","ExplanationOfBenefit.insurance.id":"System.String","ExplanationOfBenefit.insurance.modifierExtension":"Extension","ExplanationOfBenefit.insurance.preAuthRef":"string","ExplanationOfBenefit.insurer":"Reference","ExplanationOfBenefit.item":"BackboneElement","ExplanationOfBenefit.item.adjudication":"BackboneElement","ExplanationOfBenefit.item.adjudication.amount":"Money","ExplanationOfBenefit.item.adjudication.category":"CodeableConcept","ExplanationOfBenefit.item.adjudication.extension":"Extension","ExplanationOfBenefit.item.adjudication.id":"System.String","ExplanationOfBenefit.item.adjudication.modifierExtension":"Extension","ExplanationOfBenefit.item.adjudication.reason":"CodeableConcept","ExplanationOfBenefit.item.adjudication.value":"decimal","ExplanationOfBenefit.item.bodySite":"CodeableConcept","ExplanationOfBenefit.item.careTeamSequence":"positiveInt","ExplanationOfBenefit.item.category":"CodeableConcept","ExplanationOfBenefit.item.detail":"BackboneElement","ExplanationOfBenefit.item.detail.category":"CodeableConcept","ExplanationOfBenefit.item.detail.extension":"Extension","ExplanationOfBenefit.item.detail.factor":"decimal","ExplanationOfBenefit.item.detail.id":"System.String","ExplanationOfBenefit.item.detail.modifier":"CodeableConcept","ExplanationOfBenefit.item.detail.modifierExtension":"Extension","ExplanationOfBenefit.item.detail.net":"Money","ExplanationOfBenefit.item.detail.noteNumber":"positiveInt","ExplanationOfBenefit.item.detail.productOrService":"CodeableConcept","ExplanationOfBenefit.item.detail.programCode":"CodeableConcept","ExplanationOfBenefit.item.detail.quantity":"Quantity","ExplanationOfBenefit.item.detail.revenue":"CodeableConcept","ExplanationOfBenefit.item.detail.sequence":"positiveInt","ExplanationOfBenefit.item.detail.subDetail":"BackboneElement","ExplanationOfBenefit.item.detail.subDetail.category":"CodeableConcept","ExplanationOfBenefit.item.detail.subDetail.extension":"Extension","ExplanationOfBenefit.item.detail.subDetail.factor":"decimal","ExplanationOfBenefit.item.detail.subDetail.id":"System.String","ExplanationOfBenefit.item.detail.subDetail.modifier":"CodeableConcept","ExplanationOfBenefit.item.detail.subDetail.modifierExtension":"Extension","ExplanationOfBenefit.item.detail.subDetail.net":"Money","ExplanationOfBenefit.item.detail.subDetail.noteNumber":"positiveInt","ExplanationOfBenefit.item.detail.subDetail.productOrService":"CodeableConcept","ExplanationOfBenefit.item.detail.subDetail.programCode":"CodeableConcept","ExplanationOfBenefit.item.detail.subDetail.quantity":"Quantity","ExplanationOfBenefit.item.detail.subDetail.revenue":"CodeableConcept","ExplanationOfBenefit.item.detail.subDetail.sequence":"positiveInt","ExplanationOfBenefit.item.detail.subDetail.udi":"Reference","ExplanationOfBenefit.item.detail.subDetail.unitPrice":"Money","ExplanationOfBenefit.item.detail.udi":"Reference","ExplanationOfBenefit.item.detail.unitPrice":"Money","ExplanationOfBenefit.item.diagnosisSequence":"positiveInt","ExplanationOfBenefit.item.encounter":"Reference","ExplanationOfBenefit.item.extension":"Extension","ExplanationOfBenefit.item.factor":"decimal","ExplanationOfBenefit.item.id":"System.String","ExplanationOfBenefit.item.informationSequence":"positiveInt","ExplanationOfBenefit.item.locationAddress":"Address","ExplanationOfBenefit.item.locationCodeableConcept":"CodeableConcept","ExplanationOfBenefit.item.locationReference":"Reference","ExplanationOfBenefit.item.modifier":"CodeableConcept","ExplanationOfBenefit.item.modifierExtension":"Extension","ExplanationOfBenefit.item.net":"Money","ExplanationOfBenefit.item.noteNumber":"positiveInt","ExplanationOfBenefit.item.procedureSequence":"positiveInt","ExplanationOfBenefit.item.productOrService":"CodeableConcept","ExplanationOfBenefit.item.programCode":"CodeableConcept","ExplanationOfBenefit.item.quantity":"Quantity","ExplanationOfBenefit.item.revenue":"CodeableConcept","ExplanationOfBenefit.item.sequence":"positiveInt","ExplanationOfBenefit.item.servicedDate":"date","ExplanationOfBenefit.item.servicedPeriod":"Period","ExplanationOfBenefit.item.subSite":"CodeableConcept","ExplanationOfBenefit.item.udi":"Reference","ExplanationOfBenefit.item.unitPrice":"Money","ExplanationOfBenefit.language":"code","ExplanationOfBenefit.meta":"Meta","ExplanationOfBenefit.modifierExtension":"Extension","ExplanationOfBenefit.originalPrescription":"Reference","ExplanationOfBenefit.outcome":"code","ExplanationOfBenefit.patient":"Reference","ExplanationOfBenefit.payee":"BackboneElement","ExplanationOfBenefit.payee.extension":"Extension","ExplanationOfBenefit.payee.id":"System.String","ExplanationOfBenefit.payee.modifierExtension":"Extension","ExplanationOfBenefit.payee.party":"Reference","ExplanationOfBenefit.payee.type":"CodeableConcept","ExplanationOfBenefit.payment":"BackboneElement","ExplanationOfBenefit.payment.adjustment":"Money","ExplanationOfBenefit.payment.adjustmentReason":"CodeableConcept","ExplanationOfBenefit.payment.amount":"Money","ExplanationOfBenefit.payment.date":"date","ExplanationOfBenefit.payment.extension":"Extension","ExplanationOfBenefit.payment.id":"System.String","ExplanationOfBenefit.payment.identifier":"Identifier","ExplanationOfBenefit.payment.modifierExtension":"Extension","ExplanationOfBenefit.payment.type":"CodeableConcept","ExplanationOfBenefit.preAuthRef":"string","ExplanationOfBenefit.preAuthRefPeriod":"Period","ExplanationOfBenefit.precedence":"positiveInt","ExplanationOfBenefit.prescription":"Reference","ExplanationOfBenefit.priority":"CodeableConcept","ExplanationOfBenefit.procedure":"BackboneElement","ExplanationOfBenefit.procedure.date":"dateTime","ExplanationOfBenefit.procedure.extension":"Extension","ExplanationOfBenefit.procedure.id":"System.String","ExplanationOfBenefit.procedure.modifierExtension":"Extension","ExplanationOfBenefit.procedure.procedureCodeableConcept":"CodeableConcept","ExplanationOfBenefit.procedure.procedureReference":"Reference","ExplanationOfBenefit.procedure.sequence":"positiveInt","ExplanationOfBenefit.procedure.type":"CodeableConcept","ExplanationOfBenefit.procedure.udi":"Reference","ExplanationOfBenefit.processNote":"BackboneElement","ExplanationOfBenefit.processNote.extension":"Extension","ExplanationOfBenefit.processNote.id":"System.String","ExplanationOfBenefit.processNote.language":"CodeableConcept","ExplanationOfBenefit.processNote.modifierExtension":"Extension","ExplanationOfBenefit.processNote.number":"positiveInt","ExplanationOfBenefit.processNote.text":"string","ExplanationOfBenefit.processNote.type":"code","ExplanationOfBenefit.provider":"Reference","ExplanationOfBenefit.referral":"Reference","ExplanationOfBenefit.related":"BackboneElement","ExplanationOfBenefit.related.claim":"Reference","ExplanationOfBenefit.related.extension":"Extension","ExplanationOfBenefit.related.id":"System.String","ExplanationOfBenefit.related.modifierExtension":"Extension","ExplanationOfBenefit.related.reference":"Identifier","ExplanationOfBenefit.related.relationship":"CodeableConcept","ExplanationOfBenefit.status":"code","ExplanationOfBenefit.subType":"CodeableConcept","ExplanationOfBenefit.supportingInfo":"BackboneElement","ExplanationOfBenefit.supportingInfo.category":"CodeableConcept","ExplanationOfBenefit.supportingInfo.code":"CodeableConcept","ExplanationOfBenefit.supportingInfo.extension":"Extension","ExplanationOfBenefit.supportingInfo.id":"System.String","ExplanationOfBenefit.supportingInfo.modifierExtension":"Extension","ExplanationOfBenefit.supportingInfo.reason":"Coding","ExplanationOfBenefit.supportingInfo.sequence":"positiveInt","ExplanationOfBenefit.supportingInfo.timingDate":"date","ExplanationOfBenefit.supportingInfo.timingPeriod":"Period","ExplanationOfBenefit.supportingInfo.valueAttachment":"Attachment","ExplanationOfBenefit.supportingInfo.valueBoolean":"boolean","ExplanationOfBenefit.supportingInfo.valueQuantity":"Quantity","ExplanationOfBenefit.supportingInfo.valueReference":"Reference","ExplanationOfBenefit.supportingInfo.valueString":"string","ExplanationOfBenefit.text":"Narrative","ExplanationOfBenefit.total":"BackboneElement","ExplanationOfBenefit.total.amount":"Money","ExplanationOfBenefit.total.category":"CodeableConcept","ExplanationOfBenefit.total.extension":"Extension","ExplanationOfBenefit.total.id":"System.String","ExplanationOfBenefit.total.modifierExtension":"Extension","ExplanationOfBenefit.type":"CodeableConcept","ExplanationOfBenefit.use":"code","Expression.description":"string","Expression.expression":"string","Expression.extension":"Extension","Expression.id":"System.String","Expression.language":"code","Expression.name":"id","Expression.reference":"uri","Extension.extension":"Extension","Extension.id":"System.String","Extension.url":"System.String","Extension.valueAddress":"Address","Extension.valueAge":"Age","Extension.valueAnnotation":"Annotation","Extension.valueAttachment":"Attachment","Extension.valueBase64Binary":"base64Binary","Extension.valueBoolean":"boolean","Extension.valueCanonical":"canonical","Extension.valueCode":"code","Extension.valueCodeableConcept":"CodeableConcept","Extension.valueCoding":"Coding","Extension.valueContactDetail":"ContactDetail","Extension.valueContactPoint":"ContactPoint","Extension.valueContributor":"Contributor","Extension.valueCount":"Count","Extension.valueDataRequirement":"DataRequirement","Extension.valueDate":"date","Extension.valueDateTime":"dateTime","Extension.valueDecimal":"decimal","Extension.valueDistance":"Distance","Extension.valueDosage":"Dosage","Extension.valueDuration":"Duration","Extension.valueExpression":"Expression","Extension.valueHumanName":"HumanName","Extension.valueId":"id","Extension.valueIdentifier":"Identifier","Extension.valueInstant":"instant","Extension.valueInteger":"integer","Extension.valueMarkdown":"markdown","Extension.valueMeta":"Meta","Extension.valueMoney":"Money","Extension.valueOid":"oid","Extension.valueParameterDefinition":"ParameterDefinition","Extension.valuePeriod":"Period","Extension.valuePositiveInt":"positiveInt","Extension.valueQuantity":"Quantity","Extension.valueRange":"Range","Extension.valueRatio":"Ratio","Extension.valueReference":"Reference","Extension.valueRelatedArtifact":"RelatedArtifact","Extension.valueSampledData":"SampledData","Extension.valueSignature":"Signature","Extension.valueString":"string","Extension.valueTime":"time","Extension.valueTiming":"Timing","Extension.valueTriggerDefinition":"TriggerDefinition","Extension.valueUnsignedInt":"unsignedInt","Extension.valueUri":"uri","Extension.valueUrl":"url","Extension.valueUsageContext":"UsageContext","Extension.valueUuid":"uuid","FamilyMemberHistory.ageAge":"Age","FamilyMemberHistory.ageRange":"Range","FamilyMemberHistory.ageString":"string","FamilyMemberHistory.bornDate":"date","FamilyMemberHistory.bornPeriod":"Period","FamilyMemberHistory.bornString":"string","FamilyMemberHistory.condition":"BackboneElement","FamilyMemberHistory.condition.code":"CodeableConcept","FamilyMemberHistory.condition.contributedToDeath":"boolean","FamilyMemberHistory.condition.extension":"Extension","FamilyMemberHistory.condition.id":"System.String","FamilyMemberHistory.condition.modifierExtension":"Extension","FamilyMemberHistory.condition.note":"Annotation","FamilyMemberHistory.condition.onsetAge":"Age","FamilyMemberHistory.condition.onsetPeriod":"Period","FamilyMemberHistory.condition.onsetRange":"Range","FamilyMemberHistory.condition.onsetString":"string","FamilyMemberHistory.condition.outcome":"CodeableConcept","FamilyMemberHistory.contained":"Resource","FamilyMemberHistory.dataAbsentReason":"CodeableConcept","FamilyMemberHistory.date":"dateTime","FamilyMemberHistory.deceasedAge":"Age","FamilyMemberHistory.deceasedBoolean":"boolean","FamilyMemberHistory.deceasedDate":"date","FamilyMemberHistory.deceasedRange":"Range","FamilyMemberHistory.deceasedString":"string","FamilyMemberHistory.estimatedAge":"boolean","FamilyMemberHistory.extension":"Extension","FamilyMemberHistory.id":"System.String","FamilyMemberHistory.identifier":"Identifier","FamilyMemberHistory.implicitRules":"uri","FamilyMemberHistory.instantiatesCanonical":"canonical","FamilyMemberHistory.instantiatesUri":"uri","FamilyMemberHistory.language":"code","FamilyMemberHistory.meta":"Meta","FamilyMemberHistory.modifierExtension":"Extension","FamilyMemberHistory.name":"string","FamilyMemberHistory.note":"Annotation","FamilyMemberHistory.patient":"Reference","FamilyMemberHistory.reasonCode":"CodeableConcept","FamilyMemberHistory.reasonReference":"Reference","FamilyMemberHistory.relationship":"CodeableConcept","FamilyMemberHistory.sex":"CodeableConcept","FamilyMemberHistory.status":"code","FamilyMemberHistory.text":"Narrative","Flag.author":"Reference","Flag.category":"CodeableConcept","Flag.code":"CodeableConcept","Flag.contained":"Resource","Flag.encounter":"Reference","Flag.extension":"Extension","Flag.id":"System.String","Flag.identifier":"Identifier","Flag.implicitRules":"uri","Flag.language":"code","Flag.meta":"Meta","Flag.modifierExtension":"Extension","Flag.period":"Period","Flag.status":"code","Flag.subject":"Reference","Flag.text":"Narrative","Goal.achievementStatus":"CodeableConcept","Goal.addresses":"Reference","Goal.category":"CodeableConcept","Goal.contained":"Resource","Goal.description":"CodeableConcept","Goal.expressedBy":"Reference","Goal.extension":"Extension","Goal.id":"System.String","Goal.identifier":"Identifier","Goal.implicitRules":"uri","Goal.language":"code","Goal.lifecycleStatus":"code","Goal.meta":"Meta","Goal.modifierExtension":"Extension","Goal.note":"Annotation","Goal.outcomeCode":"CodeableConcept","Goal.outcomeReference":"Reference","Goal.priority":"CodeableConcept","Goal.startCodeableConcept":"CodeableConcept","Goal.startDate":"date","Goal.statusDate":"date","Goal.statusReason":"string","Goal.subject":"Reference","Goal.target":"BackboneElement","Goal.target.detailBoolean":"boolean","Goal.target.detailCodeableConcept":"CodeableConcept","Goal.target.detailInteger":"integer","Goal.target.detailQuantity":"Quantity","Goal.target.detailRange":"Range","Goal.target.detailRatio":"Ratio","Goal.target.detailString":"string","Goal.target.dueDate":"date","Goal.target.dueDuration":"Duration","Goal.target.extension":"Extension","Goal.target.id":"System.String","Goal.target.measure":"CodeableConcept","Goal.target.modifierExtension":"Extension","Goal.text":"Narrative","GraphDefinition.contact":"ContactDetail","GraphDefinition.contained":"Resource","GraphDefinition.date":"dateTime","GraphDefinition.description":"markdown","GraphDefinition.experimental":"boolean","GraphDefinition.extension":"Extension","GraphDefinition.id":"System.String","GraphDefinition.implicitRules":"uri","GraphDefinition.jurisdiction":"CodeableConcept","GraphDefinition.language":"code","GraphDefinition.link":"BackboneElement","GraphDefinition.link.description":"string","GraphDefinition.link.extension":"Extension","GraphDefinition.link.id":"System.String","GraphDefinition.link.max":"string","GraphDefinition.link.min":"integer","GraphDefinition.link.modifierExtension":"Extension","GraphDefinition.link.path":"string","GraphDefinition.link.sliceName":"string","GraphDefinition.link.target":"BackboneElement","GraphDefinition.link.target.compartment":"BackboneElement","GraphDefinition.link.target.compartment.code":"code","GraphDefinition.link.target.compartment.description":"string","GraphDefinition.link.target.compartment.expression":"string","GraphDefinition.link.target.compartment.extension":"Extension","GraphDefinition.link.target.compartment.id":"System.String","GraphDefinition.link.target.compartment.modifierExtension":"Extension","GraphDefinition.link.target.compartment.rule":"code","GraphDefinition.link.target.compartment.use":"code","GraphDefinition.link.target.extension":"Extension","GraphDefinition.link.target.id":"System.String","GraphDefinition.link.target.modifierExtension":"Extension","GraphDefinition.link.target.params":"string","GraphDefinition.link.target.profile":"canonical","GraphDefinition.link.target.type":"code","GraphDefinition.meta":"Meta","GraphDefinition.modifierExtension":"Extension","GraphDefinition.name":"string","GraphDefinition.profile":"canonical","GraphDefinition.publisher":"string","GraphDefinition.purpose":"markdown","GraphDefinition.start":"code","GraphDefinition.status":"code","GraphDefinition.text":"Narrative","GraphDefinition.url":"uri","GraphDefinition.useContext":"UsageContext","GraphDefinition.version":"string","Group.active":"boolean","Group.actual":"boolean","Group.characteristic":"BackboneElement","Group.characteristic.code":"CodeableConcept","Group.characteristic.exclude":"boolean","Group.characteristic.extension":"Extension","Group.characteristic.id":"System.String","Group.characteristic.modifierExtension":"Extension","Group.characteristic.period":"Period","Group.characteristic.valueBoolean":"boolean","Group.characteristic.valueCodeableConcept":"CodeableConcept","Group.characteristic.valueQuantity":"Quantity","Group.characteristic.valueRange":"Range","Group.characteristic.valueReference":"Reference","Group.code":"CodeableConcept","Group.contained":"Resource","Group.extension":"Extension","Group.id":"System.String","Group.identifier":"Identifier","Group.implicitRules":"uri","Group.language":"code","Group.managingEntity":"Reference","Group.member":"BackboneElement","Group.member.entity":"Reference","Group.member.extension":"Extension","Group.member.id":"System.String","Group.member.inactive":"boolean","Group.member.modifierExtension":"Extension","Group.member.period":"Period","Group.meta":"Meta","Group.modifierExtension":"Extension","Group.name":"string","Group.quantity":"unsignedInt","Group.text":"Narrative","Group.type":"code","GuidanceResponse.contained":"Resource","GuidanceResponse.dataRequirement":"DataRequirement","GuidanceResponse.encounter":"Reference","GuidanceResponse.evaluationMessage":"Reference","GuidanceResponse.extension":"Extension","GuidanceResponse.id":"System.String","GuidanceResponse.identifier":"Identifier","GuidanceResponse.implicitRules":"uri","GuidanceResponse.language":"code","GuidanceResponse.meta":"Meta","GuidanceResponse.modifierExtension":"Extension","GuidanceResponse.moduleCanonical":"canonical","GuidanceResponse.moduleCodeableConcept":"CodeableConcept","GuidanceResponse.moduleUri":"uri","GuidanceResponse.note":"Annotation","GuidanceResponse.occurrenceDateTime":"dateTime","GuidanceResponse.outputParameters":"Reference","GuidanceResponse.performer":"Reference","GuidanceResponse.reasonCode":"CodeableConcept","GuidanceResponse.reasonReference":"Reference","GuidanceResponse.requestIdentifier":"Identifier","GuidanceResponse.result":"Reference","GuidanceResponse.status":"code","GuidanceResponse.subject":"Reference","GuidanceResponse.text":"Narrative","HealthcareService.active":"boolean","HealthcareService.appointmentRequired":"boolean","HealthcareService.availabilityExceptions":"string","HealthcareService.availableTime":"BackboneElement","HealthcareService.availableTime.allDay":"boolean","HealthcareService.availableTime.availableEndTime":"time","HealthcareService.availableTime.availableStartTime":"time","HealthcareService.availableTime.daysOfWeek":"code","HealthcareService.availableTime.extension":"Extension","HealthcareService.availableTime.id":"System.String","HealthcareService.availableTime.modifierExtension":"Extension","HealthcareService.category":"CodeableConcept","HealthcareService.characteristic":"CodeableConcept","HealthcareService.comment":"string","HealthcareService.communication":"CodeableConcept","HealthcareService.contained":"Resource","HealthcareService.coverageArea":"Reference","HealthcareService.eligibility":"BackboneElement","HealthcareService.eligibility.code":"CodeableConcept","HealthcareService.eligibility.comment":"markdown","HealthcareService.eligibility.extension":"Extension","HealthcareService.eligibility.id":"System.String","HealthcareService.eligibility.modifierExtension":"Extension","HealthcareService.endpoint":"Reference","HealthcareService.extension":"Extension","HealthcareService.extraDetails":"markdown","HealthcareService.id":"System.String","HealthcareService.identifier":"Identifier","HealthcareService.implicitRules":"uri","HealthcareService.language":"code","HealthcareService.location":"Reference","HealthcareService.meta":"Meta","HealthcareService.modifierExtension":"Extension","HealthcareService.name":"string","HealthcareService.notAvailable":"BackboneElement","HealthcareService.notAvailable.description":"string","HealthcareService.notAvailable.during":"Period","HealthcareService.notAvailable.extension":"Extension","HealthcareService.notAvailable.id":"System.String","HealthcareService.notAvailable.modifierExtension":"Extension","HealthcareService.photo":"Attachment","HealthcareService.program":"CodeableConcept","HealthcareService.providedBy":"Reference","HealthcareService.referralMethod":"CodeableConcept","HealthcareService.serviceProvisionCode":"CodeableConcept","HealthcareService.specialty":"CodeableConcept","HealthcareService.telecom":"ContactPoint","HealthcareService.text":"Narrative","HealthcareService.type":"CodeableConcept","HumanName.extension":"Extension","HumanName.family":"string","HumanName.given":"string","HumanName.id":"System.String","HumanName.period":"Period","HumanName.prefix":"string","HumanName.suffix":"string","HumanName.text":"string","HumanName.use":"code","Identifier.assigner":"Reference","Identifier.extension":"Extension","Identifier.id":"System.String","Identifier.period":"Period","Identifier.system":"uri","Identifier.type":"CodeableConcept","Identifier.use":"code","Identifier.value":"string","ImagingStudy.basedOn":"Reference","ImagingStudy.contained":"Resource","ImagingStudy.description":"string","ImagingStudy.encounter":"Reference","ImagingStudy.endpoint":"Reference","ImagingStudy.extension":"Extension","ImagingStudy.id":"System.String","ImagingStudy.identifier":"Identifier","ImagingStudy.implicitRules":"uri","ImagingStudy.interpreter":"Reference","ImagingStudy.language":"code","ImagingStudy.location":"Reference","ImagingStudy.meta":"Meta","ImagingStudy.modality":"Coding","ImagingStudy.modifierExtension":"Extension","ImagingStudy.note":"Annotation","ImagingStudy.numberOfInstances":"unsignedInt","ImagingStudy.numberOfSeries":"unsignedInt","ImagingStudy.procedureCode":"CodeableConcept","ImagingStudy.procedureReference":"Reference","ImagingStudy.reasonCode":"CodeableConcept","ImagingStudy.reasonReference":"Reference","ImagingStudy.referrer":"Reference","ImagingStudy.series":"BackboneElement","ImagingStudy.series.bodySite":"Coding","ImagingStudy.series.description":"string","ImagingStudy.series.endpoint":"Reference","ImagingStudy.series.extension":"Extension","ImagingStudy.series.id":"System.String","ImagingStudy.series.instance":"BackboneElement","ImagingStudy.series.instance.extension":"Extension","ImagingStudy.series.instance.id":"System.String","ImagingStudy.series.instance.modifierExtension":"Extension","ImagingStudy.series.instance.number":"unsignedInt","ImagingStudy.series.instance.sopClass":"Coding","ImagingStudy.series.instance.title":"string","ImagingStudy.series.instance.uid":"id","ImagingStudy.series.laterality":"Coding","ImagingStudy.series.modality":"Coding","ImagingStudy.series.modifierExtension":"Extension","ImagingStudy.series.number":"unsignedInt","ImagingStudy.series.numberOfInstances":"unsignedInt","ImagingStudy.series.performer":"BackboneElement","ImagingStudy.series.performer.actor":"Reference","ImagingStudy.series.performer.extension":"Extension","ImagingStudy.series.performer.function":"CodeableConcept","ImagingStudy.series.performer.id":"System.String","ImagingStudy.series.performer.modifierExtension":"Extension","ImagingStudy.series.specimen":"Reference","ImagingStudy.series.started":"dateTime","ImagingStudy.series.uid":"id","ImagingStudy.started":"dateTime","ImagingStudy.status":"code","ImagingStudy.subject":"Reference","ImagingStudy.text":"Narrative","Immunization.contained":"Resource","Immunization.doseQuantity":"Quantity","Immunization.education":"BackboneElement","Immunization.education.documentType":"string","Immunization.education.extension":"Extension","Immunization.education.id":"System.String","Immunization.education.modifierExtension":"Extension","Immunization.education.presentationDate":"dateTime","Immunization.education.publicationDate":"dateTime","Immunization.education.reference":"uri","Immunization.encounter":"Reference","Immunization.expirationDate":"date","Immunization.extension":"Extension","Immunization.fundingSource":"CodeableConcept","Immunization.id":"System.String","Immunization.identifier":"Identifier","Immunization.implicitRules":"uri","Immunization.isSubpotent":"boolean","Immunization.language":"code","Immunization.location":"Reference","Immunization.lotNumber":"string","Immunization.manufacturer":"Reference","Immunization.meta":"Meta","Immunization.modifierExtension":"Extension","Immunization.note":"Annotation","Immunization.occurrenceDateTime":"dateTime","Immunization.occurrenceString":"string","Immunization.patient":"Reference","Immunization.performer":"BackboneElement","Immunization.performer.actor":"Reference","Immunization.performer.extension":"Extension","Immunization.performer.function":"CodeableConcept","Immunization.performer.id":"System.String","Immunization.performer.modifierExtension":"Extension","Immunization.primarySource":"boolean","Immunization.programEligibility":"CodeableConcept","Immunization.protocolApplied":"BackboneElement","Immunization.protocolApplied.authority":"Reference","Immunization.protocolApplied.doseNumberPositiveInt":"positiveInt","Immunization.protocolApplied.doseNumberString":"string","Immunization.protocolApplied.extension":"Extension","Immunization.protocolApplied.id":"System.String","Immunization.protocolApplied.modifierExtension":"Extension","Immunization.protocolApplied.series":"string","Immunization.protocolApplied.seriesDosesPositiveInt":"positiveInt","Immunization.protocolApplied.seriesDosesString":"string","Immunization.protocolApplied.targetDisease":"CodeableConcept","Immunization.reaction":"BackboneElement","Immunization.reaction.date":"dateTime","Immunization.reaction.detail":"Reference","Immunization.reaction.extension":"Extension","Immunization.reaction.id":"System.String","Immunization.reaction.modifierExtension":"Extension","Immunization.reaction.reported":"boolean","Immunization.reasonCode":"CodeableConcept","Immunization.reasonReference":"Reference","Immunization.recorded":"dateTime","Immunization.reportOrigin":"CodeableConcept","Immunization.route":"CodeableConcept","Immunization.site":"CodeableConcept","Immunization.status":"code","Immunization.statusReason":"CodeableConcept","Immunization.subpotentReason":"CodeableConcept","Immunization.text":"Narrative","Immunization.vaccineCode":"CodeableConcept","ImmunizationEvaluation.authority":"Reference","ImmunizationEvaluation.contained":"Resource","ImmunizationEvaluation.date":"dateTime","ImmunizationEvaluation.description":"string","ImmunizationEvaluation.doseNumberPositiveInt":"positiveInt","ImmunizationEvaluation.doseNumberString":"string","ImmunizationEvaluation.doseStatus":"CodeableConcept","ImmunizationEvaluation.doseStatusReason":"CodeableConcept","ImmunizationEvaluation.extension":"Extension","ImmunizationEvaluation.id":"System.String","ImmunizationEvaluation.identifier":"Identifier","ImmunizationEvaluation.immunizationEvent":"Reference","ImmunizationEvaluation.implicitRules":"uri","ImmunizationEvaluation.language":"code","ImmunizationEvaluation.meta":"Meta","ImmunizationEvaluation.modifierExtension":"Extension","ImmunizationEvaluation.patient":"Reference","ImmunizationEvaluation.series":"string","ImmunizationEvaluation.seriesDosesPositiveInt":"positiveInt","ImmunizationEvaluation.seriesDosesString":"string","ImmunizationEvaluation.status":"code","ImmunizationEvaluation.targetDisease":"CodeableConcept","ImmunizationEvaluation.text":"Narrative","ImmunizationRecommendation.authority":"Reference","ImmunizationRecommendation.contained":"Resource","ImmunizationRecommendation.date":"dateTime","ImmunizationRecommendation.extension":"Extension","ImmunizationRecommendation.id":"System.String","ImmunizationRecommendation.identifier":"Identifier","ImmunizationRecommendation.implicitRules":"uri","ImmunizationRecommendation.language":"code","ImmunizationRecommendation.meta":"Meta","ImmunizationRecommendation.modifierExtension":"Extension","ImmunizationRecommendation.patient":"Reference","ImmunizationRecommendation.recommendation":"BackboneElement","ImmunizationRecommendation.recommendation.contraindicatedVaccineCode":"CodeableConcept","ImmunizationRecommendation.recommendation.dateCriterion":"BackboneElement","ImmunizationRecommendation.recommendation.dateCriterion.code":"CodeableConcept","ImmunizationRecommendation.recommendation.dateCriterion.extension":"Extension","ImmunizationRecommendation.recommendation.dateCriterion.id":"System.String","ImmunizationRecommendation.recommendation.dateCriterion.modifierExtension":"Extension","ImmunizationRecommendation.recommendation.dateCriterion.value":"dateTime","ImmunizationRecommendation.recommendation.description":"string","ImmunizationRecommendation.recommendation.doseNumberPositiveInt":"positiveInt","ImmunizationRecommendation.recommendation.doseNumberString":"string","ImmunizationRecommendation.recommendation.extension":"Extension","ImmunizationRecommendation.recommendation.forecastReason":"CodeableConcept","ImmunizationRecommendation.recommendation.forecastStatus":"CodeableConcept","ImmunizationRecommendation.recommendation.id":"System.String","ImmunizationRecommendation.recommendation.modifierExtension":"Extension","ImmunizationRecommendation.recommendation.series":"string","ImmunizationRecommendation.recommendation.seriesDosesPositiveInt":"positiveInt","ImmunizationRecommendation.recommendation.seriesDosesString":"string","ImmunizationRecommendation.recommendation.supportingImmunization":"Reference","ImmunizationRecommendation.recommendation.supportingPatientInformation":"Reference","ImmunizationRecommendation.recommendation.targetDisease":"CodeableConcept","ImmunizationRecommendation.recommendation.vaccineCode":"CodeableConcept","ImmunizationRecommendation.text":"Narrative","ImplementationGuide.contact":"ContactDetail","ImplementationGuide.contained":"Resource","ImplementationGuide.copyright":"markdown","ImplementationGuide.date":"dateTime","ImplementationGuide.definition":"BackboneElement","ImplementationGuide.definition.extension":"Extension","ImplementationGuide.definition.grouping":"BackboneElement","ImplementationGuide.definition.grouping.description":"string","ImplementationGuide.definition.grouping.extension":"Extension","ImplementationGuide.definition.grouping.id":"System.String","ImplementationGuide.definition.grouping.modifierExtension":"Extension","ImplementationGuide.definition.grouping.name":"string","ImplementationGuide.definition.id":"System.String","ImplementationGuide.definition.modifierExtension":"Extension","ImplementationGuide.definition.page":"BackboneElement","ImplementationGuide.definition.page.extension":"Extension","ImplementationGuide.definition.page.generation":"code","ImplementationGuide.definition.page.id":"System.String","ImplementationGuide.definition.page.modifierExtension":"Extension","ImplementationGuide.definition.page.nameReference":"Reference","ImplementationGuide.definition.page.nameUrl":"url","ImplementationGuide.definition.page.title":"string","ImplementationGuide.definition.parameter":"BackboneElement","ImplementationGuide.definition.parameter.code":"code","ImplementationGuide.definition.parameter.extension":"Extension","ImplementationGuide.definition.parameter.id":"System.String","ImplementationGuide.definition.parameter.modifierExtension":"Extension","ImplementationGuide.definition.parameter.value":"string","ImplementationGuide.definition.resource":"BackboneElement","ImplementationGuide.definition.resource.description":"string","ImplementationGuide.definition.resource.exampleBoolean":"boolean","ImplementationGuide.definition.resource.exampleCanonical":"canonical","ImplementationGuide.definition.resource.extension":"Extension","ImplementationGuide.definition.resource.fhirVersion":"code","ImplementationGuide.definition.resource.groupingId":"id","ImplementationGuide.definition.resource.id":"System.String","ImplementationGuide.definition.resource.modifierExtension":"Extension","ImplementationGuide.definition.resource.name":"string","ImplementationGuide.definition.resource.reference":"Reference","ImplementationGuide.definition.template":"BackboneElement","ImplementationGuide.definition.template.code":"code","ImplementationGuide.definition.template.extension":"Extension","ImplementationGuide.definition.template.id":"System.String","ImplementationGuide.definition.template.modifierExtension":"Extension","ImplementationGuide.definition.template.scope":"string","ImplementationGuide.definition.template.source":"string","ImplementationGuide.dependsOn":"BackboneElement","ImplementationGuide.dependsOn.extension":"Extension","ImplementationGuide.dependsOn.id":"System.String","ImplementationGuide.dependsOn.modifierExtension":"Extension","ImplementationGuide.dependsOn.packageId":"id","ImplementationGuide.dependsOn.uri":"canonical","ImplementationGuide.dependsOn.version":"string","ImplementationGuide.description":"markdown","ImplementationGuide.experimental":"boolean","ImplementationGuide.extension":"Extension","ImplementationGuide.fhirVersion":"code","ImplementationGuide.global":"BackboneElement","ImplementationGuide.global.extension":"Extension","ImplementationGuide.global.id":"System.String","ImplementationGuide.global.modifierExtension":"Extension","ImplementationGuide.global.profile":"canonical","ImplementationGuide.global.type":"code","ImplementationGuide.id":"System.String","ImplementationGuide.implicitRules":"uri","ImplementationGuide.jurisdiction":"CodeableConcept","ImplementationGuide.language":"code","ImplementationGuide.license":"code","ImplementationGuide.manifest":"BackboneElement","ImplementationGuide.manifest.extension":"Extension","ImplementationGuide.manifest.id":"System.String","ImplementationGuide.manifest.image":"string","ImplementationGuide.manifest.modifierExtension":"Extension","ImplementationGuide.manifest.other":"string","ImplementationGuide.manifest.page":"BackboneElement","ImplementationGuide.manifest.page.anchor":"string","ImplementationGuide.manifest.page.extension":"Extension","ImplementationGuide.manifest.page.id":"System.String","ImplementationGuide.manifest.page.modifierExtension":"Extension","ImplementationGuide.manifest.page.name":"string","ImplementationGuide.manifest.page.title":"string","ImplementationGuide.manifest.rendering":"url","ImplementationGuide.manifest.resource":"BackboneElement","ImplementationGuide.manifest.resource.exampleBoolean":"boolean","ImplementationGuide.manifest.resource.exampleCanonical":"canonical","ImplementationGuide.manifest.resource.extension":"Extension","ImplementationGuide.manifest.resource.id":"System.String","ImplementationGuide.manifest.resource.modifierExtension":"Extension","ImplementationGuide.manifest.resource.reference":"Reference","ImplementationGuide.manifest.resource.relativePath":"url","ImplementationGuide.meta":"Meta","ImplementationGuide.modifierExtension":"Extension","ImplementationGuide.name":"string","ImplementationGuide.packageId":"id","ImplementationGuide.publisher":"string","ImplementationGuide.status":"code","ImplementationGuide.text":"Narrative","ImplementationGuide.title":"string","ImplementationGuide.url":"uri","ImplementationGuide.useContext":"UsageContext","ImplementationGuide.version":"string","InsurancePlan.administeredBy":"Reference","InsurancePlan.alias":"string","InsurancePlan.contact":"BackboneElement","InsurancePlan.contact.address":"Address","InsurancePlan.contact.extension":"Extension","InsurancePlan.contact.id":"System.String","InsurancePlan.contact.modifierExtension":"Extension","InsurancePlan.contact.name":"HumanName","InsurancePlan.contact.purpose":"CodeableConcept","InsurancePlan.contact.telecom":"ContactPoint","InsurancePlan.contained":"Resource","InsurancePlan.coverage":"BackboneElement","InsurancePlan.coverage.benefit":"BackboneElement","InsurancePlan.coverage.benefit.extension":"Extension","InsurancePlan.coverage.benefit.id":"System.String","InsurancePlan.coverage.benefit.limit":"BackboneElement","InsurancePlan.coverage.benefit.limit.code":"CodeableConcept","InsurancePlan.coverage.benefit.limit.extension":"Extension","InsurancePlan.coverage.benefit.limit.id":"System.String","InsurancePlan.coverage.benefit.limit.modifierExtension":"Extension","InsurancePlan.coverage.benefit.limit.value":"Quantity","InsurancePlan.coverage.benefit.modifierExtension":"Extension","InsurancePlan.coverage.benefit.requirement":"string","InsurancePlan.coverage.benefit.type":"CodeableConcept","InsurancePlan.coverage.extension":"Extension","InsurancePlan.coverage.id":"System.String","InsurancePlan.coverage.modifierExtension":"Extension","InsurancePlan.coverage.network":"Reference","InsurancePlan.coverage.type":"CodeableConcept","InsurancePlan.coverageArea":"Reference","InsurancePlan.endpoint":"Reference","InsurancePlan.extension":"Extension","InsurancePlan.id":"System.String","InsurancePlan.identifier":"Identifier","InsurancePlan.implicitRules":"uri","InsurancePlan.language":"code","InsurancePlan.meta":"Meta","InsurancePlan.modifierExtension":"Extension","InsurancePlan.name":"string","InsurancePlan.network":"Reference","InsurancePlan.ownedBy":"Reference","InsurancePlan.period":"Period","InsurancePlan.plan":"BackboneElement","InsurancePlan.plan.coverageArea":"Reference","InsurancePlan.plan.extension":"Extension","InsurancePlan.plan.generalCost":"BackboneElement","InsurancePlan.plan.generalCost.comment":"string","InsurancePlan.plan.generalCost.cost":"Money","InsurancePlan.plan.generalCost.extension":"Extension","InsurancePlan.plan.generalCost.groupSize":"positiveInt","InsurancePlan.plan.generalCost.id":"System.String","InsurancePlan.plan.generalCost.modifierExtension":"Extension","InsurancePlan.plan.generalCost.type":"CodeableConcept","InsurancePlan.plan.id":"System.String","InsurancePlan.plan.identifier":"Identifier","InsurancePlan.plan.modifierExtension":"Extension","InsurancePlan.plan.network":"Reference","InsurancePlan.plan.specificCost":"BackboneElement","InsurancePlan.plan.specificCost.benefit":"BackboneElement","InsurancePlan.plan.specificCost.benefit.cost":"BackboneElement","InsurancePlan.plan.specificCost.benefit.cost.applicability":"CodeableConcept","InsurancePlan.plan.specificCost.benefit.cost.extension":"Extension","InsurancePlan.plan.specificCost.benefit.cost.id":"System.String","InsurancePlan.plan.specificCost.benefit.cost.modifierExtension":"Extension","InsurancePlan.plan.specificCost.benefit.cost.qualifiers":"CodeableConcept","InsurancePlan.plan.specificCost.benefit.cost.type":"CodeableConcept","InsurancePlan.plan.specificCost.benefit.cost.value":"Quantity","InsurancePlan.plan.specificCost.benefit.extension":"Extension","InsurancePlan.plan.specificCost.benefit.id":"System.String","InsurancePlan.plan.specificCost.benefit.modifierExtension":"Extension","InsurancePlan.plan.specificCost.benefit.type":"CodeableConcept","InsurancePlan.plan.specificCost.category":"CodeableConcept","InsurancePlan.plan.specificCost.extension":"Extension","InsurancePlan.plan.specificCost.id":"System.String","InsurancePlan.plan.specificCost.modifierExtension":"Extension","InsurancePlan.plan.type":"CodeableConcept","InsurancePlan.status":"code","InsurancePlan.text":"Narrative","InsurancePlan.type":"CodeableConcept","Invoice.account":"Reference","Invoice.cancelledReason":"string","Invoice.contained":"Resource","Invoice.date":"dateTime","Invoice.extension":"Extension","Invoice.id":"System.String","Invoice.identifier":"Identifier","Invoice.implicitRules":"uri","Invoice.issuer":"Reference","Invoice.language":"code","Invoice.lineItem":"BackboneElement","Invoice.lineItem.chargeItemCodeableConcept":"CodeableConcept","Invoice.lineItem.chargeItemReference":"Reference","Invoice.lineItem.extension":"Extension","Invoice.lineItem.id":"System.String","Invoice.lineItem.modifierExtension":"Extension","Invoice.lineItem.priceComponent":"BackboneElement","Invoice.lineItem.priceComponent.amount":"Money","Invoice.lineItem.priceComponent.code":"CodeableConcept","Invoice.lineItem.priceComponent.extension":"Extension","Invoice.lineItem.priceComponent.factor":"decimal","Invoice.lineItem.priceComponent.id":"System.String","Invoice.lineItem.priceComponent.modifierExtension":"Extension","Invoice.lineItem.priceComponent.type":"code","Invoice.lineItem.sequence":"positiveInt","Invoice.meta":"Meta","Invoice.modifierExtension":"Extension","Invoice.note":"Annotation","Invoice.participant":"BackboneElement","Invoice.participant.actor":"Reference","Invoice.participant.extension":"Extension","Invoice.participant.id":"System.String","Invoice.participant.modifierExtension":"Extension","Invoice.participant.role":"CodeableConcept","Invoice.paymentTerms":"markdown","Invoice.recipient":"Reference","Invoice.status":"code","Invoice.subject":"Reference","Invoice.text":"Narrative","Invoice.totalGross":"Money","Invoice.totalNet":"Money","Invoice.type":"CodeableConcept","Library.approvalDate":"date","Library.author":"ContactDetail","Library.contact":"ContactDetail","Library.contained":"Resource","Library.content":"Attachment","Library.copyright":"markdown","Library.dataRequirement":"DataRequirement","Library.date":"dateTime","Library.description":"markdown","Library.editor":"ContactDetail","Library.effectivePeriod":"Period","Library.endorser":"ContactDetail","Library.experimental":"boolean","Library.extension":"Extension","Library.id":"System.String","Library.identifier":"Identifier","Library.implicitRules":"uri","Library.jurisdiction":"CodeableConcept","Library.language":"code","Library.lastReviewDate":"date","Library.meta":"Meta","Library.modifierExtension":"Extension","Library.name":"string","Library.parameter":"ParameterDefinition","Library.publisher":"string","Library.purpose":"markdown","Library.relatedArtifact":"RelatedArtifact","Library.reviewer":"ContactDetail","Library.status":"code","Library.subjectCodeableConcept":"CodeableConcept","Library.subjectReference":"Reference","Library.subtitle":"string","Library.text":"Narrative","Library.title":"string","Library.topic":"CodeableConcept","Library.type":"CodeableConcept","Library.url":"uri","Library.usage":"string","Library.useContext":"UsageContext","Library.version":"string","Linkage.active":"boolean","Linkage.author":"Reference","Linkage.contained":"Resource","Linkage.extension":"Extension","Linkage.id":"System.String","Linkage.implicitRules":"uri","Linkage.item":"BackboneElement","Linkage.item.extension":"Extension","Linkage.item.id":"System.String","Linkage.item.modifierExtension":"Extension","Linkage.item.resource":"Reference","Linkage.item.type":"code","Linkage.language":"code","Linkage.meta":"Meta","Linkage.modifierExtension":"Extension","Linkage.text":"Narrative","List.code":"CodeableConcept","List.contained":"Resource","List.date":"dateTime","List.emptyReason":"CodeableConcept","List.encounter":"Reference","List.entry":"BackboneElement","List.entry.date":"dateTime","List.entry.deleted":"boolean","List.entry.extension":"Extension","List.entry.flag":"CodeableConcept","List.entry.id":"System.String","List.entry.item":"Reference","List.entry.modifierExtension":"Extension","List.extension":"Extension","List.id":"System.String","List.identifier":"Identifier","List.implicitRules":"uri","List.language":"code","List.meta":"Meta","List.mode":"code","List.modifierExtension":"Extension","List.note":"Annotation","List.orderedBy":"CodeableConcept","List.source":"Reference","List.status":"code","List.subject":"Reference","List.text":"Narrative","List.title":"string","Location.address":"Address","Location.alias":"string","Location.availabilityExceptions":"string","Location.contained":"Resource","Location.description":"string","Location.endpoint":"Reference","Location.extension":"Extension","Location.hoursOfOperation":"BackboneElement","Location.hoursOfOperation.allDay":"boolean","Location.hoursOfOperation.closingTime":"time","Location.hoursOfOperation.daysOfWeek":"code","Location.hoursOfOperation.extension":"Extension","Location.hoursOfOperation.id":"System.String","Location.hoursOfOperation.modifierExtension":"Extension","Location.hoursOfOperation.openingTime":"time","Location.id":"System.String","Location.identifier":"Identifier","Location.implicitRules":"uri","Location.language":"code","Location.managingOrganization":"Reference","Location.meta":"Meta","Location.mode":"code","Location.modifierExtension":"Extension","Location.name":"string","Location.operationalStatus":"Coding","Location.partOf":"Reference","Location.physicalType":"CodeableConcept","Location.position":"BackboneElement","Location.position.altitude":"decimal","Location.position.extension":"Extension","Location.position.id":"System.String","Location.position.latitude":"decimal","Location.position.longitude":"decimal","Location.position.modifierExtension":"Extension","Location.status":"code","Location.telecom":"ContactPoint","Location.text":"Narrative","Location.type":"CodeableConcept","MarketingStatus.country":"CodeableConcept","MarketingStatus.dateRange":"Period","MarketingStatus.extension":"Extension","MarketingStatus.id":"System.String","MarketingStatus.jurisdiction":"CodeableConcept","MarketingStatus.modifierExtension":"Extension","MarketingStatus.restoreDate":"dateTime","MarketingStatus.status":"CodeableConcept","Measure.approvalDate":"date","Measure.author":"ContactDetail","Measure.clinicalRecommendationStatement":"markdown","Measure.compositeScoring":"CodeableConcept","Measure.contact":"ContactDetail","Measure.contained":"Resource","Measure.copyright":"markdown","Measure.date":"dateTime","Measure.definition":"markdown","Measure.description":"markdown","Measure.disclaimer":"markdown","Measure.editor":"ContactDetail","Measure.effectivePeriod":"Period","Measure.endorser":"ContactDetail","Measure.experimental":"boolean","Measure.extension":"Extension","Measure.group":"BackboneElement","Measure.group.code":"CodeableConcept","Measure.group.description":"string","Measure.group.extension":"Extension","Measure.group.id":"System.String","Measure.group.modifierExtension":"Extension","Measure.group.population":"BackboneElement","Measure.group.population.code":"CodeableConcept","Measure.group.population.criteria":"Expression","Measure.group.population.description":"string","Measure.group.population.extension":"Extension","Measure.group.population.id":"System.String","Measure.group.population.modifierExtension":"Extension","Measure.group.stratifier":"BackboneElement","Measure.group.stratifier.code":"CodeableConcept","Measure.group.stratifier.component":"BackboneElement","Measure.group.stratifier.component.code":"CodeableConcept","Measure.group.stratifier.component.criteria":"Expression","Measure.group.stratifier.component.description":"string","Measure.group.stratifier.component.extension":"Extension","Measure.group.stratifier.component.id":"System.String","Measure.group.stratifier.component.modifierExtension":"Extension","Measure.group.stratifier.criteria":"Expression","Measure.group.stratifier.description":"string","Measure.group.stratifier.extension":"Extension","Measure.group.stratifier.id":"System.String","Measure.group.stratifier.modifierExtension":"Extension","Measure.guidance":"markdown","Measure.id":"System.String","Measure.identifier":"Identifier","Measure.implicitRules":"uri","Measure.improvementNotation":"CodeableConcept","Measure.jurisdiction":"CodeableConcept","Measure.language":"code","Measure.lastReviewDate":"date","Measure.library":"canonical","Measure.meta":"Meta","Measure.modifierExtension":"Extension","Measure.name":"string","Measure.publisher":"string","Measure.purpose":"markdown","Measure.rateAggregation":"string","Measure.rationale":"markdown","Measure.relatedArtifact":"RelatedArtifact","Measure.reviewer":"ContactDetail","Measure.riskAdjustment":"string","Measure.scoring":"CodeableConcept","Measure.status":"code","Measure.subjectCodeableConcept":"CodeableConcept","Measure.subjectReference":"Reference","Measure.subtitle":"string","Measure.supplementalData":"BackboneElement","Measure.supplementalData.code":"CodeableConcept","Measure.supplementalData.criteria":"Expression","Measure.supplementalData.description":"string","Measure.supplementalData.extension":"Extension","Measure.supplementalData.id":"System.String","Measure.supplementalData.modifierExtension":"Extension","Measure.supplementalData.usage":"CodeableConcept","Measure.text":"Narrative","Measure.title":"string","Measure.topic":"CodeableConcept","Measure.type":"CodeableConcept","Measure.url":"uri","Measure.usage":"string","Measure.useContext":"UsageContext","Measure.version":"string","MeasureReport.contained":"Resource","MeasureReport.date":"dateTime","MeasureReport.evaluatedResource":"Reference","MeasureReport.extension":"Extension","MeasureReport.group":"BackboneElement","MeasureReport.group.code":"CodeableConcept","MeasureReport.group.extension":"Extension","MeasureReport.group.id":"System.String","MeasureReport.group.measureScore":"Quantity","MeasureReport.group.modifierExtension":"Extension","MeasureReport.group.population":"BackboneElement","MeasureReport.group.population.code":"CodeableConcept","MeasureReport.group.population.count":"integer","MeasureReport.group.population.extension":"Extension","MeasureReport.group.population.id":"System.String","MeasureReport.group.population.modifierExtension":"Extension","MeasureReport.group.population.subjectResults":"Reference","MeasureReport.group.stratifier":"BackboneElement","MeasureReport.group.stratifier.code":"CodeableConcept","MeasureReport.group.stratifier.extension":"Extension","MeasureReport.group.stratifier.id":"System.String","MeasureReport.group.stratifier.modifierExtension":"Extension","MeasureReport.group.stratifier.stratum":"BackboneElement","MeasureReport.group.stratifier.stratum.component":"BackboneElement","MeasureReport.group.stratifier.stratum.component.code":"CodeableConcept","MeasureReport.group.stratifier.stratum.component.extension":"Extension","MeasureReport.group.stratifier.stratum.component.id":"System.String","MeasureReport.group.stratifier.stratum.component.modifierExtension":"Extension","MeasureReport.group.stratifier.stratum.component.value":"CodeableConcept","MeasureReport.group.stratifier.stratum.extension":"Extension","MeasureReport.group.stratifier.stratum.id":"System.String","MeasureReport.group.stratifier.stratum.measureScore":"Quantity","MeasureReport.group.stratifier.stratum.modifierExtension":"Extension","MeasureReport.group.stratifier.stratum.population":"BackboneElement","MeasureReport.group.stratifier.stratum.population.code":"CodeableConcept","MeasureReport.group.stratifier.stratum.population.count":"integer","MeasureReport.group.stratifier.stratum.population.extension":"Extension","MeasureReport.group.stratifier.stratum.population.id":"System.String","MeasureReport.group.stratifier.stratum.population.modifierExtension":"Extension","MeasureReport.group.stratifier.stratum.population.subjectResults":"Reference","MeasureReport.group.stratifier.stratum.value":"CodeableConcept","MeasureReport.id":"System.String","MeasureReport.identifier":"Identifier","MeasureReport.implicitRules":"uri","MeasureReport.improvementNotation":"CodeableConcept","MeasureReport.language":"code","MeasureReport.measure":"canonical","MeasureReport.meta":"Meta","MeasureReport.modifierExtension":"Extension","MeasureReport.period":"Period","MeasureReport.reporter":"Reference","MeasureReport.status":"code","MeasureReport.subject":"Reference","MeasureReport.text":"Narrative","MeasureReport.type":"code","Media.basedOn":"Reference","Media.bodySite":"CodeableConcept","Media.contained":"Resource","Media.content":"Attachment","Media.createdDateTime":"dateTime","Media.createdPeriod":"Period","Media.device":"Reference","Media.deviceName":"string","Media.duration":"decimal","Media.encounter":"Reference","Media.extension":"Extension","Media.frames":"positiveInt","Media.height":"positiveInt","Media.id":"System.String","Media.identifier":"Identifier","Media.implicitRules":"uri","Media.issued":"instant","Media.language":"code","Media.meta":"Meta","Media.modality":"CodeableConcept","Media.modifierExtension":"Extension","Media.note":"Annotation","Media.operator":"Reference","Media.partOf":"Reference","Media.reasonCode":"CodeableConcept","Media.status":"code","Media.subject":"Reference","Media.text":"Narrative","Media.type":"CodeableConcept","Media.view":"CodeableConcept","Media.width":"positiveInt","Medication.amount":"Ratio","Medication.batch":"BackboneElement","Medication.batch.expirationDate":"dateTime","Medication.batch.extension":"Extension","Medication.batch.id":"System.String","Medication.batch.lotNumber":"string","Medication.batch.modifierExtension":"Extension","Medication.code":"CodeableConcept","Medication.contained":"Resource","Medication.extension":"Extension","Medication.form":"CodeableConcept","Medication.id":"System.String","Medication.identifier":"Identifier","Medication.implicitRules":"uri","Medication.ingredient":"BackboneElement","Medication.ingredient.extension":"Extension","Medication.ingredient.id":"System.String","Medication.ingredient.isActive":"boolean","Medication.ingredient.itemCodeableConcept":"CodeableConcept","Medication.ingredient.itemReference":"Reference","Medication.ingredient.modifierExtension":"Extension","Medication.ingredient.strength":"Ratio","Medication.language":"code","Medication.manufacturer":"Reference","Medication.meta":"Meta","Medication.modifierExtension":"Extension","Medication.status":"code","Medication.text":"Narrative","MedicationAdministration.category":"CodeableConcept","MedicationAdministration.contained":"Resource","MedicationAdministration.context":"Reference","MedicationAdministration.device":"Reference","MedicationAdministration.dosage":"BackboneElement","MedicationAdministration.dosage.dose":"Quantity","MedicationAdministration.dosage.extension":"Extension","MedicationAdministration.dosage.id":"System.String","MedicationAdministration.dosage.method":"CodeableConcept","MedicationAdministration.dosage.modifierExtension":"Extension","MedicationAdministration.dosage.rateQuantity":"Quantity","MedicationAdministration.dosage.rateRatio":"Ratio","MedicationAdministration.dosage.route":"CodeableConcept","MedicationAdministration.dosage.site":"CodeableConcept","MedicationAdministration.dosage.text":"string","MedicationAdministration.effectiveDateTime":"dateTime","MedicationAdministration.effectivePeriod":"Period","MedicationAdministration.eventHistory":"Reference","MedicationAdministration.extension":"Extension","MedicationAdministration.id":"System.String","MedicationAdministration.identifier":"Identifier","MedicationAdministration.implicitRules":"uri","MedicationAdministration.instantiates":"uri","MedicationAdministration.language":"code","MedicationAdministration.medicationCodeableConcept":"CodeableConcept","MedicationAdministration.medicationReference":"Reference","MedicationAdministration.meta":"Meta","MedicationAdministration.modifierExtension":"Extension","MedicationAdministration.note":"Annotation","MedicationAdministration.partOf":"Reference","MedicationAdministration.performer":"BackboneElement","MedicationAdministration.performer.actor":"Reference","MedicationAdministration.performer.extension":"Extension","MedicationAdministration.performer.function":"CodeableConcept","MedicationAdministration.performer.id":"System.String","MedicationAdministration.performer.modifierExtension":"Extension","MedicationAdministration.reasonCode":"CodeableConcept","MedicationAdministration.reasonReference":"Reference","MedicationAdministration.request":"Reference","MedicationAdministration.status":"code","MedicationAdministration.statusReason":"CodeableConcept","MedicationAdministration.subject":"Reference","MedicationAdministration.supportingInformation":"Reference","MedicationAdministration.text":"Narrative","MedicationDispense.authorizingPrescription":"Reference","MedicationDispense.category":"CodeableConcept","MedicationDispense.contained":"Resource","MedicationDispense.context":"Reference","MedicationDispense.daysSupply":"Quantity","MedicationDispense.destination":"Reference","MedicationDispense.detectedIssue":"Reference","MedicationDispense.dosageInstruction":"Dosage","MedicationDispense.eventHistory":"Reference","MedicationDispense.extension":"Extension","MedicationDispense.id":"System.String","MedicationDispense.identifier":"Identifier","MedicationDispense.implicitRules":"uri","MedicationDispense.language":"code","MedicationDispense.location":"Reference","MedicationDispense.medicationCodeableConcept":"CodeableConcept","MedicationDispense.medicationReference":"Reference","MedicationDispense.meta":"Meta","MedicationDispense.modifierExtension":"Extension","MedicationDispense.note":"Annotation","MedicationDispense.partOf":"Reference","MedicationDispense.performer":"BackboneElement","MedicationDispense.performer.actor":"Reference","MedicationDispense.performer.extension":"Extension","MedicationDispense.performer.function":"CodeableConcept","MedicationDispense.performer.id":"System.String","MedicationDispense.performer.modifierExtension":"Extension","MedicationDispense.quantity":"Quantity","MedicationDispense.receiver":"Reference","MedicationDispense.status":"code","MedicationDispense.statusReasonCodeableConcept":"CodeableConcept","MedicationDispense.statusReasonReference":"Reference","MedicationDispense.subject":"Reference","MedicationDispense.substitution":"BackboneElement","MedicationDispense.substitution.extension":"Extension","MedicationDispense.substitution.id":"System.String","MedicationDispense.substitution.modifierExtension":"Extension","MedicationDispense.substitution.reason":"CodeableConcept","MedicationDispense.substitution.responsibleParty":"Reference","MedicationDispense.substitution.type":"CodeableConcept","MedicationDispense.substitution.wasSubstituted":"boolean","MedicationDispense.supportingInformation":"Reference","MedicationDispense.text":"Narrative","MedicationDispense.type":"CodeableConcept","MedicationDispense.whenHandedOver":"dateTime","MedicationDispense.whenPrepared":"dateTime","MedicationKnowledge.administrationGuidelines":"BackboneElement","MedicationKnowledge.administrationGuidelines.dosage":"BackboneElement","MedicationKnowledge.administrationGuidelines.dosage.dosage":"Dosage","MedicationKnowledge.administrationGuidelines.dosage.extension":"Extension","MedicationKnowledge.administrationGuidelines.dosage.id":"System.String","MedicationKnowledge.administrationGuidelines.dosage.modifierExtension":"Extension","MedicationKnowledge.administrationGuidelines.dosage.type":"CodeableConcept","MedicationKnowledge.administrationGuidelines.extension":"Extension","MedicationKnowledge.administrationGuidelines.id":"System.String","MedicationKnowledge.administrationGuidelines.indicationCodeableConcept":"CodeableConcept","MedicationKnowledge.administrationGuidelines.indicationReference":"Reference","MedicationKnowledge.administrationGuidelines.modifierExtension":"Extension","MedicationKnowledge.administrationGuidelines.patientCharacteristics":"BackboneElement","MedicationKnowledge.administrationGuidelines.patientCharacteristics.characteristicCodeableConcept":"CodeableConcept","MedicationKnowledge.administrationGuidelines.patientCharacteristics.characteristicQuantity":"Quantity","MedicationKnowledge.administrationGuidelines.patientCharacteristics.extension":"Extension","MedicationKnowledge.administrationGuidelines.patientCharacteristics.id":"System.String","MedicationKnowledge.administrationGuidelines.patientCharacteristics.modifierExtension":"Extension","MedicationKnowledge.administrationGuidelines.patientCharacteristics.value":"string","MedicationKnowledge.amount":"Quantity","MedicationKnowledge.associatedMedication":"Reference","MedicationKnowledge.code":"CodeableConcept","MedicationKnowledge.contained":"Resource","MedicationKnowledge.contraindication":"Reference","MedicationKnowledge.cost":"BackboneElement","MedicationKnowledge.cost.cost":"Money","MedicationKnowledge.cost.extension":"Extension","MedicationKnowledge.cost.id":"System.String","MedicationKnowledge.cost.modifierExtension":"Extension","MedicationKnowledge.cost.source":"string","MedicationKnowledge.cost.type":"CodeableConcept","MedicationKnowledge.doseForm":"CodeableConcept","MedicationKnowledge.drugCharacteristic":"BackboneElement","MedicationKnowledge.drugCharacteristic.extension":"Extension","MedicationKnowledge.drugCharacteristic.id":"System.String","MedicationKnowledge.drugCharacteristic.modifierExtension":"Extension","MedicationKnowledge.drugCharacteristic.type":"CodeableConcept","MedicationKnowledge.drugCharacteristic.valueBase64Binary":"base64Binary","MedicationKnowledge.drugCharacteristic.valueCodeableConcept":"CodeableConcept","MedicationKnowledge.drugCharacteristic.valueQuantity":"Quantity","MedicationKnowledge.drugCharacteristic.valueString":"string","MedicationKnowledge.extension":"Extension","MedicationKnowledge.id":"System.String","MedicationKnowledge.implicitRules":"uri","MedicationKnowledge.ingredient":"BackboneElement","MedicationKnowledge.ingredient.extension":"Extension","MedicationKnowledge.ingredient.id":"System.String","MedicationKnowledge.ingredient.isActive":"boolean","MedicationKnowledge.ingredient.itemCodeableConcept":"CodeableConcept","MedicationKnowledge.ingredient.itemReference":"Reference","MedicationKnowledge.ingredient.modifierExtension":"Extension","MedicationKnowledge.ingredient.strength":"Ratio","MedicationKnowledge.intendedRoute":"CodeableConcept","MedicationKnowledge.kinetics":"BackboneElement","MedicationKnowledge.kinetics.areaUnderCurve":"Quantity","MedicationKnowledge.kinetics.extension":"Extension","MedicationKnowledge.kinetics.halfLifePeriod":"Duration","MedicationKnowledge.kinetics.id":"System.String","MedicationKnowledge.kinetics.lethalDose50":"Quantity","MedicationKnowledge.kinetics.modifierExtension":"Extension","MedicationKnowledge.language":"code","MedicationKnowledge.manufacturer":"Reference","MedicationKnowledge.medicineClassification":"BackboneElement","MedicationKnowledge.medicineClassification.classification":"CodeableConcept","MedicationKnowledge.medicineClassification.extension":"Extension","MedicationKnowledge.medicineClassification.id":"System.String","MedicationKnowledge.medicineClassification.modifierExtension":"Extension","MedicationKnowledge.medicineClassification.type":"CodeableConcept","MedicationKnowledge.meta":"Meta","MedicationKnowledge.modifierExtension":"Extension","MedicationKnowledge.monitoringProgram":"BackboneElement","MedicationKnowledge.monitoringProgram.extension":"Extension","MedicationKnowledge.monitoringProgram.id":"System.String","MedicationKnowledge.monitoringProgram.modifierExtension":"Extension","MedicationKnowledge.monitoringProgram.name":"string","MedicationKnowledge.monitoringProgram.type":"CodeableConcept","MedicationKnowledge.monograph":"BackboneElement","MedicationKnowledge.monograph.extension":"Extension","MedicationKnowledge.monograph.id":"System.String","MedicationKnowledge.monograph.modifierExtension":"Extension","MedicationKnowledge.monograph.source":"Reference","MedicationKnowledge.monograph.type":"CodeableConcept","MedicationKnowledge.packaging":"BackboneElement","MedicationKnowledge.packaging.extension":"Extension","MedicationKnowledge.packaging.id":"System.String","MedicationKnowledge.packaging.modifierExtension":"Extension","MedicationKnowledge.packaging.quantity":"Quantity","MedicationKnowledge.packaging.type":"CodeableConcept","MedicationKnowledge.preparationInstruction":"markdown","MedicationKnowledge.productType":"CodeableConcept","MedicationKnowledge.regulatory":"BackboneElement","MedicationKnowledge.regulatory.extension":"Extension","MedicationKnowledge.regulatory.id":"System.String","MedicationKnowledge.regulatory.maxDispense":"BackboneElement","MedicationKnowledge.regulatory.maxDispense.extension":"Extension","MedicationKnowledge.regulatory.maxDispense.id":"System.String","MedicationKnowledge.regulatory.maxDispense.modifierExtension":"Extension","MedicationKnowledge.regulatory.maxDispense.period":"Duration","MedicationKnowledge.regulatory.maxDispense.quantity":"Quantity","MedicationKnowledge.regulatory.modifierExtension":"Extension","MedicationKnowledge.regulatory.regulatoryAuthority":"Reference","MedicationKnowledge.regulatory.schedule":"BackboneElement","MedicationKnowledge.regulatory.schedule.extension":"Extension","MedicationKnowledge.regulatory.schedule.id":"System.String","MedicationKnowledge.regulatory.schedule.modifierExtension":"Extension","MedicationKnowledge.regulatory.schedule.schedule":"CodeableConcept","MedicationKnowledge.regulatory.substitution":"BackboneElement","MedicationKnowledge.regulatory.substitution.allowed":"boolean","MedicationKnowledge.regulatory.substitution.extension":"Extension","MedicationKnowledge.regulatory.substitution.id":"System.String","MedicationKnowledge.regulatory.substitution.modifierExtension":"Extension","MedicationKnowledge.regulatory.substitution.type":"CodeableConcept","MedicationKnowledge.relatedMedicationKnowledge":"BackboneElement","MedicationKnowledge.relatedMedicationKnowledge.extension":"Extension","MedicationKnowledge.relatedMedicationKnowledge.id":"System.String","MedicationKnowledge.relatedMedicationKnowledge.modifierExtension":"Extension","MedicationKnowledge.relatedMedicationKnowledge.reference":"Reference","MedicationKnowledge.relatedMedicationKnowledge.type":"CodeableConcept","MedicationKnowledge.status":"code","MedicationKnowledge.synonym":"string","MedicationKnowledge.text":"Narrative","MedicationRequest.authoredOn":"dateTime","MedicationRequest.basedOn":"Reference","MedicationRequest.category":"CodeableConcept","MedicationRequest.contained":"Resource","MedicationRequest.courseOfTherapyType":"CodeableConcept","MedicationRequest.detectedIssue":"Reference","MedicationRequest.dispenseRequest":"BackboneElement","MedicationRequest.dispenseRequest.dispenseInterval":"Duration","MedicationRequest.dispenseRequest.expectedSupplyDuration":"Duration","MedicationRequest.dispenseRequest.extension":"Extension","MedicationRequest.dispenseRequest.id":"System.String","MedicationRequest.dispenseRequest.initialFill":"BackboneElement","MedicationRequest.dispenseRequest.initialFill.duration":"Duration","MedicationRequest.dispenseRequest.initialFill.extension":"Extension","MedicationRequest.dispenseRequest.initialFill.id":"System.String","MedicationRequest.dispenseRequest.initialFill.modifierExtension":"Extension","MedicationRequest.dispenseRequest.initialFill.quantity":"Quantity","MedicationRequest.dispenseRequest.modifierExtension":"Extension","MedicationRequest.dispenseRequest.numberOfRepeatsAllowed":"unsignedInt","MedicationRequest.dispenseRequest.performer":"Reference","MedicationRequest.dispenseRequest.quantity":"Quantity","MedicationRequest.dispenseRequest.validityPeriod":"Period","MedicationRequest.doNotPerform":"boolean","MedicationRequest.dosageInstruction":"Dosage","MedicationRequest.encounter":"Reference","MedicationRequest.eventHistory":"Reference","MedicationRequest.extension":"Extension","MedicationRequest.groupIdentifier":"Identifier","MedicationRequest.id":"System.String","MedicationRequest.identifier":"Identifier","MedicationRequest.implicitRules":"uri","MedicationRequest.instantiatesCanonical":"canonical","MedicationRequest.instantiatesUri":"uri","MedicationRequest.insurance":"Reference","MedicationRequest.intent":"code","MedicationRequest.language":"code","MedicationRequest.medicationCodeableConcept":"CodeableConcept","MedicationRequest.medicationReference":"Reference","MedicationRequest.meta":"Meta","MedicationRequest.modifierExtension":"Extension","MedicationRequest.note":"Annotation","MedicationRequest.performer":"Reference","MedicationRequest.performerType":"CodeableConcept","MedicationRequest.priorPrescription":"Reference","MedicationRequest.priority":"code","MedicationRequest.reasonCode":"CodeableConcept","MedicationRequest.reasonReference":"Reference","MedicationRequest.recorder":"Reference","MedicationRequest.reportedBoolean":"boolean","MedicationRequest.reportedReference":"Reference","MedicationRequest.requester":"Reference","MedicationRequest.status":"code","MedicationRequest.statusReason":"CodeableConcept","MedicationRequest.subject":"Reference","MedicationRequest.substitution":"BackboneElement","MedicationRequest.substitution.allowedBoolean":"boolean","MedicationRequest.substitution.allowedCodeableConcept":"CodeableConcept","MedicationRequest.substitution.extension":"Extension","MedicationRequest.substitution.id":"System.String","MedicationRequest.substitution.modifierExtension":"Extension","MedicationRequest.substitution.reason":"CodeableConcept","MedicationRequest.supportingInformation":"Reference","MedicationRequest.text":"Narrative","MedicationStatement.basedOn":"Reference","MedicationStatement.category":"CodeableConcept","MedicationStatement.contained":"Resource","MedicationStatement.context":"Reference","MedicationStatement.dateAsserted":"dateTime","MedicationStatement.derivedFrom":"Reference","MedicationStatement.dosage":"Dosage","MedicationStatement.effectiveDateTime":"dateTime","MedicationStatement.effectivePeriod":"Period","MedicationStatement.extension":"Extension","MedicationStatement.id":"System.String","MedicationStatement.identifier":"Identifier","MedicationStatement.implicitRules":"uri","MedicationStatement.informationSource":"Reference","MedicationStatement.language":"code","MedicationStatement.medicationCodeableConcept":"CodeableConcept","MedicationStatement.medicationReference":"Reference","MedicationStatement.meta":"Meta","MedicationStatement.modifierExtension":"Extension","MedicationStatement.note":"Annotation","MedicationStatement.partOf":"Reference","MedicationStatement.reasonCode":"CodeableConcept","MedicationStatement.reasonReference":"Reference","MedicationStatement.status":"code","MedicationStatement.statusReason":"CodeableConcept","MedicationStatement.subject":"Reference","MedicationStatement.text":"Narrative","MedicinalProduct.additionalMonitoringIndicator":"CodeableConcept","MedicinalProduct.attachedDocument":"Reference","MedicinalProduct.clinicalTrial":"Reference","MedicinalProduct.combinedPharmaceuticalDoseForm":"CodeableConcept","MedicinalProduct.contact":"Reference","MedicinalProduct.contained":"Resource","MedicinalProduct.crossReference":"Identifier","MedicinalProduct.domain":"Coding","MedicinalProduct.extension":"Extension","MedicinalProduct.id":"System.String","MedicinalProduct.identifier":"Identifier","MedicinalProduct.implicitRules":"uri","MedicinalProduct.language":"code","MedicinalProduct.legalStatusOfSupply":"CodeableConcept","MedicinalProduct.manufacturingBusinessOperation":"BackboneElement","MedicinalProduct.manufacturingBusinessOperation.authorisationReferenceNumber":"Identifier","MedicinalProduct.manufacturingBusinessOperation.confidentialityIndicator":"CodeableConcept","MedicinalProduct.manufacturingBusinessOperation.effectiveDate":"dateTime","MedicinalProduct.manufacturingBusinessOperation.extension":"Extension","MedicinalProduct.manufacturingBusinessOperation.id":"System.String","MedicinalProduct.manufacturingBusinessOperation.manufacturer":"Reference","MedicinalProduct.manufacturingBusinessOperation.modifierExtension":"Extension","MedicinalProduct.manufacturingBusinessOperation.operationType":"CodeableConcept","MedicinalProduct.manufacturingBusinessOperation.regulator":"Reference","MedicinalProduct.marketingStatus":"MarketingStatus","MedicinalProduct.masterFile":"Reference","MedicinalProduct.meta":"Meta","MedicinalProduct.modifierExtension":"Extension","MedicinalProduct.name":"BackboneElement","MedicinalProduct.name.countryLanguage":"BackboneElement","MedicinalProduct.name.countryLanguage.country":"CodeableConcept","MedicinalProduct.name.countryLanguage.extension":"Extension","MedicinalProduct.name.countryLanguage.id":"System.String","MedicinalProduct.name.countryLanguage.jurisdiction":"CodeableConcept","MedicinalProduct.name.countryLanguage.language":"CodeableConcept","MedicinalProduct.name.countryLanguage.modifierExtension":"Extension","MedicinalProduct.name.extension":"Extension","MedicinalProduct.name.id":"System.String","MedicinalProduct.name.modifierExtension":"Extension","MedicinalProduct.name.namePart":"BackboneElement","MedicinalProduct.name.namePart.extension":"Extension","MedicinalProduct.name.namePart.id":"System.String","MedicinalProduct.name.namePart.modifierExtension":"Extension","MedicinalProduct.name.namePart.part":"string","MedicinalProduct.name.namePart.type":"Coding","MedicinalProduct.name.productName":"string","MedicinalProduct.packagedMedicinalProduct":"Reference","MedicinalProduct.paediatricUseIndicator":"CodeableConcept","MedicinalProduct.pharmaceuticalProduct":"Reference","MedicinalProduct.productClassification":"CodeableConcept","MedicinalProduct.specialDesignation":"BackboneElement","MedicinalProduct.specialDesignation.date":"dateTime","MedicinalProduct.specialDesignation.extension":"Extension","MedicinalProduct.specialDesignation.id":"System.String","MedicinalProduct.specialDesignation.identifier":"Identifier","MedicinalProduct.specialDesignation.indicationCodeableConcept":"CodeableConcept","MedicinalProduct.specialDesignation.indicationReference":"Reference","MedicinalProduct.specialDesignation.intendedUse":"CodeableConcept","MedicinalProduct.specialDesignation.modifierExtension":"Extension","MedicinalProduct.specialDesignation.species":"CodeableConcept","MedicinalProduct.specialDesignation.status":"CodeableConcept","MedicinalProduct.specialDesignation.type":"CodeableConcept","MedicinalProduct.specialMeasures":"string","MedicinalProduct.text":"Narrative","MedicinalProduct.type":"CodeableConcept","MedicinalProductAuthorization.contained":"Resource","MedicinalProductAuthorization.country":"CodeableConcept","MedicinalProductAuthorization.dataExclusivityPeriod":"Period","MedicinalProductAuthorization.dateOfFirstAuthorization":"dateTime","MedicinalProductAuthorization.extension":"Extension","MedicinalProductAuthorization.holder":"Reference","MedicinalProductAuthorization.id":"System.String","MedicinalProductAuthorization.identifier":"Identifier","MedicinalProductAuthorization.implicitRules":"uri","MedicinalProductAuthorization.internationalBirthDate":"dateTime","MedicinalProductAuthorization.jurisdiction":"CodeableConcept","MedicinalProductAuthorization.jurisdictionalAuthorization":"BackboneElement","MedicinalProductAuthorization.jurisdictionalAuthorization.country":"CodeableConcept","MedicinalProductAuthorization.jurisdictionalAuthorization.extension":"Extension","MedicinalProductAuthorization.jurisdictionalAuthorization.id":"System.String","MedicinalProductAuthorization.jurisdictionalAuthorization.identifier":"Identifier","MedicinalProductAuthorization.jurisdictionalAuthorization.jurisdiction":"CodeableConcept","MedicinalProductAuthorization.jurisdictionalAuthorization.legalStatusOfSupply":"CodeableConcept","MedicinalProductAuthorization.jurisdictionalAuthorization.modifierExtension":"Extension","MedicinalProductAuthorization.jurisdictionalAuthorization.validityPeriod":"Period","MedicinalProductAuthorization.language":"code","MedicinalProductAuthorization.legalBasis":"CodeableConcept","MedicinalProductAuthorization.meta":"Meta","MedicinalProductAuthorization.modifierExtension":"Extension","MedicinalProductAuthorization.procedure":"BackboneElement","MedicinalProductAuthorization.procedure.dateDateTime":"dateTime","MedicinalProductAuthorization.procedure.datePeriod":"Period","MedicinalProductAuthorization.procedure.extension":"Extension","MedicinalProductAuthorization.procedure.id":"System.String","MedicinalProductAuthorization.procedure.identifier":"Identifier","MedicinalProductAuthorization.procedure.modifierExtension":"Extension","MedicinalProductAuthorization.procedure.type":"CodeableConcept","MedicinalProductAuthorization.regulator":"Reference","MedicinalProductAuthorization.restoreDate":"dateTime","MedicinalProductAuthorization.status":"CodeableConcept","MedicinalProductAuthorization.statusDate":"dateTime","MedicinalProductAuthorization.subject":"Reference","MedicinalProductAuthorization.text":"Narrative","MedicinalProductAuthorization.validityPeriod":"Period","MedicinalProductContraindication.comorbidity":"CodeableConcept","MedicinalProductContraindication.contained":"Resource","MedicinalProductContraindication.disease":"CodeableConcept","MedicinalProductContraindication.diseaseStatus":"CodeableConcept","MedicinalProductContraindication.extension":"Extension","MedicinalProductContraindication.id":"System.String","MedicinalProductContraindication.implicitRules":"uri","MedicinalProductContraindication.language":"code","MedicinalProductContraindication.meta":"Meta","MedicinalProductContraindication.modifierExtension":"Extension","MedicinalProductContraindication.otherTherapy":"BackboneElement","MedicinalProductContraindication.otherTherapy.extension":"Extension","MedicinalProductContraindication.otherTherapy.id":"System.String","MedicinalProductContraindication.otherTherapy.medicationCodeableConcept":"CodeableConcept","MedicinalProductContraindication.otherTherapy.medicationReference":"Reference","MedicinalProductContraindication.otherTherapy.modifierExtension":"Extension","MedicinalProductContraindication.otherTherapy.therapyRelationshipType":"CodeableConcept","MedicinalProductContraindication.population":"Population","MedicinalProductContraindication.subject":"Reference","MedicinalProductContraindication.text":"Narrative","MedicinalProductContraindication.therapeuticIndication":"Reference","MedicinalProductIndication.comorbidity":"CodeableConcept","MedicinalProductIndication.contained":"Resource","MedicinalProductIndication.diseaseStatus":"CodeableConcept","MedicinalProductIndication.diseaseSymptomProcedure":"CodeableConcept","MedicinalProductIndication.duration":"Quantity","MedicinalProductIndication.extension":"Extension","MedicinalProductIndication.id":"System.String","MedicinalProductIndication.implicitRules":"uri","MedicinalProductIndication.intendedEffect":"CodeableConcept","MedicinalProductIndication.language":"code","MedicinalProductIndication.meta":"Meta","MedicinalProductIndication.modifierExtension":"Extension","MedicinalProductIndication.otherTherapy":"BackboneElement","MedicinalProductIndication.otherTherapy.extension":"Extension","MedicinalProductIndication.otherTherapy.id":"System.String","MedicinalProductIndication.otherTherapy.medicationCodeableConcept":"CodeableConcept","MedicinalProductIndication.otherTherapy.medicationReference":"Reference","MedicinalProductIndication.otherTherapy.modifierExtension":"Extension","MedicinalProductIndication.otherTherapy.therapyRelationshipType":"CodeableConcept","MedicinalProductIndication.population":"Population","MedicinalProductIndication.subject":"Reference","MedicinalProductIndication.text":"Narrative","MedicinalProductIndication.undesirableEffect":"Reference","MedicinalProductIngredient.allergenicIndicator":"boolean","MedicinalProductIngredient.contained":"Resource","MedicinalProductIngredient.extension":"Extension","MedicinalProductIngredient.id":"System.String","MedicinalProductIngredient.identifier":"Identifier","MedicinalProductIngredient.implicitRules":"uri","MedicinalProductIngredient.language":"code","MedicinalProductIngredient.manufacturer":"Reference","MedicinalProductIngredient.meta":"Meta","MedicinalProductIngredient.modifierExtension":"Extension","MedicinalProductIngredient.role":"CodeableConcept","MedicinalProductIngredient.specifiedSubstance":"BackboneElement","MedicinalProductIngredient.specifiedSubstance.code":"CodeableConcept","MedicinalProductIngredient.specifiedSubstance.confidentiality":"CodeableConcept","MedicinalProductIngredient.specifiedSubstance.extension":"Extension","MedicinalProductIngredient.specifiedSubstance.group":"CodeableConcept","MedicinalProductIngredient.specifiedSubstance.id":"System.String","MedicinalProductIngredient.specifiedSubstance.modifierExtension":"Extension","MedicinalProductIngredient.specifiedSubstance.strength":"BackboneElement","MedicinalProductIngredient.specifiedSubstance.strength.concentration":"Ratio","MedicinalProductIngredient.specifiedSubstance.strength.concentrationLowLimit":"Ratio","MedicinalProductIngredient.specifiedSubstance.strength.country":"CodeableConcept","MedicinalProductIngredient.specifiedSubstance.strength.extension":"Extension","MedicinalProductIngredient.specifiedSubstance.strength.id":"System.String","MedicinalProductIngredient.specifiedSubstance.strength.measurementPoint":"string","MedicinalProductIngredient.specifiedSubstance.strength.modifierExtension":"Extension","MedicinalProductIngredient.specifiedSubstance.strength.presentation":"Ratio","MedicinalProductIngredient.specifiedSubstance.strength.presentationLowLimit":"Ratio","MedicinalProductIngredient.specifiedSubstance.strength.referenceStrength":"BackboneElement","MedicinalProductIngredient.specifiedSubstance.strength.referenceStrength.country":"CodeableConcept","MedicinalProductIngredient.specifiedSubstance.strength.referenceStrength.extension":"Extension","MedicinalProductIngredient.specifiedSubstance.strength.referenceStrength.id":"System.String","MedicinalProductIngredient.specifiedSubstance.strength.referenceStrength.measurementPoint":"string","MedicinalProductIngredient.specifiedSubstance.strength.referenceStrength.modifierExtension":"Extension","MedicinalProductIngredient.specifiedSubstance.strength.referenceStrength.strength":"Ratio","MedicinalProductIngredient.specifiedSubstance.strength.referenceStrength.strengthLowLimit":"Ratio","MedicinalProductIngredient.specifiedSubstance.strength.referenceStrength.substance":"CodeableConcept","MedicinalProductIngredient.substance":"BackboneElement","MedicinalProductIngredient.substance.code":"CodeableConcept","MedicinalProductIngredient.substance.extension":"Extension","MedicinalProductIngredient.substance.id":"System.String","MedicinalProductIngredient.substance.modifierExtension":"Extension","MedicinalProductIngredient.text":"Narrative","MedicinalProductInteraction.contained":"Resource","MedicinalProductInteraction.description":"string","MedicinalProductInteraction.effect":"CodeableConcept","MedicinalProductInteraction.extension":"Extension","MedicinalProductInteraction.id":"System.String","MedicinalProductInteraction.implicitRules":"uri","MedicinalProductInteraction.incidence":"CodeableConcept","MedicinalProductInteraction.interactant":"BackboneElement","MedicinalProductInteraction.interactant.extension":"Extension","MedicinalProductInteraction.interactant.id":"System.String","MedicinalProductInteraction.interactant.itemCodeableConcept":"CodeableConcept","MedicinalProductInteraction.interactant.itemReference":"Reference","MedicinalProductInteraction.interactant.modifierExtension":"Extension","MedicinalProductInteraction.language":"code","MedicinalProductInteraction.management":"CodeableConcept","MedicinalProductInteraction.meta":"Meta","MedicinalProductInteraction.modifierExtension":"Extension","MedicinalProductInteraction.subject":"Reference","MedicinalProductInteraction.text":"Narrative","MedicinalProductInteraction.type":"CodeableConcept","MedicinalProductManufactured.contained":"Resource","MedicinalProductManufactured.extension":"Extension","MedicinalProductManufactured.id":"System.String","MedicinalProductManufactured.implicitRules":"uri","MedicinalProductManufactured.ingredient":"Reference","MedicinalProductManufactured.language":"code","MedicinalProductManufactured.manufacturedDoseForm":"CodeableConcept","MedicinalProductManufactured.manufacturer":"Reference","MedicinalProductManufactured.meta":"Meta","MedicinalProductManufactured.modifierExtension":"Extension","MedicinalProductManufactured.otherCharacteristics":"CodeableConcept","MedicinalProductManufactured.physicalCharacteristics":"ProdCharacteristic","MedicinalProductManufactured.quantity":"Quantity","MedicinalProductManufactured.text":"Narrative","MedicinalProductManufactured.unitOfPresentation":"CodeableConcept","MedicinalProductPackaged.batchIdentifier":"BackboneElement","MedicinalProductPackaged.batchIdentifier.extension":"Extension","MedicinalProductPackaged.batchIdentifier.id":"System.String","MedicinalProductPackaged.batchIdentifier.immediatePackaging":"Identifier","MedicinalProductPackaged.batchIdentifier.modifierExtension":"Extension","MedicinalProductPackaged.batchIdentifier.outerPackaging":"Identifier","MedicinalProductPackaged.contained":"Resource","MedicinalProductPackaged.description":"string","MedicinalProductPackaged.extension":"Extension","MedicinalProductPackaged.id":"System.String","MedicinalProductPackaged.identifier":"Identifier","MedicinalProductPackaged.implicitRules":"uri","MedicinalProductPackaged.language":"code","MedicinalProductPackaged.legalStatusOfSupply":"CodeableConcept","MedicinalProductPackaged.manufacturer":"Reference","MedicinalProductPackaged.marketingAuthorization":"Reference","MedicinalProductPackaged.marketingStatus":"MarketingStatus","MedicinalProductPackaged.meta":"Meta","MedicinalProductPackaged.modifierExtension":"Extension","MedicinalProductPackaged.packageItem":"BackboneElement","MedicinalProductPackaged.packageItem.alternateMaterial":"CodeableConcept","MedicinalProductPackaged.packageItem.device":"Reference","MedicinalProductPackaged.packageItem.extension":"Extension","MedicinalProductPackaged.packageItem.id":"System.String","MedicinalProductPackaged.packageItem.identifier":"Identifier","MedicinalProductPackaged.packageItem.manufacturedItem":"Reference","MedicinalProductPackaged.packageItem.manufacturer":"Reference","MedicinalProductPackaged.packageItem.material":"CodeableConcept","MedicinalProductPackaged.packageItem.modifierExtension":"Extension","MedicinalProductPackaged.packageItem.otherCharacteristics":"CodeableConcept","MedicinalProductPackaged.packageItem.physicalCharacteristics":"ProdCharacteristic","MedicinalProductPackaged.packageItem.quantity":"Quantity","MedicinalProductPackaged.packageItem.shelfLifeStorage":"ProductShelfLife","MedicinalProductPackaged.packageItem.type":"CodeableConcept","MedicinalProductPackaged.subject":"Reference","MedicinalProductPackaged.text":"Narrative","MedicinalProductPharmaceutical.administrableDoseForm":"CodeableConcept","MedicinalProductPharmaceutical.characteristics":"BackboneElement","MedicinalProductPharmaceutical.characteristics.code":"CodeableConcept","MedicinalProductPharmaceutical.characteristics.extension":"Extension","MedicinalProductPharmaceutical.characteristics.id":"System.String","MedicinalProductPharmaceutical.characteristics.modifierExtension":"Extension","MedicinalProductPharmaceutical.characteristics.status":"CodeableConcept","MedicinalProductPharmaceutical.contained":"Resource","MedicinalProductPharmaceutical.device":"Reference","MedicinalProductPharmaceutical.extension":"Extension","MedicinalProductPharmaceutical.id":"System.String","MedicinalProductPharmaceutical.identifier":"Identifier","MedicinalProductPharmaceutical.implicitRules":"uri","MedicinalProductPharmaceutical.ingredient":"Reference","MedicinalProductPharmaceutical.language":"code","MedicinalProductPharmaceutical.meta":"Meta","MedicinalProductPharmaceutical.modifierExtension":"Extension","MedicinalProductPharmaceutical.routeOfAdministration":"BackboneElement","MedicinalProductPharmaceutical.routeOfAdministration.code":"CodeableConcept","MedicinalProductPharmaceutical.routeOfAdministration.extension":"Extension","MedicinalProductPharmaceutical.routeOfAdministration.firstDose":"Quantity","MedicinalProductPharmaceutical.routeOfAdministration.id":"System.String","MedicinalProductPharmaceutical.routeOfAdministration.maxDosePerDay":"Quantity","MedicinalProductPharmaceutical.routeOfAdministration.maxDosePerTreatmentPeriod":"Ratio","MedicinalProductPharmaceutical.routeOfAdministration.maxSingleDose":"Quantity","MedicinalProductPharmaceutical.routeOfAdministration.maxTreatmentPeriod":"Duration","MedicinalProductPharmaceutical.routeOfAdministration.modifierExtension":"Extension","MedicinalProductPharmaceutical.routeOfAdministration.targetSpecies":"BackboneElement","MedicinalProductPharmaceutical.routeOfAdministration.targetSpecies.code":"CodeableConcept","MedicinalProductPharmaceutical.routeOfAdministration.targetSpecies.extension":"Extension","MedicinalProductPharmaceutical.routeOfAdministration.targetSpecies.id":"System.String","MedicinalProductPharmaceutical.routeOfAdministration.targetSpecies.modifierExtension":"Extension","MedicinalProductPharmaceutical.routeOfAdministration.targetSpecies.withdrawalPeriod":"BackboneElement","MedicinalProductPharmaceutical.routeOfAdministration.targetSpecies.withdrawalPeriod.extension":"Extension","MedicinalProductPharmaceutical.routeOfAdministration.targetSpecies.withdrawalPeriod.id":"System.String","MedicinalProductPharmaceutical.routeOfAdministration.targetSpecies.withdrawalPeriod.modifierExtension":"Extension","MedicinalProductPharmaceutical.routeOfAdministration.targetSpecies.withdrawalPeriod.supportingInformation":"string","MedicinalProductPharmaceutical.routeOfAdministration.targetSpecies.withdrawalPeriod.tissue":"CodeableConcept","MedicinalProductPharmaceutical.routeOfAdministration.targetSpecies.withdrawalPeriod.value":"Quantity","MedicinalProductPharmaceutical.text":"Narrative","MedicinalProductPharmaceutical.unitOfPresentation":"CodeableConcept","MedicinalProductUndesirableEffect.classification":"CodeableConcept","MedicinalProductUndesirableEffect.contained":"Resource","MedicinalProductUndesirableEffect.extension":"Extension","MedicinalProductUndesirableEffect.frequencyOfOccurrence":"CodeableConcept","MedicinalProductUndesirableEffect.id":"System.String","MedicinalProductUndesirableEffect.implicitRules":"uri","MedicinalProductUndesirableEffect.language":"code","MedicinalProductUndesirableEffect.meta":"Meta","MedicinalProductUndesirableEffect.modifierExtension":"Extension","MedicinalProductUndesirableEffect.population":"Population","MedicinalProductUndesirableEffect.subject":"Reference","MedicinalProductUndesirableEffect.symptomConditionEffect":"CodeableConcept","MedicinalProductUndesirableEffect.text":"Narrative","MessageDefinition.allowedResponse":"BackboneElement","MessageDefinition.allowedResponse.extension":"Extension","MessageDefinition.allowedResponse.id":"System.String","MessageDefinition.allowedResponse.message":"canonical","MessageDefinition.allowedResponse.modifierExtension":"Extension","MessageDefinition.allowedResponse.situation":"markdown","MessageDefinition.base":"canonical","MessageDefinition.category":"code","MessageDefinition.contact":"ContactDetail","MessageDefinition.contained":"Resource","MessageDefinition.copyright":"markdown","MessageDefinition.date":"dateTime","MessageDefinition.description":"markdown","MessageDefinition.eventCoding":"Coding","MessageDefinition.eventUri":"uri","MessageDefinition.experimental":"boolean","MessageDefinition.extension":"Extension","MessageDefinition.focus":"BackboneElement","MessageDefinition.focus.code":"code","MessageDefinition.focus.extension":"Extension","MessageDefinition.focus.id":"System.String","MessageDefinition.focus.max":"string","MessageDefinition.focus.min":"unsignedInt","MessageDefinition.focus.modifierExtension":"Extension","MessageDefinition.focus.profile":"canonical","MessageDefinition.graph":"canonical","MessageDefinition.id":"System.String","MessageDefinition.identifier":"Identifier","MessageDefinition.implicitRules":"uri","MessageDefinition.jurisdiction":"CodeableConcept","MessageDefinition.language":"code","MessageDefinition.meta":"Meta","MessageDefinition.modifierExtension":"Extension","MessageDefinition.name":"string","MessageDefinition.parent":"canonical","MessageDefinition.publisher":"string","MessageDefinition.purpose":"markdown","MessageDefinition.replaces":"canonical","MessageDefinition.responseRequired":"code","MessageDefinition.status":"code","MessageDefinition.text":"Narrative","MessageDefinition.title":"string","MessageDefinition.url":"uri","MessageDefinition.useContext":"UsageContext","MessageDefinition.version":"string","MessageHeader.author":"Reference","MessageHeader.contained":"Resource","MessageHeader.definition":"canonical","MessageHeader.destination":"BackboneElement","MessageHeader.destination.endpoint":"url","MessageHeader.destination.extension":"Extension","MessageHeader.destination.id":"System.String","MessageHeader.destination.modifierExtension":"Extension","MessageHeader.destination.name":"string","MessageHeader.destination.receiver":"Reference","MessageHeader.destination.target":"Reference","MessageHeader.enterer":"Reference","MessageHeader.eventCoding":"Coding","MessageHeader.eventUri":"uri","MessageHeader.extension":"Extension","MessageHeader.focus":"Reference","MessageHeader.id":"System.String","MessageHeader.implicitRules":"uri","MessageHeader.language":"code","MessageHeader.meta":"Meta","MessageHeader.modifierExtension":"Extension","MessageHeader.reason":"CodeableConcept","MessageHeader.response":"BackboneElement","MessageHeader.response.code":"code","MessageHeader.response.details":"Reference","MessageHeader.response.extension":"Extension","MessageHeader.response.id":"System.String","MessageHeader.response.identifier":"id","MessageHeader.response.modifierExtension":"Extension","MessageHeader.responsible":"Reference","MessageHeader.sender":"Reference","MessageHeader.source":"BackboneElement","MessageHeader.source.contact":"ContactPoint","MessageHeader.source.endpoint":"url","MessageHeader.source.extension":"Extension","MessageHeader.source.id":"System.String","MessageHeader.source.modifierExtension":"Extension","MessageHeader.source.name":"string","MessageHeader.source.software":"string","MessageHeader.source.version":"string","MessageHeader.text":"Narrative","Meta.extension":"Extension","Meta.id":"System.String","Meta.lastUpdated":"instant","Meta.profile":"canonical","Meta.security":"Coding","Meta.source":"uri","Meta.tag":"Coding","Meta.versionId":"id","MetadataResource.contact":"ContactDetail","MetadataResource.contained":"Resource","MetadataResource.date":"dateTime","MetadataResource.description":"markdown","MetadataResource.experimental":"boolean","MetadataResource.extension":"Extension","MetadataResource.id":"System.String","MetadataResource.implicitRules":"uri","MetadataResource.jurisdiction":"CodeableConcept","MetadataResource.language":"code","MetadataResource.meta":"Meta","MetadataResource.modifierExtension":"Extension","MetadataResource.name":"string","MetadataResource.publisher":"string","MetadataResource.status":"code","MetadataResource.text":"Narrative","MetadataResource.title":"string","MetadataResource.url":"uri","MetadataResource.useContext":"UsageContext","MetadataResource.version":"string","MolecularSequence.contained":"Resource","MolecularSequence.coordinateSystem":"integer","MolecularSequence.device":"Reference","MolecularSequence.extension":"Extension","MolecularSequence.id":"System.String","MolecularSequence.identifier":"Identifier","MolecularSequence.implicitRules":"uri","MolecularSequence.language":"code","MolecularSequence.meta":"Meta","MolecularSequence.modifierExtension":"Extension","MolecularSequence.observedSeq":"string","MolecularSequence.patient":"Reference","MolecularSequence.performer":"Reference","MolecularSequence.pointer":"Reference","MolecularSequence.quality":"BackboneElement","MolecularSequence.quality.end":"integer","MolecularSequence.quality.extension":"Extension","MolecularSequence.quality.fScore":"decimal","MolecularSequence.quality.gtFP":"decimal","MolecularSequence.quality.id":"System.String","MolecularSequence.quality.method":"CodeableConcept","MolecularSequence.quality.modifierExtension":"Extension","MolecularSequence.quality.precision":"decimal","MolecularSequence.quality.queryFP":"decimal","MolecularSequence.quality.queryTP":"decimal","MolecularSequence.quality.recall":"decimal","MolecularSequence.quality.roc":"BackboneElement","MolecularSequence.quality.roc.extension":"Extension","MolecularSequence.quality.roc.fMeasure":"decimal","MolecularSequence.quality.roc.id":"System.String","MolecularSequence.quality.roc.modifierExtension":"Extension","MolecularSequence.quality.roc.numFN":"integer","MolecularSequence.quality.roc.numFP":"integer","MolecularSequence.quality.roc.numTP":"integer","MolecularSequence.quality.roc.precision":"decimal","MolecularSequence.quality.roc.score":"integer","MolecularSequence.quality.roc.sensitivity":"decimal","MolecularSequence.quality.score":"Quantity","MolecularSequence.quality.standardSequence":"CodeableConcept","MolecularSequence.quality.start":"integer","MolecularSequence.quality.truthFN":"decimal","MolecularSequence.quality.truthTP":"decimal","MolecularSequence.quality.type":"code","MolecularSequence.quantity":"Quantity","MolecularSequence.readCoverage":"integer","MolecularSequence.referenceSeq":"BackboneElement","MolecularSequence.referenceSeq.chromosome":"CodeableConcept","MolecularSequence.referenceSeq.extension":"Extension","MolecularSequence.referenceSeq.genomeBuild":"string","MolecularSequence.referenceSeq.id":"System.String","MolecularSequence.referenceSeq.modifierExtension":"Extension","MolecularSequence.referenceSeq.orientation":"code","MolecularSequence.referenceSeq.referenceSeqId":"CodeableConcept","MolecularSequence.referenceSeq.referenceSeqPointer":"Reference","MolecularSequence.referenceSeq.referenceSeqString":"string","MolecularSequence.referenceSeq.strand":"code","MolecularSequence.referenceSeq.windowEnd":"integer","MolecularSequence.referenceSeq.windowStart":"integer","MolecularSequence.repository":"BackboneElement","MolecularSequence.repository.datasetId":"string","MolecularSequence.repository.extension":"Extension","MolecularSequence.repository.id":"System.String","MolecularSequence.repository.modifierExtension":"Extension","MolecularSequence.repository.name":"string","MolecularSequence.repository.readsetId":"string","MolecularSequence.repository.type":"code","MolecularSequence.repository.url":"uri","MolecularSequence.repository.variantsetId":"string","MolecularSequence.specimen":"Reference","MolecularSequence.structureVariant":"BackboneElement","MolecularSequence.structureVariant.exact":"boolean","MolecularSequence.structureVariant.extension":"Extension","MolecularSequence.structureVariant.id":"System.String","MolecularSequence.structureVariant.inner":"BackboneElement","MolecularSequence.structureVariant.inner.end":"integer","MolecularSequence.structureVariant.inner.extension":"Extension","MolecularSequence.structureVariant.inner.id":"System.String","MolecularSequence.structureVariant.inner.modifierExtension":"Extension","MolecularSequence.structureVariant.inner.start":"integer","MolecularSequence.structureVariant.length":"integer","MolecularSequence.structureVariant.modifierExtension":"Extension","MolecularSequence.structureVariant.outer":"BackboneElement","MolecularSequence.structureVariant.outer.end":"integer","MolecularSequence.structureVariant.outer.extension":"Extension","MolecularSequence.structureVariant.outer.id":"System.String","MolecularSequence.structureVariant.outer.modifierExtension":"Extension","MolecularSequence.structureVariant.outer.start":"integer","MolecularSequence.structureVariant.variantType":"CodeableConcept","MolecularSequence.text":"Narrative","MolecularSequence.type":"code","MolecularSequence.variant":"BackboneElement","MolecularSequence.variant.cigar":"string","MolecularSequence.variant.end":"integer","MolecularSequence.variant.extension":"Extension","MolecularSequence.variant.id":"System.String","MolecularSequence.variant.modifierExtension":"Extension","MolecularSequence.variant.observedAllele":"string","MolecularSequence.variant.referenceAllele":"string","MolecularSequence.variant.start":"integer","MolecularSequence.variant.variantPointer":"Reference","Money.currency":"code","Money.extension":"Extension","Money.id":"System.String","Money.value":"decimal","NamingSystem.contact":"ContactDetail","NamingSystem.contained":"Resource","NamingSystem.date":"dateTime","NamingSystem.description":"markdown","NamingSystem.extension":"Extension","NamingSystem.id":"System.String","NamingSystem.implicitRules":"uri","NamingSystem.jurisdiction":"CodeableConcept","NamingSystem.kind":"code","NamingSystem.language":"code","NamingSystem.meta":"Meta","NamingSystem.modifierExtension":"Extension","NamingSystem.name":"string","NamingSystem.publisher":"string","NamingSystem.responsible":"string","NamingSystem.status":"code","NamingSystem.text":"Narrative","NamingSystem.type":"CodeableConcept","NamingSystem.uniqueId":"BackboneElement","NamingSystem.uniqueId.comment":"string","NamingSystem.uniqueId.extension":"Extension","NamingSystem.uniqueId.id":"System.String","NamingSystem.uniqueId.modifierExtension":"Extension","NamingSystem.uniqueId.period":"Period","NamingSystem.uniqueId.preferred":"boolean","NamingSystem.uniqueId.type":"code","NamingSystem.uniqueId.value":"string","NamingSystem.usage":"string","NamingSystem.useContext":"UsageContext","Narrative.div":"xhtml","Narrative.extension":"Extension","Narrative.id":"System.String","Narrative.status":"code","NutritionOrder.allergyIntolerance":"Reference","NutritionOrder.contained":"Resource","NutritionOrder.dateTime":"dateTime","NutritionOrder.encounter":"Reference","NutritionOrder.enteralFormula":"BackboneElement","NutritionOrder.enteralFormula.additiveProductName":"string","NutritionOrder.enteralFormula.additiveType":"CodeableConcept","NutritionOrder.enteralFormula.administration":"BackboneElement","NutritionOrder.enteralFormula.administration.extension":"Extension","NutritionOrder.enteralFormula.administration.id":"System.String","NutritionOrder.enteralFormula.administration.modifierExtension":"Extension","NutritionOrder.enteralFormula.administration.quantity":"Quantity","NutritionOrder.enteralFormula.administration.rateQuantity":"Quantity","NutritionOrder.enteralFormula.administration.rateRatio":"Ratio","NutritionOrder.enteralFormula.administration.schedule":"Timing","NutritionOrder.enteralFormula.administrationInstruction":"string","NutritionOrder.enteralFormula.baseFormulaProductName":"string","NutritionOrder.enteralFormula.baseFormulaType":"CodeableConcept","NutritionOrder.enteralFormula.caloricDensity":"Quantity","NutritionOrder.enteralFormula.extension":"Extension","NutritionOrder.enteralFormula.id":"System.String","NutritionOrder.enteralFormula.maxVolumeToDeliver":"Quantity","NutritionOrder.enteralFormula.modifierExtension":"Extension","NutritionOrder.enteralFormula.routeofAdministration":"CodeableConcept","NutritionOrder.excludeFoodModifier":"CodeableConcept","NutritionOrder.extension":"Extension","NutritionOrder.foodPreferenceModifier":"CodeableConcept","NutritionOrder.id":"System.String","NutritionOrder.identifier":"Identifier","NutritionOrder.implicitRules":"uri","NutritionOrder.instantiates":"uri","NutritionOrder.instantiatesCanonical":"canonical","NutritionOrder.instantiatesUri":"uri","NutritionOrder.intent":"code","NutritionOrder.language":"code","NutritionOrder.meta":"Meta","NutritionOrder.modifierExtension":"Extension","NutritionOrder.note":"Annotation","NutritionOrder.oralDiet":"BackboneElement","NutritionOrder.oralDiet.extension":"Extension","NutritionOrder.oralDiet.fluidConsistencyType":"CodeableConcept","NutritionOrder.oralDiet.id":"System.String","NutritionOrder.oralDiet.instruction":"string","NutritionOrder.oralDiet.modifierExtension":"Extension","NutritionOrder.oralDiet.nutrient":"BackboneElement","NutritionOrder.oralDiet.nutrient.amount":"Quantity","NutritionOrder.oralDiet.nutrient.extension":"Extension","NutritionOrder.oralDiet.nutrient.id":"System.String","NutritionOrder.oralDiet.nutrient.modifier":"CodeableConcept","NutritionOrder.oralDiet.nutrient.modifierExtension":"Extension","NutritionOrder.oralDiet.schedule":"Timing","NutritionOrder.oralDiet.texture":"BackboneElement","NutritionOrder.oralDiet.texture.extension":"Extension","NutritionOrder.oralDiet.texture.foodType":"CodeableConcept","NutritionOrder.oralDiet.texture.id":"System.String","NutritionOrder.oralDiet.texture.modifier":"CodeableConcept","NutritionOrder.oralDiet.texture.modifierExtension":"Extension","NutritionOrder.oralDiet.type":"CodeableConcept","NutritionOrder.orderer":"Reference","NutritionOrder.patient":"Reference","NutritionOrder.status":"code","NutritionOrder.supplement":"BackboneElement","NutritionOrder.supplement.extension":"Extension","NutritionOrder.supplement.id":"System.String","NutritionOrder.supplement.instruction":"string","NutritionOrder.supplement.modifierExtension":"Extension","NutritionOrder.supplement.productName":"string","NutritionOrder.supplement.quantity":"Quantity","NutritionOrder.supplement.schedule":"Timing","NutritionOrder.supplement.type":"CodeableConcept","NutritionOrder.text":"Narrative","Observation.basedOn":"Reference","Observation.bodySite":"CodeableConcept","Observation.category":"CodeableConcept","Observation.code":"CodeableConcept","Observation.component":"BackboneElement","Observation.component.code":"CodeableConcept","Observation.component.dataAbsentReason":"CodeableConcept","Observation.component.extension":"Extension","Observation.component.id":"System.String","Observation.component.interpretation":"CodeableConcept","Observation.component.modifierExtension":"Extension","Observation.component.valueBoolean":"boolean","Observation.component.valueCodeableConcept":"CodeableConcept","Observation.component.valueDateTime":"dateTime","Observation.component.valueInteger":"integer","Observation.component.valuePeriod":"Period","Observation.component.valueQuantity":"Quantity","Observation.component.valueRange":"Range","Observation.component.valueRatio":"Ratio","Observation.component.valueSampledData":"SampledData","Observation.component.valueString":"string","Observation.component.valueTime":"time","Observation.contained":"Resource","Observation.dataAbsentReason":"CodeableConcept","Observation.derivedFrom":"Reference","Observation.device":"Reference","Observation.effectiveDateTime":"dateTime","Observation.effectiveInstant":"instant","Observation.effectivePeriod":"Period","Observation.effectiveTiming":"Timing","Observation.encounter":"Reference","Observation.extension":"Extension","Observation.focus":"Reference","Observation.hasMember":"Reference","Observation.id":"System.String","Observation.identifier":"Identifier","Observation.implicitRules":"uri","Observation.interpretation":"CodeableConcept","Observation.issued":"instant","Observation.language":"code","Observation.meta":"Meta","Observation.method":"CodeableConcept","Observation.modifierExtension":"Extension","Observation.note":"Annotation","Observation.partOf":"Reference","Observation.performer":"Reference","Observation.referenceRange":"BackboneElement","Observation.referenceRange.age":"Range","Observation.referenceRange.appliesTo":"CodeableConcept","Observation.referenceRange.extension":"Extension","Observation.referenceRange.high":"Quantity","Observation.referenceRange.id":"System.String","Observation.referenceRange.low":"Quantity","Observation.referenceRange.modifierExtension":"Extension","Observation.referenceRange.text":"string","Observation.referenceRange.type":"CodeableConcept","Observation.specimen":"Reference","Observation.status":"code","Observation.subject":"Reference","Observation.text":"Narrative","Observation.valueBoolean":"boolean","Observation.valueCodeableConcept":"CodeableConcept","Observation.valueDateTime":"dateTime","Observation.valueInteger":"integer","Observation.valuePeriod":"Period","Observation.valueQuantity":"Quantity","Observation.valueRange":"Range","Observation.valueRatio":"Ratio","Observation.valueSampledData":"SampledData","Observation.valueString":"string","Observation.valueTime":"time","ObservationDefinition.abnormalCodedValueSet":"Reference","ObservationDefinition.category":"CodeableConcept","ObservationDefinition.code":"CodeableConcept","ObservationDefinition.contained":"Resource","ObservationDefinition.criticalCodedValueSet":"Reference","ObservationDefinition.extension":"Extension","ObservationDefinition.id":"System.String","ObservationDefinition.identifier":"Identifier","ObservationDefinition.implicitRules":"uri","ObservationDefinition.language":"code","ObservationDefinition.meta":"Meta","ObservationDefinition.method":"CodeableConcept","ObservationDefinition.modifierExtension":"Extension","ObservationDefinition.multipleResultsAllowed":"boolean","ObservationDefinition.normalCodedValueSet":"Reference","ObservationDefinition.permittedDataType":"code","ObservationDefinition.preferredReportName":"string","ObservationDefinition.qualifiedInterval":"BackboneElement","ObservationDefinition.qualifiedInterval.age":"Range","ObservationDefinition.qualifiedInterval.appliesTo":"CodeableConcept","ObservationDefinition.qualifiedInterval.category":"code","ObservationDefinition.qualifiedInterval.condition":"string","ObservationDefinition.qualifiedInterval.context":"CodeableConcept","ObservationDefinition.qualifiedInterval.extension":"Extension","ObservationDefinition.qualifiedInterval.gender":"code","ObservationDefinition.qualifiedInterval.gestationalAge":"Range","ObservationDefinition.qualifiedInterval.id":"System.String","ObservationDefinition.qualifiedInterval.modifierExtension":"Extension","ObservationDefinition.qualifiedInterval.range":"Range","ObservationDefinition.quantitativeDetails":"BackboneElement","ObservationDefinition.quantitativeDetails.conversionFactor":"decimal","ObservationDefinition.quantitativeDetails.customaryUnit":"CodeableConcept","ObservationDefinition.quantitativeDetails.decimalPrecision":"integer","ObservationDefinition.quantitativeDetails.extension":"Extension","ObservationDefinition.quantitativeDetails.id":"System.String","ObservationDefinition.quantitativeDetails.modifierExtension":"Extension","ObservationDefinition.quantitativeDetails.unit":"CodeableConcept","ObservationDefinition.text":"Narrative","ObservationDefinition.validCodedValueSet":"Reference","OperationDefinition.affectsState":"boolean","OperationDefinition.base":"canonical","OperationDefinition.code":"code","OperationDefinition.comment":"markdown","OperationDefinition.contact":"ContactDetail","OperationDefinition.contained":"Resource","OperationDefinition.date":"dateTime","OperationDefinition.description":"markdown","OperationDefinition.experimental":"boolean","OperationDefinition.extension":"Extension","OperationDefinition.id":"System.String","OperationDefinition.implicitRules":"uri","OperationDefinition.inputProfile":"canonical","OperationDefinition.instance":"boolean","OperationDefinition.jurisdiction":"CodeableConcept","OperationDefinition.kind":"code","OperationDefinition.language":"code","OperationDefinition.meta":"Meta","OperationDefinition.modifierExtension":"Extension","OperationDefinition.name":"string","OperationDefinition.outputProfile":"canonical","OperationDefinition.overload":"BackboneElement","OperationDefinition.overload.comment":"string","OperationDefinition.overload.extension":"Extension","OperationDefinition.overload.id":"System.String","OperationDefinition.overload.modifierExtension":"Extension","OperationDefinition.overload.parameterName":"string","OperationDefinition.parameter":"BackboneElement","OperationDefinition.parameter.binding":"BackboneElement","OperationDefinition.parameter.binding.extension":"Extension","OperationDefinition.parameter.binding.id":"System.String","OperationDefinition.parameter.binding.modifierExtension":"Extension","OperationDefinition.parameter.binding.strength":"code","OperationDefinition.parameter.binding.valueSet":"canonical","OperationDefinition.parameter.documentation":"string","OperationDefinition.parameter.extension":"Extension","OperationDefinition.parameter.id":"System.String","OperationDefinition.parameter.max":"string","OperationDefinition.parameter.min":"integer","OperationDefinition.parameter.modifierExtension":"Extension","OperationDefinition.parameter.name":"code","OperationDefinition.parameter.referencedFrom":"BackboneElement","OperationDefinition.parameter.referencedFrom.extension":"Extension","OperationDefinition.parameter.referencedFrom.id":"System.String","OperationDefinition.parameter.referencedFrom.modifierExtension":"Extension","OperationDefinition.parameter.referencedFrom.source":"string","OperationDefinition.parameter.referencedFrom.sourceId":"string","OperationDefinition.parameter.searchType":"code","OperationDefinition.parameter.targetProfile":"canonical","OperationDefinition.parameter.type":"code","OperationDefinition.parameter.use":"code","OperationDefinition.publisher":"string","OperationDefinition.purpose":"markdown","OperationDefinition.resource":"code","OperationDefinition.status":"code","OperationDefinition.system":"boolean","OperationDefinition.text":"Narrative","OperationDefinition.title":"string","OperationDefinition.type":"boolean","OperationDefinition.url":"uri","OperationDefinition.useContext":"UsageContext","OperationDefinition.version":"string","OperationOutcome.contained":"Resource","OperationOutcome.extension":"Extension","OperationOutcome.id":"System.String","OperationOutcome.implicitRules":"uri","OperationOutcome.issue":"BackboneElement","OperationOutcome.issue.code":"code","OperationOutcome.issue.details":"CodeableConcept","OperationOutcome.issue.diagnostics":"string","OperationOutcome.issue.expression":"string","OperationOutcome.issue.extension":"Extension","OperationOutcome.issue.id":"System.String","OperationOutcome.issue.location":"string","OperationOutcome.issue.modifierExtension":"Extension","OperationOutcome.issue.severity":"code","OperationOutcome.language":"code","OperationOutcome.meta":"Meta","OperationOutcome.modifierExtension":"Extension","OperationOutcome.text":"Narrative","Organization.active":"boolean","Organization.address":"Address","Organization.alias":"string","Organization.contact":"BackboneElement","Organization.contact.address":"Address","Organization.contact.extension":"Extension","Organization.contact.id":"System.String","Organization.contact.modifierExtension":"Extension","Organization.contact.name":"HumanName","Organization.contact.purpose":"CodeableConcept","Organization.contact.telecom":"ContactPoint","Organization.contained":"Resource","Organization.endpoint":"Reference","Organization.extension":"Extension","Organization.id":"System.String","Organization.identifier":"Identifier","Organization.implicitRules":"uri","Organization.language":"code","Organization.meta":"Meta","Organization.modifierExtension":"Extension","Organization.name":"string","Organization.partOf":"Reference","Organization.telecom":"ContactPoint","Organization.text":"Narrative","Organization.type":"CodeableConcept","OrganizationAffiliation.active":"boolean","OrganizationAffiliation.code":"CodeableConcept","OrganizationAffiliation.contained":"Resource","OrganizationAffiliation.endpoint":"Reference","OrganizationAffiliation.extension":"Extension","OrganizationAffiliation.healthcareService":"Reference","OrganizationAffiliation.id":"System.String","OrganizationAffiliation.identifier":"Identifier","OrganizationAffiliation.implicitRules":"uri","OrganizationAffiliation.language":"code","OrganizationAffiliation.location":"Reference","OrganizationAffiliation.meta":"Meta","OrganizationAffiliation.modifierExtension":"Extension","OrganizationAffiliation.network":"Reference","OrganizationAffiliation.organization":"Reference","OrganizationAffiliation.participatingOrganization":"Reference","OrganizationAffiliation.period":"Period","OrganizationAffiliation.specialty":"CodeableConcept","OrganizationAffiliation.telecom":"ContactPoint","OrganizationAffiliation.text":"Narrative","ParameterDefinition.documentation":"string","ParameterDefinition.extension":"Extension","ParameterDefinition.id":"System.String","ParameterDefinition.max":"string","ParameterDefinition.min":"integer","ParameterDefinition.name":"code","ParameterDefinition.profile":"canonical","ParameterDefinition.type":"code","ParameterDefinition.use":"code","Parameters.id":"System.String","Parameters.implicitRules":"uri","Parameters.language":"code","Parameters.meta":"Meta","Parameters.parameter":"BackboneElement","Parameters.parameter.extension":"Extension","Parameters.parameter.id":"System.String","Parameters.parameter.modifierExtension":"Extension","Parameters.parameter.name":"string","Parameters.parameter.resource":"Resource","Parameters.parameter.valueAddress":"Address","Parameters.parameter.valueAge":"Age","Parameters.parameter.valueAnnotation":"Annotation","Parameters.parameter.valueAttachment":"Attachment","Parameters.parameter.valueBase64Binary":"base64Binary","Parameters.parameter.valueBoolean":"boolean","Parameters.parameter.valueCanonical":"canonical","Parameters.parameter.valueCode":"code","Parameters.parameter.valueCodeableConcept":"CodeableConcept","Parameters.parameter.valueCoding":"Coding","Parameters.parameter.valueContactDetail":"ContactDetail","Parameters.parameter.valueContactPoint":"ContactPoint","Parameters.parameter.valueContributor":"Contributor","Parameters.parameter.valueCount":"Count","Parameters.parameter.valueDataRequirement":"DataRequirement","Parameters.parameter.valueDate":"date","Parameters.parameter.valueDateTime":"dateTime","Parameters.parameter.valueDecimal":"decimal","Parameters.parameter.valueDistance":"Distance","Parameters.parameter.valueDosage":"Dosage","Parameters.parameter.valueDuration":"Duration","Parameters.parameter.valueExpression":"Expression","Parameters.parameter.valueHumanName":"HumanName","Parameters.parameter.valueId":"id","Parameters.parameter.valueIdentifier":"Identifier","Parameters.parameter.valueInstant":"instant","Parameters.parameter.valueInteger":"integer","Parameters.parameter.valueMarkdown":"markdown","Parameters.parameter.valueMeta":"Meta","Parameters.parameter.valueMoney":"Money","Parameters.parameter.valueOid":"oid","Parameters.parameter.valueParameterDefinition":"ParameterDefinition","Parameters.parameter.valuePeriod":"Period","Parameters.parameter.valuePositiveInt":"positiveInt","Parameters.parameter.valueQuantity":"Quantity","Parameters.parameter.valueRange":"Range","Parameters.parameter.valueRatio":"Ratio","Parameters.parameter.valueReference":"Reference","Parameters.parameter.valueRelatedArtifact":"RelatedArtifact","Parameters.parameter.valueSampledData":"SampledData","Parameters.parameter.valueSignature":"Signature","Parameters.parameter.valueString":"string","Parameters.parameter.valueTime":"time","Parameters.parameter.valueTiming":"Timing","Parameters.parameter.valueTriggerDefinition":"TriggerDefinition","Parameters.parameter.valueUnsignedInt":"unsignedInt","Parameters.parameter.valueUri":"uri","Parameters.parameter.valueUrl":"url","Parameters.parameter.valueUsageContext":"UsageContext","Parameters.parameter.valueUuid":"uuid","Patient.active":"boolean","Patient.address":"Address","Patient.birthDate":"date","Patient.communication":"BackboneElement","Patient.communication.extension":"Extension","Patient.communication.id":"System.String","Patient.communication.language":"CodeableConcept","Patient.communication.modifierExtension":"Extension","Patient.communication.preferred":"boolean","Patient.contact":"BackboneElement","Patient.contact.address":"Address","Patient.contact.extension":"Extension","Patient.contact.gender":"code","Patient.contact.id":"System.String","Patient.contact.modifierExtension":"Extension","Patient.contact.name":"HumanName","Patient.contact.organization":"Reference","Patient.contact.period":"Period","Patient.contact.relationship":"CodeableConcept","Patient.contact.telecom":"ContactPoint","Patient.contained":"Resource","Patient.deceasedBoolean":"boolean","Patient.deceasedDateTime":"dateTime","Patient.extension":"Extension","Patient.gender":"code","Patient.generalPractitioner":"Reference","Patient.id":"System.String","Patient.identifier":"Identifier","Patient.implicitRules":"uri","Patient.language":"code","Patient.link":"BackboneElement","Patient.link.extension":"Extension","Patient.link.id":"System.String","Patient.link.modifierExtension":"Extension","Patient.link.other":"Reference","Patient.link.type":"code","Patient.managingOrganization":"Reference","Patient.maritalStatus":"CodeableConcept","Patient.meta":"Meta","Patient.modifierExtension":"Extension","Patient.multipleBirthBoolean":"boolean","Patient.multipleBirthInteger":"integer","Patient.name":"HumanName","Patient.photo":"Attachment","Patient.telecom":"ContactPoint","Patient.text":"Narrative","PaymentNotice.amount":"Money","PaymentNotice.contained":"Resource","PaymentNotice.created":"dateTime","PaymentNotice.extension":"Extension","PaymentNotice.id":"System.String","PaymentNotice.identifier":"Identifier","PaymentNotice.implicitRules":"uri","PaymentNotice.language":"code","PaymentNotice.meta":"Meta","PaymentNotice.modifierExtension":"Extension","PaymentNotice.payee":"Reference","PaymentNotice.payment":"Reference","PaymentNotice.paymentDate":"date","PaymentNotice.paymentStatus":"CodeableConcept","PaymentNotice.provider":"Reference","PaymentNotice.recipient":"Reference","PaymentNotice.request":"Reference","PaymentNotice.response":"Reference","PaymentNotice.status":"code","PaymentNotice.text":"Narrative","PaymentReconciliation.contained":"Resource","PaymentReconciliation.created":"dateTime","PaymentReconciliation.detail":"BackboneElement","PaymentReconciliation.detail.amount":"Money","PaymentReconciliation.detail.date":"date","PaymentReconciliation.detail.extension":"Extension","PaymentReconciliation.detail.id":"System.String","PaymentReconciliation.detail.identifier":"Identifier","PaymentReconciliation.detail.modifierExtension":"Extension","PaymentReconciliation.detail.payee":"Reference","PaymentReconciliation.detail.predecessor":"Identifier","PaymentReconciliation.detail.request":"Reference","PaymentReconciliation.detail.response":"Reference","PaymentReconciliation.detail.responsible":"Reference","PaymentReconciliation.detail.submitter":"Reference","PaymentReconciliation.detail.type":"CodeableConcept","PaymentReconciliation.disposition":"string","PaymentReconciliation.extension":"Extension","PaymentReconciliation.formCode":"CodeableConcept","PaymentReconciliation.id":"System.String","PaymentReconciliation.identifier":"Identifier","PaymentReconciliation.implicitRules":"uri","PaymentReconciliation.language":"code","PaymentReconciliation.meta":"Meta","PaymentReconciliation.modifierExtension":"Extension","PaymentReconciliation.outcome":"code","PaymentReconciliation.paymentAmount":"Money","PaymentReconciliation.paymentDate":"date","PaymentReconciliation.paymentIdentifier":"Identifier","PaymentReconciliation.paymentIssuer":"Reference","PaymentReconciliation.period":"Period","PaymentReconciliation.processNote":"BackboneElement","PaymentReconciliation.processNote.extension":"Extension","PaymentReconciliation.processNote.id":"System.String","PaymentReconciliation.processNote.modifierExtension":"Extension","PaymentReconciliation.processNote.text":"string","PaymentReconciliation.processNote.type":"code","PaymentReconciliation.request":"Reference","PaymentReconciliation.requestor":"Reference","PaymentReconciliation.status":"code","PaymentReconciliation.text":"Narrative","Period.end":"dateTime","Period.extension":"Extension","Period.id":"System.String","Period.start":"dateTime","Person.active":"boolean","Person.address":"Address","Person.birthDate":"date","Person.contained":"Resource","Person.extension":"Extension","Person.gender":"code","Person.id":"System.String","Person.identifier":"Identifier","Person.implicitRules":"uri","Person.language":"code","Person.link":"BackboneElement","Person.link.assurance":"code","Person.link.extension":"Extension","Person.link.id":"System.String","Person.link.modifierExtension":"Extension","Person.link.target":"Reference","Person.managingOrganization":"Reference","Person.meta":"Meta","Person.modifierExtension":"Extension","Person.name":"HumanName","Person.photo":"Attachment","Person.telecom":"ContactPoint","Person.text":"Narrative","PlanDefinition.action":"BackboneElement","PlanDefinition.action.cardinalityBehavior":"code","PlanDefinition.action.code":"CodeableConcept","PlanDefinition.action.condition":"BackboneElement","PlanDefinition.action.condition.expression":"Expression","PlanDefinition.action.condition.extension":"Extension","PlanDefinition.action.condition.id":"System.String","PlanDefinition.action.condition.kind":"code","PlanDefinition.action.condition.modifierExtension":"Extension","PlanDefinition.action.definitionCanonical":"canonical","PlanDefinition.action.definitionUri":"uri","PlanDefinition.action.description":"string","PlanDefinition.action.documentation":"RelatedArtifact","PlanDefinition.action.dynamicValue":"BackboneElement","PlanDefinition.action.dynamicValue.expression":"Expression","PlanDefinition.action.dynamicValue.extension":"Extension","PlanDefinition.action.dynamicValue.id":"System.String","PlanDefinition.action.dynamicValue.modifierExtension":"Extension","PlanDefinition.action.dynamicValue.path":"string","PlanDefinition.action.extension":"Extension","PlanDefinition.action.goalId":"id","PlanDefinition.action.groupingBehavior":"code","PlanDefinition.action.id":"System.String","PlanDefinition.action.input":"DataRequirement","PlanDefinition.action.modifierExtension":"Extension","PlanDefinition.action.output":"DataRequirement","PlanDefinition.action.participant":"BackboneElement","PlanDefinition.action.participant.extension":"Extension","PlanDefinition.action.participant.id":"System.String","PlanDefinition.action.participant.modifierExtension":"Extension","PlanDefinition.action.participant.role":"CodeableConcept","PlanDefinition.action.participant.type":"code","PlanDefinition.action.precheckBehavior":"code","PlanDefinition.action.prefix":"string","PlanDefinition.action.priority":"code","PlanDefinition.action.reason":"CodeableConcept","PlanDefinition.action.relatedAction":"BackboneElement","PlanDefinition.action.relatedAction.actionId":"id","PlanDefinition.action.relatedAction.extension":"Extension","PlanDefinition.action.relatedAction.id":"System.String","PlanDefinition.action.relatedAction.modifierExtension":"Extension","PlanDefinition.action.relatedAction.offsetDuration":"Duration","PlanDefinition.action.relatedAction.offsetRange":"Range","PlanDefinition.action.relatedAction.relationship":"code","PlanDefinition.action.requiredBehavior":"code","PlanDefinition.action.selectionBehavior":"code","PlanDefinition.action.subjectCodeableConcept":"CodeableConcept","PlanDefinition.action.subjectReference":"Reference","PlanDefinition.action.textEquivalent":"string","PlanDefinition.action.timingAge":"Age","PlanDefinition.action.timingDateTime":"dateTime","PlanDefinition.action.timingDuration":"Duration","PlanDefinition.action.timingPeriod":"Period","PlanDefinition.action.timingRange":"Range","PlanDefinition.action.timingTiming":"Timing","PlanDefinition.action.title":"string","PlanDefinition.action.transform":"canonical","PlanDefinition.action.trigger":"TriggerDefinition","PlanDefinition.action.type":"CodeableConcept","PlanDefinition.approvalDate":"date","PlanDefinition.author":"ContactDetail","PlanDefinition.contact":"ContactDetail","PlanDefinition.contained":"Resource","PlanDefinition.copyright":"markdown","PlanDefinition.date":"dateTime","PlanDefinition.description":"markdown","PlanDefinition.editor":"ContactDetail","PlanDefinition.effectivePeriod":"Period","PlanDefinition.endorser":"ContactDetail","PlanDefinition.experimental":"boolean","PlanDefinition.extension":"Extension","PlanDefinition.goal":"BackboneElement","PlanDefinition.goal.addresses":"CodeableConcept","PlanDefinition.goal.category":"CodeableConcept","PlanDefinition.goal.description":"CodeableConcept","PlanDefinition.goal.documentation":"RelatedArtifact","PlanDefinition.goal.extension":"Extension","PlanDefinition.goal.id":"System.String","PlanDefinition.goal.modifierExtension":"Extension","PlanDefinition.goal.priority":"CodeableConcept","PlanDefinition.goal.start":"CodeableConcept","PlanDefinition.goal.target":"BackboneElement","PlanDefinition.goal.target.detailCodeableConcept":"CodeableConcept","PlanDefinition.goal.target.detailQuantity":"Quantity","PlanDefinition.goal.target.detailRange":"Range","PlanDefinition.goal.target.due":"Duration","PlanDefinition.goal.target.extension":"Extension","PlanDefinition.goal.target.id":"System.String","PlanDefinition.goal.target.measure":"CodeableConcept","PlanDefinition.goal.target.modifierExtension":"Extension","PlanDefinition.id":"System.String","PlanDefinition.identifier":"Identifier","PlanDefinition.implicitRules":"uri","PlanDefinition.jurisdiction":"CodeableConcept","PlanDefinition.language":"code","PlanDefinition.lastReviewDate":"date","PlanDefinition.library":"canonical","PlanDefinition.meta":"Meta","PlanDefinition.modifierExtension":"Extension","PlanDefinition.name":"string","PlanDefinition.publisher":"string","PlanDefinition.purpose":"markdown","PlanDefinition.relatedArtifact":"RelatedArtifact","PlanDefinition.reviewer":"ContactDetail","PlanDefinition.status":"code","PlanDefinition.subjectCodeableConcept":"CodeableConcept","PlanDefinition.subjectReference":"Reference","PlanDefinition.subtitle":"string","PlanDefinition.text":"Narrative","PlanDefinition.title":"string","PlanDefinition.topic":"CodeableConcept","PlanDefinition.type":"CodeableConcept","PlanDefinition.url":"uri","PlanDefinition.usage":"string","PlanDefinition.useContext":"UsageContext","PlanDefinition.version":"string","Population.ageCodeableConcept":"CodeableConcept","Population.ageRange":"Range","Population.extension":"Extension","Population.gender":"CodeableConcept","Population.id":"System.String","Population.modifierExtension":"Extension","Population.physiologicalCondition":"CodeableConcept","Population.race":"CodeableConcept","Practitioner.active":"boolean","Practitioner.address":"Address","Practitioner.birthDate":"date","Practitioner.communication":"CodeableConcept","Practitioner.contained":"Resource","Practitioner.extension":"Extension","Practitioner.gender":"code","Practitioner.id":"System.String","Practitioner.identifier":"Identifier","Practitioner.implicitRules":"uri","Practitioner.language":"code","Practitioner.meta":"Meta","Practitioner.modifierExtension":"Extension","Practitioner.name":"HumanName","Practitioner.photo":"Attachment","Practitioner.qualification":"BackboneElement","Practitioner.qualification.code":"CodeableConcept","Practitioner.qualification.extension":"Extension","Practitioner.qualification.id":"System.String","Practitioner.qualification.identifier":"Identifier","Practitioner.qualification.issuer":"Reference","Practitioner.qualification.modifierExtension":"Extension","Practitioner.qualification.period":"Period","Practitioner.telecom":"ContactPoint","Practitioner.text":"Narrative","PractitionerRole.active":"boolean","PractitionerRole.availabilityExceptions":"string","PractitionerRole.availableTime":"BackboneElement","PractitionerRole.availableTime.allDay":"boolean","PractitionerRole.availableTime.availableEndTime":"time","PractitionerRole.availableTime.availableStartTime":"time","PractitionerRole.availableTime.daysOfWeek":"code","PractitionerRole.availableTime.extension":"Extension","PractitionerRole.availableTime.id":"System.String","PractitionerRole.availableTime.modifierExtension":"Extension","PractitionerRole.code":"CodeableConcept","PractitionerRole.contained":"Resource","PractitionerRole.endpoint":"Reference","PractitionerRole.extension":"Extension","PractitionerRole.healthcareService":"Reference","PractitionerRole.id":"System.String","PractitionerRole.identifier":"Identifier","PractitionerRole.implicitRules":"uri","PractitionerRole.language":"code","PractitionerRole.location":"Reference","PractitionerRole.meta":"Meta","PractitionerRole.modifierExtension":"Extension","PractitionerRole.notAvailable":"BackboneElement","PractitionerRole.notAvailable.description":"string","PractitionerRole.notAvailable.during":"Period","PractitionerRole.notAvailable.extension":"Extension","PractitionerRole.notAvailable.id":"System.String","PractitionerRole.notAvailable.modifierExtension":"Extension","PractitionerRole.organization":"Reference","PractitionerRole.period":"Period","PractitionerRole.practitioner":"Reference","PractitionerRole.specialty":"CodeableConcept","PractitionerRole.telecom":"ContactPoint","PractitionerRole.text":"Narrative","Procedure.asserter":"Reference","Procedure.basedOn":"Reference","Procedure.bodySite":"CodeableConcept","Procedure.category":"CodeableConcept","Procedure.code":"CodeableConcept","Procedure.complication":"CodeableConcept","Procedure.complicationDetail":"Reference","Procedure.contained":"Resource","Procedure.encounter":"Reference","Procedure.extension":"Extension","Procedure.focalDevice":"BackboneElement","Procedure.focalDevice.action":"CodeableConcept","Procedure.focalDevice.extension":"Extension","Procedure.focalDevice.id":"System.String","Procedure.focalDevice.manipulated":"Reference","Procedure.focalDevice.modifierExtension":"Extension","Procedure.followUp":"CodeableConcept","Procedure.id":"System.String","Procedure.identifier":"Identifier","Procedure.implicitRules":"uri","Procedure.instantiatesCanonical":"canonical","Procedure.instantiatesUri":"uri","Procedure.language":"code","Procedure.location":"Reference","Procedure.meta":"Meta","Procedure.modifierExtension":"Extension","Procedure.note":"Annotation","Procedure.outcome":"CodeableConcept","Procedure.partOf":"Reference","Procedure.performedAge":"Age","Procedure.performedDateTime":"dateTime","Procedure.performedPeriod":"Period","Procedure.performedRange":"Range","Procedure.performedString":"string","Procedure.performer":"BackboneElement","Procedure.performer.actor":"Reference","Procedure.performer.extension":"Extension","Procedure.performer.function":"CodeableConcept","Procedure.performer.id":"System.String","Procedure.performer.modifierExtension":"Extension","Procedure.performer.onBehalfOf":"Reference","Procedure.reasonCode":"CodeableConcept","Procedure.reasonReference":"Reference","Procedure.recorder":"Reference","Procedure.report":"Reference","Procedure.status":"code","Procedure.statusReason":"CodeableConcept","Procedure.subject":"Reference","Procedure.text":"Narrative","Procedure.usedCode":"CodeableConcept","Procedure.usedReference":"Reference","ProdCharacteristic.color":"string","ProdCharacteristic.depth":"Quantity","ProdCharacteristic.extension":"Extension","ProdCharacteristic.externalDiameter":"Quantity","ProdCharacteristic.height":"Quantity","ProdCharacteristic.id":"System.String","ProdCharacteristic.image":"Attachment","ProdCharacteristic.imprint":"string","ProdCharacteristic.modifierExtension":"Extension","ProdCharacteristic.nominalVolume":"Quantity","ProdCharacteristic.scoring":"CodeableConcept","ProdCharacteristic.shape":"string","ProdCharacteristic.weight":"Quantity","ProdCharacteristic.width":"Quantity","ProductShelfLife.extension":"Extension","ProductShelfLife.id":"System.String","ProductShelfLife.identifier":"Identifier","ProductShelfLife.modifierExtension":"Extension","ProductShelfLife.period":"Quantity","ProductShelfLife.specialPrecautionsForStorage":"CodeableConcept","ProductShelfLife.type":"CodeableConcept","Provenance.activity":"CodeableConcept","Provenance.agent":"BackboneElement","Provenance.agent.extension":"Extension","Provenance.agent.id":"System.String","Provenance.agent.modifierExtension":"Extension","Provenance.agent.onBehalfOf":"Reference","Provenance.agent.role":"CodeableConcept","Provenance.agent.type":"CodeableConcept","Provenance.agent.who":"Reference","Provenance.contained":"Resource","Provenance.entity":"BackboneElement","Provenance.entity.extension":"Extension","Provenance.entity.id":"System.String","Provenance.entity.modifierExtension":"Extension","Provenance.entity.role":"code","Provenance.entity.what":"Reference","Provenance.extension":"Extension","Provenance.id":"System.String","Provenance.implicitRules":"uri","Provenance.language":"code","Provenance.location":"Reference","Provenance.meta":"Meta","Provenance.modifierExtension":"Extension","Provenance.occurredDateTime":"dateTime","Provenance.occurredPeriod":"Period","Provenance.policy":"uri","Provenance.reason":"CodeableConcept","Provenance.recorded":"instant","Provenance.signature":"Signature","Provenance.target":"Reference","Provenance.text":"Narrative","Quantity.code":"code","Quantity.comparator":"code","Quantity.extension":"Extension","Quantity.id":"System.String","Quantity.system":"uri","Quantity.unit":"string","Quantity.value":"decimal","Questionnaire.approvalDate":"date","Questionnaire.code":"Coding","Questionnaire.contact":"ContactDetail","Questionnaire.contained":"Resource","Questionnaire.copyright":"markdown","Questionnaire.date":"dateTime","Questionnaire.derivedFrom":"canonical","Questionnaire.description":"markdown","Questionnaire.effectivePeriod":"Period","Questionnaire.experimental":"boolean","Questionnaire.extension":"Extension","Questionnaire.id":"System.String","Questionnaire.identifier":"Identifier","Questionnaire.implicitRules":"uri","Questionnaire.item":"BackboneElement","Questionnaire.item.answerOption":"BackboneElement","Questionnaire.item.answerOption.extension":"Extension","Questionnaire.item.answerOption.id":"System.String","Questionnaire.item.answerOption.initialSelected":"boolean","Questionnaire.item.answerOption.modifierExtension":"Extension","Questionnaire.item.answerOption.valueCoding":"Coding","Questionnaire.item.answerOption.valueDate":"date","Questionnaire.item.answerOption.valueInteger":"integer","Questionnaire.item.answerOption.valueReference":"Reference","Questionnaire.item.answerOption.valueString":"string","Questionnaire.item.answerOption.valueTime":"time","Questionnaire.item.answerValueSet":"canonical","Questionnaire.item.code":"Coding","Questionnaire.item.definition":"uri","Questionnaire.item.enableBehavior":"code","Questionnaire.item.enableWhen":"BackboneElement","Questionnaire.item.enableWhen.answerBoolean":"boolean","Questionnaire.item.enableWhen.answerCoding":"Coding","Questionnaire.item.enableWhen.answerDate":"date","Questionnaire.item.enableWhen.answerDateTime":"dateTime","Questionnaire.item.enableWhen.answerDecimal":"decimal","Questionnaire.item.enableWhen.answerInteger":"integer","Questionnaire.item.enableWhen.answerQuantity":"Quantity","Questionnaire.item.enableWhen.answerReference":"Reference","Questionnaire.item.enableWhen.answerString":"string","Questionnaire.item.enableWhen.answerTime":"time","Questionnaire.item.enableWhen.extension":"Extension","Questionnaire.item.enableWhen.id":"System.String","Questionnaire.item.enableWhen.modifierExtension":"Extension","Questionnaire.item.enableWhen.operator":"code","Questionnaire.item.enableWhen.question":"string","Questionnaire.item.extension":"Extension","Questionnaire.item.id":"System.String","Questionnaire.item.initial":"BackboneElement","Questionnaire.item.initial.extension":"Extension","Questionnaire.item.initial.id":"System.String","Questionnaire.item.initial.modifierExtension":"Extension","Questionnaire.item.initial.valueAttachment":"Attachment","Questionnaire.item.initial.valueBoolean":"boolean","Questionnaire.item.initial.valueCoding":"Coding","Questionnaire.item.initial.valueDate":"date","Questionnaire.item.initial.valueDateTime":"dateTime","Questionnaire.item.initial.valueDecimal":"decimal","Questionnaire.item.initial.valueInteger":"integer","Questionnaire.item.initial.valueQuantity":"Quantity","Questionnaire.item.initial.valueReference":"Reference","Questionnaire.item.initial.valueString":"string","Questionnaire.item.initial.valueTime":"time","Questionnaire.item.initial.valueUri":"uri","Questionnaire.item.linkId":"string","Questionnaire.item.maxLength":"integer","Questionnaire.item.modifierExtension":"Extension","Questionnaire.item.prefix":"string","Questionnaire.item.readOnly":"boolean","Questionnaire.item.repeats":"boolean","Questionnaire.item.required":"boolean","Questionnaire.item.text":"string","Questionnaire.item.type":"code","Questionnaire.jurisdiction":"CodeableConcept","Questionnaire.language":"code","Questionnaire.lastReviewDate":"date","Questionnaire.meta":"Meta","Questionnaire.modifierExtension":"Extension","Questionnaire.name":"string","Questionnaire.publisher":"string","Questionnaire.purpose":"markdown","Questionnaire.status":"code","Questionnaire.subjectType":"code","Questionnaire.text":"Narrative","Questionnaire.title":"string","Questionnaire.url":"uri","Questionnaire.useContext":"UsageContext","Questionnaire.version":"string","QuestionnaireResponse.author":"Reference","QuestionnaireResponse.authored":"dateTime","QuestionnaireResponse.basedOn":"Reference","QuestionnaireResponse.contained":"Resource","QuestionnaireResponse.encounter":"Reference","QuestionnaireResponse.extension":"Extension","QuestionnaireResponse.id":"System.String","QuestionnaireResponse.identifier":"Identifier","QuestionnaireResponse.implicitRules":"uri","QuestionnaireResponse.item":"BackboneElement","QuestionnaireResponse.item.answer":"BackboneElement","QuestionnaireResponse.item.answer.extension":"Extension","QuestionnaireResponse.item.answer.id":"System.String","QuestionnaireResponse.item.answer.modifierExtension":"Extension","QuestionnaireResponse.item.answer.valueAttachment":"Attachment","QuestionnaireResponse.item.answer.valueBoolean":"boolean","QuestionnaireResponse.item.answer.valueCoding":"Coding","QuestionnaireResponse.item.answer.valueDate":"date","QuestionnaireResponse.item.answer.valueDateTime":"dateTime","QuestionnaireResponse.item.answer.valueDecimal":"decimal","QuestionnaireResponse.item.answer.valueInteger":"integer","QuestionnaireResponse.item.answer.valueQuantity":"Quantity","QuestionnaireResponse.item.answer.valueReference":"Reference","QuestionnaireResponse.item.answer.valueString":"string","QuestionnaireResponse.item.answer.valueTime":"time","QuestionnaireResponse.item.answer.valueUri":"uri","QuestionnaireResponse.item.definition":"uri","QuestionnaireResponse.item.extension":"Extension","QuestionnaireResponse.item.id":"System.String","QuestionnaireResponse.item.linkId":"string","QuestionnaireResponse.item.modifierExtension":"Extension","QuestionnaireResponse.item.text":"string","QuestionnaireResponse.language":"code","QuestionnaireResponse.meta":"Meta","QuestionnaireResponse.modifierExtension":"Extension","QuestionnaireResponse.partOf":"Reference","QuestionnaireResponse.questionnaire":"canonical","QuestionnaireResponse.source":"Reference","QuestionnaireResponse.status":"code","QuestionnaireResponse.subject":"Reference","QuestionnaireResponse.text":"Narrative","Range.extension":"Extension","Range.high":"Quantity","Range.id":"System.String","Range.low":"Quantity","Ratio.denominator":"Quantity","Ratio.extension":"Extension","Ratio.id":"System.String","Ratio.numerator":"Quantity","Reference.display":"string","Reference.extension":"Extension","Reference.id":"System.String","Reference.identifier":"Identifier","Reference.reference":"string","Reference.type":"uri","RelatedArtifact.citation":"markdown","RelatedArtifact.display":"string","RelatedArtifact.document":"Attachment","RelatedArtifact.extension":"Extension","RelatedArtifact.id":"System.String","RelatedArtifact.label":"string","RelatedArtifact.resource":"canonical","RelatedArtifact.type":"code","RelatedArtifact.url":"url","RelatedPerson.active":"boolean","RelatedPerson.address":"Address","RelatedPerson.birthDate":"date","RelatedPerson.communication":"BackboneElement","RelatedPerson.communication.extension":"Extension","RelatedPerson.communication.id":"System.String","RelatedPerson.communication.language":"CodeableConcept","RelatedPerson.communication.modifierExtension":"Extension","RelatedPerson.communication.preferred":"boolean","RelatedPerson.contained":"Resource","RelatedPerson.extension":"Extension","RelatedPerson.gender":"code","RelatedPerson.id":"System.String","RelatedPerson.identifier":"Identifier","RelatedPerson.implicitRules":"uri","RelatedPerson.language":"code","RelatedPerson.meta":"Meta","RelatedPerson.modifierExtension":"Extension","RelatedPerson.name":"HumanName","RelatedPerson.patient":"Reference","RelatedPerson.period":"Period","RelatedPerson.photo":"Attachment","RelatedPerson.relationship":"CodeableConcept","RelatedPerson.telecom":"ContactPoint","RelatedPerson.text":"Narrative","RequestGroup.action":"BackboneElement","RequestGroup.action.cardinalityBehavior":"code","RequestGroup.action.code":"CodeableConcept","RequestGroup.action.condition":"BackboneElement","RequestGroup.action.condition.expression":"Expression","RequestGroup.action.condition.extension":"Extension","RequestGroup.action.condition.id":"System.String","RequestGroup.action.condition.kind":"code","RequestGroup.action.condition.modifierExtension":"Extension","RequestGroup.action.description":"string","RequestGroup.action.documentation":"RelatedArtifact","RequestGroup.action.extension":"Extension","RequestGroup.action.groupingBehavior":"code","RequestGroup.action.id":"System.String","RequestGroup.action.modifierExtension":"Extension","RequestGroup.action.participant":"Reference","RequestGroup.action.precheckBehavior":"code","RequestGroup.action.prefix":"string","RequestGroup.action.priority":"code","RequestGroup.action.relatedAction":"BackboneElement","RequestGroup.action.relatedAction.actionId":"id","RequestGroup.action.relatedAction.extension":"Extension","RequestGroup.action.relatedAction.id":"System.String","RequestGroup.action.relatedAction.modifierExtension":"Extension","RequestGroup.action.relatedAction.offsetDuration":"Duration","RequestGroup.action.relatedAction.offsetRange":"Range","RequestGroup.action.relatedAction.relationship":"code","RequestGroup.action.requiredBehavior":"code","RequestGroup.action.resource":"Reference","RequestGroup.action.selectionBehavior":"code","RequestGroup.action.textEquivalent":"string","RequestGroup.action.timingAge":"Age","RequestGroup.action.timingDateTime":"dateTime","RequestGroup.action.timingDuration":"Duration","RequestGroup.action.timingPeriod":"Period","RequestGroup.action.timingRange":"Range","RequestGroup.action.timingTiming":"Timing","RequestGroup.action.title":"string","RequestGroup.action.type":"CodeableConcept","RequestGroup.author":"Reference","RequestGroup.authoredOn":"dateTime","RequestGroup.basedOn":"Reference","RequestGroup.code":"CodeableConcept","RequestGroup.contained":"Resource","RequestGroup.encounter":"Reference","RequestGroup.extension":"Extension","RequestGroup.groupIdentifier":"Identifier","RequestGroup.id":"System.String","RequestGroup.identifier":"Identifier","RequestGroup.implicitRules":"uri","RequestGroup.instantiatesCanonical":"canonical","RequestGroup.instantiatesUri":"uri","RequestGroup.intent":"code","RequestGroup.language":"code","RequestGroup.meta":"Meta","RequestGroup.modifierExtension":"Extension","RequestGroup.note":"Annotation","RequestGroup.priority":"code","RequestGroup.reasonCode":"CodeableConcept","RequestGroup.reasonReference":"Reference","RequestGroup.replaces":"Reference","RequestGroup.status":"code","RequestGroup.subject":"Reference","RequestGroup.text":"Narrative","ResearchDefinition.approvalDate":"date","ResearchDefinition.author":"ContactDetail","ResearchDefinition.comment":"string","ResearchDefinition.contact":"ContactDetail","ResearchDefinition.contained":"Resource","ResearchDefinition.copyright":"markdown","ResearchDefinition.date":"dateTime","ResearchDefinition.description":"markdown","ResearchDefinition.editor":"ContactDetail","ResearchDefinition.effectivePeriod":"Period","ResearchDefinition.endorser":"ContactDetail","ResearchDefinition.experimental":"boolean","ResearchDefinition.exposure":"Reference","ResearchDefinition.exposureAlternative":"Reference","ResearchDefinition.extension":"Extension","ResearchDefinition.id":"System.String","ResearchDefinition.identifier":"Identifier","ResearchDefinition.implicitRules":"uri","ResearchDefinition.jurisdiction":"CodeableConcept","ResearchDefinition.language":"code","ResearchDefinition.lastReviewDate":"date","ResearchDefinition.library":"canonical","ResearchDefinition.meta":"Meta","ResearchDefinition.modifierExtension":"Extension","ResearchDefinition.name":"string","ResearchDefinition.outcome":"Reference","ResearchDefinition.population":"Reference","ResearchDefinition.publisher":"string","ResearchDefinition.purpose":"markdown","ResearchDefinition.relatedArtifact":"RelatedArtifact","ResearchDefinition.reviewer":"ContactDetail","ResearchDefinition.shortTitle":"string","ResearchDefinition.status":"code","ResearchDefinition.subjectCodeableConcept":"CodeableConcept","ResearchDefinition.subjectReference":"Reference","ResearchDefinition.subtitle":"string","ResearchDefinition.text":"Narrative","ResearchDefinition.title":"string","ResearchDefinition.topic":"CodeableConcept","ResearchDefinition.url":"uri","ResearchDefinition.usage":"string","ResearchDefinition.useContext":"UsageContext","ResearchDefinition.version":"string","ResearchElementDefinition.approvalDate":"date","ResearchElementDefinition.author":"ContactDetail","ResearchElementDefinition.characteristic":"BackboneElement","ResearchElementDefinition.characteristic.definitionCanonical":"canonical","ResearchElementDefinition.characteristic.definitionCodeableConcept":"CodeableConcept","ResearchElementDefinition.characteristic.definitionDataRequirement":"DataRequirement","ResearchElementDefinition.characteristic.definitionExpression":"Expression","ResearchElementDefinition.characteristic.exclude":"boolean","ResearchElementDefinition.characteristic.extension":"Extension","ResearchElementDefinition.characteristic.id":"System.String","ResearchElementDefinition.characteristic.modifierExtension":"Extension","ResearchElementDefinition.characteristic.participantEffectiveDateTime":"dateTime","ResearchElementDefinition.characteristic.participantEffectiveDescription":"string","ResearchElementDefinition.characteristic.participantEffectiveDuration":"Duration","ResearchElementDefinition.characteristic.participantEffectiveGroupMeasure":"code","ResearchElementDefinition.characteristic.participantEffectivePeriod":"Period","ResearchElementDefinition.characteristic.participantEffectiveTimeFromStart":"Duration","ResearchElementDefinition.characteristic.participantEffectiveTiming":"Timing","ResearchElementDefinition.characteristic.studyEffectiveDateTime":"dateTime","ResearchElementDefinition.characteristic.studyEffectiveDescription":"string","ResearchElementDefinition.characteristic.studyEffectiveDuration":"Duration","ResearchElementDefinition.characteristic.studyEffectiveGroupMeasure":"code","ResearchElementDefinition.characteristic.studyEffectivePeriod":"Period","ResearchElementDefinition.characteristic.studyEffectiveTimeFromStart":"Duration","ResearchElementDefinition.characteristic.studyEffectiveTiming":"Timing","ResearchElementDefinition.characteristic.unitOfMeasure":"CodeableConcept","ResearchElementDefinition.characteristic.usageContext":"UsageContext","ResearchElementDefinition.comment":"string","ResearchElementDefinition.contact":"ContactDetail","ResearchElementDefinition.contained":"Resource","ResearchElementDefinition.copyright":"markdown","ResearchElementDefinition.date":"dateTime","ResearchElementDefinition.description":"markdown","ResearchElementDefinition.editor":"ContactDetail","ResearchElementDefinition.effectivePeriod":"Period","ResearchElementDefinition.endorser":"ContactDetail","ResearchElementDefinition.experimental":"boolean","ResearchElementDefinition.extension":"Extension","ResearchElementDefinition.id":"System.String","ResearchElementDefinition.identifier":"Identifier","ResearchElementDefinition.implicitRules":"uri","ResearchElementDefinition.jurisdiction":"CodeableConcept","ResearchElementDefinition.language":"code","ResearchElementDefinition.lastReviewDate":"date","ResearchElementDefinition.library":"canonical","ResearchElementDefinition.meta":"Meta","ResearchElementDefinition.modifierExtension":"Extension","ResearchElementDefinition.name":"string","ResearchElementDefinition.publisher":"string","ResearchElementDefinition.purpose":"markdown","ResearchElementDefinition.relatedArtifact":"RelatedArtifact","ResearchElementDefinition.reviewer":"ContactDetail","ResearchElementDefinition.shortTitle":"string","ResearchElementDefinition.status":"code","ResearchElementDefinition.subjectCodeableConcept":"CodeableConcept","ResearchElementDefinition.subjectReference":"Reference","ResearchElementDefinition.subtitle":"string","ResearchElementDefinition.text":"Narrative","ResearchElementDefinition.title":"string","ResearchElementDefinition.topic":"CodeableConcept","ResearchElementDefinition.type":"code","ResearchElementDefinition.url":"uri","ResearchElementDefinition.usage":"string","ResearchElementDefinition.useContext":"UsageContext","ResearchElementDefinition.variableType":"code","ResearchElementDefinition.version":"string","ResearchStudy.arm":"BackboneElement","ResearchStudy.arm.description":"string","ResearchStudy.arm.extension":"Extension","ResearchStudy.arm.id":"System.String","ResearchStudy.arm.modifierExtension":"Extension","ResearchStudy.arm.name":"string","ResearchStudy.arm.type":"CodeableConcept","ResearchStudy.category":"CodeableConcept","ResearchStudy.condition":"CodeableConcept","ResearchStudy.contact":"ContactDetail","ResearchStudy.contained":"Resource","ResearchStudy.description":"markdown","ResearchStudy.enrollment":"Reference","ResearchStudy.extension":"Extension","ResearchStudy.focus":"CodeableConcept","ResearchStudy.id":"System.String","ResearchStudy.identifier":"Identifier","ResearchStudy.implicitRules":"uri","ResearchStudy.keyword":"CodeableConcept","ResearchStudy.language":"code","ResearchStudy.location":"CodeableConcept","ResearchStudy.meta":"Meta","ResearchStudy.modifierExtension":"Extension","ResearchStudy.note":"Annotation","ResearchStudy.objective":"BackboneElement","ResearchStudy.objective.extension":"Extension","ResearchStudy.objective.id":"System.String","ResearchStudy.objective.modifierExtension":"Extension","ResearchStudy.objective.name":"string","ResearchStudy.objective.type":"CodeableConcept","ResearchStudy.partOf":"Reference","ResearchStudy.period":"Period","ResearchStudy.phase":"CodeableConcept","ResearchStudy.primaryPurposeType":"CodeableConcept","ResearchStudy.principalInvestigator":"Reference","ResearchStudy.protocol":"Reference","ResearchStudy.reasonStopped":"CodeableConcept","ResearchStudy.relatedArtifact":"RelatedArtifact","ResearchStudy.site":"Reference","ResearchStudy.sponsor":"Reference","ResearchStudy.status":"code","ResearchStudy.text":"Narrative","ResearchStudy.title":"string","ResearchSubject.actualArm":"string","ResearchSubject.assignedArm":"string","ResearchSubject.consent":"Reference","ResearchSubject.contained":"Resource","ResearchSubject.extension":"Extension","ResearchSubject.id":"System.String","ResearchSubject.identifier":"Identifier","ResearchSubject.implicitRules":"uri","ResearchSubject.individual":"Reference","ResearchSubject.language":"code","ResearchSubject.meta":"Meta","ResearchSubject.modifierExtension":"Extension","ResearchSubject.period":"Period","ResearchSubject.status":"code","ResearchSubject.study":"Reference","ResearchSubject.text":"Narrative","Resource.id":"System.String","Resource.implicitRules":"uri","Resource.language":"code","Resource.meta":"Meta","RiskAssessment.basedOn":"Reference","RiskAssessment.basis":"Reference","RiskAssessment.code":"CodeableConcept","RiskAssessment.condition":"Reference","RiskAssessment.contained":"Resource","RiskAssessment.encounter":"Reference","RiskAssessment.extension":"Extension","RiskAssessment.id":"System.String","RiskAssessment.identifier":"Identifier","RiskAssessment.implicitRules":"uri","RiskAssessment.language":"code","RiskAssessment.meta":"Meta","RiskAssessment.method":"CodeableConcept","RiskAssessment.mitigation":"string","RiskAssessment.modifierExtension":"Extension","RiskAssessment.note":"Annotation","RiskAssessment.occurrenceDateTime":"dateTime","RiskAssessment.occurrencePeriod":"Period","RiskAssessment.parent":"Reference","RiskAssessment.performer":"Reference","RiskAssessment.prediction":"BackboneElement","RiskAssessment.prediction.extension":"Extension","RiskAssessment.prediction.id":"System.String","RiskAssessment.prediction.modifierExtension":"Extension","RiskAssessment.prediction.outcome":"CodeableConcept","RiskAssessment.prediction.probabilityDecimal":"decimal","RiskAssessment.prediction.probabilityRange":"Range","RiskAssessment.prediction.qualitativeRisk":"CodeableConcept","RiskAssessment.prediction.rationale":"string","RiskAssessment.prediction.relativeRisk":"decimal","RiskAssessment.prediction.whenPeriod":"Period","RiskAssessment.prediction.whenRange":"Range","RiskAssessment.reasonCode":"CodeableConcept","RiskAssessment.reasonReference":"Reference","RiskAssessment.status":"code","RiskAssessment.subject":"Reference","RiskAssessment.text":"Narrative","RiskEvidenceSynthesis.approvalDate":"date","RiskEvidenceSynthesis.author":"ContactDetail","RiskEvidenceSynthesis.certainty":"BackboneElement","RiskEvidenceSynthesis.certainty.certaintySubcomponent":"BackboneElement","RiskEvidenceSynthesis.certainty.certaintySubcomponent.extension":"Extension","RiskEvidenceSynthesis.certainty.certaintySubcomponent.id":"System.String","RiskEvidenceSynthesis.certainty.certaintySubcomponent.modifierExtension":"Extension","RiskEvidenceSynthesis.certainty.certaintySubcomponent.note":"Annotation","RiskEvidenceSynthesis.certainty.certaintySubcomponent.rating":"CodeableConcept","RiskEvidenceSynthesis.certainty.certaintySubcomponent.type":"CodeableConcept","RiskEvidenceSynthesis.certainty.extension":"Extension","RiskEvidenceSynthesis.certainty.id":"System.String","RiskEvidenceSynthesis.certainty.modifierExtension":"Extension","RiskEvidenceSynthesis.certainty.note":"Annotation","RiskEvidenceSynthesis.certainty.rating":"CodeableConcept","RiskEvidenceSynthesis.contact":"ContactDetail","RiskEvidenceSynthesis.contained":"Resource","RiskEvidenceSynthesis.copyright":"markdown","RiskEvidenceSynthesis.date":"dateTime","RiskEvidenceSynthesis.description":"markdown","RiskEvidenceSynthesis.editor":"ContactDetail","RiskEvidenceSynthesis.effectivePeriod":"Period","RiskEvidenceSynthesis.endorser":"ContactDetail","RiskEvidenceSynthesis.exposure":"Reference","RiskEvidenceSynthesis.extension":"Extension","RiskEvidenceSynthesis.id":"System.String","RiskEvidenceSynthesis.identifier":"Identifier","RiskEvidenceSynthesis.implicitRules":"uri","RiskEvidenceSynthesis.jurisdiction":"CodeableConcept","RiskEvidenceSynthesis.language":"code","RiskEvidenceSynthesis.lastReviewDate":"date","RiskEvidenceSynthesis.meta":"Meta","RiskEvidenceSynthesis.modifierExtension":"Extension","RiskEvidenceSynthesis.name":"string","RiskEvidenceSynthesis.note":"Annotation","RiskEvidenceSynthesis.outcome":"Reference","RiskEvidenceSynthesis.population":"Reference","RiskEvidenceSynthesis.publisher":"string","RiskEvidenceSynthesis.relatedArtifact":"RelatedArtifact","RiskEvidenceSynthesis.reviewer":"ContactDetail","RiskEvidenceSynthesis.riskEstimate":"BackboneElement","RiskEvidenceSynthesis.riskEstimate.denominatorCount":"integer","RiskEvidenceSynthesis.riskEstimate.description":"string","RiskEvidenceSynthesis.riskEstimate.extension":"Extension","RiskEvidenceSynthesis.riskEstimate.id":"System.String","RiskEvidenceSynthesis.riskEstimate.modifierExtension":"Extension","RiskEvidenceSynthesis.riskEstimate.numeratorCount":"integer","RiskEvidenceSynthesis.riskEstimate.precisionEstimate":"BackboneElement","RiskEvidenceSynthesis.riskEstimate.precisionEstimate.extension":"Extension","RiskEvidenceSynthesis.riskEstimate.precisionEstimate.from":"decimal","RiskEvidenceSynthesis.riskEstimate.precisionEstimate.id":"System.String","RiskEvidenceSynthesis.riskEstimate.precisionEstimate.level":"decimal","RiskEvidenceSynthesis.riskEstimate.precisionEstimate.modifierExtension":"Extension","RiskEvidenceSynthesis.riskEstimate.precisionEstimate.to":"decimal","RiskEvidenceSynthesis.riskEstimate.precisionEstimate.type":"CodeableConcept","RiskEvidenceSynthesis.riskEstimate.type":"CodeableConcept","RiskEvidenceSynthesis.riskEstimate.unitOfMeasure":"CodeableConcept","RiskEvidenceSynthesis.riskEstimate.value":"decimal","RiskEvidenceSynthesis.sampleSize":"BackboneElement","RiskEvidenceSynthesis.sampleSize.description":"string","RiskEvidenceSynthesis.sampleSize.extension":"Extension","RiskEvidenceSynthesis.sampleSize.id":"System.String","RiskEvidenceSynthesis.sampleSize.modifierExtension":"Extension","RiskEvidenceSynthesis.sampleSize.numberOfParticipants":"integer","RiskEvidenceSynthesis.sampleSize.numberOfStudies":"integer","RiskEvidenceSynthesis.status":"code","RiskEvidenceSynthesis.studyType":"CodeableConcept","RiskEvidenceSynthesis.synthesisType":"CodeableConcept","RiskEvidenceSynthesis.text":"Narrative","RiskEvidenceSynthesis.title":"string","RiskEvidenceSynthesis.topic":"CodeableConcept","RiskEvidenceSynthesis.url":"uri","RiskEvidenceSynthesis.useContext":"UsageContext","RiskEvidenceSynthesis.version":"string","SampledData.data":"string","SampledData.dimensions":"positiveInt","SampledData.extension":"Extension","SampledData.factor":"decimal","SampledData.id":"System.String","SampledData.lowerLimit":"decimal","SampledData.origin":"Quantity","SampledData.period":"decimal","SampledData.upperLimit":"decimal","Schedule.active":"boolean","Schedule.actor":"Reference","Schedule.comment":"string","Schedule.contained":"Resource","Schedule.extension":"Extension","Schedule.id":"System.String","Schedule.identifier":"Identifier","Schedule.implicitRules":"uri","Schedule.language":"code","Schedule.meta":"Meta","Schedule.modifierExtension":"Extension","Schedule.planningHorizon":"Period","Schedule.serviceCategory":"CodeableConcept","Schedule.serviceType":"CodeableConcept","Schedule.specialty":"CodeableConcept","Schedule.text":"Narrative","SearchParameter.base":"code","SearchParameter.chain":"string","SearchParameter.code":"code","SearchParameter.comparator":"code","SearchParameter.component":"BackboneElement","SearchParameter.component.definition":"canonical","SearchParameter.component.expression":"string","SearchParameter.component.extension":"Extension","SearchParameter.component.id":"System.String","SearchParameter.component.modifierExtension":"Extension","SearchParameter.contact":"ContactDetail","SearchParameter.contained":"Resource","SearchParameter.date":"dateTime","SearchParameter.derivedFrom":"canonical","SearchParameter.description":"markdown","SearchParameter.experimental":"boolean","SearchParameter.expression":"string","SearchParameter.extension":"Extension","SearchParameter.id":"System.String","SearchParameter.implicitRules":"uri","SearchParameter.jurisdiction":"CodeableConcept","SearchParameter.language":"code","SearchParameter.meta":"Meta","SearchParameter.modifier":"code","SearchParameter.modifierExtension":"Extension","SearchParameter.multipleAnd":"boolean","SearchParameter.multipleOr":"boolean","SearchParameter.name":"string","SearchParameter.publisher":"string","SearchParameter.purpose":"markdown","SearchParameter.status":"code","SearchParameter.target":"code","SearchParameter.text":"Narrative","SearchParameter.type":"code","SearchParameter.url":"uri","SearchParameter.useContext":"UsageContext","SearchParameter.version":"string","SearchParameter.xpath":"string","SearchParameter.xpathUsage":"code","ServiceRequest.asNeededBoolean":"boolean","ServiceRequest.asNeededCodeableConcept":"CodeableConcept","ServiceRequest.authoredOn":"dateTime","ServiceRequest.basedOn":"Reference","ServiceRequest.bodySite":"CodeableConcept","ServiceRequest.category":"CodeableConcept","ServiceRequest.code":"CodeableConcept","ServiceRequest.contained":"Resource","ServiceRequest.doNotPerform":"boolean","ServiceRequest.encounter":"Reference","ServiceRequest.extension":"Extension","ServiceRequest.id":"System.String","ServiceRequest.identifier":"Identifier","ServiceRequest.implicitRules":"uri","ServiceRequest.instantiatesCanonical":"canonical","ServiceRequest.instantiatesUri":"uri","ServiceRequest.insurance":"Reference","ServiceRequest.intent":"code","ServiceRequest.language":"code","ServiceRequest.locationCode":"CodeableConcept","ServiceRequest.locationReference":"Reference","ServiceRequest.meta":"Meta","ServiceRequest.modifierExtension":"Extension","ServiceRequest.note":"Annotation","ServiceRequest.occurrenceDateTime":"dateTime","ServiceRequest.occurrencePeriod":"Period","ServiceRequest.occurrenceTiming":"Timing","ServiceRequest.orderDetail":"CodeableConcept","ServiceRequest.patientInstruction":"string","ServiceRequest.performer":"Reference","ServiceRequest.performerType":"CodeableConcept","ServiceRequest.priority":"code","ServiceRequest.quantityQuantity":"Quantity","ServiceRequest.quantityRange":"Range","ServiceRequest.quantityRatio":"Ratio","ServiceRequest.reasonCode":"CodeableConcept","ServiceRequest.reasonReference":"Reference","ServiceRequest.relevantHistory":"Reference","ServiceRequest.replaces":"Reference","ServiceRequest.requester":"Reference","ServiceRequest.requisition":"Identifier","ServiceRequest.specimen":"Reference","ServiceRequest.status":"code","ServiceRequest.subject":"Reference","ServiceRequest.supportingInfo":"Reference","ServiceRequest.text":"Narrative","Signature.data":"base64Binary","Signature.extension":"Extension","Signature.id":"System.String","Signature.onBehalfOf":"Reference","Signature.sigFormat":"code","Signature.targetFormat":"code","Signature.type":"Coding","Signature.when":"instant","Signature.who":"Reference","Slot.appointmentType":"CodeableConcept","Slot.comment":"string","Slot.contained":"Resource","Slot.end":"instant","Slot.extension":"Extension","Slot.id":"System.String","Slot.identifier":"Identifier","Slot.implicitRules":"uri","Slot.language":"code","Slot.meta":"Meta","Slot.modifierExtension":"Extension","Slot.overbooked":"boolean","Slot.schedule":"Reference","Slot.serviceCategory":"CodeableConcept","Slot.serviceType":"CodeableConcept","Slot.specialty":"CodeableConcept","Slot.start":"instant","Slot.status":"code","Slot.text":"Narrative","Specimen.accessionIdentifier":"Identifier","Specimen.collection":"BackboneElement","Specimen.collection.bodySite":"CodeableConcept","Specimen.collection.collectedDateTime":"dateTime","Specimen.collection.collectedPeriod":"Period","Specimen.collection.collector":"Reference","Specimen.collection.duration":"Duration","Specimen.collection.extension":"Extension","Specimen.collection.fastingStatusCodeableConcept":"CodeableConcept","Specimen.collection.fastingStatusDuration":"Duration","Specimen.collection.id":"System.String","Specimen.collection.method":"CodeableConcept","Specimen.collection.modifierExtension":"Extension","Specimen.collection.quantity":"Quantity","Specimen.condition":"CodeableConcept","Specimen.contained":"Resource","Specimen.container":"BackboneElement","Specimen.container.additiveCodeableConcept":"CodeableConcept","Specimen.container.additiveReference":"Reference","Specimen.container.capacity":"Quantity","Specimen.container.description":"string","Specimen.container.extension":"Extension","Specimen.container.id":"System.String","Specimen.container.identifier":"Identifier","Specimen.container.modifierExtension":"Extension","Specimen.container.specimenQuantity":"Quantity","Specimen.container.type":"CodeableConcept","Specimen.extension":"Extension","Specimen.id":"System.String","Specimen.identifier":"Identifier","Specimen.implicitRules":"uri","Specimen.language":"code","Specimen.meta":"Meta","Specimen.modifierExtension":"Extension","Specimen.note":"Annotation","Specimen.parent":"Reference","Specimen.processing":"BackboneElement","Specimen.processing.additive":"Reference","Specimen.processing.description":"string","Specimen.processing.extension":"Extension","Specimen.processing.id":"System.String","Specimen.processing.modifierExtension":"Extension","Specimen.processing.procedure":"CodeableConcept","Specimen.processing.timeDateTime":"dateTime","Specimen.processing.timePeriod":"Period","Specimen.receivedTime":"dateTime","Specimen.request":"Reference","Specimen.status":"code","Specimen.subject":"Reference","Specimen.text":"Narrative","Specimen.type":"CodeableConcept","SpecimenDefinition.collection":"CodeableConcept","SpecimenDefinition.contained":"Resource","SpecimenDefinition.extension":"Extension","SpecimenDefinition.id":"System.String","SpecimenDefinition.identifier":"Identifier","SpecimenDefinition.implicitRules":"uri","SpecimenDefinition.language":"code","SpecimenDefinition.meta":"Meta","SpecimenDefinition.modifierExtension":"Extension","SpecimenDefinition.patientPreparation":"CodeableConcept","SpecimenDefinition.text":"Narrative","SpecimenDefinition.timeAspect":"string","SpecimenDefinition.typeCollected":"CodeableConcept","SpecimenDefinition.typeTested":"BackboneElement","SpecimenDefinition.typeTested.container":"BackboneElement","SpecimenDefinition.typeTested.container.additive":"BackboneElement","SpecimenDefinition.typeTested.container.additive.additiveCodeableConcept":"CodeableConcept","SpecimenDefinition.typeTested.container.additive.additiveReference":"Reference","SpecimenDefinition.typeTested.container.additive.extension":"Extension","SpecimenDefinition.typeTested.container.additive.id":"System.String","SpecimenDefinition.typeTested.container.additive.modifierExtension":"Extension","SpecimenDefinition.typeTested.container.cap":"CodeableConcept","SpecimenDefinition.typeTested.container.capacity":"Quantity","SpecimenDefinition.typeTested.container.description":"string","SpecimenDefinition.typeTested.container.extension":"Extension","SpecimenDefinition.typeTested.container.id":"System.String","SpecimenDefinition.typeTested.container.material":"CodeableConcept","SpecimenDefinition.typeTested.container.minimumVolumeQuantity":"Quantity","SpecimenDefinition.typeTested.container.minimumVolumeString":"string","SpecimenDefinition.typeTested.container.modifierExtension":"Extension","SpecimenDefinition.typeTested.container.preparation":"string","SpecimenDefinition.typeTested.container.type":"CodeableConcept","SpecimenDefinition.typeTested.extension":"Extension","SpecimenDefinition.typeTested.handling":"BackboneElement","SpecimenDefinition.typeTested.handling.extension":"Extension","SpecimenDefinition.typeTested.handling.id":"System.String","SpecimenDefinition.typeTested.handling.instruction":"string","SpecimenDefinition.typeTested.handling.maxDuration":"Duration","SpecimenDefinition.typeTested.handling.modifierExtension":"Extension","SpecimenDefinition.typeTested.handling.temperatureQualifier":"CodeableConcept","SpecimenDefinition.typeTested.handling.temperatureRange":"Range","SpecimenDefinition.typeTested.id":"System.String","SpecimenDefinition.typeTested.isDerived":"boolean","SpecimenDefinition.typeTested.modifierExtension":"Extension","SpecimenDefinition.typeTested.preference":"code","SpecimenDefinition.typeTested.rejectionCriterion":"CodeableConcept","SpecimenDefinition.typeTested.requirement":"string","SpecimenDefinition.typeTested.retentionTime":"Duration","SpecimenDefinition.typeTested.type":"CodeableConcept","StructureDefinition.abstract":"boolean","StructureDefinition.baseDefinition":"canonical","StructureDefinition.contact":"ContactDetail","StructureDefinition.contained":"Resource","StructureDefinition.context":"BackboneElement","StructureDefinition.context.expression":"string","StructureDefinition.context.extension":"Extension","StructureDefinition.context.id":"System.String","StructureDefinition.context.modifierExtension":"Extension","StructureDefinition.context.type":"code","StructureDefinition.contextInvariant":"string","StructureDefinition.copyright":"markdown","StructureDefinition.date":"dateTime","StructureDefinition.derivation":"code","StructureDefinition.description":"markdown","StructureDefinition.differential":"BackboneElement","StructureDefinition.differential.element":"ElementDefinition","StructureDefinition.differential.extension":"Extension","StructureDefinition.differential.id":"System.String","StructureDefinition.differential.modifierExtension":"Extension","StructureDefinition.experimental":"boolean","StructureDefinition.extension":"Extension","StructureDefinition.fhirVersion":"code","StructureDefinition.id":"System.String","StructureDefinition.identifier":"Identifier","StructureDefinition.implicitRules":"uri","StructureDefinition.jurisdiction":"CodeableConcept","StructureDefinition.keyword":"Coding","StructureDefinition.kind":"code","StructureDefinition.language":"code","StructureDefinition.mapping":"BackboneElement","StructureDefinition.mapping.comment":"string","StructureDefinition.mapping.extension":"Extension","StructureDefinition.mapping.id":"System.String","StructureDefinition.mapping.identity":"id","StructureDefinition.mapping.modifierExtension":"Extension","StructureDefinition.mapping.name":"string","StructureDefinition.mapping.uri":"uri","StructureDefinition.meta":"Meta","StructureDefinition.modifierExtension":"Extension","StructureDefinition.name":"string","StructureDefinition.publisher":"string","StructureDefinition.purpose":"markdown","StructureDefinition.snapshot":"BackboneElement","StructureDefinition.snapshot.element":"ElementDefinition","StructureDefinition.snapshot.extension":"Extension","StructureDefinition.snapshot.id":"System.String","StructureDefinition.snapshot.modifierExtension":"Extension","StructureDefinition.status":"code","StructureDefinition.text":"Narrative","StructureDefinition.title":"string","StructureDefinition.type":"uri","StructureDefinition.url":"uri","StructureDefinition.useContext":"UsageContext","StructureDefinition.version":"string","StructureMap.contact":"ContactDetail","StructureMap.contained":"Resource","StructureMap.copyright":"markdown","StructureMap.date":"dateTime","StructureMap.description":"markdown","StructureMap.experimental":"boolean","StructureMap.extension":"Extension","StructureMap.group":"BackboneElement","StructureMap.group.documentation":"string","StructureMap.group.extends":"id","StructureMap.group.extension":"Extension","StructureMap.group.id":"System.String","StructureMap.group.input":"BackboneElement","StructureMap.group.input.documentation":"string","StructureMap.group.input.extension":"Extension","StructureMap.group.input.id":"System.String","StructureMap.group.input.mode":"code","StructureMap.group.input.modifierExtension":"Extension","StructureMap.group.input.name":"id","StructureMap.group.input.type":"string","StructureMap.group.modifierExtension":"Extension","StructureMap.group.name":"id","StructureMap.group.rule":"BackboneElement","StructureMap.group.rule.dependent":"BackboneElement","StructureMap.group.rule.dependent.extension":"Extension","StructureMap.group.rule.dependent.id":"System.String","StructureMap.group.rule.dependent.modifierExtension":"Extension","StructureMap.group.rule.dependent.name":"id","StructureMap.group.rule.dependent.variable":"string","StructureMap.group.rule.documentation":"string","StructureMap.group.rule.extension":"Extension","StructureMap.group.rule.id":"System.String","StructureMap.group.rule.modifierExtension":"Extension","StructureMap.group.rule.name":"id","StructureMap.group.rule.source":"BackboneElement","StructureMap.group.rule.source.check":"string","StructureMap.group.rule.source.condition":"string","StructureMap.group.rule.source.context":"id","StructureMap.group.rule.source.defaultValueAddress":"Address","StructureMap.group.rule.source.defaultValueAge":"Age","StructureMap.group.rule.source.defaultValueAnnotation":"Annotation","StructureMap.group.rule.source.defaultValueAttachment":"Attachment","StructureMap.group.rule.source.defaultValueBase64Binary":"base64Binary","StructureMap.group.rule.source.defaultValueBoolean":"boolean","StructureMap.group.rule.source.defaultValueCanonical":"canonical","StructureMap.group.rule.source.defaultValueCode":"code","StructureMap.group.rule.source.defaultValueCodeableConcept":"CodeableConcept","StructureMap.group.rule.source.defaultValueCoding":"Coding","StructureMap.group.rule.source.defaultValueContactDetail":"ContactDetail","StructureMap.group.rule.source.defaultValueContactPoint":"ContactPoint","StructureMap.group.rule.source.defaultValueContributor":"Contributor","StructureMap.group.rule.source.defaultValueCount":"Count","StructureMap.group.rule.source.defaultValueDataRequirement":"DataRequirement","StructureMap.group.rule.source.defaultValueDate":"date","StructureMap.group.rule.source.defaultValueDateTime":"dateTime","StructureMap.group.rule.source.defaultValueDecimal":"decimal","StructureMap.group.rule.source.defaultValueDistance":"Distance","StructureMap.group.rule.source.defaultValueDosage":"Dosage","StructureMap.group.rule.source.defaultValueDuration":"Duration","StructureMap.group.rule.source.defaultValueExpression":"Expression","StructureMap.group.rule.source.defaultValueHumanName":"HumanName","StructureMap.group.rule.source.defaultValueId":"id","StructureMap.group.rule.source.defaultValueIdentifier":"Identifier","StructureMap.group.rule.source.defaultValueInstant":"instant","StructureMap.group.rule.source.defaultValueInteger":"integer","StructureMap.group.rule.source.defaultValueMarkdown":"markdown","StructureMap.group.rule.source.defaultValueMeta":"Meta","StructureMap.group.rule.source.defaultValueMoney":"Money","StructureMap.group.rule.source.defaultValueOid":"oid","StructureMap.group.rule.source.defaultValueParameterDefinition":"ParameterDefinition","StructureMap.group.rule.source.defaultValuePeriod":"Period","StructureMap.group.rule.source.defaultValuePositiveInt":"positiveInt","StructureMap.group.rule.source.defaultValueQuantity":"Quantity","StructureMap.group.rule.source.defaultValueRange":"Range","StructureMap.group.rule.source.defaultValueRatio":"Ratio","StructureMap.group.rule.source.defaultValueReference":"Reference","StructureMap.group.rule.source.defaultValueRelatedArtifact":"RelatedArtifact","StructureMap.group.rule.source.defaultValueSampledData":"SampledData","StructureMap.group.rule.source.defaultValueSignature":"Signature","StructureMap.group.rule.source.defaultValueString":"string","StructureMap.group.rule.source.defaultValueTime":"time","StructureMap.group.rule.source.defaultValueTiming":"Timing","StructureMap.group.rule.source.defaultValueTriggerDefinition":"TriggerDefinition","StructureMap.group.rule.source.defaultValueUnsignedInt":"unsignedInt","StructureMap.group.rule.source.defaultValueUri":"uri","StructureMap.group.rule.source.defaultValueUrl":"url","StructureMap.group.rule.source.defaultValueUsageContext":"UsageContext","StructureMap.group.rule.source.defaultValueUuid":"uuid","StructureMap.group.rule.source.element":"string","StructureMap.group.rule.source.extension":"Extension","StructureMap.group.rule.source.id":"System.String","StructureMap.group.rule.source.listMode":"code","StructureMap.group.rule.source.logMessage":"string","StructureMap.group.rule.source.max":"string","StructureMap.group.rule.source.min":"integer","StructureMap.group.rule.source.modifierExtension":"Extension","StructureMap.group.rule.source.type":"string","StructureMap.group.rule.source.variable":"id","StructureMap.group.rule.target":"BackboneElement","StructureMap.group.rule.target.context":"id","StructureMap.group.rule.target.contextType":"code","StructureMap.group.rule.target.element":"string","StructureMap.group.rule.target.extension":"Extension","StructureMap.group.rule.target.id":"System.String","StructureMap.group.rule.target.listMode":"code","StructureMap.group.rule.target.listRuleId":"id","StructureMap.group.rule.target.modifierExtension":"Extension","StructureMap.group.rule.target.parameter":"BackboneElement","StructureMap.group.rule.target.parameter.extension":"Extension","StructureMap.group.rule.target.parameter.id":"System.String","StructureMap.group.rule.target.parameter.modifierExtension":"Extension","StructureMap.group.rule.target.parameter.valueBoolean":"boolean","StructureMap.group.rule.target.parameter.valueDecimal":"decimal","StructureMap.group.rule.target.parameter.valueId":"id","StructureMap.group.rule.target.parameter.valueInteger":"integer","StructureMap.group.rule.target.parameter.valueString":"string","StructureMap.group.rule.target.transform":"code","StructureMap.group.rule.target.variable":"id","StructureMap.group.typeMode":"code","StructureMap.id":"System.String","StructureMap.identifier":"Identifier","StructureMap.implicitRules":"uri","StructureMap.import":"canonical","StructureMap.jurisdiction":"CodeableConcept","StructureMap.language":"code","StructureMap.meta":"Meta","StructureMap.modifierExtension":"Extension","StructureMap.name":"string","StructureMap.publisher":"string","StructureMap.purpose":"markdown","StructureMap.status":"code","StructureMap.structure":"BackboneElement","StructureMap.structure.alias":"string","StructureMap.structure.documentation":"string","StructureMap.structure.extension":"Extension","StructureMap.structure.id":"System.String","StructureMap.structure.mode":"code","StructureMap.structure.modifierExtension":"Extension","StructureMap.structure.url":"canonical","StructureMap.text":"Narrative","StructureMap.title":"string","StructureMap.url":"uri","StructureMap.useContext":"UsageContext","StructureMap.version":"string","Subscription.channel":"BackboneElement","Subscription.channel.endpoint":"url","Subscription.channel.extension":"Extension","Subscription.channel.header":"string","Subscription.channel.id":"System.String","Subscription.channel.modifierExtension":"Extension","Subscription.channel.payload":"code","Subscription.channel.type":"code","Subscription.contact":"ContactPoint","Subscription.contained":"Resource","Subscription.criteria":"string","Subscription.end":"instant","Subscription.error":"string","Subscription.extension":"Extension","Subscription.id":"System.String","Subscription.implicitRules":"uri","Subscription.language":"code","Subscription.meta":"Meta","Subscription.modifierExtension":"Extension","Subscription.reason":"string","Subscription.status":"code","Subscription.text":"Narrative","Substance.category":"CodeableConcept","Substance.code":"CodeableConcept","Substance.contained":"Resource","Substance.description":"string","Substance.extension":"Extension","Substance.id":"System.String","Substance.identifier":"Identifier","Substance.implicitRules":"uri","Substance.ingredient":"BackboneElement","Substance.ingredient.extension":"Extension","Substance.ingredient.id":"System.String","Substance.ingredient.modifierExtension":"Extension","Substance.ingredient.quantity":"Ratio","Substance.ingredient.substanceCodeableConcept":"CodeableConcept","Substance.ingredient.substanceReference":"Reference","Substance.instance":"BackboneElement","Substance.instance.expiry":"dateTime","Substance.instance.extension":"Extension","Substance.instance.id":"System.String","Substance.instance.identifier":"Identifier","Substance.instance.modifierExtension":"Extension","Substance.instance.quantity":"Quantity","Substance.language":"code","Substance.meta":"Meta","Substance.modifierExtension":"Extension","Substance.status":"code","Substance.text":"Narrative","SubstanceAmount.amountQuantity":"Quantity","SubstanceAmount.amountRange":"Range","SubstanceAmount.amountString":"string","SubstanceAmount.amountText":"string","SubstanceAmount.amountType":"CodeableConcept","SubstanceAmount.extension":"Extension","SubstanceAmount.id":"System.String","SubstanceAmount.modifierExtension":"Extension","SubstanceAmount.referenceRange":"Element","SubstanceAmount.referenceRange.extension":"Extension","SubstanceAmount.referenceRange.highLimit":"Quantity","SubstanceAmount.referenceRange.id":"System.String","SubstanceAmount.referenceRange.lowLimit":"Quantity","SubstanceNucleicAcid.areaOfHybridisation":"string","SubstanceNucleicAcid.contained":"Resource","SubstanceNucleicAcid.extension":"Extension","SubstanceNucleicAcid.id":"System.String","SubstanceNucleicAcid.implicitRules":"uri","SubstanceNucleicAcid.language":"code","SubstanceNucleicAcid.meta":"Meta","SubstanceNucleicAcid.modifierExtension":"Extension","SubstanceNucleicAcid.numberOfSubunits":"integer","SubstanceNucleicAcid.oligoNucleotideType":"CodeableConcept","SubstanceNucleicAcid.sequenceType":"CodeableConcept","SubstanceNucleicAcid.subunit":"BackboneElement","SubstanceNucleicAcid.subunit.extension":"Extension","SubstanceNucleicAcid.subunit.fivePrime":"CodeableConcept","SubstanceNucleicAcid.subunit.id":"System.String","SubstanceNucleicAcid.subunit.length":"integer","SubstanceNucleicAcid.subunit.linkage":"BackboneElement","SubstanceNucleicAcid.subunit.linkage.connectivity":"string","SubstanceNucleicAcid.subunit.linkage.extension":"Extension","SubstanceNucleicAcid.subunit.linkage.id":"System.String","SubstanceNucleicAcid.subunit.linkage.identifier":"Identifier","SubstanceNucleicAcid.subunit.linkage.modifierExtension":"Extension","SubstanceNucleicAcid.subunit.linkage.name":"string","SubstanceNucleicAcid.subunit.linkage.residueSite":"string","SubstanceNucleicAcid.subunit.modifierExtension":"Extension","SubstanceNucleicAcid.subunit.sequence":"string","SubstanceNucleicAcid.subunit.sequenceAttachment":"Attachment","SubstanceNucleicAcid.subunit.subunit":"integer","SubstanceNucleicAcid.subunit.sugar":"BackboneElement","SubstanceNucleicAcid.subunit.sugar.extension":"Extension","SubstanceNucleicAcid.subunit.sugar.id":"System.String","SubstanceNucleicAcid.subunit.sugar.identifier":"Identifier","SubstanceNucleicAcid.subunit.sugar.modifierExtension":"Extension","SubstanceNucleicAcid.subunit.sugar.name":"string","SubstanceNucleicAcid.subunit.sugar.residueSite":"string","SubstanceNucleicAcid.subunit.threePrime":"CodeableConcept","SubstanceNucleicAcid.text":"Narrative","SubstancePolymer.class":"CodeableConcept","SubstancePolymer.contained":"Resource","SubstancePolymer.copolymerConnectivity":"CodeableConcept","SubstancePolymer.extension":"Extension","SubstancePolymer.geometry":"CodeableConcept","SubstancePolymer.id":"System.String","SubstancePolymer.implicitRules":"uri","SubstancePolymer.language":"code","SubstancePolymer.meta":"Meta","SubstancePolymer.modification":"string","SubstancePolymer.modifierExtension":"Extension","SubstancePolymer.monomerSet":"BackboneElement","SubstancePolymer.monomerSet.extension":"Extension","SubstancePolymer.monomerSet.id":"System.String","SubstancePolymer.monomerSet.modifierExtension":"Extension","SubstancePolymer.monomerSet.ratioType":"CodeableConcept","SubstancePolymer.monomerSet.startingMaterial":"BackboneElement","SubstancePolymer.monomerSet.startingMaterial.amount":"SubstanceAmount","SubstancePolymer.monomerSet.startingMaterial.extension":"Extension","SubstancePolymer.monomerSet.startingMaterial.id":"System.String","SubstancePolymer.monomerSet.startingMaterial.isDefining":"boolean","SubstancePolymer.monomerSet.startingMaterial.material":"CodeableConcept","SubstancePolymer.monomerSet.startingMaterial.modifierExtension":"Extension","SubstancePolymer.monomerSet.startingMaterial.type":"CodeableConcept","SubstancePolymer.repeat":"BackboneElement","SubstancePolymer.repeat.averageMolecularFormula":"string","SubstancePolymer.repeat.extension":"Extension","SubstancePolymer.repeat.id":"System.String","SubstancePolymer.repeat.modifierExtension":"Extension","SubstancePolymer.repeat.numberOfUnits":"integer","SubstancePolymer.repeat.repeatUnit":"BackboneElement","SubstancePolymer.repeat.repeatUnit.amount":"SubstanceAmount","SubstancePolymer.repeat.repeatUnit.degreeOfPolymerisation":"BackboneElement","SubstancePolymer.repeat.repeatUnit.degreeOfPolymerisation.amount":"SubstanceAmount","SubstancePolymer.repeat.repeatUnit.degreeOfPolymerisation.degree":"CodeableConcept","SubstancePolymer.repeat.repeatUnit.degreeOfPolymerisation.extension":"Extension","SubstancePolymer.repeat.repeatUnit.degreeOfPolymerisation.id":"System.String","SubstancePolymer.repeat.repeatUnit.degreeOfPolymerisation.modifierExtension":"Extension","SubstancePolymer.repeat.repeatUnit.extension":"Extension","SubstancePolymer.repeat.repeatUnit.id":"System.String","SubstancePolymer.repeat.repeatUnit.modifierExtension":"Extension","SubstancePolymer.repeat.repeatUnit.orientationOfPolymerisation":"CodeableConcept","SubstancePolymer.repeat.repeatUnit.repeatUnit":"string","SubstancePolymer.repeat.repeatUnit.structuralRepresentation":"BackboneElement","SubstancePolymer.repeat.repeatUnit.structuralRepresentation.attachment":"Attachment","SubstancePolymer.repeat.repeatUnit.structuralRepresentation.extension":"Extension","SubstancePolymer.repeat.repeatUnit.structuralRepresentation.id":"System.String","SubstancePolymer.repeat.repeatUnit.structuralRepresentation.modifierExtension":"Extension","SubstancePolymer.repeat.repeatUnit.structuralRepresentation.representation":"string","SubstancePolymer.repeat.repeatUnit.structuralRepresentation.type":"CodeableConcept","SubstancePolymer.repeat.repeatUnitAmountType":"CodeableConcept","SubstancePolymer.text":"Narrative","SubstanceProtein.contained":"Resource","SubstanceProtein.disulfideLinkage":"string","SubstanceProtein.extension":"Extension","SubstanceProtein.id":"System.String","SubstanceProtein.implicitRules":"uri","SubstanceProtein.language":"code","SubstanceProtein.meta":"Meta","SubstanceProtein.modifierExtension":"Extension","SubstanceProtein.numberOfSubunits":"integer","SubstanceProtein.sequenceType":"CodeableConcept","SubstanceProtein.subunit":"BackboneElement","SubstanceProtein.subunit.cTerminalModification":"string","SubstanceProtein.subunit.cTerminalModificationId":"Identifier","SubstanceProtein.subunit.extension":"Extension","SubstanceProtein.subunit.id":"System.String","SubstanceProtein.subunit.length":"integer","SubstanceProtein.subunit.modifierExtension":"Extension","SubstanceProtein.subunit.nTerminalModification":"string","SubstanceProtein.subunit.nTerminalModificationId":"Identifier","SubstanceProtein.subunit.sequence":"string","SubstanceProtein.subunit.sequenceAttachment":"Attachment","SubstanceProtein.subunit.subunit":"integer","SubstanceProtein.text":"Narrative","SubstanceReferenceInformation.classification":"BackboneElement","SubstanceReferenceInformation.classification.classification":"CodeableConcept","SubstanceReferenceInformation.classification.domain":"CodeableConcept","SubstanceReferenceInformation.classification.extension":"Extension","SubstanceReferenceInformation.classification.id":"System.String","SubstanceReferenceInformation.classification.modifierExtension":"Extension","SubstanceReferenceInformation.classification.source":"Reference","SubstanceReferenceInformation.classification.subtype":"CodeableConcept","SubstanceReferenceInformation.comment":"string","SubstanceReferenceInformation.contained":"Resource","SubstanceReferenceInformation.extension":"Extension","SubstanceReferenceInformation.gene":"BackboneElement","SubstanceReferenceInformation.gene.extension":"Extension","SubstanceReferenceInformation.gene.gene":"CodeableConcept","SubstanceReferenceInformation.gene.geneSequenceOrigin":"CodeableConcept","SubstanceReferenceInformation.gene.id":"System.String","SubstanceReferenceInformation.gene.modifierExtension":"Extension","SubstanceReferenceInformation.gene.source":"Reference","SubstanceReferenceInformation.geneElement":"BackboneElement","SubstanceReferenceInformation.geneElement.element":"Identifier","SubstanceReferenceInformation.geneElement.extension":"Extension","SubstanceReferenceInformation.geneElement.id":"System.String","SubstanceReferenceInformation.geneElement.modifierExtension":"Extension","SubstanceReferenceInformation.geneElement.source":"Reference","SubstanceReferenceInformation.geneElement.type":"CodeableConcept","SubstanceReferenceInformation.id":"System.String","SubstanceReferenceInformation.implicitRules":"uri","SubstanceReferenceInformation.language":"code","SubstanceReferenceInformation.meta":"Meta","SubstanceReferenceInformation.modifierExtension":"Extension","SubstanceReferenceInformation.target":"BackboneElement","SubstanceReferenceInformation.target.amountQuantity":"Quantity","SubstanceReferenceInformation.target.amountRange":"Range","SubstanceReferenceInformation.target.amountString":"string","SubstanceReferenceInformation.target.amountType":"CodeableConcept","SubstanceReferenceInformation.target.extension":"Extension","SubstanceReferenceInformation.target.id":"System.String","SubstanceReferenceInformation.target.interaction":"CodeableConcept","SubstanceReferenceInformation.target.modifierExtension":"Extension","SubstanceReferenceInformation.target.organism":"CodeableConcept","SubstanceReferenceInformation.target.organismType":"CodeableConcept","SubstanceReferenceInformation.target.source":"Reference","SubstanceReferenceInformation.target.target":"Identifier","SubstanceReferenceInformation.target.type":"CodeableConcept","SubstanceReferenceInformation.text":"Narrative","SubstanceSourceMaterial.contained":"Resource","SubstanceSourceMaterial.countryOfOrigin":"CodeableConcept","SubstanceSourceMaterial.developmentStage":"CodeableConcept","SubstanceSourceMaterial.extension":"Extension","SubstanceSourceMaterial.fractionDescription":"BackboneElement","SubstanceSourceMaterial.fractionDescription.extension":"Extension","SubstanceSourceMaterial.fractionDescription.fraction":"string","SubstanceSourceMaterial.fractionDescription.id":"System.String","SubstanceSourceMaterial.fractionDescription.materialType":"CodeableConcept","SubstanceSourceMaterial.fractionDescription.modifierExtension":"Extension","SubstanceSourceMaterial.geographicalLocation":"string","SubstanceSourceMaterial.id":"System.String","SubstanceSourceMaterial.implicitRules":"uri","SubstanceSourceMaterial.language":"code","SubstanceSourceMaterial.meta":"Meta","SubstanceSourceMaterial.modifierExtension":"Extension","SubstanceSourceMaterial.organism":"BackboneElement","SubstanceSourceMaterial.organism.author":"BackboneElement","SubstanceSourceMaterial.organism.author.authorDescription":"string","SubstanceSourceMaterial.organism.author.authorType":"CodeableConcept","SubstanceSourceMaterial.organism.author.extension":"Extension","SubstanceSourceMaterial.organism.author.id":"System.String","SubstanceSourceMaterial.organism.author.modifierExtension":"Extension","SubstanceSourceMaterial.organism.extension":"Extension","SubstanceSourceMaterial.organism.family":"CodeableConcept","SubstanceSourceMaterial.organism.genus":"CodeableConcept","SubstanceSourceMaterial.organism.hybrid":"BackboneElement","SubstanceSourceMaterial.organism.hybrid.extension":"Extension","SubstanceSourceMaterial.organism.hybrid.hybridType":"CodeableConcept","SubstanceSourceMaterial.organism.hybrid.id":"System.String","SubstanceSourceMaterial.organism.hybrid.maternalOrganismId":"string","SubstanceSourceMaterial.organism.hybrid.maternalOrganismName":"string","SubstanceSourceMaterial.organism.hybrid.modifierExtension":"Extension","SubstanceSourceMaterial.organism.hybrid.paternalOrganismId":"string","SubstanceSourceMaterial.organism.hybrid.paternalOrganismName":"string","SubstanceSourceMaterial.organism.id":"System.String","SubstanceSourceMaterial.organism.intraspecificDescription":"string","SubstanceSourceMaterial.organism.intraspecificType":"CodeableConcept","SubstanceSourceMaterial.organism.modifierExtension":"Extension","SubstanceSourceMaterial.organism.organismGeneral":"BackboneElement","SubstanceSourceMaterial.organism.organismGeneral.class":"CodeableConcept","SubstanceSourceMaterial.organism.organismGeneral.extension":"Extension","SubstanceSourceMaterial.organism.organismGeneral.id":"System.String","SubstanceSourceMaterial.organism.organismGeneral.kingdom":"CodeableConcept","SubstanceSourceMaterial.organism.organismGeneral.modifierExtension":"Extension","SubstanceSourceMaterial.organism.organismGeneral.order":"CodeableConcept","SubstanceSourceMaterial.organism.organismGeneral.phylum":"CodeableConcept","SubstanceSourceMaterial.organism.species":"CodeableConcept","SubstanceSourceMaterial.organismId":"Identifier","SubstanceSourceMaterial.organismName":"string","SubstanceSourceMaterial.parentSubstanceId":"Identifier","SubstanceSourceMaterial.parentSubstanceName":"string","SubstanceSourceMaterial.partDescription":"BackboneElement","SubstanceSourceMaterial.partDescription.extension":"Extension","SubstanceSourceMaterial.partDescription.id":"System.String","SubstanceSourceMaterial.partDescription.modifierExtension":"Extension","SubstanceSourceMaterial.partDescription.part":"CodeableConcept","SubstanceSourceMaterial.partDescription.partLocation":"CodeableConcept","SubstanceSourceMaterial.sourceMaterialClass":"CodeableConcept","SubstanceSourceMaterial.sourceMaterialState":"CodeableConcept","SubstanceSourceMaterial.sourceMaterialType":"CodeableConcept","SubstanceSourceMaterial.text":"Narrative","SubstanceSpecification.code":"BackboneElement","SubstanceSpecification.code.code":"CodeableConcept","SubstanceSpecification.code.comment":"string","SubstanceSpecification.code.extension":"Extension","SubstanceSpecification.code.id":"System.String","SubstanceSpecification.code.modifierExtension":"Extension","SubstanceSpecification.code.source":"Reference","SubstanceSpecification.code.status":"CodeableConcept","SubstanceSpecification.code.statusDate":"dateTime","SubstanceSpecification.comment":"string","SubstanceSpecification.contained":"Resource","SubstanceSpecification.description":"string","SubstanceSpecification.domain":"CodeableConcept","SubstanceSpecification.extension":"Extension","SubstanceSpecification.id":"System.String","SubstanceSpecification.identifier":"Identifier","SubstanceSpecification.implicitRules":"uri","SubstanceSpecification.language":"code","SubstanceSpecification.meta":"Meta","SubstanceSpecification.modifierExtension":"Extension","SubstanceSpecification.moiety":"BackboneElement","SubstanceSpecification.moiety.amountQuantity":"Quantity","SubstanceSpecification.moiety.amountString":"string","SubstanceSpecification.moiety.extension":"Extension","SubstanceSpecification.moiety.id":"System.String","SubstanceSpecification.moiety.identifier":"Identifier","SubstanceSpecification.moiety.modifierExtension":"Extension","SubstanceSpecification.moiety.molecularFormula":"string","SubstanceSpecification.moiety.name":"string","SubstanceSpecification.moiety.opticalActivity":"CodeableConcept","SubstanceSpecification.moiety.role":"CodeableConcept","SubstanceSpecification.moiety.stereochemistry":"CodeableConcept","SubstanceSpecification.name":"BackboneElement","SubstanceSpecification.name.domain":"CodeableConcept","SubstanceSpecification.name.extension":"Extension","SubstanceSpecification.name.id":"System.String","SubstanceSpecification.name.jurisdiction":"CodeableConcept","SubstanceSpecification.name.language":"CodeableConcept","SubstanceSpecification.name.modifierExtension":"Extension","SubstanceSpecification.name.name":"string","SubstanceSpecification.name.official":"BackboneElement","SubstanceSpecification.name.official.authority":"CodeableConcept","SubstanceSpecification.name.official.date":"dateTime","SubstanceSpecification.name.official.extension":"Extension","SubstanceSpecification.name.official.id":"System.String","SubstanceSpecification.name.official.modifierExtension":"Extension","SubstanceSpecification.name.official.status":"CodeableConcept","SubstanceSpecification.name.preferred":"boolean","SubstanceSpecification.name.source":"Reference","SubstanceSpecification.name.status":"CodeableConcept","SubstanceSpecification.name.type":"CodeableConcept","SubstanceSpecification.nucleicAcid":"Reference","SubstanceSpecification.polymer":"Reference","SubstanceSpecification.property":"BackboneElement","SubstanceSpecification.property.amountQuantity":"Quantity","SubstanceSpecification.property.amountString":"string","SubstanceSpecification.property.category":"CodeableConcept","SubstanceSpecification.property.code":"CodeableConcept","SubstanceSpecification.property.definingSubstanceCodeableConcept":"CodeableConcept","SubstanceSpecification.property.definingSubstanceReference":"Reference","SubstanceSpecification.property.extension":"Extension","SubstanceSpecification.property.id":"System.String","SubstanceSpecification.property.modifierExtension":"Extension","SubstanceSpecification.property.parameters":"string","SubstanceSpecification.protein":"Reference","SubstanceSpecification.referenceInformation":"Reference","SubstanceSpecification.relationship":"BackboneElement","SubstanceSpecification.relationship.amountQuantity":"Quantity","SubstanceSpecification.relationship.amountRange":"Range","SubstanceSpecification.relationship.amountRatio":"Ratio","SubstanceSpecification.relationship.amountRatioLowLimit":"Ratio","SubstanceSpecification.relationship.amountString":"string","SubstanceSpecification.relationship.amountType":"CodeableConcept","SubstanceSpecification.relationship.extension":"Extension","SubstanceSpecification.relationship.id":"System.String","SubstanceSpecification.relationship.isDefining":"boolean","SubstanceSpecification.relationship.modifierExtension":"Extension","SubstanceSpecification.relationship.relationship":"CodeableConcept","SubstanceSpecification.relationship.source":"Reference","SubstanceSpecification.relationship.substanceCodeableConcept":"CodeableConcept","SubstanceSpecification.relationship.substanceReference":"Reference","SubstanceSpecification.source":"Reference","SubstanceSpecification.sourceMaterial":"Reference","SubstanceSpecification.status":"CodeableConcept","SubstanceSpecification.structure":"BackboneElement","SubstanceSpecification.structure.extension":"Extension","SubstanceSpecification.structure.id":"System.String","SubstanceSpecification.structure.isotope":"BackboneElement","SubstanceSpecification.structure.isotope.extension":"Extension","SubstanceSpecification.structure.isotope.halfLife":"Quantity","SubstanceSpecification.structure.isotope.id":"System.String","SubstanceSpecification.structure.isotope.identifier":"Identifier","SubstanceSpecification.structure.isotope.modifierExtension":"Extension","SubstanceSpecification.structure.isotope.molecularWeight":"BackboneElement","SubstanceSpecification.structure.isotope.molecularWeight.amount":"Quantity","SubstanceSpecification.structure.isotope.molecularWeight.extension":"Extension","SubstanceSpecification.structure.isotope.molecularWeight.id":"System.String","SubstanceSpecification.structure.isotope.molecularWeight.method":"CodeableConcept","SubstanceSpecification.structure.isotope.molecularWeight.modifierExtension":"Extension","SubstanceSpecification.structure.isotope.molecularWeight.type":"CodeableConcept","SubstanceSpecification.structure.isotope.name":"CodeableConcept","SubstanceSpecification.structure.isotope.substitution":"CodeableConcept","SubstanceSpecification.structure.modifierExtension":"Extension","SubstanceSpecification.structure.molecularFormula":"string","SubstanceSpecification.structure.molecularFormulaByMoiety":"string","SubstanceSpecification.structure.opticalActivity":"CodeableConcept","SubstanceSpecification.structure.representation":"BackboneElement","SubstanceSpecification.structure.representation.attachment":"Attachment","SubstanceSpecification.structure.representation.extension":"Extension","SubstanceSpecification.structure.representation.id":"System.String","SubstanceSpecification.structure.representation.modifierExtension":"Extension","SubstanceSpecification.structure.representation.representation":"string","SubstanceSpecification.structure.representation.type":"CodeableConcept","SubstanceSpecification.structure.source":"Reference","SubstanceSpecification.structure.stereochemistry":"CodeableConcept","SubstanceSpecification.text":"Narrative","SubstanceSpecification.type":"CodeableConcept","SupplyDelivery.basedOn":"Reference","SupplyDelivery.contained":"Resource","SupplyDelivery.destination":"Reference","SupplyDelivery.extension":"Extension","SupplyDelivery.id":"System.String","SupplyDelivery.identifier":"Identifier","SupplyDelivery.implicitRules":"uri","SupplyDelivery.language":"code","SupplyDelivery.meta":"Meta","SupplyDelivery.modifierExtension":"Extension","SupplyDelivery.occurrenceDateTime":"dateTime","SupplyDelivery.occurrencePeriod":"Period","SupplyDelivery.occurrenceTiming":"Timing","SupplyDelivery.partOf":"Reference","SupplyDelivery.patient":"Reference","SupplyDelivery.receiver":"Reference","SupplyDelivery.status":"code","SupplyDelivery.suppliedItem":"BackboneElement","SupplyDelivery.suppliedItem.extension":"Extension","SupplyDelivery.suppliedItem.id":"System.String","SupplyDelivery.suppliedItem.itemCodeableConcept":"CodeableConcept","SupplyDelivery.suppliedItem.itemReference":"Reference","SupplyDelivery.suppliedItem.modifierExtension":"Extension","SupplyDelivery.suppliedItem.quantity":"Quantity","SupplyDelivery.supplier":"Reference","SupplyDelivery.text":"Narrative","SupplyDelivery.type":"CodeableConcept","SupplyRequest.authoredOn":"dateTime","SupplyRequest.category":"CodeableConcept","SupplyRequest.contained":"Resource","SupplyRequest.deliverFrom":"Reference","SupplyRequest.deliverTo":"Reference","SupplyRequest.extension":"Extension","SupplyRequest.id":"System.String","SupplyRequest.identifier":"Identifier","SupplyRequest.implicitRules":"uri","SupplyRequest.itemCodeableConcept":"CodeableConcept","SupplyRequest.itemReference":"Reference","SupplyRequest.language":"code","SupplyRequest.meta":"Meta","SupplyRequest.modifierExtension":"Extension","SupplyRequest.occurrenceDateTime":"dateTime","SupplyRequest.occurrencePeriod":"Period","SupplyRequest.occurrenceTiming":"Timing","SupplyRequest.parameter":"BackboneElement","SupplyRequest.parameter.code":"CodeableConcept","SupplyRequest.parameter.extension":"Extension","SupplyRequest.parameter.id":"System.String","SupplyRequest.parameter.modifierExtension":"Extension","SupplyRequest.parameter.valueBoolean":"boolean","SupplyRequest.parameter.valueCodeableConcept":"CodeableConcept","SupplyRequest.parameter.valueQuantity":"Quantity","SupplyRequest.parameter.valueRange":"Range","SupplyRequest.priority":"code","SupplyRequest.quantity":"Quantity","SupplyRequest.reasonCode":"CodeableConcept","SupplyRequest.reasonReference":"Reference","SupplyRequest.requester":"Reference","SupplyRequest.status":"code","SupplyRequest.supplier":"Reference","SupplyRequest.text":"Narrative","Task.authoredOn":"dateTime","Task.basedOn":"Reference","Task.businessStatus":"CodeableConcept","Task.code":"CodeableConcept","Task.contained":"Resource","Task.description":"string","Task.encounter":"Reference","Task.executionPeriod":"Period","Task.extension":"Extension","Task.focus":"Reference","Task.for":"Reference","Task.groupIdentifier":"Identifier","Task.id":"System.String","Task.identifier":"Identifier","Task.implicitRules":"uri","Task.input":"BackboneElement","Task.input.extension":"Extension","Task.input.id":"System.String","Task.input.modifierExtension":"Extension","Task.input.type":"CodeableConcept","Task.input.valueAddress":"Address","Task.input.valueAge":"Age","Task.input.valueAnnotation":"Annotation","Task.input.valueAttachment":"Attachment","Task.input.valueBase64Binary":"base64Binary","Task.input.valueBoolean":"boolean","Task.input.valueCanonical":"canonical","Task.input.valueCode":"code","Task.input.valueCodeableConcept":"CodeableConcept","Task.input.valueCoding":"Coding","Task.input.valueContactDetail":"ContactDetail","Task.input.valueContactPoint":"ContactPoint","Task.input.valueContributor":"Contributor","Task.input.valueCount":"Count","Task.input.valueDataRequirement":"DataRequirement","Task.input.valueDate":"date","Task.input.valueDateTime":"dateTime","Task.input.valueDecimal":"decimal","Task.input.valueDistance":"Distance","Task.input.valueDosage":"Dosage","Task.input.valueDuration":"Duration","Task.input.valueExpression":"Expression","Task.input.valueHumanName":"HumanName","Task.input.valueId":"id","Task.input.valueIdentifier":"Identifier","Task.input.valueInstant":"instant","Task.input.valueInteger":"integer","Task.input.valueMarkdown":"markdown","Task.input.valueMeta":"Meta","Task.input.valueMoney":"Money","Task.input.valueOid":"oid","Task.input.valueParameterDefinition":"ParameterDefinition","Task.input.valuePeriod":"Period","Task.input.valuePositiveInt":"positiveInt","Task.input.valueQuantity":"Quantity","Task.input.valueRange":"Range","Task.input.valueRatio":"Ratio","Task.input.valueReference":"Reference","Task.input.valueRelatedArtifact":"RelatedArtifact","Task.input.valueSampledData":"SampledData","Task.input.valueSignature":"Signature","Task.input.valueString":"string","Task.input.valueTime":"time","Task.input.valueTiming":"Timing","Task.input.valueTriggerDefinition":"TriggerDefinition","Task.input.valueUnsignedInt":"unsignedInt","Task.input.valueUri":"uri","Task.input.valueUrl":"url","Task.input.valueUsageContext":"UsageContext","Task.input.valueUuid":"uuid","Task.instantiatesCanonical":"canonical","Task.instantiatesUri":"uri","Task.insurance":"Reference","Task.intent":"code","Task.language":"code","Task.lastModified":"dateTime","Task.location":"Reference","Task.meta":"Meta","Task.modifierExtension":"Extension","Task.note":"Annotation","Task.output":"BackboneElement","Task.output.extension":"Extension","Task.output.id":"System.String","Task.output.modifierExtension":"Extension","Task.output.type":"CodeableConcept","Task.output.valueAddress":"Address","Task.output.valueAge":"Age","Task.output.valueAnnotation":"Annotation","Task.output.valueAttachment":"Attachment","Task.output.valueBase64Binary":"base64Binary","Task.output.valueBoolean":"boolean","Task.output.valueCanonical":"canonical","Task.output.valueCode":"code","Task.output.valueCodeableConcept":"CodeableConcept","Task.output.valueCoding":"Coding","Task.output.valueContactDetail":"ContactDetail","Task.output.valueContactPoint":"ContactPoint","Task.output.valueContributor":"Contributor","Task.output.valueCount":"Count","Task.output.valueDataRequirement":"DataRequirement","Task.output.valueDate":"date","Task.output.valueDateTime":"dateTime","Task.output.valueDecimal":"decimal","Task.output.valueDistance":"Distance","Task.output.valueDosage":"Dosage","Task.output.valueDuration":"Duration","Task.output.valueExpression":"Expression","Task.output.valueHumanName":"HumanName","Task.output.valueId":"id","Task.output.valueIdentifier":"Identifier","Task.output.valueInstant":"instant","Task.output.valueInteger":"integer","Task.output.valueMarkdown":"markdown","Task.output.valueMeta":"Meta","Task.output.valueMoney":"Money","Task.output.valueOid":"oid","Task.output.valueParameterDefinition":"ParameterDefinition","Task.output.valuePeriod":"Period","Task.output.valuePositiveInt":"positiveInt","Task.output.valueQuantity":"Quantity","Task.output.valueRange":"Range","Task.output.valueRatio":"Ratio","Task.output.valueReference":"Reference","Task.output.valueRelatedArtifact":"RelatedArtifact","Task.output.valueSampledData":"SampledData","Task.output.valueSignature":"Signature","Task.output.valueString":"string","Task.output.valueTime":"time","Task.output.valueTiming":"Timing","Task.output.valueTriggerDefinition":"TriggerDefinition","Task.output.valueUnsignedInt":"unsignedInt","Task.output.valueUri":"uri","Task.output.valueUrl":"url","Task.output.valueUsageContext":"UsageContext","Task.output.valueUuid":"uuid","Task.owner":"Reference","Task.partOf":"Reference","Task.performerType":"CodeableConcept","Task.priority":"code","Task.reasonCode":"CodeableConcept","Task.reasonReference":"Reference","Task.relevantHistory":"Reference","Task.requester":"Reference","Task.restriction":"BackboneElement","Task.restriction.extension":"Extension","Task.restriction.id":"System.String","Task.restriction.modifierExtension":"Extension","Task.restriction.period":"Period","Task.restriction.recipient":"Reference","Task.restriction.repetitions":"positiveInt","Task.status":"code","Task.statusReason":"CodeableConcept","Task.text":"Narrative","TerminologyCapabilities.closure":"BackboneElement","TerminologyCapabilities.closure.extension":"Extension","TerminologyCapabilities.closure.id":"System.String","TerminologyCapabilities.closure.modifierExtension":"Extension","TerminologyCapabilities.closure.translation":"boolean","TerminologyCapabilities.codeSearch":"code","TerminologyCapabilities.codeSystem":"BackboneElement","TerminologyCapabilities.codeSystem.extension":"Extension","TerminologyCapabilities.codeSystem.id":"System.String","TerminologyCapabilities.codeSystem.modifierExtension":"Extension","TerminologyCapabilities.codeSystem.subsumption":"boolean","TerminologyCapabilities.codeSystem.uri":"canonical","TerminologyCapabilities.codeSystem.version":"BackboneElement","TerminologyCapabilities.codeSystem.version.code":"string","TerminologyCapabilities.codeSystem.version.compositional":"boolean","TerminologyCapabilities.codeSystem.version.extension":"Extension","TerminologyCapabilities.codeSystem.version.filter":"BackboneElement","TerminologyCapabilities.codeSystem.version.filter.code":"code","TerminologyCapabilities.codeSystem.version.filter.extension":"Extension","TerminologyCapabilities.codeSystem.version.filter.id":"System.String","TerminologyCapabilities.codeSystem.version.filter.modifierExtension":"Extension","TerminologyCapabilities.codeSystem.version.filter.op":"code","TerminologyCapabilities.codeSystem.version.id":"System.String","TerminologyCapabilities.codeSystem.version.isDefault":"boolean","TerminologyCapabilities.codeSystem.version.language":"code","TerminologyCapabilities.codeSystem.version.modifierExtension":"Extension","TerminologyCapabilities.codeSystem.version.property":"code","TerminologyCapabilities.contact":"ContactDetail","TerminologyCapabilities.contained":"Resource","TerminologyCapabilities.copyright":"markdown","TerminologyCapabilities.date":"dateTime","TerminologyCapabilities.description":"markdown","TerminologyCapabilities.expansion":"BackboneElement","TerminologyCapabilities.expansion.extension":"Extension","TerminologyCapabilities.expansion.hierarchical":"boolean","TerminologyCapabilities.expansion.id":"System.String","TerminologyCapabilities.expansion.incomplete":"boolean","TerminologyCapabilities.expansion.modifierExtension":"Extension","TerminologyCapabilities.expansion.paging":"boolean","TerminologyCapabilities.expansion.parameter":"BackboneElement","TerminologyCapabilities.expansion.parameter.documentation":"string","TerminologyCapabilities.expansion.parameter.extension":"Extension","TerminologyCapabilities.expansion.parameter.id":"System.String","TerminologyCapabilities.expansion.parameter.modifierExtension":"Extension","TerminologyCapabilities.expansion.parameter.name":"code","TerminologyCapabilities.expansion.textFilter":"markdown","TerminologyCapabilities.experimental":"boolean","TerminologyCapabilities.extension":"Extension","TerminologyCapabilities.id":"System.String","TerminologyCapabilities.implementation":"BackboneElement","TerminologyCapabilities.implementation.description":"string","TerminologyCapabilities.implementation.extension":"Extension","TerminologyCapabilities.implementation.id":"System.String","TerminologyCapabilities.implementation.modifierExtension":"Extension","TerminologyCapabilities.implementation.url":"url","TerminologyCapabilities.implicitRules":"uri","TerminologyCapabilities.jurisdiction":"CodeableConcept","TerminologyCapabilities.kind":"code","TerminologyCapabilities.language":"code","TerminologyCapabilities.lockedDate":"boolean","TerminologyCapabilities.meta":"Meta","TerminologyCapabilities.modifierExtension":"Extension","TerminologyCapabilities.name":"string","TerminologyCapabilities.publisher":"string","TerminologyCapabilities.purpose":"markdown","TerminologyCapabilities.software":"BackboneElement","TerminologyCapabilities.software.extension":"Extension","TerminologyCapabilities.software.id":"System.String","TerminologyCapabilities.software.modifierExtension":"Extension","TerminologyCapabilities.software.name":"string","TerminologyCapabilities.software.version":"string","TerminologyCapabilities.status":"code","TerminologyCapabilities.text":"Narrative","TerminologyCapabilities.title":"string","TerminologyCapabilities.translation":"BackboneElement","TerminologyCapabilities.translation.extension":"Extension","TerminologyCapabilities.translation.id":"System.String","TerminologyCapabilities.translation.modifierExtension":"Extension","TerminologyCapabilities.translation.needsMap":"boolean","TerminologyCapabilities.url":"uri","TerminologyCapabilities.useContext":"UsageContext","TerminologyCapabilities.validateCode":"BackboneElement","TerminologyCapabilities.validateCode.extension":"Extension","TerminologyCapabilities.validateCode.id":"System.String","TerminologyCapabilities.validateCode.modifierExtension":"Extension","TerminologyCapabilities.validateCode.translations":"boolean","TerminologyCapabilities.version":"string","TestReport.contained":"Resource","TestReport.extension":"Extension","TestReport.id":"System.String","TestReport.identifier":"Identifier","TestReport.implicitRules":"uri","TestReport.issued":"dateTime","TestReport.language":"code","TestReport.meta":"Meta","TestReport.modifierExtension":"Extension","TestReport.name":"string","TestReport.participant":"BackboneElement","TestReport.participant.display":"string","TestReport.participant.extension":"Extension","TestReport.participant.id":"System.String","TestReport.participant.modifierExtension":"Extension","TestReport.participant.type":"code","TestReport.participant.uri":"uri","TestReport.result":"code","TestReport.score":"decimal","TestReport.setup":"BackboneElement","TestReport.setup.action":"BackboneElement","TestReport.setup.action.assert":"BackboneElement","TestReport.setup.action.assert.detail":"string","TestReport.setup.action.assert.extension":"Extension","TestReport.setup.action.assert.id":"System.String","TestReport.setup.action.assert.message":"markdown","TestReport.setup.action.assert.modifierExtension":"Extension","TestReport.setup.action.assert.result":"code","TestReport.setup.action.extension":"Extension","TestReport.setup.action.id":"System.String","TestReport.setup.action.modifierExtension":"Extension","TestReport.setup.action.operation":"BackboneElement","TestReport.setup.action.operation.detail":"uri","TestReport.setup.action.operation.extension":"Extension","TestReport.setup.action.operation.id":"System.String","TestReport.setup.action.operation.message":"markdown","TestReport.setup.action.operation.modifierExtension":"Extension","TestReport.setup.action.operation.result":"code","TestReport.setup.extension":"Extension","TestReport.setup.id":"System.String","TestReport.setup.modifierExtension":"Extension","TestReport.status":"code","TestReport.teardown":"BackboneElement","TestReport.teardown.action":"BackboneElement","TestReport.teardown.action.extension":"Extension","TestReport.teardown.action.id":"System.String","TestReport.teardown.action.modifierExtension":"Extension","TestReport.teardown.extension":"Extension","TestReport.teardown.id":"System.String","TestReport.teardown.modifierExtension":"Extension","TestReport.test":"BackboneElement","TestReport.test.action":"BackboneElement","TestReport.test.action.extension":"Extension","TestReport.test.action.id":"System.String","TestReport.test.action.modifierExtension":"Extension","TestReport.test.description":"string","TestReport.test.extension":"Extension","TestReport.test.id":"System.String","TestReport.test.modifierExtension":"Extension","TestReport.test.name":"string","TestReport.testScript":"Reference","TestReport.tester":"string","TestReport.text":"Narrative","TestScript.contact":"ContactDetail","TestScript.contained":"Resource","TestScript.copyright":"markdown","TestScript.date":"dateTime","TestScript.description":"markdown","TestScript.destination":"BackboneElement","TestScript.destination.extension":"Extension","TestScript.destination.id":"System.String","TestScript.destination.index":"integer","TestScript.destination.modifierExtension":"Extension","TestScript.destination.profile":"Coding","TestScript.experimental":"boolean","TestScript.extension":"Extension","TestScript.fixture":"BackboneElement","TestScript.fixture.autocreate":"boolean","TestScript.fixture.autodelete":"boolean","TestScript.fixture.extension":"Extension","TestScript.fixture.id":"System.String","TestScript.fixture.modifierExtension":"Extension","TestScript.fixture.resource":"Reference","TestScript.id":"System.String","TestScript.identifier":"Identifier","TestScript.implicitRules":"uri","TestScript.jurisdiction":"CodeableConcept","TestScript.language":"code","TestScript.meta":"Meta","TestScript.metadata":"BackboneElement","TestScript.metadata.capability":"BackboneElement","TestScript.metadata.capability.capabilities":"canonical","TestScript.metadata.capability.description":"string","TestScript.metadata.capability.destination":"integer","TestScript.metadata.capability.extension":"Extension","TestScript.metadata.capability.id":"System.String","TestScript.metadata.capability.link":"uri","TestScript.metadata.capability.modifierExtension":"Extension","TestScript.metadata.capability.origin":"integer","TestScript.metadata.capability.required":"boolean","TestScript.metadata.capability.validated":"boolean","TestScript.metadata.extension":"Extension","TestScript.metadata.id":"System.String","TestScript.metadata.link":"BackboneElement","TestScript.metadata.link.description":"string","TestScript.metadata.link.extension":"Extension","TestScript.metadata.link.id":"System.String","TestScript.metadata.link.modifierExtension":"Extension","TestScript.metadata.link.url":"uri","TestScript.metadata.modifierExtension":"Extension","TestScript.modifierExtension":"Extension","TestScript.name":"string","TestScript.origin":"BackboneElement","TestScript.origin.extension":"Extension","TestScript.origin.id":"System.String","TestScript.origin.index":"integer","TestScript.origin.modifierExtension":"Extension","TestScript.origin.profile":"Coding","TestScript.profile":"Reference","TestScript.publisher":"string","TestScript.purpose":"markdown","TestScript.setup":"BackboneElement","TestScript.setup.action":"BackboneElement","TestScript.setup.action.assert":"BackboneElement","TestScript.setup.action.assert.compareToSourceExpression":"string","TestScript.setup.action.assert.compareToSourceId":"string","TestScript.setup.action.assert.compareToSourcePath":"string","TestScript.setup.action.assert.contentType":"code","TestScript.setup.action.assert.description":"string","TestScript.setup.action.assert.direction":"code","TestScript.setup.action.assert.expression":"string","TestScript.setup.action.assert.extension":"Extension","TestScript.setup.action.assert.headerField":"string","TestScript.setup.action.assert.id":"System.String","TestScript.setup.action.assert.label":"string","TestScript.setup.action.assert.minimumId":"string","TestScript.setup.action.assert.modifierExtension":"Extension","TestScript.setup.action.assert.navigationLinks":"boolean","TestScript.setup.action.assert.operator":"code","TestScript.setup.action.assert.path":"string","TestScript.setup.action.assert.requestMethod":"code","TestScript.setup.action.assert.requestURL":"string","TestScript.setup.action.assert.resource":"code","TestScript.setup.action.assert.response":"code","TestScript.setup.action.assert.responseCode":"string","TestScript.setup.action.assert.sourceId":"id","TestScript.setup.action.assert.validateProfileId":"id","TestScript.setup.action.assert.value":"string","TestScript.setup.action.assert.warningOnly":"boolean","TestScript.setup.action.extension":"Extension","TestScript.setup.action.id":"System.String","TestScript.setup.action.modifierExtension":"Extension","TestScript.setup.action.operation":"BackboneElement","TestScript.setup.action.operation.accept":"code","TestScript.setup.action.operation.contentType":"code","TestScript.setup.action.operation.description":"string","TestScript.setup.action.operation.destination":"integer","TestScript.setup.action.operation.encodeRequestUrl":"boolean","TestScript.setup.action.operation.extension":"Extension","TestScript.setup.action.operation.id":"System.String","TestScript.setup.action.operation.label":"string","TestScript.setup.action.operation.method":"code","TestScript.setup.action.operation.modifierExtension":"Extension","TestScript.setup.action.operation.origin":"integer","TestScript.setup.action.operation.params":"string","TestScript.setup.action.operation.requestHeader":"BackboneElement","TestScript.setup.action.operation.requestHeader.extension":"Extension","TestScript.setup.action.operation.requestHeader.field":"string","TestScript.setup.action.operation.requestHeader.id":"System.String","TestScript.setup.action.operation.requestHeader.modifierExtension":"Extension","TestScript.setup.action.operation.requestHeader.value":"string","TestScript.setup.action.operation.requestId":"id","TestScript.setup.action.operation.resource":"code","TestScript.setup.action.operation.responseId":"id","TestScript.setup.action.operation.sourceId":"id","TestScript.setup.action.operation.targetId":"id","TestScript.setup.action.operation.type":"Coding","TestScript.setup.action.operation.url":"string","TestScript.setup.extension":"Extension","TestScript.setup.id":"System.String","TestScript.setup.modifierExtension":"Extension","TestScript.status":"code","TestScript.teardown":"BackboneElement","TestScript.teardown.action":"BackboneElement","TestScript.teardown.action.extension":"Extension","TestScript.teardown.action.id":"System.String","TestScript.teardown.action.modifierExtension":"Extension","TestScript.teardown.extension":"Extension","TestScript.teardown.id":"System.String","TestScript.teardown.modifierExtension":"Extension","TestScript.test":"BackboneElement","TestScript.test.action":"BackboneElement","TestScript.test.action.extension":"Extension","TestScript.test.action.id":"System.String","TestScript.test.action.modifierExtension":"Extension","TestScript.test.description":"string","TestScript.test.extension":"Extension","TestScript.test.id":"System.String","TestScript.test.modifierExtension":"Extension","TestScript.test.name":"string","TestScript.text":"Narrative","TestScript.title":"string","TestScript.url":"uri","TestScript.useContext":"UsageContext","TestScript.variable":"BackboneElement","TestScript.variable.defaultValue":"string","TestScript.variable.description":"string","TestScript.variable.expression":"string","TestScript.variable.extension":"Extension","TestScript.variable.headerField":"string","TestScript.variable.hint":"string","TestScript.variable.id":"System.String","TestScript.variable.modifierExtension":"Extension","TestScript.variable.name":"string","TestScript.variable.path":"string","TestScript.variable.sourceId":"id","TestScript.version":"string","Timing.code":"CodeableConcept","Timing.event":"dateTime","Timing.extension":"Extension","Timing.id":"System.String","Timing.modifierExtension":"Extension","Timing.repeat":"Element","Timing.repeat.boundsDuration":"Duration","Timing.repeat.boundsPeriod":"Period","Timing.repeat.boundsRange":"Range","Timing.repeat.count":"positiveInt","Timing.repeat.countMax":"positiveInt","Timing.repeat.dayOfWeek":"code","Timing.repeat.duration":"decimal","Timing.repeat.durationMax":"decimal","Timing.repeat.durationUnit":"code","Timing.repeat.extension":"Extension","Timing.repeat.frequency":"positiveInt","Timing.repeat.frequencyMax":"positiveInt","Timing.repeat.id":"System.String","Timing.repeat.offset":"unsignedInt","Timing.repeat.period":"decimal","Timing.repeat.periodMax":"decimal","Timing.repeat.periodUnit":"code","Timing.repeat.timeOfDay":"time","Timing.repeat.when":"code","TriggerDefinition.condition":"Expression","TriggerDefinition.data":"DataRequirement","TriggerDefinition.extension":"Extension","TriggerDefinition.id":"System.String","TriggerDefinition.name":"string","TriggerDefinition.timingDate":"date","TriggerDefinition.timingDateTime":"dateTime","TriggerDefinition.timingReference":"Reference","TriggerDefinition.timingTiming":"Timing","TriggerDefinition.type":"code","UsageContext.code":"Coding","UsageContext.extension":"Extension","UsageContext.id":"System.String","UsageContext.valueCodeableConcept":"CodeableConcept","UsageContext.valueQuantity":"Quantity","UsageContext.valueRange":"Range","UsageContext.valueReference":"Reference","ValueSet.compose":"BackboneElement","ValueSet.compose.extension":"Extension","ValueSet.compose.id":"System.String","ValueSet.compose.inactive":"boolean","ValueSet.compose.include":"BackboneElement","ValueSet.compose.include.concept":"BackboneElement","ValueSet.compose.include.concept.code":"code","ValueSet.compose.include.concept.designation":"BackboneElement","ValueSet.compose.include.concept.designation.extension":"Extension","ValueSet.compose.include.concept.designation.id":"System.String","ValueSet.compose.include.concept.designation.language":"code","ValueSet.compose.include.concept.designation.modifierExtension":"Extension","ValueSet.compose.include.concept.designation.use":"Coding","ValueSet.compose.include.concept.designation.value":"string","ValueSet.compose.include.concept.display":"string","ValueSet.compose.include.concept.extension":"Extension","ValueSet.compose.include.concept.id":"System.String","ValueSet.compose.include.concept.modifierExtension":"Extension","ValueSet.compose.include.extension":"Extension","ValueSet.compose.include.filter":"BackboneElement","ValueSet.compose.include.filter.extension":"Extension","ValueSet.compose.include.filter.id":"System.String","ValueSet.compose.include.filter.modifierExtension":"Extension","ValueSet.compose.include.filter.op":"code","ValueSet.compose.include.filter.property":"code","ValueSet.compose.include.filter.value":"string","ValueSet.compose.include.id":"System.String","ValueSet.compose.include.modifierExtension":"Extension","ValueSet.compose.include.system":"uri","ValueSet.compose.include.valueSet":"canonical","ValueSet.compose.include.version":"string","ValueSet.compose.lockedDate":"date","ValueSet.compose.modifierExtension":"Extension","ValueSet.contact":"ContactDetail","ValueSet.contained":"Resource","ValueSet.copyright":"markdown","ValueSet.date":"dateTime","ValueSet.description":"markdown","ValueSet.expansion":"BackboneElement","ValueSet.expansion.contains":"BackboneElement","ValueSet.expansion.contains.abstract":"boolean","ValueSet.expansion.contains.code":"code","ValueSet.expansion.contains.display":"string","ValueSet.expansion.contains.extension":"Extension","ValueSet.expansion.contains.id":"System.String","ValueSet.expansion.contains.inactive":"boolean","ValueSet.expansion.contains.modifierExtension":"Extension","ValueSet.expansion.contains.system":"uri","ValueSet.expansion.contains.version":"string","ValueSet.expansion.extension":"Extension","ValueSet.expansion.id":"System.String","ValueSet.expansion.identifier":"uri","ValueSet.expansion.modifierExtension":"Extension","ValueSet.expansion.offset":"integer","ValueSet.expansion.parameter":"BackboneElement","ValueSet.expansion.parameter.extension":"Extension","ValueSet.expansion.parameter.id":"System.String","ValueSet.expansion.parameter.modifierExtension":"Extension","ValueSet.expansion.parameter.name":"string","ValueSet.expansion.parameter.valueBoolean":"boolean","ValueSet.expansion.parameter.valueCode":"code","ValueSet.expansion.parameter.valueDateTime":"dateTime","ValueSet.expansion.parameter.valueDecimal":"decimal","ValueSet.expansion.parameter.valueInteger":"integer","ValueSet.expansion.parameter.valueString":"string","ValueSet.expansion.parameter.valueUri":"uri","ValueSet.expansion.timestamp":"dateTime","ValueSet.expansion.total":"integer","ValueSet.experimental":"boolean","ValueSet.extension":"Extension","ValueSet.id":"System.String","ValueSet.identifier":"Identifier","ValueSet.immutable":"boolean","ValueSet.implicitRules":"uri","ValueSet.jurisdiction":"CodeableConcept","ValueSet.language":"code","ValueSet.meta":"Meta","ValueSet.modifierExtension":"Extension","ValueSet.name":"string","ValueSet.publisher":"string","ValueSet.purpose":"markdown","ValueSet.status":"code","ValueSet.text":"Narrative","ValueSet.title":"string","ValueSet.url":"uri","ValueSet.useContext":"UsageContext","ValueSet.version":"string","VerificationResult.attestation":"BackboneElement","VerificationResult.attestation.communicationMethod":"CodeableConcept","VerificationResult.attestation.date":"date","VerificationResult.attestation.extension":"Extension","VerificationResult.attestation.id":"System.String","VerificationResult.attestation.modifierExtension":"Extension","VerificationResult.attestation.onBehalfOf":"Reference","VerificationResult.attestation.proxyIdentityCertificate":"string","VerificationResult.attestation.proxySignature":"Signature","VerificationResult.attestation.sourceIdentityCertificate":"string","VerificationResult.attestation.sourceSignature":"Signature","VerificationResult.attestation.who":"Reference","VerificationResult.contained":"Resource","VerificationResult.extension":"Extension","VerificationResult.failureAction":"CodeableConcept","VerificationResult.frequency":"Timing","VerificationResult.id":"System.String","VerificationResult.implicitRules":"uri","VerificationResult.language":"code","VerificationResult.lastPerformed":"dateTime","VerificationResult.meta":"Meta","VerificationResult.modifierExtension":"Extension","VerificationResult.need":"CodeableConcept","VerificationResult.nextScheduled":"date","VerificationResult.primarySource":"BackboneElement","VerificationResult.primarySource.canPushUpdates":"CodeableConcept","VerificationResult.primarySource.communicationMethod":"CodeableConcept","VerificationResult.primarySource.extension":"Extension","VerificationResult.primarySource.id":"System.String","VerificationResult.primarySource.modifierExtension":"Extension","VerificationResult.primarySource.pushTypeAvailable":"CodeableConcept","VerificationResult.primarySource.type":"CodeableConcept","VerificationResult.primarySource.validationDate":"dateTime","VerificationResult.primarySource.validationStatus":"CodeableConcept","VerificationResult.primarySource.who":"Reference","VerificationResult.status":"code","VerificationResult.statusDate":"dateTime","VerificationResult.target":"Reference","VerificationResult.targetLocation":"string","VerificationResult.text":"Narrative","VerificationResult.validationProcess":"CodeableConcept","VerificationResult.validationType":"CodeableConcept","VerificationResult.validator":"BackboneElement","VerificationResult.validator.attestationSignature":"Signature","VerificationResult.validator.extension":"Extension","VerificationResult.validator.id":"System.String","VerificationResult.validator.identityCertificate":"string","VerificationResult.validator.modifierExtension":"Extension","VerificationResult.validator.organization":"Reference","VisionPrescription.contained":"Resource","VisionPrescription.created":"dateTime","VisionPrescription.dateWritten":"dateTime","VisionPrescription.encounter":"Reference","VisionPrescription.extension":"Extension","VisionPrescription.id":"System.String","VisionPrescription.identifier":"Identifier","VisionPrescription.implicitRules":"uri","VisionPrescription.language":"code","VisionPrescription.lensSpecification":"BackboneElement","VisionPrescription.lensSpecification.add":"decimal","VisionPrescription.lensSpecification.axis":"integer","VisionPrescription.lensSpecification.backCurve":"decimal","VisionPrescription.lensSpecification.brand":"string","VisionPrescription.lensSpecification.color":"string","VisionPrescription.lensSpecification.cylinder":"decimal","VisionPrescription.lensSpecification.diameter":"decimal","VisionPrescription.lensSpecification.duration":"Quantity","VisionPrescription.lensSpecification.extension":"Extension","VisionPrescription.lensSpecification.eye":"code","VisionPrescription.lensSpecification.id":"System.String","VisionPrescription.lensSpecification.modifierExtension":"Extension","VisionPrescription.lensSpecification.note":"Annotation","VisionPrescription.lensSpecification.power":"decimal","VisionPrescription.lensSpecification.prism":"BackboneElement","VisionPrescription.lensSpecification.prism.amount":"decimal","VisionPrescription.lensSpecification.prism.base":"code","VisionPrescription.lensSpecification.prism.extension":"Extension","VisionPrescription.lensSpecification.prism.id":"System.String","VisionPrescription.lensSpecification.prism.modifierExtension":"Extension","VisionPrescription.lensSpecification.product":"CodeableConcept","VisionPrescription.lensSpecification.sphere":"decimal","VisionPrescription.meta":"Meta","VisionPrescription.modifierExtension":"Extension","VisionPrescription.patient":"Reference","VisionPrescription.prescriber":"Reference","VisionPrescription.status":"code","VisionPrescription.text":"Narrative","base64Binary.extension":"Extension","base64Binary.id":"System.String","base64Binary.value":"System.String","boolean.extension":"Extension","boolean.id":"System.String","boolean.value":"System.Boolean","canonical.extension":"Extension","canonical.id":"System.String","canonical.value":"System.String","code.extension":"Extension","code.id":"System.String","code.value":"System.String","date.extension":"Extension","date.id":"System.String","date.value":"System.Date","dateTime.extension":"Extension","dateTime.id":"System.String","dateTime.value":"System.DateTime","decimal.extension":"Extension","decimal.id":"System.String","decimal.value":"System.Decimal","id.extension":"Extension","id.id":"System.String","id.value":"System.String","instant.extension":"Extension","instant.id":"System.String","instant.value":"System.DateTime","integer.extension":"Extension","integer.id":"System.String","integer.value":"System.Integer","markdown.extension":"Extension","markdown.id":"System.String","markdown.value":"System.String","oid.extension":"Extension","oid.id":"System.String","oid.value":"System.String","positiveInt.extension":"Extension","positiveInt.id":"System.String","positiveInt.value":"System.String","string.extension":"Extension","string.id":"System.String","string.value":"System.String","time.extension":"Extension","time.id":"System.String","time.value":"System.Time","unsignedInt.extension":"Extension","unsignedInt.id":"System.String","unsignedInt.value":"System.String","uri.extension":"Extension","uri.id":"System.String","uri.value":"System.String","url.extension":"Extension","url.id":"System.String","url.value":"System.String","uuid.extension":"Extension","uuid.id":"System.String","uuid.value":"System.String","xhtml.extension":"Extension","xhtml.id":"System.String","xhtml.value":"System.String"}',
                );
            },
            6717: function (e) {
                'use strict';
                e.exports = JSON.parse(
                    '{"Bundle.entry.link":"Bundle.link","CapabilityStatement.rest.operation":"CapabilityStatement.rest.resource.operation","CapabilityStatement.rest.searchParam":"CapabilityStatement.rest.resource.searchParam","ChargeItemDefinition.propertyGroup.applicability":"ChargeItemDefinition.applicability","ClaimResponse.addItem.adjudication":"ClaimResponse.item.adjudication","ClaimResponse.addItem.detail.adjudication":"ClaimResponse.item.adjudication","ClaimResponse.addItem.detail.subDetail.adjudication":"ClaimResponse.item.adjudication","ClaimResponse.adjudication":"ClaimResponse.item.adjudication","ClaimResponse.item.detail.adjudication":"ClaimResponse.item.adjudication","ClaimResponse.item.detail.subDetail.adjudication":"ClaimResponse.item.adjudication","CodeSystem.concept.concept":"CodeSystem.concept","Composition.section.section":"Composition.section","ConceptMap.group.element.target.product":"ConceptMap.group.element.target.dependsOn","Consent.provision.provision":"Consent.provision","Contract.term.asset.answer":"Contract.term.offer.answer","Contract.term.group":"Contract.term","ExampleScenario.process.step.alternative.step":"ExampleScenario.process.step","ExampleScenario.process.step.operation.request":"ExampleScenario.instance.containedInstance","ExampleScenario.process.step.operation.response":"ExampleScenario.instance.containedInstance","ExampleScenario.process.step.process":"ExampleScenario.process","ExplanationOfBenefit.addItem.adjudication":"ExplanationOfBenefit.item.adjudication","ExplanationOfBenefit.addItem.detail.adjudication":"ExplanationOfBenefit.item.adjudication","ExplanationOfBenefit.addItem.detail.subDetail.adjudication":"ExplanationOfBenefit.item.adjudication","ExplanationOfBenefit.adjudication":"ExplanationOfBenefit.item.adjudication","ExplanationOfBenefit.item.detail.adjudication":"ExplanationOfBenefit.item.adjudication","ExplanationOfBenefit.item.detail.subDetail.adjudication":"ExplanationOfBenefit.item.adjudication","GraphDefinition.link.target.link":"GraphDefinition.link","ImplementationGuide.definition.page.page":"ImplementationGuide.definition.page","Invoice.totalPriceComponent":"Invoice.lineItem.priceComponent","MedicinalProductAuthorization.procedure.application":"MedicinalProductAuthorization.procedure","MedicinalProductIngredient.substance.strength":"MedicinalProductIngredient.specifiedSubstance.strength","MedicinalProductPackaged.packageItem.packageItem":"MedicinalProductPackaged.packageItem","Observation.component.referenceRange":"Observation.referenceRange","OperationDefinition.parameter.part":"OperationDefinition.parameter","Parameters.parameter.part":"Parameters.parameter","PlanDefinition.action.action":"PlanDefinition.action","Provenance.entity.agent":"Provenance.agent","Questionnaire.item.item":"Questionnaire.item","QuestionnaireResponse.item.answer.item":"QuestionnaireResponse.item","QuestionnaireResponse.item.item":"QuestionnaireResponse.item","RequestGroup.action.action":"RequestGroup.action","StructureMap.group.rule.rule":"StructureMap.group.rule","SubstanceSpecification.molecularWeight":"SubstanceSpecification.structure.isotope.molecularWeight","SubstanceSpecification.name.synonym":"SubstanceSpecification.name","SubstanceSpecification.name.translation":"SubstanceSpecification.name","SubstanceSpecification.structure.molecularWeight":"SubstanceSpecification.structure.isotope.molecularWeight","TestReport.teardown.action.operation":"TestReport.setup.action.operation","TestReport.test.action.assert":"TestReport.setup.action.assert","TestReport.test.action.operation":"TestReport.setup.action.operation","TestScript.teardown.action.operation":"TestScript.setup.action.operation","TestScript.test.action.assert":"TestScript.setup.action.assert","TestScript.test.action.operation":"TestScript.setup.action.operation","ValueSet.compose.exclude":"ValueSet.compose.include","ValueSet.expansion.contains.contains":"ValueSet.expansion.contains","ValueSet.expansion.contains.designation":"ValueSet.compose.include.concept.designation"}',
                );
            },
            6707: function (e) {
                'use strict';
                e.exports = JSON.parse(
                    '{"Account":"DomainResource","ActivityDefinition":"DomainResource","Address":"Element","AdverseEvent":"DomainResource","Age":"Quantity","AllergyIntolerance":"DomainResource","Annotation":"Element","Appointment":"DomainResource","AppointmentResponse":"DomainResource","Attachment":"Element","AuditEvent":"DomainResource","BackboneElement":"Element","Basic":"DomainResource","Binary":"Resource","BiologicallyDerivedProduct":"DomainResource","BodyStructure":"DomainResource","Bundle":"Resource","CapabilityStatement":"DomainResource","CarePlan":"DomainResource","CareTeam":"DomainResource","CatalogEntry":"DomainResource","ChargeItem":"DomainResource","ChargeItemDefinition":"DomainResource","Claim":"DomainResource","ClaimResponse":"DomainResource","ClinicalImpression":"DomainResource","CodeSystem":"DomainResource","CodeableConcept":"Element","Coding":"Element","Communication":"DomainResource","CommunicationRequest":"DomainResource","CompartmentDefinition":"DomainResource","Composition":"DomainResource","ConceptMap":"DomainResource","Condition":"DomainResource","Consent":"DomainResource","ContactDetail":"Element","ContactPoint":"Element","Contract":"DomainResource","Contributor":"Element","Count":"Quantity","Coverage":"DomainResource","CoverageEligibilityRequest":"DomainResource","CoverageEligibilityResponse":"DomainResource","DataRequirement":"Element","DetectedIssue":"DomainResource","Device":"DomainResource","DeviceDefinition":"DomainResource","DeviceMetric":"DomainResource","DeviceRequest":"DomainResource","DeviceUseStatement":"DomainResource","DiagnosticReport":"DomainResource","Distance":"Quantity","DocumentManifest":"DomainResource","DocumentReference":"DomainResource","DomainResource":"Resource","Dosage":"BackboneElement","Duration":"Quantity","EffectEvidenceSynthesis":"DomainResource","ElementDefinition":"BackboneElement","Encounter":"DomainResource","Endpoint":"DomainResource","EnrollmentRequest":"DomainResource","EnrollmentResponse":"DomainResource","EpisodeOfCare":"DomainResource","EventDefinition":"DomainResource","Evidence":"DomainResource","EvidenceVariable":"DomainResource","ExampleScenario":"DomainResource","ExplanationOfBenefit":"DomainResource","Expression":"Element","Extension":"Element","FamilyMemberHistory":"DomainResource","Flag":"DomainResource","Goal":"DomainResource","GraphDefinition":"DomainResource","Group":"DomainResource","GuidanceResponse":"DomainResource","HealthcareService":"DomainResource","HumanName":"Element","Identifier":"Element","ImagingStudy":"DomainResource","Immunization":"DomainResource","ImmunizationEvaluation":"DomainResource","ImmunizationRecommendation":"DomainResource","ImplementationGuide":"DomainResource","InsurancePlan":"DomainResource","Invoice":"DomainResource","Library":"DomainResource","Linkage":"DomainResource","List":"DomainResource","Location":"DomainResource","MarketingStatus":"BackboneElement","Measure":"DomainResource","MeasureReport":"DomainResource","Media":"DomainResource","Medication":"DomainResource","MedicationAdministration":"DomainResource","MedicationDispense":"DomainResource","MedicationKnowledge":"DomainResource","MedicationRequest":"DomainResource","MedicationStatement":"DomainResource","MedicinalProduct":"DomainResource","MedicinalProductAuthorization":"DomainResource","MedicinalProductContraindication":"DomainResource","MedicinalProductIndication":"DomainResource","MedicinalProductIngredient":"DomainResource","MedicinalProductInteraction":"DomainResource","MedicinalProductManufactured":"DomainResource","MedicinalProductPackaged":"DomainResource","MedicinalProductPharmaceutical":"DomainResource","MedicinalProductUndesirableEffect":"DomainResource","MessageDefinition":"DomainResource","MessageHeader":"DomainResource","Meta":"Element","MolecularSequence":"DomainResource","Money":"Element","MoneyQuantity":"Quantity","NamingSystem":"DomainResource","Narrative":"Element","NutritionOrder":"DomainResource","Observation":"DomainResource","ObservationDefinition":"DomainResource","OperationDefinition":"DomainResource","OperationOutcome":"DomainResource","Organization":"DomainResource","OrganizationAffiliation":"DomainResource","ParameterDefinition":"Element","Parameters":"Resource","Patient":"DomainResource","PaymentNotice":"DomainResource","PaymentReconciliation":"DomainResource","Period":"Element","Person":"DomainResource","PlanDefinition":"DomainResource","Population":"BackboneElement","Practitioner":"DomainResource","PractitionerRole":"DomainResource","Procedure":"DomainResource","ProdCharacteristic":"BackboneElement","ProductShelfLife":"BackboneElement","Provenance":"DomainResource","Quantity":"Element","Questionnaire":"DomainResource","QuestionnaireResponse":"DomainResource","Range":"Element","Ratio":"Element","Reference":"Element","RelatedArtifact":"Element","RelatedPerson":"DomainResource","RequestGroup":"DomainResource","ResearchDefinition":"DomainResource","ResearchElementDefinition":"DomainResource","ResearchStudy":"DomainResource","ResearchSubject":"DomainResource","RiskAssessment":"DomainResource","RiskEvidenceSynthesis":"DomainResource","SampledData":"Element","Schedule":"DomainResource","SearchParameter":"DomainResource","ServiceRequest":"DomainResource","Signature":"Element","SimpleQuantity":"Quantity","Slot":"DomainResource","Specimen":"DomainResource","SpecimenDefinition":"DomainResource","StructureDefinition":"DomainResource","StructureMap":"DomainResource","Subscription":"DomainResource","Substance":"DomainResource","SubstanceAmount":"BackboneElement","SubstanceNucleicAcid":"DomainResource","SubstancePolymer":"DomainResource","SubstanceProtein":"DomainResource","SubstanceReferenceInformation":"DomainResource","SubstanceSourceMaterial":"DomainResource","SubstanceSpecification":"DomainResource","SupplyDelivery":"DomainResource","SupplyRequest":"DomainResource","Task":"DomainResource","TerminologyCapabilities":"DomainResource","TestReport":"DomainResource","TestScript":"DomainResource","Timing":"BackboneElement","TriggerDefinition":"Element","UsageContext":"Element","ValueSet":"DomainResource","VerificationResult":"DomainResource","VisionPrescription":"DomainResource","base64Binary":"Element","boolean":"Element","canonical":"uri","code":"string","date":"Element","dateTime":"Element","decimal":"Element","id":"string","instant":"Element","integer":"Element","markdown":"string","oid":"uri","positiveInt":"integer","string":"Element","time":"Element","unsignedInt":"integer","uri":"Element","url":"uri","uuid":"uri","xhtml":"Element"}',
                );
            },
            1265: function (e) {
                'use strict';
                e.exports = JSON.parse(
                    '{"ActivityDefinition.product":["Reference","CodeableConcept"],"ActivityDefinition.timing":["Timing","DateTime","Period","Range"],"AllergyIntolerance.onset":["DateTime","Age","Period","Range","String"],"Annotation.author":["Reference","String"],"CarePlan.activity.detail.product":["CodeableConcept","Reference"],"CarePlan.activity.detail.scheduled":["Timing","Period","String"],"ChargeItem.occurrence":["DateTime","Period","Timing"],"Claim.accident.location":["Address","Reference"],"Claim.diagnosis.diagnosis":["CodeableConcept","Reference"],"Claim.information.timing":["Date","Period"],"Claim.information.value":["String","Quantity","Attachment","Reference"],"Claim.item.location":["CodeableConcept","Address","Reference"],"Claim.item.serviced":["Date","Period"],"Claim.procedure.procedure":["CodeableConcept","Reference"],"ClinicalImpression.effective":["DateTime","Period"],"ClinicalImpression.finding.item":["CodeableConcept","Reference"],"CodeSystem.concept.property.value":["Code","Coding","String","Integer","Boolean","DateTime"],"Communication.payload.content":["String","Attachment","Reference"],"CommunicationRequest.occurrence":["DateTime","Period"],"CommunicationRequest.payload.content":["String","Attachment","Reference"],"Composition.relatesTo.target":["Identifier","Reference"],"ConceptMap.source":["Uri","Reference"],"ConceptMap.target":["Uri","Reference"],"Condition.abatement":["DateTime","Age","Boolean","Period","Range","String"],"Condition.onset":["DateTime","Age","Period","Range","String"],"Consent.source":["Attachment","Identifier","Reference"],"Contract.binding":["Attachment","Reference"],"Contract.friendly.content":["Attachment","Reference"],"Contract.legal.content":["Attachment","Reference"],"Contract.rule.content":["Attachment","Reference"],"Contract.term.valuedItem.entity":["CodeableConcept","Reference"],"Contract.valuedItem.entity":["CodeableConcept","Reference"],"DataRequirement.codeFilter.valueSet":["String","Reference"],"DataRequirement.dateFilter.value":["DateTime","Period","Duration"],"DeviceRequest.code":["Reference","CodeableConcept"],"DeviceRequest.occurrence":["DateTime","Period","Timing"],"DeviceUseStatement.timing":["Timing","Period","DateTime"],"DiagnosticReport.effective":["DateTime","Period"],"DocumentManifest.content.p":["Attachment","Reference"],"Dosage.asNeeded":["Boolean","CodeableConcept"],"Dosage.dose":["Range","Quantity"],"Dosage.rate":["Ratio","Range","Quantity"],"ElementDefinition.binding.valueSet":["Uri","Reference"],"ElementDefinition.defaultValue":["Base64Binary","Boolean","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","Meta"],"ElementDefinition.example.value":["Base64Binary","Boolean","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","Meta"],"ElementDefinition.extension.value":["CodeableConcept","Reference"],"ElementDefinition.fixed":["Base64Binary","Boolean","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","Meta"],"ElementDefinition.maxValue":["Date","DateTime","Instant","Time","Decimal","Integer","PositiveInt","UnsignedInt","Quantity"],"ElementDefinition.minValue":["Date","DateTime","Instant","Time","Decimal","Integer","PositiveInt","UnsignedInt","Quantity"],"ElementDefinition.pattern":["Base64Binary","Boolean","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","Meta"],"EligibilityRequest.serviced":["Date","Period"],"EligibilityResponse.insurance.benefitBalance.financial.allowed":["UnsignedInt","String","Money"],"EligibilityResponse.insurance.benefitBalance.financial.used":["UnsignedInt","Money"],"ExplanationOfBenefit.accident.location":["Address","Reference"],"ExplanationOfBenefit.benefitBalance.financial.allowed":["UnsignedInt","String","Money"],"ExplanationOfBenefit.benefitBalance.financial.used":["UnsignedInt","Money"],"ExplanationOfBenefit.diagnosis.diagnosis":["CodeableConcept","Reference"],"ExplanationOfBenefit.information.timing":["Date","Period"],"ExplanationOfBenefit.information.value":["String","Quantity","Attachment","Reference"],"ExplanationOfBenefit.item.location":["CodeableConcept","Address","Reference"],"ExplanationOfBenefit.item.serviced":["Date","Period"],"ExplanationOfBenefit.procedure.procedure":["CodeableConcept","Reference"],"Extension.value":["Base64Binary","Boolean","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","Meta"],"FamilyMemberHistory.age":["Age","Range","String"],"FamilyMemberHistory.born":["Period","Date","String"],"FamilyMemberHistory.condition.onset":["Age","Range","Period","String"],"FamilyMemberHistory.deceased":["Boolean","Age","Range","Date","String"],"Goal.start":["Date","CodeableConcept"],"Goal.target.detail":["Quantity","Range","CodeableConcept"],"Goal.target.due":["Date","Duration"],"Group.characteristic.value":["CodeableConcept","Boolean","Quantity","Range"],"GuidanceResponse.reason":["CodeableConcept","Reference"],"ImplementationGuide.package.resource.source":["Uri","Reference"],"Media.occurrence":["DateTime","Period"],"Medication.ingredient.item":["CodeableConcept","Reference"],"Medication.package.content.item":["CodeableConcept","Reference"],"MedicationAdministration.dosage.rate":["Ratio","Quantity"],"MedicationAdministration.effective":["DateTime","Period"],"MedicationAdministration.medication":["CodeableConcept","Reference"],"MedicationDispense.medication":["CodeableConcept","Reference"],"MedicationDispense.notDoneReason":["CodeableConcept","Reference"],"MedicationRequest.medication":["CodeableConcept","Reference"],"MedicationStatement.effective":["DateTime","Period"],"MedicationStatement.medication":["CodeableConcept","Reference"],"NutritionOrder.enteralFormula.administration.rate":["Quantity","Ratio"],"Observation.component.value":["Quantity","CodeableConcept","String","Range","Ratio","SampledData","Attachment","Time","DateTime","Period"],"Observation.effective":["DateTime","Period"],"Observation.value":["Quantity","CodeableConcept","String","Boolean","Range","Ratio","SampledData","Attachment","Time","DateTime","Period"],"OperationDefinition.parameter.binding.valueSet":["Uri","Reference"],"Parameters.parameter.value":["Base64Binary","Boolean","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","Meta"],"Patient.deceased":["Boolean","DateTime"],"Patient.multipleBirth":["Boolean","Integer"],"PlanDefinition.action.relatedAction.offset":["Duration","Range"],"PlanDefinition.action.timing":["DateTime","Period","Duration","Range","Timing"],"PlanDefinition.goal.target.detail":["Quantity","Range","CodeableConcept"],"Procedure.performed":["DateTime","Period"],"ProcedureRequest.asNeeded":["Boolean","CodeableConcept"],"ProcedureRequest.occurrence":["DateTime","Period","Timing"],"Provenance.agent.onBehalfOf":["Uri","Reference"],"Provenance.agent.who":["Uri","Reference"],"Provenance.entity.what":["Uri","Reference","Identifier"],"Questionnaire.item.enableWhen.answer":["Boolean","Decimal","Integer","Date","DateTime","Time","String","Uri","Attachment","Coding","Quantity","Reference"],"Questionnaire.item.initial":["Boolean","Decimal","Integer","Date","DateTime","Time","String","Uri","Attachment","Coding","Quantity","Reference"],"Questionnaire.item.option.value":["Integer","Date","Time","String","Coding"],"QuestionnaireResponse.item.answer.value":["Boolean","Decimal","Integer","Date","DateTime","Time","String","Uri","Attachment","Coding","Quantity","Reference"],"ReferralRequest.occurrence":["DateTime","Period"],"RequestGroup.action.relatedAction.offset":["Duration","Range"],"RequestGroup.action.timing":["DateTime","Period","Duration","Range","Timing"],"RequestGroup.reason":["CodeableConcept","Reference"],"RiskAssessment.occurrence":["DateTime","Period"],"RiskAssessment.prediction.probability":["Decimal","Range"],"RiskAssessment.prediction.when":["Period","Range"],"RiskAssessment.reason":["CodeableConcept","Reference"],"Signature.onBehalfOf":["Uri","Reference"],"Signature.who":["Uri","Reference"],"Specimen.collection.collected":["DateTime","Period"],"Specimen.container.additive":["CodeableConcept","Reference"],"Specimen.processing.time":["DateTime","Period"],"StructureMap.group.rule.source.defaultValue":["Base64Binary","Boolean","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","Meta"],"StructureMap.group.rule.target.parameter.value":["Id","String","Boolean","Integer","Decimal"],"Substance.ingredient.substance":["CodeableConcept","Reference"],"SupplyDelivery.occurrence":["DateTime","Period","Timing"],"SupplyDelivery.suppliedItem.item":["CodeableConcept","Reference"],"SupplyRequest.occurrence":["DateTime","Period","Timing"],"SupplyRequest.orderedItem.item":["CodeableConcept","Reference"],"SupplyRequest.reason":["CodeableConcept","Reference"],"Task.definition":["Uri","Reference"],"Task.input.value":["Base64Binary","Boolean","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","Meta"],"Task.output.value":["Base64Binary","Boolean","Code","Date","DateTime","Decimal","Id","Instant","Integer","Markdown","Oid","PositiveInt","String","Time","UnsignedInt","Uri","Address","Age","Annotation","Attachment","CodeableConcept","Coding","ContactPoint","Count","Distance","Duration","HumanName","Identifier","Money","Period","Quantity","Range","Ratio","Reference","SampledData","Signature","Timing","Meta"],"Timing.repeat.bounds":["Duration","Range","Period"],"TriggerDefinition.eventTiming":["Timing","Reference","Date","DateTime"],"UsageContext.value":["CodeableConcept","Quantity","Range"],"ValueSet.expansion.parameter.value":["String","Boolean","Integer","Decimal","Uri","Code"],"VisionPrescription.reason":["CodeableConcept","Reference"]}',
                );
            },
            9023: function (e) {
                'use strict';
                e.exports = JSON.parse(
                    '{"Account.active":"Period","Account.balance":"Money","Account.contained":"Resource","Account.coverage":"BackboneElement","Account.coverage.coverage":"Reference","Account.coverage.extension":"Extension","Account.coverage.id":"string","Account.coverage.modifierExtension":"Extension","Account.coverage.priority":"positiveInt","Account.description":"string","Account.extension":"Extension","Account.guarantor":"BackboneElement","Account.guarantor.extension":"Extension","Account.guarantor.id":"string","Account.guarantor.modifierExtension":"Extension","Account.guarantor.onHold":"boolean","Account.guarantor.party":"Reference","Account.guarantor.period":"Period","Account.id":"id","Account.identifier":"Identifier","Account.implicitRules":"uri","Account.language":"code","Account.meta":"Meta","Account.modifierExtension":"Extension","Account.name":"string","Account.owner":"Reference","Account.period":"Period","Account.status":"code","Account.subject":"Reference","Account.text":"Narrative","Account.type":"CodeableConcept","ActivityDefinition.approvalDate":"date","ActivityDefinition.bodySite":"CodeableConcept","ActivityDefinition.code":"CodeableConcept","ActivityDefinition.contact":"ContactDetail","ActivityDefinition.contained":"Resource","ActivityDefinition.contributor":"Contributor","ActivityDefinition.copyright":"markdown","ActivityDefinition.date":"dateTime","ActivityDefinition.description":"markdown","ActivityDefinition.dosage":"Dosage","ActivityDefinition.dynamicValue":"BackboneElement","ActivityDefinition.dynamicValue.description":"string","ActivityDefinition.dynamicValue.expression":"string","ActivityDefinition.dynamicValue.extension":"Extension","ActivityDefinition.dynamicValue.id":"string","ActivityDefinition.dynamicValue.language":"string","ActivityDefinition.dynamicValue.modifierExtension":"Extension","ActivityDefinition.dynamicValue.path":"string","ActivityDefinition.effectivePeriod":"Period","ActivityDefinition.experimental":"boolean","ActivityDefinition.extension":"Extension","ActivityDefinition.id":"id","ActivityDefinition.identifier":"Identifier","ActivityDefinition.implicitRules":"uri","ActivityDefinition.jurisdiction":"CodeableConcept","ActivityDefinition.kind":"code","ActivityDefinition.language":"code","ActivityDefinition.lastReviewDate":"date","ActivityDefinition.library":"Reference","ActivityDefinition.location":"Reference","ActivityDefinition.meta":"Meta","ActivityDefinition.modifierExtension":"Extension","ActivityDefinition.name":"string","ActivityDefinition.participant":"BackboneElement","ActivityDefinition.participant.extension":"Extension","ActivityDefinition.participant.id":"string","ActivityDefinition.participant.modifierExtension":"Extension","ActivityDefinition.participant.role":"CodeableConcept","ActivityDefinition.participant.type":"code","ActivityDefinition.productCodeableConcept":"CodeableConcept","ActivityDefinition.productReference":"Reference","ActivityDefinition.publisher":"string","ActivityDefinition.purpose":"markdown","ActivityDefinition.quantity":"Quantity","ActivityDefinition.relatedArtifact":"RelatedArtifact","ActivityDefinition.status":"code","ActivityDefinition.text":"Narrative","ActivityDefinition.timingDateTime":"dateTime","ActivityDefinition.timingPeriod":"Period","ActivityDefinition.timingRange":"Range","ActivityDefinition.timingTiming":"Timing","ActivityDefinition.title":"string","ActivityDefinition.topic":"CodeableConcept","ActivityDefinition.transform":"Reference","ActivityDefinition.url":"uri","ActivityDefinition.usage":"string","ActivityDefinition.useContext":"UsageContext","ActivityDefinition.version":"string","Address.city":"string","Address.country":"string","Address.district":"string","Address.extension":"Extension","Address.id":"string","Address.line":"string","Address.period":"Period","Address.postalCode":"string","Address.state":"string","Address.text":"string","Address.type":"code","Address.use":"code","AdverseEvent.category":"code","AdverseEvent.contained":"Resource","AdverseEvent.date":"dateTime","AdverseEvent.description":"string","AdverseEvent.eventParticipant":"Reference","AdverseEvent.extension":"Extension","AdverseEvent.id":"id","AdverseEvent.identifier":"Identifier","AdverseEvent.implicitRules":"uri","AdverseEvent.language":"code","AdverseEvent.location":"Reference","AdverseEvent.meta":"Meta","AdverseEvent.modifierExtension":"Extension","AdverseEvent.outcome":"CodeableConcept","AdverseEvent.reaction":"Reference","AdverseEvent.recorder":"Reference","AdverseEvent.referenceDocument":"Reference","AdverseEvent.seriousness":"CodeableConcept","AdverseEvent.study":"Reference","AdverseEvent.subject":"Reference","AdverseEvent.subjectMedicalHistory":"Reference","AdverseEvent.suspectEntity":"BackboneElement","AdverseEvent.suspectEntity.causality":"code","AdverseEvent.suspectEntity.causalityAssessment":"CodeableConcept","AdverseEvent.suspectEntity.causalityAuthor":"Reference","AdverseEvent.suspectEntity.causalityMethod":"CodeableConcept","AdverseEvent.suspectEntity.causalityProductRelatedness":"string","AdverseEvent.suspectEntity.causalityResult":"CodeableConcept","AdverseEvent.suspectEntity.extension":"Extension","AdverseEvent.suspectEntity.id":"string","AdverseEvent.suspectEntity.instance":"Reference","AdverseEvent.suspectEntity.modifierExtension":"Extension","AdverseEvent.text":"Narrative","AdverseEvent.type":"CodeableConcept","Age.code":"code","Age.comparator":"code","Age.extension":"Extension","Age.id":"string","Age.system":"uri","Age.unit":"string","Age.value":"decimal","AllergyIntolerance.assertedDate":"dateTime","AllergyIntolerance.asserter":"Reference","AllergyIntolerance.category":"code","AllergyIntolerance.clinicalStatus":"code","AllergyIntolerance.code":"CodeableConcept","AllergyIntolerance.contained":"Resource","AllergyIntolerance.criticality":"code","AllergyIntolerance.extension":"Extension","AllergyIntolerance.id":"id","AllergyIntolerance.identifier":"Identifier","AllergyIntolerance.implicitRules":"uri","AllergyIntolerance.language":"code","AllergyIntolerance.lastOccurrence":"dateTime","AllergyIntolerance.meta":"Meta","AllergyIntolerance.modifierExtension":"Extension","AllergyIntolerance.note":"Annotation","AllergyIntolerance.onsetAge":"Age","AllergyIntolerance.onsetDateTime":"dateTime","AllergyIntolerance.onsetPeriod":"Period","AllergyIntolerance.onsetRange":"Range","AllergyIntolerance.onsetString":"string","AllergyIntolerance.patient":"Reference","AllergyIntolerance.reaction":"BackboneElement","AllergyIntolerance.reaction.description":"string","AllergyIntolerance.reaction.exposureRoute":"CodeableConcept","AllergyIntolerance.reaction.extension":"Extension","AllergyIntolerance.reaction.id":"string","AllergyIntolerance.reaction.manifestation":"CodeableConcept","AllergyIntolerance.reaction.modifierExtension":"Extension","AllergyIntolerance.reaction.note":"Annotation","AllergyIntolerance.reaction.onset":"dateTime","AllergyIntolerance.reaction.severity":"code","AllergyIntolerance.reaction.substance":"CodeableConcept","AllergyIntolerance.recorder":"Reference","AllergyIntolerance.text":"Narrative","AllergyIntolerance.type":"code","AllergyIntolerance.verificationStatus":"code","Annotation.authorReference":"Reference","Annotation.authorString":"string","Annotation.extension":"Extension","Annotation.id":"string","Annotation.text":"string","Annotation.time":"dateTime","Appointment.appointmentType":"CodeableConcept","Appointment.comment":"string","Appointment.contained":"Resource","Appointment.created":"dateTime","Appointment.description":"string","Appointment.end":"instant","Appointment.extension":"Extension","Appointment.id":"id","Appointment.identifier":"Identifier","Appointment.implicitRules":"uri","Appointment.incomingReferral":"Reference","Appointment.indication":"Reference","Appointment.language":"code","Appointment.meta":"Meta","Appointment.minutesDuration":"positiveInt","Appointment.modifierExtension":"Extension","Appointment.participant":"BackboneElement","Appointment.participant.actor":"Reference","Appointment.participant.extension":"Extension","Appointment.participant.id":"string","Appointment.participant.modifierExtension":"Extension","Appointment.participant.required":"code","Appointment.participant.status":"code","Appointment.participant.type":"CodeableConcept","Appointment.priority":"unsignedInt","Appointment.reason":"CodeableConcept","Appointment.requestedPeriod":"Period","Appointment.serviceCategory":"CodeableConcept","Appointment.serviceType":"CodeableConcept","Appointment.slot":"Reference","Appointment.specialty":"CodeableConcept","Appointment.start":"instant","Appointment.status":"code","Appointment.supportingInformation":"Reference","Appointment.text":"Narrative","AppointmentResponse.actor":"Reference","AppointmentResponse.appointment":"Reference","AppointmentResponse.comment":"string","AppointmentResponse.contained":"Resource","AppointmentResponse.end":"instant","AppointmentResponse.extension":"Extension","AppointmentResponse.id":"id","AppointmentResponse.identifier":"Identifier","AppointmentResponse.implicitRules":"uri","AppointmentResponse.language":"code","AppointmentResponse.meta":"Meta","AppointmentResponse.modifierExtension":"Extension","AppointmentResponse.participantStatus":"code","AppointmentResponse.participantType":"CodeableConcept","AppointmentResponse.start":"instant","AppointmentResponse.text":"Narrative","Attachment.contentType":"code","Attachment.creation":"dateTime","Attachment.data":"base64Binary","Attachment.extension":"Extension","Attachment.hash":"base64Binary","Attachment.id":"string","Attachment.language":"code","Attachment.size":"unsignedInt","Attachment.title":"string","Attachment.url":"uri","AuditEvent.action":"code","AuditEvent.agent":"BackboneElement","AuditEvent.agent.altId":"string","AuditEvent.agent.extension":"Extension","AuditEvent.agent.id":"string","AuditEvent.agent.location":"Reference","AuditEvent.agent.media":"Coding","AuditEvent.agent.modifierExtension":"Extension","AuditEvent.agent.name":"string","AuditEvent.agent.network":"BackboneElement","AuditEvent.agent.network.address":"string","AuditEvent.agent.network.extension":"Extension","AuditEvent.agent.network.id":"string","AuditEvent.agent.network.modifierExtension":"Extension","AuditEvent.agent.network.type":"code","AuditEvent.agent.policy":"uri","AuditEvent.agent.purposeOfUse":"CodeableConcept","AuditEvent.agent.reference":"Reference","AuditEvent.agent.requestor":"boolean","AuditEvent.agent.role":"CodeableConcept","AuditEvent.agent.userId":"Identifier","AuditEvent.contained":"Resource","AuditEvent.entity":"BackboneElement","AuditEvent.entity.description":"string","AuditEvent.entity.detail":"BackboneElement","AuditEvent.entity.detail.extension":"Extension","AuditEvent.entity.detail.id":"string","AuditEvent.entity.detail.modifierExtension":"Extension","AuditEvent.entity.detail.type":"string","AuditEvent.entity.detail.value":"base64Binary","AuditEvent.entity.extension":"Extension","AuditEvent.entity.id":"string","AuditEvent.entity.identifier":"Identifier","AuditEvent.entity.lifecycle":"Coding","AuditEvent.entity.modifierExtension":"Extension","AuditEvent.entity.name":"string","AuditEvent.entity.query":"base64Binary","AuditEvent.entity.reference":"Reference","AuditEvent.entity.role":"Coding","AuditEvent.entity.securityLabel":"Coding","AuditEvent.entity.type":"Coding","AuditEvent.extension":"Extension","AuditEvent.id":"id","AuditEvent.implicitRules":"uri","AuditEvent.language":"code","AuditEvent.meta":"Meta","AuditEvent.modifierExtension":"Extension","AuditEvent.outcome":"code","AuditEvent.outcomeDesc":"string","AuditEvent.purposeOfEvent":"CodeableConcept","AuditEvent.recorded":"instant","AuditEvent.source":"BackboneElement","AuditEvent.source.extension":"Extension","AuditEvent.source.id":"string","AuditEvent.source.identifier":"Identifier","AuditEvent.source.modifierExtension":"Extension","AuditEvent.source.site":"string","AuditEvent.source.type":"Coding","AuditEvent.subtype":"Coding","AuditEvent.text":"Narrative","AuditEvent.type":"Coding","BackboneElement.extension":"Extension","BackboneElement.id":"string","BackboneElement.modifierExtension":"Extension","Basic.author":"Reference","Basic.code":"CodeableConcept","Basic.contained":"Resource","Basic.created":"date","Basic.extension":"Extension","Basic.id":"id","Basic.identifier":"Identifier","Basic.implicitRules":"uri","Basic.language":"code","Basic.meta":"Meta","Basic.modifierExtension":"Extension","Basic.subject":"Reference","Basic.text":"Narrative","Binary.content":"base64Binary","Binary.contentType":"code","Binary.id":"id","Binary.implicitRules":"uri","Binary.language":"code","Binary.meta":"Meta","Binary.securityContext":"Reference","BodySite.active":"boolean","BodySite.code":"CodeableConcept","BodySite.contained":"Resource","BodySite.description":"string","BodySite.extension":"Extension","BodySite.id":"id","BodySite.identifier":"Identifier","BodySite.image":"Attachment","BodySite.implicitRules":"uri","BodySite.language":"code","BodySite.meta":"Meta","BodySite.modifierExtension":"Extension","BodySite.patient":"Reference","BodySite.qualifier":"CodeableConcept","BodySite.text":"Narrative","Bundle.entry":"BackboneElement","Bundle.entry.extension":"Extension","Bundle.entry.fullUrl":"uri","Bundle.entry.id":"string","Bundle.entry.modifierExtension":"Extension","Bundle.entry.request":"BackboneElement","Bundle.entry.request.extension":"Extension","Bundle.entry.request.id":"string","Bundle.entry.request.ifMatch":"string","Bundle.entry.request.ifModifiedSince":"instant","Bundle.entry.request.ifNoneExist":"string","Bundle.entry.request.ifNoneMatch":"string","Bundle.entry.request.method":"code","Bundle.entry.request.modifierExtension":"Extension","Bundle.entry.request.url":"uri","Bundle.entry.resource":"Resource","Bundle.entry.response":"BackboneElement","Bundle.entry.response.etag":"string","Bundle.entry.response.extension":"Extension","Bundle.entry.response.id":"string","Bundle.entry.response.lastModified":"instant","Bundle.entry.response.location":"uri","Bundle.entry.response.modifierExtension":"Extension","Bundle.entry.response.outcome":"Resource","Bundle.entry.response.status":"string","Bundle.entry.search":"BackboneElement","Bundle.entry.search.extension":"Extension","Bundle.entry.search.id":"string","Bundle.entry.search.mode":"code","Bundle.entry.search.modifierExtension":"Extension","Bundle.entry.search.score":"decimal","Bundle.id":"id","Bundle.identifier":"Identifier","Bundle.implicitRules":"uri","Bundle.language":"code","Bundle.link":"BackboneElement","Bundle.link.extension":"Extension","Bundle.link.id":"string","Bundle.link.modifierExtension":"Extension","Bundle.link.relation":"string","Bundle.link.url":"uri","Bundle.meta":"Meta","Bundle.signature":"Signature","Bundle.total":"unsignedInt","Bundle.type":"code","CapabilityStatement.acceptUnknown":"code","CapabilityStatement.contact":"ContactDetail","CapabilityStatement.contained":"Resource","CapabilityStatement.copyright":"markdown","CapabilityStatement.date":"dateTime","CapabilityStatement.description":"markdown","CapabilityStatement.document":"BackboneElement","CapabilityStatement.document.documentation":"string","CapabilityStatement.document.extension":"Extension","CapabilityStatement.document.id":"string","CapabilityStatement.document.mode":"code","CapabilityStatement.document.modifierExtension":"Extension","CapabilityStatement.document.profile":"Reference","CapabilityStatement.experimental":"boolean","CapabilityStatement.extension":"Extension","CapabilityStatement.fhirVersion":"id","CapabilityStatement.format":"code","CapabilityStatement.id":"id","CapabilityStatement.implementation":"BackboneElement","CapabilityStatement.implementation.description":"string","CapabilityStatement.implementation.extension":"Extension","CapabilityStatement.implementation.id":"string","CapabilityStatement.implementation.modifierExtension":"Extension","CapabilityStatement.implementation.url":"uri","CapabilityStatement.implementationGuide":"uri","CapabilityStatement.implicitRules":"uri","CapabilityStatement.instantiates":"uri","CapabilityStatement.jurisdiction":"CodeableConcept","CapabilityStatement.kind":"code","CapabilityStatement.language":"code","CapabilityStatement.messaging":"BackboneElement","CapabilityStatement.messaging.documentation":"string","CapabilityStatement.messaging.endpoint":"BackboneElement","CapabilityStatement.messaging.endpoint.address":"uri","CapabilityStatement.messaging.endpoint.extension":"Extension","CapabilityStatement.messaging.endpoint.id":"string","CapabilityStatement.messaging.endpoint.modifierExtension":"Extension","CapabilityStatement.messaging.endpoint.protocol":"Coding","CapabilityStatement.messaging.event":"BackboneElement","CapabilityStatement.messaging.event.category":"code","CapabilityStatement.messaging.event.code":"Coding","CapabilityStatement.messaging.event.documentation":"string","CapabilityStatement.messaging.event.extension":"Extension","CapabilityStatement.messaging.event.focus":"code","CapabilityStatement.messaging.event.id":"string","CapabilityStatement.messaging.event.mode":"code","CapabilityStatement.messaging.event.modifierExtension":"Extension","CapabilityStatement.messaging.event.request":"Reference","CapabilityStatement.messaging.event.response":"Reference","CapabilityStatement.messaging.extension":"Extension","CapabilityStatement.messaging.id":"string","CapabilityStatement.messaging.modifierExtension":"Extension","CapabilityStatement.messaging.reliableCache":"unsignedInt","CapabilityStatement.messaging.supportedMessage":"BackboneElement","CapabilityStatement.messaging.supportedMessage.definition":"Reference","CapabilityStatement.messaging.supportedMessage.extension":"Extension","CapabilityStatement.messaging.supportedMessage.id":"string","CapabilityStatement.messaging.supportedMessage.mode":"code","CapabilityStatement.messaging.supportedMessage.modifierExtension":"Extension","CapabilityStatement.meta":"Meta","CapabilityStatement.modifierExtension":"Extension","CapabilityStatement.name":"string","CapabilityStatement.patchFormat":"code","CapabilityStatement.profile":"Reference","CapabilityStatement.publisher":"string","CapabilityStatement.purpose":"markdown","CapabilityStatement.rest":"BackboneElement","CapabilityStatement.rest.compartment":"uri","CapabilityStatement.rest.documentation":"string","CapabilityStatement.rest.extension":"Extension","CapabilityStatement.rest.id":"string","CapabilityStatement.rest.interaction":"BackboneElement","CapabilityStatement.rest.interaction.code":"code","CapabilityStatement.rest.interaction.documentation":"string","CapabilityStatement.rest.interaction.extension":"Extension","CapabilityStatement.rest.interaction.id":"string","CapabilityStatement.rest.interaction.modifierExtension":"Extension","CapabilityStatement.rest.mode":"code","CapabilityStatement.rest.modifierExtension":"Extension","CapabilityStatement.rest.operation":"BackboneElement","CapabilityStatement.rest.operation.definition":"Reference","CapabilityStatement.rest.operation.extension":"Extension","CapabilityStatement.rest.operation.id":"string","CapabilityStatement.rest.operation.modifierExtension":"Extension","CapabilityStatement.rest.operation.name":"string","CapabilityStatement.rest.resource":"BackboneElement","CapabilityStatement.rest.resource.conditionalCreate":"boolean","CapabilityStatement.rest.resource.conditionalDelete":"code","CapabilityStatement.rest.resource.conditionalRead":"code","CapabilityStatement.rest.resource.conditionalUpdate":"boolean","CapabilityStatement.rest.resource.documentation":"markdown","CapabilityStatement.rest.resource.extension":"Extension","CapabilityStatement.rest.resource.id":"string","CapabilityStatement.rest.resource.interaction":"BackboneElement","CapabilityStatement.rest.resource.interaction.code":"code","CapabilityStatement.rest.resource.interaction.documentation":"string","CapabilityStatement.rest.resource.interaction.extension":"Extension","CapabilityStatement.rest.resource.interaction.id":"string","CapabilityStatement.rest.resource.interaction.modifierExtension":"Extension","CapabilityStatement.rest.resource.modifierExtension":"Extension","CapabilityStatement.rest.resource.profile":"Reference","CapabilityStatement.rest.resource.readHistory":"boolean","CapabilityStatement.rest.resource.referencePolicy":"code","CapabilityStatement.rest.resource.searchInclude":"string","CapabilityStatement.rest.resource.searchParam":"BackboneElement","CapabilityStatement.rest.resource.searchParam.definition":"uri","CapabilityStatement.rest.resource.searchParam.documentation":"string","CapabilityStatement.rest.resource.searchParam.extension":"Extension","CapabilityStatement.rest.resource.searchParam.id":"string","CapabilityStatement.rest.resource.searchParam.modifierExtension":"Extension","CapabilityStatement.rest.resource.searchParam.name":"string","CapabilityStatement.rest.resource.searchParam.type":"code","CapabilityStatement.rest.resource.searchRevInclude":"string","CapabilityStatement.rest.resource.type":"code","CapabilityStatement.rest.resource.updateCreate":"boolean","CapabilityStatement.rest.resource.versioning":"code","CapabilityStatement.rest.security":"BackboneElement","CapabilityStatement.rest.security.certificate":"BackboneElement","CapabilityStatement.rest.security.certificate.blob":"base64Binary","CapabilityStatement.rest.security.certificate.extension":"Extension","CapabilityStatement.rest.security.certificate.id":"string","CapabilityStatement.rest.security.certificate.modifierExtension":"Extension","CapabilityStatement.rest.security.certificate.type":"code","CapabilityStatement.rest.security.cors":"boolean","CapabilityStatement.rest.security.description":"string","CapabilityStatement.rest.security.extension":"Extension","CapabilityStatement.rest.security.id":"string","CapabilityStatement.rest.security.modifierExtension":"Extension","CapabilityStatement.rest.security.service":"CodeableConcept","CapabilityStatement.software":"BackboneElement","CapabilityStatement.software.extension":"Extension","CapabilityStatement.software.id":"string","CapabilityStatement.software.modifierExtension":"Extension","CapabilityStatement.software.name":"string","CapabilityStatement.software.releaseDate":"dateTime","CapabilityStatement.software.version":"string","CapabilityStatement.status":"code","CapabilityStatement.text":"Narrative","CapabilityStatement.title":"string","CapabilityStatement.url":"uri","CapabilityStatement.useContext":"UsageContext","CapabilityStatement.version":"string","CarePlan.activity":"BackboneElement","CarePlan.activity.detail":"BackboneElement","CarePlan.activity.detail.category":"CodeableConcept","CarePlan.activity.detail.code":"CodeableConcept","CarePlan.activity.detail.dailyAmount":"Quantity","CarePlan.activity.detail.definition":"Reference","CarePlan.activity.detail.description":"string","CarePlan.activity.detail.extension":"Extension","CarePlan.activity.detail.goal":"Reference","CarePlan.activity.detail.id":"string","CarePlan.activity.detail.location":"Reference","CarePlan.activity.detail.modifierExtension":"Extension","CarePlan.activity.detail.performer":"Reference","CarePlan.activity.detail.productCodeableConcept":"CodeableConcept","CarePlan.activity.detail.productReference":"Reference","CarePlan.activity.detail.prohibited":"boolean","CarePlan.activity.detail.quantity":"Quantity","CarePlan.activity.detail.reasonCode":"CodeableConcept","CarePlan.activity.detail.reasonReference":"Reference","CarePlan.activity.detail.scheduledPeriod":"Period","CarePlan.activity.detail.scheduledString":"string","CarePlan.activity.detail.scheduledTiming":"Timing","CarePlan.activity.detail.status":"code","CarePlan.activity.detail.statusReason":"string","CarePlan.activity.extension":"Extension","CarePlan.activity.id":"string","CarePlan.activity.modifierExtension":"Extension","CarePlan.activity.outcomeCodeableConcept":"CodeableConcept","CarePlan.activity.outcomeReference":"Reference","CarePlan.activity.progress":"Annotation","CarePlan.activity.reference":"Reference","CarePlan.addresses":"Reference","CarePlan.author":"Reference","CarePlan.basedOn":"Reference","CarePlan.careTeam":"Reference","CarePlan.category":"CodeableConcept","CarePlan.contained":"Resource","CarePlan.context":"Reference","CarePlan.definition":"Reference","CarePlan.description":"string","CarePlan.extension":"Extension","CarePlan.goal":"Reference","CarePlan.id":"id","CarePlan.identifier":"Identifier","CarePlan.implicitRules":"uri","CarePlan.intent":"code","CarePlan.language":"code","CarePlan.meta":"Meta","CarePlan.modifierExtension":"Extension","CarePlan.note":"Annotation","CarePlan.partOf":"Reference","CarePlan.period":"Period","CarePlan.replaces":"Reference","CarePlan.status":"code","CarePlan.subject":"Reference","CarePlan.supportingInfo":"Reference","CarePlan.text":"Narrative","CarePlan.title":"string","CareTeam.category":"CodeableConcept","CareTeam.contained":"Resource","CareTeam.context":"Reference","CareTeam.extension":"Extension","CareTeam.id":"id","CareTeam.identifier":"Identifier","CareTeam.implicitRules":"uri","CareTeam.language":"code","CareTeam.managingOrganization":"Reference","CareTeam.meta":"Meta","CareTeam.modifierExtension":"Extension","CareTeam.name":"string","CareTeam.note":"Annotation","CareTeam.participant":"BackboneElement","CareTeam.participant.extension":"Extension","CareTeam.participant.id":"string","CareTeam.participant.member":"Reference","CareTeam.participant.modifierExtension":"Extension","CareTeam.participant.onBehalfOf":"Reference","CareTeam.participant.period":"Period","CareTeam.participant.role":"CodeableConcept","CareTeam.period":"Period","CareTeam.reasonCode":"CodeableConcept","CareTeam.reasonReference":"Reference","CareTeam.status":"code","CareTeam.subject":"Reference","CareTeam.text":"Narrative","ChargeItem.account":"Reference","ChargeItem.bodysite":"CodeableConcept","ChargeItem.code":"CodeableConcept","ChargeItem.contained":"Resource","ChargeItem.context":"Reference","ChargeItem.definition":"uri","ChargeItem.enteredDate":"dateTime","ChargeItem.enterer":"Reference","ChargeItem.extension":"Extension","ChargeItem.factorOverride":"decimal","ChargeItem.id":"id","ChargeItem.identifier":"Identifier","ChargeItem.implicitRules":"uri","ChargeItem.language":"code","ChargeItem.meta":"Meta","ChargeItem.modifierExtension":"Extension","ChargeItem.note":"Annotation","ChargeItem.occurrenceDateTime":"dateTime","ChargeItem.occurrencePeriod":"Period","ChargeItem.occurrenceTiming":"Timing","ChargeItem.overrideReason":"string","ChargeItem.partOf":"Reference","ChargeItem.participant":"BackboneElement","ChargeItem.participant.actor":"Reference","ChargeItem.participant.extension":"Extension","ChargeItem.participant.id":"string","ChargeItem.participant.modifierExtension":"Extension","ChargeItem.participant.role":"CodeableConcept","ChargeItem.performingOrganization":"Reference","ChargeItem.priceOverride":"Money","ChargeItem.quantity":"Quantity","ChargeItem.reason":"CodeableConcept","ChargeItem.requestingOrganization":"Reference","ChargeItem.service":"Reference","ChargeItem.status":"code","ChargeItem.subject":"Reference","ChargeItem.supportingInformation":"Reference","ChargeItem.text":"Narrative","Claim.accident":"BackboneElement","Claim.accident.date":"date","Claim.accident.extension":"Extension","Claim.accident.id":"string","Claim.accident.locationAddress":"Address","Claim.accident.locationReference":"Reference","Claim.accident.modifierExtension":"Extension","Claim.accident.type":"CodeableConcept","Claim.billablePeriod":"Period","Claim.careTeam":"BackboneElement","Claim.careTeam.extension":"Extension","Claim.careTeam.id":"string","Claim.careTeam.modifierExtension":"Extension","Claim.careTeam.provider":"Reference","Claim.careTeam.qualification":"CodeableConcept","Claim.careTeam.responsible":"boolean","Claim.careTeam.role":"CodeableConcept","Claim.careTeam.sequence":"positiveInt","Claim.contained":"Resource","Claim.created":"dateTime","Claim.diagnosis":"BackboneElement","Claim.diagnosis.diagnosisCodeableConcept":"CodeableConcept","Claim.diagnosis.diagnosisReference":"Reference","Claim.diagnosis.extension":"Extension","Claim.diagnosis.id":"string","Claim.diagnosis.modifierExtension":"Extension","Claim.diagnosis.packageCode":"CodeableConcept","Claim.diagnosis.sequence":"positiveInt","Claim.diagnosis.type":"CodeableConcept","Claim.employmentImpacted":"Period","Claim.enterer":"Reference","Claim.extension":"Extension","Claim.facility":"Reference","Claim.fundsReserve":"CodeableConcept","Claim.hospitalization":"Period","Claim.id":"id","Claim.identifier":"Identifier","Claim.implicitRules":"uri","Claim.information":"BackboneElement","Claim.information.category":"CodeableConcept","Claim.information.code":"CodeableConcept","Claim.information.extension":"Extension","Claim.information.id":"string","Claim.information.modifierExtension":"Extension","Claim.information.reason":"CodeableConcept","Claim.information.sequence":"positiveInt","Claim.information.timingDate":"date","Claim.information.timingPeriod":"Period","Claim.information.valueAttachment":"Attachment","Claim.information.valueQuantity":"Quantity","Claim.information.valueReference":"Reference","Claim.information.valueString":"string","Claim.insurance":"BackboneElement","Claim.insurance.businessArrangement":"string","Claim.insurance.claimResponse":"Reference","Claim.insurance.coverage":"Reference","Claim.insurance.extension":"Extension","Claim.insurance.focal":"boolean","Claim.insurance.id":"string","Claim.insurance.modifierExtension":"Extension","Claim.insurance.preAuthRef":"string","Claim.insurance.sequence":"positiveInt","Claim.insurer":"Reference","Claim.item":"BackboneElement","Claim.item.bodySite":"CodeableConcept","Claim.item.careTeamLinkId":"positiveInt","Claim.item.category":"CodeableConcept","Claim.item.detail":"BackboneElement","Claim.item.detail.category":"CodeableConcept","Claim.item.detail.extension":"Extension","Claim.item.detail.factor":"decimal","Claim.item.detail.id":"string","Claim.item.detail.modifier":"CodeableConcept","Claim.item.detail.modifierExtension":"Extension","Claim.item.detail.net":"Money","Claim.item.detail.programCode":"CodeableConcept","Claim.item.detail.quantity":"Quantity","Claim.item.detail.revenue":"CodeableConcept","Claim.item.detail.sequence":"positiveInt","Claim.item.detail.service":"CodeableConcept","Claim.item.detail.subDetail":"BackboneElement","Claim.item.detail.subDetail.category":"CodeableConcept","Claim.item.detail.subDetail.extension":"Extension","Claim.item.detail.subDetail.factor":"decimal","Claim.item.detail.subDetail.id":"string","Claim.item.detail.subDetail.modifier":"CodeableConcept","Claim.item.detail.subDetail.modifierExtension":"Extension","Claim.item.detail.subDetail.net":"Money","Claim.item.detail.subDetail.programCode":"CodeableConcept","Claim.item.detail.subDetail.quantity":"Quantity","Claim.item.detail.subDetail.revenue":"CodeableConcept","Claim.item.detail.subDetail.sequence":"positiveInt","Claim.item.detail.subDetail.service":"CodeableConcept","Claim.item.detail.subDetail.udi":"Reference","Claim.item.detail.subDetail.unitPrice":"Money","Claim.item.detail.udi":"Reference","Claim.item.detail.unitPrice":"Money","Claim.item.diagnosisLinkId":"positiveInt","Claim.item.encounter":"Reference","Claim.item.extension":"Extension","Claim.item.factor":"decimal","Claim.item.id":"string","Claim.item.informationLinkId":"positiveInt","Claim.item.locationAddress":"Address","Claim.item.locationCodeableConcept":"CodeableConcept","Claim.item.locationReference":"Reference","Claim.item.modifier":"CodeableConcept","Claim.item.modifierExtension":"Extension","Claim.item.net":"Money","Claim.item.procedureLinkId":"positiveInt","Claim.item.programCode":"CodeableConcept","Claim.item.quantity":"Quantity","Claim.item.revenue":"CodeableConcept","Claim.item.sequence":"positiveInt","Claim.item.service":"CodeableConcept","Claim.item.servicedDate":"date","Claim.item.servicedPeriod":"Period","Claim.item.subSite":"CodeableConcept","Claim.item.udi":"Reference","Claim.item.unitPrice":"Money","Claim.language":"code","Claim.meta":"Meta","Claim.modifierExtension":"Extension","Claim.organization":"Reference","Claim.originalPrescription":"Reference","Claim.patient":"Reference","Claim.payee":"BackboneElement","Claim.payee.extension":"Extension","Claim.payee.id":"string","Claim.payee.modifierExtension":"Extension","Claim.payee.party":"Reference","Claim.payee.resourceType":"Coding","Claim.payee.type":"CodeableConcept","Claim.prescription":"Reference","Claim.priority":"CodeableConcept","Claim.procedure":"BackboneElement","Claim.procedure.date":"dateTime","Claim.procedure.extension":"Extension","Claim.procedure.id":"string","Claim.procedure.modifierExtension":"Extension","Claim.procedure.procedureCodeableConcept":"CodeableConcept","Claim.procedure.procedureReference":"Reference","Claim.procedure.sequence":"positiveInt","Claim.provider":"Reference","Claim.referral":"Reference","Claim.related":"BackboneElement","Claim.related.claim":"Reference","Claim.related.extension":"Extension","Claim.related.id":"string","Claim.related.modifierExtension":"Extension","Claim.related.reference":"Identifier","Claim.related.relationship":"CodeableConcept","Claim.status":"code","Claim.subType":"CodeableConcept","Claim.text":"Narrative","Claim.total":"Money","Claim.type":"CodeableConcept","Claim.use":"code","ClaimResponse.addItem":"BackboneElement","ClaimResponse.addItem.category":"CodeableConcept","ClaimResponse.addItem.detail":"BackboneElement","ClaimResponse.addItem.detail.category":"CodeableConcept","ClaimResponse.addItem.detail.extension":"Extension","ClaimResponse.addItem.detail.fee":"Money","ClaimResponse.addItem.detail.id":"string","ClaimResponse.addItem.detail.modifier":"CodeableConcept","ClaimResponse.addItem.detail.modifierExtension":"Extension","ClaimResponse.addItem.detail.noteNumber":"positiveInt","ClaimResponse.addItem.detail.revenue":"CodeableConcept","ClaimResponse.addItem.detail.service":"CodeableConcept","ClaimResponse.addItem.extension":"Extension","ClaimResponse.addItem.fee":"Money","ClaimResponse.addItem.id":"string","ClaimResponse.addItem.modifier":"CodeableConcept","ClaimResponse.addItem.modifierExtension":"Extension","ClaimResponse.addItem.noteNumber":"positiveInt","ClaimResponse.addItem.revenue":"CodeableConcept","ClaimResponse.addItem.sequenceLinkId":"positiveInt","ClaimResponse.addItem.service":"CodeableConcept","ClaimResponse.communicationRequest":"Reference","ClaimResponse.contained":"Resource","ClaimResponse.created":"dateTime","ClaimResponse.disposition":"string","ClaimResponse.error":"BackboneElement","ClaimResponse.error.code":"CodeableConcept","ClaimResponse.error.detailSequenceLinkId":"positiveInt","ClaimResponse.error.extension":"Extension","ClaimResponse.error.id":"string","ClaimResponse.error.modifierExtension":"Extension","ClaimResponse.error.sequenceLinkId":"positiveInt","ClaimResponse.error.subdetailSequenceLinkId":"positiveInt","ClaimResponse.extension":"Extension","ClaimResponse.form":"CodeableConcept","ClaimResponse.id":"id","ClaimResponse.identifier":"Identifier","ClaimResponse.implicitRules":"uri","ClaimResponse.insurance":"BackboneElement","ClaimResponse.insurance.businessArrangement":"string","ClaimResponse.insurance.claimResponse":"Reference","ClaimResponse.insurance.coverage":"Reference","ClaimResponse.insurance.extension":"Extension","ClaimResponse.insurance.focal":"boolean","ClaimResponse.insurance.id":"string","ClaimResponse.insurance.modifierExtension":"Extension","ClaimResponse.insurance.preAuthRef":"string","ClaimResponse.insurance.sequence":"positiveInt","ClaimResponse.insurer":"Reference","ClaimResponse.item":"BackboneElement","ClaimResponse.item.adjudication":"BackboneElement","ClaimResponse.item.adjudication.amount":"Money","ClaimResponse.item.adjudication.category":"CodeableConcept","ClaimResponse.item.adjudication.extension":"Extension","ClaimResponse.item.adjudication.id":"string","ClaimResponse.item.adjudication.modifierExtension":"Extension","ClaimResponse.item.adjudication.reason":"CodeableConcept","ClaimResponse.item.adjudication.value":"decimal","ClaimResponse.item.detail":"BackboneElement","ClaimResponse.item.detail.extension":"Extension","ClaimResponse.item.detail.id":"string","ClaimResponse.item.detail.modifierExtension":"Extension","ClaimResponse.item.detail.noteNumber":"positiveInt","ClaimResponse.item.detail.sequenceLinkId":"positiveInt","ClaimResponse.item.detail.subDetail":"BackboneElement","ClaimResponse.item.detail.subDetail.extension":"Extension","ClaimResponse.item.detail.subDetail.id":"string","ClaimResponse.item.detail.subDetail.modifierExtension":"Extension","ClaimResponse.item.detail.subDetail.noteNumber":"positiveInt","ClaimResponse.item.detail.subDetail.sequenceLinkId":"positiveInt","ClaimResponse.item.extension":"Extension","ClaimResponse.item.id":"string","ClaimResponse.item.modifierExtension":"Extension","ClaimResponse.item.noteNumber":"positiveInt","ClaimResponse.item.sequenceLinkId":"positiveInt","ClaimResponse.language":"code","ClaimResponse.meta":"Meta","ClaimResponse.modifierExtension":"Extension","ClaimResponse.outcome":"CodeableConcept","ClaimResponse.patient":"Reference","ClaimResponse.payeeType":"CodeableConcept","ClaimResponse.payment":"BackboneElement","ClaimResponse.payment.adjustment":"Money","ClaimResponse.payment.adjustmentReason":"CodeableConcept","ClaimResponse.payment.amount":"Money","ClaimResponse.payment.date":"date","ClaimResponse.payment.extension":"Extension","ClaimResponse.payment.id":"string","ClaimResponse.payment.identifier":"Identifier","ClaimResponse.payment.modifierExtension":"Extension","ClaimResponse.payment.type":"CodeableConcept","ClaimResponse.processNote":"BackboneElement","ClaimResponse.processNote.extension":"Extension","ClaimResponse.processNote.id":"string","ClaimResponse.processNote.language":"CodeableConcept","ClaimResponse.processNote.modifierExtension":"Extension","ClaimResponse.processNote.number":"positiveInt","ClaimResponse.processNote.text":"string","ClaimResponse.processNote.type":"CodeableConcept","ClaimResponse.request":"Reference","ClaimResponse.requestOrganization":"Reference","ClaimResponse.requestProvider":"Reference","ClaimResponse.reserved":"Coding","ClaimResponse.status":"code","ClaimResponse.text":"Narrative","ClaimResponse.totalBenefit":"Money","ClaimResponse.totalCost":"Money","ClaimResponse.unallocDeductable":"Money","ClinicalImpression.action":"Reference","ClinicalImpression.assessor":"Reference","ClinicalImpression.code":"CodeableConcept","ClinicalImpression.contained":"Resource","ClinicalImpression.context":"Reference","ClinicalImpression.date":"dateTime","ClinicalImpression.description":"string","ClinicalImpression.effectiveDateTime":"dateTime","ClinicalImpression.effectivePeriod":"Period","ClinicalImpression.extension":"Extension","ClinicalImpression.finding":"BackboneElement","ClinicalImpression.finding.basis":"string","ClinicalImpression.finding.extension":"Extension","ClinicalImpression.finding.id":"string","ClinicalImpression.finding.itemCodeableConcept":"CodeableConcept","ClinicalImpression.finding.itemReference":"Reference","ClinicalImpression.finding.modifierExtension":"Extension","ClinicalImpression.id":"id","ClinicalImpression.identifier":"Identifier","ClinicalImpression.implicitRules":"uri","ClinicalImpression.investigation":"BackboneElement","ClinicalImpression.investigation.code":"CodeableConcept","ClinicalImpression.investigation.extension":"Extension","ClinicalImpression.investigation.id":"string","ClinicalImpression.investigation.item":"Reference","ClinicalImpression.investigation.modifierExtension":"Extension","ClinicalImpression.language":"code","ClinicalImpression.meta":"Meta","ClinicalImpression.modifierExtension":"Extension","ClinicalImpression.note":"Annotation","ClinicalImpression.previous":"Reference","ClinicalImpression.problem":"Reference","ClinicalImpression.prognosisCodeableConcept":"CodeableConcept","ClinicalImpression.prognosisReference":"Reference","ClinicalImpression.protocol":"uri","ClinicalImpression.status":"code","ClinicalImpression.subject":"Reference","ClinicalImpression.summary":"string","ClinicalImpression.text":"Narrative","CodeSystem.caseSensitive":"boolean","CodeSystem.compositional":"boolean","CodeSystem.concept":"BackboneElement","CodeSystem.concept.code":"code","CodeSystem.concept.definition":"string","CodeSystem.concept.designation":"BackboneElement","CodeSystem.concept.designation.extension":"Extension","CodeSystem.concept.designation.id":"string","CodeSystem.concept.designation.language":"code","CodeSystem.concept.designation.modifierExtension":"Extension","CodeSystem.concept.designation.use":"Coding","CodeSystem.concept.designation.value":"string","CodeSystem.concept.display":"string","CodeSystem.concept.extension":"Extension","CodeSystem.concept.id":"string","CodeSystem.concept.modifierExtension":"Extension","CodeSystem.concept.property":"BackboneElement","CodeSystem.concept.property.code":"code","CodeSystem.concept.property.extension":"Extension","CodeSystem.concept.property.id":"string","CodeSystem.concept.property.modifierExtension":"Extension","CodeSystem.concept.property.valueBoolean":"boolean","CodeSystem.concept.property.valueCode":"code","CodeSystem.concept.property.valueCoding":"Coding","CodeSystem.concept.property.valueDateTime":"dateTime","CodeSystem.concept.property.valueInteger":"integer","CodeSystem.concept.property.valueString":"string","CodeSystem.contact":"ContactDetail","CodeSystem.contained":"Resource","CodeSystem.content":"code","CodeSystem.copyright":"markdown","CodeSystem.count":"unsignedInt","CodeSystem.date":"dateTime","CodeSystem.description":"markdown","CodeSystem.experimental":"boolean","CodeSystem.extension":"Extension","CodeSystem.filter":"BackboneElement","CodeSystem.filter.code":"code","CodeSystem.filter.description":"string","CodeSystem.filter.extension":"Extension","CodeSystem.filter.id":"string","CodeSystem.filter.modifierExtension":"Extension","CodeSystem.filter.operator":"code","CodeSystem.filter.value":"string","CodeSystem.hierarchyMeaning":"code","CodeSystem.id":"id","CodeSystem.identifier":"Identifier","CodeSystem.implicitRules":"uri","CodeSystem.jurisdiction":"CodeableConcept","CodeSystem.language":"code","CodeSystem.meta":"Meta","CodeSystem.modifierExtension":"Extension","CodeSystem.name":"string","CodeSystem.property":"BackboneElement","CodeSystem.property.code":"code","CodeSystem.property.description":"string","CodeSystem.property.extension":"Extension","CodeSystem.property.id":"string","CodeSystem.property.modifierExtension":"Extension","CodeSystem.property.type":"code","CodeSystem.property.uri":"uri","CodeSystem.publisher":"string","CodeSystem.purpose":"markdown","CodeSystem.status":"code","CodeSystem.text":"Narrative","CodeSystem.title":"string","CodeSystem.url":"uri","CodeSystem.useContext":"UsageContext","CodeSystem.valueSet":"uri","CodeSystem.version":"string","CodeSystem.versionNeeded":"boolean","CodeableConcept.coding":"Coding","CodeableConcept.extension":"Extension","CodeableConcept.id":"string","CodeableConcept.text":"string","Coding.code":"code","Coding.display":"string","Coding.extension":"Extension","Coding.id":"string","Coding.system":"uri","Coding.userSelected":"boolean","Coding.version":"string","Communication.basedOn":"Reference","Communication.category":"CodeableConcept","Communication.contained":"Resource","Communication.context":"Reference","Communication.definition":"Reference","Communication.extension":"Extension","Communication.id":"id","Communication.identifier":"Identifier","Communication.implicitRules":"uri","Communication.language":"code","Communication.medium":"CodeableConcept","Communication.meta":"Meta","Communication.modifierExtension":"Extension","Communication.notDone":"boolean","Communication.notDoneReason":"CodeableConcept","Communication.note":"Annotation","Communication.partOf":"Reference","Communication.payload":"BackboneElement","Communication.payload.contentAttachment":"Attachment","Communication.payload.contentReference":"Reference","Communication.payload.contentString":"string","Communication.payload.extension":"Extension","Communication.payload.id":"string","Communication.payload.modifierExtension":"Extension","Communication.reasonCode":"CodeableConcept","Communication.reasonReference":"Reference","Communication.received":"dateTime","Communication.recipient":"Reference","Communication.sender":"Reference","Communication.sent":"dateTime","Communication.status":"code","Communication.subject":"Reference","Communication.text":"Narrative","Communication.topic":"Reference","CommunicationRequest.authoredOn":"dateTime","CommunicationRequest.basedOn":"Reference","CommunicationRequest.category":"CodeableConcept","CommunicationRequest.contained":"Resource","CommunicationRequest.context":"Reference","CommunicationRequest.extension":"Extension","CommunicationRequest.groupIdentifier":"Identifier","CommunicationRequest.id":"id","CommunicationRequest.identifier":"Identifier","CommunicationRequest.implicitRules":"uri","CommunicationRequest.language":"code","CommunicationRequest.medium":"CodeableConcept","CommunicationRequest.meta":"Meta","CommunicationRequest.modifierExtension":"Extension","CommunicationRequest.note":"Annotation","CommunicationRequest.occurrenceDateTime":"dateTime","CommunicationRequest.occurrencePeriod":"Period","CommunicationRequest.payload":"BackboneElement","CommunicationRequest.payload.contentAttachment":"Attachment","CommunicationRequest.payload.contentReference":"Reference","CommunicationRequest.payload.contentString":"string","CommunicationRequest.payload.extension":"Extension","CommunicationRequest.payload.id":"string","CommunicationRequest.payload.modifierExtension":"Extension","CommunicationRequest.priority":"code","CommunicationRequest.reasonCode":"CodeableConcept","CommunicationRequest.reasonReference":"Reference","CommunicationRequest.recipient":"Reference","CommunicationRequest.replaces":"Reference","CommunicationRequest.requester":"BackboneElement","CommunicationRequest.requester.agent":"Reference","CommunicationRequest.requester.extension":"Extension","CommunicationRequest.requester.id":"string","CommunicationRequest.requester.modifierExtension":"Extension","CommunicationRequest.requester.onBehalfOf":"Reference","CommunicationRequest.sender":"Reference","CommunicationRequest.status":"code","CommunicationRequest.subject":"Reference","CommunicationRequest.text":"Narrative","CommunicationRequest.topic":"Reference","CompartmentDefinition.code":"code","CompartmentDefinition.contact":"ContactDetail","CompartmentDefinition.contained":"Resource","CompartmentDefinition.date":"dateTime","CompartmentDefinition.description":"markdown","CompartmentDefinition.experimental":"boolean","CompartmentDefinition.extension":"Extension","CompartmentDefinition.id":"id","CompartmentDefinition.implicitRules":"uri","CompartmentDefinition.jurisdiction":"CodeableConcept","CompartmentDefinition.language":"code","CompartmentDefinition.meta":"Meta","CompartmentDefinition.modifierExtension":"Extension","CompartmentDefinition.name":"string","CompartmentDefinition.publisher":"string","CompartmentDefinition.purpose":"markdown","CompartmentDefinition.resource":"BackboneElement","CompartmentDefinition.resource.code":"code","CompartmentDefinition.resource.documentation":"string","CompartmentDefinition.resource.extension":"Extension","CompartmentDefinition.resource.id":"string","CompartmentDefinition.resource.modifierExtension":"Extension","CompartmentDefinition.resource.param":"string","CompartmentDefinition.search":"boolean","CompartmentDefinition.status":"code","CompartmentDefinition.text":"Narrative","CompartmentDefinition.title":"string","CompartmentDefinition.url":"uri","CompartmentDefinition.useContext":"UsageContext","Composition.attester":"BackboneElement","Composition.attester.extension":"Extension","Composition.attester.id":"string","Composition.attester.mode":"code","Composition.attester.modifierExtension":"Extension","Composition.attester.party":"Reference","Composition.attester.time":"dateTime","Composition.author":"Reference","Composition.class":"CodeableConcept","Composition.confidentiality":"code","Composition.contained":"Resource","Composition.custodian":"Reference","Composition.date":"dateTime","Composition.encounter":"Reference","Composition.event":"BackboneElement","Composition.event.code":"CodeableConcept","Composition.event.detail":"Reference","Composition.event.extension":"Extension","Composition.event.id":"string","Composition.event.modifierExtension":"Extension","Composition.event.period":"Period","Composition.extension":"Extension","Composition.id":"id","Composition.identifier":"Identifier","Composition.implicitRules":"uri","Composition.language":"code","Composition.meta":"Meta","Composition.modifierExtension":"Extension","Composition.relatesTo":"BackboneElement","Composition.relatesTo.code":"code","Composition.relatesTo.extension":"Extension","Composition.relatesTo.id":"string","Composition.relatesTo.modifierExtension":"Extension","Composition.relatesTo.targetIdentifier":"Identifier","Composition.relatesTo.targetReference":"Reference","Composition.section":"BackboneElement","Composition.section.code":"CodeableConcept","Composition.section.emptyReason":"CodeableConcept","Composition.section.entry":"Reference","Composition.section.extension":"Extension","Composition.section.id":"string","Composition.section.mode":"code","Composition.section.modifierExtension":"Extension","Composition.section.orderedBy":"CodeableConcept","Composition.section.text":"Narrative","Composition.section.title":"string","Composition.status":"code","Composition.subject":"Reference","Composition.text":"Narrative","Composition.title":"string","Composition.type":"CodeableConcept","ConceptMap.contact":"ContactDetail","ConceptMap.contained":"Resource","ConceptMap.copyright":"markdown","ConceptMap.date":"dateTime","ConceptMap.description":"markdown","ConceptMap.experimental":"boolean","ConceptMap.extension":"Extension","ConceptMap.group":"BackboneElement","ConceptMap.group.element":"BackboneElement","ConceptMap.group.element.code":"code","ConceptMap.group.element.display":"string","ConceptMap.group.element.extension":"Extension","ConceptMap.group.element.id":"string","ConceptMap.group.element.modifierExtension":"Extension","ConceptMap.group.element.target":"BackboneElement","ConceptMap.group.element.target.code":"code","ConceptMap.group.element.target.comment":"string","ConceptMap.group.element.target.dependsOn":"BackboneElement","ConceptMap.group.element.target.dependsOn.code":"string","ConceptMap.group.element.target.dependsOn.display":"string","ConceptMap.group.element.target.dependsOn.extension":"Extension","ConceptMap.group.element.target.dependsOn.id":"string","ConceptMap.group.element.target.dependsOn.modifierExtension":"Extension","ConceptMap.group.element.target.dependsOn.property":"uri","ConceptMap.group.element.target.dependsOn.system":"uri","ConceptMap.group.element.target.display":"string","ConceptMap.group.element.target.equivalence":"code","ConceptMap.group.element.target.extension":"Extension","ConceptMap.group.element.target.id":"string","ConceptMap.group.element.target.modifierExtension":"Extension","ConceptMap.group.extension":"Extension","ConceptMap.group.id":"string","ConceptMap.group.modifierExtension":"Extension","ConceptMap.group.source":"uri","ConceptMap.group.sourceVersion":"string","ConceptMap.group.target":"uri","ConceptMap.group.targetVersion":"string","ConceptMap.group.unmapped":"BackboneElement","ConceptMap.group.unmapped.code":"code","ConceptMap.group.unmapped.display":"string","ConceptMap.group.unmapped.extension":"Extension","ConceptMap.group.unmapped.id":"string","ConceptMap.group.unmapped.mode":"code","ConceptMap.group.unmapped.modifierExtension":"Extension","ConceptMap.group.unmapped.url":"uri","ConceptMap.id":"id","ConceptMap.identifier":"Identifier","ConceptMap.implicitRules":"uri","ConceptMap.jurisdiction":"CodeableConcept","ConceptMap.language":"code","ConceptMap.meta":"Meta","ConceptMap.modifierExtension":"Extension","ConceptMap.name":"string","ConceptMap.publisher":"string","ConceptMap.purpose":"markdown","ConceptMap.sourceReference":"Reference","ConceptMap.sourceUri":"uri","ConceptMap.status":"code","ConceptMap.targetReference":"Reference","ConceptMap.targetUri":"uri","ConceptMap.text":"Narrative","ConceptMap.title":"string","ConceptMap.url":"uri","ConceptMap.useContext":"UsageContext","ConceptMap.version":"string","Condition.abatementAge":"Age","Condition.abatementBoolean":"boolean","Condition.abatementDateTime":"dateTime","Condition.abatementPeriod":"Period","Condition.abatementRange":"Range","Condition.abatementString":"string","Condition.assertedDate":"dateTime","Condition.asserter":"Reference","Condition.bodySite":"CodeableConcept","Condition.category":"CodeableConcept","Condition.clinicalStatus":"code","Condition.code":"CodeableConcept","Condition.contained":"Resource","Condition.context":"Reference","Condition.evidence":"BackboneElement","Condition.evidence.code":"CodeableConcept","Condition.evidence.detail":"Reference","Condition.evidence.extension":"Extension","Condition.evidence.id":"string","Condition.evidence.modifierExtension":"Extension","Condition.extension":"Extension","Condition.id":"id","Condition.identifier":"Identifier","Condition.implicitRules":"uri","Condition.language":"code","Condition.meta":"Meta","Condition.modifierExtension":"Extension","Condition.note":"Annotation","Condition.onsetAge":"Age","Condition.onsetDateTime":"dateTime","Condition.onsetPeriod":"Period","Condition.onsetRange":"Range","Condition.onsetString":"string","Condition.severity":"CodeableConcept","Condition.stage":"BackboneElement","Condition.stage.assessment":"Reference","Condition.stage.extension":"Extension","Condition.stage.id":"string","Condition.stage.modifierExtension":"Extension","Condition.stage.summary":"CodeableConcept","Condition.subject":"Reference","Condition.text":"Narrative","Condition.verificationStatus":"code","Consent.action":"CodeableConcept","Consent.actor":"BackboneElement","Consent.actor.extension":"Extension","Consent.actor.id":"string","Consent.actor.modifierExtension":"Extension","Consent.actor.reference":"Reference","Consent.actor.role":"CodeableConcept","Consent.category":"CodeableConcept","Consent.consentingParty":"Reference","Consent.contained":"Resource","Consent.data":"BackboneElement","Consent.data.extension":"Extension","Consent.data.id":"string","Consent.data.meaning":"code","Consent.data.modifierExtension":"Extension","Consent.data.reference":"Reference","Consent.dataPeriod":"Period","Consent.dateTime":"dateTime","Consent.except":"BackboneElement","Consent.except.action":"CodeableConcept","Consent.except.actor":"BackboneElement","Consent.except.actor.extension":"Extension","Consent.except.actor.id":"string","Consent.except.actor.modifierExtension":"Extension","Consent.except.actor.reference":"Reference","Consent.except.actor.role":"CodeableConcept","Consent.except.class":"Coding","Consent.except.code":"Coding","Consent.except.data":"BackboneElement","Consent.except.data.extension":"Extension","Consent.except.data.id":"string","Consent.except.data.meaning":"code","Consent.except.data.modifierExtension":"Extension","Consent.except.data.reference":"Reference","Consent.except.dataPeriod":"Period","Consent.except.extension":"Extension","Consent.except.id":"string","Consent.except.modifierExtension":"Extension","Consent.except.period":"Period","Consent.except.purpose":"Coding","Consent.except.securityLabel":"Coding","Consent.except.type":"code","Consent.extension":"Extension","Consent.id":"id","Consent.identifier":"Identifier","Consent.implicitRules":"uri","Consent.language":"code","Consent.meta":"Meta","Consent.modifierExtension":"Extension","Consent.organization":"Reference","Consent.patient":"Reference","Consent.period":"Period","Consent.policy":"BackboneElement","Consent.policy.authority":"uri","Consent.policy.extension":"Extension","Consent.policy.id":"string","Consent.policy.modifierExtension":"Extension","Consent.policy.uri":"uri","Consent.policyRule":"uri","Consent.purpose":"Coding","Consent.securityLabel":"Coding","Consent.sourceAttachment":"Attachment","Consent.sourceIdentifier":"Identifier","Consent.sourceReference":"Reference","Consent.status":"code","Consent.text":"Narrative","ContactDetail.extension":"Extension","ContactDetail.id":"string","ContactDetail.name":"string","ContactDetail.telecom":"ContactPoint","ContactPoint.extension":"Extension","ContactPoint.id":"string","ContactPoint.period":"Period","ContactPoint.rank":"positiveInt","ContactPoint.system":"code","ContactPoint.use":"code","ContactPoint.value":"string","Contract.action":"CodeableConcept","Contract.actionReason":"CodeableConcept","Contract.agent":"BackboneElement","Contract.agent.actor":"Reference","Contract.agent.extension":"Extension","Contract.agent.id":"string","Contract.agent.modifierExtension":"Extension","Contract.agent.role":"CodeableConcept","Contract.applies":"Period","Contract.authority":"Reference","Contract.bindingAttachment":"Attachment","Contract.bindingReference":"Reference","Contract.contained":"Resource","Contract.contentDerivative":"CodeableConcept","Contract.decisionType":"CodeableConcept","Contract.domain":"Reference","Contract.extension":"Extension","Contract.friendly":"BackboneElement","Contract.friendly.contentAttachment":"Attachment","Contract.friendly.contentReference":"Reference","Contract.friendly.extension":"Extension","Contract.friendly.id":"string","Contract.friendly.modifierExtension":"Extension","Contract.id":"id","Contract.identifier":"Identifier","Contract.implicitRules":"uri","Contract.issued":"dateTime","Contract.language":"code","Contract.legal":"BackboneElement","Contract.legal.contentAttachment":"Attachment","Contract.legal.contentReference":"Reference","Contract.legal.extension":"Extension","Contract.legal.id":"string","Contract.legal.modifierExtension":"Extension","Contract.meta":"Meta","Contract.modifierExtension":"Extension","Contract.rule":"BackboneElement","Contract.rule.contentAttachment":"Attachment","Contract.rule.contentReference":"Reference","Contract.rule.extension":"Extension","Contract.rule.id":"string","Contract.rule.modifierExtension":"Extension","Contract.securityLabel":"Coding","Contract.signer":"BackboneElement","Contract.signer.extension":"Extension","Contract.signer.id":"string","Contract.signer.modifierExtension":"Extension","Contract.signer.party":"Reference","Contract.signer.signature":"Signature","Contract.signer.type":"Coding","Contract.status":"code","Contract.subType":"CodeableConcept","Contract.subject":"Reference","Contract.term":"BackboneElement","Contract.term.action":"CodeableConcept","Contract.term.actionReason":"CodeableConcept","Contract.term.agent":"BackboneElement","Contract.term.agent.actor":"Reference","Contract.term.agent.extension":"Extension","Contract.term.agent.id":"string","Contract.term.agent.modifierExtension":"Extension","Contract.term.agent.role":"CodeableConcept","Contract.term.applies":"Period","Contract.term.extension":"Extension","Contract.term.id":"string","Contract.term.identifier":"Identifier","Contract.term.issued":"dateTime","Contract.term.modifierExtension":"Extension","Contract.term.securityLabel":"Coding","Contract.term.subType":"CodeableConcept","Contract.term.text":"string","Contract.term.topic":"Reference","Contract.term.type":"CodeableConcept","Contract.term.valuedItem":"BackboneElement","Contract.term.valuedItem.effectiveTime":"dateTime","Contract.term.valuedItem.entityCodeableConcept":"CodeableConcept","Contract.term.valuedItem.entityReference":"Reference","Contract.term.valuedItem.extension":"Extension","Contract.term.valuedItem.factor":"decimal","Contract.term.valuedItem.id":"string","Contract.term.valuedItem.identifier":"Identifier","Contract.term.valuedItem.modifierExtension":"Extension","Contract.term.valuedItem.net":"Money","Contract.term.valuedItem.points":"decimal","Contract.term.valuedItem.quantity":"Quantity","Contract.term.valuedItem.unitPrice":"Money","Contract.text":"Narrative","Contract.topic":"Reference","Contract.type":"CodeableConcept","Contract.valuedItem":"BackboneElement","Contract.valuedItem.effectiveTime":"dateTime","Contract.valuedItem.entityCodeableConcept":"CodeableConcept","Contract.valuedItem.entityReference":"Reference","Contract.valuedItem.extension":"Extension","Contract.valuedItem.factor":"decimal","Contract.valuedItem.id":"string","Contract.valuedItem.identifier":"Identifier","Contract.valuedItem.modifierExtension":"Extension","Contract.valuedItem.net":"Money","Contract.valuedItem.points":"decimal","Contract.valuedItem.quantity":"Quantity","Contract.valuedItem.unitPrice":"Money","Contributor.contact":"ContactDetail","Contributor.extension":"Extension","Contributor.id":"string","Contributor.name":"string","Contributor.type":"code","Count.code":"code","Count.comparator":"code","Count.extension":"Extension","Count.id":"string","Count.system":"uri","Count.unit":"string","Count.value":"decimal","Coverage.beneficiary":"Reference","Coverage.contained":"Resource","Coverage.contract":"Reference","Coverage.dependent":"string","Coverage.extension":"Extension","Coverage.grouping":"BackboneElement","Coverage.grouping.class":"string","Coverage.grouping.classDisplay":"string","Coverage.grouping.extension":"Extension","Coverage.grouping.group":"string","Coverage.grouping.groupDisplay":"string","Coverage.grouping.id":"string","Coverage.grouping.modifierExtension":"Extension","Coverage.grouping.plan":"string","Coverage.grouping.planDisplay":"string","Coverage.grouping.subClass":"string","Coverage.grouping.subClassDisplay":"string","Coverage.grouping.subGroup":"string","Coverage.grouping.subGroupDisplay":"string","Coverage.grouping.subPlan":"string","Coverage.grouping.subPlanDisplay":"string","Coverage.id":"id","Coverage.identifier":"Identifier","Coverage.implicitRules":"uri","Coverage.language":"code","Coverage.meta":"Meta","Coverage.modifierExtension":"Extension","Coverage.network":"string","Coverage.order":"positiveInt","Coverage.payor":"Reference","Coverage.period":"Period","Coverage.policyHolder":"Reference","Coverage.relationship":"CodeableConcept","Coverage.sequence":"string","Coverage.status":"code","Coverage.subscriber":"Reference","Coverage.subscriberId":"string","Coverage.text":"Narrative","Coverage.type":"CodeableConcept","DataElement.contact":"ContactDetail","DataElement.contained":"Resource","DataElement.copyright":"markdown","DataElement.date":"dateTime","DataElement.element":"ElementDefinition","DataElement.experimental":"boolean","DataElement.extension":"Extension","DataElement.id":"id","DataElement.identifier":"Identifier","DataElement.implicitRules":"uri","DataElement.jurisdiction":"CodeableConcept","DataElement.language":"code","DataElement.mapping":"BackboneElement","DataElement.mapping.comment":"string","DataElement.mapping.extension":"Extension","DataElement.mapping.id":"string","DataElement.mapping.identity":"id","DataElement.mapping.modifierExtension":"Extension","DataElement.mapping.name":"string","DataElement.mapping.uri":"uri","DataElement.meta":"Meta","DataElement.modifierExtension":"Extension","DataElement.name":"string","DataElement.publisher":"string","DataElement.status":"code","DataElement.stringency":"code","DataElement.text":"Narrative","DataElement.title":"string","DataElement.url":"uri","DataElement.useContext":"UsageContext","DataElement.version":"string","DataRequirement.codeFilter":"Element","DataRequirement.codeFilter.extension":"Extension","DataRequirement.codeFilter.id":"string","DataRequirement.codeFilter.path":"string","DataRequirement.codeFilter.valueCode":"code","DataRequirement.codeFilter.valueCodeableConcept":"CodeableConcept","DataRequirement.codeFilter.valueCoding":"Coding","DataRequirement.codeFilter.valueSetReference":"Reference","DataRequirement.codeFilter.valueSetString":"string","DataRequirement.dateFilter":"Element","DataRequirement.dateFilter.extension":"Extension","DataRequirement.dateFilter.id":"string","DataRequirement.dateFilter.path":"string","DataRequirement.dateFilter.valueDateTime":"dateTime","DataRequirement.dateFilter.valueDuration":"Duration","DataRequirement.dateFilter.valuePeriod":"Period","DataRequirement.extension":"Extension","DataRequirement.id":"string","DataRequirement.mustSupport":"string","DataRequirement.profile":"uri","DataRequirement.type":"code","DetectedIssue.author":"Reference","DetectedIssue.category":"CodeableConcept","DetectedIssue.contained":"Resource","DetectedIssue.date":"dateTime","DetectedIssue.detail":"string","DetectedIssue.extension":"Extension","DetectedIssue.id":"id","DetectedIssue.identifier":"Identifier","DetectedIssue.implicated":"Reference","DetectedIssue.implicitRules":"uri","DetectedIssue.language":"code","DetectedIssue.meta":"Meta","DetectedIssue.mitigation":"BackboneElement","DetectedIssue.mitigation.action":"CodeableConcept","DetectedIssue.mitigation.author":"Reference","DetectedIssue.mitigation.date":"dateTime","DetectedIssue.mitigation.extension":"Extension","DetectedIssue.mitigation.id":"string","DetectedIssue.mitigation.modifierExtension":"Extension","DetectedIssue.modifierExtension":"Extension","DetectedIssue.patient":"Reference","DetectedIssue.reference":"uri","DetectedIssue.severity":"code","DetectedIssue.status":"code","DetectedIssue.text":"Narrative","Device.contact":"ContactPoint","Device.contained":"Resource","Device.expirationDate":"dateTime","Device.extension":"Extension","Device.id":"id","Device.identifier":"Identifier","Device.implicitRules":"uri","Device.language":"code","Device.location":"Reference","Device.lotNumber":"string","Device.manufactureDate":"dateTime","Device.manufacturer":"string","Device.meta":"Meta","Device.model":"string","Device.modifierExtension":"Extension","Device.note":"Annotation","Device.owner":"Reference","Device.patient":"Reference","Device.safety":"CodeableConcept","Device.status":"code","Device.text":"Narrative","Device.type":"CodeableConcept","Device.udi":"BackboneElement","Device.udi.carrierAIDC":"base64Binary","Device.udi.carrierHRF":"string","Device.udi.deviceIdentifier":"string","Device.udi.entryType":"code","Device.udi.extension":"Extension","Device.udi.id":"string","Device.udi.issuer":"uri","Device.udi.jurisdiction":"uri","Device.udi.modifierExtension":"Extension","Device.udi.name":"string","Device.url":"uri","Device.version":"string","DeviceComponent.contained":"Resource","DeviceComponent.extension":"Extension","DeviceComponent.id":"id","DeviceComponent.identifier":"Identifier","DeviceComponent.implicitRules":"uri","DeviceComponent.language":"code","DeviceComponent.languageCode":"CodeableConcept","DeviceComponent.lastSystemChange":"instant","DeviceComponent.measurementPrinciple":"code","DeviceComponent.meta":"Meta","DeviceComponent.modifierExtension":"Extension","DeviceComponent.operationalStatus":"CodeableConcept","DeviceComponent.parameterGroup":"CodeableConcept","DeviceComponent.parent":"Reference","DeviceComponent.productionSpecification":"BackboneElement","DeviceComponent.productionSpecification.componentId":"Identifier","DeviceComponent.productionSpecification.extension":"Extension","DeviceComponent.productionSpecification.id":"string","DeviceComponent.productionSpecification.modifierExtension":"Extension","DeviceComponent.productionSpecification.productionSpec":"string","DeviceComponent.productionSpecification.specType":"CodeableConcept","DeviceComponent.source":"Reference","DeviceComponent.text":"Narrative","DeviceComponent.type":"CodeableConcept","DeviceMetric.calibration":"BackboneElement","DeviceMetric.calibration.extension":"Extension","DeviceMetric.calibration.id":"string","DeviceMetric.calibration.modifierExtension":"Extension","DeviceMetric.calibration.state":"code","DeviceMetric.calibration.time":"instant","DeviceMetric.calibration.type":"code","DeviceMetric.category":"code","DeviceMetric.color":"code","DeviceMetric.contained":"Resource","DeviceMetric.extension":"Extension","DeviceMetric.id":"id","DeviceMetric.identifier":"Identifier","DeviceMetric.implicitRules":"uri","DeviceMetric.language":"code","DeviceMetric.measurementPeriod":"Timing","DeviceMetric.meta":"Meta","DeviceMetric.modifierExtension":"Extension","DeviceMetric.operationalStatus":"code","DeviceMetric.parent":"Reference","DeviceMetric.source":"Reference","DeviceMetric.text":"Narrative","DeviceMetric.type":"CodeableConcept","DeviceMetric.unit":"CodeableConcept","DeviceRequest.authoredOn":"dateTime","DeviceRequest.basedOn":"Reference","DeviceRequest.codeCodeableConcept":"CodeableConcept","DeviceRequest.codeReference":"Reference","DeviceRequest.contained":"Resource","DeviceRequest.context":"Reference","DeviceRequest.definition":"Reference","DeviceRequest.extension":"Extension","DeviceRequest.groupIdentifier":"Identifier","DeviceRequest.id":"id","DeviceRequest.identifier":"Identifier","DeviceRequest.implicitRules":"uri","DeviceRequest.intent":"CodeableConcept","DeviceRequest.language":"code","DeviceRequest.meta":"Meta","DeviceRequest.modifierExtension":"Extension","DeviceRequest.note":"Annotation","DeviceRequest.occurrenceDateTime":"dateTime","DeviceRequest.occurrencePeriod":"Period","DeviceRequest.occurrenceTiming":"Timing","DeviceRequest.performer":"Reference","DeviceRequest.performerType":"CodeableConcept","DeviceRequest.priorRequest":"Reference","DeviceRequest.priority":"code","DeviceRequest.reasonCode":"CodeableConcept","DeviceRequest.reasonReference":"Reference","DeviceRequest.relevantHistory":"Reference","DeviceRequest.requester":"BackboneElement","DeviceRequest.requester.agent":"Reference","DeviceRequest.requester.extension":"Extension","DeviceRequest.requester.id":"string","DeviceRequest.requester.modifierExtension":"Extension","DeviceRequest.requester.onBehalfOf":"Reference","DeviceRequest.status":"code","DeviceRequest.subject":"Reference","DeviceRequest.supportingInfo":"Reference","DeviceRequest.text":"Narrative","DeviceUseStatement.bodySite":"CodeableConcept","DeviceUseStatement.contained":"Resource","DeviceUseStatement.device":"Reference","DeviceUseStatement.extension":"Extension","DeviceUseStatement.id":"id","DeviceUseStatement.identifier":"Identifier","DeviceUseStatement.implicitRules":"uri","DeviceUseStatement.indication":"CodeableConcept","DeviceUseStatement.language":"code","DeviceUseStatement.meta":"Meta","DeviceUseStatement.modifierExtension":"Extension","DeviceUseStatement.note":"Annotation","DeviceUseStatement.recordedOn":"dateTime","DeviceUseStatement.source":"Reference","DeviceUseStatement.status":"code","DeviceUseStatement.subject":"Reference","DeviceUseStatement.text":"Narrative","DeviceUseStatement.timingDateTime":"dateTime","DeviceUseStatement.timingPeriod":"Period","DeviceUseStatement.timingTiming":"Timing","DeviceUseStatement.whenUsed":"Period","DiagnosticReport.basedOn":"Reference","DiagnosticReport.category":"CodeableConcept","DiagnosticReport.code":"CodeableConcept","DiagnosticReport.codedDiagnosis":"CodeableConcept","DiagnosticReport.conclusion":"string","DiagnosticReport.contained":"Resource","DiagnosticReport.context":"Reference","DiagnosticReport.effectiveDateTime":"dateTime","DiagnosticReport.effectivePeriod":"Period","DiagnosticReport.extension":"Extension","DiagnosticReport.id":"id","DiagnosticReport.identifier":"Identifier","DiagnosticReport.image":"BackboneElement","DiagnosticReport.image.comment":"string","DiagnosticReport.image.extension":"Extension","DiagnosticReport.image.id":"string","DiagnosticReport.image.link":"Reference","DiagnosticReport.image.modifierExtension":"Extension","DiagnosticReport.imagingStudy":"Reference","DiagnosticReport.implicitRules":"uri","DiagnosticReport.issued":"instant","DiagnosticReport.language":"code","DiagnosticReport.meta":"Meta","DiagnosticReport.modifierExtension":"Extension","DiagnosticReport.performer":"BackboneElement","DiagnosticReport.performer.actor":"Reference","DiagnosticReport.performer.extension":"Extension","DiagnosticReport.performer.id":"string","DiagnosticReport.performer.modifierExtension":"Extension","DiagnosticReport.performer.role":"CodeableConcept","DiagnosticReport.presentedForm":"Attachment","DiagnosticReport.result":"Reference","DiagnosticReport.specimen":"Reference","DiagnosticReport.status":"code","DiagnosticReport.subject":"Reference","DiagnosticReport.text":"Narrative","Distance.code":"code","Distance.comparator":"code","Distance.extension":"Extension","Distance.id":"string","Distance.system":"uri","Distance.unit":"string","Distance.value":"decimal","DocumentManifest.author":"Reference","DocumentManifest.contained":"Resource","DocumentManifest.content":"BackboneElement","DocumentManifest.content.extension":"Extension","DocumentManifest.content.id":"string","DocumentManifest.content.modifierExtension":"Extension","DocumentManifest.content.pAttachment":"Attachment","DocumentManifest.content.pReference":"Reference","DocumentManifest.created":"dateTime","DocumentManifest.description":"string","DocumentManifest.extension":"Extension","DocumentManifest.id":"id","DocumentManifest.identifier":"Identifier","DocumentManifest.implicitRules":"uri","DocumentManifest.language":"code","DocumentManifest.masterIdentifier":"Identifier","DocumentManifest.meta":"Meta","DocumentManifest.modifierExtension":"Extension","DocumentManifest.recipient":"Reference","DocumentManifest.related":"BackboneElement","DocumentManifest.related.extension":"Extension","DocumentManifest.related.id":"string","DocumentManifest.related.identifier":"Identifier","DocumentManifest.related.modifierExtension":"Extension","DocumentManifest.related.ref":"Reference","DocumentManifest.source":"uri","DocumentManifest.status":"code","DocumentManifest.subject":"Reference","DocumentManifest.text":"Narrative","DocumentManifest.type":"CodeableConcept","DocumentReference.authenticator":"Reference","DocumentReference.author":"Reference","DocumentReference.class":"CodeableConcept","DocumentReference.contained":"Resource","DocumentReference.content":"BackboneElement","DocumentReference.content.attachment":"Attachment","DocumentReference.content.extension":"Extension","DocumentReference.content.format":"Coding","DocumentReference.content.id":"string","DocumentReference.content.modifierExtension":"Extension","DocumentReference.context":"BackboneElement","DocumentReference.context.encounter":"Reference","DocumentReference.context.event":"CodeableConcept","DocumentReference.context.extension":"Extension","DocumentReference.context.facilityType":"CodeableConcept","DocumentReference.context.id":"string","DocumentReference.context.modifierExtension":"Extension","DocumentReference.context.period":"Period","DocumentReference.context.practiceSetting":"CodeableConcept","DocumentReference.context.related":"BackboneElement","DocumentReference.context.related.extension":"Extension","DocumentReference.context.related.id":"string","DocumentReference.context.related.identifier":"Identifier","DocumentReference.context.related.modifierExtension":"Extension","DocumentReference.context.related.ref":"Reference","DocumentReference.context.sourcePatientInfo":"Reference","DocumentReference.created":"dateTime","DocumentReference.custodian":"Reference","DocumentReference.description":"string","DocumentReference.docStatus":"code","DocumentReference.extension":"Extension","DocumentReference.id":"id","DocumentReference.identifier":"Identifier","DocumentReference.implicitRules":"uri","DocumentReference.indexed":"instant","DocumentReference.language":"code","DocumentReference.masterIdentifier":"Identifier","DocumentReference.meta":"Meta","DocumentReference.modifierExtension":"Extension","DocumentReference.relatesTo":"BackboneElement","DocumentReference.relatesTo.code":"code","DocumentReference.relatesTo.extension":"Extension","DocumentReference.relatesTo.id":"string","DocumentReference.relatesTo.modifierExtension":"Extension","DocumentReference.relatesTo.target":"Reference","DocumentReference.securityLabel":"CodeableConcept","DocumentReference.status":"code","DocumentReference.subject":"Reference","DocumentReference.text":"Narrative","DocumentReference.type":"CodeableConcept","DomainResource.contained":"Resource","DomainResource.extension":"Extension","DomainResource.id":"id","DomainResource.implicitRules":"uri","DomainResource.language":"code","DomainResource.meta":"Meta","DomainResource.modifierExtension":"Extension","DomainResource.text":"Narrative","Dosage.additionalInstruction":"CodeableConcept","Dosage.asNeededBoolean":"boolean","Dosage.asNeededCodeableConcept":"CodeableConcept","Dosage.doseQuantity":"Quantity","Dosage.doseRange":"Range","Dosage.extension":"Extension","Dosage.id":"string","Dosage.maxDosePerAdministration":"Quantity","Dosage.maxDosePerLifetime":"Quantity","Dosage.maxDosePerPeriod":"Ratio","Dosage.method":"CodeableConcept","Dosage.patientInstruction":"string","Dosage.rateQuantity":"Quantity","Dosage.rateRange":"Range","Dosage.rateRatio":"Ratio","Dosage.route":"CodeableConcept","Dosage.sequence":"integer","Dosage.site":"CodeableConcept","Dosage.text":"string","Dosage.timing":"Timing","Duration.code":"code","Duration.comparator":"code","Duration.extension":"Extension","Duration.id":"string","Duration.system":"uri","Duration.unit":"string","Duration.value":"decimal","Element.extension":"Extension","Element.id":"string","ElementDefinition.alias":"string","ElementDefinition.base":"Element","ElementDefinition.base.extension":"Extension","ElementDefinition.base.id":"string","ElementDefinition.base.max":"string","ElementDefinition.base.min":"unsignedInt","ElementDefinition.base.path":"string","ElementDefinition.binding":"Element","ElementDefinition.binding.description":"string","ElementDefinition.binding.extension":"Extension","ElementDefinition.binding.id":"string","ElementDefinition.binding.strength":"code","ElementDefinition.binding.valueSetReference":"Reference","ElementDefinition.binding.valueSetUri":"uri","ElementDefinition.code":"Coding","ElementDefinition.comment":"markdown","ElementDefinition.condition":"id","ElementDefinition.constraint":"Element","ElementDefinition.constraint.expression":"string","ElementDefinition.constraint.extension":"Extension","ElementDefinition.constraint.human":"string","ElementDefinition.constraint.id":"string","ElementDefinition.constraint.key":"id","ElementDefinition.constraint.requirements":"string","ElementDefinition.constraint.severity":"code","ElementDefinition.constraint.source":"uri","ElementDefinition.constraint.xpath":"string","ElementDefinition.contentReference":"uri","ElementDefinition.defaultValueAddress":"Address","ElementDefinition.defaultValueAge":"Age","ElementDefinition.defaultValueAnnotation":"Annotation","ElementDefinition.defaultValueAttachment":"Attachment","ElementDefinition.defaultValueBase64Binary":"base64Binary","ElementDefinition.defaultValueBoolean":"boolean","ElementDefinition.defaultValueCode":"code","ElementDefinition.defaultValueCodeableConcept":"CodeableConcept","ElementDefinition.defaultValueCoding":"Coding","ElementDefinition.defaultValueContactPoint":"ContactPoint","ElementDefinition.defaultValueCount":"Count","ElementDefinition.defaultValueDate":"date","ElementDefinition.defaultValueDateTime":"dateTime","ElementDefinition.defaultValueDecimal":"decimal","ElementDefinition.defaultValueDistance":"Distance","ElementDefinition.defaultValueDuration":"Duration","ElementDefinition.defaultValueHumanName":"HumanName","ElementDefinition.defaultValueId":"id","ElementDefinition.defaultValueIdentifier":"Identifier","ElementDefinition.defaultValueInstant":"instant","ElementDefinition.defaultValueInteger":"integer","ElementDefinition.defaultValueMarkdown":"markdown","ElementDefinition.defaultValueMeta":"Meta","ElementDefinition.defaultValueMoney":"Money","ElementDefinition.defaultValueOid":"oid","ElementDefinition.defaultValuePeriod":"Period","ElementDefinition.defaultValuePositiveInt":"positiveInt","ElementDefinition.defaultValueQuantity":"Quantity","ElementDefinition.defaultValueRange":"Range","ElementDefinition.defaultValueRatio":"Ratio","ElementDefinition.defaultValueReference":"Reference","ElementDefinition.defaultValueSampledData":"SampledData","ElementDefinition.defaultValueSignature":"Signature","ElementDefinition.defaultValueString":"string","ElementDefinition.defaultValueTime":"time","ElementDefinition.defaultValueTiming":"Timing","ElementDefinition.defaultValueUnsignedInt":"unsignedInt","ElementDefinition.defaultValueUri":"uri","ElementDefinition.definition":"markdown","ElementDefinition.example":"Element","ElementDefinition.example.extension":"Extension","ElementDefinition.example.id":"string","ElementDefinition.example.label":"string","ElementDefinition.example.valueAddress":"Address","ElementDefinition.example.valueAge":"Age","ElementDefinition.example.valueAnnotation":"Annotation","ElementDefinition.example.valueAttachment":"Attachment","ElementDefinition.example.valueBase64Binary":"base64Binary","ElementDefinition.example.valueBoolean":"boolean","ElementDefinition.example.valueCode":"code","ElementDefinition.example.valueCodeableConcept":"CodeableConcept","ElementDefinition.example.valueCoding":"Coding","ElementDefinition.example.valueContactPoint":"ContactPoint","ElementDefinition.example.valueCount":"Count","ElementDefinition.example.valueDate":"date","ElementDefinition.example.valueDateTime":"dateTime","ElementDefinition.example.valueDecimal":"decimal","ElementDefinition.example.valueDistance":"Distance","ElementDefinition.example.valueDuration":"Duration","ElementDefinition.example.valueHumanName":"HumanName","ElementDefinition.example.valueId":"id","ElementDefinition.example.valueIdentifier":"Identifier","ElementDefinition.example.valueInstant":"instant","ElementDefinition.example.valueInteger":"integer","ElementDefinition.example.valueMarkdown":"markdown","ElementDefinition.example.valueMeta":"Meta","ElementDefinition.example.valueMoney":"Money","ElementDefinition.example.valueOid":"oid","ElementDefinition.example.valuePeriod":"Period","ElementDefinition.example.valuePositiveInt":"positiveInt","ElementDefinition.example.valueQuantity":"Quantity","ElementDefinition.example.valueRange":"Range","ElementDefinition.example.valueRatio":"Ratio","ElementDefinition.example.valueReference":"Reference","ElementDefinition.example.valueSampledData":"SampledData","ElementDefinition.example.valueSignature":"Signature","ElementDefinition.example.valueString":"string","ElementDefinition.example.valueTime":"time","ElementDefinition.example.valueTiming":"Timing","ElementDefinition.example.valueUnsignedInt":"unsignedInt","ElementDefinition.example.valueUri":"uri","ElementDefinition.extension":"Extension","ElementDefinition.extension.extension":"Extension","ElementDefinition.extension.id":"string","ElementDefinition.extension.url":"uri","ElementDefinition.extension.valueCodeableConcept":"CodeableConcept","ElementDefinition.extension.valueReference":"Reference","ElementDefinition.extension.valueString":"string","ElementDefinition.fixedAddress":"Address","ElementDefinition.fixedAge":"Age","ElementDefinition.fixedAnnotation":"Annotation","ElementDefinition.fixedAttachment":"Attachment","ElementDefinition.fixedBase64Binary":"base64Binary","ElementDefinition.fixedBoolean":"boolean","ElementDefinition.fixedCode":"code","ElementDefinition.fixedCodeableConcept":"CodeableConcept","ElementDefinition.fixedCoding":"Coding","ElementDefinition.fixedContactPoint":"ContactPoint","ElementDefinition.fixedCount":"Count","ElementDefinition.fixedDate":"date","ElementDefinition.fixedDateTime":"dateTime","ElementDefinition.fixedDecimal":"decimal","ElementDefinition.fixedDistance":"Distance","ElementDefinition.fixedDuration":"Duration","ElementDefinition.fixedHumanName":"HumanName","ElementDefinition.fixedId":"id","ElementDefinition.fixedIdentifier":"Identifier","ElementDefinition.fixedInstant":"instant","ElementDefinition.fixedInteger":"integer","ElementDefinition.fixedMarkdown":"markdown","ElementDefinition.fixedMeta":"Meta","ElementDefinition.fixedMoney":"Money","ElementDefinition.fixedOid":"oid","ElementDefinition.fixedPeriod":"Period","ElementDefinition.fixedPositiveInt":"positiveInt","ElementDefinition.fixedQuantity":"Quantity","ElementDefinition.fixedRange":"Range","ElementDefinition.fixedRatio":"Ratio","ElementDefinition.fixedReference":"Reference","ElementDefinition.fixedSampledData":"SampledData","ElementDefinition.fixedSignature":"Signature","ElementDefinition.fixedString":"string","ElementDefinition.fixedTime":"time","ElementDefinition.fixedTiming":"Timing","ElementDefinition.fixedUnsignedInt":"unsignedInt","ElementDefinition.fixedUri":"uri","ElementDefinition.id":"string","ElementDefinition.isModifier":"boolean","ElementDefinition.isSummary":"boolean","ElementDefinition.label":"string","ElementDefinition.mapping":"Element","ElementDefinition.mapping.comment":"string","ElementDefinition.mapping.extension":"Extension","ElementDefinition.mapping.id":"string","ElementDefinition.mapping.identity":"id","ElementDefinition.mapping.language":"code","ElementDefinition.mapping.map":"string","ElementDefinition.max":"string","ElementDefinition.maxLength":"integer","ElementDefinition.maxValueDate":"date","ElementDefinition.maxValueDateTime":"dateTime","ElementDefinition.maxValueDecimal":"decimal","ElementDefinition.maxValueInstant":"instant","ElementDefinition.maxValueInteger":"integer","ElementDefinition.maxValuePositiveInt":"positiveInt","ElementDefinition.maxValueQuantity":"Quantity","ElementDefinition.maxValueTime":"time","ElementDefinition.maxValueUnsignedInt":"unsignedInt","ElementDefinition.meaningWhenMissing":"markdown","ElementDefinition.min":"unsignedInt","ElementDefinition.minValueDate":"date","ElementDefinition.minValueDateTime":"dateTime","ElementDefinition.minValueDecimal":"decimal","ElementDefinition.minValueInstant":"instant","ElementDefinition.minValueInteger":"integer","ElementDefinition.minValuePositiveInt":"positiveInt","ElementDefinition.minValueQuantity":"Quantity","ElementDefinition.minValueTime":"time","ElementDefinition.minValueUnsignedInt":"unsignedInt","ElementDefinition.mustSupport":"boolean","ElementDefinition.orderMeaning":"string","ElementDefinition.path":"string","ElementDefinition.patternAddress":"Address","ElementDefinition.patternAge":"Age","ElementDefinition.patternAnnotation":"Annotation","ElementDefinition.patternAttachment":"Attachment","ElementDefinition.patternBase64Binary":"base64Binary","ElementDefinition.patternBoolean":"boolean","ElementDefinition.patternCode":"code","ElementDefinition.patternCodeableConcept":"CodeableConcept","ElementDefinition.patternCoding":"Coding","ElementDefinition.patternContactPoint":"ContactPoint","ElementDefinition.patternCount":"Count","ElementDefinition.patternDate":"date","ElementDefinition.patternDateTime":"dateTime","ElementDefinition.patternDecimal":"decimal","ElementDefinition.patternDistance":"Distance","ElementDefinition.patternDuration":"Duration","ElementDefinition.patternHumanName":"HumanName","ElementDefinition.patternId":"id","ElementDefinition.patternIdentifier":"Identifier","ElementDefinition.patternInstant":"instant","ElementDefinition.patternInteger":"integer","ElementDefinition.patternMarkdown":"markdown","ElementDefinition.patternMeta":"Meta","ElementDefinition.patternMoney":"Money","ElementDefinition.patternOid":"oid","ElementDefinition.patternPeriod":"Period","ElementDefinition.patternPositiveInt":"positiveInt","ElementDefinition.patternQuantity":"Quantity","ElementDefinition.patternRange":"Range","ElementDefinition.patternRatio":"Ratio","ElementDefinition.patternReference":"Reference","ElementDefinition.patternSampledData":"SampledData","ElementDefinition.patternSignature":"Signature","ElementDefinition.patternString":"string","ElementDefinition.patternTime":"time","ElementDefinition.patternTiming":"Timing","ElementDefinition.patternUnsignedInt":"unsignedInt","ElementDefinition.patternUri":"uri","ElementDefinition.representation":"code","ElementDefinition.requirements":"markdown","ElementDefinition.short":"string","ElementDefinition.sliceName":"string","ElementDefinition.slicing":"Element","ElementDefinition.slicing.description":"string","ElementDefinition.slicing.discriminator":"Element","ElementDefinition.slicing.discriminator.extension":"Extension","ElementDefinition.slicing.discriminator.id":"string","ElementDefinition.slicing.discriminator.path":"string","ElementDefinition.slicing.discriminator.type":"code","ElementDefinition.slicing.extension":"Extension","ElementDefinition.slicing.id":"string","ElementDefinition.slicing.ordered":"boolean","ElementDefinition.slicing.rules":"code","ElementDefinition.type":"Element","ElementDefinition.type.aggregation":"code","ElementDefinition.type.code":"uri","ElementDefinition.type.extension":"Extension","ElementDefinition.type.id":"string","ElementDefinition.type.profile":"uri","ElementDefinition.type.targetProfile":"uri","ElementDefinition.type.versioning":"code","EligibilityRequest.benefitCategory":"CodeableConcept","EligibilityRequest.benefitSubCategory":"CodeableConcept","EligibilityRequest.businessArrangement":"string","EligibilityRequest.contained":"Resource","EligibilityRequest.coverage":"Reference","EligibilityRequest.created":"dateTime","EligibilityRequest.enterer":"Reference","EligibilityRequest.extension":"Extension","EligibilityRequest.facility":"Reference","EligibilityRequest.id":"id","EligibilityRequest.identifier":"Identifier","EligibilityRequest.implicitRules":"uri","EligibilityRequest.insurer":"Reference","EligibilityRequest.language":"code","EligibilityRequest.meta":"Meta","EligibilityRequest.modifierExtension":"Extension","EligibilityRequest.organization":"Reference","EligibilityRequest.patient":"Reference","EligibilityRequest.priority":"CodeableConcept","EligibilityRequest.provider":"Reference","EligibilityRequest.servicedDate":"date","EligibilityRequest.servicedPeriod":"Period","EligibilityRequest.status":"code","EligibilityRequest.text":"Narrative","EligibilityResponse.contained":"Resource","EligibilityResponse.created":"dateTime","EligibilityResponse.disposition":"string","EligibilityResponse.error":"BackboneElement","EligibilityResponse.error.code":"CodeableConcept","EligibilityResponse.error.extension":"Extension","EligibilityResponse.error.id":"string","EligibilityResponse.error.modifierExtension":"Extension","EligibilityResponse.extension":"Extension","EligibilityResponse.form":"CodeableConcept","EligibilityResponse.id":"id","EligibilityResponse.identifier":"Identifier","EligibilityResponse.implicitRules":"uri","EligibilityResponse.inforce":"boolean","EligibilityResponse.insurance":"BackboneElement","EligibilityResponse.insurance.benefitBalance":"BackboneElement","EligibilityResponse.insurance.benefitBalance.category":"CodeableConcept","EligibilityResponse.insurance.benefitBalance.description":"string","EligibilityResponse.insurance.benefitBalance.excluded":"boolean","EligibilityResponse.insurance.benefitBalance.extension":"Extension","EligibilityResponse.insurance.benefitBalance.financial":"BackboneElement","EligibilityResponse.insurance.benefitBalance.financial.allowedMoney":"Money","EligibilityResponse.insurance.benefitBalance.financial.allowedString":"string","EligibilityResponse.insurance.benefitBalance.financial.allowedUnsignedInt":"unsignedInt","EligibilityResponse.insurance.benefitBalance.financial.extension":"Extension","EligibilityResponse.insurance.benefitBalance.financial.id":"string","EligibilityResponse.insurance.benefitBalance.financial.modifierExtension":"Extension","EligibilityResponse.insurance.benefitBalance.financial.type":"CodeableConcept","EligibilityResponse.insurance.benefitBalance.financial.usedMoney":"Money","EligibilityResponse.insurance.benefitBalance.financial.usedUnsignedInt":"unsignedInt","EligibilityResponse.insurance.benefitBalance.id":"string","EligibilityResponse.insurance.benefitBalance.modifierExtension":"Extension","EligibilityResponse.insurance.benefitBalance.name":"string","EligibilityResponse.insurance.benefitBalance.network":"CodeableConcept","EligibilityResponse.insurance.benefitBalance.subCategory":"CodeableConcept","EligibilityResponse.insurance.benefitBalance.term":"CodeableConcept","EligibilityResponse.insurance.benefitBalance.unit":"CodeableConcept","EligibilityResponse.insurance.contract":"Reference","EligibilityResponse.insurance.coverage":"Reference","EligibilityResponse.insurance.extension":"Extension","EligibilityResponse.insurance.id":"string","EligibilityResponse.insurance.modifierExtension":"Extension","EligibilityResponse.insurer":"Reference","EligibilityResponse.language":"code","EligibilityResponse.meta":"Meta","EligibilityResponse.modifierExtension":"Extension","EligibilityResponse.outcome":"CodeableConcept","EligibilityResponse.request":"Reference","EligibilityResponse.requestOrganization":"Reference","EligibilityResponse.requestProvider":"Reference","EligibilityResponse.status":"code","EligibilityResponse.text":"Narrative","Encounter.account":"Reference","Encounter.appointment":"Reference","Encounter.class":"Coding","Encounter.classHistory":"BackboneElement","Encounter.classHistory.class":"Coding","Encounter.classHistory.extension":"Extension","Encounter.classHistory.id":"string","Encounter.classHistory.modifierExtension":"Extension","Encounter.classHistory.period":"Period","Encounter.contained":"Resource","Encounter.diagnosis":"BackboneElement","Encounter.diagnosis.condition":"Reference","Encounter.diagnosis.extension":"Extension","Encounter.diagnosis.id":"string","Encounter.diagnosis.modifierExtension":"Extension","Encounter.diagnosis.rank":"positiveInt","Encounter.diagnosis.role":"CodeableConcept","Encounter.episodeOfCare":"Reference","Encounter.extension":"Extension","Encounter.hospitalization":"BackboneElement","Encounter.hospitalization.admitSource":"CodeableConcept","Encounter.hospitalization.destination":"Reference","Encounter.hospitalization.dietPreference":"CodeableConcept","Encounter.hospitalization.dischargeDisposition":"CodeableConcept","Encounter.hospitalization.extension":"Extension","Encounter.hospitalization.id":"string","Encounter.hospitalization.modifierExtension":"Extension","Encounter.hospitalization.origin":"Reference","Encounter.hospitalization.preAdmissionIdentifier":"Identifier","Encounter.hospitalization.reAdmission":"CodeableConcept","Encounter.hospitalization.specialArrangement":"CodeableConcept","Encounter.hospitalization.specialCourtesy":"CodeableConcept","Encounter.id":"id","Encounter.identifier":"Identifier","Encounter.implicitRules":"uri","Encounter.incomingReferral":"Reference","Encounter.language":"code","Encounter.length":"Duration","Encounter.location":"BackboneElement","Encounter.location.extension":"Extension","Encounter.location.id":"string","Encounter.location.location":"Reference","Encounter.location.modifierExtension":"Extension","Encounter.location.period":"Period","Encounter.location.status":"code","Encounter.meta":"Meta","Encounter.modifierExtension":"Extension","Encounter.partOf":"Reference","Encounter.participant":"BackboneElement","Encounter.participant.extension":"Extension","Encounter.participant.id":"string","Encounter.participant.individual":"Reference","Encounter.participant.modifierExtension":"Extension","Encounter.participant.period":"Period","Encounter.participant.type":"CodeableConcept","Encounter.period":"Period","Encounter.priority":"CodeableConcept","Encounter.reason":"CodeableConcept","Encounter.serviceProvider":"Reference","Encounter.status":"code","Encounter.statusHistory":"BackboneElement","Encounter.statusHistory.extension":"Extension","Encounter.statusHistory.id":"string","Encounter.statusHistory.modifierExtension":"Extension","Encounter.statusHistory.period":"Period","Encounter.statusHistory.status":"code","Encounter.subject":"Reference","Encounter.text":"Narrative","Encounter.type":"CodeableConcept","Endpoint.address":"uri","Endpoint.connectionType":"Coding","Endpoint.contact":"ContactPoint","Endpoint.contained":"Resource","Endpoint.extension":"Extension","Endpoint.header":"string","Endpoint.id":"id","Endpoint.identifier":"Identifier","Endpoint.implicitRules":"uri","Endpoint.language":"code","Endpoint.managingOrganization":"Reference","Endpoint.meta":"Meta","Endpoint.modifierExtension":"Extension","Endpoint.name":"string","Endpoint.payloadMimeType":"code","Endpoint.payloadType":"CodeableConcept","Endpoint.period":"Period","Endpoint.status":"code","Endpoint.text":"Narrative","EnrollmentRequest.contained":"Resource","EnrollmentRequest.coverage":"Reference","EnrollmentRequest.created":"dateTime","EnrollmentRequest.extension":"Extension","EnrollmentRequest.id":"id","EnrollmentRequest.identifier":"Identifier","EnrollmentRequest.implicitRules":"uri","EnrollmentRequest.insurer":"Reference","EnrollmentRequest.language":"code","EnrollmentRequest.meta":"Meta","EnrollmentRequest.modifierExtension":"Extension","EnrollmentRequest.organization":"Reference","EnrollmentRequest.provider":"Reference","EnrollmentRequest.status":"code","EnrollmentRequest.subject":"Reference","EnrollmentRequest.text":"Narrative","EnrollmentResponse.contained":"Resource","EnrollmentResponse.created":"dateTime","EnrollmentResponse.disposition":"string","EnrollmentResponse.extension":"Extension","EnrollmentResponse.id":"id","EnrollmentResponse.identifier":"Identifier","EnrollmentResponse.implicitRules":"uri","EnrollmentResponse.language":"code","EnrollmentResponse.meta":"Meta","EnrollmentResponse.modifierExtension":"Extension","EnrollmentResponse.organization":"Reference","EnrollmentResponse.outcome":"CodeableConcept","EnrollmentResponse.request":"Reference","EnrollmentResponse.requestOrganization":"Reference","EnrollmentResponse.requestProvider":"Reference","EnrollmentResponse.status":"code","EnrollmentResponse.text":"Narrative","EpisodeOfCare.account":"Reference","EpisodeOfCare.careManager":"Reference","EpisodeOfCare.contained":"Resource","EpisodeOfCare.diagnosis":"BackboneElement","EpisodeOfCare.diagnosis.condition":"Reference","EpisodeOfCare.diagnosis.extension":"Extension","EpisodeOfCare.diagnosis.id":"string","EpisodeOfCare.diagnosis.modifierExtension":"Extension","EpisodeOfCare.diagnosis.rank":"positiveInt","EpisodeOfCare.diagnosis.role":"CodeableConcept","EpisodeOfCare.extension":"Extension","EpisodeOfCare.id":"id","EpisodeOfCare.identifier":"Identifier","EpisodeOfCare.implicitRules":"uri","EpisodeOfCare.language":"code","EpisodeOfCare.managingOrganization":"Reference","EpisodeOfCare.meta":"Meta","EpisodeOfCare.modifierExtension":"Extension","EpisodeOfCare.patient":"Reference","EpisodeOfCare.period":"Period","EpisodeOfCare.referralRequest":"Reference","EpisodeOfCare.status":"code","EpisodeOfCare.statusHistory":"BackboneElement","EpisodeOfCare.statusHistory.extension":"Extension","EpisodeOfCare.statusHistory.id":"string","EpisodeOfCare.statusHistory.modifierExtension":"Extension","EpisodeOfCare.statusHistory.period":"Period","EpisodeOfCare.statusHistory.status":"code","EpisodeOfCare.team":"Reference","EpisodeOfCare.text":"Narrative","EpisodeOfCare.type":"CodeableConcept","ExpansionProfile.activeOnly":"boolean","ExpansionProfile.contact":"ContactDetail","ExpansionProfile.contained":"Resource","ExpansionProfile.date":"dateTime","ExpansionProfile.description":"markdown","ExpansionProfile.designation":"BackboneElement","ExpansionProfile.designation.exclude":"BackboneElement","ExpansionProfile.designation.exclude.designation":"BackboneElement","ExpansionProfile.designation.exclude.designation.extension":"Extension","ExpansionProfile.designation.exclude.designation.id":"string","ExpansionProfile.designation.exclude.designation.language":"code","ExpansionProfile.designation.exclude.designation.modifierExtension":"Extension","ExpansionProfile.designation.exclude.designation.use":"Coding","ExpansionProfile.designation.exclude.extension":"Extension","ExpansionProfile.designation.exclude.id":"string","ExpansionProfile.designation.exclude.modifierExtension":"Extension","ExpansionProfile.designation.extension":"Extension","ExpansionProfile.designation.id":"string","ExpansionProfile.designation.include":"BackboneElement","ExpansionProfile.designation.include.designation":"BackboneElement","ExpansionProfile.designation.include.designation.extension":"Extension","ExpansionProfile.designation.include.designation.id":"string","ExpansionProfile.designation.include.designation.language":"code","ExpansionProfile.designation.include.designation.modifierExtension":"Extension","ExpansionProfile.designation.include.designation.use":"Coding","ExpansionProfile.designation.include.extension":"Extension","ExpansionProfile.designation.include.id":"string","ExpansionProfile.designation.include.modifierExtension":"Extension","ExpansionProfile.designation.modifierExtension":"Extension","ExpansionProfile.displayLanguage":"code","ExpansionProfile.excludeNested":"boolean","ExpansionProfile.excludeNotForUI":"boolean","ExpansionProfile.excludePostCoordinated":"boolean","ExpansionProfile.excludedSystem":"BackboneElement","ExpansionProfile.excludedSystem.extension":"Extension","ExpansionProfile.excludedSystem.id":"string","ExpansionProfile.excludedSystem.modifierExtension":"Extension","ExpansionProfile.excludedSystem.system":"uri","ExpansionProfile.excludedSystem.version":"string","ExpansionProfile.experimental":"boolean","ExpansionProfile.extension":"Extension","ExpansionProfile.fixedVersion":"BackboneElement","ExpansionProfile.fixedVersion.extension":"Extension","ExpansionProfile.fixedVersion.id":"string","ExpansionProfile.fixedVersion.mode":"code","ExpansionProfile.fixedVersion.modifierExtension":"Extension","ExpansionProfile.fixedVersion.system":"uri","ExpansionProfile.fixedVersion.version":"string","ExpansionProfile.id":"id","ExpansionProfile.identifier":"Identifier","ExpansionProfile.implicitRules":"uri","ExpansionProfile.includeDefinition":"boolean","ExpansionProfile.includeDesignations":"boolean","ExpansionProfile.jurisdiction":"CodeableConcept","ExpansionProfile.language":"code","ExpansionProfile.limitedExpansion":"boolean","ExpansionProfile.meta":"Meta","ExpansionProfile.modifierExtension":"Extension","ExpansionProfile.name":"string","ExpansionProfile.publisher":"string","ExpansionProfile.status":"code","ExpansionProfile.text":"Narrative","ExpansionProfile.url":"uri","ExpansionProfile.useContext":"UsageContext","ExpansionProfile.version":"string","ExplanationOfBenefit.accident":"BackboneElement","ExplanationOfBenefit.accident.date":"date","ExplanationOfBenefit.accident.extension":"Extension","ExplanationOfBenefit.accident.id":"string","ExplanationOfBenefit.accident.locationAddress":"Address","ExplanationOfBenefit.accident.locationReference":"Reference","ExplanationOfBenefit.accident.modifierExtension":"Extension","ExplanationOfBenefit.accident.type":"CodeableConcept","ExplanationOfBenefit.addItem":"BackboneElement","ExplanationOfBenefit.addItem.category":"CodeableConcept","ExplanationOfBenefit.addItem.detail":"BackboneElement","ExplanationOfBenefit.addItem.detail.category":"CodeableConcept","ExplanationOfBenefit.addItem.detail.extension":"Extension","ExplanationOfBenefit.addItem.detail.fee":"Money","ExplanationOfBenefit.addItem.detail.id":"string","ExplanationOfBenefit.addItem.detail.modifier":"CodeableConcept","ExplanationOfBenefit.addItem.detail.modifierExtension":"Extension","ExplanationOfBenefit.addItem.detail.noteNumber":"positiveInt","ExplanationOfBenefit.addItem.detail.revenue":"CodeableConcept","ExplanationOfBenefit.addItem.detail.service":"CodeableConcept","ExplanationOfBenefit.addItem.extension":"Extension","ExplanationOfBenefit.addItem.fee":"Money","ExplanationOfBenefit.addItem.id":"string","ExplanationOfBenefit.addItem.modifier":"CodeableConcept","ExplanationOfBenefit.addItem.modifierExtension":"Extension","ExplanationOfBenefit.addItem.noteNumber":"positiveInt","ExplanationOfBenefit.addItem.revenue":"CodeableConcept","ExplanationOfBenefit.addItem.sequenceLinkId":"positiveInt","ExplanationOfBenefit.addItem.service":"CodeableConcept","ExplanationOfBenefit.benefitBalance":"BackboneElement","ExplanationOfBenefit.benefitBalance.category":"CodeableConcept","ExplanationOfBenefit.benefitBalance.description":"string","ExplanationOfBenefit.benefitBalance.excluded":"boolean","ExplanationOfBenefit.benefitBalance.extension":"Extension","ExplanationOfBenefit.benefitBalance.financial":"BackboneElement","ExplanationOfBenefit.benefitBalance.financial.allowedMoney":"Money","ExplanationOfBenefit.benefitBalance.financial.allowedString":"string","ExplanationOfBenefit.benefitBalance.financial.allowedUnsignedInt":"unsignedInt","ExplanationOfBenefit.benefitBalance.financial.extension":"Extension","ExplanationOfBenefit.benefitBalance.financial.id":"string","ExplanationOfBenefit.benefitBalance.financial.modifierExtension":"Extension","ExplanationOfBenefit.benefitBalance.financial.type":"CodeableConcept","ExplanationOfBenefit.benefitBalance.financial.usedMoney":"Money","ExplanationOfBenefit.benefitBalance.financial.usedUnsignedInt":"unsignedInt","ExplanationOfBenefit.benefitBalance.id":"string","ExplanationOfBenefit.benefitBalance.modifierExtension":"Extension","ExplanationOfBenefit.benefitBalance.name":"string","ExplanationOfBenefit.benefitBalance.network":"CodeableConcept","ExplanationOfBenefit.benefitBalance.subCategory":"CodeableConcept","ExplanationOfBenefit.benefitBalance.term":"CodeableConcept","ExplanationOfBenefit.benefitBalance.unit":"CodeableConcept","ExplanationOfBenefit.billablePeriod":"Period","ExplanationOfBenefit.careTeam":"BackboneElement","ExplanationOfBenefit.careTeam.extension":"Extension","ExplanationOfBenefit.careTeam.id":"string","ExplanationOfBenefit.careTeam.modifierExtension":"Extension","ExplanationOfBenefit.careTeam.provider":"Reference","ExplanationOfBenefit.careTeam.qualification":"CodeableConcept","ExplanationOfBenefit.careTeam.responsible":"boolean","ExplanationOfBenefit.careTeam.role":"CodeableConcept","ExplanationOfBenefit.careTeam.sequence":"positiveInt","ExplanationOfBenefit.claim":"Reference","ExplanationOfBenefit.claimResponse":"Reference","ExplanationOfBenefit.contained":"Resource","ExplanationOfBenefit.created":"dateTime","ExplanationOfBenefit.diagnosis":"BackboneElement","ExplanationOfBenefit.diagnosis.diagnosisCodeableConcept":"CodeableConcept","ExplanationOfBenefit.diagnosis.diagnosisReference":"Reference","ExplanationOfBenefit.diagnosis.extension":"Extension","ExplanationOfBenefit.diagnosis.id":"string","ExplanationOfBenefit.diagnosis.modifierExtension":"Extension","ExplanationOfBenefit.diagnosis.packageCode":"CodeableConcept","ExplanationOfBenefit.diagnosis.sequence":"positiveInt","ExplanationOfBenefit.diagnosis.type":"CodeableConcept","ExplanationOfBenefit.disposition":"string","ExplanationOfBenefit.employmentImpacted":"Period","ExplanationOfBenefit.enterer":"Reference","ExplanationOfBenefit.extension":"Extension","ExplanationOfBenefit.facility":"Reference","ExplanationOfBenefit.form":"CodeableConcept","ExplanationOfBenefit.hospitalization":"Period","ExplanationOfBenefit.id":"id","ExplanationOfBenefit.identifier":"Identifier","ExplanationOfBenefit.implicitRules":"uri","ExplanationOfBenefit.information":"BackboneElement","ExplanationOfBenefit.information.category":"CodeableConcept","ExplanationOfBenefit.information.code":"CodeableConcept","ExplanationOfBenefit.information.extension":"Extension","ExplanationOfBenefit.information.id":"string","ExplanationOfBenefit.information.modifierExtension":"Extension","ExplanationOfBenefit.information.reason":"Coding","ExplanationOfBenefit.information.sequence":"positiveInt","ExplanationOfBenefit.information.timingDate":"date","ExplanationOfBenefit.information.timingPeriod":"Period","ExplanationOfBenefit.information.valueAttachment":"Attachment","ExplanationOfBenefit.information.valueQuantity":"Quantity","ExplanationOfBenefit.information.valueReference":"Reference","ExplanationOfBenefit.information.valueString":"string","ExplanationOfBenefit.insurance":"BackboneElement","ExplanationOfBenefit.insurance.coverage":"Reference","ExplanationOfBenefit.insurance.extension":"Extension","ExplanationOfBenefit.insurance.id":"string","ExplanationOfBenefit.insurance.modifierExtension":"Extension","ExplanationOfBenefit.insurance.preAuthRef":"string","ExplanationOfBenefit.insurer":"Reference","ExplanationOfBenefit.item":"BackboneElement","ExplanationOfBenefit.item.adjudication":"BackboneElement","ExplanationOfBenefit.item.adjudication.amount":"Money","ExplanationOfBenefit.item.adjudication.category":"CodeableConcept","ExplanationOfBenefit.item.adjudication.extension":"Extension","ExplanationOfBenefit.item.adjudication.id":"string","ExplanationOfBenefit.item.adjudication.modifierExtension":"Extension","ExplanationOfBenefit.item.adjudication.reason":"CodeableConcept","ExplanationOfBenefit.item.adjudication.value":"decimal","ExplanationOfBenefit.item.bodySite":"CodeableConcept","ExplanationOfBenefit.item.careTeamLinkId":"positiveInt","ExplanationOfBenefit.item.category":"CodeableConcept","ExplanationOfBenefit.item.detail":"BackboneElement","ExplanationOfBenefit.item.detail.category":"CodeableConcept","ExplanationOfBenefit.item.detail.extension":"Extension","ExplanationOfBenefit.item.detail.factor":"decimal","ExplanationOfBenefit.item.detail.id":"string","ExplanationOfBenefit.item.detail.modifier":"CodeableConcept","ExplanationOfBenefit.item.detail.modifierExtension":"Extension","ExplanationOfBenefit.item.detail.net":"Money","ExplanationOfBenefit.item.detail.noteNumber":"positiveInt","ExplanationOfBenefit.item.detail.programCode":"CodeableConcept","ExplanationOfBenefit.item.detail.quantity":"Quantity","ExplanationOfBenefit.item.detail.revenue":"CodeableConcept","ExplanationOfBenefit.item.detail.sequence":"positiveInt","ExplanationOfBenefit.item.detail.service":"CodeableConcept","ExplanationOfBenefit.item.detail.subDetail":"BackboneElement","ExplanationOfBenefit.item.detail.subDetail.category":"CodeableConcept","ExplanationOfBenefit.item.detail.subDetail.extension":"Extension","ExplanationOfBenefit.item.detail.subDetail.factor":"decimal","ExplanationOfBenefit.item.detail.subDetail.id":"string","ExplanationOfBenefit.item.detail.subDetail.modifier":"CodeableConcept","ExplanationOfBenefit.item.detail.subDetail.modifierExtension":"Extension","ExplanationOfBenefit.item.detail.subDetail.net":"Money","ExplanationOfBenefit.item.detail.subDetail.noteNumber":"positiveInt","ExplanationOfBenefit.item.detail.subDetail.programCode":"CodeableConcept","ExplanationOfBenefit.item.detail.subDetail.quantity":"Quantity","ExplanationOfBenefit.item.detail.subDetail.revenue":"CodeableConcept","ExplanationOfBenefit.item.detail.subDetail.sequence":"positiveInt","ExplanationOfBenefit.item.detail.subDetail.service":"CodeableConcept","ExplanationOfBenefit.item.detail.subDetail.type":"CodeableConcept","ExplanationOfBenefit.item.detail.subDetail.udi":"Reference","ExplanationOfBenefit.item.detail.subDetail.unitPrice":"Money","ExplanationOfBenefit.item.detail.type":"CodeableConcept","ExplanationOfBenefit.item.detail.udi":"Reference","ExplanationOfBenefit.item.detail.unitPrice":"Money","ExplanationOfBenefit.item.diagnosisLinkId":"positiveInt","ExplanationOfBenefit.item.encounter":"Reference","ExplanationOfBenefit.item.extension":"Extension","ExplanationOfBenefit.item.factor":"decimal","ExplanationOfBenefit.item.id":"string","ExplanationOfBenefit.item.informationLinkId":"positiveInt","ExplanationOfBenefit.item.locationAddress":"Address","ExplanationOfBenefit.item.locationCodeableConcept":"CodeableConcept","ExplanationOfBenefit.item.locationReference":"Reference","ExplanationOfBenefit.item.modifier":"CodeableConcept","ExplanationOfBenefit.item.modifierExtension":"Extension","ExplanationOfBenefit.item.net":"Money","ExplanationOfBenefit.item.noteNumber":"positiveInt","ExplanationOfBenefit.item.procedureLinkId":"positiveInt","ExplanationOfBenefit.item.programCode":"CodeableConcept","ExplanationOfBenefit.item.quantity":"Quantity","ExplanationOfBenefit.item.revenue":"CodeableConcept","ExplanationOfBenefit.item.sequence":"positiveInt","ExplanationOfBenefit.item.service":"CodeableConcept","ExplanationOfBenefit.item.servicedDate":"date","ExplanationOfBenefit.item.servicedPeriod":"Period","ExplanationOfBenefit.item.subSite":"CodeableConcept","ExplanationOfBenefit.item.udi":"Reference","ExplanationOfBenefit.item.unitPrice":"Money","ExplanationOfBenefit.language":"code","ExplanationOfBenefit.meta":"Meta","ExplanationOfBenefit.modifierExtension":"Extension","ExplanationOfBenefit.organization":"Reference","ExplanationOfBenefit.originalPrescription":"Reference","ExplanationOfBenefit.outcome":"CodeableConcept","ExplanationOfBenefit.patient":"Reference","ExplanationOfBenefit.payee":"BackboneElement","ExplanationOfBenefit.payee.extension":"Extension","ExplanationOfBenefit.payee.id":"string","ExplanationOfBenefit.payee.modifierExtension":"Extension","ExplanationOfBenefit.payee.party":"Reference","ExplanationOfBenefit.payee.resourceType":"CodeableConcept","ExplanationOfBenefit.payee.type":"CodeableConcept","ExplanationOfBenefit.payment":"BackboneElement","ExplanationOfBenefit.payment.adjustment":"Money","ExplanationOfBenefit.payment.adjustmentReason":"CodeableConcept","ExplanationOfBenefit.payment.amount":"Money","ExplanationOfBenefit.payment.date":"date","ExplanationOfBenefit.payment.extension":"Extension","ExplanationOfBenefit.payment.id":"string","ExplanationOfBenefit.payment.identifier":"Identifier","ExplanationOfBenefit.payment.modifierExtension":"Extension","ExplanationOfBenefit.payment.type":"CodeableConcept","ExplanationOfBenefit.precedence":"positiveInt","ExplanationOfBenefit.prescription":"Reference","ExplanationOfBenefit.procedure":"BackboneElement","ExplanationOfBenefit.procedure.date":"dateTime","ExplanationOfBenefit.procedure.extension":"Extension","ExplanationOfBenefit.procedure.id":"string","ExplanationOfBenefit.procedure.modifierExtension":"Extension","ExplanationOfBenefit.procedure.procedureCodeableConcept":"CodeableConcept","ExplanationOfBenefit.procedure.procedureReference":"Reference","ExplanationOfBenefit.procedure.sequence":"positiveInt","ExplanationOfBenefit.processNote":"BackboneElement","ExplanationOfBenefit.processNote.extension":"Extension","ExplanationOfBenefit.processNote.id":"string","ExplanationOfBenefit.processNote.language":"CodeableConcept","ExplanationOfBenefit.processNote.modifierExtension":"Extension","ExplanationOfBenefit.processNote.number":"positiveInt","ExplanationOfBenefit.processNote.text":"string","ExplanationOfBenefit.processNote.type":"CodeableConcept","ExplanationOfBenefit.provider":"Reference","ExplanationOfBenefit.referral":"Reference","ExplanationOfBenefit.related":"BackboneElement","ExplanationOfBenefit.related.claim":"Reference","ExplanationOfBenefit.related.extension":"Extension","ExplanationOfBenefit.related.id":"string","ExplanationOfBenefit.related.modifierExtension":"Extension","ExplanationOfBenefit.related.reference":"Identifier","ExplanationOfBenefit.related.relationship":"CodeableConcept","ExplanationOfBenefit.status":"code","ExplanationOfBenefit.subType":"CodeableConcept","ExplanationOfBenefit.text":"Narrative","ExplanationOfBenefit.totalBenefit":"Money","ExplanationOfBenefit.totalCost":"Money","ExplanationOfBenefit.type":"CodeableConcept","ExplanationOfBenefit.unallocDeductable":"Money","Extension.extension":"Extension","Extension.id":"string","Extension.url":"uri","Extension.valueAddress":"Address","Extension.valueAge":"Age","Extension.valueAnnotation":"Annotation","Extension.valueAttachment":"Attachment","Extension.valueBase64Binary":"base64Binary","Extension.valueBoolean":"boolean","Extension.valueCode":"code","Extension.valueCodeableConcept":"CodeableConcept","Extension.valueCoding":"Coding","Extension.valueContactPoint":"ContactPoint","Extension.valueCount":"Count","Extension.valueDate":"date","Extension.valueDateTime":"dateTime","Extension.valueDecimal":"decimal","Extension.valueDistance":"Distance","Extension.valueDuration":"Duration","Extension.valueHumanName":"HumanName","Extension.valueId":"id","Extension.valueIdentifier":"Identifier","Extension.valueInstant":"instant","Extension.valueInteger":"integer","Extension.valueMarkdown":"markdown","Extension.valueMeta":"Meta","Extension.valueMoney":"Money","Extension.valueOid":"oid","Extension.valuePeriod":"Period","Extension.valuePositiveInt":"positiveInt","Extension.valueQuantity":"Quantity","Extension.valueRange":"Range","Extension.valueRatio":"Ratio","Extension.valueReference":"Reference","Extension.valueSampledData":"SampledData","Extension.valueSignature":"Signature","Extension.valueString":"string","Extension.valueTime":"time","Extension.valueTiming":"Timing","Extension.valueUnsignedInt":"unsignedInt","Extension.valueUri":"uri","FamilyMemberHistory.ageAge":"Age","FamilyMemberHistory.ageRange":"Range","FamilyMemberHistory.ageString":"string","FamilyMemberHistory.bornDate":"date","FamilyMemberHistory.bornPeriod":"Period","FamilyMemberHistory.bornString":"string","FamilyMemberHistory.condition":"BackboneElement","FamilyMemberHistory.condition.code":"CodeableConcept","FamilyMemberHistory.condition.extension":"Extension","FamilyMemberHistory.condition.id":"string","FamilyMemberHistory.condition.modifierExtension":"Extension","FamilyMemberHistory.condition.note":"Annotation","FamilyMemberHistory.condition.onsetAge":"Age","FamilyMemberHistory.condition.onsetPeriod":"Period","FamilyMemberHistory.condition.onsetRange":"Range","FamilyMemberHistory.condition.onsetString":"string","FamilyMemberHistory.condition.outcome":"CodeableConcept","FamilyMemberHistory.contained":"Resource","FamilyMemberHistory.date":"dateTime","FamilyMemberHistory.deceasedAge":"Age","FamilyMemberHistory.deceasedBoolean":"boolean","FamilyMemberHistory.deceasedDate":"date","FamilyMemberHistory.deceasedRange":"Range","FamilyMemberHistory.deceasedString":"string","FamilyMemberHistory.definition":"Reference","FamilyMemberHistory.estimatedAge":"boolean","FamilyMemberHistory.extension":"Extension","FamilyMemberHistory.gender":"code","FamilyMemberHistory.id":"id","FamilyMemberHistory.identifier":"Identifier","FamilyMemberHistory.implicitRules":"uri","FamilyMemberHistory.language":"code","FamilyMemberHistory.meta":"Meta","FamilyMemberHistory.modifierExtension":"Extension","FamilyMemberHistory.name":"string","FamilyMemberHistory.notDone":"boolean","FamilyMemberHistory.notDoneReason":"CodeableConcept","FamilyMemberHistory.note":"Annotation","FamilyMemberHistory.patient":"Reference","FamilyMemberHistory.reasonCode":"CodeableConcept","FamilyMemberHistory.reasonReference":"Reference","FamilyMemberHistory.relationship":"CodeableConcept","FamilyMemberHistory.status":"code","FamilyMemberHistory.text":"Narrative","Flag.author":"Reference","Flag.category":"CodeableConcept","Flag.code":"CodeableConcept","Flag.contained":"Resource","Flag.encounter":"Reference","Flag.extension":"Extension","Flag.id":"id","Flag.identifier":"Identifier","Flag.implicitRules":"uri","Flag.language":"code","Flag.meta":"Meta","Flag.modifierExtension":"Extension","Flag.period":"Period","Flag.status":"code","Flag.subject":"Reference","Flag.text":"Narrative","Goal.addresses":"Reference","Goal.category":"CodeableConcept","Goal.contained":"Resource","Goal.description":"CodeableConcept","Goal.expressedBy":"Reference","Goal.extension":"Extension","Goal.id":"id","Goal.identifier":"Identifier","Goal.implicitRules":"uri","Goal.language":"code","Goal.meta":"Meta","Goal.modifierExtension":"Extension","Goal.note":"Annotation","Goal.outcomeCode":"CodeableConcept","Goal.outcomeReference":"Reference","Goal.priority":"CodeableConcept","Goal.startCodeableConcept":"CodeableConcept","Goal.startDate":"date","Goal.status":"code","Goal.statusDate":"date","Goal.statusReason":"string","Goal.subject":"Reference","Goal.target":"BackboneElement","Goal.target.detailCodeableConcept":"CodeableConcept","Goal.target.detailQuantity":"Quantity","Goal.target.detailRange":"Range","Goal.target.dueDate":"date","Goal.target.dueDuration":"Duration","Goal.target.extension":"Extension","Goal.target.id":"string","Goal.target.measure":"CodeableConcept","Goal.target.modifierExtension":"Extension","Goal.text":"Narrative","GraphDefinition.contact":"ContactDetail","GraphDefinition.contained":"Resource","GraphDefinition.date":"dateTime","GraphDefinition.description":"markdown","GraphDefinition.experimental":"boolean","GraphDefinition.extension":"Extension","GraphDefinition.id":"id","GraphDefinition.implicitRules":"uri","GraphDefinition.jurisdiction":"CodeableConcept","GraphDefinition.language":"code","GraphDefinition.link":"BackboneElement","GraphDefinition.link.description":"string","GraphDefinition.link.extension":"Extension","GraphDefinition.link.id":"string","GraphDefinition.link.max":"string","GraphDefinition.link.min":"integer","GraphDefinition.link.modifierExtension":"Extension","GraphDefinition.link.path":"string","GraphDefinition.link.sliceName":"string","GraphDefinition.link.target":"BackboneElement","GraphDefinition.link.target.compartment":"BackboneElement","GraphDefinition.link.target.compartment.code":"code","GraphDefinition.link.target.compartment.description":"string","GraphDefinition.link.target.compartment.expression":"string","GraphDefinition.link.target.compartment.extension":"Extension","GraphDefinition.link.target.compartment.id":"string","GraphDefinition.link.target.compartment.modifierExtension":"Extension","GraphDefinition.link.target.compartment.rule":"code","GraphDefinition.link.target.extension":"Extension","GraphDefinition.link.target.id":"string","GraphDefinition.link.target.modifierExtension":"Extension","GraphDefinition.link.target.profile":"uri","GraphDefinition.link.target.type":"code","GraphDefinition.meta":"Meta","GraphDefinition.modifierExtension":"Extension","GraphDefinition.name":"string","GraphDefinition.profile":"uri","GraphDefinition.publisher":"string","GraphDefinition.purpose":"markdown","GraphDefinition.start":"code","GraphDefinition.status":"code","GraphDefinition.text":"Narrative","GraphDefinition.url":"uri","GraphDefinition.useContext":"UsageContext","GraphDefinition.version":"string","Group.active":"boolean","Group.actual":"boolean","Group.characteristic":"BackboneElement","Group.characteristic.code":"CodeableConcept","Group.characteristic.exclude":"boolean","Group.characteristic.extension":"Extension","Group.characteristic.id":"string","Group.characteristic.modifierExtension":"Extension","Group.characteristic.period":"Period","Group.characteristic.valueBoolean":"boolean","Group.characteristic.valueCodeableConcept":"CodeableConcept","Group.characteristic.valueQuantity":"Quantity","Group.characteristic.valueRange":"Range","Group.code":"CodeableConcept","Group.contained":"Resource","Group.extension":"Extension","Group.id":"id","Group.identifier":"Identifier","Group.implicitRules":"uri","Group.language":"code","Group.member":"BackboneElement","Group.member.entity":"Reference","Group.member.extension":"Extension","Group.member.id":"string","Group.member.inactive":"boolean","Group.member.modifierExtension":"Extension","Group.member.period":"Period","Group.meta":"Meta","Group.modifierExtension":"Extension","Group.name":"string","Group.quantity":"unsignedInt","Group.text":"Narrative","Group.type":"code","GuidanceResponse.contained":"Resource","GuidanceResponse.context":"Reference","GuidanceResponse.dataRequirement":"DataRequirement","GuidanceResponse.evaluationMessage":"Reference","GuidanceResponse.extension":"Extension","GuidanceResponse.id":"id","GuidanceResponse.identifier":"Identifier","GuidanceResponse.implicitRules":"uri","GuidanceResponse.language":"code","GuidanceResponse.meta":"Meta","GuidanceResponse.modifierExtension":"Extension","GuidanceResponse.module":"Reference","GuidanceResponse.note":"Annotation","GuidanceResponse.occurrenceDateTime":"dateTime","GuidanceResponse.outputParameters":"Reference","GuidanceResponse.performer":"Reference","GuidanceResponse.reasonCodeableConcept":"CodeableConcept","GuidanceResponse.reasonReference":"Reference","GuidanceResponse.requestId":"id","GuidanceResponse.result":"Reference","GuidanceResponse.status":"code","GuidanceResponse.subject":"Reference","GuidanceResponse.text":"Narrative","HealthcareService.active":"boolean","HealthcareService.appointmentRequired":"boolean","HealthcareService.availabilityExceptions":"string","HealthcareService.availableTime":"BackboneElement","HealthcareService.availableTime.allDay":"boolean","HealthcareService.availableTime.availableEndTime":"time","HealthcareService.availableTime.availableStartTime":"time","HealthcareService.availableTime.daysOfWeek":"code","HealthcareService.availableTime.extension":"Extension","HealthcareService.availableTime.id":"string","HealthcareService.availableTime.modifierExtension":"Extension","HealthcareService.category":"CodeableConcept","HealthcareService.characteristic":"CodeableConcept","HealthcareService.comment":"string","HealthcareService.contained":"Resource","HealthcareService.coverageArea":"Reference","HealthcareService.eligibility":"CodeableConcept","HealthcareService.eligibilityNote":"string","HealthcareService.endpoint":"Reference","HealthcareService.extension":"Extension","HealthcareService.extraDetails":"string","HealthcareService.id":"id","HealthcareService.identifier":"Identifier","HealthcareService.implicitRules":"uri","HealthcareService.language":"code","HealthcareService.location":"Reference","HealthcareService.meta":"Meta","HealthcareService.modifierExtension":"Extension","HealthcareService.name":"string","HealthcareService.notAvailable":"BackboneElement","HealthcareService.notAvailable.description":"string","HealthcareService.notAvailable.during":"Period","HealthcareService.notAvailable.extension":"Extension","HealthcareService.notAvailable.id":"string","HealthcareService.notAvailable.modifierExtension":"Extension","HealthcareService.photo":"Attachment","HealthcareService.programName":"string","HealthcareService.providedBy":"Reference","HealthcareService.referralMethod":"CodeableConcept","HealthcareService.serviceProvisionCode":"CodeableConcept","HealthcareService.specialty":"CodeableConcept","HealthcareService.telecom":"ContactPoint","HealthcareService.text":"Narrative","HealthcareService.type":"CodeableConcept","HumanName.extension":"Extension","HumanName.family":"string","HumanName.given":"string","HumanName.id":"string","HumanName.period":"Period","HumanName.prefix":"string","HumanName.suffix":"string","HumanName.text":"string","HumanName.use":"code","Identifier.assigner":"Reference","Identifier.extension":"Extension","Identifier.id":"string","Identifier.period":"Period","Identifier.system":"uri","Identifier.type":"CodeableConcept","Identifier.use":"code","Identifier.value":"string","ImagingManifest.author":"Reference","ImagingManifest.authoringTime":"dateTime","ImagingManifest.contained":"Resource","ImagingManifest.description":"string","ImagingManifest.extension":"Extension","ImagingManifest.id":"id","ImagingManifest.identifier":"Identifier","ImagingManifest.implicitRules":"uri","ImagingManifest.language":"code","ImagingManifest.meta":"Meta","ImagingManifest.modifierExtension":"Extension","ImagingManifest.patient":"Reference","ImagingManifest.study":"BackboneElement","ImagingManifest.study.endpoint":"Reference","ImagingManifest.study.extension":"Extension","ImagingManifest.study.id":"string","ImagingManifest.study.imagingStudy":"Reference","ImagingManifest.study.modifierExtension":"Extension","ImagingManifest.study.series":"BackboneElement","ImagingManifest.study.series.endpoint":"Reference","ImagingManifest.study.series.extension":"Extension","ImagingManifest.study.series.id":"string","ImagingManifest.study.series.instance":"BackboneElement","ImagingManifest.study.series.instance.extension":"Extension","ImagingManifest.study.series.instance.id":"string","ImagingManifest.study.series.instance.modifierExtension":"Extension","ImagingManifest.study.series.instance.sopClass":"oid","ImagingManifest.study.series.instance.uid":"oid","ImagingManifest.study.series.modifierExtension":"Extension","ImagingManifest.study.series.uid":"oid","ImagingManifest.study.uid":"oid","ImagingManifest.text":"Narrative","ImagingStudy.accession":"Identifier","ImagingStudy.availability":"code","ImagingStudy.basedOn":"Reference","ImagingStudy.contained":"Resource","ImagingStudy.context":"Reference","ImagingStudy.description":"string","ImagingStudy.endpoint":"Reference","ImagingStudy.extension":"Extension","ImagingStudy.id":"id","ImagingStudy.identifier":"Identifier","ImagingStudy.implicitRules":"uri","ImagingStudy.interpreter":"Reference","ImagingStudy.language":"code","ImagingStudy.meta":"Meta","ImagingStudy.modalityList":"Coding","ImagingStudy.modifierExtension":"Extension","ImagingStudy.numberOfInstances":"unsignedInt","ImagingStudy.numberOfSeries":"unsignedInt","ImagingStudy.patient":"Reference","ImagingStudy.procedureCode":"CodeableConcept","ImagingStudy.procedureReference":"Reference","ImagingStudy.reason":"CodeableConcept","ImagingStudy.referrer":"Reference","ImagingStudy.series":"BackboneElement","ImagingStudy.series.availability":"code","ImagingStudy.series.bodySite":"Coding","ImagingStudy.series.description":"string","ImagingStudy.series.endpoint":"Reference","ImagingStudy.series.extension":"Extension","ImagingStudy.series.id":"string","ImagingStudy.series.instance":"BackboneElement","ImagingStudy.series.instance.extension":"Extension","ImagingStudy.series.instance.id":"string","ImagingStudy.series.instance.modifierExtension":"Extension","ImagingStudy.series.instance.number":"unsignedInt","ImagingStudy.series.instance.sopClass":"oid","ImagingStudy.series.instance.title":"string","ImagingStudy.series.instance.uid":"oid","ImagingStudy.series.laterality":"Coding","ImagingStudy.series.modality":"Coding","ImagingStudy.series.modifierExtension":"Extension","ImagingStudy.series.number":"unsignedInt","ImagingStudy.series.numberOfInstances":"unsignedInt","ImagingStudy.series.performer":"Reference","ImagingStudy.series.started":"dateTime","ImagingStudy.series.uid":"oid","ImagingStudy.started":"dateTime","ImagingStudy.text":"Narrative","ImagingStudy.uid":"oid","Immunization.contained":"Resource","Immunization.date":"dateTime","Immunization.doseQuantity":"Quantity","Immunization.encounter":"Reference","Immunization.expirationDate":"date","Immunization.explanation":"BackboneElement","Immunization.explanation.extension":"Extension","Immunization.explanation.id":"string","Immunization.explanation.modifierExtension":"Extension","Immunization.explanation.reason":"CodeableConcept","Immunization.explanation.reasonNotGiven":"CodeableConcept","Immunization.extension":"Extension","Immunization.id":"id","Immunization.identifier":"Identifier","Immunization.implicitRules":"uri","Immunization.language":"code","Immunization.location":"Reference","Immunization.lotNumber":"string","Immunization.manufacturer":"Reference","Immunization.meta":"Meta","Immunization.modifierExtension":"Extension","Immunization.notGiven":"boolean","Immunization.note":"Annotation","Immunization.patient":"Reference","Immunization.practitioner":"BackboneElement","Immunization.practitioner.actor":"Reference","Immunization.practitioner.extension":"Extension","Immunization.practitioner.id":"string","Immunization.practitioner.modifierExtension":"Extension","Immunization.practitioner.role":"CodeableConcept","Immunization.primarySource":"boolean","Immunization.reaction":"BackboneElement","Immunization.reaction.date":"dateTime","Immunization.reaction.detail":"Reference","Immunization.reaction.extension":"Extension","Immunization.reaction.id":"string","Immunization.reaction.modifierExtension":"Extension","Immunization.reaction.reported":"boolean","Immunization.reportOrigin":"CodeableConcept","Immunization.route":"CodeableConcept","Immunization.site":"CodeableConcept","Immunization.status":"code","Immunization.text":"Narrative","Immunization.vaccinationProtocol":"BackboneElement","Immunization.vaccinationProtocol.authority":"Reference","Immunization.vaccinationProtocol.description":"string","Immunization.vaccinationProtocol.doseSequence":"positiveInt","Immunization.vaccinationProtocol.doseStatus":"CodeableConcept","Immunization.vaccinationProtocol.doseStatusReason":"CodeableConcept","Immunization.vaccinationProtocol.extension":"Extension","Immunization.vaccinationProtocol.id":"string","Immunization.vaccinationProtocol.modifierExtension":"Extension","Immunization.vaccinationProtocol.series":"string","Immunization.vaccinationProtocol.seriesDoses":"positiveInt","Immunization.vaccinationProtocol.targetDisease":"CodeableConcept","Immunization.vaccineCode":"CodeableConcept","ImmunizationRecommendation.contained":"Resource","ImmunizationRecommendation.extension":"Extension","ImmunizationRecommendation.id":"id","ImmunizationRecommendation.identifier":"Identifier","ImmunizationRecommendation.implicitRules":"uri","ImmunizationRecommendation.language":"code","ImmunizationRecommendation.meta":"Meta","ImmunizationRecommendation.modifierExtension":"Extension","ImmunizationRecommendation.patient":"Reference","ImmunizationRecommendation.recommendation":"BackboneElement","ImmunizationRecommendation.recommendation.date":"dateTime","ImmunizationRecommendation.recommendation.dateCriterion":"BackboneElement","ImmunizationRecommendation.recommendation.dateCriterion.code":"CodeableConcept","ImmunizationRecommendation.recommendation.dateCriterion.extension":"Extension","ImmunizationRecommendation.recommendation.dateCriterion.id":"string","ImmunizationRecommendation.recommendation.dateCriterion.modifierExtension":"Extension","ImmunizationRecommendation.recommendation.dateCriterion.value":"dateTime","ImmunizationRecommendation.recommendation.doseNumber":"positiveInt","ImmunizationRecommendation.recommendation.extension":"Extension","ImmunizationRecommendation.recommendation.forecastStatus":"CodeableConcept","ImmunizationRecommendation.recommendation.id":"string","ImmunizationRecommendation.recommendation.modifierExtension":"Extension","ImmunizationRecommendation.recommendation.protocol":"BackboneElement","ImmunizationRecommendation.recommendation.protocol.authority":"Reference","ImmunizationRecommendation.recommendation.protocol.description":"string","ImmunizationRecommendation.recommendation.protocol.doseSequence":"positiveInt","ImmunizationRecommendation.recommendation.protocol.extension":"Extension","ImmunizationRecommendation.recommendation.protocol.id":"string","ImmunizationRecommendation.recommendation.protocol.modifierExtension":"Extension","ImmunizationRecommendation.recommendation.protocol.series":"string","ImmunizationRecommendation.recommendation.supportingImmunization":"Reference","ImmunizationRecommendation.recommendation.supportingPatientInformation":"Reference","ImmunizationRecommendation.recommendation.targetDisease":"CodeableConcept","ImmunizationRecommendation.recommendation.vaccineCode":"CodeableConcept","ImmunizationRecommendation.text":"Narrative","ImplementationGuide.binary":"uri","ImplementationGuide.contact":"ContactDetail","ImplementationGuide.contained":"Resource","ImplementationGuide.copyright":"markdown","ImplementationGuide.date":"dateTime","ImplementationGuide.dependency":"BackboneElement","ImplementationGuide.dependency.extension":"Extension","ImplementationGuide.dependency.id":"string","ImplementationGuide.dependency.modifierExtension":"Extension","ImplementationGuide.dependency.type":"code","ImplementationGuide.dependency.uri":"uri","ImplementationGuide.description":"markdown","ImplementationGuide.experimental":"boolean","ImplementationGuide.extension":"Extension","ImplementationGuide.fhirVersion":"id","ImplementationGuide.global":"BackboneElement","ImplementationGuide.global.extension":"Extension","ImplementationGuide.global.id":"string","ImplementationGuide.global.modifierExtension":"Extension","ImplementationGuide.global.profile":"Reference","ImplementationGuide.global.type":"code","ImplementationGuide.id":"id","ImplementationGuide.implicitRules":"uri","ImplementationGuide.jurisdiction":"CodeableConcept","ImplementationGuide.language":"code","ImplementationGuide.meta":"Meta","ImplementationGuide.modifierExtension":"Extension","ImplementationGuide.name":"string","ImplementationGuide.package":"BackboneElement","ImplementationGuide.package.description":"string","ImplementationGuide.package.extension":"Extension","ImplementationGuide.package.id":"string","ImplementationGuide.package.modifierExtension":"Extension","ImplementationGuide.package.name":"string","ImplementationGuide.package.resource":"BackboneElement","ImplementationGuide.package.resource.acronym":"string","ImplementationGuide.package.resource.description":"string","ImplementationGuide.package.resource.example":"boolean","ImplementationGuide.package.resource.exampleFor":"Reference","ImplementationGuide.package.resource.extension":"Extension","ImplementationGuide.package.resource.id":"string","ImplementationGuide.package.resource.modifierExtension":"Extension","ImplementationGuide.package.resource.name":"string","ImplementationGuide.package.resource.sourceReference":"Reference","ImplementationGuide.package.resource.sourceUri":"uri","ImplementationGuide.page":"BackboneElement","ImplementationGuide.page.extension":"Extension","ImplementationGuide.page.format":"code","ImplementationGuide.page.id":"string","ImplementationGuide.page.kind":"code","ImplementationGuide.page.modifierExtension":"Extension","ImplementationGuide.page.package":"string","ImplementationGuide.page.source":"uri","ImplementationGuide.page.title":"string","ImplementationGuide.page.type":"code","ImplementationGuide.publisher":"string","ImplementationGuide.status":"code","ImplementationGuide.text":"Narrative","ImplementationGuide.url":"uri","ImplementationGuide.useContext":"UsageContext","ImplementationGuide.version":"string","Library.approvalDate":"date","Library.contact":"ContactDetail","Library.contained":"Resource","Library.content":"Attachment","Library.contributor":"Contributor","Library.copyright":"markdown","Library.dataRequirement":"DataRequirement","Library.date":"dateTime","Library.description":"markdown","Library.effectivePeriod":"Period","Library.experimental":"boolean","Library.extension":"Extension","Library.id":"id","Library.identifier":"Identifier","Library.implicitRules":"uri","Library.jurisdiction":"CodeableConcept","Library.language":"code","Library.lastReviewDate":"date","Library.meta":"Meta","Library.modifierExtension":"Extension","Library.name":"string","Library.parameter":"ParameterDefinition","Library.publisher":"string","Library.purpose":"markdown","Library.relatedArtifact":"RelatedArtifact","Library.status":"code","Library.text":"Narrative","Library.title":"string","Library.topic":"CodeableConcept","Library.type":"CodeableConcept","Library.url":"uri","Library.usage":"string","Library.useContext":"UsageContext","Library.version":"string","Linkage.active":"boolean","Linkage.author":"Reference","Linkage.contained":"Resource","Linkage.extension":"Extension","Linkage.id":"id","Linkage.implicitRules":"uri","Linkage.item":"BackboneElement","Linkage.item.extension":"Extension","Linkage.item.id":"string","Linkage.item.modifierExtension":"Extension","Linkage.item.resource":"Reference","Linkage.item.type":"code","Linkage.language":"code","Linkage.meta":"Meta","Linkage.modifierExtension":"Extension","Linkage.text":"Narrative","List.code":"CodeableConcept","List.contained":"Resource","List.date":"dateTime","List.emptyReason":"CodeableConcept","List.encounter":"Reference","List.entry":"BackboneElement","List.entry.date":"dateTime","List.entry.deleted":"boolean","List.entry.extension":"Extension","List.entry.flag":"CodeableConcept","List.entry.id":"string","List.entry.item":"Reference","List.entry.modifierExtension":"Extension","List.extension":"Extension","List.id":"id","List.identifier":"Identifier","List.implicitRules":"uri","List.language":"code","List.meta":"Meta","List.mode":"code","List.modifierExtension":"Extension","List.note":"Annotation","List.orderedBy":"CodeableConcept","List.source":"Reference","List.status":"code","List.subject":"Reference","List.text":"Narrative","List.title":"string","Location.address":"Address","Location.alias":"string","Location.contained":"Resource","Location.description":"string","Location.endpoint":"Reference","Location.extension":"Extension","Location.id":"id","Location.identifier":"Identifier","Location.implicitRules":"uri","Location.language":"code","Location.managingOrganization":"Reference","Location.meta":"Meta","Location.mode":"code","Location.modifierExtension":"Extension","Location.name":"string","Location.operationalStatus":"Coding","Location.partOf":"Reference","Location.physicalType":"CodeableConcept","Location.position":"BackboneElement","Location.position.altitude":"decimal","Location.position.extension":"Extension","Location.position.id":"string","Location.position.latitude":"decimal","Location.position.longitude":"decimal","Location.position.modifierExtension":"Extension","Location.status":"code","Location.telecom":"ContactPoint","Location.text":"Narrative","Location.type":"CodeableConcept","Measure.approvalDate":"date","Measure.clinicalRecommendationStatement":"markdown","Measure.compositeScoring":"CodeableConcept","Measure.contact":"ContactDetail","Measure.contained":"Resource","Measure.contributor":"Contributor","Measure.copyright":"markdown","Measure.date":"dateTime","Measure.definition":"markdown","Measure.description":"markdown","Measure.disclaimer":"markdown","Measure.effectivePeriod":"Period","Measure.experimental":"boolean","Measure.extension":"Extension","Measure.group":"BackboneElement","Measure.group.description":"string","Measure.group.extension":"Extension","Measure.group.id":"string","Measure.group.identifier":"Identifier","Measure.group.modifierExtension":"Extension","Measure.group.name":"string","Measure.group.population":"BackboneElement","Measure.group.population.code":"CodeableConcept","Measure.group.population.criteria":"string","Measure.group.population.description":"string","Measure.group.population.extension":"Extension","Measure.group.population.id":"string","Measure.group.population.identifier":"Identifier","Measure.group.population.modifierExtension":"Extension","Measure.group.population.name":"string","Measure.group.stratifier":"BackboneElement","Measure.group.stratifier.criteria":"string","Measure.group.stratifier.extension":"Extension","Measure.group.stratifier.id":"string","Measure.group.stratifier.identifier":"Identifier","Measure.group.stratifier.modifierExtension":"Extension","Measure.group.stratifier.path":"string","Measure.guidance":"markdown","Measure.id":"id","Measure.identifier":"Identifier","Measure.implicitRules":"uri","Measure.improvementNotation":"string","Measure.jurisdiction":"CodeableConcept","Measure.language":"code","Measure.lastReviewDate":"date","Measure.library":"Reference","Measure.meta":"Meta","Measure.modifierExtension":"Extension","Measure.name":"string","Measure.publisher":"string","Measure.purpose":"markdown","Measure.rateAggregation":"string","Measure.rationale":"markdown","Measure.relatedArtifact":"RelatedArtifact","Measure.riskAdjustment":"string","Measure.scoring":"CodeableConcept","Measure.set":"string","Measure.status":"code","Measure.supplementalData":"BackboneElement","Measure.supplementalData.criteria":"string","Measure.supplementalData.extension":"Extension","Measure.supplementalData.id":"string","Measure.supplementalData.identifier":"Identifier","Measure.supplementalData.modifierExtension":"Extension","Measure.supplementalData.path":"string","Measure.supplementalData.usage":"CodeableConcept","Measure.text":"Narrative","Measure.title":"string","Measure.topic":"CodeableConcept","Measure.type":"CodeableConcept","Measure.url":"uri","Measure.usage":"string","Measure.useContext":"UsageContext","Measure.version":"string","MeasureReport.contained":"Resource","MeasureReport.date":"dateTime","MeasureReport.evaluatedResources":"Reference","MeasureReport.extension":"Extension","MeasureReport.group":"BackboneElement","MeasureReport.group.extension":"Extension","MeasureReport.group.id":"string","MeasureReport.group.identifier":"Identifier","MeasureReport.group.measureScore":"decimal","MeasureReport.group.modifierExtension":"Extension","MeasureReport.group.population":"BackboneElement","MeasureReport.group.population.code":"CodeableConcept","MeasureReport.group.population.count":"integer","MeasureReport.group.population.extension":"Extension","MeasureReport.group.population.id":"string","MeasureReport.group.population.identifier":"Identifier","MeasureReport.group.population.modifierExtension":"Extension","MeasureReport.group.population.patients":"Reference","MeasureReport.group.stratifier":"BackboneElement","MeasureReport.group.stratifier.extension":"Extension","MeasureReport.group.stratifier.id":"string","MeasureReport.group.stratifier.identifier":"Identifier","MeasureReport.group.stratifier.modifierExtension":"Extension","MeasureReport.group.stratifier.stratum":"BackboneElement","MeasureReport.group.stratifier.stratum.extension":"Extension","MeasureReport.group.stratifier.stratum.id":"string","MeasureReport.group.stratifier.stratum.measureScore":"decimal","MeasureReport.group.stratifier.stratum.modifierExtension":"Extension","MeasureReport.group.stratifier.stratum.population":"BackboneElement","MeasureReport.group.stratifier.stratum.population.code":"CodeableConcept","MeasureReport.group.stratifier.stratum.population.count":"integer","MeasureReport.group.stratifier.stratum.population.extension":"Extension","MeasureReport.group.stratifier.stratum.population.id":"string","MeasureReport.group.stratifier.stratum.population.identifier":"Identifier","MeasureReport.group.stratifier.stratum.population.modifierExtension":"Extension","MeasureReport.group.stratifier.stratum.population.patients":"Reference","MeasureReport.group.stratifier.stratum.value":"string","MeasureReport.id":"id","MeasureReport.identifier":"Identifier","MeasureReport.implicitRules":"uri","MeasureReport.language":"code","MeasureReport.measure":"Reference","MeasureReport.meta":"Meta","MeasureReport.modifierExtension":"Extension","MeasureReport.patient":"Reference","MeasureReport.period":"Period","MeasureReport.reportingOrganization":"Reference","MeasureReport.status":"code","MeasureReport.text":"Narrative","MeasureReport.type":"code","Media.basedOn":"Reference","Media.bodySite":"CodeableConcept","Media.contained":"Resource","Media.content":"Attachment","Media.context":"Reference","Media.device":"Reference","Media.duration":"unsignedInt","Media.extension":"Extension","Media.frames":"positiveInt","Media.height":"positiveInt","Media.id":"id","Media.identifier":"Identifier","Media.implicitRules":"uri","Media.language":"code","Media.meta":"Meta","Media.modifierExtension":"Extension","Media.note":"Annotation","Media.occurrenceDateTime":"dateTime","Media.occurrencePeriod":"Period","Media.operator":"Reference","Media.reasonCode":"CodeableConcept","Media.subject":"Reference","Media.subtype":"CodeableConcept","Media.text":"Narrative","Media.type":"code","Media.view":"CodeableConcept","Media.width":"positiveInt","Medication.code":"CodeableConcept","Medication.contained":"Resource","Medication.extension":"Extension","Medication.form":"CodeableConcept","Medication.id":"id","Medication.image":"Attachment","Medication.implicitRules":"uri","Medication.ingredient":"BackboneElement","Medication.ingredient.amount":"Ratio","Medication.ingredient.extension":"Extension","Medication.ingredient.id":"string","Medication.ingredient.isActive":"boolean","Medication.ingredient.itemCodeableConcept":"CodeableConcept","Medication.ingredient.itemReference":"Reference","Medication.ingredient.modifierExtension":"Extension","Medication.isBrand":"boolean","Medication.isOverTheCounter":"boolean","Medication.language":"code","Medication.manufacturer":"Reference","Medication.meta":"Meta","Medication.modifierExtension":"Extension","Medication.package":"BackboneElement","Medication.package.batch":"BackboneElement","Medication.package.batch.expirationDate":"dateTime","Medication.package.batch.extension":"Extension","Medication.package.batch.id":"string","Medication.package.batch.lotNumber":"string","Medication.package.batch.modifierExtension":"Extension","Medication.package.container":"CodeableConcept","Medication.package.content":"BackboneElement","Medication.package.content.amount":"Quantity","Medication.package.content.extension":"Extension","Medication.package.content.id":"string","Medication.package.content.itemCodeableConcept":"CodeableConcept","Medication.package.content.itemReference":"Reference","Medication.package.content.modifierExtension":"Extension","Medication.package.extension":"Extension","Medication.package.id":"string","Medication.package.modifierExtension":"Extension","Medication.status":"code","Medication.text":"Narrative","MedicationAdministration.category":"CodeableConcept","MedicationAdministration.contained":"Resource","MedicationAdministration.context":"Reference","MedicationAdministration.definition":"Reference","MedicationAdministration.device":"Reference","MedicationAdministration.dosage":"BackboneElement","MedicationAdministration.dosage.dose":"Quantity","MedicationAdministration.dosage.extension":"Extension","MedicationAdministration.dosage.id":"string","MedicationAdministration.dosage.method":"CodeableConcept","MedicationAdministration.dosage.modifierExtension":"Extension","MedicationAdministration.dosage.rateQuantity":"Quantity","MedicationAdministration.dosage.rateRatio":"Ratio","MedicationAdministration.dosage.route":"CodeableConcept","MedicationAdministration.dosage.site":"CodeableConcept","MedicationAdministration.dosage.text":"string","MedicationAdministration.effectiveDateTime":"dateTime","MedicationAdministration.effectivePeriod":"Period","MedicationAdministration.eventHistory":"Reference","MedicationAdministration.extension":"Extension","MedicationAdministration.id":"id","MedicationAdministration.identifier":"Identifier","MedicationAdministration.implicitRules":"uri","MedicationAdministration.language":"code","MedicationAdministration.medicationCodeableConcept":"CodeableConcept","MedicationAdministration.medicationReference":"Reference","MedicationAdministration.meta":"Meta","MedicationAdministration.modifierExtension":"Extension","MedicationAdministration.notGiven":"boolean","MedicationAdministration.note":"Annotation","MedicationAdministration.partOf":"Reference","MedicationAdministration.performer":"BackboneElement","MedicationAdministration.performer.actor":"Reference","MedicationAdministration.performer.extension":"Extension","MedicationAdministration.performer.id":"string","MedicationAdministration.performer.modifierExtension":"Extension","MedicationAdministration.performer.onBehalfOf":"Reference","MedicationAdministration.prescription":"Reference","MedicationAdministration.reasonCode":"CodeableConcept","MedicationAdministration.reasonNotGiven":"CodeableConcept","MedicationAdministration.reasonReference":"Reference","MedicationAdministration.status":"code","MedicationAdministration.subject":"Reference","MedicationAdministration.supportingInformation":"Reference","MedicationAdministration.text":"Narrative","MedicationDispense.authorizingPrescription":"Reference","MedicationDispense.category":"CodeableConcept","MedicationDispense.contained":"Resource","MedicationDispense.context":"Reference","MedicationDispense.daysSupply":"Quantity","MedicationDispense.destination":"Reference","MedicationDispense.detectedIssue":"Reference","MedicationDispense.dosageInstruction":"Dosage","MedicationDispense.eventHistory":"Reference","MedicationDispense.extension":"Extension","MedicationDispense.id":"id","MedicationDispense.identifier":"Identifier","MedicationDispense.implicitRules":"uri","MedicationDispense.language":"code","MedicationDispense.medicationCodeableConcept":"CodeableConcept","MedicationDispense.medicationReference":"Reference","MedicationDispense.meta":"Meta","MedicationDispense.modifierExtension":"Extension","MedicationDispense.notDone":"boolean","MedicationDispense.notDoneReasonCodeableConcept":"CodeableConcept","MedicationDispense.notDoneReasonReference":"Reference","MedicationDispense.note":"Annotation","MedicationDispense.partOf":"Reference","MedicationDispense.performer":"BackboneElement","MedicationDispense.performer.actor":"Reference","MedicationDispense.performer.extension":"Extension","MedicationDispense.performer.id":"string","MedicationDispense.performer.modifierExtension":"Extension","MedicationDispense.performer.onBehalfOf":"Reference","MedicationDispense.quantity":"Quantity","MedicationDispense.receiver":"Reference","MedicationDispense.status":"code","MedicationDispense.subject":"Reference","MedicationDispense.substitution":"BackboneElement","MedicationDispense.substitution.extension":"Extension","MedicationDispense.substitution.id":"string","MedicationDispense.substitution.modifierExtension":"Extension","MedicationDispense.substitution.reason":"CodeableConcept","MedicationDispense.substitution.responsibleParty":"Reference","MedicationDispense.substitution.type":"CodeableConcept","MedicationDispense.substitution.wasSubstituted":"boolean","MedicationDispense.supportingInformation":"Reference","MedicationDispense.text":"Narrative","MedicationDispense.type":"CodeableConcept","MedicationDispense.whenHandedOver":"dateTime","MedicationDispense.whenPrepared":"dateTime","MedicationRequest.authoredOn":"dateTime","MedicationRequest.basedOn":"Reference","MedicationRequest.category":"CodeableConcept","MedicationRequest.contained":"Resource","MedicationRequest.context":"Reference","MedicationRequest.definition":"Reference","MedicationRequest.detectedIssue":"Reference","MedicationRequest.dispenseRequest":"BackboneElement","MedicationRequest.dispenseRequest.expectedSupplyDuration":"Duration","MedicationRequest.dispenseRequest.extension":"Extension","MedicationRequest.dispenseRequest.id":"string","MedicationRequest.dispenseRequest.modifierExtension":"Extension","MedicationRequest.dispenseRequest.numberOfRepeatsAllowed":"positiveInt","MedicationRequest.dispenseRequest.performer":"Reference","MedicationRequest.dispenseRequest.quantity":"Quantity","MedicationRequest.dispenseRequest.validityPeriod":"Period","MedicationRequest.dosageInstruction":"Dosage","MedicationRequest.eventHistory":"Reference","MedicationRequest.extension":"Extension","MedicationRequest.groupIdentifier":"Identifier","MedicationRequest.id":"id","MedicationRequest.identifier":"Identifier","MedicationRequest.implicitRules":"uri","MedicationRequest.intent":"code","MedicationRequest.language":"code","MedicationRequest.medicationCodeableConcept":"CodeableConcept","MedicationRequest.medicationReference":"Reference","MedicationRequest.meta":"Meta","MedicationRequest.modifierExtension":"Extension","MedicationRequest.note":"Annotation","MedicationRequest.priorPrescription":"Reference","MedicationRequest.priority":"code","MedicationRequest.reasonCode":"CodeableConcept","MedicationRequest.reasonReference":"Reference","MedicationRequest.recorder":"Reference","MedicationRequest.requester":"BackboneElement","MedicationRequest.requester.agent":"Reference","MedicationRequest.requester.extension":"Extension","MedicationRequest.requester.id":"string","MedicationRequest.requester.modifierExtension":"Extension","MedicationRequest.requester.onBehalfOf":"Reference","MedicationRequest.status":"code","MedicationRequest.subject":"Reference","MedicationRequest.substitution":"BackboneElement","MedicationRequest.substitution.allowed":"boolean","MedicationRequest.substitution.extension":"Extension","MedicationRequest.substitution.id":"string","MedicationRequest.substitution.modifierExtension":"Extension","MedicationRequest.substitution.reason":"CodeableConcept","MedicationRequest.supportingInformation":"Reference","MedicationRequest.text":"Narrative","MedicationStatement.basedOn":"Reference","MedicationStatement.category":"CodeableConcept","MedicationStatement.contained":"Resource","MedicationStatement.context":"Reference","MedicationStatement.dateAsserted":"dateTime","MedicationStatement.derivedFrom":"Reference","MedicationStatement.dosage":"Dosage","MedicationStatement.effectiveDateTime":"dateTime","MedicationStatement.effectivePeriod":"Period","MedicationStatement.extension":"Extension","MedicationStatement.id":"id","MedicationStatement.identifier":"Identifier","MedicationStatement.implicitRules":"uri","MedicationStatement.informationSource":"Reference","MedicationStatement.language":"code","MedicationStatement.medicationCodeableConcept":"CodeableConcept","MedicationStatement.medicationReference":"Reference","MedicationStatement.meta":"Meta","MedicationStatement.modifierExtension":"Extension","MedicationStatement.note":"Annotation","MedicationStatement.partOf":"Reference","MedicationStatement.reasonCode":"CodeableConcept","MedicationStatement.reasonNotTaken":"CodeableConcept","MedicationStatement.reasonReference":"Reference","MedicationStatement.status":"code","MedicationStatement.subject":"Reference","MedicationStatement.taken":"code","MedicationStatement.text":"Narrative","MessageDefinition.allowedResponse":"BackboneElement","MessageDefinition.allowedResponse.extension":"Extension","MessageDefinition.allowedResponse.id":"string","MessageDefinition.allowedResponse.message":"Reference","MessageDefinition.allowedResponse.modifierExtension":"Extension","MessageDefinition.allowedResponse.situation":"markdown","MessageDefinition.base":"Reference","MessageDefinition.category":"code","MessageDefinition.contact":"ContactDetail","MessageDefinition.contained":"Resource","MessageDefinition.copyright":"markdown","MessageDefinition.date":"dateTime","MessageDefinition.description":"markdown","MessageDefinition.event":"Coding","MessageDefinition.experimental":"boolean","MessageDefinition.extension":"Extension","MessageDefinition.focus":"BackboneElement","MessageDefinition.focus.code":"code","MessageDefinition.focus.extension":"Extension","MessageDefinition.focus.id":"string","MessageDefinition.focus.max":"string","MessageDefinition.focus.min":"unsignedInt","MessageDefinition.focus.modifierExtension":"Extension","MessageDefinition.focus.profile":"Reference","MessageDefinition.id":"id","MessageDefinition.identifier":"Identifier","MessageDefinition.implicitRules":"uri","MessageDefinition.jurisdiction":"CodeableConcept","MessageDefinition.language":"code","MessageDefinition.meta":"Meta","MessageDefinition.modifierExtension":"Extension","MessageDefinition.name":"string","MessageDefinition.parent":"Reference","MessageDefinition.publisher":"string","MessageDefinition.purpose":"markdown","MessageDefinition.replaces":"Reference","MessageDefinition.responseRequired":"boolean","MessageDefinition.status":"code","MessageDefinition.text":"Narrative","MessageDefinition.title":"string","MessageDefinition.url":"uri","MessageDefinition.useContext":"UsageContext","MessageDefinition.version":"string","MessageHeader.author":"Reference","MessageHeader.contained":"Resource","MessageHeader.destination":"BackboneElement","MessageHeader.destination.endpoint":"uri","MessageHeader.destination.extension":"Extension","MessageHeader.destination.id":"string","MessageHeader.destination.modifierExtension":"Extension","MessageHeader.destination.name":"string","MessageHeader.destination.target":"Reference","MessageHeader.enterer":"Reference","MessageHeader.event":"Coding","MessageHeader.extension":"Extension","MessageHeader.focus":"Reference","MessageHeader.id":"id","MessageHeader.implicitRules":"uri","MessageHeader.language":"code","MessageHeader.meta":"Meta","MessageHeader.modifierExtension":"Extension","MessageHeader.reason":"CodeableConcept","MessageHeader.receiver":"Reference","MessageHeader.response":"BackboneElement","MessageHeader.response.code":"code","MessageHeader.response.details":"Reference","MessageHeader.response.extension":"Extension","MessageHeader.response.id":"string","MessageHeader.response.identifier":"id","MessageHeader.response.modifierExtension":"Extension","MessageHeader.responsible":"Reference","MessageHeader.sender":"Reference","MessageHeader.source":"BackboneElement","MessageHeader.source.contact":"ContactPoint","MessageHeader.source.endpoint":"uri","MessageHeader.source.extension":"Extension","MessageHeader.source.id":"string","MessageHeader.source.modifierExtension":"Extension","MessageHeader.source.name":"string","MessageHeader.source.software":"string","MessageHeader.source.version":"string","MessageHeader.text":"Narrative","MessageHeader.timestamp":"instant","Meta.extension":"Extension","Meta.id":"string","Meta.lastUpdated":"instant","Meta.profile":"uri","Meta.security":"Coding","Meta.tag":"Coding","Meta.versionId":"id","MetadataResource.contact":"ContactDetail","MetadataResource.contained":"Resource","MetadataResource.date":"dateTime","MetadataResource.description":"markdown","MetadataResource.experimental":"boolean","MetadataResource.extension":"Extension","MetadataResource.id":"id","MetadataResource.implicitRules":"uri","MetadataResource.jurisdiction":"CodeableConcept","MetadataResource.language":"code","MetadataResource.meta":"Meta","MetadataResource.modifierExtension":"Extension","MetadataResource.name":"string","MetadataResource.publisher":"string","MetadataResource.status":"code","MetadataResource.text":"Narrative","MetadataResource.title":"string","MetadataResource.url":"uri","MetadataResource.useContext":"UsageContext","MetadataResource.version":"string","Money.code":"code","Money.comparator":"code","Money.extension":"Extension","Money.id":"string","Money.system":"uri","Money.unit":"string","Money.value":"decimal","NamingSystem.contact":"ContactDetail","NamingSystem.contained":"Resource","NamingSystem.date":"dateTime","NamingSystem.description":"markdown","NamingSystem.extension":"Extension","NamingSystem.id":"id","NamingSystem.implicitRules":"uri","NamingSystem.jurisdiction":"CodeableConcept","NamingSystem.kind":"code","NamingSystem.language":"code","NamingSystem.meta":"Meta","NamingSystem.modifierExtension":"Extension","NamingSystem.name":"string","NamingSystem.publisher":"string","NamingSystem.replacedBy":"Reference","NamingSystem.responsible":"string","NamingSystem.status":"code","NamingSystem.text":"Narrative","NamingSystem.type":"CodeableConcept","NamingSystem.uniqueId":"BackboneElement","NamingSystem.uniqueId.comment":"string","NamingSystem.uniqueId.extension":"Extension","NamingSystem.uniqueId.id":"string","NamingSystem.uniqueId.modifierExtension":"Extension","NamingSystem.uniqueId.period":"Period","NamingSystem.uniqueId.preferred":"boolean","NamingSystem.uniqueId.type":"code","NamingSystem.uniqueId.value":"string","NamingSystem.usage":"string","NamingSystem.useContext":"UsageContext","Narrative.div":"xhtml","Narrative.extension":"Extension","Narrative.id":"string","Narrative.status":"code","NutritionOrder.allergyIntolerance":"Reference","NutritionOrder.contained":"Resource","NutritionOrder.dateTime":"dateTime","NutritionOrder.encounter":"Reference","NutritionOrder.enteralFormula":"BackboneElement","NutritionOrder.enteralFormula.additiveProductName":"string","NutritionOrder.enteralFormula.additiveType":"CodeableConcept","NutritionOrder.enteralFormula.administration":"BackboneElement","NutritionOrder.enteralFormula.administration.extension":"Extension","NutritionOrder.enteralFormula.administration.id":"string","NutritionOrder.enteralFormula.administration.modifierExtension":"Extension","NutritionOrder.enteralFormula.administration.quantity":"Quantity","NutritionOrder.enteralFormula.administration.rateQuantity":"Quantity","NutritionOrder.enteralFormula.administration.rateRatio":"Ratio","NutritionOrder.enteralFormula.administration.schedule":"Timing","NutritionOrder.enteralFormula.administrationInstruction":"string","NutritionOrder.enteralFormula.baseFormulaProductName":"string","NutritionOrder.enteralFormula.baseFormulaType":"CodeableConcept","NutritionOrder.enteralFormula.caloricDensity":"Quantity","NutritionOrder.enteralFormula.extension":"Extension","NutritionOrder.enteralFormula.id":"string","NutritionOrder.enteralFormula.maxVolumeToDeliver":"Quantity","NutritionOrder.enteralFormula.modifierExtension":"Extension","NutritionOrder.enteralFormula.routeofAdministration":"CodeableConcept","NutritionOrder.excludeFoodModifier":"CodeableConcept","NutritionOrder.extension":"Extension","NutritionOrder.foodPreferenceModifier":"CodeableConcept","NutritionOrder.id":"id","NutritionOrder.identifier":"Identifier","NutritionOrder.implicitRules":"uri","NutritionOrder.language":"code","NutritionOrder.meta":"Meta","NutritionOrder.modifierExtension":"Extension","NutritionOrder.oralDiet":"BackboneElement","NutritionOrder.oralDiet.extension":"Extension","NutritionOrder.oralDiet.fluidConsistencyType":"CodeableConcept","NutritionOrder.oralDiet.id":"string","NutritionOrder.oralDiet.instruction":"string","NutritionOrder.oralDiet.modifierExtension":"Extension","NutritionOrder.oralDiet.nutrient":"BackboneElement","NutritionOrder.oralDiet.nutrient.amount":"Quantity","NutritionOrder.oralDiet.nutrient.extension":"Extension","NutritionOrder.oralDiet.nutrient.id":"string","NutritionOrder.oralDiet.nutrient.modifier":"CodeableConcept","NutritionOrder.oralDiet.nutrient.modifierExtension":"Extension","NutritionOrder.oralDiet.schedule":"Timing","NutritionOrder.oralDiet.texture":"BackboneElement","NutritionOrder.oralDiet.texture.extension":"Extension","NutritionOrder.oralDiet.texture.foodType":"CodeableConcept","NutritionOrder.oralDiet.texture.id":"string","NutritionOrder.oralDiet.texture.modifier":"CodeableConcept","NutritionOrder.oralDiet.texture.modifierExtension":"Extension","NutritionOrder.oralDiet.type":"CodeableConcept","NutritionOrder.orderer":"Reference","NutritionOrder.patient":"Reference","NutritionOrder.status":"code","NutritionOrder.supplement":"BackboneElement","NutritionOrder.supplement.extension":"Extension","NutritionOrder.supplement.id":"string","NutritionOrder.supplement.instruction":"string","NutritionOrder.supplement.modifierExtension":"Extension","NutritionOrder.supplement.productName":"string","NutritionOrder.supplement.quantity":"Quantity","NutritionOrder.supplement.schedule":"Timing","NutritionOrder.supplement.type":"CodeableConcept","NutritionOrder.text":"Narrative","Observation.basedOn":"Reference","Observation.bodySite":"CodeableConcept","Observation.category":"CodeableConcept","Observation.code":"CodeableConcept","Observation.comment":"string","Observation.component":"BackboneElement","Observation.component.code":"CodeableConcept","Observation.component.dataAbsentReason":"CodeableConcept","Observation.component.extension":"Extension","Observation.component.id":"string","Observation.component.interpretation":"CodeableConcept","Observation.component.modifierExtension":"Extension","Observation.component.valueAttachment":"Attachment","Observation.component.valueCodeableConcept":"CodeableConcept","Observation.component.valueDateTime":"dateTime","Observation.component.valuePeriod":"Period","Observation.component.valueQuantity":"Quantity","Observation.component.valueRange":"Range","Observation.component.valueRatio":"Ratio","Observation.component.valueSampledData":"SampledData","Observation.component.valueString":"string","Observation.component.valueTime":"time","Observation.contained":"Resource","Observation.context":"Reference","Observation.dataAbsentReason":"CodeableConcept","Observation.device":"Reference","Observation.effectiveDateTime":"dateTime","Observation.effectivePeriod":"Period","Observation.extension":"Extension","Observation.id":"id","Observation.identifier":"Identifier","Observation.implicitRules":"uri","Observation.interpretation":"CodeableConcept","Observation.issued":"instant","Observation.language":"code","Observation.meta":"Meta","Observation.method":"CodeableConcept","Observation.modifierExtension":"Extension","Observation.performer":"Reference","Observation.referenceRange":"BackboneElement","Observation.referenceRange.age":"Range","Observation.referenceRange.appliesTo":"CodeableConcept","Observation.referenceRange.extension":"Extension","Observation.referenceRange.high":"Quantity","Observation.referenceRange.id":"string","Observation.referenceRange.low":"Quantity","Observation.referenceRange.modifierExtension":"Extension","Observation.referenceRange.text":"string","Observation.referenceRange.type":"CodeableConcept","Observation.related":"BackboneElement","Observation.related.extension":"Extension","Observation.related.id":"string","Observation.related.modifierExtension":"Extension","Observation.related.target":"Reference","Observation.related.type":"code","Observation.specimen":"Reference","Observation.status":"code","Observation.subject":"Reference","Observation.text":"Narrative","Observation.valueAttachment":"Attachment","Observation.valueBoolean":"boolean","Observation.valueCodeableConcept":"CodeableConcept","Observation.valueDateTime":"dateTime","Observation.valuePeriod":"Period","Observation.valueQuantity":"Quantity","Observation.valueRange":"Range","Observation.valueRatio":"Ratio","Observation.valueSampledData":"SampledData","Observation.valueString":"string","Observation.valueTime":"time","OperationDefinition.base":"Reference","OperationDefinition.code":"code","OperationDefinition.comment":"string","OperationDefinition.contact":"ContactDetail","OperationDefinition.contained":"Resource","OperationDefinition.date":"dateTime","OperationDefinition.description":"markdown","OperationDefinition.experimental":"boolean","OperationDefinition.extension":"Extension","OperationDefinition.id":"id","OperationDefinition.idempotent":"boolean","OperationDefinition.implicitRules":"uri","OperationDefinition.instance":"boolean","OperationDefinition.jurisdiction":"CodeableConcept","OperationDefinition.kind":"code","OperationDefinition.language":"code","OperationDefinition.meta":"Meta","OperationDefinition.modifierExtension":"Extension","OperationDefinition.name":"string","OperationDefinition.overload":"BackboneElement","OperationDefinition.overload.comment":"string","OperationDefinition.overload.extension":"Extension","OperationDefinition.overload.id":"string","OperationDefinition.overload.modifierExtension":"Extension","OperationDefinition.overload.parameterName":"string","OperationDefinition.parameter":"BackboneElement","OperationDefinition.parameter.binding":"BackboneElement","OperationDefinition.parameter.binding.extension":"Extension","OperationDefinition.parameter.binding.id":"string","OperationDefinition.parameter.binding.modifierExtension":"Extension","OperationDefinition.parameter.binding.strength":"code","OperationDefinition.parameter.binding.valueSetReference":"Reference","OperationDefinition.parameter.binding.valueSetUri":"uri","OperationDefinition.parameter.documentation":"string","OperationDefinition.parameter.extension":"Extension","OperationDefinition.parameter.id":"string","OperationDefinition.parameter.max":"string","OperationDefinition.parameter.min":"integer","OperationDefinition.parameter.modifierExtension":"Extension","OperationDefinition.parameter.name":"code","OperationDefinition.parameter.profile":"Reference","OperationDefinition.parameter.searchType":"code","OperationDefinition.parameter.type":"code","OperationDefinition.parameter.use":"code","OperationDefinition.publisher":"string","OperationDefinition.purpose":"markdown","OperationDefinition.resource":"code","OperationDefinition.status":"code","OperationDefinition.system":"boolean","OperationDefinition.text":"Narrative","OperationDefinition.type":"boolean","OperationDefinition.url":"uri","OperationDefinition.useContext":"UsageContext","OperationDefinition.version":"string","OperationOutcome.contained":"Resource","OperationOutcome.extension":"Extension","OperationOutcome.id":"id","OperationOutcome.implicitRules":"uri","OperationOutcome.issue":"BackboneElement","OperationOutcome.issue.code":"code","OperationOutcome.issue.details":"CodeableConcept","OperationOutcome.issue.diagnostics":"string","OperationOutcome.issue.expression":"string","OperationOutcome.issue.extension":"Extension","OperationOutcome.issue.id":"string","OperationOutcome.issue.location":"string","OperationOutcome.issue.modifierExtension":"Extension","OperationOutcome.issue.severity":"code","OperationOutcome.language":"code","OperationOutcome.meta":"Meta","OperationOutcome.modifierExtension":"Extension","OperationOutcome.text":"Narrative","Organization.active":"boolean","Organization.address":"Address","Organization.alias":"string","Organization.contact":"BackboneElement","Organization.contact.address":"Address","Organization.contact.extension":"Extension","Organization.contact.id":"string","Organization.contact.modifierExtension":"Extension","Organization.contact.name":"HumanName","Organization.contact.purpose":"CodeableConcept","Organization.contact.telecom":"ContactPoint","Organization.contained":"Resource","Organization.endpoint":"Reference","Organization.extension":"Extension","Organization.id":"id","Organization.identifier":"Identifier","Organization.implicitRules":"uri","Organization.language":"code","Organization.meta":"Meta","Organization.modifierExtension":"Extension","Organization.name":"string","Organization.partOf":"Reference","Organization.telecom":"ContactPoint","Organization.text":"Narrative","Organization.type":"CodeableConcept","ParameterDefinition.documentation":"string","ParameterDefinition.extension":"Extension","ParameterDefinition.id":"string","ParameterDefinition.max":"string","ParameterDefinition.min":"integer","ParameterDefinition.name":"code","ParameterDefinition.profile":"Reference","ParameterDefinition.type":"code","ParameterDefinition.use":"code","Parameters.id":"id","Parameters.implicitRules":"uri","Parameters.language":"code","Parameters.meta":"Meta","Parameters.parameter":"BackboneElement","Parameters.parameter.extension":"Extension","Parameters.parameter.id":"string","Parameters.parameter.modifierExtension":"Extension","Parameters.parameter.name":"string","Parameters.parameter.resource":"Resource","Parameters.parameter.valueAddress":"Address","Parameters.parameter.valueAge":"Age","Parameters.parameter.valueAnnotation":"Annotation","Parameters.parameter.valueAttachment":"Attachment","Parameters.parameter.valueBase64Binary":"base64Binary","Parameters.parameter.valueBoolean":"boolean","Parameters.parameter.valueCode":"code","Parameters.parameter.valueCodeableConcept":"CodeableConcept","Parameters.parameter.valueCoding":"Coding","Parameters.parameter.valueContactPoint":"ContactPoint","Parameters.parameter.valueCount":"Count","Parameters.parameter.valueDate":"date","Parameters.parameter.valueDateTime":"dateTime","Parameters.parameter.valueDecimal":"decimal","Parameters.parameter.valueDistance":"Distance","Parameters.parameter.valueDuration":"Duration","Parameters.parameter.valueHumanName":"HumanName","Parameters.parameter.valueId":"id","Parameters.parameter.valueIdentifier":"Identifier","Parameters.parameter.valueInstant":"instant","Parameters.parameter.valueInteger":"integer","Parameters.parameter.valueMarkdown":"markdown","Parameters.parameter.valueMeta":"Meta","Parameters.parameter.valueMoney":"Money","Parameters.parameter.valueOid":"oid","Parameters.parameter.valuePeriod":"Period","Parameters.parameter.valuePositiveInt":"positiveInt","Parameters.parameter.valueQuantity":"Quantity","Parameters.parameter.valueRange":"Range","Parameters.parameter.valueRatio":"Ratio","Parameters.parameter.valueReference":"Reference","Parameters.parameter.valueSampledData":"SampledData","Parameters.parameter.valueSignature":"Signature","Parameters.parameter.valueString":"string","Parameters.parameter.valueTime":"time","Parameters.parameter.valueTiming":"Timing","Parameters.parameter.valueUnsignedInt":"unsignedInt","Parameters.parameter.valueUri":"uri","Patient.active":"boolean","Patient.address":"Address","Patient.animal":"BackboneElement","Patient.animal.breed":"CodeableConcept","Patient.animal.extension":"Extension","Patient.animal.genderStatus":"CodeableConcept","Patient.animal.id":"string","Patient.animal.modifierExtension":"Extension","Patient.animal.species":"CodeableConcept","Patient.birthDate":"date","Patient.communication":"BackboneElement","Patient.communication.extension":"Extension","Patient.communication.id":"string","Patient.communication.language":"CodeableConcept","Patient.communication.modifierExtension":"Extension","Patient.communication.preferred":"boolean","Patient.contact":"BackboneElement","Patient.contact.address":"Address","Patient.contact.extension":"Extension","Patient.contact.gender":"code","Patient.contact.id":"string","Patient.contact.modifierExtension":"Extension","Patient.contact.name":"HumanName","Patient.contact.organization":"Reference","Patient.contact.period":"Period","Patient.contact.relationship":"CodeableConcept","Patient.contact.telecom":"ContactPoint","Patient.contained":"Resource","Patient.deceasedBoolean":"boolean","Patient.deceasedDateTime":"dateTime","Patient.extension":"Extension","Patient.gender":"code","Patient.generalPractitioner":"Reference","Patient.id":"id","Patient.identifier":"Identifier","Patient.implicitRules":"uri","Patient.language":"code","Patient.link":"BackboneElement","Patient.link.extension":"Extension","Patient.link.id":"string","Patient.link.modifierExtension":"Extension","Patient.link.other":"Reference","Patient.link.type":"code","Patient.managingOrganization":"Reference","Patient.maritalStatus":"CodeableConcept","Patient.meta":"Meta","Patient.modifierExtension":"Extension","Patient.multipleBirthBoolean":"boolean","Patient.multipleBirthInteger":"integer","Patient.name":"HumanName","Patient.photo":"Attachment","Patient.telecom":"ContactPoint","Patient.text":"Narrative","PaymentNotice.contained":"Resource","PaymentNotice.created":"dateTime","PaymentNotice.extension":"Extension","PaymentNotice.id":"id","PaymentNotice.identifier":"Identifier","PaymentNotice.implicitRules":"uri","PaymentNotice.language":"code","PaymentNotice.meta":"Meta","PaymentNotice.modifierExtension":"Extension","PaymentNotice.organization":"Reference","PaymentNotice.paymentStatus":"CodeableConcept","PaymentNotice.provider":"Reference","PaymentNotice.request":"Reference","PaymentNotice.response":"Reference","PaymentNotice.status":"code","PaymentNotice.statusDate":"date","PaymentNotice.target":"Reference","PaymentNotice.text":"Narrative","PaymentReconciliation.contained":"Resource","PaymentReconciliation.created":"dateTime","PaymentReconciliation.detail":"BackboneElement","PaymentReconciliation.detail.amount":"Money","PaymentReconciliation.detail.date":"date","PaymentReconciliation.detail.extension":"Extension","PaymentReconciliation.detail.id":"string","PaymentReconciliation.detail.modifierExtension":"Extension","PaymentReconciliation.detail.payee":"Reference","PaymentReconciliation.detail.request":"Reference","PaymentReconciliation.detail.response":"Reference","PaymentReconciliation.detail.submitter":"Reference","PaymentReconciliation.detail.type":"CodeableConcept","PaymentReconciliation.disposition":"string","PaymentReconciliation.extension":"Extension","PaymentReconciliation.form":"CodeableConcept","PaymentReconciliation.id":"id","PaymentReconciliation.identifier":"Identifier","PaymentReconciliation.implicitRules":"uri","PaymentReconciliation.language":"code","PaymentReconciliation.meta":"Meta","PaymentReconciliation.modifierExtension":"Extension","PaymentReconciliation.organization":"Reference","PaymentReconciliation.outcome":"CodeableConcept","PaymentReconciliation.period":"Period","PaymentReconciliation.processNote":"BackboneElement","PaymentReconciliation.processNote.extension":"Extension","PaymentReconciliation.processNote.id":"string","PaymentReconciliation.processNote.modifierExtension":"Extension","PaymentReconciliation.processNote.text":"string","PaymentReconciliation.processNote.type":"CodeableConcept","PaymentReconciliation.request":"Reference","PaymentReconciliation.requestOrganization":"Reference","PaymentReconciliation.requestProvider":"Reference","PaymentReconciliation.status":"code","PaymentReconciliation.text":"Narrative","PaymentReconciliation.total":"Money","Period.end":"dateTime","Period.extension":"Extension","Period.id":"string","Period.start":"dateTime","Person.active":"boolean","Person.address":"Address","Person.birthDate":"date","Person.contained":"Resource","Person.extension":"Extension","Person.gender":"code","Person.id":"id","Person.identifier":"Identifier","Person.implicitRules":"uri","Person.language":"code","Person.link":"BackboneElement","Person.link.assurance":"code","Person.link.extension":"Extension","Person.link.id":"string","Person.link.modifierExtension":"Extension","Person.link.target":"Reference","Person.managingOrganization":"Reference","Person.meta":"Meta","Person.modifierExtension":"Extension","Person.name":"HumanName","Person.photo":"Attachment","Person.telecom":"ContactPoint","Person.text":"Narrative","PlanDefinition.action":"BackboneElement","PlanDefinition.action.cardinalityBehavior":"code","PlanDefinition.action.code":"CodeableConcept","PlanDefinition.action.condition":"BackboneElement","PlanDefinition.action.condition.description":"string","PlanDefinition.action.condition.expression":"string","PlanDefinition.action.condition.extension":"Extension","PlanDefinition.action.condition.id":"string","PlanDefinition.action.condition.kind":"code","PlanDefinition.action.condition.language":"string","PlanDefinition.action.condition.modifierExtension":"Extension","PlanDefinition.action.definition":"Reference","PlanDefinition.action.description":"string","PlanDefinition.action.documentation":"RelatedArtifact","PlanDefinition.action.dynamicValue":"BackboneElement","PlanDefinition.action.dynamicValue.description":"string","PlanDefinition.action.dynamicValue.expression":"string","PlanDefinition.action.dynamicValue.extension":"Extension","PlanDefinition.action.dynamicValue.id":"string","PlanDefinition.action.dynamicValue.language":"string","PlanDefinition.action.dynamicValue.modifierExtension":"Extension","PlanDefinition.action.dynamicValue.path":"string","PlanDefinition.action.extension":"Extension","PlanDefinition.action.goalId":"id","PlanDefinition.action.groupingBehavior":"code","PlanDefinition.action.id":"string","PlanDefinition.action.input":"DataRequirement","PlanDefinition.action.label":"string","PlanDefinition.action.modifierExtension":"Extension","PlanDefinition.action.output":"DataRequirement","PlanDefinition.action.participant":"BackboneElement","PlanDefinition.action.participant.extension":"Extension","PlanDefinition.action.participant.id":"string","PlanDefinition.action.participant.modifierExtension":"Extension","PlanDefinition.action.participant.role":"CodeableConcept","PlanDefinition.action.participant.type":"code","PlanDefinition.action.precheckBehavior":"code","PlanDefinition.action.reason":"CodeableConcept","PlanDefinition.action.relatedAction":"BackboneElement","PlanDefinition.action.relatedAction.actionId":"id","PlanDefinition.action.relatedAction.extension":"Extension","PlanDefinition.action.relatedAction.id":"string","PlanDefinition.action.relatedAction.modifierExtension":"Extension","PlanDefinition.action.relatedAction.offsetDuration":"Duration","PlanDefinition.action.relatedAction.offsetRange":"Range","PlanDefinition.action.relatedAction.relationship":"code","PlanDefinition.action.requiredBehavior":"code","PlanDefinition.action.selectionBehavior":"code","PlanDefinition.action.textEquivalent":"string","PlanDefinition.action.timingDateTime":"dateTime","PlanDefinition.action.timingDuration":"Duration","PlanDefinition.action.timingPeriod":"Period","PlanDefinition.action.timingRange":"Range","PlanDefinition.action.timingTiming":"Timing","PlanDefinition.action.title":"string","PlanDefinition.action.transform":"Reference","PlanDefinition.action.triggerDefinition":"TriggerDefinition","PlanDefinition.action.type":"Coding","PlanDefinition.approvalDate":"date","PlanDefinition.contact":"ContactDetail","PlanDefinition.contained":"Resource","PlanDefinition.contributor":"Contributor","PlanDefinition.copyright":"markdown","PlanDefinition.date":"dateTime","PlanDefinition.description":"markdown","PlanDefinition.effectivePeriod":"Period","PlanDefinition.experimental":"boolean","PlanDefinition.extension":"Extension","PlanDefinition.goal":"BackboneElement","PlanDefinition.goal.addresses":"CodeableConcept","PlanDefinition.goal.category":"CodeableConcept","PlanDefinition.goal.description":"CodeableConcept","PlanDefinition.goal.documentation":"RelatedArtifact","PlanDefinition.goal.extension":"Extension","PlanDefinition.goal.id":"string","PlanDefinition.goal.modifierExtension":"Extension","PlanDefinition.goal.priority":"CodeableConcept","PlanDefinition.goal.start":"CodeableConcept","PlanDefinition.goal.target":"BackboneElement","PlanDefinition.goal.target.detailCodeableConcept":"CodeableConcept","PlanDefinition.goal.target.detailQuantity":"Quantity","PlanDefinition.goal.target.detailRange":"Range","PlanDefinition.goal.target.due":"Duration","PlanDefinition.goal.target.extension":"Extension","PlanDefinition.goal.target.id":"string","PlanDefinition.goal.target.measure":"CodeableConcept","PlanDefinition.goal.target.modifierExtension":"Extension","PlanDefinition.id":"id","PlanDefinition.identifier":"Identifier","PlanDefinition.implicitRules":"uri","PlanDefinition.jurisdiction":"CodeableConcept","PlanDefinition.language":"code","PlanDefinition.lastReviewDate":"date","PlanDefinition.library":"Reference","PlanDefinition.meta":"Meta","PlanDefinition.modifierExtension":"Extension","PlanDefinition.name":"string","PlanDefinition.publisher":"string","PlanDefinition.purpose":"markdown","PlanDefinition.relatedArtifact":"RelatedArtifact","PlanDefinition.status":"code","PlanDefinition.text":"Narrative","PlanDefinition.title":"string","PlanDefinition.topic":"CodeableConcept","PlanDefinition.type":"CodeableConcept","PlanDefinition.url":"uri","PlanDefinition.usage":"string","PlanDefinition.useContext":"UsageContext","PlanDefinition.version":"string","Practitioner.active":"boolean","Practitioner.address":"Address","Practitioner.birthDate":"date","Practitioner.communication":"CodeableConcept","Practitioner.contained":"Resource","Practitioner.extension":"Extension","Practitioner.gender":"code","Practitioner.id":"id","Practitioner.identifier":"Identifier","Practitioner.implicitRules":"uri","Practitioner.language":"code","Practitioner.meta":"Meta","Practitioner.modifierExtension":"Extension","Practitioner.name":"HumanName","Practitioner.photo":"Attachment","Practitioner.qualification":"BackboneElement","Practitioner.qualification.code":"CodeableConcept","Practitioner.qualification.extension":"Extension","Practitioner.qualification.id":"string","Practitioner.qualification.identifier":"Identifier","Practitioner.qualification.issuer":"Reference","Practitioner.qualification.modifierExtension":"Extension","Practitioner.qualification.period":"Period","Practitioner.telecom":"ContactPoint","Practitioner.text":"Narrative","PractitionerRole.active":"boolean","PractitionerRole.availabilityExceptions":"string","PractitionerRole.availableTime":"BackboneElement","PractitionerRole.availableTime.allDay":"boolean","PractitionerRole.availableTime.availableEndTime":"time","PractitionerRole.availableTime.availableStartTime":"time","PractitionerRole.availableTime.daysOfWeek":"code","PractitionerRole.availableTime.extension":"Extension","PractitionerRole.availableTime.id":"string","PractitionerRole.availableTime.modifierExtension":"Extension","PractitionerRole.code":"CodeableConcept","PractitionerRole.contained":"Resource","PractitionerRole.endpoint":"Reference","PractitionerRole.extension":"Extension","PractitionerRole.healthcareService":"Reference","PractitionerRole.id":"id","PractitionerRole.identifier":"Identifier","PractitionerRole.implicitRules":"uri","PractitionerRole.language":"code","PractitionerRole.location":"Reference","PractitionerRole.meta":"Meta","PractitionerRole.modifierExtension":"Extension","PractitionerRole.notAvailable":"BackboneElement","PractitionerRole.notAvailable.description":"string","PractitionerRole.notAvailable.during":"Period","PractitionerRole.notAvailable.extension":"Extension","PractitionerRole.notAvailable.id":"string","PractitionerRole.notAvailable.modifierExtension":"Extension","PractitionerRole.organization":"Reference","PractitionerRole.period":"Period","PractitionerRole.practitioner":"Reference","PractitionerRole.specialty":"CodeableConcept","PractitionerRole.telecom":"ContactPoint","PractitionerRole.text":"Narrative","Procedure.basedOn":"Reference","Procedure.bodySite":"CodeableConcept","Procedure.category":"CodeableConcept","Procedure.code":"CodeableConcept","Procedure.complication":"CodeableConcept","Procedure.complicationDetail":"Reference","Procedure.contained":"Resource","Procedure.context":"Reference","Procedure.definition":"Reference","Procedure.extension":"Extension","Procedure.focalDevice":"BackboneElement","Procedure.focalDevice.action":"CodeableConcept","Procedure.focalDevice.extension":"Extension","Procedure.focalDevice.id":"string","Procedure.focalDevice.manipulated":"Reference","Procedure.focalDevice.modifierExtension":"Extension","Procedure.followUp":"CodeableConcept","Procedure.id":"id","Procedure.identifier":"Identifier","Procedure.implicitRules":"uri","Procedure.language":"code","Procedure.location":"Reference","Procedure.meta":"Meta","Procedure.modifierExtension":"Extension","Procedure.notDone":"boolean","Procedure.notDoneReason":"CodeableConcept","Procedure.note":"Annotation","Procedure.outcome":"CodeableConcept","Procedure.partOf":"Reference","Procedure.performedDateTime":"dateTime","Procedure.performedPeriod":"Period","Procedure.performer":"BackboneElement","Procedure.performer.actor":"Reference","Procedure.performer.extension":"Extension","Procedure.performer.id":"string","Procedure.performer.modifierExtension":"Extension","Procedure.performer.onBehalfOf":"Reference","Procedure.performer.role":"CodeableConcept","Procedure.reasonCode":"CodeableConcept","Procedure.reasonReference":"Reference","Procedure.report":"Reference","Procedure.status":"code","Procedure.subject":"Reference","Procedure.text":"Narrative","Procedure.usedCode":"CodeableConcept","Procedure.usedReference":"Reference","ProcedureRequest.asNeededBoolean":"boolean","ProcedureRequest.asNeededCodeableConcept":"CodeableConcept","ProcedureRequest.authoredOn":"dateTime","ProcedureRequest.basedOn":"Reference","ProcedureRequest.bodySite":"CodeableConcept","ProcedureRequest.category":"CodeableConcept","ProcedureRequest.code":"CodeableConcept","ProcedureRequest.contained":"Resource","ProcedureRequest.context":"Reference","ProcedureRequest.definition":"Reference","ProcedureRequest.doNotPerform":"boolean","ProcedureRequest.extension":"Extension","ProcedureRequest.id":"id","ProcedureRequest.identifier":"Identifier","ProcedureRequest.implicitRules":"uri","ProcedureRequest.intent":"code","ProcedureRequest.language":"code","ProcedureRequest.meta":"Meta","ProcedureRequest.modifierExtension":"Extension","ProcedureRequest.note":"Annotation","ProcedureRequest.occurrenceDateTime":"dateTime","ProcedureRequest.occurrencePeriod":"Period","ProcedureRequest.occurrenceTiming":"Timing","ProcedureRequest.performer":"Reference","ProcedureRequest.performerType":"CodeableConcept","ProcedureRequest.priority":"code","ProcedureRequest.reasonCode":"CodeableConcept","ProcedureRequest.reasonReference":"Reference","ProcedureRequest.relevantHistory":"Reference","ProcedureRequest.replaces":"Reference","ProcedureRequest.requester":"BackboneElement","ProcedureRequest.requester.agent":"Reference","ProcedureRequest.requester.extension":"Extension","ProcedureRequest.requester.id":"string","ProcedureRequest.requester.modifierExtension":"Extension","ProcedureRequest.requester.onBehalfOf":"Reference","ProcedureRequest.requisition":"Identifier","ProcedureRequest.specimen":"Reference","ProcedureRequest.status":"code","ProcedureRequest.subject":"Reference","ProcedureRequest.supportingInfo":"Reference","ProcedureRequest.text":"Narrative","ProcessRequest.action":"code","ProcessRequest.contained":"Resource","ProcessRequest.created":"dateTime","ProcessRequest.exclude":"string","ProcessRequest.extension":"Extension","ProcessRequest.id":"id","ProcessRequest.identifier":"Identifier","ProcessRequest.implicitRules":"uri","ProcessRequest.include":"string","ProcessRequest.item":"BackboneElement","ProcessRequest.item.extension":"Extension","ProcessRequest.item.id":"string","ProcessRequest.item.modifierExtension":"Extension","ProcessRequest.item.sequenceLinkId":"integer","ProcessRequest.language":"code","ProcessRequest.meta":"Meta","ProcessRequest.modifierExtension":"Extension","ProcessRequest.nullify":"boolean","ProcessRequest.organization":"Reference","ProcessRequest.period":"Period","ProcessRequest.provider":"Reference","ProcessRequest.reference":"string","ProcessRequest.request":"Reference","ProcessRequest.response":"Reference","ProcessRequest.status":"code","ProcessRequest.target":"Reference","ProcessRequest.text":"Narrative","ProcessResponse.communicationRequest":"Reference","ProcessResponse.contained":"Resource","ProcessResponse.created":"dateTime","ProcessResponse.disposition":"string","ProcessResponse.error":"CodeableConcept","ProcessResponse.extension":"Extension","ProcessResponse.form":"CodeableConcept","ProcessResponse.id":"id","ProcessResponse.identifier":"Identifier","ProcessResponse.implicitRules":"uri","ProcessResponse.language":"code","ProcessResponse.meta":"Meta","ProcessResponse.modifierExtension":"Extension","ProcessResponse.organization":"Reference","ProcessResponse.outcome":"CodeableConcept","ProcessResponse.processNote":"BackboneElement","ProcessResponse.processNote.extension":"Extension","ProcessResponse.processNote.id":"string","ProcessResponse.processNote.modifierExtension":"Extension","ProcessResponse.processNote.text":"string","ProcessResponse.processNote.type":"CodeableConcept","ProcessResponse.request":"Reference","ProcessResponse.requestOrganization":"Reference","ProcessResponse.requestProvider":"Reference","ProcessResponse.status":"code","ProcessResponse.text":"Narrative","Provenance.activity":"Coding","Provenance.agent":"BackboneElement","Provenance.agent.extension":"Extension","Provenance.agent.id":"string","Provenance.agent.modifierExtension":"Extension","Provenance.agent.onBehalfOfReference":"Reference","Provenance.agent.onBehalfOfUri":"uri","Provenance.agent.relatedAgentType":"CodeableConcept","Provenance.agent.role":"CodeableConcept","Provenance.agent.whoReference":"Reference","Provenance.agent.whoUri":"uri","Provenance.contained":"Resource","Provenance.entity":"BackboneElement","Provenance.entity.extension":"Extension","Provenance.entity.id":"string","Provenance.entity.modifierExtension":"Extension","Provenance.entity.role":"code","Provenance.entity.whatIdentifier":"Identifier","Provenance.entity.whatReference":"Reference","Provenance.entity.whatUri":"uri","Provenance.extension":"Extension","Provenance.id":"id","Provenance.implicitRules":"uri","Provenance.language":"code","Provenance.location":"Reference","Provenance.meta":"Meta","Provenance.modifierExtension":"Extension","Provenance.period":"Period","Provenance.policy":"uri","Provenance.reason":"Coding","Provenance.recorded":"instant","Provenance.signature":"Signature","Provenance.target":"Reference","Provenance.text":"Narrative","Quantity.code":"code","Quantity.comparator":"code","Quantity.extension":"Extension","Quantity.id":"string","Quantity.system":"uri","Quantity.unit":"string","Quantity.value":"decimal","Questionnaire.approvalDate":"date","Questionnaire.code":"Coding","Questionnaire.contact":"ContactDetail","Questionnaire.contained":"Resource","Questionnaire.copyright":"markdown","Questionnaire.date":"dateTime","Questionnaire.description":"markdown","Questionnaire.effectivePeriod":"Period","Questionnaire.experimental":"boolean","Questionnaire.extension":"Extension","Questionnaire.id":"id","Questionnaire.identifier":"Identifier","Questionnaire.implicitRules":"uri","Questionnaire.item":"BackboneElement","Questionnaire.item.code":"Coding","Questionnaire.item.definition":"uri","Questionnaire.item.enableWhen":"BackboneElement","Questionnaire.item.enableWhen.answerAttachment":"Attachment","Questionnaire.item.enableWhen.answerBoolean":"boolean","Questionnaire.item.enableWhen.answerCoding":"Coding","Questionnaire.item.enableWhen.answerDate":"date","Questionnaire.item.enableWhen.answerDateTime":"dateTime","Questionnaire.item.enableWhen.answerDecimal":"decimal","Questionnaire.item.enableWhen.answerInteger":"integer","Questionnaire.item.enableWhen.answerQuantity":"Quantity","Questionnaire.item.enableWhen.answerReference":"Reference","Questionnaire.item.enableWhen.answerString":"string","Questionnaire.item.enableWhen.answerTime":"time","Questionnaire.item.enableWhen.answerUri":"uri","Questionnaire.item.enableWhen.extension":"Extension","Questionnaire.item.enableWhen.hasAnswer":"boolean","Questionnaire.item.enableWhen.id":"string","Questionnaire.item.enableWhen.modifierExtension":"Extension","Questionnaire.item.enableWhen.question":"string","Questionnaire.item.extension":"Extension","Questionnaire.item.id":"string","Questionnaire.item.initialAttachment":"Attachment","Questionnaire.item.initialBoolean":"boolean","Questionnaire.item.initialCoding":"Coding","Questionnaire.item.initialDate":"date","Questionnaire.item.initialDateTime":"dateTime","Questionnaire.item.initialDecimal":"decimal","Questionnaire.item.initialInteger":"integer","Questionnaire.item.initialQuantity":"Quantity","Questionnaire.item.initialReference":"Reference","Questionnaire.item.initialString":"string","Questionnaire.item.initialTime":"time","Questionnaire.item.initialUri":"uri","Questionnaire.item.linkId":"string","Questionnaire.item.maxLength":"integer","Questionnaire.item.modifierExtension":"Extension","Questionnaire.item.option":"BackboneElement","Questionnaire.item.option.extension":"Extension","Questionnaire.item.option.id":"string","Questionnaire.item.option.modifierExtension":"Extension","Questionnaire.item.option.valueCoding":"Coding","Questionnaire.item.option.valueDate":"date","Questionnaire.item.option.valueInteger":"integer","Questionnaire.item.option.valueString":"string","Questionnaire.item.option.valueTime":"time","Questionnaire.item.options":"Reference","Questionnaire.item.prefix":"string","Questionnaire.item.readOnly":"boolean","Questionnaire.item.repeats":"boolean","Questionnaire.item.required":"boolean","Questionnaire.item.text":"string","Questionnaire.item.type":"code","Questionnaire.jurisdiction":"CodeableConcept","Questionnaire.language":"code","Questionnaire.lastReviewDate":"date","Questionnaire.meta":"Meta","Questionnaire.modifierExtension":"Extension","Questionnaire.name":"string","Questionnaire.publisher":"string","Questionnaire.purpose":"markdown","Questionnaire.status":"code","Questionnaire.subjectType":"code","Questionnaire.text":"Narrative","Questionnaire.title":"string","Questionnaire.url":"uri","Questionnaire.useContext":"UsageContext","Questionnaire.version":"string","QuestionnaireResponse.author":"Reference","QuestionnaireResponse.authored":"dateTime","QuestionnaireResponse.basedOn":"Reference","QuestionnaireResponse.contained":"Resource","QuestionnaireResponse.context":"Reference","QuestionnaireResponse.extension":"Extension","QuestionnaireResponse.id":"id","QuestionnaireResponse.identifier":"Identifier","QuestionnaireResponse.implicitRules":"uri","QuestionnaireResponse.item":"BackboneElement","QuestionnaireResponse.item.answer":"BackboneElement","QuestionnaireResponse.item.answer.extension":"Extension","QuestionnaireResponse.item.answer.id":"string","QuestionnaireResponse.item.answer.modifierExtension":"Extension","QuestionnaireResponse.item.answer.valueAttachment":"Attachment","QuestionnaireResponse.item.answer.valueBoolean":"boolean","QuestionnaireResponse.item.answer.valueCoding":"Coding","QuestionnaireResponse.item.answer.valueDate":"date","QuestionnaireResponse.item.answer.valueDateTime":"dateTime","QuestionnaireResponse.item.answer.valueDecimal":"decimal","QuestionnaireResponse.item.answer.valueInteger":"integer","QuestionnaireResponse.item.answer.valueQuantity":"Quantity","QuestionnaireResponse.item.answer.valueReference":"Reference","QuestionnaireResponse.item.answer.valueString":"string","QuestionnaireResponse.item.answer.valueTime":"time","QuestionnaireResponse.item.answer.valueUri":"uri","QuestionnaireResponse.item.definition":"uri","QuestionnaireResponse.item.extension":"Extension","QuestionnaireResponse.item.id":"string","QuestionnaireResponse.item.linkId":"string","QuestionnaireResponse.item.modifierExtension":"Extension","QuestionnaireResponse.item.subject":"Reference","QuestionnaireResponse.item.text":"string","QuestionnaireResponse.language":"code","QuestionnaireResponse.meta":"Meta","QuestionnaireResponse.modifierExtension":"Extension","QuestionnaireResponse.parent":"Reference","QuestionnaireResponse.questionnaire":"Reference","QuestionnaireResponse.source":"Reference","QuestionnaireResponse.status":"code","QuestionnaireResponse.subject":"Reference","QuestionnaireResponse.text":"Narrative","Range.extension":"Extension","Range.high":"Quantity","Range.id":"string","Range.low":"Quantity","Ratio.denominator":"Quantity","Ratio.extension":"Extension","Ratio.id":"string","Ratio.numerator":"Quantity","Reference.display":"string","Reference.extension":"Extension","Reference.id":"string","Reference.identifier":"Identifier","Reference.reference":"string","ReferralRequest.authoredOn":"dateTime","ReferralRequest.basedOn":"Reference","ReferralRequest.contained":"Resource","ReferralRequest.context":"Reference","ReferralRequest.definition":"Reference","ReferralRequest.description":"string","ReferralRequest.extension":"Extension","ReferralRequest.groupIdentifier":"Identifier","ReferralRequest.id":"id","ReferralRequest.identifier":"Identifier","ReferralRequest.implicitRules":"uri","ReferralRequest.intent":"code","ReferralRequest.language":"code","ReferralRequest.meta":"Meta","ReferralRequest.modifierExtension":"Extension","ReferralRequest.note":"Annotation","ReferralRequest.occurrenceDateTime":"dateTime","ReferralRequest.occurrencePeriod":"Period","ReferralRequest.priority":"code","ReferralRequest.reasonCode":"CodeableConcept","ReferralRequest.reasonReference":"Reference","ReferralRequest.recipient":"Reference","ReferralRequest.relevantHistory":"Reference","ReferralRequest.replaces":"Reference","ReferralRequest.requester":"BackboneElement","ReferralRequest.requester.agent":"Reference","ReferralRequest.requester.extension":"Extension","ReferralRequest.requester.id":"string","ReferralRequest.requester.modifierExtension":"Extension","ReferralRequest.requester.onBehalfOf":"Reference","ReferralRequest.serviceRequested":"CodeableConcept","ReferralRequest.specialty":"CodeableConcept","ReferralRequest.status":"code","ReferralRequest.subject":"Reference","ReferralRequest.supportingInfo":"Reference","ReferralRequest.text":"Narrative","ReferralRequest.type":"CodeableConcept","RelatedArtifact.citation":"string","RelatedArtifact.display":"string","RelatedArtifact.document":"Attachment","RelatedArtifact.extension":"Extension","RelatedArtifact.id":"string","RelatedArtifact.resource":"Reference","RelatedArtifact.type":"code","RelatedArtifact.url":"uri","RelatedPerson.active":"boolean","RelatedPerson.address":"Address","RelatedPerson.birthDate":"date","RelatedPerson.contained":"Resource","RelatedPerson.extension":"Extension","RelatedPerson.gender":"code","RelatedPerson.id":"id","RelatedPerson.identifier":"Identifier","RelatedPerson.implicitRules":"uri","RelatedPerson.language":"code","RelatedPerson.meta":"Meta","RelatedPerson.modifierExtension":"Extension","RelatedPerson.name":"HumanName","RelatedPerson.patient":"Reference","RelatedPerson.period":"Period","RelatedPerson.photo":"Attachment","RelatedPerson.relationship":"CodeableConcept","RelatedPerson.telecom":"ContactPoint","RelatedPerson.text":"Narrative","RequestGroup.action":"BackboneElement","RequestGroup.action.cardinalityBehavior":"code","RequestGroup.action.code":"CodeableConcept","RequestGroup.action.condition":"BackboneElement","RequestGroup.action.condition.description":"string","RequestGroup.action.condition.expression":"string","RequestGroup.action.condition.extension":"Extension","RequestGroup.action.condition.id":"string","RequestGroup.action.condition.kind":"code","RequestGroup.action.condition.language":"string","RequestGroup.action.condition.modifierExtension":"Extension","RequestGroup.action.description":"string","RequestGroup.action.documentation":"RelatedArtifact","RequestGroup.action.extension":"Extension","RequestGroup.action.groupingBehavior":"code","RequestGroup.action.id":"string","RequestGroup.action.label":"string","RequestGroup.action.modifierExtension":"Extension","RequestGroup.action.participant":"Reference","RequestGroup.action.precheckBehavior":"code","RequestGroup.action.relatedAction":"BackboneElement","RequestGroup.action.relatedAction.actionId":"id","RequestGroup.action.relatedAction.extension":"Extension","RequestGroup.action.relatedAction.id":"string","RequestGroup.action.relatedAction.modifierExtension":"Extension","RequestGroup.action.relatedAction.offsetDuration":"Duration","RequestGroup.action.relatedAction.offsetRange":"Range","RequestGroup.action.relatedAction.relationship":"code","RequestGroup.action.requiredBehavior":"code","RequestGroup.action.resource":"Reference","RequestGroup.action.selectionBehavior":"code","RequestGroup.action.textEquivalent":"string","RequestGroup.action.timingDateTime":"dateTime","RequestGroup.action.timingDuration":"Duration","RequestGroup.action.timingPeriod":"Period","RequestGroup.action.timingRange":"Range","RequestGroup.action.timingTiming":"Timing","RequestGroup.action.title":"string","RequestGroup.action.type":"Coding","RequestGroup.author":"Reference","RequestGroup.authoredOn":"dateTime","RequestGroup.basedOn":"Reference","RequestGroup.contained":"Resource","RequestGroup.context":"Reference","RequestGroup.definition":"Reference","RequestGroup.extension":"Extension","RequestGroup.groupIdentifier":"Identifier","RequestGroup.id":"id","RequestGroup.identifier":"Identifier","RequestGroup.implicitRules":"uri","RequestGroup.intent":"code","RequestGroup.language":"code","RequestGroup.meta":"Meta","RequestGroup.modifierExtension":"Extension","RequestGroup.note":"Annotation","RequestGroup.priority":"code","RequestGroup.reasonCodeableConcept":"CodeableConcept","RequestGroup.reasonReference":"Reference","RequestGroup.replaces":"Reference","RequestGroup.status":"code","RequestGroup.subject":"Reference","RequestGroup.text":"Narrative","ResearchStudy.arm":"BackboneElement","ResearchStudy.arm.code":"CodeableConcept","ResearchStudy.arm.description":"string","ResearchStudy.arm.extension":"Extension","ResearchStudy.arm.id":"string","ResearchStudy.arm.modifierExtension":"Extension","ResearchStudy.arm.name":"string","ResearchStudy.category":"CodeableConcept","ResearchStudy.contact":"ContactDetail","ResearchStudy.contained":"Resource","ResearchStudy.description":"markdown","ResearchStudy.enrollment":"Reference","ResearchStudy.extension":"Extension","ResearchStudy.focus":"CodeableConcept","ResearchStudy.id":"id","ResearchStudy.identifier":"Identifier","ResearchStudy.implicitRules":"uri","ResearchStudy.jurisdiction":"CodeableConcept","ResearchStudy.keyword":"CodeableConcept","ResearchStudy.language":"code","ResearchStudy.meta":"Meta","ResearchStudy.modifierExtension":"Extension","ResearchStudy.note":"Annotation","ResearchStudy.partOf":"Reference","ResearchStudy.period":"Period","ResearchStudy.principalInvestigator":"Reference","ResearchStudy.protocol":"Reference","ResearchStudy.reasonStopped":"CodeableConcept","ResearchStudy.relatedArtifact":"RelatedArtifact","ResearchStudy.site":"Reference","ResearchStudy.sponsor":"Reference","ResearchStudy.status":"code","ResearchStudy.text":"Narrative","ResearchStudy.title":"string","ResearchSubject.actualArm":"string","ResearchSubject.assignedArm":"string","ResearchSubject.consent":"Reference","ResearchSubject.contained":"Resource","ResearchSubject.extension":"Extension","ResearchSubject.id":"id","ResearchSubject.identifier":"Identifier","ResearchSubject.implicitRules":"uri","ResearchSubject.individual":"Reference","ResearchSubject.language":"code","ResearchSubject.meta":"Meta","ResearchSubject.modifierExtension":"Extension","ResearchSubject.period":"Period","ResearchSubject.status":"code","ResearchSubject.study":"Reference","ResearchSubject.text":"Narrative","Resource.id":"id","Resource.implicitRules":"uri","Resource.language":"code","Resource.meta":"Meta","RiskAssessment.basedOn":"Reference","RiskAssessment.basis":"Reference","RiskAssessment.code":"CodeableConcept","RiskAssessment.comment":"string","RiskAssessment.condition":"Reference","RiskAssessment.contained":"Resource","RiskAssessment.context":"Reference","RiskAssessment.extension":"Extension","RiskAssessment.id":"id","RiskAssessment.identifier":"Identifier","RiskAssessment.implicitRules":"uri","RiskAssessment.language":"code","RiskAssessment.meta":"Meta","RiskAssessment.method":"CodeableConcept","RiskAssessment.mitigation":"string","RiskAssessment.modifierExtension":"Extension","RiskAssessment.occurrenceDateTime":"dateTime","RiskAssessment.occurrencePeriod":"Period","RiskAssessment.parent":"Reference","RiskAssessment.performer":"Reference","RiskAssessment.prediction":"BackboneElement","RiskAssessment.prediction.extension":"Extension","RiskAssessment.prediction.id":"string","RiskAssessment.prediction.modifierExtension":"Extension","RiskAssessment.prediction.outcome":"CodeableConcept","RiskAssessment.prediction.probabilityDecimal":"decimal","RiskAssessment.prediction.probabilityRange":"Range","RiskAssessment.prediction.qualitativeRisk":"CodeableConcept","RiskAssessment.prediction.rationale":"string","RiskAssessment.prediction.relativeRisk":"decimal","RiskAssessment.prediction.whenPeriod":"Period","RiskAssessment.prediction.whenRange":"Range","RiskAssessment.reasonCodeableConcept":"CodeableConcept","RiskAssessment.reasonReference":"Reference","RiskAssessment.status":"code","RiskAssessment.subject":"Reference","RiskAssessment.text":"Narrative","SampledData.data":"string","SampledData.dimensions":"positiveInt","SampledData.extension":"Extension","SampledData.factor":"decimal","SampledData.id":"string","SampledData.lowerLimit":"decimal","SampledData.origin":"Quantity","SampledData.period":"decimal","SampledData.upperLimit":"decimal","Schedule.active":"boolean","Schedule.actor":"Reference","Schedule.comment":"string","Schedule.contained":"Resource","Schedule.extension":"Extension","Schedule.id":"id","Schedule.identifier":"Identifier","Schedule.implicitRules":"uri","Schedule.language":"code","Schedule.meta":"Meta","Schedule.modifierExtension":"Extension","Schedule.planningHorizon":"Period","Schedule.serviceCategory":"CodeableConcept","Schedule.serviceType":"CodeableConcept","Schedule.specialty":"CodeableConcept","Schedule.text":"Narrative","SearchParameter.base":"code","SearchParameter.chain":"string","SearchParameter.code":"code","SearchParameter.comparator":"code","SearchParameter.component":"BackboneElement","SearchParameter.component.definition":"Reference","SearchParameter.component.expression":"string","SearchParameter.component.extension":"Extension","SearchParameter.component.id":"string","SearchParameter.component.modifierExtension":"Extension","SearchParameter.contact":"ContactDetail","SearchParameter.contained":"Resource","SearchParameter.date":"dateTime","SearchParameter.derivedFrom":"uri","SearchParameter.description":"markdown","SearchParameter.experimental":"boolean","SearchParameter.expression":"string","SearchParameter.extension":"Extension","SearchParameter.id":"id","SearchParameter.implicitRules":"uri","SearchParameter.jurisdiction":"CodeableConcept","SearchParameter.language":"code","SearchParameter.meta":"Meta","SearchParameter.modifier":"code","SearchParameter.modifierExtension":"Extension","SearchParameter.name":"string","SearchParameter.publisher":"string","SearchParameter.purpose":"markdown","SearchParameter.status":"code","SearchParameter.target":"code","SearchParameter.text":"Narrative","SearchParameter.type":"code","SearchParameter.url":"uri","SearchParameter.useContext":"UsageContext","SearchParameter.version":"string","SearchParameter.xpath":"string","SearchParameter.xpathUsage":"code","Sequence.contained":"Resource","Sequence.coordinateSystem":"integer","Sequence.device":"Reference","Sequence.extension":"Extension","Sequence.id":"id","Sequence.identifier":"Identifier","Sequence.implicitRules":"uri","Sequence.language":"code","Sequence.meta":"Meta","Sequence.modifierExtension":"Extension","Sequence.observedSeq":"string","Sequence.patient":"Reference","Sequence.performer":"Reference","Sequence.pointer":"Reference","Sequence.quality":"BackboneElement","Sequence.quality.end":"integer","Sequence.quality.extension":"Extension","Sequence.quality.fScore":"decimal","Sequence.quality.gtFP":"decimal","Sequence.quality.id":"string","Sequence.quality.method":"CodeableConcept","Sequence.quality.modifierExtension":"Extension","Sequence.quality.precision":"decimal","Sequence.quality.queryFP":"decimal","Sequence.quality.queryTP":"decimal","Sequence.quality.recall":"decimal","Sequence.quality.score":"Quantity","Sequence.quality.standardSequence":"CodeableConcept","Sequence.quality.start":"integer","Sequence.quality.truthFN":"decimal","Sequence.quality.truthTP":"decimal","Sequence.quality.type":"code","Sequence.quantity":"Quantity","Sequence.readCoverage":"integer","Sequence.referenceSeq":"BackboneElement","Sequence.referenceSeq.chromosome":"CodeableConcept","Sequence.referenceSeq.extension":"Extension","Sequence.referenceSeq.genomeBuild":"string","Sequence.referenceSeq.id":"string","Sequence.referenceSeq.modifierExtension":"Extension","Sequence.referenceSeq.referenceSeqId":"CodeableConcept","Sequence.referenceSeq.referenceSeqPointer":"Reference","Sequence.referenceSeq.referenceSeqString":"string","Sequence.referenceSeq.strand":"integer","Sequence.referenceSeq.windowEnd":"integer","Sequence.referenceSeq.windowStart":"integer","Sequence.repository":"BackboneElement","Sequence.repository.datasetId":"string","Sequence.repository.extension":"Extension","Sequence.repository.id":"string","Sequence.repository.modifierExtension":"Extension","Sequence.repository.name":"string","Sequence.repository.readsetId":"string","Sequence.repository.type":"code","Sequence.repository.url":"uri","Sequence.repository.variantsetId":"string","Sequence.specimen":"Reference","Sequence.text":"Narrative","Sequence.type":"code","Sequence.variant":"BackboneElement","Sequence.variant.cigar":"string","Sequence.variant.end":"integer","Sequence.variant.extension":"Extension","Sequence.variant.id":"string","Sequence.variant.modifierExtension":"Extension","Sequence.variant.observedAllele":"string","Sequence.variant.referenceAllele":"string","Sequence.variant.start":"integer","Sequence.variant.variantPointer":"Reference","ServiceDefinition.approvalDate":"date","ServiceDefinition.contact":"ContactDetail","ServiceDefinition.contained":"Resource","ServiceDefinition.contributor":"Contributor","ServiceDefinition.copyright":"markdown","ServiceDefinition.dataRequirement":"DataRequirement","ServiceDefinition.date":"dateTime","ServiceDefinition.description":"markdown","ServiceDefinition.effectivePeriod":"Period","ServiceDefinition.experimental":"boolean","ServiceDefinition.extension":"Extension","ServiceDefinition.id":"id","ServiceDefinition.identifier":"Identifier","ServiceDefinition.implicitRules":"uri","ServiceDefinition.jurisdiction":"CodeableConcept","ServiceDefinition.language":"code","ServiceDefinition.lastReviewDate":"date","ServiceDefinition.meta":"Meta","ServiceDefinition.modifierExtension":"Extension","ServiceDefinition.name":"string","ServiceDefinition.operationDefinition":"Reference","ServiceDefinition.publisher":"string","ServiceDefinition.purpose":"markdown","ServiceDefinition.relatedArtifact":"RelatedArtifact","ServiceDefinition.status":"code","ServiceDefinition.text":"Narrative","ServiceDefinition.title":"string","ServiceDefinition.topic":"CodeableConcept","ServiceDefinition.trigger":"TriggerDefinition","ServiceDefinition.url":"uri","ServiceDefinition.usage":"string","ServiceDefinition.useContext":"UsageContext","ServiceDefinition.version":"string","Signature.blob":"base64Binary","Signature.contentType":"code","Signature.extension":"Extension","Signature.id":"string","Signature.onBehalfOfReference":"Reference","Signature.onBehalfOfUri":"uri","Signature.type":"Coding","Signature.when":"instant","Signature.whoReference":"Reference","Signature.whoUri":"uri","Slot.appointmentType":"CodeableConcept","Slot.comment":"string","Slot.contained":"Resource","Slot.end":"instant","Slot.extension":"Extension","Slot.id":"id","Slot.identifier":"Identifier","Slot.implicitRules":"uri","Slot.language":"code","Slot.meta":"Meta","Slot.modifierExtension":"Extension","Slot.overbooked":"boolean","Slot.schedule":"Reference","Slot.serviceCategory":"CodeableConcept","Slot.serviceType":"CodeableConcept","Slot.specialty":"CodeableConcept","Slot.start":"instant","Slot.status":"code","Slot.text":"Narrative","Specimen.accessionIdentifier":"Identifier","Specimen.collection":"BackboneElement","Specimen.collection.bodySite":"CodeableConcept","Specimen.collection.collectedDateTime":"dateTime","Specimen.collection.collectedPeriod":"Period","Specimen.collection.collector":"Reference","Specimen.collection.extension":"Extension","Specimen.collection.id":"string","Specimen.collection.method":"CodeableConcept","Specimen.collection.modifierExtension":"Extension","Specimen.collection.quantity":"Quantity","Specimen.contained":"Resource","Specimen.container":"BackboneElement","Specimen.container.additiveCodeableConcept":"CodeableConcept","Specimen.container.additiveReference":"Reference","Specimen.container.capacity":"Quantity","Specimen.container.description":"string","Specimen.container.extension":"Extension","Specimen.container.id":"string","Specimen.container.identifier":"Identifier","Specimen.container.modifierExtension":"Extension","Specimen.container.specimenQuantity":"Quantity","Specimen.container.type":"CodeableConcept","Specimen.extension":"Extension","Specimen.id":"id","Specimen.identifier":"Identifier","Specimen.implicitRules":"uri","Specimen.language":"code","Specimen.meta":"Meta","Specimen.modifierExtension":"Extension","Specimen.note":"Annotation","Specimen.parent":"Reference","Specimen.processing":"BackboneElement","Specimen.processing.additive":"Reference","Specimen.processing.description":"string","Specimen.processing.extension":"Extension","Specimen.processing.id":"string","Specimen.processing.modifierExtension":"Extension","Specimen.processing.procedure":"CodeableConcept","Specimen.processing.timeDateTime":"dateTime","Specimen.processing.timePeriod":"Period","Specimen.receivedTime":"dateTime","Specimen.request":"Reference","Specimen.status":"code","Specimen.subject":"Reference","Specimen.text":"Narrative","Specimen.type":"CodeableConcept","StructureDefinition.abstract":"boolean","StructureDefinition.baseDefinition":"uri","StructureDefinition.contact":"ContactDetail","StructureDefinition.contained":"Resource","StructureDefinition.context":"string","StructureDefinition.contextInvariant":"string","StructureDefinition.contextType":"code","StructureDefinition.copyright":"markdown","StructureDefinition.date":"dateTime","StructureDefinition.derivation":"code","StructureDefinition.description":"markdown","StructureDefinition.differential":"BackboneElement","StructureDefinition.differential.element":"ElementDefinition","StructureDefinition.differential.extension":"Extension","StructureDefinition.differential.id":"string","StructureDefinition.differential.modifierExtension":"Extension","StructureDefinition.experimental":"boolean","StructureDefinition.extension":"Extension","StructureDefinition.fhirVersion":"id","StructureDefinition.id":"id","StructureDefinition.identifier":"Identifier","StructureDefinition.implicitRules":"uri","StructureDefinition.jurisdiction":"CodeableConcept","StructureDefinition.keyword":"Coding","StructureDefinition.kind":"code","StructureDefinition.language":"code","StructureDefinition.mapping":"BackboneElement","StructureDefinition.mapping.comment":"string","StructureDefinition.mapping.extension":"Extension","StructureDefinition.mapping.id":"string","StructureDefinition.mapping.identity":"id","StructureDefinition.mapping.modifierExtension":"Extension","StructureDefinition.mapping.name":"string","StructureDefinition.mapping.uri":"uri","StructureDefinition.meta":"Meta","StructureDefinition.modifierExtension":"Extension","StructureDefinition.name":"string","StructureDefinition.publisher":"string","StructureDefinition.purpose":"markdown","StructureDefinition.snapshot":"BackboneElement","StructureDefinition.snapshot.element":"ElementDefinition","StructureDefinition.snapshot.extension":"Extension","StructureDefinition.snapshot.id":"string","StructureDefinition.snapshot.modifierExtension":"Extension","StructureDefinition.status":"code","StructureDefinition.text":"Narrative","StructureDefinition.title":"string","StructureDefinition.type":"code","StructureDefinition.url":"uri","StructureDefinition.useContext":"UsageContext","StructureDefinition.version":"string","StructureMap.contact":"ContactDetail","StructureMap.contained":"Resource","StructureMap.copyright":"markdown","StructureMap.date":"dateTime","StructureMap.description":"markdown","StructureMap.experimental":"boolean","StructureMap.extension":"Extension","StructureMap.group":"BackboneElement","StructureMap.group.documentation":"string","StructureMap.group.extends":"id","StructureMap.group.extension":"Extension","StructureMap.group.id":"string","StructureMap.group.input":"BackboneElement","StructureMap.group.input.documentation":"string","StructureMap.group.input.extension":"Extension","StructureMap.group.input.id":"string","StructureMap.group.input.mode":"code","StructureMap.group.input.modifierExtension":"Extension","StructureMap.group.input.name":"id","StructureMap.group.input.type":"string","StructureMap.group.modifierExtension":"Extension","StructureMap.group.name":"id","StructureMap.group.rule":"BackboneElement","StructureMap.group.rule.dependent":"BackboneElement","StructureMap.group.rule.dependent.extension":"Extension","StructureMap.group.rule.dependent.id":"string","StructureMap.group.rule.dependent.modifierExtension":"Extension","StructureMap.group.rule.dependent.name":"id","StructureMap.group.rule.dependent.variable":"string","StructureMap.group.rule.documentation":"string","StructureMap.group.rule.extension":"Extension","StructureMap.group.rule.id":"string","StructureMap.group.rule.modifierExtension":"Extension","StructureMap.group.rule.name":"id","StructureMap.group.rule.source":"BackboneElement","StructureMap.group.rule.source.check":"string","StructureMap.group.rule.source.condition":"string","StructureMap.group.rule.source.context":"id","StructureMap.group.rule.source.defaultValueAddress":"Address","StructureMap.group.rule.source.defaultValueAge":"Age","StructureMap.group.rule.source.defaultValueAnnotation":"Annotation","StructureMap.group.rule.source.defaultValueAttachment":"Attachment","StructureMap.group.rule.source.defaultValueBase64Binary":"base64Binary","StructureMap.group.rule.source.defaultValueBoolean":"boolean","StructureMap.group.rule.source.defaultValueCode":"code","StructureMap.group.rule.source.defaultValueCodeableConcept":"CodeableConcept","StructureMap.group.rule.source.defaultValueCoding":"Coding","StructureMap.group.rule.source.defaultValueContactPoint":"ContactPoint","StructureMap.group.rule.source.defaultValueCount":"Count","StructureMap.group.rule.source.defaultValueDate":"date","StructureMap.group.rule.source.defaultValueDateTime":"dateTime","StructureMap.group.rule.source.defaultValueDecimal":"decimal","StructureMap.group.rule.source.defaultValueDistance":"Distance","StructureMap.group.rule.source.defaultValueDuration":"Duration","StructureMap.group.rule.source.defaultValueHumanName":"HumanName","StructureMap.group.rule.source.defaultValueId":"id","StructureMap.group.rule.source.defaultValueIdentifier":"Identifier","StructureMap.group.rule.source.defaultValueInstant":"instant","StructureMap.group.rule.source.defaultValueInteger":"integer","StructureMap.group.rule.source.defaultValueMarkdown":"markdown","StructureMap.group.rule.source.defaultValueMeta":"Meta","StructureMap.group.rule.source.defaultValueMoney":"Money","StructureMap.group.rule.source.defaultValueOid":"oid","StructureMap.group.rule.source.defaultValuePeriod":"Period","StructureMap.group.rule.source.defaultValuePositiveInt":"positiveInt","StructureMap.group.rule.source.defaultValueQuantity":"Quantity","StructureMap.group.rule.source.defaultValueRange":"Range","StructureMap.group.rule.source.defaultValueRatio":"Ratio","StructureMap.group.rule.source.defaultValueReference":"Reference","StructureMap.group.rule.source.defaultValueSampledData":"SampledData","StructureMap.group.rule.source.defaultValueSignature":"Signature","StructureMap.group.rule.source.defaultValueString":"string","StructureMap.group.rule.source.defaultValueTime":"time","StructureMap.group.rule.source.defaultValueTiming":"Timing","StructureMap.group.rule.source.defaultValueUnsignedInt":"unsignedInt","StructureMap.group.rule.source.defaultValueUri":"uri","StructureMap.group.rule.source.element":"string","StructureMap.group.rule.source.extension":"Extension","StructureMap.group.rule.source.id":"string","StructureMap.group.rule.source.listMode":"code","StructureMap.group.rule.source.max":"string","StructureMap.group.rule.source.min":"integer","StructureMap.group.rule.source.modifierExtension":"Extension","StructureMap.group.rule.source.type":"string","StructureMap.group.rule.source.variable":"id","StructureMap.group.rule.target":"BackboneElement","StructureMap.group.rule.target.context":"id","StructureMap.group.rule.target.contextType":"code","StructureMap.group.rule.target.element":"string","StructureMap.group.rule.target.extension":"Extension","StructureMap.group.rule.target.id":"string","StructureMap.group.rule.target.listMode":"code","StructureMap.group.rule.target.listRuleId":"id","StructureMap.group.rule.target.modifierExtension":"Extension","StructureMap.group.rule.target.parameter":"BackboneElement","StructureMap.group.rule.target.parameter.extension":"Extension","StructureMap.group.rule.target.parameter.id":"string","StructureMap.group.rule.target.parameter.modifierExtension":"Extension","StructureMap.group.rule.target.parameter.valueBoolean":"boolean","StructureMap.group.rule.target.parameter.valueDecimal":"decimal","StructureMap.group.rule.target.parameter.valueId":"id","StructureMap.group.rule.target.parameter.valueInteger":"integer","StructureMap.group.rule.target.parameter.valueString":"string","StructureMap.group.rule.target.transform":"code","StructureMap.group.rule.target.variable":"id","StructureMap.group.typeMode":"code","StructureMap.id":"id","StructureMap.identifier":"Identifier","StructureMap.implicitRules":"uri","StructureMap.import":"uri","StructureMap.jurisdiction":"CodeableConcept","StructureMap.language":"code","StructureMap.meta":"Meta","StructureMap.modifierExtension":"Extension","StructureMap.name":"string","StructureMap.publisher":"string","StructureMap.purpose":"markdown","StructureMap.status":"code","StructureMap.structure":"BackboneElement","StructureMap.structure.alias":"string","StructureMap.structure.documentation":"string","StructureMap.structure.extension":"Extension","StructureMap.structure.id":"string","StructureMap.structure.mode":"code","StructureMap.structure.modifierExtension":"Extension","StructureMap.structure.url":"uri","StructureMap.text":"Narrative","StructureMap.title":"string","StructureMap.url":"uri","StructureMap.useContext":"UsageContext","StructureMap.version":"string","Subscription.channel":"BackboneElement","Subscription.channel.endpoint":"uri","Subscription.channel.extension":"Extension","Subscription.channel.header":"string","Subscription.channel.id":"string","Subscription.channel.modifierExtension":"Extension","Subscription.channel.payload":"string","Subscription.channel.type":"code","Subscription.contact":"ContactPoint","Subscription.contained":"Resource","Subscription.criteria":"string","Subscription.end":"instant","Subscription.error":"string","Subscription.extension":"Extension","Subscription.id":"id","Subscription.implicitRules":"uri","Subscription.language":"code","Subscription.meta":"Meta","Subscription.modifierExtension":"Extension","Subscription.reason":"string","Subscription.status":"code","Subscription.tag":"Coding","Subscription.text":"Narrative","Substance.category":"CodeableConcept","Substance.code":"CodeableConcept","Substance.contained":"Resource","Substance.description":"string","Substance.extension":"Extension","Substance.id":"id","Substance.identifier":"Identifier","Substance.implicitRules":"uri","Substance.ingredient":"BackboneElement","Substance.ingredient.extension":"Extension","Substance.ingredient.id":"string","Substance.ingredient.modifierExtension":"Extension","Substance.ingredient.quantity":"Ratio","Substance.ingredient.substanceCodeableConcept":"CodeableConcept","Substance.ingredient.substanceReference":"Reference","Substance.instance":"BackboneElement","Substance.instance.expiry":"dateTime","Substance.instance.extension":"Extension","Substance.instance.id":"string","Substance.instance.identifier":"Identifier","Substance.instance.modifierExtension":"Extension","Substance.instance.quantity":"Quantity","Substance.language":"code","Substance.meta":"Meta","Substance.modifierExtension":"Extension","Substance.status":"code","Substance.text":"Narrative","SupplyDelivery.basedOn":"Reference","SupplyDelivery.contained":"Resource","SupplyDelivery.destination":"Reference","SupplyDelivery.extension":"Extension","SupplyDelivery.id":"id","SupplyDelivery.identifier":"Identifier","SupplyDelivery.implicitRules":"uri","SupplyDelivery.language":"code","SupplyDelivery.meta":"Meta","SupplyDelivery.modifierExtension":"Extension","SupplyDelivery.occurrenceDateTime":"dateTime","SupplyDelivery.occurrencePeriod":"Period","SupplyDelivery.occurrenceTiming":"Timing","SupplyDelivery.partOf":"Reference","SupplyDelivery.patient":"Reference","SupplyDelivery.receiver":"Reference","SupplyDelivery.status":"code","SupplyDelivery.suppliedItem":"BackboneElement","SupplyDelivery.suppliedItem.extension":"Extension","SupplyDelivery.suppliedItem.id":"string","SupplyDelivery.suppliedItem.itemCodeableConcept":"CodeableConcept","SupplyDelivery.suppliedItem.itemReference":"Reference","SupplyDelivery.suppliedItem.modifierExtension":"Extension","SupplyDelivery.suppliedItem.quantity":"Quantity","SupplyDelivery.supplier":"Reference","SupplyDelivery.text":"Narrative","SupplyDelivery.type":"CodeableConcept","SupplyRequest.authoredOn":"dateTime","SupplyRequest.category":"CodeableConcept","SupplyRequest.contained":"Resource","SupplyRequest.deliverFrom":"Reference","SupplyRequest.deliverTo":"Reference","SupplyRequest.extension":"Extension","SupplyRequest.id":"id","SupplyRequest.identifier":"Identifier","SupplyRequest.implicitRules":"uri","SupplyRequest.language":"code","SupplyRequest.meta":"Meta","SupplyRequest.modifierExtension":"Extension","SupplyRequest.occurrenceDateTime":"dateTime","SupplyRequest.occurrencePeriod":"Period","SupplyRequest.occurrenceTiming":"Timing","SupplyRequest.orderedItem":"BackboneElement","SupplyRequest.orderedItem.extension":"Extension","SupplyRequest.orderedItem.id":"string","SupplyRequest.orderedItem.itemCodeableConcept":"CodeableConcept","SupplyRequest.orderedItem.itemReference":"Reference","SupplyRequest.orderedItem.modifierExtension":"Extension","SupplyRequest.orderedItem.quantity":"Quantity","SupplyRequest.priority":"code","SupplyRequest.reasonCodeableConcept":"CodeableConcept","SupplyRequest.reasonReference":"Reference","SupplyRequest.requester":"BackboneElement","SupplyRequest.requester.agent":"Reference","SupplyRequest.requester.extension":"Extension","SupplyRequest.requester.id":"string","SupplyRequest.requester.modifierExtension":"Extension","SupplyRequest.requester.onBehalfOf":"Reference","SupplyRequest.status":"code","SupplyRequest.supplier":"Reference","SupplyRequest.text":"Narrative","Task.authoredOn":"dateTime","Task.basedOn":"Reference","Task.businessStatus":"CodeableConcept","Task.code":"CodeableConcept","Task.contained":"Resource","Task.context":"Reference","Task.definitionReference":"Reference","Task.definitionUri":"uri","Task.description":"string","Task.executionPeriod":"Period","Task.extension":"Extension","Task.focus":"Reference","Task.for":"Reference","Task.groupIdentifier":"Identifier","Task.id":"id","Task.identifier":"Identifier","Task.implicitRules":"uri","Task.input":"BackboneElement","Task.input.extension":"Extension","Task.input.id":"string","Task.input.modifierExtension":"Extension","Task.input.type":"CodeableConcept","Task.input.valueAddress":"Address","Task.input.valueAge":"Age","Task.input.valueAnnotation":"Annotation","Task.input.valueAttachment":"Attachment","Task.input.valueBase64Binary":"base64Binary","Task.input.valueBoolean":"boolean","Task.input.valueCode":"code","Task.input.valueCodeableConcept":"CodeableConcept","Task.input.valueCoding":"Coding","Task.input.valueContactPoint":"ContactPoint","Task.input.valueCount":"Count","Task.input.valueDate":"date","Task.input.valueDateTime":"dateTime","Task.input.valueDecimal":"decimal","Task.input.valueDistance":"Distance","Task.input.valueDuration":"Duration","Task.input.valueHumanName":"HumanName","Task.input.valueId":"id","Task.input.valueIdentifier":"Identifier","Task.input.valueInstant":"instant","Task.input.valueInteger":"integer","Task.input.valueMarkdown":"markdown","Task.input.valueMeta":"Meta","Task.input.valueMoney":"Money","Task.input.valueOid":"oid","Task.input.valuePeriod":"Period","Task.input.valuePositiveInt":"positiveInt","Task.input.valueQuantity":"Quantity","Task.input.valueRange":"Range","Task.input.valueRatio":"Ratio","Task.input.valueReference":"Reference","Task.input.valueSampledData":"SampledData","Task.input.valueSignature":"Signature","Task.input.valueString":"string","Task.input.valueTime":"time","Task.input.valueTiming":"Timing","Task.input.valueUnsignedInt":"unsignedInt","Task.input.valueUri":"uri","Task.intent":"code","Task.language":"code","Task.lastModified":"dateTime","Task.meta":"Meta","Task.modifierExtension":"Extension","Task.note":"Annotation","Task.output":"BackboneElement","Task.output.extension":"Extension","Task.output.id":"string","Task.output.modifierExtension":"Extension","Task.output.type":"CodeableConcept","Task.output.valueAddress":"Address","Task.output.valueAge":"Age","Task.output.valueAnnotation":"Annotation","Task.output.valueAttachment":"Attachment","Task.output.valueBase64Binary":"base64Binary","Task.output.valueBoolean":"boolean","Task.output.valueCode":"code","Task.output.valueCodeableConcept":"CodeableConcept","Task.output.valueCoding":"Coding","Task.output.valueContactPoint":"ContactPoint","Task.output.valueCount":"Count","Task.output.valueDate":"date","Task.output.valueDateTime":"dateTime","Task.output.valueDecimal":"decimal","Task.output.valueDistance":"Distance","Task.output.valueDuration":"Duration","Task.output.valueHumanName":"HumanName","Task.output.valueId":"id","Task.output.valueIdentifier":"Identifier","Task.output.valueInstant":"instant","Task.output.valueInteger":"integer","Task.output.valueMarkdown":"markdown","Task.output.valueMeta":"Meta","Task.output.valueMoney":"Money","Task.output.valueOid":"oid","Task.output.valuePeriod":"Period","Task.output.valuePositiveInt":"positiveInt","Task.output.valueQuantity":"Quantity","Task.output.valueRange":"Range","Task.output.valueRatio":"Ratio","Task.output.valueReference":"Reference","Task.output.valueSampledData":"SampledData","Task.output.valueSignature":"Signature","Task.output.valueString":"string","Task.output.valueTime":"time","Task.output.valueTiming":"Timing","Task.output.valueUnsignedInt":"unsignedInt","Task.output.valueUri":"uri","Task.owner":"Reference","Task.partOf":"Reference","Task.performerType":"CodeableConcept","Task.priority":"code","Task.reason":"CodeableConcept","Task.relevantHistory":"Reference","Task.requester":"BackboneElement","Task.requester.agent":"Reference","Task.requester.extension":"Extension","Task.requester.id":"string","Task.requester.modifierExtension":"Extension","Task.requester.onBehalfOf":"Reference","Task.restriction":"BackboneElement","Task.restriction.extension":"Extension","Task.restriction.id":"string","Task.restriction.modifierExtension":"Extension","Task.restriction.period":"Period","Task.restriction.recipient":"Reference","Task.restriction.repetitions":"positiveInt","Task.status":"code","Task.statusReason":"CodeableConcept","Task.text":"Narrative","TestReport.contained":"Resource","TestReport.extension":"Extension","TestReport.id":"id","TestReport.identifier":"Identifier","TestReport.implicitRules":"uri","TestReport.issued":"dateTime","TestReport.language":"code","TestReport.meta":"Meta","TestReport.modifierExtension":"Extension","TestReport.name":"string","TestReport.participant":"BackboneElement","TestReport.participant.display":"string","TestReport.participant.extension":"Extension","TestReport.participant.id":"string","TestReport.participant.modifierExtension":"Extension","TestReport.participant.type":"code","TestReport.participant.uri":"uri","TestReport.result":"code","TestReport.score":"decimal","TestReport.setup":"BackboneElement","TestReport.setup.action":"BackboneElement","TestReport.setup.action.assert":"BackboneElement","TestReport.setup.action.assert.detail":"string","TestReport.setup.action.assert.extension":"Extension","TestReport.setup.action.assert.id":"string","TestReport.setup.action.assert.message":"markdown","TestReport.setup.action.assert.modifierExtension":"Extension","TestReport.setup.action.assert.result":"code","TestReport.setup.action.extension":"Extension","TestReport.setup.action.id":"string","TestReport.setup.action.modifierExtension":"Extension","TestReport.setup.action.operation":"BackboneElement","TestReport.setup.action.operation.detail":"uri","TestReport.setup.action.operation.extension":"Extension","TestReport.setup.action.operation.id":"string","TestReport.setup.action.operation.message":"markdown","TestReport.setup.action.operation.modifierExtension":"Extension","TestReport.setup.action.operation.result":"code","TestReport.setup.extension":"Extension","TestReport.setup.id":"string","TestReport.setup.modifierExtension":"Extension","TestReport.status":"code","TestReport.teardown":"BackboneElement","TestReport.teardown.action":"BackboneElement","TestReport.teardown.action.extension":"Extension","TestReport.teardown.action.id":"string","TestReport.teardown.action.modifierExtension":"Extension","TestReport.teardown.extension":"Extension","TestReport.teardown.id":"string","TestReport.teardown.modifierExtension":"Extension","TestReport.test":"BackboneElement","TestReport.test.action":"BackboneElement","TestReport.test.action.extension":"Extension","TestReport.test.action.id":"string","TestReport.test.action.modifierExtension":"Extension","TestReport.test.description":"string","TestReport.test.extension":"Extension","TestReport.test.id":"string","TestReport.test.modifierExtension":"Extension","TestReport.test.name":"string","TestReport.testScript":"Reference","TestReport.tester":"string","TestReport.text":"Narrative","TestScript.contact":"ContactDetail","TestScript.contained":"Resource","TestScript.copyright":"markdown","TestScript.date":"dateTime","TestScript.description":"markdown","TestScript.destination":"BackboneElement","TestScript.destination.extension":"Extension","TestScript.destination.id":"string","TestScript.destination.index":"integer","TestScript.destination.modifierExtension":"Extension","TestScript.destination.profile":"Coding","TestScript.experimental":"boolean","TestScript.extension":"Extension","TestScript.fixture":"BackboneElement","TestScript.fixture.autocreate":"boolean","TestScript.fixture.autodelete":"boolean","TestScript.fixture.extension":"Extension","TestScript.fixture.id":"string","TestScript.fixture.modifierExtension":"Extension","TestScript.fixture.resource":"Reference","TestScript.id":"id","TestScript.identifier":"Identifier","TestScript.implicitRules":"uri","TestScript.jurisdiction":"CodeableConcept","TestScript.language":"code","TestScript.meta":"Meta","TestScript.metadata":"BackboneElement","TestScript.metadata.capability":"BackboneElement","TestScript.metadata.capability.capabilities":"Reference","TestScript.metadata.capability.description":"string","TestScript.metadata.capability.destination":"integer","TestScript.metadata.capability.extension":"Extension","TestScript.metadata.capability.id":"string","TestScript.metadata.capability.link":"uri","TestScript.metadata.capability.modifierExtension":"Extension","TestScript.metadata.capability.origin":"integer","TestScript.metadata.capability.required":"boolean","TestScript.metadata.capability.validated":"boolean","TestScript.metadata.extension":"Extension","TestScript.metadata.id":"string","TestScript.metadata.link":"BackboneElement","TestScript.metadata.link.description":"string","TestScript.metadata.link.extension":"Extension","TestScript.metadata.link.id":"string","TestScript.metadata.link.modifierExtension":"Extension","TestScript.metadata.link.url":"uri","TestScript.metadata.modifierExtension":"Extension","TestScript.modifierExtension":"Extension","TestScript.name":"string","TestScript.origin":"BackboneElement","TestScript.origin.extension":"Extension","TestScript.origin.id":"string","TestScript.origin.index":"integer","TestScript.origin.modifierExtension":"Extension","TestScript.origin.profile":"Coding","TestScript.profile":"Reference","TestScript.publisher":"string","TestScript.purpose":"markdown","TestScript.rule":"BackboneElement","TestScript.rule.extension":"Extension","TestScript.rule.id":"string","TestScript.rule.modifierExtension":"Extension","TestScript.rule.param":"BackboneElement","TestScript.rule.param.extension":"Extension","TestScript.rule.param.id":"string","TestScript.rule.param.modifierExtension":"Extension","TestScript.rule.param.name":"string","TestScript.rule.param.value":"string","TestScript.rule.resource":"Reference","TestScript.ruleset":"BackboneElement","TestScript.ruleset.extension":"Extension","TestScript.ruleset.id":"string","TestScript.ruleset.modifierExtension":"Extension","TestScript.ruleset.resource":"Reference","TestScript.ruleset.rule":"BackboneElement","TestScript.ruleset.rule.extension":"Extension","TestScript.ruleset.rule.id":"string","TestScript.ruleset.rule.modifierExtension":"Extension","TestScript.ruleset.rule.param":"BackboneElement","TestScript.ruleset.rule.param.extension":"Extension","TestScript.ruleset.rule.param.id":"string","TestScript.ruleset.rule.param.modifierExtension":"Extension","TestScript.ruleset.rule.param.name":"string","TestScript.ruleset.rule.param.value":"string","TestScript.ruleset.rule.ruleId":"id","TestScript.setup":"BackboneElement","TestScript.setup.action":"BackboneElement","TestScript.setup.action.assert":"BackboneElement","TestScript.setup.action.assert.compareToSourceExpression":"string","TestScript.setup.action.assert.compareToSourceId":"string","TestScript.setup.action.assert.compareToSourcePath":"string","TestScript.setup.action.assert.contentType":"code","TestScript.setup.action.assert.description":"string","TestScript.setup.action.assert.direction":"code","TestScript.setup.action.assert.expression":"string","TestScript.setup.action.assert.extension":"Extension","TestScript.setup.action.assert.headerField":"string","TestScript.setup.action.assert.id":"string","TestScript.setup.action.assert.label":"string","TestScript.setup.action.assert.minimumId":"string","TestScript.setup.action.assert.modifierExtension":"Extension","TestScript.setup.action.assert.navigationLinks":"boolean","TestScript.setup.action.assert.operator":"code","TestScript.setup.action.assert.path":"string","TestScript.setup.action.assert.requestMethod":"code","TestScript.setup.action.assert.requestURL":"string","TestScript.setup.action.assert.resource":"code","TestScript.setup.action.assert.response":"code","TestScript.setup.action.assert.responseCode":"string","TestScript.setup.action.assert.rule":"BackboneElement","TestScript.setup.action.assert.rule.extension":"Extension","TestScript.setup.action.assert.rule.id":"string","TestScript.setup.action.assert.rule.modifierExtension":"Extension","TestScript.setup.action.assert.rule.param":"BackboneElement","TestScript.setup.action.assert.rule.param.extension":"Extension","TestScript.setup.action.assert.rule.param.id":"string","TestScript.setup.action.assert.rule.param.modifierExtension":"Extension","TestScript.setup.action.assert.rule.param.name":"string","TestScript.setup.action.assert.rule.param.value":"string","TestScript.setup.action.assert.rule.ruleId":"id","TestScript.setup.action.assert.ruleset":"BackboneElement","TestScript.setup.action.assert.ruleset.extension":"Extension","TestScript.setup.action.assert.ruleset.id":"string","TestScript.setup.action.assert.ruleset.modifierExtension":"Extension","TestScript.setup.action.assert.ruleset.rule":"BackboneElement","TestScript.setup.action.assert.ruleset.rule.extension":"Extension","TestScript.setup.action.assert.ruleset.rule.id":"string","TestScript.setup.action.assert.ruleset.rule.modifierExtension":"Extension","TestScript.setup.action.assert.ruleset.rule.param":"BackboneElement","TestScript.setup.action.assert.ruleset.rule.param.extension":"Extension","TestScript.setup.action.assert.ruleset.rule.param.id":"string","TestScript.setup.action.assert.ruleset.rule.param.modifierExtension":"Extension","TestScript.setup.action.assert.ruleset.rule.param.name":"string","TestScript.setup.action.assert.ruleset.rule.param.value":"string","TestScript.setup.action.assert.ruleset.rule.ruleId":"id","TestScript.setup.action.assert.ruleset.rulesetId":"id","TestScript.setup.action.assert.sourceId":"id","TestScript.setup.action.assert.validateProfileId":"id","TestScript.setup.action.assert.value":"string","TestScript.setup.action.assert.warningOnly":"boolean","TestScript.setup.action.extension":"Extension","TestScript.setup.action.id":"string","TestScript.setup.action.modifierExtension":"Extension","TestScript.setup.action.operation":"BackboneElement","TestScript.setup.action.operation.accept":"code","TestScript.setup.action.operation.contentType":"code","TestScript.setup.action.operation.description":"string","TestScript.setup.action.operation.destination":"integer","TestScript.setup.action.operation.encodeRequestUrl":"boolean","TestScript.setup.action.operation.extension":"Extension","TestScript.setup.action.operation.id":"string","TestScript.setup.action.operation.label":"string","TestScript.setup.action.operation.modifierExtension":"Extension","TestScript.setup.action.operation.origin":"integer","TestScript.setup.action.operation.params":"string","TestScript.setup.action.operation.requestHeader":"BackboneElement","TestScript.setup.action.operation.requestHeader.extension":"Extension","TestScript.setup.action.operation.requestHeader.field":"string","TestScript.setup.action.operation.requestHeader.id":"string","TestScript.setup.action.operation.requestHeader.modifierExtension":"Extension","TestScript.setup.action.operation.requestHeader.value":"string","TestScript.setup.action.operation.requestId":"id","TestScript.setup.action.operation.resource":"code","TestScript.setup.action.operation.responseId":"id","TestScript.setup.action.operation.sourceId":"id","TestScript.setup.action.operation.targetId":"id","TestScript.setup.action.operation.type":"Coding","TestScript.setup.action.operation.url":"string","TestScript.setup.extension":"Extension","TestScript.setup.id":"string","TestScript.setup.modifierExtension":"Extension","TestScript.status":"code","TestScript.teardown":"BackboneElement","TestScript.teardown.action":"BackboneElement","TestScript.teardown.action.extension":"Extension","TestScript.teardown.action.id":"string","TestScript.teardown.action.modifierExtension":"Extension","TestScript.teardown.extension":"Extension","TestScript.teardown.id":"string","TestScript.teardown.modifierExtension":"Extension","TestScript.test":"BackboneElement","TestScript.test.action":"BackboneElement","TestScript.test.action.extension":"Extension","TestScript.test.action.id":"string","TestScript.test.action.modifierExtension":"Extension","TestScript.test.description":"string","TestScript.test.extension":"Extension","TestScript.test.id":"string","TestScript.test.modifierExtension":"Extension","TestScript.test.name":"string","TestScript.text":"Narrative","TestScript.title":"string","TestScript.url":"uri","TestScript.useContext":"UsageContext","TestScript.variable":"BackboneElement","TestScript.variable.defaultValue":"string","TestScript.variable.description":"string","TestScript.variable.expression":"string","TestScript.variable.extension":"Extension","TestScript.variable.headerField":"string","TestScript.variable.hint":"string","TestScript.variable.id":"string","TestScript.variable.modifierExtension":"Extension","TestScript.variable.name":"string","TestScript.variable.path":"string","TestScript.variable.sourceId":"id","TestScript.version":"string","Timing.code":"CodeableConcept","Timing.event":"dateTime","Timing.extension":"Extension","Timing.id":"string","Timing.repeat":"Element","Timing.repeat.boundsDuration":"Duration","Timing.repeat.boundsPeriod":"Period","Timing.repeat.boundsRange":"Range","Timing.repeat.count":"integer","Timing.repeat.countMax":"integer","Timing.repeat.dayOfWeek":"code","Timing.repeat.duration":"decimal","Timing.repeat.durationMax":"decimal","Timing.repeat.durationUnit":"code","Timing.repeat.extension":"Extension","Timing.repeat.frequency":"integer","Timing.repeat.frequencyMax":"integer","Timing.repeat.id":"string","Timing.repeat.offset":"unsignedInt","Timing.repeat.period":"decimal","Timing.repeat.periodMax":"decimal","Timing.repeat.periodUnit":"code","Timing.repeat.timeOfDay":"time","Timing.repeat.when":"code","TriggerDefinition.eventData":"DataRequirement","TriggerDefinition.eventName":"string","TriggerDefinition.eventTimingDate":"date","TriggerDefinition.eventTimingDateTime":"dateTime","TriggerDefinition.eventTimingReference":"Reference","TriggerDefinition.eventTimingTiming":"Timing","TriggerDefinition.extension":"Extension","TriggerDefinition.id":"string","TriggerDefinition.type":"code","UsageContext.code":"Coding","UsageContext.extension":"Extension","UsageContext.id":"string","UsageContext.valueCodeableConcept":"CodeableConcept","UsageContext.valueQuantity":"Quantity","UsageContext.valueRange":"Range","ValueSet.compose":"BackboneElement","ValueSet.compose.extension":"Extension","ValueSet.compose.id":"string","ValueSet.compose.inactive":"boolean","ValueSet.compose.include":"BackboneElement","ValueSet.compose.include.concept":"BackboneElement","ValueSet.compose.include.concept.code":"code","ValueSet.compose.include.concept.designation":"BackboneElement","ValueSet.compose.include.concept.designation.extension":"Extension","ValueSet.compose.include.concept.designation.id":"string","ValueSet.compose.include.concept.designation.language":"code","ValueSet.compose.include.concept.designation.modifierExtension":"Extension","ValueSet.compose.include.concept.designation.use":"Coding","ValueSet.compose.include.concept.designation.value":"string","ValueSet.compose.include.concept.display":"string","ValueSet.compose.include.concept.extension":"Extension","ValueSet.compose.include.concept.id":"string","ValueSet.compose.include.concept.modifierExtension":"Extension","ValueSet.compose.include.extension":"Extension","ValueSet.compose.include.filter":"BackboneElement","ValueSet.compose.include.filter.extension":"Extension","ValueSet.compose.include.filter.id":"string","ValueSet.compose.include.filter.modifierExtension":"Extension","ValueSet.compose.include.filter.op":"code","ValueSet.compose.include.filter.property":"code","ValueSet.compose.include.filter.value":"code","ValueSet.compose.include.id":"string","ValueSet.compose.include.modifierExtension":"Extension","ValueSet.compose.include.system":"uri","ValueSet.compose.include.valueSet":"uri","ValueSet.compose.include.version":"string","ValueSet.compose.lockedDate":"date","ValueSet.compose.modifierExtension":"Extension","ValueSet.contact":"ContactDetail","ValueSet.contained":"Resource","ValueSet.copyright":"markdown","ValueSet.date":"dateTime","ValueSet.description":"markdown","ValueSet.expansion":"BackboneElement","ValueSet.expansion.contains":"BackboneElement","ValueSet.expansion.contains.abstract":"boolean","ValueSet.expansion.contains.code":"code","ValueSet.expansion.contains.display":"string","ValueSet.expansion.contains.extension":"Extension","ValueSet.expansion.contains.id":"string","ValueSet.expansion.contains.inactive":"boolean","ValueSet.expansion.contains.modifierExtension":"Extension","ValueSet.expansion.contains.system":"uri","ValueSet.expansion.contains.version":"string","ValueSet.expansion.extension":"Extension","ValueSet.expansion.id":"string","ValueSet.expansion.identifier":"uri","ValueSet.expansion.modifierExtension":"Extension","ValueSet.expansion.offset":"integer","ValueSet.expansion.parameter":"BackboneElement","ValueSet.expansion.parameter.extension":"Extension","ValueSet.expansion.parameter.id":"string","ValueSet.expansion.parameter.modifierExtension":"Extension","ValueSet.expansion.parameter.name":"string","ValueSet.expansion.parameter.valueBoolean":"boolean","ValueSet.expansion.parameter.valueCode":"code","ValueSet.expansion.parameter.valueDecimal":"decimal","ValueSet.expansion.parameter.valueInteger":"integer","ValueSet.expansion.parameter.valueString":"string","ValueSet.expansion.parameter.valueUri":"uri","ValueSet.expansion.timestamp":"dateTime","ValueSet.expansion.total":"integer","ValueSet.experimental":"boolean","ValueSet.extensible":"boolean","ValueSet.extension":"Extension","ValueSet.id":"id","ValueSet.identifier":"Identifier","ValueSet.immutable":"boolean","ValueSet.implicitRules":"uri","ValueSet.jurisdiction":"CodeableConcept","ValueSet.language":"code","ValueSet.meta":"Meta","ValueSet.modifierExtension":"Extension","ValueSet.name":"string","ValueSet.publisher":"string","ValueSet.purpose":"markdown","ValueSet.status":"code","ValueSet.text":"Narrative","ValueSet.title":"string","ValueSet.url":"uri","ValueSet.useContext":"UsageContext","ValueSet.version":"string","VisionPrescription.contained":"Resource","VisionPrescription.dateWritten":"dateTime","VisionPrescription.dispense":"BackboneElement","VisionPrescription.dispense.add":"decimal","VisionPrescription.dispense.axis":"integer","VisionPrescription.dispense.backCurve":"decimal","VisionPrescription.dispense.base":"code","VisionPrescription.dispense.brand":"string","VisionPrescription.dispense.color":"string","VisionPrescription.dispense.cylinder":"decimal","VisionPrescription.dispense.diameter":"decimal","VisionPrescription.dispense.duration":"Quantity","VisionPrescription.dispense.extension":"Extension","VisionPrescription.dispense.eye":"code","VisionPrescription.dispense.id":"string","VisionPrescription.dispense.modifierExtension":"Extension","VisionPrescription.dispense.note":"Annotation","VisionPrescription.dispense.power":"decimal","VisionPrescription.dispense.prism":"decimal","VisionPrescription.dispense.product":"CodeableConcept","VisionPrescription.dispense.sphere":"decimal","VisionPrescription.encounter":"Reference","VisionPrescription.extension":"Extension","VisionPrescription.id":"id","VisionPrescription.identifier":"Identifier","VisionPrescription.implicitRules":"uri","VisionPrescription.language":"code","VisionPrescription.meta":"Meta","VisionPrescription.modifierExtension":"Extension","VisionPrescription.patient":"Reference","VisionPrescription.prescriber":"Reference","VisionPrescription.reasonCodeableConcept":"CodeableConcept","VisionPrescription.reasonReference":"Reference","VisionPrescription.status":"code","VisionPrescription.text":"Narrative","base64Binary.extension":"Extension","base64Binary.id":"string","boolean.extension":"Extension","boolean.id":"string","code.extension":"Extension","code.id":"string","date.extension":"Extension","date.id":"string","dateTime.extension":"Extension","dateTime.id":"string","decimal.extension":"Extension","decimal.id":"string","id.extension":"Extension","id.id":"string","instant.extension":"Extension","instant.id":"string","integer.extension":"Extension","integer.id":"string","markdown.extension":"Extension","markdown.id":"string","oid.extension":"Extension","oid.id":"string","positiveInt.extension":"Extension","positiveInt.id":"string","string.extension":"Extension","string.id":"string","time.extension":"Extension","time.id":"string","unsignedInt.extension":"Extension","unsignedInt.id":"string","uri.extension":"Extension","uri.id":"string","uuid.extension":"Extension","uuid.id":"string","xhtml.extension":"Extension","xhtml.id":"string"}',
                );
            },
            359: function (e) {
                'use strict';
                e.exports = JSON.parse(
                    '{"Bundle.entry.link":"Bundle.link","CapabilityStatement.rest.searchParam":"CapabilityStatement.rest.resource.searchParam","ClaimResponse.addItem.adjudication":"ClaimResponse.item.adjudication","ClaimResponse.addItem.detail.adjudication":"ClaimResponse.item.adjudication","ClaimResponse.item.detail.adjudication":"ClaimResponse.item.adjudication","ClaimResponse.item.detail.subDetail.adjudication":"ClaimResponse.item.adjudication","CodeSystem.concept.concept":"CodeSystem.concept","Composition.section.section":"Composition.section","ConceptMap.group.element.target.product":"ConceptMap.group.element.target.dependsOn","Contract.term.group":"Contract.term","ExplanationOfBenefit.addItem.adjudication":"ExplanationOfBenefit.item.adjudication","ExplanationOfBenefit.addItem.detail.adjudication":"ExplanationOfBenefit.item.adjudication","ExplanationOfBenefit.item.detail.adjudication":"ExplanationOfBenefit.item.adjudication","ExplanationOfBenefit.item.detail.subDetail.adjudication":"ExplanationOfBenefit.item.adjudication","GraphDefinition.link.target.link":"GraphDefinition.link","ImplementationGuide.page.page":"ImplementationGuide.page","Observation.component.referenceRange":"Observation.referenceRange","OperationDefinition.parameter.part":"OperationDefinition.parameter","Parameters.parameter.part":"Parameters.parameter","PlanDefinition.action.action":"PlanDefinition.action","Provenance.entity.agent":"Provenance.agent","Questionnaire.item.item":"Questionnaire.item","QuestionnaireResponse.item.answer.item":"QuestionnaireResponse.item","QuestionnaireResponse.item.item":"QuestionnaireResponse.item","RequestGroup.action.action":"RequestGroup.action","StructureMap.group.rule.rule":"StructureMap.group.rule","TestReport.teardown.action.operation":"TestReport.setup.action.operation","TestReport.test.action.assert":"TestReport.setup.action.assert","TestReport.test.action.operation":"TestReport.setup.action.operation","TestScript.teardown.action.operation":"TestScript.setup.action.operation","TestScript.test.action.assert":"TestScript.setup.action.assert","TestScript.test.action.operation":"TestScript.setup.action.operation","ValueSet.compose.exclude":"ValueSet.compose.include","ValueSet.expansion.contains.contains":"ValueSet.expansion.contains","ValueSet.expansion.contains.designation":"ValueSet.compose.include.concept.designation"}',
                );
            },
            3194: function (e) {
                'use strict';
                e.exports = JSON.parse(
                    '{"Account":"DomainResource","ActivityDefinition":"DomainResource","Address":"Element","AdverseEvent":"DomainResource","Age":"Quantity","AllergyIntolerance":"DomainResource","Annotation":"Element","Appointment":"DomainResource","AppointmentResponse":"DomainResource","Attachment":"Element","AuditEvent":"DomainResource","BackboneElement":"Element","Basic":"DomainResource","Binary":"Resource","BodySite":"DomainResource","Bundle":"Resource","CapabilityStatement":"DomainResource","CarePlan":"DomainResource","CareTeam":"DomainResource","ChargeItem":"DomainResource","Claim":"DomainResource","ClaimResponse":"DomainResource","ClinicalImpression":"DomainResource","CodeSystem":"DomainResource","CodeableConcept":"Element","Coding":"Element","Communication":"DomainResource","CommunicationRequest":"DomainResource","CompartmentDefinition":"DomainResource","Composition":"DomainResource","ConceptMap":"DomainResource","Condition":"DomainResource","Consent":"DomainResource","ContactDetail":"Element","ContactPoint":"Element","Contract":"DomainResource","Contributor":"Element","Count":"Quantity","Coverage":"DomainResource","DataElement":"DomainResource","DataRequirement":"Element","DetectedIssue":"DomainResource","Device":"DomainResource","DeviceComponent":"DomainResource","DeviceMetric":"DomainResource","DeviceRequest":"DomainResource","DeviceUseStatement":"DomainResource","DiagnosticReport":"DomainResource","Distance":"Quantity","DocumentManifest":"DomainResource","DocumentReference":"DomainResource","DomainResource":"Resource","Dosage":"Element","Duration":"Quantity","ElementDefinition":"Element","EligibilityRequest":"DomainResource","EligibilityResponse":"DomainResource","Encounter":"DomainResource","Endpoint":"DomainResource","EnrollmentRequest":"DomainResource","EnrollmentResponse":"DomainResource","EpisodeOfCare":"DomainResource","ExpansionProfile":"DomainResource","ExplanationOfBenefit":"DomainResource","Extension":"Element","FamilyMemberHistory":"DomainResource","Flag":"DomainResource","Goal":"DomainResource","GraphDefinition":"DomainResource","Group":"DomainResource","GuidanceResponse":"DomainResource","HealthcareService":"DomainResource","HumanName":"Element","Identifier":"Element","ImagingManifest":"DomainResource","ImagingStudy":"DomainResource","Immunization":"DomainResource","ImmunizationRecommendation":"DomainResource","ImplementationGuide":"DomainResource","Library":"DomainResource","Linkage":"DomainResource","List":"DomainResource","Location":"DomainResource","Measure":"DomainResource","MeasureReport":"DomainResource","Media":"DomainResource","Medication":"DomainResource","MedicationAdministration":"DomainResource","MedicationDispense":"DomainResource","MedicationRequest":"DomainResource","MedicationStatement":"DomainResource","MessageDefinition":"DomainResource","MessageHeader":"DomainResource","Meta":"Element","Money":"Quantity","NamingSystem":"DomainResource","Narrative":"Element","NutritionOrder":"DomainResource","Observation":"DomainResource","OperationDefinition":"DomainResource","OperationOutcome":"DomainResource","Organization":"DomainResource","ParameterDefinition":"Element","Parameters":"Resource","Patient":"DomainResource","PaymentNotice":"DomainResource","PaymentReconciliation":"DomainResource","Period":"Element","Person":"DomainResource","PlanDefinition":"DomainResource","Practitioner":"DomainResource","PractitionerRole":"DomainResource","Procedure":"DomainResource","ProcedureRequest":"DomainResource","ProcessRequest":"DomainResource","ProcessResponse":"DomainResource","Provenance":"DomainResource","Quantity":"Element","Questionnaire":"DomainResource","QuestionnaireResponse":"DomainResource","Range":"Element","Ratio":"Element","Reference":"Element","ReferralRequest":"DomainResource","RelatedArtifact":"Element","RelatedPerson":"DomainResource","RequestGroup":"DomainResource","ResearchStudy":"DomainResource","ResearchSubject":"DomainResource","RiskAssessment":"DomainResource","SampledData":"Element","Schedule":"DomainResource","SearchParameter":"DomainResource","Sequence":"DomainResource","ServiceDefinition":"DomainResource","Signature":"Element","SimpleQuantity":"Quantity","Slot":"DomainResource","Specimen":"DomainResource","StructureDefinition":"DomainResource","StructureMap":"DomainResource","Subscription":"DomainResource","Substance":"DomainResource","SupplyDelivery":"DomainResource","SupplyRequest":"DomainResource","Task":"DomainResource","TestReport":"DomainResource","TestScript":"DomainResource","Timing":"Element","TriggerDefinition":"Element","UsageContext":"Element","ValueSet":"DomainResource","VisionPrescription":"DomainResource","base64Binary":"Element","boolean":"Element","code":"string","date":"Element","dateTime":"Element","decimal":"Element","id":"string","instant":"Element","integer":"Element","markdown":"string","oid":"uri","positiveInt":"integer","string":"Element","time":"Element","unsignedInt":"integer","uri":"Element","uuid":"uri","xhtml":"Element"}',
                );
            },
            9852: function (e) {
                'use strict';
                e.exports = JSON.parse(
                    '{"name":"fhirpath","version":"3.15.1","description":"A FHIRPath engine","main":"src/fhirpath.js","types":"src/fhirpath.d.ts","dependencies":{"@lhncbc/ucum-lhc":"^5.0.0","antlr4":"~4.9.3","commander":"^2.18.0","date-fns":"^1.30.1","js-yaml":"^3.13.1"},"devDependencies":{"@babel/core":"^7.21.4","@babel/eslint-parser":"^7.17.0","@babel/preset-env":"^7.16.11","babel-loader":"^8.2.3","benny":"github:caderek/benny#0ad058d3c7ef0b488a8fe9ae3519159fc7f36bb6","bestzip":"^2.2.0","copy-webpack-plugin":"^6.0.3","cypress":"^13.7.2","eslint":"^8.10.0","fhir":"^4.10.3","grunt":"^1.5.2","grunt-cli":"^1.4.3","grunt-text-replace":"^0.4.0","jasmine-spec-reporter":"^4.2.1","jest":"^29.7.0","jit-grunt":"^0.10.0","lodash":"^4.17.21","open":"^8.4.0","rimraf":"^3.0.0","tmp":"0.0.33","tsd":"^0.31.1","webpack":"^5.11.1","webpack-bundle-analyzer":"^4.4.2","webpack-cli":"^4.9.1","xml2js":"^0.5.0","yargs":"^15.1.0"},"engines":{"node":">=8.9.0"},"tsd":{"directory":"test/typescript"},"scripts":{"postinstall":"echo \\"Building the Benny package based on a pull request which fixes an issue with \'statusShift\'... \\" && (cd node_modules/benny && npm i && npm run build > /dev/null) || echo \\"Building the Benny package is completed.\\"","generateParser":"cd src/parser; rimraf ./generated/*; java -Xmx500M -cp \\"../../antlr-4.9.3-complete.jar:$CLASSPATH\\" org.antlr.v4.Tool -o generated -Dlanguage=JavaScript FHIRPath.g4; grunt updateParserRequirements","build":"cd browser-build && webpack && rimraf fhirpath.zip && bestzip fhirpath.zip LICENSE.md fhirpath.min.js fhirpath.r5.min.js fhirpath.r4.min.js fhirpath.stu3.min.js fhirpath.dstu2.min.js && rimraf  LICENSE.md","test:unit":"node --use_strict node_modules/.bin/jest && TZ=America/New_York node --use_strict node_modules/.bin/jest && TZ=Europe/Paris node --use_strict node_modules/.bin/jest","test:unit:debug":"echo \'open chrome chrome://inspect/\' && node --inspect node_modules/.bin/jest --runInBand","build:demo":"npm run build && cd demo && npm run build","test:e2e":"npm run build:demo && cypress run","test:tsd":"tsd","test":"npm run lint && npm run test:tsd && npm run test:unit && npm run test:e2e && echo \\"For tests specific to IE 11, open browser-build/test/index.html in IE 11, and confirm that the tests on that page pass.\\"","lint":"eslint src/parser/index.js src/*.js converter/","compare-performance":"node ./test/benchmark.js"},"bin":{"fhirpath":"bin/fhirpath"},"repository":"github:HL7/fhirpath.js","license":"SEE LICENSE in LICENSE.md"}',
                );
            },
        },
        t = {};

    function n(i) {
        var a = t[i];
        if (void 0 !== a) {
            return a.exports;
        }
        var o = (t[i] = { id: i, loaded: !1, exports: {} });
        e[i].call(o.exports, o, o.exports, n);
        o.loaded = !0;
        return o.exports;
    }

    n.n = function (e) {
        var t =
            e && e.__esModule
                ? function () {
                      return e.default;
                  }
                : function () {
                      return e;
                  };
        n.d(t, { a: t });
        return t;
    };
    n.d = function (e, t) {
        for (var i in t) {
            if (n.o(t, i) && !n.o(e, i)) {
                Object.defineProperty(e, i, { enumerable: !0, get: t[i] });
            }
        }
    };
    n.g = (function () {
        if ('object' == typeof globalThis) {
            return globalThis;
        }
        try {
            return this || new Function('return this')();
        } catch (e) {
            if ('object' == typeof window) {
                return window;
            }
        }
    })();
    n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    };
    n.nmd = function (e) {
        e.paths = [];
        if (!e.children) {
            e.children = [];
        }
        return e;
    };
    !(function () {
        'use strict';
        n(7337);
        var e = {
                fhirVersion: 'STU3',
                stdQProfile: 'http://hl7.org/fhir/3.0/StructureDefinition/Questionnaire',
                stdQRProfile: 'http://hl7.org/fhir/3.0/StructureDefinition/QuestionnaireResponse',
            },
            t = n(5252),
            i = n(21),
            a = n(561);
        let o = Object.create(a.A);
        Object.assign(o, {
            _createObsIntValue: function (e) {
                let t = { value: e.value };
                this._setFHIRQuantityUnit(t, e.unit);
                return { key: 'valueQuantity', val: t };
            },
        });
        var r = o,
            s = {
                stdQProfile: 'http://hl7.org/fhir/3.0/StructureDefinition/Questionnaire',
                stdQRProfile: 'http://hl7.org/fhir/3.0/StructureDefinition/QuestionnaireResponse',
                convertLFormsToQRAndExtractFHIRData: function (e, t, n) {
                    var i = this.convertLFormsToQuestionnaireResponse(e, t, n);
                    if (!i) {
                        return null;
                    }
                    if (!i.id) {
                        i.id = this._commonExport._getUniqueId(
                            (i.code && i.code[0] && i.code[0].code) || i.identifier || 'QR',
                        );
                    }
                    i.id;
                    for (
                        var a = [i], o = ['Practitioner', 'Patient', 'RelatedPerson'], r = 0, s = e.itemList.length;
                        r < s;
                        ++r
                    ) {
                        var c = e.itemList[r];
                        if (this._getExtractValue(c) && this._hasItemValue(c)) {
                            const e = [];
                            for (var l = c; l && !e.length; ) {
                                if (l.extension) {
                                    LForms.Util.findObjectInArray(
                                        l.extension,
                                        'url',
                                        this.fhirExtObsExtractCategory,
                                        0,
                                        !0,
                                    ).forEach(t => e.push(t.valueCodeableConcept));
                                }
                                l = l._parentItem;
                            }
                            for (var u = this._commonExport._createObservation(c), d = 0, m = u.length; d < m; d++) {
                                if (i.basedOn) {
                                    u[d].basedOn = i.basedOn;
                                }
                                if (i.subject) {
                                    u[d].subject = i.subject;
                                }
                                if (i.context) {
                                    u[d].context = i.context;
                                }
                                if (i.authored) {
                                    u[d].effectiveDateTime = i.authored;
                                    u[d].issued = i.authored;
                                }
                                if (i.author && o.indexOf(i.author.type) >= 0) {
                                    u[d].performer = i.author;
                                }
                                if (e.length) {
                                    u[d].category = e;
                                }
                                a.push(u[d]);
                            }
                        }
                    }
                    return a;
                },
                _processQuestionCardinality: function (e, t) {
                    if (t.questionCardinality) {
                        if ('*' === t.questionCardinality.max) {
                            e.repeats = !0;
                        } else if (parseInt(t.questionCardinality.max) > 1) {
                            e.repeats = !0;
                            e.extension.push({
                                url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-maxOccurs',
                                valueInteger: parseInt(t.questionCardinality.max),
                            });
                        }
                    } else {
                        e.repeats = !1;
                    }
                },
                _handleSpecialConstraints: function (e, t) {
                    if (e && 'TITLE' === t.dataType) {
                        delete e.code;
                        delete e.required;
                        delete e.repeats;
                        delete e.readOnly;
                    }
                },
                _handleRestrictions: function (e, t) {
                    if (t.restrictions) {
                        for (var n in t.restrictions) {
                            var i = t.restrictions[n],
                                a = null,
                                o = this._getAssumedDataTypeForExport(t),
                                r = this._getValueKeyByDataType('value', t);
                            switch (n) {
                                case 'minExclusive':
                                case 'minInclusive':
                                case 'maxExclusive':
                                case 'maxInclusive':
                                    a = this._exportMinMax(o, i, r, n);
                                    break;
                                case 'minLength':
                                    if ('ST' === o || 'TX' === o || 'URL' === o || 'QTY' === o) {
                                        a = {
                                            url: 'http://hl7.org/fhir/StructureDefinition/minLength',
                                            valueInteger: parseInt(i),
                                        };
                                    }
                                    break;
                                case 'maxLength':
                                    if ('ST' === o || 'TX' === o || 'URL' === o || 'QTY' === o) {
                                        e.maxLength = parseInt(i);
                                    }
                                    break;
                                case 'pattern':
                                    if ('ST' === o || 'TX' === o) {
                                        a = { url: 'http://hl7.org/fhir/StructureDefinition/regex', valueString: i };
                                    }
                                    break;
                                case 'maxDecimalPlaces':
                                    if ('REAL' === o) {
                                        a = { url: this.fhirExtUrlMaxDecimalPlaces, valueInteger: i };
                                    }
                            }
                            if (a) {
                                e.extension.push(a);
                            }
                        }
                    }
                },
                _handleChoiceField: function (e, t) {
                    if (t.externallyDefined) {
                        this._handleExternallyDefined(e, t);
                    } else if (t.answers && !t.answerValueSet) {
                        if (!t._fhirExt || !t._fhirExt[this.fhirExtAnswerExp]) {
                            e.option = this._handleAnswers(t);
                        }
                    } else if (t.answerValueSet) {
                        e.options = t.answerValueSet;
                    }
                },
                _handleAnswers: function (e) {
                    for (var t = [], n = 0, i = e.answers.length; n < i; n++) {
                        var a = e.answers[n],
                            o = {};
                        if ('CODING' === e.dataType) {
                            o.valueCoding = {};
                            if (a.code) {
                                o.valueCoding.code = a.code;
                            }
                            if (a.text) {
                                o.valueCoding.display = a.text;
                            }
                            if (a.system) {
                                o.valueCoding.system = LForms.Util.getCodeSystem(a.system);
                            }
                        } else if (
                            'ST' === e.dataType ||
                            'INT' === e.dataType ||
                            'DT' === e.dataType ||
                            'TM' === e.dataType
                        ) {
                            var r = this._getValueKeyByDataType('value', e);
                            o[r] = a.text;
                            if ('valueString' === r && a.obj_valueString) {
                                o._valueString = a.obj_valueString;
                            }
                        }
                        var s = [];
                        if (a.label) {
                            s.push({
                                url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
                                valueString: a.label,
                            });
                        }
                        if (null !== a.score && void 0 !== a.score) {
                            s.push({ url: this.fhirExtUrlOptionScore, valueDecimal: a.score });
                        }
                        if (s.length > 0) {
                            o.extension = s;
                        }
                        t.push(o);
                    }
                    return t;
                },
                _handleInitialValues: function (e, t) {
                    if (null !== t.defaultAnswer && void 0 !== t.defaultAnswer && '' !== t.defaultAnswer) {
                        var n = this._getAssumedDataTypeForExport(t),
                            i = this._getValueKeyByDataType('initial', t);
                        if ('CODING' === n) {
                            var a = null,
                                o = null;
                            if (
                                'object' ==
                                typeof (r =
                                    this._answerRepeats(t) && Array.isArray(t.defaultAnswer)
                                        ? t.defaultAnswer[0]
                                        : t.defaultAnswer)
                            ) {
                                o = { code: r.code };
                                if (void 0 !== r) {
                                    o.display = r.text;
                                }
                                if ((a = r.system || t.answerCodeSystem)) {
                                    o.system = LForms.Util.getCodeSystem(a);
                                }
                                e[i] = o;
                            } else if ('string' == typeof r) {
                                e.initialString = r;
                            }
                        } else if (t.answers && ('ST' === n || 'INT' === n || 'DT' === n || 'TM' === n)) {
                            var r =
                                this._answerRepeats(t) && Array.isArray(t.defaultAnswer)
                                    ? t.defaultAnswer[0]
                                    : t.defaultAnswer;
                            e[i] = r.text;
                        } else if ('QTY' === n) {
                            var s = this._makeQuantity(t.defaultAnswer, t.units);
                            if (s) {
                                e[i] = s;
                            }
                        } else if (
                            'BL' === n ||
                            'REAL' === n ||
                            'INT' === n ||
                            'TM' === n ||
                            'ST' === n ||
                            'TX' === n ||
                            'URL' === n
                        ) {
                            e[i] = t.defaultAnswer;
                        } else if ('DT' === n || 'DTM' === n) {
                            var c = LForms.Util.stringToDate(t.defaultAnswer);
                            if (c) {
                                c = 'DTM' === n ? LForms.Util.dateToDTMString(c) : LForms.Util.dateToDTStringISO(c);
                                e[i] = c;
                            } else {
                                console.error(
                                    t.defaultAnswer +
                                        ': Invalid date/datetime string as defaultAnswer for ' +
                                        t.questionCode,
                                );
                            }
                        }
                    }
                },
                _handleLFormsUnits: function (e, t) {
                    if (t.units && t.units.length > 0) {
                        var n = this._getAssumedDataTypeForExport(t);
                        if ('REAL' === n || 'INT' === n) {
                            e.extension.push({
                                url: this.fhirExtUrlUnit,
                                valueCoding: this._createFhirUnitCoding(t.units[0]),
                            });
                        } else if ('QTY' === n) {
                            var i = this._getDefaultUnit(t.units);
                            if ((i && i.default) || e.initialQuantity) {
                                if (!e.initialQuantity) {
                                    e.initialQuantity = {};
                                }
                                this._setUnitAttributesToFhirQuantity(e.initialQuantity, i);
                            }
                            for (var a = 0, o = t.units.length; a < o; a++) {
                                var r = t.units[a],
                                    s = { url: this.fhirExtUrlUnitOption, valueCoding: this._createFhirUnitCoding(r) };
                                e.extension.push(s);
                            }
                        }
                    }
                },
                _handleSkipLogic: function (e, t, n) {
                    if (t.skipLogic) {
                        for (var i = [], a = 0, o = t.skipLogic.conditions.length; a < o; a++) {
                            var r = t.skipLogic.conditions[a],
                                s = n._getSkipLogicSourceItem(t, r.source),
                                c = { question: s.linkId },
                                l = this._getValueKeyByDataType('answer', s),
                                u = this._getAssumedDataTypeForExport(s);
                            if (r.trigger.hasOwnProperty('exists')) {
                                c.hasAnswer = r.trigger.exists;
                            } else if ('CODING' === u) {
                                let e = this._copyTriggerCoding(r.trigger.value, null, !0);
                                if (e) {
                                    c[l] = e;
                                } else {
                                    throw new Error('Unable to convert trigger to answerCoding: ' + r.trigger.value);
                                }
                            } else if ('QTY' === u) {
                                let e = this._makeQuantity(r.trigger.value, s.units);
                                if (e) {
                                    c[l] = e;
                                }
                            } else if (
                                'BL' === u ||
                                'REAL' === u ||
                                'INT' === u ||
                                'DT' === u ||
                                'DTM' === u ||
                                'TM' === u ||
                                'ST' === u ||
                                'TX' === u ||
                                'URL' === u
                            ) {
                                c[l] = r.trigger.value;
                            }
                            i.push(c);
                        }
                        e.enableWhen = i;
                    }
                },
            },
            c = n(3544),
            l = n(5336),
            u = n(1868),
            d = n(9407);
        var m = function (e) {
                var t = e;
                t.fhirExtUrlOptionScore = t.fhirExtUrlOptionScoreLookup.STU3;
                t.fhirExtUrlValueSetScore = 'http://hl7.org/fhir/StructureDefinition/valueset-ordinalValue';
                t._extractContainedVS = function (e) {
                    var n;
                    if (e.contained && e.contained.length > 0) {
                        n = {};
                        e.contained.forEach(function (e) {
                            if (
                                'ValueSet' === e.resourceType &&
                                e.expansion &&
                                e.expansion.contains &&
                                e.expansion.contains.length > 0
                            ) {
                                var i = t.answersFromVS(e);
                                if (!i) {
                                    i = [];
                                }
                                var a = { answers: i };
                                if (e.id) {
                                    n['#' + e.id] = a;
                                }
                                if (e.url) {
                                    n[e.url] = a;
                                }
                            }
                        });
                    }
                    return n;
                };
                t._processSkipLogic = function (e, n, i) {
                    if (n.enableWhen) {
                        e.skipLogic = { conditions: [], action: 'show' };
                        for (var a = 0; a < n.enableWhen.length; a++) {
                            if (!n.enableWhen[a].question) {
                                throw new Error(
                                    "Question with linkId '" +
                                        n.linkId +
                                        "' contains enableWhen but is missing the enableWhen.question field.",
                                );
                            }
                            if (!i[n.enableWhen[a].question]) {
                                throw new Error(
                                    "Question with linkId '" +
                                        n.linkId +
                                        "' contains enableWhen pointing to a question with linkId '" +
                                        n.enableWhen[a].question +
                                        "' that does not exist.",
                                );
                            }
                            var o = t._getDataType(i[n.enableWhen[a].question]),
                                r = { source: n.enableWhen[a].question };
                            if (n.enableWhen[a].hasOwnProperty('hasAnswer')) {
                                r.trigger = { exists: n.enableWhen[a].hasAnswer };
                            } else {
                                var s = t._getFHIRValueWithPrefixKey(n.enableWhen[a], /^answer/);
                                if ('CODING' === o) {
                                    r.trigger = { value: t._copyTriggerCoding(s, null, !1) };
                                } else if ('QTY' === o) {
                                    r.trigger = { value: s.value };
                                } else {
                                    r.trigger = { value: s };
                                }
                            }
                            e.skipLogic.conditions.push(r);
                        }
                    }
                };
                t._processAnswers = function (e, n, i, a) {
                    if (n.option) {
                        e.answers = [];
                        for (var o = 0; o < n.option.length; o++) {
                            var r = {},
                                s = n.option[o],
                                c = Object.keys(s).filter(function (e) {
                                    return 0 === e.indexOf('value');
                                });
                            if (c && c.length > 0) {
                                if ('valueCoding' === c[0]) {
                                    if (void 0 !== s[c[0]].code) {
                                        r.code = s[c[0]].code;
                                    }
                                    if (void 0 !== s[c[0]].display) {
                                        r.text = s[c[0]].display;
                                    }
                                    if (void 0 !== s[c[0]].system) {
                                        r.system = s[c[0]].system;
                                    }
                                } else if ('valueString' === c[0] || 'valueDate' === c[0] || 'valueTime' === c[0]) {
                                    r.text = s[c[0]];
                                    if ('valueString' === c[0] && s._valueString) {
                                        r.obj_valueString = s._valueString;
                                        const e = LForms.Util.findObjectInArray(
                                            r.obj_valueString.extension,
                                            'url',
                                            'http://hl7.org/fhir/StructureDefinition/rendering-xhtml',
                                        );
                                        if (e) {
                                            r.textHTML = e.valueString;
                                            if (t._widgetOptions?.allowHTML) {
                                                if (a && e.valueString.match(/img/) && e.valueString.match(/src/)) {
                                                    r.textHTML =
                                                        LForms.Util._internalUtil._getHtmlStringWithContainedImages(
                                                            a,
                                                            e.valueString,
                                                        ) || r.textHTML;
                                                }
                                                let t = LForms.Util.checkForInvalidHtmlTags(r.textHTML);
                                                if (t && t.length > 0) {
                                                    r.hasInvalidHtmlTag = !0;
                                                    LForms.Util._internalUtil.printInvalidHtmlToConsole(t);
                                                }
                                            }
                                        }
                                    }
                                } else if ('valueInteger' === c[0]) {
                                    r.text = parseInt(s[c[0]]);
                                } else {
                                    throw new Error('Unable to handle data type in answerOption: ' + c[0]);
                                }
                                var l = LForms.Util.findObjectInArray(s.extension, 'url', t.fhirExtUrlOptionPrefix);
                                if (l) {
                                    r.label = l.valueString;
                                }
                                var u = s.extension?.find(e => t.fhirExtUrlOptionScoreUrlSet.has(e.url));
                                if (
                                    (u = !u
                                        ? LForms.Util.findObjectInArray(
                                              s.extension,
                                              'url',
                                              t.argonautExtUrlExtensionScore,
                                          )
                                        : u)
                                ) {
                                    r.score = parseFloat(u.valueDecimal);
                                }
                            }
                            e.answers.push(r);
                        }
                    } else if (n.options) {
                        if (i) {
                            var d = i[n.options.reference];
                        }
                        if (d) {
                            e.answers = d.answers;
                        } else {
                            e.answerValueSet = n.options.reference;
                        }
                    }
                };
                t._processFHIRQuestionAndAnswerCardinality = function (e, n) {
                    var i,
                        a,
                        o = LForms.Util.findObjectInArray(n.extension, 'url', t.fhirExtUrlCardinalityMin),
                        r = LForms.Util.findObjectInArray(n.extension, 'url', t.fhirExtUrlCardinalityMax),
                        s = n.repeats,
                        c = n.required;
                    if (
                        'CODING' === e.dataType ||
                        (n.option &&
                            ('ST' === e.dataType || 'INT' === e.dataType || 'DT' === e.dataType || 'TM' === e.dataType))
                    ) {
                        if (s) {
                            if (n.item && n.item.length >= 0 && n.item.some(e => 'display' !== e.type)) {
                                i = { max: '1' };
                                a = r ? { max: r.valueInteger.toString() } : { max: '*' };
                            } else {
                                i = r ? { max: r.valueInteger.toString() } : { max: '*' };
                            }
                        } else {
                            i = { max: '1' };
                        }
                        if (c) {
                            i.min = o ? o.valueInteger.toString() : '1';
                        } else {
                            i.min = '0';
                        }
                    } else {
                        if (s) {
                            a = r ? { max: r.valueInteger.toString() } : { max: '*' };
                        } else {
                            a = { max: '1' };
                        }
                        if (c) {
                            a.min = o ? o.valueInteger.toString() : '1';
                            i = { min: '1' };
                        } else {
                            a.min = '1';
                        }
                    }
                    if (a) {
                        e.questionCardinality = a;
                    }
                    if (i) {
                        e.answerCardinality = i;
                    }
                };
                t._processEditable = function (e, t) {
                    if (t.readOnly) {
                        e.editable = '0';
                    }
                };
                t._processDefaultAnswer = function (e, n) {
                    var i = LForms.Util.deepCopy(n.initialCoding);
                    if (i) {
                        i._type = 'Coding';
                    } else {
                        i = t._getFHIRValueWithPrefixKey(n, /^initial/);
                    }
                    if (null != i) {
                        this._processFHIRValues(e, [i], !0);
                    }
                };
                t.getFirstInitialQuantity = function (e) {
                    return e.initialQuantity || null;
                };
                t._processDisplayItemCode = function (e, t) {
                    if ('display' === t.type && t.linkId) {
                        var n = t.linkId.split('/');
                        if (n && n[n.length - 1]) {
                            e.questionCode = n[n.length - 1];
                        }
                    }
                };
                t._processDataType = function (e, n) {
                    var i = t._getDataType(n);
                    if ('open-choice' === n.type) {
                        e.answerConstraint = 'optionsOrString';
                    }
                    if ('SECTION' === i || 'TITLE' === i) {
                        e.header = !0;
                    }
                    e.dataType = i;
                };
                let n = t._mergeQR;
                n._getQRStructure = function (e) {
                    var t = { qrItemsInfo: [] };
                    if (e) {
                        this._checkQRItems(t, e);
                    }
                    return t;
                };
                n._checkQRItems = function (e, n) {
                    var i = [],
                        a = {};
                    if (n && n.item) {
                        for (var o = 0, r = n.item.length; o < r; o++) {
                            var s = n.item[o].linkId;
                            if (!a[s]) {
                                for (
                                    var c = this._findTotalRepeatingNum(s, n),
                                        l = c.repeatingItems,
                                        u = 0,
                                        d = l.length;
                                    u < d;
                                    u++
                                ) {
                                    var m = { linkId: s, item: l[u], index: u, total: c.total };
                                    this._checkQRItems(m, l[u]);
                                    t._checkQRItemAnswerItems(m, l[u]);
                                    i.push(m);
                                }
                                a[s] = !0;
                            }
                        }
                        e.qrItemsInfo = i;
                    }
                };
                n._findTotalRepeatingNum = function (e, t) {
                    for (var n = 0, i = [], a = 0, o = t.item.length; a < o; a++) {
                        var r = t.item[a];
                        if (e === r.linkId) {
                            i.push(r);
                            if (Array.isArray(r.answer)) {
                                n += r.answer.length;
                            } else {
                                n += 1;
                            }
                        }
                    }
                    return { total: n, repeatingItems: i };
                };
                n._addRepeatingItems = function (e, t, n) {
                    var i = null;
                    if (e.items) {
                        for (var a = 0, o = e.items.length; a < o; a++) {
                            if (t === e.items[a].linkId) {
                                i = e.items[a];
                                break;
                            }
                        }
                        if (i) {
                            for (; n > 1; ) {
                                var r = LForms.Util.deepCopy(i);
                                e.items.splice(a, 0, r);
                                n -= 1;
                            }
                        }
                    }
                };
                n._findTheMatchingItemByLinkIdAndIndex = function (e, t, n) {
                    var i = null,
                        a = 0;
                    if (e.items) {
                        for (var o = 0, r = e.items.length; o < r; o++) {
                            if (t === e.items[o].linkId) {
                                if (a === n) {
                                    i = e.items[o];
                                    break;
                                } else {
                                    a += 1;
                                }
                            }
                        }
                    }
                    return i;
                };
                n._findTheMatchingItemByLinkId = function (e, t) {
                    var n = null;
                    if (e.items) {
                        for (var i = 0, a = e.items.length; i < a; i++) {
                            if (t === e.items[i].linkId) {
                                n = e.items[i];
                                break;
                            }
                        }
                    }
                    return n;
                };
            },
            p = n(7360),
            f = n(5844),
            g = n(3136);
        if (!LForms.FHIR) {
            LForms.FHIR = {};
        }
        var h = (LForms.FHIR[e.fhirVersion] = { LOINC_URI: t.F });
        h.fhirpath = n(7941);
        h.fhirpathModel = n(1126);
        h.DiagnosticReport = Object.assign({}, i.A);
        h.DiagnosticReport._commonExport = r;
        h.SDC = s;
        h.SDC._commonExport = r;
        (0, c.A)(h.SDC);
        (0, l.A)(h.SDC);
        (0, u.A)(h.SDC);
        (0, d.A)(h.SDC);
        m(h.SDC);
        (0, p.A)(h.SDC);
        (0, f.C)(h.SDC);
        h.SDC.ExpressionProcessor = g.b;
        Object.assign(h.SDC, e);
        h.reservedVarNames = {};
        ['context', 'resource'].forEach(function (e) {
            h.reservedVarNames[e] = !0;
        });
    })();
    !(function () {
        'use strict';
        n(7337);
        let e = '3.0';
        var t = {
                fhirVersion: 'R4',
                SDCVersion: e,
                QProfile: 'http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire|' + e,
                QRProfile: 'http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaireresponse|' + e,
                stdQProfile: 'http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire',
                stdQRProfile: 'http://hl7.org/fhir/4.0/StructureDefinition/QuestionnaireResponse',
            },
            i = n(5252),
            a = n(21),
            o = n(4333),
            r = n(4462),
            s = n(3544),
            c = n(5336),
            l = n(2777),
            u = n(1868),
            d = n(9407),
            m = n(1910),
            p = n(7360),
            f = n(6726),
            g = n(5844),
            h = n(3136);
        if (!LForms.FHIR) {
            LForms.FHIR = {};
        }
        var y = (LForms.FHIR[t.fhirVersion] = { LOINC_URI: i.F });
        y.fhirpath = n(7941);
        y.fhirpathModel = n(7887);
        y.DiagnosticReport = Object.assign({}, a.A);
        y.DiagnosticReport._commonExport = o.A;
        y.SDC = Object.assign({}, r.A);
        y.SDC._commonExport = o.A;
        (0, s.A)(y.SDC);
        (0, c.A)(y.SDC);
        (0, l.A)(y.SDC);
        (0, u.A)(y.SDC);
        (0, d.A)(y.SDC);
        (0, m.A)(y.SDC);
        (0, p.A)(y.SDC);
        (0, f.A)(y.SDC);
        (0, g.C)(y.SDC);
        y.SDC.ExpressionProcessor = h.b;
        Object.assign(y.SDC, t);
        y.reservedVarNames = {};
        ['context', 'resource'].forEach(function (e) {
            y.reservedVarNames[e] = !0;
        });
    })();
    !(function () {
        'use strict';
        n(7337);
        let e = '3.0';
        var t = {
                fhirVersion: 'R4B',
                SDCVersion: e,
                QProfile: 'http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire|' + e,
                QRProfile: 'http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaireresponse|' + e,
                stdQProfile: 'http://hl7.org/fhir/4.3/StructureDefinition/Questionnaire',
                stdQRProfile: 'http://hl7.org/fhir/4.3/StructureDefinition/QuestionnaireResponse',
            },
            i = n(5252),
            a = n(21),
            o = n(4333),
            r = n(4462),
            s = n(3544),
            c = n(5336),
            l = n(2777),
            u = n(1868),
            d = n(9407),
            m = n(1910),
            p = n(7360),
            f = n(6726),
            g = n(5844),
            h = n(3136);
        if (!LForms.FHIR) {
            LForms.FHIR = {};
        }
        var y = (LForms.FHIR[t.fhirVersion] = { LOINC_URI: i.F });
        y.fhirpath = n(7941);
        y.fhirpathModel = n(7887);
        y.DiagnosticReport = Object.assign({}, a.A);
        y.DiagnosticReport._commonExport = o.A;
        y.SDC = Object.assign({}, r.A);
        y.SDC._commonExport = o.A;
        (0, s.A)(y.SDC);
        (0, c.A)(y.SDC);
        (0, l.A)(y.SDC);
        (0, u.A)(y.SDC);
        (0, d.A)(y.SDC);
        (0, m.A)(y.SDC);
        (0, p.A)(y.SDC);
        (0, f.A)(y.SDC);
        (0, g.C)(y.SDC);
        y.SDC.ExpressionProcessor = h.b;
        Object.assign(y.SDC, t);
        y.reservedVarNames = {};
        ['context', 'resource'].forEach(function (e) {
            y.reservedVarNames[e] = !0;
        });
    })();
    !(function () {
        'use strict';
        var e = n(5252),
            t = n(21),
            i = n(4333),
            a = n(4462),
            o = n(3544),
            r = n(5336),
            s = n(2777);
        var c = function (e) {
                const t = { CODING: !0, ST: !0, INT: !0, DT: !0, TM: !0 };
                var n = e;
                n.stdQProfile = 'http://hl7.org/fhir/5.0/StructureDefinition/Questionnaire';
                n.stdQRProfile = 'http://hl7.org/fhir/5.0/StructureDefinition/QuestionnaireResponse';
                n._getFhirDataType = function (e) {
                    var t = this._getAssumedDataTypeForExport(e),
                        n = this._lformsTypesToFHIRTypes[t];
                    if (!n) {
                        n = 'string';
                    }
                    return n;
                };
                n._handleAnswerConstraint = function (e, t) {
                    if (t.answerConstraint) {
                        e.answerConstraint = t.answerConstraint;
                    }
                };
                n._handleInitialValues = function (e, t) {
                    if (null === t.defaultAnswer || void 0 === t.defaultAnswer || '' === t.defaultAnswer) {
                        return;
                    }
                    var n = this._getAssumedDataTypeForExport(t),
                        i =
                            this._answerRepeats(t) && Array.isArray(t.defaultAnswer)
                                ? t.defaultAnswer
                                : [t.defaultAnswer],
                        a = this._getValueKeyByDataType('value', t),
                        o = null;
                    let r = [];
                    for (var s = 0, c = i.length; s < c; s++) {
                        let e = i[s];
                        if ('CODING' === n) {
                            let n = !1;
                            if (t.answers) {
                                for (var l = 0, u = t.answers.length; l < u; l++) {
                                    if (LForms.Util.areTwoAnswersSame(e, t.answers[l], t)) {
                                        n = !0;
                                        break;
                                    }
                                }
                            }
                            if (!n) {
                                if ('string' == typeof e) {
                                    r.push({ valueString: e });
                                } else if ('object' == typeof e) {
                                    let t = LForms.Util.deepCopy(e);
                                    if (t.text) {
                                        t.display = t.text;
                                        delete t.text;
                                    }
                                    if (t.system) {
                                        t.system = LForms.Util.getCodeSystem(t.system);
                                    }
                                    r.push(t);
                                }
                            }
                        } else if ('QTY' === n) {
                            (o = {})[a] = this._makeQuantity(e, t.units);
                            r.push(o);
                        } else if (t.answers && ('ST' === n || 'INT' === n || 'DT' === n || 'TM' === n)) {
                            if ('string' == typeof e) {
                                r.push({ valueString: e });
                            } else {
                                r.push({ [a]: e.text });
                            }
                        } else if (
                            'INT' === n ||
                            'REAL' === n ||
                            'BL' === n ||
                            'TM' === n ||
                            'ST' === n ||
                            'TX' === n ||
                            'URL' === n
                        ) {
                            (o = {})[a] = e;
                            r.push(o);
                        } else if ('DT' === n || 'DTM' === n) {
                            var d = LForms.Util.stringToDate(e);
                            if (d) {
                                d = 'DTM' === n ? LForms.Util.dateToDTMString(d) : LForms.Util.dateToDTStringISO(d);
                                r.push({ [a]: d });
                            } else {
                                console.error(
                                    e + ': Invalid date/datetime string as defaultAnswer for ' + t.questionCode,
                                );
                            }
                        }
                    }
                    if (r.length > 0) {
                        e.initial = r;
                    }
                };
                n._handleDisabledDisplay = function (e, t) {
                    if (t.disabledDisplay) {
                        e.disabledDisplay = t.disabledDisplay;
                    }
                };
                n._lfItemValueToFhirAnswer = function (e) {
                    if (void 0 === e.value || null === e.value || '' === e.value) {
                        return null;
                    }
                    for (
                        var n = this._getAssumedDataTypeForExport(e),
                            i = this._answerRepeats(e) ? e.value : [e.value],
                            a = [],
                            o = 0;
                        o < i.length;
                        ++o
                    ) {
                        var r = i[o];
                        if (null != r && '' !== r) {
                            var s = null,
                                c = [];
                            if (null !== r.score && void 0 !== r.score) {
                                c.push({ url: this.fhirExtUrlOptionScore, valueDecimal: r.score });
                            }
                            if (e.answers) {
                                if (t[n]) {
                                    if ('optionsOrString' === e.answerConstraint && 'string' == typeof r) {
                                        s = { valueString: r };
                                        if (c.length > 0) {
                                            s._valueString = { extension: c };
                                        }
                                    } else if (!LForms.jQuery.isEmptyObject(r)) {
                                        if ('CODING' === n) {
                                            var l = this._setIfHasValue(
                                                null,
                                                'system',
                                                LForms.Util.getCodeSystem(r.system),
                                            );
                                            l = this._setIfHasValue(l, 'code', r.code);
                                            if ((l = this._setIfHasValue(l, 'display', r.text)) && c.length > 0) {
                                                l.extension = c;
                                            }
                                            s = this._setIfHasValue(null, 'valueCoding', l);
                                        } else {
                                            s = { [(d = this._getValueKeyByDataType('value', e))]: r.text };
                                            if (c.length > 0) {
                                                s['_' + d] = { extension: c };
                                            }
                                        }
                                    }
                                }
                            } else if ('QTY' === n) {
                                var u = this._makeValueQuantity(r, e.unit);
                                if (u && c.length > 0) {
                                    u.extension = c;
                                }
                                s = this._setIfHasValue(null, 'valueQuantity', u);
                            } else if (this._lformsTypesToFHIRFields[n]) {
                                var d;
                                s = { [(d = this._getValueKeyByDataType('value', e))]: r };
                                if (c.length > 0) {
                                    s['_' + d] = { extension: c };
                                }
                            }
                        }
                        if (null !== s) {
                            a.push(s);
                        }
                    }
                    return 0 === a.length ? null : a;
                };
            },
            l = n(7360);
        var u = function (e) {
                var t = e;
                t.fhirExtUrlOptionScore = t.fhirExtUrlOptionScoreLookup.R5;
                t._processDataType = function (e, n) {
                    var i = t._getDataType(n);
                    if ('SECTION' === i) {
                        e.header = !0;
                    }
                    e.dataType = i;
                };
                t._getDataType = function (e) {
                    var t = 'string';
                    switch (e.type) {
                        case 'string':
                            t = 'ST';
                            break;
                        case 'group':
                            t = 'SECTION';
                            break;
                        case 'choice':
                            t = 'CODING';
                            console.log(
                                `Warning: An item (linkId:${e.linkId}) has a type of 'choice', which is no longer a supported item type in R5.`,
                            );
                            break;
                        case 'open-choice':
                            t = 'CODING';
                            console.log(
                                `Warning: An item (linkId:${e.linkId}) has a type of 'open-choice', which is no longer a supported item type in R5.`,
                            );
                            break;
                        case 'integer':
                            t = 'INT';
                            break;
                        case 'decimal':
                            t = 'REAL';
                            break;
                        case 'text':
                            t = 'TX';
                            break;
                        case 'boolean':
                            t = 'BL';
                            break;
                        case 'date':
                            t = 'DT';
                            break;
                        case 'dateTime':
                            t = 'DTM';
                            break;
                        case 'time':
                            t = 'TM';
                            break;
                        case 'display':
                            t = 'TITLE';
                            break;
                        case 'url':
                            t = 'URL';
                            break;
                        case 'quantity':
                            t = 'QTY';
                            break;
                        case 'attachment':
                            t = 'attachment';
                            break;
                        case 'coding':
                            t = 'CODING';
                    }
                    return t;
                };
                t._processAnswerConstraint = function (e, t) {
                    if (t.answerConstraint) {
                        e.answerConstraint = t.answerConstraint;
                    }
                };
                t._processDefaultAnswerValue = function (e, n, i) {
                    let a;
                    e = LForms.Util.deepCopy(e);
                    switch (i) {
                        case 'coding':
                            if (e.valueCoding) {
                                a = e.valueCoding;
                                a._type = 'Coding';
                            } else if (e.valueString) {
                                a = e.valueString;
                            }
                            break;
                        case 'string':
                            if (e.valueString) {
                                a = e.valueString;
                            }
                            break;
                        case 'integer':
                            if (null !== e.valueInteger && void 0 !== e.valueInteger) {
                                a = e.valueInteger;
                            } else if (e.valueString) {
                                a = e.valueString;
                            }
                            break;
                        case 'date':
                            if (e.valueDate) {
                                a = e.valueDate;
                            } else if (e.valueString) {
                                a = e.valueString;
                            }
                            break;
                        case 'time':
                            if (e.valueTime) {
                                a = e.valueTime;
                            } else if (e.valueString) {
                                a = e.valueString;
                            }
                            break;
                        default:
                            a = t._getFHIRValueWithPrefixKey(e, /^value/);
                    }
                    if (null != a) {
                        n.push(a);
                    }
                };
                t._processDisabledDisplay = function (e, t) {
                    if (t.disabledDisplay) {
                        e.disabledDisplay = t.disabledDisplay;
                    }
                };
                t._processNonCodingAnswerValueInQR = function (e, t, n = !1) {
                    let i;
                    if ('ST' === t.dataType || 'INT' === t.dataType || 'DT' === t.dataType || 'TM' === t.dataType) {
                        for (var a = t.answers, o = 0, r = a.length; o < r && !i; ++o) {
                            if (e === a[o].text) {
                                i = a[o];
                                break;
                            }
                        }
                        if (!i) {
                            i = n ? e : { text: e, _notOnList: !0 };
                        }
                    }
                    return i;
                };
            },
            d = n(5844),
            m = n(3136);
        if (!LForms.FHIR) {
            LForms.FHIR = {};
        }
        var p = (LForms.FHIR.R5 = { LOINC_URI: e.F });
        p.fhirpath = n(7941);
        p.fhirpathModel = n(7887);
        p.DiagnosticReport = Object.assign({}, t.A);
        p.DiagnosticReport._commonExport = i.A;
        p.SDC = Object.assign({}, a.A);
        p.SDC._commonExport = i.A;
        (0, o.A)(p.SDC);
        (0, r.A)(p.SDC);
        (0, s.A)(p.SDC);
        c(p.SDC);
        (0, l.A)(p.SDC);
        u(p.SDC);
        (0, d.C)(p.SDC);
        p.SDC.ExpressionProcessor = m.b;
        p.SDC.fhirVersion = 'R5';
        p.reservedVarNames = {};
        ['context', 'resource'].forEach(function (e) {
            p.reservedVarNames[e] = !0;
        });
    })();
})();
//# sourceMappingURL=lformsFHIRAll.min.js.map
